
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $7efe9ca969eb570d$exports = {};
$7efe9ca969eb570d$exports = JSON.parse('{"version":1,"songs":[{"title":"Getting Started song","tracks":[{"song":"do r\xe1n","name":"Samplton idea","notes":"Samplton is a live performance sampler designed for playing, practicing, and performing music. It lets you organize audio tracks into pads, trigger them precisely, loop sections, and automatically move between tracks.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-zac.mp3","bpm":193,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"do r\xe1n","name":"Quantize","notes":"Press Q to switch between Quantize modes. Quantize determines when a track starts, keeping transitions synchronized with the beat.Set Quantize to NONE to play samples freely without beat synchronization.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Zac1.mp3","bpm":193,"signature":"","bars":8,"repeat":1,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"do r\xe1n","name":"Keyshots","notes":"All main controls are mapped to your keyboard. Open Menu \u2192 Keyshots to see all available keyboard shortcuts.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Zac2.mp3","bpm":193,"signature":"","bars":8,"repeat":2,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"do r\xe1n","name":"autoplay","notes":"Autoplay automatically continues to the next track. When it is enabled, Samplton plays the tracks in sequence without requiring you to trigger each one manually.You can turn Autoplay off at any time to stay on the current track.Turn Autoplay back on when you are ready to continue to the next track","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Sloha.mp3","bpm":193,"signature":"","bars":8,"repeat":2,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"do r\xe1n","name":"edit song","notes":"Edit Tracks lets you manage the tracks in your song.You can enable Edit Tracks using the button in the bottom-right corner of the Songs section.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Sloha-prech-do-dnb.mp3","bpm":193,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"do r\xe1n","name":"edit song - icons","notes":"\u2630 \u2014 Move,\u270E \u2014 Open Track Settings,\xd7 \u2014 Delete \u2014 Remove the track from the song(not library), \u21BB \u2014 Upload / Replace \u2014 Upload a new audio,\u25A4 \u2014 Load from Library \u2014 Choose an audio file you have already uploaded to your Sample Library","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Dnb-zac.mp3","bpm":193,"signature":"","bars":32,"repeat":2,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"do r\xe1n","name":"SAMPLE LIBRARY","notes":"Sample Library stores all your uploaded audio files in one place. You can preview your samples, delete files you no longer need, or load an existing sample into any track without uploading it again.The Sample Library is available in Edit Song mode.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Dnb-git-s.mp3","bpm":193,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"do r\xe1n","name":"edit sample","notes":"The Edit Sample button is located in the bottom-right corner of each track in Edit Song mode.You can preview, adjust the sample\u2019s start point, BPM, number of bars, time signature, repeat count, fade time, autoplay","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Dnb-git-s1.mp3","bpm":193,"signature":"","bars":8,"repeat":2,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"do r\xe1n","name":"notes & subtitles","notes":"Add notes to each track to prepare lyrics, performance instructions, chord changes, or anything else you need. Enable Subtitles to display these notes directly on screen while the track is playing.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Dnb-zac.mp3","bpm":193,"signature":"","bars":32,"repeat":1,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"do r\xe1n","name":"prepare all songs","notes":"Prepare All Songs loads and prepares all audio files in advance, so your entire set is ready to play instantly. Once prepared, your songs can also be played offline \u2014 ideal for live performances without a reliable internet connection.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Dnb-git-Kon-prech.mp3","bpm":193,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"do r\xe1n","name":"Import / export","notes":"Export saves your project structure and settings as a backup file. Audio files are not included. Import restores the project settings, while the audio files remain in your Sample Library.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-Dnb-Spev-prech.mp3","bpm":193,"signature":"","bars":36,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"do r\xe1n","name":"help improve samplton","notes":"Samplton is continuously evolving. If you find a bug, have an idea for a new feature, or think something could work better, please let me know. Your feedback can help shape future versions of Samplton.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Do-ran-dnb-syn.mp3","bpm":193,"signature":"","bars":36,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1}]},{"title":"song & subtitles","tracks":[{"song":"mola","name":"zac","notes":"Subtitles","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-zac-180.mp3","bpm":180,"signature":"","bars":8,"repeat":1,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"mola","name":"zac1","notes":"On each pad in the Settings section.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-zac1.mp3","bpm":180,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"mola","name":"sloha","notes":"Next to Notes, there is a Subtitles checkbox.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-zac-180.mp3","bpm":180,"signature":"","bars":8,"repeat":1,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"mola","name":"sloha2","notes":"When checked, the subtitles will be displayed directly while the track is playing.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-zac3.mp3","bpm":180,"signature":"","bars":16,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"mola","name":"ref","notes":"This way, you can prepare lyrics or any notes you need in advance.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-Ref.mp3","bpm":180,"signature":"","bars":20,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"mola","name":"flute","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-Flute.mp3","bpm":180,"signature":"","bars":32,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"mola","name":"sloha","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-Sloha2.mp3","bpm":180,"signature":"","bars":16,"repeat":2,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"mola","name":"do noci","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-Sloha22.mp3","bpm":180,"signature":"","bars":16,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"mola","name":"ref","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-Ref.mp3","bpm":180,"signature":"","bars":20,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"mola","name":"flute","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-Bass-flute.mp3","bpm":180,"signature":"","bars":56,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"mola","name":"zaveer","notes":"pocita sa 6 a 7","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Mola-Bass-Koniec.mp3","bpm":180,"signature":13,"bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1}]},{"title":"song & autoplay","tracks":[{"fadeintime":0.1,"notes":"When you click Autoplay, the song will start from the first pad.","repeat":1,"song":"papierova fobia","bpm":100,"name":"click auto pad","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/08/Pap-Zac-kla.mp3","bars":4,"start_at":0.01,"signature":4,"notesVisible":true,"autoplay":1},{"bars":4,"repeat":1,"bpm":100,"notes":"The song will continue, and you can set as many repeats as you want.","signature":4,"start_at":0.01,"fadeintime":0.1,"name":"sloha","song":"papierova fobia","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/08/Pap-Zac-Po-naruci.mp3","notesVisible":true,"autoplay":1},{"start_at":0.01,"signature":4,"bars":8,"repeat":1,"mp3":"https://www.divartwp.sk/wp-content/uploads/2026/08/Pap-Zac-Tvar.mp3","name":"sloha1","song":"papierova fobia","bpm":100,"notes":"But now Autoplay has stopped automatically because I set Autoplay to Off in the sample settings. Press Autoplay again and the song will continue.","fadeintime":0.1,"notesVisible":true,"autoplay":0},{"name":"ref","start_at":0.01,"song":"papierova fobia","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/08/Pap-Ref.mp3","notes":"Now the song continues, and it will stop again at the next track because Autoplay is set to Off there as well.","bpm":100,"signature":4,"bars":8,"fadeintime":0.1,"repeat":1,"notesVisible":true,"autoplay":1},{"name":"po ref","song":"papierova fobia","fadeintime":0.1,"mp3":"https://www.divartwp.sk/wp-content/uploads/2026/08/Pap-Po-ref.mp3","signature":4,"bpm":100,"notes":"Pretty clever, right? And Autoplay is off again.","start_at":0.01,"bars":8,"repeat":1,"notesVisible":true,"autoplay":0},{"fadeintime":0.1,"mp3":"https://www.divartwp.sk/wp-content/uploads/2026/08/Pap-pre-kon.mp3","bars":8,"name":"pred koniec","bpm":100,"song":"papierova fobia","repeat":1,"start_at":0.01,"notes":"And Autoplay is off again.","signature":4,"notesVisible":true,"autoplay":0},{"fadeintime":0.1,"mp3":"https://www.divartwp.sk/wp-content/uploads/2026/08/Kon.mp3","bars":8,"notes":"Pretty clever, right?","repeat":1,"song":"papierova fobia","name":"kon zac","signature":4,"bpm":100,"start_at":0.01,"notesVisible":true,"autoplay":1},{"notes":"","bpm":100,"signature":4,"fadeintime":0.1,"name":"kon nastup","song":"papierova fobia","start_at":0.01,"bars":8,"repeat":1,"mp3":"https://www.divartwp.sk/wp-content/uploads/2026/08/Kon-nastup.mp3","notesVisible":true,"autoplay":1},{"name":"klaves","fadeintime":0.1,"signature":4,"notes":"","song":"papierova fobia","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/08/Kon-Cely.mp3","start_at":0.01,"bpm":100,"repeat":1,"bars":26,"notesVisible":true,"autoplay":1}]},{"title":"song from 1 audio","tracks":[{"song":"watergate good moog","name":"watergate by moog","notes":"It\u2019s best to have your samples as separate audio files, but...","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3","bpm":174,"signature":"","bars":16,"repeat":"","start_at":0.05,"fadein":"on","fadeintime":0.1,"midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"watergate good moog","name":"zac1","notes":"If you want to experiment, you can build the whole song from a single audio file.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3","bpm":174,"signature":"","bars":16,"repeat":"","start_at":22.07,"fadein":"on","fadeintime":0.1,"midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"watergate good moog","name":"SPA","notes":"For this, use the Start At field in Track Settings. It lets you start the song from any point you want.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3","bpm":174,"signature":"","bars":16,"repeat":4,"start_at":44.14,"fadein":"on","fadeintime":0.1,"midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"watergate good moog","name":"SPA ZAVER","notes":"Sometimes you may need to adjust the Fade Time setting as well. If a sample starts with a click or pop, adding a short fade will make the start sound much smoother.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3","bpm":174,"signature":"","bars":16,"repeat":"","start_at":132.42,"fadein":"on","fadeintime":0.1,"midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"watergate good moog","name":"nastup","notes":"Press the E key or click the Edit pencil in the bottom-right corner. You\u2019ll see that every track uses the same audio file, just with different Start At points.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3","bpm":174,"signature":"","bars":16,"repeat":"","start_at":154.49,"fadein":"on","fadeintime":0.1,"midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"watergate good moog","name":"drum bass","notes":"ENJOY","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3","bpm":174,"signature":"","bars":40,"repeat":2,"start_at":176.57,"fadein":"on","fadeintime":0.1,"midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"watergate good moog","name":"nastup","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3","bpm":174,"signature":"","bars":16,"repeat":"","start_at":286.92,"fadein":"on","fadeintime":0.1,"midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"watergate good moog","name":"final","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3","bpm":174,"signature":"","bars":16,"repeat":"","start_at":309,"fadein":"on","fadeintime":0.1,"midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"watergate good moog","name":"end","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Watergate-Bez.mp3","bpm":174,"signature":"","bars":16,"repeat":"","start_at":342.1,"fadein":"on","fadeintime":0.1,"midiPC":"","midCC":"","notesVisible":true,"autoplay":1}]},{"title":"irregular meter","tracks":[{"song":"future rainer pethe","name":"piano","notes":"This track demonstrates how Samplton can be used to create and perform an unusual 19/4 rhythm.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/future-zac.mp3","bpm":180,"signature":19,"bars":2,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"future rainer pethe","name":"piano bass","notes":"It shows that loops and musical structures are not limited to standard time signatures such as 4/4 \u2014 even complex","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/future-zac1.mp3","bpm":180,"signature":19,"bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"future rainer pethe","name":"theme","notes":"unconventional rhythmic patterns can be built and played live.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/future-Vyhr1.mp3","bpm":180,"signature":19,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"future rainer pethe","name":"part","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/future-Part.mp3","bpm":180,"signature":19,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"future rainer pethe","name":"theme","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/future-Vyhr2.mp3","bpm":180,"signature":19,"bars":6,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"future rainer pethe","name":"part","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/future-Part-pred-kon.mp3","bpm":180,"signature":19,"bars":4,"repeat":2,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"future rainer pethe","name":"fin","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/future-Part-Kon.mp3","bpm":180,"signature":5,"bars":56,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1},{"song":"future rainer pethe","name":"future by rainer pethe","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/future-Part-Kon1.mp3","bpm":180,"signature":5,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":true,"autoplay":1}]},{"title":"drums","tracks":[{"song":"drums","name":"Bass Drum","notes":"Set Quantize to NONE to disable looping. Each pad will play only once, allowing you to trigger samples freely like drums, without AUTO mode or automatic looping. Samplton is not primarily designed as a drum-pad application. Its main purpose is precise live playback and synchronization with other devices, as well as practicing and preparing your live performance.","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/08/Bass-Drum-1.wav","bpm":"","signature":"","bars":"","repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":"","notesVisible":false},{"song":"drums","name":"High Conga","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/08/High-Conga-1.wav","bpm":"","signature":"","bars":"","repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"drums","name":"Claves","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/08/Claves.wav","bpm":"","signature":"","bars":"","repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"drums","name":"Side Stick","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/08/Ensoniq-SQ-1-Side-Stick.wav","bpm":"","signature":"","bars":"","repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""}]},{"tracks":[{"song":"\u010Do s vami","name":"sloha1","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/05/Slo1.mp3","notes":"","repeat":1,"fadeintime":0.1,"start_at":0.02,"signature":4,"fadein":"","bars":24,"bpm":142},{"bars":24,"notes":"","bpm":142,"start_at":0.02,"fadein":"","repeat":1,"fadeintime":0.1,"mp3":"https://www.divartwp.sk/wp-content/uploads/2026/05/Slo2.mp3","signature":4,"song":"\u010Do s vami","name":"Sloha2"},{"bars":24,"bpm":142,"repeat":1,"signature":4,"fadein":"","fadeintime":0.1,"notes":"","name":"Sloha3","start_at":0.02,"song":"\u010Do s vami","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/05/Slo3.mp3"},{"bpm":142,"fadein":"","signature":4,"name":"ref short","fadeintime":0.1,"song":"\u010Do s vami","notes":"","bars":32,"mp3":"https://www.divartwp.sk/wp-content/uploads/2026/05/Ref-short.mp3","start_at":0.02,"repeat":1},{"song":"\u010Do s vami","signature":4,"mp3":"https://www.divartwp.sk/wp-content/uploads/2026/05/Prech.mp3","name":"prech","start_at":0.02,"repeat":2,"fadein":"","notes":"","bars":4,"fadeintime":0.1,"bpm":142},{"song":"\u010Do s vami","notes":"","midCC":"","repeat":"","midiPC":"","name":"sloha4","fadein":"","signature":"","fadeintime":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/05/Slo3.mp3","bpm":142,"start_at":"","bars":24},{"name":"ref long","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/05/Ref-long.mp3","start_at":"","fadeintime":"","fadein":"","signature":"","midCC":"","notes":"","bars":56,"bpm":142,"song":"\u010Do s vami","midiPC":"","repeat":""},{"signature":"","bpm":142,"repeat":1,"mp3":"https://www.divartwp.sk/wp-content/uploads/2026/05/Zac.mp3","song":"\u010Do s vami","midiPC":"","start_at":"","bars":4,"notes":"","midCC":"","fadein":"","fadeintime":"","name":"po ref"},{"fadein":"","name":"ref bez","notes":"","midCC":"","bars":99,"signature":"","song":"\u010Do s vami","start_at":"","fadeintime":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/05/Ref-Bez.mp3","midiPC":"","bpm":142,"repeat":""},{"name":"dub","midCC":"","notes":"","fadein":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Co-s-vami-Dub.mp3","bpm":142,"bars":8,"start_at":"","fadeintime":"","song":"\u010Do s vami","signature":"","repeat":"","midiPC":""}],"title":"\u010Do s vami"},{"title":"o krajine","tracks":[{"song":"o krajine","name":"zac","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-zac-155-24.mp3","bpm":155,"signature":"","bars":4,"repeat":2,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"o krajine","name":"flute","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-Flute-.mp3","bpm":155,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"o krajine","name":"prech","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-zac-155-24.mp3","bpm":155,"signature":"","bars":2,"repeat":1,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"o krajine","name":"flazo","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-Flazo.mp3","bpm":155,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"o krajine","name":"flazo1","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-Flazo1.mp3","bpm":155,"signature":"","bars":8,"repeat":3,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"o krajine","name":"prech","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-Prech.mp3","bpm":155,"signature":"","bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"o krajine","name":"pokrac","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-Pokrac.mp3","bpm":155,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"on","fadeintime":0.1,"midiPC":"","midCC":""},{"song":"o krajine","name":"syn","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-Pokrac-syn.mp3","bpm":155,"signature":"","bars":40,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"o krajine","name":"kon","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-Koniec-.mp3","bpm":155,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"o krajine","name":"kon1","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Okrajinne-Koniec1.mp3","bpm":155,"signature":"","bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""}]},{"title":"zbl\xedska\u0165","tracks":[{"song":"zbl\xedska\u0165","name":"slak","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-slak-zac.mp3","bpm":115,"signature":"","bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zbl\xedska\u0165","name":"slak1","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-slak-zac1.mp3","bpm":115,"signature":"","bars":12,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zbl\xedska\u0165","name":"zac bass","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Zac-bass.mp3","bpm":115,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zbl\xedska\u0165","name":"bass 2","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Zac2-bass.mp3","bpm":115,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zbl\xedska\u0165","name":"vyhravka","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Zac-vyhravka.mp3","bpm":115,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zbl\xedska\u0165","name":"ref","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Ref.mp3","bpm":115,"signature":2,"bars":57,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zbl\xedska\u0165","name":"clap","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Clap.mp3","bpm":115,"signature":4,"bars":4,"repeat":2,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zbl\xedska\u0165","name":"bass","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Zac-bass.mp3","bpm":115,"signature":"","bars":4,"repeat":2,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zbl\xedska\u0165","name":"bass1","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Zac2-bass.mp3","bpm":115,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zbl\xedska\u0165","name":"vyhravka","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Zac-vyhravka.mp3","bpm":115,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zbl\xedska\u0165","name":"ref cut","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Ref-cut.mp3","bpm":115,"signature":2,"bars":52,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zbl\xedska\u0165","name":"ref","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Ref2.mp3","bpm":115,"signature":2,"bars":57,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zbl\xedska\u0165","name":"zaver","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Kon-115-bpm.mp3","bpm":115,"signature":"","bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zbl\xedska\u0165","name":"zaver","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zbliskat-Kon-115-bpm.mp3","bpm":115,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""}]},{"title":"like a blues","tracks":[{"song":"like a blues","name":"piano","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-klavir-110.mp3","bpm":110,"signature":2,"bars":58,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"like a blues","name":"piano tema","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Zac-58.mp3","bpm":110,"signature":2,"bars":58,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"like a blues","name":"regge","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Regge-60.mp3","bpm":110,"signature":4,"bars":30,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"like a blues","name":"regge1","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Regge2-38.mp3","bpm":110,"signature":4,"bars":19,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"like a blues","name":"amb piano","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Piano.mp3","bpm":110,"signature":4,"bars":2,"repeat":3,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"like a blues","name":"amb piano 1","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Piano1.mp3","bpm":110,"signature":4,"bars":2,"repeat":2,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"like a blues","name":"amb piano 2","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Piano3.mp3","bpm":110,"signature":1,"bars":18,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"like a blues","name":"amb bass piano","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Jazz-bass.mp3","bpm":110,"signature":4,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"like a blues","name":"jazz","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Jazz.mp3","bpm":110,"signature":4,"bars":18,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"like a blues","name":"jazz1","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Jazz1.mp3","bpm":110,"signature":4,"bars":20,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"like a blues","name":"prechod","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Like-a-blues-Jazz-po.mp3","bpm":110,"signature":4,"bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""}]},{"title":"zapalka","tracks":[{"song":"zapalka","name":"ruch","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-ruch-200.mp3","bpm":200,"signature":3,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zapalka","name":"ruch bongo","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-ruch-Bong.mp3","bpm":200,"signature":3,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zapalka","name":"zac","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-Zac-kus.mp3","bpm":200,"signature":3,"bars":16,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zapalka","name":"sloha pol","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-sloha-pol.mp3","bpm":200,"signature":3,"bars":32,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zapalka","name":"sloha","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-sloha-Cela.mp3","bpm":200,"signature":3,"bars":84,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zapalka","name":"pokrac","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-pokrac.mp3","bpm":200,"signature":3,"bars":16,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zapalka","name":"bass","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-pokrac-bass.mp3","bpm":200,"signature":3,"bars":16,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zapalka","name":"bass1","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-pokrac-bass1.mp3","bpm":200,"signature":3,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zapalka","name":"bass prechod","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-pokrac-bass2.mp3","bpm":200,"signature":3,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zapalka","name":"tema","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-Koniec.mp3","bpm":200,"signature":3,"bars":24,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zapalka","name":"tema bez","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-Koniec1.mp3","bpm":200,"signature":3,"bars":32,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zapalka","name":"koniec","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-Koniec2.mp3","bpm":200,"signature":3,"bars":50,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"zapalka","name":"sampel","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Zapalka-Koniec-bez-1.mp3","bpm":200,"signature":3,"bars":48,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""}]},{"title":"miesta v nas","tracks":[{"song":"miesta v nas","name":"zac ruch","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-zac.mp3","bpm":110,"signature":"","bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"miesta v nas","name":"sloha","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Sloha.mp3","bpm":110,"signature":"","bars":20,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"miesta v nas","name":"flute","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Flute-110.mp3","bpm":110,"signature":"","bars":20,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"miesta v nas","name":"sloha cut","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Sloha.mp3","bpm":110,"signature":"","bars":16,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"miesta v nas","name":"zaver","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Zaver.mp3","bpm":110,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"miesta v nas","name":"prechod","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Pokrac-zac.mp3","bpm":110,"signature":"","bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"miesta v nas","name":"flute","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Pokrac.mp3","bpm":110,"signature":"","bars":20,"repeat":2,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"miesta v nas","name":"flute cut","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Pokrac.mp3","bpm":110,"signature":"","bars":16,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"miesta v nas","name":"zaver","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Zaver.mp3","bpm":110,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"miesta v nas","name":"koniec","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Miesta-v-Nas-Pokrac-zac.mp3","bpm":110,"signature":"","bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""}]},{"title":"karma sala","tracks":[{"song":"karma sala","name":"zac bass 1","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-zac-210.mp3","bpm":210,"signature":9,"bars":2,"repeat":2,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"karma sala","name":"zac bass 2","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-zac-bass.mp3","bpm":210,"signature":9,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"karma sala","name":"sloha spev","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-Sloha.mp3","bpm":210,"signature":9,"bars":28,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"karma sala","name":"refren","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-Ref.mp3","bpm":210,"signature":9,"bars":16,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"karma sala","name":"po refren","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-Ref-po.mp3","bpm":210,"signature":9,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"karma sala","name":"sloha 2","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-Sloha2.mp3","bpm":210,"signature":9,"bars":16,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"karma sala","name":"ref koniec","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-Ref2.mp3","bpm":210,"signature":9,"bars":8,"repeat":4,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"karma sala","name":"sampel","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-sampel-rec.mp3","bpm":210,"signature":9,"bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"karma sala","name":"sampel","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Karma-Sala-sampel-.mp3","bpm":210,"signature":9,"bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""}]},{"title":"ohnostroj","tracks":[{"song":"ohnostroj","name":"zac","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Ohnostroj-zac-85.mp3","bpm":85,"signature":"","bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"ohnostroj","name":"kopak","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Ohnostroj-zac-kop.mp3","bpm":85,"signature":"","bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"ohnostroj","name":"truba","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Ohnostroj-zac-Truba.mp3","bpm":85,"signature":"","bars":4,"repeat":2,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"ohnostroj","name":"sloha zac","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Ohnostroj-Sloha-zac.mp3","bpm":85,"signature":"","bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"ohnostroj","name":"sloha","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Ohnostroj-Sloha-Cela.mp3","bpm":85,"signature":"","bars":16,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"ohnostroj","name":"ref a sloha 2","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Ohnostroj-Sloha-Cela.mp3","bpm":85,"signature":"","bars":24,"repeat":"","start_at":45.22,"fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"ohnostroj","name":"ref a zaver","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Ohnostroj-Sloha-Cela.mp3","bpm":85,"signature":"","bars":48,"repeat":"","start_at":113,"fadein":"","fadeintime":"","midiPC":"","midCC":""}]},{"title":"azuro","tracks":[{"song":"azuro","name":"zac","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Azuro-zac-100.mp3","bpm":100,"signature":"","bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"azuro","name":"tema","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Azuro-Tema.mp3","bpm":100,"signature":"","bars":36,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"azuro","name":"spev","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Azuro-Spev.mp3","bpm":100,"signature":"","bars":36,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"azuro","name":"solo","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/Azuro-Solo.mp3","bpm":100,"signature":"","bars":36,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""}]},{"title":"05ka","tracks":[{"song":"05ka","name":"piano","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-zac-110.mp3","bpm":110,"signature":5,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"piano zac","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-zac-1.mp3","bpm":110,"signature":5,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"fender","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-zac-Tema.mp3","bpm":110,"signature":5,"bars":16,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"piano nic","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema1.mp3","bpm":110,"signature":5,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"bass zac","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema2.mp3","bpm":110,"signature":5,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"bass syn","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema3Syn.mp3","bpm":110,"signature":5,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"bass","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema4Bass.mp3","bpm":110,"signature":5,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"tema","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema5.mp3","bpm":110,"signature":5,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"zaver","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema5Prech.mp3","bpm":110,"signature":5,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"o nieco","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema6-Spev.mp3","bpm":110,"signature":5,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"obraz sa","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema6-Spev-pol.mp3","bpm":110,"signature":5,"bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"rychly beat","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema7.mp3","bpm":110,"signature":5,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"opustis plaz","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema8.mp3","bpm":110,"signature":5,"bars":8,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"prechod","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Tema9-Prech.mp3","bpm":110,"signature":5,"bars":2,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"part2","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Koniec.mp3","bpm":110,"signature":5,"bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"part3","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Koniec1.mp3","bpm":110,"signature":5,"bars":4,"repeat":2,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"part4","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Koniec2.mp3","bpm":110,"signature":5,"bars":4,"repeat":2,"start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"zaver","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Koniec3.mp3","bpm":110,"signature":5,"bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"zaver1","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Koniec4.mp3","bpm":110,"signature":5,"bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""},{"song":"05ka","name":"zaver2","notes":"","mp3":"https://www.divartwp.sk/wp-content/uploads/2026/04/05Ka-Koniec5.mp3","bpm":110,"signature":5,"bars":4,"repeat":"","start_at":"","fadein":"","fadeintime":"","midiPC":"","midCC":""}]}]}');


var $5e47a1030dc5501a$exports = {};
$5e47a1030dc5501a$exports = JSON.parse('{"terms":{"title":"Terms & Conditions","content":["<b>Last updated: 26 August 2026</b>","<b>1. Operator</b><br>Samplton is operated by Martin Rybo\u0161 \u2013 Divart, Pribinova 82/A, 960 01 Zvolen, Slovakia. Company ID (I\u010CO): 43562230. Tax ID (DI\u010C): 1049451865. The operator is not VAT registered. Contact: info@samplton.eu.","<b>2. About Samplton</b><br>Samplton is a web-based Progressive Web App (PWA) intended for organising, storing, preparing and playing audio samples and songs. Some functions may also be available offline after the required data has been downloaded to the user\'s device.","<b>3. User Account</b><br>Some features require the user to sign in. Authentication is currently provided through Google. The user is responsible for maintaining access to their account and for activity performed through their account.","<b>4. FREE Version</b><br>Samplton may provide a FREE version with limited functionality, number of songs, maximum individual file size and cloud storage capacity. Current limits are displayed in the application and may be changed for future use of the FREE service.","<b>5. PRO Licence</b><br>The current PRO offer costs EUR 10 and provides access to PRO functionality, including unlimited songs and 100 MB of cloud storage. The exact features, price and storage included in the purchase are displayed to the user before payment.","<b>6. Additional Cloud Storage</b><br>PRO users may purchase additional cloud storage. The current offer is an additional 100 MB for EUR 10 per year. Additional storage is time-limited according to the period stated at checkout. The price and duration applicable to an order are always those displayed before payment.","<b>7. Payments</b><br>Online payments are processed by Stripe. Samplton does not directly store the user\'s payment card details. Before completing a purchase, the user is shown the applicable product, price and payment conditions.","<b>8. Activation</b><br>Paid functionality is associated with the Samplton user account used for the purchase. Activation may require successful confirmation of payment by the payment provider and Samplton\'s payment infrastructure.","<b>9. User Audio and Content</b><br>The user retains rights to audio and other content uploaded to Samplton. By uploading content, the user authorises Samplton to technically store, process, reproduce and transmit that content only to the extent necessary to provide the service. The user must have the necessary rights or permissions for all uploaded content.","<b>10. Cloud Storage and Backups</b><br>Samplton cloud storage is intended to support the operation of the application and should not be considered the user\'s only permanent archive. Users are strongly encouraged to retain their own backup copies of important audio files and project data.","<b>11. Third-Party Services</b><br>Samplton relies on third-party infrastructure and services, including services used for authentication, cloud storage, database functionality and payment processing. Temporary interruption or limitation of these services may affect Samplton.","<b>12. Updates and Changes</b><br>Samplton may receive updates, bug fixes, security changes and functional improvements. Features may be changed where reasonably necessary for technical, security or operational reasons and subject to applicable consumer law.","<b>13. Availability</b><br>The operator aims to keep Samplton available but does not guarantee uninterrupted operation. Temporary interruptions may occur because of maintenance, updates, internet connectivity, hosting infrastructure or third-party services.","<b>14. Consumer Rights and Digital Service Defects</b><br>Nothing in these Terms limits mandatory consumer rights. If Samplton or purchased digital functionality is not supplied as agreed or has a defect, the consumer may exercise the remedies available under applicable Slovak and European consumer law. Complaints can be submitted to info@samplton.eu.","<b>15. Right of Withdrawal</b><br>Consumers entering into a distance contract generally have a statutory right to withdraw within the period provided by applicable law. Where the law permits immediate supply of digital content or a digital service to affect the right of withdrawal, the required information, express request or consent and acknowledgement will be obtained separately during the purchase process. These Terms do not remove any statutory right of withdrawal.","<b>16. Refunds</b><br>Refunds and price reductions are provided where required by applicable consumer law. Nothing in these Terms excludes the consumer\'s statutory remedies for failure to supply or lack of conformity of digital content or a digital service.","<b>17. Prohibited Use</b><br>Samplton must not be used to store or distribute unlawful content, content that infringes third-party rights, malicious files or content whose storage or use would violate applicable law.","<b>18. Suspension or Termination</b><br>The operator may restrict access where reasonably necessary to protect the service, other users or infrastructure, or in cases of serious violation of these Terms or applicable law. Mandatory consumer rights and rights relating to purchased services remain unaffected.","<b>19. Alternative Dispute Resolution</b><br>If a consumer is not satisfied with the handling of a complaint or believes that their consumer rights have been violated, they may request remedy from the operator and may use the applicable alternative dispute resolution mechanisms available under Slovak law.","<b>20. Governing Law</b><br>These Terms are governed by the laws of the Slovak Republic, without depriving consumers residing in another country of mandatory consumer protection granted to them by applicable law.","<b>21. Contact</b><br>Martin Rybo\u0161 \u2013 Divart<br>Pribinova 82/A<br>960 01 Zvolen<br>Slovakia<br>I\u010CO: 43562230<br>DI\u010C: 1049451865<br>Not VAT registered<br>Email: info@samplton.eu<br>Website: samplton.eu"]},"privacy":{"title":"Privacy Policy","content":["<b>1. Personal Data</b><br>Samplton processes only data necessary to provide user accounts, cloud projects, storage and paid services.","<b>2. Google Sign-In</b><br>When signing in with Google, Samplton may receive information such as your name, email address, profile image and account identifier.","<b>3. Firebase</b><br>Firebase services are used for authentication and storing account-related project information.","<b>4. Cloudflare</b><br>Cloudflare infrastructure, including R2 storage, may be used to store and deliver user-uploaded audio files.","<b>5. Stripe</b><br>Stripe processes payments. Payment card details are processed by Stripe and are not stored by Samplton.","<b>6. Purpose</b><br>Personal information is used to operate Samplton, authenticate users, save projects, provide storage and manage purchased services.","<b>7. Data Deletion</b><br>Users may contact us to request information about or deletion of personal data, subject to applicable legal obligations.","<b>8. Security</b><br>Reasonable technical measures are used to protect account and project data. No online service can guarantee absolute security."]},"cookies":{"title":"Cookies & Local Storage","content":["<b>Local Storage</b><br>Samplton stores certain settings locally in your browser, for example metronome preferences and application state.","<b>IndexedDB</b><br>Samplton uses browser IndexedDB storage to cache projects and audio files for performance and offline functionality.","<b>Service Worker</b><br>The installed PWA may use browser cache and a Service Worker to allow faster loading and offline functionality.","<b>Authentication</b><br>Authentication services may use technically necessary browser storage to keep users signed in securely.","<b>Analytics and Advertising</b><br>Samplton currently does not intentionally use advertising cookies. If optional analytics or marketing technologies are added, this policy will be updated and consent will be requested where required."]},"contact":{"title":"Contact","content":["<b>Samplton</b>","Operator: Martin Rybo\u0161 \u2013 Divart","Business address: Pribinova 82/A, 960 01 Zvolen, Slovakia","Company ID (I\u010CO): 43562230","Tax ID (DI\u010C): 1049451865","VAT: Not VAT registered","Email: info@samplton.eu","Website: samplton.eu"]}}');


const $a7f559d5d89c892f$export$6d3c090e66a883b1 = ()=>undefined;


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $029952e65115eee5$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $029952e65115eee5$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $029952e65115eee5$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $029952e65115eee5$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $029952e65115eee5$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $029952e65115eee5$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $029952e65115eee5$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const $029952e65115eee5$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($029952e65115eee5$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $029952e65115eee5$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $029952e65115eee5$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $029952e65115eee5$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $029952e65115eee5$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $029952e65115eee5$var$stringToByteArray$1(str);
    return $029952e65115eee5$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $029952e65115eee5$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $029952e65115eee5$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $029952e65115eee5$export$c62426fdd000a97e = function(str) {
    try {
        return $029952e65115eee5$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $029952e65115eee5$export$6c40052bed430212(value) {
    return $029952e65115eee5$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $029952e65115eee5$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$029952e65115eee5$var$isValidKey(prop)) continue;
        target[prop] = $029952e65115eee5$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $029952e65115eee5$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $029952e65115eee5$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $029952e65115eee5$var$getDefaultsFromGlobal = ()=>$029952e65115eee5$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $029952e65115eee5$var$getDefaultsFromEnvVariable = ()=>{
    return;
};
const $029952e65115eee5$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $029952e65115eee5$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $029952e65115eee5$export$212bb2fc580a90a8 = ()=>{
    try {
        return (0, $a7f559d5d89c892f$export$6d3c090e66a883b1)() || $029952e65115eee5$var$getDefaultsFromGlobal() || $029952e65115eee5$var$getDefaultsFromEnvVariable() || $029952e65115eee5$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $029952e65115eee5$export$9c11895284c8adad = (productName)=>$029952e65115eee5$export$212bb2fc580a90a8()?.emulatorHosts?.[productName];
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $029952e65115eee5$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $029952e65115eee5$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $029952e65115eee5$export$3dfb6827a9f89756 = ()=>$029952e65115eee5$export$212bb2fc580a90a8()?.config;
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $029952e65115eee5$export$5539a1a3afe87d6 = (name)=>$029952e65115eee5$export$212bb2fc580a90a8()?.[`_${name}`];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $029952e65115eee5$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $029952e65115eee5$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = {
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        },
        // Override with user options
        ...token
    };
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $029952e65115eee5$export$4b5284a3025a455(JSON.stringify(header)),
        $029952e65115eee5$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $029952e65115eee5$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $029952e65115eee5$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($029952e65115eee5$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $029952e65115eee5$export$8ee0fc9ee280b4ee() {
    const forceEnvironment = $029952e65115eee5$export$212bb2fc580a90a8()?.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $029952e65115eee5$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' || $029952e65115eee5$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $029952e65115eee5$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $029952e65115eee5$export$ad9e9b75cb9fb797() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function $029952e65115eee5$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $029952e65115eee5$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $029952e65115eee5$export$f2f6a8999f8ebd30() {
    return $029952e65115eee5$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $029952e65115eee5$export$7e7b1a9668aaed8() {
    const ua = $029952e65115eee5$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $029952e65115eee5$export$202944b2d2824246() {
    return $029952e65115eee5$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $029952e65115eee5$export$5d1d834fbbf8bab7() {
    return $029952e65115eee5$export$588c7fdda06fbb0a.NODE_CLIENT === true || $029952e65115eee5$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $029952e65115eee5$export$95df08bae54cb4df() {
    return !$029952e65115eee5$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/** Returns true if we are running in Safari or WebKit */ function $029952e65115eee5$export$ef10bcfb06572016() {
    return !$029952e65115eee5$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && (navigator.userAgent.includes('Safari') || navigator.userAgent.includes('WebKit')) && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $029952e65115eee5$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $029952e65115eee5$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                reject(request.error?.message || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $029952e65115eee5$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $029952e65115eee5$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $029952e65115eee5$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $029952e65115eee5$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, $029952e65115eee5$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $029952e65115eee5$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $029952e65115eee5$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $029952e65115eee5$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $029952e65115eee5$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $029952e65115eee5$var$replaceTemplate(template, data) {
    try {
        let ptr = 0;
        let result = '';
        while(ptr < template.length){
            const start = template.indexOf('{$', ptr);
            if (start === -1) {
                result += template.substring(ptr);
                break;
            }
            const end = template.indexOf('}', start + 2);
            if (end === -1) {
                result += template.substring(ptr);
                break;
            }
            const key = template.substring(start + 2, end);
            const value = data[key];
            result += template.substring(ptr, start) + (value != null ? String(value) : `<${key}?>`);
            ptr = end + 1;
        }
        return result;
    } catch (e) {
        // Should never happen, but fallback just in case
        return template;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $029952e65115eee5$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $029952e65115eee5$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $029952e65115eee5$export$c5a53ce6a17cf18d($029952e65115eee5$export$c62426fdd000a97e(parts[0]) || '');
        claims = $029952e65115eee5$export$c5a53ce6a17cf18d($029952e65115eee5$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$5f870fcca7ae6a88 = function(token) {
    const claims = $029952e65115eee5$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$701c661ec91095f2 = function(token) {
    const claims = $029952e65115eee5$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $029952e65115eee5$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$fc970ed23da99565 = function(token) {
    const claims = $029952e65115eee5$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $029952e65115eee5$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $029952e65115eee5$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $029952e65115eee5$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $029952e65115eee5$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $029952e65115eee5$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($029952e65115eee5$var$isObject(aProp) && $029952e65115eee5$var$isObject(bProp)) {
            if (!$029952e65115eee5$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $029952e65115eee5$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $029952e65115eee5$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $029952e65115eee5$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $029952e65115eee5$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $029952e65115eee5$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $029952e65115eee5$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $029952e65115eee5$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $029952e65115eee5$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $029952e65115eee5$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $029952e65115eee5$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($029952e65115eee5$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $029952e65115eee5$var$noop;
        if (observer.error === undefined) observer.error = $029952e65115eee5$var$noop;
        if (observer.complete === undefined) observer.complete = $029952e65115eee5$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $029952e65115eee5$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $029952e65115eee5$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $029952e65115eee5$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $029952e65115eee5$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $029952e65115eee5$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $029952e65115eee5$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($029952e65115eee5$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $029952e65115eee5$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($029952e65115eee5$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $029952e65115eee5$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($029952e65115eee5$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $029952e65115eee5$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $029952e65115eee5$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $029952e65115eee5$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $029952e65115eee5$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $029952e65115eee5$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $029952e65115eee5$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $029952e65115eee5$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $029952e65115eee5$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $029952e65115eee5$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $029952e65115eee5$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $029952e65115eee5$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($029952e65115eee5$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $029952e65115eee5$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $029952e65115eee5$var$indicator(i);
}
function $029952e65115eee5$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $029952e65115eee5$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function $029952e65115eee5$export$5b4d24b45140ad90(url) {
    // `isCloudWorkstation` is called without protocol in certain connect*Emulator functions
    // In HTTP request builders, it's called with the protocol.
    // If called with protocol prefix, it's a valid URL, so we extract the hostname
    // If called without, we assume the string is the hostname.
    try {
        const host = url.startsWith('http://') || url.startsWith('https://') ? new URL(url).hostname : url;
        return host.endsWith('.cloudworkstations.dev');
    } catch  {
        return false;
    }
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ async function $029952e65115eee5$export$c0f0d0ce4283a937(endpoint) {
    const result = await fetch(endpoint, {
        credentials: 'include'
    });
    return result.ok;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @public
 * Generates a SHA-256 hash for the given input string.
 *
 * @param input The string to hash.
 * @returns A promise that resolves to the SHA-256 hash as a hex string.
 */ async function $029952e65115eee5$export$7220bf91e5c1b402(input) {
    const textEncoder = new TextEncoder();
    const data = textEncoder.encode(input);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    // Convert ArrayBuffer to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hexHash = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join('');
    return hexHash;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $5782dd2556309534$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5782dd2556309534$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $5782dd2556309534$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $029952e65115eee5$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options?.identifier);
        const optional = options?.optional ?? false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($5782dd2556309534$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $5782dd2556309534$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $5782dd2556309534$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $5782dd2556309534$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $5782dd2556309534$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = this.onInitCallbacks.get(normalizedIdentifier) ?? new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch  {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $5782dd2556309534$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch  {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $5782dd2556309534$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $5782dd2556309534$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $5782dd2556309534$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $5782dd2556309534$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $5782dd2556309534$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $5782dd2556309534$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $5782dd2556309534$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $59d1e3b150b2f36d$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $59d1e3b150b2f36d$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($59d1e3b150b2f36d$export$243e62d78d3b544d || ($59d1e3b150b2f36d$export$243e62d78d3b544d = {}));
const $59d1e3b150b2f36d$var$levelStringToEnum = {
    'debug': $59d1e3b150b2f36d$export$243e62d78d3b544d.DEBUG,
    'verbose': $59d1e3b150b2f36d$export$243e62d78d3b544d.VERBOSE,
    'info': $59d1e3b150b2f36d$export$243e62d78d3b544d.INFO,
    'warn': $59d1e3b150b2f36d$export$243e62d78d3b544d.WARN,
    'error': $59d1e3b150b2f36d$export$243e62d78d3b544d.ERROR,
    'silent': $59d1e3b150b2f36d$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $59d1e3b150b2f36d$var$defaultLogLevel = $59d1e3b150b2f36d$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $59d1e3b150b2f36d$var$ConsoleMethod = {
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.DEBUG]: 'log',
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.INFO]: 'info',
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.WARN]: 'warn',
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $59d1e3b150b2f36d$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $59d1e3b150b2f36d$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $59d1e3b150b2f36d$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $59d1e3b150b2f36d$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $59d1e3b150b2f36d$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $59d1e3b150b2f36d$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $59d1e3b150b2f36d$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $59d1e3b150b2f36d$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $59d1e3b150b2f36d$export$c622e99c0ce7b1c9(level) {
    $59d1e3b150b2f36d$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $59d1e3b150b2f36d$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $59d1e3b150b2f36d$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $59d1e3b150b2f36d$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel ?? instance.logLevel)) logCallback({
                level: $59d1e3b150b2f36d$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $e67bf383372d72f4$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $e67bf383372d72f4$var$idbProxyableTypes;
let $e67bf383372d72f4$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getIdbProxyableTypes() {
    return $e67bf383372d72f4$var$idbProxyableTypes || ($e67bf383372d72f4$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getCursorAdvanceMethods() {
    return $e67bf383372d72f4$var$cursorAdvanceMethods || ($e67bf383372d72f4$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $e67bf383372d72f4$var$cursorRequestMap = new WeakMap();
const $e67bf383372d72f4$var$transactionDoneMap = new WeakMap();
const $e67bf383372d72f4$var$transactionStoreNamesMap = new WeakMap();
const $e67bf383372d72f4$var$transformCache = new WeakMap();
const $e67bf383372d72f4$export$407448d2b89b1813 = new WeakMap();
function $e67bf383372d72f4$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($e67bf383372d72f4$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $e67bf383372d72f4$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $e67bf383372d72f4$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $e67bf383372d72f4$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($e67bf383372d72f4$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $e67bf383372d72f4$var$transactionDoneMap.set(tx, done);
}
let $e67bf383372d72f4$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $e67bf383372d72f4$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $e67bf383372d72f4$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $e67bf383372d72f4$export$43caf9889c228507(callback) {
    $e67bf383372d72f4$var$idbProxyTraps = callback($e67bf383372d72f4$var$idbProxyTraps);
}
function $e67bf383372d72f4$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($e67bf383372d72f4$export$3b14a55fb2447963(this), storeNames, ...args);
        $e67bf383372d72f4$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($e67bf383372d72f4$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b($e67bf383372d72f4$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args));
    };
}
function $e67bf383372d72f4$var$transformCachableValue(value) {
    if (typeof value === 'function') return $e67bf383372d72f4$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $e67bf383372d72f4$var$cacheDonePromiseForTransaction(value);
    if ($e67bf383372d72f4$export$23f2a1d2818174ef(value, $e67bf383372d72f4$var$getIdbProxyableTypes())) return new Proxy(value, $e67bf383372d72f4$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $e67bf383372d72f4$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $e67bf383372d72f4$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($e67bf383372d72f4$var$transformCache.has(value)) return $e67bf383372d72f4$var$transformCache.get(value);
    const newValue = $e67bf383372d72f4$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $e67bf383372d72f4$var$transformCache.set(value, newValue);
        $e67bf383372d72f4$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $e67bf383372d72f4$export$3b14a55fb2447963 = (value)=>$e67bf383372d72f4$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $da032767b57a4aa4$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $da032767b57a4aa4$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $da032767b57a4aa4$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $da032767b57a4aa4$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $da032767b57a4aa4$var$cachedMethods = new Map();
function $da032767b57a4aa4$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($da032767b57a4aa4$var$cachedMethods.get(prop)) return $da032767b57a4aa4$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $da032767b57a4aa4$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $da032767b57a4aa4$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $da032767b57a4aa4$var$cachedMethods.set(prop, method);
    return method;
}
(0, $e67bf383372d72f4$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5e587d655f0a08bb$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($5e587d655f0a08bb$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $5e587d655f0a08bb$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return component?.type === "VERSION" /* ComponentType.VERSION */ ;
}
const $5e587d655f0a08bb$var$name$q = "@firebase/app";
const $5e587d655f0a08bb$var$version$1 = "0.16.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e587d655f0a08bb$var$logger = new (0, $59d1e3b150b2f36d$export$efa9a398d6368992)('@firebase/app');
const $5e587d655f0a08bb$var$name$p = "@firebase/app-compat";
const $5e587d655f0a08bb$var$name$o = "@firebase/analytics-compat";
const $5e587d655f0a08bb$var$name$n = "@firebase/analytics";
const $5e587d655f0a08bb$var$name$m = "@firebase/app-check-compat";
const $5e587d655f0a08bb$var$name$l = "@firebase/app-check";
const $5e587d655f0a08bb$var$name$k = "@firebase/auth";
const $5e587d655f0a08bb$var$name$j = "@firebase/auth-compat";
const $5e587d655f0a08bb$var$name$i = "@firebase/database";
const $5e587d655f0a08bb$var$name$h = "@firebase/data-connect";
const $5e587d655f0a08bb$var$name$g = "@firebase/database-compat";
const $5e587d655f0a08bb$var$name$f = "@firebase/functions";
const $5e587d655f0a08bb$var$name$e = "@firebase/functions-compat";
const $5e587d655f0a08bb$var$name$d = "@firebase/installations";
const $5e587d655f0a08bb$var$name$c = "@firebase/installations-compat";
const $5e587d655f0a08bb$var$name$b = "@firebase/messaging";
const $5e587d655f0a08bb$var$name$a = "@firebase/messaging-compat";
const $5e587d655f0a08bb$var$name$9 = "@firebase/performance";
const $5e587d655f0a08bb$var$name$8 = "@firebase/performance-compat";
const $5e587d655f0a08bb$var$name$7 = "@firebase/remote-config";
const $5e587d655f0a08bb$var$name$6 = "@firebase/remote-config-compat";
const $5e587d655f0a08bb$var$name$5 = "@firebase/storage";
const $5e587d655f0a08bb$var$name$4 = "@firebase/storage-compat";
const $5e587d655f0a08bb$var$name$3 = "@firebase/firestore";
const $5e587d655f0a08bb$var$name$2 = "@firebase/ai";
const $5e587d655f0a08bb$var$name$1 = "@firebase/firestore-compat";
const $5e587d655f0a08bb$var$name = "firebase";
const $5e587d655f0a08bb$var$version = "12.17.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $5e587d655f0a08bb$export$9f30fa0c10967f7f = '[DEFAULT]';
const $5e587d655f0a08bb$var$PLATFORM_LOG_STRING = {
    [$5e587d655f0a08bb$var$name$q]: 'fire-core',
    [$5e587d655f0a08bb$var$name$p]: 'fire-core-compat',
    [$5e587d655f0a08bb$var$name$n]: 'fire-analytics',
    [$5e587d655f0a08bb$var$name$o]: 'fire-analytics-compat',
    [$5e587d655f0a08bb$var$name$l]: 'fire-app-check',
    [$5e587d655f0a08bb$var$name$m]: 'fire-app-check-compat',
    [$5e587d655f0a08bb$var$name$k]: 'fire-auth',
    [$5e587d655f0a08bb$var$name$j]: 'fire-auth-compat',
    [$5e587d655f0a08bb$var$name$i]: 'fire-rtdb',
    [$5e587d655f0a08bb$var$name$h]: 'fire-data-connect',
    [$5e587d655f0a08bb$var$name$g]: 'fire-rtdb-compat',
    [$5e587d655f0a08bb$var$name$f]: 'fire-fn',
    [$5e587d655f0a08bb$var$name$e]: 'fire-fn-compat',
    [$5e587d655f0a08bb$var$name$d]: 'fire-iid',
    [$5e587d655f0a08bb$var$name$c]: 'fire-iid-compat',
    [$5e587d655f0a08bb$var$name$b]: 'fire-fcm',
    [$5e587d655f0a08bb$var$name$a]: 'fire-fcm-compat',
    [$5e587d655f0a08bb$var$name$9]: 'fire-perf',
    [$5e587d655f0a08bb$var$name$8]: 'fire-perf-compat',
    [$5e587d655f0a08bb$var$name$7]: 'fire-rc',
    [$5e587d655f0a08bb$var$name$6]: 'fire-rc-compat',
    [$5e587d655f0a08bb$var$name$5]: 'fire-gcs',
    [$5e587d655f0a08bb$var$name$4]: 'fire-gcs-compat',
    [$5e587d655f0a08bb$var$name$3]: 'fire-fst',
    [$5e587d655f0a08bb$var$name$1]: 'fire-fst-compat',
    [$5e587d655f0a08bb$var$name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [$5e587d655f0a08bb$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $5e587d655f0a08bb$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $5e587d655f0a08bb$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5e587d655f0a08bb$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $5e587d655f0a08bb$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $5e587d655f0a08bb$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $5e587d655f0a08bb$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $5e587d655f0a08bb$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($5e587d655f0a08bb$export$9566bce3835c0f28.has(componentName)) {
        $5e587d655f0a08bb$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $5e587d655f0a08bb$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $5e587d655f0a08bb$export$b4e3c36c855b14b5.values())$5e587d655f0a08bb$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $5e587d655f0a08bb$export$fb03ad8d3d5c5f76.values())$5e587d655f0a08bb$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $5e587d655f0a08bb$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $5e587d655f0a08bb$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $5e587d655f0a08bb$export$9f30fa0c10967f7f) {
    $5e587d655f0a08bb$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $5e587d655f0a08bb$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $5e587d655f0a08bb$export$38e311c93c671bec(obj) {
    if ($5e587d655f0a08bb$export$110778f8e98b8257(obj)) return false;
    return 'authIdToken' in obj || 'appCheckToken' in obj || 'releaseOnDeref' in obj || 'automaticDataCollectionEnabled' in obj;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $5e587d655f0a08bb$export$643c8bc6c389f34e(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $5e587d655f0a08bb$export$3685d89b9c3cdfaf() {
    $5e587d655f0a08bb$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e587d655f0a08bb$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different {$mismatchedParam}. Existing: '{$oldValue}'. New: '{$newValue}'.",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const $5e587d655f0a08bb$var$ERROR_FACTORY = new (0, $029952e65115eee5$export$3fa6e1b18a3b2d40)('app', 'Firebase', $5e587d655f0a08bb$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5e587d655f0a08bb$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = {
            ...options
        };
        this._config = {
            ...config
        };
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $5782dd2556309534$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function $5e587d655f0a08bb$var$validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, $029952e65115eee5$export$c62426fdd000a97e)(base64Token.split('.')[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class $5e587d655f0a08bb$var$FirebaseServerAppImpl extends $5e587d655f0a08bb$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = {
            automaticDataCollectionEnabled: automaticDataCollectionEnabled,
            ...serverConfig
        };
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) $5e587d655f0a08bb$var$validateTokenTTL(this._serverConfig.authIdToken, 'authIdToken');
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) $5e587d655f0a08bb$var$validateTokenTTL(this._serverConfig.appCheckToken, 'appCheckToken');
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $5e587d655f0a08bb$export$d29d5299a7137abc($5e587d655f0a08bb$var$name$q, $5e587d655f0a08bb$var$version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $5e587d655f0a08bb$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $5e587d655f0a08bb$export$31499a9cd224b78c = $5e587d655f0a08bb$var$version;
function $5e587d655f0a08bb$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = {
        name: $5e587d655f0a08bb$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: true,
        ...rawConfig
    };
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $029952e65115eee5$export$3dfb6827a9f89756)());
    if (!options) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $5e587d655f0a08bb$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if (!(0, $029952e65115eee5$export$9cb4719e2e525b7a)(options, existingApp.options)) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name,
            mismatchedParam: 'options',
            oldValue: JSON.stringify(existingApp.options),
            newValue: JSON.stringify(options)
        });
        else if (!(0, $029952e65115eee5$export$9cb4719e2e525b7a)(config, existingApp.config)) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name,
            mismatchedParam: 'config',
            oldValue: JSON.stringify(existingApp.config),
            newValue: JSON.stringify(config)
        });
        else return existingApp;
    }
    const container = new (0, $5782dd2556309534$export$436a80eea5d5c0c5)(name);
    for (const component of $5e587d655f0a08bb$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $5e587d655f0a08bb$var$FirebaseAppImpl(options, config, container);
    $5e587d655f0a08bb$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $5e587d655f0a08bb$export$45a407ab953b136b(_options, _serverAppConfig = {}) {
    if ((0, $029952e65115eee5$export$4e09c449d6c407f7)() && !(0, $029952e65115eee5$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    let firebaseOptions;
    let serverAppSettings = _serverAppConfig || {};
    if (_options) {
        if ($5e587d655f0a08bb$export$110778f8e98b8257(_options)) firebaseOptions = _options.options;
        else if ($5e587d655f0a08bb$export$38e311c93c671bec(_options)) serverAppSettings = _options;
        else firebaseOptions = _options;
    }
    if (serverAppSettings.automaticDataCollectionEnabled === undefined) serverAppSettings.automaticDataCollectionEnabled = true;
    firebaseOptions || (firebaseOptions = (0, $029952e65115eee5$export$3dfb6827a9f89756)());
    if (!firebaseOptions) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    // Build an app name based on a hash of the configuration options.
    const nameObj = {
        ...serverAppSettings,
        ...firebaseOptions
    };
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (serverAppSettings.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = $5e587d655f0a08bb$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(serverAppSettings.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $5782dd2556309534$export$436a80eea5d5c0c5)(nameString);
    for (const component of $5e587d655f0a08bb$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $5e587d655f0a08bb$var$FirebaseServerAppImpl(firebaseOptions, serverAppSettings, nameString, container);
    $5e587d655f0a08bb$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $5e587d655f0a08bb$export$f9962582c9e66d99(name = $5e587d655f0a08bb$export$9f30fa0c10967f7f) {
    const app = $5e587d655f0a08bb$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $5e587d655f0a08bb$export$9f30fa0c10967f7f && (0, $029952e65115eee5$export$3dfb6827a9f89756)()) return $5e587d655f0a08bb$export$c55cfd413944906d();
    if (!app) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $5e587d655f0a08bb$export$68ddedf7d44b3bdf() {
    return Array.from($5e587d655f0a08bb$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $5e587d655f0a08bb$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($5e587d655f0a08bb$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $5e587d655f0a08bb$export$b4e3c36c855b14b5.delete(name);
    } else if ($5e587d655f0a08bb$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $5e587d655f0a08bb$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $5e587d655f0a08bb$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = $5e587d655f0a08bb$var$PLATFORM_LOG_STRING[libraryKeyOrName] ?? libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $5e587d655f0a08bb$var$logger.warn(warning.join(' '));
        return;
    }
    $5e587d655f0a08bb$export$c930050e7bb63965(new (0, $5782dd2556309534$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $5e587d655f0a08bb$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $59d1e3b150b2f36d$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $5e587d655f0a08bb$export$c622e99c0ce7b1c9(logLevel) {
    (0, $59d1e3b150b2f36d$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e587d655f0a08bb$var$DB_NAME = 'firebase-heartbeat-database';
const $5e587d655f0a08bb$var$DB_VERSION = 1;
const $5e587d655f0a08bb$var$STORE_NAME = 'firebase-heartbeat-store';
let $5e587d655f0a08bb$var$dbPromise = null;
function $5e587d655f0a08bb$var$getDbPromise() {
    if (!$5e587d655f0a08bb$var$dbPromise) $5e587d655f0a08bb$var$dbPromise = (0, $da032767b57a4aa4$export$ca0ed41b1a2af7e)($5e587d655f0a08bb$var$DB_NAME, $5e587d655f0a08bb$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($5e587d655f0a08bb$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $5e587d655f0a08bb$var$dbPromise;
}
async function $5e587d655f0a08bb$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $5e587d655f0a08bb$var$getDbPromise();
        const tx = db.transaction($5e587d655f0a08bb$var$STORE_NAME);
        const result = await tx.objectStore($5e587d655f0a08bb$var$STORE_NAME).get($5e587d655f0a08bb$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $029952e65115eee5$export$dd24e9cd51226c56)) $5e587d655f0a08bb$var$logger.warn(e.message);
        else {
            const idbGetError = $5e587d655f0a08bb$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e?.message
            });
            $5e587d655f0a08bb$var$logger.warn(idbGetError.message);
        }
    }
}
async function $5e587d655f0a08bb$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $5e587d655f0a08bb$var$getDbPromise();
        const tx = db.transaction($5e587d655f0a08bb$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($5e587d655f0a08bb$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $5e587d655f0a08bb$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $029952e65115eee5$export$dd24e9cd51226c56)) $5e587d655f0a08bb$var$logger.warn(e.message);
        else {
            const idbGetError = $5e587d655f0a08bb$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e?.message
            });
            $5e587d655f0a08bb$var$logger.warn(idbGetError.message);
        }
    }
}
function $5e587d655f0a08bb$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e587d655f0a08bb$var$MAX_HEADER_BYTES = 1024;
const $5e587d655f0a08bb$var$MAX_NUM_STORED_HEARTBEATS = 30;
class $5e587d655f0a08bb$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $5e587d655f0a08bb$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $5e587d655f0a08bb$var$getUTCDateString();
            if (this._heartbeatsCache?.heartbeats == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (this._heartbeatsCache?.heartbeats == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date: date,
                    agent: agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > $5e587d655f0a08bb$var$MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = $5e587d655f0a08bb$var$getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $5e587d655f0a08bb$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (this._heartbeatsCache?.heartbeats == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = $5e587d655f0a08bb$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $5e587d655f0a08bb$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $029952e65115eee5$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $5e587d655f0a08bb$var$logger.warn(e);
            return '';
        }
    }
}
function $5e587d655f0a08bb$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $5e587d655f0a08bb$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $5e587d655f0a08bb$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($5e587d655f0a08bb$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($5e587d655f0a08bb$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $5e587d655f0a08bb$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $029952e65115eee5$export$3865db50535c2055)()) return false;
        else return (0, $029952e65115eee5$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $5e587d655f0a08bb$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject?.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $5e587d655f0a08bb$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $5e587d655f0a08bb$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $5e587d655f0a08bb$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $029952e65115eee5$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function $5e587d655f0a08bb$var$getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5e587d655f0a08bb$var$registerCoreComponents(variant) {
    $5e587d655f0a08bb$export$c930050e7bb63965(new (0, $5782dd2556309534$export$16fa2f45be04daa8)('platform-logger', (container)=>new $5e587d655f0a08bb$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $5e587d655f0a08bb$export$c930050e7bb63965(new (0, $5782dd2556309534$export$16fa2f45be04daa8)('heartbeat', (container)=>new $5e587d655f0a08bb$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $5e587d655f0a08bb$export$d29d5299a7137abc($5e587d655f0a08bb$var$name$q, $5e587d655f0a08bb$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    $5e587d655f0a08bb$export$d29d5299a7137abc($5e587d655f0a08bb$var$name$q, $5e587d655f0a08bb$var$version$1, 'esm2020');
    // Register platform SDK identifier (no version).
    $5e587d655f0a08bb$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $5e587d655f0a08bb$var$registerCoreComponents('');





/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $b38ec4aa5ef4f8c4$export$f1e1789686576879 = {
    /** Phone as second factor */ PHONE: 'phone',
    TOTP: 'totp'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $b38ec4aa5ef4f8c4$export$342063e11d6c3cad = {
    /** Facebook provider ID */ FACEBOOK: 'facebook.com',
    /** GitHub provider ID */ GITHUB: 'github.com',
    /** Google provider ID */ GOOGLE: 'google.com',
    /** Password provider */ PASSWORD: 'password',
    /** Phone provider */ PHONE: 'phone',
    /** Twitter provider ID */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $b38ec4aa5ef4f8c4$export$882b5998b3b9117c = {
    /** Email link sign in method */ EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */ EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */ FACEBOOK: 'facebook.com',
    /** GitHub sign in method */ GITHUB: 'github.com',
    /** Google sign in method */ GOOGLE: 'google.com',
    /** Phone sign in method */ PHONE: 'phone',
    /** Twitter sign in method */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $b38ec4aa5ef4f8c4$export$dda1d9f60106f0e9 = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */ SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $b38ec4aa5ef4f8c4$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */ PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */ RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */ VERIFY_EMAIL: 'VERIFY_EMAIL'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b38ec4aa5ef4f8c4$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: 'This operation is restricted to administrators only.',
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: '',
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: 'This browser is not supported.',
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: 'The action code has expired.',
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: 'The mobile app identifier is not registered for the current project.',
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: 'The supplied auth credential is incorrect, malformed or has expired.',
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: 'Login blocked by user-provided method: {$originalMessage}',
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: 'A non-empty password must be provided',
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: 'User was not linked to an account with the given provider.',
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: 'The operation has timed out.',
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: 'The operation requires a verified email.',
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: '',
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is missing when sending request to the backend.',
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is invalid when sending request to the backend.',
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: 'The reCAPTCHA action is invalid when sending request to the backend.',
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: 'reCAPTCHA Enterprise integration is not enabled for this project.',
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: 'The reCAPTCHA client type is missing when sending request to the backend.',
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is missing when sending request to the backend.',
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: 'Invalid request parameters.',
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is invalid when sending request to the backend.',
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: 'The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.',
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: 'The password does not meet the requirements.',
        ["invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ ]: "The provided Hosting link domain is not configured in Firebase Hosting or is not owned by the current project. This cannot be a default Hosting domain (`web.app` or `firebaseapp.com`)."
    };
}
function $b38ec4aa5ef4f8c4$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $b38ec4aa5ef4f8c4$export$4a5767248b18ef41 = $b38ec4aa5ef4f8c4$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $b38ec4aa5ef4f8c4$export$3c2fa207a37baaea = $b38ec4aa5ef4f8c4$var$_prodErrorMap;
const $b38ec4aa5ef4f8c4$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $029952e65115eee5$export$3fa6e1b18a3b2d40)('auth', 'Firebase', $b38ec4aa5ef4f8c4$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $b38ec4aa5ef4f8c4$export$db3b6bfb95261072 = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_LOGIN_CREDENTIALS: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_PASSWORD: 'auth/missing-password',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized',
    RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
    MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
    INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
    INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
    MISSING_CLIENT_TYPE: 'auth/missing-client-type',
    MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
    INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
    INVALID_REQ_TYPE: 'auth/invalid-req-type',
    INVALID_HOSTING_LINK_DOMAIN: 'auth/invalid-hosting-link-domain'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b38ec4aa5ef4f8c4$var$logClient = new (0, $59d1e3b150b2f36d$export$efa9a398d6368992)('@firebase/auth');
function $b38ec4aa5ef4f8c4$var$_logWarn(msg, ...args) {
    if ($b38ec4aa5ef4f8c4$var$logClient.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).WARN) $b38ec4aa5ef4f8c4$var$logClient.warn(`Auth (${(0, $5e587d655f0a08bb$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
function $b38ec4aa5ef4f8c4$var$_logError(msg, ...args) {
    if ($b38ec4aa5ef4f8c4$var$logClient.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).ERROR) $b38ec4aa5ef4f8c4$var$logClient.error(`Auth (${(0, $5e587d655f0a08bb$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b38ec4aa5ef4f8c4$export$3d12bd131bb975d1(authOrCode, ...rest) {
    throw $b38ec4aa5ef4f8c4$var$createErrorInternal(authOrCode, ...rest);
}
function $b38ec4aa5ef4f8c4$export$890c4ad488842ce7(authOrCode, ...rest) {
    return $b38ec4aa5ef4f8c4$var$createErrorInternal(authOrCode, ...rest);
}
function $b38ec4aa5ef4f8c4$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = {
        ...$b38ec4aa5ef4f8c4$export$3c2fa207a37baaea(),
        [code]: message
    };
    const factory = new (0, $029952e65115eee5$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $b38ec4aa5ef4f8c4$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'Operations that alter the current user are not supported in conjunction with FirebaseServerApp');
}
function $b38ec4aa5ef4f8c4$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $b38ec4aa5ef4f8c4$export$3d12bd131bb975d1(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $b38ec4aa5ef4f8c4$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $b38ec4aa5ef4f8c4$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $b38ec4aa5ef4f8c4$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(assertion, authOrCode, ...rest) {
    if (!assertion) throw $b38ec4aa5ef4f8c4$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $b38ec4aa5ef4f8c4$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $b38ec4aa5ef4f8c4$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $b38ec4aa5ef4f8c4$export$92108d983e8ee699(assertion, message) {
    if (!assertion) $b38ec4aa5ef4f8c4$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b38ec4aa5ef4f8c4$var$_getCurrentUrl() {
    return typeof self !== 'undefined' && self.location?.href || '';
}
function $b38ec4aa5ef4f8c4$var$_isHttpOrHttps() {
    return $b38ec4aa5ef4f8c4$var$_getCurrentScheme() === 'http:' || $b38ec4aa5ef4f8c4$var$_getCurrentScheme() === 'https:';
}
function $b38ec4aa5ef4f8c4$var$_getCurrentScheme() {
    return typeof self !== 'undefined' && self.location?.protocol || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $b38ec4aa5ef4f8c4$var$_isOnline() {
    if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && typeof navigator.onLine === 'boolean' && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($b38ec4aa5ef4f8c4$var$_isHttpOrHttps() || (0, $029952e65115eee5$export$caa8774a9107a58e)() || 'connection' in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $b38ec4aa5ef4f8c4$var$_getUserLanguage() {
    if (typeof navigator === 'undefined') return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $b38ec4aa5ef4f8c4$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $b38ec4aa5ef4f8c4$export$92108d983e8ee699(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = (0, $029952e65115eee5$export$872f8323f01d7ae0)() || (0, $029952e65115eee5$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$b38ec4aa5ef4f8c4$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b38ec4aa5ef4f8c4$var$_emulatorUrl(config, path) {
    $b38ec4aa5ef4f8c4$export$92108d983e8ee699(config.emulator, 'Emulator should always be set here');
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b38ec4aa5ef4f8c4$export$faec65b429be379 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== 'undefined' && 'fetch' in self) return self.fetch;
        if (typeof globalThis !== 'undefined' && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== 'undefined') return fetch;
        $b38ec4aa5ef4f8c4$var$debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== 'undefined' && 'Headers' in self) return self.Headers;
        if (typeof globalThis !== 'undefined' && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== 'undefined') return Headers;
        $b38ec4aa5ef4f8c4$var$debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== 'undefined' && 'Response' in self) return self.Response;
        if (typeof globalThis !== 'undefined' && globalThis.Response) return globalThis.Response;
        if (typeof Response !== 'undefined') return Response;
        $b38ec4aa5ef4f8c4$var$debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $b38ec4aa5ef4f8c4$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b38ec4aa5ef4f8c4$var$CookieAuthProxiedEndpoints = [
    "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ ,
    "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ ,
    "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ ,
    "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ ,
    "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ ,
    "/v1/token" /* Endpoint.TOKEN */ 
];
const $b38ec4aa5ef4f8c4$var$DEFAULT_API_TIMEOUT_MS = new $b38ec4aa5ef4f8c4$var$Delay(30000, 60000);
function $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return {
        ...request,
        tenantId: auth.tenantId
    };
    return request;
}
async function $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $b38ec4aa5ef4f8c4$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $029952e65115eee5$export$ac4103b836844853)({
            ...params,
            key: auth.config.apiKey
        }).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/json';
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        const fetchArgs = {
            method: method,
            headers: headers,
            ...body
        };
        /* Security-conscious server-side frameworks tend to have built in mitigations for referrer
           problems". See the Cloudflare GitHub issue #487: Error: The 'referrerPolicy' field on
           'RequestInitializerDict' is not implemented."
           https://github.com/cloudflare/next-on-pages/issues/487 */ if (!(0, $029952e65115eee5$export$ad9e9b75cb9fb797)()) fetchArgs.referrerPolicy = 'strict-origin-when-cross-origin';
        if (auth.emulatorConfig && (0, $029952e65115eee5$export$5b4d24b45140ad90)(auth.emulatorConfig.host)) fetchArgs.credentials = 'include';
        return $b38ec4aa5ef4f8c4$export$faec65b429be379.fetch()(await $b38ec4aa5ef4f8c4$var$_getFinalTarget(auth, auth.config.apiHost, path, query), fetchArgs);
    });
}
async function $b38ec4aa5ef4f8c4$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = {
        ...$b38ec4aa5ef4f8c4$var$SERVER_ERROR_MAP,
        ...customErrorMap
    };
    try {
        const networkTimeout = new $b38ec4aa5ef4f8c4$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) throw $b38ec4aa5ef4f8c4$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !('errorMessage' in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $b38ec4aa5ef4f8c4$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $b38ec4aa5ef4f8c4$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $b38ec4aa5ef4f8c4$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, '-');
            if (serverErrorMessage) throw $b38ec4aa5ef4f8c4$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $b38ec4aa5ef4f8c4$export$3d12bd131bb975d1(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $029952e65115eee5$export$dd24e9cd51226c56)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $b38ec4aa5ef4f8c4$export$3d12bd131bb975d1(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            'message': String(e)
        });
    }
}
async function $b38ec4aa5ef4f8c4$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ('mfaPendingCredential' in serverResponse) $b38ec4aa5ef4f8c4$export$3d12bd131bb975d1(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
async function $b38ec4aa5ef4f8c4$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    const authInternal = auth;
    const finalTarget = authInternal.config.emulator ? $b38ec4aa5ef4f8c4$var$_emulatorUrl(auth.config, base) : `${auth.config.apiScheme}://${base}`;
    // Cookie auth works by MiTMing the signIn and token endpoints from the developer's backend,
    // saving the idToken and refreshToken into cookies, and then redacting the refreshToken
    // from the response
    if ($b38ec4aa5ef4f8c4$var$CookieAuthProxiedEndpoints.includes(path)) {
        // Persistence manager is async, we need to await it. We can't just wait for auth initialized
        // here since auth initialization calls this function.
        await authInternal._persistenceManagerAvailable;
        if (authInternal._getPersistenceType() === "COOKIE" /* PersistenceType.COOKIE */ ) {
            const cookiePersistence = authInternal._getPersistence();
            return cookiePersistence._getFinalTarget(finalTarget).toString();
        }
    }
    return finalTarget;
}
function $b38ec4aa5ef4f8c4$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case 'ENFORCE':
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case 'AUDIT':
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case 'OFF':
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $b38ec4aa5ef4f8c4$var$NetworkTimeout {
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($b38ec4aa5ef4f8c4$export$890c4ad488842ce7(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $b38ec4aa5ef4f8c4$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
}
function $b38ec4aa5ef4f8c4$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $b38ec4aa5ef4f8c4$export$890c4ad488842ce7(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b38ec4aa5ef4f8c4$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $b38ec4aa5ef4f8c4$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $b38ec4aa5ef4f8c4$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = '';
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error('recaptchaKey undefined');
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split('/')[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $b38ec4aa5ef4f8c4$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
    /**
     * Returns true if reCAPTCHA Enterprise protection is enabled in at least one provider, otherwise
     * returns false.
     *
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for at least one provider.
     */ isAnyProviderEnabled() {
        return this.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) || this.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b38ec4aa5ef4f8c4$var$getRecaptchaParams(auth) {
    return (await $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || '';
}
async function $b38ec4aa5ef4f8c4$var$getRecaptchaConfig(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b38ec4aa5ef4f8c4$var$deleteAccount(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $b38ec4aa5ef4f8c4$var$deleteLinkedAccounts(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $b38ec4aa5ef4f8c4$var$getAccountInfo(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b38ec4aa5ef4f8c4$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$7f8ddf7c7c20b3cd(user, forceRefresh = false) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$9bb611d729802a56(user, forceRefresh = false) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $b38ec4aa5ef4f8c4$var$_parseToken(token);
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase?.['sign_in_provider'];
    return {
        claims: claims,
        token: token,
        authTime: $b38ec4aa5ef4f8c4$var$utcTimestampToDateString($b38ec4aa5ef4f8c4$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $b38ec4aa5ef4f8c4$var$utcTimestampToDateString($b38ec4aa5ef4f8c4$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $b38ec4aa5ef4f8c4$var$utcTimestampToDateString($b38ec4aa5ef4f8c4$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: firebase?.['sign_in_second_factor'] || null
    };
}
function $b38ec4aa5ef4f8c4$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $b38ec4aa5ef4f8c4$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $b38ec4aa5ef4f8c4$var$_logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = (0, $029952e65115eee5$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $b38ec4aa5ef4f8c4$var$_logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $b38ec4aa5ef4f8c4$var$_logError('Caught error parsing JWT payload as JSON', e?.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $b38ec4aa5ef4f8c4$var$_tokenExpiresIn(token) {
    const parsedToken = $b38ec4aa5ef4f8c4$var$_parseToken(token);
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof parsedToken.exp !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof parsedToken.iat !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b38ec4aa5ef4f8c4$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $029952e65115eee5$export$dd24e9cd51226c56) && $b38ec4aa5ef4f8c4$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $b38ec4aa5ef4f8c4$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b38ec4aa5ef4f8c4$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = this.user.stsTokenManager.expirationTime ?? 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if (e?.code === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b38ec4aa5ef4f8c4$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $b38ec4aa5ef4f8c4$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $b38ec4aa5ef4f8c4$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b38ec4aa5ef4f8c4$var$_reloadWithoutSaving(user) {
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $b38ec4aa5ef4f8c4$var$_logoutIfInvalidated(user, $b38ec4aa5ef4f8c4$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(response?.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = coreAccount.providerUserInfo?.length ? $b38ec4aa5ef4f8c4$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $b38ec4aa5ef4f8c4$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !providerData?.length;
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $b38ec4aa5ef4f8c4$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$2e2af4578d910ddf(user) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    await $b38ec4aa5ef4f8c4$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $b38ec4aa5ef4f8c4$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $b38ec4aa5ef4f8c4$var$extractProviderData(providers) {
    return providers.map(({ providerId: providerId, ...provider })=>{
        return {
            providerId: providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable camelcase */ async function $b38ec4aa5ef4f8c4$var$requestStsToken(auth, refreshToken) {
    const response = await $b38ec4aa5ef4f8c4$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $029952e65115eee5$export$ac4103b836844853)({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = await $b38ec4aa5ef4f8c4$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/x-www-form-urlencoded';
        const options = {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        };
        if (auth.emulatorConfig && (0, $029952e65115eee5$export$5b4d24b45140ad90)(auth.emulatorConfig.host)) options.credentials = 'include';
        return $b38ec4aa5ef4f8c4$export$faec65b429be379.fetch()(url, options);
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $b38ec4aa5ef4f8c4$var$revokeToken(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $b38ec4aa5ef4f8c4$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof response.idToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof response.refreshToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined' ? Number(response.expiresIn) : $b38ec4aa5ef4f8c4$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $b38ec4aa5ef4f8c4$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $b38ec4aa5ef4f8c4$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $b38ec4aa5ef4f8c4$var$StsTokenManager();
        if (refreshToken) {
            $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof refreshToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof accessToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof expirationTime === 'number', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $b38ec4aa5ef4f8c4$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $b38ec4aa5ef4f8c4$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b38ec4aa5ef4f8c4$var$assertStringOrUndefined(assertion, appName) {
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $b38ec4aa5ef4f8c4$export$2ed0fc6709e59212 {
    constructor({ uid: uid, auth: auth, stsTokenManager: stsTokenManager, ...opt }){
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $b38ec4aa5ef4f8c4$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $b38ec4aa5ef4f8c4$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $b38ec4aa5ef4f8c4$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $b38ec4aa5ef4f8c4$export$9bb611d729802a56(this, forceRefresh);
    }
    reload() {
        return $b38ec4aa5ef4f8c4$export$2e2af4578d910ddf(this);
    }
    _assign(user) {
        if (this === user) return;
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>({
                ...userInfo
            }));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $b38ec4aa5ef4f8c4$export$2ed0fc6709e59212({
            ...this,
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        });
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $b38ec4aa5ef4f8c4$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.auth.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $b38ec4aa5ef4f8c4$var$_logoutIfInvalidated(this, $b38ec4aa5ef4f8c4$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return {
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>({
                    ...userInfo
                })),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId,
            ...this.metadata.toJSON(),
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        };
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        const displayName = object.displayName ?? undefined;
        const email = object.email ?? undefined;
        const phoneNumber = object.phoneNumber ?? undefined;
        const photoURL = object.photoURL ?? undefined;
        const tenantId = object.tenantId ?? undefined;
        const _redirectEventId = object._redirectEventId ?? undefined;
        const createdAt = object.createdAt ?? undefined;
        const lastLoginAt = object.lastLoginAt ?? undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $b38ec4aa5ef4f8c4$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof uid === 'string', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $b38ec4aa5ef4f8c4$var$assertStringOrUndefined(displayName, auth.name);
        $b38ec4aa5ef4f8c4$var$assertStringOrUndefined(email, auth.name);
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof emailVerified === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof isAnonymous === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $b38ec4aa5ef4f8c4$var$assertStringOrUndefined(phoneNumber, auth.name);
        $b38ec4aa5ef4f8c4$var$assertStringOrUndefined(photoURL, auth.name);
        $b38ec4aa5ef4f8c4$var$assertStringOrUndefined(tenantId, auth.name);
        $b38ec4aa5ef4f8c4$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $b38ec4aa5ef4f8c4$var$assertStringOrUndefined(createdAt, auth.name);
        $b38ec4aa5ef4f8c4$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $b38ec4aa5ef4f8c4$export$2ed0fc6709e59212({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>({
                ...userInfo
            }));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $b38ec4aa5ef4f8c4$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $b38ec4aa5ef4f8c4$export$2ed0fc6709e59212({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $b38ec4aa5ef4f8c4$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $b38ec4aa5ef4f8c4$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !providerData?.length;
        const stsTokenManager = new $b38ec4aa5ef4f8c4$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $b38ec4aa5ef4f8c4$export$2ed0fc6709e59212({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $b38ec4aa5ef4f8c4$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !providerData?.length
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b38ec4aa5ef4f8c4$var$instanceCache = new Map();
function $b38ec4aa5ef4f8c4$export$cf2f7c5792f80b46(cls) {
    $b38ec4aa5ef4f8c4$export$92108d983e8ee699(cls instanceof Function, 'Expected a class definition');
    let instance = $b38ec4aa5ef4f8c4$var$instanceCache.get(cls);
    if (instance) {
        $b38ec4aa5ef4f8c4$export$92108d983e8ee699(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    $b38ec4aa5ef4f8c4$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b38ec4aa5ef4f8c4$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$b38ec4aa5ef4f8c4$var$InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $b38ec4aa5ef4f8c4$export$61196ced6d74a310 = $b38ec4aa5ef4f8c4$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b38ec4aa5ef4f8c4$export$53a70dd1ebbae346(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $b38ec4aa5ef4f8c4$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $b38ec4aa5ef4f8c4$export$53a70dd1ebbae346(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $b38ec4aa5ef4f8c4$export$53a70dd1ebbae346("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        if (!blob) return null;
        if (typeof blob === 'string') {
            const response = await $b38ec4aa5ef4f8c4$var$getAccountInfo(this.auth, {
                idToken: blob
            }).catch(()=>undefined);
            if (!response) return null;
            return $b38ec4aa5ef4f8c4$export$2ed0fc6709e59212._fromGetAccountInfoResponse(this.auth, response, blob);
        }
        return $b38ec4aa5ef4f8c4$export$2ed0fc6709e59212._fromJSON(this.auth, blob);
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $b38ec4aa5ef4f8c4$var$PersistenceUserManager($b38ec4aa5ef4f8c4$export$cf2f7c5792f80b46($b38ec4aa5ef4f8c4$export$61196ced6d74a310), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $b38ec4aa5ef4f8c4$export$cf2f7c5792f80b46($b38ec4aa5ef4f8c4$export$61196ced6d74a310);
        const key = $b38ec4aa5ef4f8c4$export$53a70dd1ebbae346(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                let user;
                if (typeof blob === 'string') {
                    const response = await $b38ec4aa5ef4f8c4$var$getAccountInfo(auth, {
                        idToken: blob
                    }).catch(()=>undefined);
                    if (!response) break;
                    user = await $b38ec4aa5ef4f8c4$export$2ed0fc6709e59212._fromGetAccountInfoResponse(auth, response, blob);
                } else user = $b38ec4aa5ef4f8c4$export$2ed0fc6709e59212._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch  {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $b38ec4aa5ef4f8c4$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch  {}
        }));
        return new $b38ec4aa5ef4f8c4$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $b38ec4aa5ef4f8c4$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) return "Opera" /* BrowserName.OPERA */ ;
    else if ($b38ec4aa5ef4f8c4$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes('msie') || ua.includes('trident/')) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes('edge/')) return "Edge" /* BrowserName.EDGE */ ;
    else if ($b38ec4aa5ef4f8c4$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes('silk/')) return "Silk" /* BrowserName.SILK */ ;
    else if ($b38ec4aa5ef4f8c4$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($b38ec4aa5ef4f8c4$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($b38ec4aa5ef4f8c4$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes('chrome/') || $b38ec4aa5ef4f8c4$var$_isChromeIOS(ua)) && !ua.includes('edge/')) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($b38ec4aa5ef4f8c4$export$28f7fcd39efa255(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if (matches?.length === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $b38ec4aa5ef4f8c4$var$_isFirefox(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $b38ec4aa5ef4f8c4$var$_isSafari(userAgent = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('crios/') && !ua.includes('android');
}
function $b38ec4aa5ef4f8c4$var$_isChromeIOS(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $b38ec4aa5ef4f8c4$var$_isIEMobile(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $b38ec4aa5ef4f8c4$export$28f7fcd39efa255(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $b38ec4aa5ef4f8c4$var$_isBlackBerry(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $b38ec4aa5ef4f8c4$var$_isWebOS(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $b38ec4aa5ef4f8c4$export$9fa96a7d116ea3ce(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $b38ec4aa5ef4f8c4$export$9d398bebfec1c039(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $b38ec4aa5ef4f8c4$var$_isIOSStandalone(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return $b38ec4aa5ef4f8c4$export$9fa96a7d116ea3ce(ua) && !!window.navigator?.standalone;
}
function $b38ec4aa5ef4f8c4$var$_isIE10() {
    return (0, $029952e65115eee5$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $b38ec4aa5ef4f8c4$var$_isMobileBrowser(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $b38ec4aa5ef4f8c4$export$9fa96a7d116ea3ce(ua) || $b38ec4aa5ef4f8c4$export$28f7fcd39efa255(ua) || $b38ec4aa5ef4f8c4$var$_isWebOS(ua) || $b38ec4aa5ef4f8c4$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $b38ec4aa5ef4f8c4$var$_isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $b38ec4aa5ef4f8c4$export$738ab4df8bf92ae9(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $b38ec4aa5ef4f8c4$var$_getBrowserName((0, $029952e65115eee5$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$b38ec4aa5ef4f8c4$var$_getBrowserName((0, $029952e65115eee5$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(',') : 'FirebaseCore-web'; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $5e587d655f0a08bb$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b38ec4aa5ef4f8c4$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e?.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $b38ec4aa5ef4f8c4$var$_getPasswordPolicy(auth, request = {}) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $b38ec4aa5ef4f8c4$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $b38ec4aa5ef4f8c4$var$PasswordPolicyImpl {
    constructor(response){
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = responseOptions.minPasswordLength ?? $b38ec4aa5ef4f8c4$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === 'ENFORCEMENT_STATE_UNSPECIFIED') this.enforcementState = 'OFF';
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = response.allowedNonAlphanumericCharacters?.join('') ?? '';
        this.forceUpgradeOnSignin = response.forceUpgradeOnSignin ?? false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = status.meetsMinPasswordLength ?? true);
        status.isValid && (status.isValid = status.meetsMaxPasswordLength ?? true);
        status.isValid && (status.isValid = status.containsLowercaseLetter ?? true);
        status.isValid && (status.isValid = status.containsUppercaseLetter ?? true);
        status.isValid && (status.isValid = status.containsNumericCharacter ?? true);
        status.isValid && (status.isValid = status.containsNonAlphanumericCharacter ?? true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= 'a' && passwordChar <= 'z', /* containsUppercaseCharacter= */ passwordChar >= 'A' && passwordChar <= 'Z', /* containsNumericCharacter= */ passwordChar >= '0' && passwordChar <= '9', /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b38ec4aa5ef4f8c4$export$91477dc880baac21 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $b38ec4aa5ef4f8c4$var$Subscription(this);
        this.idTokenSubscription = new $b38ec4aa5ef4f8c4$var$Subscription(this);
        this.beforeStateQueue = new $b38ec4aa5ef4f8c4$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $b38ec4aa5ef4f8c4$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        this._resolvePersistenceManagerAvailable = undefined;
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
        // TODO(jamesdaniels) explore less hacky way to do this, cookie authentication needs
        // persistenceMananger to be available. see _getFinalTarget for more context
        this._persistenceManagerAvailable = new Promise((resolve)=>this._resolvePersistenceManagerAvailable = resolve);
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $b38ec4aa5ef4f8c4$export$cf2f7c5792f80b46(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            if (this._deleted) return;
            this.persistenceManager = await $b38ec4aa5ef4f8c4$var$PersistenceUserManager.create(this, persistenceHierarchy);
            this._resolvePersistenceManagerAvailable?.();
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if (this._popupRedirectResolver?._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = this.currentUser?.uid || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $b38ec4aa5ef4f8c4$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $b38ec4aa5ef4f8c4$export$2ed0fc6709e59212._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn('FirebaseServerApp could not login user with provided authIdToken: ', err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = this.redirectUser?._redirectEventId;
            const storedUserEventId = futureCurrentUser?._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && result?.user) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $b38ec4aa5ef4f8c4$var$_reloadWithoutSaving(user);
        } catch (e) {
            if (e?.code !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $b38ec4aa5ef4f8c4$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $029952e65115eee5$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($b38ec4aa5ef4f8c4$export$cf2f7c5792f80b46(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $b38ec4aa5ef4f8c4$var$_getPasswordPolicy(this);
        const passwordPolicy = new $b38ec4aa5ef4f8c4$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistenceType() {
        return this.assertedPersistence.persistence.type;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $029952e65115eee5$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: 'apple.com',
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $b38ec4aa5ef4f8c4$var$revokeToken(this, request);
        }
    }
    toJSON() {
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: this._currentUser?.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $b38ec4aa5ef4f8c4$export$cf2f7c5792f80b46(popupRedirectResolver) || this._popupRedirectResolver;
            $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $b38ec4aa5ef4f8c4$var$PersistenceUserManager.create(this, [
                $b38ec4aa5ef4f8c4$export$cf2f7c5792f80b46(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (this._currentUser?._redirectEventId === id) return this._currentUser;
        if (this.redirectUser?._redirectEventId === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = this.currentUser?.uid ?? null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === 'function' ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === 'function') {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $b38ec4aa5ef4f8c4$export$738ab4df8bf92ae9(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await this.heartbeatServiceProvider.getImmediate({
            optional: true
        })?.getHeartbeatsHeader();
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheckTokenResult = await this.appCheckServiceProvider.getImmediate({
            optional: true
        })?.getToken();
        if (appCheckTokenResult?.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $b38ec4aa5ef4f8c4$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult?.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $b38ec4aa5ef4f8c4$export$23ebac1979863676(auth) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $b38ec4aa5ef4f8c4$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $029952e65115eee5$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $b38ec4aa5ef4f8c4$var$externalJSProvider = {
    async loadJS () {
        throw new Error('Unable to load external scripts');
    },
    recaptchaV2Script: '',
    recaptchaEnterpriseScript: '',
    gapiScript: ''
};
function $b38ec4aa5ef4f8c4$var$_setExternalJSProvider(p) {
    $b38ec4aa5ef4f8c4$var$externalJSProvider = p;
}
function $b38ec4aa5ef4f8c4$var$_loadJS(url) {
    return $b38ec4aa5ef4f8c4$var$externalJSProvider.loadJS(url);
}
function $b38ec4aa5ef4f8c4$var$_recaptchaV2ScriptUrl() {
    return $b38ec4aa5ef4f8c4$var$externalJSProvider.recaptchaV2Script;
}
function $b38ec4aa5ef4f8c4$var$_recaptchaEnterpriseScriptUrl() {
    return $b38ec4aa5ef4f8c4$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $b38ec4aa5ef4f8c4$var$_gapiScriptUrl() {
    return $b38ec4aa5ef4f8c4$var$externalJSProvider.gapiScript;
}
function $b38ec4aa5ef4f8c4$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b38ec4aa5ef4f8c4$var$_SOLVE_TIME_MS = 500;
const $b38ec4aa5ef4f8c4$var$_EXPIRATION_TIME_MS = 60000;
const $b38ec4aa5ef4f8c4$var$_WIDGET_ID_START = 1000000000000;
class $b38ec4aa5ef4f8c4$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $b38ec4aa5ef4f8c4$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $b38ec4aa5ef4f8c4$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        const id = optWidgetId || $b38ec4aa5ef4f8c4$var$_WIDGET_ID_START;
        this._widgets.get(id)?.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        const id = optWidgetId || $b38ec4aa5ef4f8c4$var$_WIDGET_ID_START;
        return this._widgets.get(id)?.getResponse() || '';
    }
    async execute(optWidgetId) {
        const id = optWidgetId || $b38ec4aa5ef4f8c4$var$_WIDGET_ID_START;
        this._widgets.get(id)?.execute();
        return '';
    }
}
class $b38ec4aa5ef4f8c4$var$MockGreCAPTCHATopLevel {
    constructor(){
        this.enterprise = new $b38ec4aa5ef4f8c4$var$MockGreCAPTCHA();
    }
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $b38ec4aa5ef4f8c4$var$MockGreCAPTCHA {
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $b38ec4aa5ef4f8c4$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) this.execute();
        else this.container.addEventListener('click', this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $b38ec4aa5ef4f8c4$var$generateRandomAlphaNumericString(50);
            const { callback: callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $b38ec4aa5ef4f8c4$var$_EXPIRATION_TIME_MS);
        }, $b38ec4aa5ef4f8c4$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error('reCAPTCHA mock was already deleted!');
    }
}
function $b38ec4aa5ef4f8c4$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join('');
}
/* eslint-disable @typescript-eslint/no-require-imports */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b38ec4aa5ef4f8c4$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
const $b38ec4aa5ef4f8c4$var$FAKE_TOKEN = 'NO_RECAPTCHA';
const $b38ec4aa5ef4f8c4$var$RECAPTCHA_ENTERPRISE_ONLOAD_CALLBACK_NAME = 'onFirebaseAuthREInstanceReady';
class $b38ec4aa5ef4f8c4$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $b38ec4aa5ef4f8c4$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $b38ec4aa5ef4f8c4$export$23ebac1979863676(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = 'verify', forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $b38ec4aa5ef4f8c4$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error('recaptcha Enterprise site key undefined'));
                    else {
                        const config = new $b38ec4aa5ef4f8c4$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($b38ec4aa5ef4f8c4$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($b38ec4aa5ef4f8c4$var$FAKE_TOKEN);
                });
            });
            else reject(Error('No reCAPTCHA enterprise script loaded.'));
        }
        // Returns Promise for a mock token when appVerificationDisabledForTesting is true.
        if (this.auth.settings.appVerificationDisabledForTesting) {
            const mockRecaptcha = new $b38ec4aa5ef4f8c4$var$MockGreCAPTCHATopLevel();
            return mockRecaptcha.execute('siteKey', {
                action: 'verify'
            });
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then(async (siteKey)=>{
                if (!forceRefresh && $b38ec4aa5ef4f8c4$var$isEnterprise(window.grecaptcha) && // If download has already been initiated, do not trigger another
                // download, await the promise here.
                $b38ec4aa5ef4f8c4$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred) {
                    await $b38ec4aa5ef4f8c4$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred.promise;
                    retrieveRecaptchaToken(siteKey, resolve, reject);
                } else {
                    if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                    }
                    let url = $b38ec4aa5ef4f8c4$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey + `&onload=${$b38ec4aa5ef4f8c4$var$RECAPTCHA_ENTERPRISE_ONLOAD_CALLBACK_NAME}`;
                    // Existence of deferred indicates download has been initiated.
                    $b38ec4aa5ef4f8c4$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred = new (0, $029952e65115eee5$export$85f6557964517f1a)();
                    /**
                     * Script attached to global window object that will be called
                     * when the ReCAPTCHA Enterprise instance is ready.
                     * grecaptcha.ready() is not reliable when there are multiple
                     * scripts on the page, and script.onload only indicates the
                     * script has downloaded, not that it has initialized.
                     */ window[$b38ec4aa5ef4f8c4$var$RECAPTCHA_ENTERPRISE_ONLOAD_CALLBACK_NAME] = ()=>{
                        $b38ec4aa5ef4f8c4$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred?.resolve();
                    };
                    $b38ec4aa5ef4f8c4$var$_loadJS(url).then(()=>$b38ec4aa5ef4f8c4$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred?.promise).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
/**
 * Deferred that resolves when script tag has been injected onto the page
 * and the script is ready (grecaptcha.ready() and script.onload are not
 * reliable indicators, so this resolves when the global
 * `window[RECAPTCHA_ENTERPRISE_ONLOAD_CALLBACK_NAME]()` callback provided to the recaptcha url param "onload"
 * is triggered).
 * As a static variable this is applied to all instances of the class.
 * This will cause an error if users try to create multiple RecaptchaVerifiers
 * with different Recaptcha Enterprise sitekeys, which should be an
 * unuspported use case.
 */ $b38ec4aa5ef4f8c4$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred = null;
async function $b38ec4aa5ef4f8c4$var$injectRecaptchaFields(auth, request, action, isCaptchaResp = false, isFakeToken = false) {
    const verifier = new $b38ec4aa5ef4f8c4$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    if (isFakeToken) captchaResponse = $b38ec4aa5ef4f8c4$var$FAKE_TOKEN;
    else try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = {
        ...request
    };
    if (action === "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */  || action === "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ ) {
        if ('phoneEnrollmentInfo' in newRequest) {
            const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
            const recaptchaToken = newRequest.phoneEnrollmentInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneEnrollmentInfo': {
                    phoneNumber: phoneNumber,
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        } else if ('phoneSignInInfo' in newRequest) {
            const recaptchaToken = newRequest.phoneSignInInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneSignInInfo': {
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        }
        return newRequest;
    }
    if (!isCaptchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        'captchaResp': captchaResponse
    });
    Object.assign(newRequest, {
        'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $b38ec4aa5ef4f8c4$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod, recaptchaAuthProvider) {
    if (recaptchaAuthProvider === "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) {
        if (authInstance._getRecaptchaConfig()?.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ )) {
            const requestWithRecaptcha = await $b38ec4aa5ef4f8c4$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return actionMethod(authInstance, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
                const requestWithRecaptcha = await $b38ec4aa5ef4f8c4$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
                return actionMethod(authInstance, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    } else if (recaptchaAuthProvider === "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) {
        if (authInstance._getRecaptchaConfig()?.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) {
            const requestWithRecaptcha = await $b38ec4aa5ef4f8c4$var$injectRecaptchaFields(authInstance, request, actionName);
            return actionMethod(authInstance, requestWithRecaptcha).catch(async (error)=>{
                if (authInstance._getRecaptchaConfig()?.getProviderEnforcementState("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) === "AUDIT" /* EnforcementState.AUDIT */ ) // AUDIT mode
                {
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }` || error.code === `auth/${"invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ }`) {
                        console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${actionName} flow.`);
                        // reCAPTCHA Enterprise token is missing or reCAPTCHA Enterprise token
                        // check fails.
                        // Fallback to reCAPTCHA v2 flow.
                        const requestWithRecaptchaFields = await $b38ec4aa5ef4f8c4$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
                        );
                        // This will call the PhoneApiCaller to fetch and inject reCAPTCHA v2 token.
                        return actionMethod(authInstance, requestWithRecaptchaFields);
                    }
                }
                // ENFORCE mode or AUDIT mode with any other error.
                return Promise.reject(error);
            });
        } else {
            // Do reCAPTCHA v2 flow.
            const requestWithRecaptchaFields = await $b38ec4aa5ef4f8c4$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
            );
            // This will call the PhoneApiCaller to fetch and inject v2 token.
            return actionMethod(authInstance, requestWithRecaptchaFields);
        }
    } else return Promise.reject(recaptchaAuthProvider + ' provider is not supported.');
}
async function $b38ec4aa5ef4f8c4$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $b38ec4aa5ef4f8c4$export$23ebac1979863676(auth);
    const response = await $b38ec4aa5ef4f8c4$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $b38ec4aa5ef4f8c4$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isAnyProviderEnabled()) {
        const verifier = new $b38ec4aa5ef4f8c4$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$a07804094c3ecf2d(app, deps) {
    const provider = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $029952e65115eee5$export$9cb4719e2e525b7a)(initialOptions, deps ?? {})) return auth;
        else $b38ec4aa5ef4f8c4$export$3d12bd131bb975d1(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $b38ec4aa5ef4f8c4$var$_initializeAuthInstance(auth, deps) {
    const persistence = deps?.persistence || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($b38ec4aa5ef4f8c4$export$cf2f7c5792f80b46);
    if (deps?.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps?.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$efccba1c4a2ef57b(auth, url, options) {
    const authInternal = $b38ec4aa5ef4f8c4$export$23ebac1979863676(auth);
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!options?.disableWarnings;
    const protocol = $b38ec4aa5ef4f8c4$var$extractProtocol(url);
    const { host: host, port: port } = $b38ec4aa5ef4f8c4$var$extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    const emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    const emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    // There are a few scenarios to guard against if the Auth instance has already started:
    if (!authInternal._canInitEmulator) {
        // Applications may not initialize the emulator for the first time if Auth has already started
        // to make network requests.
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(authInternal.config.emulator && authInternal.emulatorConfig, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // Applications may not alter the configuration of the emulator (aka pass a different config)
        // once Auth has started to make network requests.
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd((0, $029952e65115eee5$export$9cb4719e2e525b7a)(emulator, authInternal.config.emulator) && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(emulatorConfig, authInternal.emulatorConfig), authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // It's valid, however, to invoke connectAuthEmulator() after Auth has started making
        // connections, so long as the config matches the existing config. This results in a no-op.
        return;
    }
    authInternal.config.emulator = emulator;
    authInternal.emulatorConfig = emulatorConfig;
    authInternal.settings.appVerificationDisabledForTesting = true;
    // Workaround to get cookies in Firebase Studio
    if ((0, $029952e65115eee5$export$5b4d24b45140ad90)(host)) (0, $029952e65115eee5$export$c0f0d0ce4283a937)(`${protocol}//${host}${portStr}`);
    else if (!disableWarnings) $b38ec4aa5ef4f8c4$var$emitEmulatorWarning();
}
function $b38ec4aa5ef4f8c4$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function $b38ec4aa5ef4f8c4$var$extractHostAndPort(url) {
    const protocol = $b38ec4aa5ef4f8c4$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: '',
        port: null
    };
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $b38ec4aa5ef4f8c4$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(':');
        return {
            host: host,
            port: $b38ec4aa5ef4f8c4$var$parsePort(port)
        };
    }
}
function $b38ec4aa5ef4f8c4$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $b38ec4aa5ef4f8c4$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText = 'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $b38ec4aa5ef4f8c4$export$8b22cf2602fb60ce {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $b38ec4aa5ef4f8c4$var$debugFail('not implemented');
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $b38ec4aa5ef4f8c4$var$debugFail('not implemented');
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $b38ec4aa5ef4f8c4$var$debugFail('not implemented');
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $b38ec4aa5ef4f8c4$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b38ec4aa5ef4f8c4$var$resetPassword(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
async function $b38ec4aa5ef4f8c4$var$updateEmailPassword(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $b38ec4aa5ef4f8c4$var$linkEmailPassword(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $b38ec4aa5ef4f8c4$var$applyActionCode$1(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b38ec4aa5ef4f8c4$var$signInWithPassword(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
async function $b38ec4aa5ef4f8c4$var$sendOobCode(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
async function $b38ec4aa5ef4f8c4$var$sendEmailVerification$1(auth, request) {
    return $b38ec4aa5ef4f8c4$var$sendOobCode(auth, request);
}
async function $b38ec4aa5ef4f8c4$var$sendPasswordResetEmail$1(auth, request) {
    return $b38ec4aa5ef4f8c4$var$sendOobCode(auth, request);
}
async function $b38ec4aa5ef4f8c4$var$sendSignInLinkToEmail$1(auth, request) {
    return $b38ec4aa5ef4f8c4$var$sendOobCode(auth, request);
}
async function $b38ec4aa5ef4f8c4$var$verifyAndChangeEmail(auth, request) {
    return $b38ec4aa5ef4f8c4$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b38ec4aa5ef4f8c4$var$signInWithEmailLink$1(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
async function $b38ec4aa5ef4f8c4$var$signInWithEmailLinkForLinking(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $b38ec4aa5ef4f8c4$export$a9c23c6ac3fc3eca extends $b38ec4aa5ef4f8c4$export$8b22cf2602fb60ce {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $b38ec4aa5ef4f8c4$export$a9c23c6ac3fc3eca(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $b38ec4aa5ef4f8c4$export$a9c23c6ac3fc3eca(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if (obj?.email && obj?.password) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $b38ec4aa5ef4f8c4$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $b38ec4aa5ef4f8c4$var$signInWithPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $b38ec4aa5ef4f8c4$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $b38ec4aa5ef4f8c4$export$3d12bd131bb975d1(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $b38ec4aa5ef4f8c4$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $b38ec4aa5ef4f8c4$var$linkEmailPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $b38ec4aa5ef4f8c4$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $b38ec4aa5ef4f8c4$export$3d12bd131bb975d1(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b38ec4aa5ef4f8c4$var$signInWithIdp(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b38ec4aa5ef4f8c4$var$IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $b38ec4aa5ef4f8c4$export$c4ce752e73470fba extends $b38ec4aa5ef4f8c4$export$8b22cf2602fb60ce {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $b38ec4aa5ef4f8c4$export$c4ce752e73470fba(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $b38ec4aa5ef4f8c4$export$3d12bd131bb975d1("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, ...rest } = obj;
        if (!providerId || !signInMethod) return null;
        const cred = new $b38ec4aa5ef4f8c4$export$c4ce752e73470fba(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $b38ec4aa5ef4f8c4$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $b38ec4aa5ef4f8c4$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $b38ec4aa5ef4f8c4$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $b38ec4aa5ef4f8c4$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody['id_token'] = this.idToken;
            if (this.accessToken) postBody['access_token'] = this.accessToken;
            if (this.secret) postBody['oauth_token_secret'] = this.secret;
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody['nonce'] = this.nonce;
            request.postBody = (0, $029952e65115eee5$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b38ec4aa5ef4f8c4$var$sendPhoneVerificationCode(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
async function $b38ec4aa5ef4f8c4$var$signInWithPhoneNumber$1(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
async function $b38ec4aa5ef4f8c4$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $b38ec4aa5ef4f8c4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $b38ec4aa5ef4f8c4$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $b38ec4aa5ef4f8c4$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $b38ec4aa5ef4f8c4$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = {
        ...request,
        operation: 'REAUTH'
    };
    return $b38ec4aa5ef4f8c4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, apiRequest), $b38ec4aa5ef4f8c4$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $b38ec4aa5ef4f8c4$export$56c0d5a1e737357d extends $b38ec4aa5ef4f8c4$export$8b22cf2602fb60ce {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $b38ec4aa5ef4f8c4$export$56c0d5a1e737357d({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $b38ec4aa5ef4f8c4$export$56c0d5a1e737357d({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $b38ec4aa5ef4f8c4$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $b38ec4aa5ef4f8c4$var$linkWithPhoneNumber$1(auth, {
            idToken: idToken,
            ...this._makeVerificationRequest()
        });
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $b38ec4aa5ef4f8c4$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === 'string') json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $b38ec4aa5ef4f8c4$export$56c0d5a1e737357d({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $b38ec4aa5ef4f8c4$var$parseMode(mode) {
    switch(mode){
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case 'resetPassword':
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case 'signIn':
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $b38ec4aa5ef4f8c4$var$parseDeepLink(url) {
    const link = (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(link))['deep_link_id'] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(iOSDeepLink))['link'] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $b38ec4aa5ef4f8c4$export$407448d2b89b1813 {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        const searchParams = (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(actionLink));
        const apiKey = searchParams["apiKey" /* QueryField.API_KEY */ ] ?? null;
        const code = searchParams["oobCode" /* QueryField.CODE */ ] ?? null;
        const operation = $b38ec4aa5ef4f8c4$var$parseMode(searchParams["mode" /* QueryField.MODE */ ] ?? null);
        // Validate API key, code and mode.
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ] ?? null;
        this.languageCode = searchParams["lang" /* QueryField.LANGUAGE_CODE */ ] ?? null;
        this.tenantId = searchParams["tenantId" /* QueryField.TENANT_ID */ ] ?? null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $b38ec4aa5ef4f8c4$var$parseDeepLink(link);
        try {
            return new $b38ec4aa5ef4f8c4$export$407448d2b89b1813(actionLink);
        } catch  {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$34aec0b863436764(link) {
    return $b38ec4aa5ef4f8c4$export$407448d2b89b1813.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $b38ec4aa5ef4f8c4$export$4368d992c4eafac0 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $b38ec4aa5ef4f8c4$export$4368d992c4eafac0.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $b38ec4aa5ef4f8c4$export$a9c23c6ac3fc3eca._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $b38ec4aa5ef4f8c4$export$407448d2b89b1813.parseLink(emailLink);
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $b38ec4aa5ef4f8c4$export$a9c23c6ac3fc3eca._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $b38ec4aa5ef4f8c4$export$4368d992c4eafac0.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $b38ec4aa5ef4f8c4$export$4368d992c4eafac0.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $b38ec4aa5ef4f8c4$export$4368d992c4eafac0.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $b38ec4aa5ef4f8c4$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $b38ec4aa5ef4f8c4$var$BaseOAuthProvider extends $b38ec4aa5ef4f8c4$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $b38ec4aa5ef4f8c4$export$39b482c5e57630a8 extends $b38ec4aa5ef4f8c4$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd('providerId' in obj && 'signInMethod' in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $b38ec4aa5ef4f8c4$export$c4ce752e73470fba._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential({
            ...params,
            nonce: params.rawNonce
        });
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $b38ec4aa5ef4f8c4$export$c4ce752e73470fba._fromParams({
            ...params,
            providerId: this.providerId,
            signInMethod: this.providerId
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $b38ec4aa5ef4f8c4$export$39b482c5e57630a8.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $b38ec4aa5ef4f8c4$export$39b482c5e57630a8.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $b38ec4aa5ef4f8c4$export$39b482c5e57630a8(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $b38ec4aa5ef4f8c4$export$d66501df72047452 extends $b38ec4aa5ef4f8c4$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $b38ec4aa5ef4f8c4$export$c4ce752e73470fba._fromParams({
            providerId: $b38ec4aa5ef4f8c4$export$d66501df72047452.PROVIDER_ID,
            signInMethod: $b38ec4aa5ef4f8c4$export$d66501df72047452.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $b38ec4aa5ef4f8c4$export$d66501df72047452.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $b38ec4aa5ef4f8c4$export$d66501df72047452.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $b38ec4aa5ef4f8c4$export$d66501df72047452.credential(tokenResponse.oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $b38ec4aa5ef4f8c4$export$d66501df72047452.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $b38ec4aa5ef4f8c4$export$d66501df72047452.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $b38ec4aa5ef4f8c4$export$2d1720544b23b823 extends $b38ec4aa5ef4f8c4$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $b38ec4aa5ef4f8c4$export$c4ce752e73470fba._fromParams({
            providerId: $b38ec4aa5ef4f8c4$export$2d1720544b23b823.PROVIDER_ID,
            signInMethod: $b38ec4aa5ef4f8c4$export$2d1720544b23b823.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $b38ec4aa5ef4f8c4$export$2d1720544b23b823.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $b38ec4aa5ef4f8c4$export$2d1720544b23b823.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $b38ec4aa5ef4f8c4$export$2d1720544b23b823.credential(oauthIdToken, oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $b38ec4aa5ef4f8c4$export$2d1720544b23b823.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $b38ec4aa5ef4f8c4$export$2d1720544b23b823.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $b38ec4aa5ef4f8c4$export$2329c99376c9d0a4 extends $b38ec4aa5ef4f8c4$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return $b38ec4aa5ef4f8c4$export$c4ce752e73470fba._fromParams({
            providerId: $b38ec4aa5ef4f8c4$export$2329c99376c9d0a4.PROVIDER_ID,
            signInMethod: $b38ec4aa5ef4f8c4$export$2329c99376c9d0a4.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $b38ec4aa5ef4f8c4$export$2329c99376c9d0a4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $b38ec4aa5ef4f8c4$export$2329c99376c9d0a4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $b38ec4aa5ef4f8c4$export$2329c99376c9d0a4.credential(tokenResponse.oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $b38ec4aa5ef4f8c4$export$2329c99376c9d0a4.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $b38ec4aa5ef4f8c4$export$2329c99376c9d0a4.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the SAML credentials returned by an {@link SAMLAuthProvider}.
 *
 * @public
 */ const $b38ec4aa5ef4f8c4$var$IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */ class $b38ec4aa5ef4f8c4$export$c03999cb2f36933f extends $b38ec4aa5ef4f8c4$export$8b22cf2602fb60ce {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $b38ec4aa5ef4f8c4$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $b38ec4aa5ef4f8c4$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $b38ec4aa5ef4f8c4$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $b38ec4aa5ef4f8c4$export$c03999cb2f36933f(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $b38ec4aa5ef4f8c4$export$c03999cb2f36933f(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $b38ec4aa5ef4f8c4$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b38ec4aa5ef4f8c4$var$SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $b38ec4aa5ef4f8c4$export$25ce5a424b770e84 extends $b38ec4aa5ef4f8c4$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(providerId.startsWith($b38ec4aa5ef4f8c4$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $b38ec4aa5ef4f8c4$export$25ce5a424b770e84.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $b38ec4aa5ef4f8c4$export$25ce5a424b770e84.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $b38ec4aa5ef4f8c4$export$c03999cb2f36933f.fromJSON(json);
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $b38ec4aa5ef4f8c4$export$c03999cb2f36933f._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $b38ec4aa5ef4f8c4$export$7ccc53e8f1e7dfc5 extends $b38ec4aa5ef4f8c4$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $b38ec4aa5ef4f8c4$export$c4ce752e73470fba._fromParams({
            providerId: $b38ec4aa5ef4f8c4$export$7ccc53e8f1e7dfc5.PROVIDER_ID,
            signInMethod: $b38ec4aa5ef4f8c4$export$7ccc53e8f1e7dfc5.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $b38ec4aa5ef4f8c4$export$7ccc53e8f1e7dfc5.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $b38ec4aa5ef4f8c4$export$7ccc53e8f1e7dfc5.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $b38ec4aa5ef4f8c4$export$7ccc53e8f1e7dfc5.credential(oauthAccessToken, oauthTokenSecret);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $b38ec4aa5ef4f8c4$export$7ccc53e8f1e7dfc5.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $b38ec4aa5ef4f8c4$export$7ccc53e8f1e7dfc5.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b38ec4aa5ef4f8c4$var$signUp(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b38ec4aa5ef4f8c4$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $b38ec4aa5ef4f8c4$export$2ed0fc6709e59212._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $b38ec4aa5ef4f8c4$var$providerIdForResponse(idTokenResponse);
        const userCred = new $b38ec4aa5ef4f8c4$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $b38ec4aa5ef4f8c4$var$providerIdForResponse(response);
        return new $b38ec4aa5ef4f8c4$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $b38ec4aa5ef4f8c4$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ('phoneNumber' in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$2219238a014317b0(auth) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $b38ec4aa5ef4f8c4$export$23ebac1979863676(auth);
    await authInternal._initializationPromise;
    if (authInternal.currentUser?.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $b38ec4aa5ef4f8c4$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $b38ec4aa5ef4f8c4$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $b38ec4aa5ef4f8c4$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b38ec4aa5ef4f8c4$var$MultiFactorError extends (0, $029952e65115eee5$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $b38ec4aa5ef4f8c4$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: auth.tenantId ?? undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $b38ec4aa5ef4f8c4$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $b38ec4aa5ef4f8c4$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $b38ec4aa5ef4f8c4$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $b38ec4aa5ef4f8c4$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$ab83b03e4111b1d0(user, providerId) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    await $b38ec4aa5ef4f8c4$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $b38ec4aa5ef4f8c4$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $b38ec4aa5ef4f8c4$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $b38ec4aa5ef4f8c4$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $b38ec4aa5ef4f8c4$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $b38ec4aa5ef4f8c4$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $b38ec4aa5ef4f8c4$var$_assertLinkedStatus(expected, user, provider) {
    await $b38ec4aa5ef4f8c4$var$_reloadWithoutSaving(user);
    const providerIds = $b38ec4aa5ef4f8c4$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b38ec4aa5ef4f8c4$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $b38ec4aa5ef4f8c4$var$_logoutIfInvalidated(user, $b38ec4aa5ef4f8c4$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $b38ec4aa5ef4f8c4$var$_parseToken(response.idToken);
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $b38ec4aa5ef4f8c4$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if (e?.code === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $b38ec4aa5ef4f8c4$export$3d12bd131bb975d1(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b38ec4aa5ef4f8c4$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $b38ec4aa5ef4f8c4$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $b38ec4aa5ef4f8c4$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$4c3d22f3d993c33f(auth, credential) {
    return $b38ec4aa5ef4f8c4$var$_signInWithCredential($b38ec4aa5ef4f8c4$export$23ebac1979863676(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$e7c866399fa523f5(user, credential) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    await $b38ec4aa5ef4f8c4$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $b38ec4aa5ef4f8c4$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$ce26c07117d59d6a(user, credential) {
    return $b38ec4aa5ef4f8c4$var$_reauthenticate((0, $029952e65115eee5$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b38ec4aa5ef4f8c4$var$signInWithCustomToken$1(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$f787f51d84a910ad(auth, customToken) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $b38ec4aa5ef4f8c4$export$23ebac1979863676(auth);
    const response = await $b38ec4aa5ef4f8c4$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $b38ec4aa5ef4f8c4$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b38ec4aa5ef4f8c4$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) return $b38ec4aa5ef4f8c4$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ('totpInfo' in enrollment) return $b38ec4aa5ef4f8c4$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $b38ec4aa5ef4f8c4$export$3d12bd131bb975d1(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $b38ec4aa5ef4f8c4$var$PhoneMultiFactorInfoImpl extends $b38ec4aa5ef4f8c4$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $b38ec4aa5ef4f8c4$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $b38ec4aa5ef4f8c4$var$TotpMultiFactorInfoImpl extends $b38ec4aa5ef4f8c4$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $b38ec4aa5ef4f8c4$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b38ec4aa5ef4f8c4$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(actionCodeSettings.url?.length > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof actionCodeSettings.linkDomain === 'undefined' || actionCodeSettings.linkDomain.length > 0, auth, "invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.linkDomain = actionCodeSettings.linkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $b38ec4aa5ef4f8c4$var$recachePasswordPolicy(auth) {
    const authInternal = $b38ec4aa5ef4f8c4$export$23ebac1979863676(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$a9c996f45e5784d0(auth, email, actionCodeSettings) {
    const authInternal = $b38ec4aa5ef4f8c4$export$23ebac1979863676(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $b38ec4aa5ef4f8c4$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $b38ec4aa5ef4f8c4$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $b38ec4aa5ef4f8c4$var$sendPasswordResetEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$90a7f3efeed30595(auth, oobCode, newPassword) {
    await $b38ec4aa5ef4f8c4$var$resetPassword((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $b38ec4aa5ef4f8c4$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$ae1af26003f05816(auth, oobCode) {
    await $b38ec4aa5ef4f8c4$var$applyActionCode$1((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$3b14a55fb2447963(auth, oobCode) {
    const authModular = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth);
    const response = await $b38ec4aa5ef4f8c4$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $b38ec4aa5ef4f8c4$var$MultiFactorInfoImpl._fromServerResponse($b38ec4aa5ef4f8c4$export$23ebac1979863676(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$1fbe638ecf81657e(auth, code) {
    const { data: data } = await $b38ec4aa5ef4f8c4$export$3b14a55fb2447963((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$d141bba7fdc215a3(auth, email, password) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $b38ec4aa5ef4f8c4$export$23ebac1979863676(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $b38ec4aa5ef4f8c4$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $b38ec4aa5ef4f8c4$var$signUp, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $b38ec4aa5ef4f8c4$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $b38ec4aa5ef4f8c4$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$c9170ad7d4cd7e57(auth, email, password) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $b38ec4aa5ef4f8c4$export$4c3d22f3d993c33f((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), $b38ec4aa5ef4f8c4$export$4368d992c4eafac0.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $b38ec4aa5ef4f8c4$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$7910e0436ed8d1de(auth, email, actionCodeSettings) {
    const authInternal = $b38ec4aa5ef4f8c4$export$23ebac1979863676(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $b38ec4aa5ef4f8c4$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $b38ec4aa5ef4f8c4$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $b38ec4aa5ef4f8c4$var$sendSignInLinkToEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$3a6d5c9ae78a2c08(auth, emailLink) {
    const actionCodeUrl = $b38ec4aa5ef4f8c4$export$407448d2b89b1813.parseLink(emailLink);
    return actionCodeUrl?.operation === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$ee7c8ad385a60b7b(auth, email, emailLink) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth);
    const credential = $b38ec4aa5ef4f8c4$export$4368d992c4eafac0.credentialWithLink(email, emailLink || $b38ec4aa5ef4f8c4$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $b38ec4aa5ef4f8c4$export$4c3d22f3d993c33f(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b38ec4aa5ef4f8c4$var$createAuthUri(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$ef35774e6d314e91(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $b38ec4aa5ef4f8c4$var$_isHttpOrHttps() ? $b38ec4aa5ef4f8c4$var$_getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $b38ec4aa5ef4f8c4$var$createAuthUri((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$c3950d9923825c02(user, actionCodeSettings) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $b38ec4aa5ef4f8c4$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $b38ec4aa5ef4f8c4$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$493d36ec626b6698(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $b38ec4aa5ef4f8c4$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $b38ec4aa5ef4f8c4$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b38ec4aa5ef4f8c4$var$updateProfile$1(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$8a5498727ef6be21(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $b38ec4aa5ef4f8c4$var$_logoutIfInvalidated(userInternal, $b38ec4aa5ef4f8c4$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$306ddfe3a8403e2(user, newEmail) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $b38ec4aa5ef4f8c4$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$7a38258bbe170828(user, newPassword) {
    return $b38ec4aa5ef4f8c4$var$updateEmailOrPassword((0, $029952e65115eee5$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $b38ec4aa5ef4f8c4$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $b38ec4aa5ef4f8c4$var$_logoutIfInvalidated(user, $b38ec4aa5ef4f8c4$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $b38ec4aa5ef4f8c4$var$_fromIdTokenResponse(idTokenResponse) {
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && idTokenResponse?.idToken) {
        const signInProvider = $b38ec4aa5ef4f8c4$var$_parseToken(idTokenResponse.idToken)?.firebase?.['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $b38ec4aa5ef4f8c4$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $b38ec4aa5ef4f8c4$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $b38ec4aa5ef4f8c4$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $b38ec4aa5ef4f8c4$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $b38ec4aa5ef4f8c4$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $b38ec4aa5ef4f8c4$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $b38ec4aa5ef4f8c4$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $b38ec4aa5ef4f8c4$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $b38ec4aa5ef4f8c4$var$FederatedAdditionalUserInfoWithUsername extends $b38ec4aa5ef4f8c4$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $b38ec4aa5ef4f8c4$var$FacebookAdditionalUserInfo extends $b38ec4aa5ef4f8c4$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $b38ec4aa5ef4f8c4$var$GithubAdditionalUserInfo extends $b38ec4aa5ef4f8c4$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof profile?.login === 'string' ? profile?.login : null);
    }
}
class $b38ec4aa5ef4f8c4$var$GoogleAdditionalUserInfo extends $b38ec4aa5ef4f8c4$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $b38ec4aa5ef4f8c4$var$TwitterAdditionalUserInfo extends $b38ec4aa5ef4f8c4$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$e7094788287c5e9b(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $b38ec4aa5ef4f8c4$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$555508cbc6add439(auth, persistence) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$3722cfe417b6ed86(auth) {
    return $b38ec4aa5ef4f8c4$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$6554612db691658e(auth, password) {
    const authInternal = $b38ec4aa5ef4f8c4$export$23ebac1979863676(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$3d8c2f653ac9d0b9(auth, nextOrObserver, error, completed) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $b38ec4aa5ef4f8c4$export$ffb5f4729a158638(auth, callback, onAbort) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$71511d61b312f219(auth, nextOrObserver, error, completed) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$d24c54395ce0c509(auth) {
    (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$1a82df3d29112e01(auth, user) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$21579262ef46735b(auth) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$a93c5207d687da10(auth, token) {
    const authInternal = $b38ec4aa5ef4f8c4$export$23ebac1979863676(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$df995fae86a55f06(user) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b38ec4aa5ef4f8c4$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $b38ec4aa5ef4f8c4$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $b38ec4aa5ef4f8c4$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? 'idToken' : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        if (obj?.multiFactorSession) {
            if (obj.multiFactorSession?.pendingCredential) return $b38ec4aa5ef4f8c4$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if (obj.multiFactorSession?.idToken) return $b38ec4aa5ef4f8c4$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b38ec4aa5ef4f8c4$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $b38ec4aa5ef4f8c4$export$23ebac1979863676(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$b38ec4aa5ef4f8c4$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $b38ec4aa5ef4f8c4$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $b38ec4aa5ef4f8c4$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = {
                ...serverResponse,
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            };
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $b38ec4aa5ef4f8c4$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $b38ec4aa5ef4f8c4$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $b38ec4aa5ef4f8c4$export$3d12bd131bb975d1(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$b4171a6734a65d42(auth, error) {
    const authModular = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(errorInternal.customData._serverResponse?.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $b38ec4aa5ef4f8c4$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b38ec4aa5ef4f8c4$var$startEnrollPhoneMfa(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
function $b38ec4aa5ef4f8c4$var$finalizeEnrollPhoneMfa(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
function $b38ec4aa5ef4f8c4$var$startEnrollTotpMfa(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
function $b38ec4aa5ef4f8c4$var$finalizeEnrollTotpMfa(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
function $b38ec4aa5ef4f8c4$var$withdrawMfa(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
class $b38ec4aa5ef4f8c4$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$b38ec4aa5ef4f8c4$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $b38ec4aa5ef4f8c4$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $b38ec4aa5ef4f8c4$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $b38ec4aa5ef4f8c4$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $b38ec4aa5ef4f8c4$var$_logoutIfInvalidated(this.user, $b38ec4aa5ef4f8c4$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $b38ec4aa5ef4f8c4$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$dc98b0b04f4c7758(user) {
    const userModular = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if (!$b38ec4aa5ef4f8c4$var$multiFactorUserCache.has(userModular)) $b38ec4aa5ef4f8c4$var$multiFactorUserCache.set(userModular, $b38ec4aa5ef4f8c4$var$MultiFactorUserImpl._fromUser(userModular));
    return $b38ec4aa5ef4f8c4$var$multiFactorUserCache.get(userModular);
}
const $b38ec4aa5ef4f8c4$var$STORAGE_AVAILABLE_KEY = '__sak';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $b38ec4aa5ef4f8c4$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($b38ec4aa5ef4f8c4$var$STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem($b38ec4aa5ef4f8c4$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch  {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const $b38ec4aa5ef4f8c4$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $b38ec4aa5ef4f8c4$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $b38ec4aa5ef4f8c4$var$BrowserLocalPersistence extends $b38ec4aa5ef4f8c4$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $b38ec4aa5ef4f8c4$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($b38ec4aa5ef4f8c4$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $b38ec4aa5ef4f8c4$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent('storage', {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $b38ec4aa5ef4f8c4$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$b38ec4aa5ef4f8c4$var$BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $b38ec4aa5ef4f8c4$export$43caf9889c228507 = $b38ec4aa5ef4f8c4$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b38ec4aa5ef4f8c4$var$POLLING_INTERVAL_MS = 1000;
// Pull a cookie value from document.cookie
function $b38ec4aa5ef4f8c4$var$getDocumentCookie(name) {
    const escapedName = name.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
    const matcher = RegExp(`${escapedName}=([^;]+)`);
    return document.cookie.match(matcher)?.[1] ?? null;
}
// Produce a sanitized cookie name from the persistence key
function $b38ec4aa5ef4f8c4$var$getCookieName(key) {
    // __HOST- doesn't work in localhost https://issues.chromium.org/issues/40196122 but it has
    // desirable security properties, so lets use a different cookie name while in dev-mode.
    // Already checked isSecureContext in _isAvailable, so if it's http we're hitting local.
    const isDevMode = window.location.protocol === 'http:';
    return `${isDevMode ? '__dev_' : '__HOST-'}FIREBASE_${key.split(':')[3]}`;
}
class $b38ec4aa5ef4f8c4$var$CookiePersistence {
    constructor(){
        this.type = "COOKIE" /* PersistenceType.COOKIE */ ;
        this.listenerUnsubscribes = new Map();
    }
    // used to get the URL to the backend to proxy to
    _getFinalTarget(originalUrl) {
        const url = new URL(`${window.location.origin}/__cookies__`);
        url.searchParams.set('finalTarget', originalUrl);
        return url;
    }
    // To be a usable persistence method in a chain browserCookiePersistence ensures that
    // prerequisites have been met, namely that we're in a secureContext, navigator and document are
    // available and cookies are enabled. Not all UAs support these method, so fallback accordingly.
    async _isAvailable() {
        if (typeof isSecureContext === 'boolean' && !isSecureContext) return false;
        if (typeof navigator === 'undefined' || typeof document === 'undefined') return false;
        return navigator.cookieEnabled ?? true;
    }
    // Set should be a noop as we expect middleware to handle this
    async _set(_key, _value) {
        return;
    }
    // Attempt to get the cookie from cookieStore, fallback to document.cookie
    async _get(key) {
        if (!this._isAvailable()) return null;
        const name = $b38ec4aa5ef4f8c4$var$getCookieName(key);
        if (window.cookieStore) {
            const cookie = await window.cookieStore.get(name);
            return cookie?.value;
        }
        return $b38ec4aa5ef4f8c4$var$getDocumentCookie(name);
    }
    // Log out by overriding the idToken with a sentinel value of ""
    async _remove(key) {
        if (!this._isAvailable()) return;
        // To make sure we don't hit signout over and over again, only do this operation if we need to
        // with the logout sentinel value of "" this can cause race conditions. Unnecessary set-cookie
        // headers will reduce CDN hit rates too.
        const existingValue = await this._get(key);
        if (!existingValue) return;
        const name = $b38ec4aa5ef4f8c4$var$getCookieName(key);
        document.cookie = `${name}=;Max-Age=34560000;Partitioned;Secure;SameSite=Strict;Path=/;Priority=High`;
        await fetch(`/__cookies__`, {
            method: 'DELETE'
        }).catch(()=>undefined);
    }
    // Listen for cookie changes, both cookieStore and fallback to polling document.cookie
    _addListener(key, listener) {
        if (!this._isAvailable()) return;
        const name = $b38ec4aa5ef4f8c4$var$getCookieName(key);
        if (window.cookieStore) {
            const cb = (event)=>{
                const changedCookie = event.changed.find((change)=>change.name === name);
                if (changedCookie) listener(changedCookie.value);
                const deletedCookie = event.deleted.find((change)=>change.name === name);
                if (deletedCookie) listener(null);
            };
            const unsubscribe = ()=>window.cookieStore.removeEventListener('change', cb);
            this.listenerUnsubscribes.set(listener, unsubscribe);
            return window.cookieStore.addEventListener('change', cb);
        }
        let lastValue = $b38ec4aa5ef4f8c4$var$getDocumentCookie(name);
        const interval = setInterval(()=>{
            const currentValue = $b38ec4aa5ef4f8c4$var$getDocumentCookie(name);
            if (currentValue !== lastValue) {
                listener(currentValue);
                lastValue = currentValue;
            }
        }, $b38ec4aa5ef4f8c4$var$POLLING_INTERVAL_MS);
        const unsubscribe = ()=>clearInterval(interval);
        this.listenerUnsubscribes.set(listener, unsubscribe);
    }
    _removeListener(_key, listener) {
        const unsubscribe = this.listenerUnsubscribes.get(listener);
        if (!unsubscribe) return;
        unsubscribe();
        this.listenerUnsubscribes.delete(listener);
    }
}
$b38ec4aa5ef4f8c4$var$CookiePersistence.type = 'COOKIE';
/**
 * An implementation of {@link Persistence} of type `COOKIE`, for use on the client side in
 * applications leveraging hybrid rendering and middleware.
 *
 * @remarks This persistence method requires companion middleware to function, such as that provided
 * by {@link https://firebaseopensource.com/projects/firebaseextended/reactfire/ | ReactFire} for
 * NextJS.
 * @beta
 */ const $b38ec4aa5ef4f8c4$export$9e5f44173e64f162 = $b38ec4aa5ef4f8c4$var$CookiePersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b38ec4aa5ef4f8c4$var$BrowserSessionPersistence extends $b38ec4aa5ef4f8c4$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$b38ec4aa5ef4f8c4$var$BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $b38ec4aa5ef4f8c4$export$625550452a3fa3ec = $b38ec4aa5ef4f8c4$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $b38ec4aa5ef4f8c4$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $b38ec4aa5ef4f8c4$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $b38ec4aa5ef4f8c4$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!handlers?.size) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $b38ec4aa5ef4f8c4$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener('message', this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener('message', this.boundEventHandler);
    }
}
$b38ec4aa5ef4f8c4$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b38ec4aa5ef4f8c4$export$f96d196f7728bb5(prefix = '', digits = 10) {
    let random = '';
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $b38ec4aa5ef4f8c4$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $b38ec4aa5ef4f8c4$export$f96d196f7728bb5('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $b38ec4aa5ef4f8c4$var$_window() {
    return window;
}
function $b38ec4aa5ef4f8c4$var$_setWindowLocation(url) {
    $b38ec4aa5ef4f8c4$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b38ec4aa5ef4f8c4$var$_isWorker() {
    return typeof $b38ec4aa5ef4f8c4$var$_window()['WorkerGlobalScope'] !== 'undefined' && typeof $b38ec4aa5ef4f8c4$var$_window()['importScripts'] === 'function';
}
async function $b38ec4aa5ef4f8c4$var$_getActiveServiceWorker() {
    if (!navigator?.serviceWorker) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch  {
        return null;
    }
}
function $b38ec4aa5ef4f8c4$var$_getServiceWorkerController() {
    return navigator?.serviceWorker?.controller || null;
}
function $b38ec4aa5ef4f8c4$var$_getWorkerGlobalScope() {
    return $b38ec4aa5ef4f8c4$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b38ec4aa5ef4f8c4$var$DB_NAME = 'firebaseLocalStorageDb';
const $b38ec4aa5ef4f8c4$var$DB_VERSION = 1;
const $b38ec4aa5ef4f8c4$var$DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const $b38ec4aa5ef4f8c4$var$DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $b38ec4aa5ef4f8c4$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener('success', ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener('error', ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $b38ec4aa5ef4f8c4$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $b38ec4aa5ef4f8c4$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? 'readwrite' : 'readonly').objectStore($b38ec4aa5ef4f8c4$var$DB_OBJECTSTORE_NAME);
}
function $b38ec4aa5ef4f8c4$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($b38ec4aa5ef4f8c4$var$DB_NAME);
    return new $b38ec4aa5ef4f8c4$var$DBPromise(request).toPromise();
}
function $b38ec4aa5ef4f8c4$var$_openDatabase() {
    const request = indexedDB.open($b38ec4aa5ef4f8c4$var$DB_NAME, $b38ec4aa5ef4f8c4$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener('error', ()=>{
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', ()=>{
            const db = request.result;
            try {
                db.createObjectStore($b38ec4aa5ef4f8c4$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $b38ec4aa5ef4f8c4$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($b38ec4aa5ef4f8c4$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $b38ec4aa5ef4f8c4$var$_deleteDatabase();
                resolve(await $b38ec4aa5ef4f8c4$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $b38ec4aa5ef4f8c4$var$_putObject(db, key, value) {
    const request = $b38ec4aa5ef4f8c4$var$getObjectStore(db, true).put({
        [$b38ec4aa5ef4f8c4$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $b38ec4aa5ef4f8c4$var$DBPromise(request).toPromise();
}
async function $b38ec4aa5ef4f8c4$var$getObject(db, key) {
    const request = $b38ec4aa5ef4f8c4$var$getObjectStore(db, false).get(key);
    const data = await new $b38ec4aa5ef4f8c4$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $b38ec4aa5ef4f8c4$var$_deleteObject(db, key) {
    const request = $b38ec4aa5ef4f8c4$var$getObjectStore(db, true).delete(key);
    return new $b38ec4aa5ef4f8c4$var$DBPromise(request).toPromise();
}
const $b38ec4aa5ef4f8c4$var$_POLLING_INTERVAL_MS = 800;
const $b38ec4aa5ef4f8c4$var$_TRANSACTION_RETRY_COUNT = 3;
class $b38ec4aa5ef4f8c4$var$IndexedDBLocalPersistence {
    registerLifecycleListeners() {
        if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
            window.addEventListener('pagehide', this.onPageHide);
            window.addEventListener('pageshow', this.onPageShow);
        }
        if (typeof document !== 'undefined' && typeof document.addEventListener === 'function') document.addEventListener('visibilitychange', this.onVisibilityChange);
    }
    unregisterLifecycleListeners() {
        if (typeof window !== 'undefined' && typeof window.removeEventListener === 'function') {
            window.removeEventListener('pagehide', this.onPageHide);
            window.removeEventListener('pageshow', this.onPageShow);
        }
        if (typeof document !== 'undefined' && typeof document.removeEventListener === 'function') document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this.dbPromise = null;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.isHiding = false;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        this.onPageHide = ()=>{
            this.isHiding = true;
            this.stopPolling();
            if (this.dbPromise) {
                this.dbPromise.then((db)=>db.close()).catch(()=>{});
                this.dbPromise = null;
            }
        };
        this.onPageShow = ()=>{
            if (this.isHiding) {
                this.isHiding = false;
                if (Object.keys(this.listeners).length > 0) this.startPolling();
            }
        };
        this.onVisibilityChange = ()=>{
            if (typeof document !== 'undefined') {
                if (document.visibilityState === 'hidden') this.onPageHide();
                else if (document.visibilityState === 'visible') this.onPageShow();
            }
        };
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.isHiding) throw new Error('Database is closing/hidden');
        if (this.dbPromise) return this.dbPromise;
        this.dbPromise = $b38ec4aa5ef4f8c4$var$_openDatabase();
        this.dbPromise.catch(()=>{
            this.dbPromise = null;
        });
        return this.dbPromise;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (this.isHiding) throw e;
            if (numAttempts++ > $b38ec4aa5ef4f8c4$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.dbPromise) {
                const db = await this.dbPromise;
                db.close();
                this.dbPromise = null;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $b38ec4aa5ef4f8c4$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $b38ec4aa5ef4f8c4$var$Receiver._getInstance($b38ec4aa5ef4f8c4$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $b38ec4aa5ef4f8c4$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $b38ec4aa5ef4f8c4$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (results[0]?.fulfilled && results[0]?.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ )) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $b38ec4aa5ef4f8c4$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch  {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            await this._withRetries(async (db)=>{
                await $b38ec4aa5ef4f8c4$var$_putObject(db, $b38ec4aa5ef4f8c4$var$STORAGE_AVAILABLE_KEY, '1');
                await $b38ec4aa5ef4f8c4$var$_deleteObject(db, $b38ec4aa5ef4f8c4$var$STORAGE_AVAILABLE_KEY);
            });
            return true;
        } catch  {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$b38ec4aa5ef4f8c4$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$b38ec4aa5ef4f8c4$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$b38ec4aa5ef4f8c4$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        if (this.isHiding) return [];
        try {
            // TODO: check if we need to fallback if getAll is not supported
            const result = await this._withRetries((db)=>{
                const getAllRequest = $b38ec4aa5ef4f8c4$var$getObjectStore(db, false).getAll();
                return new $b38ec4aa5ef4f8c4$var$DBPromise(getAllRequest).toPromise();
            });
            if (this.isHiding) return [];
            if (!result) return [];
            // If we have pending writes in progress abort, we'll get picked up on the next poll
            if (this.pendingWrites !== 0) return [];
            const keys = [];
            const keysInResult = new Set();
            if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
                keysInResult.add(key);
                if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                    this.notifyListeners(key, value);
                    keys.push(key);
                }
            }
            for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
                // Deleted
                this.notifyListeners(localKey, null);
                keys.push(localKey);
            }
            return keys;
        } catch (e) {
            if (!this.isHiding) $b38ec4aa5ef4f8c4$var$_logWarn(`Firebase Auth cross-tab polling failed with error: ${e}`);
            return [];
        }
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $b38ec4aa5ef4f8c4$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            this.startPolling();
            this.registerLifecycleListeners();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.stopPolling();
            this.unregisterLifecycleListeners();
        }
    }
}
$b38ec4aa5ef4f8c4$var$IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $b38ec4aa5ef4f8c4$export$3a1a48c8f6ef640e = $b38ec4aa5ef4f8c4$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b38ec4aa5ef4f8c4$var$startSignInPhoneMfa(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
function $b38ec4aa5ef4f8c4$var$finalizeSignInPhoneMfa(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
function $b38ec4aa5ef4f8c4$var$finalizeSignInTotpMfa(auth, request) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $b38ec4aa5ef4f8c4$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $b38ec4aa5ef4f8c4$var$_JSLOAD_CALLBACK = $b38ec4aa5ef4f8c4$var$_generateCallbackName('rcb');
const $b38ec4aa5ef4f8c4$var$NETWORK_TIMEOUT_DELAY = new $b38ec4aa5ef4f8c4$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $b38ec4aa5ef4f8c4$var$ReCaptchaLoaderImpl {
    constructor(){
        this.hostLanguage = '';
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!$b38ec4aa5ef4f8c4$var$_window().grecaptcha?.render;
    }
    load(auth, hl = '') {
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd($b38ec4aa5ef4f8c4$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $b38ec4aa5ef4f8c4$var$isV2($b38ec4aa5ef4f8c4$var$_window().grecaptcha)) return Promise.resolve($b38ec4aa5ef4f8c4$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $b38ec4aa5ef4f8c4$var$_window().setTimeout(()=>{
                reject($b38ec4aa5ef4f8c4$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $b38ec4aa5ef4f8c4$var$NETWORK_TIMEOUT_DELAY.get());
            $b38ec4aa5ef4f8c4$var$_window()[$b38ec4aa5ef4f8c4$var$_JSLOAD_CALLBACK] = ()=>{
                $b38ec4aa5ef4f8c4$var$_window().clearTimeout(networkTimeout);
                delete $b38ec4aa5ef4f8c4$var$_window()[$b38ec4aa5ef4f8c4$var$_JSLOAD_CALLBACK];
                const recaptcha = $b38ec4aa5ef4f8c4$var$_window().grecaptcha;
                if (!recaptcha || !$b38ec4aa5ef4f8c4$var$isV2(recaptcha)) {
                    reject($b38ec4aa5ef4f8c4$export$890c4ad488842ce7(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$b38ec4aa5ef4f8c4$var$_recaptchaV2ScriptUrl()}?${(0, $029952e65115eee5$export$ac4103b836844853)({
                onload: $b38ec4aa5ef4f8c4$var$_JSLOAD_CALLBACK,
                render: 'explicit',
                hl: hl
            })}`;
            $b38ec4aa5ef4f8c4$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($b38ec4aa5ef4f8c4$export$890c4ad488842ce7(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!$b38ec4aa5ef4f8c4$var$_window().grecaptcha?.render && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $b38ec4aa5ef4f8c4$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $b38ec4aa5ef4f8c4$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $b38ec4aa5ef4f8c4$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b38ec4aa5ef4f8c4$var$RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const $b38ec4aa5ef4f8c4$var$DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $b38ec4aa5ef4f8c4$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = {
        ...$b38ec4aa5ef4f8c4$var$DEFAULT_PARAMS
    }){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $b38ec4aa5ef4f8c4$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $b38ec4aa5ef4f8c4$export$23ebac1979863676(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $b38ec4aa5ef4f8c4$var$MockReCaptchaLoaderImpl() : new $b38ec4aa5ef4f8c4$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === 'function') existing(token);
            else if (typeof existing === 'string') {
                const globalFunc = $b38ec4aa5ef4f8c4$var$_window()[existing];
                if (typeof globalFunc === 'function') globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd($b38ec4aa5ef4f8c4$var$_isHttpOrHttps() && !$b38ec4aa5ef4f8c4$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $b38ec4aa5ef4f8c4$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $b38ec4aa5ef4f8c4$var$getRecaptchaParams(this.auth);
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $b38ec4aa5ef4f8c4$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener('load', resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener('load', resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b38ec4aa5ef4f8c4$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $b38ec4aa5ef4f8c4$export$56c0d5a1e737357d._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method requires a {@link ApplicationVerifier}.
 * This SDK includes an implementation based on reCAPTCHA v2, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * If you've enabled project-level reCAPTCHA Enterprise bot protection in
 * Enforce mode, you can omit the {@link ApplicationVerifier}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$995eb9fca571757(auth, phoneNumber, appVerifier) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $b38ec4aa5ef4f8c4$export$23ebac1979863676(auth);
    const verificationId = await $b38ec4aa5ef4f8c4$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $029952e65115eee5$export$4befe9b5fa509a1b)(appVerifier));
    return new $b38ec4aa5ef4f8c4$var$ConfirmationResultImpl(verificationId, (cred)=>$b38ec4aa5ef4f8c4$export$4c3d22f3d993c33f(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$71cec2538cb2c617(user, phoneNumber, appVerifier) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    await $b38ec4aa5ef4f8c4$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $b38ec4aa5ef4f8c4$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $029952e65115eee5$export$4befe9b5fa509a1b)(appVerifier));
    return new $b38ec4aa5ef4f8c4$var$ConfirmationResultImpl(verificationId, (cred)=>$b38ec4aa5ef4f8c4$export$e7c866399fa523f5(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$6559d589eb85fbb6(user, phoneNumber, appVerifier) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $b38ec4aa5ef4f8c4$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $029952e65115eee5$export$4befe9b5fa509a1b)(appVerifier));
    return new $b38ec4aa5ef4f8c4$var$ConfirmationResultImpl(verificationId, (cred)=>$b38ec4aa5ef4f8c4$export$ce26c07117d59d6a(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $b38ec4aa5ef4f8c4$var$_verifyPhoneNumber(auth, options, verifier) {
    if (!auth._getRecaptchaConfig()) try {
        await $b38ec4aa5ef4f8c4$var$_initializeRecaptchaConfig(auth);
    } catch (error) {
        // If an error occurs while fetching the config, there is no way to know the enablement state
        // of Phone provider, so we proceed with recaptcha V2 verification.
        // The error is likely "recaptchaKey undefined", as reCAPTCHA Enterprise is not
        // enabled for any provider.
        console.log('Failed to initialize reCAPTCHA Enterprise config. Triggering the reCAPTCHA v2 verification.');
    }
    try {
        let phoneInfoOptions;
        if (typeof options === 'string') phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const startPhoneMfaEnrollmentRequest = {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startEnrollPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneEnrollmentInfo.captchaResponse === $b38ec4aa5ef4f8c4$var$FAKE_TOKEN) {
                        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(verifier?.type === $b38ec4aa5ef4f8c4$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $b38ec4aa5ef4f8c4$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $b38ec4aa5ef4f8c4$var$startEnrollPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $b38ec4aa5ef4f8c4$var$startEnrollPhoneMfa(authInstance, request);
                };
                const startPhoneMfaEnrollmentResponse = $b38ec4aa5ef4f8c4$var$handleRecaptchaFlow(auth, startPhoneMfaEnrollmentRequest, "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */ , startEnrollPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaEnrollmentResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = phoneInfoOptions.multiFactorHint?.uid || phoneInfoOptions.multiFactorUid;
                $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const startPhoneMfaSignInRequest = {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startSignInPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneSignInInfo.captchaResponse === $b38ec4aa5ef4f8c4$var$FAKE_TOKEN) {
                        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(verifier?.type === $b38ec4aa5ef4f8c4$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $b38ec4aa5ef4f8c4$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $b38ec4aa5ef4f8c4$var$startSignInPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $b38ec4aa5ef4f8c4$var$startSignInPhoneMfa(authInstance, request);
                };
                const startPhoneMfaSignInResponse = $b38ec4aa5ef4f8c4$var$handleRecaptchaFlow(auth, startPhoneMfaSignInRequest, "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ , startSignInPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaSignInResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const sendPhoneVerificationCodeRequest = {
                phoneNumber: phoneInfoOptions.phoneNumber,
                clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
            };
            const sendPhoneVerificationCodeActionCallback = async (authInstance, request)=>{
                // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                if (request.captchaResponse === $b38ec4aa5ef4f8c4$var$FAKE_TOKEN) {
                    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(verifier?.type === $b38ec4aa5ef4f8c4$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    const requestWithRecaptchaV2 = await $b38ec4aa5ef4f8c4$var$injectRecaptchaV2Token(authInstance, request, verifier);
                    return $b38ec4aa5ef4f8c4$var$sendPhoneVerificationCode(authInstance, requestWithRecaptchaV2);
                }
                return $b38ec4aa5ef4f8c4$var$sendPhoneVerificationCode(authInstance, request);
            };
            const sendPhoneVerificationCodeResponse = $b38ec4aa5ef4f8c4$var$handleRecaptchaFlow(auth, sendPhoneVerificationCodeRequest, "sendVerificationCode" /* RecaptchaActionName.SEND_VERIFICATION_CODE */ , sendPhoneVerificationCodeActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
            const response = await sendPhoneVerificationCodeResponse.catch((error)=>{
                return Promise.reject(error);
            });
            return response.sessionInfo;
        }
    } finally{
        verifier?._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$2f6ca3d3b1f80bf5(user, credential) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $b38ec4aa5ef4f8c4$var$_link$1(userInternal, credential);
}
// Helper function that fetches and injects a reCAPTCHA v2 token into the request.
async function $b38ec4aa5ef4f8c4$var$injectRecaptchaV2Token(auth, request, recaptchaV2Verifier) {
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(recaptchaV2Verifier.type === $b38ec4aa5ef4f8c4$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const recaptchaV2Token = await recaptchaV2Verifier.verify();
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof recaptchaV2Token === 'string', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const newRequest = {
        ...request
    };
    if ('phoneEnrollmentInfo' in newRequest) {
        const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
        const captchaResponse = newRequest.phoneEnrollmentInfo.captchaResponse;
        const clientType = newRequest.phoneEnrollmentInfo.clientType;
        const recaptchaVersion = newRequest.phoneEnrollmentInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneEnrollmentInfo': {
                phoneNumber: phoneNumber,
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else if ('phoneSignInInfo' in newRequest) {
        const captchaResponse = newRequest.phoneSignInInfo.captchaResponse;
        const clientType = newRequest.phoneSignInInfo.clientType;
        const recaptchaVersion = newRequest.phoneSignInInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneSignInInfo': {
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else {
        Object.assign(newRequest, {
            'recaptchaToken': recaptchaV2Token
        });
        return newRequest;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $b38ec4aa5ef4f8c4$export$23f2a1d2818174ef {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $b38ec4aa5ef4f8c4$export$23f2a1d2818174ef.PROVIDER_ID;
        this.auth = $b38ec4aa5ef4f8c4$export$23ebac1979863676(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - An {@link ApplicationVerifier}, which prevents
     * requests from unauthorized clients. This SDK includes an implementation
     * based on reCAPTCHA v2, {@link RecaptchaVerifier}. If you've enabled
     * reCAPTCHA Enterprise bot protection in Enforce mode, this parameter is
     * optional; in all other configurations, the parameter is required.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow.
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $b38ec4aa5ef4f8c4$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $029952e65115eee5$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $b38ec4aa5ef4f8c4$export$56c0d5a1e737357d._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $b38ec4aa5ef4f8c4$export$23f2a1d2818174ef.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $b38ec4aa5ef4f8c4$export$23f2a1d2818174ef.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $b38ec4aa5ef4f8c4$export$56c0d5a1e737357d._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $b38ec4aa5ef4f8c4$export$23f2a1d2818174ef.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $b38ec4aa5ef4f8c4$export$23f2a1d2818174ef.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $b38ec4aa5ef4f8c4$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $b38ec4aa5ef4f8c4$export$cf2f7c5792f80b46(resolverOverride);
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b38ec4aa5ef4f8c4$var$IdpCredential extends $b38ec4aa5ef4f8c4$export$8b22cf2602fb60ce {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $b38ec4aa5ef4f8c4$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $b38ec4aa5ef4f8c4$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $b38ec4aa5ef4f8c4$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $b38ec4aa5ef4f8c4$var$_signIn(params) {
    return $b38ec4aa5ef4f8c4$var$_signInWithCredential(params.auth, new $b38ec4aa5ef4f8c4$var$IdpCredential(params), params.bypassAuthState);
}
function $b38ec4aa5ef4f8c4$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $b38ec4aa5ef4f8c4$var$_reauthenticate(user, new $b38ec4aa5ef4f8c4$var$IdpCredential(params), params.bypassAuthState);
}
async function $b38ec4aa5ef4f8c4$var$_link(params) {
    const { auth: auth, user: user } = params;
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $b38ec4aa5ef4f8c4$var$_link$1(user, new $b38ec4aa5ef4f8c4$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $b38ec4aa5ef4f8c4$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $b38ec4aa5ef4f8c4$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $b38ec4aa5ef4f8c4$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $b38ec4aa5ef4f8c4$var$_reauth;
            default:
                $b38ec4aa5ef4f8c4$export$3d12bd131bb975d1(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $b38ec4aa5ef4f8c4$export$92108d983e8ee699(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $b38ec4aa5ef4f8c4$export$92108d983e8ee699(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b38ec4aa5ef4f8c4$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $b38ec4aa5ef4f8c4$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$f38c853ae54ed474(auth, provider, resolver) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($b38ec4aa5ef4f8c4$export$890c4ad488842ce7(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $b38ec4aa5ef4f8c4$export$23ebac1979863676(auth);
    $b38ec4aa5ef4f8c4$var$_assertInstanceOf(auth, provider, $b38ec4aa5ef4f8c4$var$FederatedAuthProvider);
    const resolverInternal = $b38ec4aa5ef4f8c4$var$_withDefaultResolver(authInternal, resolver);
    const action = new $b38ec4aa5ef4f8c4$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$efca4cbe5dd06740(user, provider, resolver) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($b38ec4aa5ef4f8c4$export$890c4ad488842ce7(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $b38ec4aa5ef4f8c4$var$_assertInstanceOf(userInternal.auth, provider, $b38ec4aa5ef4f8c4$var$FederatedAuthProvider);
    const resolverInternal = $b38ec4aa5ef4f8c4$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $b38ec4aa5ef4f8c4$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$78acf4525d8a74c4(user, provider, resolver) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    $b38ec4aa5ef4f8c4$var$_assertInstanceOf(userInternal.auth, provider, $b38ec4aa5ef4f8c4$var$FederatedAuthProvider);
    const resolverInternal = $b38ec4aa5ef4f8c4$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $b38ec4aa5ef4f8c4$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $b38ec4aa5ef4f8c4$var$PopupOperation extends $b38ec4aa5ef4f8c4$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($b38ec4aa5ef4f8c4$var$PopupOperation.currentPopupAction) $b38ec4aa5ef4f8c4$var$PopupOperation.currentPopupAction.cancel();
        $b38ec4aa5ef4f8c4$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $b38ec4aa5ef4f8c4$export$92108d983e8ee699(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = $b38ec4aa5ef4f8c4$export$f96d196f7728bb5();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($b38ec4aa5ef4f8c4$export$890c4ad488842ce7(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        return this.authWindow?.associatedEvent || null;
    }
    cancel() {
        this.reject($b38ec4aa5ef4f8c4$export$890c4ad488842ce7(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $b38ec4aa5ef4f8c4$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            if (this.authWindow?.window?.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($b38ec4aa5ef4f8c4$export$890c4ad488842ce7(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $b38ec4aa5ef4f8c4$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$b38ec4aa5ef4f8c4$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b38ec4aa5ef4f8c4$var$PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $b38ec4aa5ef4f8c4$var$redirectOutcomeMap = new Map();
class $b38ec4aa5ef4f8c4$var$RedirectAction extends $b38ec4aa5ef4f8c4$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $b38ec4aa5ef4f8c4$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $b38ec4aa5ef4f8c4$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $b38ec4aa5ef4f8c4$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $b38ec4aa5ef4f8c4$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $b38ec4aa5ef4f8c4$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $b38ec4aa5ef4f8c4$var$pendingRedirectKey(auth);
    const persistence = $b38ec4aa5ef4f8c4$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $b38ec4aa5ef4f8c4$var$_setPendingRedirectStatus(resolver, auth) {
    return $b38ec4aa5ef4f8c4$var$resolverPersistence(resolver)._set($b38ec4aa5ef4f8c4$var$pendingRedirectKey(auth), 'true');
}
function $b38ec4aa5ef4f8c4$export$a05254e7c3aeba6e() {
    $b38ec4aa5ef4f8c4$var$redirectOutcomeMap.clear();
}
function $b38ec4aa5ef4f8c4$export$b9a6b53f9be3734(auth, result) {
    $b38ec4aa5ef4f8c4$var$redirectOutcomeMap.set(auth._key(), result);
}
function $b38ec4aa5ef4f8c4$var$resolverPersistence(resolver) {
    return $b38ec4aa5ef4f8c4$export$cf2f7c5792f80b46(resolver._redirectPersistence);
}
function $b38ec4aa5ef4f8c4$var$pendingRedirectKey(auth) {
    return $b38ec4aa5ef4f8c4$export$53a70dd1ebbae346($b38ec4aa5ef4f8c4$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$3b513254972cfc9c(auth, provider, resolver) {
    return $b38ec4aa5ef4f8c4$var$_signInWithRedirect(auth, provider, resolver);
}
async function $b38ec4aa5ef4f8c4$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $b38ec4aa5ef4f8c4$export$23ebac1979863676(auth);
    $b38ec4aa5ef4f8c4$var$_assertInstanceOf(auth, provider, $b38ec4aa5ef4f8c4$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $b38ec4aa5ef4f8c4$var$_withDefaultResolver(authInternal, resolver);
    await $b38ec4aa5ef4f8c4$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$a8550f7dbe79f93a(user, provider, resolver) {
    return $b38ec4aa5ef4f8c4$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $b38ec4aa5ef4f8c4$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    $b38ec4aa5ef4f8c4$var$_assertInstanceOf(userInternal.auth, provider, $b38ec4aa5ef4f8c4$var$FederatedAuthProvider);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $b38ec4aa5ef4f8c4$var$_withDefaultResolver(userInternal.auth, resolver);
    await $b38ec4aa5ef4f8c4$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $b38ec4aa5ef4f8c4$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$8743009a87fcb00f(user, provider, resolver) {
    return $b38ec4aa5ef4f8c4$var$_linkWithRedirect(user, provider, resolver);
}
async function $b38ec4aa5ef4f8c4$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    $b38ec4aa5ef4f8c4$var$_assertInstanceOf(userInternal.auth, provider, $b38ec4aa5ef4f8c4$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $b38ec4aa5ef4f8c4$var$_withDefaultResolver(userInternal.auth, resolver);
    await $b38ec4aa5ef4f8c4$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $b38ec4aa5ef4f8c4$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $b38ec4aa5ef4f8c4$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $b38ec4aa5ef4f8c4$export$3466f893ebf79586(auth, resolver) {
    await $b38ec4aa5ef4f8c4$export$23ebac1979863676(auth)._initializationPromise;
    return $b38ec4aa5ef4f8c4$export$a33b77bbdbb8366c(auth, resolver, false);
}
async function $b38ec4aa5ef4f8c4$export$a33b77bbdbb8366c(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($b38ec4aa5ef4f8c4$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $b38ec4aa5ef4f8c4$export$23ebac1979863676(auth);
    const resolver = $b38ec4aa5ef4f8c4$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $b38ec4aa5ef4f8c4$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $b38ec4aa5ef4f8c4$var$prepareUserForRedirect(user) {
    const eventId = $b38ec4aa5ef4f8c4$export$f96d196f7728bb5(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $b38ec4aa5ef4f8c4$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $b38ec4aa5ef4f8c4$export$158acd800e1ef08b {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$b38ec4aa5ef4f8c4$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        if (event.error && !$b38ec4aa5ef4f8c4$var$isNullRedirectEvent(event)) {
            const code = event.error.code?.split('auth/')[1] || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($b38ec4aa5ef4f8c4$export$890c4ad488842ce7(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $b38ec4aa5ef4f8c4$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($b38ec4aa5ef4f8c4$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($b38ec4aa5ef4f8c4$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $b38ec4aa5ef4f8c4$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join('-');
}
function $b38ec4aa5ef4f8c4$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && error?.code === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $b38ec4aa5ef4f8c4$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $b38ec4aa5ef4f8c4$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $b38ec4aa5ef4f8c4$export$24baa2b76016ce0e(auth, request = {}) {
    return $b38ec4aa5ef4f8c4$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b38ec4aa5ef4f8c4$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $b38ec4aa5ef4f8c4$var$HTTP_REGEX = /^https?/;
async function $b38ec4aa5ef4f8c4$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $b38ec4aa5ef4f8c4$export$24baa2b76016ce0e(auth);
    for (const domain of authorizedDomains)try {
        if ($b38ec4aa5ef4f8c4$var$matchDomain(domain)) return;
    } catch  {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $b38ec4aa5ef4f8c4$export$3d12bd131bb975d1(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $b38ec4aa5ef4f8c4$var$matchDomain(expected) {
    const currentUrl = $b38ec4aa5ef4f8c4$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') // For some reason we're not parsing chrome URLs properly
        return protocol === 'chrome-extension:' && expected.replace('chrome-extension://', '') === currentUrl.replace('chrome-extension://', '');
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!$b38ec4aa5ef4f8c4$var$HTTP_REGEX.test(protocol)) return false;
    if ($b38ec4aa5ef4f8c4$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b38ec4aa5ef4f8c4$var$NETWORK_TIMEOUT = new $b38ec4aa5ef4f8c4$var$Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $b38ec4aa5ef4f8c4$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $b38ec4aa5ef4f8c4$var$_window().___jsl;
    // Get current hint.
    if (beacon?.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $b38ec4aa5ef4f8c4$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $b38ec4aa5ef4f8c4$var$resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $b38ec4aa5ef4f8c4$var$resetUnloadedGapiModules();
                    reject($b38ec4aa5ef4f8c4$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $b38ec4aa5ef4f8c4$var$NETWORK_TIMEOUT.get()
            });
        }
        if ($b38ec4aa5ef4f8c4$var$_window().gapi?.iframes?.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!$b38ec4aa5ef4f8c4$var$_window().gapi?.load) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $b38ec4aa5ef4f8c4$var$_generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            $b38ec4aa5ef4f8c4$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($b38ec4aa5ef4f8c4$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $b38ec4aa5ef4f8c4$var$_loadJS(`${$b38ec4aa5ef4f8c4$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $b38ec4aa5ef4f8c4$var$cachedGApiLoader = null;
        throw error;
    });
}
let $b38ec4aa5ef4f8c4$var$cachedGApiLoader = null;
function $b38ec4aa5ef4f8c4$var$_loadGapi(auth) {
    $b38ec4aa5ef4f8c4$var$cachedGApiLoader = $b38ec4aa5ef4f8c4$var$cachedGApiLoader || $b38ec4aa5ef4f8c4$var$loadGapi(auth);
    return $b38ec4aa5ef4f8c4$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b38ec4aa5ef4f8c4$var$PING_TIMEOUT = new $b38ec4aa5ef4f8c4$var$Delay(5000, 15000);
const $b38ec4aa5ef4f8c4$var$IFRAME_PATH = '__/auth/iframe';
const $b38ec4aa5ef4f8c4$var$EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const $b38ec4aa5ef4f8c4$var$IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $b38ec4aa5ef4f8c4$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        'p'
    ],
    [
        'staging-identitytoolkit.sandbox.googleapis.com',
        's'
    ],
    [
        'test-identitytoolkit.sandbox.googleapis.com',
        't'
    ] // test
]);
function $b38ec4aa5ef4f8c4$var$getIframeUrl(auth) {
    const config = auth.config;
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $b38ec4aa5ef4f8c4$var$_emulatorUrl(config, $b38ec4aa5ef4f8c4$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$b38ec4aa5ef4f8c4$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $5e587d655f0a08bb$export$31499a9cd224b78c)
    };
    const eid = $b38ec4aa5ef4f8c4$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(',');
    return `${url}?${(0, $029952e65115eee5$export$ac4103b836844853)(params).slice(1)}`;
}
async function $b38ec4aa5ef4f8c4$var$_openIframe(auth) {
    const context = await $b38ec4aa5ef4f8c4$var$_loadGapi(auth);
    const gapi1 = $b38ec4aa5ef4f8c4$var$_window().gapi;
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $b38ec4aa5ef4f8c4$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $b38ec4aa5ef4f8c4$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $b38ec4aa5ef4f8c4$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $b38ec4aa5ef4f8c4$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $b38ec4aa5ef4f8c4$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $b38ec4aa5ef4f8c4$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b38ec4aa5ef4f8c4$var$BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const $b38ec4aa5ef4f8c4$var$DEFAULT_WIDTH = 500;
const $b38ec4aa5ef4f8c4$var$DEFAULT_HEIGHT = 600;
const $b38ec4aa5ef4f8c4$var$TARGET_BLANK = '_blank';
const $b38ec4aa5ef4f8c4$var$FIREFOX_EMPTY_URL = 'http://localhost';
class $b38ec4aa5ef4f8c4$export$9f4f30ee63539e24 {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $b38ec4aa5ef4f8c4$var$_open(auth, url, name, width = $b38ec4aa5ef4f8c4$var$DEFAULT_WIDTH, height = $b38ec4aa5ef4f8c4$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = {
        ...$b38ec4aa5ef4f8c4$var$BASE_POPUP_OPTIONS,
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    };
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $029952e65115eee5$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $b38ec4aa5ef4f8c4$var$_isChromeIOS(ua) ? $b38ec4aa5ef4f8c4$var$TARGET_BLANK : name;
    if ($b38ec4aa5ef4f8c4$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $b38ec4aa5ef4f8c4$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, '');
    if ($b38ec4aa5ef4f8c4$var$_isIOSStandalone(ua) && target !== '_self') {
        $b38ec4aa5ef4f8c4$var$openAsNewWindowIOS(url || '', target);
        return new $b38ec4aa5ef4f8c4$export$9f4f30ee63539e24(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $b38ec4aa5ef4f8c4$export$9f4f30ee63539e24(newWin);
}
function $b38ec4aa5ef4f8c4$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $b38ec4aa5ef4f8c4$var$WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */ const $b38ec4aa5ef4f8c4$var$EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $b38ec4aa5ef4f8c4$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');
async function $b38ec4aa5ef4f8c4$export$91c6e00c14e7e6fd(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $5e587d655f0a08bb$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $b38ec4aa5ef4f8c4$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!(0, $029952e65115eee5$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $b38ec4aa5ef4f8c4$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== '');
        if (scopes.length > 0) params.scopes = scopes.join(',');
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$b38ec4aa5ef4f8c4$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : '';
    // Start at index 1 to skip the leading '&' in the query string
    return `${$b38ec4aa5ef4f8c4$var$getHandlerBase(auth)}?${(0, $029952e65115eee5$export$ac4103b836844853)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $b38ec4aa5ef4f8c4$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$b38ec4aa5ef4f8c4$var$WIDGET_PATH}`;
    return $b38ec4aa5ef4f8c4$var$_emulatorUrl(config, $b38ec4aa5ef4f8c4$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $b38ec4aa5ef4f8c4$var$WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class $b38ec4aa5ef4f8c4$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $b38ec4aa5ef4f8c4$export$625550452a3fa3ec;
        this._completeRedirectFn = $b38ec4aa5ef4f8c4$export$a33b77bbdbb8366c;
        this._overrideRedirectResult = $b38ec4aa5ef4f8c4$export$b9a6b53f9be3734;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        $b38ec4aa5ef4f8c4$export$92108d983e8ee699(this.eventManagers[auth._key()]?.manager, '_initialize() not called before _openPopup()');
        const url = await $b38ec4aa5ef4f8c4$export$91c6e00c14e7e6fd(auth, provider, authType, $b38ec4aa5ef4f8c4$var$_getCurrentUrl(), eventId);
        return $b38ec4aa5ef4f8c4$var$_open(auth, url, $b38ec4aa5ef4f8c4$export$f96d196f7728bb5());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $b38ec4aa5ef4f8c4$export$91c6e00c14e7e6fd(auth, provider, authType, $b38ec4aa5ef4f8c4$var$_getCurrentUrl(), eventId);
        $b38ec4aa5ef4f8c4$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $b38ec4aa5ef4f8c4$export$92108d983e8ee699(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $b38ec4aa5ef4f8c4$var$_openIframe(auth);
        const manager = new $b38ec4aa5ef4f8c4$export$158acd800e1ef08b(auth);
        iframe.register('authEvent', (iframeEvent)=>{
            $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(iframeEvent?.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($b38ec4aa5ef4f8c4$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $b38ec4aa5ef4f8c4$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            const isSupported = result?.[0]?.[$b38ec4aa5ef4f8c4$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $b38ec4aa5ef4f8c4$export$3d12bd131bb975d1(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $b38ec4aa5ef4f8c4$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $b38ec4aa5ef4f8c4$var$_isMobileBrowser() || $b38ec4aa5ef4f8c4$var$_isSafari() || $b38ec4aa5ef4f8c4$export$9fa96a7d116ea3ce();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $b38ec4aa5ef4f8c4$export$2408f22a0fab9ae5 = $b38ec4aa5ef4f8c4$var$BrowserPopupRedirectResolver;
class $b38ec4aa5ef4f8c4$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $b38ec4aa5ef4f8c4$var$debugFail('unexpected MultiFactorSessionType');
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $b38ec4aa5ef4f8c4$var$PhoneMultiFactorAssertionImpl extends $b38ec4aa5ef4f8c4$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $b38ec4aa5ef4f8c4$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $b38ec4aa5ef4f8c4$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $b38ec4aa5ef4f8c4$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $b38ec4aa5ef4f8c4$export$35e795649ee09318 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $b38ec4aa5ef4f8c4$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $b38ec4aa5ef4f8c4$export$35e795649ee09318.FACTOR_ID = 'phone';
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $b38ec4aa5ef4f8c4$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $b38ec4aa5ef4f8c4$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $b38ec4aa5ef4f8c4$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        const mfaSession = session;
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof mfaSession.user?.auth !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $b38ec4aa5ef4f8c4$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $b38ec4aa5ef4f8c4$export$953cecd6e717a553._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $b38ec4aa5ef4f8c4$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $b38ec4aa5ef4f8c4$var$TotpMultiFactorAssertionImpl extends $b38ec4aa5ef4f8c4$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $b38ec4aa5ef4f8c4$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $b38ec4aa5ef4f8c4$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(typeof this.secret !== 'undefined', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $b38ec4aa5ef4f8c4$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $b38ec4aa5ef4f8c4$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $b38ec4aa5ef4f8c4$export$953cecd6e717a553 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $b38ec4aa5ef4f8c4$export$953cecd6e717a553(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        let useDefaults = false;
        if ($b38ec4aa5ef4f8c4$var$_isEmptyString(accountName) || $b38ec4aa5ef4f8c4$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($b38ec4aa5ef4f8c4$var$_isEmptyString(accountName)) accountName = this.auth.currentUser?.email || 'unknownuser';
            if ($b38ec4aa5ef4f8c4$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $b38ec4aa5ef4f8c4$var$_isEmptyString(input) {
    return typeof input === 'undefined' || input?.length === 0;
}
var $b38ec4aa5ef4f8c4$var$name = "@firebase/auth";
var $b38ec4aa5ef4f8c4$var$version = "1.13.4";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b38ec4aa5ef4f8c4$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        this.assertAuthConfigured();
        return this.auth.currentUser?.uid || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener(user?.stsTokenManager.accessToken || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b38ec4aa5ef4f8c4$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return 'node';
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return 'rn';
        case "Worker" /* ClientPlatform.WORKER */ :
            return 'webworker';
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return 'cordova';
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return 'web-extension';
        default:
            return undefined;
    }
}
/** @internal */ function $b38ec4aa5ef4f8c4$var$registerAuth(clientPlatform) {
    (0, $5e587d655f0a08bb$export$c930050e7bb63965)(new (0, $5782dd2556309534$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const appCheckServiceProvider = container.getProvider('app-check-internal');
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $b38ec4aa5ef4f8c4$export$d66dc83d8cfc8dd(apiKey && !apiKey.includes(':'), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $b38ec4aa5ef4f8c4$export$738ab4df8bf92ae9(clientPlatform)
        };
        const authInstance = new $b38ec4aa5ef4f8c4$export$91477dc880baac21(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $b38ec4aa5ef4f8c4$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $5e587d655f0a08bb$export$c930050e7bb63965)(new (0, $5782dd2556309534$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $b38ec4aa5ef4f8c4$export$23ebac1979863676(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $b38ec4aa5ef4f8c4$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($b38ec4aa5ef4f8c4$var$name, $b38ec4aa5ef4f8c4$var$version, $b38ec4aa5ef4f8c4$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($b38ec4aa5ef4f8c4$var$name, $b38ec4aa5ef4f8c4$var$version, 'esm2020');
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b38ec4aa5ef4f8c4$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $b38ec4aa5ef4f8c4$var$authIdTokenMaxAge = (0, $029952e65115eee5$export$5539a1a3afe87d6)('authIdTokenMaxAge') || $b38ec4aa5ef4f8c4$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $b38ec4aa5ef4f8c4$var$lastPostedIdToken = null;
const $b38ec4aa5ef4f8c4$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $b38ec4aa5ef4f8c4$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult?.token;
        if ($b38ec4aa5ef4f8c4$var$lastPostedIdToken === idToken) return;
        $b38ec4aa5ef4f8c4$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? 'POST' : 'DELETE',
            headers: idToken ? {
                'Authorization': `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $b38ec4aa5ef4f8c4$export$96f57966bedc81b4(app = (0, $5e587d655f0a08bb$export$f9962582c9e66d99)()) {
    const provider = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $b38ec4aa5ef4f8c4$export$a07804094c3ecf2d(app, {
        popupRedirectResolver: $b38ec4aa5ef4f8c4$export$2408f22a0fab9ae5,
        persistence: [
            $b38ec4aa5ef4f8c4$export$3a1a48c8f6ef640e,
            $b38ec4aa5ef4f8c4$export$43caf9889c228507,
            $b38ec4aa5ef4f8c4$export$625550452a3fa3ec
        ]
    });
    const authTokenSyncPath = (0, $029952e65115eee5$export$5539a1a3afe87d6)('authTokenSyncURL');
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === 'boolean' && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $b38ec4aa5ef4f8c4$var$mintCookieFactory(authTokenSyncUrl.toString());
            $b38ec4aa5ef4f8c4$export$ffb5f4729a158638(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $b38ec4aa5ef4f8c4$export$3d8c2f653ac9d0b9(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $029952e65115eee5$export$9c11895284c8adad)('auth');
    if (authEmulatorHost) $b38ec4aa5ef4f8c4$export$efccba1c4a2ef57b(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $b38ec4aa5ef4f8c4$var$getScriptParentElement() {
    return document.getElementsByTagName('head')?.[0] ?? document;
}
$b38ec4aa5ef4f8c4$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement('script');
            el.setAttribute('src', url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $b38ec4aa5ef4f8c4$export$890c4ad488842ce7("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = 'text/javascript';
            el.charset = 'UTF-8';
            $b38ec4aa5ef4f8c4$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: 'https://apis.google.com/js/api.js',
    recaptchaV2Script: 'https://www.google.com/recaptcha/api.js',
    recaptchaEnterpriseScript: 'https://www.google.com/recaptcha/enterprise.js?render='
});
$b38ec4aa5ef4f8c4$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );














var $906344b47e605252$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $906344b47e605252$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $906344b47e605252$export$70ffa26850098d01;
var $906344b47e605252$export$9f5a3dfc7a9f5dd;
(function() {
    var h; /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    function k(d, a) {
        function c() {}
        c.prototype = a.prototype;
        d.F = a.prototype;
        d.prototype = new c;
        d.prototype.constructor = d;
        d.D = function(f, e, g) {
            for(var b = Array(arguments.length - 2), r = 2; r < arguments.length; r++)b[r - 2] = arguments[r];
            return a.prototype[e].apply(f, b);
        };
    }
    function l() {
        this.blockSize = -1;
    }
    function m() {
        this.blockSize = -1;
        this.blockSize = 64;
        this.g = Array(4);
        this.C = Array(this.blockSize);
        this.o = this.h = 0;
        this.u();
    }
    k(m, l);
    m.prototype.u = function() {
        this.g[0] = 1732584193;
        this.g[1] = 4023233417;
        this.g[2] = 2562383102;
        this.g[3] = 271733878;
        this.o = this.h = 0;
    };
    function n(d, a, c) {
        c || (c = 0);
        const f = Array(16);
        if (typeof a === "string") for(var e = 0; e < 16; ++e)f[e] = a.charCodeAt(c++) | a.charCodeAt(c++) << 8 | a.charCodeAt(c++) << 16 | a.charCodeAt(c++) << 24;
        else for(e = 0; e < 16; ++e)f[e] = a[c++] | a[c++] << 8 | a[c++] << 16 | a[c++] << 24;
        a = d.g[0];
        c = d.g[1];
        e = d.g[2];
        let g = d.g[3], b;
        b = a + (g ^ c & (e ^ g)) + f[0] + 3614090360 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[1] + 3905402710 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[2] + 606105819 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[3] + 3250441966 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[4] + 4118548399 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[5] + 1200080426 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[6] + 2821735955 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[7] + 4249261313 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[8] + 1770035416 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[9] + 2336552879 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[10] + 4294925233 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[11] + 2304563134 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[12] + 1804603682 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[13] + 4254626195 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[14] + 2792965006 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[15] + 1236535329 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (e ^ g & (c ^ e)) + f[1] + 4129170786 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[6] + 3225465664 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[11] + 643717713 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[0] + 3921069994 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[5] + 3593408605 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[10] + 38016083 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[15] + 3634488961 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[4] + 3889429448 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[9] + 568446438 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[14] + 3275163606 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[3] + 4107603335 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[8] + 1163531501 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[13] + 2850285829 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[2] + 4243563512 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[7] + 1735328473 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[12] + 2368359562 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (c ^ e ^ g) + f[5] + 4294588738 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[8] + 2272392833 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[11] + 1839030562 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[14] + 4259657740 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[1] + 2763975236 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[4] + 1272893353 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[7] + 4139469664 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[10] + 3200236656 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[13] + 681279174 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[0] + 3936430074 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[3] + 3572445317 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[6] + 76029189 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[9] + 3654602809 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[12] + 3873151461 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[15] + 530742520 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[2] + 3299628645 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (e ^ (c | ~g)) + f[0] + 4096336452 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[7] + 1126891415 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[14] + 2878612391 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[5] + 4237533241 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[12] + 1700485571 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[3] + 2399980690 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[10] + 4293915773 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[1] + 2240044497 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[8] + 1873313359 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[15] + 4264355552 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[6] + 2734768916 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[13] + 1309151649 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[4] + 4149444226 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[11] + 3174756917 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[2] + 718787259 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[9] + 3951481745 & 4294967295;
        d.g[0] = d.g[0] + a & 4294967295;
        d.g[1] = d.g[1] + (e + (b << 21 & 4294967295 | b >>> 11)) & 4294967295;
        d.g[2] = d.g[2] + e & 4294967295;
        d.g[3] = d.g[3] + g & 4294967295;
    }
    m.prototype.v = function(d, a) {
        a === void 0 && (a = d.length);
        const c = a - this.blockSize, f = this.C;
        let e = this.h, g = 0;
        for(; g < a;){
            if (e == 0) for(; g <= c;)n(this, d, g), g += this.blockSize;
            if (typeof d === "string") {
                for(; g < a;)if (f[e++] = d.charCodeAt(g++), e == this.blockSize) {
                    n(this, f);
                    e = 0;
                    break;
                }
            } else for(; g < a;)if (f[e++] = d[g++], e == this.blockSize) {
                n(this, f);
                e = 0;
                break;
            }
        }
        this.h = e;
        this.o += a;
    };
    m.prototype.A = function() {
        var d = Array((this.h < 56 ? this.blockSize : this.blockSize * 2) - this.h);
        d[0] = 128;
        for(var a = 1; a < d.length - 8; ++a)d[a] = 0;
        a = this.o * 8;
        for(var c = d.length - 8; c < d.length; ++c)d[c] = a & 255, a /= 256;
        this.v(d);
        d = Array(16);
        a = 0;
        for(c = 0; c < 4; ++c)for(let f = 0; f < 32; f += 8)d[a++] = this.g[c] >>> f & 255;
        return d;
    };
    function p(d, a) {
        var c = q;
        return Object.prototype.hasOwnProperty.call(c, d) ? c[d] : c[d] = a(d);
    }
    function t(d, a) {
        this.h = a;
        const c = [];
        let f = !0;
        for(let e = d.length - 1; e >= 0; e--){
            const g = d[e] | 0;
            f && g == a || (c[e] = g, f = !1);
        }
        this.g = c;
    }
    var q = {};
    function u(d) {
        return -128 <= d && d < 128 ? p(d, function(a) {
            return new t([
                a | 0
            ], a < 0 ? -1 : 0);
        }) : new t([
            d | 0
        ], d < 0 ? -1 : 0);
    }
    function v(d) {
        if (isNaN(d) || !isFinite(d)) return w;
        if (d < 0) return x(v(-d));
        const a = [];
        let c = 1;
        for(let f = 0; d >= c; f++)a[f] = d / c | 0, c *= 4294967296;
        return new t(a, 0);
    }
    function y(d, a) {
        if (d.length == 0) throw Error("number format error: empty string");
        a = a || 10;
        if (a < 2 || 36 < a) throw Error("radix out of range: " + a);
        if (d.charAt(0) == "-") return x(y(d.substring(1), a));
        if (d.indexOf("-") >= 0) throw Error('number format error: interior "-" character');
        const c = v(Math.pow(a, 8));
        let f = w;
        for(let g = 0; g < d.length; g += 8){
            var e = Math.min(8, d.length - g);
            const b = parseInt(d.substring(g, g + e), a);
            e < 8 ? (e = v(Math.pow(a, e)), f = f.j(e).add(v(b))) : (f = f.j(c), f = f.add(v(b)));
        }
        return f;
    }
    var w = u(0), z = u(1), A = u(16777216);
    h = t.prototype;
    h.m = function() {
        if (B(this)) return -x(this).m();
        let d = 0, a = 1;
        for(let c = 0; c < this.g.length; c++){
            const f = this.i(c);
            d += (f >= 0 ? f : 4294967296 + f) * a;
            a *= 4294967296;
        }
        return d;
    };
    h.toString = function(d) {
        d = d || 10;
        if (d < 2 || 36 < d) throw Error("radix out of range: " + d);
        if (C(this)) return "0";
        if (B(this)) return "-" + x(this).toString(d);
        const a = v(Math.pow(d, 6));
        var c = this;
        let f = "";
        for(;;){
            const e = D(c, a).g;
            c = F(c, e.j(a));
            let g = ((c.g.length > 0 ? c.g[0] : c.h) >>> 0).toString(d);
            c = e;
            if (C(c)) return g + f;
            for(; g.length < 6;)g = "0" + g;
            f = g + f;
        }
    };
    h.i = function(d) {
        return d < 0 ? 0 : d < this.g.length ? this.g[d] : this.h;
    };
    function C(d) {
        if (d.h != 0) return !1;
        for(let a = 0; a < d.g.length; a++)if (d.g[a] != 0) return !1;
        return !0;
    }
    function B(d) {
        return d.h == -1;
    }
    h.l = function(d) {
        d = F(this, d);
        return B(d) ? -1 : C(d) ? 0 : 1;
    };
    function x(d) {
        const a = d.g.length, c = [];
        for(let f = 0; f < a; f++)c[f] = ~d.g[f];
        return new t(c, ~d.h).add(z);
    }
    h.abs = function() {
        return B(this) ? x(this) : this;
    };
    h.add = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        let f = 0;
        for(let e = 0; e <= a; e++){
            let g = f + (this.i(e) & 65535) + (d.i(e) & 65535), b = (g >>> 16) + (this.i(e) >>> 16) + (d.i(e) >>> 16);
            f = b >>> 16;
            g &= 65535;
            b &= 65535;
            c[e] = b << 16 | g;
        }
        return new t(c, c[c.length - 1] & -2147483648 ? -1 : 0);
    };
    function F(d, a) {
        return d.add(x(a));
    }
    h.j = function(d) {
        if (C(this) || C(d)) return w;
        if (B(this)) return B(d) ? x(this).j(x(d)) : x(x(this).j(d));
        if (B(d)) return x(this.j(x(d)));
        if (this.l(A) < 0 && d.l(A) < 0) return v(this.m() * d.m());
        const a = this.g.length + d.g.length, c = [];
        for(var f = 0; f < 2 * a; f++)c[f] = 0;
        for(f = 0; f < this.g.length; f++)for(let e = 0; e < d.g.length; e++){
            const g = this.i(f) >>> 16, b = this.i(f) & 65535, r = d.i(e) >>> 16, E = d.i(e) & 65535;
            c[2 * f + 2 * e] += b * E;
            G(c, 2 * f + 2 * e);
            c[2 * f + 2 * e + 1] += g * E;
            G(c, 2 * f + 2 * e + 1);
            c[2 * f + 2 * e + 1] += b * r;
            G(c, 2 * f + 2 * e + 1);
            c[2 * f + 2 * e + 2] += g * r;
            G(c, 2 * f + 2 * e + 2);
        }
        for(d = 0; d < a; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
        for(d = a; d < 2 * a; d++)c[d] = 0;
        return new t(c, 0);
    };
    function G(d, a) {
        for(; (d[a] & 65535) != d[a];)d[a + 1] += d[a] >>> 16, d[a] &= 65535, a++;
    }
    function H(d, a) {
        this.g = d;
        this.h = a;
    }
    function D(d, a) {
        if (C(a)) throw Error("division by zero");
        if (C(d)) return new H(w, w);
        if (B(d)) return a = D(x(d), a), new H(x(a.g), x(a.h));
        if (B(a)) return a = D(d, x(a)), new H(x(a.g), a.h);
        if (d.g.length > 30) {
            if (B(d) || B(a)) throw Error("slowDivide_ only works with positive integers.");
            for(var c = z, f = a; f.l(d) <= 0;)c = I(c), f = I(f);
            var e = J(c, 1), g = J(f, 1);
            f = J(f, 2);
            for(c = J(c, 2); !C(f);){
                var b = g.add(f);
                b.l(d) <= 0 && (e = e.add(c), g = b);
                f = J(f, 1);
                c = J(c, 1);
            }
            a = F(d, e.j(a));
            return new H(e, a);
        }
        for(e = w; d.l(a) >= 0;){
            c = Math.max(1, Math.floor(d.m() / a.m()));
            f = Math.ceil(Math.log(c) / Math.LN2);
            f = f <= 48 ? 1 : Math.pow(2, f - 48);
            g = v(c);
            for(b = g.j(a); B(b) || b.l(d) > 0;)c -= f, g = v(c), b = g.j(a);
            C(g) && (g = z);
            e = e.add(g);
            d = F(d, b);
        }
        return new H(e, d);
    }
    h.B = function(d) {
        return D(this, d).h;
    };
    h.and = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) & d.i(f);
        return new t(c, this.h & d.h);
    };
    h.or = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) | d.i(f);
        return new t(c, this.h | d.h);
    };
    h.xor = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) ^ d.i(f);
        return new t(c, this.h ^ d.h);
    };
    function I(d) {
        const a = d.g.length + 1, c = [];
        for(let f = 0; f < a; f++)c[f] = d.i(f) << 1 | d.i(f - 1) >>> 31;
        return new t(c, d.h);
    }
    function J(d, a) {
        const c = a >> 5;
        a %= 32;
        const f = d.g.length - c, e = [];
        for(let g = 0; g < f; g++)e[g] = a > 0 ? d.i(g + c) >>> a | d.i(g + c + 1) << 32 - a : d.i(g + c);
        return new t(e, d.h);
    }
    m.prototype.digest = m.prototype.A;
    m.prototype.reset = m.prototype.u;
    m.prototype.update = m.prototype.v;
    $906344b47e605252$export$9f5a3dfc7a9f5dd = $906344b47e605252$export$2e2bcd8739ae039.Md5 = m;
    t.prototype.add = t.prototype.add;
    t.prototype.multiply = t.prototype.j;
    t.prototype.modulo = t.prototype.B;
    t.prototype.compare = t.prototype.l;
    t.prototype.toNumber = t.prototype.m;
    t.prototype.toString = t.prototype.toString;
    t.prototype.getBits = t.prototype.i;
    t.fromNumber = v;
    t.fromString = y;
    $906344b47e605252$export$70ffa26850098d01 = $906344b47e605252$export$2e2bcd8739ae039.Integer = t;
}).apply(typeof $906344b47e605252$var$commonjsGlobal !== 'undefined' ? $906344b47e605252$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});



var $33cb313d667e3306$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $33cb313d667e3306$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $33cb313d667e3306$export$26404658cda3ee02;
var $33cb313d667e3306$export$ddb1030448106742;
var $33cb313d667e3306$export$aa726fb96ad3e039;
var $33cb313d667e3306$export$3d7865934588d77e;
var $33cb313d667e3306$export$d4e71bc0b80dc0fb;
var $33cb313d667e3306$export$cbbc350c1dfc80cb;
var $33cb313d667e3306$export$d61e24a684f9e51;
var $33cb313d667e3306$export$888d0d9ab79d08fc;
var $33cb313d667e3306$export$66869136fc133c3a;
(function() {
    var h, aa = Object.defineProperty;
    function ba(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $33cb313d667e3306$var$commonjsGlobal && $33cb313d667e3306$var$commonjsGlobal
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) a: {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && b != null && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    da("Symbol.dispose", function(a) {
        return a ? a : Symbol("Symbol.dispose");
    });
    da("Array.prototype.values", function(a) {
        return a ? a : function() {
            return this[Symbol.iterator]();
        };
    });
    da("Object.entries", function(a) {
        return a ? a : function(b) {
            var c = [], d;
            for(d in b)Object.prototype.hasOwnProperty.call(b, d) && c.push([
                d,
                b[d]
            ]);
            return c;
        };
    }); /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    var ea = ea || {}, l = this || self;
    function n(a) {
        var b = typeof a;
        return b == "object" && a != null || b == "function";
    }
    function fa(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function p(a, b, c) {
        p = fa;
        return p.apply(null, arguments);
    }
    function ha(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    function t(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.Z = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
        a.Ob = function(d, e, f) {
            for(var g = Array(arguments.length - 2), k = 2; k < arguments.length; k++)g[k - 2] = arguments[k];
            return b.prototype[e].apply(d, g);
        };
    }
    var ia = typeof AsyncContext !== "undefined" && typeof AsyncContext.Snapshot === "function" ? (a)=>a && AsyncContext.Snapshot.wrap(a) : (a)=>a;
    function ja(a) {
        const b = a.length;
        if (b > 0) {
            const c = Array(b);
            for(let d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    function ka(a, b) {
        for(let d = 1; d < arguments.length; d++){
            const e = arguments[d];
            var c = typeof e;
            c = c != "object" ? c : e ? Array.isArray(e) ? "array" : c : "null";
            if (c == "array" || c == "object" && typeof e.length == "number") {
                c = a.length || 0;
                const f = e.length || 0;
                a.length = c + f;
                for(let g = 0; g < f; g++)a[c + g] = e[g];
            } else a.push(e);
        }
    }
    class la {
        constructor(a, b){
            this.i = a;
            this.j = b;
            this.h = 0;
            this.g = null;
        }
        get() {
            let a;
            this.h > 0 ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
            return a;
        }
    }
    function ma(a) {
        l.setTimeout(()=>{
            throw a;
        }, 0);
    }
    function na() {
        var a = oa;
        let b = null;
        a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
        return b;
    }
    class pa {
        constructor(){
            this.h = this.g = null;
        }
        add(a, b) {
            const c = qa.get();
            c.set(a, b);
            this.h ? this.h.next = c : this.g = c;
            this.h = c;
        }
    }
    var qa = new la(()=>new ra, (a)=>a.reset());
    class ra {
        constructor(){
            this.next = this.g = this.h = null;
        }
        set(a, b) {
            this.h = a;
            this.g = b;
            this.next = null;
        }
        reset() {
            this.next = this.g = this.h = null;
        }
    }
    let u, v = !1, oa = new pa, ta = ()=>{
        const a = Promise.resolve(void 0);
        u = ()=>{
            a.then(sa);
        };
    };
    function sa() {
        for(var a; a = na();){
            try {
                a.h.call(a.g);
            } catch (c) {
                ma(c);
            }
            var b = qa;
            b.j(a);
            b.h < 100 && (b.h++, a.next = b.g, b.g = a);
        }
        v = !1;
    }
    function w() {
        this.u = this.u;
        this.C = this.C;
    }
    w.prototype.u = !1;
    w.prototype.dispose = function() {
        this.u || (this.u = !0, this.N());
    };
    w.prototype[Symbol.dispose] = function() {
        this.dispose();
    };
    w.prototype.N = function() {
        if (this.C) for(; this.C.length;)this.C.shift()();
    };
    function x(a, b) {
        this.type = a;
        this.g = this.target = b;
        this.defaultPrevented = !1;
    }
    x.prototype.h = function() {
        this.defaultPrevented = !0;
    };
    var ua = function() {
        if (!l.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        });
        try {
            const c = ()=>{};
            l.addEventListener("test", c, b);
            l.removeEventListener("test", c, b);
        } catch (c) {}
        return a;
    }();
    function y(a) {
        return /^[\s\xa0]*$/.test(a);
    }
    function z(a, b) {
        x.call(this, a ? a.type : "");
        this.relatedTarget = this.g = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.state = null;
        this.pointerId = 0;
        this.pointerType = "";
        this.i = null;
        a && this.init(a, b);
    }
    t(z, x);
    z.prototype.init = function(a, b) {
        const c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.g = b;
        b = a.relatedTarget;
        b || (c == "mouseover" ? b = a.fromElement : c == "mouseout" && (b = a.toElement));
        this.relatedTarget = b;
        d ? (this.clientX = d.clientX !== void 0 ? d.clientX : d.pageX, this.clientY = d.clientY !== void 0 ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = a.clientX !== void 0 ? a.clientX : a.pageX, this.clientY = a.clientY !== void 0 ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = a.pointerType;
        this.state = a.state;
        this.i = a;
        a.defaultPrevented && z.Z.h.call(this);
    };
    z.prototype.h = function() {
        z.Z.h.call(this);
        const a = this.i;
        a.preventDefault ? a.preventDefault() : a.returnValue = !1;
    };
    var B = "closure_listenable_" + (Math.random() * 1E6 | 0);
    var va = 0;
    function wa(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.ha = e;
        this.key = ++va;
        this.da = this.fa = !1;
    }
    function xa(a) {
        a.da = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.ha = null;
    }
    function ya(a, b, c) {
        for(const d in a)b.call(c, a[d], d, a);
    }
    function Aa(a, b) {
        for(const c in a)b.call(void 0, a[c], c, a);
    }
    function Ba(a) {
        const b = {};
        for(const c in a)b[c] = a[c];
        return b;
    }
    const Ca = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function Da(a, b) {
        let c, d;
        for(let e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(let f = 0; f < Ca.length; f++)c = Ca[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function Ea(a) {
        this.src = a;
        this.g = {};
        this.h = 0;
    }
    Ea.prototype.add = function(a, b, c, d, e) {
        const f = a.toString();
        a = this.g[f];
        a || (a = this.g[f] = [], this.h++);
        const g = Fa(a, b, d, e);
        g > -1 ? (b = a[g], c || (b.fa = !1)) : (b = new wa(b, this.src, f, !!d, e), b.fa = c, a.push(b));
        return b;
    };
    function Ga(a, b) {
        const c = b.type;
        if (c in a.g) {
            var d = a.g[c], e = Array.prototype.indexOf.call(d, b, void 0), f;
            (f = e >= 0) && Array.prototype.splice.call(d, e, 1);
            f && (xa(b), a.g[c].length == 0 && (delete a.g[c], a.h--));
        }
    }
    function Fa(a, b, c, d) {
        for(let e = 0; e < a.length; ++e){
            const f = a[e];
            if (!f.da && f.listener == b && f.capture == !!c && f.ha == d) return e;
        }
        return -1;
    }
    var Ha = "closure_lm_" + (Math.random() * 1E6 | 0), Ia = {};
    function Ka(a, b, c, d, e) {
        if (d && d.once) return La(a, b, c, d, e);
        if (Array.isArray(b)) {
            for(let f = 0; f < b.length; f++)Ka(a, b[f], c, d, e);
            return null;
        }
        c = Ma(c);
        return a && a[B] ? a.J(b, c, n(d) ? !!d.capture : !!d, e) : Na(a, b, c, !1, d, e);
    }
    function Na(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        const g = n(e) ? !!e.capture : !!e;
        let k = Oa(a);
        k || (a[Ha] = k = new Ea(a));
        c = k.add(b, c, d, g, f);
        if (c.proxy) return c;
        d = Pa();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) ua || (e = g), e === void 0 && (e = !1), a.addEventListener(b.toString(), d, e);
        else if (a.attachEvent) a.attachEvent(Qa(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        return c;
    }
    function Pa() {
        function a(c) {
            return b.call(a.src, a.listener, c);
        }
        const b = Ra;
        return a;
    }
    function La(a, b, c, d, e) {
        if (Array.isArray(b)) {
            for(let f = 0; f < b.length; f++)La(a, b[f], c, d, e);
            return null;
        }
        c = Ma(c);
        return a && a[B] ? a.K(b, c, n(d) ? !!d.capture : !!d, e) : Na(a, b, c, !0, d, e);
    }
    function Sa(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)Sa(a, b[f], c, d, e);
        else (d = n(d) ? !!d.capture : !!d, c = Ma(c), a && a[B]) ? (a = a.i, f = String(b).toString(), f in a.g && (b = a.g[f], c = Fa(b, c, d, e), c > -1 && (xa(b[c]), Array.prototype.splice.call(b, c, 1), b.length == 0 && (delete a.g[f], a.h--)))) : a && (a = Oa(a)) && (b = a.g[b.toString()], a = -1, b && (a = Fa(b, c, d, e)), (c = a > -1 ? b[a] : null) && Ta(c));
    }
    function Ta(a) {
        if (typeof a !== "number" && a && !a.da) {
            var b = a.src;
            if (b && b[B]) Ga(b.i, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Qa(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                (c = Oa(b)) ? (Ga(c, a), c.h == 0 && (c.src = null, b[Ha] = null)) : xa(a);
            }
        }
    }
    function Qa(a) {
        return a in Ia ? Ia[a] : Ia[a] = "on" + a;
    }
    function Ra(a, b) {
        if (a.da) a = !0;
        else {
            b = new z(b, this);
            const c = a.listener, d = a.ha || a.src;
            a.fa && Ta(a);
            a = c.call(d, b);
        }
        return a;
    }
    function Oa(a) {
        a = a[Ha];
        return a instanceof Ea ? a : null;
    }
    var Ua = "__closure_events_fn_" + (Math.random() * 1E9 >>> 0);
    function Ma(a) {
        if (typeof a === "function") return a;
        a[Ua] || (a[Ua] = function(b) {
            return a.handleEvent(b);
        });
        return a[Ua];
    }
    function C() {
        w.call(this);
        this.i = new Ea(this);
        this.M = this;
        this.G = null;
    }
    t(C, w);
    C.prototype[B] = !0;
    C.prototype.removeEventListener = function(a, b, c, d) {
        Sa(this, a, b, c, d);
    };
    function D(a, b) {
        var c, d = a.G;
        if (d) for(c = []; d; d = d.G)c.push(d);
        a = a.M;
        d = b.type || b;
        if (typeof b === "string") b = new x(b, a);
        else if (b instanceof x) b.target = b.target || a;
        else {
            var e = b;
            b = new x(d, a);
            Da(b, e);
        }
        e = !0;
        let f, g;
        if (c) for(g = c.length - 1; g >= 0; g--)f = b.g = c[g], e = Va(f, d, !0, b) && e;
        f = b.g = a;
        e = Va(f, d, !0, b) && e;
        e = Va(f, d, !1, b) && e;
        if (c) for(g = 0; g < c.length; g++)f = b.g = c[g], e = Va(f, d, !1, b) && e;
    }
    C.prototype.N = function() {
        C.Z.N.call(this);
        if (this.i) {
            var a = this.i;
            for(const c in a.g){
                const d = a.g[c];
                for(let e = 0; e < d.length; e++)xa(d[e]);
                delete a.g[c];
                a.h--;
            }
        }
        this.G = null;
    };
    C.prototype.J = function(a, b, c, d) {
        return this.i.add(String(a), b, !1, c, d);
    };
    C.prototype.K = function(a, b, c, d) {
        return this.i.add(String(a), b, !0, c, d);
    };
    function Va(a, b, c, d) {
        b = a.i.g[String(b)];
        if (!b) return !0;
        b = b.concat();
        let e = !0;
        for(let f = 0; f < b.length; ++f){
            const g = b[f];
            if (g && !g.da && g.capture == c) {
                const k = g.listener, q = g.ha || g.src;
                g.fa && Ga(a.i, g);
                e = k.call(q, d) !== !1 && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function Wa(a, b) {
        if (typeof a !== "function") {
            if (a && typeof a.handleEvent == "function") a = p(a.handleEvent, a);
            else throw Error("Invalid listener argument");
        }
        return Number(b) > 2147483647 ? -1 : l.setTimeout(a, b || 0);
    }
    function Xa(a) {
        a.g = Wa(()=>{
            a.g = null;
            a.i && (a.i = !1, Xa(a));
        }, a.l);
        const b = a.h;
        a.h = null;
        a.m.apply(null, b);
    }
    class Ya extends w {
        constructor(a, b){
            super();
            this.m = a;
            this.l = b;
            this.h = null;
            this.i = !1;
            this.g = null;
        }
        j(a) {
            this.h = arguments;
            this.g ? this.i = !0 : Xa(this);
        }
        N() {
            super.N();
            this.g && (l.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
        }
    }
    function E(a) {
        w.call(this);
        this.h = a;
        this.g = {};
    }
    t(E, w);
    var Za = [];
    function $a(a) {
        ya(a.g, function(b, c) {
            this.g.hasOwnProperty(c) && Ta(b);
        }, a);
        a.g = {};
    }
    E.prototype.N = function() {
        E.Z.N.call(this);
        $a(this);
    };
    E.prototype.handleEvent = function() {
        throw Error("EventHandler.handleEvent not implemented");
    };
    var ab = l.JSON.stringify;
    var cb = l.JSON.parse;
    var db = class {
        stringify(a) {
            return l.JSON.stringify(a, void 0);
        }
        parse(a) {
            return l.JSON.parse(a, void 0);
        }
    };
    function eb() {}
    function fb() {}
    var H = {
        OPEN: "a",
        hb: "b",
        ERROR: "c",
        tb: "d"
    };
    function gb() {
        x.call(this, "d");
    }
    t(gb, x);
    function hb() {
        x.call(this, "c");
    }
    t(hb, x);
    var I = {}, ib = null;
    function jb() {
        return ib = ib || new C;
    }
    I.Ia = "serverreachability";
    function kb(a) {
        x.call(this, I.Ia, a);
    }
    t(kb, x);
    function lb(a) {
        const b = jb();
        D(b, new kb(b));
    }
    I.STAT_EVENT = "statevent";
    function mb(a, b) {
        x.call(this, I.STAT_EVENT, a);
        this.stat = b;
    }
    t(mb, x);
    function J(a) {
        const b = jb();
        D(b, new mb(b, a));
    }
    I.Ja = "timingevent";
    function nb(a, b) {
        x.call(this, I.Ja, a);
        this.size = b;
    }
    t(nb, x);
    function ob(a, b) {
        if (typeof a !== "function") throw Error("Fn must not be null and must be a function");
        return l.setTimeout(function() {
            a();
        }, b);
    }
    function pb() {
        this.g = !0;
    }
    pb.prototype.ua = function() {
        this.g = !1;
    };
    function qb(a, b, c, d, e, f) {
        a.info(function() {
            if (a.g) {
                if (f) {
                    var g = "";
                    var k = f.split("&");
                    for(let m = 0; m < k.length; m++){
                        var q = k[m].split("=");
                        if (q.length > 1) {
                            const r = q[0];
                            q = q[1];
                            const A = r.split("_");
                            g = A.length >= 2 && A[1] == "type" ? g + (r + "=" + q + "&") : g + (r + "=redacted&");
                        }
                    }
                } else g = null;
            } else g = f;
            return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + g;
        });
    }
    function rb(a, b, c, d, e, f, g) {
        a.info(function() {
            return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + g;
        });
    }
    function K(a, b, c, d) {
        a.info(function() {
            return "XMLHTTP TEXT (" + b + "): " + sb(a, c) + (d ? " " + d : "");
        });
    }
    function tb(a, b) {
        a.info(function() {
            return "TIMEOUT: " + b;
        });
    }
    pb.prototype.info = function() {};
    function sb(a, b) {
        if (!a.g) return b;
        if (!b) return null;
        try {
            const f = JSON.parse(b);
            if (f) {
                for(a = 0; a < f.length; a++)if (Array.isArray(f[a])) {
                    var c = f[a];
                    if (!(c.length < 2)) {
                        var d = c[1];
                        if (Array.isArray(d) && !(d.length < 1)) {
                            var e = d[0];
                            if (e != "noop" && e != "stop" && e != "close") for(let g = 1; g < d.length; g++)d[g] = "";
                        }
                    }
                }
            }
            return ab(f);
        } catch (f) {
            return b;
        }
    }
    var ub = {
        NO_ERROR: 0,
        cb: 1,
        qb: 2,
        pb: 3,
        kb: 4,
        ob: 5,
        rb: 6,
        Ga: 7,
        TIMEOUT: 8,
        ub: 9
    };
    var vb = {
        ib: "complete",
        Fb: "success",
        ERROR: "error",
        Ga: "abort",
        xb: "ready",
        yb: "readystatechange",
        TIMEOUT: "timeout",
        sb: "incrementaldata",
        wb: "progress",
        lb: "downloadprogress",
        Nb: "uploadprogress"
    };
    var wb;
    function xb() {}
    t(xb, eb);
    xb.prototype.g = function() {
        return new XMLHttpRequest;
    };
    wb = new xb;
    function L(a) {
        return encodeURIComponent(String(a));
    }
    function yb(a) {
        var b = 1;
        a = a.split(":");
        const c = [];
        for(; b > 0 && a.length;)c.push(a.shift()), b--;
        a.length && c.push(a.join(":"));
        return c;
    }
    function N(a, b, c, d) {
        this.j = a;
        this.i = b;
        this.l = c;
        this.S = d || 1;
        this.V = new E(this);
        this.H = 45E3;
        this.J = null;
        this.o = !1;
        this.u = this.B = this.A = this.M = this.F = this.T = this.D = null;
        this.G = [];
        this.g = null;
        this.C = 0;
        this.m = this.v = null;
        this.X = -1;
        this.K = !1;
        this.P = 0;
        this.O = null;
        this.W = this.L = this.U = this.R = !1;
        this.h = new zb;
    }
    function zb() {
        this.i = null;
        this.g = "";
        this.h = !1;
    }
    var Ab = {}, Bb = {};
    function Cb(a, b, c) {
        a.M = 1;
        a.A = Db(O(b));
        a.u = c;
        a.R = !0;
        Eb(a, null);
    }
    function Eb(a, b) {
        a.F = Date.now();
        Fb(a);
        a.B = O(a.A);
        var c = a.B, d = a.S;
        Array.isArray(d) || (d = [
            String(d)
        ]);
        Gb(c.i, "t", d);
        a.C = 0;
        c = a.j.L;
        a.h = new zb;
        a.g = Hb(a.j, c ? b : null, !a.u);
        a.P > 0 && (a.O = new Ya(p(a.Y, a, a.g), a.P));
        b = a.V;
        c = a.g;
        d = a.ba;
        var e = "readystatechange";
        Array.isArray(e) || (e && (Za[0] = e.toString()), e = Za);
        for(let f = 0; f < e.length; f++){
            const g = Ka(c, e[f], d || b.handleEvent, !1, b.h || b);
            if (!g) break;
            b.g[g.key] = g;
        }
        b = a.J ? Ba(a.J) : {};
        a.u ? (a.v || (a.v = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.B, a.v, a.u, b)) : (a.v = "GET", a.g.ea(a.B, a.v, null, b));
        lb();
        qb(a.i, a.v, a.B, a.l, a.S, a.u);
    }
    N.prototype.ba = function(a) {
        a = a.target;
        const b = this.O;
        b && P(a) == 3 ? b.j() : this.Y(a);
    };
    N.prototype.Y = function(a) {
        try {
            if (a == this.g) a: {
                const k = P(this.g), q = this.g.ya(), m = this.g.ca();
                if (!(k < 3) && (k != 3 || this.g && (this.h.h || this.g.la() || Ib(this.g)))) {
                    this.K || k != 4 || q == 7 || (q == 8 || m <= 0 ? lb(3) : lb(2));
                    Jb(this);
                    var b = this.g.ca();
                    this.X = b;
                    var c = Kb(this);
                    this.o = b == 200;
                    rb(this.i, this.v, this.B, this.l, this.S, k, b);
                    if (this.o) {
                        if (this.U && !this.L) {
                            b: {
                                if (this.g) {
                                    var d, e = this.g;
                                    if ((d = e.g ? e.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !y(d)) {
                                        var f = d;
                                        break b;
                                    }
                                }
                                f = null;
                            }
                            if (a = f) K(this.i, this.l, a, "Initial handshake response via X-HTTP-Initial-Response"), this.L = !0, Lb(this, a);
                            else {
                                this.o = !1;
                                this.m = 3;
                                J(12);
                                Q(this);
                                Mb(this);
                                break a;
                            }
                        }
                        if (this.R) {
                            a = !0;
                            let r;
                            for(; !this.K && this.C < c.length;)if (r = Nb(this, c), r == Bb) {
                                k == 4 && (this.m = 4, J(14), a = !1);
                                K(this.i, this.l, null, "[Incomplete Response]");
                                break;
                            } else if (r == Ab) {
                                this.m = 4;
                                J(15);
                                K(this.i, this.l, c, "[Invalid Chunk]");
                                a = !1;
                                break;
                            } else K(this.i, this.l, r, null), Lb(this, r);
                            Ob(this) && this.C != 0 && (this.h.g = this.h.g.slice(this.C), this.C = 0);
                            k != 4 || c.length != 0 || this.h.h || (this.m = 1, J(16), a = !1);
                            this.o = this.o && a;
                            if (!a) K(this.i, this.l, c, "[Invalid Chunked Response]"), Q(this), Mb(this);
                            else if (c.length > 0 && !this.W) {
                                this.W = !0;
                                var g = this.j;
                                g.g == this && g.aa && !g.P && (g.j.info("Great, no buffering proxy detected. Bytes received: " + c.length), Pb(g), g.P = !0, J(11));
                            }
                        } else K(this.i, this.l, c, null), Lb(this, c);
                        k == 4 && Q(this);
                        this.o && !this.K && (k == 4 ? Qb(this.j, this) : (this.o = !1, Fb(this)));
                    } else Rb(this.g), b == 400 && c.indexOf("Unknown SID") > 0 ? (this.m = 3, J(12)) : (this.m = 0, J(13)), Q(this), Mb(this);
                }
            }
        } catch (k) {} finally{}
    };
    function Kb(a) {
        if (!Ob(a)) return a.g.la();
        const b = Ib(a.g);
        if (b === "") return "";
        let c = "";
        const d = b.length, e = P(a.g) == 4;
        if (!a.h.i) {
            if (typeof TextDecoder === "undefined") return Q(a), Mb(a), "";
            a.h.i = new l.TextDecoder;
        }
        for(let f = 0; f < d; f++)a.h.h = !0, c += a.h.i.decode(b[f], {
            stream: !(e && f == d - 1)
        });
        b.length = 0;
        a.h.g += c;
        a.C = 0;
        return a.h.g;
    }
    function Ob(a) {
        return a.g ? a.v == "GET" && a.M != 2 && a.j.Aa : !1;
    }
    function Nb(a, b) {
        var c = a.C, d = b.indexOf("\n", c);
        if (d == -1) return Bb;
        c = Number(b.substring(c, d));
        if (isNaN(c)) return Ab;
        d += 1;
        if (d + c > b.length) return Bb;
        b = b.slice(d, d + c);
        a.C = d + c;
        return b;
    }
    N.prototype.cancel = function() {
        this.K = !0;
        Q(this);
    };
    function Fb(a) {
        a.T = Date.now() + a.H;
        Sb(a, a.H);
    }
    function Sb(a, b) {
        if (a.D != null) throw Error("WatchDog timer not null");
        a.D = ob(p(a.aa, a), b);
    }
    function Jb(a) {
        a.D && (l.clearTimeout(a.D), a.D = null);
    }
    N.prototype.aa = function() {
        this.D = null;
        const a = Date.now();
        a - this.T >= 0 ? (tb(this.i, this.B), this.M != 2 && (lb(), J(17)), Q(this), this.m = 2, Mb(this)) : Sb(this, this.T - a);
    };
    function Mb(a) {
        a.j.I == 0 || a.K || Qb(a.j, a);
    }
    function Q(a) {
        Jb(a);
        var b = a.O;
        b && typeof b.dispose == "function" && b.dispose();
        a.O = null;
        $a(a.V);
        a.g && (b = a.g, a.g = null, b.abort(), b.dispose());
    }
    function Lb(a, b) {
        try {
            var c = a.j;
            if (c.I != 0 && (c.g == a || Tb(c.h, a))) {
                if (!a.L && Tb(c.h, a) && c.I == 3) {
                    try {
                        var d = c.Ba.g.parse(b);
                    } catch (m) {
                        d = null;
                    }
                    if (Array.isArray(d) && d.length == 3) {
                        var e = d;
                        if (e[0] == 0) {
                            a: if (!c.v) {
                                if (c.g) {
                                    if (c.g.F + 3E3 < a.F) Ub(c), Vb(c);
                                    else break a;
                                }
                                Wb(c);
                                J(18);
                            }
                        } else c.xa = e[1], 0 < c.xa - c.K && e[2] < 37500 && c.F && c.A == 0 && !c.C && (c.C = ob(p(c.Va, c), 6E3));
                        Xb(c.h) <= 1 && c.ta && (c.ta = void 0);
                    } else R(c, 11);
                } else if ((a.L || c.g == a) && Ub(c), !y(b)) for(e = c.Ba.g.parse(b), b = 0; b < e.length; b++){
                    let m = e[b];
                    const r = m[0];
                    if (!(r <= c.K)) {
                        if (c.K = r, m = m[1], c.I == 2) {
                            if (m[0] == "c") {
                                c.M = m[1];
                                c.ba = m[2];
                                const A = m[3];
                                A != null && (c.ka = A, c.j.info("VER=" + c.ka));
                                const M = m[4];
                                M != null && (c.za = M, c.j.info("SVER=" + c.za));
                                const F = m[5];
                                F != null && typeof F === "number" && F > 0 && (d = 1.5 * F, c.O = d, c.j.info("backChannelRequestTimeoutMs_=" + d));
                                d = c;
                                const G = a.g;
                                if (G) {
                                    const za = G.g ? G.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                                    if (za) {
                                        var f = d.h;
                                        f.g || za.indexOf("spdy") == -1 && za.indexOf("quic") == -1 && za.indexOf("h2") == -1 || (f.j = f.l, f.g = new Set, f.h && (Yb(f, f.h), f.h = null));
                                    }
                                    if (d.G) {
                                        const bb = G.g ? G.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                        bb && (d.wa = bb, S(d.J, d.G, bb));
                                    }
                                }
                                c.I = 3;
                                c.l && c.l.ra();
                                c.aa && (c.T = Date.now() - a.F, c.j.info("Handshake RTT: " + c.T + "ms"));
                                d = c;
                                var g = a;
                                d.na = Zb(d, d.L ? d.ba : null, d.W);
                                if (g.L) {
                                    $b(d.h, g);
                                    var k = g, q = d.O;
                                    q && (k.H = q);
                                    k.D && (Jb(k), Fb(k));
                                    d.g = g;
                                } else ac(d);
                                c.i.length > 0 && bc(c);
                            } else m[0] != "stop" && m[0] != "close" || R(c, 7);
                        } else c.I == 3 && (m[0] == "stop" || m[0] == "close" ? m[0] == "stop" ? R(c, 7) : cc(c) : m[0] != "noop" && c.l && c.l.qa(m), c.A = 0);
                    }
                }
            }
            lb(4);
        } catch (m) {}
    }
    var dc = class {
        constructor(a, b){
            this.g = a;
            this.map = b;
        }
    };
    function ec(a) {
        this.l = a || 10;
        l.PerformanceNavigationTiming ? (a = l.performance.getEntriesByType("navigation"), a = a.length > 0 && (a[0].nextHopProtocol == "hq" || a[0].nextHopProtocol == "h2")) : a = !!(l.chrome && l.chrome.loadTimes && l.chrome.loadTimes() && l.chrome.loadTimes().wasFetchedViaSpdy);
        this.j = a ? this.l : 1;
        this.g = null;
        this.j > 1 && (this.g = new Set);
        this.h = null;
        this.i = [];
    }
    function fc(a) {
        return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
    }
    function Xb(a) {
        return a.h ? 1 : a.g ? a.g.size : 0;
    }
    function Tb(a, b) {
        return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
    }
    function Yb(a, b) {
        a.g ? a.g.add(b) : a.h = b;
    }
    function $b(a, b) {
        a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
    }
    ec.prototype.cancel = function() {
        this.i = hc(this);
        if (this.h) this.h.cancel(), this.h = null;
        else if (this.g && this.g.size !== 0) {
            for (const a of this.g.values())a.cancel();
            this.g.clear();
        }
    };
    function hc(a) {
        if (a.h != null) return a.i.concat(a.h.G);
        if (a.g != null && a.g.size !== 0) {
            let b = a.i;
            for (const c of a.g.values())b = b.concat(c.G);
            return b;
        }
        return ja(a.i);
    }
    var ic = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
    function jc(a, b) {
        if (a) {
            a = a.split("&");
            for(let c = 0; c < a.length; c++){
                const d = a[c].indexOf("=");
                let e, f = null;
                d >= 0 ? (e = a[c].substring(0, d), f = a[c].substring(d + 1)) : e = a[c];
                b(e, f ? decodeURIComponent(f.replace(/\+/g, " ")) : "");
            }
        }
    }
    function T(a) {
        this.g = this.o = this.j = "";
        this.u = null;
        this.m = this.h = "";
        this.l = !1;
        let b;
        a instanceof T ? (this.l = a.l, kc(this, a.j), this.o = a.o, this.g = a.g, lc(this, a.u), this.h = a.h, mc(this, nc(a.i)), this.m = a.m) : a && (b = String(a).match(ic)) ? (this.l = !1, kc(this, b[1] || "", !0), this.o = oc(b[2] || ""), this.g = oc(b[3] || "", !0), lc(this, b[4]), this.h = oc(b[5] || "", !0), mc(this, b[6] || "", !0), this.m = oc(b[7] || "")) : (this.l = !1, this.i = new pc(null, this.l));
    }
    T.prototype.toString = function() {
        const a = [];
        var b = this.j;
        b && a.push(qc(b, rc, !0), ":");
        var c = this.g;
        if (c || b == "file") a.push("//"), (b = this.o) && a.push(qc(b, rc, !0), "@"), a.push(L(c).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.u, c != null && a.push(":", String(c));
        if (c = this.h) this.g && c.charAt(0) != "/" && a.push("/"), a.push(qc(c, c.charAt(0) == "/" ? sc : tc, !0));
        (c = this.i.toString()) && a.push("?", c);
        (c = this.m) && a.push("#", qc(c, uc));
        return a.join("");
    };
    T.prototype.resolve = function(a) {
        const b = O(this);
        let c = !!a.j;
        c ? kc(b, a.j) : c = !!a.o;
        c ? b.o = a.o : c = !!a.g;
        c ? b.g = a.g : c = a.u != null;
        var d = a.h;
        if (c) lc(b, a.u);
        else if (c = !!a.h) {
            if (d.charAt(0) != "/") {
                if (this.g && !this.h) d = "/" + d;
                else {
                    var e = b.h.lastIndexOf("/");
                    e != -1 && (d = b.h.slice(0, e + 1) + d);
                }
            }
            e = d;
            if (e == ".." || e == ".") d = "";
            else if (e.indexOf("./") != -1 || e.indexOf("/.") != -1) {
                d = e.lastIndexOf("/", 0) == 0;
                e = e.split("/");
                const f = [];
                for(let g = 0; g < e.length;){
                    const k = e[g++];
                    k == "." ? d && g == e.length && f.push("") : k == ".." ? ((f.length > 1 || f.length == 1 && f[0] != "") && f.pop(), d && g == e.length && f.push("")) : (f.push(k), d = !0);
                }
                d = f.join("/");
            } else d = e;
        }
        c ? b.h = d : c = a.i.toString() !== "";
        c ? mc(b, nc(a.i)) : c = !!a.m;
        c && (b.m = a.m);
        return b;
    };
    function O(a) {
        return new T(a);
    }
    function kc(a, b, c) {
        a.j = c ? oc(b, !0) : b;
        a.j && (a.j = a.j.replace(/:$/, ""));
    }
    function lc(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || b < 0) throw Error("Bad port number " + b);
            a.u = b;
        } else a.u = null;
    }
    function mc(a, b, c) {
        b instanceof pc ? (a.i = b, vc(a.i, a.l)) : (c || (b = qc(b, wc)), a.i = new pc(b, a.l));
    }
    function S(a, b, c) {
        a.i.set(b, c);
    }
    function Db(a) {
        S(a, "zx", Math.floor(Math.random() * 2147483648).toString(36) + Math.abs(Math.floor(Math.random() * 2147483648) ^ Date.now()).toString(36));
        return a;
    }
    function oc(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function qc(a, b, c) {
        return typeof a === "string" ? (a = encodeURI(a).replace(b, xc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function xc(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var rc = /[#\/\?@]/g, tc = /[#\?:]/g, sc = /[#\?]/g, wc = /[#\?@]/g, uc = /#/g;
    function pc(a, b) {
        this.h = this.g = null;
        this.i = a || null;
        this.j = !!b;
    }
    function U(a) {
        a.g || (a.g = new Map, a.h = 0, a.i && jc(a.i, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    h = pc.prototype;
    h.add = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        let c = this.g.get(a);
        c || this.g.set(a, c = []);
        c.push(b);
        this.h += 1;
        return this;
    };
    function yc(a, b) {
        U(a);
        b = V(a, b);
        a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
    }
    function zc(a, b) {
        U(a);
        b = V(a, b);
        return a.g.has(b);
    }
    h.forEach = function(a, b) {
        U(this);
        this.g.forEach(function(c, d) {
            c.forEach(function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    function Ac(a, b) {
        U(a);
        let c = [];
        if (typeof b === "string") zc(a, b) && (c = c.concat(a.g.get(V(a, b))));
        else for(a = Array.from(a.g.values()), b = 0; b < a.length; b++)c = c.concat(a[b]);
        return c;
    }
    h.set = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        zc(this, a) && (this.h -= this.g.get(a).length);
        this.g.set(a, [
            b
        ]);
        this.h += 1;
        return this;
    };
    h.get = function(a, b) {
        if (!a) return b;
        a = Ac(this, a);
        return a.length > 0 ? String(a[0]) : b;
    };
    function Gb(a, b, c) {
        yc(a, b);
        c.length > 0 && (a.i = null, a.g.set(V(a, b), ja(c)), a.h += c.length);
    }
    h.toString = function() {
        if (this.i) return this.i;
        if (!this.g) return "";
        const a = [], b = Array.from(this.g.keys());
        for(let d = 0; d < b.length; d++){
            var c = b[d];
            const e = L(c);
            c = Ac(this, c);
            for(let f = 0; f < c.length; f++){
                let g = e;
                c[f] !== "" && (g += "=" + L(c[f]));
                a.push(g);
            }
        }
        return this.i = a.join("&");
    };
    function nc(a) {
        const b = new pc;
        b.i = a.i;
        a.g && (b.g = new Map(a.g), b.h = a.h);
        return b;
    }
    function V(a, b) {
        b = String(b);
        a.j && (b = b.toLowerCase());
        return b;
    }
    function vc(a, b) {
        b && !a.j && (U(a), a.i = null, a.g.forEach(function(c, d) {
            const e = d.toLowerCase();
            d != e && (yc(this, d), Gb(this, e, c));
        }, a));
        a.j = b;
    }
    function Bc(a, b) {
        const c = new pb;
        if (l.Image) {
            const d = new Image;
            d.onload = ha(W, c, "TestLoadImage: loaded", !0, b, d);
            d.onerror = ha(W, c, "TestLoadImage: error", !1, b, d);
            d.onabort = ha(W, c, "TestLoadImage: abort", !1, b, d);
            d.ontimeout = ha(W, c, "TestLoadImage: timeout", !1, b, d);
            l.setTimeout(function() {
                if (d.ontimeout) d.ontimeout();
            }, 1E4);
            d.src = a;
        } else b(!1);
    }
    function Cc(a, b) {
        const c = new pb, d = new AbortController, e = setTimeout(()=>{
            d.abort();
            W(c, "TestPingServer: timeout", !1, b);
        }, 1E4);
        fetch(a, {
            signal: d.signal
        }).then((f)=>{
            clearTimeout(e);
            f.ok ? W(c, "TestPingServer: ok", !0, b) : W(c, "TestPingServer: server error", !1, b);
        }).catch(()=>{
            clearTimeout(e);
            W(c, "TestPingServer: error", !1, b);
        });
    }
    function W(a, b, c, d, e) {
        try {
            e && (e.onload = null, e.onerror = null, e.onabort = null, e.ontimeout = null), d(c);
        } catch (f) {}
    }
    function Dc() {
        this.g = new db;
    }
    function Ec(a) {
        this.i = a.Sb || null;
        this.h = a.ab || !1;
    }
    t(Ec, eb);
    Ec.prototype.g = function() {
        return new Fc(this.i, this.h);
    };
    function Fc(a, b) {
        C.call(this);
        this.H = a;
        this.o = b;
        this.m = void 0;
        this.status = this.readyState = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.A = new Headers;
        this.h = null;
        this.F = "GET";
        this.D = "";
        this.g = !1;
        this.B = this.j = this.l = null;
        this.v = new AbortController;
    }
    t(Fc, C);
    h = Fc.prototype;
    h.open = function(a, b) {
        if (this.readyState != 0) throw this.abort(), Error("Error reopening a connection");
        this.F = a;
        this.D = b;
        this.readyState = 1;
        Gc(this);
    };
    h.send = function(a) {
        if (this.readyState != 1) throw this.abort(), Error("need to call open() first. ");
        if (this.v.signal.aborted) throw this.abort(), Error("Request was aborted.");
        this.g = !0;
        const b = {
            headers: this.A,
            method: this.F,
            credentials: this.m,
            cache: void 0,
            signal: this.v.signal
        };
        a && (b.body = a);
        (this.H || l).fetch(new Request(this.D, b)).then(this.Pa.bind(this), this.ga.bind(this));
    };
    h.abort = function() {
        this.response = this.responseText = "";
        this.A = new Headers;
        this.status = 0;
        this.v.abort();
        this.j && this.j.cancel("Request was aborted.").catch(()=>{});
        this.readyState >= 1 && this.g && this.readyState != 4 && (this.g = !1, Hc(this));
        this.readyState = 0;
    };
    h.Pa = function(a) {
        if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, Gc(this)), this.g && (this.readyState = 3, Gc(this), this.g))) {
            if (this.responseType === "arraybuffer") a.arrayBuffer().then(this.Na.bind(this), this.ga.bind(this));
            else if (typeof l.ReadableStream !== "undefined" && "body" in a) {
                this.j = a.body.getReader();
                if (this.o) {
                    if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                    this.response = [];
                } else this.response = this.responseText = "", this.B = new TextDecoder;
                Ic(this);
            } else a.text().then(this.Oa.bind(this), this.ga.bind(this));
        }
    };
    function Ic(a) {
        a.j.read().then(a.Ma.bind(a)).catch(a.ga.bind(a));
    }
    h.Ma = function(a) {
        if (this.g) {
            if (this.o && a.value) this.response.push(a.value);
            else if (!this.o) {
                var b = a.value ? a.value : new Uint8Array(0);
                if (b = this.B.decode(b, {
                    stream: !a.done
                })) this.response = this.responseText += b;
            }
            a.done ? Hc(this) : Gc(this);
            this.readyState == 3 && Ic(this);
        }
    };
    h.Oa = function(a) {
        this.g && (this.response = this.responseText = a, Hc(this));
    };
    h.Na = function(a) {
        this.g && (this.response = a, Hc(this));
    };
    h.ga = function() {
        this.g && Hc(this);
    };
    function Hc(a) {
        a.readyState = 4;
        a.l = null;
        a.j = null;
        a.B = null;
        Gc(a);
    }
    h.setRequestHeader = function(a, b) {
        this.A.append(a, b);
    };
    h.getResponseHeader = function(a) {
        return this.h ? this.h.get(a.toLowerCase()) || "" : "";
    };
    h.getAllResponseHeaders = function() {
        if (!this.h) return "";
        const a = [], b = this.h.entries();
        for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Gc(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    Object.defineProperty(Fc.prototype, "withCredentials", {
        get: function() {
            return this.m === "include";
        },
        set: function(a) {
            this.m = a ? "include" : "same-origin";
        }
    });
    function Jc(a) {
        let b = "";
        ya(a, function(c, d) {
            b += d;
            b += ":";
            b += c;
            b += "\r\n";
        });
        return b;
    }
    function Kc(a, b, c) {
        a: {
            for(d in c){
                var d = !1;
                break a;
            }
            d = !0;
        }
        d || (c = Jc(c), typeof a === "string" ? c != null && L(c) : S(a, b, c));
    }
    function X(a) {
        C.call(this);
        this.headers = new Map;
        this.L = a || null;
        this.h = !1;
        this.g = null;
        this.D = "";
        this.o = 0;
        this.l = "";
        this.j = this.B = this.v = this.A = !1;
        this.m = null;
        this.F = "";
        this.H = !1;
    }
    t(X, C);
    var Lc = /^https?$/i, Mc = [
        "POST",
        "PUT"
    ];
    h = X.prototype;
    h.Fa = function(a) {
        this.H = a;
    };
    h.ea = function(a, b, c, d) {
        if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
        b = b ? b.toUpperCase() : "GET";
        this.D = a;
        this.l = "";
        this.o = 0;
        this.A = !1;
        this.h = !0;
        this.g = this.L ? this.L.g() : wb.g();
        this.g.onreadystatechange = ia(p(this.Ca, this));
        try {
            this.B = !0, this.g.open(b, String(a), !0), this.B = !1;
        } catch (f) {
            Nc(this, f);
            return;
        }
        a = c || "";
        c = new Map(this.headers);
        if (d) {
            if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
            else if (typeof d.keys === "function" && typeof d.get === "function") for (const f of d.keys())c.set(f, d.get(f));
            else throw Error("Unknown input type for opt_headers: " + String(d));
        }
        d = Array.from(c.keys()).find((f)=>"content-type" == f.toLowerCase());
        e = l.FormData && a instanceof l.FormData;
        !(Array.prototype.indexOf.call(Mc, b, void 0) >= 0) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        for (const [f, g] of c)this.g.setRequestHeader(f, g);
        this.F && (this.g.responseType = this.F);
        "withCredentials" in this.g && this.g.withCredentials !== this.H && (this.g.withCredentials = this.H);
        try {
            this.m && (clearTimeout(this.m), this.m = null), this.v = !0, this.g.send(a), this.v = !1;
        } catch (f) {
            Nc(this, f);
        }
    };
    function Nc(a, b) {
        a.h = !1;
        a.g && (a.j = !0, a.g.abort(), a.j = !1);
        a.l = b;
        a.o = 5;
        Oc(a);
        Pc(a);
    }
    function Oc(a) {
        a.A || (a.A = !0, D(a, "complete"), D(a, "error"));
    }
    h.abort = function(a) {
        this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.o = a || 7, D(this, "complete"), D(this, "abort"), Pc(this));
    };
    h.N = function() {
        this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), Pc(this, !0));
        X.Z.N.call(this);
    };
    h.Ca = function() {
        this.u || (this.B || this.v || this.j ? Qc(this) : this.Xa());
    };
    h.Xa = function() {
        Qc(this);
    };
    function Qc(a) {
        if (a.h && typeof ea != "undefined") {
            if (a.v && P(a) == 4) setTimeout(a.Ca.bind(a), 0);
            else if (D(a, "readystatechange"), P(a) == 4) {
                a.h = !1;
                try {
                    const f = a.ca();
                    a: switch(f){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var b = !0;
                            break a;
                        default:
                            b = !1;
                    }
                    var c;
                    if (!(c = b)) {
                        var d;
                        if (d = f === 0) {
                            let g = String(a.D).match(ic)[1] || null;
                            !g && l.self && l.self.location && (g = l.self.location.protocol.slice(0, -1));
                            d = !Lc.test(g ? g.toLowerCase() : "");
                        }
                        c = d;
                    }
                    if (c) D(a, "complete"), D(a, "success");
                    else {
                        a.o = 6;
                        try {
                            var e = P(a) > 2 ? a.g.statusText : "";
                        } catch (g) {
                            e = "";
                        }
                        a.l = e + " [" + a.ca() + "]";
                        Oc(a);
                    }
                } finally{
                    Pc(a);
                }
            }
        }
    }
    function Pc(a, b) {
        if (a.g) {
            a.m && (clearTimeout(a.m), a.m = null);
            const c = a.g;
            a.g = null;
            b || D(a, "ready");
            try {
                c.onreadystatechange = null;
            } catch (d) {}
        }
    }
    h.isActive = function() {
        return !!this.g;
    };
    function P(a) {
        return a.g ? a.g.readyState : 0;
    }
    h.ca = function() {
        try {
            return P(this) > 2 ? this.g.status : -1;
        } catch (a) {
            return -1;
        }
    };
    h.la = function() {
        try {
            return this.g ? this.g.responseText : "";
        } catch (a) {
            return "";
        }
    };
    h.La = function(a) {
        if (this.g) {
            var b = this.g.responseText;
            a && b.indexOf(a) == 0 && (b = b.substring(a.length));
            return cb(b);
        }
    };
    function Ib(a) {
        try {
            if (!a.g) return null;
            if ("response" in a.g) return a.g.response;
            switch(a.F){
                case "":
                case "text":
                    return a.g.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
            }
            return null;
        } catch (b) {
            return null;
        }
    }
    function Rb(a) {
        const b = {};
        a = (a.g && P(a) >= 2 ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
        for(let d = 0; d < a.length; d++){
            if (y(a[d])) continue;
            var c = yb(a[d]);
            const e = c[0];
            c = c[1];
            if (typeof c !== "string") continue;
            c = c.trim();
            const f = b[e] || [];
            b[e] = f;
            f.push(c);
        }
        Aa(b, function(d) {
            return d.join(", ");
        });
    }
    h.ya = function() {
        return this.o;
    };
    h.Ha = function() {
        return typeof this.l === "string" ? this.l : String(this.l);
    };
    function Rc(a, b, c) {
        return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
    }
    function Sc(a) {
        this.za = 0;
        this.i = [];
        this.j = new pb;
        this.ba = this.na = this.J = this.W = this.g = this.wa = this.G = this.H = this.u = this.U = this.o = null;
        this.Ya = this.V = 0;
        this.Sa = Rc("failFast", !1, a);
        this.F = this.C = this.v = this.m = this.l = null;
        this.X = !0;
        this.xa = this.K = -1;
        this.Y = this.A = this.D = 0;
        this.Qa = Rc("baseRetryDelayMs", 5E3, a);
        this.Za = Rc("retryDelaySeedMs", 1E4, a);
        this.Ta = Rc("forwardChannelMaxRetries", 2, a);
        this.va = Rc("forwardChannelRequestTimeoutMs", 2E4, a);
        this.ma = a && a.xmlHttpFactory || void 0;
        this.Ua = a && a.Rb || void 0;
        this.Aa = a && a.useFetchStreams || !1;
        this.O = void 0;
        this.L = a && a.supportsCrossDomainXhr || !1;
        this.M = "";
        this.h = new ec(a && a.concurrentRequestLimit);
        this.Ba = new Dc;
        this.S = a && a.fastHandshake || !1;
        this.R = a && a.encodeInitMessageHeaders || !1;
        this.S && this.R && (this.R = !1);
        this.Ra = a && a.Pb || !1;
        a && a.ua && this.j.ua();
        a && a.forceLongPolling && (this.X = !1);
        this.aa = !this.S && this.X && a && a.detectBufferingProxy || !1;
        this.ia = void 0;
        a && a.longPollingTimeout && a.longPollingTimeout > 0 && (this.ia = a.longPollingTimeout);
        this.ta = void 0;
        this.T = 0;
        this.P = !1;
        this.ja = this.B = null;
    }
    h = Sc.prototype;
    h.ka = 8;
    h.I = 1;
    h.connect = function(a, b, c, d) {
        J(0);
        this.W = a;
        this.H = b || {};
        c && d !== void 0 && (this.H.OSID = c, this.H.OAID = d);
        this.F = this.X;
        this.J = Zb(this, null, this.W);
        bc(this);
    };
    function cc(a) {
        Tc(a);
        if (a.I == 3) {
            var b = a.V++, c = O(a.J);
            S(c, "SID", a.M);
            S(c, "RID", b);
            S(c, "TYPE", "terminate");
            Uc(a, c);
            b = new N(a, a.j, b);
            b.M = 2;
            b.A = Db(O(c));
            c = !1;
            if (l.navigator && l.navigator.sendBeacon) try {
                c = l.navigator.sendBeacon(b.A.toString(), "");
            } catch (d) {}
            !c && l.Image && ((new Image).src = b.A, c = !0);
            c || (b.g = Hb(b.j, null), b.g.ea(b.A));
            b.F = Date.now();
            Fb(b);
        }
        Vc(a);
    }
    function Vb(a) {
        a.g && (Pb(a), a.g.cancel(), a.g = null);
    }
    function Tc(a) {
        Vb(a);
        a.v && (l.clearTimeout(a.v), a.v = null);
        Ub(a);
        a.h.cancel();
        a.m && (typeof a.m === "number" && l.clearTimeout(a.m), a.m = null);
    }
    function bc(a) {
        if (!fc(a.h) && !a.m) {
            a.m = !0;
            var b = a.Ea;
            u || ta();
            v || (u(), v = !0);
            oa.add(b, a);
            a.D = 0;
        }
    }
    function Wc(a, b) {
        if (Xb(a.h) >= a.h.j - (a.m ? 1 : 0)) return !1;
        if (a.m) return a.i = b.G.concat(a.i), !0;
        if (a.I == 1 || a.I == 2 || a.D >= (a.Sa ? 0 : a.Ta)) return !1;
        a.m = ob(p(a.Ea, a, b), Xc(a, a.D));
        a.D++;
        return !0;
    }
    h.Ea = function(a) {
        if (this.m) {
            if (this.m = null, this.I == 1) {
                if (!a) {
                    this.V = Math.floor(Math.random() * 1E5);
                    a = this.V++;
                    const e = new N(this, this.j, a);
                    let f = this.o;
                    this.U && (f ? (f = Ba(f), Da(f, this.U)) : f = this.U);
                    this.u !== null || this.R || (e.J = f, f = null);
                    if (this.S) a: {
                        var b = 0;
                        for(var c = 0; c < this.i.length; c++){
                            b: {
                                var d = this.i[c];
                                if ("__data__" in d.map && (d = d.map.__data__, typeof d === "string")) {
                                    d = d.length;
                                    break b;
                                }
                                d = void 0;
                            }
                            if (d === void 0) break;
                            b += d;
                            if (b > 4096) {
                                b = c;
                                break a;
                            }
                            if (b === 4096 || c === this.i.length - 1) {
                                b = c + 1;
                                break a;
                            }
                        }
                        b = 1E3;
                    }
                    else b = 1E3;
                    b = Yc(this, e, b);
                    c = O(this.J);
                    S(c, "RID", a);
                    S(c, "CVER", 22);
                    this.G && S(c, "X-HTTP-Session-Id", this.G);
                    Uc(this, c);
                    f && (this.R ? b = "headers=" + L(Jc(f)) + "&" + b : this.u && Kc(c, this.u, f));
                    Yb(this.h, e);
                    this.Ra && S(c, "TYPE", "init");
                    this.S ? (S(c, "$req", b), S(c, "SID", "null"), e.U = !0, Cb(e, c, null)) : Cb(e, c, b);
                    this.I = 2;
                }
            } else this.I == 3 && (a ? Zc(this, a) : this.i.length == 0 || fc(this.h) || Zc(this));
        }
    };
    function Zc(a, b) {
        var c;
        b ? c = b.l : c = a.V++;
        const d = O(a.J);
        S(d, "SID", a.M);
        S(d, "RID", c);
        S(d, "AID", a.K);
        Uc(a, d);
        a.u && a.o && Kc(d, a.u, a.o);
        c = new N(a, a.j, c, a.D + 1);
        a.u === null && (c.J = a.o);
        b && (a.i = b.G.concat(a.i));
        b = Yc(a, c, 1E3);
        c.H = Math.round(a.va * .5) + Math.round(a.va * .5 * Math.random());
        Yb(a.h, c);
        Cb(c, d, b);
    }
    function Uc(a, b) {
        a.H && ya(a.H, function(c, d) {
            S(b, d, c);
        });
        a.l && ya({}, function(c, d) {
            S(b, d, c);
        });
    }
    function Yc(a, b, c) {
        c = Math.min(a.i.length, c);
        const d = a.l ? p(a.l.Ka, a.l, a) : null;
        a: {
            var e = a.i;
            let k = -1;
            for(;;){
                const q = [
                    "count=" + c
                ];
                k == -1 ? c > 0 ? (k = e[0].g, q.push("ofs=" + k)) : k = 0 : q.push("ofs=" + k);
                let m = !0;
                for(let r = 0; r < c; r++){
                    var f = e[r].g;
                    const A = e[r].map;
                    f -= k;
                    if (f < 0) k = Math.max(0, e[r].g - 100), m = !1;
                    else try {
                        f = "req" + f + "_";
                        try {
                            var g = A instanceof Map ? A : Object.entries(A);
                            for (const [M, F] of g){
                                let G = F;
                                n(F) && (G = ab(F));
                                q.push(f + M + "=" + encodeURIComponent(G));
                            }
                        } catch (M) {
                            throw q.push(f + "type=" + encodeURIComponent("_badmap")), M;
                        }
                    } catch (M) {
                        d && d(A);
                    }
                }
                if (m) {
                    g = q.join("&");
                    break a;
                }
            }
            g = void 0;
        }
        a = a.i.splice(0, c);
        b.G = a;
        return g;
    }
    function ac(a) {
        if (!a.g && !a.v) {
            a.Y = 1;
            var b = a.Da;
            u || ta();
            v || (u(), v = !0);
            oa.add(b, a);
            a.A = 0;
        }
    }
    function Wb(a) {
        if (a.g || a.v || a.A >= 3) return !1;
        a.Y++;
        a.v = ob(p(a.Da, a), Xc(a, a.A));
        a.A++;
        return !0;
    }
    h.Da = function() {
        this.v = null;
        $c(this);
        if (this.aa && !(this.P || this.g == null || this.T <= 0)) {
            var a = 4 * this.T;
            this.j.info("BP detection timer enabled: " + a);
            this.B = ob(p(this.Wa, this), a);
        }
    };
    h.Wa = function() {
        this.B && (this.B = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.P = !0, J(10), Vb(this), $c(this));
    };
    function Pb(a) {
        a.B != null && (l.clearTimeout(a.B), a.B = null);
    }
    function $c(a) {
        a.g = new N(a, a.j, "rpc", a.Y);
        a.u === null && (a.g.J = a.o);
        a.g.P = 0;
        var b = O(a.na);
        S(b, "RID", "rpc");
        S(b, "SID", a.M);
        S(b, "AID", a.K);
        S(b, "CI", a.F ? "0" : "1");
        !a.F && a.ia && S(b, "TO", a.ia);
        S(b, "TYPE", "xmlhttp");
        Uc(a, b);
        a.u && a.o && Kc(b, a.u, a.o);
        a.O && (a.g.H = a.O);
        var c = a.g;
        a = a.ba;
        c.M = 1;
        c.A = Db(O(b));
        c.u = null;
        c.R = !0;
        Eb(c, a);
    }
    h.Va = function() {
        this.C != null && (this.C = null, Vb(this), Wb(this), J(19));
    };
    function Ub(a) {
        a.C != null && (l.clearTimeout(a.C), a.C = null);
    }
    function Qb(a, b) {
        var c = null;
        if (a.g == b) {
            Ub(a);
            Pb(a);
            a.g = null;
            var d = 2;
        } else if (Tb(a.h, b)) c = b.G, $b(a.h, b), d = 1;
        else return;
        if (a.I != 0) {
            if (b.o) {
                if (d == 1) {
                    c = b.u ? b.u.length : 0;
                    b = Date.now() - b.F;
                    var e = a.D;
                    d = jb();
                    D(d, new nb(d, c));
                    bc(a);
                } else ac(a);
            } else if (e = b.m, e == 3 || e == 0 && b.X > 0 || !(d == 1 && Wc(a, b) || d == 2 && Wb(a))) switch(c && c.length > 0 && (b = a.h, b.i = b.i.concat(c)), e){
                case 1:
                    R(a, 5);
                    break;
                case 4:
                    R(a, 10);
                    break;
                case 3:
                    R(a, 6);
                    break;
                default:
                    R(a, 2);
            }
        }
    }
    function Xc(a, b) {
        let c = a.Qa + Math.floor(Math.random() * a.Za);
        a.isActive() || (c *= 2);
        return c * b;
    }
    function R(a, b) {
        a.j.info("Error code " + b);
        if (b == 2) {
            var c = p(a.bb, a), d = a.Ua;
            const e = !d;
            d = new T(d || "//www.google.com/images/cleardot.gif");
            l.location && l.location.protocol == "http" || kc(d, "https");
            Db(d);
            e ? Bc(d.toString(), c) : Cc(d.toString(), c);
        } else J(2);
        a.I = 0;
        a.l && a.l.pa(b);
        Vc(a);
        Tc(a);
    }
    h.bb = function(a) {
        a ? (this.j.info("Successfully pinged google.com"), J(2)) : (this.j.info("Failed to ping google.com"), J(1));
    };
    function Vc(a) {
        a.I = 0;
        a.ja = [];
        if (a.l) {
            const b = hc(a.h);
            if (b.length != 0 || a.i.length != 0) ka(a.ja, b), ka(a.ja, a.i), a.h.i.length = 0, ja(a.i), a.i.length = 0;
            a.l.oa();
        }
    }
    function Zb(a, b, c) {
        var d = c instanceof T ? O(c) : new T(c);
        if (d.g != "") b && (d.g = b + "." + d.g), lc(d, d.u);
        else {
            var e = l.location;
            d = e.protocol;
            b = b ? b + "." + e.hostname : e.hostname;
            e = +e.port;
            const f = new T(null);
            d && kc(f, d);
            b && (f.g = b);
            e && lc(f, e);
            c && (f.h = c);
            d = f;
        }
        c = a.G;
        b = a.wa;
        c && b && S(d, c, b);
        S(d, "VER", a.ka);
        Uc(a, d);
        return d;
    }
    function Hb(a, b, c) {
        if (b && !a.L) throw Error("Can't create secondary domain capable XhrIo object.");
        b = a.Aa && !a.ma ? new X(new Ec({
            ab: c
        })) : new X(a.ma);
        b.Fa(a.L);
        return b;
    }
    h.isActive = function() {
        return !!this.l && this.l.isActive(this);
    };
    function ad() {}
    h = ad.prototype;
    h.ra = function() {};
    h.qa = function() {};
    h.pa = function() {};
    h.oa = function() {};
    h.isActive = function() {
        return !0;
    };
    h.Ka = function() {};
    function bd() {}
    bd.prototype.g = function(a, b) {
        return new Y(a, b);
    };
    function Y(a, b) {
        C.call(this);
        this.g = new Sc(b);
        this.l = a;
        this.h = b && b.messageUrlParams || null;
        a = b && b.messageHeaders || null;
        b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
            "X-Client-Protocol": "webchannel"
        });
        this.g.o = a;
        a = b && b.initMessageHeaders || null;
        b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
            "X-WebChannel-Content-Type": b.messageContentType
        });
        b && b.sa && (a ? a["X-WebChannel-Client-Profile"] = b.sa : a = {
            "X-WebChannel-Client-Profile": b.sa
        });
        this.g.U = a;
        (a = b && b.Qb) && !y(a) && (this.g.u = a);
        this.A = b && b.supportsCrossDomainXhr || !1;
        this.v = b && b.sendRawJson || !1;
        (b = b && b.httpSessionIdParam) && !y(b) && (this.g.G = b, a = this.h, a !== null && b in a && (a = this.h, b in a && delete a[b]));
        this.j = new Z(this);
    }
    t(Y, C);
    Y.prototype.m = function() {
        this.g.l = this.j;
        this.A && (this.g.L = !0);
        this.g.connect(this.l, this.h || void 0);
    };
    Y.prototype.close = function() {
        cc(this.g);
    };
    Y.prototype.o = function(a) {
        var b = this.g;
        if (typeof a === "string") {
            var c = {};
            c.__data__ = a;
            a = c;
        } else this.v && (c = {}, c.__data__ = ab(a), a = c);
        b.i.push(new dc(b.Ya++, a));
        b.I == 3 && bc(b);
    };
    Y.prototype.N = function() {
        this.g.l = null;
        delete this.j;
        cc(this.g);
        delete this.g;
        Y.Z.N.call(this);
    };
    function cd(a) {
        gb.call(this);
        a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
        var b = a.__sm__;
        if (b) {
            a: {
                for(const c in b){
                    a = c;
                    break a;
                }
                a = void 0;
            }
            if (this.i = a) a = this.i, b = b !== null && a in b ? b[a] : void 0;
            this.data = b;
        } else this.data = a;
    }
    t(cd, gb);
    function dd() {
        hb.call(this);
        this.status = 1;
    }
    t(dd, hb);
    function Z(a) {
        this.g = a;
    }
    t(Z, ad);
    Z.prototype.ra = function() {
        D(this.g, "a");
    };
    Z.prototype.qa = function(a) {
        D(this.g, new cd(a));
    };
    Z.prototype.pa = function(a) {
        D(this.g, new dd());
    };
    Z.prototype.oa = function() {
        D(this.g, "b");
    };
    bd.prototype.createWebChannel = bd.prototype.g;
    Y.prototype.send = Y.prototype.o;
    Y.prototype.open = Y.prototype.m;
    Y.prototype.close = Y.prototype.close;
    $33cb313d667e3306$export$66869136fc133c3a = $33cb313d667e3306$export$2e2bcd8739ae039.createWebChannelTransport = function() {
        return new bd;
    };
    $33cb313d667e3306$export$888d0d9ab79d08fc = $33cb313d667e3306$export$2e2bcd8739ae039.getStatEventTarget = function() {
        return jb();
    };
    $33cb313d667e3306$export$d61e24a684f9e51 = $33cb313d667e3306$export$2e2bcd8739ae039.Event = I;
    $33cb313d667e3306$export$cbbc350c1dfc80cb = $33cb313d667e3306$export$2e2bcd8739ae039.Stat = {
        jb: 0,
        mb: 1,
        nb: 2,
        Hb: 3,
        Mb: 4,
        Jb: 5,
        Kb: 6,
        Ib: 7,
        Gb: 8,
        Lb: 9,
        PROXY: 10,
        NOPROXY: 11,
        Eb: 12,
        Ab: 13,
        Bb: 14,
        zb: 15,
        Cb: 16,
        Db: 17,
        fb: 18,
        eb: 19,
        gb: 20
    };
    ub.NO_ERROR = 0;
    ub.TIMEOUT = 8;
    ub.HTTP_ERROR = 6;
    $33cb313d667e3306$export$d4e71bc0b80dc0fb = $33cb313d667e3306$export$2e2bcd8739ae039.ErrorCode = ub;
    vb.COMPLETE = "complete";
    $33cb313d667e3306$export$3d7865934588d77e = $33cb313d667e3306$export$2e2bcd8739ae039.EventType = vb;
    fb.EventType = H;
    H.OPEN = "a";
    H.CLOSE = "b";
    H.ERROR = "c";
    H.MESSAGE = "d";
    C.prototype.listen = C.prototype.J;
    $33cb313d667e3306$export$aa726fb96ad3e039 = $33cb313d667e3306$export$2e2bcd8739ae039.WebChannel = fb;
    $33cb313d667e3306$export$ddb1030448106742 = $33cb313d667e3306$export$2e2bcd8739ae039.FetchXmlHttpFactory = Ec;
    X.prototype.listenOnce = X.prototype.K;
    X.prototype.getLastError = X.prototype.Ha;
    X.prototype.getLastErrorCode = X.prototype.ya;
    X.prototype.getStatus = X.prototype.ca;
    X.prototype.getResponseJson = X.prototype.La;
    X.prototype.getResponseText = X.prototype.la;
    X.prototype.send = X.prototype.ea;
    X.prototype.setWithCredentials = X.prototype.Fa;
    $33cb313d667e3306$export$26404658cda3ee02 = $33cb313d667e3306$export$2e2bcd8739ae039.XhrIo = X;
}).apply(typeof $33cb313d667e3306$var$commonjsGlobal !== 'undefined' ? $33cb313d667e3306$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});


/*!
* re2js
* RE2JS is the JavaScript port of RE2, a regular expression engine that provides linear time matching
*
* @version v2.8.6
* @author Oleksii Vasyliev
* @homepage https://github.com/le0pard/re2js#readme
* @repository github:le0pard/re2js
* @license MIT
*/ //#region src/RE2Flags.js
var $394755e62edee9eb$var$RE2Flags = class RE2Flags {
    static FOLD_CASE = 1;
    static LITERAL = 2;
    static CLASS_NL = 4;
    static DOT_NL = 8;
    static ONE_LINE = 16;
    static NON_GREEDY = 32;
    static PERL_X = 64;
    static UNICODE_GROUPS = 128;
    static WAS_DOLLAR = 256;
    static LOOKBEHIND = 512;
    static MATCH_NL = RE2Flags.CLASS_NL | RE2Flags.DOT_NL;
    static PERL = RE2Flags.CLASS_NL | RE2Flags.ONE_LINE | RE2Flags.PERL_X | RE2Flags.UNICODE_GROUPS;
    static POSIX = 0;
    static UNANCHORED = 0;
    static ANCHOR_START = 1;
    static ANCHOR_BOTH = 2;
};
//#endregion
//#region src/PublicFlags.js
/**
* Public flags for RE2JS and RE2Set compilation.
*/ const $394755e62edee9eb$var$PublicFlags = {
    CASE_INSENSITIVE: 1,
    DOTALL: 2,
    MULTILINE: 4,
    DISABLE_UNICODE_GROUPS: 8,
    LONGEST_MATCH: 16,
    LOOKBEHINDS: 512
};
//#endregion
//#region src/Codepoint.js
/**
* Various constants and helper for unicode codepoints.
*/ const $394755e62edee9eb$var$ASCII_SIZE = 128;
const $394755e62edee9eb$var$ASCII_TO_UPPER = new Int32Array($394755e62edee9eb$var$ASCII_SIZE);
const $394755e62edee9eb$var$ASCII_TO_LOWER = new Int32Array($394755e62edee9eb$var$ASCII_SIZE);
const $394755e62edee9eb$var$MAX_BMP = 65535;
for(let i = 0; i < $394755e62edee9eb$var$ASCII_SIZE; i++){
    if (i >= 97 && i <= 122) $394755e62edee9eb$var$ASCII_TO_UPPER[i] = i - 32;
    else $394755e62edee9eb$var$ASCII_TO_UPPER[i] = i;
    if (i >= 65 && i <= 90) $394755e62edee9eb$var$ASCII_TO_LOWER[i] = i + 32;
    else $394755e62edee9eb$var$ASCII_TO_LOWER[i] = i;
}
var $394755e62edee9eb$var$Codepoint = class {
    static CODES = /* @__PURE__ */ new Map([
        [
            "\x07",
            7
        ],
        [
            "\b",
            8
        ],
        [
            "	",
            9
        ],
        [
            "\n",
            10
        ],
        [
            "\v",
            11
        ],
        [
            "\f",
            12
        ],
        [
            "\r",
            13
        ],
        [
            " ",
            32
        ],
        [
            "\"",
            34
        ],
        [
            "$",
            36
        ],
        [
            "&",
            38
        ],
        [
            "'",
            39
        ],
        [
            "(",
            40
        ],
        [
            ")",
            41
        ],
        [
            "*",
            42
        ],
        [
            "+",
            43
        ],
        [
            "-",
            45
        ],
        [
            ".",
            46
        ],
        [
            "0",
            48
        ],
        [
            "1",
            49
        ],
        [
            "2",
            50
        ],
        [
            "3",
            51
        ],
        [
            "4",
            52
        ],
        [
            "5",
            53
        ],
        [
            "6",
            54
        ],
        [
            "7",
            55
        ],
        [
            "8",
            56
        ],
        [
            "9",
            57
        ],
        [
            ":",
            58
        ],
        [
            "<",
            60
        ],
        [
            ">",
            62
        ],
        [
            "?",
            63
        ],
        [
            "A",
            65
        ],
        [
            "B",
            66
        ],
        [
            "C",
            67
        ],
        [
            "F",
            70
        ],
        [
            "P",
            80
        ],
        [
            "Q",
            81
        ],
        [
            "U",
            85
        ],
        [
            "Z",
            90
        ],
        [
            "[",
            91
        ],
        [
            "\\",
            92
        ],
        [
            "]",
            93
        ],
        [
            "^",
            94
        ],
        [
            "_",
            95
        ],
        [
            "`",
            96
        ],
        [
            "a",
            97
        ],
        [
            "b",
            98
        ],
        [
            "f",
            102
        ],
        [
            "i",
            105
        ],
        [
            "m",
            109
        ],
        [
            "n",
            110
        ],
        [
            "r",
            114
        ],
        [
            "s",
            115
        ],
        [
            "t",
            116
        ],
        [
            "v",
            118
        ],
        [
            "x",
            120
        ],
        [
            "z",
            122
        ],
        [
            "{",
            123
        ],
        [
            "|",
            124
        ],
        [
            "}",
            125
        ]
    ]);
    static toUpperCase(codepoint) {
        if (codepoint < $394755e62edee9eb$var$ASCII_SIZE) return $394755e62edee9eb$var$ASCII_TO_UPPER[codepoint];
        const s = String.fromCodePoint(codepoint).toUpperCase();
        const expectedLen = s.codePointAt(0) > $394755e62edee9eb$var$MAX_BMP ? 2 : 1;
        if (s.length > expectedLen) return codepoint;
        const sOrigin = String.fromCodePoint(s.codePointAt(0)).toLowerCase();
        const originExpectedLen = sOrigin.codePointAt(0) > $394755e62edee9eb$var$MAX_BMP ? 2 : 1;
        if (sOrigin.length > originExpectedLen || sOrigin.codePointAt(0) !== codepoint) return codepoint;
        return s.codePointAt(0);
    }
    static toLowerCase(codepoint) {
        if (codepoint < $394755e62edee9eb$var$ASCII_SIZE) return $394755e62edee9eb$var$ASCII_TO_LOWER[codepoint];
        const s = String.fromCodePoint(codepoint).toLowerCase();
        const expectedLen = s.codePointAt(0) > $394755e62edee9eb$var$MAX_BMP ? 2 : 1;
        if (s.length > expectedLen) return codepoint;
        const sOrigin = String.fromCodePoint(s.codePointAt(0)).toUpperCase();
        const originExpectedLen = sOrigin.codePointAt(0) > $394755e62edee9eb$var$MAX_BMP ? 2 : 1;
        if (sOrigin.length > originExpectedLen || sOrigin.codePointAt(0) !== codepoint) return codepoint;
        return s.codePointAt(0);
    }
};
//#endregion
//#region src/UnicodeRangeTable.js
var $394755e62edee9eb$var$UnicodeRangeTable = class {
    /**
	* @param {Uint32Array | number[]} data
	* @param {boolean} isStride1
	*/ constructor(data, isStride1 = false){
        this.data = data;
        this.isStride1 = isStride1;
        this.SIZE = isStride1 ? 2 : 3;
    }
    getLo(index) {
        return this.data[index * this.SIZE];
    }
    getHi(index) {
        return this.data[index * this.SIZE + 1];
    }
    getStride(index) {
        return this.isStride1 ? 1 : this.data[index * this.SIZE + 2];
    }
    get length() {
        return this.data.length / this.SIZE;
    }
};
//#endregion
//#region src/UnicodeTables.js
const $394755e62edee9eb$var$B64_MAP = /* @__PURE__ */ new Uint8Array(256);
for(let i = 0, b = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-"; i < 64; i++)$394755e62edee9eb$var$B64_MAP[b.charCodeAt(i)] = i;
const $394755e62edee9eb$var$decodeVLQ = (str)=>{
    const res = [];
    let value = 0, shift = 0;
    for(let i = 0; i < str.length; i++){
        let digit = $394755e62edee9eb$var$B64_MAP[str.charCodeAt(i)];
        value |= (digit & 31) << shift;
        if ((digit & 32) === 0) {
            res.push(value);
            value = 0;
            shift = 0;
        } else shift += 5;
    }
    return res;
};
const $394755e62edee9eb$var$decodeRanges = (str, isStride1)=>{
    const res = $394755e62edee9eb$var$decodeVLQ(str);
    const numRanges = isStride1 ? res.length / 2 : res.length / 3;
    const out = new Uint32Array(numRanges * 3);
    let current = 0, resIdx = 0;
    for(let i = 0; i < numRanges; i++){
        current += res[resIdx++];
        out[i * 3] = current;
        current += res[resIdx++];
        out[i * 3 + 1] = current;
        out[i * 3 + 2] = isStride1 ? 1 : res[resIdx++];
    }
    return out;
};
const $394755e62edee9eb$var$decodeOrbit = (str)=>{
    const res = $394755e62edee9eb$var$decodeVLQ(str);
    const map = /* @__PURE__ */ new Map();
    let currentKey = 0;
    for(let i = 0; i < res.length; i += 2){
        currentKey += res[i];
        const zz = res[i + 1];
        const delta = zz >>> 1 ^ -(zz & 1);
        map.set(currentKey, currentKey + delta);
    }
    return map;
};
var $394755e62edee9eb$var$LazyMap = class {
    constructor(initializer){
        this.initializer = initializer;
        this.cache = /* @__PURE__ */ new Map();
    }
    has(key) {
        return key in this.initializer;
    }
    get(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        const fn = this.initializer[key];
        const val = fn ? fn() : null;
        this.cache.set(key, val);
        return val;
    }
};
var $394755e62edee9eb$var$UnicodeTables = class {
    static _CASE_ORBIT = null;
    static get CASE_ORBIT() {
        if (!this._CASE_ORBIT) this._CASE_ORBIT = $394755e62edee9eb$var$decodeOrbit("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");
        return this._CASE_ORBIT;
    }
    static _Print = null;
    static get Print() {
        if (!this._Print) this._Print = new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hB9CBjBLBCpWBDFBFGBCCCBSBCsMBClBBDxBBDCBC2BBJaBFFBSVBC-FBCvBBD6BBDkDBP6BBDwBBDOBCbBDCCBJBGfBIqCBCgFBCHBDBBDVBCGBCEEBCBDIBDBBDDBJFFBCCBDBDYBDCBCFBFBBDVBCGBCBBCBBCBBDCCBDBFBBDCBEIIBCBCIIBPBLCBCIBCCBCVBCGBCBBCEBDJBCCBCCBDQQBCBDLBIGBCCBCHBDBBDVBCGBCBBCEBDIBDBBDCBICBFBBCEBDRBLBBCFBECBCDBEBBCCCBEEBEEBBBELBFEBECBCDBDHHPUBGMBCCBCWBCPBDIBCCBCDBIBBCCBCBBDDBDJBIVBCCBCWBCJBCEBDIBCCBCDBIBBGCBCDBDJBCCBNMBCCBCyBBCCBCFBFPBDZBCCBCRBEXBCIBCDDBFBEFFBEBCCCBGBHJBDCBN5BBFcBmBBBCCCBDBCXBCCCBVBDEBCCCBFBCJBDDBhBnCBCjBBFmBBCjBBCOBCMBmBlGBCGGD4LBCDBDGBCCCBCBDoBBCDBDgBBCDBDGBCCCBCBDOBC4BBCDBDiCBDfBEZBH1CBDFBD-TBCbBE4CBIVBKXBKTBNMBCCBCBBN9CBDJBHJBHNBCKBH4CBIqBBGlCBLeBCLBFLBFEEBoBBDEBMrBBFZBHKBE9BBDgCBCcBDKBHJBHNBDtBBDLBVsCBClFBJ7BBEOBE9BBGqBBDKBJqBBG1QBDFBDlBBDFBDHBCGCBdBD0BBCOBCNBDFBCSBDCBCIBSXBJuBBSBBDaBCMBEhBBPgBBQrEBF5UBXKBWz4BBD9LBGsBBCGGD3BBIBBPXBKGBCGBCGBCGBCGBCGBCGBCGBC9DBjBZBC4CBN1GBbPBC+BBC1CBDmDBGqBBC9CBC1CBKvBBCszcBE2BBK7KBV3FBJ8GBV7BBEJBH3BBJlCBJLBHzDBMdBEtCBCKBFgBBC2BBKNBDJBDmDBZbBLFBDFBDFBKGBCGBC7BBF9DBDJBHj9KBNWBFwBBloItLBDpDBnBGBNEBGZBCEBCCCBCCBCCBoUBhBpBBHyBBCSBCDBFEBCmEBF9FBEFBDFBDFBDCBEGBCGBOBBDLBCZBCSBCBBCOBDNBjB6DBGCBFsBBE3CBCMBEwBwBBsBBjEcBEwBBQbBFjBBKdBGqBBGdBCkBBFNBrB9EBDJBHjBBFjBBFnBBJzBBMLBCOBCGBCBBCKBCOBCGBCBBEzBBN2JBKVBLHBZFBCpBBCIBmCFBDCCBqBBCBBEDDBVBCnCBJIBxBSBCBBGgBBEaBGaBnB3BBFTBDxBBCBBGHBCCBCcBDCBFJBIIBI-BBhBmBBFLBK1BBEcBDaBGZBIDBNGBxCoCB4ByBBOyBBItBBJJBHlBBEcBJBBxGeBCpBBCCBDBBRFBJIBiBtBBJpBBXZBnBbBVWBKtCBFjBBK9BBCEBOYBIJBH0BBCRBJmBBK-CBCTBMRBCuBB-BGBCCCBCBCOBCKBH6BBGJBHDBCHBDBBDVBCGBCBBCEBCJBDBBDCBDHHGGBDGBEEBMJBCDDClBBCJBCDDCDBCJBCBBJBBe7CBCEBfnCBJJBnF1BBDlBBjBkCBMJBHMBU5BBHJBHTBdaBDOBFWB6F7BBlDyCBNHBDDDBGBCBBCdBCBBDLBKJBnCHBDtBBDKBcnCBJyCBOoCBIJB3CHB5ChBBPJBHIBCsBBCNBLcBEfBDVBCNBqCGBCBBCrBBECCBCCBHBJJBHFBCBBCkBBCBBCFBIJBHrBBFJB3HYBIQBCoBBEcB2CQQBwBBO6cBnDuDBCEBMjGBtyCiDBOvhBBRVBL68DBGmSB61G5BBn2B4RBIeBCJBFwCBCJBHdBDFBLlCBLJBCGBCUBGSBxN5BBnG6CBGYBDYBtBqCBF4BBIQBhCEBMGBK1mHBqBfBiDyDB+vIDBCGBCBBCiJBQeeBBBDPPBCBJrMBloCqDBGMBEIBIJBDDBh7D8HBEzNBHWBQQBQtBBDWBKzDB9B1HBLmBBDpCBJvDBWlCB7DTBNTBN2CBKYBoE0CBCmCBCBBDDDBDDBCBCLBCCCBFBCgCBCDBDHBCGBCbBCDBCEBCEEBFBCzKBDjJBD9VBQEBCOBxiBeBHFB2GGBCQBDGBCBBCEBG9BBiBxDxDBrBBENBDJBFBBhKeBS5BBGxOxOBoBB3GqBBFhGhGBdBCVBJBBhHGBCDBCBBCOBCkGBDPBqBrCBFJBFBByYjCBtC8BBjGDBCaBCBBCDDCJBCDBCCCHFFCECBBBCBBCDDCICBCCDDBCGBCDBCDBCCCBIBCQBGCBCEBCQB1BBBvIrBBFjDBNOBDOBCOBCkBBLtFB5BcBOrBBFIBIBBPFB7E4eBEQBEMBE5GBHLBFQQBKBF3BBJJBHnBBJdBDLBFBBPIBoB3KBJNBDMBEKBE4BBCFFBOBDLBFJBIyEBCmDBmgB-2pBBhB9oEBDt0FBDwpHBQtTBjtC9QBjvBq6EBGppIBnkzVvHB", false));
        return this._Print;
    }
    static CATEGORIES = new $394755e62edee9eb$var$LazyMap({
        C: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("AfBgDgBBOrWrWBHHBCBICCVuMuMnBBBzBBBE4B4BBGBcDBHQBXhGhGxBBB8BBBmDNB8BBByBBBQddBCCMEBhBGBsCiFiFJBBDBBXIICCBFBBKBBDBBFHBCDBDGGBaaBEEHDBDBBXIIDGDBCCGDBDBBECBCGBFCCBFBSJBEKKEXXIDDGBBLIEBCCBNBFBBNGBIEEJBBDBBXIIDGGBKKBDDBEEBFBEDBDGGBTTBIBDHHBBBEFFBBBDCCDCBDCBECBNDBGCBEFFBCCBEBCNBWEBOEEYRRBKKEFFBFBDEEDBBFBBLGBXEEYLLGBBKEEFGBDEBEFFBLLELBOEE0BEEHDBRBBbEETCBZKKCBBICBCDBHCCJFBLBBELB7BDBekBBDCCGZZCYYBGGCIILBBFfBpClBlBBCBoBlBlBQOOBjBBnGCCBDBCBB6LFFBIICFFBqBqBFBBiBFFBIICFFBQQ6BFFBkCkCBhBhBBBBbFB3CBBHBB+UCB6CGBXIBZIBVLBOEEDLB-CBBLFBLFBPMMBEB6CGBsBEBnCJBgBNNBCBNDBCCBrBBBGKBtBDBbFBMCB-BBBiCeeBMMBEBLFBPBBvBBBNTBuCnFnFBGB9BCBQCB-BEBsBBBMHBsBEB3QBBHBBnBBBHBBJGCgBBB2BQQPBBHUUBEEKMMBDBbEByBPBDBBcOOBBBjBNBiBOBtEDB7UVBMUB14BBB-LEBuBCCBDBCBB5BGBDNBZIBI4BI-DhBBb6C6CBKB3GZBxC3C3CBoDoDBDBsB-C-C3CIBxBuzcuzcBBB4BIB9KTB5FHB+GTB9BCBLFB5BHBnCHBNFB1DKBfCBvCMMBCBiB4B4BBHBPBBLBBoDXBdJBHBBHBBHIBIII9BDB-DBBLFBl9KLBYDByBjoIBvLBBrDlBBILBGEBbGGCGDrUfBrBFB0BUUFDBGoEoEBCB-FCBHBBHBBHBBECBIIIBLBDBBNbbUDDQBBPhBB8DEBEDBuBCB5COOBBBCuBBvBhEBeCByBOBdDBlBIBfEBsBEBfmBmBBCBPpBB-EBBLFBlBDBlBDBpBHB1BKBNQQIDDMQQIDDBBB1BLB4JIBXJBJXBHrBrBKkCBHBBCtBtBDCBCBBYpCpCBGBKvBBUDDBDBiBCBcEBclBB5BDBVBBzBDDBDBJEEeBBEDBLGBKGBhCfBoBDBNIB3BCBeBBcEBbGBFLBIvCBqC2BB0BMB0BGBvBHBLFBnBCBeHBDvGBgBrBrBEBBDPBHHBKgBBvBHBrBVBblBBdTBYIBvCDBlBIB-BGGBLBaGBLFB2BTTBGBoBIBhDVVBJBTwBwBB8BBICCFQQMFB8BEBLFBFJJBDDBXXIDDGLLBDDBEEBCCBEBCEBIBBICBGKBLCCBCCnBLLCBBCFFLDDBGBDcB9CGGBcBpCHBLlFB3BBBnBhBBmCKBLFBOSB7BFBLFBVbBcBBQDBY4FB9BjDB0CLBJBBCBBJDDfDDBNNBHBLlCBJBBvBBBMaBpCHB0CMBqCGBL1CBJ3CBjBNBLFBKuBuBPJBeCBhBBBXPPBnCBIDDtBCBCDDKHBLFBHDDmBDDHGBLFBtBDBL1HBaGBSqBqBBBBe0CBCOBzBMB8clDBwDGGBJBlGryCBkDMBxhBPBXJB88DEBoS41GB7Bl2BB6RGBgBLLBCByCLLBEBfBBHJBnCJBLIIWEBUvNB7BlGB8CEBaBBarBBsCDB6BGBS-BBGKBIIB3mHoBBhBgDB0D8vIBFIIDkJkJBNBCcBEBBCNBFHBtMjoCBsDEBOCBKGBLBBF-6DB+HCB1NFBYOBSOBvBBBYIB1D7BB3HJBoBBBrCHBxDUBnC5DBVLBVLB4CIBamEB2CoCoCDBBCBBDBBFNNCIIiCFFBJJIddFGGCCBI1K1KBlJlJB-V-VBNBGQQBuiBBgBFBH0GBISSBIIDGGBDB-BgBBCvDBuBCBPBBLDBD-JBgBQB7BEBCvOBrB1GBsBDBC-FBgBXXBGBD-GBIFFDQQmGBBRoBBtCDBLDBDwYBlCrCB+BhGBFccDCCBCCLFFCCCBEBCDBCECEDDCBBCICDCCBFFIKFCLLSEBEGGSzBBDtIBtBDBlDLBQBBQQQmBJBvF3BBeMBtBDBKGBDNBH5EB6eCBSCBOCB7GFBNDBCOBNDB5BHBLFBpBHBfBBNDBDNBKmBB5KHBPBBOCBMCB6BCCBCBRBBNDBLGB0EoDoDBjgBBh3pBfB-oEBBv0FBBypHOBvThtCB-QhvBBs6EEBrpIlkzVBxHvw-FB", false)),
        Cc: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("AfgDgB", true)),
        Cf: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("tFzqBzqBBEBXhGhGyBhMhMBxCxCs5D9-B9-BBDBbEByBEBCJBw03B6H6HBBBimEQQj7IPBhjiBDBwmFHBn0rYffB+CB", false)),
        Cn: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("4bBBHDBICCVuMuMnBBBzBBBE4B4BBGBcDBHKBvI9B9BBmDmDBMB8BBByBBBQddBCCMEBjBEBuHJJBDDBXXICCBBBFBBKBBDBBFHBCDBDGGBaaBEEHDBDBBXIIDGDBCCGDBDBBECBCGBFCCBFBSJBEKKEXXIDDGBBLIEBCCBNBFBBNGBIEEJBBDBBXIIDGGBKKBDDBEEBFBEDBDGGBTTBIBDHHBBBEFFBBBDCCDCBDCBECBNDBGCBEFFBCCBEBCNBWEBOEEYRRBKKEFFBFBDEEDBBFBBLGBXEEYLLGBBKEEFGBDEBEFFBLLELBOEE0BEEHDBRBBbEETCBZKKCBBICBCDBHCCJFBLBBELB7BDBekBBDCCGZZCYYBGGCIILBBFfBpClBlBBCBoBlBlBQOOBjBBnGCCBDBCBB6LFFBIICFFBqBqBFBBiBFFBIICFFBQQ6BFFBkCkCBhBhBBBBbFB3CBBHBB+UCB6CGBXIBZIBVLBOEEDLB-CBBLFBLFBbFB6CGBsBEBnCJBgBNNBCBNDBCCBrBBBGKBtBDBbFBMCB-BBBiCeeBMMBEBLFBPBBvBBBNTBuCnFnFBGB9BCBQCB-BEBsBBBMHBsBEB3QBBHBBnBBBHBBJGCgBBB2BQQPBBHUUBEEKmDmDNBBcOOBBBjBNBiBOBtEDB7UVBMUB14BBB-LEBuBCCBDBCBB5BGBDNBZIBI4BI-DhBBb6C6CBKB3GZBxC3C3CBoDoDBDBsB-C-C3CIBxBuzcuzcBBB4BIB9KTB5FHB+GTB9BCBLFB5BHBnCHBNFB1DKBfCBvCMMBCBiB4B4BBHBPBBLBBoDXBdJBHBBHBBHIBIII9BDB-DBBLFBl9KLBYDByBDBvzIBBrDlBBILBGEBbGGCGDrUfBrBFB0BUUFDBGoEoEBCC-FCBHBBHBBHBBECBIIIBIBGBBNbbUDDQBBPhBB8DEBEDBuBCB5COOBBBCuBBvBhEBeCByBOBdDBlBIBfEBsBEBfmBmBBCBPpBB-EBBLFBlBDBlBDBpBHB1BKBNQQIDDMQQIDDBBB1BLB4JIBXJBJXBHrBrBKkCBHBBCtBtBDCBCBBYpCpCBGBKvBBUDDBDBiBCBcEBclBB5BDBVBBzBDDBDBJEEeBBEDBLGBKGBhCfBoBDBNIB3BCBeBBcEBbGBFLBIvCBqC2BB0BMB0BGBvBHBLFBnBCBeHBDvGBgBrBrBEBBDPBHHBKgBBvBHBrBVBblBBdTBYIBvCDBlBIBlCJBCBBaGBLFB2BTTBGBoBIBhDVVBJBTwBwBB8BBICCFQQMFB8BEBLFBFJJBDDBXXIDDGLLBDDBEEBCCBEBCEBIBBICBGKBLCCBCCnBLLCBBCFFLDDBGBDcB9CGGBcBpCHBLlFB3BBBnBhBBmCKBLFBOSB7BFBLFBVbBcBBQDBY4FB9BjDB0CLBJBBCBBJDDfDDBNNBHBLlCBJBBvBBBMaBpCHB0CMBqCGBL1CBJ3CBjBNBLFBKuBuBPJBeCBhBBBXPPBnCBIDDtBCBCDDKHBLFBHDDmBDDHGBLFBtBDBL1HBaGBSqBqBBBBe0CBCOBzBMB8clDBwDGGBJBlGryCBkDMB3iBJB88DEBoS41GB7Bl2BB6RGBgBLLBCByCLLBEBfBBHJBnCJBLIIWEBUvNB7BlGB8CEBaBBarBBsCDB6BGBS-BBGKBIIB3mHoBBhBgDB0D8vIBFIIDkJkJBNBCcBEBBCNBFHBtMjoCBsDEBOCBKGBLBBJ76DB+HCB1NFBYOBSOBvBBBYIB1D7BB3HJBoBBBjGUBnC5DBVLBVLB4CIBamEB2CoCoCDBBCBBDBBFNNCIIiCFFBJJIddFGGCCBI1K1KBlJlJB-V-VBNBGQQBuiBBgBFBH0GBISSBIIDGGBDB-BgBBCvDBuBCBPBBLDBD-JBgBQB7BEBCvOBrB1GBsBDBC-FBgBXXBGBD-GBIFFDQQmGBBRoBBtCDBLDBDwYBlCrCB+BhGBFccDCCBCCLFFCCCBEBCDBCECEDDCBBCICDCCBFFIKFCLLSEBEGGSzBBDtIBtBDBlDLBQBBQQQmBJBvF3BBeMBtBDBKGBDNBH5EB6eCBSCBOCB7GFBNDBCOBNDB5BHBLFBpBHBfBBNDBDNBKmBB5KHBPBBOCBMCB6BCCBCBRBBNDBLGB0EoDoDBjgBBh3pBfB-oEBBv0FBBypHOBvThtCB-QhvBBs6EEBrpIm8yVBCdBhD-DBxHvw-BB---BBB---BBB", false)),
        Co: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gg4B-nGh4hc9--BD9--B", true)),
        Cs: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gg2B--B", true)),
        L: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hCZBHZBwBLLFGGBVBCeBCpOBFLBPEBICCiEEBCBBDDBCHHCCBCCCBSBCyCBCqEBJlFBClBBDHHBnBBoCaBFDBuBqBBkBBBCiDBCQQBIIBLLBBBDRRCdBe4CBMZZBfBKBBFGGBUBFKKEYYBXBIKBGXBCGBRpBB7B1BBETTIJBQPBFHBDBBDVBCGBCEEBCBERROBBCCBPBBLJJBEBFBBDVBCGBCBBCBBCBBgBDBCUUBBBRIBCCBCVBCGBCBBCEBETTQBBYMMBGBDBBDVBCGBCBBCEBEffBCCBBBQSSCFBECBCDBEBBCCCBEEBEEBBBELBX1B1BBGBCCBCWBCPBEbbBBBCBBDBBfFFBGBCCBCWBCJBCEBEffBBBCBBQBBSIBCCBCoBBDRRGCBJCBZFBGRBEXBCIBCDDBFB7BvBBCBBNGB7BBBCCCBDBCXBCCCBIBCBBKDDBDBCWWBCBhBgCgCBGBCjBBcEB0DqBBVRRBEBFDBEEEBIIBBBFMBNSSBkBBCGGDqBBCsKBCDBDGBCCCBCBDoBBCDBDgBBCDBDGBCCCBCBDOBC4BBCDBDiCBmBPBR1CBDFBErTBDQBCZBGqCBHHBIRBOSBPRBPMBCCBQzBBkBFFkC4CBIEBDhBBCGGBkCBLeByBdBDEBMrBBFZB3BWBK0BBzC+C+CBtBBSHB3BdBOBBLrBBbjBBqBCBLjBBDKBGqBBDCBqBDBCFBCBBEGGB+FBhC1IBDFBDlBBDFBDHBCGCBdBD0BBCGBCEEBBBCGBEDBDFBFMBGCBCGB1DOORMBmDFFDJBCEEBDBHGCBCBCKBDDBGEBF1B1BB8zC8zCBjHBHDBEBBNlBBCGGD3BBIRRBVBKGBCGBCGBCGBCGBCGBCGBCGBxC2O2OBrBrBBDBGBBF1CBHCBC5CBCDBGqBBC9CBSfBxBPBhQ-tGBhCs0VBkCtBBDsIBEPBLBBVuBBReBDlCByBIBDmDBDxCBVQBCCBCDBCWBezBBPxBB-BFBECCBMMBaBLWBacBIuBBdRRBDBCJBLEBCoBBYCBCHBVWBEEEBwBBCEEBDDBDBDCCZCBDKBICBNFBDFBDFBKGBCGBCqBBCNBHyDBej9KBNWBFwBBloItLBDpDBnBGBNEBGCCBIBCMBCEBCCCBCCBCCBqDBiBqLBT-BBD1BBpBLB1DEBCmEBlBZBHZBM4CBEFBDFBDFBDCBkBLBCZBCSBCBBCOBDNBjB6DBmMcBEwBBwBfBOTBCHBHlBBLdBDjBBFHBxB9EBTjBBFjBBFnBBJzBBNKBCOBCGBCBBCKBCOBCGBCBBEzBBN2JBKVBLHBZFBCpBBCIBmCFBDCCBqBBCBBEDDBVBLWBKeBiCSBCBBLVBLZBHZBnB3BBHBBhCQQBCBCCBCcBrBcBEcBkBHBCbBc1BBLVBLSBORBvDoCB4ByBBOyBBOjBBnBbBKWB7HpBBHBBRFB5BcBLJJBUBrBRBvBUBcWBN0BB6BBBDOOBrBBhBYBbjBBeDDJiBBENNBuBBPDBWCCkBRBCYBUBBgCGBCCCBCBCOBCJBIuBBnBHBDBBDVBCGBCBBCEBETTNEBfJBCDDClBBCaaCtBtBBzBBTDBVCBfvBBVBBC5F5FBtBBqBDBlBvBBV8B8BBpBBOoCoCBZBmBGB6FrBB1D-BBgBHBDDDBGBCBBCXBQCC-CHBDmBBRCCdLLBmBBIWWMtBBUTTBnCBoGgBBgBIBCkBBSyByBBcBxDGBCBBClBBWaaBEBCBBCfBPYYBqBBlISBQCCBLBChBB9DwCwCB4cBnHjGBtyCgDBQvhBBSFBa68DBGmSB61GdBj3B4RBIeBSuCBSdBTvBBRDBgBUBGSBxNsBB0G-BBhBYBDYBtBqCBGjCjCBLBhCBBCPPBNNB0mHBqBfBiDyDB+vIDBCGBCBBCiJBQeeBBBDPPBCBJrMBloCqDBGMBEIBIJBn7F0CBCmCBCBBDDDBDDBCBCLBCCCBFBCgCBCDBDHBCGBCbBCDBCEBCEEBFBCzKBDYBCYBCeBCYBCeBCYBCeBCYBCeBCYBCHB15BeBHFBmI9BBzEsBBLGBRiKiKBcBTrBBlPbBlHdBDwGwGBdBCCBCBBCGBDEBKBBhHGBCDBCBBCOBCkGB8BjCBI1lB1lBBCBCaBCBBCDDCJBCDBCCCHFFCECBBBCBBCDDCICBCCDDBCGBCDBCDBCCCBIBCQBGCBCEBCQBlqE-2pBBhB9oEBDt0FBDwpHBQtTBjtC9QBjvBq6EBGppIB", false)),
        LC: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hCZBHZB7BLLBVBCeBCiGBCDBFvGBDZBhGDBDBBECBCHHCCBCCCBSBCyCBCqEBJlFBClBBKoBB44ClBBCGGDqBBDCBhV1CBDFBjkCKBGqBBDCBhCrBBgCMBChBBmD1IBDFBDlBBDFBDHBCGCBdBD0BBCGBCEEBBBCGBEDBDFBFMBGCBCGBmIFFDJBCEEBDBHGCBCBCFBFDDBCBGEBF1B1BB8zC8zCB6DBDmDBHDBEBBNlBBCGGzoetBBTbBnEtCBCWBEDBCsCBZBBE2Z2ZBpBBGIBIvCBh6TGBNEBqgBZBHZBmlBvCBhDjBBFjBB1DKBCOBCGBCBBCKBCOBCGBCBBk2ByBBOyBB+CVBLVB74C-BBhrV-BBhBYBDYBtpZ0CBCmCBCBBDDDBDDBCBCLBCCCBFBCgCBCDBDHBCGBCbBCDBCEBCEEBFBCzKBDYBCYBCeBCYBCeBCYBCeBCYBCeBCYBCHB15BJBCTBHFB2uCjCB", false)),
        Ll: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hDZB7BqBqBBWBCHBC2BCBQCBuBCDECBBBDCCDEEBFFDEEBBBDDDCCCDCCBCCDEECDDBDDBBBHGDCOCBSCBDDCEEC4BCBFBDDDBCCFICBjCBDZBiGCCEEEBBBTccBhBBCBBECBCWCBDBCGDB0B0BBuBBCgBCK0BCDMCBgDCxBoBBo6CqBBDCB5XFBjkCIBC2D2DBqBBgCMBChBBnD0ECBHBCgDCBHBJFBLHBJHBJFBLHBJHBJNBDHBJHBJHBJEBCBBHEEBBBCBBJDBDBBJHBLCBCBBzIEEBEEcKFDBBJDBF2B2Bs1CvBBCEEBGCFCCBCCBEBGiDCBIICFFNlBBCGG0oesBCUaCoEMCBBBC+BCBGBCCCDICFCCDCCBBBCSCGGGCMCFCCDOCbEE2ZqBBGIBIvCBh6TGBNEBqhBZBumBnBBpEjBB8EKBCOBCGBCBBk4ByBB+DVB75CfBhsVfB8BYBnqZZBbGBCRBbZBbDBCCCBFBCKBbZBbZBbZBbZBbZBbZBbZBbZBbbBdYBCFBbYBCFBbYBCFBbYBCFBbYBCFBC15B15BBIBCTBHFB4vChBB", false)),
        Lm: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wVRBFLBPEBICCmEGG-OnHnHlFBBuIBBFgBgBKEEhFoFoF1mBgEgE2R72B72BsDkTkTxOFBvF+BBOjBjBBjBByVOORMBg-CBByHgGgG2OsBsBBDBGiDiDB+C+CBBB34bjnBjnBBEBvIzDzDdBB6DIBxCYYpDDBEBB2OXXqEtDtDWBBoDDBKngVngVuBBBh-BFBCpBBCIB0sBhBhB2K04D04DnrTDB9PCBpBBBnRMBhCBBCPPB9-P9-PBCBCGBCBByhM9BBqGGBud0Q0QsSAB", false)),
        Lo: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("qFQQhIFFBCBxGBB7ZaBFDBuBfBCJBkBBBCiDBCZZBLLBBBDRRCdBe4CBMZZBfBWVBrBYBIKBGXBCGBRoBB8B1BBETTIJBROBFHBDBBDVBCGBCEEBCBERROBBCCBPBBLJJBEBFBBDVBCGBCBBCBBCBBgBDBCUUBBBRIBCCBCVBCGBCBBCEBETTQBBYMMBGBDBBDVBCGBCBBCEBEffBCCBBBQSSCFBECBCDBEBBCCCBEEBEEBBBELBX1B1BBGBCCBCWBCPBEbbBBBCBBDBBfFFBGBCCBCWBCJBCEBEffBBBCBBQBBSIBCCBCoBBDRRGCBJCBZFBGRBEXBCIBCDDBFB7BvBBCBBNFB8BBBCCCBDBCXBCCCBIBCBBKDDBDBYDBhBgCgCBGBCjBBcEB0DqBBVRRBEBFDBEEEBIIBBBFMBNyDyDBnKBCDBDGBCCCBCBDoBBCDBDgBBCDBDGBCCCBCBDOBC4BBCDBDiCBmBPByDrTBDQBCZBGqCBHHBIRBOSBPRBPMBCCBQzBBpBkCkCBhBBC0BBIEBDhBBCGGBkCBLeByBdBDEBMrBBFZB3BWBK0BBxFuBBSHB3BdBOBBLrBBbjBBqBCBLdByDDBCFBCBBE7hB7hBBCB4-C3BBZWBKGBCGBCGBCGBCGBCGBCGBCGBoR2B2BF1CBJCCB4CBFGGBpBBC9CBSfBxBPBhQ-tGBhC0wUBC2jBBkCnBBJrIBFPBLBBjCyByBBkCBqFoDoDEGBCCBCDBCWBezBBPxBB-BFBECCBMMBaBLWBacBIuBBuBEBDIBLEBCoBBYCBCHBVPBCFBEEEBwBBCEEBDDBDBDCCZBBEKBIPPBEBDFBDFBKGBCGByEiBBej9KBNWBFwBBloItLBDpDBkCCCBIBCMBCEBCCCBCCBCCBqDBiBqLBT-BBD1BBpBLB1DEBCmEBqDJBCsBBDeBEFBDFBDFBDCBkBLBCZBCSBCBBCOBDNBjB6DBmMcBEwBBwBfBOTBCHBHlBBLdBDjBBFHBhEtCBjDnBBJzBB9CzBBN2JBKVBLHB5EFBDCCBqBBCBBEDDBVBLWBKeBiCSBCBBLVBLZBHZBnB3BBHBBhCQQBCBCCBCcBrBcBEcBkBHBCbBc1BBLVBLSBORBvDoCB4FjBBnBDBCxJxJBoBBHBBRCBCBB5BcBLJJBUBrBRBvBUBcWBN0BB6BBBDOOBrBBhBYBbjBBeDDJiBBENNBuBBPDBWCCkBRBCYBUBBgCGBCCCBCBCOBCJBIuBBnBHBDBBDVBCGBCBBCEBETTNEBfJBCDDClBBCaaCtBtBBzBBTDBVCBfvBBVBBC5F5FBtBBqBDBlBvBBV8B8BBpBBOoCoCBZBmBGB6FrBB0GHBDDDBGBCBBCXBQCC-CHBDmBBRCCdLLBmBBIWWMtBBUTTBnCBoGgBBgBIBCkBBSyByBBcBxDGBCBBClBBWaaBEBCBBCfBPYYBnBBCBBlISBQCCBLBChBB9DwCwCB4cBnHjGBtyCgDBQvhBBSFBa68DBGmSB61GdBj3B4RBIeBSuCBSdBTvBB0BUBGSB0NnBB2MqCBGwFwFB0mHBqBfBiDyDBuwIiJBQeeBBBDPPBCBJrMBloCqDBGMBEIBIJBxzI2P2PBrBBiBiKiKBcBTrBBlPaBmHdBDwGwGBdBCCBCBBCGBDEBKiHiHBFBCDBCBBCOBCkGB8pBDBCaBCBBCDDCJBCDBCCCHFFCECBBBCBBCDDCICBCCDDBCGBCDBCDBCCCBIBCQBGCBCEBCQBlqE-2pBBhB9oEBDt0FBDwpHBQtTBjtC9QBjvBq6EBGppIB", false)),
        Lt: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("lOGDnB2sH2sHBGBJHBJHBNQQwBAB", false)),
        Lu: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hCZBmDWBCGBiB2BCDOCDuBCBECEBBCCCBCCBBBDDBCBBCCBEBBCBBCECBCCDCCBCCBBBCCCBEEIJDCMCDQCDDDCCBC4BCIBBCBBDCCBCBCGCiJCCEJJHCCBBBCCCBCCBPBCIBkBDDBBBEWCGDDCBBDyBBxBgBCK2BCBMCD+CCDlBBq6ClBBCGGzW1CB0kCHHBpBBDCBhK0ECKgDCKHBJFBLHBJHBJFBMGCJHBpCDBNDBNDBNEBMDBnIFFECBDCBDEEBDBHGCBCBDDBLBBG+B+B9zCvBBxBCCBBBDGCBCBCDDJCBCgDCJCCFuqeuqeCqBCUaCoEMCE8BCLECBICFCCDCCEUCBDBCEBCOCBCBCCCBQCZs5Vs5VBYBmmBnBBpEjBB9EKBCOBCGBCBBr3ByBB+EVB75CfBhsVfBhCYBoqZZBbZBbZBbCCBGDBDDBCBCHBbZBbBBCDBDHBCGBcBBCDBCEBCEEBFBcZBbZBbZBbZBbZBbZBfYBiBYBiBYBiBYBiBYBiB2pE2pEBgBB", false)),
        M: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gYvDB0IGBoIsBBCCCBCCBCCpCKBxBUBRmDmDBFBDFBDBBCDBkBffBZB8CKB7BIBKZZBCBCIBCCBCEBsBCB8BIBrBXBCgBB3BCBCRBCGBLBBeCB5BCCBFBDBBDCBKLLBbbDCB5BCCBDBFBBDCBEffBEEMCB5BCCBGBCCBCCBVBBXFBCCB5BCCBFBDBBDCBICBLBBf8B8BBDBECBCDBKpBpBBDB4BCCBFBCCBCDBIBBMBBeCB5BCCBFBCCBCDBIBBMBBQNNBCB4BBBCGBCCBCDBKLLBeeBBBnCFFBEBCCCBGBTBB+BDDBFBNHBjDDDBHBMGBqCBBcECFBByBTBCBBGKBCjBBKlDlDBSBYDBFCBCCBDGBEDBOLBCLLBCBgWCBzdDBdCBeBBfBBhCfBKuBuBBBBC2D2DBjBjB3DLBFLB8GEB6BJBCcBDxBxBBsBBDLBVEBwBQBnBIBNCBfMB5BNBxBTB5ECBCUBFHHDCBnG-BBxWgBB--CCBuEhDhDBeBrRFBqDBB1udDBCJBhBBBxCBBxIEEFYYBDBF0C0CBzBzBBQBbRBOnBnBBGBaMBtBDBwBNBlBkCkCBMBNJJBuBuBBBBzBCCBBBDBBGBBCqBqBBDBGBBtHHBCBBx5TiXiXBOBRPBuejHjH2EEBn0BCBCBBGDBpBCBFmFmFB+R+RBCBiCEB+JBBuCFBnCKByBDB7DCB2BOBqBDDBLLBCBuBKBI+B+BBBBlBNBRBBtBNNBBBxBNBJDBCBB9CLBHDD+ELBWDB4BBBCGBDBBDCBKLLBDDBFBEEBkCIBCDDCDBCEBCPPBzCzCBQBYyCyCBSBsHGBDIBcBBzCQBrDMBmDOBhIOB2HFBCBBDDBCCCBuEuEBFBDGBEddBIBpBGBCDBJKKBJBvBPBnGHBoGHBCHBzCVBCNB7DFBECCBCCBFBCjCjCBDBCBBCEB8KDBKBBCxBxBBFBEEBYmnFmnFHOBpmLRBhuCEB8BGB5gBCCB1BBIDByCMMBslTslTBizEizEBsBBDWB-QEBEFBJHBDGBfDB1ECB89B2BBFxBBJPPXEBCOBxqBGBCQBDGBCBBCEBlDhFhFBFB4L+B+BBCB9PDB-HBB0HDDIBBG7O7OBFBuDGB29lYvHB", false)),
        Mc: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("joC4B4BDCBJDBCBBzBBB7BCBHBBDBBLsBsB7BCBjC7B7BBBBJCCB2B2BB7B7BCHHBDDBLLnDBBCBBECBCCBLqBqBBBB+BDB+BBB7BCCBDBDBBCBBKBBdPPB7B7BBBBGCBCCBLrBrBBsCsCBBBHHBTBBrKBBgCsFsFBFFHDDBaaBLLBBBDGBWBBDFBDLLBBB5zBffiEIIBGBCBB7KDBDCBFBBCFBhHBB7BCCKCCBJJBEByExBxBGCCBDBCBB+BffFBBD9B9BDCBCEEBxBxBBGBJBBsFWW35EBB0-dBBD5C5CBzBzBBOBvEBBwBxBxBBFFBDDBBBvDBBDBBZuBuBCuDuDDBBGuHuHBCCBCCBCC0gZCCgEuBuBBBBFBB0DZZB8B8BxBCBKBBO+C+CBBBEBBCrFrFBBBgBBB7BBBCDBDBBDCBKLLB1C1CBBBIDDCDBCBBCmDmDBBBJBBErDrDBBBHCCBCBDuHuHBBBHDBDyDyDBBBJBBCuDuDCBBHoDoDCBBFmImIBBBK4H4HBEBCBBFDDCvEvEBBBJDBF1C1CeBB-BqGqGECCoGPPrDIID2G2GBDBFBBC-K-KBNNxBBBJBBCpvQpvQBBBlxD2BBpDBB0rYBBHFB", false)),
        Me: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("okBBB1xF-wB-wBBCBCCBsshBCB", false)),
        Mn: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gYvDB0IEBqIsBBCCCBCCBCCpCKBxBUBRmDmDBFBDFBDBBCDBkBffBZB8CKB7BIBKZZBCBCIBCCBCEBsBCB8BIBrBXBCfB4BCCFHBFEEBFBLBBe7B7BFDBJVVBbbDBB6BFFBFFBDDBBBEffBEEMBB6BFFBDBCBBFVVBXXBEBC7B7BDCCBCBJIIBMMBff+BNNzBEE4BCCBBBGCBCDBIBBMBBe7B7BDHHGBBVBBdBB6BBBFDBJVVBeepCIIBBBC7C7CDGBNHBjDDDBHBMGBqCBBcEC4BNBCEBCBBGKBCjBBKnDnDBCBCFBCBBDBBaBBFCBRDBODDBHHQgWgWBBBzdCBeBBfBBfBBhCBBCGBJDDBJBKuBuBBBBC2D2DBjBjB3DCBFBBKHHBBB8GBBD7B7BCGBCCCDHBHJBDxBxBBMBCeBDLBVDBxBCCBDBCGGpBIBNBBhBDBDBBCCB5BCCBEECCB7BHBDBB5ECBCMBCGBFHHEBBnG-BBxWMBFEEBKB--CCBuEhDhDBeBrRDBsDBB1udFFBIBhBBBxCBBxIEEFaaBGG4EBBbRBOnBnBBGBaKBvBCBxBDDBCBDBBoBkCkCBEBDBBDBBNJJwB0B0BCCBDBBGBBCrBrBBJJvHDDFx5Tx5TiXPBRPBuejHjH2EEBn0BCBCBBGDBpBCBFmFmFB+R+RBCBiCEB+JBBuCFBnCKByBDB8D3B3BBNBqBDDBLLBBByBDBDBBI+B+BBBBlBEBCHB-BNNB1B1BBHBLDBDgDgDBBBDCCBHHD+E+EEHBWBB6BBBEmBmBBFBEEBnCFBOECPBB2CHBDCBCYY1CFBCFFBCCBvHvHBCBHBBCBBcBB2CHBDCCBrDrDCDDBEBCmDmDCDDBCBCEBkIIBCBBhIBBCFFxEDBDBBFhBhBBIBpBFBDDBJKKBEBDCBvBMBCBBnGCCBBBCqGqGBFBCFBCzCzCBUBDGBCBBCBB7DFBECCBCCBFBCpCpCBEEC8K8KBMMB1B1BBDBGCCYmnFmnFHOBpmLLBECBhuCEB8BGB5gBgCgCBCByC5lT5lTBizEizEBsBBDWBhRCBSHBDGBfDB1ECB89B2BBFxBBJPPXEBCOBxqBGBCQBDGBCBBCEBlDhFhFBFB4L+B+BBCB9PDB-HBB0HDDIBBG7O7OBFBuDGB29lYvHB", false)),
        N: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wBJB5DBBGDDBBBitBJBnEJBnGJB9MJB3DJBFFBtDJB3DJB3DJBDFBvDMB0DJBJGBoDJBpDGBISBuDJBhDJB3DJBnCTBtIJBnCJBwWTBybCBwHJBHJBXJBtJJBhEKBmFJBHJB3FJB3CJBnEJBHJB3gBEEBEBHJBnGyBBDEB3W7BBvCVB3TdBqrBqYqYaIBPCB4KDBrEJBfHBCOBhBJBoBOBh7cJB9FJBhKFB7EJBnBJBnGJBXJB3CJB3MJB34UJBuPsBBN4BBSBB2KaBlBDBeJJnEEBrGJBvdHBaGBoBIBsCEBXFBhFBBDPBDtBBhCIB1BBBfCBsCEBpDHBZHBqBGBrKFBxBJBHJB3IeB-EJBrBDBxDGBnEdBhEJB9BJBxEJBITB8HJB3KJB3DJB3LJBnDJBHTBtCLBlNSB+CJB3UJB3CcBkHJBnCJB3BJBnLJBnDUBshBuDBimPJBnpCJB3CJBnEJBCGBvQJBnIWB+KCB6nXJBnuBTBNTBtDYB2iBxBBhqCJBnNJB3PJB4HJBtWIBhEJB4Y6BBCCBCDBtCsBBCOBjeMBk3CJB", false)),
        Nd: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wBJnxBJnEJnGJ9MJ3DJ3DJ3DJ3DJ3DJ3DJ3DJ3DJ3DJhDJ3DJnCJ3IJnCJn6BJnBJtJJhEJnFJHJ3FJ3CJnEJHJnuiBJnVJnBJnGJXJ3CJ3MJ34UJnsBJnkCJHJ9YJhEJ9BJxEJ3IJ3KJ3DJ3LJnDJHTtCJnNJnDJ3UJ3CJ3HJnCJ3BJnLJ3uQJnpCJ3CJnEJ3QJ37XJ12CxBhqCJnNJ3PJ4HJ2aJ30EJ", true)),
        Nl: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("u3FCBwzCiBBDDB-zDaaBHBPCBs1dJBxyW0BBtOJJnEEBrhIuDBm8SCB", false)),
        No: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("yFBBGDDBBB2pCFB5LFB5DCBmEGB6GGBSIByNJB2hBTB0jBJBhP20B20BEFBHJBnGPBqB3W3WB6BBvCVB3TdBqrB1kB1kBBCBrEJBfHBCOBhBJBoBOBxrdFBymWsBBiCDBSBB2KaBlBDB1pBHBaGBoBIBsCEBXFBhFBBDPBDtBBhCIB1BBBfCBsCEBpDHBZHBqBGBrKFBhLeB-EJBrBDBxDGBnETB8LTBmqBBBvNIBobSB0aUBn8SGB-YWBqhZTBNTBtDYBvqFIBid6BBCCBCDBtCsBBCOBjeMB", false)),
        P: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hBCBCFBCDBLBBEBBbCBCccCkBkBGEELBBEEE-VJJzOFBqBBB0BCCDDDtBBBVBBCBBOCCBBBrCDBnDsBsBBMBqHCB3BOBgBmImIBLLtE5D5D6DnMnMNwLwL7CLLBpFpFBNBCmBmBBCBoCrCrCBDBFBBwDFBsFlTlTBHB4EuTuTtBBBvCCBoCBB+ECBCCBmBKB6JBB5GBBhEGBCFBhFBBLGBdCB9DDB8BEB-BBBhCHBM9Z9ZBWBJTBCMBCLBfBBPBB6TDBeBB+hBNBwCBBgBJB0MVBgCDBhBBB8XDBCBBxDwEwEBtBBCfBDLBkNCBFJBDLBRNNjD7C7CjgdBBuICBkDLL0DFB9LDB3CBBpBCBCyByBBwBwBiDMBRBB9DDB-DBBRBB6HzqUzqUBxGxGBIBXiBBCNBCFFCBB2ECBCFBCDBLBBEBBbCBCccCCCBFB7MCB9UxBxB-MoXoXoGgBgBxIIBnBxDxDBFBjCGB6CDByO-J-JjBlElEBDBtBDB+FGBuDBBCDB-DDBxBBBwCDBFOOCCB5CFBsDrJrJBCCBzDzDBDBLBBCpDpD7HWBqDCBdMBtCjEjEBBB9HpIpIBBB8E9C9CBGB0CCBCEB+CJB4GgDgDBDBrBBBmUBBrCMBwFxjBxjBBDB97CBB8zOBBmEiCiCBDBJpRpRBBBoJDBoK9lT9lTovHEB07C-a-aBAB", false)),
        Pc: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("-Cg-Hg-HBUU-u3BBBZCBwHAB", false)),
        Pd: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("tB9qB9qB0BiyDiyDmgBqgCqgCBEBiwDDDgBBBFdd-NUUwDxszBxszBBmBmBLqFqFhzD-J-J", false)),
        Pe: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("pB0B0BgB+1D+1DC-6B-6BqtC4B4BQ7T7TCff-hBMCxChBhBCGC1MUChCCCiBmhBmhBCECtBGCtNICEGCDBB-ozB6G6GeOCESSCCCrF0B0BgBGD", false)),
        Pf: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("7F+6H+6HEddpuDCCFDDQEE", false)),
        Pi: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("rFt7Ht7HDBBDaapuDCCFDDQEE", false)),
        Po: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hBCBCCBDECBLLBEEBcclCGGPBBI-V-VJzOzOBEBqB3B3BDDDtBBBVBBCBBOCCBBBrCDBnDsBsBBMBqHCB3BOBgBmImIBLLtE5D5D6DnMnMNwLwL7CLLBpFpFBNBCxDxDrCEBFBBwDFBsFlTlTBHBmY9D9DBBBoCBB+ECBCCBmBFBCDB6JBB5GBBhEGBCFBhFBBLGBdCB9DDB8BEB-BBBhCHBMjajaBJJBGBJIBDDBDCBEKBCCCBIB7kDDBCBBxDwEwEBFFBBBDDDBHBCBBCDDBLLBDBCJBDDBCCCBLBDCBtNCB6B+F+FjgdBBuICBkDLL0DFB9LDB3CBBpBCBCyByBBwBwBiDMBRBB9DDB-DBBRBB6HlxUlxUBFBDXXVBBDDBECBCDBICBHCCB2E2EBBBCCBDECBLLBEEBcclBDDB7M7MBBB9UxBxB-MoXoXoGgBgBxIIBnBxDxDBFBjCGB6CDB0ZlElEBDBtBDB+FGBuDBBCDB-DDBxBBBwCDBFOOCCB5CFBsDrJrJBCCBzDzDBDBLBBCpDpD7HWBqDCBdMBtCjEjEBBB9HpIpIBBB8E9C9CBGB0CCBCEB+CJB4GgDgDBDBrBBBmUBBrCMBwFxjBxjBBDB97CBB8zOBBmEiCiCBDBJpRpRBBBoJDBoK9lT9lTovHEB07C-a-aBAB", false)),
        Ps: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("oBzBzBgB-1D-1DC-6B-6B-rCEEnB4B4BQ7T7TCff-hBMCxChBhBCGC1MUChCCCiBmhBmhBCECaTTCECtNICEGCDipzBipzB4GeeCMCESSCCCrFzBzBgBEEDAB", false)),
        S: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("kBHHRCBgBCCcCCkBEBCBBDCCBCBDEEfgBgBrODBNNBGGBCCCBPB2DPPBxDxDsErIrIBBB3DCBDDDBvGvGLUUB4H4HIBBpEqLqLBHHB2H2H-DjEjEBGBlEwGwGqBmGmGiGCBQCCBBBDFBVECmEHBCFBCBBGDBmGBBxXJB0WuLuLlL+E+EBgBBiLJBKIBhiBCCBBBMCBOCBOCBOBBmCOOoBCBOCBUhBB-BBBCDBCBBLCCBBBGFBCECFMMBFFBDBGDBC7B7BBFFB2LBFcBD+HBXKByCtCBXnTBtBwBBDeBLyMBX+BBFfBD1LBDpEBmHFBmLBBvBZBC4CBN1GBbPBFOOBNNWBBHBB8CBB0HBBFJBhBlBBKRRBdBMdBJQQBeBLmBBQ-JBhuG-BBx0V2BB6RWBKBBoDBB+EDBLDB+RCBiHPPB+9T+9TpEgBBuLPBhCBB3BHBtBDBjDCCBBBD7E7EHRRBBBgBCCcCCiEGBCGBOBB6JIB6BQBDCBCMBEwBwBBrBB7zBBBwSmWmWBiKiKBGBnjC2kC2kCBbBr6SDBG3qU3qUk7DvHBLCBEzNBHWBQQBgDzDB9B1HBLmBBD7BBGCBXBBIdBF8BBWhCBE7F7FB1CBrbaagBaagBaagBaagBaa9B-PB4BDBzBHBCNBCBBp2BwNwNttCEE+DiOiOBvIvIBqBBFjDBNOBDOBCOBCkBBYgFB5BcBOrBBFIBIBBPFB7E4eBEQBEMBE5GBHLBFQQBKBF3BBJJBHnBBJdBDLBFBBPIBoB3KBJNBDMBEKBE4BBCFFBOBDLBFJBIyEBC7CBLAB", false)),
        Sc: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("kB+D+DBCBqnB8D8DzPBBzPBBI2H2HoImSmS8sClmClmCBgBB37hBkuVkuVtD7E7E8GBBEBB3-HDB-4wBxtCxtC", false)),
        Sk: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("+CCCoCHHFEEqQDBNNBGGBCCCBPB2DPPBjoBjoB15FCCBBBMCBOCBOCBOBB9kEBBkzdWBKBBoDBBxePPBniUniUBPB8bCCjF4g9B4g9BBDB", false)),
        Sm: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("rBRRBBB+BCCuBFFmBgBgB-XwQwQBBB8xGOOoBCBOCBsEoBoBBDBHlClCBDBGBBFGDIgBgBBDDCgBgBBqIBhBBB7CffBXBpBFB2OKK3BHBwDxKxKBDBDeBLPBhIiEBX+BBFfBDhIBxBUBDFB9+zB5Z5ZCCBlFRRBBB+BCCkEHHBCBitDBBhrwBx+Bx+BagBgBagBgBagBgBagBgBat5Ft5FB-uC-uCBHB", false)),
        So: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("mFDDFCCyerIrIBgEgEBvGvGLUUB4H4HkQ2L2LjEFBClElEwGqBqBoMCBQCCBBBDFBVECmEHBCFBCBBGDBmGBBxXJB0WzWzW+EhBBiLJBKIBksBBBCDBCBBLCCBHHBEBCECFMMBPPCBBC7B7BBKKBDBDDBCBBCBBCGBCeBDBBCCCBdBtIHBFTBDGBDwCBCdBanBBHnCBXKByCtCBX2FBCIBC1BBJuDBC3HBtBrBBhC-HBhQvBBWBBHmBBDpEBmHFBmLBBvBZBC4CBN1GBbPBFOOBNNWBBHBBxKBBFJBhBlBBKRRBdBMdBJQQBeBLmBBQ-JBhuG-BBx0V2BBibDBLBBC+R+RBBBqqUPBuLPBhCBB3BHBuBCBlPEEFBBOBB6JIB6BQBDCBCMBEwBwBBrBB7zBBBwSpgBpgBBGBnjC2kC2kCBGBFQBr6SDBG3qU3qUk7DvHBLCBEzNBHWBQPBhDzDB9B1HBLmBBD7BBGCBXBBIdBF8BBWhCBE7F7FB1CBqlB-PB4BDBzBHBCNBCBBp2B96C96CiEyWyWBqBBFjDBNOBDOBCOBCkBBYgFB5BcBOrBBFIBIBBPFB7E6HBG4WBEQBEMBE5GBHLBFQQBKBF3BBJJBHnBBJdBDLBFBB-B3KBJNBDMBEKBE4BBCFFBOBDLBFJBIyEBC7CBLAB", false)),
        Z: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gBgEgEgvFgsCgsCBJBeBBGwBwBh9DAB", false)),
        Zl: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ohIA", true)),
        Zp: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("phIA", true)),
        Zs: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gBgEgEgvFgsCgsCBJBlBwBwBh9DAB", false)),
        ASCII_Hex_Digit: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wBJIFbF", true)),
        Alphabetic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hCZBHZBwBLLFGGBVBCeBCpOBFLBPEBICC3CeeBQBCBBDDBCHHCCBCCCBSBCyCBCqEBJlFBClBBDHHBnBBoBNBCCCBCCBCCJaBFDBeKBG3BBCGBPlDBCHBFHBFCBLCBDRRBuBBOkDBZgBBKBBFGGBWBDSBUYBIKBGXBCGBIJJBoBBLLBEGBHrCBCPBCCBFOBOSBCHBDBBDVBCGBCEEBCBEHBDBBDBBCJJFBBCEBNBBLFFBBBCFBFBBDVBCGBCBBCBBCBBFEBFBBDBBFIIBCBCSSBEBMCBCIBCCBCVBCGBCBBCEBEIBCCBCBBEQQBCBWDBFCBCHBDBBDVBCGBCBBCEBEHBDBBDBBKBBFBBCEBORRBCCBEBECBCDBEBBCCCBEEBEEBBBELBFEBECBCCBEHHpBMBCCBCWBCPBEHBCCBCCBJBBCCBCBBDDBdDBCHBCCBCWBCJBCEBEHBCCBCCBJBBGCBCDBOCBNMBCCBCoBBDHBCCBCCBCGGBCBIEBXFBCCBCRBEXBCIBCDDBFBJFBCCCBGBTBBO5BBGGBH0B0BBECBDBCXBCCCBRBCCBDEBCHHPDBhBgCgCBGBCjBBFSBFPBCjBBkC2BBCDDBDBR-BBLDBDlBBCGGDqBBCsKBCDBDGBCCCBCBDoBBCDBDgBBCDBDGBCCCBCBDOBC4BBCDBDiCBmBPBR1CBDFBErTBDQBCZBGqCBEKBITBMUBNTBNMBCCBCBBNzBBDSBPFFkC4CBIqBBGlCBLeBCLBFIBYdBDEBMrBBFZB3BbBF+BBDTBzBYYBMMBBByBzBBCOBCHB0BpBBDDBLrBBCKBP2BBXCBLjBBDKBGqBBDCBqBDBCFBCBBEGGB+FBUhBBM1IBDFBDlBBDFBDHBCGCBdBD0BBCGBCEEBBBCGBEDBDFBFMBGCBCGB1DOORMBmDFFDJBCEEBDBHGCBCBCKBDDBGEBFSSBnBBuZzBB34BkHBHDBEBBNlBBCGGD3BBIRRBVBKGBCGBCGBCGBCGBCGBCGBCGBCfBwB2O2OBBBaIBIEBDEBF1CBHCBC5CBCDBGqBBC9CBSfBxBPBhQ-tGBhCs0VBkCtBBDsIBEPBLBBVuBBGHBEwDBoBIBDmDBDxCBVUBCgBBZzBBNjCBCtBtBBEBECCBBBLgBBGiBBOcBEyBBCLBQRRBOBLEBC2BBKNBTWBEkCBCCCZCBDPBDDBMFBDFBDFBKGBCGBCqBBCNBH6DBWj9KBNWBFwBBloItLBDpDBnBGBNEBGLBCMBCEBCCCBCCBCCBqDBiBqLBT-BBD1BBpBLB1DEBCmEBlBZBHZBM4CBEFBDFBDFBDCBkBLBCZBCSBCBBCOBDNBjB6DBmC0BBsIcBEwBBwBfBOdBGqBBGdBDjBBFHBCEBrB9EBTjBBFjBBFnBBJzBBNKBCOBCGBCBBCKBCOBCGBCBBEzBBN2JBKVBLHBZFBCpBBCIBmCFBDCCBqBBCBBEDDBVBLWBKeBiCSBCBBLVBLZBHZBnB3BBHBBhCDBCBBGHBCCBCcBrBcBEcBkBHBCbBc1BBLVBLSBORBvDoCB4ByBBOyBBOnBBjBbBEGGBVB7HpBBCBBEBBRFBzBCBEcBLJJBUBrBRBvBUBcWBKlCBsBEBL4BBKOOBXBYyBBSDBJiBBEKKB+BBCDBKBBLCCkBRBChBBDHHBCB-BGBCCCBCBCOBCJBI4BBYDBCHBDBBDVBCGBCBBCEBEHBDBBDBBEHHGGBdJBCDDClBBCJBCDDCDBCBBECCtBhCBCCBCDBVCBfhCBDBBC5F5FB0BBDGBaFBjB+BBCEE8B1BBDoCoCBZBDNBWGB6F4BBoD-BBgBHBDDDBGBCBBCdBCBBDBBDDB+CHBDtBBDFBCCCBccBxBBDJBSnCBGTTBnCBoDHB5CgBBgBIBCsBBCGBCyByBBcBDVBCNBqCGBCBBCrBBECCBCCBBBCDDBZZBEBCBBCkBBCBBCDBCYYBqBBlIWBKQBCoBBECBwDwCwCB4cBnDuDBSjGBtyCgDBQvhBBSFBa68DBGmSB61GuBBy2B4RBIeBSuCBSdBTvBBRDBgBUBGSBxNsBB0G-BBhBYBDYBtBqCBF4BBIQBhCBBCNNBFBK1mHBqBfBiDyDB+vIDBCGBCBBCiJBQeeBBBDPPBCBJrMBloCqDBGMBEIBIJBFi7Fi7FBzCBCmCBCBBDDDBDDBCBCLBCCCBFBCgCBCDBDHBCGBCbBCDBCEBCEEBFBCzKBDYBCYBCeBCYBCeBCYBCeBCYBCeBCYBCHB15BeBHFB2GGBCQBDGBCBBCEBG9BBiBxDxDBrBBLGBRiKiKBcBTrBBlPbBlHdBDwGwGBdBCVBJBBhHGBCDBCBBCOBCkGB8BjCBEEE1lBDBCaBCBBCDDCJBCDBCCCHFFCECBBBCBBCDDCICBCCDDBCGBCDBCDBCCCBIBCQBGCBCEBCQB1TZBHZBHZB3zD-2pBBhB9oEBDt0FBDwpHBQtTBjtC9QBjvBq6EBGppIB", false)),
        Dash: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("tB9qB9qB0BiyDiyDmgBqgCqgCBEB+BoBoBQnMnMlgDDDgBBBFdd-NUUwDxszBxszBBmBmBLqFqFhzD-J-J", false)),
        Emoji: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("jBHHGJBwDFFu8HNN5GXX7CFBQBBwLBBNnFnFaKBFCBoGoHoHBLLK7B7BBCBCEBKGDBDDFDDCBBDIEBJJBBBGCCGLBMBBDCCBCCTDDBTTBEBCCCBEEBGGDBBFBBMBBGBBDGGBECBVVBGGBEBCDBDFFDDDBEBCDDCCCHEEHLLBQQDFFCFFBBBCMMBxBxBBBBKeP1LBBwOCBUBB0BFF7mBNN6SCCrrvDrGrGhFBBNBBPDDBIBsCZBCBBYVVDIBWBBvFhBBDvDBDBBCCBDyCBDCBCmIBC+BBMFBCXBIBBDHBNDDBCBDFFBOOBDDJBBKGGBBBNCBJCBDCCFHHEHHB0CBxBlCBGHBDDBEJBECCBEEDJBkHLBF8I8IBtBBCJBC4FBxDMBEKBE4BBCFFBOBDLBFJB", false)),
        Emoji_Component: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("jBHHGJB0+H2G2Gsp3B3+8B3+8BBYB8PEBxtBDBtzhY-CB", false)),
        Emoji_Modifier: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("7-8DE", true)),
        Emoji_Modifier_Base: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("9wJ8G8GRDB4jzD9B9BBBBDDDBBB2DBBDKBWSBEFFBBBCCBICCZqGqGBFFWFFBvFvFBBBEEB0CRRBBBKMMgSDDJHBHKKBIBDCB5B+B+BBCCBCCSCBCMBmHCBrBIB", false)),
        Emoji_Presentation: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("64IBBuGDBEDDqQBBWBBzBLBsBUUOJJBSSBGGBJJGWWIBBCFFDIIFBBdkBkBCFFBBBC+B+BBBBZPP8aBB0BFFvlxDrGrG-FDDBIBsCZBCZZVDDBDBCCBWBBvFgBBNIBClCBCVBNqBBFEBNQBEEEBlCBCCCB5FBD+BBODBCXBTbbBOO3C0CBxBlCBHEEBBBDDBEDBMBBIIBkHLBF8I8IBtBBCJBC4FBxDMBEKBE4BBCFFBOBDLBFJB", false)),
        Extended_Pictographic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("pFFFu8HNN5GXX7CFBQBBwLBBNnFnFaKBFCBoGoHoHBLLK7B7BBCBCEBKGDBDDFDDCBBDIEBJJBBBGCCGLBMBBDCCBCCTDDBTTBEBCCCBEEBGGDBBFBBMBBGBBDGGBECBVVBGGBEBCDBDFFDDDBEBCDDCCCHEEHLLBQQDFFCFFBBBCMMBxBxBBBBKeP1LBBwOCBUBB0BFF7mBNN6SCCrrvDoBoBBCBlDLBQBBQPPBmBmBBIBxDBBNBBPDDBIBU3BBcOBLVVDIBCDBKWBH7FBDvDBDBBCCBDyCBDCBCDBG9HBC+BBMFBCXBIBBDHBNDDBCBDFFBOOBDDJBBKGGBBBNCBJCBDCCFHHEHHB0CBxBlCBGHBDQBECCBEBDMB7GlBBNDB5BHBLFBpBHBfBBNDBDNBKmBBNuBBCJBC4FB5CHBPxEBhI9fB", false)),
        Hex_Digit: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wBJIFbFq1-BJIFbF", true)),
        Lowercase: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hDZBwBLLFlBlBBWBCHBC2BCBQCBuBCDECBBBDCCDEEBFFDEEBBBDDDCCCDCCBCCDEECDDBDDBBBHGDCOCBSCBDDCEEC4BCBFBDDDBCCFICBjCBDiBBIBBfEBhDsBsBCEEDDBTccBhBBCBBECBCWCBDBCGDB0B0BBuBBCgBCK0BCDMCBgDCxBoBBo6CqBBCDB5XFBjkCIBC2D2DB+FBiC0ECBHBCgDCBHBJFBLHBJHBJFBLHBJHBJNBDHBJHBJHBJEBCBBHEEBBBCBBJDBDBBJHBLCBCBB6DOORMBuDEEBEEcKFDBBJDBFiBiBBOBFsasaBYBn6BvBBCEEBGCFCCBCCBGBEiDCBIICFFNlBBCGG0oesBCUaCBBBmEMCBBBC8BCBIBCCCDICFCCDCCBBBCSCGGGCMCFCCDOCWDBCCCBBB2ZqBBCNBHvCBh6TGBNEBqhBZBumBnBBpEjBB8EKBCOBCGBCBBkODDBBBCpBBCIBmoByBB+DVB75CfBhsVfB8BYBnqZZBbGBCRBbZBbDBCCCBFBCKBbZBbZBbZBbZBbZBbZBbZBbZBbbBdYBCFBbYBCFBbYBCFBbYBCFBbYBCFBC15B15BBIBCTBHFBmI9BB1lChBB", false)),
        Math: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("rBRRBBBgBeeCuBuBFmBmBgB5W5WBBBDbbBDDBBBwQCBuwGccBBBMEEOPPBCBWEBMEBiCMBFEEBFFBDBTFFDJBCDDBEBHEEBDDBCCBBBCFBENBClClCBWBCFBCBBFBBFfBCHHBPPBqIBJDBVBB7CffBZBCZZMGB+NBBNJBFFBFBBDBBEEBPCCDFBMHBGBB6BCCeDBKCBxK-BBhI-PBxBUBDFB9+zB4Z4ZBEBCjFjFRCBeCCeCCkEHHBCBitDBBhrwBwoBwoBBzCBCmCBCBBDDDBDDBCBCLBCCCBFBCgCBCDBDHBCGBCbBCDBCEBCEEBFBCzKBDjJBDxBBhwFDBCaBCBBCDDCJBCDBCCCHFFCECBBBCBBCDDCICBCCDDBCGBCDBCDBCCCBIBCQBGCBCEBCQB1BBB-uCIB", false)),
        Quotation_Mark: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("iBFFkEQQ96HHBaBBowDqOqOBCBOCBixzBDB+FFF7CBB", false)),
        Terminal_Punctuation: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hBLLCMMBEE-ZJJiQ6B6BpCPPCCB1FsBsBBJBCsHsHB3B3BBEBCHBgBmImIB1nB1nBBtFtFFFB4JBB2YHBmY9D9DBBBoCBB+ECBEoBoBBCBDBB7JBBjLDBjFBBLBBCCBeCB8FEB-BBBldYYBKKBBBwlDCBzJOOFLLCBBEBBtNBB8ndBBuICBkHEB-LBB3CBBgD4E4EBBB0ECBgERRB6H6HnxUDDB6B6BBBBCDBqFLLCMMBEEiCDD7hBxBxBnkBoGoG3JBB5EFBlCFB6CDB5dEBtBDB+FGBxDDBgECBiEBBHRRB5C5CBDBtDrJrJB2D2DBBBNBBnLDBEOBqDBB6HCBmQCC8HBB4CBBFBB-MCBuBmUmUBrCrCBspBspBBDB6vRBBmEiCiCBBBLqRqRBoJoJBnwTnwTovHDB", false)),
        Uppercase: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hCZBmDWBCGBiB2BCDOCDuBCBECEBBCCCBCCBBBDDBCBBCCBEBBCBBCECBCCDCCBCCBBBCCCBEEIJDCMCDQCDDDCCBC4BCIBBCBBDCCBCBCGCiJCCEJJHCCBBBCCCBCCBPBCIBkBDDBBBEWCGDDCBBDyBBxBgBCK2BCBMCD+CCDlBBq6ClBBCGGzW1CB0kCHHBpBBDCBhK0ECKgDCKHBJFBLHBJHBJFBMGCJHBpCDBNDBNDBNEBMDBnIFFECBDCBDEEBDBHGCBCBDDBLBBGbbBOBUzZzZBYBx5BvBBxBCCBBBDGCBCBCDDJCBCgDCJCCFuqeuqeCqBCUaCoEMCE8BCLECBICFCCDCCEUCBDBCEBCOCBCBCCCBQCZs5Vs5VBYBmmBnBBpEjBB9EKBCOBCGBCBBr3ByBB+EVB75CfBhsVfBhCYBoqZZBbZBbZBbCCBGDBDDBCBCHBbZBbBBCDBDHBCGBcBBCDBCEBCEEBFBcZBbZBbZBbZBbZBbZBfYBiBYBiBYBiBYBiBYBiB2pE2pEBgBBvgCZBHZBHZB", false)),
        White_Space: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("JEBTlDlDbgvFgvFgsCKBeBBGwBwBh9DAB", false))
    });
    static get Upper() {
        return this.CATEGORIES.get("Lu");
    }
    static SCRIPTS = new $394755e62edee9eb$var$LazyMap({
        Adlam: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("go6DrCFJFB", true)),
        Ahom: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g4lCaDOFW", true)),
        Anatolian_Hieroglyphs: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggxCmS", true)),
        Arabic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gwBEBCFBCNBCCBCfBCJBMZBCrDBChBBxCvBBxHhBBGqCBCcBxy8BtPBDvEBhBPBxDEBCmEBk7DeBkCFBJIBiBFBh43BDBCaBCBBCDDCJBCDBCCCHFFCECBBBCBBCDDCICBCCDDBCGBCDBCDBCCCBIBCQBGCBCEBCQB1BBB", false)),
        Armenian: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("xpBlBDxBDCks9BE", true)),
        Avestan: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g4iC1BEG", true)),
        Balinese: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g4GsCCxB", true)),
        Bamum: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g1pB3CpowB4R", true)),
        Bassa_Vah: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("w26CdDF", true)),
        Batak: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g+GzBJD", true)),
        Bengali: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gsCDBCHBDBBDVBCGBCEEBCBDIBDBBDDBJFFBCCBDBDYB", false)),
        Beria_Erfe: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g17CYDY", true)),
        Bhaiksuki: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggnCICsBCNLc", true)),
        Bopomofo: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("qXB6wLqBxDf", true)),
        Brahmi: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggkCtCFjBKA", true)),
        Braille: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggK-H", true)),
        Buginese: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gwGbDB", true)),
        Buhid: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g6FT", true)),
        Canadian_Aboriginal: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggF-TxRlC7tgCP", true)),
        Carian: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g1gCwB", true)),
        Caucasian_Albanian: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wphCzBMA", true)),
        Chakma: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gokC0BCR", true)),
        Cham: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gwqB2BKNDJDD", true)),
        Cherokee: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g9E1CDFz7lBvC", true)),
        Chorasmian: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("w9jCb", true)),
        Common: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("AgCBbFBbuBBCOBCEBYgBgBiOmBBGEBDTB1DKKHCC+THHPEEhB9E9ElQiEiEB6mB6mB2MDBjJwvBwvBBBBoCBBsGBBCumBumBOIIBCBCFBCCBDmYmYBKBD2CBCKBEKBCOBShBB-BlBBCCBDFBCaBCQBqBCBF5UBXKBW-cBhIzTBDpEBhQ9CBzMUBCCCBXBQHBFDB8CBBE7C7CB0E0EBOBhBlBBKxBxBB+BBgBwCBwB5C5CBmFBhuG-BBhoWhBBnDCBmFJB1HhFhFsMPPBzuUzuUBxGxGBIBXiBBCSBCDB0ECCBeBbFBbKBLuBuBBhChCBFBCGBLEBjICBFsBBEIBxCMB0BsBBlHaBltuBDB96D8HBEzNBHWBQQBgDzDB9B1HBLmBBD9BBEQBJBBIdBF8BB2GTBNTBN2CBKYBoE0CBCmCBCBBDDDBDDBCBCLBCCCBFBCgCBCDBDHBCGBCbBCDBCEBCEEBFBCzKBDjJBDxBByjFjCBtC8BBjWrBBFjDBNOBDOBCOBCkBBLtFB5BZBCBBOrBBFIBIBBPFB7E4eBEQBEMBE5GBHLBFQQBKBF3BBJJBHnBBJdBDLBFBBPIBoB3KBJNBDMBEKBE4BBCFFBOBDLBFJBIyEBCmDBnghYffB+CB", false)),
        Coptic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ifNxkKzDGG", true)),
        Cuneiform: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggoC5cnDuDCEMjG", true)),
        Cypriot: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggiCFBDCCBqBBCBBEDD", false)),
        Cypro_Minoan: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("w8rCiD", true)),
        Cyrillic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggBkEBDoFBx6FKBhFtCtCojEfBhie-CBv8VBBhw4B9BBiBAB", false)),
        Deseret: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gghCvC", true)),
        Devanagari: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("goCwCFODZh7nBfhwcJ", true)),
        Dives_Akuru: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gomCGBDDDBGBCBBCdBCBBDLBKJB", false)),
        Dogra: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggmC7B", true)),
        Duployan: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggvDqDGMEIIJDD", true)),
        Egyptian_Hieroglyphs: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggsC1iBL68D", true)),
        Elbasan: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gohCnB", true)),
        Elymaic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g-jCW", true)),
        Ethiopic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gwEoCBCDBDGBCCCBCBDoBBCDBDgBBCDBDGBCCCBCBDOBC4BBCDBDiCBDfBEZBnvGWBKGBCGBCGBCGBCGBCGBCGBCGBjpfFBDFBDFBKGBCGBylvCGBCDBCBBCOB", false)),
        Garay: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gqjClBEcJB", true)),
        Georgian: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("glElBBCGGDqBBCDBx8CqBBDCBhiElBBCGG", false)),
        Glagolitic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggL-Ch9sDGCQDGCBCE", true)),
        Gothic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("w5gCa", true)),
        Grantha: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g4kCDBCHBDBBDVBCGBCBBCEBDIBDBBDCBDHHGGBDGBEEB", false)),
        Greek: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wbDBCCBDDBCFFCCCBBBCCCBSBC+BBPPBnpGEBzBEBFEB1ChKhKBUBDFBDlBBDFBDHBCGCBdBD0BBCOBCNBDFBCSBDCBCIBoJ-xiB-xiB7uVuCBSgj0Bgj0BBkCB", false)),
        Gujarati: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("h0CCBCIBCCBCVBCGBCBBCEBDJBCCBCCBDQQBCBDLBIGB", false)),
        Gunjala_Gondi: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("grnCFCBCkBCBCFIJ", true)),
        Gurmukhi: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hwCCBCFBFBBDVBCGBCBBCBBCBBDCCBDBFBBDCBEIIBCBCIIBPB", false)),
        Gurung_Khema: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("go4C5B", true)),
        Han: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g0LZBC4CBN1GBwBCCaIBPDBle-tGBhC-vUBhoWtLBDpDBpodBBNGBqgkB-2pBBhB9oEBDt0FBDwpHBQtTBjtC9QBjvBq6EBGppIB", false)),
        Hangul: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("goE-HvxHBiI9CyDeiCei3dckUj9KNWFwBl9JeEFDFDFDC", true)),
        Hanifi_Rohingya: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gojCnBJJ", true)),
        Hanunoo: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g5FU", true)),
        Hatran: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gniCSCBGE", true)),
        Hebrew: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("xsB2BBJaBFFBpp9BZBCEBCCCBCCBCCBIB", false)),
        Hiragana: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hiM1CBHCBi7-C+IBTeeBBBulQAB", false)),
        Imperial_Aramaic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("giiCVCI", true)),
        Inherited: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gYvDB2IBBlOKBbhXhXBCB8qEtBBDLBlPCBCMBCGBFHHEBBnG-BBtQBBjGgBB65DDBsDBBmrzBPBRNBwejHjH7iEl+uBl+uBBsBBDWBhRCBSHBDGBfDBz6rYvHB", false)),
        Inscriptional_Pahlavi: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g7iCSGH", true)),
        Inscriptional_Parthian: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g6iCVDH", true)),
        Javanese: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gsqBtCDJFB", true)),
        Kaithi: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gkkCiCLA", true)),
        Kannada: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gkDMCCCWCJCEDICCCDIBGCCDDJCC", true)),
        Katakana: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hlM5CBDCBxHPBxGuBBC3CBvgzBJBCsBBzisBDBCGBCBBCgJgJBBBzBPPBCB", false)),
        Kawi: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g4nCQCoBEc", true)),
        Kayah_Li: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("goqBtBCA", true)),
        Kharoshthi: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gwiCDCBGHCCCcDCFJII", true)),
        Khitan_Small_Script: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("k-7C84G84GB0OBqBAB", false)),
        Khmer: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g8F9CDJHJnPf", true)),
        Khojki: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gwkCRCuB", true)),
        Khudawadi: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("w1kC6BGJ", true)),
        Kirat_Rai: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gq7C5B", true)),
        Lao: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("h0DBBCCCBDBCXBCCCBVBDEBCCCBFBCJBDDB", false)),
        Latin: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hCZBHZBwBQQGWBCeBCgOBoBEB8wGlBBHwBBGDBGMBClCBiC-HByLOORMBuEBBHccSoBB42CfBj1elDBExCBVOBxZqBBCIBCDB38TGB7gBZBHZBmhCFBCpBBCIBm61BeBHFB", false)),
        Lepcha: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggH3BEOEC", true)),
        Limbu: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("goGeBCLBFLBFEEBKB", false)),
        Linear_A: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gwhC2JKVLH", true)),
        Linear_B: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gggCLCZCSCBCODNjB6D", true)),
        Lisu: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wmpBvBx1eA", true)),
        Lycian: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g0gCc", true)),
        Lydian: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gpiCZGA", true)),
        Mahajani: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wqkCmB", true)),
        Makasar: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g3nCY", true)),
        Malayalam: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("goDMCCCyBCCCFFPDZ", true)),
        Mandaic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("giCbDA", true)),
        Manichaean: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g2iCmBFL", true)),
        Marchen: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wjnCfDVCN", true)),
        Masaram_Gondi: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gonCGBCBBCrBBECCBCCBHBJJB", false)),
        Medefaidrin: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gy7C6C", true)),
        Meetei_Mayek: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g3qBWqGtBDJ", true)),
        Mende_Kikakui: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gg6DkGDP", true)),
        Meroitic_Cursive: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gtiCXFTDtB", true)),
        Meroitic_Hieroglyphs: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gsiCf", true)),
        Miao: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g47CqCF4BIQ", true)),
        Modi: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gwlCkCMJ", true)),
        Mongolian: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggGBBDCCBSBH4CBIqBB2t-BMB", false)),
        Mro: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gy6CeCJFB", true)),
        Multani: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g0kCGBCCCBCBCOBCKB", false)),
        Myanmar: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggE-EhqmBeiDfxibT", true)),
        Nabataean: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gkiCeJI", true)),
        Nag_Mundari: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wm5DpB", true)),
        Nandinagari: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gtmCHDtBDK", true)),
        New_Tai_Lue: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gsGrBFZHKEB", true)),
        Newa: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gglC7CCE", true)),
        Nko: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g+B6BDC", true)),
        Nushu: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("h-7CvsQvsQBqMB", false)),
        Nyiakeng_Puachue_Hmong: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("go4DsBENDJFB", true)),
        Ogham: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g0Fc", true)),
        Ol_Chiki: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wiHvB", true)),
        Ol_Onal: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wu5DqBFA", true)),
        Old_Hungarian: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gkjCyBOyBIF", true)),
        Old_Italic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g4gCjBKC", true)),
        Old_North_Arabian: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g0iCf", true)),
        Old_Permic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("w6gCqB", true)),
        Old_Persian: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g9gCjBFN", true)),
        Old_Sogdian: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g4jCnB", true)),
        Old_South_Arabian: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gziCf", true)),
        Old_Turkic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggjCoC", true)),
        Old_Uyghur: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("w7jCZ", true)),
        Oriya: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("h4CCCHDBDVCGCBCEDIDBDCICFBCEDR", true)),
        Osage: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wlhCjBFjB", true)),
        Osmanya: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gkhCdDJ", true)),
        Pahawh_Hmong: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g46ClCLJCGCUGS", true)),
        Palmyrene: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gjiCf", true)),
        Pau_Cin_Hau: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g2mC4B", true)),
        Phags_Pa: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("giqB3B", true)),
        Phoenician: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("goiCbEA", true)),
        Psalter_Pahlavi: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g8iCRIDNG", true)),
        Rejang: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wpqBjBMA", true)),
        Runic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g1FqCEK", true)),
        Samaritan: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggCtBDO", true)),
        Saurashtra: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gkqBlCJL", true)),
        Sharada: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gskC-ChsCH", true)),
        Shavian: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wihCvB", true)),
        Siddham: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gslC1BDlB", true)),
        Sidetic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gqiCZ", true)),
        SignWriting: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gg2DrUQECO", true)),
        Sinhala: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hsDCBCRBEXBCIBCDDBFBEFFBEBCCCBGBHJBDCBt-gCTB", false)),
        Sogdian: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("w5jCpB", true)),
        Sora_Sompeng: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wmkCYIJ", true)),
        Soyombo: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wymCyC", true)),
        Sundanese: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g8G-BhIH", true)),
        Sunuwar: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g+mChBPJ", true)),
        Syloti_Nagri: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggqBsB", true)),
        Syriac: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g4BNC7BDCxIK", true)),
        Tagalog: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g4FVKA", true)),
        Tagbanwa: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g7FMCCCB", true)),
        Tai_Le: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wqGdDE", true)),
        Tai_Tham: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gxG+BCcDKHJHN", true)),
        Tai_Viet: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g0qBiCZE", true)),
        Tai_Yo: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g25DeCVJB", true)),
        Takri: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g0lC5BHJ", true)),
        Tamil: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("i8CBBCFBECBCDBEBBCCCBEEBEEBBBELBFEBECBCDBDHHPUBm+kCxBBOAB", false)),
        Tangsa: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wz6CuCCJ", true)),
        Tangut: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g-7CgBgBB+3GBhQeBiDyDB", false)),
        Telugu: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggDMCCCWCPDICCCDIBCCCBDDDJII", true)),
        Thaana: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g8BxB", true)),
        Thai: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hwD5BGb", true)),
        Tibetan: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g4DnCCjBFmBCjBCOCGFB", true)),
        Tifinagh: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wpL3BIBPA", true)),
        Tirhuta: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gklCnCJJ", true)),
        Todhri: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("guhCzB", true)),
        Tolong_Siki: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wtnCrBFJ", true)),
        Toto: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("w04De", true)),
        Tulu_Tigalari: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g8kCJBCDDClBBCJBCDDCDBCJBCBBJBB", false)),
        Ugaritic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g8gCdCA", true)),
        Unknown: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("4bBBHDBICCVuMuMnBBBzBBBE4B4BBGBcDBHKBvI9B9BBmDmDBMB8BBByBBBQddBCCMEBjBEBuHJJBDDBXXICCBBBFBBKBBDBBFHBCDBDGGBaaBEEHDBDBBXIIDGDBCCGDBDBBECBCGBFCCBFBSJBEKKEXXIDDGBBLIEBCCBNBFBBNGBIEEJBBDBBXIIDGGBKKBDDBEEBFBEDBDGGBTTBIBDHHBBBEFFBBBDCCDCBDCBECBNDBGCBEFFBCCBEBCNBWEBOEEYRRBKKEFFBFBDEEDBBFBBLGBXEEYLLGBBKEEFGBDEBEFFBLLELBOEE0BEEHDBRBBbEETCBZKKCBBICBCDBHCCJFBLBBELB7BDBekBBDCCGZZCYYBGGCIILBBFfBpClBlBBCBoBlBlBQOOBjBBnGCCBDBCBB6LFFBIICFFBqBqBFBBiBFFBIICFFBQQ6BFFBkCkCBhBhBBBBbFB3CBBHBB+UCB6CGBXIBZIBVLBOEEDLB-CBBLFBLFBbFB6CGBsBEBnCJBgBNNBCBNDBCCBrBBBGKBtBDBbFBMCB-BBBiCeeBMMBEBLFBPBBvBBBNTBuCnFnFBGB9BCBQCB-BEBsBBBMHBsBEB3QBBHBBnBBBHBBJGCgBBB2BQQPBBHUUBEEKmDmDNBBcOOBBBjBNBiBOBtEDB7UVBMUB14BBB-LEBuBCCBDBCBB5BGBDNBZIBI4BI-DhBBb6C6CBKB3GZBxC3C3CBoDoDBDBsB-C-C3CIBxBuzcuzcBBB4BIB9KTB5FHB+GTB9BCBLFB5BHBnCHBNFB1DKBfCBvCMMBCBiB4B4BBHBPBBLBBoDXBdJBHBBHBBHIBIII9BDB-DBBLFBl9KLBYDByBjoIBvLBBrDlBBILBGEBbGGCGDrUfBrBFB0BUUFDBGoEoEBCC-FCBHBBHBBHBBECBIIIBIBGBBNbbUDDQBBPhBB8DEBEDBuBCB5COOBBBCuBBvBhEBeCByBOBdDBlBIBfEBsBEBfmBmBBCBPpBB-EBBLFBlBDBlBDBpBHB1BKBNQQIDDMQQIDDBBB1BLB4JIBXJBJXBHrBrBKkCBHBBCtBtBDCBCBBYpCpCBGBKvBBUDDBDBiBCBcEBclBB5BDBVBBzBDDBDBJEEeBBEDBLGBKGBhCfBoBDBNIB3BCBeBBcEBbGBFLBIvCBqC2BB0BMB0BGBvBHBLFBnBCBeHBDvGBgBrBrBEBBDPBHHBKgBBvBHBrBVBblBBdTBYIBvCDBlBIBlCJBCBBaGBLFB2BTTBGBoBIBhDVVBJBTwBwBB8BBICCFQQMFB8BEBLFBFJJBDDBXXIDDGLLBDDBEEBCCBEBCEBIBBICBGKBLCCBCCnBLLCBBCFFLDDBGBDcB9CGGBcBpCHBLlFB3BBBnBhBBmCKBLFBOSB7BFBLFBVbBcBBQDBY4FB9BjDB0CLBJBBCBBJDDfDDBNNBHBLlCBJBBvBBBMaBpCHB0CMBqCGBL1CBJ3CBjBNBLFBKuBuBPJBeCBhBBBXPPBnCBIDDtBCBCDDKHBLFBHDDmBDDHGBLFBtBDBL1HBaGBSqBqBBBBe0CBCOBzBMB8clDBwDGGBJBlGryCBkDMB3iBJB88DEBoS41GB7Bl2BB6RGBgBLLBCByCLLBEBfBBHJBnCJBLIIWEBUvNB7BlGB8CEBaBBarBBsCDB6BGBS-BBGKBIIB3mHoBBhBgDB0D8vIBFIIDkJkJBNBCcBEBBCNBFHBtMjoCBsDEBOCBKGBLBBJ76DB+HCB1NFBYOBSOBvBBBYIB1D7BB3HJBoBBBjGUBnC5DBVLBVLB4CIBamEB2CoCoCDBBCBBDBBFNNCIIiCFFBJJIddFGGCCBI1K1KBlJlJB-V-VBNBGQQBuiBBgBFBH0GBISSBIIDGGBDB-BgBBCvDBuBCBPBBLDBD-JBgBQB7BEBCvOBrB1GBsBDBC-FBgBXXBGBD-GBIFFDQQmGBBRoBBtCDBLDBDwYBlCrCB+BhGBFccDCCBCCLFFCCCBEBCDBCECEDDCBBCICDCCBFFIKFCLLSEBEGGSzBBDtIBtBDBlDLBQBBQQQmBJBvF3BBeMBtBDBKGBDNBH5EB6eCBSCBOCB7GFBNDBCOBNDB5BHBLFBpBHBfBBNDBDNBKmBB5KHBPBBOCBMCB6BCCBCBRBBNDBLGB0EoDoDBjgBBh3pBfB-oEBBv0FBBypHOBvThtCB-QhvBBs6EEBrpIm8yVBCdBhD-DBxHvw-FB", false)),
        Vai: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gopBrJ", true)),
        Vithkuqi: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("wrhCKCOCGCBCKCOCGCB", true)),
        Wancho: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g24D5BGA", true)),
        Warang_Citi: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("glmCyCNA", true)),
        Yezidi: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("g0jCpBCCDB", true)),
        Yi: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ggoBskBE2B", true)),
        Zanabazar_Square: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("gwmCnC", true))
    });
    static FOLD_CATEGORIES = new $394755e62edee9eb$var$LazyMap({
        L: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("laA", true)),
        LC: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("laA", true)),
        Ll: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hCZBmDWBCGBiBuBCEECDOCDuBCBECEBBCCCBCCBBBDDBCBBCCBEBBCBBCECBCCDCCBCCBBBCCCBEEIBBCBBCBBCOCDQCDBBCCCBBBC4BCIBBCBBDCCBCBCGC3HrBrBCEEJHHCCBCCCBCCBPBCIBkBJJCUCGDDCBBDyBBxBgBCK2BCBMCD+CCDlBBq6ClBBCGGzW1CB0kCHHBpBBDCBhK0ECKgDCKHBJFBLHBJHBJFBMGCJHBZHBJHBJHBJEBMEBMDBNEBMEBqJEEBHHxC9zC9zCBuBBxBCCBBBDGCBCBCDDJCBCgDCJCCFuqeuqeCqBCUaCoEMCE8BCLECBICFCCDCCEUCBDBCEBCOCBCBCCCBQCZs5Vs5VBYBmmBnBBpEjBB9EKBCOBCGBCBBr3ByBB+EVB75CfBhsVfBhCYBoyehBB", false)),
        Lt: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("kOCCBCCBCClBCCtsHHBJHBJHBMQQwBAB", false)),
        Lu: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hDZB7BqBqBBWBCHBCuBCEECDOCDsBCDECBBBDCCDEEGDDECBDDDCCCDFFDEECDDECCGBBCBBCBBCOCBSCDBBCEECkBCEQCJDDBCCFICBEBCBBCCCBEEBCCBCBCEBDCCBDDIDDCBBEFBGLLBnFnFsBCCEEEBBBvBDBCdBCBBECBCWCBDBCGD1BvBBCgBCK0BCDMCBgDCyBlBBq6CqBBDCB5XFBjkCIBCvHvHERRzD0ECGGGC8CCBHBJFBLHBJHBJFBMGCJHBJNBzBBBNSSBPPBEEpL2B2Bs1CvBBCEEBGCHDDLiDCJCCFNNBkBBCGG0oesBCUaCoEMCE8BCLCCDICFFFCBBDSCMOCFCCDOCb9a9advCBi8UZBumBnBBpEjBB8EKBCOBCGBCBBk4ByBB+DVB75CfBhsVfB8BYBvyehBB", false)),
        M: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("5cgBgBlgHAB", false)),
        Mn: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("5cgBgBlgHAB", false)),
        Emoji: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("8mJA", true)),
        Extended_Pictographic: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("8mJA", true)),
        Lowercase: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hCZBmDWBCGBiBuBCEECDOCDuBCBECEBBCCCBCCBBBDDBCBBCCBEBBCBBCECBCCDCCBCCBBBCCCBEEIBBCBBCBBCOCDQCDBBCCCBBBC4BCIBBCBBDCCBCBCGCiJCCEJJHCCBBBCCCBCCBPBCIBkBJJCUCGDDCBBDyBBxBgBCK2BCBMCD+CCDlBBq6ClBBCGGzW1CB0kCHHBpBBDCBhK0ECKgDCKHBJFBLHBJHBJFBMGCJHBZHBJHBJHBJEBMEBMDBNEBMEBqJEEBHHuBPBUzZzZBYBx5BvBBxBCCBBBDGCBCBCDDJCBCgDCJCCFuqeuqeCqBCUaCoEMCE8BCLECBICFCCDCCEUCBDBCEBCOCBCBCCCBQCZs5Vs5VBYBmmBnBBpEjBB9EKBCOBCGBCBBr3ByBB+EVB75CfBhsVfBhCYBoyehBB", false)),
        Math: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("ycGDCHHFMMDDDCHHFAB", false)),
        Uppercase: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("hDZB7BqBqBBWBCHBCuBCEECDOCDsBCDECBBBDCCDEEGDDECBDDDCCCDFFDEECDDECCGBBCBBCBBCOCBSCDBBCEECkBCEQCJDDBCCFICBEBCBBCCCBEEBCCBCBCEBDCCBDDIDDCBBEFBGLLBnFnFsBCCEEEBBBvBDBCdBCBBECBCWCBDBCGD1BvBBCgBCK0BCDMCBgDCyBlBBq6CqBBDCB5XFBjkCIBCvHvHERRzD0ECGGGC8CCBHBJFBLHBJHBJFBMGCJHBJNBzBBBNSSBPPBEEpLiBiBBOBFsasaBYBn6BvBBCEEBGCHDDLiDCJCCFNNBkBBCGG0oesBCUaCoEMCE8BCLCCDICFFFCBBDSCMOCFCCDOCb9a9advCBi8UZBumBnBBpEjBB8EKBCOBCGBCBBk4ByBB+DVB75CfBhsVfB8BYBvyehBB", false))
    });
    static FOLD_SCRIPT = new $394755e62edee9eb$var$LazyMap({
        Common: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("8cgBgB", false)),
        Greek: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("1FwUwU", false)),
        Inherited: ()=>new $394755e62edee9eb$var$UnicodeRangeTable($394755e62edee9eb$var$decodeRanges("5cgBgBlgHAB", false))
    });
};
//#endregion
//#region src/Unicode.js
/**
* Utilities for dealing with Unicode better than JS does.
*/ var $394755e62edee9eb$var$Unicode = class Unicode {
    static MAX_RUNE = 1114111;
    static MAX_ASCII = 127;
    static MAX_LATIN1 = 255;
    static MAX_BMP = 65535;
    static MIN_FOLD = 65;
    static MAX_FOLD = 125251;
    static MIN_HIGH_SURROGATE = 55296;
    static MAX_HIGH_SURROGATE = 56319;
    static MIN_LOW_SURROGATE = 56320;
    static MAX_LOW_SURROGATE = 57343;
    static MIN_SUPPLEMENTARY_CODE_POINT = 65536;
    static is32(ranges, r) {
        let lo = 0;
        let hi = ranges.length;
        while(lo < hi){
            const m = lo + Math.floor((hi - lo) / 2);
            const rlo = ranges.getLo(m);
            const rhi = ranges.getHi(m);
            if (rlo <= r && r <= rhi) {
                const stride = ranges.getStride(m);
                return (r - rlo) % stride === 0;
            }
            if (r < rlo) hi = m;
            else lo = m + 1;
        }
        return false;
    }
    static is(ranges, r) {
        if (r <= Unicode.MAX_LATIN1) {
            for(let i = 0; i < ranges.length; i++){
                if (r > ranges.getHi(i)) continue;
                const rlo = ranges.getLo(i);
                if (r < rlo) return false;
                const stride = ranges.getStride(i);
                return (r - rlo) % stride === 0;
            }
            return false;
        }
        return ranges.length > 0 && r >= ranges.getLo(0) && Unicode.is32(ranges, r);
    }
    static isUpper(r) {
        if (r <= Unicode.MAX_LATIN1) {
            const s = String.fromCodePoint(r);
            return s.toUpperCase() === s && s.toLowerCase() !== s;
        }
        return Unicode.is($394755e62edee9eb$var$UnicodeTables.Upper, r);
    }
    static isPrint(r) {
        if (r <= Unicode.MAX_LATIN1) return r >= 32 && r < Unicode.MAX_ASCII || r >= 161 && r !== 173;
        return Unicode.is($394755e62edee9eb$var$UnicodeTables.Print, r);
    }
    static simpleFold(r) {
        if ($394755e62edee9eb$var$UnicodeTables.CASE_ORBIT.has(r)) return $394755e62edee9eb$var$UnicodeTables.CASE_ORBIT.get(r);
        const l = $394755e62edee9eb$var$Codepoint.toLowerCase(r);
        if (l !== r) return l;
        return $394755e62edee9eb$var$Codepoint.toUpperCase(r);
    }
    static equalsIgnoreCase(r1, r2) {
        if (r1 === r2) return true;
        if (r1 < 0 || r2 < 0) return false;
        if (r1 <= Unicode.MAX_ASCII && r2 <= Unicode.MAX_ASCII) {
            if (65 <= r1 && r1 <= 90) r1 |= 32;
            if (65 <= r2 && r2 <= 90) r2 |= 32;
            return r1 === r2;
        }
        for(let r = Unicode.simpleFold(r1); r !== r1; r = Unicode.simpleFold(r))if (r === r2) return true;
        return false;
    }
};
//#endregion
//#region src/Utils.js
/**
* Size of the precomputed single-byte lookup table.
* Covers standard ASCII and Latin-1 characters for fast-path execution.
*/ const $394755e62edee9eb$var$FAST_PATH_TABLE_SIZE = 256;
/**
* Precomputed lookup table for Word Boundary (\b, \B) assertions.
* * By precomputing the boolean results for standard ASCII word ranges
* ('a'-'z', 'A'-'Z', '0'-'9', '_'), we completely eliminate 4 logical
* branches from the NFA's hot execution loop. This prevents costly
* CPU branch mispredictions when scanning large strings.
*/ const $394755e62edee9eb$var$WORD_RUNE_TABLE = new Uint8Array($394755e62edee9eb$var$FAST_PATH_TABLE_SIZE);
for(let i = 0; i < $394755e62edee9eb$var$FAST_PATH_TABLE_SIZE; i++)$394755e62edee9eb$var$WORD_RUNE_TABLE[i] = 97 <= i && i <= 122 || 65 <= i && i <= 90 || 48 <= i && i <= 57 || i === 95 ? 1 : 0;
let $394755e62edee9eb$var$cachedNativeEncoder = null;
let $394755e62edee9eb$var$cachedNativeDecoder = null;
/**
* Various constants and helper utilities.
*/ var $394755e62edee9eb$var$Utils = class Utils {
    static METACHARACTERS = "\\.+*?()|[]{}^$";
    static EMPTY_BEGIN_LINE = 1;
    static EMPTY_END_LINE = 2;
    static EMPTY_BEGIN_TEXT = 4;
    static EMPTY_END_TEXT = 8;
    static EMPTY_WORD_BOUNDARY = 16;
    static EMPTY_NO_WORD_BOUNDARY = 32;
    static EMPTY_ALL = -1;
    static emptyInts() {
        return [];
    }
    static isByteArray(input) {
        return Array.isArray(input) || input instanceof Uint8Array;
    }
    static isalnum(c) {
        return $394755e62edee9eb$var$Codepoint.CODES.get("0") <= c && c <= $394755e62edee9eb$var$Codepoint.CODES.get("9") || $394755e62edee9eb$var$Codepoint.CODES.get("a") <= c && c <= $394755e62edee9eb$var$Codepoint.CODES.get("z") || $394755e62edee9eb$var$Codepoint.CODES.get("A") <= c && c <= $394755e62edee9eb$var$Codepoint.CODES.get("Z");
    }
    static unhex(c) {
        if ($394755e62edee9eb$var$Codepoint.CODES.get("0") <= c && c <= $394755e62edee9eb$var$Codepoint.CODES.get("9")) return c - $394755e62edee9eb$var$Codepoint.CODES.get("0");
        if ($394755e62edee9eb$var$Codepoint.CODES.get("a") <= c && c <= $394755e62edee9eb$var$Codepoint.CODES.get("f")) return c - $394755e62edee9eb$var$Codepoint.CODES.get("a") + 10;
        if ($394755e62edee9eb$var$Codepoint.CODES.get("A") <= c && c <= $394755e62edee9eb$var$Codepoint.CODES.get("F")) return c - $394755e62edee9eb$var$Codepoint.CODES.get("A") + 10;
        return -1;
    }
    static escapeRune(rune) {
        let out = "";
        if ($394755e62edee9eb$var$Unicode.isPrint(rune)) {
            if (Utils.METACHARACTERS.indexOf(String.fromCodePoint(rune)) >= 0) out += "\\";
            out += String.fromCodePoint(rune);
        } else switch(rune){
            case $394755e62edee9eb$var$Codepoint.CODES.get("\""):
                out += "\\\"";
                break;
            case $394755e62edee9eb$var$Codepoint.CODES.get("\\"):
                out += "\\\\";
                break;
            case $394755e62edee9eb$var$Codepoint.CODES.get("	"):
                out += "\\t";
                break;
            case $394755e62edee9eb$var$Codepoint.CODES.get("\n"):
                out += "\\n";
                break;
            case $394755e62edee9eb$var$Codepoint.CODES.get("\r"):
                out += "\\r";
                break;
            case $394755e62edee9eb$var$Codepoint.CODES.get("\b"):
                out += "\\b";
                break;
            case $394755e62edee9eb$var$Codepoint.CODES.get("\f"):
                out += "\\f";
                break;
            default:
                {
                    let s = rune.toString(16);
                    if (rune < 256) {
                        out += "\\x";
                        if (s.length === 1) out += "0";
                        out += s;
                    } else out += `\\x{${s}}`;
                    break;
                }
        }
        return out;
    }
    static stringToRunes(str) {
        const string = String(str);
        const runes = [];
        let i = 0;
        while(i < string.length){
            const cp = string.codePointAt(i);
            runes.push(cp);
            i += cp > $394755e62edee9eb$var$Unicode.MAX_BMP ? 2 : 1;
        }
        return runes;
    }
    static runeToString(r) {
        return String.fromCodePoint(r);
    }
    static isWordRune(r) {
        return r < $394755e62edee9eb$var$FAST_PATH_TABLE_SIZE ? $394755e62edee9eb$var$WORD_RUNE_TABLE[r] === 1 : false;
    }
    static emptyOpContext(r1, r2) {
        let op = 0;
        if (r1 < 0) op |= Utils.EMPTY_BEGIN_TEXT | Utils.EMPTY_BEGIN_LINE;
        if (r1 === 10) op |= Utils.EMPTY_BEGIN_LINE;
        if (r2 < 0) op |= Utils.EMPTY_END_TEXT | Utils.EMPTY_END_LINE;
        if (r2 === 10) op |= Utils.EMPTY_END_LINE;
        if (Utils.isWordRune(r1) !== Utils.isWordRune(r2)) op |= Utils.EMPTY_WORD_BOUNDARY;
        else op |= Utils.EMPTY_NO_WORD_BOUNDARY;
        return op;
    }
    /**
	* Returns a string that quotes all regular expression metacharacters inside the argument text;
	* the returned string is a regular expression matching the literal text. For example,
	* {@code quoteMeta("[foo]").equals("\\[foo\\]")}.
	* @param {string} str
	* @returns {string}
	*/ static quoteMeta(str) {
        return str.split("").map((s)=>{
            if (Utils.METACHARACTERS.indexOf(s) >= 0) return `\\${s}`;
            return s;
        }).join("");
    }
    static charCount(codePoint) {
        return codePoint > $394755e62edee9eb$var$Unicode.MAX_BMP ? 2 : 1;
    }
    /**
	* High-speed conversion from TypedArrays to standard JS Arrays.
	* Bypasses the expensive Symbol.iterator overhead of Array.from()
	*/ static toArray(typedArray) {
        const len = typedArray.length;
        const res = new Array(len);
        for(let i = 0; i < len; i++)res[i] = typedArray[i];
        return res;
    }
    static stringToUtf8ByteArray(str) {
        if (globalThis.TextEncoder) {
            if (!$394755e62edee9eb$var$cachedNativeEncoder) $394755e62edee9eb$var$cachedNativeEncoder = new TextEncoder();
            return $394755e62edee9eb$var$cachedNativeEncoder.encode(str);
        } else {
            let out = [], p = 0;
            for(let i = 0; i < str.length; i++){
                let c = str.charCodeAt(i);
                if (c < 128) out[p++] = c;
                else if (c < 2048) {
                    out[p++] = c >> 6 | 192;
                    out[p++] = c & 63 | 128;
                } else if ((c & 64512) === $394755e62edee9eb$var$Unicode.MIN_HIGH_SURROGATE && i + 1 < str.length && (str.charCodeAt(i + 1) & 64512) === $394755e62edee9eb$var$Unicode.MIN_LOW_SURROGATE) {
                    c = $394755e62edee9eb$var$Unicode.MIN_SUPPLEMENTARY_CODE_POINT + ((c & 1023) << 10) + (str.charCodeAt(++i) & 1023);
                    out[p++] = c >> 18 | 240;
                    out[p++] = c >> 12 & 63 | 128;
                    out[p++] = c >> 6 & 63 | 128;
                    out[p++] = c & 63 | 128;
                } else {
                    out[p++] = c >> 12 | 224;
                    out[p++] = c >> 6 & 63 | 128;
                    out[p++] = c & 63 | 128;
                }
            }
            return out;
        }
    }
    static utf8ByteArrayToString(bytes) {
        if (globalThis.TextDecoder) {
            if (!$394755e62edee9eb$var$cachedNativeDecoder) $394755e62edee9eb$var$cachedNativeDecoder = new TextDecoder("utf-8");
            const view = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
            return $394755e62edee9eb$var$cachedNativeDecoder.decode(view);
        } else {
            let out = [], pos = 0, c = 0;
            while(pos < bytes.length){
                let c1 = bytes[pos++];
                if (c1 < 128) out[c++] = String.fromCharCode(c1);
                else if (c1 > 191 && c1 < 224) {
                    let c2 = bytes[pos++];
                    out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
                } else if (c1 > 239 && c1 < 365) {
                    let c2 = bytes[pos++];
                    let c3 = bytes[pos++];
                    let c4 = bytes[pos++];
                    let u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - $394755e62edee9eb$var$Unicode.MIN_SUPPLEMENTARY_CODE_POINT;
                    out[c++] = String.fromCharCode($394755e62edee9eb$var$Unicode.MIN_HIGH_SURROGATE + (u >> 10));
                    out[c++] = String.fromCharCode($394755e62edee9eb$var$Unicode.MIN_LOW_SURROGATE + (u & 1023));
                } else {
                    let c2 = bytes[pos++];
                    let c3 = bytes[pos++];
                    out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                }
            }
            return out.join("");
        }
    }
};
//#endregion
//#region src/helpers.js
const $394755e62edee9eb$var$createEnum = (values = [], initNum = 0)=>{
    const enumObject = Object.create(null);
    for(let i = 0; i < values.length; i++){
        const val = values[i];
        const keyVal = initNum + i;
        enumObject[val] = keyVal;
        enumObject[keyVal] = val;
    }
    return Object.freeze(enumObject);
};
//#endregion
//#region src/MatcherInput.js
/**
* Abstract the representations of input text supplied to Matcher.
*/ var $394755e62edee9eb$export$cefe1fb40cb8a0f6 = class MatcherInputBase {
    static Encoding = $394755e62edee9eb$var$createEnum([
        "UTF_16",
        "UTF_8"
    ]);
    getEncoding() {
        throw Error("not implemented");
    }
    /** @returns {string} */ asCharSequence() {
        throw Error("not implemented");
    }
    /** @returns {Uint8Array|number[]} */ asBytes() {
        throw Error("not implemented");
    }
    /** @returns {number} */ length() {
        throw Error("not implemented");
    }
    /**
	*
	* @returns {boolean}
	*/ isUTF8Encoding() {
        return this.getEncoding() === MatcherInputBase.Encoding.UTF_8;
    }
    /**
	*
	* @returns {boolean}
	*/ isUTF16Encoding() {
        return this.getEncoding() === MatcherInputBase.Encoding.UTF_16;
    }
};
var $394755e62edee9eb$var$Utf8MatcherInput = class extends $394755e62edee9eb$export$cefe1fb40cb8a0f6 {
    /** @param {Uint8Array|number[]|null} bytes */ constructor(bytes = null){
        super();
        this.bytes = bytes;
    }
    getEncoding() {
        return $394755e62edee9eb$export$cefe1fb40cb8a0f6.Encoding.UTF_8;
    }
    /**
	*
	* @returns {string}
	*/ asCharSequence() {
        return $394755e62edee9eb$var$Utils.utf8ByteArrayToString(this.bytes);
    }
    /**
	*
	* @returns {Uint8Array|number[]|null}
	*/ asBytes() {
        return this.bytes;
    }
    /**
	*
	* @returns {number}
	*/ length() {
        return this.bytes.length;
    }
};
var $394755e62edee9eb$var$Utf16MatcherInput = class extends $394755e62edee9eb$export$cefe1fb40cb8a0f6 {
    /** @param {string|null} charSequence */ constructor(charSequence = null){
        super();
        this.charSequence = charSequence;
    }
    getEncoding() {
        return $394755e62edee9eb$export$cefe1fb40cb8a0f6.Encoding.UTF_16;
    }
    /**
	*
	* @returns {string}
	*/ asCharSequence() {
        return this.charSequence;
    }
    /**
	*
	* @returns {number[]}
	*/ asBytes() {
        return $394755e62edee9eb$var$Utils.stringToUtf8ByteArray(this.charSequence.toString());
    }
    /**
	*
	* @returns {number}
	*/ length() {
        return this.charSequence.length;
    }
};
var $394755e62edee9eb$export$3430ac14b3833fca = class {
    /**
	* Return the MatcherInput for UTF_16 encoding.
	* @returns {Utf16MatcherInput}
	*/ static utf16(charSequence) {
        return new $394755e62edee9eb$var$Utf16MatcherInput(charSequence);
    }
    /**
	* Return the MatcherInput for UTF_8 encoding.
	* @returns {Utf8MatcherInput}
	*/ static utf8(input) {
        if ($394755e62edee9eb$var$Utils.isByteArray(input)) return new $394755e62edee9eb$var$Utf8MatcherInput(input);
        return new $394755e62edee9eb$var$Utf8MatcherInput($394755e62edee9eb$var$Utils.stringToUtf8ByteArray(input));
    }
};
//#endregion
//#region src/MachineInput.js
/**
* MachineInput abstracts different representations of the input text supplied to the Machine. It
* provides one-character lookahead.
*/ var $394755e62edee9eb$var$MachineInputBase = class {
    static EOF() {
        return -8;
    }
    constructor(){
        this.end = 0;
    }
    canCheckPrefix() {
        return true;
    }
    endPos() {
        return this.end;
    }
    hasString() {
        return false;
    }
    hasAnyString() {
        return false;
    }
    prefixLength() {
        return 0;
    }
};
var $394755e62edee9eb$var$MachineUTF8Input = class extends $394755e62edee9eb$var$MachineInputBase {
    constructor(bytes, start = 0, end = bytes.length){
        super();
        this.bytes = bytes;
        this.start = start;
        this.end = end;
    }
    hasString(prefilter, pos) {
        const target = prefilter.bytes;
        if (target.length === 0) return true;
        const idx = this.indexOf(this.bytes, target, this.start + pos);
        return idx !== -1 && idx <= this.end - target.length;
    }
    hasAnyString(prefilter, pos) {
        if (!prefilter.ac8) return false;
        return prefilter.ac8.searchUTF8(this.bytes, this.start + pos, this.end);
    }
    step(pos) {
        pos += this.start;
        if (pos >= this.end) return $394755e62edee9eb$var$MachineInputBase.EOF();
        const c = this.bytes[pos] & 255;
        if (c < 128) return c << 3 | 1;
        else if (c >= 194 && c <= 223 && pos + 1 < this.end) {
            const c1 = this.bytes[pos + 1] & 255;
            if ((c1 & 192) !== 128) return c << 3 | 1;
            return ((c & 31) << 6 | c1 & 63) << 3 | 2;
        } else if (c >= 224 && c <= 239 && pos + 2 < this.end) {
            const c1 = this.bytes[pos + 1] & 255;
            if ((c1 & 192) !== 128) return c << 3 | 1;
            const c2 = this.bytes[pos + 2] & 255;
            if ((c2 & 192) !== 128) return c << 3 | 1;
            return ((c & 15) << 12 | (c1 & 63) << 6 | c2 & 63) << 3 | 3;
        } else if (c >= 240 && c <= 244 && pos + 3 < this.end) {
            const c1 = this.bytes[pos + 1] & 255;
            if ((c1 & 192) !== 128) return c << 3 | 1;
            const c2 = this.bytes[pos + 2] & 255;
            if ((c2 & 192) !== 128) return c << 3 | 1;
            const c3 = this.bytes[pos + 3] & 255;
            if ((c3 & 192) !== 128) return c << 3 | 1;
            return ((c & 7) << 18 | (c1 & 63) << 12 | (c2 & 63) << 6 | c3 & 63) << 3 | 4;
        } else return c << 3 | 1;
    }
    index(re2, pos) {
        pos += this.start;
        const i = this.indexOf(this.bytes, re2.prefixUTF8, pos);
        return i < 0 ? i : i - pos;
    }
    context(pos) {
        pos += this.start;
        let r1 = -1;
        if (pos > this.start && pos <= this.end) {
            let start = pos - 1;
            r1 = this.bytes[start--];
            if (r1 >= 128) {
                let lim = pos - 4;
                if (lim < this.start) lim = this.start;
                while(start >= lim && (this.bytes[start] & 192) === 128)start--;
                if (start < this.start) start = this.start;
                r1 = this.step(start - this.start) >> 3;
            }
        }
        const r2 = pos < this.end ? this.step(pos - this.start) >> 3 : -1;
        return $394755e62edee9eb$var$Utils.emptyOpContext(r1, r2);
    }
    indexOf(source, target, fromIndex = 0) {
        let targetLength = target.length;
        if (targetLength === 0) return fromIndex <= this.end ? fromIndex : -1;
        const firstByte = target[0];
        let limit = this.end - targetLength;
        const hasNativeIndexOf = typeof source.indexOf === "function";
        let i = fromIndex;
        while(i <= limit){
            if (hasNativeIndexOf) {
                i = source.indexOf(firstByte, i);
                if (i === -1 || i > limit) return -1;
            } else {
                while(i <= limit && source[i] !== firstByte)i++;
                if (i > limit) return -1;
            }
            let match = true;
            for(let j = 1; j < targetLength; j++)if (source[i + j] !== target[j]) {
                match = false;
                break;
            }
            if (match) return i;
            i++;
        }
        return -1;
    }
    prefixLength(re2) {
        return re2.prefixUTF8.length;
    }
};
var $394755e62edee9eb$var$MachineUTF16Input = class extends $394755e62edee9eb$var$MachineInputBase {
    constructor(charSequence, start = 0, end = charSequence.length){
        super();
        this.charSequence = charSequence;
        this.start = start;
        this.end = end;
    }
    hasString(prefilter, pos) {
        const idx = this.charSequence.indexOf(prefilter.str, this.start + pos);
        return idx !== -1 && idx <= this.end - prefilter.str.length;
    }
    hasAnyString(prefilter, pos) {
        if (!prefilter.ac16) return false;
        return prefilter.ac16.searchUTF16(this.charSequence, this.start + pos, this.end);
    }
    step(pos) {
        pos += this.start;
        if (pos >= this.end) return $394755e62edee9eb$var$MachineInputBase.EOF();
        const c1 = this.charSequence.charCodeAt(pos);
        if (c1 < $394755e62edee9eb$var$Unicode.MIN_HIGH_SURROGATE || c1 > $394755e62edee9eb$var$Unicode.MAX_HIGH_SURROGATE || pos + 1 >= this.end) return c1 << 3 | 1;
        const c2 = this.charSequence.charCodeAt(pos + 1);
        if (c2 >= $394755e62edee9eb$var$Unicode.MIN_LOW_SURROGATE && c2 <= $394755e62edee9eb$var$Unicode.MAX_LOW_SURROGATE) return (c1 - $394755e62edee9eb$var$Unicode.MIN_HIGH_SURROGATE) * 1024 + (c2 - $394755e62edee9eb$var$Unicode.MIN_LOW_SURROGATE) + $394755e62edee9eb$var$Unicode.MIN_SUPPLEMENTARY_CODE_POINT << 3 | 2;
        return c1 << 3 | 1;
    }
    index(re2, pos) {
        pos += this.start;
        const i = this.charSequence.indexOf(re2.prefix, pos);
        if (i < 0 || i > this.end - re2.prefix.length) return -1;
        return i - pos;
    }
    context(pos) {
        pos += this.start;
        const r1 = pos > this.start && pos <= this.end ? this.charSequence.charCodeAt(pos - 1) : -1;
        const r2 = pos < this.end ? this.charSequence.charCodeAt(pos) : -1;
        return $394755e62edee9eb$var$Utils.emptyOpContext(r1, r2);
    }
    prefixLength(re2) {
        return re2.prefix.length;
    }
};
var $394755e62edee9eb$var$MachineInput = class {
    static fromUTF8(bytes, start = 0, end = bytes.length) {
        return new $394755e62edee9eb$var$MachineUTF8Input(bytes, start, end);
    }
    static fromUTF16(charSequence, start = 0, end = charSequence.length) {
        return new $394755e62edee9eb$var$MachineUTF16Input(charSequence, start, end);
    }
};
//#endregion
//#region src/exceptions.js
var $394755e62edee9eb$export$54306bca8e0bffc2 = class extends Error {
    /** @param {string} message */ constructor(message){
        super(message);
        this.name = "RE2JSException";
    }
};
/**
* An exception thrown by the parser if the pattern was invalid.
*/ var $394755e62edee9eb$export$9c12d0c1e9bff151 = class extends $394755e62edee9eb$export$54306bca8e0bffc2 {
    /**
	* @param {string} error
	* @param {string|null} [input=null]
	*/ constructor(error, input = null){
        let message = `error parsing regexp: ${error}`;
        if (input) message += `: \`${input}\``;
        super(message);
        this.name = "RE2JSSyntaxException";
        this.message = message;
        /** @type {string} */ this.error = error;
        /** @type {string|null} */ this.input = input;
    }
    /**
	* Retrieves the description of the error.
	* @returns {string}
	*/ getDescription() {
        return this.error;
    }
    /**
	* Retrieves the erroneous regular-expression pattern.
	* @returns {string|null}
	*/ getPattern() {
        return this.input;
    }
};
/**
* An exception thrown by the compiler
*/ var $394755e62edee9eb$export$457eacef9ada3821 = class extends $394755e62edee9eb$export$54306bca8e0bffc2 {
    /** @param {string} message */ constructor(message){
        super(message);
        this.name = "RE2JSCompileException";
    }
};
/**
* An exception thrown by using groups
*/ var $394755e62edee9eb$export$eab8e70da4919c35 = class extends $394755e62edee9eb$export$54306bca8e0bffc2 {
    /** @param {string} message */ constructor(message){
        super(message);
        this.name = "RE2JSGroupException";
    }
};
/**
* An exception thrown by flags
*/ var $394755e62edee9eb$export$fa1c64d63b2c22b1 = class extends $394755e62edee9eb$export$54306bca8e0bffc2 {
    /** @param {string} message */ constructor(message){
        super(message);
        this.name = "RE2JSFlagsException";
    }
};
/**
* An exception thrown for internal engine errors, such as corrupted bytecodes.
*/ var $394755e62edee9eb$export$3a148716bb6e0468 = class extends $394755e62edee9eb$export$54306bca8e0bffc2 {
    /** @param {string} message */ constructor(message){
        super(message);
        this.name = "RE2JSInternalException";
    }
};
//#endregion
//#region src/Matcher.js
/**
* A stateful iterator that interprets a regex {@code RE2JS} on a specific input.
*
* Conceptually, a Matcher consists of four parts:
* <ol>
* <li>A compiled regular expression {@code RE2JS}, set at construction and fixed for the lifetime
* of the matcher.</li>
*
* <li>The remainder of the input string, set at construction or {@link #reset()} and advanced by
* each match operation such as {@link #find}, {@link #matches} or {@link #lookingAt}.</li>
*
* <li>The current match information, accessible via {@link #start}, {@link #end}, and
* {@link #group}, and updated by each match operation.</li>
*
* <li>The append position, used and advanced by {@link #appendReplacement} and {@link #appendTail}
* if performing a search and replace from the input to an external {@code StringBuffer}.
*
* </ol>
*
*
* @author rsc@google.com (Russ Cox)
*/ var $394755e62edee9eb$export$20214574ec94167d = class Matcher {
    /**
	* V8 and WebKit have historical hard limits on the number of arguments
	* that can be passed to a function. We cap replacer arguments to prevent
	* Call Stack Overflow (DoS) vulnerabilities on massive ASTs.
	*/ static MAX_REPLACER_ARGS = 65535;
    /**
	* Quotes '\' and '$' in {@code s}, so that the returned string could be used in
	* {@link #appendReplacement} as a literal replacement of {@code s}.
	*
	* @param {string} str the string to be quoted
	* @param {boolean} [javaMode=false] whether the replacement will be used in javaMode
	* @returns {string} the quoted string
	*/ static quoteReplacement(str, javaMode = false) {
        if (javaMode) {
            if (str.indexOf("\\") < 0 && str.indexOf("$") < 0) return str;
            return str.split("").map((s)=>{
                const c = s.codePointAt(0);
                if (c === $394755e62edee9eb$var$Codepoint.CODES.get("\\") || c === $394755e62edee9eb$var$Codepoint.CODES.get("$")) return `\\${s}`;
                return s;
            }).join("");
        }
        if (str.indexOf("$") < 0) return str;
        return str.split("").map((s)=>{
            if (s.codePointAt(0) === $394755e62edee9eb$var$Codepoint.CODES.get("$")) return "$$";
            return s;
        }).join("");
    }
    /**
	*
	* @param {import('./index.js').RE2JS} pattern
	* @param {string|number[]|Uint8Array|MatcherInputBase} input
	*/ constructor(pattern, input){
        if (pattern === null) throw new Error("pattern is null");
        /**
		* The pattern being matched.
		* @type {import('./index.js').RE2JS}
		*/ this.patternInput = pattern;
        const re2 = this.patternInput.re2();
        /** @type {number} */ this.patternGroupCount = re2.numberOfCapturingGroups();
        /** @type {number[]} */ this.groups = [];
        /** @type {Record<string, number>} */ this.namedGroups = re2.namedGroups;
        /** @type {number} */ this.numberOfInstructions = re2.numberOfInstructions();
        if (input instanceof $394755e62edee9eb$export$cefe1fb40cb8a0f6) this.resetMatcherInput(input);
        else if ($394755e62edee9eb$var$Utils.isByteArray(input)) this.resetMatcherInput($394755e62edee9eb$export$3430ac14b3833fca.utf8(input));
        else this.resetMatcherInput($394755e62edee9eb$export$3430ac14b3833fca.utf16(input));
    }
    /**
	* Returns the {@code RE2JS} associated with this {@code Matcher}.
	* @returns {import('./index.js').RE2JS}
	*/ pattern() {
        return this.patternInput;
    }
    /**
	* Resets the {@code Matcher}, rewinding input and discarding any match information.
	*
	* @returns {Matcher} the {@code Matcher} itself, for chained method calls
	*/ reset() {
        /** @type {number} */ this.matcherInputLength = this.matcherInput.length();
        /** @type {number} */ this.appendPos = 0;
        this.hasMatch = false;
        this.hasGroups = false;
        this.anchorFlag = 0;
        return this;
    }
    /**
	* Resets the {@code Matcher} and changes the input.
	* @param {string|number[]|Uint8Array|MatcherInputBase} input
	* @returns {Matcher} the {@code Matcher} itself, for chained method calls
	*/ resetMatcherInput(input) {
        if (input === null) throw new Error("input is null");
        if (!(input instanceof $394755e62edee9eb$export$cefe1fb40cb8a0f6)) {
            if ($394755e62edee9eb$var$Utils.isByteArray(input)) input = $394755e62edee9eb$export$3430ac14b3833fca.utf8(input);
            else input = $394755e62edee9eb$export$3430ac14b3833fca.utf16(input);
        }
        this.matcherInput = input;
        this.reset();
        return this;
    }
    /**
	* Returns the start of the named group of the most recent match, or -1 if the group was not
	* matched.
	* @param {string|number} [group=0]
	* @returns {number}
	*/ start(group = 0) {
        if (typeof group === "string") {
            const groupInt = this.namedGroups[group];
            if (!Number.isFinite(groupInt)) throw new $394755e62edee9eb$export$eab8e70da4919c35(`group '${group}' not found`);
            group = groupInt;
        }
        this.loadGroup(group);
        return this.groups[2 * group];
    }
    /**
	* Returns the end of the named group of the most recent match, or -1 if the group was not
	* matched.
	* @param {string|number} [group=0]
	* @returns {number}
	*/ end(group = 0) {
        if (typeof group === "string") {
            const groupInt = this.namedGroups[group];
            if (!Number.isFinite(groupInt)) throw new $394755e62edee9eb$export$eab8e70da4919c35(`group '${group}' not found`);
            group = groupInt;
        }
        this.loadGroup(group);
        return this.groups[2 * group + 1];
    }
    /**
	* Returns the program size of this pattern.
	*
	* <p>
	* Similar to the C++ implementation, the program size is a very approximate measure of a regexp's
	* "cost". Larger numbers are more expensive than smaller numbers.
	* </p>
	*
	* @returns {number} the program size of this pattern
	*/ programSize() {
        return this.numberOfInstructions;
    }
    /**
	* Returns the named group of the most recent match, or {@code null} if the group was not matched.
	* @param {string|number} [group=0]
	* @returns {string|null}
	*/ group(group = 0) {
        if (typeof group === "string") {
            const groupInt = this.namedGroups[group];
            if (!Number.isFinite(groupInt)) throw new $394755e62edee9eb$export$eab8e70da4919c35(`group '${group}' not found`);
            group = groupInt;
        }
        const start = this.start(group);
        const end = this.end(group);
        if (start < 0 && end < 0) return null;
        return this.substring(start, end);
    }
    /**
	* Returns a dictionary map of all named capturing groups and their matched values.
	* If a group was not matched, its value will be `null`.
	* @returns {Record<string, string|null>}
	*/ getNamedGroups() {
        if (!this.hasMatch) throw new $394755e62edee9eb$export$eab8e70da4919c35("perhaps no match attempted");
        const result = Object.create(null);
        for (const name of Object.keys(this.namedGroups))result[name] = this.group(name);
        return result;
    }
    /**
	* Returns the number of subgroups in this pattern.
	*
	* @returns {number} the number of subgroups; the overall match (group 0) does not count
	*/ groupCount() {
        return this.patternGroupCount;
    }
    /**
	* Helper: finds subgroup information if needed for group.
	* @param {number} group
	* @private
	*/ loadGroup(group) {
        if (group < 0 || group > this.patternGroupCount) throw new $394755e62edee9eb$export$eab8e70da4919c35(`Group index out of bounds: ${group}`);
        if (!this.hasMatch) throw new $394755e62edee9eb$export$eab8e70da4919c35("perhaps no match attempted");
        if (group === 0 || this.hasGroups) return;
        const end = this.matcherInputLength;
        const res = this.patternInput.re2().matchMachineInput(this.matcherInput, this.groups[0], end, this.anchorFlag, 1 + this.patternGroupCount);
        if (!res[0]) throw new $394755e62edee9eb$export$eab8e70da4919c35("inconsistency in matching group data");
        this.groups = res[1];
        this.hasGroups = true;
    }
    /**
	* Matches the entire input against the pattern (anchored start and end). If there is a match,
	* {@code matches} sets the match state to describe it.
	*
	* @returns {boolean} true if the entire input matches the pattern
	*/ matches() {
        return this.genMatch(0, $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH);
    }
    /**
	* Matches the beginning of input against the pattern (anchored start). If there is a match,
	* {@code lookingAt} sets the match state to describe it.
	*
	* @returns {boolean} true if the beginning of the input matches the pattern
	*/ lookingAt() {
        return this.genMatch(0, $394755e62edee9eb$var$RE2Flags.ANCHOR_START);
    }
    /**
	* Matches the input against the pattern (unanchored), starting at a specified position. If there
	* is a match, {@code find} sets the match state to describe it.
	*
	* @param {number|null} [start=null] the input position where the search begins
	* @returns {boolean} if it finds a match
	* @throws IndexOutOfBoundsException if start is not a valid input position
	*/ find(start = null) {
        if (start !== null) {
            if (start < 0 || start > this.matcherInputLength) throw new $394755e62edee9eb$export$eab8e70da4919c35(`start index out of bounds: ${start}`);
            this.reset();
            return this.genMatch(start, 0);
        }
        start = 0;
        if (this.hasMatch) {
            start = this.groups[1];
            if (this.groups[0] === this.groups[1]) {
                const r = (this.matcherInput.isUTF16Encoding() ? $394755e62edee9eb$var$MachineInput.fromUTF16(this.matcherInput.asCharSequence(), 0, this.matcherInputLength) : $394755e62edee9eb$var$MachineInput.fromUTF8(this.matcherInput.asBytes(), 0, this.matcherInputLength)).step(start);
                if (r < 0) start++;
                else start += r & 7;
            }
        }
        return this.genMatch(start, $394755e62edee9eb$var$RE2Flags.UNANCHORED);
    }
    /**
	* Helper: does match starting at start, with RE2 anchor flag.
	* @param {number} startByte
	* @param {number} anchor
	* @returns {boolean}
	* @private
	*/ genMatch(startByte, anchor) {
        const res = this.patternInput.re2().matchMachineInput(this.matcherInput, startByte, this.matcherInputLength, anchor, 1);
        if (!res[0]) {
            this.hasMatch = false;
            return false;
        }
        this.groups = res[1];
        this.hasMatch = true;
        this.hasGroups = this.patternGroupCount === 0;
        this.anchorFlag = anchor;
        return true;
    }
    /**
	* Helper: return substring for [start, end).
	* @param {number} start
	* @param {number} end
	* @returns {string}
	*/ substring(start, end) {
        if (this.matcherInput.isUTF8Encoding()) return $394755e62edee9eb$var$Utils.utf8ByteArrayToString(this.matcherInput.asBytes().slice(start, end));
        return this.matcherInput.asCharSequence().substring(start, end).toString();
    }
    /**
	* Helper for Pattern: return input length.
	* @returns {number}
	*/ inputLength() {
        return this.matcherInputLength;
    }
    /**
	* Appends to result two strings: the text from the append position up to the beginning of the
	* most recent match, and then the replacement with submatch groups substituted for references of
	* the form {@code $n}, where {@code n} is the group number in decimal. It advances the append
	* position to where the most recent match ended.
	*
	* To embed a literal {@code $}, use \$ (actually {@code "\\$"} with string escapes). The escape
	* is only necessary when {@code $} is followed by a digit, but it is always allowed. Only
	* {@code $} and {@code \} need escaping, but any character can be escaped.
	*
	* The group number {@code n} in {@code $n} is always at least one digit and expands to use more
	* digits as long as the resulting number is a valid group number for this pattern. To cut it off
	* earlier, escape the first digit that should not be used.
	*
	* @param {string} replacement the replacement string
	* @param {boolean} [javaMode=false] activate java mode (different behaviour for capture groups and special characters)
	* @returns {string}
	* @throws IllegalStateException if there was no most recent match
	* @throws IndexOutOfBoundsException if replacement refers to an invalid group
	* @private
	*/ appendReplacement(replacement, javaMode = false) {
        let res = "";
        const s = this.start();
        const e = this.end();
        if (this.appendPos < s) res += this.substring(this.appendPos, s);
        this.appendPos = e;
        res += javaMode ? this.appendReplacementInternalJava(replacement) : this.appendReplacementInternalJs(replacement);
        return res;
    }
    /**
	* @param {string} replacement - the replacement string
	* @returns {string}
	* @private
	*/ appendReplacementInternalJava(replacement) {
        let res = "";
        let last = 0;
        const m = replacement.length;
        let i = 0;
        while(i < m){
            const cCode = replacement.codePointAt(i);
            if (cCode === $394755e62edee9eb$var$Codepoint.CODES.get("\\")) {
                if (last < i) res += replacement.substring(last, i);
                i++;
                if (i >= m) throw new $394755e62edee9eb$export$eab8e70da4919c35("character to be escaped is missing");
                last = i;
                i++;
                continue;
            }
            if (cCode === $394755e62edee9eb$var$Codepoint.CODES.get("$")) {
                if (last < i) res += replacement.substring(last, i);
                if (i + 1 >= m) throw new $394755e62edee9eb$export$eab8e70da4919c35("Illegal group reference: group index is missing");
                const nextCode = replacement.codePointAt(i + 1);
                if ($394755e62edee9eb$var$Codepoint.CODES.get("0") <= nextCode && nextCode <= $394755e62edee9eb$var$Codepoint.CODES.get("9")) {
                    let n = nextCode - $394755e62edee9eb$var$Codepoint.CODES.get("0");
                    let j = i + 2;
                    for(; j < m; j++){
                        const digit = replacement.codePointAt(j);
                        if (digit < $394755e62edee9eb$var$Codepoint.CODES.get("0") || digit > $394755e62edee9eb$var$Codepoint.CODES.get("9") || n * 10 + digit - $394755e62edee9eb$var$Codepoint.CODES.get("0") > this.patternGroupCount) break;
                        n = n * 10 + digit - $394755e62edee9eb$var$Codepoint.CODES.get("0");
                    }
                    if (n > this.patternGroupCount) throw new $394755e62edee9eb$export$eab8e70da4919c35(`n > number of groups: ${n}`);
                    const group = this.group(n);
                    if (group !== null) res += group;
                    i = j;
                    last = i;
                } else if (nextCode === $394755e62edee9eb$var$Codepoint.CODES.get("{")) {
                    let j = i + 2;
                    while(j < m && replacement.codePointAt(j) !== $394755e62edee9eb$var$Codepoint.CODES.get("}"))j++;
                    if (j >= m) throw new $394755e62edee9eb$export$eab8e70da4919c35("named capture group is missing trailing '}'");
                    const groupName = replacement.substring(i + 2, j);
                    const groupVal = this.group(groupName);
                    if (groupVal !== null) res += groupVal;
                    i = j + 1;
                    last = i;
                } else throw new $394755e62edee9eb$export$eab8e70da4919c35("Illegal group reference");
                continue;
            }
            i++;
        }
        if (last < m) res += replacement.substring(last, m);
        return res;
    }
    /**
	* @param {string} replacement - the replacement string
	* @returns {string}
	* @private
	*/ appendReplacementInternalJs(replacement) {
        let res = "";
        let last = 0;
        const m = replacement.length;
        for(let i = 0; i < m - 1; i++)if (replacement.codePointAt(i) === $394755e62edee9eb$var$Codepoint.CODES.get("$")) {
            let c = replacement.codePointAt(i + 1);
            if ($394755e62edee9eb$var$Codepoint.CODES.get("$") === c) {
                if (last < i) res += replacement.substring(last, i);
                res += "$";
                i++;
                last = i + 1;
                continue;
            } else if ($394755e62edee9eb$var$Codepoint.CODES.get("&") === c) {
                if (last < i) res += replacement.substring(last, i);
                const group = this.group(0);
                if (group !== null) res += group;
                else res += "$&";
                i++;
                last = i + 1;
                continue;
            } else if ($394755e62edee9eb$var$Codepoint.CODES.get("`") === c) {
                if (last < i) res += replacement.substring(last, i);
                res += this.substring(0, this.start(0));
                i++;
                last = i + 1;
                continue;
            } else if ($394755e62edee9eb$var$Codepoint.CODES.get("'") === c) {
                if (last < i) res += replacement.substring(last, i);
                res += this.substring(this.end(0), this.matcherInputLength);
                i++;
                last = i + 1;
                continue;
            } else if ($394755e62edee9eb$var$Codepoint.CODES.get("1") <= c && c <= $394755e62edee9eb$var$Codepoint.CODES.get("9")) {
                let n = c - $394755e62edee9eb$var$Codepoint.CODES.get("0");
                if (last < i) res += replacement.substring(last, i);
                for(i += 2; i < m; i++){
                    c = replacement.codePointAt(i);
                    if (c < $394755e62edee9eb$var$Codepoint.CODES.get("0") || c > $394755e62edee9eb$var$Codepoint.CODES.get("9") || n * 10 + c - $394755e62edee9eb$var$Codepoint.CODES.get("0") > this.patternGroupCount) break;
                    n = n * 10 + c - $394755e62edee9eb$var$Codepoint.CODES.get("0");
                }
                if (n > this.patternGroupCount) {
                    res += `$${n}`;
                    last = i;
                    i--;
                    continue;
                }
                const group = this.group(n);
                if (group !== null) res += group;
                last = i;
                i--;
                continue;
            } else if (c === $394755e62edee9eb$var$Codepoint.CODES.get("<")) {
                if (last < i) res += replacement.substring(last, i);
                i++;
                let j = i + 1;
                while(j < replacement.length && replacement.codePointAt(j) !== $394755e62edee9eb$var$Codepoint.CODES.get(">") && replacement.codePointAt(j) !== $394755e62edee9eb$var$Codepoint.CODES.get(" "))j++;
                if (j === replacement.length || replacement.codePointAt(j) !== $394755e62edee9eb$var$Codepoint.CODES.get(">")) {
                    res += replacement.substring(i - 1, j + 1);
                    last = j + 1;
                    i = j;
                    continue;
                }
                const groupName = replacement.substring(i + 1, j);
                if (Object.prototype.hasOwnProperty.call(this.namedGroups, groupName)) {
                    const groupVal = this.group(groupName);
                    if (groupVal !== null) res += groupVal;
                } else res += `$<${groupName}>`;
                last = j + 1;
                i = j;
                continue;
            }
        }
        if (last < m) res += replacement.substring(last, m);
        return res;
    }
    /**
	* Return the substring of the input from the append position to the end of the
	* input.
	* @returns {string}
	*/ appendTail() {
        return this.substring(this.appendPos, this.matcherInputLength);
    }
    /**
	* Returns the input with all matches replaced by {@code replacement}, interpreted as for
	* {@code appendReplacement}.
	*
	* @param {string|((...args: any[]) => string)} replacement - the replacement string or a replacer function
	* @param {boolean} [javaMode=false] - activate java mode (different behaviour for capture groups and special characters)
	* @returns {string} the input string with the matches replaced
	* @throws IndexOutOfBoundsException if replacement refers to an invalid group and javaMode is true
	*/ replaceAll(replacement, javaMode = false) {
        return this.replace(replacement, true, javaMode);
    }
    /**
	* Returns the input with the first match replaced by {@code replacement}, interpreted as for
	* {@code appendReplacement}.
	*
	* @param {string|((...args: any[]) => string)} replacement - the replacement string or a replacer function
	* @param {boolean} [javaMode=false] - activate java mode (different behaviour for capture groups and special characters)
	* @returns {string} the input string with the first match replaced
	* @throws IndexOutOfBoundsException if replacement refers to an invalid group and javaMode is true
	*/ replaceFirst(replacement, javaMode = false) {
        return this.replace(replacement, false, javaMode);
    }
    /**
	* Helper: replaceAll/replaceFirst hybrid.
	* @param {string|((...args: any[]) => string)} replacement - the replacement string or a replacer function
	* @param {boolean} [all=true] - replace all matches
	* @param {boolean} [javaMode=false] - activate java mode (different behaviour for capture groups and special characters)
	* @returns {string}
	* @private
	*/ replace(replacement, all = true, javaMode = false) {
        let res = "";
        this.reset();
        const isFunc = typeof replacement === "function";
        const hasNamedGroups = Object.keys(this.namedGroups).length > 0;
        let originalInput = null;
        if (isFunc) {
            if (this.groupCount() >= Matcher.MAX_REPLACER_ARGS) throw new $394755e62edee9eb$export$eab8e70da4919c35("Too many capture groups to safely invoke replacer function");
            originalInput = this.matcherInput.isUTF8Encoding() ? this.matcherInput.asBytes() : this.matcherInput.asCharSequence();
        }
        while(this.find()){
            res += isFunc ? this.appendReplacementFunc(replacement, hasNamedGroups, originalInput) : this.appendReplacement(replacement, javaMode);
            if (!all) break;
        }
        res += this.appendTail();
        return res;
    }
    /**
	* Evaluates a replacer function for the current match and appends the result,
	* along with any un-matched preceding text, advancing the append position.
	* @param {Function} replacer - the replacer function
	* @param {boolean} hasNamedGroups - cached flag if pattern has named groups
	* @param {string|Uint8Array|number[]} originalInput - the cached original input reference
	* @returns {string} the evaluated string to append
	* @private
	*/ appendReplacementFunc(replacer, hasNamedGroups, originalInput) {
        let res = "";
        const s = this.start();
        const e = this.end();
        if (this.appendPos < s) res += this.substring(this.appendPos, s);
        this.appendPos = e;
        const args = this.buildReplacerArgs(s, hasNamedGroups, originalInput);
        res += String(replacer(...args));
        return res;
    }
    /**
	* Builds the argument array for the replacer function matching the standard
	* JS String.prototype.replace(regex, replacer) signature.
	* @param {number} matchStart - the start index of the match
	* @param {boolean} hasNamedGroups - cached flag if pattern has named groups
	* @param {string|Uint8Array|number[]} originalInput - the cached original input reference
	* @returns {Array} array of arguments
	* @private
	*/ buildReplacerArgs(matchStart, hasNamedGroups, originalInput) {
        const args = [
            this.group(0)
        ];
        const numGroups = this.groupCount();
        for(let i = 1; i <= numGroups; i++){
            const start = this.start(i);
            if (start < 0) args.push(void 0);
            else args.push(this.substring(start, this.end(i)));
        }
        args.push(matchStart);
        args.push(originalInput);
        if (hasNamedGroups) {
            const parsedGroups = this.getNamedGroups();
            for(const key in parsedGroups)if (parsedGroups[key] === null) parsedGroups[key] = void 0;
            args.push(parsedGroups);
        }
        return args;
    }
};
//#endregion
//#region src/Inst.js
/**
* A single instruction in the regular expression virtual machine.
*
* @see http://swtch.com/~rsc/regexp/regexp2.html
*/ var $394755e62edee9eb$var$Inst = class Inst {
    static ALT = 1;
    static ALT_MATCH = 2;
    static CAPTURE = 3;
    static EMPTY_WIDTH = 4;
    static FAIL = 5;
    static MATCH = 6;
    static NOP = 7;
    static RUNE = 8;
    static RUNE1 = 9;
    static RUNE_ANY = 10;
    static RUNE_ANY_NOT_NL = 11;
    static LB_WRITE = 12;
    static LB_CHECK = 13;
    static isRuneOp(op) {
        return Inst.RUNE <= op && op <= Inst.RUNE_ANY_NOT_NL;
    }
    static escapeRunes(runes) {
        let out = "\"";
        for (let rune of runes)out += $394755e62edee9eb$var$Utils.escapeRune(rune);
        out += "\"";
        return out;
    }
    constructor(op){
        this.op = op;
        this.out = 0;
        this.arg = 0;
        this.runes = [];
        /** @type {Uint32Array | number[] | null} */ this.next = null;
    }
    matchRune(r) {
        if (this.runes.length === 1) {
            const r0 = this.runes[0];
            if ((this.arg & $394755e62edee9eb$var$RE2Flags.FOLD_CASE) !== 0) return $394755e62edee9eb$var$Unicode.equalsIgnoreCase(r0, r);
            return r === r0;
        }
        const len = this.runes.length;
        if (len === 0) return false;
        if (len === 2 || len === 4 || len === 6 || len === 8) {
            for(let j = 0; j < len; j += 2){
                if (r < this.runes[j]) return false;
                if (r <= this.runes[j + 1]) return true;
            }
            return false;
        }
        let base = 0;
        let n = len >> 1;
        while(n > 1){
            const half = n >> 1;
            base += this.runes[base + half << 1] <= r ? half : 0;
            n -= half;
        }
        base += this.runes[base << 1] <= r ? 1 : 0;
        const m = base - 1;
        return m >= 0 && r <= this.runes[m << 1 | 1];
    }
    matchRunePos(r) {
        if (this.runes.length === 1) {
            const r0 = this.runes[0];
            if ((this.arg & $394755e62edee9eb$var$RE2Flags.FOLD_CASE) !== 0) return $394755e62edee9eb$var$Unicode.equalsIgnoreCase(r0, r) ? 0 : -1;
            return r === r0 ? 0 : -1;
        }
        const len = this.runes.length;
        if (len === 0) return -1;
        if (len === 2 || len === 4 || len === 6 || len === 8) {
            for(let j = 0; j < len; j += 2){
                if (r < this.runes[j]) return -1;
                if (r <= this.runes[j + 1]) return Math.floor(j / 2);
            }
            return -1;
        }
        let base = 0;
        let n = len >> 1;
        while(n > 1){
            const half = n >> 1;
            base += this.runes[base + half << 1] <= r ? half : 0;
            n -= half;
        }
        base += this.runes[base << 1] <= r ? 1 : 0;
        const m = base - 1;
        return m >= 0 && r <= this.runes[m << 1 | 1] ? m : -1;
    }
    /**
	*
	* @returns {string}
	*/ toString() {
        switch(this.op){
            case Inst.ALT:
                return `alt -> ${this.out}, ${this.arg}`;
            case Inst.ALT_MATCH:
                return `altmatch -> ${this.out}, ${this.arg}`;
            case Inst.CAPTURE:
                return `cap ${this.arg} -> ${this.out}`;
            case Inst.EMPTY_WIDTH:
                return `empty ${this.arg} -> ${this.out}`;
            case Inst.MATCH:
                return `match${this.arg !== 0 ? ` ${this.arg}` : ""}`;
            case Inst.FAIL:
                return "fail";
            case Inst.NOP:
                return `nop -> ${this.out}`;
            case Inst.LB_WRITE:
                return `lbwrite ${this.arg} -> ${this.out}`;
            case Inst.LB_CHECK:
                return `lbcheck ${this.arg} -> ${this.out}`;
            case Inst.RUNE:
                if (this.runes === null) return "rune <null>";
                return [
                    "rune ",
                    Inst.escapeRunes(this.runes),
                    (this.arg & $394755e62edee9eb$var$RE2Flags.FOLD_CASE) !== 0 ? "/i" : "",
                    " -> ",
                    this.out
                ].join("");
            case Inst.RUNE1:
                return `rune1 ${Inst.escapeRunes(this.runes)} -> ${this.out}`;
            case Inst.RUNE_ANY:
                return `any -> ${this.out}`;
            case Inst.RUNE_ANY_NOT_NL:
                return `anynotnl -> ${this.out}`;
            default:
                throw new Error("unhandled case in Inst.toString");
        }
    }
};
//#endregion
//#region src/Machine.js
var $394755e62edee9eb$var$Queue = class {
    constructor(numInst){
        this.sparse = new Int32Array(numInst);
        this.densePcs = new Int32Array(numInst);
        this.denseCaps = null;
        this.size = 0;
        this.ncap = 0;
    }
    init(ncap) {
        this.ncap = ncap;
        const needed = this.densePcs.length * ncap;
        if (!this.denseCaps || this.denseCaps.length < needed) this.denseCaps = new Int32Array(needed);
    }
    contains(pc) {
        const j = this.sparse[pc];
        return j < this.size && this.densePcs[j] === pc;
    }
    isEmpty() {
        return this.size === 0;
    }
    add(pc) {
        const j = this.size++;
        this.sparse[pc] = j;
        this.densePcs[j] = pc;
        return j;
    }
    clear() {
        this.size = 0;
    }
    toString() {
        let out = "{";
        for(let i = 0; i < this.size; i++){
            if (i !== 0) out += ", ";
            out += this.densePcs[i];
        }
        out += "}";
        return out;
    }
};
var $394755e62edee9eb$var$Machine = class Machine {
    static fromRE2(re2) {
        const m = new Machine();
        m.prog = re2.prog;
        m.re2 = re2;
        m.q0 = new $394755e62edee9eb$var$Queue(m.prog.numInst());
        m.q1 = new $394755e62edee9eb$var$Queue(m.prog.numInst());
        m.matched = false;
        m.matchcap = new Int32Array(m.prog.numCap < 2 ? 2 : m.prog.numCap);
        m.ncap = 0;
        return m;
    }
    static fromMachine(machine) {
        return Machine.fromRE2(machine.re2);
    }
    constructor(){
        this.prog = null;
        this.re2 = null;
        this.q0 = null;
        this.q1 = null;
        this.matched = false;
        this.matchcap = null;
        this.ncap = 0;
        this.lbTable = null;
    }
    init(ncap) {
        this.ncap = ncap;
        if (ncap > this.matchcap.length) this.matchcap = new Int32Array(ncap).fill(-1);
        else this.matchcap.fill(-1);
        this.q0.init(ncap);
        this.q1.init(ncap);
        if (this.prog.numLb > 0) {
            if (!this.lbTable || this.lbTable.length < this.prog.numLb + 1) this.lbTable = new Int32Array(this.prog.numLb + 1);
            this.lbTable.fill(-1);
        }
    }
    submatches() {
        if (this.ncap === 0) return $394755e62edee9eb$var$Utils.emptyInts();
        return $394755e62edee9eb$var$Utils.toArray(this.matchcap.subarray(0, this.ncap));
    }
    match(input, pos, anchor) {
        const startCond = this.re2.cond;
        if (startCond === $394755e62edee9eb$var$Utils.EMPTY_ALL) return false;
        if ((anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_START || anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH) && pos !== 0) return false;
        this.matched = false;
        this.matchcap.fill(-1);
        let currentPos = this.prog.numLb > 0 ? 0 : pos;
        let matchStartPos = pos;
        let runq = this.q0;
        let nextq = this.q1;
        let r = input.step(currentPos);
        let rune = r >> 3;
        let width = r & 7;
        let rune1 = -1;
        let width1 = 0;
        if (r !== $394755e62edee9eb$var$MachineInputBase.EOF()) {
            r = input.step(currentPos + width);
            rune1 = r >> 3;
            width1 = r & 7;
        }
        let flag;
        if (currentPos === 0) flag = $394755e62edee9eb$var$Utils.emptyOpContext(-1, rune);
        else flag = input.context(currentPos);
        while(true){
            if (runq.isEmpty()) {
                if ((startCond & $394755e62edee9eb$var$Utils.EMPTY_BEGIN_TEXT) !== 0 && currentPos !== 0) break;
                if ((anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_START || anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH) && currentPos !== 0) break;
                if (this.matched) break;
                if (this.prog.numLb === 0 && !(this.re2.prefix.length === 0) && rune1 !== this.re2.prefixRune && input.canCheckPrefix()) {
                    const advance = input.index(this.re2, currentPos);
                    if (advance < 0) break;
                    currentPos += advance;
                    r = input.step(currentPos);
                    rune = r >> 3;
                    width = r & 7;
                    r = input.step(currentPos + width);
                    rune1 = r >> 3;
                    width1 = r & 7;
                    flag = input.context(currentPos);
                }
            }
            if (currentPos === 0 && this.prog.numLb > 0) for(let i = 0; i < this.prog.lbStarts.length; i++)this.add(runq, this.prog.lbStarts[i], currentPos, this.matchcap, 0, flag);
            if (!this.matched && (currentPos === 0 || anchor === $394755e62edee9eb$var$RE2Flags.UNANCHORED)) {
                if (currentPos >= matchStartPos) {
                    if (this.ncap > 0) this.matchcap[0] = currentPos;
                    this.add(runq, this.prog.start, currentPos, this.matchcap, 0, flag);
                }
            }
            const nextPos = currentPos + width;
            flag = input.context(nextPos);
            this.step(runq, nextq, currentPos, nextPos, rune, flag, anchor, currentPos === input.endPos());
            if (width === 0) break;
            if (this.ncap === 0 && this.matched) break;
            currentPos += width;
            rune = rune1;
            width = width1;
            if (rune !== -1) {
                r = input.step(currentPos + width);
                rune1 = r >> 3;
                width1 = r & 7;
            }
            const tmpq = runq;
            runq = nextq;
            nextq = tmpq;
        }
        nextq.clear();
        return this.matched;
    }
    matchSet(input, pos, anchor) {
        const startCond = this.re2.cond;
        if (startCond === $394755e62edee9eb$var$Utils.EMPTY_ALL) return [];
        if ((anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_START || anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH) && pos !== 0) return [];
        let currentPos = this.prog.numLb > 0 ? 0 : pos;
        let matchStartPos = pos;
        let runq = this.q0;
        let nextq = this.q1;
        let r = input.step(currentPos);
        let rune = r >> 3;
        let width = r & 7;
        let rune1 = -1;
        let width1 = 0;
        if (r !== $394755e62edee9eb$var$MachineInputBase.EOF()) {
            r = input.step(currentPos + width);
            rune1 = r >> 3;
            width1 = r & 7;
        }
        let flag = currentPos === 0 ? $394755e62edee9eb$var$Utils.emptyOpContext(-1, rune) : input.context(currentPos);
        const matches = /* @__PURE__ */ new Set();
        while(true){
            if (runq.isEmpty()) {
                if ((startCond & $394755e62edee9eb$var$Utils.EMPTY_BEGIN_TEXT) !== 0 && currentPos !== 0) break;
                if ((anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_START || anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH) && currentPos !== 0) break;
            }
            if (currentPos === 0 && this.prog.numLb > 0) for(let i = 0; i < this.prog.lbStarts.length; i++)this.add(runq, this.prog.lbStarts[i], currentPos, this.matchcap, 0, flag);
            if (currentPos === 0 || anchor === $394755e62edee9eb$var$RE2Flags.UNANCHORED) {
                if (currentPos >= matchStartPos) this.add(runq, this.prog.start, currentPos, this.matchcap, 0, flag);
            }
            const nextPos = currentPos + width;
            flag = input.context(nextPos);
            for(let j = 0; j < runq.size; j++){
                const pc = runq.densePcs[j];
                const i = this.prog.inst[pc];
                const capOffset = j * this.ncap;
                let add = false;
                switch(i.op){
                    case $394755e62edee9eb$var$Inst.MATCH:
                        if (anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH && currentPos !== input.endPos()) break;
                        matches.add(i.arg);
                        break;
                    case $394755e62edee9eb$var$Inst.RUNE:
                        add = i.matchRune(rune);
                        break;
                    case $394755e62edee9eb$var$Inst.RUNE1:
                        add = rune === i.runes[0];
                        break;
                    case $394755e62edee9eb$var$Inst.RUNE_ANY:
                        add = true;
                        break;
                    case $394755e62edee9eb$var$Inst.RUNE_ANY_NOT_NL:
                        add = rune !== 10;
                        break;
                    default:
                        continue;
                }
                if (add) this.add(nextq, i.out, nextPos, runq.denseCaps, capOffset, flag);
            }
            runq.clear();
            if (width === 0) break;
            currentPos += width;
            rune = rune1;
            width = width1;
            if (rune !== -1) {
                r = input.step(currentPos + width);
                rune1 = r >> 3;
                width1 = r & 7;
            }
            const tmpq = runq;
            runq = nextq;
            nextq = tmpq;
        }
        nextq.clear();
        return Array.from(matches).sort((a, b)=>a - b);
    }
    step(runq, nextq, pos, nextPos, c, nextCond, anchor, atEnd) {
        const longest = this.re2.longest;
        for(let j = 0; j < runq.size; j++){
            const pc = runq.densePcs[j];
            const capOffset = j * this.ncap;
            if (longest && this.matched && this.ncap > 0 && this.matchcap[0] < runq.denseCaps[capOffset]) continue;
            const i = this.prog.inst[pc];
            let add = false;
            switch(i.op){
                case $394755e62edee9eb$var$Inst.MATCH:
                    if (anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH && !atEnd) break;
                    if (this.ncap > 0 && (!longest || !this.matched || this.matchcap[1] < pos)) {
                        runq.denseCaps[capOffset + 1] = pos;
                        for(let k = 0; k < this.ncap; k++)this.matchcap[k] = runq.denseCaps[capOffset + k];
                    }
                    if (!longest) runq.size = 0;
                    this.matched = true;
                    break;
                case $394755e62edee9eb$var$Inst.RUNE:
                    add = i.matchRune(c);
                    break;
                case $394755e62edee9eb$var$Inst.RUNE1:
                    add = c === i.runes[0];
                    break;
                case $394755e62edee9eb$var$Inst.RUNE_ANY:
                    add = true;
                    break;
                case $394755e62edee9eb$var$Inst.RUNE_ANY_NOT_NL:
                    add = c !== 10;
                    break;
                default:
                    continue;
            }
            if (add) this.add(nextq, i.out, nextPos, runq.denseCaps, capOffset, nextCond);
        }
        runq.clear();
    }
    add(q, pc, pos, capArray, capOffset, cond) {
        while(true){
            if (pc === 0) return;
            if (q.contains(pc)) return;
            const d = q.add(pc);
            const inst = this.prog.inst[pc];
            switch(inst.op){
                case $394755e62edee9eb$var$Inst.FAIL:
                    return;
                case $394755e62edee9eb$var$Inst.ALT:
                case $394755e62edee9eb$var$Inst.ALT_MATCH:
                    this.add(q, inst.out, pos, capArray, capOffset, cond);
                    pc = inst.arg;
                    continue;
                case $394755e62edee9eb$var$Inst.EMPTY_WIDTH:
                    if ((inst.arg & ~cond) === 0) {
                        pc = inst.out;
                        continue;
                    }
                    return;
                case $394755e62edee9eb$var$Inst.NOP:
                    pc = inst.out;
                    continue;
                case $394755e62edee9eb$var$Inst.CAPTURE:
                    if (inst.arg < this.ncap) {
                        const opos = capArray[capOffset + inst.arg];
                        capArray[capOffset + inst.arg] = pos;
                        this.add(q, inst.out, pos, capArray, capOffset, cond);
                        capArray[capOffset + inst.arg] = opos;
                        return;
                    } else {
                        pc = inst.out;
                        continue;
                    }
                case $394755e62edee9eb$var$Inst.LB_WRITE:
                    this.lbTable[Math.abs(inst.arg)] = pos;
                    pc = inst.out;
                    continue;
                case $394755e62edee9eb$var$Inst.LB_CHECK:
                    if (inst.arg > 0) {
                        if (this.lbTable[inst.arg] === pos) {
                            pc = inst.out;
                            continue;
                        }
                    } else if (this.lbTable[-inst.arg] !== pos) {
                        pc = inst.out;
                        continue;
                    }
                    return;
                case $394755e62edee9eb$var$Inst.MATCH:
                case $394755e62edee9eb$var$Inst.RUNE:
                case $394755e62edee9eb$var$Inst.RUNE1:
                case $394755e62edee9eb$var$Inst.RUNE_ANY:
                case $394755e62edee9eb$var$Inst.RUNE_ANY_NOT_NL:
                    if (this.ncap > 0) {
                        const destOffset = d * this.ncap;
                        for(let c = 0; c < this.ncap; c++)q.denseCaps[destOffset + c] = capArray[capOffset + c];
                    }
                    return;
                default:
                    throw new $394755e62edee9eb$export$3a148716bb6e0468("unhandled");
            }
        }
    }
};
//#endregion
//#region src/DFA.js
const $394755e62edee9eb$var$hashPCs = (pcs)=>{
    let h = -2128831035;
    for(let i = 0; i < pcs.length; i++){
        h ^= pcs[i];
        h = Math.imul(h, 16777619);
    }
    return h;
};
const $394755e62edee9eb$var$arraysEqual = (a, b)=>{
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++)if (a[i] !== b[i]) return false;
    return true;
};
var $394755e62edee9eb$var$DFAState = class {
    constructor(nfaStates, isMatch, matchIDs = []){
        this.nfaStates = nfaStates;
        this.isMatch = isMatch;
        this.matchIDs = matchIDs;
        this.nextLatin1 = new Array($394755e62edee9eb$var$Unicode.MAX_LATIN1 + 1).fill(null);
        this.nextLatin1Anchored = new Array($394755e62edee9eb$var$Unicode.MAX_LATIN1 + 1).fill(null);
        this.transKeys = [];
        this.transVals = [];
        this.lastSeen = 0;
    }
};
var $394755e62edee9eb$var$DFA = class DFA {
    static MAX_CACHE_CLEARS = 5;
    static STATE_MEMORY_ESTIMATE = 838;
    constructor(prog, maxMem = 8388608){
        this.prog = prog;
        this.stateCache = /* @__PURE__ */ new Map();
        this.stateCount = 0;
        this.startState = null;
        this.stateLimit = Math.max(1, Math.floor(maxMem / DFA.STATE_MEMORY_ESTIMATE));
        this.cacheClears = 0;
        this.failed = false;
        this.clock = 0;
    }
    computeClosure(pcs) {
        const closure = /* @__PURE__ */ new Set();
        const stack = [
            ...pcs
        ];
        let isMatch = false;
        const matchIDs = [];
        while(stack.length > 0){
            const pc = stack.pop();
            if (closure.has(pc)) continue;
            closure.add(pc);
            const inst = this.prog.getInst(pc);
            switch(inst.op){
                case $394755e62edee9eb$var$Inst.MATCH:
                    isMatch = true;
                    if (!matchIDs.includes(inst.arg)) matchIDs.push(inst.arg);
                    break;
                case $394755e62edee9eb$var$Inst.ALT:
                case $394755e62edee9eb$var$Inst.ALT_MATCH:
                    stack.push(inst.out);
                    stack.push(inst.arg);
                    break;
                case $394755e62edee9eb$var$Inst.NOP:
                case $394755e62edee9eb$var$Inst.CAPTURE:
                    stack.push(inst.out);
                    break;
                case $394755e62edee9eb$var$Inst.EMPTY_WIDTH:
                case $394755e62edee9eb$var$Inst.LB_WRITE:
                case $394755e62edee9eb$var$Inst.LB_CHECK:
                    return null;
            }
        }
        const sortedPCs = Int32Array.from(closure).sort();
        matchIDs.sort((a, b)=>a - b);
        return {
            pcs: sortedPCs,
            isMatch: isMatch,
            matchIDs: matchIDs
        };
    }
    getState(pcs) {
        const closureResult = this.computeClosure(pcs);
        if (!closureResult) return null;
        const sortedPCs = closureResult.pcs;
        const hash = $394755e62edee9eb$var$hashPCs(sortedPCs);
        let bucket = this.stateCache.get(hash);
        if (bucket) for(let i = 0; i < bucket.length; i++){
            const state = bucket[i];
            if ($394755e62edee9eb$var$arraysEqual(state.nfaStates, sortedPCs)) {
                state.lastSeen = ++this.clock;
                return state;
            }
        }
        else {
            bucket = [];
            this.stateCache.set(hash, bucket);
        }
        if (this.failed) return null;
        if (this.stateCount >= this.stateLimit) {
            this.cacheClears++;
            if (this.cacheClears >= DFA.MAX_CACHE_CLEARS) {
                this.failed = true;
                this.stateCache.clear();
                this.stateCount = 0;
                this.startState = null;
                return null;
            }
            this.evictCache();
            bucket = this.stateCache.get(hash);
            if (!bucket) {
                bucket = [];
                this.stateCache.set(hash, bucket);
            }
        }
        const state = new $394755e62edee9eb$var$DFAState(sortedPCs, closureResult.isMatch, closureResult.matchIDs);
        state.lastSeen = ++this.clock;
        bucket.push(state);
        this.stateCount++;
        return state;
    }
    evictCache() {
        const allStates = [];
        for (const bucket of this.stateCache.values())for(let i = 0; i < bucket.length; i++)allStates.push(bucket[i]);
        allStates.sort((a, b)=>a.lastSeen - b.lastSeen);
        const keepCount = Math.max(1, Math.floor(this.stateLimit / 2));
        const startIndex = allStates.length - keepCount;
        const survivorsArray = allStates.slice(startIndex);
        const survivors = new Set(survivorsArray);
        this.stateCache.clear();
        this.stateCount = 0;
        for(let i = 0; i < survivorsArray.length; i++){
            const state = survivorsArray[i];
            state.nextLatin1.fill(null);
            state.nextLatin1Anchored.fill(null);
            state.transKeys.length = 0;
            state.transVals.length = 0;
            const hash = $394755e62edee9eb$var$hashPCs(state.nfaStates);
            let bucket = this.stateCache.get(hash);
            if (!bucket) {
                bucket = [];
                this.stateCache.set(hash, bucket);
            }
            bucket.push(state);
            this.stateCount++;
        }
        if (this.startState && !survivors.has(this.startState)) this.startState = null;
    }
    step(state, charCode, anchor) {
        if (charCode <= $394755e62edee9eb$var$Unicode.MAX_LATIN1) {
            if (anchor === $394755e62edee9eb$var$RE2Flags.UNANCHORED) {
                const next = state.nextLatin1[charCode];
                if (next !== null) return next;
            } else {
                const next = state.nextLatin1Anchored[charCode];
                if (next !== null) return next;
            }
        } else {
            const key = charCode + (anchor === $394755e62edee9eb$var$RE2Flags.UNANCHORED ? 0 : $394755e62edee9eb$var$Unicode.MAX_RUNE + 1);
            const keys = state.transKeys;
            const len = keys.length;
            for(let i = 0; i < len; i++)if (keys[i] === key) return state.transVals[i];
        }
        const nextPCs = [];
        for(let i = 0; i < state.nfaStates.length; i++){
            const pc = state.nfaStates[i];
            const inst = this.prog.getInst(pc);
            if ($394755e62edee9eb$var$Inst.isRuneOp(inst.op) && inst.matchRune(charCode)) nextPCs.push(inst.out);
        }
        if (anchor === $394755e62edee9eb$var$RE2Flags.UNANCHORED) nextPCs.push(this.prog.start);
        const nextState = this.getState(nextPCs);
        if (charCode <= $394755e62edee9eb$var$Unicode.MAX_LATIN1) {
            if (anchor === $394755e62edee9eb$var$RE2Flags.UNANCHORED) state.nextLatin1[charCode] = nextState;
            else state.nextLatin1Anchored[charCode] = nextState;
        } else {
            const key = charCode + (anchor === $394755e62edee9eb$var$RE2Flags.UNANCHORED ? 0 : $394755e62edee9eb$var$Unicode.MAX_RUNE + 1);
            state.transKeys.push(key);
            state.transVals.push(nextState);
        }
        return nextState;
    }
    match(input, pos, anchor) {
        if ((anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_START || anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH) && pos !== 0) return false;
        if (!this.startState) {
            this.startState = this.getState([
                this.prog.start
            ]);
            if (!this.startState) return null;
        }
        let endPos = input.endPos();
        let currentState = this.startState;
        if (currentState.isMatch) {
            if (anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH) {
                if (pos === endPos) return true;
            } else return true;
        }
        let i = pos;
        while(i < endPos){
            const r = input.step(i);
            const rune = r >> 3;
            const width = r & 7;
            if (width === 0) break;
            currentState = anchor === $394755e62edee9eb$var$RE2Flags.UNANCHORED && rune <= $394755e62edee9eb$var$Unicode.MAX_LATIN1 && currentState.nextLatin1[rune] || this.step(currentState, rune, anchor);
            if (currentState === null) return null;
            currentState.lastSeen = ++this.clock;
            if (currentState.isMatch) {
                if (anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH) {
                    if (i + width === endPos) return true;
                } else return true;
            }
            if (currentState.nfaStates.length === 0) {
                if (anchor !== $394755e62edee9eb$var$RE2Flags.UNANCHORED) return false;
            }
            i += width;
        }
        return false;
    }
    matchSet(input, pos, anchor) {
        if ((anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_START || anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH) && pos !== 0) return [];
        if (!this.startState) {
            this.startState = this.getState([
                this.prog.start
            ]);
            if (!this.startState) return null;
        }
        let endPos = input.endPos();
        let currentState = this.startState;
        const matches = /* @__PURE__ */ new Set();
        const checkMatch = (state, currentPos)=>{
            if (state.isMatch) {
                if (anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH) {
                    if (currentPos === endPos) state.matchIDs.forEach((id)=>matches.add(id));
                } else state.matchIDs.forEach((id)=>matches.add(id));
            }
        };
        checkMatch(currentState, pos);
        let i = pos;
        while(i < endPos){
            const r = input.step(i);
            const rune = r >> 3;
            const width = r & 7;
            if (width === 0) break;
            currentState = anchor === $394755e62edee9eb$var$RE2Flags.UNANCHORED && rune <= $394755e62edee9eb$var$Unicode.MAX_LATIN1 && currentState.nextLatin1[rune] || this.step(currentState, rune, anchor);
            if (currentState === null) return null;
            currentState.lastSeen = ++this.clock;
            i += width;
            checkMatch(currentState, i);
            if (currentState.nfaStates.length === 0) {
                if (anchor !== $394755e62edee9eb$var$RE2Flags.UNANCHORED) break;
            }
        }
        return Array.from(matches).sort((a, b)=>a - b);
    }
};
//#endregion
//#region src/Backtracker.js
const $394755e62edee9eb$var$VISITED_BITS = 32;
const $394755e62edee9eb$var$MAX_BACKTRACK_PROG = 500;
const $394755e62edee9eb$var$INITIAL_JOB_CAPACITY = 256;
const $394755e62edee9eb$var$MAX_BACKTRACK_VECTOR = 262144;
var $394755e62edee9eb$var$BitState = class {
    constructor(){
        this.end = 0;
        this.cap = /* @__PURE__ */ new Int32Array(0);
        this.matchcap = /* @__PURE__ */ new Int32Array(0);
        this.ncap = 0;
        this.jobPc = new Int32Array($394755e62edee9eb$var$INITIAL_JOB_CAPACITY);
        this.jobArg = new Uint8Array($394755e62edee9eb$var$INITIAL_JOB_CAPACITY);
        this.jobPos = new Int32Array($394755e62edee9eb$var$INITIAL_JOB_CAPACITY);
        this.jobLen = 0;
        this.visited = /* @__PURE__ */ new Uint32Array(0);
    }
    reset(prog, end, ncap) {
        this.end = end;
        this.jobLen = 0;
        this.ncap = ncap;
        const visitedSize = prog.numInst() * (end + 1) + $394755e62edee9eb$var$VISITED_BITS - 1 >>> 5;
        if (this.visited.length < visitedSize) this.visited = new Uint32Array(visitedSize);
        else this.visited.fill(0, 0, visitedSize);
        if (this.cap.length < ncap) this.cap = new Int32Array(ncap).fill(-1);
        else this.cap.fill(-1, 0, ncap);
        if (this.matchcap.length < ncap) this.matchcap = new Int32Array(ncap).fill(-1);
        else this.matchcap.fill(-1, 0, ncap);
    }
    shouldVisit(pc, pos) {
        const n = pc * (this.end + 1) + pos;
        const idx = n >>> 5;
        const mask = 1 << (n & 31);
        if ((this.visited[idx] & mask) !== 0) return false;
        this.visited[idx] |= mask;
        return true;
    }
    push(re2, pc, pos, arg) {
        if (re2.prog.getInst(pc).op !== $394755e62edee9eb$var$Inst.FAIL && (arg || this.shouldVisit(pc, pos))) {
            if (this.jobLen >= this.jobPc.length) {
                const newSize = this.jobPc.length * 2;
                const newPc = new Int32Array(newSize);
                newPc.set(this.jobPc);
                this.jobPc = newPc;
                const newArg = new Uint8Array(newSize);
                newArg.set(this.jobArg);
                this.jobArg = newArg;
                const newPos = new Int32Array(newSize);
                newPos.set(this.jobPos);
                this.jobPos = newPos;
            }
            this.jobPc[this.jobLen] = pc;
            this.jobArg[this.jobLen] = arg ? 1 : 0;
            this.jobPos[this.jobLen] = pos;
            this.jobLen++;
        }
    }
    tryBacktrack(re2, input, pc, pos, anchor) {
        const longest = re2.longest;
        this.push(re2, pc, pos, false);
        while(this.jobLen > 0){
            this.jobLen--;
            let currentPc = this.jobPc[this.jobLen];
            let arg = this.jobArg[this.jobLen] === 1;
            let currentPos = this.jobPos[this.jobLen];
            let skipShouldVisit = true;
            while(true){
                if (!skipShouldVisit) {
                    if (!this.shouldVisit(currentPc, currentPos)) break;
                }
                skipShouldVisit = false;
                const inst = re2.prog.getInst(currentPc);
                switch(inst.op){
                    case $394755e62edee9eb$var$Inst.FAIL:
                        throw new $394755e62edee9eb$export$3a148716bb6e0468("unexpected InstFail");
                    case $394755e62edee9eb$var$Inst.ALT:
                        if (arg) {
                            arg = false;
                            currentPc = inst.arg;
                            continue;
                        } else {
                            this.push(re2, currentPc, currentPos, true);
                            currentPc = inst.out;
                            continue;
                        }
                    case $394755e62edee9eb$var$Inst.ALT_MATCH:
                        {
                            const outInst = re2.prog.getInst(inst.out);
                            if ($394755e62edee9eb$var$Inst.isRuneOp(outInst.op)) {
                                this.push(re2, inst.arg, currentPos, false);
                                currentPc = inst.arg;
                                currentPos = this.end;
                                continue;
                            }
                            this.push(re2, inst.out, this.end, false);
                            currentPc = inst.out;
                            continue;
                        }
                    case $394755e62edee9eb$var$Inst.RUNE:
                        {
                            const r = input.step(currentPos);
                            if (r === $394755e62edee9eb$var$MachineInputBase.EOF()) break;
                            if (!inst.matchRune(r >> 3)) break;
                            currentPos += r & 7;
                            currentPc = inst.out;
                            continue;
                        }
                    case $394755e62edee9eb$var$Inst.RUNE1:
                        {
                            const r = input.step(currentPos);
                            if (r === $394755e62edee9eb$var$MachineInputBase.EOF()) break;
                            if (r >> 3 !== inst.runes[0]) break;
                            currentPos += r & 7;
                            currentPc = inst.out;
                            continue;
                        }
                    case $394755e62edee9eb$var$Inst.RUNE_ANY_NOT_NL:
                        {
                            const r = input.step(currentPos);
                            if (r === $394755e62edee9eb$var$MachineInputBase.EOF()) break;
                            if (r >> 3 === 10) break;
                            currentPos += r & 7;
                            currentPc = inst.out;
                            continue;
                        }
                    case $394755e62edee9eb$var$Inst.RUNE_ANY:
                        {
                            const r = input.step(currentPos);
                            if (r === $394755e62edee9eb$var$MachineInputBase.EOF()) break;
                            currentPos += r & 7;
                            currentPc = inst.out;
                            continue;
                        }
                    case $394755e62edee9eb$var$Inst.CAPTURE:
                        if (arg) {
                            this.cap[inst.arg] = currentPos;
                            break;
                        } else {
                            if (inst.arg < this.ncap) {
                                this.push(re2, currentPc, this.cap[inst.arg], true);
                                this.cap[inst.arg] = currentPos;
                            }
                            currentPc = inst.out;
                            continue;
                        }
                    case $394755e62edee9eb$var$Inst.EMPTY_WIDTH:
                        {
                            const flag = input.context(currentPos);
                            if ((inst.arg & ~flag) !== 0) break;
                            currentPc = inst.out;
                            continue;
                        }
                    case $394755e62edee9eb$var$Inst.NOP:
                        currentPc = inst.out;
                        continue;
                    case $394755e62edee9eb$var$Inst.MATCH:
                        {
                            if (anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH && currentPos !== this.end) break;
                            if (this.ncap === 0) return true;
                            if (this.ncap > 1) this.cap[1] = currentPos;
                            const old = this.matchcap[1];
                            if (old === -1 || longest && currentPos > 0 && currentPos > old) this.matchcap.set(this.cap);
                            if (!longest) return true;
                            if (currentPos === this.end) return true;
                            break;
                        }
                    case $394755e62edee9eb$var$Inst.LB_WRITE:
                    case $394755e62edee9eb$var$Inst.LB_CHECK:
                        throw new $394755e62edee9eb$export$3a148716bb6e0468("Backtracker cannot evaluate Lookbehind instructions");
                    default:
                        throw new $394755e62edee9eb$export$3a148716bb6e0468("bad inst");
                }
                break;
            }
        }
        return longest && this.matchcap.length > 1 && this.matchcap[1] >= 0;
    }
};
const $394755e62edee9eb$var$bitStatePool = [];
var $394755e62edee9eb$var$Backtracker = class Backtracker {
    static shouldBacktrack(prog) {
        return prog.numInst() <= $394755e62edee9eb$var$MAX_BACKTRACK_PROG;
    }
    static maxBitStateLen(prog) {
        if (!Backtracker.shouldBacktrack(prog)) return 0;
        return Math.floor($394755e62edee9eb$var$MAX_BACKTRACK_VECTOR / prog.numInst());
    }
    static execute(re2, input, pos, anchor, ncap) {
        const startCond = re2.cond;
        if (startCond === $394755e62edee9eb$var$Utils.EMPTY_ALL) return null;
        if ((anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_START || anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH) && pos !== 0) return null;
        if ((startCond & $394755e62edee9eb$var$Utils.EMPTY_BEGIN_TEXT) !== 0 && pos !== 0) return null;
        const b = $394755e62edee9eb$var$bitStatePool.length > 0 ? $394755e62edee9eb$var$bitStatePool.pop() : new $394755e62edee9eb$var$BitState();
        const end = input.endPos();
        b.reset(re2.prog, end, ncap);
        let matched = false;
        if ((startCond & $394755e62edee9eb$var$Utils.EMPTY_BEGIN_TEXT) !== 0 || anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_START || anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH) {
            if (b.ncap > 0) b.cap[0] = pos;
            if (b.tryBacktrack(re2, input, re2.prog.start, pos, anchor)) matched = true;
        } else {
            let width = -1;
            for(; pos <= end && width !== 0; pos += width){
                if (re2.prefix.length > 0) {
                    const advance = input.index(re2, pos);
                    if (advance < 0) break;
                    pos += advance;
                }
                if (b.ncap > 0) b.cap[0] = pos;
                if (b.tryBacktrack(re2, input, re2.prog.start, pos, anchor)) {
                    matched = true;
                    break;
                }
                const r = input.step(pos);
                width = r === $394755e62edee9eb$var$MachineInputBase.EOF() ? 0 : r & 7;
            }
        }
        if (!matched) {
            $394755e62edee9eb$var$bitStatePool.push(b);
            return null;
        }
        const result = ncap === 0 ? [] : $394755e62edee9eb$var$Utils.toArray(b.matchcap.subarray(0, ncap));
        $394755e62edee9eb$var$bitStatePool.push(b);
        return result;
    }
};
//#endregion
//#region src/OnePass.js
var $394755e62edee9eb$var$QueueOnePass = class {
    constructor(size){
        this.sparse = new Uint32Array(size);
        this.dense = new Uint32Array(size);
        this.size = 0;
        this.nextIndex = 0;
    }
    empty() {
        return this.nextIndex >= this.size;
    }
    next() {
        return this.dense[this.nextIndex++];
    }
    clear() {
        this.size = 0;
        this.nextIndex = 0;
    }
    contains(u) {
        return u < this.sparse.length && this.sparse[u] < this.size && this.dense[this.sparse[u]] === u;
    }
    insert(u) {
        if (!this.contains(u)) this.insertNew(u);
    }
    insertNew(u) {
        if (u >= this.sparse.length) return;
        this.sparse[u] = this.size;
        this.dense[this.size] = u;
        this.size++;
    }
};
const $394755e62edee9eb$var$mergeRuneSets = (leftRunes, rightRunes, leftPC, rightPC)=>{
    const leftLen = leftRunes.length;
    const rightLen = rightRunes.length;
    let lx = 0, rx = 0;
    const merged = [];
    const next = [];
    let ok = true;
    let ix = -1;
    const extend = (isLeft)=>{
        const newArray = isLeft ? leftRunes : rightRunes;
        const low = isLeft ? lx : rx;
        const pc = isLeft ? leftPC : rightPC;
        if (ix > 0 && newArray[low] <= merged[ix]) return false;
        merged.push(newArray[low], newArray[low + 1]);
        if (isLeft) lx += 2;
        else rx += 2;
        ix += 2;
        next.push(pc);
        return true;
    };
    while(lx < leftLen || rx < rightLen){
        if (rx >= rightLen) ok = extend(true);
        else if (lx >= leftLen) ok = extend(false);
        else if (rightRunes[rx] < leftRunes[lx]) ok = extend(false);
        else ok = extend(true);
        if (!ok) return null;
    }
    return {
        merged: merged,
        next: next
    };
};
var $394755e62edee9eb$var$OnePassProg = class {
    constructor(prog){
        this.start = prog.start;
        this.numCap = prog.numCap;
        this.inst = new Array(prog.inst.length);
        for(let i = 0; i < prog.inst.length; i++){
            const orig = prog.inst[i];
            const inst = new $394755e62edee9eb$var$Inst(orig.op);
            inst.out = orig.out;
            inst.arg = orig.arg;
            inst.runes = orig.runes ? orig.runes.slice() : [];
            inst.next = null;
            this.inst[i] = inst;
        }
    }
};
const $394755e62edee9eb$var$onePassCopy = (prog)=>{
    const p = new $394755e62edee9eb$var$OnePassProg(prog);
    for(let pc = 0; pc < p.inst.length; pc++){
        const inst = p.inst[pc];
        if (inst.op !== $394755e62edee9eb$var$Inst.ALT && inst.op !== $394755e62edee9eb$var$Inst.ALT_MATCH) continue;
        let pAOther = "out";
        let pAAlt = "arg";
        let instAlt = p.inst[inst[pAAlt]];
        if (instAlt.op !== $394755e62edee9eb$var$Inst.ALT && instAlt.op !== $394755e62edee9eb$var$Inst.ALT_MATCH) {
            pAOther = "arg";
            pAAlt = "out";
            instAlt = p.inst[inst[pAAlt]];
            if (instAlt.op !== $394755e62edee9eb$var$Inst.ALT && instAlt.op !== $394755e62edee9eb$var$Inst.ALT_MATCH) continue;
        }
        const instOther = p.inst[inst[pAOther]];
        if (instOther.op === $394755e62edee9eb$var$Inst.ALT || instOther.op === $394755e62edee9eb$var$Inst.ALT_MATCH) continue;
        let pBAlt = "out";
        let pBOther = "arg";
        let patch = false;
        if (instAlt.out === pc) patch = true;
        else if (instAlt.arg === pc) {
            patch = true;
            pBAlt = "arg";
            pBOther = "out";
        }
        if (patch) instAlt[pBAlt] = inst[pAOther];
        if (inst[pAOther] === instAlt[pBAlt]) inst[pAAlt] = instAlt[pBOther];
    }
    return p;
};
const $394755e62edee9eb$var$makeOnePass = (p)=>{
    if (p.inst.length >= 1e3) return null;
    const instQueue = new $394755e62edee9eb$var$QueueOnePass(p.inst.length);
    const visitQueue = new $394755e62edee9eb$var$QueueOnePass(p.inst.length);
    const onePassRunes = new Array(p.inst.length);
    const m = new Array(p.inst.length).fill(false);
    const check = (pc)=>{
        let ok = true;
        const inst = p.inst[pc];
        if (visitQueue.contains(pc)) return true;
        visitQueue.insert(pc);
        switch(inst.op){
            case $394755e62edee9eb$var$Inst.ALT:
            case $394755e62edee9eb$var$Inst.ALT_MATCH:
                {
                    ok = check(inst.out) && check(inst.arg);
                    let matchOut = m[inst.out];
                    let matchArg = m[inst.arg];
                    if (matchOut && matchArg) return false;
                    if (matchArg) {
                        const tempOut = inst.out;
                        inst.out = inst.arg;
                        inst.arg = tempOut;
                        const tempMatch = matchOut;
                        matchOut = matchArg;
                        matchArg = tempMatch;
                    }
                    if (matchOut) {
                        m[pc] = true;
                        inst.op = $394755e62edee9eb$var$Inst.ALT_MATCH;
                    }
                    const leftRunes = onePassRunes[inst.out] || [];
                    const rightRunes = onePassRunes[inst.arg] || [];
                    const mergeRes = $394755e62edee9eb$var$mergeRuneSets(leftRunes, rightRunes, inst.out, inst.arg);
                    if (!mergeRes) return false;
                    onePassRunes[pc] = mergeRes.merged;
                    inst.next = new Uint32Array(mergeRes.next);
                    break;
                }
            case $394755e62edee9eb$var$Inst.CAPTURE:
            case $394755e62edee9eb$var$Inst.EMPTY_WIDTH:
            case $394755e62edee9eb$var$Inst.NOP:
                ok = check(inst.out);
                m[pc] = m[inst.out];
                onePassRunes[pc] = onePassRunes[inst.out] ? onePassRunes[inst.out].slice() : [];
                inst.next = new Uint32Array(Math.floor(onePassRunes[pc].length / 2) + 1).fill(inst.out);
                break;
            case $394755e62edee9eb$var$Inst.MATCH:
            case $394755e62edee9eb$var$Inst.FAIL:
                m[pc] = inst.op === $394755e62edee9eb$var$Inst.MATCH;
                break;
            case $394755e62edee9eb$var$Inst.RUNE:
                {
                    m[pc] = false;
                    if (inst.next && inst.next.length > 0) break;
                    instQueue.insert(inst.out);
                    if (!inst.runes || inst.runes.length === 0) {
                        onePassRunes[pc] = [];
                        inst.next = new Uint32Array([
                            inst.out
                        ]);
                        break;
                    }
                    let runes = [];
                    if (inst.runes.length === 1 && (inst.arg & $394755e62edee9eb$var$RE2Flags.FOLD_CASE) !== 0) {
                        const r0 = inst.runes[0];
                        runes.push(r0, r0);
                        for(let r1 = $394755e62edee9eb$var$Unicode.simpleFold(r0); r1 !== r0; r1 = $394755e62edee9eb$var$Unicode.simpleFold(r1))runes.push(r1, r1);
                        runes.sort((a, b)=>a - b);
                    } else for(let j = 0; j < inst.runes.length; j++)runes.push(inst.runes[j]);
                    onePassRunes[pc] = runes;
                    inst.next = new Uint32Array(Math.floor(runes.length / 2) + 1).fill(inst.out);
                    inst.op = $394755e62edee9eb$var$Inst.RUNE;
                    break;
                }
            case $394755e62edee9eb$var$Inst.RUNE1:
                {
                    m[pc] = false;
                    if (inst.next && inst.next.length > 0) break;
                    instQueue.insert(inst.out);
                    let runes = [];
                    if ((inst.arg & $394755e62edee9eb$var$RE2Flags.FOLD_CASE) !== 0) {
                        const r0 = inst.runes[0];
                        runes.push(r0, r0);
                        for(let r1 = $394755e62edee9eb$var$Unicode.simpleFold(r0); r1 !== r0; r1 = $394755e62edee9eb$var$Unicode.simpleFold(r1))runes.push(r1, r1);
                        runes.sort((a, b)=>a - b);
                    } else runes.push(inst.runes[0], inst.runes[0]);
                    onePassRunes[pc] = runes;
                    inst.next = new Uint32Array(Math.floor(runes.length / 2) + 1).fill(inst.out);
                    inst.op = $394755e62edee9eb$var$Inst.RUNE;
                    break;
                }
            case $394755e62edee9eb$var$Inst.RUNE_ANY:
                m[pc] = false;
                if (inst.next && inst.next.length > 0) break;
                instQueue.insert(inst.out);
                onePassRunes[pc] = [
                    0,
                    $394755e62edee9eb$var$Unicode.MAX_RUNE
                ];
                inst.next = new Uint32Array([
                    inst.out
                ]);
                break;
            case $394755e62edee9eb$var$Inst.RUNE_ANY_NOT_NL:
                m[pc] = false;
                if (inst.next && inst.next.length > 0) break;
                instQueue.insert(inst.out);
                onePassRunes[pc] = [
                    0,
                    9,
                    11,
                    $394755e62edee9eb$var$Unicode.MAX_RUNE
                ];
                inst.next = new Uint32Array(Math.floor(onePassRunes[pc].length / 2) + 1).fill(inst.out);
                break;
        }
        return ok;
    };
    instQueue.clear();
    instQueue.insert(p.start);
    while(!instQueue.empty()){
        visitQueue.clear();
        if (!check(instQueue.next())) return null;
    }
    for(let i = 0; i < p.inst.length; i++)if (onePassRunes[i]) p.inst[i].runes = onePassRunes[i];
    return p;
};
const $394755e62edee9eb$var$cleanupOnePass = (p, original)=>{
    for(let ix = 0; ix < original.inst.length; ix++){
        const instOriginal = original.inst[ix];
        switch(instOriginal.op){
            case $394755e62edee9eb$var$Inst.ALT:
            case $394755e62edee9eb$var$Inst.ALT_MATCH:
            case $394755e62edee9eb$var$Inst.RUNE:
                break;
            case $394755e62edee9eb$var$Inst.CAPTURE:
            case $394755e62edee9eb$var$Inst.EMPTY_WIDTH:
            case $394755e62edee9eb$var$Inst.NOP:
            case $394755e62edee9eb$var$Inst.MATCH:
            case $394755e62edee9eb$var$Inst.FAIL:
                p.inst[ix].next = null;
                break;
            case $394755e62edee9eb$var$Inst.RUNE1:
            case $394755e62edee9eb$var$Inst.RUNE_ANY:
            case $394755e62edee9eb$var$Inst.RUNE_ANY_NOT_NL:
                p.inst[ix].next = null;
                p.inst[ix].op = instOriginal.op;
                p.inst[ix].runes = instOriginal.runes ? instOriginal.runes.slice() : [];
                break;
        }
    }
};
var $394755e62edee9eb$var$OnePass = class OnePass {
    static compile(prog) {
        if (prog.start === 0) return null;
        if (prog.numLb > 0) return null;
        const startInst = prog.inst[prog.start];
        if (startInst.op !== $394755e62edee9eb$var$Inst.EMPTY_WIDTH || (startInst.arg & $394755e62edee9eb$var$Utils.EMPTY_BEGIN_TEXT) === 0) return null;
        let hasAlt = false;
        for(let i = 0; i < prog.inst.length; i++)if (prog.inst[i].op === $394755e62edee9eb$var$Inst.ALT || prog.inst[i].op === $394755e62edee9eb$var$Inst.ALT_MATCH) {
            hasAlt = true;
            break;
        }
        for(let i = 0; i < prog.inst.length; i++){
            const inst = prog.inst[i];
            const opOut = prog.inst[inst.out].op;
            switch(inst.op){
                case $394755e62edee9eb$var$Inst.ALT:
                case $394755e62edee9eb$var$Inst.ALT_MATCH:
                    if (opOut === $394755e62edee9eb$var$Inst.MATCH || prog.inst[inst.arg].op === $394755e62edee9eb$var$Inst.MATCH) return null;
                    break;
                case $394755e62edee9eb$var$Inst.EMPTY_WIDTH:
                    if (opOut === $394755e62edee9eb$var$Inst.MATCH) {
                        if ((inst.arg & $394755e62edee9eb$var$Utils.EMPTY_END_TEXT) === $394755e62edee9eb$var$Utils.EMPTY_END_TEXT) continue;
                        return null;
                    }
                    break;
                default:
                    if (opOut === $394755e62edee9eb$var$Inst.MATCH && hasAlt) return null;
                    break;
            }
        }
        let p = $394755e62edee9eb$var$onePassCopy(prog);
        p = $394755e62edee9eb$var$makeOnePass(p);
        if (p !== null) $394755e62edee9eb$var$cleanupOnePass(p, prog);
        return p;
    }
    static next(inst, r) {
        const nextIdx = inst.matchRunePos(r);
        if (nextIdx >= 0) return inst.next[nextIdx];
        if (inst.op === $394755e62edee9eb$var$Inst.ALT_MATCH) return inst.out;
        return 0;
    }
    static execute(re2, input, pos, anchor, ncap) {
        const onepass = re2.onepass;
        if (!onepass) return null;
        const matchcap = new Int32Array(ncap).fill(-1);
        let matched = false;
        let r = input.step(pos);
        let rune = r >> 3;
        let width = r & 7;
        let r1 = $394755e62edee9eb$var$MachineInputBase.EOF();
        let rune1 = -1;
        let width1 = 0;
        if (r !== $394755e62edee9eb$var$MachineInputBase.EOF()) {
            r1 = input.step(pos + width);
            if (r1 !== $394755e62edee9eb$var$MachineInputBase.EOF()) {
                rune1 = r1 >> 3;
                width1 = r1 & 7;
            }
        }
        let flag = pos === 0 ? $394755e62edee9eb$var$Utils.emptyOpContext(-1, rune) : input.context(pos);
        let pc = onepass.start;
        let inst;
        while(true){
            inst = onepass.inst[pc];
            pc = inst.out;
            switch(inst.op){
                case $394755e62edee9eb$var$Inst.MATCH:
                    if (anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH && pos !== input.endPos()) return null;
                    matched = true;
                    if (matchcap.length > 0) {
                        matchcap[0] = 0;
                        matchcap[1] = pos;
                    }
                    return ncap === 0 ? [] : $394755e62edee9eb$var$Utils.toArray(matchcap);
                case $394755e62edee9eb$var$Inst.RUNE:
                    if (!inst.matchRune(rune)) return null;
                    break;
                case $394755e62edee9eb$var$Inst.RUNE1:
                    if (rune !== inst.runes[0]) return null;
                    break;
                case $394755e62edee9eb$var$Inst.RUNE_ANY:
                    break;
                case $394755e62edee9eb$var$Inst.RUNE_ANY_NOT_NL:
                    if (rune === 10) return null;
                    break;
                case $394755e62edee9eb$var$Inst.ALT:
                case $394755e62edee9eb$var$Inst.ALT_MATCH:
                    pc = OnePass.next(inst, rune);
                    continue;
                case $394755e62edee9eb$var$Inst.FAIL:
                    return null;
                case $394755e62edee9eb$var$Inst.NOP:
                    continue;
                case $394755e62edee9eb$var$Inst.EMPTY_WIDTH:
                    if ((inst.arg & ~flag) !== 0) return null;
                    continue;
                case $394755e62edee9eb$var$Inst.CAPTURE:
                    if (inst.arg < matchcap.length) matchcap[inst.arg] = pos;
                    continue;
                default:
                    throw new $394755e62edee9eb$export$3a148716bb6e0468("bad inst");
            }
            if (width === 0) break;
            flag = $394755e62edee9eb$var$Utils.emptyOpContext(rune, rune1);
            pos += width;
            rune = rune1;
            width = width1;
            if (rune !== -1) {
                r1 = input.step(pos + width);
                if (r1 !== $394755e62edee9eb$var$MachineInputBase.EOF()) {
                    rune1 = r1 >> 3;
                    width1 = r1 & 7;
                } else {
                    rune1 = -1;
                    width1 = 0;
                }
            }
        }
        if (!matched) return null;
        return ncap === 0 ? [] : $394755e62edee9eb$var$Utils.toArray(matchcap);
    }
};
//#endregion
//#region src/Regexp.js
/**
* Regular expression abstract syntax tree. Produced by parser, used by compiler. NB, this
* corresponds to {@code syntax.regexp} in the Go implementation; Go's {@code regexp} is called
* {@code RE2} in Java.
*/ var $394755e62edee9eb$var$Regexp = class Regexp {
    static Op = $394755e62edee9eb$var$createEnum([
        "NO_MATCH",
        "EMPTY_MATCH",
        "LITERAL",
        "CHAR_CLASS",
        "ANY_CHAR_NOT_NL",
        "ANY_CHAR",
        "BEGIN_LINE",
        "END_LINE",
        "BEGIN_TEXT",
        "END_TEXT",
        "WORD_BOUNDARY",
        "NO_WORD_BOUNDARY",
        "CAPTURE",
        "STAR",
        "PLUS",
        "QUEST",
        "REPEAT",
        "CONCAT",
        "ALTERNATE",
        "PLB",
        "NLB",
        "LEFT_PAREN",
        "VERTICAL_BAR"
    ]);
    static isPseudoOp(op) {
        return op >= Regexp.Op.LEFT_PAREN;
    }
    static emptySubs() {
        return [];
    }
    static quoteIfHyphen(rune) {
        if (rune === $394755e62edee9eb$var$Codepoint.CODES.get("-")) return "\\";
        return "";
    }
    static fromRegexp(re) {
        const regex = new Regexp(re.op);
        regex.flags = re.flags;
        regex.subs = re.subs;
        regex.runes = re.runes;
        regex.cap = re.cap;
        regex.min = re.min;
        regex.max = re.max;
        regex.name = re.name;
        regex.namedGroups = re.namedGroups;
        regex.lb = re.lb;
        return regex;
    }
    constructor(op){
        this.op = op;
        this.flags = 0;
        this.subs = Regexp.emptySubs();
        this.runes = [];
        this.min = 0;
        this.max = 0;
        this.cap = 0;
        this.name = null;
        this.namedGroups = Object.create(null);
        this.lb = 0;
    }
    reinit() {
        this.flags = 0;
        this.subs = Regexp.emptySubs();
        this.runes = [];
        this.cap = 0;
        this.min = 0;
        this.max = 0;
        this.name = null;
        this.namedGroups = Object.create(null);
        this.lb = 0;
    }
    toString() {
        return this.appendTo();
    }
    appendTo() {
        let out = "";
        switch(this.op){
            case Regexp.Op.NO_MATCH:
                out += "[^\\x00-\\x{10FFFF}]";
                break;
            case Regexp.Op.EMPTY_MATCH:
                out += "(?:)";
                break;
            case Regexp.Op.STAR:
            case Regexp.Op.PLUS:
            case Regexp.Op.QUEST:
            case Regexp.Op.REPEAT:
                {
                    const sub = this.subs[0];
                    if (sub.op > Regexp.Op.CAPTURE || sub.op === Regexp.Op.LITERAL && sub.runes.length > 1) out += `(?:${sub.appendTo()})`;
                    else out += sub.appendTo();
                    switch(this.op){
                        case Regexp.Op.STAR:
                            out += "*";
                            break;
                        case Regexp.Op.PLUS:
                            out += "+";
                            break;
                        case Regexp.Op.QUEST:
                            out += "?";
                            break;
                        case Regexp.Op.REPEAT:
                            out += `{${this.min}`;
                            if (this.min !== this.max) {
                                out += ",";
                                if (this.max >= 0) out += this.max;
                            }
                            out += "}";
                            break;
                    }
                    if ((this.flags & $394755e62edee9eb$var$RE2Flags.NON_GREEDY) !== 0) out += "?";
                    break;
                }
            case Regexp.Op.CONCAT:
                for (let sub of this.subs)if (sub.op === Regexp.Op.ALTERNATE) out += `(?:${sub.appendTo()})`;
                else out += sub.appendTo();
                break;
            case Regexp.Op.ALTERNATE:
                {
                    let sep = "";
                    for (let sub of this.subs){
                        out += sep;
                        sep = "|";
                        out += sub.appendTo();
                    }
                    break;
                }
            case Regexp.Op.LITERAL:
                if ((this.flags & $394755e62edee9eb$var$RE2Flags.FOLD_CASE) !== 0) out += "(?i:";
                for (let rune of this.runes)out += $394755e62edee9eb$var$Utils.escapeRune(rune);
                if ((this.flags & $394755e62edee9eb$var$RE2Flags.FOLD_CASE) !== 0) out += ")";
                break;
            case Regexp.Op.ANY_CHAR_NOT_NL:
                out += "(?-s:.)";
                break;
            case Regexp.Op.ANY_CHAR:
                out += "(?s:.)";
                break;
            case Regexp.Op.PLB:
                out += `(?<=${this.subs[0].appendTo()})`;
                break;
            case Regexp.Op.NLB:
                out += `(?<!${this.subs[0].appendTo()})`;
                break;
            case Regexp.Op.CAPTURE:
                if (this.name === null || this.name.length === 0) out += "(";
                else out += `(?P<${this.name}>`;
                if (this.subs[0].op !== Regexp.Op.EMPTY_MATCH) out += this.subs[0].appendTo();
                out += ")";
                break;
            case Regexp.Op.BEGIN_TEXT:
                out += "\\A";
                break;
            case Regexp.Op.END_TEXT:
                if ((this.flags & $394755e62edee9eb$var$RE2Flags.WAS_DOLLAR) !== 0) out += "(?-m:$)";
                else out += "\\z";
                break;
            case Regexp.Op.BEGIN_LINE:
                out += "^";
                break;
            case Regexp.Op.END_LINE:
                out += "$";
                break;
            case Regexp.Op.WORD_BOUNDARY:
                out += "\\b";
                break;
            case Regexp.Op.NO_WORD_BOUNDARY:
                out += "\\B";
                break;
            case Regexp.Op.CHAR_CLASS:
                if (this.runes.length % 2 !== 0) {
                    out += "[invalid char class]";
                    break;
                }
                out += "[";
                if (this.runes.length === 0) out += "^\\x00-\\x{10FFFF}";
                else if (this.runes[0] === 0 && this.runes[this.runes.length - 1] === $394755e62edee9eb$var$Unicode.MAX_RUNE) {
                    out += "^";
                    for(let i = 1; i < this.runes.length - 1; i += 2){
                        const lo = this.runes[i] + 1;
                        const hi = this.runes[i + 1] - 1;
                        out += Regexp.quoteIfHyphen(lo);
                        out += $394755e62edee9eb$var$Utils.escapeRune(lo);
                        if (lo !== hi) {
                            out += "-";
                            out += Regexp.quoteIfHyphen(hi);
                            out += $394755e62edee9eb$var$Utils.escapeRune(hi);
                        }
                    }
                } else for(let i = 0; i < this.runes.length; i += 2){
                    const lo = this.runes[i];
                    const hi = this.runes[i + 1];
                    out += Regexp.quoteIfHyphen(lo);
                    out += $394755e62edee9eb$var$Utils.escapeRune(lo);
                    if (lo !== hi) {
                        out += "-";
                        out += Regexp.quoteIfHyphen(hi);
                        out += $394755e62edee9eb$var$Utils.escapeRune(hi);
                    }
                }
                out += "]";
                break;
            default:
                out += this.op;
                break;
        }
        return out;
    }
    maxCap() {
        let m = 0;
        if (this.op === Regexp.Op.CAPTURE) m = this.cap;
        if (this.subs !== null) for (let sub of this.subs){
            const n = sub.maxCap();
            if (m < n) m = n;
        }
        return m;
    }
    equals(that) {
        if (!(that !== null && that instanceof Regexp)) return false;
        if (this.op !== that.op) return false;
        switch(this.op){
            case Regexp.Op.END_TEXT:
                if ((this.flags & $394755e62edee9eb$var$RE2Flags.WAS_DOLLAR) !== (that.flags & $394755e62edee9eb$var$RE2Flags.WAS_DOLLAR)) return false;
                break;
            case Regexp.Op.LITERAL:
            case Regexp.Op.CHAR_CLASS:
                if (this.runes === null && that.runes === null) break;
                if (this.runes === null || that.runes === null) return false;
                if (this.runes.length !== that.runes.length) return false;
                for(let i = 0; i < this.runes.length; i++)if (this.runes[i] !== that.runes[i]) return false;
                break;
            case Regexp.Op.ALTERNATE:
            case Regexp.Op.CONCAT:
                if (this.subs.length !== that.subs.length) return false;
                for(let i = 0; i < this.subs.length; ++i)if (!this.subs[i].equals(that.subs[i])) return false;
                break;
            case Regexp.Op.STAR:
            case Regexp.Op.PLUS:
            case Regexp.Op.QUEST:
                if ((this.flags & $394755e62edee9eb$var$RE2Flags.NON_GREEDY) !== (that.flags & $394755e62edee9eb$var$RE2Flags.NON_GREEDY) || !this.subs[0].equals(that.subs[0])) return false;
                break;
            case Regexp.Op.REPEAT:
                if ((this.flags & $394755e62edee9eb$var$RE2Flags.NON_GREEDY) !== (that.flags & $394755e62edee9eb$var$RE2Flags.NON_GREEDY) || this.min !== that.min || this.max !== that.max || !this.subs[0].equals(that.subs[0])) return false;
                break;
            case Regexp.Op.CAPTURE:
                if (this.cap !== that.cap || (this.name === null ? that.name !== null : this.name !== that.name) || !this.subs[0].equals(that.subs[0])) return false;
                break;
            case Regexp.Op.PLB:
            case Regexp.Op.NLB:
                if (this.lb !== that.lb || !this.subs[0].equals(that.subs[0])) return false;
                break;
        }
        return true;
    }
};
//#endregion
//#region src/Prefilter.js
var $394755e62edee9eb$var$AhoCorasick = class {
    constructor(wordArrays){
        this.next = [
            Object.create(null)
        ];
        this.fail = [
            0
        ];
        this.match = [
            false
        ];
        for (const word of wordArrays){
            let node = 0;
            for(let i = 0; i < word.length; i++){
                const val = word[i];
                if (!(val in this.next[node])) {
                    this.next.push(Object.create(null));
                    this.fail.push(0);
                    this.match.push(false);
                    this.next[node][val] = this.next.length - 1;
                }
                node = this.next[node][val];
            }
            this.match[node] = true;
        }
        const queue = [];
        for(const val in this.next[0])if (Object.prototype.hasOwnProperty.call(this.next[0], val)) {
            const child = this.next[0][val];
            this.fail[child] = 0;
            queue.push(child);
        }
        while(queue.length > 0){
            const curr = queue.shift();
            for(const val in this.next[curr])if (Object.prototype.hasOwnProperty.call(this.next[curr], val)) {
                const child = this.next[curr][val];
                let failNode = this.fail[curr];
                while(failNode !== 0 && !(val in this.next[failNode]))failNode = this.fail[failNode];
                if (val in this.next[failNode]) this.fail[child] = this.next[failNode][val];
                else this.fail[child] = 0;
                this.match[child] = this.match[child] || this.match[this.fail[child]];
                queue.push(child);
            }
        }
    }
    searchUTF16(charSeq, start, end) {
        let node = 0;
        for(let i = start; i < end; i++){
            const val = charSeq.charCodeAt(i);
            while(node !== 0 && !(val in this.next[node]))node = this.fail[node];
            if (val in this.next[node]) node = this.next[node][val];
            if (this.match[node]) return true;
        }
        return false;
    }
    searchUTF8(bytes, start, end) {
        let node = 0;
        for(let i = start; i < end; i++){
            const val = bytes[i];
            while(node !== 0 && !(val in this.next[node]))node = this.fail[node];
            if (val in this.next[node]) node = this.next[node][val];
            if (this.match[node]) return true;
        }
        return false;
    }
};
var $394755e62edee9eb$var$Prefilter = class Prefilter {
    static Type = {
        NONE: 0,
        EXACT: 1,
        AND: 2,
        OR: 3
    };
    constructor(type){
        this.type = type;
        this.subs = [];
        this.str = "";
        this.bytes = null;
        this.ac16 = null;
        this.ac8 = null;
    }
    eval(input, pos) {
        switch(this.type){
            case Prefilter.Type.NONE:
                return true;
            case Prefilter.Type.EXACT:
                return input.hasString(this, pos);
            case Prefilter.Type.AND:
                for(let i = 0; i < this.subs.length; i++)if (!this.subs[i].eval(input, pos)) return false;
                return true;
            case Prefilter.Type.OR:
                if (this.ac16 && this.ac8) return input.hasAnyString(this, pos);
                for(let i = 0; i < this.subs.length; i++)if (this.subs[i].eval(input, pos)) return true;
                return false;
            default:
                return true;
        }
    }
};
var $394755e62edee9eb$var$PrefilterTree = class PrefilterTree {
    static build(re) {
        const pf = PrefilterTree.fromRegexp(re);
        return PrefilterTree.simplify(pf);
    }
    static fromRegexp(re) {
        if (!re) return new $394755e62edee9eb$var$Prefilter($394755e62edee9eb$var$Prefilter.Type.NONE);
        switch(re.op){
            case $394755e62edee9eb$var$Regexp.Op.PLB:
            case $394755e62edee9eb$var$Regexp.Op.NLB:
            case $394755e62edee9eb$var$Regexp.Op.NO_MATCH:
            case $394755e62edee9eb$var$Regexp.Op.EMPTY_MATCH:
            case $394755e62edee9eb$var$Regexp.Op.BEGIN_LINE:
            case $394755e62edee9eb$var$Regexp.Op.END_LINE:
            case $394755e62edee9eb$var$Regexp.Op.BEGIN_TEXT:
            case $394755e62edee9eb$var$Regexp.Op.END_TEXT:
            case $394755e62edee9eb$var$Regexp.Op.WORD_BOUNDARY:
            case $394755e62edee9eb$var$Regexp.Op.NO_WORD_BOUNDARY:
            case $394755e62edee9eb$var$Regexp.Op.CHAR_CLASS:
            case $394755e62edee9eb$var$Regexp.Op.ANY_CHAR_NOT_NL:
            case $394755e62edee9eb$var$Regexp.Op.ANY_CHAR:
                return new $394755e62edee9eb$var$Prefilter($394755e62edee9eb$var$Prefilter.Type.NONE);
            case $394755e62edee9eb$var$Regexp.Op.LITERAL:
                {
                    if (re.runes.length === 0 || (re.flags & $394755e62edee9eb$var$RE2Flags.FOLD_CASE) !== 0) return new $394755e62edee9eb$var$Prefilter($394755e62edee9eb$var$Prefilter.Type.NONE);
                    const pf = new $394755e62edee9eb$var$Prefilter($394755e62edee9eb$var$Prefilter.Type.EXACT);
                    let str = "";
                    for(let i = 0; i < re.runes.length; i++)str += String.fromCodePoint(re.runes[i]);
                    pf.str = str;
                    pf.bytes = $394755e62edee9eb$var$Utils.stringToUtf8ByteArray(pf.str);
                    return pf;
                }
            case $394755e62edee9eb$var$Regexp.Op.CAPTURE:
            case $394755e62edee9eb$var$Regexp.Op.PLUS:
                return PrefilterTree.fromRegexp(re.subs[0]);
            case $394755e62edee9eb$var$Regexp.Op.REPEAT:
                if (re.min >= 1) return PrefilterTree.fromRegexp(re.subs[0]);
                return new $394755e62edee9eb$var$Prefilter($394755e62edee9eb$var$Prefilter.Type.NONE);
            case $394755e62edee9eb$var$Regexp.Op.CONCAT:
                {
                    const pf = new $394755e62edee9eb$var$Prefilter($394755e62edee9eb$var$Prefilter.Type.AND);
                    for (const sub of re.subs)pf.subs.push(PrefilterTree.fromRegexp(sub));
                    return pf;
                }
            case $394755e62edee9eb$var$Regexp.Op.ALTERNATE:
                {
                    const pf = new $394755e62edee9eb$var$Prefilter($394755e62edee9eb$var$Prefilter.Type.OR);
                    for (const sub of re.subs)pf.subs.push(PrefilterTree.fromRegexp(sub));
                    return pf;
                }
            default:
                return new $394755e62edee9eb$var$Prefilter($394755e62edee9eb$var$Prefilter.Type.NONE);
        }
    }
    static simplify(pf) {
        if (pf.type === $394755e62edee9eb$var$Prefilter.Type.EXACT || pf.type === $394755e62edee9eb$var$Prefilter.Type.NONE) return pf;
        if (pf.type === $394755e62edee9eb$var$Prefilter.Type.AND) {
            const newSubs = [];
            for (const sub of pf.subs){
                const s = PrefilterTree.simplify(sub);
                if (s.type !== $394755e62edee9eb$var$Prefilter.Type.NONE) {
                    if (s.type === $394755e62edee9eb$var$Prefilter.Type.AND) for(let j = 0; j < s.subs.length; j++)newSubs.push(s.subs[j]);
                    else newSubs.push(s);
                }
            }
            if (newSubs.length === 0) return new $394755e62edee9eb$var$Prefilter($394755e62edee9eb$var$Prefilter.Type.NONE);
            if (newSubs.length === 1) return newSubs[0];
            pf.subs = newSubs;
            return pf;
        }
        if (pf.type === $394755e62edee9eb$var$Prefilter.Type.OR) {
            const newSubs = [];
            for (const sub of pf.subs){
                const s = PrefilterTree.simplify(sub);
                if (s.type === $394755e62edee9eb$var$Prefilter.Type.NONE) return new $394755e62edee9eb$var$Prefilter($394755e62edee9eb$var$Prefilter.Type.NONE);
                if (s.type === $394755e62edee9eb$var$Prefilter.Type.OR) for(let j = 0; j < s.subs.length; j++)newSubs.push(s.subs[j]);
                else newSubs.push(s);
            }
            if (newSubs.length === 0) return new $394755e62edee9eb$var$Prefilter($394755e62edee9eb$var$Prefilter.Type.NONE);
            if (newSubs.length === 1) return newSubs[0];
            const seen = /* @__PURE__ */ new Set();
            const uniqueSubs = [];
            for (const sub of newSubs)if (sub.type === $394755e62edee9eb$var$Prefilter.Type.EXACT) {
                if (!seen.has(sub.str)) {
                    seen.add(sub.str);
                    uniqueSubs.push(sub);
                }
            } else uniqueSubs.push(sub);
            pf.subs = uniqueSubs;
            let allExact = true;
            for (const sub of uniqueSubs)if (sub.type !== $394755e62edee9eb$var$Prefilter.Type.EXACT) {
                allExact = false;
                break;
            }
            if (allExact && uniqueSubs.length > 1) {
                pf.ac16 = new $394755e62edee9eb$var$AhoCorasick(uniqueSubs.map((s)=>{
                    const arr = [];
                    for(let i = 0; i < s.str.length; i++)arr.push(s.str.charCodeAt(i));
                    return arr;
                }));
                pf.ac8 = new $394755e62edee9eb$var$AhoCorasick(uniqueSubs.map((s)=>s.bytes));
            }
            return pf;
        }
        return pf;
    }
};
//#endregion
//#region src/Prog.js
/**
* A list of instruction pointers waiting to be patched.
* Tracks both `head` and `tail` to allow O(1) appending during compilation.
* * Values are encoded integers, not standard memory pointers:
* - Program instruction index: `l >> 1`
* - Patch `.out` field if: `(l & 1) === 0`
* - Patch `.arg` field if: `(l & 1) === 1`
* - `0` denotes an empty list.
* * @see https://swtch.com/~rsc/regexp/regexp1.html
*/ var $394755e62edee9eb$var$PatchList = class {
    /**
	* @param {number} head - Encoded pointer to the start of the patch list.
	* @param {number} tail - Encoded pointer to the end of the patch list.
	*/ constructor(head = 0, tail = 0){
        this.head = head;
        this.tail = tail;
    }
};
/**
* A Prog is a compiled regular expression program.
*/ var $394755e62edee9eb$var$Prog = class {
    constructor(){
        this.inst = [];
        this.start = 0;
        this.numCap = 2;
        this.lbStarts = [];
        this.numLb = 0;
    }
    getInst(pc) {
        return this.inst[pc];
    }
    numInst() {
        return this.inst.length;
    }
    addInst(op) {
        this.inst.push(new $394755e62edee9eb$var$Inst(op));
    }
    skipNop(pc) {
        let i = this.inst[pc];
        while(i.op === $394755e62edee9eb$var$Inst.NOP || i.op === $394755e62edee9eb$var$Inst.CAPTURE){
            i = this.inst[pc];
            pc = i.out;
        }
        return i;
    }
    prefix() {
        let prefix = "";
        let i = this.skipNop(this.start);
        if (!$394755e62edee9eb$var$Inst.isRuneOp(i.op) || i.runes.length !== 1) return [
            i.op === $394755e62edee9eb$var$Inst.MATCH,
            prefix
        ];
        while($394755e62edee9eb$var$Inst.isRuneOp(i.op) && i.runes.length === 1 && (i.arg & $394755e62edee9eb$var$RE2Flags.FOLD_CASE) === 0){
            prefix += String.fromCodePoint(i.runes[0]);
            i = this.skipNop(i.out);
        }
        return [
            i.op === $394755e62edee9eb$var$Inst.MATCH,
            prefix
        ];
    }
    startCond() {
        let flag = 0;
        let pc = this.start;
        loop: for(;;){
            const i = this.inst[pc];
            switch(i.op){
                case $394755e62edee9eb$var$Inst.EMPTY_WIDTH:
                    flag |= i.arg;
                    break;
                case $394755e62edee9eb$var$Inst.FAIL:
                    return -1;
                case $394755e62edee9eb$var$Inst.CAPTURE:
                case $394755e62edee9eb$var$Inst.NOP:
                    break;
                default:
                    break loop;
            }
            pc = i.out;
        }
        return flag;
    }
    patch(l, val) {
        let head = l.head;
        while(head !== 0){
            const i = this.inst[head >> 1];
            if ((head & 1) === 0) {
                head = i.out;
                i.out = val;
            } else {
                head = i.arg;
                i.arg = val;
            }
        }
    }
    append(l1, l2) {
        if (l1.head === 0) return l2;
        if (l2.head === 0) return l1;
        const i = this.inst[l1.tail >> 1];
        if ((l1.tail & 1) === 0) i.out = l2.head;
        else i.arg = l2.head;
        return new $394755e62edee9eb$var$PatchList(l1.head, l2.tail);
    }
    /**
	*
	* @returns {string}
	*/ toString() {
        let out = "";
        for(let pc = 0; pc < this.inst.length; pc++){
            const len = out.length;
            out += pc;
            if (pc === this.start) out += "*";
            out += "        ".substring(out.length - len);
            out += this.inst[pc];
            out += "\n";
        }
        return out;
    }
};
//#endregion
//#region src/Compiler.js
/**
* A fragment of a compiled regular expression program.
*
* @see http://swtch.com/~rsc/regexp/regexp1.html
* @class
*/ var $394755e62edee9eb$var$Frag = class {
    constructor(i = 0, out = new $394755e62edee9eb$var$PatchList(), nullable = false){
        this.i = i;
        this.out = out;
        this.nullable = nullable;
    }
};
/**
* Compiler from {@code Regexp} (RE2 abstract syntax) to {@code RE2} (compiled regular expression).
*
* The only entry point is {@link #compileRegexp}.
*/ var $394755e62edee9eb$var$Compiler = class Compiler {
    static ANY_RUNE_NOT_NL() {
        return [
            0,
            $394755e62edee9eb$var$Codepoint.CODES.get("\n") - 1,
            $394755e62edee9eb$var$Codepoint.CODES.get("\n") + 1,
            $394755e62edee9eb$var$Unicode.MAX_RUNE
        ];
    }
    static ANY_RUNE() {
        return [
            0,
            $394755e62edee9eb$var$Unicode.MAX_RUNE
        ];
    }
    static compileRegexp(re) {
        const c = new Compiler();
        const f = c.compile(re);
        c.prog.patch(f.out, c.newInst($394755e62edee9eb$var$Inst.MATCH).i);
        c.prog.start = f.i;
        return c.prog;
    }
    static compileSet(regexps) {
        const c = new Compiler();
        if (regexps.length === 0) {
            c.prog.start = c.newInst($394755e62edee9eb$var$Inst.FAIL).i;
            return c.prog;
        }
        let starts = [];
        for(let i = 0; i < regexps.length; i++){
            const f = c.compile(regexps[i]);
            const m = c.newInst($394755e62edee9eb$var$Inst.MATCH);
            c.prog.getInst(m.i).arg = i;
            c.prog.patch(f.out, m.i);
            starts.push(f.i);
        }
        let start = starts[0];
        for(let i = 1; i < starts.length; i++){
            const f = c.newInst($394755e62edee9eb$var$Inst.ALT);
            const inst = c.prog.getInst(f.i);
            inst.out = start;
            inst.arg = starts[i];
            start = f.i;
        }
        c.prog.start = start;
        return c.prog;
    }
    constructor(){
        this.prog = new $394755e62edee9eb$var$Prog();
        this.newInst($394755e62edee9eb$var$Inst.FAIL);
    }
    newInst(op) {
        this.prog.addInst(op);
        return new $394755e62edee9eb$var$Frag(this.prog.numInst() - 1, new $394755e62edee9eb$var$PatchList(), true);
    }
    nop() {
        const f = this.newInst($394755e62edee9eb$var$Inst.NOP);
        f.out = new $394755e62edee9eb$var$PatchList(f.i << 1, f.i << 1);
        return f;
    }
    fail() {
        return new $394755e62edee9eb$var$Frag();
    }
    cap(arg) {
        const f = this.newInst($394755e62edee9eb$var$Inst.CAPTURE);
        f.out = new $394755e62edee9eb$var$PatchList(f.i << 1, f.i << 1);
        this.prog.getInst(f.i).arg = arg;
        if (this.prog.numCap < arg + 1) this.prog.numCap = arg + 1;
        return f;
    }
    cat(f1, f2) {
        if (f1.i === 0 || f2.i === 0) return this.fail();
        this.prog.patch(f1.out, f2.i);
        return new $394755e62edee9eb$var$Frag(f1.i, f2.out, f1.nullable && f2.nullable);
    }
    alt(f1, f2) {
        if (f1.i === 0) return f2;
        if (f2.i === 0) return f1;
        const f = this.newInst($394755e62edee9eb$var$Inst.ALT);
        const i = this.prog.getInst(f.i);
        i.out = f1.i;
        i.arg = f2.i;
        f.out = this.prog.append(f1.out, f2.out);
        f.nullable = f1.nullable || f2.nullable;
        return f;
    }
    loop(f1, nongreedy) {
        const f = this.newInst($394755e62edee9eb$var$Inst.ALT);
        const i = this.prog.getInst(f.i);
        if (nongreedy) {
            i.arg = f1.i;
            f.out = new $394755e62edee9eb$var$PatchList(f.i << 1, f.i << 1);
        } else {
            i.out = f1.i;
            f.out = new $394755e62edee9eb$var$PatchList(f.i << 1 | 1, f.i << 1 | 1);
        }
        this.prog.patch(f1.out, f.i);
        return f;
    }
    quest(f1, nongreedy) {
        const f = this.newInst($394755e62edee9eb$var$Inst.ALT);
        const i = this.prog.getInst(f.i);
        if (nongreedy) {
            i.arg = f1.i;
            f.out = new $394755e62edee9eb$var$PatchList(f.i << 1, f.i << 1);
        } else {
            i.out = f1.i;
            f.out = new $394755e62edee9eb$var$PatchList(f.i << 1 | 1, f.i << 1 | 1);
        }
        f.out = this.prog.append(f.out, f1.out);
        return f;
    }
    star(f1, nongreedy) {
        if (f1.nullable) return this.quest(this.plus(f1, nongreedy), nongreedy);
        return this.loop(f1, nongreedy);
    }
    plus(f1, nongreedy) {
        return new $394755e62edee9eb$var$Frag(f1.i, this.loop(f1, nongreedy).out, f1.nullable);
    }
    empty(op) {
        const f = this.newInst($394755e62edee9eb$var$Inst.EMPTY_WIDTH);
        this.prog.getInst(f.i).arg = op;
        f.out = new $394755e62edee9eb$var$PatchList(f.i << 1, f.i << 1);
        return f;
    }
    rune(runes, flags) {
        const f = this.newInst($394755e62edee9eb$var$Inst.RUNE);
        f.nullable = false;
        const i = this.prog.getInst(f.i);
        i.runes = runes;
        flags &= $394755e62edee9eb$var$RE2Flags.FOLD_CASE;
        if (runes.length !== 1 || $394755e62edee9eb$var$Unicode.simpleFold(runes[0]) === runes[0]) flags &= ~$394755e62edee9eb$var$RE2Flags.FOLD_CASE;
        i.arg = flags;
        f.out = new $394755e62edee9eb$var$PatchList(f.i << 1, f.i << 1);
        if ((flags & $394755e62edee9eb$var$RE2Flags.FOLD_CASE) === 0 && runes.length === 1 || runes.length === 2 && runes[0] === runes[1]) i.op = $394755e62edee9eb$var$Inst.RUNE1;
        else if (runes.length === 2 && runes[0] === 0 && runes[1] === $394755e62edee9eb$var$Unicode.MAX_RUNE) i.op = $394755e62edee9eb$var$Inst.RUNE_ANY;
        else if (runes.length === 4 && runes[0] === 0 && runes[1] === $394755e62edee9eb$var$Codepoint.CODES.get("\n") - 1 && runes[2] === $394755e62edee9eb$var$Codepoint.CODES.get("\n") + 1 && runes[3] === $394755e62edee9eb$var$Unicode.MAX_RUNE) i.op = $394755e62edee9eb$var$Inst.RUNE_ANY_NOT_NL;
        return f;
    }
    lookBehind(a, lb) {
        const id = this.newInst($394755e62edee9eb$var$Inst.LB_WRITE);
        this.prog.getInst(id.i).arg = lb;
        const any = this.rune(Compiler.ANY_RUNE(), 0);
        const dotStar = this.star(any, true);
        const lbAutomaton = this.cat(dotStar, a);
        this.prog.patch(lbAutomaton.out, id.i);
        const checkId = this.newInst($394755e62edee9eb$var$Inst.LB_CHECK);
        this.prog.getInst(checkId.i).arg = lb;
        this.prog.lbStarts.push(lbAutomaton.i);
        if (Math.abs(lb) > this.prog.numLb) this.prog.numLb = Math.abs(lb);
        checkId.out = new $394755e62edee9eb$var$PatchList(checkId.i << 1, checkId.i << 1);
        return checkId;
    }
    compile(re) {
        switch(re.op){
            case $394755e62edee9eb$var$Regexp.Op.NO_MATCH:
                return this.fail();
            case $394755e62edee9eb$var$Regexp.Op.EMPTY_MATCH:
                return this.nop();
            case $394755e62edee9eb$var$Regexp.Op.LITERAL:
                if (re.runes.length === 0) return this.nop();
                else {
                    let f = null;
                    for (let r of re.runes){
                        const f1 = this.rune([
                            r
                        ], re.flags);
                        f = f === null ? f1 : this.cat(f, f1);
                    }
                    return f;
                }
            case $394755e62edee9eb$var$Regexp.Op.CHAR_CLASS:
                return this.rune(re.runes, re.flags);
            case $394755e62edee9eb$var$Regexp.Op.ANY_CHAR_NOT_NL:
                return this.rune(Compiler.ANY_RUNE_NOT_NL(), 0);
            case $394755e62edee9eb$var$Regexp.Op.ANY_CHAR:
                return this.rune(Compiler.ANY_RUNE(), 0);
            case $394755e62edee9eb$var$Regexp.Op.BEGIN_LINE:
                return this.empty($394755e62edee9eb$var$Utils.EMPTY_BEGIN_LINE);
            case $394755e62edee9eb$var$Regexp.Op.END_LINE:
                return this.empty($394755e62edee9eb$var$Utils.EMPTY_END_LINE);
            case $394755e62edee9eb$var$Regexp.Op.BEGIN_TEXT:
                return this.empty($394755e62edee9eb$var$Utils.EMPTY_BEGIN_TEXT);
            case $394755e62edee9eb$var$Regexp.Op.END_TEXT:
                return this.empty($394755e62edee9eb$var$Utils.EMPTY_END_TEXT);
            case $394755e62edee9eb$var$Regexp.Op.WORD_BOUNDARY:
                return this.empty($394755e62edee9eb$var$Utils.EMPTY_WORD_BOUNDARY);
            case $394755e62edee9eb$var$Regexp.Op.NO_WORD_BOUNDARY:
                return this.empty($394755e62edee9eb$var$Utils.EMPTY_NO_WORD_BOUNDARY);
            case $394755e62edee9eb$var$Regexp.Op.PLB:
            case $394755e62edee9eb$var$Regexp.Op.NLB:
                return this.lookBehind(this.compile(re.subs[0]), re.lb);
            case $394755e62edee9eb$var$Regexp.Op.CAPTURE:
                {
                    const bra = this.cap(re.cap << 1);
                    const sub = this.compile(re.subs[0]);
                    const ket = this.cap(re.cap << 1 | 1);
                    return this.cat(this.cat(bra, sub), ket);
                }
            case $394755e62edee9eb$var$Regexp.Op.STAR:
                return this.star(this.compile(re.subs[0]), (re.flags & $394755e62edee9eb$var$RE2Flags.NON_GREEDY) !== 0);
            case $394755e62edee9eb$var$Regexp.Op.PLUS:
                return this.plus(this.compile(re.subs[0]), (re.flags & $394755e62edee9eb$var$RE2Flags.NON_GREEDY) !== 0);
            case $394755e62edee9eb$var$Regexp.Op.QUEST:
                return this.quest(this.compile(re.subs[0]), (re.flags & $394755e62edee9eb$var$RE2Flags.NON_GREEDY) !== 0);
            case $394755e62edee9eb$var$Regexp.Op.CONCAT:
                if (re.subs.length === 0) return this.nop();
                else {
                    let f = null;
                    for (let sub of re.subs){
                        const f1 = this.compile(sub);
                        f = f === null ? f1 : this.cat(f, f1);
                    }
                    return f;
                }
            case $394755e62edee9eb$var$Regexp.Op.ALTERNATE:
                if (re.subs.length === 0) return this.nop();
                else {
                    let f = null;
                    for (let sub of re.subs){
                        const f1 = this.compile(sub);
                        f = f === null ? f1 : this.alt(f, f1);
                    }
                    return f;
                }
            default:
                throw new $394755e62edee9eb$export$457eacef9ada3821("regexp: unhandled case in compile");
        }
    }
};
//#endregion
//#region src/Simplify.js
var $394755e62edee9eb$var$Simplify = class Simplify {
    static simplify(re) {
        if (re === null) return null;
        switch(re.op){
            case $394755e62edee9eb$var$Regexp.Op.PLB:
            case $394755e62edee9eb$var$Regexp.Op.NLB:
            case $394755e62edee9eb$var$Regexp.Op.CAPTURE:
                {
                    const sub = Simplify.simplify(re.subs[0]);
                    if (sub !== re.subs[0]) {
                        const nre = $394755e62edee9eb$var$Regexp.fromRegexp(re);
                        nre.runes = [];
                        nre.subs = [
                            sub
                        ];
                        return nre;
                    }
                    return re;
                }
            case $394755e62edee9eb$var$Regexp.Op.CONCAT:
            case $394755e62edee9eb$var$Regexp.Op.ALTERNATE:
                {
                    const newSubs = [];
                    let changed = false;
                    for(let i = 0; i < re.subs.length; i++){
                        const sub = re.subs[i];
                        const nsub = Simplify.simplify(sub);
                        if (nsub !== sub) changed = true;
                        if (re.op === $394755e62edee9eb$var$Regexp.Op.CONCAT) {
                            if (nsub.op === $394755e62edee9eb$var$Regexp.Op.NO_MATCH) return new $394755e62edee9eb$var$Regexp($394755e62edee9eb$var$Regexp.Op.NO_MATCH);
                            if (nsub.op === $394755e62edee9eb$var$Regexp.Op.EMPTY_MATCH) {
                                changed = true;
                                continue;
                            }
                            if (nsub.op === $394755e62edee9eb$var$Regexp.Op.CONCAT) {
                                changed = true;
                                for(let j = 0; j < nsub.subs.length; j++)newSubs.push(nsub.subs[j]);
                                continue;
                            }
                        } else if (re.op === $394755e62edee9eb$var$Regexp.Op.ALTERNATE) {
                            if (nsub.op === $394755e62edee9eb$var$Regexp.Op.NO_MATCH) {
                                changed = true;
                                continue;
                            }
                            if (nsub.op === $394755e62edee9eb$var$Regexp.Op.ALTERNATE) {
                                changed = true;
                                for(let j = 0; j < nsub.subs.length; j++)newSubs.push(nsub.subs[j]);
                                continue;
                            }
                        }
                        newSubs.push(nsub);
                    }
                    if (changed) {
                        if (newSubs.length === 0) return new $394755e62edee9eb$var$Regexp(re.op === $394755e62edee9eb$var$Regexp.Op.CONCAT ? $394755e62edee9eb$var$Regexp.Op.EMPTY_MATCH : $394755e62edee9eb$var$Regexp.Op.NO_MATCH);
                        if (newSubs.length === 1) return newSubs[0];
                        const nre = $394755e62edee9eb$var$Regexp.fromRegexp(re);
                        nre.runes = [];
                        nre.subs = newSubs;
                        return nre;
                    }
                    return re;
                }
            case $394755e62edee9eb$var$Regexp.Op.CHAR_CLASS:
                if (re.runes === null) return re;
                if (re.runes.length === 0) return new $394755e62edee9eb$var$Regexp($394755e62edee9eb$var$Regexp.Op.NO_MATCH);
                if (re.runes.length === 2 && re.runes[0] === 0 && re.runes[1] === $394755e62edee9eb$var$Unicode.MAX_RUNE) return new $394755e62edee9eb$var$Regexp($394755e62edee9eb$var$Regexp.Op.ANY_CHAR);
                if (re.runes.length === 4 && re.runes[0] === 0 && re.runes[1] === $394755e62edee9eb$var$Codepoint.CODES.get("\n") - 1 && re.runes[2] === $394755e62edee9eb$var$Codepoint.CODES.get("\n") + 1 && re.runes[3] === $394755e62edee9eb$var$Unicode.MAX_RUNE) return new $394755e62edee9eb$var$Regexp($394755e62edee9eb$var$Regexp.Op.ANY_CHAR_NOT_NL);
                return re;
            case $394755e62edee9eb$var$Regexp.Op.STAR:
            case $394755e62edee9eb$var$Regexp.Op.PLUS:
            case $394755e62edee9eb$var$Regexp.Op.QUEST:
                {
                    const sub = Simplify.simplify(re.subs[0]);
                    return Simplify.simplify1(re.op, re.flags, sub, re);
                }
            case $394755e62edee9eb$var$Regexp.Op.REPEAT:
                {
                    if (re.min === 0 && re.max === 0) return new $394755e62edee9eb$var$Regexp($394755e62edee9eb$var$Regexp.Op.EMPTY_MATCH);
                    const sub = Simplify.simplify(re.subs[0]);
                    if (re.max === -1) {
                        if (re.min === 0) return Simplify.simplify1($394755e62edee9eb$var$Regexp.Op.STAR, re.flags, sub, null);
                        if (re.min === 1) return Simplify.simplify1($394755e62edee9eb$var$Regexp.Op.PLUS, re.flags, sub, null);
                        const nre = new $394755e62edee9eb$var$Regexp($394755e62edee9eb$var$Regexp.Op.CONCAT);
                        const subs = [];
                        for(let i = 0; i < re.min - 1; i++)subs.push(sub);
                        subs.push(Simplify.simplify1($394755e62edee9eb$var$Regexp.Op.PLUS, re.flags, sub, null));
                        nre.subs = subs.slice(0);
                        return Simplify.simplify(nre);
                    }
                    if (re.min === 1 && re.max === 1) return sub;
                    let prefixSubs = null;
                    if (re.min > 0) {
                        prefixSubs = [];
                        for(let i = 0; i < re.min; i++)prefixSubs.push(sub);
                    }
                    if (re.max > re.min) {
                        let suffix = Simplify.simplify1($394755e62edee9eb$var$Regexp.Op.QUEST, re.flags, sub, null);
                        for(let i = re.min + 1; i < re.max; i++){
                            const nre2 = new $394755e62edee9eb$var$Regexp($394755e62edee9eb$var$Regexp.Op.CONCAT);
                            nre2.subs = [
                                sub,
                                suffix
                            ];
                            suffix = Simplify.simplify1($394755e62edee9eb$var$Regexp.Op.QUEST, re.flags, nre2, null);
                        }
                        if (prefixSubs === null) return suffix;
                        prefixSubs.push(suffix);
                    }
                    if (prefixSubs !== null) {
                        const prefix = new $394755e62edee9eb$var$Regexp($394755e62edee9eb$var$Regexp.Op.CONCAT);
                        prefix.subs = prefixSubs.slice(0);
                        return Simplify.simplify(prefix);
                    }
                    return new $394755e62edee9eb$var$Regexp($394755e62edee9eb$var$Regexp.Op.NO_MATCH);
                }
        }
        return re;
    }
    static simplify1(op, flags, sub, re) {
        if (sub.op === $394755e62edee9eb$var$Regexp.Op.EMPTY_MATCH) return sub;
        if (sub.op === $394755e62edee9eb$var$Regexp.Op.NO_MATCH) {
            if (op === $394755e62edee9eb$var$Regexp.Op.PLUS) return sub;
            return new $394755e62edee9eb$var$Regexp($394755e62edee9eb$var$Regexp.Op.EMPTY_MATCH);
        }
        if (op === sub.op && (flags & $394755e62edee9eb$var$RE2Flags.NON_GREEDY) === (sub.flags & $394755e62edee9eb$var$RE2Flags.NON_GREEDY)) return sub;
        if (re !== null && re.op === op && (re.flags & $394755e62edee9eb$var$RE2Flags.NON_GREEDY) === (flags & $394755e62edee9eb$var$RE2Flags.NON_GREEDY) && sub === re.subs[0]) return re;
        const nre = new $394755e62edee9eb$var$Regexp(op);
        nre.flags = flags;
        nre.subs = [
            sub
        ];
        return nre;
    }
};
//#endregion
//#region src/CharGroup.js
var $394755e62edee9eb$var$CharGroup = class {
    constructor(sign, cls){
        this.sign = sign;
        this.cls = cls;
    }
};
const $394755e62edee9eb$var$code1 = [
    48,
    57
];
const $394755e62edee9eb$var$code2 = [
    9,
    10,
    12,
    13,
    32,
    32
];
const $394755e62edee9eb$var$code3 = [
    48,
    57,
    65,
    90,
    95,
    95,
    97,
    122
];
const $394755e62edee9eb$var$PERL_GROUPS = /* @__PURE__ */ new Map([
    [
        "\\d",
        new $394755e62edee9eb$var$CharGroup(1, $394755e62edee9eb$var$code1)
    ],
    [
        "\\D",
        new $394755e62edee9eb$var$CharGroup(-1, $394755e62edee9eb$var$code1)
    ],
    [
        "\\s",
        new $394755e62edee9eb$var$CharGroup(1, $394755e62edee9eb$var$code2)
    ],
    [
        "\\S",
        new $394755e62edee9eb$var$CharGroup(-1, $394755e62edee9eb$var$code2)
    ],
    [
        "\\w",
        new $394755e62edee9eb$var$CharGroup(1, $394755e62edee9eb$var$code3)
    ],
    [
        "\\W",
        new $394755e62edee9eb$var$CharGroup(-1, $394755e62edee9eb$var$code3)
    ]
]);
const $394755e62edee9eb$var$code4 = [
    48,
    57,
    65,
    90,
    97,
    122
];
const $394755e62edee9eb$var$code5 = [
    65,
    90,
    97,
    122
];
const $394755e62edee9eb$var$code6 = [
    0,
    127
];
const $394755e62edee9eb$var$code7 = [
    9,
    9,
    32,
    32
];
const $394755e62edee9eb$var$code8 = [
    0,
    31,
    127,
    127
];
const $394755e62edee9eb$var$code9 = [
    48,
    57
];
const $394755e62edee9eb$var$code10 = [
    33,
    126
];
const $394755e62edee9eb$var$code11 = [
    97,
    122
];
const $394755e62edee9eb$var$code12 = [
    32,
    126
];
const $394755e62edee9eb$var$code13 = [
    33,
    47,
    58,
    64,
    91,
    96,
    123,
    126
];
const $394755e62edee9eb$var$code14 = [
    9,
    13,
    32,
    32
];
const $394755e62edee9eb$var$code15 = [
    65,
    90
];
const $394755e62edee9eb$var$code16 = [
    48,
    57,
    65,
    90,
    95,
    95,
    97,
    122
];
const $394755e62edee9eb$var$code17 = [
    48,
    57,
    65,
    70,
    97,
    102
];
const $394755e62edee9eb$var$POSIX_GROUPS = /* @__PURE__ */ new Map([
    [
        "[:alnum:]",
        new $394755e62edee9eb$var$CharGroup(1, $394755e62edee9eb$var$code4)
    ],
    [
        "[:^alnum:]",
        new $394755e62edee9eb$var$CharGroup(-1, $394755e62edee9eb$var$code4)
    ],
    [
        "[:alpha:]",
        new $394755e62edee9eb$var$CharGroup(1, $394755e62edee9eb$var$code5)
    ],
    [
        "[:^alpha:]",
        new $394755e62edee9eb$var$CharGroup(-1, $394755e62edee9eb$var$code5)
    ],
    [
        "[:ascii:]",
        new $394755e62edee9eb$var$CharGroup(1, $394755e62edee9eb$var$code6)
    ],
    [
        "[:^ascii:]",
        new $394755e62edee9eb$var$CharGroup(-1, $394755e62edee9eb$var$code6)
    ],
    [
        "[:blank:]",
        new $394755e62edee9eb$var$CharGroup(1, $394755e62edee9eb$var$code7)
    ],
    [
        "[:^blank:]",
        new $394755e62edee9eb$var$CharGroup(-1, $394755e62edee9eb$var$code7)
    ],
    [
        "[:cntrl:]",
        new $394755e62edee9eb$var$CharGroup(1, $394755e62edee9eb$var$code8)
    ],
    [
        "[:^cntrl:]",
        new $394755e62edee9eb$var$CharGroup(-1, $394755e62edee9eb$var$code8)
    ],
    [
        "[:digit:]",
        new $394755e62edee9eb$var$CharGroup(1, $394755e62edee9eb$var$code9)
    ],
    [
        "[:^digit:]",
        new $394755e62edee9eb$var$CharGroup(-1, $394755e62edee9eb$var$code9)
    ],
    [
        "[:graph:]",
        new $394755e62edee9eb$var$CharGroup(1, $394755e62edee9eb$var$code10)
    ],
    [
        "[:^graph:]",
        new $394755e62edee9eb$var$CharGroup(-1, $394755e62edee9eb$var$code10)
    ],
    [
        "[:lower:]",
        new $394755e62edee9eb$var$CharGroup(1, $394755e62edee9eb$var$code11)
    ],
    [
        "[:^lower:]",
        new $394755e62edee9eb$var$CharGroup(-1, $394755e62edee9eb$var$code11)
    ],
    [
        "[:print:]",
        new $394755e62edee9eb$var$CharGroup(1, $394755e62edee9eb$var$code12)
    ],
    [
        "[:^print:]",
        new $394755e62edee9eb$var$CharGroup(-1, $394755e62edee9eb$var$code12)
    ],
    [
        "[:punct:]",
        new $394755e62edee9eb$var$CharGroup(1, $394755e62edee9eb$var$code13)
    ],
    [
        "[:^punct:]",
        new $394755e62edee9eb$var$CharGroup(-1, $394755e62edee9eb$var$code13)
    ],
    [
        "[:space:]",
        new $394755e62edee9eb$var$CharGroup(1, $394755e62edee9eb$var$code14)
    ],
    [
        "[:^space:]",
        new $394755e62edee9eb$var$CharGroup(-1, $394755e62edee9eb$var$code14)
    ],
    [
        "[:upper:]",
        new $394755e62edee9eb$var$CharGroup(1, $394755e62edee9eb$var$code15)
    ],
    [
        "[:^upper:]",
        new $394755e62edee9eb$var$CharGroup(-1, $394755e62edee9eb$var$code15)
    ],
    [
        "[:word:]",
        new $394755e62edee9eb$var$CharGroup(1, $394755e62edee9eb$var$code16)
    ],
    [
        "[:^word:]",
        new $394755e62edee9eb$var$CharGroup(-1, $394755e62edee9eb$var$code16)
    ],
    [
        "[:xdigit:]",
        new $394755e62edee9eb$var$CharGroup(1, $394755e62edee9eb$var$code17)
    ],
    [
        "[:^xdigit:]",
        new $394755e62edee9eb$var$CharGroup(-1, $394755e62edee9eb$var$code17)
    ]
]);
//#endregion
//#region src/CharClass.js
/**
* A "builder"-style helper class for manipulating character classes represented as an array of
* pairs of runes [lo, hi], each denoting an inclusive interval.
*
* All methods mutate the internal state and return {@code this}, allowing operations to be chained.
*/ var $394755e62edee9eb$var$CharClass = class CharClass {
    static charClassToString(r, len) {
        let result = "[";
        for(let i = 0; i < len; i += 2){
            if (i > 0) result += " ";
            const lo = r[i];
            const hi = r[i + 1];
            if (lo === hi) result += `0x${lo.toString(16)}`;
            else result += `0x${lo.toString(16)}-0x${hi.toString(16)}`;
        }
        result += "]";
        return result;
    }
    static cmp(array, i, pivotFrom, pivotTo) {
        const cmp = array[i] - pivotFrom;
        return cmp !== 0 ? cmp : pivotTo - array[i + 1];
    }
    static qsortIntPair(array, left, right) {
        const pivotIndex = ((left + right) / 2 | 0) & -2;
        const pivotFrom = array[pivotIndex];
        const pivotTo = array[pivotIndex + 1];
        let i = left;
        let j = right;
        while(i <= j){
            while(i < right && CharClass.cmp(array, i, pivotFrom, pivotTo) < 0)i += 2;
            while(j > left && CharClass.cmp(array, j, pivotFrom, pivotTo) > 0)j -= 2;
            if (i <= j) {
                if (i !== j) {
                    let temp = array[i];
                    array[i] = array[j];
                    array[j] = temp;
                    temp = array[i + 1];
                    array[i + 1] = array[j + 1];
                    array[j + 1] = temp;
                }
                i += 2;
                j -= 2;
            }
        }
        if (left < j) CharClass.qsortIntPair(array, left, j);
        if (i < right) CharClass.qsortIntPair(array, i, right);
    }
    constructor(r = $394755e62edee9eb$var$Utils.emptyInts()){
        this.r = r;
        this.len = r.length;
    }
    toArray() {
        if (this.len === this.r.length) return this.r;
        else return this.r.slice(0, this.len);
    }
    cleanClass() {
        if (this.len < 4) return this;
        CharClass.qsortIntPair(this.r, 0, this.len - 2);
        let w = 2;
        for(let i = 2; i < this.len; i += 2){
            const lo = this.r[i];
            const hi = this.r[i + 1];
            if (lo <= this.r[w - 1] + 1) {
                if (hi > this.r[w - 1]) this.r[w - 1] = hi;
                continue;
            }
            this.r[w] = lo;
            this.r[w + 1] = hi;
            w += 2;
        }
        this.len = w;
        return this;
    }
    appendLiteral(x, flags) {
        return (flags & $394755e62edee9eb$var$RE2Flags.FOLD_CASE) !== 0 ? this.appendFoldedRange(x, x) : this.appendRange(x, x);
    }
    appendRange(lo, hi) {
        if (this.len > 0) {
            for(let i = 2; i <= 4; i += 2)if (this.len >= i) {
                const rlo = this.r[this.len - i];
                const rhi = this.r[this.len - i + 1];
                if (lo <= rhi + 1 && rlo <= hi + 1) {
                    if (lo < rlo) this.r[this.len - i] = lo;
                    if (hi > rhi) this.r[this.len - i + 1] = hi;
                    return this;
                }
            }
        }
        this.r[this.len++] = lo;
        this.r[this.len++] = hi;
        return this;
    }
    appendFoldedRange(lo, hi) {
        if (lo <= $394755e62edee9eb$var$Unicode.MIN_FOLD && hi >= $394755e62edee9eb$var$Unicode.MAX_FOLD) return this.appendRange(lo, hi);
        if (hi < $394755e62edee9eb$var$Unicode.MIN_FOLD || lo > $394755e62edee9eb$var$Unicode.MAX_FOLD) return this.appendRange(lo, hi);
        if (lo < $394755e62edee9eb$var$Unicode.MIN_FOLD) {
            this.appendRange(lo, $394755e62edee9eb$var$Unicode.MIN_FOLD - 1);
            lo = $394755e62edee9eb$var$Unicode.MIN_FOLD;
        }
        if (hi > $394755e62edee9eb$var$Unicode.MAX_FOLD) {
            this.appendRange($394755e62edee9eb$var$Unicode.MAX_FOLD + 1, hi);
            hi = $394755e62edee9eb$var$Unicode.MAX_FOLD;
        }
        for(let c = lo; c <= hi; c++){
            this.appendRange(c, c);
            for(let f = $394755e62edee9eb$var$Unicode.simpleFold(c); f !== c; f = $394755e62edee9eb$var$Unicode.simpleFold(f))this.appendRange(f, f);
        }
        return this;
    }
    appendClass(x) {
        for(let i = 0; i < x.length; i += 2)this.appendRange(x[i], x[i + 1]);
        return this;
    }
    appendFoldedClass(x) {
        for(let i = 0; i < x.length; i += 2)this.appendFoldedRange(x[i], x[i + 1]);
        return this;
    }
    appendNegatedClass(x) {
        let nextLo = 0;
        for(let i = 0; i < x.length; i += 2){
            const lo = x[i];
            const hi = x[i + 1];
            if (nextLo <= lo - 1) this.appendRange(nextLo, lo - 1);
            nextLo = hi + 1;
        }
        if (nextLo <= $394755e62edee9eb$var$Unicode.MAX_RUNE) this.appendRange(nextLo, $394755e62edee9eb$var$Unicode.MAX_RUNE);
        return this;
    }
    appendTable(table) {
        for(let i = 0; i < table.length; ++i){
            const lo = table.getLo(i);
            const hi = table.getHi(i);
            const stride = table.getStride(i);
            if (stride === 1) {
                this.appendRange(lo, hi);
                continue;
            }
            for(let c = lo; c <= hi; c += stride)this.appendRange(c, c);
        }
        return this;
    }
    appendNegatedTable(table) {
        let nextLo = 0;
        for(let i = 0; i < table.length; ++i){
            const lo = table.getLo(i);
            const hi = table.getHi(i);
            const stride = table.getStride(i);
            if (stride === 1) {
                if (nextLo <= lo - 1) this.appendRange(nextLo, lo - 1);
                nextLo = hi + 1;
                continue;
            }
            for(let c = lo; c <= hi; c += stride){
                if (nextLo <= c - 1) this.appendRange(nextLo, c - 1);
                nextLo = c + 1;
            }
        }
        if (nextLo <= $394755e62edee9eb$var$Unicode.MAX_RUNE) this.appendRange(nextLo, $394755e62edee9eb$var$Unicode.MAX_RUNE);
        return this;
    }
    appendTableWithSign(table, sign) {
        return sign < 0 ? this.appendNegatedTable(table) : this.appendTable(table);
    }
    negateClass() {
        let nextLo = 0;
        let w = 0;
        for(let i = 0; i < this.len; i += 2){
            const lo = this.r[i];
            const hi = this.r[i + 1];
            if (nextLo <= lo - 1) {
                this.r[w] = nextLo;
                this.r[w + 1] = lo - 1;
                w += 2;
            }
            nextLo = hi + 1;
        }
        this.len = w;
        if (nextLo <= $394755e62edee9eb$var$Unicode.MAX_RUNE) {
            this.r[this.len++] = nextLo;
            this.r[this.len++] = $394755e62edee9eb$var$Unicode.MAX_RUNE;
        }
        return this;
    }
    appendClassWithSign(x, sign) {
        return sign < 0 ? this.appendNegatedClass(x) : this.appendClass(x);
    }
    appendGroup(g, foldCase) {
        let cls = g.cls;
        if (foldCase) cls = new CharClass().appendFoldedClass(cls).cleanClass().toArray();
        return this.appendClassWithSign(cls, g.sign);
    }
    toString() {
        return CharClass.charClassToString(this.r, this.len);
    }
};
//#endregion
//#region src/Parser.js
var $394755e62edee9eb$var$StringIterator = class {
    constructor(str){
        this.str = str;
        this.position = 0;
    }
    pos() {
        return this.position;
    }
    rewindTo(pos) {
        this.position = pos;
    }
    more() {
        return this.position < this.str.length;
    }
    peek() {
        return this.str.codePointAt(this.position);
    }
    skip(n) {
        this.position += n;
    }
    skipString(s) {
        this.position += s.length;
    }
    pop() {
        const r = this.str.codePointAt(this.position);
        this.position += $394755e62edee9eb$var$Utils.charCount(r);
        return r;
    }
    lookingAt(s) {
        return this.str.startsWith(s, this.position);
    }
    rest() {
        return this.str.substring(this.position);
    }
    from(beforePos) {
        return this.str.substring(beforePos, this.position);
    }
    toString() {
        return this.rest();
    }
};
/**
* A parser of regular expression patterns.
*
* The only public entry point is {@link #parse(String pattern, int flags)}.
*/ var $394755e62edee9eb$var$Parser = class Parser {
    static ERR_INTERNAL_ERROR = "regexp/syntax: internal error";
    static ERR_INVALID_CHAR_RANGE = "invalid character class range";
    static ERR_INVALID_ESCAPE = "invalid escape sequence";
    static ERR_INVALID_NAMED_CAPTURE = "invalid named capture";
    static ERR_INVALID_PERL_OP = "invalid or unsupported Perl syntax";
    static ERR_INVALID_REPEAT_OP = "invalid nested repetition operator";
    static ERR_INVALID_REPEAT_SIZE = "invalid repeat count";
    static ERR_MISSING_BRACKET = "missing closing ]";
    static ERR_MISSING_PAREN = "missing closing )";
    static ERR_MISSING_REPEAT_ARGUMENT = "missing argument to repetition operator";
    static ERR_TRAILING_BACKSLASH = "trailing backslash at end of expression";
    static ERR_DUPLICATE_NAMED_CAPTURE = "duplicate capture group name";
    static ERR_UNEXPECTED_PAREN = "unexpected )";
    static ERR_NESTING_DEPTH = "expression nests too deeply";
    static ERR_LARGE = "expression too large";
    static ERR_INVALID_CAPTURE_IN_LOOKBEHIND = "invalid capture in lookbehind";
    static MAX_HEIGHT = 1e3;
    static MAX_SIZE = 3355443;
    static MAX_RUNES = 33554432;
    static ANY_TABLE = new $394755e62edee9eb$var$UnicodeRangeTable(new Uint32Array([
        0,
        $394755e62edee9eb$var$Unicode.MAX_RUNE,
        1
    ]));
    static ASCII_TABLE = new $394755e62edee9eb$var$UnicodeRangeTable(new Uint32Array([
        0,
        127,
        1
    ]));
    static ASCII_FOLD_TABLE = new $394755e62edee9eb$var$UnicodeRangeTable(new Uint32Array([
        0,
        127,
        1,
        383,
        383,
        1,
        8490,
        8490,
        1
    ]));
    static unicodeTable(name) {
        if (name === "Any") return {
            tab: Parser.ANY_TABLE,
            fold: Parser.ANY_TABLE,
            sign: 1
        };
        if (name === "Ascii") return {
            tab: Parser.ASCII_TABLE,
            fold: Parser.ASCII_FOLD_TABLE,
            sign: 1
        };
        if (name === "Assigned") return {
            tab: $394755e62edee9eb$var$UnicodeTables.CATEGORIES.get("Cn"),
            fold: $394755e62edee9eb$var$UnicodeTables.CATEGORIES.get("Cn"),
            sign: -1
        };
        if (name === "Lc") return {
            tab: $394755e62edee9eb$var$UnicodeTables.CATEGORIES.get("LC"),
            fold: $394755e62edee9eb$var$UnicodeTables.FOLD_CATEGORIES.get("LC"),
            sign: 1
        };
        if ($394755e62edee9eb$var$UnicodeTables.CATEGORIES.has(name)) return {
            tab: $394755e62edee9eb$var$UnicodeTables.CATEGORIES.get(name),
            fold: $394755e62edee9eb$var$UnicodeTables.FOLD_CATEGORIES.get(name),
            sign: 1
        };
        if ($394755e62edee9eb$var$UnicodeTables.SCRIPTS.has(name)) return {
            tab: $394755e62edee9eb$var$UnicodeTables.SCRIPTS.get(name),
            fold: $394755e62edee9eb$var$UnicodeTables.FOLD_SCRIPT.get(name),
            sign: 1
        };
        return null;
    }
    static minFoldRune(r) {
        if (r < $394755e62edee9eb$var$Unicode.MIN_FOLD || r > $394755e62edee9eb$var$Unicode.MAX_FOLD) return r;
        let min = r;
        const r0 = r;
        for(r = $394755e62edee9eb$var$Unicode.simpleFold(r); r !== r0; r = $394755e62edee9eb$var$Unicode.simpleFold(r))if (min > r) min = r;
        return min;
    }
    static leadingRegexp(re) {
        if (re.op === $394755e62edee9eb$var$Regexp.Op.EMPTY_MATCH) return null;
        if (re.op === $394755e62edee9eb$var$Regexp.Op.CONCAT && re.subs.length > 0) {
            const sub = re.subs[0];
            if (sub.op === $394755e62edee9eb$var$Regexp.Op.EMPTY_MATCH) return null;
            return sub;
        }
        return re;
    }
    static literalRegexp(s, flags) {
        const re = new $394755e62edee9eb$var$Regexp($394755e62edee9eb$var$Regexp.Op.LITERAL);
        re.flags = flags;
        re.runes = $394755e62edee9eb$var$Utils.stringToRunes(s);
        return re;
    }
    /**
	* Parse regular expression pattern {@code pattern} with mode flags {@code flags}.
	* @param {string} pattern
	* @param {number} flags
	*/ static parse(pattern, flags) {
        return new Parser(pattern, flags).parseInternal();
    }
    static parseRepeat(t) {
        const start = t.pos();
        if (!t.more() || !t.lookingAt("{")) return -1;
        t.skip(1);
        const min = Parser.parseInt(t);
        if (min === -1) return -1;
        if (!t.more()) return -1;
        let max;
        if (!t.lookingAt(",")) max = min;
        else {
            t.skip(1);
            if (!t.more()) return -1;
            if (t.lookingAt("}")) max = -1;
            else if ((max = Parser.parseInt(t)) === -1) return -1;
        }
        if (!t.more() || !t.lookingAt("}")) return -1;
        t.skip(1);
        if (min < 0 || min > 1e3 || max === -2 || max > 1e3 || max >= 0 && min > max) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_INVALID_REPEAT_SIZE, t.from(start));
        return min << 16 | max & $394755e62edee9eb$var$Unicode.MAX_BMP;
    }
    static isValidCaptureName(name) {
        if (name.length === 0) return false;
        for(let i = 0; i < name.length; i++){
            const c = name.codePointAt(i);
            if (c !== $394755e62edee9eb$var$Codepoint.CODES.get("_") && !$394755e62edee9eb$var$Utils.isalnum(c)) return false;
        }
        return true;
    }
    static parseInt(t) {
        const start = t.pos();
        while(t.more() && t.peek() >= $394755e62edee9eb$var$Codepoint.CODES.get("0") && t.peek() <= $394755e62edee9eb$var$Codepoint.CODES.get("9"))t.skip(1);
        const n = t.from(start);
        if (n.length === 0 || n.length > 1 && n.codePointAt(0) === $394755e62edee9eb$var$Codepoint.CODES.get("0")) return -1;
        if (n.length > 8) return -2;
        return parseInt(n, 10);
    }
    static isCharClass(re) {
        return re.op === $394755e62edee9eb$var$Regexp.Op.LITERAL && re.runes.length === 1 || re.op === $394755e62edee9eb$var$Regexp.Op.CHAR_CLASS || re.op === $394755e62edee9eb$var$Regexp.Op.ANY_CHAR_NOT_NL || re.op === $394755e62edee9eb$var$Regexp.Op.ANY_CHAR;
    }
    static matchRune(re, r) {
        switch(re.op){
            case $394755e62edee9eb$var$Regexp.Op.LITERAL:
                return re.runes.length === 1 && re.runes[0] === r;
            case $394755e62edee9eb$var$Regexp.Op.CHAR_CLASS:
                for(let i = 0; i < re.runes.length; i += 2)if (re.runes[i] <= r && r <= re.runes[i + 1]) return true;
                return false;
            case $394755e62edee9eb$var$Regexp.Op.ANY_CHAR_NOT_NL:
                return r !== $394755e62edee9eb$var$Codepoint.CODES.get("\n");
            case $394755e62edee9eb$var$Regexp.Op.ANY_CHAR:
                return true;
        }
        return false;
    }
    static mergeCharClass(dst, src) {
        switch(dst.op){
            case $394755e62edee9eb$var$Regexp.Op.ANY_CHAR:
                break;
            case $394755e62edee9eb$var$Regexp.Op.ANY_CHAR_NOT_NL:
                if (Parser.matchRune(src, $394755e62edee9eb$var$Codepoint.CODES.get("\n"))) dst.op = $394755e62edee9eb$var$Regexp.Op.ANY_CHAR;
                break;
            case $394755e62edee9eb$var$Regexp.Op.CHAR_CLASS:
                if (src.op === $394755e62edee9eb$var$Regexp.Op.LITERAL) dst.runes = new $394755e62edee9eb$var$CharClass(dst.runes).appendLiteral(src.runes[0], src.flags).toArray();
                else dst.runes = new $394755e62edee9eb$var$CharClass(dst.runes).appendClass(src.runes).toArray();
                break;
            case $394755e62edee9eb$var$Regexp.Op.LITERAL:
                if (src.runes[0] === dst.runes[0] && src.flags === dst.flags) break;
                dst.op = $394755e62edee9eb$var$Regexp.Op.CHAR_CLASS;
                dst.runes = new $394755e62edee9eb$var$CharClass().appendLiteral(dst.runes[0], dst.flags).appendLiteral(src.runes[0], src.flags).toArray();
                break;
        }
    }
    static parseEscape(t) {
        const startPos = t.pos();
        t.skip(1);
        if (!t.more()) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_TRAILING_BACKSLASH);
        let c = t.pop();
        bigswitch: switch(c){
            case $394755e62edee9eb$var$Codepoint.CODES.get("1"):
            case $394755e62edee9eb$var$Codepoint.CODES.get("2"):
            case $394755e62edee9eb$var$Codepoint.CODES.get("3"):
            case $394755e62edee9eb$var$Codepoint.CODES.get("4"):
            case $394755e62edee9eb$var$Codepoint.CODES.get("5"):
            case $394755e62edee9eb$var$Codepoint.CODES.get("6"):
            case $394755e62edee9eb$var$Codepoint.CODES.get("7"):
                if (!t.more() || t.peek() < $394755e62edee9eb$var$Codepoint.CODES.get("0") || t.peek() > $394755e62edee9eb$var$Codepoint.CODES.get("7")) break;
            case $394755e62edee9eb$var$Codepoint.CODES.get("0"):
                {
                    let r = c - $394755e62edee9eb$var$Codepoint.CODES.get("0");
                    for(let i = 1; i < 3; i++){
                        if (!t.more() || t.peek() < $394755e62edee9eb$var$Codepoint.CODES.get("0") || t.peek() > $394755e62edee9eb$var$Codepoint.CODES.get("7")) break;
                        r = r * 8 + t.peek() - $394755e62edee9eb$var$Codepoint.CODES.get("0");
                        t.skip(1);
                    }
                    return r;
                }
            case $394755e62edee9eb$var$Codepoint.CODES.get("x"):
                {
                    if (!t.more()) break;
                    c = t.pop();
                    if (c === $394755e62edee9eb$var$Codepoint.CODES.get("{")) {
                        let nhex = 0;
                        let r = 0;
                        while(true){
                            if (!t.more()) break bigswitch;
                            c = t.pop();
                            if (c === $394755e62edee9eb$var$Codepoint.CODES.get("}")) break;
                            const v = $394755e62edee9eb$var$Utils.unhex(c);
                            if (v < 0) break bigswitch;
                            r = r * 16 + v;
                            if (r > $394755e62edee9eb$var$Unicode.MAX_RUNE) break bigswitch;
                            nhex++;
                        }
                        if (nhex === 0) break bigswitch;
                        return r;
                    }
                    const x = $394755e62edee9eb$var$Utils.unhex(c);
                    if (!t.more()) break;
                    c = t.pop();
                    const y = $394755e62edee9eb$var$Utils.unhex(c);
                    if (x < 0 || y < 0) break;
                    return x * 16 + y;
                }
            case $394755e62edee9eb$var$Codepoint.CODES.get("a"):
                return $394755e62edee9eb$var$Codepoint.CODES.get("\x07");
            case $394755e62edee9eb$var$Codepoint.CODES.get("f"):
                return $394755e62edee9eb$var$Codepoint.CODES.get("\f");
            case $394755e62edee9eb$var$Codepoint.CODES.get("n"):
                return $394755e62edee9eb$var$Codepoint.CODES.get("\n");
            case $394755e62edee9eb$var$Codepoint.CODES.get("r"):
                return $394755e62edee9eb$var$Codepoint.CODES.get("\r");
            case $394755e62edee9eb$var$Codepoint.CODES.get("t"):
                return $394755e62edee9eb$var$Codepoint.CODES.get("	");
            case $394755e62edee9eb$var$Codepoint.CODES.get("v"):
                return $394755e62edee9eb$var$Codepoint.CODES.get("\v");
            default:
                if (c <= $394755e62edee9eb$var$Unicode.MAX_ASCII && !$394755e62edee9eb$var$Utils.isalnum(c)) return c;
                break;
        }
        throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_INVALID_ESCAPE, t.from(startPos));
    }
    static parseClassChar(t, wholeClassPos) {
        if (!t.more()) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_MISSING_BRACKET, t.from(wholeClassPos));
        if (t.lookingAt("\\")) return Parser.parseEscape(t);
        return t.pop();
    }
    static concatRunes(x, y) {
        for(let i = 0; i < y.length; i++)x.push(y[i]);
        return x;
    }
    static hasCapture(re) {
        if (re === null) return false;
        if (re.op === $394755e62edee9eb$var$Regexp.Op.CAPTURE) return true;
        if (re.subs) {
            for (let sub of re.subs)if (Parser.hasCapture(sub)) return true;
        }
        return false;
    }
    constructor(wholeRegexp, flags = 0){
        this.wholeRegexp = wholeRegexp;
        this.flags = flags;
        this.numCap = 0;
        this.namedGroups = Object.create(null);
        this.stack = [];
        this.free = null;
        this.numRegexp = 0;
        this.numRunes = 0;
        this.repeats = 0;
        this.height = null;
        this.size = null;
        this.nlb = 0;
    }
    newRegexp(op) {
        let re = this.free;
        if (re !== null && re.subs !== null && re.subs.length > 0) {
            this.free = re.subs[0];
            re.reinit();
            re.op = op;
        } else {
            re = new $394755e62edee9eb$var$Regexp(op);
            this.numRegexp += 1;
        }
        return re;
    }
    reuse(re) {
        if (this.height !== null && this.height.has(re)) this.height.delete(re);
        if (re.subs !== null && re.subs.length > 0) re.subs[0] = this.free;
        this.free = re;
    }
    checkLimits(re) {
        if (this.numRunes > Parser.MAX_RUNES) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_LARGE);
        this.checkSize(re);
        this.checkHeight(re);
    }
    checkSize(re) {
        if (this.size === null) {
            if (this.repeats === 0) this.repeats = 1;
            if (re.op === $394755e62edee9eb$var$Regexp.Op.REPEAT) {
                let n = re.max;
                if (n === -1) n = re.min;
                if (n <= 0) n = 1;
                if (n > Math.floor(Parser.MAX_SIZE / this.repeats)) this.repeats = Parser.MAX_SIZE;
                else this.repeats *= n;
            }
            if (this.numRegexp < Math.floor(Parser.MAX_SIZE / this.repeats)) return;
            this.size = /* @__PURE__ */ new Map();
            for (let reEx of this.stack)this.checkSize(reEx);
        }
        if (this.calcSize(re, true) > Parser.MAX_SIZE) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_LARGE);
    }
    calcSize(re, force = false) {
        if (!force && this.size !== null) {
            if (this.size.has(re)) return this.size.get(re);
        }
        let size = 0;
        switch(re.op){
            case $394755e62edee9eb$var$Regexp.Op.LITERAL:
                size = re.runes.length;
                break;
            case $394755e62edee9eb$var$Regexp.Op.PLB:
            case $394755e62edee9eb$var$Regexp.Op.NLB:
            case $394755e62edee9eb$var$Regexp.Op.CAPTURE:
            case $394755e62edee9eb$var$Regexp.Op.STAR:
                size = 2 + this.calcSize(re.subs[0]);
                break;
            case $394755e62edee9eb$var$Regexp.Op.PLUS:
            case $394755e62edee9eb$var$Regexp.Op.QUEST:
                size = 1 + this.calcSize(re.subs[0]);
                break;
            case $394755e62edee9eb$var$Regexp.Op.CONCAT:
                for (let sub of re.subs)size = size + this.calcSize(sub);
                break;
            case $394755e62edee9eb$var$Regexp.Op.ALTERNATE:
                for (let sub of re.subs)size = size + this.calcSize(sub);
                if (re.subs.length > 1) size = size + re.subs.length - 1;
                break;
            case $394755e62edee9eb$var$Regexp.Op.REPEAT:
                {
                    let sub = this.calcSize(re.subs[0]);
                    if (re.max === -1) {
                        if (re.min === 0) size = 2 + sub;
                        else size = 1 + re.min * sub;
                        break;
                    }
                    size = re.max * sub + (re.max - re.min);
                    break;
                }
        }
        size = Math.max(1, size);
        if (this.size === null) this.size = /* @__PURE__ */ new Map();
        this.size.set(re, size);
        return size;
    }
    checkHeight(re) {
        if (this.numRegexp < Parser.MAX_HEIGHT) return;
        if (this.height === null) {
            this.height = /* @__PURE__ */ new Map();
            for (let reEx of this.stack)this.checkHeight(reEx);
        }
        if (this.calcHeight(re, true) > Parser.MAX_HEIGHT) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_NESTING_DEPTH);
    }
    calcHeight(re, force = false) {
        if (!force && this.height !== null) {
            if (this.height.has(re)) return this.height.get(re);
        }
        let h = 1;
        for (let sub of re.subs){
            const hsub = this.calcHeight(sub);
            if (h < 1 + hsub) h = 1 + hsub;
        }
        if (this.height === null) this.height = /* @__PURE__ */ new Map();
        this.height.set(re, h);
        return h;
    }
    pop() {
        return this.stack.pop();
    }
    popToPseudo() {
        const n = this.stack.length;
        let i = n;
        while(i > 0 && !$394755e62edee9eb$var$Regexp.isPseudoOp(this.stack[i - 1].op))i--;
        const r = this.stack.slice(i, n);
        this.stack = this.stack.slice(0, i);
        return r;
    }
    push(re) {
        this.numRunes += re.runes.length;
        if (re.op === $394755e62edee9eb$var$Regexp.Op.CHAR_CLASS && re.runes.length === 2 && re.runes[0] === re.runes[1]) {
            if (this.maybeConcat(re.runes[0], this.flags & ~$394755e62edee9eb$var$RE2Flags.FOLD_CASE)) return null;
            re.op = $394755e62edee9eb$var$Regexp.Op.LITERAL;
            re.runes = [
                re.runes[0]
            ];
            re.flags = this.flags & ~$394755e62edee9eb$var$RE2Flags.FOLD_CASE;
        } else if (re.op === $394755e62edee9eb$var$Regexp.Op.CHAR_CLASS && re.runes.length === 4 && re.runes[0] === re.runes[1] && re.runes[2] === re.runes[3] && $394755e62edee9eb$var$Unicode.simpleFold(re.runes[0]) === re.runes[2] && $394755e62edee9eb$var$Unicode.simpleFold(re.runes[2]) === re.runes[0] || re.op === $394755e62edee9eb$var$Regexp.Op.CHAR_CLASS && re.runes.length === 2 && re.runes[0] + 1 === re.runes[1] && $394755e62edee9eb$var$Unicode.simpleFold(re.runes[0]) === re.runes[1] && $394755e62edee9eb$var$Unicode.simpleFold(re.runes[1]) === re.runes[0]) {
            if (this.maybeConcat(re.runes[0], this.flags | $394755e62edee9eb$var$RE2Flags.FOLD_CASE)) return null;
            re.op = $394755e62edee9eb$var$Regexp.Op.LITERAL;
            re.runes = [
                re.runes[0]
            ];
            re.flags = this.flags | $394755e62edee9eb$var$RE2Flags.FOLD_CASE;
        } else this.maybeConcat(-1, 0);
        this.stack.push(re);
        this.checkLimits(re);
        return re;
    }
    maybeConcat(r, flags) {
        const n = this.stack.length;
        if (n < 2) return false;
        const re1 = this.stack[n - 1];
        const re2 = this.stack[n - 2];
        if (re1.op !== $394755e62edee9eb$var$Regexp.Op.LITERAL || re2.op !== $394755e62edee9eb$var$Regexp.Op.LITERAL || (re1.flags & $394755e62edee9eb$var$RE2Flags.FOLD_CASE) !== (re2.flags & $394755e62edee9eb$var$RE2Flags.FOLD_CASE)) return false;
        re2.runes = Parser.concatRunes(re2.runes, re1.runes);
        if (r >= 0) {
            re1.runes = [
                r
            ];
            re1.flags = flags;
            return true;
        }
        this.pop();
        this.reuse(re1);
        return false;
    }
    newLiteral(r, flags) {
        const re = this.newRegexp($394755e62edee9eb$var$Regexp.Op.LITERAL);
        re.flags = flags;
        if ((flags & $394755e62edee9eb$var$RE2Flags.FOLD_CASE) !== 0) r = Parser.minFoldRune(r);
        re.runes = [
            r
        ];
        return re;
    }
    literal(r) {
        this.push(this.newLiteral(r, this.flags));
    }
    op(op) {
        const re = this.newRegexp(op);
        re.flags = this.flags;
        return this.push(re);
    }
    repeat(op, min, max, beforePos, t, lastRepeatPos) {
        let flags = this.flags;
        if ((flags & $394755e62edee9eb$var$RE2Flags.PERL_X) !== 0) {
            if (t.more() && t.lookingAt("?")) {
                t.skip(1);
                flags ^= $394755e62edee9eb$var$RE2Flags.NON_GREEDY;
            }
            if (lastRepeatPos !== -1) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_INVALID_REPEAT_OP, t.from(lastRepeatPos));
        }
        const n = this.stack.length;
        if (n === 0) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_MISSING_REPEAT_ARGUMENT, t.from(beforePos));
        const sub = this.stack[n - 1];
        if ($394755e62edee9eb$var$Regexp.isPseudoOp(sub.op)) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_MISSING_REPEAT_ARGUMENT, t.from(beforePos));
        const re = this.newRegexp(op);
        re.min = min;
        re.max = max;
        re.flags = flags;
        re.subs = [
            sub
        ];
        this.stack[n - 1] = re;
        this.checkLimits(re);
        if (op === $394755e62edee9eb$var$Regexp.Op.REPEAT && (min >= 2 || max >= 2) && !this.repeatIsValid(re, 1e3)) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_INVALID_REPEAT_SIZE, t.from(beforePos));
    }
    repeatIsValid(re, n) {
        if (re.op === $394755e62edee9eb$var$Regexp.Op.REPEAT) {
            let m = re.max;
            if (m === 0) return true;
            if (m < 0) m = re.min;
            if (m > n) return false;
            if (m > 0) n = Math.trunc(n / m);
        }
        for (let sub of re.subs)if (!this.repeatIsValid(sub, n)) return false;
        return true;
    }
    concat() {
        this.maybeConcat(-1, 0);
        const subs = this.popToPseudo();
        if (subs.length === 0) return this.push(this.newRegexp($394755e62edee9eb$var$Regexp.Op.EMPTY_MATCH));
        return this.push(this.collapse(subs, $394755e62edee9eb$var$Regexp.Op.CONCAT));
    }
    alternate() {
        const subs = this.popToPseudo();
        if (subs.length > 0) this.cleanAlt(subs[subs.length - 1]);
        if (subs.length === 0) return this.push(this.newRegexp($394755e62edee9eb$var$Regexp.Op.NO_MATCH));
        return this.push(this.collapse(subs, $394755e62edee9eb$var$Regexp.Op.ALTERNATE));
    }
    cleanAlt(re) {
        if (re.op === $394755e62edee9eb$var$Regexp.Op.CHAR_CLASS) {
            re.runes = new $394755e62edee9eb$var$CharClass(re.runes).cleanClass().toArray();
            if (re.runes.length === 2 && re.runes[0] === 0 && re.runes[1] === $394755e62edee9eb$var$Unicode.MAX_RUNE) {
                re.runes = [];
                re.op = $394755e62edee9eb$var$Regexp.Op.ANY_CHAR;
            } else if (re.runes.length === 4 && re.runes[0] === 0 && re.runes[1] === $394755e62edee9eb$var$Codepoint.CODES.get("\n") - 1 && re.runes[2] === $394755e62edee9eb$var$Codepoint.CODES.get("\n") + 1 && re.runes[3] === $394755e62edee9eb$var$Unicode.MAX_RUNE) {
                re.runes = [];
                re.op = $394755e62edee9eb$var$Regexp.Op.ANY_CHAR_NOT_NL;
            }
        }
    }
    collapse(subs, op) {
        if (subs.length === 1) return subs[0];
        let len = 0;
        for (let sub of subs)len += sub.op === op ? sub.subs.length : 1;
        let newsubs = new Array(len).fill(null);
        let i = 0;
        for (let sub of subs)if (sub.op === op) {
            for(let j = 0; j < sub.subs.length; j++)newsubs[i++] = sub.subs[j];
            this.reuse(sub);
        } else newsubs[i++] = sub;
        let re = this.newRegexp(op);
        re.subs = newsubs;
        if (op === $394755e62edee9eb$var$Regexp.Op.ALTERNATE) {
            re.subs = this.factor(re.subs);
            if (re.subs.length === 1) {
                const old = re;
                re = re.subs[0];
                this.reuse(old);
            }
        }
        return re;
    }
    factor(array) {
        if (array.length < 2) return array;
        let s = 0;
        let lensub = array.length;
        let lenout = 0;
        let str = null;
        let strlen = 0;
        let strflags = 0;
        let start = 0;
        for(let i = 0; i <= lensub; i++){
            let istr = null;
            let istrlen = 0;
            let iflags = 0;
            if (i < lensub) {
                let re = array[s + i];
                if (re.op === $394755e62edee9eb$var$Regexp.Op.CONCAT && re.subs.length > 0) re = re.subs[0];
                if (re.op === $394755e62edee9eb$var$Regexp.Op.LITERAL) {
                    istr = re.runes;
                    istrlen = re.runes.length;
                    iflags = re.flags & $394755e62edee9eb$var$RE2Flags.FOLD_CASE;
                }
                if (iflags === strflags) {
                    let same = 0;
                    while(same < strlen && same < istrlen && str[same] === istr[same])same++;
                    if (same > 0) {
                        strlen = same;
                        continue;
                    }
                }
            }
            if (i === start) ;
            else if (i === start + 1) array[lenout++] = array[s + start];
            else {
                const prefix = this.newRegexp($394755e62edee9eb$var$Regexp.Op.LITERAL);
                prefix.flags = strflags;
                prefix.runes = str.slice(0, strlen);
                for(let j = start; j < i; j++){
                    array[s + j] = this.removeLeadingString(array[s + j], strlen);
                    this.checkLimits(array[s + j]);
                }
                const suffix = this.collapse(array.slice(s + start, s + i), $394755e62edee9eb$var$Regexp.Op.ALTERNATE);
                const re = this.newRegexp($394755e62edee9eb$var$Regexp.Op.CONCAT);
                re.subs = [
                    prefix,
                    suffix
                ];
                array[lenout++] = re;
            }
            start = i;
            str = istr;
            strlen = istrlen;
            strflags = iflags;
        }
        lensub = lenout;
        s = 0;
        start = 0;
        lenout = 0;
        let first = null;
        for(let i = 0; i <= lensub; i++){
            let ifirst = null;
            if (i < lensub) {
                ifirst = Parser.leadingRegexp(array[s + i]);
                if (first !== null && first.equals(ifirst) && (Parser.isCharClass(first) || first.op === $394755e62edee9eb$var$Regexp.Op.REPEAT && first.min === first.max && Parser.isCharClass(first.subs[0]))) continue;
            }
            if (i === start) ;
            else if (i === start + 1) array[lenout++] = array[s + start];
            else {
                const prefix = first;
                for(let j = start; j < i; j++){
                    const reuse = j !== start;
                    array[s + j] = this.removeLeadingRegexp(array[s + j], reuse);
                    this.checkLimits(array[s + j]);
                }
                const suffix = this.collapse(array.slice(s + start, s + i), $394755e62edee9eb$var$Regexp.Op.ALTERNATE);
                const re = this.newRegexp($394755e62edee9eb$var$Regexp.Op.CONCAT);
                re.subs = [
                    prefix,
                    suffix
                ];
                array[lenout++] = re;
            }
            start = i;
            first = ifirst;
        }
        lensub = lenout;
        s = 0;
        start = 0;
        lenout = 0;
        for(let i = 0; i <= lensub; i++){
            if (i < lensub && Parser.isCharClass(array[s + i])) continue;
            if (i === start) ;
            else if (i === start + 1) array[lenout++] = array[s + start];
            else {
                let max = start;
                for(let j = start + 1; j < i; j++){
                    const subMax = array[s + max];
                    const subJ = array[s + j];
                    if (subMax.op < subJ.op || subMax.op === subJ.op && (subMax.runes !== null ? subMax.runes.length : 0) < (subJ.runes !== null ? subJ.runes.length : 0)) max = j;
                }
                const tmp = array[s + start];
                array[s + start] = array[s + max];
                array[s + max] = tmp;
                for(let j = start + 1; j < i; j++){
                    Parser.mergeCharClass(array[s + start], array[s + j]);
                    this.reuse(array[s + j]);
                }
                this.cleanAlt(array[s + start]);
                array[lenout++] = array[s + start];
            }
            if (i < lensub) array[lenout++] = array[s + i];
            start = i + 1;
        }
        lensub = lenout;
        s = 0;
        start = 0;
        lenout = 0;
        for(let i = 0; i < lensub; ++i){
            if (i + 1 < lensub && array[s + i].op === $394755e62edee9eb$var$Regexp.Op.EMPTY_MATCH && array[s + i + 1].op === $394755e62edee9eb$var$Regexp.Op.EMPTY_MATCH) continue;
            array[lenout++] = array[s + i];
        }
        lensub = lenout;
        s = 0;
        return array.slice(s, lensub);
    }
    removeLeadingString(re, n) {
        if (re.op === $394755e62edee9eb$var$Regexp.Op.CONCAT && re.subs.length > 0) {
            const sub = this.removeLeadingString(re.subs[0], n);
            re.subs[0] = sub;
            if (sub.op === $394755e62edee9eb$var$Regexp.Op.EMPTY_MATCH) {
                this.reuse(sub);
                switch(re.subs.length){
                    case 0:
                    case 1:
                        re.op = $394755e62edee9eb$var$Regexp.Op.EMPTY_MATCH;
                        re.subs = $394755e62edee9eb$var$Regexp.emptySubs();
                        break;
                    case 2:
                        {
                            const old = re;
                            re = re.subs[1];
                            this.reuse(old);
                            break;
                        }
                    default:
                        re.subs = re.subs.slice(1, re.subs.length);
                        break;
                }
            }
            return re;
        }
        if (re.op === $394755e62edee9eb$var$Regexp.Op.LITERAL) {
            re.runes = re.runes.slice(n, re.runes.length);
            if (re.runes.length === 0) re.op = $394755e62edee9eb$var$Regexp.Op.EMPTY_MATCH;
        }
        return re;
    }
    removeLeadingRegexp(re, reuse) {
        if (re.op === $394755e62edee9eb$var$Regexp.Op.CONCAT && re.subs.length > 0) {
            if (reuse) this.reuse(re.subs[0]);
            re.subs = re.subs.slice(1, re.subs.length);
            switch(re.subs.length){
                case 0:
                    re.op = $394755e62edee9eb$var$Regexp.Op.EMPTY_MATCH;
                    re.subs = $394755e62edee9eb$var$Regexp.emptySubs();
                    break;
                case 1:
                    {
                        const old = re;
                        re = re.subs[0];
                        this.reuse(old);
                        break;
                    }
            }
            return re;
        }
        if (reuse) this.reuse(re);
        return this.newRegexp($394755e62edee9eb$var$Regexp.Op.EMPTY_MATCH);
    }
    parseInternal() {
        if ((this.flags & $394755e62edee9eb$var$RE2Flags.LITERAL) !== 0) return Parser.literalRegexp(this.wholeRegexp, this.flags);
        let lastRepeatPos = -1;
        let min = -1;
        let max = -1;
        const t = new $394755e62edee9eb$var$StringIterator(this.wholeRegexp);
        while(t.more()){
            let repeatPos = -1;
            bigswitch: switch(t.peek()){
                case $394755e62edee9eb$var$Codepoint.CODES.get("("):
                    if ((this.flags & $394755e62edee9eb$var$RE2Flags.LOOKBEHIND) !== 0) {
                        if (t.lookingAt("(?<=")) {
                            this.parsePosLookBehind();
                            t.skip(4);
                            break;
                        }
                        if (t.lookingAt("(?<!")) {
                            this.parseNegLookBehind();
                            t.skip(4);
                            break;
                        }
                    }
                    if ((this.flags & $394755e62edee9eb$var$RE2Flags.PERL_X) !== 0 && t.lookingAt("(?")) {
                        this.parsePerlFlags(t);
                        break;
                    }
                    this.op($394755e62edee9eb$var$Regexp.Op.LEFT_PAREN).cap = ++this.numCap;
                    t.skip(1);
                    break;
                case $394755e62edee9eb$var$Codepoint.CODES.get("|"):
                    this.parseVerticalBar();
                    t.skip(1);
                    break;
                case $394755e62edee9eb$var$Codepoint.CODES.get(")"):
                    this.parseRightParen();
                    t.skip(1);
                    break;
                case $394755e62edee9eb$var$Codepoint.CODES.get("^"):
                    if ((this.flags & $394755e62edee9eb$var$RE2Flags.ONE_LINE) !== 0) this.op($394755e62edee9eb$var$Regexp.Op.BEGIN_TEXT);
                    else this.op($394755e62edee9eb$var$Regexp.Op.BEGIN_LINE);
                    t.skip(1);
                    break;
                case $394755e62edee9eb$var$Codepoint.CODES.get("$"):
                    if ((this.flags & $394755e62edee9eb$var$RE2Flags.ONE_LINE) !== 0) this.op($394755e62edee9eb$var$Regexp.Op.END_TEXT).flags |= $394755e62edee9eb$var$RE2Flags.WAS_DOLLAR;
                    else this.op($394755e62edee9eb$var$Regexp.Op.END_LINE);
                    t.skip(1);
                    break;
                case $394755e62edee9eb$var$Codepoint.CODES.get("."):
                    if ((this.flags & $394755e62edee9eb$var$RE2Flags.DOT_NL) !== 0) this.op($394755e62edee9eb$var$Regexp.Op.ANY_CHAR);
                    else this.op($394755e62edee9eb$var$Regexp.Op.ANY_CHAR_NOT_NL);
                    t.skip(1);
                    break;
                case $394755e62edee9eb$var$Codepoint.CODES.get("["):
                    this.parseClass(t);
                    break;
                case $394755e62edee9eb$var$Codepoint.CODES.get("*"):
                case $394755e62edee9eb$var$Codepoint.CODES.get("+"):
                case $394755e62edee9eb$var$Codepoint.CODES.get("?"):
                    {
                        repeatPos = t.pos();
                        let op = null;
                        switch(t.pop()){
                            case $394755e62edee9eb$var$Codepoint.CODES.get("*"):
                                op = $394755e62edee9eb$var$Regexp.Op.STAR;
                                break;
                            case $394755e62edee9eb$var$Codepoint.CODES.get("+"):
                                op = $394755e62edee9eb$var$Regexp.Op.PLUS;
                                break;
                            case $394755e62edee9eb$var$Codepoint.CODES.get("?"):
                                op = $394755e62edee9eb$var$Regexp.Op.QUEST;
                                break;
                        }
                        this.repeat(op, min, max, repeatPos, t, lastRepeatPos);
                        break;
                    }
                case $394755e62edee9eb$var$Codepoint.CODES.get("{"):
                    {
                        repeatPos = t.pos();
                        const minMax = Parser.parseRepeat(t);
                        if (minMax < 0) {
                            t.rewindTo(repeatPos);
                            this.literal(t.pop());
                            break;
                        }
                        min = minMax >> 16;
                        max = (minMax & $394755e62edee9eb$var$Unicode.MAX_BMP) << 16 >> 16;
                        this.repeat($394755e62edee9eb$var$Regexp.Op.REPEAT, min, max, repeatPos, t, lastRepeatPos);
                        break;
                    }
                case $394755e62edee9eb$var$Codepoint.CODES.get("\\"):
                    {
                        const savedPos = t.pos();
                        t.skip(1);
                        if ((this.flags & $394755e62edee9eb$var$RE2Flags.PERL_X) !== 0 && t.more()) switch(t.pop()){
                            case $394755e62edee9eb$var$Codepoint.CODES.get("A"):
                                this.op($394755e62edee9eb$var$Regexp.Op.BEGIN_TEXT);
                                break bigswitch;
                            case $394755e62edee9eb$var$Codepoint.CODES.get("b"):
                                this.op($394755e62edee9eb$var$Regexp.Op.WORD_BOUNDARY);
                                break bigswitch;
                            case $394755e62edee9eb$var$Codepoint.CODES.get("B"):
                                this.op($394755e62edee9eb$var$Regexp.Op.NO_WORD_BOUNDARY);
                                break bigswitch;
                            case $394755e62edee9eb$var$Codepoint.CODES.get("C"):
                                throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_INVALID_ESCAPE, "\\C");
                            case $394755e62edee9eb$var$Codepoint.CODES.get("Q"):
                                {
                                    let lit = t.rest();
                                    const i = lit.indexOf("\\E");
                                    if (i >= 0) {
                                        lit = lit.substring(0, i);
                                        t.skipString(lit);
                                        t.skipString("\\E");
                                    } else t.skipString(lit);
                                    let j = 0;
                                    while(j < lit.length){
                                        const codepoint = lit.codePointAt(j);
                                        this.literal(codepoint);
                                        j += $394755e62edee9eb$var$Utils.charCount(codepoint);
                                    }
                                    break bigswitch;
                                }
                            case $394755e62edee9eb$var$Codepoint.CODES.get("z"):
                                this.op($394755e62edee9eb$var$Regexp.Op.END_TEXT);
                                break bigswitch;
                            default:
                                t.rewindTo(savedPos);
                                break;
                        }
                        else t.rewindTo(savedPos);
                        const re = this.newRegexp($394755e62edee9eb$var$Regexp.Op.CHAR_CLASS);
                        re.flags = this.flags;
                        if (t.lookingAt("\\p") || t.lookingAt("\\P")) {
                            const cc = new $394755e62edee9eb$var$CharClass();
                            if (this.parseUnicodeClass(t, cc)) {
                                re.runes = cc.toArray();
                                this.push(re);
                                break bigswitch;
                            }
                        }
                        const cc = new $394755e62edee9eb$var$CharClass();
                        if (this.parsePerlClassEscape(t, cc)) {
                            re.runes = cc.toArray();
                            this.push(re);
                            break bigswitch;
                        }
                        t.rewindTo(savedPos);
                        this.reuse(re);
                        this.literal(Parser.parseEscape(t));
                        break;
                    }
                default:
                    this.literal(t.pop());
                    break;
            }
            lastRepeatPos = repeatPos;
        }
        this.concat();
        if (this.swapVerticalBar()) this.pop();
        this.alternate();
        if (this.stack.length !== 1) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_MISSING_PAREN, this.wholeRegexp);
        this.stack[0].namedGroups = this.namedGroups;
        return this.stack[0];
    }
    parsePerlFlags(t) {
        const startPos = t.pos();
        const s = t.rest();
        if (s.startsWith("(?P<") || s.startsWith("(?<")) {
            const begin = s.charAt(2) === "P" ? 4 : 3;
            const end = s.indexOf(">");
            if (end < 0) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_INVALID_NAMED_CAPTURE, s);
            const name = s.substring(begin, end);
            t.skipString(name);
            t.skip(begin + 1);
            if (!Parser.isValidCaptureName(name)) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_INVALID_NAMED_CAPTURE, s.substring(0, end + 1));
            const re = this.op($394755e62edee9eb$var$Regexp.Op.LEFT_PAREN);
            re.cap = ++this.numCap;
            if (this.namedGroups[name]) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_DUPLICATE_NAMED_CAPTURE, name);
            this.namedGroups[name] = this.numCap;
            re.name = name;
            return;
        }
        t.skip(2);
        let flags = this.flags;
        let sign = 1;
        let sawFlag = false;
        loop: while(t.more()){
            const c = t.pop();
            switch(c){
                case $394755e62edee9eb$var$Codepoint.CODES.get("i"):
                    flags |= $394755e62edee9eb$var$RE2Flags.FOLD_CASE;
                    sawFlag = true;
                    break;
                case $394755e62edee9eb$var$Codepoint.CODES.get("m"):
                    flags &= ~$394755e62edee9eb$var$RE2Flags.ONE_LINE;
                    sawFlag = true;
                    break;
                case $394755e62edee9eb$var$Codepoint.CODES.get("s"):
                    flags |= $394755e62edee9eb$var$RE2Flags.DOT_NL;
                    sawFlag = true;
                    break;
                case $394755e62edee9eb$var$Codepoint.CODES.get("U"):
                    flags |= $394755e62edee9eb$var$RE2Flags.NON_GREEDY;
                    sawFlag = true;
                    break;
                case $394755e62edee9eb$var$Codepoint.CODES.get("-"):
                    if (sign < 0) break loop;
                    sign = -1;
                    flags = ~flags;
                    sawFlag = false;
                    break;
                case $394755e62edee9eb$var$Codepoint.CODES.get(":"):
                case $394755e62edee9eb$var$Codepoint.CODES.get(")"):
                    if (sign < 0) {
                        if (!sawFlag) break loop;
                        flags = ~flags;
                    }
                    if (c === $394755e62edee9eb$var$Codepoint.CODES.get(":")) this.op($394755e62edee9eb$var$Regexp.Op.LEFT_PAREN);
                    this.flags = flags;
                    return;
                default:
                    break loop;
            }
        }
        throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_INVALID_PERL_OP, t.from(startPos));
    }
    parsePosLookBehind() {
        const re = this.newRegexp($394755e62edee9eb$var$Regexp.Op.LEFT_PAREN);
        re.flags = this.flags;
        re.lb = ++this.nlb;
        return this.push(re);
    }
    parseNegLookBehind() {
        const re = this.newRegexp($394755e62edee9eb$var$Regexp.Op.LEFT_PAREN);
        re.flags = this.flags;
        re.lb = -++this.nlb;
        return this.push(re);
    }
    parseVerticalBar() {
        this.concat();
        if (!this.swapVerticalBar()) this.op($394755e62edee9eb$var$Regexp.Op.VERTICAL_BAR);
    }
    swapVerticalBar() {
        const n = this.stack.length;
        if (n >= 3 && this.stack[n - 2].op === $394755e62edee9eb$var$Regexp.Op.VERTICAL_BAR && Parser.isCharClass(this.stack[n - 1]) && Parser.isCharClass(this.stack[n - 3])) {
            let re1 = this.stack[n - 1];
            let re3 = this.stack[n - 3];
            if (re1.op > re3.op) {
                const tmp = re3;
                re3 = re1;
                re1 = tmp;
                this.stack[n - 3] = re3;
            }
            Parser.mergeCharClass(re3, re1);
            this.reuse(re1);
            this.pop();
            return true;
        }
        if (n >= 2) {
            const re1 = this.stack[n - 1];
            const re2 = this.stack[n - 2];
            if (re2.op === $394755e62edee9eb$var$Regexp.Op.VERTICAL_BAR) {
                if (n >= 3) this.cleanAlt(this.stack[n - 3]);
                this.stack[n - 2] = re1;
                this.stack[n - 1] = re2;
                return true;
            }
        }
        return false;
    }
    parseRightParen() {
        this.concat();
        if (this.swapVerticalBar()) this.pop();
        this.alternate();
        if (this.stack.length < 2) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_UNEXPECTED_PAREN, this.wholeRegexp);
        const re1 = this.pop();
        const re2 = this.pop();
        if (re2.op !== $394755e62edee9eb$var$Regexp.Op.LEFT_PAREN) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_UNEXPECTED_PAREN, this.wholeRegexp);
        this.flags = re2.flags;
        if (re2.lb !== 0) {
            if (Parser.hasCapture(re1)) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_INVALID_CAPTURE_IN_LOOKBEHIND, this.wholeRegexp);
            if (re2.lb > 0) re2.op = $394755e62edee9eb$var$Regexp.Op.PLB;
            else re2.op = $394755e62edee9eb$var$Regexp.Op.NLB;
            re2.subs = [
                re1
            ];
            this.push(re2);
            return;
        }
        if (re2.cap === 0) this.push(re1);
        else {
            re2.op = $394755e62edee9eb$var$Regexp.Op.CAPTURE;
            re2.subs = [
                re1
            ];
            this.push(re2);
        }
    }
    parsePerlClassEscape(t, cc) {
        const beforePos = t.pos();
        if ((this.flags & $394755e62edee9eb$var$RE2Flags.PERL_X) === 0 || !t.more() || t.pop() !== $394755e62edee9eb$var$Codepoint.CODES.get("\\") || !t.more()) return false;
        t.pop();
        const p = t.from(beforePos);
        const g = $394755e62edee9eb$var$PERL_GROUPS.has(p) ? $394755e62edee9eb$var$PERL_GROUPS.get(p) : null;
        if (g === null) return false;
        cc.appendGroup(g, (this.flags & $394755e62edee9eb$var$RE2Flags.FOLD_CASE) !== 0);
        return true;
    }
    parseNamedClass(t, cc) {
        const cls = t.rest();
        const i = cls.indexOf(":]");
        if (i < 0) return false;
        const name = cls.substring(0, i + 2);
        t.skipString(name);
        const g = $394755e62edee9eb$var$POSIX_GROUPS.has(name) ? $394755e62edee9eb$var$POSIX_GROUPS.get(name) : null;
        if (g === null) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_INVALID_CHAR_RANGE, name);
        cc.appendGroup(g, (this.flags & $394755e62edee9eb$var$RE2Flags.FOLD_CASE) !== 0);
        return true;
    }
    parseUnicodeClass(t, cc) {
        const startPos = t.pos();
        if ((this.flags & $394755e62edee9eb$var$RE2Flags.UNICODE_GROUPS) === 0 || !t.lookingAt("\\p") && !t.lookingAt("\\P")) return false;
        t.skip(1);
        let sign = 1;
        let c = t.pop();
        if (c === $394755e62edee9eb$var$Codepoint.CODES.get("P")) sign = -1;
        if (!t.more()) {
            t.rewindTo(startPos);
            throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_INVALID_CHAR_RANGE, t.rest());
        }
        c = t.pop();
        let name;
        if (c !== $394755e62edee9eb$var$Codepoint.CODES.get("{")) name = $394755e62edee9eb$var$Utils.runeToString(c);
        else {
            const rest = t.rest();
            const end = rest.indexOf("}");
            if (end < 0) {
                t.rewindTo(startPos);
                throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_INVALID_CHAR_RANGE, t.rest());
            }
            name = rest.substring(0, end);
            t.skipString(name);
            t.skip(1);
        }
        if (!(name.length === 0) && name.codePointAt(0) === $394755e62edee9eb$var$Codepoint.CODES.get("^")) {
            sign = 0 - sign;
            name = name.substring(1);
        }
        const pair = Parser.unicodeTable(name);
        if (pair === null) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_INVALID_CHAR_RANGE, t.from(startPos));
        if (pair.sign < 0) sign = 0 - sign;
        const tab = pair.tab;
        const fold = pair.fold;
        if ((this.flags & $394755e62edee9eb$var$RE2Flags.FOLD_CASE) === 0 || fold === null) cc.appendTableWithSign(tab, sign);
        else {
            const tmp = new $394755e62edee9eb$var$CharClass().appendTable(tab).appendTable(fold).cleanClass().toArray();
            cc.appendClassWithSign(tmp, sign);
        }
        return true;
    }
    parseClass(t) {
        const startPos = t.pos();
        t.skip(1);
        const re = this.newRegexp($394755e62edee9eb$var$Regexp.Op.CHAR_CLASS);
        re.flags = this.flags;
        const cc = new $394755e62edee9eb$var$CharClass();
        let sign = 1;
        if (t.more() && t.lookingAt("^")) {
            sign = -1;
            t.skip(1);
            if ((this.flags & $394755e62edee9eb$var$RE2Flags.CLASS_NL) === 0) cc.appendRange($394755e62edee9eb$var$Codepoint.CODES.get("\n"), $394755e62edee9eb$var$Codepoint.CODES.get("\n"));
        }
        let first = true;
        while(!t.more() || t.peek() !== $394755e62edee9eb$var$Codepoint.CODES.get("]") || first){
            if (t.more() && t.lookingAt("-") && (this.flags & $394755e62edee9eb$var$RE2Flags.PERL_X) === 0 && !first) {
                const s = t.rest();
                if (s === "-" || !s.startsWith("-]")) {
                    t.rewindTo(startPos);
                    throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_INVALID_CHAR_RANGE, t.rest());
                }
            }
            first = false;
            const beforePos = t.pos();
            if (t.lookingAt("[:")) {
                if (this.parseNamedClass(t, cc)) continue;
                t.rewindTo(beforePos);
            }
            if (this.parseUnicodeClass(t, cc)) continue;
            if (this.parsePerlClassEscape(t, cc)) continue;
            t.rewindTo(beforePos);
            const lo = Parser.parseClassChar(t, startPos);
            let hi = lo;
            if (t.more() && t.lookingAt("-")) {
                t.skip(1);
                if (t.more() && t.lookingAt("]")) t.skip(-1);
                else {
                    hi = Parser.parseClassChar(t, startPos);
                    if (hi < lo) throw new $394755e62edee9eb$export$9c12d0c1e9bff151(Parser.ERR_INVALID_CHAR_RANGE, t.from(beforePos));
                }
            }
            if ((this.flags & $394755e62edee9eb$var$RE2Flags.FOLD_CASE) === 0) cc.appendRange(lo, hi);
            else cc.appendFoldedRange(lo, hi);
        }
        t.skip(1);
        cc.cleanClass();
        if (sign < 0) cc.negateClass();
        re.runes = cc.toArray();
        this.push(re);
    }
};
//#endregion
//#region src/RE2.js
/**
* An RE2 class instance is a compiled representation of an RE2 regular expression, independent of
* the public Java-like Pattern/Matcher API.
*
* This class also contains various implementation helpers for RE2 regular expressions.
*
* Use the {@link #quoteMeta(String)} utility function to quote all regular expression
* metacharacters in an arbitrary string.
*
*/ var $394755e62edee9eb$var$RE2 = class RE2 {
    static initTest(expr) {
        const re2 = RE2.compile(expr);
        const res = new RE2(re2.expr, re2.prog, re2.numSubexp, re2.longest);
        res.cond = re2.cond;
        res.prefix = re2.prefix;
        res.prefixUTF8 = re2.prefixUTF8;
        res.prefixComplete = re2.prefixComplete;
        res.prefixRune = re2.prefixRune;
        res.prefilter = re2.prefilter;
        return res;
    }
    /**
	* Parses a regular expression and returns, if successful, an {@code RE2} instance that can be
	* used to match against text.
	*
	* When matching against text, the regexp returns a match that begins as early as possible in the
	* input (leftmost), and among those it chooses the one that a backtracking search would have
	* found first. This so-called leftmost-first matching is the same semantics that Perl, Python,
	* and other implementations use, although this package implements it without the expense of
	* backtracking. For POSIX leftmost-longest matching, see {@link #compilePOSIX}.
	*/ static compile(expr) {
        return RE2.compileImpl(expr, $394755e62edee9eb$var$RE2Flags.PERL, false);
    }
    /**
	* {@code compilePOSIX} is like {@link #compile} but restricts the regular expression to POSIX ERE
	* (egrep) syntax and changes the match semantics to leftmost-longest.
	*
	* That is, when matching against text, the regexp returns a match that begins as early as
	* possible in the input (leftmost), and among those it chooses a match that is as long as
	* possible. This so-called leftmost-longest matching is the same semantics that early regular
	* expression implementations used and that POSIX specifies.
	*
	* However, there can be multiple leftmost-longest matches, with different submatch choices, and
	* here this package diverges from POSIX. Among the possible leftmost-longest matches, this
	* package chooses the one that a backtracking search would have found first, while POSIX
	* specifies that the match be chosen to maximize the length of the first subexpression, then the
	* second, and so on from left to right. The POSIX rule is computationally prohibitive and not
	* even well-defined. See http://swtch.com/~rsc/regexp/regexp2.html#posix
	*/ static compilePOSIX(expr) {
        return RE2.compileImpl(expr, $394755e62edee9eb$var$RE2Flags.POSIX, true);
    }
    static compileImpl(expr, mode, longest) {
        let re = $394755e62edee9eb$var$Parser.parse(expr, mode);
        const maxCap = re.maxCap();
        re = $394755e62edee9eb$var$Simplify.simplify(re);
        const prefilter = $394755e62edee9eb$var$PrefilterTree.build(re);
        const prog = $394755e62edee9eb$var$Compiler.compileRegexp(re);
        const re2 = new RE2(expr, prog, maxCap, longest);
        re2.prefilter = prefilter.type === $394755e62edee9eb$var$Prefilter.Type.NONE ? null : prefilter;
        const [prefixCompl, prefixStr] = prog.prefix();
        re2.prefixComplete = prefixCompl;
        re2.prefix = prefixStr;
        re2.prefixUTF8 = $394755e62edee9eb$var$Utils.stringToUtf8ByteArray(re2.prefix);
        if (re2.prefix.length > 0) re2.prefixRune = re2.prefix.codePointAt(0);
        re2.namedGroups = re.namedGroups;
        return re2;
    }
    /**
	* Returns true iff textual regular expression {@code pattern} matches string {@code s}.
	*
	* More complicated queries need to use {@link #compile} and the full {@code RE2} interface.
	*/ static match(pattern, s) {
        return RE2.compile(pattern).match(s);
    }
    constructor(expr, prog, numSubexp = 0, longest = 0){
        this.expr = expr;
        this.prog = prog;
        this.numSubexp = numSubexp;
        this.longest = longest;
        this.cond = prog.startCond();
        this.prefix = null;
        this.prefixUTF8 = null;
        this.prefixComplete = false;
        this.prefixRune = 0;
        this.machinePool = [];
        this.dfa = new $394755e62edee9eb$var$DFA(this.prog);
        this.onepass = $394755e62edee9eb$var$OnePass.compile(this.prog);
        this.prefilter = null;
    }
    matchPrefixComplete(input, pos, anchor, ncap) {
        if ((anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_START || anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH) && pos !== 0) return null;
        let matchStart = -1;
        let matchEnd = -1;
        const pLen = input.prefixLength(this);
        if (anchor === $394755e62edee9eb$var$RE2Flags.UNANCHORED) {
            const idx = input.index(this, pos);
            if (idx < 0) return null;
            matchStart = pos + idx;
            matchEnd = matchStart + pLen;
        } else if (anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH) {
            if (input.endPos() !== pLen) return null;
            if (input.index(this, 0) !== 0) return null;
            matchStart = 0;
            matchEnd = pLen;
        } else if (anchor === $394755e62edee9eb$var$RE2Flags.ANCHOR_START) {
            if (input.index(this, 0) !== 0) return null;
            matchStart = 0;
            matchEnd = pLen;
        }
        if (matchStart < 0) return null;
        if (ncap > 0) {
            const matchcap = new Int32Array(ncap).fill(-1);
            matchcap[0] = matchStart;
            matchcap[1] = matchEnd;
            return Array.from(matchcap);
        }
        return [];
    }
    executeEngine(input, pos, anchor, ncap) {
        if (this.prefixComplete && (ncap === 0 || this.numSubexp === 0)) return this.matchPrefixComplete(input, pos, anchor, ncap);
        if (this.prefilter !== null && anchor === $394755e62edee9eb$var$RE2Flags.UNANCHORED) {
            if (!this.prefilter.eval(input, pos)) return null;
        }
        if (this.onepass !== null) return $394755e62edee9eb$var$OnePass.execute(this, input, pos, anchor, ncap);
        if (ncap > 0) {
            if (this.prog.numLb === 0 && input.endPos() <= $394755e62edee9eb$var$Backtracker.maxBitStateLen(this.prog)) return $394755e62edee9eb$var$Backtracker.execute(this, input, pos, anchor, ncap);
            return this.doExecuteNFA(input, pos, anchor, ncap);
        }
        if (this.prog.numLb === 0) {
            const dfaResult = this.dfa.match(input, pos, anchor);
            if (dfaResult !== null) return dfaResult ? [] : null;
            if (input.endPos() <= $394755e62edee9eb$var$Backtracker.maxBitStateLen(this.prog)) return $394755e62edee9eb$var$Backtracker.execute(this, input, pos, anchor, ncap);
        }
        return this.doExecuteNFA(input, pos, anchor, ncap);
    }
    /**
	* Returns the number of parenthesized subexpressions in this regular expression.
	*/ numberOfCapturingGroups() {
        return this.numSubexp;
    }
    /**
	* Returns the number of instructions in this compiled regular expression program.
	*/ numberOfInstructions() {
        return this.prog.numInst();
    }
    get() {
        return this.machinePool.length > 0 ? this.machinePool.pop() : null;
    }
    reset() {
        this.machinePool.length = 0;
    }
    put(m) {
        this.machinePool.push(m);
    }
    toString() {
        return this.expr;
    }
    doExecuteNFA(input, pos, anchor, ncap) {
        let m = this.get();
        if (!m) m = $394755e62edee9eb$var$Machine.fromRE2(this);
        m.init(ncap);
        const cap = m.match(input, pos, anchor) ? m.submatches() : null;
        this.put(m);
        return cap;
    }
    match(s) {
        return this.executeEngine($394755e62edee9eb$var$MachineInput.fromUTF16(s), 0, $394755e62edee9eb$var$RE2Flags.UNANCHORED, 0) !== null;
    }
    /**
	* Matches the regular expression against input starting at position start and ending at position
	* end, with the given anchoring. Records the submatch boundaries in group, which is [start, end)
	* pairs of byte offsets. The number of boundaries needed is inferred from the size of the group
	* array. It is most efficient not to ask for submatch boundaries.
	*
	* @param input the input byte array
	* @param start the beginning position in the input
	* @param end the end position in the input
	* @param anchor the anchoring flag (UNANCHORED, ANCHOR_START, ANCHOR_BOTH)
	* @param group the array to fill with submatch positions
	* @param ngroup the number of array pairs to fill in
	* @returns true if a match was found
	*/ matchWithGroup(input, start, end, anchor, ngroup) {
        if (!(input instanceof $394755e62edee9eb$export$cefe1fb40cb8a0f6)) {
            if ($394755e62edee9eb$var$Utils.isByteArray(input)) input = $394755e62edee9eb$export$3430ac14b3833fca.utf8(input);
            else input = $394755e62edee9eb$export$3430ac14b3833fca.utf16(input);
        }
        return this.matchMachineInput(input, start, end, anchor, ngroup);
    }
    matchMachineInput(input, start, end, anchor, ngroup) {
        if (start > end) return [
            false,
            null
        ];
        const machineInput = input.isUTF16Encoding() ? $394755e62edee9eb$var$MachineInput.fromUTF16(input.asCharSequence(), 0, end) : $394755e62edee9eb$var$MachineInput.fromUTF8(input.asBytes(), 0, end);
        const groupMatch = this.executeEngine(machineInput, start, anchor, 2 * ngroup);
        if (groupMatch === null) return [
            false,
            null
        ];
        return [
            true,
            groupMatch
        ];
    }
    /**
	* Returns true iff this regexp matches the UTF-8 byte array {@code b}.
	*/ matchUTF8(b) {
        return this.executeEngine($394755e62edee9eb$var$MachineInput.fromUTF8(b), 0, $394755e62edee9eb$var$RE2Flags.UNANCHORED, 0) !== null;
    }
    /**
	* Returns a copy of {@code src} in which all matches for this regexp have been replaced by
	* {@code repl}. No support is provided for expressions (e.g. {@code \1} or {@code $1}) in the
	* replacement string.
	*/ replaceAll(src, repl) {
        return this.replaceAllFunc(src, ()=>repl, 2 * src.length + 1);
    }
    /**
	* Returns a copy of {@code src} in which only the first match for this regexp has been replaced
	* by {@code repl}. No support is provided for expressions (e.g. {@code \1} or {@code $1}) in the
	* replacement string.
	*/ replaceFirst(src, repl) {
        return this.replaceAllFunc(src, ()=>repl, 1);
    }
    /**
	* Returns a copy of {@code src} in which at most {@code maxReplaces} matches for this regexp have
	* been replaced by the return value of of function {@code repl} (whose first argument is the
	* matched string). No support is provided for expressions (e.g. {@code \1} or {@code $1}) in the
	* replacement string.
	*/ replaceAllFunc(src, replFunc, maxReplaces) {
        let lastMatchEnd = 0;
        let searchPos = 0;
        let out = "";
        const input = $394755e62edee9eb$var$MachineInput.fromUTF16(src);
        let numReplaces = 0;
        while(searchPos <= src.length){
            const a = this.executeEngine(input, searchPos, $394755e62edee9eb$var$RE2Flags.UNANCHORED, 2);
            if (a === null || a.length === 0) break;
            out += src.substring(lastMatchEnd, a[0]);
            if (a[1] > lastMatchEnd || a[0] === 0) {
                out += replFunc(src.substring(a[0], a[1]));
                numReplaces++;
            }
            lastMatchEnd = a[1];
            const width = input.step(searchPos) & 7;
            if (searchPos + width > a[1]) searchPos += width;
            else if (searchPos + 1 > a[1]) searchPos++;
            else searchPos = a[1];
            if (numReplaces >= maxReplaces) break;
        }
        out += src.substring(lastMatchEnd);
        return out;
    }
    pad(a) {
        if (a === null) return null;
        let n = (1 + this.numSubexp) * 2;
        if (a.length < n) {
            let a2 = new Array(n).fill(-1);
            for(let i = 0; i < a.length; i++)a2[i] = a[i];
            a = a2;
        }
        return a;
    }
    allMatches(input, n, deliverFun = (v)=>v) {
        let result = [];
        const end = input.endPos();
        if (n < 0) n = end + 1;
        let pos = 0;
        let i = 0;
        let prevMatchEnd = -1;
        while(i < n && pos <= end){
            const matches = this.executeEngine(input, pos, $394755e62edee9eb$var$RE2Flags.UNANCHORED, this.prog.numCap);
            if (matches === null || matches.length === 0) break;
            let accept = true;
            if (matches[1] === pos) {
                if (matches[0] === prevMatchEnd) accept = false;
                const r = input.step(pos);
                if (r < 0) pos = end + 1;
                else pos += r & 7;
            } else pos = matches[1];
            prevMatchEnd = matches[1];
            if (accept) {
                result.push(deliverFun(this.pad(matches)));
                i++;
            }
        }
        return result;
    }
    /**
	* Returns an array holding the text of the leftmost match in {@code b} of this regular
	* expression.
	*
	* A return value of null indicates no match.
	*/ findUTF8(b) {
        const a = this.executeEngine($394755e62edee9eb$var$MachineInput.fromUTF8(b), 0, $394755e62edee9eb$var$RE2Flags.UNANCHORED, 2);
        if (a === null) return null;
        return b.slice(a[0], a[1]);
    }
    /**
	* Returns a two-element array of integers defining the location of the leftmost match in
	* {@code b} of this regular expression. The match itself is at {@code b[loc[0]...loc[1]]}.
	*
	* A return value of null indicates no match.
	*/ findUTF8Index(b) {
        const a = this.executeEngine($394755e62edee9eb$var$MachineInput.fromUTF8(b), 0, $394755e62edee9eb$var$RE2Flags.UNANCHORED, 2);
        if (a === null) return null;
        return a.slice(0, 2);
    }
    /**
	* Returns a string holding the text of the leftmost match in {@code s} of this regular
	* expression.
	*
	* If there is no match, the return value is an empty string, but it will also be empty if the
	* regular expression successfully matches an empty string. Use {@link #findIndex} or
	* {@link #findSubmatch} if it is necessary to distinguish these cases.
	*/ find(s) {
        const a = this.executeEngine($394755e62edee9eb$var$MachineInput.fromUTF16(s), 0, $394755e62edee9eb$var$RE2Flags.UNANCHORED, 2);
        if (a === null) return "";
        return s.substring(a[0], a[1]);
    }
    /**
	* Returns a two-element array of integers defining the location of the leftmost match in
	* {@code s} of this regular expression. The match itself is at
	* {@code s.substring(loc[0], loc[1])}.
	*
	* A return value of null indicates no match.
	*/ findIndex(s) {
        return this.executeEngine($394755e62edee9eb$var$MachineInput.fromUTF16(s), 0, $394755e62edee9eb$var$RE2Flags.UNANCHORED, 2);
    }
    /**
	* Returns an array of arrays the text of the leftmost match of the regular expression in
	* {@code b} and the matches, if any, of its subexpressions, as defined by the <a
	* href='#submatch'>Submatch</a> description above.
	*
	* A return value of null indicates no match.
	*/ findUTF8Submatch(b) {
        const a = this.executeEngine($394755e62edee9eb$var$MachineInput.fromUTF8(b), 0, $394755e62edee9eb$var$RE2Flags.UNANCHORED, this.prog.numCap);
        if (a === null) return null;
        const ret = new Array(1 + this.numSubexp).fill(null);
        for(let i = 0; i < ret.length; i++)if (2 * i < a.length && a[2 * i] >= 0) ret[i] = b.slice(a[2 * i], a[2 * i + 1]);
        return ret;
    }
    /**
	* Returns an array holding the index pairs identifying the leftmost match of this regular
	* expression in {@code b} and the matches, if any, of its subexpressions, as defined by the the
	* <a href='#submatch'>Submatch</a> and <a href='#index'>Index</a> descriptions above.
	*
	* A return value of null indicates no match.
	*/ findUTF8SubmatchIndex(b) {
        return this.pad(this.executeEngine($394755e62edee9eb$var$MachineInput.fromUTF8(b), 0, $394755e62edee9eb$var$RE2Flags.UNANCHORED, this.prog.numCap));
    }
    /**
	* Returns an array of strings holding the text of the leftmost match of the regular expression in
	* {@code s} and the matches, if any, of its subexpressions, as defined by the <a
	* href='#submatch'>Submatch</a> description above.
	*
	* A return value of null indicates no match.
	*/ findSubmatch(s) {
        const a = this.executeEngine($394755e62edee9eb$var$MachineInput.fromUTF16(s), 0, $394755e62edee9eb$var$RE2Flags.UNANCHORED, this.prog.numCap);
        if (a === null) return null;
        const ret = new Array(1 + this.numSubexp).fill(null);
        for(let i = 0; i < ret.length; i++)if (2 * i < a.length && a[2 * i] >= 0) ret[i] = s.substring(a[2 * i], a[2 * i + 1]);
        return ret;
    }
    /**
	* Returns an array holding the index pairs identifying the leftmost match of this regular
	* expression in {@code s} and the matches, if any, of its subexpressions, as defined by the <a
	* href='#submatch'>Submatch</a> description above.
	*
	* A return value of null indicates no match.
	*/ findSubmatchIndex(s) {
        return this.pad(this.executeEngine($394755e62edee9eb$var$MachineInput.fromUTF16(s), 0, $394755e62edee9eb$var$RE2Flags.UNANCHORED, this.prog.numCap));
    }
    /**
	* {@code findAllUTF8()} is the <a href='#all'>All</a> version of {@link #findUTF8}; it returns a
	* list of up to {@code n} successive matches of the expression, as defined by the <a
	* href='#all'>All</a> description above.
	*
	* A return value of null indicates no match.
	*
	* TODO(adonovan): think about defining a byte slice view class, like a read-only Go slice backed
	* by |b|.
	*/ findAllUTF8(b, n) {
        const result = this.allMatches($394755e62edee9eb$var$MachineInput.fromUTF8(b), n, (match)=>b.slice(match[0], match[1]));
        if (result.length === 0) return null;
        return result;
    }
    /**
	* {@code findAllUTF8Index} is the <a href='#all'>All</a> version of {@link #findUTF8Index}; it
	* returns a list of up to {@code n} successive matches of the expression, as defined by the <a
	* href='#all'>All</a> description above.
	*
	* A return value of null indicates no match.
	*/ findAllUTF8Index(b, n) {
        const result = this.allMatches($394755e62edee9eb$var$MachineInput.fromUTF8(b), n, (match)=>match.slice(0, 2));
        if (result.length === 0) return null;
        return result;
    }
    /**
	* {@code findAll} is the <a href='#all'>All</a> version of {@link #find}; it returns a list of up
	* to {@code n} successive matches of the expression, as defined by the <a href='#all'>All</a>
	* description above.
	*
	* A return value of null indicates no match.
	*/ findAll(s, n) {
        const result = this.allMatches($394755e62edee9eb$var$MachineInput.fromUTF16(s), n, (match)=>s.substring(match[0], match[1]));
        if (result.length === 0) return null;
        return result;
    }
    /**
	* {@code findAllIndex} is the <a href='#all'>All</a> version of {@link #findIndex}; it returns a
	* list of up to {@code n} successive matches of the expression, as defined by the <a
	* href='#all'>All</a> description above.
	*
	* A return value of null indicates no match.
	*/ findAllIndex(s, n) {
        const result = this.allMatches($394755e62edee9eb$var$MachineInput.fromUTF16(s), n, (match)=>match.slice(0, 2));
        if (result.length === 0) return null;
        return result;
    }
    /**
	* {@code findAllUTF8Submatch} is the <a href='#all'>All</a> version of {@link #findUTF8Submatch};
	* it returns a list of up to {@code n} successive matches of the expression, as defined by the <a
	* href='#all'>All</a> description above.
	*
	* A return value of null indicates no match.
	*/ findAllUTF8Submatch(b, n) {
        const result = this.allMatches($394755e62edee9eb$var$MachineInput.fromUTF8(b), n, (match)=>{
            let slice = new Array(match.length / 2 | 0).fill(null);
            for(let j = 0; j < slice.length; j++)if (match[2 * j] >= 0) slice[j] = b.slice(match[2 * j], match[2 * j + 1]);
            return slice;
        });
        if (result.length === 0) return null;
        return result;
    }
    /**
	* {@code findAllUTF8SubmatchIndex} is the <a href='#all'>All</a> version of
	* {@link #findUTF8SubmatchIndex}; it returns a list of up to {@code n} successive matches of the
	* expression, as defined by the <a href='#all'>All</a> description above.
	*
	* A return value of null indicates no match.
	*/ findAllUTF8SubmatchIndex(b, n) {
        const result = this.allMatches($394755e62edee9eb$var$MachineInput.fromUTF8(b), n);
        if (result.length === 0) return null;
        return result;
    }
    /**
	* {@code findAllSubmatch} is the <a href='#all'>All</a> version of {@link #findSubmatch}; it
	* returns a list of up to {@code n} successive matches of the expression, as defined by the <a
	* href='#all'>All</a> description above.
	*
	* A return value of null indicates no match.
	*/ findAllSubmatch(s, n) {
        const result = this.allMatches($394755e62edee9eb$var$MachineInput.fromUTF16(s), n, (match)=>{
            let slice = new Array(match.length / 2 | 0).fill(null);
            for(let j = 0; j < slice.length; j++)if (match[2 * j] >= 0) slice[j] = s.substring(match[2 * j], match[2 * j + 1]);
            return slice;
        });
        if (result.length === 0) return null;
        return result;
    }
    /**
	* {@code findAllSubmatchIndex} is the <a href='#all'>All</a> version of
	* {@link #findSubmatchIndex}; it returns a list of up to {@code n} successive matches of the
	* expression, as defined by the <a href='#all'>All</a> description above.
	*
	* A return value of null indicates no match.
	*/ findAllSubmatchIndex(s, n) {
        const result = this.allMatches($394755e62edee9eb$var$MachineInput.fromUTF16(s), n);
        if (result.length === 0) return null;
        return result;
    }
};
//#endregion
//#region src/Set.js
var $394755e62edee9eb$export$a6524876738a3b9d = class RE2Set {
    /** @type {number} */ static UNANCHORED = $394755e62edee9eb$var$RE2Flags.UNANCHORED;
    /** @type {number} */ static ANCHOR_START = $394755e62edee9eb$var$RE2Flags.ANCHOR_START;
    /** @type {number} */ static ANCHOR_BOTH = $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH;
    /**
	* Constructs a new RE2Set with the specified anchor mode and flags.
	* @param {number} [anchor=RE2Set.UNANCHORED] - The anchoring mode (e.g., RE2Set.UNANCHORED).
	* @param {number} [flags=0] - The public flags to apply to all patterns in the set.
	* @param {number} [maxMem=8388608] - The maximum memory in bytes to use for the DFA (default 8MB).
	*/ constructor(anchor = RE2Set.UNANCHORED, flags = 0, maxMem = 8388608){
        this.anchor = anchor;
        this.jsFlags = flags;
        this.maxMem = maxMem;
        let re2Flags = $394755e62edee9eb$var$RE2Flags.PERL;
        if ((flags & $394755e62edee9eb$var$PublicFlags.DISABLE_UNICODE_GROUPS) !== 0) re2Flags &= ~$394755e62edee9eb$var$RE2Flags.UNICODE_GROUPS;
        if ((flags & $394755e62edee9eb$var$PublicFlags.LOOKBEHINDS) !== 0) re2Flags |= $394755e62edee9eb$var$RE2Flags.LOOKBEHIND;
        this.re2Flags = re2Flags;
        this.regexps = [];
        this.prog = null;
        this.dfa = null;
        this.dummyRe2 = null;
    }
    /**
	* Adds a new regular expression pattern to the set.
	* Patterns cannot be added after the set has been compiled.
	* @param {string} pattern - The regular expression pattern to add.
	* @returns {number} The integer index assigned to the added pattern.
	* @throws {RE2JSCompileException} If patterns are added after compilation.
	*/ add(pattern) {
        if (this.prog) throw new $394755e62edee9eb$export$457eacef9ada3821("Cannot add patterns after compile");
        let fregex = pattern;
        if ((this.jsFlags & $394755e62edee9eb$var$PublicFlags.CASE_INSENSITIVE) !== 0) fregex = `(?i)${fregex}`;
        if ((this.jsFlags & $394755e62edee9eb$var$PublicFlags.DOTALL) !== 0) fregex = `(?s)${fregex}`;
        if ((this.jsFlags & $394755e62edee9eb$var$PublicFlags.MULTILINE) !== 0) fregex = `(?m)${fregex}`;
        const re = $394755e62edee9eb$var$Parser.parse(fregex, this.re2Flags);
        this.regexps.push($394755e62edee9eb$var$Simplify.simplify(re));
        return this.regexps.length - 1;
    }
    /**
	* Compiles the added patterns into a single state machine.
	* This is automatically called on the first match if not called explicitly.
	* @returns {void}
	*/ compile() {
        if (this.prog) return;
        this.prog = $394755e62edee9eb$var$Compiler.compileSet(this.regexps);
        this.dfa = new $394755e62edee9eb$var$DFA(this.prog, this.maxMem);
        this.dummyRe2 = {
            prog: this.prog,
            cond: this.prog.startCond(),
            prefix: "",
            prefixRune: 0,
            longest: false
        };
    }
    /**
	* Matches the input against the compiled set of regular expressions.
	* @param {string|number[]|Uint8Array} input - The input string or UTF-8 byte array to match against.
	* @returns {number[]} An array of indices representing the patterns that successfully matched the input.
	*/ match(input) {
        if (!this.prog) this.compile();
        const machineInput = $394755e62edee9eb$var$Utils.isByteArray(input) ? $394755e62edee9eb$var$MachineInput.fromUTF8(input) : $394755e62edee9eb$var$MachineInput.fromUTF16(input);
        let internalAnchor = $394755e62edee9eb$var$RE2Flags.UNANCHORED;
        if (this.anchor === RE2Set.ANCHOR_START) internalAnchor = $394755e62edee9eb$var$RE2Flags.ANCHOR_START;
        else if (this.anchor === RE2Set.ANCHOR_BOTH) internalAnchor = $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH;
        const dfaResult = this.dfa.matchSet(machineInput, 0, internalAnchor);
        if (dfaResult !== null) return dfaResult;
        const machine = $394755e62edee9eb$var$Machine.fromRE2(this.dummyRe2);
        machine.init(0);
        return machine.matchSet(machineInput, 0, internalAnchor);
    }
};
//#endregion
//#region src/TranslateRegExpString.js
/**
* Transform JS regex string to RE2 regex string
*/ var $394755e62edee9eb$var$TranslateRegExpString = class TranslateRegExpString {
    static isHexadecimal(ch) {
        return "0" <= ch && ch <= "9" || "A" <= ch && ch <= "F" || "a" <= ch && ch <= "f";
    }
    static translate(data) {
        let prefixFlags = "";
        if (data instanceof RegExp) {
            if (data.ignoreCase) prefixFlags += "i";
            if (data.multiline) prefixFlags += "m";
            if (data.dotAll) prefixFlags += "s";
            data = data.source;
        }
        if (typeof data !== "string") return data;
        let result = "";
        let changed = false;
        let size = data.length;
        if (size === 0) {
            result = "(?:)";
            changed = true;
        }
        let inCharClass = false;
        let i = 0;
        while(i < size){
            let ch = data[i];
            if (ch === "\\") {
                if (i + 1 < size) {
                    ch = data[i + 1];
                    switch(ch){
                        case "\\":
                            result += "\\\\";
                            i += 2;
                            continue;
                        case "c":
                            if (i + 2 < size) {
                                let code = data[i + 2].charCodeAt(0);
                                if (code >= 65 && code <= 90 || code >= 97 && code <= 122) {
                                    let val = code % 32;
                                    result += "\\x";
                                    result += (val >> 4).toString(16).toUpperCase();
                                    result += (val & 15).toString(16).toUpperCase();
                                    i += 3;
                                    changed = true;
                                    continue;
                                }
                            }
                            result += "c";
                            i += 2;
                            changed = true;
                            continue;
                        case "u":
                            if (i + 2 < size) {
                                if (data[i + 2] === "{") {
                                    let j = i + 3;
                                    let hasHex = false;
                                    let closed = false;
                                    while(j < size){
                                        const hexChar = data[j];
                                        if (hexChar === "}") {
                                            closed = true;
                                            break;
                                        }
                                        if (!TranslateRegExpString.isHexadecimal(hexChar)) break;
                                        hasHex = true;
                                        j++;
                                    }
                                    if (closed && hasHex) {
                                        result += "\\x";
                                        i += 2;
                                        changed = true;
                                        continue;
                                    }
                                } else if (i + 5 < size) {
                                    let isHex4 = true;
                                    for(let j = 0; j < 4; j++)if (!TranslateRegExpString.isHexadecimal(data[i + 2 + j])) {
                                        isHex4 = false;
                                        break;
                                    }
                                    if (isHex4) {
                                        result += "\\x{" + data.substring(i + 2, i + 6) + "}";
                                        i += 6;
                                        changed = true;
                                        continue;
                                    }
                                }
                            }
                            result += "u";
                            i += 2;
                            changed = true;
                            continue;
                        case "x":
                            {
                                let isValidHex = false;
                                if (i + 2 < size && data[i + 2] === "{") {
                                    let j = i + 3;
                                    let hasHex = false;
                                    let closed = false;
                                    while(j < size){
                                        const hexChar = data[j];
                                        if (hexChar === "}") {
                                            closed = true;
                                            break;
                                        }
                                        if (!TranslateRegExpString.isHexadecimal(hexChar)) break;
                                        hasHex = true;
                                        j++;
                                    }
                                    if (closed && hasHex) isValidHex = true;
                                } else if (i + 3 < size && TranslateRegExpString.isHexadecimal(data[i + 2]) && TranslateRegExpString.isHexadecimal(data[i + 3])) isValidHex = true;
                                if (isValidHex) {
                                    result += "\\x";
                                    i += 2;
                                } else {
                                    result += "x";
                                    i += 2;
                                    changed = true;
                                }
                                continue;
                            }
                        case "n":
                        case "r":
                        case "t":
                        case "a":
                        case "f":
                        case "v":
                        case "d":
                        case "D":
                        case "s":
                        case "S":
                        case "w":
                        case "W":
                        case "b":
                        case "B":
                        case "p":
                        case "P":
                        case "A":
                        case "z":
                        case "Q":
                        case "E":
                        case "0":
                        case "1":
                        case "2":
                        case "3":
                        case "4":
                        case "5":
                        case "6":
                        case "7":
                            result += "\\" + ch;
                            i += 2;
                            continue;
                        default:
                            {
                                let cp = data.codePointAt(i + 1);
                                if (cp >= 48 && cp <= 57 || cp >= 65 && cp <= 90 || cp >= 97 && cp <= 122) {
                                    let symSize = $394755e62edee9eb$var$Utils.charCount(cp);
                                    result += data.substring(i + 1, i + 1 + symSize);
                                    i += symSize + 1;
                                    changed = true;
                                } else {
                                    result += "\\";
                                    let symSize = $394755e62edee9eb$var$Utils.charCount(cp);
                                    result += data.substring(i + 1, i + 1 + symSize);
                                    i += symSize + 1;
                                }
                                continue;
                            }
                    }
                }
            } else if (ch === "/") {
                result += "\\/";
                i += 1;
                changed = true;
                continue;
            } else if (ch === "[") inCharClass = true;
            else if (ch === "]") inCharClass = false;
            else if (!inCharClass && ch === "(" && i + 2 < size && data[i + 1] === "?" && data[i + 2] === "<") {
                if (i + 3 < size && !"=!>)".includes(data[i + 3])) {
                    result += "(?P<";
                    i += 3;
                    changed = true;
                    continue;
                }
            }
            let cp = data.codePointAt(i);
            let symSize = $394755e62edee9eb$var$Utils.charCount(cp);
            result += data.substring(i, i + symSize);
            i += symSize;
        }
        const finalResult = changed ? result : data;
        if (prefixFlags.length > 0) return `(?${prefixFlags})${finalResult}`;
        return finalResult;
    }
};
//#endregion
//#region src/index.js
/**
* A compiled representation of an RE2 regular expression
*
* The matching functions take {@code String} arguments instead of the more general Java
* {@code CharSequence} since the latter doesn't provide UTF-16 decoding.
*
*
* @author rsc@google.com (Russ Cox)
* @class
*/ var $394755e62edee9eb$export$e46efc5f33420715 = class RE2JS {
    /**
	* Flag: case insensitive matching.
	*/ static CASE_INSENSITIVE = $394755e62edee9eb$var$PublicFlags.CASE_INSENSITIVE;
    /**
	* Flag: dot ({@code .}) matches all characters, including newline.
	*/ static DOTALL = $394755e62edee9eb$var$PublicFlags.DOTALL;
    /**
	* Flag: multiline matching: {@code ^} and {@code $} match at beginning and end of line, not just
	* beginning and end of input.
	*/ static MULTILINE = $394755e62edee9eb$var$PublicFlags.MULTILINE;
    /**
	* Flag: Unicode groups (e.g. {@code \p\ Greek\} ) will be syntax errors.
	*/ static DISABLE_UNICODE_GROUPS = $394755e62edee9eb$var$PublicFlags.DISABLE_UNICODE_GROUPS;
    /**
	* Flag: matches longest possible string.
	*/ static LONGEST_MATCH = $394755e62edee9eb$var$PublicFlags.LONGEST_MATCH;
    /**
	* Flag: enable linear-time captureless lookbehinds.
	*/ static LOOKBEHINDS = $394755e62edee9eb$var$PublicFlags.LOOKBEHINDS;
    /**
	* Returns a literal pattern string for the specified string.
	*
	* This method produces a string that can be used to create a <code>RE2JS</code> that would
	* match the string <code>s</code> as if it were a literal pattern.
	*
	* Metacharacters or escape sequences in the input sequence will be given no special meaning.
	*
	* @param {string} str The string to be literalized
	* @returns {string} A literal string replacement
	*/ static quote(str) {
        return $394755e62edee9eb$var$Utils.quoteMeta(str);
    }
    /**
	* Quotes '\' and '$' in {@code str}, so that the returned string could be used in
	* replacement methods as a literal replacement of {@code str}.
	*
	* This is a convenience delegation to {@link Matcher.quoteReplacement}.
	*
	* @param {string} str the string to be quoted
	* @param {boolean} [javaMode=false] whether the replacement will be used in javaMode
	* @returns {string} the quoted string
	*/ static quoteReplacement(str, javaMode = false) {
        return $394755e62edee9eb$export$20214574ec94167d.quoteReplacement(str, javaMode);
    }
    /**
	* Translates a given regular expression string to ensure compatibility with RE2JS.
	*
	* This function preprocesses the input regex string by applying necessary transformations,
	* such as escaping special characters (e.g., `/`), converting named capture groups to
	* RE2JS-compatible syntax, and handling Unicode sequences properly. It ensures that the
	* resulting regex is safe and properly formatted before compilation.
	*
	* @param {string|RegExp} expr - The regular expression string to be translated.
	* @returns {string} - The transformed regular expression string, ready for compilation.
	*/ static translateRegExp(expr) {
        return $394755e62edee9eb$var$TranslateRegExpString.translate(expr);
    }
    /**
	* Helper: create new RE2JS with given regex and flags. Flregex is the regex with flags applied.
	* @param {string} regex
	* @param {number} [flags=0]
	* @returns {RE2JS}
	*/ static compile(regex, flags = 0) {
        let fregex = regex;
        if ((flags & RE2JS.CASE_INSENSITIVE) !== 0) fregex = `(?i)${fregex}`;
        if ((flags & RE2JS.DOTALL) !== 0) fregex = `(?s)${fregex}`;
        if ((flags & RE2JS.MULTILINE) !== 0) fregex = `(?m)${fregex}`;
        if ((flags & ~(RE2JS.MULTILINE | RE2JS.DOTALL | RE2JS.CASE_INSENSITIVE | RE2JS.DISABLE_UNICODE_GROUPS | RE2JS.LONGEST_MATCH | RE2JS.LOOKBEHINDS)) !== 0) throw new $394755e62edee9eb$export$fa1c64d63b2c22b1("Flags should only be a combination of MULTILINE, DOTALL, CASE_INSENSITIVE, DISABLE_UNICODE_GROUPS, LONGEST_MATCH, LOOKBEHINDS");
        let re2Flags = $394755e62edee9eb$var$RE2Flags.PERL;
        if ((flags & RE2JS.DISABLE_UNICODE_GROUPS) !== 0) re2Flags &= ~$394755e62edee9eb$var$RE2Flags.UNICODE_GROUPS;
        if ((flags & RE2JS.LOOKBEHINDS) !== 0) re2Flags |= $394755e62edee9eb$var$RE2Flags.LOOKBEHIND;
        const p = new RE2JS(regex, flags);
        p.re2Input = $394755e62edee9eb$var$RE2.compileImpl(fregex, re2Flags, (flags & RE2JS.LONGEST_MATCH) !== 0);
        return p;
    }
    /**
	* Matches a string against a regular expression.
	*
	* @param {string} regex the regular expression
	* @param {string|number[]|Uint8Array} input the input
	* @returns {boolean} true if the regular expression matches the entire input
	* @throws RE2JSSyntaxException if the regular expression is malformed
	*/ static matches(regex, input) {
        return RE2JS.compile(regex).testExact(input);
    }
    /**
	* This is visible for testing.
	* @private
	*/ static initTest(pattern, flags, re2) {
        if (pattern == null) throw new Error("pattern is null");
        if (re2 == null) throw new Error("re2 is null");
        const p = new RE2JS(pattern, flags);
        p.re2Input = re2;
        return p;
    }
    /**
	*
	* @param {string} pattern
	* @param {number} flags
	*/ constructor(pattern, flags){
        this.patternInput = pattern;
        this.flagsInput = flags;
        /** @type {import('./RE2.js').RE2} */ this.re2Input = null;
    }
    /**
	* Releases memory used by internal caches associated with this pattern. Does not change the
	* observable behaviour. Useful for tests that detect memory leaks via allocation tracking.
	*/ reset() {
        this.re2Input.reset();
    }
    /**
	* Returns the flags used in the constructor.
	* @returns {number}
	*/ flags() {
        return this.flagsInput;
    }
    /**
	* Returns the pattern used in the constructor.
	* @returns {string}
	*/ pattern() {
        return this.patternInput;
    }
    re2() {
        return this.re2Input;
    }
    /**
	* Matches a string against a regular expression.
	*
	* @param {string|number[]|Uint8Array} input the input
	* @returns {boolean} true if the regular expression matches the entire input
	*/ matches(input) {
        return this.testExact(input);
    }
    /**
	* Creates a new {@code Matcher} matching the pattern against the input.
	*
	* @param {string|number[]|Uint8Array|MatcherInputBase} input the input string
	* @returns {Matcher}
	*/ matcher(input) {
        if ($394755e62edee9eb$var$Utils.isByteArray(input)) input = $394755e62edee9eb$export$3430ac14b3833fca.utf8(input);
        return new $394755e62edee9eb$export$20214574ec94167d(this, input);
    }
    /**
	* Tests whether the regular expression matches any part of the input string.
	* Performance Note: This method is highly optimized. Because it only returns
	* a boolean and does not extract capture groups, it bypasses the `Matcher` overhead
	* and guarantees execution on the high-speed DFA engine whenever possible.
	*
	* @param {string|number[]|Uint8Array} input - The input string or UTF-8 byte array to test against.
	* @returns {boolean} `true` if the pattern is found anywhere in the input, `false` otherwise.
	*/ test(input) {
        if ($394755e62edee9eb$var$Utils.isByteArray(input)) return this.re2Input.matchUTF8(input);
        return this.re2Input.match(input);
    }
    /**
	* Tests whether the regular expression matches the ENTIRE input string.
	* * **Performance Note:** This operates identically to `.matches()`, but is significantly
	* faster because it does not request capture group data. By requesting 0 capture groups,
	* it securely routes execution through the DFA fast-path.
	*
	* @param {string|number[]|Uint8Array} input - The input string or UTF-8 byte array to test against.
	* @returns {boolean} `true` if the exact input string fully matches the pattern, `false` otherwise.
	*/ testExact(input) {
        const machineInput = $394755e62edee9eb$var$Utils.isByteArray(input) ? $394755e62edee9eb$var$MachineInput.fromUTF8(input) : $394755e62edee9eb$var$MachineInput.fromUTF16(input);
        return this.re2Input.executeEngine(machineInput, 0, $394755e62edee9eb$var$RE2Flags.ANCHOR_BOTH, 0) !== null;
    }
    /**
	* Executes a search for a match in a specified string.
	* Returns a result array, or null if no match is found.
	* The returned array perfectly mirrors standard JavaScript `RegExpExecArray`,
	* including `.index`, `.input`, and `.groups` properties.
	*
	* @param {string|number[]|Uint8Array} input the input string or byte array
	* @returns {Array|null} the match array with index, input, and groups properties, or null
	*/ exec(input) {
        const m = this.matcher(input);
        if (!m.find()) return null;
        const result = [
            m.group(0)
        ];
        for(let i = 1; i <= m.groupCount(); i++){
            const val = m.group(i);
            result.push(val === null ? void 0 : val);
        }
        result.index = m.start(0);
        result.input = input;
        const namedGroups = this.namedGroups();
        if (Object.keys(namedGroups).length > 0) {
            const parsedGroups = m.getNamedGroups();
            for(const key in parsedGroups)if (parsedGroups[key] === null) parsedGroups[key] = void 0;
            result.groups = parsedGroups;
        } else result.groups = void 0;
        return result;
    }
    /**
	* Splits input around instances of the regular expression. It returns an array giving the strings
	* that occur before, between, and after instances of the regular expression.
	*
	* If {@code limit <= 0}, there is no limit on the size of the returned array. If
	* {@code limit == 0}, empty strings that would occur at the end of the array are omitted. If
	* {@code limit > 0}, at most limit strings are returned. The final string contains the remainder
	* of the input, possibly including additional matches of the pattern.
	*
	* @param {string} input the input string to be split
	* @param {number} [limit=0] the limit
	* @returns {string[]} the split strings
	*/ split(input, limit = 0) {
        const m = this.matcher(input);
        const result = [];
        let emptiesSkipped = 0;
        let last = 0;
        while(m.find()){
            if (last === 0 && m.end() === 0) {
                last = m.end();
                continue;
            }
            if (limit > 0 && result.length === limit - 1) break;
            if (last === m.start()) {
                if (limit === 0) {
                    emptiesSkipped += 1;
                    last = m.end();
                    continue;
                }
            } else while(emptiesSkipped > 0){
                result.push("");
                emptiesSkipped -= 1;
            }
            result.push(m.substring(last, m.start()));
            last = m.end();
        }
        if (limit === 0 && last !== m.inputLength()) {
            while(emptiesSkipped > 0){
                result.push("");
                emptiesSkipped -= 1;
            }
            result.push(m.substring(last, m.inputLength()));
        }
        if (limit !== 0 || result.length === 0 && !(last === m.inputLength() && last > 0)) result.push(m.substring(last, m.inputLength()));
        return result;
    }
    /**
	* Returns an iterator of all results matching a string against the regular expression,
	* including capturing groups.
	*
	* @param {string|number[]|Uint8Array} input the input string or byte array
	* @returns {IterableIterator<RegExpMatchArray>}
	*/ *matchAll(input) {
        const m = this.matcher(input);
        while(m.find()){
            const result = [
                m.group(0)
            ];
            for(let i = 1; i <= m.groupCount(); i++){
                const groupVal = m.group(i);
                result.push(groupVal === null ? void 0 : groupVal);
            }
            result.index = m.start(0);
            result.input = input;
            const namedGroups = this.namedGroups();
            if (Object.keys(namedGroups).length > 0) {
                const parsedGroups = m.getNamedGroups();
                for(const key in parsedGroups)if (parsedGroups[key] === null) parsedGroups[key] = void 0;
                result.groups = parsedGroups;
            } else result.groups = void 0;
            yield result;
        }
    }
    /**
	*
	* @returns {string}
	*/ toString() {
        return this.patternInput;
    }
    /**
	* Returns the program size of this pattern.
	*
	* <p>
	* Similar to the C++ implementation, the program size is a very approximate measure of a regexp's
	* "cost". Larger numbers are more expensive than smaller numbers.
	* </p>
	*
	* @returns {number} the program size of this pattern
	*/ programSize() {
        return this.re2Input.numberOfInstructions();
    }
    /**
	* Returns the number of capturing groups in this matcher's pattern. Group zero denotes the entire
	* pattern and is excluded from this count.
	*
	* @returns {number} the number of capturing groups in this pattern
	*/ groupCount() {
        return this.re2Input.numberOfCapturingGroups();
    }
    /**
	* Return a map of the capturing groups in this matcher's pattern, where key is the name and value
	* is the index of the group in the pattern.
	* @returns {Record<string, number>}
	*/ namedGroups() {
        return this.re2Input.namedGroups;
    }
    /**
	*
	* @param {*} other
	* @returns {boolean}
	*/ equals(other) {
        if (this === other) return true;
        if (other === null || this.constructor !== other.constructor) return false;
        return this.flagsInput === other.flagsInput && this.patternInput === other.patternInput;
    }
};
/**
* Creates an RE2JS regex directly from a template literal.
* @overload
* @param {TemplateStringsArray} stringsOrFlags - The raw string segments of the template literal.
* @param {...any} values - The interpolated values.
* @returns {RE2JS}
*/ /**
* Creates a template literal tag function with specific RE2JS flags.
* @overload
* @param {number} stringsOrFlags - The RE2JS flags to apply (e.g., RE2JS.CASE_INSENSITIVE).
* @returns {(strings: TemplateStringsArray, ...tagValues: any[]) => RE2JS}
*/ /**
* Implementation signature
* @param {TemplateStringsArray | number} stringsOrFlags
* @param {...any} values
* @returns {RE2JS | ((strings: TemplateStringsArray, ...tagValues: any[]) => RE2JS)}
*/ const $394755e62edee9eb$export$b1f1627d659a651 = (stringsOrFlags, ...values)=>{
    if (Array.isArray(stringsOrFlags) && "raw" in stringsOrFlags) {
        const pattern = String.raw(stringsOrFlags, ...values);
        return $394755e62edee9eb$export$e46efc5f33420715.compile(pattern);
    }
    const flags = typeof stringsOrFlags === "number" ? stringsOrFlags : 0;
    return (strings, ...tagValues)=>{
        const pattern = String.raw(strings, ...tagValues);
        return $394755e62edee9eb$export$e46efc5f33420715.compile(pattern, flags);
    };
};


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $2fa92ec193801792$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The semver (www.semver.org) version of the SDK. */ let $2fa92ec193801792$var$ve = "12.17.0";
function $2fa92ec193801792$export$92108d983e8ee699(e) {
    $2fa92ec193801792$var$ve = e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$Se = new (0, $59d1e3b150b2f36d$export$efa9a398d6368992)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $2fa92ec193801792$var$__PRIVATE_getLogLevel() {
    return $2fa92ec193801792$var$Se.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $2fa92ec193801792$export$7a0bdf7d4a91ea88(e) {
    $2fa92ec193801792$var$Se.setLogLevel(e);
}
function $2fa92ec193801792$export$2329c99376c9d0a4(e, ...t) {
    if ($2fa92ec193801792$var$Se.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG) {
        const n = t.map($2fa92ec193801792$var$__PRIVATE_argToString);
        $2fa92ec193801792$var$Se.debug(`Firestore (${$2fa92ec193801792$var$ve}): ${e}`, ...n);
    }
}
function $2fa92ec193801792$var$__PRIVATE_logError(e, ...t) {
    if ($2fa92ec193801792$var$Se.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).ERROR) {
        const n = t.map($2fa92ec193801792$var$__PRIVATE_argToString);
        $2fa92ec193801792$var$Se.error(`Firestore (${$2fa92ec193801792$var$ve}): ${e}`, ...n);
    }
}
/**
 * @internal
 */ function $2fa92ec193801792$export$7f8ddf7c7c20b3cd(e, ...t) {
    if ($2fa92ec193801792$var$Se.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).WARN) {
        const n = t.map($2fa92ec193801792$var$__PRIVATE_argToString);
        $2fa92ec193801792$var$Se.warn(`Firestore (${$2fa92ec193801792$var$ve}): ${e}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $2fa92ec193801792$var$__PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2fa92ec193801792$export$1a82df3d29112e01(e, t, n) {
    let r = "Unexpected state";
    "string" == typeof t ? r = t : n = t, $2fa92ec193801792$var$__PRIVATE__fail(e, r, n);
}
function $2fa92ec193801792$var$__PRIVATE__fail(e, t, n) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    let r = `FIRESTORE (${$2fa92ec193801792$var$ve}) INTERNAL ASSERTION FAILED: ${t} (ID: ${e.toString(16)})`;
    if (void 0 !== n) try {
        r += " CONTEXT: " + JSON.stringify(n);
    } catch (e) {
        r += " CONTEXT: " + n;
    }
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $2fa92ec193801792$var$__PRIVATE_logError(r), new Error(r);
}
function $2fa92ec193801792$var$__PRIVATE_hardAssert(e, t, n, r) {
    let i = "Unexpected state";
    "string" == typeof n ? i = n : r = n, e || $2fa92ec193801792$var$__PRIVATE__fail(t, i, r);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $2fa92ec193801792$export$a05254e7c3aeba6e(e, t) {
    e || $2fa92ec193801792$export$1a82df3d29112e01(57014, t);
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $2fa92ec193801792$var$__PRIVATE_debugCast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $2fa92ec193801792$var$__PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const t = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
    else // Falls back to Math.random
    for(let t = 0; t < e; t++)n[t] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */ class $2fa92ec193801792$export$ae1af26003f05816 {
    static newId() {
        // Alphanumeric characters
        const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = 62 * Math.floor(256 / 62);
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const r = $2fa92ec193801792$var$__PRIVATE_randomBytes(40);
            for(let i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && r[i] < t && (n += e.charAt(r[i] % 62));
        }
        return n;
    }
}
function $2fa92ec193801792$var$__PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
/** Compare strings in UTF-8 encoded byte order */ function $2fa92ec193801792$var$__PRIVATE_compareUtf8Strings(e, t) {
    // Find the first differing character (a.k.a. "UTF-16 code unit") in the two strings and,
    // if found, use that character to determine the relative ordering of the two strings as a
    // whole. Comparing UTF-16 strings in UTF-8 byte order can be done simply and efficiently by
    // comparing the UTF-16 code units (chars). This serendipitously works because of the way UTF-8
    // and UTF-16 happen to represent Unicode code points.
    // After finding the first pair of differing characters, there are two cases:
    // Case 1: Both characters are non-surrogates (code points less than or equal to 0xFFFF) or
    // both are surrogates from a surrogate pair (that collectively represent code points greater
    // than 0xFFFF). In this case their numeric order as UTF-16 code units is the same as the
    // lexicographical order of their corresponding UTF-8 byte sequences. A direct comparison is
    // sufficient.
    // Case 2: One character is a surrogate and the other is not. In this case the surrogate-
    // containing string is always ordered after the non-surrogate. This is because surrogates are
    // used to represent code points greater than 0xFFFF which have 4-byte UTF-8 representations
    // and are lexicographically greater than the 1, 2, or 3-byte representations of code points
    // less than or equal to 0xFFFF.
    // An example of why Case 2 is required is comparing the following two Unicode code points:
    // |-----------------------|------------|---------------------|-----------------|
    // | Name                  | Code Point | UTF-8 Encoding      | UTF-16 Encoding |
    // |-----------------------|------------|---------------------|-----------------|
    // | Replacement Character | U+FFFD     | 0xEF 0xBF 0xBD      | 0xFFFD          |
    // | Grinning Face         | U+1F600    | 0xF0 0x9F 0x98 0x80 | 0xD83D 0xDE00   |
    // |-----------------------|------------|---------------------|-----------------|
    // A lexicographical comparison of the UTF-8 encodings of these code points would order
    // "Replacement Character" _before_ "Grinning Face" because 0xEF is less than 0xF0. However, a
    // direct comparison of the UTF-16 code units, as would be done in case 1, would erroneously
    // produce the _opposite_ ordering, because 0xFFFD is _greater than_ 0xD83D. As it turns out,
    // this relative ordering holds for all comparisons of UTF-16 code points requiring a surrogate
    // pair with those that do not.
    const n = Math.min(e.length, t.length);
    for(let r = 0; r < n; r++){
        const n = e.charAt(r), i = t.charAt(r);
        if (n !== i) return $2fa92ec193801792$var$__PRIVATE_isSurrogate(n) === $2fa92ec193801792$var$__PRIVATE_isSurrogate(i) ? $2fa92ec193801792$var$__PRIVATE_primitiveComparator(n, i) : $2fa92ec193801792$var$__PRIVATE_isSurrogate(n) ? 1 : -1;
    }
    // Use the lengths of the strings to determine the overall comparison result since either the
    // strings were equal or one is a prefix of the other.
    return $2fa92ec193801792$var$__PRIVATE_primitiveComparator(e.length, t.length);
}
const $2fa92ec193801792$var$De = 55296, $2fa92ec193801792$var$xe = 57343;
function $2fa92ec193801792$var$__PRIVATE_isSurrogate(e) {
    const t = e.charCodeAt(0);
    return t >= $2fa92ec193801792$var$De && t <= $2fa92ec193801792$var$xe;
}
/** Helper to compare arrays using isEqual(). */ function $2fa92ec193801792$var$__PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every((e, r)=>n(e, t[r]));
}
/**
 * Verifies equality for an optional value.
 */ function $2fa92ec193801792$export$545a72cc0d3f00b0(e, t, n) {
    return void 0 === e && void 0 === t || void 0 !== e && void 0 !== t && n(e, t);
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $2fa92ec193801792$var$__PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class $2fa92ec193801792$var$SortedMap {
    constructor(e, t){
        this.comparator = e, this.root = t || $2fa92ec193801792$var$LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(e, t) {
        return new $2fa92ec193801792$var$SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, $2fa92ec193801792$var$LLRBNode.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(e) {
        return new $2fa92ec193801792$var$SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, $2fa92ec193801792$var$LLRBNode.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(e) {
        let t = this.root;
        for(; !t.isEmpty();){
            const n = this.comparator(e, t.key);
            if (0 === n) return t.value;
            n < 0 ? t = t.left : n > 0 && (t = t.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(e) {
        // Number of nodes that were pruned when descending right
        let t = 0, n = this.root;
        for(; !n.isEmpty();){
            const r = this.comparator(e, n.key);
            if (0 === r) return t + n.left.size;
            r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (t += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.root.inorderTraversal(e);
    }
    forEach(e) {
        this.inorderTraversal((t, n)=>(e(t, n), false));
    }
    toString() {
        const e = [];
        return this.inorderTraversal((t, n)=>(e.push(`${t}:${n}`), false)), `{${e.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.root.reverseTraversal(e);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $2fa92ec193801792$var$SortedMapIterator(this.root, null, this.comparator, false);
    }
    getIteratorFrom(e) {
        return new $2fa92ec193801792$var$SortedMapIterator(this.root, e, this.comparator, false);
    }
    getReverseIterator() {
        return new $2fa92ec193801792$var$SortedMapIterator(this.root, null, this.comparator, true);
    }
    getReverseIteratorFrom(e) {
        return new $2fa92ec193801792$var$SortedMapIterator(this.root, e, this.comparator, true);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $2fa92ec193801792$var$SortedMapIterator {
    constructor(e, t, n, r){
        this.isReverse = r, this.nodeStack = [];
        let i = 1;
        for(; !e.isEmpty();)if (i = t ? n(e.key, t) : 1, // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    getNext() {
        let e = this.nodeStack.pop();
        const t = {
            key: e.key,
            value: e.value
        };
        if (this.isReverse) for(e = e.left; !e.isEmpty();)this.nodeStack.push(e), e = e.right;
        else for(e = e.right; !e.isEmpty();)this.nodeStack.push(e), e = e.left;
        return t;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const e = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: e.key,
            value: e.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $2fa92ec193801792$var$LLRBNode {
    constructor(e, t, n, r, i){
        this.key = e, this.value = t, this.color = null != n ? n : $2fa92ec193801792$var$LLRBNode.RED, this.left = null != r ? r : $2fa92ec193801792$var$LLRBNode.EMPTY, this.right = null != i ? i : $2fa92ec193801792$var$LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(e, t, n, r, i) {
        return new $2fa92ec193801792$var$LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return false;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(e, t, n) {
        let r = this;
        const i = n(e, r.key);
        return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $2fa92ec193801792$var$LLRBNode.EMPTY;
        let e = this;
        return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), e.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(e, t) {
        let n, r = this;
        if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), r = r.copy(null, null, null, r.left.remove(e, t), null);
        else {
            if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 0 === t(e, r.key)) {
                if (r.right.isEmpty()) return $2fa92ec193801792$var$LLRBNode.EMPTY;
                n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
            }
            r = r.copy(null, null, null, null, r.right.remove(e, t));
        }
        return r.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let e = this;
        return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
    }
    moveRedLeft() {
        let e = this.colorFlip();
        return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
    }
    moveRedRight() {
        let e = this.colorFlip();
        return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
    }
    rotateLeft() {
        const e = this.copy(null, null, $2fa92ec193801792$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, e, null);
    }
    rotateRight() {
        const e = this.copy(null, null, $2fa92ec193801792$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, e);
    }
    colorFlip() {
        const e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, e, t);
    }
    // For testing.
    checkMaxDepth() {
        const e = this.check();
        return Math.pow(2, e) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $2fa92ec193801792$export$1a82df3d29112e01(43730, {
            key: this.key,
            value: this.value
        });
        if (this.right.isRed()) throw $2fa92ec193801792$export$1a82df3d29112e01(14113, {
            key: this.key,
            value: this.value
        });
        const e = this.left.check();
        if (e !== this.right.check()) throw $2fa92ec193801792$export$1a82df3d29112e01(27949);
        return e + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$2fa92ec193801792$var$LLRBNode.EMPTY = null, $2fa92ec193801792$var$LLRBNode.RED = true, $2fa92ec193801792$var$LLRBNode.BLACK = false;
// end LLRBEmptyNode
$2fa92ec193801792$var$LLRBNode.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class LLRBEmptyNode {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw $2fa92ec193801792$export$1a82df3d29112e01(57766);
    }
    get value() {
        throw $2fa92ec193801792$export$1a82df3d29112e01(16141);
    }
    get color() {
        throw $2fa92ec193801792$export$1a82df3d29112e01(16727);
    }
    get left() {
        throw $2fa92ec193801792$export$1a82df3d29112e01(29726);
    }
    get right() {
        throw $2fa92ec193801792$export$1a82df3d29112e01(36894);
    }
    // Returns a copy of the current node.
    copy(e, t, n, r, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(e, t, n) {
        return new $2fa92ec193801792$var$LLRBNode(e, t);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(e, t) {
        return this;
    }
    isEmpty() {
        return true;
    }
    inorderTraversal(e) {
        return false;
    }
    reverseTraversal(e) {
        return false;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return false;
    }
    // For testing.
    checkMaxDepth() {
        return true;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $2fa92ec193801792$var$SortedSet {
    constructor(e){
        this.comparator = e, this.data = new $2fa92ec193801792$var$SortedMap(this.comparator);
    }
    has(e) {
        return null !== this.data.get(e);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(e) {
        return this.data.indexOf(e);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(e) {
        this.data.inorderTraversal((t, n)=>(e(t), false));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(e, t) {
        const n = this.data.getIteratorFrom(e[0]);
        for(; n.hasNext();){
            const r = n.getNext();
            if (this.comparator(r.key, e[1]) >= 0) return;
            t(r.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(e, t) {
        let n;
        for(n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext();){
            if (!e(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(e) {
        const t = this.data.getIteratorFrom(e);
        return t.hasNext() ? t.getNext().key : null;
    }
    getIterator() {
        return new $2fa92ec193801792$var$SortedSetIterator(this.data.getIterator());
    }
    getIteratorFrom(e) {
        return new $2fa92ec193801792$var$SortedSetIterator(this.data.getIteratorFrom(e));
    }
    /** Inserts or updates an element */ add(e) {
        return this.copy(this.data.remove(e).insert(e, true));
    }
    /** Deletes an element */ delete(e) {
        return this.has(e) ? this.copy(this.data.remove(e)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(e) {
        let t = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return t.size < e.size && (t = e, e = this), e.forEach((e)=>{
            t = t.add(e);
        }), t;
    }
    isEqual(e) {
        if (!(e instanceof $2fa92ec193801792$var$SortedSet)) return false;
        if (this.size !== e.size) return false;
        const t = this.data.getIterator(), n = e.data.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (0 !== this.comparator(e, r)) return false;
        }
        return true;
    }
    toArray() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t);
        }), e;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>e.push(t)), "SortedSet(" + e.toString() + ")";
    }
    copy(e) {
        const t = new $2fa92ec193801792$var$SortedSet(this.comparator);
        return t.data = e, t;
    }
}
class $2fa92ec193801792$var$SortedSetIterator {
    constructor(e){
        this.iter = e;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $2fa92ec193801792$var$__PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$export$db3b6bfb95261072 = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller cannot be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class $2fa92ec193801792$export$2408f22a0fab9ae5 extends (0, $029952e65115eee5$export$dd24e9cd51226c56) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ e, /**
     * A custom error description.
     */ t){
        super(e, t), this.code = e, this.message = t, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$Ce = "__name__";
/**
 * Path represents an ordered sequence of string segments.
 */ class $2fa92ec193801792$var$BasePath {
    constructor(e, t, n){
        void 0 === t ? t = 0 : t > e.length && $2fa92ec193801792$export$1a82df3d29112e01(637, {
            offset: t,
            range: e.length
        }), void 0 === n ? n = e.length - t : n > e.length - t && $2fa92ec193801792$export$1a82df3d29112e01(1746, {
            length: n,
            range: e.length - t
        }), this.segments = e, this.offset = t, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(e) {
        return 0 === $2fa92ec193801792$var$BasePath.comparator(this, e);
    }
    child(e) {
        const t = this.segments.slice(this.offset, this.limit());
        return e instanceof $2fa92ec193801792$var$BasePath ? e.forEach((e)=>{
            t.push(e);
        }) : t.push(e), this.construct(t);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(e) {
        return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(e) {
        return this.segments[this.offset + e];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(e) {
        if (e.length < this.length) return false;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return false;
        return true;
    }
    isImmediateParentOf(e) {
        if (this.length + 1 !== e.length) return false;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return false;
        return true;
    }
    forEach(e) {
        for(let t = this.offset, n = this.limit(); t < n; t++)e(this.segments[t]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    /**
     * Compare 2 paths segment by segment, prioritizing numeric IDs
     * (e.g., "__id123__") in numeric ascending order, followed by string
     * segments in lexicographical order.
     */ static comparator(e, t) {
        const n = Math.min(e.length, t.length);
        for(let r = 0; r < n; r++){
            const n = $2fa92ec193801792$var$BasePath.compareSegments(e.get(r), t.get(r));
            if (0 !== n) return n;
        }
        return $2fa92ec193801792$var$__PRIVATE_primitiveComparator(e.length, t.length);
    }
    static compareSegments(e, t) {
        const n = $2fa92ec193801792$var$BasePath.isNumericId(e), r = $2fa92ec193801792$var$BasePath.isNumericId(t);
        return n && !r ? -1 : !n && r ? 1 : n && r ? $2fa92ec193801792$var$BasePath.extractNumericId(e).compare($2fa92ec193801792$var$BasePath.extractNumericId(t)) : $2fa92ec193801792$var$__PRIVATE_compareUtf8Strings(e, t);
    }
    // Checks if a segment is a numeric ID (starts with "__id" and ends with "__").
    static isNumericId(e) {
        return e.startsWith("__id") && e.endsWith("__");
    }
    static extractNumericId(e) {
        return (0, $906344b47e605252$export$70ffa26850098d01).fromString(e.substring(4, e.length - 2));
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $2fa92ec193801792$export$db202ddc8be9136 extends $2fa92ec193801792$var$BasePath {
    construct(e, t, n) {
        return new $2fa92ec193801792$export$db202ddc8be9136(e, t, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    toStringWithLeadingSlash() {
        return `/${this.canonicalString()}`;
    }
    /**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */ toUriEncodedString() {
        return this.toArray().map(encodeURIComponent).join("/");
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...e) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const t = [];
        for (const n of e){
            if (n.indexOf("//") >= 0) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and trailing slashed.
            t.push(...n.split("/").filter((e)=>e.length > 0));
        }
        return new $2fa92ec193801792$export$db202ddc8be9136(t);
    }
    static emptyPath() {
        return new $2fa92ec193801792$export$db202ddc8be9136([]);
    }
}
const $2fa92ec193801792$var$Fe = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ let $2fa92ec193801792$export$b9a6b53f9be3734 = class FieldPath extends $2fa92ec193801792$var$BasePath {
    construct(e, t, n) {
        return new FieldPath(e, t, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(e) {
        return $2fa92ec193801792$var$Fe.test(e);
    }
    canonicalString() {
        return this.toArray().map((e)=>(e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), FieldPath.isValidIdentifier(e) || (e = "`" + e + "`"), e)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && this.get(0) === $2fa92ec193801792$var$Ce;
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new FieldPath([
            $2fa92ec193801792$var$Ce
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(e) {
        const t = [];
        let n = "", r = 0;
        const __PRIVATE_addCurrentSegment = ()=>{
            if (0 === n.length) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, `Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            t.push(n), n = "";
        };
        let i = false;
        for(; r < e.length;){
            const t = e[r];
            if ("\\" === t) {
                if (r + 1 === e.length) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
                const t = e[r + 1];
                if ("\\" !== t && "." !== t && "`" !== t) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
                n += t, r += 2;
            } else "`" === t ? (i = !i, r++) : "." !== t || i ? (n += t, r++) : (__PRIVATE_addCurrentSegment(), r++);
        }
        if (__PRIVATE_addCurrentSegment(), i) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
        return new FieldPath(t);
    }
    static emptyPath() {
        return new FieldPath([]);
    }
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $2fa92ec193801792$var$FieldMask {
    constructor(e){
        this.fields = e, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort($2fa92ec193801792$export$b9a6b53f9be3734.comparator);
    }
    static empty() {
        return new $2fa92ec193801792$var$FieldMask([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(e) {
        let t = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$export$b9a6b53f9be3734.comparator);
        for (const e of this.fields)t = t.add(e);
        for (const n of e)t = t.add(n);
        return new $2fa92ec193801792$var$FieldMask(t.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(e) {
        for (const t of this.fields)if (t.isPrefixOf(e)) return true;
        return false;
    }
    isEqual(e) {
        return $2fa92ec193801792$var$__PRIVATE_arrayEquals(this.fields, e.fields, (e, t)=>e.isEqual(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2fa92ec193801792$var$__PRIVATE_objectSize(e) {
    let t = 0;
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}
function $2fa92ec193801792$var$forEach(e, t) {
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function $2fa92ec193801792$export$971d5caa766a69d7(e, t) {
    const n = [];
    for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
    return n;
}
function $2fa92ec193801792$var$isEmpty(e) {
    for(const t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $2fa92ec193801792$export$a07804094c3ecf2d {
    constructor(e){
        this.path = e;
    }
    static fromPath(e) {
        return new $2fa92ec193801792$export$a07804094c3ecf2d($2fa92ec193801792$export$db202ddc8be9136.fromString(e));
    }
    static fromName(e) {
        return new $2fa92ec193801792$export$a07804094c3ecf2d($2fa92ec193801792$export$db202ddc8be9136.fromString(e).popFirst(5));
    }
    static empty() {
        return new $2fa92ec193801792$export$a07804094c3ecf2d($2fa92ec193801792$export$db202ddc8be9136.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(e) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(e) {
        return null !== e && 0 === $2fa92ec193801792$export$db202ddc8be9136.comparator(this.path, e.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(e, t) {
        return $2fa92ec193801792$export$db202ddc8be9136.comparator(e.path, t.path);
    }
    static isDocumentKey(e) {
        return e.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(e) {
        return new $2fa92ec193801792$export$a07804094c3ecf2d(new $2fa92ec193801792$export$db202ddc8be9136(e.slice()));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2fa92ec193801792$var$__PRIVATE_validateNonEmptyArgument(e, t, n) {
    if (!n) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $2fa92ec193801792$export$faec65b429be379(e, t, n, r) {
    if (true === t && true === r) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $2fa92ec193801792$var$__PRIVATE_validateDocumentPath(e) {
    if (!$2fa92ec193801792$export$a07804094c3ecf2d.isDocumentKey(e)) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $2fa92ec193801792$var$__PRIVATE_validateCollectionPath(e) {
    if ($2fa92ec193801792$export$a07804094c3ecf2d.isDocumentKey(e)) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ function $2fa92ec193801792$export$ebb8f7cd71856fb9(e) {
    return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
}
/** Returns a string describing the type / value of the provided input. */ function $2fa92ec193801792$export$ab83b03e4111b1d0(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == typeof e) {
        if (e instanceof Array) return "an array";
        {
            const t = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }(e);
            return t ? `a custom ${t} object` : "an object";
        }
    }
    return "function" == typeof e ? "a function" : $2fa92ec193801792$export$1a82df3d29112e01(12329, {
        type: typeof e
    });
}
function $2fa92ec193801792$export$df995fae86a55f06(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    if ("_delegate" in e && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e = e._delegate), !(e instanceof t)) {
        if (t.name === e.constructor.name) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = $2fa92ec193801792$export$ab83b03e4111b1d0(e);
            throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
        }
    }
    return e;
}
function $2fa92ec193801792$export$34aec0b863436764(e, t) {
    if (t <= 0) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper function to define a JSON schema {@link Property}.
 * @private
 * @internal
 */ function $2fa92ec193801792$export$ffb5f4729a158638(e, t) {
    const n = {
        typeString: e
    };
    return t && (n.value = t), n;
}
/**
 * Validates the JSON object based on the provided schema, and narrows the type to the provided
 * JSON schema.
 * @private
 * @internal
 *
 * @param json - A JSON object to validate.
 * @param scheme - a {@link JsonSchema} that defines the properties to validate.
 * @returns true if the JSON schema exists within the object. Throws a FirestoreError otherwise.
 */ function $2fa92ec193801792$export$9bb611d729802a56(e, t) {
    if (!$2fa92ec193801792$export$ebb8f7cd71856fb9(e)) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "JSON must be an object");
    let n;
    for(const r in t)if (t[r]) {
        const i = t[r].typeString, s = "value" in t[r] ? {
            value: t[r].value
        } : void 0;
        if (!(r in e)) {
            n = `JSON missing required field: '${r}'`;
            break;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const _ = e[r];
        if (i && typeof _ !== i) {
            n = `JSON field '${r}' must be a ${i}.`;
            break;
        }
        if (void 0 !== s && _ !== s.value) {
            n = `Expected '${r}' field to equal '${s.value}'`;
            break;
        }
    }
    if (n) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, n);
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
const $2fa92ec193801792$var$Me = -62135596800, $2fa92ec193801792$var$Ne = 1e6;
// Number of nanoseconds in a millisecond.
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $2fa92ec193801792$export$890c4ad488842ce7 {
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $2fa92ec193801792$export$890c4ad488842ce7.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(e) {
        return $2fa92ec193801792$export$890c4ad488842ce7.fromMillis(e.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(e) {
        const t = Math.floor(e / 1e3), n = Math.floor((e - 1e3 * t) * $2fa92ec193801792$var$Ne);
        return new $2fa92ec193801792$export$890c4ad488842ce7(t, n);
    }
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ e, /**
     * The fractions of a second at nanosecond resolution.*
     */ t){
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < $2fa92ec193801792$var$Me) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        // This will break in the year 10,000.
        if (e >= 253402300800) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / $2fa92ec193801792$var$Ne;
    }
    _compareTo(e) {
        return this.seconds === e.seconds ? $2fa92ec193801792$var$__PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : $2fa92ec193801792$var$__PRIVATE_primitiveComparator(this.seconds, e.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(e) {
        return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /**
     * Returns a JSON-serializable representation of this `Timestamp`.
     */ toJSON() {
        return {
            type: $2fa92ec193801792$export$890c4ad488842ce7._jsonSchemaVersion,
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Builds a `Timestamp` instance from a JSON object created by {@link Timestamp.toJSON}.
     */ static fromJSON(e) {
        if ($2fa92ec193801792$export$9bb611d729802a56(e, $2fa92ec193801792$export$890c4ad488842ce7._jsonSchema)) return new $2fa92ec193801792$export$890c4ad488842ce7(e.seconds, e.nanoseconds);
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexicographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexicographical ordering.
        const e = this.seconds - $2fa92ec193801792$var$Me;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
$2fa92ec193801792$export$890c4ad488842ce7._jsonSchemaVersion = "firestore/timestamp/1.0", $2fa92ec193801792$export$890c4ad488842ce7._jsonSchema = {
    type: $2fa92ec193801792$export$ffb5f4729a158638("string", $2fa92ec193801792$export$890c4ad488842ce7._jsonSchemaVersion),
    seconds: $2fa92ec193801792$export$ffb5f4729a158638("number"),
    nanoseconds: $2fa92ec193801792$export$ffb5f4729a158638("number")
};
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ class $2fa92ec193801792$var$__PRIVATE_Base64DecodeError extends Error {
    constructor(){
        super(...arguments), this.name = "Base64DecodeError";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $2fa92ec193801792$export$9f4f30ee63539e24() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $2fa92ec193801792$export$158acd800e1ef08b {
    constructor(e){
        this.binaryString = e;
    }
    static fromBase64String(e) {
        const t = function __PRIVATE_decodeBase64(e) {
            try {
                return atob(e);
            } catch (e) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && e instanceof DOMException ? new $2fa92ec193801792$var$__PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
            }
        }(e);
        return new $2fa92ec193801792$export$158acd800e1ef08b(t);
    }
    static fromUint8Array(e) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const t = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(e) {
            let t = "";
            for(let n = 0; n < e.length; ++n)t += String.fromCharCode(e[n]);
            return t;
        }(e);
        return new $2fa92ec193801792$export$158acd800e1ef08b(t);
    }
    [Symbol.iterator]() {
        let e = 0;
        return {
            next: ()=>e < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(e++),
                    done: false
                } : {
                    value: void 0,
                    done: true
                }
        };
    }
    toBase64() {
        return function __PRIVATE_encodeBase64(e) {
            return btoa(e);
        }(this.binaryString);
    }
    toUint8Array() {
        return function __PRIVATE_uint8ArrayFromBinaryString(e) {
            const t = new Uint8Array(e.length);
            for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
            return t;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(e) {
        return $2fa92ec193801792$var$__PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
    }
    isEqual(e) {
        return this.binaryString === e.binaryString;
    }
}
$2fa92ec193801792$export$158acd800e1ef08b.EMPTY_BYTE_STRING = new $2fa92ec193801792$export$158acd800e1ef08b("");
const $2fa92ec193801792$var$Le = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $2fa92ec193801792$var$__PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($2fa92ec193801792$var$__PRIVATE_hardAssert(!!e, 39018), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let t = 0;
        const n = $2fa92ec193801792$var$Le.exec(e);
        if ($2fa92ec193801792$var$__PRIVATE_hardAssert(!!n, 46558, {
            timestamp: e
        }), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let e = n[1];
            e = (e + "000000000").substr(0, 9), t = Number(e);
        }
        // Parse the date to get the seconds.
        const r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: $2fa92ec193801792$var$__PRIVATE_normalizeNumber(e.seconds),
        nanos: $2fa92ec193801792$var$__PRIVATE_normalizeNumber(e.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $2fa92ec193801792$var$__PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $2fa92ec193801792$var$__PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? $2fa92ec193801792$export$158acd800e1ef08b.fromBase64String(e) : $2fa92ec193801792$export$158acd800e1ef08b.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ const $2fa92ec193801792$var$Be = "server_timestamp", $2fa92ec193801792$var$Ue = "__type__", $2fa92ec193801792$var$ke = "__previous_value__", $2fa92ec193801792$var$qe = "__local_write_time__";
function $2fa92ec193801792$export$f38c853ae54ed474(e) {
    const t = (e?.mapValue?.fields || {})[$2fa92ec193801792$var$Ue]?.stringValue;
    return t === $2fa92ec193801792$var$Be;
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $2fa92ec193801792$var$__PRIVATE_getPreviousValue(e) {
    const t = e.mapValue.fields[$2fa92ec193801792$var$ke];
    return $2fa92ec193801792$export$f38c853ae54ed474(t) ? $2fa92ec193801792$var$__PRIVATE_getPreviousValue(t) : t;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $2fa92ec193801792$var$__PRIVATE_getLocalWriteTime(e) {
    const t = $2fa92ec193801792$var$__PRIVATE_normalizeTimestamp(e.mapValue.fields[$2fa92ec193801792$var$qe].timestampValue);
    return new $2fa92ec193801792$export$890c4ad488842ce7(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$var$DatabaseInfo {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions - Options that configure long-polling.
     * @param useFetchStreams - Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(e, t, n, r, i, s, _, o, a, u, c, l, E){
        this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = _, this.longPollingOptions = o, this.useFetchStreams = a, this.isUsingEmulator = u, this.apiKey = c, this._customHeaders = l, this.grpcFlowControlWindow = E;
    }
}
/** The default database name for a project. */ const $2fa92ec193801792$var$$e = "(default)";
/**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $2fa92ec193801792$export$cf2f7c5792f80b46 {
    constructor(e, t){
        this.projectId = e, this.database = t || $2fa92ec193801792$var$$e;
    }
    static empty() {
        return new $2fa92ec193801792$export$cf2f7c5792f80b46("", "");
    }
    get isDefaultDatabase() {
        return this.database === $2fa92ec193801792$var$$e;
    }
    isEqual(e) {
        return e instanceof $2fa92ec193801792$export$cf2f7c5792f80b46 && e.projectId === this.projectId && e.database === this.database;
    }
}
function $2fa92ec193801792$export$8b22cf2602fb60ce(e, t) {
    if (!Object.prototype.hasOwnProperty.apply(e.options, [
        "projectId"
    ])) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
    return new $2fa92ec193801792$export$cf2f7c5792f80b46(e.options.projectId, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Sentinel value that sorts before any Mutation Batch ID. */ const $2fa92ec193801792$var$Ke = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function $2fa92ec193801792$var$__PRIVATE_isNullOrUndefined(e) {
    return null == e;
}
/** Returns whether the value represents -0. */ function $2fa92ec193801792$var$__PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}
function $2fa92ec193801792$export$479ac0420f53ed26(e) {
    return "number" == typeof e;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $2fa92ec193801792$var$isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !$2fa92ec193801792$var$__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
function $2fa92ec193801792$export$4ae495d48253603d(e) {
    return "string" == typeof e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$We = "__type__", $2fa92ec193801792$var$Qe = "__max__", $2fa92ec193801792$var$Ge = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: $2fa92ec193801792$var$Qe
            }
        }
    }
}, $2fa92ec193801792$var$ze = "__vector__", $2fa92ec193801792$var$je = "value", $2fa92ec193801792$var$He = {
    nullValue: "NULL_VALUE"
}, $2fa92ec193801792$var$Je = {
    booleanValue: true
}, $2fa92ec193801792$var$Ye = {
    booleanValue: false
};
/** Extracts the backend's type order for the provided value. */ function $2fa92ec193801792$var$__PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */  : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in e ? 5 /* TypeOrder.StringValue */  : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in e ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in e ? $2fa92ec193801792$export$f38c853ae54ed474(e) ? 4 /* TypeOrder.ServerTimestampValue */  : $2fa92ec193801792$var$__PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */  : $2fa92ec193801792$var$__PRIVATE_isVectorValue(e) ? 10 /* TypeOrder.VectorValue */  : 11 /* TypeOrder.ObjectValue */  : $2fa92ec193801792$export$1a82df3d29112e01(28295, {
        value: e
    });
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $2fa92ec193801792$var$__PRIVATE_valueEquals$1(e, t, n) {
    if (e === t) return true;
    const r = $2fa92ec193801792$var$__PRIVATE_typeOrder(e);
    if (r !== $2fa92ec193801792$var$__PRIVATE_typeOrder(t)) return false;
    switch(r){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return true;
        case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue === t.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $2fa92ec193801792$var$__PRIVATE_getLocalWriteTime(e).isEqual($2fa92ec193801792$var$__PRIVATE_getLocalWriteTime(t));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(e, t) {
                if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return e.timestampValue === t.timestampValue;
                const n = $2fa92ec193801792$var$__PRIVATE_normalizeTimestamp(e.timestampValue), r = $2fa92ec193801792$var$__PRIVATE_normalizeTimestamp(t.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(e, t);
        case 5 /* TypeOrder.StringValue */ :
            return e.stringValue === t.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(e, t) {
                return $2fa92ec193801792$var$__PRIVATE_normalizeByteString(e.bytesValue).isEqual($2fa92ec193801792$var$__PRIVATE_normalizeByteString(t.bytesValue));
            }(e, t);
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue === t.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(e, t) {
                return $2fa92ec193801792$var$__PRIVATE_normalizeNumber(e.geoPointValue.latitude) === $2fa92ec193801792$var$__PRIVATE_normalizeNumber(t.geoPointValue.latitude) && $2fa92ec193801792$var$__PRIVATE_normalizeNumber(e.geoPointValue.longitude) === $2fa92ec193801792$var$__PRIVATE_normalizeNumber(t.geoPointValue.longitude);
            }(e, t);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(e, t, n) {
                if ("integerValue" in e && "integerValue" in t) return $2fa92ec193801792$var$__PRIVATE_normalizeNumber(e.integerValue) === $2fa92ec193801792$var$__PRIVATE_normalizeNumber(t.integerValue);
                let r, i;
                if ("doubleValue" in e && "doubleValue" in t) r = $2fa92ec193801792$var$__PRIVATE_normalizeNumber(e.doubleValue), i = $2fa92ec193801792$var$__PRIVATE_normalizeNumber(t.doubleValue);
                else {
                    if (!n?.t) return false;
                    r = $2fa92ec193801792$var$__PRIVATE_normalizeNumber(e.integerValue ?? e.doubleValue), i = $2fa92ec193801792$var$__PRIVATE_normalizeNumber(t.integerValue ?? t.doubleValue);
                }
                if (r === i) return !!n?.i || $2fa92ec193801792$var$__PRIVATE_isNegativeZero(r) === $2fa92ec193801792$var$__PRIVATE_isNegativeZero(i);
                return !!(void 0 === n || n.o) && isNaN(r) && isNaN(i);
            }(e, t, n);
        case 9 /* TypeOrder.ArrayValue */ :
            return $2fa92ec193801792$var$__PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], (e, t)=>$2fa92ec193801792$var$__PRIVATE_valueEquals$1(e, t, n));
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(e, t, n) {
                const r = e.mapValue.fields || {}, i = t.mapValue.fields || {};
                if ($2fa92ec193801792$var$__PRIVATE_objectSize(r) !== $2fa92ec193801792$var$__PRIVATE_objectSize(i)) return false;
                for(const e in r)if (r.hasOwnProperty(e) && (void 0 === i[e] || !$2fa92ec193801792$var$__PRIVATE_valueEquals$1(r[e], i[e], n))) return false;
                return true;
            }(e, t, n);
        default:
            return $2fa92ec193801792$export$1a82df3d29112e01(52216, {
                left: e
            });
    }
}
function $2fa92ec193801792$var$__PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find((e)=>$2fa92ec193801792$var$__PRIVATE_valueEquals$1(e, t));
}
function $2fa92ec193801792$var$__PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    const n = $2fa92ec193801792$var$__PRIVATE_typeOrder(e), r = $2fa92ec193801792$var$__PRIVATE_typeOrder(t);
    if (n !== r) return $2fa92ec193801792$var$__PRIVATE_primitiveComparator(n, r);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return $2fa92ec193801792$var$__PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(e, t) {
                const n = $2fa92ec193801792$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = $2fa92ec193801792$var$__PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(e, t);
        case 3 /* TypeOrder.TimestampValue */ :
            return $2fa92ec193801792$var$__PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $2fa92ec193801792$var$__PRIVATE_compareTimestamps($2fa92ec193801792$var$__PRIVATE_getLocalWriteTime(e), $2fa92ec193801792$var$__PRIVATE_getLocalWriteTime(t));
        case 5 /* TypeOrder.StringValue */ :
            return $2fa92ec193801792$var$__PRIVATE_compareUtf8Strings(e.stringValue, t.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(e, t) {
                const n = $2fa92ec193801792$var$__PRIVATE_normalizeByteString(e), r = $2fa92ec193801792$var$__PRIVATE_normalizeByteString(t);
                return n.compareTo(r);
            }(e.bytesValue, t.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(e, t) {
                const n = e.split("/"), r = t.split("/");
                for(let e = 0; e < n.length && e < r.length; e++){
                    const t = $2fa92ec193801792$var$__PRIVATE_primitiveComparator(n[e], r[e]);
                    if (0 !== t) return t;
                }
                return $2fa92ec193801792$var$__PRIVATE_primitiveComparator(n.length, r.length);
            }(e.referenceValue, t.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(e, t) {
                const n = $2fa92ec193801792$var$__PRIVATE_primitiveComparator($2fa92ec193801792$var$__PRIVATE_normalizeNumber(e.latitude), $2fa92ec193801792$var$__PRIVATE_normalizeNumber(t.latitude));
                if (0 !== n) return n;
                return $2fa92ec193801792$var$__PRIVATE_primitiveComparator($2fa92ec193801792$var$__PRIVATE_normalizeNumber(e.longitude), $2fa92ec193801792$var$__PRIVATE_normalizeNumber(t.longitude));
            }(e.geoPointValue, t.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return $2fa92ec193801792$var$__PRIVATE_compareArrays(e.arrayValue, t.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
            return function __PRIVATE_compareVectors(e, t) {
                const n = e.fields || {}, r = t.fields || {}, i = n[$2fa92ec193801792$var$je]?.arrayValue, s = r[$2fa92ec193801792$var$je]?.arrayValue, _ = $2fa92ec193801792$var$__PRIVATE_primitiveComparator(i?.values?.length || 0, s?.values?.length || 0);
                if (0 !== _) return _;
                return $2fa92ec193801792$var$__PRIVATE_compareArrays(i, s);
            }(e.mapValue, t.mapValue);
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(e, t) {
                if (e === $2fa92ec193801792$var$Ge.mapValue && t === $2fa92ec193801792$var$Ge.mapValue) return 0;
                if (e === $2fa92ec193801792$var$Ge.mapValue) return 1;
                if (t === $2fa92ec193801792$var$Ge.mapValue) return -1;
                const n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), s.sort();
                for(let e = 0; e < r.length && e < s.length; ++e){
                    const t = $2fa92ec193801792$var$__PRIVATE_compareUtf8Strings(r[e], s[e]);
                    if (0 !== t) return t;
                    const _ = $2fa92ec193801792$var$__PRIVATE_valueCompare(n[r[e]], i[s[e]]);
                    if (0 !== _) return _;
                }
                return $2fa92ec193801792$var$__PRIVATE_primitiveComparator(r.length, s.length);
            }(e.mapValue, t.mapValue);
        default:
            throw $2fa92ec193801792$export$1a82df3d29112e01(23264, {
                u: n
            });
    }
}
function $2fa92ec193801792$var$__PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return $2fa92ec193801792$var$__PRIVATE_primitiveComparator(e, t);
    const n = $2fa92ec193801792$var$__PRIVATE_normalizeTimestamp(e), r = $2fa92ec193801792$var$__PRIVATE_normalizeTimestamp(t), i = $2fa92ec193801792$var$__PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : $2fa92ec193801792$var$__PRIVATE_primitiveComparator(n.nanos, r.nanos);
}
function $2fa92ec193801792$var$__PRIVATE_compareArrays(e, t) {
    const n = e.values || [], r = t.values || [];
    for(let e = 0; e < n.length && e < r.length; ++e){
        const t = $2fa92ec193801792$var$__PRIVATE_valueCompare(n[e], r[e]);
        if (void 0 !== t && 0 !== t) return t;
    }
    return $2fa92ec193801792$var$__PRIVATE_primitiveComparator(n.length, r.length);
}
function $2fa92ec193801792$var$canonicalId(e) {
    return $2fa92ec193801792$var$__PRIVATE_canonifyValue(e);
}
function $2fa92ec193801792$var$__PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        const t = $2fa92ec193801792$var$__PRIVATE_normalizeTimestamp(e);
        return `time(${t.seconds},${t.nanos})`;
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return $2fa92ec193801792$var$__PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return $2fa92ec193801792$export$a07804094c3ecf2d.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return `geo(${e.latitude},${e.longitude})`;
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        let t = "[", n = true;
        for (const r of e.values || [])n ? n = false : t += ",", t += $2fa92ec193801792$var$__PRIVATE_canonifyValue(r);
        return t + "]";
    }(e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const t = Object.keys(e.fields || {}).sort();
        let n = "{", r = true;
        for (const i of t)r ? r = false : n += ",", n += `${i}:${$2fa92ec193801792$var$__PRIVATE_canonifyValue(e.fields[i])}`;
        return n + "}";
    }(e.mapValue) : $2fa92ec193801792$export$1a82df3d29112e01(61005, {
        value: e
    });
}
function $2fa92ec193801792$var$__PRIVATE_estimateByteSize(e) {
    switch($2fa92ec193801792$var$__PRIVATE_typeOrder(e)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            const t = $2fa92ec193801792$var$__PRIVATE_getPreviousValue(e);
            return t ? 16 + $2fa92ec193801792$var$__PRIVATE_estimateByteSize(t) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * e.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return $2fa92ec193801792$var$__PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_estimateArrayByteSize(e) {
                return (e.values || []).reduce((e, t)=>e + $2fa92ec193801792$var$__PRIVATE_estimateByteSize(t), 0);
            }(e.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_estimateMapByteSize(e) {
                let t = 0;
                return $2fa92ec193801792$var$forEach(e.fields, (e, n)=>{
                    t += e.length + $2fa92ec193801792$var$__PRIVATE_estimateByteSize(n);
                }), t;
            }(e.mapValue);
        default:
            throw $2fa92ec193801792$export$1a82df3d29112e01(13486, {
                value: e
            });
    }
}
function $2fa92ec193801792$export$995eb9fca571757(e, t) {
    return {
        referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}`
    };
}
/** Returns true if `value` is an BooleanValue . */ /** Returns true if `value` is an IntegerValue . */ function $2fa92ec193801792$var$isInteger(e) {
    return !!e && "integerValue" in e;
}
/** Returns true if `value` is a DoubleValue. */ function $2fa92ec193801792$var$__PRIVATE_isDouble(e) {
    return !!e && "doubleValue" in e;
}
/** Returns true if `value` is either an IntegerValue or a DoubleValue. */ function $2fa92ec193801792$var$R(e) {
    return $2fa92ec193801792$var$isInteger(e) || $2fa92ec193801792$var$__PRIVATE_isDouble(e);
}
/** Returns true if `value` is an ArrayValue. */ function $2fa92ec193801792$var$isArray(e) {
    return !!e && "arrayValue" in e;
}
/** Returns true if `value` is an ArrayValue. */ /** Returns true if `value` is a NullValue. */ function $2fa92ec193801792$var$__PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}
/** Returns true if `value` is NaN. */ function $2fa92ec193801792$var$__PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
/** Returns true if `value` is Timestamp. */ /** Returns true if `value` is a MapValue. */ function $2fa92ec193801792$var$__PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}
/** Returns true if `value` is a VetorValue. */ function $2fa92ec193801792$var$__PRIVATE_isVectorValue(e) {
    const t = (e?.mapValue?.fields || {})[$2fa92ec193801792$var$We]?.stringValue;
    return t === $2fa92ec193801792$var$ze;
}
/** Returns true if `value` is a VetorValue. */ function $2fa92ec193801792$var$__PRIVATE_getVectorValue(e) {
    return (e?.mapValue?.fields || {})[$2fa92ec193801792$var$je]?.arrayValue;
}
/** Creates a deep copy of `source`. */ function $2fa92ec193801792$var$__PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: {
            ...e.geoPointValue
        }
    };
    if (e.timestampValue && "object" == typeof e.timestampValue) return {
        timestampValue: {
            ...e.timestampValue
        }
    };
    if (e.mapValue) {
        const t = {
            mapValue: {
                fields: {}
            }
        };
        return $2fa92ec193801792$var$forEach(e.mapValue.fields, (e, n)=>t.mapValue.fields[e] = $2fa92ec193801792$var$__PRIVATE_deepClone(n)), t;
    }
    if (e.arrayValue) {
        const t = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (e.arrayValue.values || []).length; ++n)t.arrayValue.values[n] = $2fa92ec193801792$var$__PRIVATE_deepClone(e.arrayValue.values[n]);
        return t;
    }
    return {
        ...e
    };
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $2fa92ec193801792$var$__PRIVATE_isMaxValue(e) {
    return (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue === $2fa92ec193801792$var$Qe;
}
const $2fa92ec193801792$var$Ze = {
    mapValue: {
        fields: {
            [$2fa92ec193801792$var$We]: {
                stringValue: $2fa92ec193801792$var$ze
            },
            [$2fa92ec193801792$var$je]: {
                arrayValue: {}
            }
        }
    }
};
/** Returns the lowest value for the given value type (inclusive). */ function $2fa92ec193801792$var$__PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? $2fa92ec193801792$var$He : "booleanValue" in e ? {
        booleanValue: false
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? $2fa92ec193801792$export$995eb9fca571757($2fa92ec193801792$export$cf2f7c5792f80b46.empty(), $2fa92ec193801792$export$a07804094c3ecf2d.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? $2fa92ec193801792$var$__PRIVATE_isVectorValue(e) ? $2fa92ec193801792$var$Ze : {
        mapValue: {}
    } : $2fa92ec193801792$export$1a82df3d29112e01(35942, {
        value: e
    });
}
/** Returns the largest value for the given value type (exclusive). */ function $2fa92ec193801792$var$__PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: false
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? $2fa92ec193801792$export$995eb9fca571757($2fa92ec193801792$export$cf2f7c5792f80b46.empty(), $2fa92ec193801792$export$a07804094c3ecf2d.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? $2fa92ec193801792$var$Ze : "mapValue" in e ? $2fa92ec193801792$var$__PRIVATE_isVectorValue(e) ? {
        mapValue: {}
    } : $2fa92ec193801792$var$Ge : $2fa92ec193801792$export$1a82df3d29112e01(61959, {
        value: e
    });
}
function $2fa92ec193801792$var$__PRIVATE_lowerBoundCompare(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}
function $2fa92ec193801792$var$__PRIVATE_upperBoundCompare(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $2fa92ec193801792$export$c4ce752e73470fba {
    constructor(e){
        this.value = e;
    }
    static empty() {
        return new $2fa92ec193801792$export$c4ce752e73470fba({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(e) {
        if (e.isEmpty()) return this.value;
        {
            let t = this.value;
            for(let n = 0; n < e.length - 1; ++n)if (t = (t.mapValue.fields || {})[e.get(n)], !$2fa92ec193801792$var$__PRIVATE_isMapValue(t)) return null;
            return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(e, t) {
        this.getFieldsMap(e.popLast())[e.lastSegment()] = $2fa92ec193801792$var$__PRIVATE_deepClone(t);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(e) {
        let t = $2fa92ec193801792$export$b9a6b53f9be3734.emptyPath(), n = {}, r = [];
        e.forEach((e, i)=>{
            if (!t.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const e = this.getFieldsMap(t);
                this.applyChanges(e, n, r), n = {}, r = [], t = i.popLast();
            }
            e ? n[i.lastSegment()] = $2fa92ec193801792$var$__PRIVATE_deepClone(e) : r.push(i.lastSegment());
        });
        const i = this.getFieldsMap(t);
        this.applyChanges(i, n, r);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(e) {
        const t = this.field(e.popLast());
        $2fa92ec193801792$var$__PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
    }
    isEqual(e) {
        return $2fa92ec193801792$var$__PRIVATE_valueEquals$1(this.value, e.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(e) {
        let t = this.value;
        t.mapValue.fields || (t.mapValue = {
            fields: {}
        });
        for(let n = 0; n < e.length; ++n){
            let r = t.mapValue.fields[e.get(n)];
            $2fa92ec193801792$var$__PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                mapValue: {
                    fields: {}
                }
            }, t.mapValue.fields[e.get(n)] = r), t = r;
        }
        return t.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(e, t, n) {
        $2fa92ec193801792$var$forEach(t, (t, n)=>e[t] = n);
        for (const t of n)delete e[t];
    }
    clone() {
        return new $2fa92ec193801792$export$c4ce752e73470fba($2fa92ec193801792$var$__PRIVATE_deepClone(this.value));
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $2fa92ec193801792$var$__PRIVATE_extractFieldMask(e) {
    const t = [];
    return $2fa92ec193801792$var$forEach(e.fields, (e, n)=>{
        const r = new $2fa92ec193801792$export$b9a6b53f9be3734([
            e
        ]);
        if ($2fa92ec193801792$var$__PRIVATE_isMapValue(n)) {
            const e = $2fa92ec193801792$var$__PRIVATE_extractFieldMask(n.mapValue).fields;
            if (0 === e.length) // Preserve the empty map by adding it to the FieldMask.
            t.push(r);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of e)t.push(r.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    }), new $2fa92ec193801792$var$FieldMask(t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $2fa92ec193801792$var$__PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $2fa92ec193801792$var$__PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $2fa92ec193801792$var$__PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $2fa92ec193801792$var$toNumber(e, t, n) {
    return $2fa92ec193801792$var$isSafeInteger(t) ? $2fa92ec193801792$var$__PRIVATE_toInteger(t) : $2fa92ec193801792$var$__PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $2fa92ec193801792$var$TransformOperation {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $2fa92ec193801792$var$__PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof $2fa92ec193801792$var$__PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        const n = {
            fields: {
                [$2fa92ec193801792$var$Ue]: {
                    stringValue: $2fa92ec193801792$var$Be
                },
                [$2fa92ec193801792$var$qe]: {
                    timestampValue: {
                        seconds: e.seconds,
                        nanos: e.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return t && $2fa92ec193801792$export$f38c853ae54ed474(t) && (t = $2fa92ec193801792$var$__PRIVATE_getPreviousValue(t)), t && (n.fields[$2fa92ec193801792$var$ke] = t), {
            mapValue: n
        };
    }(n, t) : e instanceof $2fa92ec193801792$var$__PRIVATE_ArrayUnionTransformOperation ? $2fa92ec193801792$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $2fa92ec193801792$var$__PRIVATE_ArrayRemoveTransformOperation ? $2fa92ec193801792$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : e instanceof $2fa92ec193801792$var$__PRIVATE_NumericIncrementTransformOperation ? function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = $2fa92ec193801792$var$__PRIVATE_computeTransformOperationBaseValue(e, t), r = $2fa92ec193801792$var$asNumber(n) + $2fa92ec193801792$var$asNumber(e.l);
        return $2fa92ec193801792$var$isInteger(n) && $2fa92ec193801792$var$isInteger(e.l) ? $2fa92ec193801792$var$__PRIVATE_toInteger(r) : $2fa92ec193801792$var$__PRIVATE_toDouble(e.serializer, r);
    }(e, t) : e instanceof $2fa92ec193801792$var$__PRIVATE_NumericMinimumTransformOperation ? function __PRIVATE_applyNumericMinimumTransformOperationToLocalView(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_applyNumericTransformOperationToLocalView(e, t, Math.min);
    }(e, t) : e instanceof $2fa92ec193801792$var$__PRIVATE_NumericMaximumTransformOperation ? function __PRIVATE_applyNumericMaximumTransformOperationToLocalView(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_applyNumericTransformOperationToLocalView(e, t, Math.max);
    }(e, t) : void 0;
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $2fa92ec193801792$var$__PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof $2fa92ec193801792$var$__PRIVATE_ArrayUnionTransformOperation ? $2fa92ec193801792$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $2fa92ec193801792$var$__PRIVATE_ArrayRemoveTransformOperation ? $2fa92ec193801792$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $2fa92ec193801792$var$__PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof $2fa92ec193801792$var$__PRIVATE_NumericIncrementTransformOperation ? $2fa92ec193801792$var$R(t) ? t : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class $2fa92ec193801792$var$__PRIVATE_ServerTimestampTransform extends $2fa92ec193801792$var$TransformOperation {
}
/** Transforms an array value via a union operation. */ class $2fa92ec193801792$var$__PRIVATE_ArrayUnionTransformOperation extends $2fa92ec193801792$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $2fa92ec193801792$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n.some((e)=>$2fa92ec193801792$var$__PRIVATE_valueEquals$1(e, t)) || n.push(t);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class $2fa92ec193801792$var$__PRIVATE_ArrayRemoveTransformOperation extends $2fa92ec193801792$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $2fa92ec193801792$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    let n = $2fa92ec193801792$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n = n.filter((e)=>!$2fa92ec193801792$var$__PRIVATE_valueEquals$1(e, t));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $2fa92ec193801792$var$__PRIVATE_NumericTransformOperation extends $2fa92ec193801792$var$TransformOperation {
    constructor(e, t){
        super(), this.serializer = e, this.l = t;
    }
}
class $2fa92ec193801792$var$__PRIVATE_NumericIncrementTransformOperation extends $2fa92ec193801792$var$__PRIVATE_NumericTransformOperation {
}
class $2fa92ec193801792$var$__PRIVATE_NumericMinimumTransformOperation extends $2fa92ec193801792$var$__PRIVATE_NumericTransformOperation {
}
class $2fa92ec193801792$var$__PRIVATE_NumericMaximumTransformOperation extends $2fa92ec193801792$var$__PRIVATE_NumericTransformOperation {
}
function $2fa92ec193801792$var$__PRIVATE_applyNumericTransformOperationToLocalView(e, t, n) {
    if (!$2fa92ec193801792$var$R(t)) return e.l;
    const r = n($2fa92ec193801792$var$asNumber(t), $2fa92ec193801792$var$asNumber(e.l));
    return $2fa92ec193801792$var$isInteger(t) && $2fa92ec193801792$var$isInteger(e.l) ? $2fa92ec193801792$var$__PRIVATE_toInteger(r) : $2fa92ec193801792$var$__PRIVATE_toDouble(e.serializer, r);
}
function $2fa92ec193801792$var$asNumber(e) {
    return $2fa92ec193801792$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function $2fa92ec193801792$var$__PRIVATE_coercedFieldValuesArray(e) {
    return $2fa92ec193801792$var$isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $2fa92ec193801792$var$FieldTransform {
    constructor(e, t){
        this.field = e, this.transform = t;
    }
}
function $2fa92ec193801792$var$__PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof $2fa92ec193801792$var$__PRIVATE_ArrayUnionTransformOperation && t instanceof $2fa92ec193801792$var$__PRIVATE_ArrayUnionTransformOperation || e instanceof $2fa92ec193801792$var$__PRIVATE_ArrayRemoveTransformOperation && t instanceof $2fa92ec193801792$var$__PRIVATE_ArrayRemoveTransformOperation ? $2fa92ec193801792$var$__PRIVATE_arrayEquals(e.elements, t.elements, $2fa92ec193801792$var$__PRIVATE_valueEquals$1) : e instanceof $2fa92ec193801792$var$__PRIVATE_NumericIncrementTransformOperation && t instanceof $2fa92ec193801792$var$__PRIVATE_NumericIncrementTransformOperation || e instanceof $2fa92ec193801792$var$__PRIVATE_NumericMinimumTransformOperation && t instanceof $2fa92ec193801792$var$__PRIVATE_NumericMinimumTransformOperation || e instanceof $2fa92ec193801792$var$__PRIVATE_NumericMaximumTransformOperation && t instanceof $2fa92ec193801792$var$__PRIVATE_NumericMaximumTransformOperation ? $2fa92ec193801792$var$__PRIVATE_valueEquals$1(e.l, t.l) : e instanceof $2fa92ec193801792$var$__PRIVATE_ServerTimestampTransform && t instanceof $2fa92ec193801792$var$__PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}
/** The result of successfully applying a mutation to the backend. */ class $2fa92ec193801792$var$MutationResult {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ e, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ t){
        this.version = e, this.transformResults = t;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $2fa92ec193801792$export$56c0d5a1e737357d {
    constructor(e, t){
        this.updateTime = e, this.exists = t;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new $2fa92ec193801792$export$56c0d5a1e737357d;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(e) {
        return new $2fa92ec193801792$export$56c0d5a1e737357d(void 0, e);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(e) {
        return new $2fa92ec193801792$export$56c0d5a1e737357d(e);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(e) {
        return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
    }
}
/** Returns true if the preconditions is valid for the given document. */ function $2fa92ec193801792$var$__PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $2fa92ec193801792$var$Mutation {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $2fa92ec193801792$var$__PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === t) return e.isNoDocument() ? new $2fa92ec193801792$export$4a5767248b18ef41(e.key, $2fa92ec193801792$export$56c0d5a1e737357d.none()) : new $2fa92ec193801792$var$__PRIVATE_SetMutation(e.key, e.data, $2fa92ec193801792$export$56c0d5a1e737357d.none());
    {
        const n = e.data, r = $2fa92ec193801792$export$c4ce752e73470fba.empty();
        let i = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$export$b9a6b53f9be3734.comparator);
        for (let e of t.fields)if (!i.has(e)) {
            let t = n.field(e);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === t && e.length > 1 && (e = e.popLast(), t = n.field(e)), null === t ? r.delete(e) : r.set(e, t), i = i.add(e);
        }
        return new $2fa92ec193801792$var$__PRIVATE_PatchMutation(e.key, r, new $2fa92ec193801792$var$FieldMask(i.toArray()), $2fa92ec193801792$export$56c0d5a1e737357d.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $2fa92ec193801792$var$__PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof $2fa92ec193801792$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const r = e.value.clone(), i = $2fa92ec193801792$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof $2fa92ec193801792$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!$2fa92ec193801792$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        const r = $2fa92ec193801792$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll($2fa92ec193801792$var$__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $2fa92ec193801792$var$__PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof $2fa92ec193801792$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!$2fa92ec193801792$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = e.value.clone(), s = $2fa92ec193801792$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(e, t, n, r) : e instanceof $2fa92ec193801792$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!$2fa92ec193801792$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        const i = $2fa92ec193801792$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll($2fa92ec193801792$var$__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map((e)=>e.field));
    }(e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if ($2fa92ec193801792$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), null;
        return n;
    }(e, t, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $2fa92ec193801792$var$__PRIVATE_mutationExtractBaseValue(e, t) {
    let n = null;
    for (const r of e.fieldTransforms){
        const e = t.data.field(r.field), i = $2fa92ec193801792$var$__PRIVATE_computeTransformOperationBaseValue(r.transform, e || null);
        null != i && (null === n && (n = $2fa92ec193801792$export$c4ce752e73470fba.empty()), n.set(r.field, i));
    }
    return n || null;
}
function $2fa92ec193801792$var$__PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && $2fa92ec193801792$var$__PRIVATE_arrayEquals(e, t, (e, t)=>$2fa92ec193801792$var$__PRIVATE_fieldTransformEquals(e, t));
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */  === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */  !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $2fa92ec193801792$var$__PRIVATE_SetMutation extends $2fa92ec193801792$var$Mutation {
    constructor(e, t, n, r = []){
        super(), this.key = e, this.value = t, this.precondition = n, this.fieldTransforms = r, this.type = 0 /* MutationType.Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
class $2fa92ec193801792$var$__PRIVATE_PatchMutation extends $2fa92ec193801792$var$Mutation {
    constructor(e, t, n, r, i = []){
        super(), this.key = e, this.data = t, this.fieldMask = n, this.precondition = r, this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
function $2fa92ec193801792$var$__PRIVATE_getPatch(e) {
    const t = new Map;
    return e.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const r = e.data.field(n);
            t.set(n, r);
        }
    }), t;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $2fa92ec193801792$var$__PRIVATE_serverTransformResults(e, t, n) {
    const r = new Map;
    $2fa92ec193801792$var$__PRIVATE_hardAssert(e.length === n.length, 32656, {
        h: n.length,
        T: e.length
    });
    for(let i = 0; i < n.length; i++){
        const s = e[i], _ = s.transform, o = t.data.field(s.field);
        r.set(s.field, $2fa92ec193801792$var$__PRIVATE_applyTransformOperationToRemoteDocument(_, o, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $2fa92ec193801792$var$__PRIVATE_localTransformResults(e, t, n) {
    const r = new Map;
    for (const i of e){
        const e = i.transform, s = n.data.field(i.field);
        r.set(i.field, $2fa92ec193801792$var$__PRIVATE_applyTransformOperationToLocalView(e, s, t));
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ class $2fa92ec193801792$export$4a5767248b18ef41 extends $2fa92ec193801792$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 2 /* MutationType.Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
class $2fa92ec193801792$var$__PRIVATE_VerifyMutation extends $2fa92ec193801792$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 3 /* MutationType.Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ class $2fa92ec193801792$export$3a6d5c9ae78a2c08 {
    constructor(e, t, n){
        this.alias = e, this.aggregateType = t, this.fieldPath = n;
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class $2fa92ec193801792$export$3b513254972cfc9c {
    constructor(e, t){
        this.position = e, this.inclusive = t;
    }
}
function $2fa92ec193801792$var$__PRIVATE_boundCompareToDocument(e, t, n) {
    let r = 0;
    for(let i = 0; i < e.position.length; i++){
        const s = t[i], _ = e.position[i];
        if (s.field.isKeyField()) r = $2fa92ec193801792$export$a07804094c3ecf2d.comparator($2fa92ec193801792$export$a07804094c3ecf2d.fromName(_.referenceValue), n.key);
        else r = $2fa92ec193801792$var$__PRIVATE_valueCompare(_, n.data.field(s.field));
        if ("desc" /* Direction.DESCENDING */  === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $2fa92ec193801792$var$__PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return false;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return false;
    for(let n = 0; n < e.position.length; n++){
        if (!$2fa92ec193801792$var$__PRIVATE_valueEquals$1(e.position[n], t.position[n])) return false;
    }
    return true;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$var$Filter {
}
class $2fa92ec193801792$export$d66501df72047452 extends $2fa92ec193801792$var$Filter {
    constructor(e, t, n){
        super(), this.field = e, this.op = t, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t, n) {
        return e.isKeyField() ? "in" /* Operator.IN */  === t || "not-in" /* Operator.NOT_IN */  === t ? this.createKeyFieldInFilter(e, t, n) : new $2fa92ec193801792$var$__PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === t ? new $2fa92ec193801792$var$__PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */  === t ? new $2fa92ec193801792$var$__PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */  === t ? new $2fa92ec193801792$var$__PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t ? new $2fa92ec193801792$var$__PRIVATE_ArrayContainsAnyFilter(e, n) : new $2fa92ec193801792$export$d66501df72047452(e, t, n);
    }
    static createKeyFieldInFilter(e, t, n) {
        return "in" /* Operator.IN */  === t ? new $2fa92ec193801792$var$__PRIVATE_KeyFieldInFilter(e, n) : new $2fa92ec193801792$var$__PRIVATE_KeyFieldNotInFilter(e, n);
    }
    matches(e) {
        const t = e.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== t && void 0 === t.nullValue && this.matchesComparison($2fa92ec193801792$var$__PRIVATE_valueCompare(t, this.value)) : null !== t && $2fa92ec193801792$var$__PRIVATE_typeOrder(this.value) === $2fa92ec193801792$var$__PRIVATE_typeOrder(t) && this.matchesComparison($2fa92ec193801792$var$__PRIVATE_valueCompare(t, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    matchesComparison(e) {
        switch(this.op){
            case "<" /* Operator.LESS_THAN */ :
                return e < 0;
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return e <= 0;
            case "==" /* Operator.EQUAL */ :
                return 0 === e;
            case "!=" /* Operator.NOT_EQUAL */ :
                return 0 !== e;
            case ">" /* Operator.GREATER_THAN */ :
                return e > 0;
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return e >= 0;
            default:
                return $2fa92ec193801792$export$1a82df3d29112e01(47266, {
                    operator: this.op
                });
        }
    }
    isInequality() {
        return [
            "<" /* Operator.LESS_THAN */ ,
            "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
            ">" /* Operator.GREATER_THAN */ ,
            ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
            "!=" /* Operator.NOT_EQUAL */ ,
            "not-in" /* Operator.NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [
            this
        ];
    }
    getFilters() {
        return [
            this
        ];
    }
}
class $2fa92ec193801792$export$e7094788287c5e9b extends $2fa92ec193801792$var$Filter {
    constructor(e, t){
        super(), this.filters = e, this.op = t, this.P = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t) {
        return new $2fa92ec193801792$export$e7094788287c5e9b(e, t);
    }
    matches(e) {
        return $2fa92ec193801792$var$__PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find((t)=>!t.matches(e)) : void 0 !== this.filters.find((t)=>t.matches(e));
    }
    getFlattenedFilters() {
        return null !== this.P || (this.P = this.filters.reduce((e, t)=>e.concat(t.getFlattenedFilters()), [])), this.P;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
}
function $2fa92ec193801792$var$__PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */  === e.op;
}
function $2fa92ec193801792$var$__PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */  === e.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function $2fa92ec193801792$var$__PRIVATE_compositeFilterIsFlatConjunction(e) {
    return $2fa92ec193801792$var$__PRIVATE_compositeFilterIsFlat(e) && $2fa92ec193801792$var$__PRIVATE_compositeFilterIsConjunction(e);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function $2fa92ec193801792$var$__PRIVATE_compositeFilterIsFlat(e) {
    for (const t of e.filters)if (t instanceof $2fa92ec193801792$export$e7094788287c5e9b) return false;
    return true;
}
function $2fa92ec193801792$var$__PRIVATE_canonifyFilter(e) {
    if (e instanceof $2fa92ec193801792$export$d66501df72047452) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + $2fa92ec193801792$var$canonicalId(e.value);
    if ($2fa92ec193801792$var$__PRIVATE_compositeFilterIsFlatConjunction(e)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map((e)=>$2fa92ec193801792$var$__PRIVATE_canonifyFilter(e)).join(",");
    {
        // filter instanceof CompositeFilter
        const t = e.filters.map((e)=>$2fa92ec193801792$var$__PRIVATE_canonifyFilter(e)).join(",");
        return `${e.op}(${t})`;
    }
}
function $2fa92ec193801792$var$__PRIVATE_filterEquals(e, t) {
    return e instanceof $2fa92ec193801792$export$d66501df72047452 ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof $2fa92ec193801792$export$d66501df72047452 && e.op === t.op && e.field.isEqual(t.field) && $2fa92ec193801792$var$__PRIVATE_valueEquals$1(e.value, t.value);
    }(e, t) : e instanceof $2fa92ec193801792$export$e7094788287c5e9b ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof $2fa92ec193801792$export$e7094788287c5e9b && e.op === t.op && e.filters.length === t.filters.length) return e.filters.reduce((e, n, r)=>e && $2fa92ec193801792$var$__PRIVATE_filterEquals(n, t.filters[r]), true);
        return false;
    }(e, t) : void $2fa92ec193801792$export$1a82df3d29112e01(19439);
}
function $2fa92ec193801792$var$__PRIVATE_compositeFilterWithAddedFilters(e, t) {
    const n = e.filters.concat(t);
    return $2fa92ec193801792$export$e7094788287c5e9b.create(n, e.op);
}
/** Returns a debug description for `filter`. */ function $2fa92ec193801792$var$__PRIVATE_stringifyFilter(e) {
    return e instanceof $2fa92ec193801792$export$d66501df72047452 ? function __PRIVATE_stringifyFieldFilter(e) {
        return `${e.field.canonicalString()} ${e.op} ${$2fa92ec193801792$var$canonicalId(e.value)}`;
    }(e) : e instanceof $2fa92ec193801792$export$e7094788287c5e9b ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map($2fa92ec193801792$var$__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}
class $2fa92ec193801792$var$__PRIVATE_KeyFieldFilter extends $2fa92ec193801792$export$d66501df72047452 {
    constructor(e, t, n){
        super(e, t, n), this.key = $2fa92ec193801792$export$a07804094c3ecf2d.fromName(n.referenceValue);
    }
    matches(e) {
        const t = $2fa92ec193801792$export$a07804094c3ecf2d.comparator(e.key, this.key);
        return this.matchesComparison(t);
    }
}
/** Filter that matches on key fields within an array. */ class $2fa92ec193801792$var$__PRIVATE_KeyFieldInFilter extends $2fa92ec193801792$export$d66501df72047452 {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t), this.keys = $2fa92ec193801792$var$__PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
    }
    matches(e) {
        return this.keys.some((t)=>t.isEqual(e.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class $2fa92ec193801792$var$__PRIVATE_KeyFieldNotInFilter extends $2fa92ec193801792$export$d66501df72047452 {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t), this.keys = $2fa92ec193801792$var$__PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        return !this.keys.some((t)=>t.isEqual(e.key));
    }
}
function $2fa92ec193801792$var$__PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    return (t.arrayValue?.values || []).map((e)=>$2fa92ec193801792$export$a07804094c3ecf2d.fromName(e.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $2fa92ec193801792$var$__PRIVATE_ArrayContainsFilter extends $2fa92ec193801792$export$d66501df72047452 {
    constructor(e, t){
        super(e, "array-contains" /* Operator.ARRAY_CONTAINS */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return $2fa92ec193801792$var$isArray(t) && $2fa92ec193801792$var$__PRIVATE_arrayValueContains(t.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class $2fa92ec193801792$var$__PRIVATE_InFilter extends $2fa92ec193801792$export$d66501df72047452 {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return null !== t && $2fa92ec193801792$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the not-in operator. */ class $2fa92ec193801792$var$__PRIVATE_NotInFilter extends $2fa92ec193801792$export$d66501df72047452 {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        if ($2fa92ec193801792$var$__PRIVATE_arrayValueContains(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return false;
        const t = e.data.field(this.field);
        return null !== t && void 0 === t.nullValue && !$2fa92ec193801792$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $2fa92ec193801792$var$__PRIVATE_ArrayContainsAnyFilter extends $2fa92ec193801792$export$d66501df72047452 {
    constructor(e, t){
        super(e, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return !(!$2fa92ec193801792$var$isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some((e)=>$2fa92ec193801792$var$__PRIVATE_arrayValueContains(this.value.arrayValue, e));
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $2fa92ec193801792$export$23f2a1d2818174ef {
    constructor(e, t = "asc" /* Direction.ASCENDING */ ){
        this.field = e, this.dir = t;
    }
}
function $2fa92ec193801792$var$__PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $2fa92ec193801792$var$SnapshotVersion {
    static fromTimestamp(e) {
        return new $2fa92ec193801792$var$SnapshotVersion(e);
    }
    static min() {
        return new $2fa92ec193801792$var$SnapshotVersion(new $2fa92ec193801792$export$890c4ad488842ce7(0, 0));
    }
    static max() {
        return new $2fa92ec193801792$var$SnapshotVersion(new $2fa92ec193801792$export$890c4ad488842ce7(253402300799, 999999999));
    }
    constructor(e){
        this.timestamp = e;
    }
    compareTo(e) {
        return this.timestamp._compareTo(e.timestamp);
    }
    isEqual(e) {
        return this.timestamp.isEqual(e.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $2fa92ec193801792$var$MutableDocument {
    constructor(e, t, n, r, i, s, _){
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = s, this.documentState = _;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(e) {
        return new $2fa92ec193801792$var$MutableDocument(e, 0 /* DocumentType.INVALID */ , /* version */ $2fa92ec193801792$var$SnapshotVersion.min(), /* readTime */ $2fa92ec193801792$var$SnapshotVersion.min(), /* createTime */ $2fa92ec193801792$var$SnapshotVersion.min(), $2fa92ec193801792$export$c4ce752e73470fba.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(e, t, n, r) {
        return new $2fa92ec193801792$var$MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ t, /* readTime */ $2fa92ec193801792$var$SnapshotVersion.min(), /* createTime */ n, r, 0 /* DocumentState.SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(e, t) {
        return new $2fa92ec193801792$var$MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ t, /* readTime */ $2fa92ec193801792$var$SnapshotVersion.min(), /* createTime */ $2fa92ec193801792$var$SnapshotVersion.min(), $2fa92ec193801792$export$c4ce752e73470fba.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(e, t) {
        return new $2fa92ec193801792$var$MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ t, /* readTime */ $2fa92ec193801792$var$SnapshotVersion.min(), /* createTime */ $2fa92ec193801792$var$SnapshotVersion.min(), $2fa92ec193801792$export$c4ce752e73470fba.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(e, t) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual($2fa92ec193801792$var$SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = e), this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(e) {
        return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = $2fa92ec193801792$export$c4ce752e73470fba.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(e) {
        return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = $2fa92ec193801792$export$c4ce752e73470fba.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = $2fa92ec193801792$var$SnapshotVersion.min(), this;
    }
    setReadTime(e) {
        return this.readTime = e, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(e) {
        return e instanceof $2fa92ec193801792$var$MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
    }
    mutableCopy() {
        return new $2fa92ec193801792$var$MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ const $2fa92ec193801792$var$Xe = -1;
/**
 * The initial sequence number for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class $2fa92ec193801792$export$4c3d22f3d993c33f {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ e, /** The collection ID this index applies to. */ t, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ r){
        this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $2fa92ec193801792$var$__PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find((e)=>2 /* IndexKind.CONTAINS */  === e.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function $2fa92ec193801792$var$__PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter((e)=>2 /* IndexKind.CONTAINS */  !== e.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function $2fa92ec193801792$var$__PRIVATE_fieldIndexSemanticComparator(e, t) {
    let n = $2fa92ec193801792$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for(let r = 0; r < Math.min(e.fields.length, t.fields.length); ++r)if (n = $2fa92ec193801792$var$__PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 0 !== n) return n;
    return $2fa92ec193801792$var$__PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}
/** Returns a debug representation of the field index */ $2fa92ec193801792$export$4c3d22f3d993c33f.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class $2fa92ec193801792$export$2219238a014317b0 {
    constructor(/** The field path of the component. */ e, /** The fields sorting order. */ t){
        this.fieldPath = e, this.kind = t;
    }
}
function $2fa92ec193801792$var$__PRIVATE_indexSegmentComparator(e, t) {
    const n = $2fa92ec193801792$export$b9a6b53f9be3734.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : $2fa92ec193801792$var$__PRIVATE_primitiveComparator(e.kind, t.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class $2fa92ec193801792$export$f787f51d84a910ad {
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ e, /** The the latest indexed read time, document and batch id. */ t){
        this.sequenceNumber = e, this.offset = t;
    }
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new $2fa92ec193801792$export$f787f51d84a910ad(0, $2fa92ec193801792$var$IndexOffset.min());
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $2fa92ec193801792$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = $2fa92ec193801792$var$SnapshotVersion.fromTimestamp(1e9 === r ? new $2fa92ec193801792$export$890c4ad488842ce7(n + 1, 0) : new $2fa92ec193801792$export$890c4ad488842ce7(n, r));
    return new $2fa92ec193801792$var$IndexOffset(i, $2fa92ec193801792$export$a07804094c3ecf2d.empty(), t);
}
/** Creates a new offset based on the provided document. */ function $2fa92ec193801792$var$__PRIVATE_newIndexOffsetFromDocument(e) {
    return new $2fa92ec193801792$var$IndexOffset(e.readTime, e.key, $2fa92ec193801792$var$Xe);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class $2fa92ec193801792$var$IndexOffset {
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ e, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ t, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new $2fa92ec193801792$var$IndexOffset($2fa92ec193801792$var$SnapshotVersion.min(), $2fa92ec193801792$export$a07804094c3ecf2d.empty(), $2fa92ec193801792$var$Xe);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new $2fa92ec193801792$var$IndexOffset($2fa92ec193801792$var$SnapshotVersion.max(), $2fa92ec193801792$export$a07804094c3ecf2d.empty(), $2fa92ec193801792$var$Xe);
    }
}
function $2fa92ec193801792$var$__PRIVATE_indexOffsetComparator(e, t) {
    let n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = $2fa92ec193801792$export$a07804094c3ecf2d.comparator(e.documentKey, t.documentKey), 0 !== n ? n : $2fa92ec193801792$var$__PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $2fa92ec193801792$var$__PRIVATE_TargetImpl {
    constructor(e, t = null, n = [], r = [], i = null, s = null, _ = null){
        this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = s, this.endAt = _, this.R = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $2fa92ec193801792$var$__PRIVATE_newTarget(e, t = null, n = [], r = [], i = null, s = null, _ = null) {
    return new $2fa92ec193801792$var$__PRIVATE_TargetImpl(e, t, n, r, i, s, _);
}
function $2fa92ec193801792$var$__PRIVATE_canonifyTarget(e) {
    const t = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    if (null === t.R) {
        let e = t.path.canonicalString();
        null !== t.collectionGroup && (e += "|cg:" + t.collectionGroup), e += "|f:", e += t.filters.map((e)=>$2fa92ec193801792$var$__PRIVATE_canonifyFilter(e)).join(","), e += "|ob:", e += t.orderBy.map((e)=>(function __PRIVATE_canonifyOrderBy(e) {
                // TODO(b/29183165): Make this collision robust.
                return e.field.canonicalString() + e.dir;
            })(e)).join(","), $2fa92ec193801792$var$__PRIVATE_isNullOrUndefined(t.limit) || (e += "|l:", e += t.limit), t.startAt && (e += "|lb:", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((e)=>$2fa92ec193801792$var$canonicalId(e)).join(",")), t.endAt && (e += "|ub:", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((e)=>$2fa92ec193801792$var$canonicalId(e)).join(",")), t.R = e;
    }
    return t.R;
}
function $2fa92ec193801792$var$__PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return false;
    if (e.orderBy.length !== t.orderBy.length) return false;
    for(let n = 0; n < e.orderBy.length; n++)if (!$2fa92ec193801792$var$__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return false;
    if (e.filters.length !== t.filters.length) return false;
    for(let n = 0; n < e.filters.length; n++)if (!$2fa92ec193801792$var$__PRIVATE_filterEquals(e.filters[n], t.filters[n])) return false;
    return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!$2fa92ec193801792$var$__PRIVATE_boundEquals(e.startAt, t.startAt) && $2fa92ec193801792$var$__PRIVATE_boundEquals(e.endAt, t.endAt);
}
function $2fa92ec193801792$var$__PRIVATE_targetIsPipelineTarget(e) {
    // Workaround for circular dependency
    return !!e.isCorePipeline;
}
function $2fa92ec193801792$var$__PRIVATE_targetIsDocumentTarget(e) {
    return !!e.path && $2fa92ec193801792$export$a07804094c3ecf2d.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/** Returns the field filters that target the given field path. */ function $2fa92ec193801792$var$__PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter((e)=>e instanceof $2fa92ec193801792$export$d66501df72047452 && e.field.isEqual(t));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $2fa92ec193801792$var$__PRIVATE_targetGetAscendingBound(e, t, n) {
    let r = $2fa92ec193801792$var$He, i = true;
    // Process all filters to find a value for the current field segment
    for (const n of $2fa92ec193801792$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $2fa92ec193801792$var$He, t = true;
        switch(n.op){
            case "<" /* Operator.LESS_THAN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = $2fa92ec193801792$var$__PRIVATE_valuesGetLowerBound(n.value);
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case ">" /* Operator.GREATER_THAN */ :
                e = n.value, t = false;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $2fa92ec193801792$var$He;
        }
        $2fa92ec193801792$var$__PRIVATE_lowerBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) < 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $2fa92ec193801792$var$__PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) < 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $2fa92ec193801792$var$__PRIVATE_targetGetDescendingBound(e, t, n) {
    let r = $2fa92ec193801792$var$Ge, i = true;
    // Process all filters to find a value for the current field segment
    for (const n of $2fa92ec193801792$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $2fa92ec193801792$var$Ge, t = true;
        switch(n.op){
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            case ">" /* Operator.GREATER_THAN */ :
                e = $2fa92ec193801792$var$__PRIVATE_valuesGetUpperBound(n.value), t = false;
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case "<" /* Operator.LESS_THAN */ :
                e = n.value, t = false;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $2fa92ec193801792$var$Ge;
        }
        $2fa92ec193801792$var$__PRIVATE_upperBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) > 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $2fa92ec193801792$var$__PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) > 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $2fa92ec193801792$var$__PRIVATE_QueryImpl {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(e, t = null, n = [], r = [], i = null, s = "F" /* LimitType.First */ , _ = null, o = null){
        this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = s, this.startAt = _, this.endAt = o, this.I = null, // The corresponding `Target` of this `Query` instance, for use with
        // non-aggregate queries.
        this.A = null, // The corresponding `Target` of this `Query` instance, for use with
        // aggregate queries. Unlike targets for non-aggregate queries,
        // aggregate query targets do not contain normalized order-bys, they only
        // contain explicit order-bys.
        this.V = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function $2fa92ec193801792$var$__PRIVATE_newQuery(e, t, n, r, i, s, _, o) {
    return new $2fa92ec193801792$var$__PRIVATE_QueryImpl(e, t, n, r, i, s, _, o);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $2fa92ec193801792$export$3c2fa207a37baaea(e) {
    return new $2fa92ec193801792$var$__PRIVATE_QueryImpl(e);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $2fa92ec193801792$var$__PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}
// Returns the sorted set of inequality filter fields used in this query.
/**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ function $2fa92ec193801792$var$__PRIVATE_isDocumentQuery$1(e) {
    return $2fa92ec193801792$export$a07804094c3ecf2d.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $2fa92ec193801792$export$21579262ef46735b(e) {
    return null !== e.collectionGroup;
}
/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function $2fa92ec193801792$export$ee7c8ad385a60b7b(e) {
    const t = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    if (null === t.I) {
        t.I = [];
        const e = new Set;
        // Any explicit order by fields should be added as is.
        for (const n of t.explicitOrderBy)t.I.push(n), e.add(n.field.canonicalString());
        // The order of the implicit ordering always matches the last explicit order by.
        const n = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ , r = function __PRIVATE_getInequalityFilterFields(e) {
            let t = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$export$b9a6b53f9be3734.comparator);
            return e.filters.forEach((e)=>{
                e.getFlattenedFilters().forEach((e)=>{
                    e.isInequality() && (t = t.add(e.field));
                });
            }), t;
        }(t);
        // Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
        // order. When there are multiple inequality filters on the same field, the field should be added
        // only once.
        // Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
        // field to be sorted last.
        r.forEach((r)=>{
            e.has(r.canonicalString()) || r.isKeyField() || t.I.push(new $2fa92ec193801792$export$23f2a1d2818174ef(r, n));
        }), // Add the document key field to the last if it is not explicitly ordered.
        e.has($2fa92ec193801792$export$b9a6b53f9be3734.keyField().canonicalString()) || t.I.push(new $2fa92ec193801792$export$23f2a1d2818174ef($2fa92ec193801792$export$b9a6b53f9be3734.keyField(), n));
    }
    return t.I;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function $2fa92ec193801792$var$__PRIVATE_queryToTarget(e) {
    const t = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    return t.A || (t.A = $2fa92ec193801792$var$__PRIVATE__queryToTarget(t, $2fa92ec193801792$export$ee7c8ad385a60b7b(e))), t.A;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function $2fa92ec193801792$var$__PRIVATE_queryToAggregateTarget(e) {
    const t = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    return t.V || // Do not include implicit order-bys for aggregate queries.
    (t.V = $2fa92ec193801792$var$__PRIVATE__queryToTarget(t, e.explicitOrderBy)), t.V;
}
function $2fa92ec193801792$var$__PRIVATE__queryToTarget(e, t) {
    if ("F" /* LimitType.First */  === e.limitType) return $2fa92ec193801792$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
    {
        // Flip the orderBy directions since we want the last results
        t = t.map((e)=>{
            const t = "desc" /* Direction.DESCENDING */  === e.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
            return new $2fa92ec193801792$export$23f2a1d2818174ef(e.field, t);
        });
        // We need to swap the cursors to match the now-flipped query ordering.
        const n = e.endAt ? new $2fa92ec193801792$export$3b513254972cfc9c(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new $2fa92ec193801792$export$3b513254972cfc9c(e.startAt.position, e.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return $2fa92ec193801792$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
    }
}
function $2fa92ec193801792$export$f1e1789686576879(e, t) {
    const n = e.filters.concat([
        t
    ]);
    return new $2fa92ec193801792$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function $2fa92ec193801792$export$35e795649ee09318(e, t) {
    // TODO(dimond): validate that orderBy does not list the same key twice.
    const n = e.explicitOrderBy.concat([
        t
    ]);
    return new $2fa92ec193801792$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
}
function $2fa92ec193801792$export$dda1d9f60106f0e9(e, t, n) {
    return new $2fa92ec193801792$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function $2fa92ec193801792$export$9e5f44173e64f162(e, t) {
    return new $2fa92ec193801792$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
}
function $2fa92ec193801792$export$2d1720544b23b823(e, t) {
    return new $2fa92ec193801792$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
}
function $2fa92ec193801792$var$__PRIVATE_queryEquals(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_targetEquals($2fa92ec193801792$var$__PRIVATE_queryToTarget(e), $2fa92ec193801792$var$__PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $2fa92ec193801792$var$__PRIVATE_stringifyQuery(e) {
    return `Query(target=${function __PRIVATE_stringifyTarget(e) {
        let t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += `, filters: [${e.filters.map((e)=>$2fa92ec193801792$var$__PRIVATE_stringifyFilter(e)).join(", ")}]`), $2fa92ec193801792$var$__PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += `, orderBy: [${e.orderBy.map((e)=>(function __PRIVATE_stringifyOrderBy(e) {
                return `${e.field.canonicalString()} (${e.dir})`;
            })(e)).join(", ")}]`), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((e)=>$2fa92ec193801792$var$canonicalId(e)).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((e)=>$2fa92ec193801792$var$canonicalId(e)).join(",")), `Target(${t})`;
    }($2fa92ec193801792$var$__PRIVATE_queryToTarget(e))}; limitType=${e.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function $2fa92ec193801792$var$__PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        const n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : $2fa92ec193801792$export$a07804094c3ecf2d.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }(e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        // We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
        // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
        // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
        // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
        // A document with content of {b:1} matches the filters, but does not match the orderBy because
        // it's missing the field 'a'.
        for (const n of $2fa92ec193801792$export$ee7c8ad385a60b7b(e))// order-by key always matches
        if (!n.field.isKeyField() && null === t.data.field(n.field)) return false;
        return true;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        for (const n of e.filters)if (!n.matches(t)) return false;
        return true;
    }(e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            const r = $2fa92ec193801792$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, $2fa92ec193801792$export$ee7c8ad385a60b7b(e), t)) return false;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            const r = $2fa92ec193801792$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, $2fa92ec193801792$export$ee7c8ad385a60b7b(e), t)) return false;
        return true;
    }(e, t);
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $2fa92ec193801792$export$7ccc53e8f1e7dfc5(e) {
    return (t, n)=>{
        let r = false;
        for (const i of $2fa92ec193801792$export$ee7c8ad385a60b7b(e)){
            const e = $2fa92ec193801792$var$__PRIVATE_compareDocs(i, t, n);
            if (0 !== e) return e;
            r = r || i.field.isKeyField();
        }
        return 0;
    };
}
function $2fa92ec193801792$var$__PRIVATE_compareDocs(e, t, n) {
    const r = e.field.isKeyField() ? $2fa92ec193801792$export$a07804094c3ecf2d.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        const r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? $2fa92ec193801792$var$__PRIVATE_valueCompare(r, i) : $2fa92ec193801792$export$1a82df3d29112e01(42886);
    }(e.field, t, n);
    switch(e.dir){
        case "asc" /* Direction.ASCENDING */ :
            return r;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * r;
        default:
            return $2fa92ec193801792$export$1a82df3d29112e01(19790, {
                direction: e.dir
            });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$var$ExistenceFilter {
    constructor(e, t){
        this.count = e, this.unchangedNames = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $2fa92ec193801792$var$et, $2fa92ec193801792$var$tt;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $2fa92ec193801792$var$__PRIVATE_isPermanentError(e) {
    switch(e){
        case $2fa92ec193801792$export$db3b6bfb95261072.OK:
            return $2fa92ec193801792$export$1a82df3d29112e01(64938);
        case $2fa92ec193801792$export$db3b6bfb95261072.CANCELLED:
        case $2fa92ec193801792$export$db3b6bfb95261072.UNKNOWN:
        case $2fa92ec193801792$export$db3b6bfb95261072.DEADLINE_EXCEEDED:
        case $2fa92ec193801792$export$db3b6bfb95261072.RESOURCE_EXHAUSTED:
        case $2fa92ec193801792$export$db3b6bfb95261072.INTERNAL:
        case $2fa92ec193801792$export$db3b6bfb95261072.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $2fa92ec193801792$export$db3b6bfb95261072.UNAUTHENTICATED:
            return false;
        case $2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT:
        case $2fa92ec193801792$export$db3b6bfb95261072.NOT_FOUND:
        case $2fa92ec193801792$export$db3b6bfb95261072.ALREADY_EXISTS:
        case $2fa92ec193801792$export$db3b6bfb95261072.PERMISSION_DENIED:
        case $2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependent on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $2fa92ec193801792$export$db3b6bfb95261072.ABORTED:
        case $2fa92ec193801792$export$db3b6bfb95261072.OUT_OF_RANGE:
        case $2fa92ec193801792$export$db3b6bfb95261072.UNIMPLEMENTED:
        case $2fa92ec193801792$export$db3b6bfb95261072.DATA_LOSS:
            return true;
        default:
            return $2fa92ec193801792$export$1a82df3d29112e01(15467, {
                code: e
            });
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $2fa92ec193801792$var$__PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $2fa92ec193801792$var$__PRIVATE_logError("GRPC error has no .code"), $2fa92ec193801792$export$db3b6bfb95261072.UNKNOWN;
    switch(e){
        case $2fa92ec193801792$var$et.OK:
            return $2fa92ec193801792$export$db3b6bfb95261072.OK;
        case $2fa92ec193801792$var$et.CANCELLED:
            return $2fa92ec193801792$export$db3b6bfb95261072.CANCELLED;
        case $2fa92ec193801792$var$et.UNKNOWN:
            return $2fa92ec193801792$export$db3b6bfb95261072.UNKNOWN;
        case $2fa92ec193801792$var$et.DEADLINE_EXCEEDED:
            return $2fa92ec193801792$export$db3b6bfb95261072.DEADLINE_EXCEEDED;
        case $2fa92ec193801792$var$et.RESOURCE_EXHAUSTED:
            return $2fa92ec193801792$export$db3b6bfb95261072.RESOURCE_EXHAUSTED;
        case $2fa92ec193801792$var$et.INTERNAL:
            return $2fa92ec193801792$export$db3b6bfb95261072.INTERNAL;
        case $2fa92ec193801792$var$et.UNAVAILABLE:
            return $2fa92ec193801792$export$db3b6bfb95261072.UNAVAILABLE;
        case $2fa92ec193801792$var$et.UNAUTHENTICATED:
            return $2fa92ec193801792$export$db3b6bfb95261072.UNAUTHENTICATED;
        case $2fa92ec193801792$var$et.INVALID_ARGUMENT:
            return $2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT;
        case $2fa92ec193801792$var$et.NOT_FOUND:
            return $2fa92ec193801792$export$db3b6bfb95261072.NOT_FOUND;
        case $2fa92ec193801792$var$et.ALREADY_EXISTS:
            return $2fa92ec193801792$export$db3b6bfb95261072.ALREADY_EXISTS;
        case $2fa92ec193801792$var$et.PERMISSION_DENIED:
            return $2fa92ec193801792$export$db3b6bfb95261072.PERMISSION_DENIED;
        case $2fa92ec193801792$var$et.FAILED_PRECONDITION:
            return $2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION;
        case $2fa92ec193801792$var$et.ABORTED:
            return $2fa92ec193801792$export$db3b6bfb95261072.ABORTED;
        case $2fa92ec193801792$var$et.OUT_OF_RANGE:
            return $2fa92ec193801792$export$db3b6bfb95261072.OUT_OF_RANGE;
        case $2fa92ec193801792$var$et.UNIMPLEMENTED:
            return $2fa92ec193801792$export$db3b6bfb95261072.UNIMPLEMENTED;
        case $2fa92ec193801792$var$et.DATA_LOSS:
            return $2fa92ec193801792$export$db3b6bfb95261072.DATA_LOSS;
        default:
            return $2fa92ec193801792$export$1a82df3d29112e01(39323, {
                code: e
            });
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($2fa92ec193801792$var$tt = $2fa92ec193801792$var$et || ($2fa92ec193801792$var$et = {}))[$2fa92ec193801792$var$tt.OK = 0] = "OK", $2fa92ec193801792$var$tt[$2fa92ec193801792$var$tt.CANCELLED = 1] = "CANCELLED", $2fa92ec193801792$var$tt[$2fa92ec193801792$var$tt.UNKNOWN = 2] = "UNKNOWN", $2fa92ec193801792$var$tt[$2fa92ec193801792$var$tt.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $2fa92ec193801792$var$tt[$2fa92ec193801792$var$tt.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $2fa92ec193801792$var$tt[$2fa92ec193801792$var$tt.NOT_FOUND = 5] = "NOT_FOUND", $2fa92ec193801792$var$tt[$2fa92ec193801792$var$tt.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $2fa92ec193801792$var$tt[$2fa92ec193801792$var$tt.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $2fa92ec193801792$var$tt[$2fa92ec193801792$var$tt.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $2fa92ec193801792$var$tt[$2fa92ec193801792$var$tt.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $2fa92ec193801792$var$tt[$2fa92ec193801792$var$tt.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $2fa92ec193801792$var$tt[$2fa92ec193801792$var$tt.ABORTED = 10] = "ABORTED", $2fa92ec193801792$var$tt[$2fa92ec193801792$var$tt.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $2fa92ec193801792$var$tt[$2fa92ec193801792$var$tt.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $2fa92ec193801792$var$tt[$2fa92ec193801792$var$tt.INTERNAL = 13] = "INTERNAL", $2fa92ec193801792$var$tt[$2fa92ec193801792$var$tt.UNAVAILABLE = 14] = "UNAVAILABLE", $2fa92ec193801792$var$tt[$2fa92ec193801792$var$tt.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class $2fa92ec193801792$var$ObjectMap {
    constructor(e, t){
        this.mapKeyFn = e, this.equalsFn = t, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */ get(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 !== n) {
            for (const [t, r] of n)if (this.equalsFn(t, e)) return r;
        }
    }
    has(e) {
        return void 0 !== this.get(e);
    }
    /** Put this key and value in the map. */ set(e, t) {
        const n = this.mapKeyFn(e), r = this.inner[n];
        if (void 0 === r) return this.inner[n] = [
            [
                e,
                t
            ]
        ], void this.innerSize++;
        for(let n = 0; n < r.length; n++)if (this.equalsFn(r[n][0], e)) // This is updating an existing entry and does not increase `innerSize`.
        return void (r[n] = [
            e,
            t
        ]);
        r.push([
            e,
            t
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 === n) return false;
        for(let r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, true;
        return false;
    }
    forEach(e) {
        $2fa92ec193801792$var$forEach(this.inner, (t, n)=>{
            for (const [t, r] of n)e(t, r);
        });
    }
    isEmpty() {
        return $2fa92ec193801792$var$isEmpty(this.inner);
    }
    size() {
        return this.innerSize;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$nt = new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$export$a07804094c3ecf2d.comparator);
function $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap() {
    return $2fa92ec193801792$var$nt;
}
const $2fa92ec193801792$var$rt = new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$export$a07804094c3ecf2d.comparator);
function $2fa92ec193801792$var$documentMap(...e) {
    let t = $2fa92ec193801792$var$rt;
    for (const n of e)t = t.insert(n.key, n);
    return t;
}
function $2fa92ec193801792$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    let t = $2fa92ec193801792$var$rt;
    return e.forEach((e, n)=>t = t.insert(e, n.overlayedDocument)), t;
}
function $2fa92ec193801792$var$__PRIVATE_newOverlayMap() {
    return $2fa92ec193801792$var$__PRIVATE_newDocumentKeyMap();
}
function $2fa92ec193801792$var$__PRIVATE_newMutationMap() {
    return $2fa92ec193801792$var$__PRIVATE_newDocumentKeyMap();
}
function $2fa92ec193801792$var$__PRIVATE_newDocumentKeyMap() {
    return new $2fa92ec193801792$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
}
const $2fa92ec193801792$var$it = new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$export$a07804094c3ecf2d.comparator);
const $2fa92ec193801792$var$st = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$export$a07804094c3ecf2d.comparator);
function $2fa92ec193801792$export$a9c996f45e5784d0(...e) {
    let t = $2fa92ec193801792$var$st;
    for (const n of e)t = t.add(n);
    return t;
}
const $2fa92ec193801792$var$_t = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$var$__PRIVATE_primitiveComparator);
function $2fa92ec193801792$var$__PRIVATE_targetIdSet() {
    return $2fa92ec193801792$var$_t;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The global, singleton instance of TestingHooksSpi.
 *
 * This variable will be `null` in all cases _except_ when running from
 * integration tests that have registered callbacks to be notified of events
 * that happen during the test execution.
 */ let $2fa92ec193801792$var$ot = null;
/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance - the instance to set.
 */ function $2fa92ec193801792$export$306ddfe3a8403e2(e) {
    if ($2fa92ec193801792$var$ot) throw new Error("a TestingHooksSpi instance is already set");
    $2fa92ec193801792$var$ot = e;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function $2fa92ec193801792$var$__PRIVATE_newTextEncoder() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$at = new (0, $906344b47e605252$export$70ffa26850098d01)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function $2fa92ec193801792$var$__PRIVATE_getMd5HashValue(e) {
    const t = $2fa92ec193801792$var$__PRIVATE_newTextEncoder().encode(e), n = new (0, $906344b47e605252$export$9f5a3dfc7a9f5dd);
    return n.update(t), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function $2fa92ec193801792$var$__PRIVATE_get64BitUints(e) {
    const t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ true), r = t.getUint32(4, /* littleEndian= */ true), i = t.getUint32(8, /* littleEndian= */ true), s = t.getUint32(12, /* littleEndian= */ true);
    return [
        new (0, $906344b47e605252$export$70ffa26850098d01)([
            n,
            r
        ], 0),
        new (0, $906344b47e605252$export$70ffa26850098d01)([
            i,
            s
        ], 0)
    ];
}
class $2fa92ec193801792$var$BloomFilter {
    constructor(e, t, n){
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new $2fa92ec193801792$var$__PRIVATE_BloomFilterError(`Invalid padding: ${t}`);
        if (n < 0) throw new $2fa92ec193801792$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (e.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new $2fa92ec193801792$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (0 === e.length && 0 !== t) // Empty bloom filter should have 0 padding.
        throw new $2fa92ec193801792$var$__PRIVATE_BloomFilterError(`Invalid padding when bitmap length is 0: ${t}`);
        this.m = 8 * e.length - t, // Set the bit count in Integer to avoid repetition in mightContain().
        this.p = (0, $906344b47e605252$export$70ffa26850098d01).fromNumber(this.m);
    }
    // Calculate the ith hash value based on the hashed 64bit integers,
    // and calculate its corresponding bit index in the bitmap to be checked.
    v(e, t, n) {
        // Calculate hashed value h(i) = h1 + (i * h2).
        let r = e.add(t.multiply((0, $906344b47e605252$export$70ffa26850098d01).fromNumber(n)));
        // Wrap if hash value overflow 64bit.
        return 1 === r.compare($2fa92ec193801792$var$at) && (r = new (0, $906344b47e605252$export$70ffa26850098d01)([
            r.getBits(0),
            r.getBits(1)
        ], 0)), r.modulo(this.p).toNumber();
    }
    // Return whether the bit on the given index in the bitmap is set to 1.
    S(e) {
        return !!(this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
    }
    mightContain(e) {
        // Empty bitmap should always return false on membership check.
        if (0 === this.m) return false;
        const t = $2fa92ec193801792$var$__PRIVATE_getMd5HashValue(e), [n, r] = $2fa92ec193801792$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.v(n, r, e);
            if (!this.S(t)) return false;
        }
        return true;
    }
    /** Create bloom filter for testing purposes only. */ static create(e, t, n) {
        const r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new $2fa92ec193801792$var$BloomFilter(i, r, t);
        return n.forEach((e)=>s.insert(e)), s;
    }
    insert(e) {
        if (0 === this.m) return;
        const t = $2fa92ec193801792$var$__PRIVATE_getMd5HashValue(e), [n, r] = $2fa92ec193801792$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.v(n, r, e);
            this.D(t);
        }
    }
    D(e) {
        const t = Math.floor(e / 8), n = e % 8;
        this.bitmap[t] |= 1 << n;
    }
}
class $2fa92ec193801792$var$__PRIVATE_BloomFilterError extends Error {
    constructor(){
        super(...arguments), this.name = "BloomFilterError";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class $2fa92ec193801792$var$RemoteEvent {
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ e, /**
     * A map from target to changes to the target. See TargetChange.
     */ t, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which augmented documents (pipeline) have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ i, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ s){
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.augmentedDocumentUpdates = i, this.resolvedLimboDocuments = s;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(e, t, n) {
        const r = new Map;
        return r.set(e, $2fa92ec193801792$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new $2fa92ec193801792$var$RemoteEvent($2fa92ec193801792$var$SnapshotVersion.min(), r, new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$var$__PRIVATE_primitiveComparator), $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap(), $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap(), $2fa92ec193801792$export$a9c996f45e5784d0());
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class $2fa92ec193801792$var$TargetChange {
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ e, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ t, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(e, t, n) {
        return new $2fa92ec193801792$var$TargetChange(n, t, $2fa92ec193801792$export$a9c996f45e5784d0(), $2fa92ec193801792$export$a9c996f45e5784d0(), $2fa92ec193801792$export$a9c996f45e5784d0());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class $2fa92ec193801792$var$__PRIVATE_DocumentWatchChange {
    constructor(/** The new document applies to all of these targets. */ e, /** The new document is removed from all of these targets. */ t, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r){
        this.C = e, this.removedTargetIds = t, this.key = n, this.F = r;
    }
}
class $2fa92ec193801792$var$__PRIVATE_ExistenceFilterChange {
    constructor(e, t){
        this.targetId = e, this.O = t;
    }
}
class $2fa92ec193801792$var$__PRIVATE_WatchTargetChange {
    constructor(/** What kind of change occurred to the watch target. */ e, /** The target IDs that were added/removed/set. */ t, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = $2fa92ec193801792$export$158acd800e1ef08b.EMPTY_BYTE_STRING, r = null){
        this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
    }
}
/** Tracks the internal state of a Watch target. */ class $2fa92ec193801792$var$__PRIVATE_TargetState {
    /**
     * Track the targetId for logging.
     */ constructor(e){
        this.targetId = e, /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.M = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.N = $2fa92ec193801792$var$__PRIVATE_snapshotChangesMap(), /** See public getters for explanations of these fields. */ this.L = $2fa92ec193801792$export$158acd800e1ef08b.EMPTY_BYTE_STRING, this.B = false, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.U = true;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.B;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.L;
    }
    /** Whether this target has pending target adds or target removes. */ get k() {
        return 0 !== this.M;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get q() {
        return this.U;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ $(e) {
        e.approximateByteSize() > 0 && (this.U = true, this.L = e);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ K() {
        let e = $2fa92ec193801792$export$a9c996f45e5784d0(), t = $2fa92ec193801792$export$a9c996f45e5784d0(), n = $2fa92ec193801792$export$a9c996f45e5784d0();
        return this.N.forEach((r, i)=>{
            switch(i){
                case 0 /* ChangeType.Added */ :
                    e = e.add(r);
                    break;
                case 2 /* ChangeType.Modified */ :
                    t = t.add(r);
                    break;
                case 1 /* ChangeType.Removed */ :
                    n = n.add(r);
                    break;
                default:
                    $2fa92ec193801792$export$1a82df3d29112e01(38017, {
                        changeType: i
                    });
            }
        }), new $2fa92ec193801792$var$TargetChange(this.L, this.B, e, t, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ W() {
        this.U = false, this.N = $2fa92ec193801792$var$__PRIVATE_snapshotChangesMap();
    }
    G(e, t) {
        this.U = true, this.N = this.N.insert(e, t);
    }
    j(e) {
        this.U = true, this.N = this.N.remove(e);
    }
    H() {
        this.M += 1;
    }
    J() {
        this.M -= 1, $2fa92ec193801792$var$__PRIVATE_hardAssert(this.M >= 0, 3241, {
            M: this.M,
            targetId: this.targetId
        });
    }
    Y() {
        this.U = true, this.B = true;
    }
}
const $2fa92ec193801792$var$ut = "WatchChangeAggregator";
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class $2fa92ec193801792$var$__PRIVATE_WatchChangeAggregator {
    constructor(e){
        this.Z = e, /**
         * The internal state of all tracked targets.
         *
         * Targets have the following lifecycle of [states] within the WatchChangeAggregator:
         * [unknown] -> recordPendingTargetRequest(t)
         *           -> [pending]
         *           -> handleTargetChange(t, Added)
         *           -> [added / !pending]
         *           -> recordPendingTargetRequest(t)
         *           -> [pending]
         *           -> handleTargetChange(t, Removed)
         *           -> [unknown]
         *
         * A reset on an [added] target leaves the target in an [added] state.
         * [added / !pending] -> handleTargetChange(t, Reset)
         *                    -> [added / !pending]
         *
         * [active]: is a substate of [added], where also `remoteStore.listenTargets.has(t) === true`.
         *           Generally it is expected that when a target is [active / !pending]
         *           then it is also [active], but the implementation does not guarantee
         *           this will always be true.
         *
         */ this.X = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.ee = $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap(), this.te = $2fa92ec193801792$var$__PRIVATE_documentTargetMap(), /** Keeps track of the augmented documents to update since the last raised snapshot. */ this.ne = $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap(), /** A mapping of document keys to their set of target IDs. */ this.re = $2fa92ec193801792$var$__PRIVATE_documentTargetMap(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.ie = new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$var$__PRIVATE_primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ se(e) {
        for (const t of e.C)e.F && e.F.isFoundDocument() ? this._e(t, e.F) : this.oe(t, e.key, e.F);
        for (const t of e.removedTargetIds)this.oe(t, e.key, e.F);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ ae(e) {
        this.forEachTarget(e, (t)=>{
            const n = this.X.get(t);
            // skip unknown target state, this indicates the target change is for
            // an old target
            if (n) switch(e.state){
                case 0 /* WatchTargetChangeState.NoChange */ :
                    this.ue(t) && n.$(e.resumeToken);
                    break;
                case 1 /* WatchTargetChangeState.Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.J(), n.k || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.W(), n.$(e.resumeToken);
                    break;
                case 2 /* WatchTargetChangeState.Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.J(), n.k || this.removeTarget(t);
                    break;
                case 3 /* WatchTargetChangeState.Current */ :
                    this.ue(t) && (n.Y(), n.$(e.resumeToken));
                    break;
                case 4 /* WatchTargetChangeState.Reset */ :
                    this.ue(t) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.ce(t), n.$(e.resumeToken));
                    break;
                default:
                    $2fa92ec193801792$export$1a82df3d29112e01(56790, {
                        state: e.state
                    });
            }
            else $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$ut, `handleTargetChange received targetChange for untracked target ID (${t}) with state (${e.state})`);
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(e, t) {
        e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.X.forEach((e, n)=>{
            this.ue(n) && t(n);
        });
    }
    le(e) {
        return $2fa92ec193801792$var$__PRIVATE_targetIsPipelineTarget(e) ? "documents" === e.getPipelineSourceType() && 1 === e.getPipelineDocuments()?.length : $2fa92ec193801792$var$__PRIVATE_targetIsDocumentTarget(e);
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ Ee(e) {
        const t = e.targetId, n = e.O.count, r = this.he(t);
        if (r) {
            const i = r.target;
            if (this.le(i)) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const e = new $2fa92ec193801792$export$a07804094c3ecf2d($2fa92ec193801792$var$__PRIVATE_targetIsPipelineTarget(i) ? $2fa92ec193801792$export$db202ddc8be9136.fromString(i.getPipelineDocuments()[0]) : i.path);
                    this.oe(t, e, $2fa92ec193801792$var$MutableDocument.newNoDocument(e, $2fa92ec193801792$var$SnapshotVersion.min()));
                } else $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === n, 20013, "Single document existence filter with count: " + n);
            } else {
                const r = this.Te(t);
                // Existence filter mismatch. Mark the documents as being in limbo, and
                // raise a snapshot with `isFromCache:true`.
                if (r !== n) {
                    // Apply bloom filter to identify and mark removed documents.
                    const n = this.Pe(e), i = n ? this.Re(n, e, r) : 1 /* BloomFilterApplicationStatus.Skipped */ ;
                    if (0 /* BloomFilterApplicationStatus.Success */  !== i) {
                        // If bloom filter application fails, we reset the mapping and
                        // trigger re-run of the query.
                        this.ce(t);
                        const e = 2 /* BloomFilterApplicationStatus.FalsePositive */  === i ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                        this.ie = this.ie.insert(t, e);
                    }
                    $2fa92ec193801792$var$ot?.Ie(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r, i) {
                        const s = {
                            localCacheCount: e,
                            existenceFilterCount: t.count,
                            databaseId: n.database,
                            projectId: n.projectId
                        }, _ = t.unchangedNames;
                        _ && (s.bloomFilter = {
                            applied: 0 /* BloomFilterApplicationStatus.Success */  === i,
                            hashCount: _?.hashCount ?? 0,
                            bitmapLength: _?.bits?.bitmap?.length ?? 0,
                            padding: _?.bits?.padding ?? 0,
                            mightContain: (e)=>r?.mightContain(e) ?? false
                        });
                        return s;
                    }(r, e.O, this.Z.Ae(), n, i));
                }
            }
        }
    }
    /**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */ Pe(e) {
        const t = e.O.unchangedNames;
        if (!t || !t.bits) return null;
        const { bits: { bitmap: n = "", padding: r = 0 }, hashCount: i = 0 } = t;
        let s, _;
        try {
            s = $2fa92ec193801792$var$__PRIVATE_normalizeByteString(n).toUint8Array();
        } catch (e) {
            if (e instanceof $2fa92ec193801792$var$__PRIVATE_Base64DecodeError) return $2fa92ec193801792$export$7f8ddf7c7c20b3cd("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
            throw e;
        }
        try {
            // BloomFilter throws error if the inputs are invalid.
            _ = new $2fa92ec193801792$var$BloomFilter(s, r, i);
        } catch (e) {
            return $2fa92ec193801792$export$7f8ddf7c7c20b3cd(e instanceof $2fa92ec193801792$var$__PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
        }
        return 0 === _.m ? null : _;
    }
    /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ Re(e, t, n) {
        return t.O.count === n - this.Ve(e, t.targetId) ? 0 /* BloomFilterApplicationStatus.Success */  : 2 /* BloomFilterApplicationStatus.FalsePositive */ ;
    }
    /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ Ve(e, t) {
        const n = this.Z.getRemoteKeysForTarget(t);
        let r = 0;
        return n.forEach((n)=>{
            const i = this.Z.Ae(), s = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
            e.mightContain(s) || (this.oe(t, n, /*updatedDocument=*/ null), r++);
        }), r;
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ de(e) {
        const t = new Map;
        this.X.forEach((n, r)=>{
            const i = this.he(r);
            if (i) {
                if (n.current && this.le(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document for this
                    // target. This resolves the limbo state of the document, removing it
                    // from limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const t = $2fa92ec193801792$var$__PRIVATE_targetIsPipelineTarget(i.target) ? $2fa92ec193801792$export$db202ddc8be9136.fromString(i.target.getPipelineDocuments()[0]) : i.target.path, n = new $2fa92ec193801792$export$a07804094c3ecf2d(t);
                    this.fe(n).has(r) || this.me(r, n) || this.oe(r, n, $2fa92ec193801792$var$MutableDocument.newNoDocument(n, e));
                }
                n.q && (t.set(r, n.K()), n.W());
            }
        });
        let n = $2fa92ec193801792$export$a9c996f45e5784d0();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.re.forEach((e, t)=>{
            let r = true;
            t.forEachWhile((e)=>{
                const t = this.he(e);
                return !t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === t.purpose || (r = false, false);
            }), r && (n = n.add(e));
        }), this.ee.forEach((t, n)=>n.setReadTime(e)), this.ne.forEach((t, n)=>n.setReadTime(e));
        const r = new $2fa92ec193801792$var$RemoteEvent(e, t, this.ie, this.ee, this.ne, n);
        return this.ee = $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap(), this.te = $2fa92ec193801792$var$__PRIVATE_documentTargetMap(), this.ne = $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap(), this.re = $2fa92ec193801792$var$__PRIVATE_documentTargetMap(), this.ie = new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$var$__PRIVATE_primitiveComparator), r;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    _e(e, t) {
        const n = this.X.get(e);
        // skip unknown or inactive targets
        if (!n || !this.ue(e)) return void $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$ut, `addDocumentToTarget received document for unknown inactive target (${e})`);
        const r = this.me(e, t.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
        n.G(t.key, r), $2fa92ec193801792$var$__PRIVATE_targetIsPipelineTarget(this.he(e).target) && "exact" !== this.he(e).target.getPipelineFlavor() ? this.ne = this.ne.insert(t.key, t) : this.ee = this.ee.insert(t.key, t), this.te = this.te.insert(t.key, this.fe(t.key).add(e)), this.re = this.re.insert(t.key, this.pe(t.key).add(e));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    oe(e, t, n) {
        const r = this.X.get(e);
        // skip unknown target state, this indicates the target change is for
        // an old target
        r && this.ue(e) ? (this.me(e, t) ? r.G(t, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        r.j(t), this.re = this.re.insert(t, this.pe(t).delete(e)), this.re = this.re.insert(t, this.pe(t).add(e)), n && ($2fa92ec193801792$var$__PRIVATE_targetIsPipelineTarget(this.he(e).target) && "exact" !== this.he(e).target.getPipelineFlavor() ? this.ne = this.ne.insert(t, n) : this.ee = this.ee.insert(t, n))) : $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$ut, `removeDocumentFromTarget received document for unknown or inactive target (${e})`);
    }
    removeTarget(e) {
        this.X.delete(e);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ Te(e) {
        const t = this.X.get(e);
        // skip unknown target state
        if (!t) return 0;
        const n = t.K();
        return this.Z.getRemoteKeysForTarget(e).size + n.addedDocuments.size - n.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ H(e) {
        // For each request we get we need to record we need a response for it.
        let t = this.X.get(e);
        t || ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$ut, `recordPendingTargetRequest set up tracking for target ID ${e}`), t = new $2fa92ec193801792$var$__PRIVATE_TargetState(e), this.X.set(e, t)), t.H();
    }
    pe(e) {
        let t = this.re.get(e);
        return t || (t = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$var$__PRIVATE_primitiveComparator), this.re = this.re.insert(e, t)), t;
    }
    fe(e) {
        let t = this.te.get(e);
        return t || (t = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$var$__PRIVATE_primitiveComparator), this.te = this.te.insert(e, t)), t;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ ue(e) {
        const t = null !== this.he(e);
        return t || $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$ut, "Detected inactive target", e), t;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ he(e) {
        const t = this.X.get(e);
        return void 0 === t || t.k ? null : this.Z.ge(e);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ ce(e) {
        this.X.set(e, new $2fa92ec193801792$var$__PRIVATE_TargetState(e));
        this.Z.getRemoteKeysForTarget(e).forEach((t)=>{
            this.oe(e, t, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ me(e, t) {
        return this.Z.getRemoteKeysForTarget(e).has(t);
    }
}
function $2fa92ec193801792$var$__PRIVATE_documentTargetMap() {
    return new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$export$a07804094c3ecf2d.comparator);
}
function $2fa92ec193801792$var$__PRIVATE_snapshotChangesMap() {
    return new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$export$a07804094c3ecf2d.comparator);
}
const $2fa92ec193801792$var$ct = (()=>{
    const e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
})(), $2fa92ec193801792$var$lt = (()=>{
    const e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
})(), $2fa92ec193801792$var$Et = (()=>{
    const e = {
        and: "AND",
        or: "OR"
    };
    return e;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $2fa92ec193801792$var$JsonProtoSerializer {
    constructor(e, t){
        this.databaseId = e, this.useProto3Json = t;
    }
}
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function $2fa92ec193801792$var$__PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || $2fa92ec193801792$var$__PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $2fa92ec193801792$var$toTimestamp(e, t) {
    if (e.useProto3Json) return `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}
/**
 * Returns a Timestamp typed object given protobuf timestamp value.
 */ function $2fa92ec193801792$var$fromTimestamp(e) {
    const t = $2fa92ec193801792$var$__PRIVATE_normalizeTimestamp(e);
    return new $2fa92ec193801792$export$890c4ad488842ce7(t.seconds, t.nanos);
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $2fa92ec193801792$var$__PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $2fa92ec193801792$var$__PRIVATE_toVersion(e, t) {
    return $2fa92ec193801792$var$toTimestamp(e, t.toTimestamp());
}
function $2fa92ec193801792$var$__PRIVATE_fromVersion(e) {
    return $2fa92ec193801792$var$__PRIVATE_hardAssert(!!e, 49232), $2fa92ec193801792$var$SnapshotVersion.fromTimestamp($2fa92ec193801792$var$fromTimestamp(e));
}
function $2fa92ec193801792$var$__PRIVATE_toResourceName(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_toResourcePath(e, t).canonicalString();
}
function $2fa92ec193801792$var$__PRIVATE_toResourcePath(e, t) {
    const n = (function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new $2fa92ec193801792$export$db202ddc8be9136([
            "projects",
            e.projectId,
            "databases",
            e.database
        ]);
    })(e).child("documents");
    return void 0 === t ? n : n.child(t);
}
function $2fa92ec193801792$var$__PRIVATE_fromResourceName(e) {
    const t = $2fa92ec193801792$export$db202ddc8be9136.fromString(e);
    return $2fa92ec193801792$var$__PRIVATE_hardAssert($2fa92ec193801792$var$__PRIVATE_isValidResourceName(t), 10190, {
        key: t.toString()
    }), t;
}
function $2fa92ec193801792$var$__PRIVATE_toName(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_toResourceName(e.databaseId, t.path);
}
function $2fa92ec193801792$var$fromName(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_fromResourceName(t);
    if (n.get(1) !== e.databaseId.projectId) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
    if (n.get(3) !== e.databaseId.database) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
    return new $2fa92ec193801792$export$a07804094c3ecf2d($2fa92ec193801792$var$__PRIVATE_extractLocalPathFromResourceName(n));
}
function $2fa92ec193801792$var$__PRIVATE_toQueryPath(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_toResourceName(e.databaseId, t);
}
function $2fa92ec193801792$var$__PRIVATE_fromQueryPath(e) {
    const t = $2fa92ec193801792$var$__PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === t.length ? $2fa92ec193801792$export$db202ddc8be9136.emptyPath() : $2fa92ec193801792$var$__PRIVATE_extractLocalPathFromResourceName(t);
}
function $2fa92ec193801792$var$__PRIVATE_getEncodedDatabaseId(e) {
    return new $2fa92ec193801792$export$db202ddc8be9136([
        "projects",
        e.databaseId.projectId,
        "databases",
        e.databaseId.database
    ]).canonicalString();
}
function $2fa92ec193801792$var$__PRIVATE_extractLocalPathFromResourceName(e) {
    return $2fa92ec193801792$var$__PRIVATE_hardAssert(e.length > 4 && "documents" === e.get(4), 29091, {
        key: e.toString()
    }), e.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $2fa92ec193801792$var$__PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: $2fa92ec193801792$var$__PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}
function $2fa92ec193801792$var$__PRIVATE_fromPipelineResponse(e, t, n) {
    const r = {};
    t.transaction?.length && (r.transaction = t.transaction);
    const i = t.executionTime ? $2fa92ec193801792$var$__PRIVATE_fromVersion(t.executionTime) : void 0;
    return r.executionTime = i, n && (r.key = n.name ? $2fa92ec193801792$var$fromName(e, n.name) : void 0, r.fields = new $2fa92ec193801792$export$c4ce752e73470fba({
        mapValue: {
            fields: n.fields
        }
    }), r.createTime = n.createTime ? $2fa92ec193801792$var$__PRIVATE_fromVersion(n.createTime) : void 0, r.updateTime = n.updateTime ? $2fa92ec193801792$var$__PRIVATE_fromVersion(n.updateTime) : void 0), r;
}
function $2fa92ec193801792$export$3a1a48c8f6ef640e(e, t, n) {
    const r = $2fa92ec193801792$var$fromName(e, t.name), i = $2fa92ec193801792$var$__PRIVATE_fromVersion(t.updateTime), s = t.createTime ? $2fa92ec193801792$var$__PRIVATE_fromVersion(t.createTime) : $2fa92ec193801792$var$SnapshotVersion.min(), _ = new $2fa92ec193801792$export$c4ce752e73470fba({
        mapValue: {
            fields: t.fields
        }
    }), o = $2fa92ec193801792$var$MutableDocument.newFoundDocument(r, i, s, _);
    return n && o.setHasCommittedMutations(), n ? o.setHasCommittedMutations() : o;
}
function $2fa92ec193801792$var$__PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(!!t.found, 43571), t.found.name, t.found.updateTime;
        const n = $2fa92ec193801792$var$fromName(e, t.found.name), r = $2fa92ec193801792$var$__PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? $2fa92ec193801792$var$__PRIVATE_fromVersion(t.found.createTime) : $2fa92ec193801792$var$SnapshotVersion.min(), s = new $2fa92ec193801792$export$c4ce752e73470fba({
            mapValue: {
                fields: t.found.fields
            }
        });
        return $2fa92ec193801792$var$MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(!!t.missing, 3894), $2fa92ec193801792$var$__PRIVATE_hardAssert(!!t.readTime, 22933);
        const n = $2fa92ec193801792$var$fromName(e, t.missing), r = $2fa92ec193801792$var$__PRIVATE_fromVersion(t.readTime);
        return $2fa92ec193801792$var$MutableDocument.newNoDocument(n, r);
    }(e, t) : $2fa92ec193801792$export$1a82df3d29112e01(7234, {
        result: t
    });
}
function $2fa92ec193801792$var$__PRIVATE_fromWatchChange(e, t) {
    let n;
    if ("targetChange" in t) {
        t.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const r = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === e ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */  : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */  : $2fa92ec193801792$export$1a82df3d29112e01(39313, {
                state: e
            });
        }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], _ = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? ($2fa92ec193801792$var$__PRIVATE_hardAssert(void 0 === t || "string" == typeof t, 58123), $2fa92ec193801792$export$158acd800e1ef08b.fromBase64String(t || "")) : ($2fa92ec193801792$var$__PRIVATE_hardAssert(void 0 === t || // Check if the value is an instance of both Buffer and Uint8Array,
            // despite the fact that Buffer extends Uint8Array. In some
            // environments, such as jsdom, the prototype chain of Buffer
            // does not indicate that it extends Uint8Array.
            t instanceof $2fa92ec193801792$require$Buffer || t instanceof Uint8Array, 16193), $2fa92ec193801792$export$158acd800e1ef08b.fromUint8Array(t || new Uint8Array));
        }(e, t.targetChange.resumeToken), o = t.targetChange.cause, a = o && function __PRIVATE_fromRpcStatus(e) {
            const t = void 0 === e.code ? $2fa92ec193801792$export$db3b6bfb95261072.UNKNOWN : $2fa92ec193801792$var$__PRIVATE_mapCodeFromRpcCode(e.code);
            return new $2fa92ec193801792$export$2408f22a0fab9ae5(t, e.message || "");
        }(o);
        n = new $2fa92ec193801792$var$__PRIVATE_WatchTargetChange(r, i, _, a || null);
    } else if ("documentChange" in t) {
        t.documentChange;
        const r = t.documentChange;
        r.document, r.document.name, r.document.updateTime;
        const i = $2fa92ec193801792$var$fromName(e, r.document.name), s = $2fa92ec193801792$var$__PRIVATE_fromVersion(r.document.updateTime), _ = r.document.createTime ? $2fa92ec193801792$var$__PRIVATE_fromVersion(r.document.createTime) : $2fa92ec193801792$var$SnapshotVersion.min(), o = new $2fa92ec193801792$export$c4ce752e73470fba({
            mapValue: {
                fields: r.document.fields
            }
        }), a = $2fa92ec193801792$var$MutableDocument.newFoundDocument(i, s, _, o), u = r.targetIds || [], c = r.removedTargetIds || [];
        n = new $2fa92ec193801792$var$__PRIVATE_DocumentWatchChange(u, c, a.key, a);
    } else if ("documentDelete" in t) {
        t.documentDelete;
        const r = t.documentDelete;
        r.document;
        const i = $2fa92ec193801792$var$fromName(e, r.document), s = r.readTime ? $2fa92ec193801792$var$__PRIVATE_fromVersion(r.readTime) : $2fa92ec193801792$var$SnapshotVersion.min(), _ = $2fa92ec193801792$var$MutableDocument.newNoDocument(i, s), o = r.removedTargetIds || [];
        n = new $2fa92ec193801792$var$__PRIVATE_DocumentWatchChange([], o, _.key, _);
    } else if ("documentRemove" in t) {
        t.documentRemove;
        const r = t.documentRemove;
        r.document;
        const i = $2fa92ec193801792$var$fromName(e, r.document), s = r.removedTargetIds || [];
        n = new $2fa92ec193801792$var$__PRIVATE_DocumentWatchChange([], s, i, null);
    } else {
        if (!("filter" in t)) return $2fa92ec193801792$export$1a82df3d29112e01(11601, {
            ye: t
        });
        {
            t.filter;
            const e = t.filter;
            e.targetId;
            const { count: r = 0, unchangedNames: i } = e, s = new $2fa92ec193801792$var$ExistenceFilter(r, i), _ = e.targetId;
            n = new $2fa92ec193801792$var$__PRIVATE_ExistenceFilterChange(_, s);
        }
    }
    return n;
}
function $2fa92ec193801792$var$toMutation(e, t) {
    let n;
    if (t instanceof $2fa92ec193801792$var$__PRIVATE_SetMutation) n = {
        update: $2fa92ec193801792$var$__PRIVATE_toMutationDocument(e, t.key, t.value)
    };
    else if (t instanceof $2fa92ec193801792$export$4a5767248b18ef41) n = {
        delete: $2fa92ec193801792$var$__PRIVATE_toName(e, t.key)
    };
    else if (t instanceof $2fa92ec193801792$var$__PRIVATE_PatchMutation) n = {
        update: $2fa92ec193801792$var$__PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: $2fa92ec193801792$var$__PRIVATE_toDocumentMask(t.fieldMask)
    };
    else {
        if (!(t instanceof $2fa92ec193801792$var$__PRIVATE_VerifyMutation)) return $2fa92ec193801792$export$1a82df3d29112e01(16599, {
            we: t.type
        });
        n = {
            verify: $2fa92ec193801792$var$__PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map((e)=>(function __PRIVATE_toFieldTransform(e, t) {
            const n = t.transform;
            if (n instanceof $2fa92ec193801792$var$__PRIVATE_ServerTimestampTransform) return {
                fieldPath: t.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $2fa92ec193801792$var$__PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $2fa92ec193801792$var$__PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $2fa92ec193801792$var$__PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                increment: n.l
            };
            if (n instanceof $2fa92ec193801792$var$__PRIVATE_NumericMinimumTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                minimum: n.l
            };
            if (n instanceof $2fa92ec193801792$var$__PRIVATE_NumericMaximumTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                maximum: n.l
            };
            throw $2fa92ec193801792$export$1a82df3d29112e01(20930, {
                transform: t.transform
            });
        })(0, e))), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: $2fa92ec193801792$var$__PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : $2fa92ec193801792$export$1a82df3d29112e01(27497);
    }(e, t.precondition)), n;
}
function $2fa92ec193801792$var$__PRIVATE_fromMutation(e, t) {
    const n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? $2fa92ec193801792$export$56c0d5a1e737357d.updateTime($2fa92ec193801792$var$__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? $2fa92ec193801792$export$56c0d5a1e737357d.exists(e.exists) : $2fa92ec193801792$export$56c0d5a1e737357d.none();
    }(t.currentDocument) : $2fa92ec193801792$export$56c0d5a1e737357d.none(), r = t.updateTransforms ? t.updateTransforms.map((t)=>(function __PRIVATE_fromFieldTransform(e, t) {
            let n = null;
            if ("setToServerValue" in t) $2fa92ec193801792$var$__PRIVATE_hardAssert("REQUEST_TIME" === t.setToServerValue, 16630, {
                proto: t
            }), n = new $2fa92ec193801792$var$__PRIVATE_ServerTimestampTransform;
            else if ("appendMissingElements" in t) {
                const e = t.appendMissingElements.values || [];
                n = new $2fa92ec193801792$var$__PRIVATE_ArrayUnionTransformOperation(e);
            } else if ("removeAllFromArray" in t) {
                const e = t.removeAllFromArray.values || [];
                n = new $2fa92ec193801792$var$__PRIVATE_ArrayRemoveTransformOperation(e);
            } else "increment" in t ? n = new $2fa92ec193801792$var$__PRIVATE_NumericIncrementTransformOperation(e, t.increment) : "minimum" in t ? n = new $2fa92ec193801792$var$__PRIVATE_NumericMinimumTransformOperation(e, t.minimum) : "maximum" in t ? n = new $2fa92ec193801792$var$__PRIVATE_NumericMaximumTransformOperation(e, t.maximum) : $2fa92ec193801792$export$1a82df3d29112e01(16584, {
                proto: t
            });
            const r = $2fa92ec193801792$export$b9a6b53f9be3734.fromServerFormat(t.fieldPath);
            return new $2fa92ec193801792$var$FieldTransform(r, n);
        })(e, t)) : [];
    if (t.update) {
        t.update.name;
        const i = $2fa92ec193801792$var$fromName(e, t.update.name), s = new $2fa92ec193801792$export$c4ce752e73470fba({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            const e = function __PRIVATE_fromDocumentMask(e) {
                const t = e.fieldPaths || [];
                return new $2fa92ec193801792$var$FieldMask(t.map((e)=>$2fa92ec193801792$export$b9a6b53f9be3734.fromServerFormat(e)));
            }(t.updateMask);
            return new $2fa92ec193801792$var$__PRIVATE_PatchMutation(i, s, e, n, r);
        }
        return new $2fa92ec193801792$var$__PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        const r = $2fa92ec193801792$var$fromName(e, t.delete);
        return new $2fa92ec193801792$export$4a5767248b18ef41(r, n);
    }
    if (t.verify) {
        const r = $2fa92ec193801792$var$fromName(e, t.verify);
        return new $2fa92ec193801792$var$__PRIVATE_VerifyMutation(r, n);
    }
    return $2fa92ec193801792$export$1a82df3d29112e01(1463, {
        proto: t
    });
}
function $2fa92ec193801792$var$__PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? ($2fa92ec193801792$var$__PRIVATE_hardAssert(void 0 !== t, 14353), e.map((e)=>(function __PRIVATE_fromWriteResult(e, t) {
            // NOTE: Deletes don't have an updateTime.
            let n = e.updateTime ? $2fa92ec193801792$var$__PRIVATE_fromVersion(e.updateTime) : $2fa92ec193801792$var$__PRIVATE_fromVersion(t);
            return n.isEqual($2fa92ec193801792$var$SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $2fa92ec193801792$var$__PRIVATE_fromVersion(t)), new $2fa92ec193801792$var$MutationResult(n, e.transformResults || []);
        })(e, t))) : [];
}
function $2fa92ec193801792$var$__PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [
            $2fa92ec193801792$var$__PRIVATE_toQueryPath(e, t.path)
        ]
    };
}
function $2fa92ec193801792$var$__PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, r = t.path;
    let i;
    null !== t.collectionGroup ? (i = r, n.structuredQuery.from = [
        {
            collectionId: t.collectionGroup,
            allDescendants: true
        }
    ]) : (i = r.popLast(), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]), n.parent = $2fa92ec193801792$var$__PRIVATE_toQueryPath(e, i);
    const s = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return $2fa92ec193801792$var$__PRIVATE_toFilter($2fa92ec193801792$export$e7094788287c5e9b.create(e, "and" /* CompositeOperator.AND */ ));
    }(t.filters);
    s && (n.structuredQuery.where = s);
    const _ = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map((e)=>// visible for testing
            (function __PRIVATE_toPropertyOrder(e) {
                return {
                    field: $2fa92ec193801792$var$__PRIVATE_toFieldPathReference(e.field),
                    direction: $2fa92ec193801792$var$__PRIVATE_toDirection(e.dir)
                };
            })(e));
    }(t.orderBy);
    _ && (n.structuredQuery.orderBy = _);
    const o = $2fa92ec193801792$var$__PRIVATE_toInt32Proto(e, t.limit);
    return null !== o && (n.structuredQuery.limit = o), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), {
        be: n,
        parent: i
    };
}
function $2fa92ec193801792$var$__PRIVATE_toRunAggregationQueryRequest(e, t, n, r) {
    const { be: i, parent: s } = $2fa92ec193801792$var$__PRIVATE_toQueryTarget(e, t), _ = {}, o = [];
    let a = 0;
    return n.forEach((e)=>{
        // Map all client-side aliases to a unique short-form
        // alias. This avoids issues with client-side aliases that
        // exceed the 1500-byte string size limit.
        const t = r ? e.alias : "aggregate_" + a++;
        _[t] = e.alias, "count" === e.aggregateType ? o.push({
            alias: t,
            count: {}
        }) : "avg" === e.aggregateType ? o.push({
            alias: t,
            avg: {
                field: $2fa92ec193801792$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        }) : "sum" === e.aggregateType && o.push({
            alias: t,
            sum: {
                field: $2fa92ec193801792$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        });
    }), {
        request: {
            structuredAggregationQuery: {
                aggregations: o,
                structuredQuery: i.structuredQuery
            },
            parent: i.parent
        },
        ve: _,
        parent: s
    };
}
function $2fa92ec193801792$var$__PRIVATE_convertQueryTargetToQuery(e) {
    let t = $2fa92ec193801792$var$__PRIVATE_fromQueryPath(e.parent);
    const n = e.structuredQuery, r = n.from ? n.from.length : 0;
    let i = null;
    if (r > 0) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === r, 65062);
        const e = n.from[0];
        e.allDescendants ? i = e.collectionId : t = t.child(e.collectionId);
    }
    let s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        const t = $2fa92ec193801792$var$__PRIVATE_fromFilter(e);
        if (t instanceof $2fa92ec193801792$export$e7094788287c5e9b && $2fa92ec193801792$var$__PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [
            t
        ];
    }(n.where));
    let _ = [];
    n.orderBy && (_ = function __PRIVATE_fromOrder(e) {
        return e.map((e)=>(function __PRIVATE_fromPropertyOrder(e) {
                return new $2fa92ec193801792$export$23f2a1d2818174ef($2fa92ec193801792$var$__PRIVATE_fromFieldPathReference(e.field), // visible for testing
                function __PRIVATE_fromDirection(e) {
                    switch(e){
                        case "ASCENDING":
                            return "asc" /* Direction.ASCENDING */ ;
                        case "DESCENDING":
                            return "desc" /* Direction.DESCENDING */ ;
                        default:
                            return;
                    }
                }(e.direction));
            })(e));
    }(n.orderBy));
    let o = null;
    n.limit && (o = function __PRIVATE_fromInt32Proto(e) {
        let t;
        return t = "object" == typeof e ? e.value : e, $2fa92ec193801792$var$__PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    let a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        const t = !!e.before, n = e.values || [];
        return new $2fa92ec193801792$export$3b513254972cfc9c(n, t);
    }(n.startAt));
    let u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        const t = !e.before, n = e.values || [];
        return new $2fa92ec193801792$export$3b513254972cfc9c(n, t);
    }(n.endAt)), $2fa92ec193801792$var$__PRIVATE_newQuery(t, i, _, s, o, "F" /* LimitType.First */ , a, u);
}
function $2fa92ec193801792$var$__PRIVATE_toListenRequestLabels(e, t) {
    const n = function __PRIVATE_toLabel(e) {
        switch(e){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return $2fa92ec193801792$export$1a82df3d29112e01(28987, {
                    purpose: e
                });
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $2fa92ec193801792$var$__PRIVATE_toPipelineTarget(e, t) {
    return {
        structuredPipeline: {
            pipeline: {
                stages: t.stages.map((t)=>t._toProto(e))
            }
        }
    };
}
function $2fa92ec193801792$var$__PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch(e.unaryFilter.op){
            case "IS_NAN":
                const t = $2fa92ec193801792$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $2fa92ec193801792$export$d66501df72047452.create(t, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                const n = $2fa92ec193801792$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $2fa92ec193801792$export$d66501df72047452.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                const r = $2fa92ec193801792$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $2fa92ec193801792$export$d66501df72047452.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                const i = $2fa92ec193801792$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $2fa92ec193801792$export$d66501df72047452.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "OPERATOR_UNSPECIFIED":
                return $2fa92ec193801792$export$1a82df3d29112e01(61313);
            default:
                return $2fa92ec193801792$export$1a82df3d29112e01(60726);
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return $2fa92ec193801792$export$d66501df72047452.create($2fa92ec193801792$var$__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch(e){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                case "OPERATOR_UNSPECIFIED":
                    return $2fa92ec193801792$export$1a82df3d29112e01(58110);
                default:
                    return $2fa92ec193801792$export$1a82df3d29112e01(50506);
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return $2fa92ec193801792$export$e7094788287c5e9b.create(e.compositeFilter.filters.map((e)=>$2fa92ec193801792$var$__PRIVATE_fromFilter(e)), function __PRIVATE_fromCompositeOperatorName(e) {
            switch(e){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return $2fa92ec193801792$export$1a82df3d29112e01(1026);
            }
        }(e.compositeFilter.op));
    }(e) : $2fa92ec193801792$export$1a82df3d29112e01(30097, {
        filter: e
    });
}
function $2fa92ec193801792$var$__PRIVATE_toDirection(e) {
    return $2fa92ec193801792$var$ct[e];
}
function $2fa92ec193801792$var$__PRIVATE_toOperatorName(e) {
    return $2fa92ec193801792$var$lt[e];
}
function $2fa92ec193801792$var$__PRIVATE_toCompositeOperatorName(e) {
    return $2fa92ec193801792$var$Et[e];
}
function $2fa92ec193801792$var$__PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}
function $2fa92ec193801792$var$__PRIVATE_fromFieldPathReference(e) {
    return $2fa92ec193801792$export$b9a6b53f9be3734.fromServerFormat(e.fieldPath);
}
function $2fa92ec193801792$var$__PRIVATE_toFilter(e) {
    return e instanceof $2fa92ec193801792$export$d66501df72047452 ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */  === e.op) {
            if ($2fa92ec193801792$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $2fa92ec193801792$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if ($2fa92ec193801792$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $2fa92ec193801792$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === e.op) {
            if ($2fa92ec193801792$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $2fa92ec193801792$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if ($2fa92ec193801792$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $2fa92ec193801792$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: $2fa92ec193801792$var$__PRIVATE_toFieldPathReference(e.field),
                op: $2fa92ec193801792$var$__PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof $2fa92ec193801792$export$e7094788287c5e9b ? function __PRIVATE_toCompositeFilter(e) {
        const t = e.getFilters().map((e)=>$2fa92ec193801792$var$__PRIVATE_toFilter(e));
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: $2fa92ec193801792$var$__PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : $2fa92ec193801792$export$1a82df3d29112e01(54877, {
        filter: e
    });
}
function $2fa92ec193801792$var$__PRIVATE_toDocumentMask(e) {
    const t = [];
    return e.fields.forEach((e)=>t.push(e.canonicalString())), {
        fieldPaths: t
    };
}
function $2fa92ec193801792$var$__PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
function $2fa92ec193801792$var$__PRIVATE_isProtoValueSerializable(// eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    return !!e && "function" == typeof e._toProto && "ProtoValue" === e._protoValueType;
}
function $2fa92ec193801792$var$toMapValue(e, t) {
    const n = {
        fields: {}
    };
    return t.forEach((t, r)=>{
        if ("string" != typeof r) throw new Error(`Cannot encode map with non-string key: ${r}`);
        n.fields[r] = t._toProto(e);
    }), {
        mapValue: n
    };
}
function $2fa92ec193801792$var$__PRIVATE_toStringValue(e) {
    return {
        stringValue: e
    };
}
function $2fa92ec193801792$var$__PRIVATE_toPipelineValue(e) {
    return {
        pipelineValue: e
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2fa92ec193801792$export$b4171a6734a65d42(e) {
    return new $2fa92ec193801792$var$JsonProtoSerializer(e, /* useProto3Json= */ true);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $2fa92ec193801792$export$8a5498727ef6be21 {
    /** @hideconstructor */ constructor(e){
        this._byteString = e;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(e) {
        try {
            return new $2fa92ec193801792$export$8a5498727ef6be21($2fa92ec193801792$export$158acd800e1ef08b.fromBase64String(e));
        } catch (e) {
            throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(e) {
        return new $2fa92ec193801792$export$8a5498727ef6be21($2fa92ec193801792$export$158acd800e1ef08b.fromUint8Array(e));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(e) {
        return this._byteString.isEqual(e._byteString);
    }
    /**
     * Returns a JSON-serializable representation of this `Bytes` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $2fa92ec193801792$export$8a5498727ef6be21._jsonSchemaVersion,
            bytes: this.toBase64()
        };
    }
    /**
     * Builds a `Bytes` instance from a JSON object created by {@link Bytes.toJSON}.
     *
     * @param json - a JSON object represention of a `Bytes` instance
     * @returns an instance of {@link Bytes} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($2fa92ec193801792$export$9bb611d729802a56(e, $2fa92ec193801792$export$8a5498727ef6be21._jsonSchema)) return $2fa92ec193801792$export$8a5498727ef6be21.fromBase64String(e.bytes);
    }
}
$2fa92ec193801792$export$8a5498727ef6be21._jsonSchemaVersion = "firestore/bytes/1.0", $2fa92ec193801792$export$8a5498727ef6be21._jsonSchema = {
    type: $2fa92ec193801792$export$ffb5f4729a158638("string", $2fa92ec193801792$export$8a5498727ef6be21._jsonSchemaVersion),
    bytes: $2fa92ec193801792$export$ffb5f4729a158638("string")
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $2fa92ec193801792$export$90a7f3efeed30595 {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...e){
        for(let t = 0; t < e.length; ++t)if (0 === e[t].length) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $2fa92ec193801792$export$b9a6b53f9be3734(e);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(e) {
        return this._internalPath.isEqual(e._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $2fa92ec193801792$export$9d0e2d13d04f7070() {
    return new $2fa92ec193801792$export$90a7f3efeed30595($2fa92ec193801792$var$Ce);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $2fa92ec193801792$export$3d12bd131bb975d1 {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(e){
        this._methodName = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $2fa92ec193801792$export$91c6e00c14e7e6fd {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(e, t){
        if (!isFinite(e) || e < -90 || e > 90) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this._lat = e, this._long = t;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(e) {
        return this._lat === e._lat && this._long === e._long;
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(e) {
        return $2fa92ec193801792$var$__PRIVATE_primitiveComparator(this._lat, e._lat) || $2fa92ec193801792$var$__PRIVATE_primitiveComparator(this._long, e._long);
    }
    /**
     * Returns a JSON-serializable representation of this `GeoPoint` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long,
            type: $2fa92ec193801792$export$91c6e00c14e7e6fd._jsonSchemaVersion
        };
    }
    /**
     * Builds a `GeoPoint` instance from a JSON object created by {@link GeoPoint.toJSON}.
     *
     * @param json - a JSON object represention of a `GeoPoint` instance
     * @returns an instance of {@link GeoPoint} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($2fa92ec193801792$export$9bb611d729802a56(e, $2fa92ec193801792$export$91c6e00c14e7e6fd._jsonSchema)) return new $2fa92ec193801792$export$91c6e00c14e7e6fd(e.latitude, e.longitude);
    }
}
$2fa92ec193801792$export$91c6e00c14e7e6fd._jsonSchemaVersion = "firestore/geoPoint/1.0", $2fa92ec193801792$export$91c6e00c14e7e6fd._jsonSchema = {
    type: $2fa92ec193801792$export$ffb5f4729a158638("string", $2fa92ec193801792$export$91c6e00c14e7e6fd._jsonSchemaVersion),
    latitude: $2fa92ec193801792$export$ffb5f4729a158638("number"),
    longitude: $2fa92ec193801792$export$ffb5f4729a158638("number")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $2fa92ec193801792$var$User {
    constructor(e){
        this.uid = e;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(e) {
        return e.uid === this.uid;
    }
}
/** A user with a null UID. */ $2fa92ec193801792$var$User.UNAUTHENTICATED = new $2fa92ec193801792$var$User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$2fa92ec193801792$var$User.GOOGLE_CREDENTIALS = new $2fa92ec193801792$var$User("google-credentials-uid"), $2fa92ec193801792$var$User.FIRST_PARTY = new $2fa92ec193801792$var$User("first-party-uid"), $2fa92ec193801792$var$User.MOCK_USER = new $2fa92ec193801792$var$User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$var$__PRIVATE_Deferred {
    constructor(){
        this.promise = new Promise((e, t)=>{
            this.resolve = e, this.reject = t;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$var$__PRIVATE_OAuthToken {
    constructor(e, t){
        this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${e}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $2fa92ec193801792$export$a33b77bbdbb8366c {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(e, t) {
        // Fire with initial user.
        e.enqueueRetryable(()=>t($2fa92ec193801792$var$User.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $2fa92ec193801792$var$__PRIVATE_EmulatorAuthCredentialsProvider {
    constructor(e){
        this.token = e, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(e, t) {
        this.changeListener = t, // Fire with initial user.
        e.enqueueRetryable(()=>t(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
class $2fa92ec193801792$export$71511d61b312f219 {
    constructor(e){
        this.Se = e, /** Tracks the current User. */ this.currentUser = $2fa92ec193801792$var$User.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.De = 0, this.forceRefresh = false, this.auth = null;
    }
    start(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(void 0 === this.xe, 42304);
        let n = this.De;
        // A change listener that prevents double-firing for the same token change.
        const __PRIVATE_guardedChangeListener = (e)=>this.De !== n ? (n = this.De, t(e)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let r = new $2fa92ec193801792$var$__PRIVATE_Deferred;
        this.xe = ()=>{
            this.De++, this.currentUser = this.Ce(), r.resolve(), r = new $2fa92ec193801792$var$__PRIVATE_Deferred, e.enqueueRetryable(()=>__PRIVATE_guardedChangeListener(this.currentUser));
        };
        const __PRIVATE_awaitNextToken = ()=>{
            const t = r;
            e.enqueueRetryable(async ()=>{
                await t.promise, await __PRIVATE_guardedChangeListener(this.currentUser);
            });
        }, __PRIVATE_registerAuth = (e)=>{
            $2fa92ec193801792$export$2329c99376c9d0a4("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = e, this.xe && (this.auth.addAuthTokenListener(this.xe), __PRIVATE_awaitNextToken());
        };
        this.Se.onInit((e)=>__PRIVATE_registerAuth(e)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const e = this.Se.getImmediate({
                    optional: true
                });
                e ? __PRIVATE_registerAuth(e) : // If auth is still not available, proceed with `null` user
                ($2fa92ec193801792$export$2329c99376c9d0a4("FirebaseAuthCredentialsProvider", "Auth not yet detected"), r.resolve(), r = new $2fa92ec193801792$var$__PRIVATE_Deferred);
            }
        }, 0), __PRIVATE_awaitNextToken();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const e = this.De, t = this.forceRefresh;
        return this.forceRefresh = false, this.auth ? this.auth.getToken(t).then((t)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.De !== e ? ($2fa92ec193801792$export$2329c99376c9d0a4("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : t ? ($2fa92ec193801792$var$__PRIVATE_hardAssert("string" == typeof t.accessToken, 31837, {
                Fe: t
            }), new $2fa92ec193801792$var$__PRIVATE_OAuthToken(t.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = true;
    }
    shutdown() {
        this.auth && this.xe && this.auth.removeAuthTokenListener(this.xe), this.xe = void 0;
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    Ce() {
        const e = this.auth && this.auth.getUid();
        return $2fa92ec193801792$var$__PRIVATE_hardAssert(null === e || "string" == typeof e, 2055, {
            Oe: e
        }), new $2fa92ec193801792$var$User(e);
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $2fa92ec193801792$var$__PRIVATE_FirstPartyToken {
    constructor(e, t, n){
        this.Me = e, this.Ne = t, this.Le = n, this.type = "FirstParty", this.user = $2fa92ec193801792$var$User.FIRST_PARTY, this.Be = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ Ue() {
        return this.Le ? this.Le() : null;
    }
    get headers() {
        this.Be.set("X-Goog-AuthUser", this.Me);
        // Use array notation to prevent minification
        const e = this.Ue();
        return e && this.Be.set("Authorization", e), this.Ne && this.Be.set("X-Goog-Iam-Authorization-Token", this.Ne), this.Be;
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $2fa92ec193801792$var$__PRIVATE_FirstPartyAuthCredentialsProvider {
    constructor(e, t, n){
        this.Me = e, this.Ne = t, this.Le = n;
    }
    getToken() {
        return Promise.resolve(new $2fa92ec193801792$var$__PRIVATE_FirstPartyToken(this.Me, this.Ne, this.Le));
    }
    start(e, t) {
        // Fire with initial uid.
        e.enqueueRetryable(()=>t($2fa92ec193801792$var$User.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class $2fa92ec193801792$var$AppCheckToken {
    constructor(e){
        this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class $2fa92ec193801792$export$407448d2b89b1813 {
    constructor(e, t){
        this.ke = t, this.forceRefresh = false, this.appCheck = null, this.qe = null, this.$e = null, (0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(e) && e.settings.appCheckToken && (this.$e = e.settings.appCheckToken);
    }
    start(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(void 0 === this.xe, 3512);
        const onTokenChanged = (e)=>{
            null != e.error && $2fa92ec193801792$export$2329c99376c9d0a4("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);
            const n = e.token !== this.qe;
            return this.qe = e.token, $2fa92ec193801792$export$2329c99376c9d0a4("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? t(e.token) : Promise.resolve();
        };
        this.xe = (t)=>{
            e.enqueueRetryable(()=>onTokenChanged(t));
        };
        const __PRIVATE_registerAppCheck = (e)=>{
            $2fa92ec193801792$export$2329c99376c9d0a4("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = e, this.xe && this.appCheck.addTokenListener(this.xe);
        };
        this.ke.onInit((e)=>__PRIVATE_registerAppCheck(e)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const e = this.ke.getImmediate({
                    optional: true
                });
                e ? __PRIVATE_registerAppCheck(e) : // If AppCheck is still not available, proceed without it.
                $2fa92ec193801792$export$2329c99376c9d0a4("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        if (this.$e) return Promise.resolve(new $2fa92ec193801792$var$AppCheckToken(this.$e));
        const e = this.forceRefresh;
        return this.forceRefresh = false, this.appCheck ? this.appCheck.getToken(e).then((e)=>e ? ($2fa92ec193801792$var$__PRIVATE_hardAssert("string" == typeof e.token, 44558, {
                tokenResult: e
            }), this.qe = e.token, new $2fa92ec193801792$var$AppCheckToken(e.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = true;
    }
    shutdown() {
        this.appCheck && this.xe && this.appCheck.removeTokenListener(this.xe), this.xe = void 0;
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class $2fa92ec193801792$export$53a70dd1ebbae346 {
    getToken() {
        return Promise.resolve(new $2fa92ec193801792$var$AppCheckToken(""));
    }
    invalidateToken() {}
    start(e, t) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function $2fa92ec193801792$var$__PRIVATE_cloneLongPollingOptions(e) {
    const t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$var$__PRIVATE_NoopConnectivityMonitor {
    Ke(e) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ const $2fa92ec193801792$var$ht = "ConnectivityMonitor";
/**
 * Browser implementation of ConnectivityMonitor.
 */ class $2fa92ec193801792$var$__PRIVATE_BrowserConnectivityMonitor {
    constructor(){
        this.We = ()=>this.Qe(), this.Ge = ()=>this.ze(), this.je = [], this.He();
    }
    Ke(e) {
        this.je.push(e);
    }
    shutdown() {
        window.removeEventListener("online", this.We), window.removeEventListener("offline", this.Ge);
    }
    He() {
        window.addEventListener("online", this.We), window.addEventListener("offline", this.Ge);
    }
    Qe() {
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$ht, "Network connectivity changed: AVAILABLE");
        for (const e of this.je)e(0 /* NetworkStatus.AVAILABLE */ );
    }
    ze() {
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$ht, "Network connectivity changed: UNAVAILABLE");
        for (const e of this.je)e(1 /* NetworkStatus.UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static Je() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let $2fa92ec193801792$var$Tt = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @returns the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function $2fa92ec193801792$var$__PRIVATE_generateUniqueDebugId() {
    return null === $2fa92ec193801792$var$Tt ? $2fa92ec193801792$var$Tt = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : $2fa92ec193801792$var$Tt++, "0x" + $2fa92ec193801792$var$Tt.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$Pt = "RestConnection", $2fa92ec193801792$var$Rt = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery",
    ExecutePipeline: "executePipeline"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class $2fa92ec193801792$var$__PRIVATE_RestConnection {
    get Ye() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return false;
    }
    constructor(e){
        this.databaseInfo = e, this.databaseId = e.databaseId;
        const t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.Ze = t + "://" + e.host, this.Xe = `projects/${n}/databases/${r}`, this.et = this.databaseId.database === $2fa92ec193801792$var$$e ? `project_id=${n}` : `project_id=${n}&database_id=${r}`;
    }
    tt(e, t, n, r, i) {
        const s = $2fa92ec193801792$var$__PRIVATE_generateUniqueDebugId(), _ = this.nt(e, t.toUriEncodedString());
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$Pt, `Sending RPC '${e}' ${s}:`, _, n);
        const o = {
            "google-cloud-resource-prefix": this.Xe,
            "x-goog-request-params": this.et
        };
        this.rt(o, r, i);
        const { host: a } = new URL(_), u = (0, $029952e65115eee5$export$5b4d24b45140ad90)(a);
        return this.it(e, _, o, n, u).then((t)=>($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$Pt, `Received RPC '${e}' ${s}: `, t), t), (t)=>{
            throw $2fa92ec193801792$export$7f8ddf7c7c20b3cd($2fa92ec193801792$var$Pt, `RPC '${e}' ${s} failed with error: `, t, "url: ", _, "request:", n), t;
        });
    }
    st(e, t, n, r, i, s) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.tt(e, t, n, r, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ rt(e, t, n) {
        if (e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
        // so we need to get its value when we need it in a function.
        function __PRIVATE_getGoogApiClientValue() {
            return "gl-js/ fire/" + $2fa92ec193801792$var$ve;
        }(), // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach((t, n)=>e[n] = t), n && n.headers.forEach((t, n)=>e[n] = t), this.databaseInfo._customHeaders) for (const t of Object.keys(this.databaseInfo._customHeaders))e[t] = this.databaseInfo._customHeaders[t];
    }
    nt(e, t) {
        const n = $2fa92ec193801792$var$Rt[e];
        let r = `${this.Ze}/v1/${t}:${n}`;
        return this.databaseInfo.apiKey && (r = `${r}?key=${encodeURIComponent(this.databaseInfo.apiKey)}`), r;
    }
    /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */ terminate() {
    // No-op
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class $2fa92ec193801792$var$__PRIVATE_StreamBridge {
    constructor(e){
        this._t = e._t, this.ot = e.ot;
    }
    ut(e) {
        this.ct = e;
    }
    lt(e) {
        this.Et = e;
    }
    ht(e) {
        this.Tt = e;
    }
    onMessage(e) {
        this.Pt = e;
    }
    close() {
        this.ot();
    }
    send(e) {
        this._t(e);
    }
    Rt() {
        this.ct();
    }
    It() {
        this.Et();
    }
    At(e) {
        this.Tt(e);
    }
    Vt(e) {
        this.Pt(e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$It = "WebChannelConnection", $2fa92ec193801792$var$__PRIVATE_unguardedEventListen = (e, t, n)=>{
    // TODO(dimond): closure typing seems broken because WebChannel does
    // not implement goog.events.Listenable
    e.listen(t, (e)=>{
        try {
            n(e);
        } catch (e) {
            setTimeout(()=>{
                throw e;
            }, 0);
        }
    });
};
class $2fa92ec193801792$var$__PRIVATE_WebChannelConnection extends $2fa92ec193801792$var$__PRIVATE_RestConnection {
    constructor(e){
        super(e), /** A collection of open WebChannel instances */ this.dt = [], this.forceLongPolling = e.forceLongPolling, this.autoDetectLongPolling = e.autoDetectLongPolling, this.useFetchStreams = e.useFetchStreams, this.longPollingOptions = e.longPollingOptions;
    }
    /**
     * Initialize STAT_EVENT listener once. Subsequent calls are a no-op.
     * getStatEventTarget() returns the same target every time.
     */ static ft() {
        if (!$2fa92ec193801792$var$__PRIVATE_WebChannelConnection.gt) {
            const e = (0, $33cb313d667e3306$export$888d0d9ab79d08fc)();
            $2fa92ec193801792$var$__PRIVATE_unguardedEventListen(e, (0, $33cb313d667e3306$export$d61e24a684f9e51).STAT_EVENT, (e)=>{
                e.stat === (0, $33cb313d667e3306$export$cbbc350c1dfc80cb).PROXY ? $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$It, "STAT_EVENT: detected buffering proxy") : e.stat === (0, $33cb313d667e3306$export$cbbc350c1dfc80cb).NOPROXY && $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$It, "STAT_EVENT: detected no buffering proxy");
            }), $2fa92ec193801792$var$__PRIVATE_WebChannelConnection.gt = true;
        }
    }
    it(e, t, n, r, i) {
        const _ = $2fa92ec193801792$var$__PRIVATE_generateUniqueDebugId();
        return new Promise((i, o)=>{
            const a = new (0, $33cb313d667e3306$export$26404658cda3ee02);
            a.setWithCredentials(true), a.listenOnce((0, $33cb313d667e3306$export$3d7865934588d77e).COMPLETE, ()=>{
                try {
                    switch(a.getLastErrorCode()){
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).NO_ERROR:
                            const t = a.getResponseJson();
                            $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$It, `XHR for RPC '${e}' ${_} received:`, JSON.stringify(t)), i(t);
                            break;
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).TIMEOUT:
                            $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$It, `RPC '${e}' ${_} timed out`), o(new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).HTTP_ERROR:
                            const n = a.getStatus();
                            if ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$It, `RPC '${e}' ${_} failed with status:`, n, "response text:", a.getResponseText()), n > 0) {
                                let e = a.getResponseJson();
                                Array.isArray(e) && (e = e[0]);
                                const t = e?.error;
                                if (t && t.status && t.message) {
                                    const e = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                        const t = e.toLowerCase().replace(/_/g, "-");
                                        return Object.values($2fa92ec193801792$export$db3b6bfb95261072).indexOf(t) >= 0 ? t : $2fa92ec193801792$export$db3b6bfb95261072.UNKNOWN;
                                    }(t.status);
                                    o(new $2fa92ec193801792$export$2408f22a0fab9ae5(e, t.message));
                                } else o(new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.UNKNOWN, "Server responded with status " + a.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            o(new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $2fa92ec193801792$export$1a82df3d29112e01(9055, {
                                yt: e,
                                streamId: _,
                                wt: a.getLastErrorCode(),
                                bt: a.getLastError()
                            });
                    }
                } finally{
                    $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$It, `RPC '${e}' ${_} completed.`);
                }
            });
            const u = JSON.stringify(r);
            $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$It, `RPC '${e}' ${_} sending request:`, r), a.send(t, "POST", u, n, 15);
        });
    }
    vt(e, t, n) {
        const r = $2fa92ec193801792$var$__PRIVATE_generateUniqueDebugId(), i = [
            this.Ze,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            e,
            "/channel"
        ], _ = this.createWebChannelTransport(), o = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: true,
            supportsCrossDomainXhr: true,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        }, a = this.longPollingOptions.timeoutSeconds;
        void 0 !== a && (o.longPollingTimeout = Math.round(1e3 * a)), this.useFetchStreams && (o.useFetchStreams = true), this.rt(o.initMessageHeaders, t, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the encodeInitMessageHeaders option to specify that
        // the headers should instead be encoded in the request's POST payload,
        // which is recognized by the webchannel backend.
        o.encodeInitMessageHeaders = true;
        const u = i.join("");
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$It, `Creating RPC '${e}' stream ${r}: ${u}`, o);
        const c = _.createWebChannel(u, o);
        this.St(c);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let l = false, E = false;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const h = new $2fa92ec193801792$var$__PRIVATE_StreamBridge({
            _t: (t)=>{
                E ? $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$It, `Not sending because RPC '${e}' stream ${r} is closed:`, t) : (l || ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$It, `Opening RPC '${e}' stream ${r} transport.`), c.open(), l = true), $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$It, `RPC '${e}' stream ${r} sending:`, t), c.send(t));
            },
            ot: ()=>c.close()
        });
        return $2fa92ec193801792$var$__PRIVATE_unguardedEventListen(c, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.OPEN, ()=>{
            E || ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$It, `RPC '${e}' stream ${r} transport opened.`), h.Rt());
        }), $2fa92ec193801792$var$__PRIVATE_unguardedEventListen(c, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.CLOSE, ()=>{
            E || (E = !0, $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$It, `RPC '${e}' stream ${r} transport closed`), h.At(), this.Dt(c));
        }), $2fa92ec193801792$var$__PRIVATE_unguardedEventListen(c, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.ERROR, (t)=>{
            E || (E = !0, $2fa92ec193801792$export$7f8ddf7c7c20b3cd($2fa92ec193801792$var$It, `RPC '${e}' stream ${r} transport errored. Name:`, t.name, "Message:", t.message), h.At(new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.UNAVAILABLE, "The operation could not be completed")));
        }), $2fa92ec193801792$var$__PRIVATE_unguardedEventListen(c, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.MESSAGE, (t)=>{
            if (!E) {
                const n = t.data[0];
                $2fa92ec193801792$var$__PRIVATE_hardAssert(!!n, 16349);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const i = n, _ = i?.error || i[0]?.error;
                if (_) {
                    $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$It, `RPC '${e}' stream ${r} received error:`, _);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const t = _.status;
                    let n = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function __PRIVATE_mapCodeFromRpcStatus(e) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const t = $2fa92ec193801792$var$et[e];
                        if (void 0 !== t) return $2fa92ec193801792$var$__PRIVATE_mapCodeFromRpcCode(t);
                    }(t), i = _.message;
                    "NOT_FOUND" === t && i.includes("database") && i.includes("does not exist") && i.includes(this.databaseId.database) && $2fa92ec193801792$export$7f8ddf7c7c20b3cd(`Database '${this.databaseId.database}' not found. Please check your project configuration.`), void 0 === n && (n = $2fa92ec193801792$export$db3b6bfb95261072.INTERNAL, i = "Unknown error status: " + t + " with message " + _.message), // Mark closed so no further events are propagated
                    E = !0, h.At(new $2fa92ec193801792$export$2408f22a0fab9ae5(n, i)), c.close();
                } else $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$It, `RPC '${e}' stream ${r} received:`, n), h.Vt(n);
            }
        }), // Ensure that event listeners are configured for STAT_EVENTs.
        $2fa92ec193801792$var$__PRIVATE_WebChannelConnection.ft(), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            h.It();
        }, 0), h;
    }
    /**
     * Closes and cleans up any resources associated with the connection.
     */ terminate() {
        // If the Firestore instance is terminated, we will explicitly
        // close any remaining open WebChannel instances.
        this.dt.forEach((e)=>e.close()), this.dt = [];
    }
    /**
     * Add a WebChannel instance to the collection of open instances.
     * @param webChannel
     */ St(e) {
        this.dt.push(e);
    }
    /**
     * Remove a WebChannel instance from the collection of open instances.
     * @param webChannel
     */ Dt(e) {
        this.dt = this.dt.filter((t)=>t === e);
    }
    /**
     * Modifies the headers for a request, adding the api key if present,
     * and then calling super.modifyHeadersForRequest
     */ rt(e, t, n) {
        super.rt(e, t, n), // For web channel streams, we want to send the api key in the headers.
        this.databaseInfo.apiKey && (e["x-goog-api-key"] = this.databaseInfo.apiKey);
    }
    /**
     * Wrapped for mocking.
     * @protected
     */ createWebChannelTransport() {
        return (0, $33cb313d667e3306$export$66869136fc133c3a)();
    }
}
/**
 * Track if the STAT_EVENT listener has been initialized.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ function $2fa92ec193801792$var$__PRIVATE_newConnection(e) {
    return new $2fa92ec193801792$var$__PRIVATE_WebChannelConnection(e);
}
/** Return the Platform-specific connectivity monitor. */ $2fa92ec193801792$var$__PRIVATE_WebChannelConnection.gt = false;
/**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $2fa92ec193801792$var$__PRIVATE_ExponentialBackoff {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ e, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ t, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, r = 1.5, i = 6e4){
        this.xt = e, this.timerId = t, this.Ct = n, this.Ft = r, this.Ot = i, this.Mt = 0, this.Nt = null, /** The last backoff attempt, as epoch milliseconds. */ this.Lt = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.Mt = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ Bt() {
        this.Mt = this.Ot;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ Ut(e) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const t = Math.floor(this.Mt + this.kt()), n = Math.max(0, Date.now() - this.Lt), r = Math.max(0, t - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        r > 0 && $2fa92ec193801792$export$2329c99376c9d0a4("ExponentialBackoff", `Backing off for ${r} ms (base delay: ${this.Mt} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`), this.Nt = this.xt.enqueueAfterDelay(this.timerId, r, ()=>(this.Lt = Date.now(), e())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.Mt *= this.Ft, this.Mt < this.Ct && (this.Mt = this.Ct), this.Mt > this.Ot && (this.Mt = this.Ot);
    }
    qt() {
        null !== this.Nt && (this.Nt.skipDelay(), this.Nt = null);
    }
    cancel() {
        null !== this.Nt && (this.Nt.cancel(), this.Nt = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ kt() {
        return (Math.random() - .5) * this.Mt;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$At = "PersistentStream";
/** The time a stream stays open after it is marked idle. */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class $2fa92ec193801792$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s, _, o){
        this.xt = e, this.$t = n, this.Kt = r, this.connection = i, this.authCredentialsProvider = s, this.appCheckCredentialsProvider = _, this.listener = o, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.Wt = 0, this.Qt = null, this.Gt = null, this.stream = null, /**
         * Count of response messages received.
         */ this.zt = 0, this.jt = new $2fa92ec193801792$var$__PRIVATE_ExponentialBackoff(e, t);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ Ht() {
        return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.Jt();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ Jt() {
        return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        this.zt = 0, 4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.Yt();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.Ht() && await this.close(0 /* PersistentStreamState.Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ Zt() {
        this.state = 0 /* PersistentStreamState.Initial */ , this.jt.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ Xt() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.Jt() && null === this.Qt && (this.Qt = this.xt.enqueueAfterDelay(this.$t, 6e4, ()=>this.en()));
    }
    /** Sends a message to the underlying stream. */ tn(e) {
        this.nn(), this.stream.send(e);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async en() {
        if (this.Jt()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* PersistentStreamState.Initial */ );
    }
    /** Marks the stream as active again. */ nn() {
        this.Qt && (this.Qt.cancel(), this.Qt = null);
    }
    /** Cancels the health check delayed operation. */ rn() {
        this.Gt && (this.Gt.cancel(), this.Gt = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(e, t) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.nn(), this.rn(), this.jt.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.Wt++, 4 /* PersistentStreamState.Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.jt.reset() : t && t.code === $2fa92ec193801792$export$db3b6bfb95261072.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        ($2fa92ec193801792$var$__PRIVATE_logError(t.toString()), $2fa92ec193801792$var$__PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), this.jt.Bt()) : t && t.code === $2fa92ec193801792$export$db3b6bfb95261072.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.sn(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = e, // Notify the listener that the stream closed.
        await this.listener.ht(t);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ sn() {}
    auth() {
        this.state = 1 /* PersistentStreamState.Starting */ ;
        const e = this._n(this.Wt), t = this.Wt;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([e, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.Wt === t && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.an(e, n);
        }, (t)=>{
            e(()=>{
                const e = new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.UNKNOWN, "Fetching auth token failed: " + t.message);
                return this.un(e);
            });
        });
    }
    an(e, t) {
        const n = this._n(this.Wt);
        this.stream = this.cn(e, t), this.stream.ut(()=>{
            n(()=>this.listener.ut());
        }), this.stream.lt(()=>{
            n(()=>(this.state = 2 /* PersistentStreamState.Open */ , this.Gt = this.xt.enqueueAfterDelay(this.Kt, 1e4, ()=>(this.Jt() && (this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve())), this.listener.lt()));
        }), this.stream.ht((e)=>{
            n(()=>this.un(e));
        }), this.stream.onMessage((e)=>{
            n(()=>1 == ++this.zt ? this.En(e) : this.onNext(e));
        });
    }
    Yt() {
        this.state = 5 /* PersistentStreamState.Backoff */ , this.jt.Ut(async ()=>{
            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
        });
    }
    // Visible for tests
    un(e) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$At, `close with error: ${e}`), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , e);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ _n(e) {
        return (t)=>{
            this.xt.enqueueAndForget(()=>this.Wt === e ? t() : ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$At, "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class $2fa92ec193801792$var$__PRIVATE_PersistentListenStream extends $2fa92ec193801792$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    cn(e, t) {
        return this.connection.vt("Listen", e, t);
    }
    En(e) {
        return this.onNext(e);
    }
    onNext(e) {
        // A successful response means the stream is healthy
        this.jt.reset();
        const t = $2fa92ec193801792$var$__PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in e)) return $2fa92ec193801792$var$SnapshotVersion.min();
            const t = e.targetChange;
            return t.targetIds && t.targetIds.length ? $2fa92ec193801792$var$SnapshotVersion.min() : t.readTime ? $2fa92ec193801792$var$__PRIVATE_fromVersion(t.readTime) : $2fa92ec193801792$var$SnapshotVersion.min();
        }(e);
        return this.listener.hn(t, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ Tn(e) {
        const t = {};
        t.database = $2fa92ec193801792$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
            let n;
            const r = t.target;
            if (n = $2fa92ec193801792$var$__PRIVATE_targetIsPipelineTarget(r) ? {
                pipelineQuery: $2fa92ec193801792$var$__PRIVATE_toPipelineTarget(e, r)
            } : $2fa92ec193801792$var$__PRIVATE_targetIsDocumentTarget(r) ? {
                documents: $2fa92ec193801792$var$__PRIVATE_toDocumentsTarget(e, r)
            } : {
                query: $2fa92ec193801792$var$__PRIVATE_toQueryTarget(e, r).be
            }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                n.resumeToken = $2fa92ec193801792$var$__PRIVATE_toBytes(e, t.resumeToken);
                const r = $2fa92ec193801792$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            } else if (t.snapshotVersion.compareTo($2fa92ec193801792$var$SnapshotVersion.min()) > 0) {
                // TODO(wuandy): Consider removing above check because it is most likely true.
                // Right now, many tests depend on this behaviour though (leaving min() out
                // of serialization).
                n.readTime = $2fa92ec193801792$var$toTimestamp(e, t.snapshotVersion.toTimestamp());
                const r = $2fa92ec193801792$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            }
            return n;
        }(this.serializer, e);
        const n = $2fa92ec193801792$var$__PRIVATE_toListenRequestLabels(this.serializer, e);
        n && (t.labels = n), this.tn(t);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ Pn(e) {
        const t = {};
        t.database = $2fa92ec193801792$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, this.tn(t);
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class $2fa92ec193801792$var$__PRIVATE_PersistentWriteStream extends $2fa92ec193801792$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get Rn() {
        return this.zt > 0;
    }
    // Override of PersistentStream.start
    start() {
        this.lastStreamToken = void 0, super.start();
    }
    sn() {
        this.Rn && this.In([]);
    }
    cn(e, t) {
        return this.connection.vt("Write", e, t);
    }
    En(e) {
        // Always capture the last stream token.
        return $2fa92ec193801792$var$__PRIVATE_hardAssert(!!e.streamToken, 31322), this.lastStreamToken = e.streamToken, // The first response is always the handshake response
        $2fa92ec193801792$var$__PRIVATE_hardAssert(!e.writeResults || 0 === e.writeResults.length, 55816), this.listener.An();
    }
    onNext(e) {
        // Always capture the last stream token.
        $2fa92ec193801792$var$__PRIVATE_hardAssert(!!e.streamToken, 12678), this.lastStreamToken = e.streamToken, // A successful first write response means the stream is healthy,
        // Note, that we could consider a successful handshake healthy, however,
        // the write itself might be causing an error we want to back off from.
        this.jt.reset();
        const t = $2fa92ec193801792$var$__PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = $2fa92ec193801792$var$__PRIVATE_fromVersion(e.commitTime);
        return this.listener.Vn(n, t);
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ dn() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const e = {};
        e.database = $2fa92ec193801792$var$__PRIVATE_getEncodedDatabaseId(this.serializer), this.tn(e);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ In(e) {
        const t = {
            streamToken: this.lastStreamToken,
            writes: e.map((e)=>$2fa92ec193801792$var$toMutation(this.serializer, e))
        };
        this.tn(t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ class $2fa92ec193801792$var$Datastore {
}
/**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $2fa92ec193801792$var$__PRIVATE_DatastoreImpl extends $2fa92ec193801792$var$Datastore {
    constructor(e, t, n, r){
        super(), this.authCredentials = e, this.appCheckCredentials = t, this.connection = n, this.serializer = r, this.fn = false;
    }
    mn() {
        if (this.fn) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ tt(e, t, n, r) {
        return this.mn(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([i, s])=>this.connection.tt(e, $2fa92ec193801792$var$__PRIVATE_toResourcePath(t, n), r, i, s)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $2fa92ec193801792$export$db3b6bfb95261072.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.UNKNOWN, e.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ st(e, t, n, r, i) {
        return this.mn(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, _])=>this.connection.st(e, $2fa92ec193801792$var$__PRIVATE_toResourcePath(t, n), r, s, _, i)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $2fa92ec193801792$export$db3b6bfb95261072.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.UNKNOWN, e.toString());
        });
    }
    terminate() {
        this.fn = true, this.connection.terminate();
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
function $2fa92ec193801792$var$__PRIVATE_newDatastore(e, t, n, r) {
    return new $2fa92ec193801792$var$__PRIVATE_DatastoreImpl(e, t, n, r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$Vt = "ComponentProvider", $2fa92ec193801792$var$dt = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ function $2fa92ec193801792$var$__PRIVATE_makeDatabaseInfo(e, t, n, r, i) {
    return new $2fa92ec193801792$var$DatabaseInfo(e, t, n, i.host, i.ssl, i.experimentalForceLongPolling, i.experimentalAutoDetectLongPolling, $2fa92ec193801792$var$__PRIVATE_cloneLongPollingOptions(i.experimentalLongPollingOptions), i.useFetchStreams, i.isUsingEmulator, r, i._customHeaders, i.grpcFlowControlWindow);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$ft = {
    didRun: false,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
}, $2fa92ec193801792$var$mt = 41943040;
class $2fa92ec193801792$var$LruParams {
    static withCacheSize(e) {
        return new $2fa92ec193801792$var$LruParams(e, $2fa92ec193801792$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $2fa92ec193801792$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, // The percentage of sequence numbers that we will attempt to collect
    t, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
}
$2fa92ec193801792$var$LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, $2fa92ec193801792$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $2fa92ec193801792$var$LruParams.DEFAULT = new $2fa92ec193801792$var$LruParams($2fa92ec193801792$var$mt, $2fa92ec193801792$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $2fa92ec193801792$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $2fa92ec193801792$var$LruParams.DISABLED = new $2fa92ec193801792$var$LruParams(-1, 0, 0);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class $2fa92ec193801792$var$__PRIVATE_ListenSequence {
    constructor(e, t){
        this.previousValue = e, t && (t.sequenceNumberHandler = (e)=>this.pn(e), this.gn = (e)=>t.writeSequenceNumber(e));
    }
    pn(e) {
        return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
    }
    next() {
        const e = ++this.previousValue;
        return this.gn && this.gn(e), e;
    }
}
$2fa92ec193801792$var$__PRIVATE_ListenSequence.yn = -1;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$pt = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class $2fa92ec193801792$var$PersistenceTransaction {
    constructor(){
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(e) {
        this.onCommittedListeners.push(e);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((e)=>e());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function $2fa92ec193801792$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    if (e.code !== $2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION || e.message !== $2fa92ec193801792$var$pt) throw e;
    $2fa92ec193801792$export$2329c99376c9d0a4("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class $2fa92ec193801792$var$PersistencePromise {
    constructor(e){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = false, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = false, e((e)=>{
            this.isDone = true, this.result = e, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(e);
        }, (e)=>{
            this.isDone = true, this.error = e, this.catchCallback && this.catchCallback(e);
        });
    }
    catch(e) {
        return this.next(void 0, e);
    }
    next(e, t) {
        return this.callbackAttached && $2fa92ec193801792$export$1a82df3d29112e01(59440), this.callbackAttached = true, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new $2fa92ec193801792$var$PersistencePromise((n, r)=>{
            this.nextCallback = (t)=>{
                this.wrapSuccess(e, t).next(n, r);
            }, this.catchCallback = (e)=>{
                this.wrapFailure(t, e).next(n, r);
            };
        });
    }
    toPromise() {
        return new Promise((e, t)=>{
            this.next(e, t);
        });
    }
    wrapUserFunction(e) {
        try {
            const t = e();
            return t instanceof $2fa92ec193801792$var$PersistencePromise ? t : $2fa92ec193801792$var$PersistencePromise.resolve(t);
        } catch (e) {
            return $2fa92ec193801792$var$PersistencePromise.reject(e);
        }
    }
    wrapSuccess(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $2fa92ec193801792$var$PersistencePromise.resolve(t);
    }
    wrapFailure(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $2fa92ec193801792$var$PersistencePromise.reject(t);
    }
    static resolve(e) {
        return new $2fa92ec193801792$var$PersistencePromise((t, n)=>{
            t(e);
        });
    }
    static reject(e) {
        return new $2fa92ec193801792$var$PersistencePromise((t, n)=>{
            n(e);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new $2fa92ec193801792$var$PersistencePromise((t, n)=>{
            let r = 0, i = 0, s = false;
            e.forEach((e)=>{
                ++r, e.next(()=>{
                    ++i, s && i === r && t();
                }, (e)=>n(e));
            }), s = true, i === r && t();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(e) {
        let t = $2fa92ec193801792$var$PersistencePromise.resolve(false);
        for (const n of e)t = t.next((e)=>e ? $2fa92ec193801792$var$PersistencePromise.resolve(e) : n());
        return t;
    }
    static forEach(e, t) {
        const n = [];
        return e.forEach((e, r)=>{
            n.push(t.call(this, e, r));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(e, t) {
        return new $2fa92ec193801792$var$PersistencePromise((n, r)=>{
            const i = e.length, s = new Array(i);
            let _ = 0;
            for(let o = 0; o < i; o++){
                const a = o;
                t(e[a]).next((e)=>{
                    s[a] = e, ++_, _ === i && n(s);
                }, (e)=>r(e));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(e, t) {
        return new $2fa92ec193801792$var$PersistencePromise((n, r)=>{
            const process = ()=>{
                true === e() ? t().next(()=>{
                    process();
                }, r) : n();
            };
            process();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `indexedDB` are guarded by SimpleDb.isAvailable() and getGlobal()
/* eslint-disable no-restricted-globals */ const $2fa92ec193801792$var$gt = "SimpleDb";
/**
 * The maximum number of retry attempts for an IndexedDb transaction that fails
 * with a DOMException.
 */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class $2fa92ec193801792$var$__PRIVATE_SimpleDbTransaction {
    static open(e, t, n, r) {
        try {
            return new $2fa92ec193801792$var$__PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
        } catch (e) {
            throw new $2fa92ec193801792$var$__PRIVATE_IndexedDbTransactionError(t, e);
        }
    }
    constructor(e, t){
        this.action = e, this.transaction = t, this.aborted = false, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.wn = new $2fa92ec193801792$var$__PRIVATE_Deferred, this.transaction.oncomplete = ()=>{
            this.wn.resolve();
        }, this.transaction.onabort = ()=>{
            t.error ? this.wn.reject(new $2fa92ec193801792$var$__PRIVATE_IndexedDbTransactionError(e, t.error)) : this.wn.resolve();
        }, this.transaction.onerror = (t)=>{
            const n = $2fa92ec193801792$var$__PRIVATE_checkForAndReportiOSError(t.target.error);
            this.wn.reject(new $2fa92ec193801792$var$__PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    get bn() {
        return this.wn.promise;
    }
    abort(e) {
        e && this.wn.reject(e), this.aborted || ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$gt, "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = true, this.transaction.abort());
    }
    vn() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = this.transaction;
        this.aborted || "function" != typeof e.commit || e.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(e) {
        const t = this.transaction.objectStore(e);
        return new $2fa92ec193801792$var$__PRIVATE_SimpleDbStore(t);
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class $2fa92ec193801792$var$__PRIVATE_SimpleDb {
    /** Deletes the specified database. */ static delete(e) {
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$gt, "Removing database:", e);
        return $2fa92ec193801792$var$__PRIVATE_wrapRequest((0, $029952e65115eee5$export$a4e55266d2135a7f)().indexedDB.deleteDatabase(e)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static Je() {
        if (!(0, $029952e65115eee5$export$3865db50535c2055)()) return false;
        if ($2fa92ec193801792$var$__PRIVATE_SimpleDb.Sn()) return true;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const e = (0, $029952e65115eee5$export$c36915b22ce77c19)(), t = $2fa92ec193801792$var$__PRIVATE_SimpleDb.Dn(e), n = 0 < t && t < 10, r = $2fa92ec193801792$var$__PRIVATE_getAndroidVersion(e), i = 0 < r && r < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static Sn() {
        return false;
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static xn(e, t) {
        return e.store(t);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static Dn(e) {
        const t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(e, t, n){
        this.name = e, this.version = t, this.Cn = n, this.Fn = null;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === $2fa92ec193801792$var$__PRIVATE_SimpleDb.Dn((0, $029952e65115eee5$export$c36915b22ce77c19)()) && $2fa92ec193801792$var$__PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async On(e) {
        return this.db || ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$gt, "Opening database:", this.name), this.db = await new Promise((t, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const r = indexedDB.open(this.name, this.version);
            r.onsuccess = (e)=>{
                const n = e.target.result;
                t(n);
            }, r.onblocked = ()=>{
                n(new $2fa92ec193801792$var$__PRIVATE_IndexedDbTransactionError(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, r.onerror = (t)=>{
                const r = t.target.error;
                "VersionError" === r.name ? n(new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === r.name ? n(new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + r)) : n(new $2fa92ec193801792$var$__PRIVATE_IndexedDbTransactionError(e, r));
            }, r.onupgradeneeded = (e)=>{
                $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$gt, 'Database "' + this.name + '" requires upgrade from version:', e.oldVersion);
                const t = e.target.result;
                this.Cn.Mn(t, r.transaction, e.oldVersion, this.version).next(()=>{
                    $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$gt, "Database upgrade to version " + this.version + " complete");
                });
            };
        })), this.Nn && (this.db.onversionchange = (e)=>this.Nn(e)), this.db;
    }
    Ln(e) {
        this.Nn = e, this.db && (this.db.onversionchange = (t)=>e(t));
    }
    async runTransaction(e, t, n, r) {
        const i = "readonly" === t;
        let s = 0;
        for(;;){
            ++s;
            try {
                this.db = await this.On(e);
                const t = $2fa92ec193801792$var$__PRIVATE_SimpleDbTransaction.open(this.db, e, i ? "readonly" : "readwrite", n), s = r(t).next((e)=>(t.vn(), e)).catch((e)=>// Abort the transaction if there was an error.
                    (t.abort(e), $2fa92ec193801792$var$PersistencePromise.reject(e))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return s.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await t.bn, s;
            } catch (e) {
                const t = e, n = "FirebaseError" !== t.name && s < 3;
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                if ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$gt, "Transaction failed with error:", t.message, "Retrying:", n), this.close(), !n) return Promise.reject(t);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}
/** Parse User Agent to determine Android version. Returns -1 if not found. */ function $2fa92ec193801792$var$__PRIVATE_getAndroidVersion(e) {
    const t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n);
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class $2fa92ec193801792$var$__PRIVATE_IterationController {
    constructor(e){
        this.Bn = e, this.Un = false, this.kn = null;
    }
    get isDone() {
        return this.Un;
    }
    get qn() {
        return this.kn;
    }
    set cursor(e) {
        this.Bn = e;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.Un = true;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ $n(e) {
        this.kn = e;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return $2fa92ec193801792$var$__PRIVATE_wrapRequest(this.Bn.delete());
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class $2fa92ec193801792$var$__PRIVATE_IndexedDbTransactionError extends $2fa92ec193801792$export$2408f22a0fab9ae5 {
    constructor(e, t){
        super($2fa92ec193801792$export$db3b6bfb95261072.UNAVAILABLE, `IndexedDB transaction '${e}' failed: ${t}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $2fa92ec193801792$var$__PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class $2fa92ec193801792$var$__PRIVATE_SimpleDbStore {
    constructor(e){
        this.store = e;
    }
    put(e, t) {
        let n;
        return void 0 !== t ? ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$gt, "PUT", this.store.name, e, t), n = this.store.put(t, e)) : ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$gt, "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), $2fa92ec193801792$var$__PRIVATE_wrapRequest(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(e) {
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$gt, "ADD", this.store.name, e, e);
        return $2fa92ec193801792$var$__PRIVATE_wrapRequest(this.store.add(e));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(e) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $2fa92ec193801792$var$__PRIVATE_wrapRequest(this.store.get(e)).next((t)=>// Normalize nonexistence to null.
            (void 0 === t && (t = null), $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$gt, "GET", this.store.name, e, t), t));
    }
    delete(e) {
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$gt, "DELETE", this.store.name, e);
        return $2fa92ec193801792$var$__PRIVATE_wrapRequest(this.store.delete(e));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$gt, "COUNT", this.store.name);
        return $2fa92ec193801792$var$__PRIVATE_wrapRequest(this.store.count());
    }
    Kn(e, t) {
        const n = this.options(e, t), r = n.index ? this.store.index(n.index) : this.store;
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster.
        if ("function" == typeof r.getAll) {
            const e = r.getAll(n.range);
            return new $2fa92ec193801792$var$PersistencePromise((t, n)=>{
                e.onerror = (e)=>{
                    n(e.target.error);
                }, e.onsuccess = (e)=>{
                    t(e.target.result);
                };
            });
        }
        {
            const e = this.cursor(n), t = [];
            return this.Wn(e, (e, n)=>{
                t.push(n);
            }).next(()=>t);
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ Qn(e, t) {
        const n = this.store.getAll(e, null === t ? void 0 : t);
        return new $2fa92ec193801792$var$PersistencePromise((e, t)=>{
            n.onerror = (e)=>{
                t(e.target.error);
            }, n.onsuccess = (t)=>{
                e(t.target.result);
            };
        });
    }
    Gn(e, t) {
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$gt, "DELETE ALL", this.store.name);
        const n = this.options(e, t);
        n.zn = false;
        const r = this.cursor(n);
        return this.Wn(r, (e, t, n)=>n.delete());
    }
    jn(e, t) {
        let n;
        t ? n = e : (n = {}, t = e);
        const r = this.cursor(n);
        return this.Wn(r, t);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ Hn(e) {
        const t = this.cursor({});
        return new $2fa92ec193801792$var$PersistencePromise((n, r)=>{
            t.onerror = (e)=>{
                const t = $2fa92ec193801792$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
                r(t);
            }, t.onsuccess = (t)=>{
                const r = t.target.result;
                r ? e(r.primaryKey, r.value).next((e)=>{
                    e ? r.continue() : n();
                }) : n();
            };
        });
    }
    Wn(e, t) {
        const n = [];
        return new $2fa92ec193801792$var$PersistencePromise((r, i)=>{
            e.onerror = (e)=>{
                i(e.target.error);
            }, e.onsuccess = (e)=>{
                const i = e.target.result;
                if (!i) return void r();
                const s = new $2fa92ec193801792$var$__PRIVATE_IterationController(i), _ = t(i.primaryKey, i.value, s);
                if (_ instanceof $2fa92ec193801792$var$PersistencePromise) {
                    const e = _.catch((e)=>(s.done(), $2fa92ec193801792$var$PersistencePromise.reject(e)));
                    n.push(e);
                }
                s.isDone ? r() : null === s.qn ? i.continue() : i.continue(s.qn);
            };
        }).next(()=>$2fa92ec193801792$var$PersistencePromise.waitFor(n));
    }
    options(e, t) {
        let n;
        return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
            index: n,
            range: t
        };
    }
    cursor(e) {
        let t = "next";
        if (e.reverse && (t = "prev"), e.index) {
            const n = this.store.index(e.index);
            return e.zn ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
        }
        return this.store.openCursor(e.range, t);
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $2fa92ec193801792$var$__PRIVATE_wrapRequest(e) {
    return new $2fa92ec193801792$var$PersistencePromise((t, n)=>{
        e.onsuccess = (e)=>{
            const n = e.target.result;
            t(n);
        }, e.onerror = (e)=>{
            const t = $2fa92ec193801792$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    });
}
// Guard so we only report the error once.
let $2fa92ec193801792$var$yt = false;
function $2fa92ec193801792$var$__PRIVATE_checkForAndReportiOSError(e) {
    const t = $2fa92ec193801792$var$__PRIVATE_SimpleDb.Dn((0, $029952e65115eee5$export$c36915b22ce77c19)());
    if (t >= 12.2 && t < 13) {
        const t = "An internal error was encountered in the Indexed Database server";
        if (e.message.indexOf(t) >= 0) {
            // Wrap error in a more descriptive one.
            const e = new $2fa92ec193801792$export$2408f22a0fab9ae5("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${t}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return $2fa92ec193801792$var$yt || ($2fa92ec193801792$var$yt = true, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw e;
            }, 0)), e;
        }
    }
    return e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$wt = "LruGarbageCollector", $2fa92ec193801792$var$bt = 1048576;
function $2fa92ec193801792$var$__PRIVATE_bufferEntryComparator([e, t], [n, r]) {
    const i = $2fa92ec193801792$var$__PRIVATE_primitiveComparator(e, n);
    return 0 === i ? $2fa92ec193801792$var$__PRIVATE_primitiveComparator(t, r) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class $2fa92ec193801792$var$__PRIVATE_RollingSequenceNumberBuffer {
    constructor(e){
        this.Jn = e, this.buffer = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$var$__PRIVATE_bufferEntryComparator), this.Yn = 0;
    }
    Zn() {
        return ++this.Yn;
    }
    Xn(e) {
        const t = [
            e,
            this.Zn()
        ];
        if (this.buffer.size < this.Jn) this.buffer = this.buffer.add(t);
        else {
            const e = this.buffer.last();
            $2fa92ec193801792$var$__PRIVATE_bufferEntryComparator(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class $2fa92ec193801792$var$__PRIVATE_LruScheduler {
    constructor(e, t, n){
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.er = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.tr(6e4);
    }
    stop() {
        this.er && (this.er.cancel(), this.er = null);
    }
    get started() {
        return null !== this.er;
    }
    tr(e) {
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$wt, `Garbage collection scheduled in ${e}ms`), this.er = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, async ()=>{
            this.er = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (e) {
                $2fa92ec193801792$var$__PRIVATE_isIndexedDbTransactionError(e) ? $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$wt, "Ignoring IndexedDB error during garbage collection: ", e) : await $2fa92ec193801792$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.tr(3e5);
        });
    }
}
/**
 * Implements the steps for LRU garbage collection.
 */ class $2fa92ec193801792$var$__PRIVATE_LruGarbageCollectorImpl {
    constructor(e, t){
        this.nr = e, this.params = t;
    }
    calculateTargetCount(e, t) {
        return this.nr.rr(e).next((e)=>Math.floor(t / 100 * e));
    }
    nthSequenceNumber(e, t) {
        if (0 === t) return $2fa92ec193801792$var$PersistencePromise.resolve($2fa92ec193801792$var$__PRIVATE_ListenSequence.yn);
        const n = new $2fa92ec193801792$var$__PRIVATE_RollingSequenceNumberBuffer(t);
        return this.nr.forEachTarget(e, (e)=>n.Xn(e.sequenceNumber)).next(()=>this.nr.ir(e, (e)=>n.Xn(e))).next(()=>n.maxValue);
    }
    removeTargets(e, t, n) {
        return this.nr.removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        return this.nr.removeOrphanedDocuments(e, t);
    }
    collect(e, t) {
        return -1 === this.params.cacheSizeCollectionThreshold ? ($2fa92ec193801792$export$2329c99376c9d0a4("LruGarbageCollector", "Garbage collection skipped; disabled"), $2fa92ec193801792$var$PersistencePromise.resolve($2fa92ec193801792$var$ft)) : this.getCacheSize(e).next((n)=>n < this.params.cacheSizeCollectionThreshold ? ($2fa92ec193801792$export$2329c99376c9d0a4("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), $2fa92ec193801792$var$ft) : this.sr(e, t));
    }
    getCacheSize(e) {
        return this.nr.getCacheSize(e);
    }
    sr(e, t) {
        let n, r, i, s, _, o, a;
        const u = Date.now();
        return this.calculateTargetCount(e, this.params.percentileToCollect).next((t)=>// Cap at the configured max
            (t > this.params.maximumSequenceNumbersToCollect ? ($2fa92ec193801792$export$2329c99376c9d0a4("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`), r = this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), this.nthSequenceNumber(e, r))).next((r)=>(n = r, _ = Date.now(), this.removeTargets(e, n, t))).next((t)=>(i = t, o = Date.now(), this.removeOrphanedDocuments(e, n))).next((e)=>{
            if (a = Date.now(), $2fa92ec193801792$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG) $2fa92ec193801792$export$2329c99376c9d0a4("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${s - u}ms\n\tDetermined least recently used ${r} in ` + (_ - s) + "ms\n" + `\tRemoved ${i} targets in ` + (o - _) + "ms\n" + `\tRemoved ${e} documents in ` + (a - o) + "ms\n" + `Total Duration: ${a - u}ms`);
            return $2fa92ec193801792$var$PersistencePromise.resolve({
                didRun: true,
                sequenceNumbersCollected: r,
                targetsRemoved: i,
                documentsRemoved: e
            });
        });
    }
}
function $2fa92ec193801792$var$__PRIVATE_newLruGarbageCollector(e, t) {
    return new $2fa92ec193801792$var$__PRIVATE_LruGarbageCollectorImpl(e, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
const $2fa92ec193801792$var$vt = "firestore.googleapis.com", $2fa92ec193801792$var$St = true;
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $2fa92ec193801792$var$FirestoreSettingsImpl {
    constructor(e){
        if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = $2fa92ec193801792$var$vt, this.ssl = $2fa92ec193801792$var$St;
        } else this.host = e.host, this.ssl = e.ssl ?? $2fa92ec193801792$var$St;
        if (this.isUsingEmulator = void 0 !== e.emulatorOptions, this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, e._customHeaders && (this._customHeaders = {
            ...e._customHeaders
        }), void 0 === e.cacheSizeBytes) this.cacheSizeBytes = $2fa92ec193801792$var$mt;
        else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < $2fa92ec193801792$var$bt) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
        }
        if ($2fa92ec193801792$export$faec65b429be379("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = false : void 0 === e.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = $2fa92ec193801792$var$__PRIVATE_cloneLongPollingOptions(e.experimentalLongPollingOptions ?? {}), function __PRIVATE_validateLongPollingOptions(e) {
            if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds)) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
                if (e.timeoutSeconds < 5) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
                if (e.timeoutSeconds > 30) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams, void 0 !== e.grpcFlowControlWindow) {
            if ("number" != typeof e.grpcFlowControlWindow || e.grpcFlowControlWindow <= 0 || e.grpcFlowControlWindow > 2147483647 || !Number.isInteger(e.grpcFlowControlWindow)) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "grpcFlowControlWindow must be a positive integer and cannot exceed 2147483647");
            this.grpcFlowControlWindow = e.grpcFlowControlWindow;
        }
    }
    isEqual(e) {
        return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && /**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ function __PRIVATE_longPollingOptionsEqual(e, t) {
            return e.timeoutSeconds === t.timeoutSeconds;
        }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams && this.grpcFlowControlWindow === e.grpcFlowControlWindow && function __PRIVATE_customHeadersEqual(e, t) {
            if (e === t) return true;
            if (!e || !t) return false;
            const n = Object.keys(e), r = Object.keys(t);
            if (n.length !== r.length) return false;
            for (const r of n)if (e[r] !== t[r]) return false;
            return true;
        }(this._customHeaders, e._customHeaders);
    }
}
let $2fa92ec193801792$var$Dt = class Firestore {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $2fa92ec193801792$var$FirestoreSettingsImpl({}), this._settingsFrozen = false, this._emulatorOptions = {}, // A task that is assigned when the terminate() is invoked and resolved when
        // all components have shut down. Otherwise, Firestore is not terminated,
        // which can mean either the FirestoreClient is in the process of starting,
        // or restarting.
        this._terminateTask = "notTerminated";
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return "notTerminated" !== this._terminateTask;
    }
    _setSettings(e) {
        if (this._settingsFrozen) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $2fa92ec193801792$var$FirestoreSettingsImpl(e), this._emulatorOptions = e.emulatorOptions || {}, void 0 !== e.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(e) {
            if (!e) return new $2fa92ec193801792$export$a33b77bbdbb8366c;
            switch(e.type){
                case "firstParty":
                    return new $2fa92ec193801792$var$__PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
                case "provider":
                    return e.client;
                default:
                    throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(e.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _getEmulatorOptions() {
        return this._emulatorOptions;
    }
    _freezeSettings() {
        return this._settingsFrozen = true, this._settings;
    }
    _delete() {
        // The `_terminateTask` must be assigned future that completes when
        // terminate is complete. The existence of this future puts SDK in state
        // that will not accept further API interaction.
        return "notTerminated" === this._terminateTask && (this._terminateTask = this._terminate()), this._terminateTask;
    }
    async _restart() {
        // The `_terminateTask` must equal 'notTerminated' after restart to
        // signal that client is in a state that accepts API calls.
        "notTerminated" === this._terminateTask ? await this._terminate() : this._terminateTask = "notTerminated";
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function __PRIVATE_removeComponents(e) {
            const t = $2fa92ec193801792$var$dt.get(e);
            t && ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$Vt, "Removing Datastore"), $2fa92ec193801792$var$dt.delete(e), t.terminate());
        }(this), Promise.resolve();
    }
};
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function $2fa92ec193801792$export$667d3bf0c5f83305(e, t, n, r = {}) {
    e = $2fa92ec193801792$export$df995fae86a55f06(e, $2fa92ec193801792$var$Dt);
    const i = (0, $029952e65115eee5$export$5b4d24b45140ad90)(t), _ = e._getSettings(), o = {
        ..._,
        emulatorOptions: e._getEmulatorOptions()
    }, a = `${t}:${n}`;
    i && (0, $029952e65115eee5$export$c0f0d0ce4283a937)(`https://${a}`), _.host !== $2fa92ec193801792$var$vt && _.host !== a && $2fa92ec193801792$export$7f8ddf7c7c20b3cd("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used.");
    const u = {
        ..._,
        host: a,
        ssl: i,
        emulatorOptions: r
    };
    // No-op if the new configuration matches the current configuration. This supports SSR
    // enviornments which might call `connectFirestoreEmulator` multiple times as a standard practice.
    if (!(0, $029952e65115eee5$export$9cb4719e2e525b7a)(u, o) && (e._setSettings(u), r.mockUserToken)) {
        let t, n;
        if ("string" == typeof r.mockUserToken) t = r.mockUserToken, n = $2fa92ec193801792$var$User.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            t = (0, $029952e65115eee5$export$367bf224123348f1)(r.mockUserToken, e._app?.options.projectId);
            const i = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!i) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new $2fa92ec193801792$var$User(i);
        }
        e._authCredentials = new $2fa92ec193801792$var$__PRIVATE_EmulatorAuthCredentialsProvider(new $2fa92ec193801792$var$__PRIVATE_OAuthToken(t, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $2fa92ec193801792$export$3722cfe417b6ed86 {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = e;
    }
    withConverter(e) {
        return new $2fa92ec193801792$export$3722cfe417b6ed86(this.firestore, e, this._query);
    }
}
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $2fa92ec193801792$export$78acf4525d8a74c4 {
    /** @hideconstructor */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = e;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $2fa92ec193801792$export$28f7fcd39efa255(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(e) {
        return new $2fa92ec193801792$export$78acf4525d8a74c4(this.firestore, e, this._key);
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentReference` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $2fa92ec193801792$export$78acf4525d8a74c4._jsonSchemaVersion,
            referencePath: this._key.toString()
        };
    }
    static fromJSON(e, t, n) {
        if ($2fa92ec193801792$export$9bb611d729802a56(t, $2fa92ec193801792$export$78acf4525d8a74c4._jsonSchema)) return new $2fa92ec193801792$export$78acf4525d8a74c4(e, n || null, new $2fa92ec193801792$export$a07804094c3ecf2d($2fa92ec193801792$export$db202ddc8be9136.fromString(t.referencePath)));
    }
}
$2fa92ec193801792$export$78acf4525d8a74c4._jsonSchemaVersion = "firestore/documentReference/1.0", $2fa92ec193801792$export$78acf4525d8a74c4._jsonSchema = {
    type: $2fa92ec193801792$export$ffb5f4729a158638("string", $2fa92ec193801792$export$78acf4525d8a74c4._jsonSchemaVersion),
    referencePath: $2fa92ec193801792$export$ffb5f4729a158638("string")
};
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class $2fa92ec193801792$export$28f7fcd39efa255 extends $2fa92ec193801792$export$3722cfe417b6ed86 {
    /** @hideconstructor */ constructor(e, t, n){
        super(e, t, $2fa92ec193801792$export$3c2fa207a37baaea(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const e = this._path.popLast();
        return e.isEmpty() ? null : new $2fa92ec193801792$export$78acf4525d8a74c4(this.firestore, /* converter= */ null, new $2fa92ec193801792$export$a07804094c3ecf2d(e));
    }
    withConverter(e) {
        return new $2fa92ec193801792$export$28f7fcd39efa255(this.firestore, e, this._path);
    }
}
function $2fa92ec193801792$export$7060da4b5db56fb9(e) {
    return e instanceof $2fa92ec193801792$export$28f7fcd39efa255;
}
function $2fa92ec193801792$export$738ab4df8bf92ae9(e, t, ...n) {
    if (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e), $2fa92ec193801792$var$__PRIVATE_validateNonEmptyArgument("collection", "path", t), e instanceof $2fa92ec193801792$var$Dt) {
        const r = $2fa92ec193801792$export$db202ddc8be9136.fromString(t, ...n);
        return $2fa92ec193801792$var$__PRIVATE_validateCollectionPath(r), new $2fa92ec193801792$export$28f7fcd39efa255(e, /* converter= */ null, r);
    }
    {
        if (!(e instanceof $2fa92ec193801792$export$78acf4525d8a74c4 || e instanceof $2fa92ec193801792$export$28f7fcd39efa255)) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($2fa92ec193801792$export$db202ddc8be9136.fromString(t, ...n));
        return $2fa92ec193801792$var$__PRIVATE_validateCollectionPath(r), new $2fa92ec193801792$export$28f7fcd39efa255(e.firestore, /* converter= */ null, r);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $2fa92ec193801792$export$d377dcb2b61d6c4e(e, t) {
    if (e = $2fa92ec193801792$export$df995fae86a55f06(e, $2fa92ec193801792$var$Dt), $2fa92ec193801792$var$__PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", t), t.indexOf("/") >= 0) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, `Invalid collection ID '${t}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $2fa92ec193801792$export$3722cfe417b6ed86(e, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new $2fa92ec193801792$var$__PRIVATE_QueryImpl($2fa92ec193801792$export$db202ddc8be9136.emptyPath(), e);
    }(t));
}
function $2fa92ec193801792$export$ebd11618f299a286(e, t, ...n) {
    if (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = $2fa92ec193801792$export$ae1af26003f05816.newId()), $2fa92ec193801792$var$__PRIVATE_validateNonEmptyArgument("doc", "path", t), e instanceof $2fa92ec193801792$var$Dt) {
        const r = $2fa92ec193801792$export$db202ddc8be9136.fromString(t, ...n);
        return $2fa92ec193801792$var$__PRIVATE_validateDocumentPath(r), new $2fa92ec193801792$export$78acf4525d8a74c4(e, /* converter= */ null, new $2fa92ec193801792$export$a07804094c3ecf2d(r));
    }
    {
        if (!(e instanceof $2fa92ec193801792$export$78acf4525d8a74c4 || e instanceof $2fa92ec193801792$export$28f7fcd39efa255)) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Expected first argument to doc() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($2fa92ec193801792$export$db202ddc8be9136.fromString(t, ...n));
        return $2fa92ec193801792$var$__PRIVATE_validateDocumentPath(r), new $2fa92ec193801792$export$78acf4525d8a74c4(e.firestore, e instanceof $2fa92ec193801792$export$28f7fcd39efa255 ? e.converter : null, new $2fa92ec193801792$export$a07804094c3ecf2d(r));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $2fa92ec193801792$export$53c86fa97d611818(e, t) {
    return e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e), t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t), (e instanceof $2fa92ec193801792$export$78acf4525d8a74c4 || e instanceof $2fa92ec193801792$export$28f7fcd39efa255) && (t instanceof $2fa92ec193801792$export$78acf4525d8a74c4 || t instanceof $2fa92ec193801792$export$28f7fcd39efa255) && e.firestore === t.firestore && e.path === t.path && e.converter === t.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $2fa92ec193801792$export$ef35774e6d314e91(e, t) {
    return e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e), t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t), e instanceof $2fa92ec193801792$export$3722cfe417b6ed86 && t instanceof $2fa92ec193801792$export$3722cfe417b6ed86 && e.firestore === t.firestore && $2fa92ec193801792$var$__PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns true iff the array contains the value using strong equality.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a vector type in Firestore documents.
 * Create an instance with <code>{@link vector}</code>.
 */ class $2fa92ec193801792$export$24baa2b76016ce0e {
    /**
     * @private
     * @internal
     */ constructor(e){
        // Making a copy of the parameter.
        this._values = (e || []).map((e)=>e);
    }
    /**
     * Returns a copy of the raw number array form of the vector.
     */ toArray() {
        return this._values.map((e)=>e);
    }
    /**
     * Returns `true` if the two `VectorValue` values have the same raw number arrays, returns `false` otherwise.
     */ isEqual(e) {
        /**
 * Verifies equality for an array of primitives.
 *
 * @private
 * @internal
 * @param left - Array of primitives.
 * @param right - Array of primitives.
 * @returns True if arrays are equal.
 */ return function __PRIVATE_isPrimitiveArrayEqual(e, t) {
            if (e.length !== t.length) return false;
            for(let n = 0; n < e.length; ++n)if (e[n] !== t[n]) return false;
            return true;
        }(this._values, e._values);
    }
    /**
     * Returns a JSON-serializable representation of this `VectorValue` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $2fa92ec193801792$export$24baa2b76016ce0e._jsonSchemaVersion,
            vectorValues: this._values
        };
    }
    /**
     * Builds a `VectorValue` instance from a JSON object created by {@link VectorValue.toJSON}.
     *
     * @param json - a JSON object represention of a `VectorValue` instance.
     * @returns an instance of {@link VectorValue} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($2fa92ec193801792$export$9bb611d729802a56(e, $2fa92ec193801792$export$24baa2b76016ce0e._jsonSchema)) {
            if (Array.isArray(e.vectorValues) && e.vectorValues.every((e)=>"number" == typeof e)) return new $2fa92ec193801792$export$24baa2b76016ce0e(e.vectorValues);
            throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Expected 'vectorValues' field to be a number array");
        }
    }
}
$2fa92ec193801792$export$24baa2b76016ce0e._jsonSchemaVersion = "firestore/vectorValue/1.0", $2fa92ec193801792$export$24baa2b76016ce0e._jsonSchema = {
    type: $2fa92ec193801792$export$ffb5f4729a158638("string", $2fa92ec193801792$export$24baa2b76016ce0e._jsonSchemaVersion),
    vectorValues: $2fa92ec193801792$export$ffb5f4729a158638("object")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$xt = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $2fa92ec193801792$var$ParsedSetData {
    constructor(e, t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return null !== this.fieldMask ? new $2fa92ec193801792$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new $2fa92ec193801792$var$__PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $2fa92ec193801792$var$ParsedUpdateData {
    constructor(e, // The fieldMask does not include document transforms.
    t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return new $2fa92ec193801792$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
    }
}
function $2fa92ec193801792$var$__PRIVATE_isWrite(e) {
    switch(e){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return true;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return false;
        default:
            throw $2fa92ec193801792$export$1a82df3d29112e01(40011, {
                dataSource: e
            });
    }
}
/** A "context" object passed around while parsing user data. */ class $2fa92ec193801792$var$ParseContextImpl {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(e, t, n, r, i, s){
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.validatePath(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    get path() {
        return this.settings.path;
    }
    get dataSource() {
        return this.settings.dataSource;
    }
    /** Returns a new context with the specified settings overwritten. */ contextWith(e) {
        return new $2fa92ec193801792$var$ParseContextImpl({
            ...this.settings,
            ...e
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    childContextForField(e) {
        const t = this.path?.child(e), n = this.contextWith({
            path: t,
            arrayElement: false
        });
        return n.validatePathSegment(e), n;
    }
    childContextForFieldPath(e) {
        const t = this.path?.child(e), n = this.contextWith({
            path: t,
            arrayElement: false
        });
        return n.validatePath(), n;
    }
    childContextForArray(e) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.contextWith({
            path: void 0,
            arrayElement: true
        });
    }
    createError(e) {
        return $2fa92ec193801792$var$createError(e, this.settings.methodName, this.settings.hasConverter || false, this.path, this.settings.targetDoc);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(e) {
        return void 0 !== this.fieldMask.find((t)=>e.isPrefixOf(t)) || void 0 !== this.fieldTransforms.find((t)=>e.isPrefixOf(t.field));
    }
    validatePath() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let e = 0; e < this.path.length; e++)this.validatePathSegment(this.path.get(e));
    }
    validatePathSegment(e) {
        if (0 === e.length) throw this.createError("Document fields must not be empty");
        if ($2fa92ec193801792$var$__PRIVATE_isWrite(this.dataSource) && $2fa92ec193801792$var$xt.test(e)) throw this.createError('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $2fa92ec193801792$var$UserDataReader {
    constructor(e, t, n){
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || $2fa92ec193801792$export$b4171a6734a65d42(e);
    }
    /** Creates a new top-level parse context. */ createContext(e, t, n, r = false) {
        return new $2fa92ec193801792$var$ParseContextImpl({
            dataSource: e,
            methodName: t,
            targetDoc: n,
            path: $2fa92ec193801792$export$b9a6b53f9be3734.emptyPath(),
            arrayElement: false,
            hasConverter: r
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}
function $2fa92ec193801792$export$882b5998b3b9117c(e) {
    const t = e._freezeSettings(), n = $2fa92ec193801792$export$b4171a6734a65d42(e._databaseId);
    return new $2fa92ec193801792$var$UserDataReader(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $2fa92ec193801792$export$43caf9889c228507(e, t, n, r, i, _ = {}) {
    const o = e.createContext(_.merge || _.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , t, n, i);
    $2fa92ec193801792$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", o, r);
    const a = $2fa92ec193801792$var$__PRIVATE_parseObject(r, o);
    let u, c;
    if (_.merge) u = new $2fa92ec193801792$var$FieldMask(o.fieldMask), c = o.fieldTransforms;
    else if (_.mergeFields) {
        const e = [];
        for (const r of _.mergeFields){
            const i = $2fa92ec193801792$export$625550452a3fa3ec(t, r, n);
            if (!o.contains(i)) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $2fa92ec193801792$var$__PRIVATE_fieldMaskContains(e, i) || e.push(i);
        }
        u = new $2fa92ec193801792$var$FieldMask(e), c = o.fieldTransforms.filter((e)=>u.covers(e.field));
    } else u = null, c = o.fieldTransforms;
    return new $2fa92ec193801792$var$ParsedSetData(new $2fa92ec193801792$export$c4ce752e73470fba(a), u, c);
}
class $2fa92ec193801792$var$__PRIVATE_DeleteFieldValueImpl extends $2fa92ec193801792$export$3d12bd131bb975d1 {
    _toFieldTransform(e) {
        if (2 /* UserDataSource.MergeSet */  !== e.dataSource) throw 1 /* UserDataSource.Update */  === e.dataSource ? e.createError(`${this._methodName}() can only appear at the top level of your update data`) : e.createError(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return e.fieldMask.push(e.path), null;
    }
    isEqual(e) {
        return e instanceof $2fa92ec193801792$var$__PRIVATE_DeleteFieldValueImpl;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $2fa92ec193801792$var$__PRIVATE_createSentinelChildContext(e, t, n) {
    return new $2fa92ec193801792$var$ParseContextImpl({
        dataSource: 3 /* UserDataSource.Argument */ ,
        targetDoc: t.settings.targetDoc,
        methodName: e._methodName,
        arrayElement: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
class $2fa92ec193801792$var$__PRIVATE_ServerTimestampFieldValueImpl extends $2fa92ec193801792$export$3d12bd131bb975d1 {
    _toFieldTransform(e) {
        return new $2fa92ec193801792$var$FieldTransform(e.path, new $2fa92ec193801792$var$__PRIVATE_ServerTimestampTransform);
    }
    isEqual(e) {
        return e instanceof $2fa92ec193801792$var$__PRIVATE_ServerTimestampFieldValueImpl;
    }
}
class $2fa92ec193801792$var$__PRIVATE_ArrayUnionFieldValueImpl extends $2fa92ec193801792$export$3d12bd131bb975d1 {
    constructor(e, t){
        super(e), this._r = t;
    }
    _toFieldTransform(e) {
        const t = $2fa92ec193801792$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ true), n = this._r.map((e)=>$2fa92ec193801792$var$__PRIVATE_parseData(e, t)), r = new $2fa92ec193801792$var$__PRIVATE_ArrayUnionTransformOperation(n);
        return new $2fa92ec193801792$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $2fa92ec193801792$var$__PRIVATE_ArrayUnionFieldValueImpl && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(this._r, e._r);
    }
}
class $2fa92ec193801792$var$__PRIVATE_ArrayRemoveFieldValueImpl extends $2fa92ec193801792$export$3d12bd131bb975d1 {
    constructor(e, t){
        super(e), this._r = t;
    }
    _toFieldTransform(e) {
        const t = $2fa92ec193801792$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ true), n = this._r.map((e)=>$2fa92ec193801792$var$__PRIVATE_parseData(e, t)), r = new $2fa92ec193801792$var$__PRIVATE_ArrayRemoveTransformOperation(n);
        return new $2fa92ec193801792$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $2fa92ec193801792$var$__PRIVATE_ArrayRemoveFieldValueImpl && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(this._r, e._r);
    }
}
class $2fa92ec193801792$var$__PRIVATE_NumericIncrementFieldValueImpl extends $2fa92ec193801792$export$3d12bd131bb975d1 {
    constructor(e, t){
        super(e), this.ar = t;
    }
    _toFieldTransform(e) {
        const t = new $2fa92ec193801792$var$__PRIVATE_NumericIncrementTransformOperation(e.serializer, $2fa92ec193801792$var$toNumber(e.serializer, this.ar));
        return new $2fa92ec193801792$var$FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof $2fa92ec193801792$var$__PRIVATE_NumericIncrementFieldValueImpl && (this.ar === e.ar || Number.isNaN(this.ar) && Number.isNaN(e.ar));
    }
}
class $2fa92ec193801792$var$__PRIVATE_NumericMinimumFieldValueImpl extends $2fa92ec193801792$export$3d12bd131bb975d1 {
    constructor(e, t){
        super(e), this.ar = t;
    }
    _toFieldTransform(e) {
        const t = new $2fa92ec193801792$var$__PRIVATE_NumericMinimumTransformOperation(e.serializer, $2fa92ec193801792$var$toNumber(e.serializer, this.ar));
        return new $2fa92ec193801792$var$FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof $2fa92ec193801792$var$__PRIVATE_NumericMinimumFieldValueImpl && (this.ar === e.ar || Number.isNaN(this.ar) && Number.isNaN(e.ar));
    }
}
class $2fa92ec193801792$var$__PRIVATE_NumericMaximumFieldValueImpl extends $2fa92ec193801792$export$3d12bd131bb975d1 {
    constructor(e, t){
        super(e), this.ar = t;
    }
    _toFieldTransform(e) {
        const t = new $2fa92ec193801792$var$__PRIVATE_NumericMaximumTransformOperation(e.serializer, $2fa92ec193801792$var$toNumber(e.serializer, this.ar));
        return new $2fa92ec193801792$var$FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof $2fa92ec193801792$var$__PRIVATE_NumericMaximumFieldValueImpl && (this.ar === e.ar || Number.isNaN(this.ar) && Number.isNaN(e.ar));
    }
}
/** Parse update data from an update() call. */ function $2fa92ec193801792$export$d141bba7fdc215a3(e, t, n, r) {
    const i = e.createContext(1 /* UserDataSource.Update */ , t, n);
    $2fa92ec193801792$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    const s = [], _ = $2fa92ec193801792$export$c4ce752e73470fba.empty();
    $2fa92ec193801792$var$forEach(r, (e, r)=>{
        const o = $2fa92ec193801792$export$555508cbc6add439(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(r);
        const a = i.childContextForFieldPath(o);
        if (r instanceof $2fa92ec193801792$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(o);
        else {
            const e = $2fa92ec193801792$var$__PRIVATE_parseData(r, a);
            null != e && (s.push(o), _.set(o, e));
        }
    });
    const o = new $2fa92ec193801792$var$FieldMask(s);
    return new $2fa92ec193801792$var$ParsedUpdateData(_, o, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $2fa92ec193801792$export$efccba1c4a2ef57b(e, t, n, r, i, _) {
    const o = e.createContext(1 /* UserDataSource.Update */ , t, n), a = [
        $2fa92ec193801792$export$625550452a3fa3ec(t, r, n)
    ], u = [
        i
    ];
    if (_.length % 2 != 0) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let e = 0; e < _.length; e += 2)a.push($2fa92ec193801792$export$625550452a3fa3ec(t, _[e])), u.push(_[e + 1]);
    const c = [], l = $2fa92ec193801792$export$c4ce752e73470fba.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let e = a.length - 1; e >= 0; --e)if (!$2fa92ec193801792$var$__PRIVATE_fieldMaskContains(c, a[e])) {
        const t = a[e];
        let n = u[e];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(n);
        const r = o.childContextForFieldPath(t);
        if (n instanceof $2fa92ec193801792$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        c.push(t);
        else {
            const e = $2fa92ec193801792$var$__PRIVATE_parseData(n, r);
            null != e && (c.push(t), l.set(t, e));
        }
    }
    const E = new $2fa92ec193801792$var$FieldMask(c);
    return new $2fa92ec193801792$var$ParsedUpdateData(l, E, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $2fa92ec193801792$export$39b482c5e57630a8(e, t, n, r = false) {
    return $2fa92ec193801792$var$__PRIVATE_parseData(n, e.createContext(r ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , t));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $2fa92ec193801792$var$__PRIVATE_parseData(e, t, r) {
    if ($2fa92ec193801792$var$__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e))) return $2fa92ec193801792$var$__PRIVATE_validatePlainObject("Unsupported field value:", t, e), $2fa92ec193801792$var$__PRIVATE_parseObject(e, t);
    if (e instanceof $2fa92ec193801792$export$3d12bd131bb975d1) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$2fa92ec193801792$var$__PRIVATE_isWrite(t.dataSource)) throw t.createError(`${e._methodName}() can only be used with update() and set()`);
        if (!t.path) throw t.createError(`${e._methodName}() is not currently supported inside arrays`);
        const n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }(e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.arrayElement && 4 /* UserDataSource.ArrayArgument */  !== t.dataSource) throw t.createError("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            const n = [];
            let r = 0;
            for (const i of e){
                let e = $2fa92ec193801792$var$__PRIVATE_parseData(i, t.childContextForArray(r));
                null == e && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (e = {
                    nullValue: "NULL_VALUE"
                }), n.push(e), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t, r) {
        if (null === (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return $2fa92ec193801792$var$toNumber(t.serializer, e);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            const n = $2fa92ec193801792$export$890c4ad488842ce7.fromDate(e);
            return {
                timestampValue: $2fa92ec193801792$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $2fa92ec193801792$export$890c4ad488842ce7) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new $2fa92ec193801792$export$890c4ad488842ce7(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: $2fa92ec193801792$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $2fa92ec193801792$export$91c6e00c14e7e6fd) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof $2fa92ec193801792$export$8a5498727ef6be21) return {
            bytesValue: $2fa92ec193801792$var$__PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof $2fa92ec193801792$export$78acf4525d8a74c4) {
            const n = t.databaseId, r = e.firestore._databaseId;
            if (!r.isEqual(n)) throw t.createError(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: $2fa92ec193801792$var$__PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        if (e instanceof $2fa92ec193801792$export$24baa2b76016ce0e) /**
 * Creates a new VectorValue proto value (using the internal format).
 */ return function __PRIVATE_parseVectorValue(e, t) {
            const r = e instanceof $2fa92ec193801792$export$24baa2b76016ce0e ? e.toArray() : e, i = {
                fields: {
                    [$2fa92ec193801792$var$We]: {
                        stringValue: $2fa92ec193801792$var$ze
                    },
                    [$2fa92ec193801792$var$je]: {
                        arrayValue: {
                            values: r.map((e)=>{
                                if ("number" != typeof e) throw t.createError("VectorValues must only contain numeric values.");
                                return $2fa92ec193801792$var$__PRIVATE_toDouble(t.serializer, e);
                            })
                        }
                    }
                }
            };
            return {
                mapValue: i
            };
        }(e, t);
        if ($2fa92ec193801792$var$__PRIVATE_isProtoValueSerializable(e)) return e._toProto(t.serializer);
        throw t.createError(`Unsupported field value: ${$2fa92ec193801792$export$ab83b03e4111b1d0(e)}`);
    }(e, t);
}
function $2fa92ec193801792$var$__PRIVATE_parseObject(e, t) {
    const n = {};
    return $2fa92ec193801792$var$isEmpty(e) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : $2fa92ec193801792$var$forEach(e, (e, r)=>{
        const i = $2fa92ec193801792$var$__PRIVATE_parseData(r, t.childContextForField(e));
        null != i && (n[e] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $2fa92ec193801792$var$__PRIVATE_looksLikeJsonObject(e) {
    return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof $2fa92ec193801792$export$890c4ad488842ce7 || e instanceof $2fa92ec193801792$export$91c6e00c14e7e6fd || e instanceof $2fa92ec193801792$export$8a5498727ef6be21 || e instanceof $2fa92ec193801792$export$78acf4525d8a74c4 || e instanceof $2fa92ec193801792$export$3d12bd131bb975d1 || e instanceof $2fa92ec193801792$export$24baa2b76016ce0e || $2fa92ec193801792$var$__PRIVATE_isProtoValueSerializable(e));
}
function $2fa92ec193801792$var$__PRIVATE_validatePlainObject(e, t, n) {
    if (!$2fa92ec193801792$var$__PRIVATE_looksLikeJsonObject(n) || !$2fa92ec193801792$export$ebb8f7cd71856fb9(n)) {
        const r = $2fa92ec193801792$export$ab83b03e4111b1d0(n);
        throw "an object" === r ? t.createError(e + " a custom object") : t.createError(e + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $2fa92ec193801792$export$625550452a3fa3ec(e, t, n) {
    if (// If required, replace the FieldPath Compat class with the firestore-exp
    // FieldPath.
    (t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t)) instanceof $2fa92ec193801792$export$90a7f3efeed30595) return t._internalPath;
    if ("string" == typeof t) return $2fa92ec193801792$export$555508cbc6add439(e, t);
    throw $2fa92ec193801792$var$createError("Field path arguments must be of type string or ", e, /* hasConverter= */ false, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $2fa92ec193801792$var$Ct = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $2fa92ec193801792$export$555508cbc6add439(e, t, n) {
    if (t.search($2fa92ec193801792$var$Ct) >= 0) throw $2fa92ec193801792$var$createError(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, /* hasConverter= */ false, /* path= */ void 0, n);
    try {
        return new $2fa92ec193801792$export$90a7f3efeed30595(...t.split("."))._internalPath;
    } catch (r) {
        throw $2fa92ec193801792$var$createError(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, /* hasConverter= */ false, /* path= */ void 0, n);
    }
}
function $2fa92ec193801792$var$createError(e, t, n, r, i) {
    const _ = r && !r.isEmpty(), o = void 0 !== i;
    let a = `Function ${t}() called with invalid data`;
    n && (a += " (via `toFirestore()`)"), a += ". ";
    let u = "";
    return (_ || o) && (u += " (found", _ && (u += ` in field ${r}`), o && (u += ` in document ${i}`), u += ")"), new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, a + e + u);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $2fa92ec193801792$var$__PRIVATE_fieldMaskContains(e, t) {
    return e.some((e)=>e.isEqual(t));
}
function $2fa92ec193801792$var$__PRIVATE_isUserData(e) {
    return "function" == typeof e._readUserData;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$var$OptionsUtil {
    constructor(e){
        this.optionDefinitions = e;
    }
    _getKnownOptions(e, t) {
        const n = $2fa92ec193801792$export$c4ce752e73470fba.empty();
        // SERIALIZE KNOWN OPTIONS
        for(const r in this.optionDefinitions)if (this.optionDefinitions.hasOwnProperty(r)) {
            const i = this.optionDefinitions[r];
            if (r in e) {
                const s = e[r];
                let _;
                if (i.nestedOptions && $2fa92ec193801792$export$ebb8f7cd71856fb9(s)) _ = {
                    mapValue: {
                        fields: new $2fa92ec193801792$var$OptionsUtil(i.nestedOptions).getOptionsProto(t, s)
                    }
                };
                else s && (_ = $2fa92ec193801792$var$__PRIVATE_parseData(s, t) ?? void 0);
                _ && n.set($2fa92ec193801792$export$b9a6b53f9be3734.fromServerFormat(i.serverName), _);
            }
        }
        return n;
    }
    getOptionsProto(e, t, n) {
        const r = this._getKnownOptions(t, e);
        // APPLY OPTIONS OVERRIDES
        if (n) {
            const t = new Map($2fa92ec193801792$export$971d5caa766a69d7(n, (t, n)=>[
                    $2fa92ec193801792$export$b9a6b53f9be3734.fromServerFormat(n),
                    void 0 !== t ? $2fa92ec193801792$var$__PRIVATE_parseData(t, e) : null
                ]));
            r.setAll(t);
        }
        // Return MapValue from `result` or empty map value
        return r.value.mapValue.fields ?? {};
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint @typescript-eslint/no-explicit-any: 0 */ function $2fa92ec193801792$export$993a080e5cb62d74(e) {
    return "object" == typeof e && null !== e && !!("nullValue" in e && (null === e.nullValue || "NULL_VALUE" === e.nullValue) || "booleanValue" in e && (null === e.booleanValue || "boolean" == typeof e.booleanValue) || "integerValue" in e && (null === e.integerValue || "number" == typeof e.integerValue || "string" == typeof e.integerValue) || "doubleValue" in e && (null === e.doubleValue || "number" == typeof e.doubleValue) || "timestampValue" in e && (null === e.timestampValue || function __PRIVATE_isITimestamp(e) {
        return "object" == typeof e && null !== e && "seconds" in e && (null === e.seconds || "number" == typeof e.seconds || "string" == typeof e.seconds) && "nanos" in e && (null === e.nanos || "number" == typeof e.nanos);
    }(e.timestampValue)) || "stringValue" in e && (null === e.stringValue || "string" == typeof e.stringValue) || "bytesValue" in e && (null === e.bytesValue || e.bytesValue instanceof Uint8Array) || "referenceValue" in e && (null === e.referenceValue || "string" == typeof e.referenceValue) || "geoPointValue" in e && (null === e.geoPointValue || function __PRIVATE_isILatLng(e) {
        return "object" == typeof e && null !== e && "latitude" in e && (null === e.latitude || "number" == typeof e.latitude) && "longitude" in e && (null === e.longitude || "number" == typeof e.longitude);
    }(e.geoPointValue)) || "arrayValue" in e && (null === e.arrayValue || function __PRIVATE_isIArrayValue(e) {
        return "object" == typeof e && null !== e && !(!("values" in e) || null !== e.values && !Array.isArray(e.values));
    }(e.arrayValue)) || "mapValue" in e && (null === e.mapValue || function __PRIVATE_isIMapValue(e) {
        return "object" == typeof e && null !== e && !(!("fields" in e) || null !== e.fields && !$2fa92ec193801792$export$ebb8f7cd71856fb9(e.fields));
    }(e.mapValue)) || "fieldReferenceValue" in e && (null === e.fieldReferenceValue || "string" == typeof e.fieldReferenceValue) || "functionValue" in e && (null === e.functionValue || function __PRIVATE_isIFunction(e) {
        return "object" == typeof e && null !== e && !(!("name" in e) || null !== e.name && "string" != typeof e.name || !("args" in e) || null !== e.args && !Array.isArray(e.args));
    }(e.functionValue)) || "pipelineValue" in e && (null === e.pipelineValue || function __PRIVATE_isIPipeline(e) {
        return "object" == typeof e && null !== e && !(!("stages" in e) || null !== e.stages && !Array.isArray(e.stages));
    }(e.pipelineValue)));
// Check optional properties and their types
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $2fa92ec193801792$export$317a3d46287192d8() {
    return new $2fa92ec193801792$var$__PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $2fa92ec193801792$export$39c1cc7c062529d4() {
    return new $2fa92ec193801792$var$__PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $2fa92ec193801792$export$2ed0fc6709e59212(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $2fa92ec193801792$var$__PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $2fa92ec193801792$export$c03999cb2f36933f(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $2fa92ec193801792$var$__PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $2fa92ec193801792$export$fef3dfd9bad05307(e) {
    return new $2fa92ec193801792$var$__PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to set the field to the numeric minimum of the
 * field's current and the given value.
 *
 * @param n - The value to compare to the existing field value.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $2fa92ec193801792$export$2ec5befb9e6c97d4(e) {
    return new $2fa92ec193801792$var$__PRIVATE_NumericMinimumFieldValueImpl("minimum", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to set the field to the numeric maximum of the
 * field's current and the given value.
 *
 * @param n - The value to compare to the existing field value.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $2fa92ec193801792$export$d29e374196577086(e) {
    return new $2fa92ec193801792$var$__PRIVATE_NumericMaximumFieldValueImpl("maximum", e);
}
/**
 * Creates a new `VectorValue` constructed with a copy of the given array of numbers.
 *
 * @param values - Create a `VectorValue` instance with a copy of this array of numbers.
 *
 * @returns A new `VectorValue` constructed with a copy of the given array of numbers.
 */ function $2fa92ec193801792$export$f074adc9fbd50943(e) {
    return new $2fa92ec193801792$export$24baa2b76016ce0e(e);
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts a value to an Expression, Returning either a Constant, MapFunction,
 * ArrayFunction, or the input itself (if it's already an expression).
 *
 * @private
 * @internal
 * @param value
 */ function $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e) {
    let n;
    return e instanceof $2fa92ec193801792$export$766bf7dcfb630b6c ? e : (n = $2fa92ec193801792$export$ebb8f7cd71856fb9(e) ? $2fa92ec193801792$var$__PRIVATE__map(e) : e instanceof Array ? $2fa92ec193801792$export$6dabbe08653f866f(e) : $2fa92ec193801792$export$2538633961795d6b(e, void 0), n);
}
/**
 * Converts a value to an Expression, Returning either a Constant, MapFunction,
 * ArrayFunction, or the input itself (if it's already an expression).
 *
 * @private
 * @internal
 * @param value
 */ function $2fa92ec193801792$var$__PRIVATE_vectorToExpr(e) {
    if (e instanceof $2fa92ec193801792$export$766bf7dcfb630b6c) return e;
    if (e instanceof $2fa92ec193801792$export$24baa2b76016ce0e) return $2fa92ec193801792$export$674f8f4247a5112e(e);
    if (Array.isArray(e)) return $2fa92ec193801792$export$674f8f4247a5112e($2fa92ec193801792$export$f074adc9fbd50943(e));
    throw new Error("Unsupported value: " + typeof e);
}
/**
 * Converts a value to an Expression, Returning either a Constant, MapFunction,
 * ArrayFunction, or the input itself (if it's already an expression).
 * If the input is a string, it is assumed to be a field name, and a
 * field(value) is returned.
 *
 * @private
 * @internal
 * @param value
 */ function $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(t) {
    if ($2fa92ec193801792$export$4ae495d48253603d(t)) return $2fa92ec193801792$export$b4d5ecaefe2b27f3(t);
    return $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t);
}
/**
 *
 * Represents an expression that can be evaluated to a value within the execution of a {@link
 * @firebase/firestore/pipelines#Pipeline}.
 *
 * Expressions are the building blocks for creating complex queries and transformations in
 * Firestore pipelines. They can represent:
 *
 * - **Field references:** Access values from document fields.
 * - **Literals:** Represent constant values (strings, numbers, booleans).
 * - **Function calls:** Apply functions to one or more expressions.
 *
 * The `Expression` class provides a fluent API for building expressions. You can chain together
 * method calls to create complex expressions.
 */ class $2fa92ec193801792$export$766bf7dcfb630b6c {
    constructor(){
        this._protoValueType = "ProtoValue";
    }
    /**
     * Creates an expression that adds this expression to another expression.
     *
     * @example
     * ```typescript
     * // Add the value of the 'quantity' field and the 'reserve' field.
     * field("quantity").add(field("reserve"));
     * ```
     *
     * @param second - The expression or literal to add to this expression.
     * @param others - Optional additional expressions or literals to add to this expression.
     * @returns A new `Expression` representing the addition operation.
     */ add(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("add", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "add");
    }
    /**
     * Wraps the expression in a [BooleanExpression].
     *
     * @returns A [BooleanExpression] representing the same expression.
     */ asBoolean() {
        if (this instanceof $2fa92ec193801792$export$65ab0ebced932b79) return this;
        if (this instanceof $2fa92ec193801792$var$Constant) return new $2fa92ec193801792$var$__PRIVATE_BooleanConstant(this);
        if (this instanceof $2fa92ec193801792$export$e0c3a065614c6254) return new $2fa92ec193801792$var$__PRIVATE_BooleanField(this);
        if (this instanceof $2fa92ec193801792$export$acf3ba20e47771d) return new $2fa92ec193801792$var$__PRIVATE_BooleanFunctionExpression(this);
        throw new $2fa92ec193801792$export$2408f22a0fab9ae5("invalid-argument", `Conversion of type ${typeof this} to BooleanExpression not supported.`);
    }
    subtract(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("subtract", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "subtract");
    }
    /**
     * Creates an expression that multiplies this expression by another expression.
     *
     * @example
     * ```typescript
     * // Multiply the 'quantity' field by the 'price' field
     * field("quantity").multiply(field("price"));
     * ```
     *
     * @param second - The second expression or literal to multiply by.
     * @param others - Optional additional expressions or literals to multiply by.
     * @returns A new `Expression` representing the multiplication operation.
     */ multiply(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("multiply", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "multiply");
    }
    divide(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("divide", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "divide");
    }
    mod(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("mod", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "mod");
    }
    equal(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("equal", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "equal").asBoolean();
    }
    notEqual(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("not_equal", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "notEqual").asBoolean();
    }
    lessThan(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("less_than", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "lessThan").asBoolean();
    }
    lessThanOrEqual(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("less_than_or_equal", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "lessThanOrEqual").asBoolean();
    }
    greaterThan(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("greater_than", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "greaterThan").asBoolean();
    }
    greaterThanOrEqual(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("greater_than_or_equal", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "greaterThanOrEqual").asBoolean();
    }
    /**
     * Creates an expression that concatenates an array expression with one or more other arrays.
     *
     * @example
     * ```typescript
     * // Combine the 'items' array with another array field.
     * field("items").arrayConcat(field("otherItems"));
     * ```
     * @param secondArray - Second array expression or array literal to concatenate.
     * @param otherArrays - Optional additional array expressions or array literals to concatenate.
     * @returns A new `Expression` representing the concatenated array.
     */ arrayConcat(e, ...t) {
        const n = [
            e,
            ...t
        ].map((e)=>$2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e));
        return new $2fa92ec193801792$export$acf3ba20e47771d("array_concat", [
            this,
            ...n
        ], "arrayConcat");
    }
    arrayContains(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("array_contains", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "arrayContains").asBoolean();
    }
    arrayContainsAll(e) {
        const t = Array.isArray(e) ? new $2fa92ec193801792$var$__PRIVATE_ListOfExprs(e.map($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr), "arrayContainsAll") : e;
        return new $2fa92ec193801792$export$acf3ba20e47771d("array_contains_all", [
            this,
            t
        ], "arrayContainsAll").asBoolean();
    }
    arrayContainsAny(e) {
        const t = Array.isArray(e) ? new $2fa92ec193801792$var$__PRIVATE_ListOfExprs(e.map($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr), "arrayContainsAny") : e;
        return new $2fa92ec193801792$export$acf3ba20e47771d("array_contains_any", [
            this,
            t
        ], "arrayContainsAny").asBoolean();
    }
    /**
     * Creates an expression that reverses an array.
     *
     * @example
     * ```typescript
     * // Reverse the value of the 'myArray' field.
     * field("myArray").arrayReverse();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the reversed array.
     */ arrayReverse() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("array_reverse", [
            this
        ]);
    }
    /**
     * Creates an expression that calculates the length of an array.
     *
     * @example
     * ```typescript
     * // Get the number of items in the 'cart' array
     * field("cart").arrayLength();
     * ```
     *
     * @returns A new `Expression` representing the length of the array.
     */ arrayLength() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("array_length", [
            this
        ], "arrayLength");
    }
    equalAny(e) {
        const t = Array.isArray(e) ? new $2fa92ec193801792$var$__PRIVATE_ListOfExprs(e.map($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr), "equalAny") : e;
        return new $2fa92ec193801792$export$acf3ba20e47771d("equal_any", [
            this,
            t
        ], "equalAny").asBoolean();
    }
    notEqualAny(e) {
        const t = Array.isArray(e) ? new $2fa92ec193801792$var$__PRIVATE_ListOfExprs(e.map($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr), "notEqualAny") : e;
        return new $2fa92ec193801792$export$acf3ba20e47771d("not_equal_any", [
            this,
            t
        ], "notEqualAny").asBoolean();
    }
    /**
     * Creates an expression that checks if a field exists in the document.
     *
     * @example
     * ```typescript
     * // Check if the document has a field named "phoneNumber"
     * field("phoneNumber").exists();
     * ```
     *
     * @returns A new `Expression` representing the 'exists' check.
     */ exists() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("exists", [
            this
        ], "exists").asBoolean();
    }
    /**
     * Creates an expression that calculates the character length of a string in UTF-8.
     *
     * @example
     * ```typescript
     * // Get the character length of the 'name' field in its UTF-8 form.
     * field("name").charLength();
     * ```
     *
     * @returns A new `Expression` representing the length of the string.
     */ charLength() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("char_length", [
            this
        ], "charLength");
    }
    like(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("like", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "like").asBoolean();
    }
    regexContains(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("regex_contains", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "regexContains").asBoolean();
    }
    regexFind(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("regex_find", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "regexFind");
    }
    regexFindAll(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("regex_find_all", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "regexFindAll");
    }
    regexMatch(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("regex_match", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "regexMatch").asBoolean();
    }
    stringContains(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("string_contains", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "stringContains").asBoolean();
    }
    startsWith(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("starts_with", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "startsWith").asBoolean();
    }
    endsWith(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("ends_with", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "endsWith").asBoolean();
    }
    /**
     * Creates an expression that converts a string to lowercase.
     *
     * @example
     * ```typescript
     * // Convert the 'name' field to lowercase
     * field("name").toLower();
     * ```
     *
     * @returns A new `Expression` representing the lowercase string.
     */ toLower() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("to_lower", [
            this
        ], "toLower");
    }
    /**
     * Creates an expression that converts a string to uppercase.
     *
     * @example
     * ```typescript
     * // Convert the 'title' field to uppercase
     * field("title").toUpper();
     * ```
     *
     * @returns A new `Expression` representing the uppercase string.
     */ toUpper() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("to_upper", [
            this
        ], "toUpper");
    }
    /**
     * Creates an expression that removes leading and trailing characters from a string or byte array.
     *
     * @example
     * ```typescript
     * // Trim whitespace from the 'userInput' field
     * field("userInput").trim();
     *
     * // Trim quotes from the 'userInput' field
     * field("userInput").trim('"');
     * ```
     * @param valueToTrim - Optional This parameter is treated as a set of characters or bytes that will be
     * trimmed from the input. If not specified, then whitespace will be trimmed.
     * @returns A new `Expression` representing the trimmed string or byte array.
     */ trim(e) {
        const t = [
            this
        ];
        return e && t.push($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)), new $2fa92ec193801792$export$acf3ba20e47771d("trim", t, "trim");
    }
    /**
     * Trims whitespace or a specified set of characters/bytes from the beginning of a string or byte array.
     *
     * @example
     * ```typescript
     * // Trim whitespace from the beginning of the 'userInput' field
     * field("userInput").ltrim();
     *
     * // Trim quotes from the beginning of the 'userInput' field
     * field("userInput").ltrim('"');
     * ```
     *
     * @param valueToTrim - Optional. A string or byte array containing the characters/bytes to trim.
     * If not specified, whitespace will be trimmed.
     * @returns A new `Expression` representing the trimmed string.
     */ ltrim(e) {
        const t = [
            this
        ];
        return e && t.push($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)), new $2fa92ec193801792$export$acf3ba20e47771d("ltrim", t, "ltrim");
    }
    /**
     * Trims whitespace or a specified set of characters/bytes from the end of a string or byte array.
     *
     * @example
     * ```typescript
     * // Trim whitespace from the end of the 'userInput' field
     * field("userInput").rtrim();
     *
     * // Trim quotes from the end of the 'userInput' field
     * field("userInput").rtrim('"');
     * ```
     *
     * @param valueToTrim - Optional. A string or byte array containing the characters/bytes to trim.
     * If not specified, whitespace will be trimmed.
     * @returns A new `Expression` representing the trimmed string or byte array.
     */ rtrim(e) {
        const t = [
            this
        ];
        return e && t.push($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)), new $2fa92ec193801792$export$acf3ba20e47771d("rtrim", t, "rtrim");
    }
    /**
     * Creates an expression that returns the data type of this expression's result, as a string.
     *
     * @remarks
     * This is evaluated on the backend. This means:
     * 1. Generic typed elements (like `array<string>`) evaluate strictly to the primitive `'array'`.
     * 2. Any custom `FirestoreDataConverter` mappings are ignored.
     * 3. For numeric values, the backend does not yield the JavaScript `"number"` type; it evaluates
     *    precisely as `"int64"` or `"float64"`.
     * 4. For date or timestamp objects, the backend evaluates to `"timestamp"`.
     *
     * @example
     * ```typescript
     * // Get the data type of the value in field 'title'
     * field('title').type()
     * ```
     *
     * @returns A new `Expression` representing the data type.
     */ type() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("type", [
            this
        ]);
    }
    /**
     * Creates an expression that checks if the result of this expression is of the given type.
     *
     * @remarks Null or undefined fields evaluate to skip/error. Use `ifAbsent()` / `isAbsent()` to evaluate missing data.
     * Supported values for `type` are:
     * `'null'`, `'array'`, `'boolean'`, `'bytes'`, `'timestamp'`, `'geo_point'`, `'number'`,
     * `'int32'`, `'int64'`, `'float64'`, `'decimal128'`, `'map'`, `'reference'`, `'string'`,
     * `'vector'`, `'max_key'`, `'min_key'`, `'object_id'`, `'regex'`, `'request_timestamp'`.
     *
     * @example
     * ```typescript
     * // Check if the 'price' field is specifically an integer (not just 'number')
     * field('price').isType('int64');
     * ```
     *
     * @param type - The type to check for.
     * @returns A new `BooleanExpression` that evaluates to true if the expression's result is of the given type, false otherwise.
     */ isType(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("is_type", [
            this,
            $2fa92ec193801792$export$674f8f4247a5112e(e)
        ], "isType").asBoolean();
    }
    /**
     * Creates an expression that concatenates string expressions together.
     *
     * @example
     * ```typescript
     * // Combine the 'firstName', " ", and 'lastName' fields into a single string
     * field("firstName").stringConcat(constant(" "), field("lastName"));
     * ```
     *
     * @param secondString - The additional expression or string literal to concatenate.
     * @param otherStrings - Optional additional expressions or string literals to concatenate.
     * @returns A new `Expression` representing the concatenated string.
     */ stringConcat(e, ...t) {
        const n = [
            e,
            ...t
        ].map($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr);
        return new $2fa92ec193801792$export$acf3ba20e47771d("string_concat", [
            this,
            ...n
        ], "stringConcat");
    }
    /**
     * Creates an expression that finds the index of the first occurrence of a substring or byte sequence.
     *
     * @example
     * ```typescript
     * // Find the index of "foo" in the 'text' field
     * field("text").stringIndexOf("foo");
     * ```
     *
     * @param search - The substring or byte sequence to search for.
     * @returns A new `Expression` representing the index of the first occurrence.
     */ stringIndexOf(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("string_index_of", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "stringIndexOf");
    }
    /**
     * Creates an expression that repeats a string or byte array a specified number of times.
     *
     * @example
     * ```typescript
     * // Repeat the 'label' field 3 times
     * field("label").stringRepeat(3);
     * ```
     *
     * @param repetitions - The number of times to repeat the string or byte array.
     * @returns A new `Expression` representing the repeated string or byte array.
     */ stringRepeat(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("string_repeat", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "stringRepeat");
    }
    /**
     * Creates an expression that replaces all occurrences of a substring or byte sequence with a replacement.
     *
     * @example
     * ```typescript
     * // Replace all occurrences of "foo" with "bar" in the 'text' field
     * field("text").stringReplaceAll("foo", "bar");
     * ```
     *
     * @param find - The substring or byte sequence to search for.
     * @param replacement - The replacement string or byte sequence.
     * @returns A new `Expression` representing the string or byte array with replacements.
     */ stringReplaceAll(e, t) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("string_replace_all", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e),
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t)
        ], "stringReplaceAll");
    }
    /**
     * Creates an expression that replaces the first occurrence of a substring or byte sequence with a replacement.
     *
     * @example
     * ```typescript
     * // Replace the first occurrence of "foo" with "bar" in the 'text' field
     * field("text").stringReplaceOne("foo", "bar");
     * ```
     *
     * @param find - The substring or byte sequence to search for.
     * @param replacement - The replacement string or byte sequence.
     * @returns A new `Expression` representing the string or byte array with the replacement.
     */ stringReplaceOne(e, t) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("string_replace_one", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e),
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t)
        ], "stringReplaceOne");
    }
    /**
     * Creates an expression that concatenates expression results together.
     *
     * @example
     * ```typescript
     * // Combine the 'firstName', ' ', and 'lastName' fields into a single value.
     * field("firstName").concat(constant(" "), field("lastName"));
     * ```
     *
     * @param second - The additional expression or literal to concatenate.
     * @param others - Optional additional expressions or literals to concatenate.
     * @returns A new `Expression` representing the concatenated value.
     */ concat(e, ...t) {
        const n = [
            e,
            ...t
        ].map($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr);
        return new $2fa92ec193801792$export$acf3ba20e47771d("concat", [
            this,
            ...n
        ], "concat");
    }
    /**
     * Creates an expression that reverses this string expression.
     *
     * @example
     * ```typescript
     * // Reverse the value of the 'myString' field.
     * field("myString").reverse();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the reversed string.
     */ reverse() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("reverse", [
            this
        ], "reverse");
    }
    /**
     * Filters the array using a provided alias and predicate expression.
     *
     * @example
     * ```typescript
     * // Filter the 'items' array to only include those where the 'price' is greater than 10
     * field("items").arrayFilter('item', greaterThan(variable('item.price'), 10));
     * ```
     *
     * @param alias - The variable name to use for each element.
     * @param filter - The predicate boolean expression to filter by.
     * @returns A new `Expression` representing the filtered array.
     */ arrayFilter(e, t) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("array_filter", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e),
            t
        ], "arrayFilter");
    }
    /**
     * Creates an expression that applies a provided transformation to each element in an array.
     *
     * @example
     * ```typescript
     * // Transform the 'scores' array by multiplying each score by 10
     * field("scores").arrayTransform("score", multiply(variable("score"), 10));
     * ```
     *
     * @param elementAlias - The variable name to use for each element.
     * @param transform - The lambda expression used to transform the elements.
     * @returns A new `Expression` representing the arrayTransform operation.
     */ arrayTransform(e, t) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("array_transform", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e),
            t
        ], "arrayTransform");
    }
    /**
     * Creates an expression that applies a provided transformation to each element in an array, providing the element's index to the transformation expression.
     *
     * @example
     * ```typescript
     * // Transform the 'scores' array by adding the index to each score
     * field("scores").arrayTransformWithIndex("score", "i", add(variable("score"), variable("i")));
     * ```
     *
     * @param elementAlias - The variable name to use for each element.
     * @param indexAlias - The variable name to use for the current index.
     * @param transform - The lambda expression used to transform the elements.
     * @returns A new `Expression` representing the arrayTransformWithIndex operation.
     */ arrayTransformWithIndex(e, t, n) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("array_transform", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e),
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t),
            n
        ], "arrayTransformWithIndex");
    }
    /**
     * Returns a subset of the array.
     *
     * @example
     * ```typescript
     * // Get 5 elements from the 'items' array starting from index 2
     * field("items").arraySlice(2, 5);
     *
     * // Get n number of elements from the 'items' array starting from index 2
     * field("items").arraySlice(2, field("count"));
     * ```
     *
     * @param offset - The starting offset.
     * @param length - The optional length of the slice.
     * @returns A new `Expression` representing the sliced array.
     */ arraySlice(e, t) {
        const n = [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ];
        return void 0 !== t && n.push($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t)), new $2fa92ec193801792$export$acf3ba20e47771d("array_slice", n, "arraySlice");
    }
    /**
     * Returns the first element of the array.
     *
     * @example
     * ```typescript
     * // Get the first element of the 'myArray' field.
     * field("myArray").arrayFirst();
     * ```
     *
     * @returns A new `Expression` representing the first element.
     */ arrayFirst() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("array_first", [
            this
        ], "arrayFirst");
    }
    arrayFirstN(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("array_first_n", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "arrayFirstN");
    }
    /**
     * Returns the last element of the array.
     *
     * @example
     * ```typescript
     * // Get the last element of the 'myArray' field.
     * field("myArray").arrayLast();
     * ```
     *
     * @returns A new `Expression` representing the last element.
     */ arrayLast() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("array_last", [
            this
        ], "arrayLast");
    }
    arrayLastN(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("array_last_n", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "arrayLastN");
    }
    /**
     * Returns the maximum value in the array.
     *
     * @example
     * ```typescript
     * // Get the maximum value of the 'myArray' field.
     * field("myArray").arrayMaximum();
     * ```
     *
     * @returns A new `Expression` representing the maximum value.
     */ arrayMaximum() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("maximum", [
            this
        ], "arrayMaximum");
    }
    arrayMaximumN(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("maximum_n", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "arrayMaximumN");
    }
    /**
     * Returns the minimum value in the array.
     *
     * @example
     * ```typescript
     * // Get the minimum value of the 'myArray' field.
     * field("myArray").arrayMinimum();
     * ```
     *
     * @returns A new `Expression` representing the minimum value.
     */ arrayMinimum() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("minimum", [
            this
        ], "arrayMinimum");
    }
    arrayMinimumN(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("minimum_n", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "arrayMinimumN");
    }
    arrayIndexOf(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("array_index_of", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e),
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr("first")
        ], "arrayIndexOf");
    }
    arrayLastIndexOf(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("array_index_of", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e),
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr("last")
        ], "arrayLastIndexOf");
    }
    arrayIndexOfAll(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("array_index_of_all", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "arrayIndexOfAll");
    }
    /**
     * Creates an expression that calculates the length of this string expression in bytes.
     *
     * @example
     * ```typescript
     * // Calculate the length of the 'myString' field in bytes.
     * field("myString").byteLength();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the length of the string in bytes.
     */ byteLength() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("byte_length", [
            this
        ], "byteLength");
    }
    /**
     * Creates an expression that computes the ceiling of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the ceiling of the 'price' field.
     * field("price").ceil();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the ceiling of the numeric value.
     */ ceil() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("ceil", [
            this
        ]);
    }
    /**
     * Creates an expression that computes the floor of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the floor of the 'price' field.
     * field("price").floor();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the floor of the numeric value.
     */ floor() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("floor", [
            this
        ]);
    }
    /**
     * Creates an expression that computes the absolute value of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the absolute value of the 'price' field.
     * field("price").abs();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the absolute value of the numeric value.
     */ abs() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("abs", [
            this
        ]);
    }
    /**
     * Creates an expression that computes e to the power of this expression.
     *
     * @example
     * ```typescript
     * // Compute e to the power of the 'value' field.
     * field("value").exp();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the exp of the numeric value.
     */ exp() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("exp", [
            this
        ]);
    }
    /**
     * Accesses a value from a map (object) field using the provided key.
     *
     * @example
     * ```typescript
     * // Get the 'city' value from the 'address' map field
     * field("address").mapGet("city");
     * ```
     *
     * @param subfield - The key to access in the map.
     * @returns A new `Expression` representing the value associated with the given key in the map.
     */ mapGet(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("map_get", [
            this,
            $2fa92ec193801792$export$674f8f4247a5112e(e)
        ], "mapGet");
    }
    /**
     * Creates an expression that returns a new map with the specified entries added or updated.
     *
     * @remarks
     * Note that `mapSet` only performs shallow updates to the map. Setting a value to `null`
     * will retain the key with a `null` value. To remove a key entirely, use `mapRemove`.
     *
     * @example
     * ```typescript
     * // Set the 'city' to "San Francisco" in the 'address' map
     * field("address").mapSet("city", "San Francisco");
     * ```
     *
     * @param key - The key to set. Must be a string or a constant string expression.
     * @param value - The value to set.
     * @param moreKeyValues - Additional key-value pairs to set.
     * @returns A new `Expression` representing the map with the entries set.
     */ mapSet(e, t, ...n) {
        const r = [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e),
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t),
            ...n.map($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr)
        ];
        return new $2fa92ec193801792$export$acf3ba20e47771d("map_set", r, "mapSet");
    }
    /**
     * Creates an expression that returns the keys of a map.
     *
     * @remarks
     * While the backend generally preserves insertion order, relying on the
     * order of the output array is not guaranteed and should be avoided.
     *
     * @example
     * ```typescript
     * // Get the keys of the 'address' map
     * field("address").mapKeys();
     * ```
     *
     * @returns A new `Expression` representing the keys of the map.
     */ mapKeys() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("map_keys", [
            this
        ], "mapKeys");
    }
    /**
     * Creates an expression that returns the values of a map.
     *
     * @remarks
     * While the backend generally preserves insertion order, relying on the
     * order of the output array is not guaranteed and should be avoided.
     *
     * @example
     * ```typescript
     * // Get the values of the 'address' map
     * field("address").mapValues();
     * ```
     *
     * @returns A new `Expression` representing the values of the map.
     */ mapValues() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("map_values", [
            this
        ], "mapValues");
    }
    /**
     * Creates an expression that returns the entries of a map as an array of maps,
     * where each map contains a `"k"` property for the key and a `"v"` property for the value.
     * For example: `[{ k: "key1", v: "value1" }, ...]`.
     *
     * @example
     * ```typescript
     * // Get the entries of the 'address' map
     * field("address").mapEntries();
     * ```
     *
     * @returns A new `Expression` representing the entries of the map.
     */ mapEntries() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("map_entries", [
            this
        ], "mapEntries");
    }
    /**
     * @public
     * Creates an expression that returns the value of a field from the document that results from the evaluation of this expression.
     *
     * @example
     * ```typescript
     * // Get the value of the "city" field in the "address" document.
     * field("address").getField("city")
     * ```
     *
     * @param key The field to access in the document.
     * @returns A new `Expression` representing the value of the field in the document.
     */ getField(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("get_field", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "get_field");
    }
    /**
     * Creates an aggregation that counts the number of stage inputs with valid evaluations of the
     * expression or field.
     *
     * @example
     * ```typescript
     * // Count the total number of products
     * field("productId").count().as("totalProducts");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'count' aggregation.
     */ count() {
        return $2fa92ec193801792$export$1ddf2d01943a3512._create("count", [
            this
        ], "count");
    }
    /**
     * Creates an aggregation that calculates the sum of a numeric field across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Calculate the total revenue from a set of orders
     * field("orderAmount").sum().as("totalRevenue");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'sum' aggregation.
     */ sum() {
        return $2fa92ec193801792$export$1ddf2d01943a3512._create("sum", [
            this
        ], "sum");
    }
    /**
     * Creates an aggregation that calculates the average (mean) of a numeric field across multiple
     * stage inputs.
     *
     * @example
     * ```typescript
     * // Calculate the average age of users
     * field("age").average().as("averageAge");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'average' aggregation.
     */ average() {
        return $2fa92ec193801792$export$1ddf2d01943a3512._create("average", [
            this
        ], "average");
    }
    /**
     * Creates an aggregation that finds the minimum value of a field across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Find the lowest price of all products
     * field("price").minimum().as("lowestPrice");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'minimum' aggregation.
     */ minimum() {
        return $2fa92ec193801792$export$1ddf2d01943a3512._create("minimum", [
            this
        ], "minimum");
    }
    /**
     * Creates an aggregation that finds the maximum value of a field across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Find the highest score in a leaderboard
     * field("score").maximum().as("highestScore");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'maximum' aggregation.
     */ maximum() {
        return $2fa92ec193801792$export$1ddf2d01943a3512._create("maximum", [
            this
        ], "maximum");
    }
    /**
     * Creates an aggregation that finds the first value of an expression across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Find the first value of the 'rating' field
     * field("rating").first().as("firstRating");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'first' aggregation.
     */ first() {
        return $2fa92ec193801792$export$1ddf2d01943a3512._create("first", [
            this
        ], "first");
    }
    /**
     * Creates an aggregation that finds the last value of an expression across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Find the last value of the 'rating' field
     * field("rating").last().as("lastRating");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'last' aggregation.
     */ last() {
        return $2fa92ec193801792$export$1ddf2d01943a3512._create("last", [
            this
        ], "last");
    }
    /**
     * Creates an aggregation that collects all values of an expression across multiple stage inputs
     * into an array.
     *
     * @remarks
     * If the expression resolves to an absent value, it is converted to `null`.
     * The order of elements in the output array is not stable and shouldn't be relied upon.
     *
     * @example
     * ```typescript
     * // Collect all tags from books into an array
     * field("tags").arrayAgg().as("allTags");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'array_agg' aggregation.
     */ arrayAgg() {
        return $2fa92ec193801792$export$1ddf2d01943a3512._create("array_agg", [
            this
        ], "arrayAgg");
    }
    /**
     * Creates an aggregation that collects all distinct values of an expression across multiple stage
     * inputs into an array.
     *
     * @remarks
     * If the expression resolves to an absent value, it is converted to `null`.
     * The order of elements in the output array is not stable and shouldn't be relied upon.
     *
     * @example
     * ```typescript
     * // Collect all distinct tags from books into an array
     * field("tags").arrayAggDistinct().as("allDistinctTags");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'array_agg_distinct' aggregation.
     */ arrayAggDistinct() {
        return $2fa92ec193801792$export$1ddf2d01943a3512._create("array_agg_distinct", [
            this
        ], "arrayAggDistinct");
    }
    /**
     * Creates an aggregation that counts the number of distinct values of the expression or field.
     *
     * @example
     * ```typescript
     * // Count the distinct number of products
     * field("productId").countDistinct().as("distinctProducts");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'count_distinct' aggregation.
     */ countDistinct() {
        return $2fa92ec193801792$export$1ddf2d01943a3512._create("count_distinct", [
            this
        ], "countDistinct");
    }
    /**
     * Creates an expression that returns the larger value between this expression and another expression, based on Firestore's value type ordering.
     *
     * @example
     * ```typescript
     * // Returns the larger value between the 'timestamp' field and the current timestamp.
     * field("timestamp").logicalMaximum(currentTimestamp());
     * ```
     *
     * @param second - The second expression or literal to compare with.
     * @param others - Optional additional expressions or literals to compare with.
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical maximum operation.
     */ logicalMaximum(e, ...t) {
        const n = [
            e,
            ...t
        ];
        return new $2fa92ec193801792$export$acf3ba20e47771d("maximum", [
            this,
            ...n.map($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr)
        ], "logicalMaximum");
    }
    /**
     * Creates an expression that returns the smaller value between this expression and another expression, based on Firestore's value type ordering.
     *
     * @example
     * ```typescript
     * // Returns the smaller value between the 'timestamp' field and the current timestamp.
     * field("timestamp").logicalMinimum(currentTimestamp());
     * ```
     *
     * @param second - The second expression or literal to compare with.
     * @param others - Optional additional expressions or literals to compare with.
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical minimum operation.
     */ logicalMinimum(e, ...t) {
        const n = [
            e,
            ...t
        ];
        return new $2fa92ec193801792$export$acf3ba20e47771d("minimum", [
            this,
            ...n.map($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr)
        ], "minimum");
    }
    /**
     * Creates an expression that calculates the length (number of dimensions) of this Firestore Vector expression.
     *
     * @example
     * ```typescript
     * // Get the vector length (dimension) of the field 'embedding'.
     * field("embedding").vectorLength();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the length of the vector.
     */ vectorLength() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("vector_length", [
            this
        ], "vectorLength");
    }
    cosineDistance(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("cosine_distance", [
            this,
            $2fa92ec193801792$var$__PRIVATE_vectorToExpr(e)
        ], "cosineDistance");
    }
    dotProduct(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("dot_product", [
            this,
            $2fa92ec193801792$var$__PRIVATE_vectorToExpr(e)
        ], "dotProduct");
    }
    euclideanDistance(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("euclidean_distance", [
            this,
            $2fa92ec193801792$var$__PRIVATE_vectorToExpr(e)
        ], "euclideanDistance");
    }
    /**
     * Creates an expression that interprets this expression as the number of microseconds since the Unix epoch (1970-01-01 00:00:00 UTC)
     * and returns a timestamp.
     *
     * @example
     * ```typescript
     * // Interpret the 'microseconds' field as microseconds since epoch.
     * field("microseconds").unixMicrosToTimestamp();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the timestamp.
     */ unixMicrosToTimestamp() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("unix_micros_to_timestamp", [
            this
        ], "unixMicrosToTimestamp");
    }
    /**
     * Creates an expression that converts this timestamp expression to the number of microseconds since the Unix epoch (1970-01-01 00:00:00 UTC).
     *
     * @example
     * ```typescript
     * // Convert the 'timestamp' field to microseconds since epoch.
     * field("timestamp").timestampToUnixMicros();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the number of microseconds since epoch.
     */ timestampToUnixMicros() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("timestamp_to_unix_micros", [
            this
        ], "timestampToUnixMicros");
    }
    /**
     * Creates an expression that interprets this expression as the number of milliseconds since the Unix epoch (1970-01-01 00:00:00 UTC)
     * and returns a timestamp.
     *
     * @example
     * ```typescript
     * // Interpret the 'milliseconds' field as milliseconds since epoch.
     * field("milliseconds").unixMillisToTimestamp();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the timestamp.
     */ unixMillisToTimestamp() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("unix_millis_to_timestamp", [
            this
        ], "unixMillisToTimestamp");
    }
    /**
     * Creates an expression that converts this timestamp expression to the number of milliseconds since the Unix epoch (1970-01-01 00:00:00 UTC).
     *
     * @example
     * ```typescript
     * // Convert the 'timestamp' field to milliseconds since epoch.
     * field("timestamp").timestampToUnixMillis();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the number of milliseconds since epoch.
     */ timestampToUnixMillis() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("timestamp_to_unix_millis", [
            this
        ], "timestampToUnixMillis");
    }
    /**
     * Creates an expression that interprets this expression as the number of seconds since the Unix epoch (1970-01-01 00:00:00 UTC)
     * and returns a timestamp.
     *
     * @example
     * ```typescript
     * // Interpret the 'seconds' field as seconds since epoch.
     * field("seconds").unixSecondsToTimestamp();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the timestamp.
     */ unixSecondsToTimestamp() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("unix_seconds_to_timestamp", [
            this
        ], "unixSecondsToTimestamp");
    }
    /**
     * Creates an expression that converts this timestamp expression to the number of seconds since the Unix epoch (1970-01-01 00:00:00 UTC).
     *
     * @example
     * ```typescript
     * // Convert the 'timestamp' field to seconds since epoch.
     * field("timestamp").timestampToUnixSeconds();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the number of seconds since epoch.
     */ timestampToUnixSeconds() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("timestamp_to_unix_seconds", [
            this
        ], "timestampToUnixSeconds");
    }
    timestampAdd(e, t) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("timestamp_add", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e),
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t)
        ], "timestampAdd");
    }
    timestampSubtract(e, t) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("timestamp_subtract", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e),
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t)
        ], "timestampSubtract");
    }
    timestampDiff(e, t) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("timestamp_diff", [
            this,
            $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e),
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t)
        ], "timestampDiff");
    }
    timestampExtract(e, t) {
        const n = [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ];
        return t && n.push($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t)), new $2fa92ec193801792$export$acf3ba20e47771d("timestamp_extract", n, "timestampExtract");
    }
    /**
     *
     * Creates an expression that returns the document ID from a path.
     *
     * @example
     * ```typescript
     * // Get the document ID from a path.
     * field("__path__").documentId();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the documentId operation.
     */ documentId() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("document_id", [
            this
        ], "documentId");
    }
    /**
     *
     * Creates an expression that returns the parent document reference of a document reference.
     *
     * @example
     * ```typescript
     * // Get the parent document reference of a document reference.
     * field("__path__").parent();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the parent operation.
     */ parent() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("parent", [
            this
        ], "parent");
    }
    substring(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e);
        return new $2fa92ec193801792$export$acf3ba20e47771d("substring", void 0 === t ? [
            this,
            n
        ] : [
            this,
            n,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t)
        ], "substring");
    }
    arrayGet(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("array_get", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "arrayGet");
    }
    /**
     *
     * Creates an expression that checks if a given expression produces an error.
     *
     * @example
     * ```typescript
     * // Check if the result of a calculation is an error
     * field("title").arrayContains(1).isError();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#BooleanExpression} representing the 'isError' check.
     */ isError() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("is_error", [
            this
        ], "isError").asBoolean();
    }
    ifError(e) {
        const t = new $2fa92ec193801792$export$acf3ba20e47771d("if_error", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "ifError");
        return e instanceof $2fa92ec193801792$export$65ab0ebced932b79 ? t.asBoolean() : t;
    }
    /**
     *
     * Creates an expression that returns `true` if the result of this expression
     * is absent. Otherwise, returns `false` even if the value is `null`.
     *
     * @example
     * ```typescript
     * // Check if the field `value` is absent.
     * field("value").isAbsent();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#BooleanExpression} representing the 'isAbsent' check.
     */ isAbsent() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("is_absent", [
            this
        ], "isAbsent").asBoolean();
    }
    mapRemove(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("map_remove", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "mapRemove");
    }
    /**
     *
     * Creates an expression that merges multiple map values.
     *
     * @example
     * ```
     * // Merges the map in the settings field with, a map literal, and a map in
     * // that is conditionally returned by another expression
     * field('settings').mapMerge({ enabled: true }, conditional(field('isAdmin'), { admin: true}, {})
     * ```
     *
     * @param secondMap - A required second map to merge. Represented as a literal or
     * an expression that returns a map.
     * @param otherMaps - Optional additional maps to merge. Each map is represented
     * as a literal or an expression that returns a map.
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the 'mapMerge' operation.
     */ mapMerge(e, ...t) {
        const n = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e), r = t.map($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr);
        return new $2fa92ec193801792$export$acf3ba20e47771d("map_merge", [
            this,
            n,
            ...r
        ], "mapMerge");
    }
    pow(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("pow", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ]);
    }
    trunc(e) {
        return void 0 === e ? new $2fa92ec193801792$export$acf3ba20e47771d("trunc", [
            this
        ]) : new $2fa92ec193801792$export$acf3ba20e47771d("trunc", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "trunc");
    }
    round(e) {
        return void 0 === e ? new $2fa92ec193801792$export$acf3ba20e47771d("round", [
            this
        ]) : new $2fa92ec193801792$export$acf3ba20e47771d("round", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "round");
    }
    /**
     * Creates an expression that returns the collection ID from a path.
     *
     * @example
     * ```typescript
     * // Get the collection ID from a path.
     * field("__path__").collectionId();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the collectionId operation.
     */ collectionId() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("collection_id", [
            this
        ]);
    }
    /**
     * Creates an expression that calculates the length of a string, array, map, vector, or bytes.
     *
     * @example
     * ```typescript
     * // Get the length of the 'name' field.
     * field("name").length();
     *
     * // Get the number of items in the 'cart' array.
     * field("cart").length();
     * ```
     *
     * @returns A new `Expression` representing the length of the string, array, map, vector, or bytes.
     */ length() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("length", [
            this
        ]);
    }
    /**
     * Creates an expression that computes the natural logarithm of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the natural logarithm of the 'value' field.
     * field("value").ln();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the natural logarithm of the numeric value.
     */ ln() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("ln", [
            this
        ]);
    }
    /**
     * Creates an expression that computes the square root of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the square root of the 'value' field.
     * field("value").sqrt();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the square root of the numeric value.
     */ sqrt() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("sqrt", [
            this
        ]);
    }
    /**
     * Creates an expression that reverses a string.
     *
     * @example
     * ```typescript
     * // Reverse the value of the 'myString' field.
     * field("myString").stringReverse();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the reversed string.
     */ stringReverse() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("string_reverse", [
            this
        ]);
    }
    ifAbsent(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("if_absent", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "ifAbsent");
    }
    ifNull(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("if_null", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "ifNull");
    }
    /**
     * Creates an expression that returns the first non-null, non-absent argument, without evaluating
     * the rest of the arguments. When all arguments are null or absent, returns the last argument.
     *
     * @example
     * ```typescript
     * // Returns the value of the first non-null, non-absent field among 'preferredName', 'fullName',
     * // or the last argument if all previous fields are null.
     * field("preferredName").coalesce(field("fullName"), "Anonymous");
     * ```
     *
     * @param replacement - The value to use if this expression evaluates to null.
     * @param others - Optional additional values to check if previous values are null.
     * @returns A new `Expression` representing the coalesce operation.
     */ coalesce(e, ...t) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("coalesce", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e),
            ...t.map($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr)
        ], "coalesce");
    }
    join(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("join", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "join");
    }
    /**
     * Creates an expression that computes the base-10 logarithm of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the base-10 logarithm of the 'value' field.
     * field("value").log10();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the base-10 logarithm of the numeric value.
     */ log10() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("log10", [
            this
        ]);
    }
    /**
     * Creates an expression that computes the sum of the elements in an array.
     *
     * @example
     * ```typescript
     * // Compute the sum of the elements in the 'scores' field.
     * field("scores").arraySum();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the sum of the elements in the array.
     */ arraySum() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("sum", [
            this
        ]);
    }
    split(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("split", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ]);
    }
    timestampTruncate(e, t) {
        const n = [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ];
        return t && n.push($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t)), new $2fa92ec193801792$export$acf3ba20e47771d("timestamp_trunc", n);
    }
    // TODO(search) enable with backend support
    // /**
    //  * Evaluates if the result of this `expression` is between
    //  * the `lowerBound` (inclusive) and `upperBound` (inclusive).
    //  *
    //  * @example
    //  * ```
    //  * // Evaluate if the 'tireWidth' is between 2.2 and 2.4
    //  * field('tireWidth').between(constant(2.2), constant(2.4))
    //  *
    //  * // This is functionally equivalent to
    //  * and(field('tireWidth').greaterThanOrEqual(contant(2.2)), field('tireWidth').lessThanOrEqual(constant(2.4)))
    //  * ```
    //  *
    //  * @param lowerBound - Lower bound (inclusive) of the range.
    //  * @param upperBound - Upper bound (inclusive) of the range.
    //  */
    // between(lowerBound: Expression, upperBound: Expression): BooleanExpression;
    // /**
    //  * Evaluates if the result of this `expression` is between
    //  * the `lowerBound` (inclusive) and `upperBound` (inclusive).
    //  *
    //  * @example
    //  * ```
    //  * // Evaluate if the 'tireWidth' is between 2.2 and 2.4
    //  * field('tireWidth').between(2.2, 2.4)
    //  *
    //  * // This is functionally equivalent to
    //  * and(field('tireWidth').greaterThanOrEqual(2.2), field('tireWidth').lessThanOrEqual(2.4))
    //  * ```
    //  *
    //  * @param lowerBound - Lower bound (inclusive) of the range.
    //  * @param upperBound - Upper bound (inclusive) of the range.
    //  */
    // between(lowerBound: unknown, upperBound: unknown): BooleanExpression;
    // between(lowerBound: unknown, upperBound: unknown): BooleanExpression {
    //   return new FunctionExpression('between', [
    //     this,
    //     valueToDefaultExpr(lowerBound),
    //     valueToDefaultExpr(upperBound)
    //   ]).asBoolean();
    // }
    // TODO(search) enable with backend support
    // /**
    //  * Evaluates to an HTML-formatted text snippet that renders terms matching
    //  * the search query in `<b>bold</b>`.
    //  *
    //  * @remarks This Expression can only be used within a `search` stage.
    //  *
    //  * @param rquery Define the search query using the search domain-specific language (DSL).
    //  */
    // snippet(rquery: string): Expression;
    // /**
    //  * Evaluates to an HTML-formatted text snippet that renders terms matching
    //  * the search query in `<b>bold</b>`.
    //  *
    //  * @remarks This Expression can only be used within a `search` stage.
    //  *
    //  * @param options Define how snippeting behaves.
    //  */
    // snippet(options: SnippetOptions): Expression;
    // snippet(queryOrOptions: string | SnippetOptions): Expression {
    //   const options: SnippetOptions = isString(queryOrOptions)
    //     ? { rquery: queryOrOptions }
    //     : queryOrOptions;
    //   const rquery = options.rquery;
    //   const internalOptions = {
    //     maxSnippetWidth: options.maxSnippetWidth,
    //     maxSnippets: options.maxSnippets,
    //     separator: options.separator
    //   };
    //   return new SnippetExpression([this, constant(rquery)], internalOptions);
    // }
    // TODO(new-expression): Add new expression method definitions above this line
    /**
     * Creates an {@link @firebase/firestore/pipelines#Ordering} that sorts documents in ascending order based on this expression.
     *
     * @example
     * ```typescript
     * // Sort documents by the 'name' field in ascending order
     * firestore.pipeline().collection("users")
     *   .sort(field("name").ascending());
     * ```
     *
     * @returns A new `Ordering` for ascending sorting.
     */ ascending() {
        return $2fa92ec193801792$export$9ddbdd0bfc5623a(this);
    }
    /**
     * Creates an {@link @firebase/firestore/pipelines#Ordering} that sorts documents in descending order based on this expression.
     *
     * @example
     * ```typescript
     * // Sort documents by the 'createdAt' field in descending order
     * firestore.pipeline().collection("users")
     *   .sort(field("createdAt").descending());
     * ```
     *
     * @returns A new `Ordering` for descending sorting.
     */ descending() {
        return $2fa92ec193801792$export$b37556a6cf1be916(this);
    }
    /**
     * Assigns an alias to this expression.
     *
     * Aliases are useful for renaming fields in the output of a stage or for giving meaningful
     * names to calculated values.
     *
     * @example
     * ```typescript
     * // Calculate the total price and assign it the alias "totalPrice" and add it to the output.
     * firestore.pipeline().collection("items")
     *   .addFields(field("price").multiply(field("quantity")).as("totalPrice"));
     * ```
     *
     * @param name - The alias to assign to this expression.
     * @returns A new {@link @firebase/firestore/pipelines#AliasedExpression} that wraps this
     *     expression and associates it with the provided alias.
     */ as(e) {
        return new $2fa92ec193801792$export$dabba94403d45c8e(this, e, "as");
    }
}
/**
 *
 * A class that represents an aggregate function.
 */ class $2fa92ec193801792$export$1ddf2d01943a3512 {
    constructor(e, t){
        this.name = e, this.params = t, this.exprType = "AggregateFunction", this._protoValueType = "ProtoValue";
    }
    /**
     * @internal
     * @private
     */ static _create(e, t, n) {
        const r = new $2fa92ec193801792$export$1ddf2d01943a3512(e, t);
        return r._methodName = n, r;
    }
    /**
     * Assigns an alias to this AggregateFunction. The alias specifies the name that
     * the aggregated value will have in the output document.
     *
     * @example
     * ```typescript
     * // Calculate the average price of all items and assign it the alias "averagePrice".
     * firestore.pipeline().collection("items")
     *   .aggregate(field("price").average().as("averagePrice"));
     * ```
     *
     * @param name - The alias to assign to this AggregateFunction.
     * @returns A new {@link @firebase/firestore/pipelines#AliasedAggregate} that wraps this
     *     AggregateFunction and associates it with the provided alias.
     */ as(e) {
        return new $2fa92ec193801792$export$add49c223b9ce4ea(this, e, "as");
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            functionValue: {
                name: this.name,
                args: this.params.map((t)=>t._toProto(e))
            }
        };
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        e = this._methodName ? e.contextWith({
            methodName: this._methodName
        }) : e, this.params.forEach((t)=>t._readUserData(e));
    }
}
/**
 *
 * An AggregateFunction with alias.
 */ class $2fa92ec193801792$export$add49c223b9ce4ea {
    constructor(e, t, n){
        this.aggregate = e, this.alias = t, this._methodName = n;
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        this.aggregate._readUserData(e);
    }
}
class $2fa92ec193801792$export$dabba94403d45c8e {
    constructor(e, t, n){
        this.expr = e, this.alias = t, this._methodName = n, this.exprType = "AliasedExpression", this.selectable = true;
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        this.expr._readUserData(e);
    }
}
/**
 * @internal
 */ class $2fa92ec193801792$var$__PRIVATE_ListOfExprs extends $2fa92ec193801792$export$766bf7dcfb630b6c {
    constructor(e, t){
        super(), this.ur = e, this._methodName = t, this.expressionType = "ListOfExpressions";
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            arrayValue: {
                values: this.ur.map((t)=>t._toProto(e))
            }
        };
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        this.ur.forEach((t)=>t._readUserData(e));
    }
}
/**
 *
 * Represents a reference to a field in a Firestore document, or outputs of a {@link @firebase/firestore/pipelines#Pipeline} stage.
 *
 * <p>Field references are used to access document field values in expressions and to specify fields
 * for sorting, filtering, and projecting data in Firestore pipelines.
 *
 * <p>You can create a `Field` instance using the static {@link @firebase/firestore/pipelines#field} method:
 *
 * @example
 * ```typescript
 * // Create a Field instance for the 'name' field
 * const nameField = field("name");
 *
 * // Create a Field instance for a nested field 'address.city'
 * const cityField = field("address.city");
 * ```
 */ class $2fa92ec193801792$export$e0c3a065614c6254 extends $2fa92ec193801792$export$766bf7dcfb630b6c {
    /**
     * @internal
     * @private
     * @hideconstructor
     * @param fieldPath
     */ constructor(e, t){
        super(), this.fieldPath = e, this._methodName = t, this.expressionType = "Field", this.selectable = true;
    }
    get _fieldPath() {
        return this.fieldPath;
    }
    get fieldName() {
        return this.fieldPath.canonicalString();
    }
    get alias() {
        return this.fieldName;
    }
    get expr() {
        return this;
    }
    // TODO(search) enable with backend support
    // /**
    //  * Perform a full-text search on this field.
    //  *
    //  * @remarks This Expression can only be used within a `search` stage.
    //  *
    //  * @param rquery Define the search query using the search domain-specific language (DSL).
    //  */
    // matches(rquery: string | Expression): BooleanExpression {
    //   return new FunctionExpression(
    //     'matches',
    //     [this, valueToDefaultExpr(rquery)],
    //     'matches'
    //   ).asBoolean();
    // }
    /**
     * @beta
     * Evaluates to the distance in meters between the location specified
     * by this field and the query location.
     *
     * @remarks This Expression can only be used within a `search` stage.
     *
     * @param location - Compute distance to this GeoPoint.
     */ geoDistance(e) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("geo_distance", [
            this,
            $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
        ], "geoDistance");
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            fieldReferenceValue: this.fieldPath.canonicalString()
        };
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {}
}
function $2fa92ec193801792$export$b4d5ecaefe2b27f3(e) {
    return $2fa92ec193801792$export$1abb261478089fe6(e, "field");
}
function $2fa92ec193801792$export$1abb261478089fe6(e, t) {
    return new $2fa92ec193801792$export$e0c3a065614c6254("string" == typeof e ? $2fa92ec193801792$var$Ce === e ? $2fa92ec193801792$export$9d0e2d13d04f7070()._internalPath : $2fa92ec193801792$export$625550452a3fa3ec("field", e) : e._internalPath, t);
}
/**
 * @internal
 *
 * Represents a constant value that can be used in a Firestore pipeline expression.
 *
 * You can create a `Constant` instance using the static {@link @firebase/firestore/pipelines#field} method:
 *
 * @example
 * ```typescript
 * // Create a Constant instance for the number 10
 * const ten = constant(10);
 *
 * // Create a Constant instance for the string "hello"
 * const hello = constant("hello");
 * ```
 */ class $2fa92ec193801792$var$Constant extends $2fa92ec193801792$export$766bf7dcfb630b6c {
    /**
     * @private
     * @internal
     * @hideconstructor
     * @param value - The value of the constant.
     */ constructor(e, t){
        super(), this.value = e, this._methodName = t, this.expressionType = "Constant";
    }
    /**
     * @private
     * @internal
     */ static _fromProto(e) {
        const t = new $2fa92ec193801792$var$Constant(e, void 0);
        return t._protoValue = e, t;
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return $2fa92ec193801792$var$__PRIVATE_hardAssert(void 0 !== this._protoValue, 237), this._protoValue;
    }
    _getValue() {
        return this._protoValue;
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        e = this._methodName ? e.contextWith({
            methodName: this._methodName
        }) : e, $2fa92ec193801792$export$993a080e5cb62d74(this._protoValue) || (this._protoValue = $2fa92ec193801792$var$__PRIVATE_parseData(this.value, e));
    }
}
function $2fa92ec193801792$export$674f8f4247a5112e(e, t) {
    return $2fa92ec193801792$export$2538633961795d6b(e, "constant");
}
/**
 * @internal
 * @private
 * @param value
 * @param methodName
 */ function $2fa92ec193801792$export$2538633961795d6b(e, t) {
    const n = new $2fa92ec193801792$var$Constant(e, t);
    return "boolean" == typeof e ? new $2fa92ec193801792$var$__PRIVATE_BooleanConstant(n) : n;
}
/**
 * Internal only
 * @internal
 * @private
 */ class $2fa92ec193801792$var$MapValue extends $2fa92ec193801792$export$766bf7dcfb630b6c {
    constructor(e, t){
        super(), this.cr = e, this._methodName = t, this.expressionType = "Constant";
    }
    _readUserData(e) {
        e = this._methodName ? e.contextWith({
            methodName: this._methodName
        }) : e, this.cr.forEach((t)=>{
            t._readUserData(e);
        });
    }
    _toProto(e) {
        return $2fa92ec193801792$var$toMapValue(e, this.cr);
    }
}
/**
 *
 * This class defines the base class for Firestore {@link @firebase/firestore/pipelines#Pipeline} functions, which can be evaluated within pipeline
 * execution.
 *
 * Typically, you would not use this class or its children directly. Use either the functions like {@link @firebase/firestore/pipelines#and}, {@link @firebase/firestore/pipelines#(equal:1)},
 * or the methods on {@link @firebase/firestore/pipelines#Expression} ({@link @firebase/firestore/pipelines#Expression.(equal:1)}, {@link @firebase/firestore/pipelines#Expression.(lessThan:1)}, etc.) to construct new Function instances.
 */ class $2fa92ec193801792$export$acf3ba20e47771d extends $2fa92ec193801792$export$766bf7dcfb630b6c {
    /**
     * @hideconstructor
     */ constructor(e, t, n, r){
        super(), this.name = e, this.params = t, this.expressionType = "Function", /**
         * @private
         * @internal
         */ this._optionsProto = void 0, void 0 !== n && (this._methodName = n), void 0 !== r && (this._options = r);
    }
    /**
     * @private
     * @internal
     */ get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        const t = {
            functionValue: {
                name: this.name,
                args: this.params.map((t)=>t._toProto(e))
            }
        };
        return this._optionsProto && (t.functionValue.options = this._optionsProto), t;
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        e = this._methodName ? e.contextWith({
            methodName: this._methodName
        }) : e, this.params.forEach((t)=>t._readUserData(e)), this._options && (this._optionsProto = this._optionsUtil.getOptionsProto(e, this._options));
    }
}
/**
 *
 * An interface that represents a filter condition.
 */ class $2fa92ec193801792$export$65ab0ebced932b79 extends $2fa92ec193801792$export$766bf7dcfb630b6c {
    get _methodName() {
        return this._expr._methodName;
    }
    /**
     * Creates an aggregation that finds the count of input documents satisfying
     * this boolean expression.
     *
     * @example
     * ```typescript
     * // Find the count of documents with a score greater than 90
     * field("score").greaterThan(90).countIf().as("highestScore");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'countIf' aggregation.
     */ countIf() {
        return $2fa92ec193801792$export$1ddf2d01943a3512._create("count_if", [
            this
        ], "countIf");
    }
    /**
     * Creates an expression that negates this boolean expression.
     *
     * @example
     * ```typescript
     * // Find documents where the 'tags' field does not contain 'completed'
     * field("tags").arrayContains("completed").not();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the negated filter condition.
     */ not() {
        return new $2fa92ec193801792$export$acf3ba20e47771d("not", [
            this
        ], "not").asBoolean();
    }
    /**
     * Creates a conditional expression that evaluates to the 'then' expression
     * if `this` expression evaluates to `true`,
     * or evaluates to the 'else' expression if `this` expressions evaluates `false`.
     *
     * @example
     * ```typescript
     * // If 'age' is greater than 18, return "Adult"; otherwise, return "Minor".
     * field("age").greaterThanOrEqual(18).conditional(constant("Adult"), constant("Minor"));
     * ```
     *
     * @param thenExpr - The expression to evaluate if the condition is true.
     * @param elseExpr - The expression to evaluate if the condition is false.
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the conditional expression.
     */ conditional(e, t) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("conditional", [
            this,
            e,
            t
        ], "conditional");
    }
    ifError(e) {
        const t = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e), n = new $2fa92ec193801792$export$acf3ba20e47771d("if_error", [
            this,
            t
        ], "ifError");
        return t instanceof $2fa92ec193801792$export$65ab0ebced932b79 ? n.asBoolean() : n;
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return this._expr._toProto(e);
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        this._expr._readUserData(e);
    }
}
class $2fa92ec193801792$var$__PRIVATE_BooleanFunctionExpression extends $2fa92ec193801792$export$65ab0ebced932b79 {
    constructor(e){
        super(), this._expr = e, this.expressionType = "Function";
    }
}
class $2fa92ec193801792$var$__PRIVATE_BooleanConstant extends $2fa92ec193801792$export$65ab0ebced932b79 {
    constructor(e){
        super(), this._expr = e, this.expressionType = "Constant";
    }
    _getValue() {
        return this._expr._getValue();
    }
}
class $2fa92ec193801792$var$__PRIVATE_BooleanField extends $2fa92ec193801792$export$65ab0ebced932b79 {
    constructor(e){
        super(), this._expr = e, this.expressionType = "Field";
    }
}
/**
 * Creates an aggregation that counts the number of stage inputs where the provided
 * boolean expression evaluates to true.
 *
 * @example
 * ```typescript
 * // Count the number of documents where 'is_active' field equals true
 * countIf(field("is_active").equal(true)).as("numActiveDocuments");
 * ```
 *
 * @param booleanExpr - The boolean expression to evaluate on each input.
 * @returns A new `AggregateFunction` representing the 'countIf' aggregation.
 */ function $2fa92ec193801792$export$cac96592272af85b(e) {
    return e.countIf();
}
function $2fa92ec193801792$export$49e6ee724f7f1ace(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayGet($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
/**
 *
 * Creates an expression that checks if a given expression produces an error.
 *
 * @example
 * ```typescript
 * // Check if the result of a calculation is an error
 * isError(field("title").arrayContains(1));
 * ```
 *
 * @param value - The expression to check.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the 'isError' check.
 */ function $2fa92ec193801792$export$5ff0b879ab65d0b0(e) {
    return e.isError().asBoolean();
}
function $2fa92ec193801792$export$bd7cbab8c073cd83(e, t) {
    return e instanceof $2fa92ec193801792$export$65ab0ebced932b79 && t instanceof $2fa92ec193801792$export$65ab0ebced932b79 ? e.ifError(t).asBoolean() : e.ifError($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$61c0af74ec47d243(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).isAbsent();
}
function $2fa92ec193801792$export$e5e9f924d040c2f1(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).mapRemove($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$479d1ccc5f2ab701(e, t, ...n) {
    const r = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t), i = n.map($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr);
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).mapMerge(r, ...i);
}
function $2fa92ec193801792$export$442d269b0886b975(e) {
    return $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e).documentId();
}
function $2fa92ec193801792$export$f089288e53d0d132(e) {
    return $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e).parent();
}
function $2fa92ec193801792$export$89d219c4c965baa6(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e), i = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t), s = void 0 === n ? void 0 : $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(n);
    return r.substring(i, s);
}
function $2fa92ec193801792$export$4f33f238a5c1ad77(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).add($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$7ff026c33490f1d6(t, n) {
    const r = "string" == typeof t ? $2fa92ec193801792$export$b4d5ecaefe2b27f3(t) : t, i = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(n);
    return r.subtract(i);
}
function $2fa92ec193801792$export$4113de5c72f4637b(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).multiply($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$14e06f865fe2f186(t, n) {
    const r = "string" == typeof t ? $2fa92ec193801792$export$b4d5ecaefe2b27f3(t) : t, i = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(n);
    return r.divide(i);
}
function $2fa92ec193801792$export$b09e910f6bc5792f(t, n) {
    const r = "string" == typeof t ? $2fa92ec193801792$export$b4d5ecaefe2b27f3(t) : t, i = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(n);
    return r.mod(i);
}
/**
 *
 * Creates an expression that creates a Firestore map value from an input object.
 *
 * @example
 * ```typescript
 * // Create a map from the input object and reference the 'baz' field value from the input document.
 * map({foo: 'bar', baz: field('baz')}).as('data');
 * ```
 *
 * @param elements - The input map to evaluate in the expression.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the map function.
 */ function $2fa92ec193801792$export$4d522598b426bb73(e) {
    return $2fa92ec193801792$var$__PRIVATE__map(e);
}
function $2fa92ec193801792$var$__PRIVATE__map(e, t) {
    const n = [];
    for(const t in e)if (Object.prototype.hasOwnProperty.call(e, t)) {
        const r = e[t];
        n.push($2fa92ec193801792$export$674f8f4247a5112e(t)), n.push($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(r));
    }
    return new $2fa92ec193801792$export$acf3ba20e47771d("map", n, "map");
}
/**
 * Internal use only
 * Converts a plainObject to a mapValue in the proto representation,
 * rather than a functionValue+map that is the result of the map(...) function.
 * This behaves different from constant(plainObject) because it
 * traverses the input object, converts values in the object to expressions,
 * and calls _readUserData on each of these expressions.
 * @private
 * @internal
 * @param plainObject
 */ function $2fa92ec193801792$export$45aabb5431c2d04f(e) {
    const t = new Map;
    for(const n in e)if (Object.prototype.hasOwnProperty.call(e, n)) {
        const r = e[n];
        t.set(n, $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(r));
    }
    return new $2fa92ec193801792$var$MapValue(t, void 0);
}
/**
 *
 * Creates an expression that creates a Firestore array value from an input array.
 *
 * @example
 * ```typescript
 * // Create an array value from the input array and reference the 'baz' field value from the input document.
 * array(['bar', field('baz')]).as('foo');
 * ```
 *
 * @param elements - The input array to evaluate in the expression.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the array function.
 */ function $2fa92ec193801792$export$6dabbe08653f866f(e) {
    return function __PRIVATE__array(e, t) {
        return new $2fa92ec193801792$export$acf3ba20e47771d("array", e.map((e)=>$2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)), t);
    }(e, "array");
}
function $2fa92ec193801792$export$9d2f55df59533b05(n, r) {
    const i = n instanceof $2fa92ec193801792$export$766bf7dcfb630b6c ? n : $2fa92ec193801792$export$b4d5ecaefe2b27f3(n), s = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(r);
    return i.equal(s);
}
function $2fa92ec193801792$export$9198f9466fc833e(n, r) {
    const i = n instanceof $2fa92ec193801792$export$766bf7dcfb630b6c ? n : $2fa92ec193801792$export$b4d5ecaefe2b27f3(n), s = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(r);
    return i.notEqual(s);
}
function $2fa92ec193801792$export$3dfa6803f1a6c839(n, r) {
    const i = n instanceof $2fa92ec193801792$export$766bf7dcfb630b6c ? n : $2fa92ec193801792$export$b4d5ecaefe2b27f3(n), s = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(r);
    return i.lessThan(s);
}
function $2fa92ec193801792$export$ceef9c3fcdc11035(n, r) {
    const i = n instanceof $2fa92ec193801792$export$766bf7dcfb630b6c ? n : $2fa92ec193801792$export$b4d5ecaefe2b27f3(n), s = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(r);
    return i.lessThanOrEqual(s);
}
function $2fa92ec193801792$export$27df29599c06edba(n, r) {
    const i = n instanceof $2fa92ec193801792$export$766bf7dcfb630b6c ? n : $2fa92ec193801792$export$b4d5ecaefe2b27f3(n), s = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(r);
    return i.greaterThan(s);
}
function $2fa92ec193801792$export$9afebd5b903c9b2(n, r) {
    const i = n instanceof $2fa92ec193801792$export$766bf7dcfb630b6c ? n : $2fa92ec193801792$export$b4d5ecaefe2b27f3(n), s = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(r);
    return i.greaterThanOrEqual(s);
}
function $2fa92ec193801792$export$1ec7a8278ebd1290(e, t, ...n) {
    const r = n.map((e)=>$2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e));
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayConcat($2fa92ec193801792$var$__PRIVATE_fieldOrExpression(t), ...r);
}
function $2fa92ec193801792$export$4ad369a19af21c23(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e), r = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t);
    return n.arrayContains(r);
}
function $2fa92ec193801792$export$54c4fabc2291e9c0(e, t) {
    // @ts-ignore implementation accepts both types
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayContainsAny(t);
}
function $2fa92ec193801792$export$89e9012e902952b6(e, t) {
    // @ts-ignore implementation accepts both types
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayContainsAll(t);
}
function $2fa92ec193801792$export$b975d55abac2bbe3(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayLength();
}
function $2fa92ec193801792$export$f4df619f1753fd48(e, t) {
    // @ts-ignore implementation accepts both types
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).equalAny(t);
}
function $2fa92ec193801792$export$979127a300539e02(e, t) {
    // @ts-ignore implementation accepts both types
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).notEqualAny(t);
}
/**
 *
 * Creates an expression that performs a logical 'XOR' (exclusive OR) operation on multiple BooleanExpressions.
 *
 * @example
 * ```typescript
 * // Check if only one of the conditions is true: 'age' greater than 18, 'city' is "London",
 * // or 'status' is "active".
 * const condition = xor(
 *     greaterThan("age", 18),
 *     equal("city", "London"),
 *     equal("status", "active"));
 * ```
 *
 * @param first - The first condition.
 * @param second - The second condition.
 * @param additionalConditions - Additional conditions to 'XOR' together.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical 'XOR' operation.
 */ function $2fa92ec193801792$export$b6568c80b9b0b3bb(e, t, ...n) {
    return new $2fa92ec193801792$export$acf3ba20e47771d("xor", [
        e,
        t,
        ...n
    ], "xor").asBoolean();
}
/**
 *
 * Creates a conditional expression that evaluates to a 'then' expression if a condition is true
 * and an 'else' expression if the condition is false.
 *
 * @example
 * ```typescript
 * // If 'age' is greater than 18, return "Adult"; otherwise, return "Minor".
 * conditional(
 *     greaterThan("age", 18), constant("Adult"), constant("Minor"));
 * ```
 *
 * @param condition - The condition to evaluate.
 * @param thenExpr - The expression to evaluate if the condition is true.
 * @param elseExpr - The expression to evaluate if the condition is false.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the conditional expression.
 */ function $2fa92ec193801792$export$e2c5c0657668816f(e, t, n) {
    return new $2fa92ec193801792$export$acf3ba20e47771d("conditional", [
        e,
        t,
        n
    ], "conditional");
}
/**
 *
 * Creates an expression that negates a filter condition.
 *
 * @example
 * ```typescript
 * // Find documents where the 'completed' field is NOT true
 * not(equal("completed", true));
 * ```
 *
 * @param booleanExpr - The filter condition to negate.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the negated filter condition.
 */ function $2fa92ec193801792$export$6c6581d59e81d1b9(e) {
    return e.not();
}
function $2fa92ec193801792$export$72f39d47420ee910(e, t, ...n) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).logicalMaximum($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t), ...n.map((e)=>$2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)));
}
function $2fa92ec193801792$export$eaaeafa904fe3ddf(e, t, ...n) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).logicalMinimum($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t), ...n.map((e)=>$2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)));
}
function $2fa92ec193801792$export$b8423798394d5395(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).exists();
}
function $2fa92ec193801792$export$cca44b2176b5b24(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).reverse();
}
function $2fa92ec193801792$export$c373adc892eb6355(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).byteLength();
}
function $2fa92ec193801792$export$a6a89e41033eb1f5(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).exp();
}
function $2fa92ec193801792$export$a274e22fb40f762e(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).ceil();
}
function $2fa92ec193801792$export$1b08679bee270a7(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).floor();
}
/**
 * Creates an aggregation that counts the number of distinct values of a field.
 *
 * @param expr - The expression or field to count distinct values of.
 * @returns A new `AggregateFunction` representing the 'count_distinct' aggregation.
 */ function $2fa92ec193801792$export$c26ed9b31334b7c5(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).countDistinct();
}
function $2fa92ec193801792$export$aea64bc1b6f8f415(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).charLength();
}
function $2fa92ec193801792$export$18981f2c53519bdb(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e), r = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t);
    return n.like(r);
}
function $2fa92ec193801792$export$4c9c5bd3cb5071b3(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e), r = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t);
    return n.regexContains(r);
}
function $2fa92ec193801792$export$a1edd97dd51cd48d(e, t, n) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayFilter(t, n);
}
function $2fa92ec193801792$export$bde1ed0f60b38f2f(e, t, n) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayTransform(t, n);
}
function $2fa92ec193801792$export$e9316ff9106cdb75(e, t, n, r) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayTransformWithIndex(t, n, r);
}
function $2fa92ec193801792$export$a3c9165b94390bcd(e, t, n) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arraySlice(t, n);
}
function $2fa92ec193801792$export$807f1ba34db587c7(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayFirst();
}
function $2fa92ec193801792$export$c7ca7e4bc4f8a16e(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayFirstN($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$c5d7c1ac98841e53(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayLast();
}
function $2fa92ec193801792$export$c1df809846363ebe(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayLastN($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$b02498c06ddfef28(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayMaximum();
}
function $2fa92ec193801792$export$1343a74baacb0543(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayMaximumN($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$87b6ab1c2cb8b955(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayMinimum();
}
function $2fa92ec193801792$export$cd571ca6d1702b73(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayMinimumN($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$6735ce526161c7bd(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayIndexOf($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$d92db8a7dc823bb0(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayLastIndexOf($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$6e4b1d19c6e2e012(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayIndexOfAll($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$877f099d45b93781(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e), r = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t);
    return n.regexFind(r);
}
function $2fa92ec193801792$export$35ed09b180ef97ea(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e), r = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t);
    return n.regexFindAll(r);
}
function $2fa92ec193801792$export$2b8fb79170dd2867(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e), r = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t);
    return n.regexMatch(r);
}
function $2fa92ec193801792$export$f856ea2695751642(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e), r = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t);
    return n.stringContains(r);
}
function $2fa92ec193801792$export$67f43c86699e7942(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).startsWith($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$dfbc9f8d49064aaa(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).endsWith($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$8cf43619936b7867(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).toLower();
}
function $2fa92ec193801792$export$5c585649956053b(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).toUpper();
}
function $2fa92ec193801792$export$e6142e6054105de8(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).trim(t);
}
function $2fa92ec193801792$export$2fa162a495d26869(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).ltrim(t);
}
function $2fa92ec193801792$export$4057e2e08e752e42(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).rtrim(t);
}
function $2fa92ec193801792$export$3e0e4217c1341b05(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).type();
}
function $2fa92ec193801792$export$8ba20c7a218ff803(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).isType(t);
}
function $2fa92ec193801792$export$f4ac706686bb6b94(e, t, ...n) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).stringConcat($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t), ...n.map($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr));
}
function $2fa92ec193801792$export$9eb7d68b803f333e(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).stringIndexOf(t);
}
function $2fa92ec193801792$export$d006832d466f7288(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).stringRepeat(t);
}
function $2fa92ec193801792$export$780222aa087431a(e, t, n) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).stringReplaceAll(t, n);
}
function $2fa92ec193801792$export$8f88bf9884346f21(e, t, n) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).stringReplaceOne(t, n);
}
function $2fa92ec193801792$export$2aa5a0e309f2893e(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).mapGet(t);
}
function $2fa92ec193801792$export$b4f27e0fc616e2cc(e, t, n, ...r) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).mapSet(t, n, ...r);
}
function $2fa92ec193801792$export$28bdf2a38ef37818(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).mapKeys();
}
function $2fa92ec193801792$export$53d26b7a9a23d594(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).mapValues();
}
function $2fa92ec193801792$export$2055d1a955f03d83(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).mapEntries();
}
/**
 * Creates an aggregation that counts the total number of stage inputs.
 *
 * @example
 * ```typescript
 * // Count the total number of input documents
 * countAll().as("totalDocument");
 * ```
 *
 * @returns A new {@link @firebase/firestore/pipelines#AggregateFunction} representing the 'countAll' aggregation.
 */ function $2fa92ec193801792$export$e856a6a9bfd75991() {
    return $2fa92ec193801792$export$1ddf2d01943a3512._create("count", [], "count");
}
function $2fa92ec193801792$export$d0b8fd51f345f3c4(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).count();
}
function $2fa92ec193801792$export$a71af22d6b7f045f(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).sum();
}
function $2fa92ec193801792$export$1776704b6532a19a(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).average();
}
function $2fa92ec193801792$export$1ec27080ebb34cc5(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).minimum();
}
function $2fa92ec193801792$export$dac0feeddfa6e7d(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).maximum();
}
function $2fa92ec193801792$export$c866f24f04caecda(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).first();
}
function $2fa92ec193801792$export$75f09c6dff6140e4(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).last();
}
function $2fa92ec193801792$export$df7c425476ed4f2(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayAgg();
}
function $2fa92ec193801792$export$f5339a28e56d1baf(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arrayAggDistinct();
}
function $2fa92ec193801792$export$5f39619cda7ef666(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e), r = $2fa92ec193801792$var$__PRIVATE_vectorToExpr(t);
    return n.cosineDistance(r);
}
function $2fa92ec193801792$export$8b5c9fc32300301a(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e), r = $2fa92ec193801792$var$__PRIVATE_vectorToExpr(t);
    return n.dotProduct(r);
}
function $2fa92ec193801792$export$5cd0acb7e4618351(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e), r = $2fa92ec193801792$var$__PRIVATE_vectorToExpr(t);
    return n.euclideanDistance(r);
}
function $2fa92ec193801792$export$f2e0ce65e7cf9b72(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).vectorLength();
}
function $2fa92ec193801792$export$386ba9289b75caa8(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).unixMicrosToTimestamp();
}
function $2fa92ec193801792$export$b626a1a623cddf9c(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).timestampToUnixMicros();
}
function $2fa92ec193801792$export$ecf3680988977892(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).unixMillisToTimestamp();
}
function $2fa92ec193801792$export$10967c44ee7a7824(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).timestampToUnixMillis();
}
function $2fa92ec193801792$export$430a2249591529d3(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).unixSecondsToTimestamp();
}
function $2fa92ec193801792$export$e78fd51b94b96331(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).timestampToUnixSeconds();
}
function $2fa92ec193801792$export$76c46b74e9079f74(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e), i = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t), s = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(n);
    return r.timestampAdd(i, s);
}
function $2fa92ec193801792$export$7ab585746576f734(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e), i = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t), s = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(n);
    return r.timestampSubtract(i, s);
}
/**
 *
 * Creates an expression that evaluates to the current server timestamp.
 *
 * @example
 * ```typescript
 * // Get the current server timestamp
 * currentTimestamp()
 * ```
 *
 * @returns A new Expression representing the current server timestamp.
 */ function $2fa92ec193801792$export$e574dd6aa004e569() {
    return new $2fa92ec193801792$export$acf3ba20e47771d("current_timestamp", [], "currentTimestamp");
}
/**
 *
 * Creates an expression that performs a logical 'AND' operation on multiple filter conditions.
 *
 * @example
 * ```typescript
 * // Check if the 'age' field is greater than 18 AND the 'city' field is "London" AND
 * // the 'status' field is "active"
 * const condition = and(greaterThan("age", 18), equal("city", "London"), equal("status", "active"));
 * ```
 *
 * @param first - The first filter condition.
 * @param second - The second filter condition.
 * @param more - Additional filter conditions to 'AND' together.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical 'AND' operation.
 */ function $2fa92ec193801792$export$7fe88b5920ffddd2(e, t, ...n) {
    return new $2fa92ec193801792$export$acf3ba20e47771d("and", [
        e,
        t,
        ...n
    ], "and").asBoolean();
}
/**
 *
 * Creates an expression that performs a logical 'OR' operation on multiple filter conditions.
 *
 * @example
 * ```typescript
 * // Check if the 'age' field is greater than 18 OR the 'city' field is "London" OR
 * // the 'status' field is "active"
 * const condition = or(greaterThan("age", 18), equal("city", "London"), equal("status", "active"));
 * ```
 *
 * @param first - The first filter condition.
 * @param second - The second filter condition.
 * @param more - Additional filter conditions to 'OR' together.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical 'OR' operation.
 */ function $2fa92ec193801792$export$2b548b2e30e1dd12(e, t, ...n) {
    return new $2fa92ec193801792$export$acf3ba20e47771d("or", [
        e,
        t,
        ...n
    ], "xor").asBoolean();
}
/**
 *
 * Creates an expression that performs a logical 'NOR' operation on multiple filter conditions.
 *
 * @example
 * ```typescript
 * // Check if neither the 'age' field is greater than 18 nor the 'city' field is "London"
 * const condition = nor(
 *   greaterThan("age", 18),
 *   equal("city", "London")
 * );
 * ```
 *
 * @param first - The first filter condition.
 * @param second - The second filter condition.
 * @param more - Additional filter conditions to 'NOR' together.
 * @returns A new {@link @firebase/firestore/pipelines#BooleanExpression} representing the logical 'NOR' operation.
 */ function $2fa92ec193801792$export$7c49ce7c630afad5(e, t, ...n) {
    return new $2fa92ec193801792$export$acf3ba20e47771d("nor", [
        e,
        t,
        ...n
    ], "nor").asBoolean();
}
function $2fa92ec193801792$export$dfa1698a1e9944f5(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).pow(t);
}
/**
 *
 * Creates an expression that generates a random number between 0.0 and 1.0 but not including 1.0.
 *
 * @example
 * ```typescript
 * // Generate a random number between 0.0 and 1.0.
 * rand();
 * ```
 *
 * @returns A new `Expression` representing the rand operation.
 */ function $2fa92ec193801792$export$df8cac1947751fe2() {
    return new $2fa92ec193801792$export$acf3ba20e47771d("rand", [], "rand");
}
function $2fa92ec193801792$export$1fdf989998e04586(e, t) {
    return void 0 === t ? $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).round() : $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).round($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$bee557efb6b6e(e, t) {
    return void 0 === t ? $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).trunc() : $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).trunc($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$afbe48a4a4275937(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).collectionId();
}
function $2fa92ec193801792$export$5889bd2d81e52552(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).length();
}
function $2fa92ec193801792$export$94202a6a16ecfef9(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).ln();
}
function $2fa92ec193801792$export$8c8450b83b664ba4(e, t) {
    return new $2fa92ec193801792$export$acf3ba20e47771d("log", [
        $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e),
        $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t)
    ]);
}
function $2fa92ec193801792$export$382baae81601348e(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).sqrt();
}
function $2fa92ec193801792$export$4b4160c0c582e338(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).stringReverse();
}
function $2fa92ec193801792$export$f572e3cd01c21b80(e, t, ...n) {
    return new $2fa92ec193801792$export$acf3ba20e47771d("concat", [
        $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e),
        $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t),
        ...n.map($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr)
    ]);
}
function $2fa92ec193801792$export$df838d0240c938cf(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).abs();
}
function $2fa92ec193801792$export$f4d17792a1948a63(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).ifAbsent($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$68488251523c02c0(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).ifNull(t);
}
function $2fa92ec193801792$export$67ff43e65e668f2b(e, t, ...n) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).coalesce(t, ...n);
}
/**
 * Creates an expression that evaluates to the result corresponding to the first true condition.
 *
 * @remarks
 * This function behaves like a `switch` statement. It accepts an alternating sequence of conditions
 * and their corresponding results.
 * If an odd number of arguments is provided, the final argument serves as a default fallback result.
 * If no default is provided and no condition evaluates to true, it throws an error.
 *
 * @example
 * ```typescript
 * // Return "Active" if field "status" is 1, "Pending" if field "status" is 2,
 * // and default to "Unknown" if none of the conditions are true.
 * switchOn(
 *   equal(field("status"), 1), constant("Active"),
 *   equal(field("status"), 2), constant("Pending"),
 *   constant("Unknown")
 * )
 * ```
 *
 * @param condition - The first condition to check.
 * @param result - The result if the first condition is true.
 * @param others - Additional conditions and results, and optionally a default value.
 * @returns A new Expression representing the switch operation.
 */ function $2fa92ec193801792$export$ed5ad63bb4971148(e, t, ...n) {
    return new $2fa92ec193801792$export$acf3ba20e47771d("switch_on", [
        $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e),
        $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t),
        ...n.map($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr)
    ], "switchOn");
}
function $2fa92ec193801792$export$4707f455a0e6a485(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).join($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$f932f06c7eb6abeb(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).log10();
}
function $2fa92ec193801792$export$cbfbec548517f2b6(e) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).arraySum();
}
function $2fa92ec193801792$export$127e440b727e338f(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).split($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t));
}
function $2fa92ec193801792$export$a191827a7c796803(e, t, n) {
    const r = $2fa92ec193801792$export$4ae495d48253603d(t) ? $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t) : t;
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).timestampTruncate(r, n);
}
/**
 * @public
 * Creates an expression that retrieves the value of a variable bound via `define()`.
 *
 * @example
 * ```typescript
 * db.pipeline().collection("products")
 *   .define(
 *     field("price").multiply(0.9).as("discountedPrice"),
 *     field("stock").add(10).as("newStock")
 *   )
 *   .where(variable("discountedPrice").lessThan(100))
 *   .select(field("name"), variable("newStock"));
 * ```
 *
 * @param name - The name of the variable to retrieve.
 * @returns An {@link @firebase/firestore/pipelines#Expression} representing the variable's value.
 */ function $2fa92ec193801792$export$76377e288772571c(e) {
    return new $2fa92ec193801792$var$__PRIVATE_VariableExpression(e);
}
/**
 * @internal
 *
 * Expression representing a variable reference. This evaluates to the value of a variable
 * defined in a pipeline.
 */ class $2fa92ec193801792$var$__PRIVATE_VariableExpression extends $2fa92ec193801792$export$766bf7dcfb630b6c {
    /**
     * @hideconstructor
     */ constructor(e){
        super(), this.name = e, this.expressionType = "Variable";
    }
    /**
     * @internal
     */ _toProto(e) {
        return {
            variableReferenceValue: this.name
        };
    }
    /**
     * @internal
     */ _readUserData(e) {}
}
/**
 * @public
 * Creates an expression that represents the current document being processed.
 *
 * @example
 * ```typescript
 * // Define the current document as a variable "doc"
 * firestore.pipeline().collection("books")
 *     .define(currentDocument().as("doc"))
 *     // Access a field from the defined document variable
 *     .select(variable("doc").mapGet("title"));
 * ```
 *
 * @returns An {@link @firebase/firestore/pipelines#Expression} representing the current document.
 */ function $2fa92ec193801792$export$1dfcf732dfa226de() {
    return new $2fa92ec193801792$export$acf3ba20e47771d("current_document", []);
}
/**
 * @internal
 */ function $2fa92ec193801792$export$1314441b8d04e1d5(e) {
    return new $2fa92ec193801792$var$__PRIVATE_PipelineValueExpression(e);
}
/**
 * @internal
 */ class $2fa92ec193801792$var$__PRIVATE_PipelineValueExpression extends $2fa92ec193801792$export$766bf7dcfb630b6c {
    /**
     * @hideconstructor
     */ constructor(e){
        super(), this.pipeline = e, this.expressionType = "PipelineValue";
    }
    /**
     * @internal
     */ _toProto(e) {
        return $2fa92ec193801792$var$__PRIVATE_toPipelineValue(this.pipeline._toProto(e));
    }
    /**
     * @internal
     */ _readUserData(e) {
        this.pipeline._readUserData(e);
    }
}
function $2fa92ec193801792$export$2dd707df679de14f(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e), i = $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(t), s = $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(n);
    return r.timestampDiff(i, s);
}
function $2fa92ec193801792$export$ac4ac9092d127df3(e, t, n) {
    return $2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e).timestampExtract($2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(t), n);
}
// TODO(search) enable with backend support
// /**
//  * Perform a full-text search on the specified field.
//  *
//  * @remarks This Expression can only be used within a `search` stage.
//  *
//  * @example
//  * ```typescript
//  * db.pipeline().collection('restaurants').search({
//  *   query: matches('menu', 'waffles')
//  * })
//  * ```
//  *
//  * @param searchField Search the specified field.
//  * @param rquery Define the search query using the search domain-specific language (DSL).
//  */
// export function matches(
//   searchField: string | Field,
//   rquery: string | Expression
// ): BooleanExpression {
//   return toField(searchField).matches(rquery);
// }
/**
 * @beta
 * Perform a full-text search on all indexed search fields in the document.
 *
 * @remarks This Expression can only be used within a `search` stage.
 *
 * @example
 * ```typescript
 * db.pipeline().collection('restaurants').search({
 *   query: documentMatches('waffles OR pancakes')
 * })
 * ```
 *
 * @param rquery Define the search query using the search domain-specific language (DSL).
 */ function $2fa92ec193801792$export$d76842aa27385215(e) {
    return new $2fa92ec193801792$export$acf3ba20e47771d("document_matches", [
        $2fa92ec193801792$var$__PRIVATE_valueToDefaultExpr(e)
    ], "documentMatches").asBoolean();
}
/**
 * @beta
 *
 * Evaluates to the search score that reflects the topicality of the document
 * to all of the text predicates (for example: `documentMatches`)
 * in the search query. If `SearchOptions.query` is not set or does not contain
 * any text predicates, then this topicality score will always be `0`.
 *
 * @example
 * ```typescript
 * db.pipeline().collection('restaurants').search({
 *   query: 'waffles',
 *   sort: score().descending()
 * })
 * ```
 *
 * @remarks This Expression can only be used within a `search` stage.
 */ function $2fa92ec193801792$export$da8061bacc7a8f46() {
    return new $2fa92ec193801792$export$acf3ba20e47771d("score", [], "score");
}
// TODO(search) enable with backend support
// /**
//  * Options defining how a snippet expression is evaluated.
//  */
// export interface SnippetOptions {
//   /**
//    * Define the search query using the search domain-specific language (DSL).
//    */
//   rquery: string;
//   /**
//    * The maximum width of the string estimated for a variable width font. The
//    * unit is tenths of ems. The default is `160`.
//    */
//   maxSnippetWidth?: number;
//   /**
//    * The maximum number of non-contiguous pieces of text in the returned snippet.
//    * The default is `1`.
//    */
//   maxSnippets?: number;
//   /**
//    * The string to join the pieces. The default value is '\n'
//    */
//   separator?: string;
// }
// /**
//  * Evaluates to an HTML-formatted text snippet that highlights terms matching
//  * the search query in `<b>bold</b>`.
//  *
//  * @remarks This Expression can only be used within a `search` stage.
//  *
//  * @example
//  * ```typescript
//  * db.pipeline().collection('restaurants').search({
//  *   query: 'waffles',
//  *   addFields: { snippet: snippet('menu', 'waffles') }
//  * })
//  * ```
//  *
//  * @param searchField Search the specified field for matching terms.
//  * @param rquery Define the search query using the search domain-specific language (DSL).
//  */
// export function snippet(
//   searchField: string | Field,
//   rquery: string
// ): Expression;
// /**
//  * Evaluates to an HTML-formatted text snippet that highlights terms matching
//  * the search query in `<b>bold</b>`.
//  *
//  * @remarks This Expression can only be used within a `search` stage.
//  *
//  * @param searchField Search the specified field for matching terms.
//  * @param options Define the search query using the search domain-specific language (DSL).
//  */
// export function snippet(
//   searchField: string | Field,
//   options: SnippetOptions
// ): Expression;
// export function snippet(
//   field: string | Field,
//   queryOrOptions: string | SnippetOptions
// ): Expression {
//   return toField(field).snippet(
//     isString(queryOrOptions) ? { rquery: queryOrOptions } : queryOrOptions
//   );
// }
/**
 * @beta
 * Evaluates to the distance in meters between the location in the specified
 * field and the query location.
 *
 * @remarks This Expression can only be used within a `search` stage.
 *
 * @example
 * ```typescript
 * db.pipeline().collection('restaurants').search({
 *   query: 'waffles',
 *   sort: geoDistance('location', new GeoPoint(37.0, -122.0)).ascending()
 * })
 * ```
 *
 * @param fieldName - Specifies the field in the document which contains
 * the first GeoPoint for distance computation.
 * @param location - Compute distance to this GeoPoint.
 */ function $2fa92ec193801792$export$42bcab07638ec4d7(e, t) {
    return $2fa92ec193801792$export$26a0a7676ca7aa04(e).geoDistance(t);
}
function $2fa92ec193801792$export$9ddbdd0bfc5623a(e) {
    return new $2fa92ec193801792$export$101619b11a34a0bd($2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e), "ascending", "ascending");
}
function $2fa92ec193801792$export$b37556a6cf1be916(e) {
    return new $2fa92ec193801792$export$101619b11a34a0bd($2fa92ec193801792$var$__PRIVATE_fieldOrExpression(e), "descending", "descending");
}
/**
 *
 * Represents an ordering criterion for sorting documents in a Firestore pipeline.
 *
 * You create `Ordering` instances using the `ascending` and `descending` helper functions.
 */ class $2fa92ec193801792$export$101619b11a34a0bd {
    constructor(e, t, n){
        this.expr = e, this.direction = t, this._methodName = n, this._protoValueType = "ProtoValue";
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            mapValue: {
                fields: {
                    direction: $2fa92ec193801792$var$__PRIVATE_toStringValue(this.direction),
                    expression: this.expr._toProto(e)
                }
            }
        };
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        this.expr._readUserData(e);
    }
}
function $2fa92ec193801792$export$136fd86de524d3c2(e) {
    const t = e;
    return t.selectable && $2fa92ec193801792$export$4ae495d48253603d(t.alias) && $2fa92ec193801792$export$eb84e45a33f6ba7c(t.expr);
}
function $2fa92ec193801792$export$b0165a7e514844(e) {
    const t = e;
    return null != t && $2fa92ec193801792$export$eb84e45a33f6ba7c(t.expr) && ("ascending" === t.direction || "descending" === t.direction);
}
function $2fa92ec193801792$export$5dbe06c6d8c68cfb(e) {
    const t = e;
    return $2fa92ec193801792$export$4ae495d48253603d(t.alias) && t.aggregate instanceof $2fa92ec193801792$export$1ddf2d01943a3512;
}
function $2fa92ec193801792$export$eb84e45a33f6ba7c(e) {
    return e instanceof $2fa92ec193801792$export$766bf7dcfb630b6c;
}
function $2fa92ec193801792$export$b169257caa88022a(e) {
    return e instanceof $2fa92ec193801792$export$65ab0ebced932b79;
}
function $2fa92ec193801792$export$a36fb7d24305ed9d(e) {
    return e instanceof $2fa92ec193801792$export$dabba94403d45c8e;
}
function $2fa92ec193801792$export$62d08d6fa708df47(e) {
    return e instanceof $2fa92ec193801792$export$e0c3a065614c6254;
}
function $2fa92ec193801792$export$26a0a7676ca7aa04(t) {
    if ($2fa92ec193801792$export$4ae495d48253603d(t)) return $2fa92ec193801792$export$b4d5ecaefe2b27f3(t);
    return t;
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$var$Stage {
    constructor(e){
        /**
         * Store _optionsProto parsed by _readUserData.
         * @private
         * @internal
         * @protected
         */ this.optionsProto = void 0, { rawOptions: this.rawOptions, ...this.knownOptions } = e;
    }
    _readUserData(e) {
        this.optionsProto = this._optionsUtil.getOptionsProto(e, this.knownOptions, this.rawOptions);
    }
    _toProto(e) {
        return {
            name: this._name,
            options: this.optionsProto
        };
    }
}
class $2fa92ec193801792$export$31e67cf12fc9668 extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "add_fields";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.fields = e;
    }
    _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $2fa92ec193801792$var$toMapValue(e, this.fields)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.fields, e);
    }
}
class $2fa92ec193801792$export$5521614468b862fb extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "remove_fields";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.fields = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: this.fields.map((t)=>t._toProto(e))
        };
    }
    _readUserData(e) {
        super._readUserData(e), $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.fields, e);
    }
}
/**
 * @public
 */ class $2fa92ec193801792$export$55ff3cc1821e8445 extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "let";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.lr = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $2fa92ec193801792$var$toMapValue(e, this.lr)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.lr, e);
    }
}
class $2fa92ec193801792$export$45d219bdcd8ac53c extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "aggregate";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
    constructor(e, t, n){
        super(n), this.groups = e, this.accumulators = t;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $2fa92ec193801792$var$toMapValue(e, this.accumulators),
                $2fa92ec193801792$var$toMapValue(e, this.groups)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.groups, e), $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.accumulators, e);
    }
}
class $2fa92ec193801792$export$f438b12253c2b499 extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "distinct";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.groups = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $2fa92ec193801792$var$toMapValue(e, this.groups)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.groups, e);
    }
}
class $2fa92ec193801792$export$c5d1328b37d47994 extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "collection";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({
            forceIndex: {
                serverName: "force_index"
            }
        });
    }
    constructor(e, t){
        super(t), // prepend slash to collection string
        this.Er = e.startsWith("/") ? e : "/" + e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                {
                    referenceValue: this.Er
                }
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class $2fa92ec193801792$export$d22783b3c2400a3a extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "collection_group";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({
            forceIndex: {
                serverName: "force_index"
            }
        });
    }
    constructor(e, t){
        super(t), this.collectionId = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                {
                    referenceValue: ""
                },
                {
                    stringValue: this.collectionId
                }
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class $2fa92ec193801792$export$c667925124dac624 extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "subcollection";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.path = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                {
                    stringValue: this.path
                }
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class $2fa92ec193801792$export$7f557e5eb95176c2 extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "database";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e)
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class $2fa92ec193801792$export$51b138e5a065c2bb extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "documents";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
    constructor(e, t){
        if (super(t), !e || 0 === e.length) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Empty document paths are not allowed in DocumentsSource");
        const n = e.map((e)=>e.startsWith("/") ? e : "/" + e), r = new Set(n);
        if (r.size !== n.length) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Duplicate document paths are not allowed in DocumentsSource");
        this.hr = n, this.Tr = r;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: this.hr.map((e)=>({
                    referenceValue: e
                }))
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class $2fa92ec193801792$export$4b170465d7badfa1 extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "where";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.condition = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                this.condition._toProto(e)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.condition, e);
    }
}
class $2fa92ec193801792$export$2e63b696b2c9441b extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "find_nearest";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({
            limit: {
                serverName: "limit"
            },
            distanceField: {
                serverName: "distance_field"
            }
        });
    }
    constructor(e, t, n, r){
        super(r), this.vectorValue = e, this.field = t, this.distanceMeasure = n;
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                this.field._toProto(e),
                this.vectorValue._toProto(e),
                $2fa92ec193801792$var$__PRIVATE_toStringValue(this.distanceMeasure)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.vectorValue, e), $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.field, e);
    }
}
class $2fa92ec193801792$export$56350196709588fc extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "limit";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
    constructor(e, t){
        $2fa92ec193801792$var$__PRIVATE_hardAssert(!isNaN(e) && e !== 1 / 0 && e !== -1 / 0, 34860), super(t), this.limit = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $2fa92ec193801792$var$toNumber(e, this.limit)
            ]
        };
    }
}
class $2fa92ec193801792$export$4e222d082f82ee97 extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "offset";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.offset = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $2fa92ec193801792$var$toNumber(e, this.offset)
            ]
        };
    }
}
class $2fa92ec193801792$export$847533e5bf524f5f extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "select";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.selections = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $2fa92ec193801792$var$toMapValue(e, this.selections)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.selections, e);
    }
}
class $2fa92ec193801792$export$b2bcef12bcefba04 extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "sort";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.orderings = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: this.orderings.map((t)=>t._toProto(e))
        };
    }
    _readUserData(e) {
        super._readUserData(e), $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.orderings, e);
    }
}
class $2fa92ec193801792$export$60bb826a6acf3081 extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "sample";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
    constructor(e, t, n){
        super(n), this.rate = e, this.mode = t;
    }
    _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $2fa92ec193801792$var$toNumber(e, this.rate),
                $2fa92ec193801792$var$__PRIVATE_toStringValue(this.mode)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class $2fa92ec193801792$export$27d1aff6bea49709 extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "union";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.other = e;
    }
    _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $2fa92ec193801792$var$__PRIVATE_toPipelineValue(this.other._toProto(e))
            ]
        };
    }
    _readUserData(e) {
        this.other._readUserData(e), super._readUserData(e);
    }
}
class $2fa92ec193801792$export$ebc5e65867841cbe extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "unnest";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({
            indexField: {
                serverName: "index_field"
            }
        });
    }
    constructor(e, t, n){
        super(n), this.alias = e, this.expr = t;
    }
    _toProto(t) {
        return {
            ...super._toProto(t),
            args: [
                this.expr._toProto(t),
                $2fa92ec193801792$export$b4d5ecaefe2b27f3(this.alias)._toProto(t)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.expr, e);
    }
}
class $2fa92ec193801792$export$aff10ba49ece4b91 extends $2fa92ec193801792$var$Stage {
    get _name() {
        return "replace_with";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.map = e;
    }
    _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                this.map._toProto(e),
                $2fa92ec193801792$var$__PRIVATE_toStringValue($2fa92ec193801792$export$aff10ba49ece4b91.Pr)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.map, e);
    }
}
$2fa92ec193801792$export$aff10ba49ece4b91.Pr = "full_replace";
/**
 * @beta
 */ class $2fa92ec193801792$export$381353cf1dd55255 extends $2fa92ec193801792$var$Stage {
    constructor(e){
        super(e), this.Rr = e;
    }
    get _name() {
        return "search";
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({
            query: {
                serverName: "query"
            },
            limit: {
                serverName: "limit"
            },
            retrievalDepth: {
                serverName: "retrieval_depth"
            },
            sort: {
                serverName: "sort"
            },
            addFields: {
                serverName: "add_fields"
            },
            select: {
                serverName: "select"
            },
            offset: {
                serverName: "offset"
            },
            Ir: {
                serverName: "query_enhancement"
            },
            languageCode: {
                serverName: "language_code"
            }
        });
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: []
        };
    }
    _readUserData(e) {
        $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.Rr.query, e), this.Rr.addFields && $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.Rr.addFields, e), this.Rr.select && $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.Rr.select, e), this.Rr.sort && $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.Rr.sort, e), super._readUserData(e);
    }
}
/**
 * @beta
 */ class $2fa92ec193801792$export$a91cd623adc48128 extends $2fa92ec193801792$var$Stage {
    /**
     * @private
     * @internal
     */ constructor(e, t, n){
        super({
            rawOptions: n
        }), this.name = e, this.params = t;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            name: this.name,
            args: this.params.map((t)=>t._toProto(e)),
            options: this.optionsProto
        };
    }
    _readUserData(e) {
        super._readUserData(e), $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(this.params, e);
    }
    get _name() {
        return this.name;
    }
    get _optionsUtil() {
        return new $2fa92ec193801792$var$OptionsUtil({});
    }
}
/**
 * Helper to read user data across a number of different formats.
 * @param name - Name of the calling function. Used for error messages when invalid user data is encountered.
 * @param expressionMap
 * @returns the expressionMap argument.
 * @private
 */ function $2fa92ec193801792$var$__PRIVATE_readUserDataHelper(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_isUserData(e) ? e._readUserData(t) : Array.isArray(e) ? e.forEach((e)=>e._readUserData(t)) : e instanceof Map ? e.forEach((e)=>e._readUserData(t)) : Object.values(e).forEach((e)=>e._readUserData(t)), e;
}
/**
 * @license
 * Copyright 2026 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @beta
 * @internal
 *
 * The RealtimePipeline class provides a flexible and expressive framework for building complex data
 * transformation and query pipelines that can be used with Firestore's real-time and offline capabilities.
 *
 * A RealtimePipeline takes data sources, such as Firestore collections or collection groups, and applies
 * a series of stages that are chained together. Each stage takes the output from the previous stage
 * (or the data source) and produces an output for the next stage (or as the final output of the
 * pipeline).
 *
 * Expressions can be used within each stage to filter and transform data through the stage.
 *
 * NOTE: Both the initial and subsequent snapshots for RealtimePipeline take the consideration of the SDK's cache.
 * They might include results that have not been synchronized with the server yet, and wait for subsequent snapshots
 * to reflect the latest server state, this is the same as classic Firestore {@link Query}.
 * This behavior is different from the {@link Pipeline} class, which does not take the consideration of the SDK's cache.
 *
 * Usage Examples:
 *
 * ```typescript
 * const db: Firestore; // Assumes a valid firestore instance.
 *
 * // Example 1: Listen to books published after 1980
 * const unsubscribe = onRealtimePipelineSnapshot(db.realtimePipeline()
 *     .collection("books")
 *     .where(field("published").gt(1980)),
 *     (snapshot) => {
 *       // Handle the snapshot
 *     }
 * );
 * ```
 */ // TODO(pipeline): Add more examples to showcase functions
class $2fa92ec193801792$var$__PRIVATE_RealtimePipeline {
    /**
     * @internal
     * @private
     * @param _db
     * @param userDataReader
     * @param _userDataWriter
     * @param _documentReferenceFactory
     * @param stages
     */ constructor(/**
     * @internal
     * @private
     */ e, /**
     * @internal
     * @private
     */ t, /**
     * @internal
     * @private
     */ n, r){
        this._db = e, this.userDataReader = t, this._userDataWriter = n, this.stages = r;
    }
    /**
     * Reads user data for each expression in the expressionMap.
     * @param name Name of the calling function. Used for error messages when invalid user data is encountered.
     * @param expressionMap
     * @return the expressionMap argument.
     * @private
     * @internal
     */ Ar(e, t) {
        const n = this.userDataReader.createContext(3 /* UserDataSource.Argument */ , e);
        return $2fa92ec193801792$var$__PRIVATE_isUserData(t) ? t._readUserData(n) : Array.isArray(t) ? t.forEach((e)=>e._readUserData(n)) : t.forEach((e)=>e._readUserData(n)), t;
    }
    where(e) {
        const t = this.stages.map((e)=>e);
        return this.Ar("where", e), t.push(new $2fa92ec193801792$export$4b170465d7badfa1(e, {})), new $2fa92ec193801792$var$__PRIVATE_RealtimePipeline(this._db, this.userDataReader, this._userDataWriter, t);
    }
    limit(e) {
        const t = this.stages.map((e)=>e);
        return t.push(new $2fa92ec193801792$export$56350196709588fc(e, {})), new $2fa92ec193801792$var$__PRIVATE_RealtimePipeline(this._db, this.userDataReader, this._userDataWriter, t);
    }
    sort(e, ...t) {
        const n = this.stages.map((e)=>e);
        // Option object
        return "orderings" in e ? n.push(new $2fa92ec193801792$export$b2bcef12bcefba04(this.Ar("sort", e.orderings), {})) : // Ordering object
        n.push(new $2fa92ec193801792$export$b2bcef12bcefba04(this.Ar("sort", [
            e,
            ...t
        ]), {})), new $2fa92ec193801792$var$__PRIVATE_RealtimePipeline(this._db, this.userDataReader, this._userDataWriter, n);
    }
    /**
     * @internal
     * @private
     */ Vr(e) {
        return {
            pipeline: {
                stages: this.stages.map((t)=>t._toProto(e))
            }
        };
    }
}
// Copyright 2024 Google LLC* @license
// Copyright 2024 Google LLC
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//      http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
class $2fa92ec193801792$var$__PRIVATE_EvaluateResult {
    constructor(e, t){
        this.type = e, this.value = t;
    }
    static dr() {
        return new $2fa92ec193801792$var$__PRIVATE_EvaluateResult("ERROR", void 0);
    }
    static mr() {
        return new $2fa92ec193801792$var$__PRIVATE_EvaluateResult("UNSET", void 0);
    }
    static pr() {
        return new $2fa92ec193801792$var$__PRIVATE_EvaluateResult("NULL", $2fa92ec193801792$var$He);
    }
    static newValue(e) {
        return $2fa92ec193801792$var$__PRIVATE_isNullValue(e) ? new $2fa92ec193801792$var$__PRIVATE_EvaluateResult("NULL", $2fa92ec193801792$var$He) : function __PRIVATE_isBoolean(e) {
            return !!e && "booleanValue" in e;
        }(e) ? new $2fa92ec193801792$var$__PRIVATE_EvaluateResult("BOOLEAN", e) : $2fa92ec193801792$var$isInteger(e) ? new $2fa92ec193801792$var$__PRIVATE_EvaluateResult("INT", e) : $2fa92ec193801792$var$__PRIVATE_isDouble(e) ? new $2fa92ec193801792$var$__PRIVATE_EvaluateResult("DOUBLE", e) : function __PRIVATE_isTimestampValue(e) {
            return !!e && "timestampValue" in e && !!e.timestampValue;
        }(e) ? new $2fa92ec193801792$var$__PRIVATE_EvaluateResult("TIMESTAMP", e) : function __PRIVATE_isString(e) {
            return !!e && "stringValue" in e;
        }(e) ? new $2fa92ec193801792$var$__PRIVATE_EvaluateResult("STRING", e) : function __PRIVATE_isBytes(e) {
            return !!e && "bytesValue" in e;
        }(e) ? new $2fa92ec193801792$var$__PRIVATE_EvaluateResult("BYTES", e) : e.referenceValue ? new $2fa92ec193801792$var$__PRIVATE_EvaluateResult("REFERENCE", e) : e.geoPointValue ? new $2fa92ec193801792$var$__PRIVATE_EvaluateResult("GEO_POINT", e) : $2fa92ec193801792$var$isArray(e) ? new $2fa92ec193801792$var$__PRIVATE_EvaluateResult("ARRAY", e) : $2fa92ec193801792$var$__PRIVATE_isVectorValue(e) ? new $2fa92ec193801792$var$__PRIVATE_EvaluateResult("VECTOR", e) : $2fa92ec193801792$var$__PRIVATE_isMapValue(e) ? new $2fa92ec193801792$var$__PRIVATE_EvaluateResult("MAP", e) : new $2fa92ec193801792$var$__PRIVATE_EvaluateResult("ERROR", void 0);
    }
    gr() {
        return "ERROR" === this.type || "UNSET" === this.type;
    }
    yr() {
        return "NULL" === this.type;
    }
}
function $2fa92ec193801792$var$__PRIVATE_valueOrUndefined(e) {
    if (!e.gr()) return e.value;
}
function $2fa92ec193801792$var$__PRIVATE_unwrapExpression(e) {
    return e instanceof $2fa92ec193801792$export$65ab0ebced932b79 ? e._expr : e;
}
function $2fa92ec193801792$var$__PRIVATE_toEvaluable(e) {
    if ((e = $2fa92ec193801792$var$__PRIVATE_unwrapExpression(e)) instanceof $2fa92ec193801792$export$e0c3a065614c6254) return new $2fa92ec193801792$var$__PRIVATE_CoreField(e);
    if (e instanceof $2fa92ec193801792$var$Constant) return new $2fa92ec193801792$var$__PRIVATE_CoreConstant(e);
    if (e instanceof $2fa92ec193801792$var$__PRIVATE_ListOfExprs) return new $2fa92ec193801792$var$__PRIVATE_CoreListOfExprs(e);
    if (e instanceof $2fa92ec193801792$export$acf3ba20e47771d) {
        // TODO(pipeline): We should define all supported function names as constants somewhere instead of magic strings.
        if ("add" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreAdd(e);
        if ("subtract" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreSubtract(e);
        if ("multiply" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreMultiply(e);
        if ("divide" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreDivide(e);
        if ("mod" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreMod(e);
        if ("and" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreAnd(e);
        if ("equal" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreEq(e);
        if ("not_equal" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreNeq(e);
        if ("less_than" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreLt(e);
        if ("less_than_or_equal" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreLte(e);
        if ("greater_than" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreGt(e);
        if ("greater_than_or_equal" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreGte(e);
        if ("array_concat" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreArrayConcat(e);
        if ("array_reverse" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreArrayReverse(e);
        if ("array_contains" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreArrayContains(e);
        if ("array_contains_all" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreArrayContainsAll(e);
        if ("array_contains_any" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreArrayContainsAny(e);
        if ("array_length" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreArrayLength(e);
        if ("array_element" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreArrayElement(e);
        if ("equal_any" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreEqAny(e);
        if ("not_equal_any" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreNotEqAny(e);
        if ("is_nan" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreIsNan(e);
        if ("is_not_nan" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreIsNotNan(e);
        if ("is_null" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreIsNull(e);
        if ("is_not_null" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreIsNotNull(e);
        if ("is_error" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreIsError(e);
        if ("exists" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreExists(e);
        if ("not" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreNot(e);
        if ("or" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreOr(e);
        if ("xor" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreXor(e);
        if ("conditional" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreCond(e);
        if ("maximum" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreLogicalMaximum(e);
        if ("minimum" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreLogicalMinimum(e);
        if ("reverse" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreReverse(e);
        if ("replace_first" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreReplaceFirst(e);
        if ("replace_all" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreReplaceAll(e);
        if ("char_length" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreCharLength(e);
        if ("byte_length" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreByteLength(e);
        if ("like" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreLike(e);
        if ("regex_contains" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreRegexContains(e);
        if ("regex_match" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreRegexMatch(e);
        if ("string_contains" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreStrContains(e);
        if ("starts_with" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreStartsWith(e);
        if ("ends_with" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreEndsWith(e);
        if ("to_lower" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreToLower(e);
        if ("to_upper" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreToUpper(e);
        if ("trim" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreTrim(e);
        if ("string_concat" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreStrConcat(e);
        if ("map_get" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreMapGet(e);
        if ("cosine_distance" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreCosineDistance(e);
        if ("dot_product" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreDotProduct(e);
        if ("euclidean_distance" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreEuclideanDistance(e);
        if ("vector_length" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreVectorLength(e);
        if ("unix_micros_to_timestamp" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreUnixMicrosToTimestamp(e);
        if ("timestamp_to_unix_micros" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreTimestampToUnixMicros(e);
        if ("unix_millis_to_timestamp" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreUnixMillisToTimestamp(e);
        if ("timestamp_to_unix_millis" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreTimestampToUnixMillis(e);
        if ("unix_seconds_to_timestamp" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreUnixSecondsToTimestamp(e);
        if ("timestamp_to_unix_seconds" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreTimestampToUnixSeconds(e);
        if ("timestamp_add" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreTimestampAdd(e);
        if ("timestamp_subtract" === e.name) return new $2fa92ec193801792$var$__PRIVATE_CoreTimestampSub(e);
    }
    throw new Error(`Unknown Expr : ${e}`);
}
class $2fa92ec193801792$var$__PRIVATE_CoreField {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        if (this.expr.fieldName === $2fa92ec193801792$var$Ce) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            referenceValue: $2fa92ec193801792$var$__PRIVATE_toName(e.serializer, t.key)
        });
        if ("__update_time__" === this.expr.fieldName) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            timestampValue: $2fa92ec193801792$var$__PRIVATE_toVersion(e.serializer, t.version)
        });
        if ("__create_time__" === this.expr.fieldName) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            timestampValue: $2fa92ec193801792$var$__PRIVATE_toVersion(e.serializer, t.createTime)
        });
        // Return 'UNSET' if the field doesn't exist, otherwise the Value.
        const n = t.data.field(this.expr._fieldPath);
        return n ? $2fa92ec193801792$export$f38c853ae54ed474(n) ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue(function __PRIVATE_getServerTimestampValue(e, t) {
            if ("estimate" === e.serverTimestampBehavior) return {
                timestampValue: $2fa92ec193801792$var$__PRIVATE_toVersion(e.serializer, $2fa92ec193801792$var$SnapshotVersion.fromTimestamp($2fa92ec193801792$var$__PRIVATE_getLocalWriteTime(t)))
            };
            if ("previous" === e.serverTimestampBehavior) {
                const e = $2fa92ec193801792$var$__PRIVATE_getPreviousValue(t);
                if (e) return e;
            }
            return {
                nullValue: "NULL_VALUE"
            };
        }(e, n)) : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue(n) : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.mr();
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreConstant {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue(this.expr._getValue());
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreListOfExprs {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        const n = this.expr.ur.map((n)=>$2fa92ec193801792$var$__PRIVATE_toEvaluable(n).evaluate(e, t));
        // If any sub-expression resulted in error or was unset, the list evaluation fails.
        return n.some((e)=>e.gr()) ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr() : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            arrayValue: {
                values: n.map((e)=>e.value)
            }
        });
    }
}
function $2fa92ec193801792$var$__PRIVATE_asDouble(e) {
    return $2fa92ec193801792$var$__PRIVATE_isDouble(e) ? Number(e.doubleValue) : Number(e.integerValue);
}
function $2fa92ec193801792$var$__PRIVATE_asBigInt(e) {
    return BigInt(e.integerValue);
}
const $2fa92ec193801792$var$Ft = BigInt("0x7fffffffffffffff"), $2fa92ec193801792$var$Ot = -BigInt("0x8000000000000000");
class $2fa92ec193801792$var$__PRIVATE_BigIntOrDoubleArithmetics {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(this.expr.params.length >= 2, 24778);
        const n = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t), r = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        let i = this.wr(n, r);
        for (const n of this.expr.params.slice(2)){
            const r = $2fa92ec193801792$var$__PRIVATE_toEvaluable(n).evaluate(e, t);
            i = this.wr(i, r);
        }
        return i;
    }
    wr(e, t) {
        // If any operand is error or unset, the result is error.
        if (e.gr() || t.gr()) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        if (e.yr() || t.yr()) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
        // Type check: Both must be numbers (integer or double).
        // We know left and right are Value here due to the check above.
        const n = e.value, r = t.value;
        if (!$2fa92ec193801792$var$__PRIVATE_isDouble(n) && !$2fa92ec193801792$var$isInteger(n) || !$2fa92ec193801792$var$__PRIVATE_isDouble(r) && !$2fa92ec193801792$var$isInteger(r)) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr(); // Type error
        // Perform arithmetic based on types.
        if ($2fa92ec193801792$var$__PRIVATE_isDouble(n) || $2fa92ec193801792$var$__PRIVATE_isDouble(r)) {
            const e = this.br(n, r);
            return e ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue(e) : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        if ($2fa92ec193801792$var$isInteger(n) && $2fa92ec193801792$var$isInteger(r)) {
            // Pass the narrowed Value types
            const e = this.vr(n, r);
            return void 0 === e ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr() : "number" == typeof e ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                doubleValue: e
            }) : e < $2fa92ec193801792$var$Ot || e > $2fa92ec193801792$var$Ft ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr() : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                integerValue: `${e}`
            });
        }
        // Should not be reached due to initial type checks
        return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
    }
}
function $2fa92ec193801792$var$__PRIVATE_strictValueEquals(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_typeOrder(e) !== $2fa92ec193801792$var$__PRIVATE_typeOrder(t) ? "TYPE_MISMATCH" : $2fa92ec193801792$var$__PRIVATE_isNanValue(e) || $2fa92ec193801792$var$__PRIVATE_isNanValue(t) ? "NOT_EQ" : $2fa92ec193801792$var$__PRIVATE_isNullValue(e) && $2fa92ec193801792$var$__PRIVATE_isNullValue(t) ? "EQ" : $2fa92ec193801792$var$__PRIVATE_isNullValue(e) || $2fa92ec193801792$var$__PRIVATE_isNullValue(t) ? "NULL" : $2fa92ec193801792$var$isArray(e) && $2fa92ec193801792$var$isArray(t) ? function __PRIVATE_strictArrayValueEquals(e, t) {
        if (e.values?.length !== t.values?.length) return "NOT_EQ";
        let n = false;
        for(let r = 0; r < (e.values?.length ?? 0); r++){
            const i = e.values[r], s = t.values[r];
            switch($2fa92ec193801792$var$__PRIVATE_strictValueEquals(i, s)){
                case "EQ":
                    break;
                case "NOT_EQ":
                case "TYPE_MISMATCH":
                    return "NOT_EQ";
                case "NULL":
                    n = true;
                    break;
                default:
                    $2fa92ec193801792$export$1a82df3d29112e01(44609, {
                        Sr: i,
                        Dr: s
                    });
            }
        }
        if (n) return "NULL";
        return "EQ";
    }(e.arrayValue, t.arrayValue) : $2fa92ec193801792$var$__PRIVATE_isVectorValue(e) && $2fa92ec193801792$var$__PRIVATE_isVectorValue(t) || $2fa92ec193801792$var$__PRIVATE_isMapValue(e) && $2fa92ec193801792$var$__PRIVATE_isMapValue(t) ? function __PRIVATE_strictObjectValueEquals(e, t) {
        const n = e.fields || {}, r = t.fields || {};
        if ($2fa92ec193801792$var$__PRIVATE_objectSize(n) !== $2fa92ec193801792$var$__PRIVATE_objectSize(r)) return "NOT_EQ";
        let i = false;
        for(const e in n)if (n.hasOwnProperty(e)) {
            if (void 0 === r[e]) return "NOT_EQ";
            switch($2fa92ec193801792$var$__PRIVATE_strictValueEquals(n[e], r[e])){
                case "NOT_EQ":
                case "TYPE_MISMATCH":
                    return "NOT_EQ";
                case "NULL":
                    i = true;
            }
        }
        if (i) return "NULL";
        return "EQ";
    }(e.mapValue, t.mapValue) : function __PRIVATE_valueEquals(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_valueEquals$1(e, t, {
            o: false,
            t: true,
            i: true
        });
    }(e, t) ? "EQ" : "NOT_EQ";
}
class $2fa92ec193801792$var$__PRIVATE_CoreAdd extends $2fa92ec193801792$var$__PRIVATE_BigIntOrDoubleArithmetics {
    vr(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_asBigInt(e) + $2fa92ec193801792$var$__PRIVATE_asBigInt(t);
    }
    br(e, t) {
        return {
            doubleValue: $2fa92ec193801792$var$__PRIVATE_asDouble(e) + $2fa92ec193801792$var$__PRIVATE_asDouble(t)
        };
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreSubtract extends $2fa92ec193801792$var$__PRIVATE_BigIntOrDoubleArithmetics {
    constructor(e){
        super(e), this.expr = e;
    }
    vr(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_asBigInt(e) - $2fa92ec193801792$var$__PRIVATE_asBigInt(t);
    }
    br(e, t) {
        return {
            doubleValue: $2fa92ec193801792$var$__PRIVATE_asDouble(e) - $2fa92ec193801792$var$__PRIVATE_asDouble(t)
        };
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreMultiply extends $2fa92ec193801792$var$__PRIVATE_BigIntOrDoubleArithmetics {
    constructor(e){
        super(e), this.expr = e;
    }
    vr(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_asBigInt(e) * $2fa92ec193801792$var$__PRIVATE_asBigInt(t);
    }
    br(e, t) {
        return {
            doubleValue: $2fa92ec193801792$var$__PRIVATE_asDouble(e) * $2fa92ec193801792$var$__PRIVATE_asDouble(t)
        };
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreDivide extends $2fa92ec193801792$var$__PRIVATE_BigIntOrDoubleArithmetics {
    constructor(e){
        super(e), this.expr = e;
    }
    vr(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_asBigInt(t);
        if (n !== BigInt(0)) return $2fa92ec193801792$var$__PRIVATE_asBigInt(e) / n;
    }
    br(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_asDouble(t);
        return 0 === n ? {
            doubleValue: $2fa92ec193801792$var$__PRIVATE_isNegativeZero(n) ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY
        } : {
            doubleValue: $2fa92ec193801792$var$__PRIVATE_asDouble(e) / n
        };
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreMod extends $2fa92ec193801792$var$__PRIVATE_BigIntOrDoubleArithmetics {
    constructor(e){
        super(e), this.expr = e;
    }
    vr(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_asBigInt(t);
        if (n !== BigInt(0)) return $2fa92ec193801792$var$__PRIVATE_asBigInt(e) % n;
    }
    br(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_asDouble(t);
        if (0 !== n) return {
            doubleValue: $2fa92ec193801792$var$__PRIVATE_asDouble(e) % n
        };
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreAnd {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        let n = false, r = false;
        for (const i of this.expr.params){
            const s = $2fa92ec193801792$var$__PRIVATE_toEvaluable(i).evaluate(e, t);
            switch(s.type){
                case "BOOLEAN":
                    if (!s.value?.booleanValue) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye);
                    break;
                case "NULL":
                    r = true;
                    break;
                default:
                    n = true;
            }
        }
        return n ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr() : r ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr() : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Je);
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreNot {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 9634);
        const n = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "BOOLEAN":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                    booleanValue: !n.value?.booleanValue
                });
            case "NULL":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreOr {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        let n = false, r = false;
        for (const i of this.expr.params){
            const s = $2fa92ec193801792$var$__PRIVATE_toEvaluable(i).evaluate(e, t);
            switch(s.type){
                case "BOOLEAN":
                    if (s.value?.booleanValue) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Je);
                    break;
                case "NULL":
                    r = true;
                    break;
                default:
                    n = true;
            }
        }
        return n ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr() : r ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr() : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye);
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreXor {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        let n = false, r = false;
        for (const i of this.expr.params){
            const s = $2fa92ec193801792$var$__PRIVATE_toEvaluable(i).evaluate(e, t);
            switch(s.type){
                case "BOOLEAN":
                    n = $2fa92ec193801792$var$__PRIVATE_CoreXor.xor(n, !!s.value?.booleanValue);
                    break;
                case "NULL":
                    r = true;
                    break;
                default:
                    return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
            }
        }
        return r ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr() : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            booleanValue: n
        });
    }
    // XOR(a, b) is equivalent to (a OR b) AND NOT(a AND b)
    // It is required to evaluate all arguments to ensure that the correct error semantics are
    // applied.
    static xor(e, t) {
        return (e || t) && !(e && t);
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreEqAny {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(2 === this.expr.params.length, 55094);
        let n = false;
        const r = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "NULL":
                n = true;
                break;
            case "ERROR":
            case "UNSET":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        const i = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(i.type){
            case "ARRAY":
                break;
            case "NULL":
                n = true;
                break;
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        if (n) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
        for (const e of i.value?.arrayValue?.values ?? [])switch($2fa92ec193801792$var$__PRIVATE_isNullValue(r.value) && $2fa92ec193801792$var$__PRIVATE_isNullValue(e) ? "EQ" : $2fa92ec193801792$var$__PRIVATE_strictValueEquals(r.value, e)){
            case "EQ":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Je);
            case "NOT_EQ":
            case "TYPE_MISMATCH":
                break;
            case "NULL":
                n = true;
                break;
            default:
                $2fa92ec193801792$export$1a82df3d29112e01(44608, {
                    value: r.value,
                    candidate: e
                });
        }
        return n ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr() : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye);
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreNotEqAny {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        return new $2fa92ec193801792$var$__PRIVATE_CoreNot(new $2fa92ec193801792$export$acf3ba20e47771d("not", [
            new $2fa92ec193801792$export$acf3ba20e47771d("equal_any", this.expr.params)
        ])).evaluate(e, t);
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreIsNan {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 23322);
        const n = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "INT":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye);
            case "DOUBLE":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                    booleanValue: isNaN($2fa92ec193801792$var$__PRIVATE_asDouble(n.value))
                });
            case "NULL":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreIsNotNan {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 50406);
        return new $2fa92ec193801792$var$__PRIVATE_CoreNot(new $2fa92ec193801792$export$acf3ba20e47771d("not", [
            new $2fa92ec193801792$export$acf3ba20e47771d("is_nan", this.expr.params)
        ])).evaluate(e, t);
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreIsNull {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 23123);
        switch($2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t).type){
            case "NULL":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Je);
            case "UNSET":
            case "ERROR":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye);
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreIsNotNull {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 23167);
        return new $2fa92ec193801792$var$__PRIVATE_CoreNot(new $2fa92ec193801792$export$acf3ba20e47771d("not", [
            new $2fa92ec193801792$export$acf3ba20e47771d("is_null", this.expr.params)
        ])).evaluate(e, t);
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreIsError {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 5228);
        return "ERROR" === $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t).type ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Je) : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye);
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreExists {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 6877);
        switch($2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t).type){
            case "ERROR":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
            case "UNSET":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye);
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Je);
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreCond {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(3 === this.expr.params.length, 11706);
        const n = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "BOOLEAN":
                return n.value?.booleanValue ? $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t) : $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[2]).evaluate(e, t);
            case "NULL":
                return $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[2]).evaluate(e, t);
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreLogicalMaximum {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        const n = this.expr.params.map((n)=>$2fa92ec193801792$var$__PRIVATE_toEvaluable(n).evaluate(e, t));
        let r;
        for (const e of n)switch(e.type){
            case "ERROR":
            case "UNSET":
            case "NULL":
                continue;
            default:
                r = void 0 === r || $2fa92ec193801792$var$__PRIVATE_valueCompare(e.value, r.value) > 0 ? e : r;
        }
        return void 0 === r ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr() : r;
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreLogicalMinimum {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        const n = this.expr.params.map((n)=>$2fa92ec193801792$var$__PRIVATE_toEvaluable(n).evaluate(e, t));
        let r;
        for (const e of n)switch(e.type){
            case "ERROR":
            case "UNSET":
            case "NULL":
                continue;
            default:
                r = void 0 === r || $2fa92ec193801792$var$__PRIVATE_valueCompare(e.value, r.value) < 0 ? e : r;
        }
        return void 0 === r ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr() : r;
    }
}
class $2fa92ec193801792$var$__PRIVATE_ComparisonBase {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(2 === this.expr.params.length, 31033, `${this.expr.name}() function should have exactly 2 params`);
        const n = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "ERROR":
            case "UNSET":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        const r = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(r.type){
            case "ERROR":
            case "UNSET":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        return this.Cr(n, r);
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreEq extends $2fa92ec193801792$var$__PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Cr(e, t) {
        if (e.yr() && t.yr()) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Je);
        if (e.yr() || t.yr()) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye);
        if ($2fa92ec193801792$var$__PRIVATE_isNanValue(e.value) || $2fa92ec193801792$var$__PRIVATE_isNanValue(t.value)) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye);
        if ($2fa92ec193801792$var$__PRIVATE_typeOrder(e.value) !== $2fa92ec193801792$var$__PRIVATE_typeOrder(t.value)) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye);
        switch($2fa92ec193801792$var$__PRIVATE_strictValueEquals(e.value, t.value)){
            case "EQ":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Je);
            case "NOT_EQ":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye);
            case "NULL":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
            default:
                $2fa92ec193801792$export$1a82df3d29112e01(44615, {
                    left: e,
                    right: t
                });
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreNeq extends $2fa92ec193801792$var$__PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Cr(e, t) {
        switch($2fa92ec193801792$var$__PRIVATE_strictValueEquals(e.value, t.value)){
            case "EQ":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye);
            case "NOT_EQ":
            case "TYPE_MISMATCH":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Je);
            case "NULL":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
            default:
                $2fa92ec193801792$export$1a82df3d29112e01(44614, {
                    left: e,
                    right: t
                });
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreLt extends $2fa92ec193801792$var$__PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Cr(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_typeOrder(e.value) !== $2fa92ec193801792$var$__PRIVATE_typeOrder(t.value) || $2fa92ec193801792$var$__PRIVATE_isNanValue(e.value) || $2fa92ec193801792$var$__PRIVATE_isNanValue(t.value) ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye) : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            booleanValue: $2fa92ec193801792$var$__PRIVATE_valueCompare(e.value, t.value) < 0
        });
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreLte extends $2fa92ec193801792$var$__PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Cr(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_typeOrder(e.value) !== $2fa92ec193801792$var$__PRIVATE_typeOrder(t.value) || $2fa92ec193801792$var$__PRIVATE_isNanValue(e.value) || $2fa92ec193801792$var$__PRIVATE_isNanValue(t.value) ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye) : "EQ" === $2fa92ec193801792$var$__PRIVATE_strictValueEquals(e.value, t.value) ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Je) : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            booleanValue: $2fa92ec193801792$var$__PRIVATE_valueCompare(e.value, t.value) < 0
        });
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreGt extends $2fa92ec193801792$var$__PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Cr(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_typeOrder(e.value) !== $2fa92ec193801792$var$__PRIVATE_typeOrder(t.value) || $2fa92ec193801792$var$__PRIVATE_isNanValue(e.value) || $2fa92ec193801792$var$__PRIVATE_isNanValue(t.value) ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye) : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            booleanValue: $2fa92ec193801792$var$__PRIVATE_valueCompare(e.value, t.value) > 0
        });
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreGte extends $2fa92ec193801792$var$__PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Cr(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_typeOrder(e.value) !== $2fa92ec193801792$var$__PRIVATE_typeOrder(t.value) || $2fa92ec193801792$var$__PRIVATE_isNanValue(e.value) || $2fa92ec193801792$var$__PRIVATE_isNanValue(t.value) ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye) : "EQ" === $2fa92ec193801792$var$__PRIVATE_strictValueEquals(e.value, t.value) ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Je) : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            booleanValue: $2fa92ec193801792$var$__PRIVATE_valueCompare(e.value, t.value) > 0
        });
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreArrayConcat {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        throw new Error("Unimplemented");
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreArrayReverse {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 216);
        const n = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "NULL":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
            case "ARRAY":
                {
                    const e = n.value.arrayValue?.values ?? [];
                    return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                        arrayValue: {
                            values: [
                                ...e
                            ].reverse()
                        }
                    });
                }
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreArrayContains {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_hardAssert(2 === this.expr.params.length, 52884), new $2fa92ec193801792$var$__PRIVATE_CoreEqAny(new $2fa92ec193801792$export$acf3ba20e47771d("eq_any", [
            this.expr.params[1],
            this.expr.params[0]
        ])).evaluate(e, t);
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreArrayContainsAll {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(2 === this.expr.params.length, 1392);
        let n = false;
        const r = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "ARRAY":
                break;
            case "NULL":
                n = true;
                break;
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        const i = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(i.type){
            case "ARRAY":
                break;
            case "NULL":
                n = true;
                break;
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        if (n) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
        const s = i.value?.arrayValue?.values ?? [], _ = r.value?.arrayValue?.values ?? [];
        for (const e of s){
            let t = false;
            n = false;
            for (const r of _){
                switch($2fa92ec193801792$var$__PRIVATE_isNullValue(e) && $2fa92ec193801792$var$__PRIVATE_isNullValue(r) ? "EQ" : $2fa92ec193801792$var$__PRIVATE_strictValueEquals(e, r)){
                    case "EQ":
                        t = true;
                        break;
                    case "NOT_EQ":
                    case "TYPE_MISMATCH":
                        break;
                    case "NULL":
                        n = true;
                        break;
                    default:
                        $2fa92ec193801792$export$1a82df3d29112e01(44613, {
                            value: r,
                            search: e
                        });
                }
                if (t) break;
            }
            if (!t) // false case - we didn't find a match, short circuit
            return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye);
        }
        return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Je);
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreArrayContainsAny {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(2 === this.expr.params.length, 2680);
        let n = false;
        const r = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "ARRAY":
                break;
            case "NULL":
                n = true;
                break;
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        const i = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(i.type){
            case "ARRAY":
                break;
            case "NULL":
                n = true;
                break;
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        if (n) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
        const s = i.value?.arrayValue?.values ?? [], _ = r.value?.arrayValue?.values ?? [];
        for (const e of _)for (const t of s)switch($2fa92ec193801792$var$__PRIVATE_isNullValue(e) && $2fa92ec193801792$var$__PRIVATE_isNullValue(t) ? "EQ" : $2fa92ec193801792$var$__PRIVATE_strictValueEquals(e, t)){
            case "EQ":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Je);
            case "NOT_EQ":
            case "TYPE_MISMATCH":
                break;
            case "NULL":
                n = true;
                break;
            default:
                $2fa92ec193801792$export$1a82df3d29112e01(60403, {
                    value: e,
                    search: t
                });
        }
        return n ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr() : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue($2fa92ec193801792$var$Ye);
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreArrayLength {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 38605);
        const n = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "NULL":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
            case "ARRAY":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                    integerValue: `${n.value?.arrayValue?.values?.length ?? 0}`
                });
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreArrayElement {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        throw new Error("Unimplemented");
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreReverse {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 1508);
        const n = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "NULL":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
            case "BYTES":
                {
                    const e = n.value?.bytesValue;
                    if ("string" == typeof e) {
                        const t = $2fa92ec193801792$export$158acd800e1ef08b.fromBase64String(e).toUint8Array();
                        return t.reverse(), $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                            bytesValue: $2fa92ec193801792$export$158acd800e1ef08b.fromUint8Array(t).toBase64()
                        });
                    }
                    return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                        bytesValue: new Uint8Array(e).reverse()
                    });
                }
            case "STRING":
                {
                    const e = n.value?.stringValue, t = new Intl.__PRIVATE_Segmenter(void 0, {
                        granularity: "grapheme"
                    }).segment(e), r = Array.from(t, (e)=>e.segment).reverse();
                    return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                        stringValue: r.join("")
                    });
                }
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreReplaceFirst {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        throw new Error("Unimplemented");
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreReplaceAll {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        throw new Error("Unimplemented");
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreCharLength {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 19400);
        const n = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "NULL":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
            case "STRING":
                {
                    const e = function __PRIVATE_getUnicodePointCount(e) {
                        let t = 0;
                        for(let n = 0; n < e.length; n++){
                            const r = e.codePointAt(n);
                            if (void 0 === r) return; // Should not happen with valid JS strings
                            // BMP character (including lone surrogates, which count as 1)
                            if (r <= 65535) {
                                // Check specifically for lone surrogates which are invalid UTF-16 sequences
                                if (r >= 55296 && r <= 57343) {
                                    // High surrogate: check if followed by low surrogate
                                    if (r <= 56319) {
                                        const r = e.codePointAt(n + 1);
                                        void 0 !== r && r >= 56320 && r <= 57343 ? // Valid surrogate pair (counts as one character)
                                        (t += 1, n++) : // Lone high surrogate - treat as one character for length, but invalid for byte length
                                        t += 1;
                                    } else // Lone low surrogate - treat as one character
                                    t += 1;
                                } else // Regular BMP character
                                t += 1;
                            } else {
                                if (!(r <= 1114111)) return;
                                // Invalid code point
                                t += 1, n++;
                            }
                        }
                        return t;
                    }(n.value.stringValue);
                    // If counting failed (e.g., invalid sequence), return error
                    return void 0 === e ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr() : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                        integerValue: e
                    });
                }
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreByteLength {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 8486);
        const n = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "BYTES":
                {
                    const e = n.value?.bytesValue;
                    return "string" == typeof e ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                        integerValue: $2fa92ec193801792$export$158acd800e1ef08b.fromBase64String(e).toUint8Array().length
                    }) : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                        integerValue: new Uint8Array(e).length
                    });
                }
            case "STRING":
                {
                    // return the number of bytes in the string
                    const e = function __PRIVATE_getUtf8ByteLength(e) {
                        let t = 0;
                        for(let n = 0; n < e.length; n++){
                            const r = e.codePointAt(n);
                            // Check for out of range of lone surrogate
                            if (void 0 === r) return;
                            if (r >= 55296 && r <= 57343) {
                                // If it is a high surrogate, check if a low surrogate follows
                                if (!(r <= 56319)) return;
                                // Lone low surrogate
                                {
                                    const r = e.codePointAt(n + 1);
                                    if (void 0 === r || !(r >= 56320 && r <= 57343)) return; // Lone high surrogate
                                    // Valid surrogate pair
                                    t += 4, n++;
                                }
                            } else if (r <= 127) t += 1;
                            else if (r <= 2047) t += 2;
                            else if (r <= 65535) t += 3;
                            else {
                                if (!(r <= 1114111)) return;
                                // Invalid code point (should not normally happen)
                                t += 4, n++;
                            }
                        }
                        return t;
                    }(n.value?.stringValue);
                    return void 0 === e ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr() : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                        integerValue: e
                    });
                }
            case "NULL":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_StringSearchFunctionBase {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(2 === this.expr.params.length, 39773, `${this.expr.name}() function should have exactly two parameters`);
        let n = false;
        const r = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "STRING":
                break;
            case "NULL":
                n = true;
                break;
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        const i = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(i.type){
            case "STRING":
                break;
            case "NULL":
                n = true;
                break;
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        return n ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr() : this.Fr(r.value?.stringValue, i.value?.stringValue);
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreLike extends $2fa92ec193801792$var$__PRIVATE_StringSearchFunctionBase {
    Fr(e, t) {
        try {
            const n = function __PRIVATE_likeToRegex(e) {
                let t = "";
                for(let n = 0; n < e.length; n++){
                    const r = e.charAt(n);
                    switch(r){
                        case "_":
                            t += ".";
                            break;
                        case "%":
                            t += ".*";
                            break;
                        // Escape regex special characters
                        case "\\":
                        // Need to escape backslash itself
                        case ".":
                        case "*":
                        case "?":
                        case "+":
                        case "^":
                        case "$":
                        case "|":
                        case "(":
                        case ")":
                        case "[":
                        case "]":
                        case "{":
                        case "}":
                            t += "\\" + r;
                            break;
                        default:
                            t += r;
                    }
                }
                // Anchor the regex to match the entire string
                return "^" + t + "$";
            }(t), r = (0, $394755e62edee9eb$export$e46efc5f33420715).compile(n);
            return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                booleanValue: r.matches(e)
            });
        } catch (e) {
            return $2fa92ec193801792$export$7f8ddf7c7c20b3cd(`Invalid LIKE pattern converted to regex: ${t}, returning error. Error: ${e}`), $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreRegexContains extends $2fa92ec193801792$var$__PRIVATE_StringSearchFunctionBase {
    Fr(e, t) {
        try {
            const n = (0, $394755e62edee9eb$export$e46efc5f33420715).compile(t);
            return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                booleanValue: n.test(e)
            });
        } catch (e) {
            return $2fa92ec193801792$export$7f8ddf7c7c20b3cd(`Invalid regex pattern found in regex_contains: ${t}, returning error`), $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreRegexMatch extends $2fa92ec193801792$var$__PRIVATE_StringSearchFunctionBase {
    Fr(e, t) {
        try {
            // Use matches() for full string match semantics
            return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                booleanValue: (0, $394755e62edee9eb$export$e46efc5f33420715).compile(t).matches(e)
            });
        } catch (e) {
            return $2fa92ec193801792$export$7f8ddf7c7c20b3cd(`Invalid regex pattern found in regex_match: ${t}, returning error`), $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreStrContains extends $2fa92ec193801792$var$__PRIVATE_StringSearchFunctionBase {
    Fr(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            booleanValue: e.includes(t)
        });
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreStartsWith extends $2fa92ec193801792$var$__PRIVATE_StringSearchFunctionBase {
    Fr(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            booleanValue: e.startsWith(t)
        });
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreEndsWith extends $2fa92ec193801792$var$__PRIVATE_StringSearchFunctionBase {
    Fr(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            booleanValue: e.endsWith(t)
        });
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreToLower {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 29079);
        const n = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "STRING":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                    stringValue: n.value?.stringValue?.toLowerCase()
                });
            case "NULL":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreToUpper {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 60487);
        const n = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "STRING":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                    stringValue: n.value?.stringValue?.toUpperCase()
                });
            case "NULL":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreTrim {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 28544);
        const n = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "STRING":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                    stringValue: n.value?.stringValue?.trim()
                });
            case "NULL":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreStrConcat {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        const n = this.expr.params.map((n)=>$2fa92ec193801792$var$__PRIVATE_toEvaluable(n).evaluate(e, t));
        // If any part is error or unset, or not a string (and not null), result is error
        // If any part is null, result is null
        let r = "", i = false;
        for (const e of n)switch(e.type){
            case "STRING":
                r += e.value.stringValue;
                break;
            case "NULL":
                i = true;
                break;
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        return i ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr() : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            stringValue: r
        });
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreMapGet {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(2 === this.expr.params.length, 4483);
        const n = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "UNSET":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.mr();
            case "MAP":
                break;
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        const r = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        if ("STRING" !== r.type) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        const i = n.value?.mapValue?.fields?.[r.value?.stringValue];
        return void 0 === i ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.mr() : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue(i);
    }
}
class $2fa92ec193801792$var$__PRIVATE_DistanceBase {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(2 === this.expr.params.length, 25231, `${this.expr.name}() function should have exactly 2 params`);
        let n = false;
        const r = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "VECTOR":
                break;
            case "NULL":
                n = true;
                break;
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        const i = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(i.type){
            case "VECTOR":
                break;
            case "NULL":
                n = true;
                break;
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        if (n) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
        const s = $2fa92ec193801792$var$__PRIVATE_getVectorValue(r.value), _ = $2fa92ec193801792$var$__PRIVATE_getVectorValue(i.value);
        // Mismatched lengths or undefined vectors result in error
        if (void 0 === s || void 0 === _ || s.values?.length !== _.values?.length) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        const o = this.Or(s, _);
        // NaN or undefined distance calculation results in error
        return void 0 === o || isNaN(o) ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr() : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            doubleValue: o
        });
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreCosineDistance extends $2fa92ec193801792$var$__PRIVATE_DistanceBase {
    Or(e, t) {
        const n = e?.values ?? [], r = t?.values ?? [];
        if (0 === n.length) return;
        // Distance undefined for empty vectors
        let i = 0, s = 0, _ = 0;
        for(let e = 0; e < n.length; e++){
            // Error if any element is not a number
            if (!$2fa92ec193801792$var$R(n[e]) || !$2fa92ec193801792$var$R(r[e])) return;
            const t = $2fa92ec193801792$var$__PRIVATE_asDouble(n[e]), o = $2fa92ec193801792$var$__PRIVATE_asDouble(r[e]);
            i += t * o, s += t * t, _ += o * o;
        }
        const o = Math.sqrt(s) * Math.sqrt(_);
        // Distance undefined if either vector has zero magnitude
        if (0 === o) return;
        // Clamp cosine similarity to [-1, 1] due to potential floating point inaccuracies
        return 1 - Math.max(-1, Math.min(1, i / o));
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreDotProduct extends $2fa92ec193801792$var$__PRIVATE_DistanceBase {
    Or(e, t) {
        const n = e?.values ?? [], r = t?.values ?? [];
        if (0 === n.length) return 0;
        // Dot product of empty vectors is 0
        let i = 0;
        for(let e = 0; e < n.length; e++){
            // Error if any element is not a number
            if (!$2fa92ec193801792$var$R(n[e]) || !$2fa92ec193801792$var$R(r[e])) return;
            i += $2fa92ec193801792$var$__PRIVATE_asDouble(n[e]) * $2fa92ec193801792$var$__PRIVATE_asDouble(r[e]);
        }
        return i;
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreEuclideanDistance extends $2fa92ec193801792$var$__PRIVATE_DistanceBase {
    Or(e, t) {
        const n = e?.values ?? [], r = t?.values ?? [];
        if (0 === n.length) return 0;
        // Distance between empty vectors is 0
        let i = 0;
        for(let e = 0; e < n.length; e++){
            // Error if any element is not a number
            if (!$2fa92ec193801792$var$R(n[e]) || !$2fa92ec193801792$var$R(r[e])) return;
            const t = $2fa92ec193801792$var$__PRIVATE_asDouble(n[e]), s = $2fa92ec193801792$var$__PRIVATE_asDouble(r[e]);
            i += Math.pow(t - s, 2);
        }
        return Math.sqrt(i);
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreVectorLength {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 39044);
        const n = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "VECTOR":
                {
                    const e = $2fa92ec193801792$var$__PRIVATE_getVectorValue(n.value);
                    return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
                        integerValue: e?.values?.length ?? 0
                    });
                }
            case "NULL":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
    }
}
// 0001-01-01T00:00:00Z
const $2fa92ec193801792$var$Mt = BigInt(-62135596800), $2fa92ec193801792$var$Nt = BigInt(253402300799), $2fa92ec193801792$var$Lt = BigInt(1e3), $2fa92ec193801792$var$Bt = BigInt(1e6), $2fa92ec193801792$var$Ut = $2fa92ec193801792$var$Mt * $2fa92ec193801792$var$Lt, $2fa92ec193801792$var$kt = $2fa92ec193801792$var$Nt * $2fa92ec193801792$var$Lt + BigInt(999), $2fa92ec193801792$var$qt = $2fa92ec193801792$var$Mt * $2fa92ec193801792$var$Bt, $2fa92ec193801792$var$$t = $2fa92ec193801792$var$Nt * $2fa92ec193801792$var$Bt + BigInt(999999);
// 9999-12-31T23:59:59Z - but the max timestamp has 999,999,999 nanoseconds
// Max sub-second micros
function $2fa92ec193801792$var$__PRIVATE_isMicrosInBounds(e) {
    return e >= $2fa92ec193801792$var$qt && e <= $2fa92ec193801792$var$$t;
}
function $2fa92ec193801792$var$__PRIVATE_isSecondsInBounds(e) {
    return e >= $2fa92ec193801792$var$Mt && e <= $2fa92ec193801792$var$Nt;
}
function $2fa92ec193801792$var$__PRIVATE_isTimestampInBounds(e, t) {
    const n = BigInt(e);
    return !(n < $2fa92ec193801792$var$Mt || n > $2fa92ec193801792$var$Nt) && // Nanos must be non-negative and less than 1 second
    !(t < 0 || t >= 1e9) && // Additional check for min/max boundaries
    (n !== $2fa92ec193801792$var$Mt || 0 === t) && !(n === $2fa92ec193801792$var$Nt && t > 999999999);
}
// Helper function to adjust timestamp for negative nanoseconds
function $2fa92ec193801792$var$__PRIVATE_adjustTimestamp(e, t) {
    return t < 0 ? {
        seconds: e - 1,
        nanos: t + 1e9
    } : {
        seconds: e,
        nanos: t
    };
}
function $2fa92ec193801792$var$__PRIVATE_timestampToMicros(e) {
    return BigInt(e.seconds) * $2fa92ec193801792$var$Bt + // Integer division truncates towards zero
    BigInt(Math.trunc(e.nanoseconds / 1e3));
}
class $2fa92ec193801792$var$__PRIVATE_UnixToTimestamp {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 49262, `${this.expr.name}() function should have exactly one parameter`);
        const n = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "INT":
                return this.toTimestamp(BigInt(n.value.integerValue));
            case "NULL":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreUnixMicrosToTimestamp extends $2fa92ec193801792$var$__PRIVATE_UnixToTimestamp {
    toTimestamp(e) {
        if (!$2fa92ec193801792$var$__PRIVATE_isMicrosInBounds(e)) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        let t = Number(e / $2fa92ec193801792$var$Bt), n = Number(e % $2fa92ec193801792$var$Bt * BigInt(1e3));
        // Note: BigInt modulo can result in negative values if the dividend is negative.
        // Adjust for negative nanoseconds
        const r = $2fa92ec193801792$var$__PRIVATE_adjustTimestamp(t, n);
        // Final bounds check after adjustment
        return t = r.seconds, n = r.nanos, $2fa92ec193801792$var$__PRIVATE_isTimestampInBounds(t, n) ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            timestampValue: {
                seconds: t,
                nanos: n
            }
        }) : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreUnixMillisToTimestamp extends $2fa92ec193801792$var$__PRIVATE_UnixToTimestamp {
    toTimestamp(e) {
        if (!function __PRIVATE_isMillisInBounds(e) {
            return e >= $2fa92ec193801792$var$Ut && e <= $2fa92ec193801792$var$kt;
        }(e)) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        let t = Number(e / $2fa92ec193801792$var$Lt), n = Number(e % $2fa92ec193801792$var$Lt * BigInt(1e6));
        // Adjust for negative nanoseconds
        const r = $2fa92ec193801792$var$__PRIVATE_adjustTimestamp(t, n);
        // Final bounds check after adjustment
        return t = r.seconds, n = r.nanos, $2fa92ec193801792$var$__PRIVATE_isTimestampInBounds(t, n) ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            timestampValue: {
                seconds: t,
                nanos: n
            }
        }) : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreUnixSecondsToTimestamp extends $2fa92ec193801792$var$__PRIVATE_UnixToTimestamp {
    toTimestamp(e) {
        if (!$2fa92ec193801792$var$__PRIVATE_isSecondsInBounds(e)) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        const t = Number(e);
        return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            timestampValue: {
                seconds: t,
                nanos: 0
            }
        });
    }
}
class $2fa92ec193801792$var$__PRIVATE_TimestampToUnix {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 1265, `${this.expr.name}() function should have exactly one parameter`);
        const n = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "TIMESTAMP":
                break;
            case "NULL":
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        const r = $2fa92ec193801792$var$fromTimestamp(n.value.timestampValue);
        // Check if the input timestamp is within valid bounds
        return $2fa92ec193801792$var$__PRIVATE_isTimestampInBounds(r.seconds, r.nanoseconds) ? this.Mr(r) : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreTimestampToUnixMicros extends $2fa92ec193801792$var$__PRIVATE_TimestampToUnix {
    Mr(e) {
        const t = $2fa92ec193801792$var$__PRIVATE_timestampToMicros(e);
        // Check if the resulting micros are within representable bounds
        return $2fa92ec193801792$var$__PRIVATE_isMicrosInBounds(t) ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            integerValue: `${t.toString()}`
        }) : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreTimestampToUnixMillis extends $2fa92ec193801792$var$__PRIVATE_TimestampToUnix {
    Mr(e) {
        const t = $2fa92ec193801792$var$__PRIVATE_timestampToMicros(e), n = t / BigInt(1e3), r = t % BigInt(1e3);
        // Perform division, truncating towards zero (default JS BigInt division)
        return n > BigInt(0) || r === BigInt(0) ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            integerValue: n.toString()
        }) : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            integerValue: (n - BigInt(1)).toString()
        });
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreTimestampToUnixSeconds extends $2fa92ec193801792$var$__PRIVATE_TimestampToUnix {
    Mr(e) {
        // Seconds are directly available
        const t = BigInt(e.seconds);
        // Check if the resulting seconds are within representable bounds
        return $2fa92ec193801792$var$__PRIVATE_isSecondsInBounds(t) ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            integerValue: t.toString()
        }) : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
    }
}
class $2fa92ec193801792$var$__PRIVATE_TimestampArithmetic {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(3 === this.expr.params.length, 2775, `${this.expr.name}() function should have exactly 3 parameters`);
        let n = false;
        const r = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "TIMESTAMP":
                break;
            case "NULL":
                n = true;
                break;
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        const i = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        let s;
        switch(i.type){
            case "STRING":
                if (s = function __PRIVATE_asTimeUnit(e) {
                    switch(e){
                        case "microsecond":
                            return "microsecond";
                        case "millisecond":
                            return "millisecond";
                        case "second":
                            return "second";
                        case "minute":
                            return "minute";
                        case "hour":
                            return "hour";
                        case "day":
                            return "day";
                        default:
                            return;
                    }
                }(i.value.stringValue), void 0 === s) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
                break;
            case "NULL":
                n = true;
                break;
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        const _ = $2fa92ec193801792$var$__PRIVATE_toEvaluable(this.expr.params[2]).evaluate(e, t);
        switch(_.type){
            case "INT":
                break;
            case "NULL":
                n = true;
                break;
            default:
                return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        if (n) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.pr();
        const o = BigInt(_.value.integerValue);
        let a;
        try {
            switch(s){
                case "microsecond":
                    a = o;
                    break;
                case "millisecond":
                    a = o * BigInt(1e3);
                    break;
                case "second":
                    a = o * BigInt(1e6);
                    break;
                case "minute":
                    a = o * BigInt(6e7);
                    break;
                case "hour":
                    a = o * BigInt(36e8);
                    break;
                case "day":
                    a = o * BigInt(864e8);
                    break;
                default:
                    return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
            }
            // Check for potential overflow during multiplication
            if ("microsecond" !== s && o !== BigInt(0) && a / o !== BigInt(this.Nr(s))) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        } catch (e) {
            // Catch potential BigInt errors (though unlikely with isInteger check)
            return $2fa92ec193801792$export$7f8ddf7c7c20b3cd(`Error during timestamp arithmetic: ${e}`), $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        }
        const u = $2fa92ec193801792$var$fromTimestamp(r.value.timestampValue);
        // Check initial timestamp bounds
        if (!$2fa92ec193801792$var$__PRIVATE_isTimestampInBounds(u.seconds, u.nanoseconds)) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        const c = $2fa92ec193801792$var$__PRIVATE_timestampToMicros(u), l = this.Lr(c, a);
        // Check final microsecond bounds
        if (!$2fa92ec193801792$var$__PRIVATE_isMicrosInBounds(l)) return $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
        // Convert back to seconds and nanos
        const E = Number(l / $2fa92ec193801792$var$Bt), h = l % $2fa92ec193801792$var$Bt, T = Number((h < 0 ? h + $2fa92ec193801792$var$Bt : h) * BigInt(1e3)), P = h < 0 ? E - 1 : E;
        // Final check on calculated timestamp bounds
        return $2fa92ec193801792$var$__PRIVATE_isTimestampInBounds(P, T) ? $2fa92ec193801792$var$__PRIVATE_EvaluateResult.newValue({
            timestampValue: {
                seconds: P,
                nanos: T
            }
        }) : $2fa92ec193801792$var$__PRIVATE_EvaluateResult.dr();
    }
    Nr(e) {
        switch(e){
            case "millisecond":
                return 1e3;
            case "second":
                return 1e6;
            case "minute":
                return 6e7;
            case "hour":
                return 36e8;
            case "day":
                return 864e8;
            default:
                return 1;
        }
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreTimestampAdd extends $2fa92ec193801792$var$__PRIVATE_TimestampArithmetic {
    Lr(e, t) {
        return e + t;
    }
}
class $2fa92ec193801792$var$__PRIVATE_CoreTimestampSub extends $2fa92ec193801792$var$__PRIVATE_TimestampArithmetic {
    Lr(e, t) {
        return e - t;
    }
}
// Copyright 2024 Google LLC* @license
// Copyright 2024 Google LLC
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//      http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
class $2fa92ec193801792$var$CorePipeline {
    constructor(e, t, n){
        this.serializer = e, this.stages = t, this.listenOptions = n, this.isCorePipeline = true;
    }
    getPipelineCollection() {
        return $2fa92ec193801792$var$getPipelineCollection(this);
    }
    getPipelineCollectionGroup() {
        return $2fa92ec193801792$var$getPipelineCollectionGroup(this);
    }
    getPipelineCollectionId() {
        return $2fa92ec193801792$var$getPipelineCollectionId(this);
    }
    getPipelineDocuments() {
        return $2fa92ec193801792$var$getPipelineDocuments(this);
    }
    getPipelineFlavor() {
        return function getPipelineFlavor(e) {
            let t = "exact";
            return e.stages.forEach((n, r)=>{
                n._name !== $2fa92ec193801792$export$f438b12253c2b499.name && n._name !== $2fa92ec193801792$export$45d219bdcd8ac53c.name || (t = "keyless"), n._name === $2fa92ec193801792$export$847533e5bf524f5f.name && "exact" === t && (t = "augmented"), // TODO(pipeline): verify the last stage is addFields, and it is added by the SDK.
                n._name === $2fa92ec193801792$export$31e67cf12fc9668.name && r < e.stages.length - 1 && "exact" === t && (t = "augmented");
            }), t;
        }(this);
    }
    getPipelineSourceType() {
        return $2fa92ec193801792$var$getPipelineSourceType(this);
    }
}
function $2fa92ec193801792$var$getPipelineSourceType(e) {
    const t = e.stages[0];
    return t instanceof $2fa92ec193801792$export$c5d1328b37d47994 || t instanceof $2fa92ec193801792$export$d22783b3c2400a3a || t instanceof $2fa92ec193801792$export$7f557e5eb95176c2 || t instanceof $2fa92ec193801792$export$51b138e5a065c2bb ? t._name : "unknown";
}
function $2fa92ec193801792$var$getPipelineCollection(e) {
    if ("collection" === $2fa92ec193801792$var$getPipelineSourceType(e)) return e.stages[0].Er;
}
function $2fa92ec193801792$var$getPipelineCollectionGroup(e) {
    if ("collection_group" === $2fa92ec193801792$var$getPipelineSourceType(e)) return e.stages[0].collectionId;
}
function $2fa92ec193801792$var$getPipelineCollectionId(e) {
    switch($2fa92ec193801792$var$getPipelineSourceType(e)){
        case "collection":
            return $2fa92ec193801792$export$db202ddc8be9136.fromString($2fa92ec193801792$var$getPipelineCollection(e)).lastSegment();
        case "collection_group":
            return $2fa92ec193801792$var$getPipelineCollectionGroup(e);
        default:
            return;
    }
}
function $2fa92ec193801792$var$getPipelineDocuments(e) {
    if ("documents" === $2fa92ec193801792$var$getPipelineSourceType(e)) return e.stages[0].hr;
}
function $2fa92ec193801792$var$__PRIVATE_toPipelineBooleanExpr(t) {
    if (t instanceof $2fa92ec193801792$export$d66501df72047452) {
        const n = $2fa92ec193801792$export$b4d5ecaefe2b27f3(t.field.toString()), r = t.value;
        // Comparison filters
        switch(t.op){
            case "<" /* Operator.LESS_THAN */ :
                return $2fa92ec193801792$export$7fe88b5920ffddd2(n.exists(), n.lessThan($2fa92ec193801792$var$Constant._fromProto(r)));
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return $2fa92ec193801792$export$7fe88b5920ffddd2(n.exists(), n.lessThanOrEqual($2fa92ec193801792$var$Constant._fromProto(r)));
            case ">" /* Operator.GREATER_THAN */ :
                return $2fa92ec193801792$export$7fe88b5920ffddd2(n.exists(), n.greaterThan($2fa92ec193801792$var$Constant._fromProto(r)));
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return $2fa92ec193801792$export$7fe88b5920ffddd2(n.exists(), n.greaterThanOrEqual($2fa92ec193801792$var$Constant._fromProto(r)));
            case "==" /* Operator.EQUAL */ :
                return $2fa92ec193801792$export$7fe88b5920ffddd2(n.exists(), n.equal($2fa92ec193801792$var$Constant._fromProto(r)));
            case "!=" /* Operator.NOT_EQUAL */ :
                return n.notEqual($2fa92ec193801792$var$Constant._fromProto(r));
            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                return $2fa92ec193801792$export$7fe88b5920ffddd2(n.exists(), n.arrayContains($2fa92ec193801792$var$Constant._fromProto(r)));
            case "in" /* Operator.IN */ :
                {
                    const e = r?.arrayValue?.values?.map((e)=>$2fa92ec193801792$var$Constant._fromProto(e));
                    return e ? 1 === e.length ? $2fa92ec193801792$export$7fe88b5920ffddd2(n.exists(), n.equal(e[0])) : $2fa92ec193801792$export$7fe88b5920ffddd2(n.exists(), n.equalAny(e)) : $2fa92ec193801792$export$7fe88b5920ffddd2(n.exists(), n.equalAny([]));
                }
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                {
                    const e = r?.arrayValue?.values?.map((e)=>$2fa92ec193801792$var$Constant._fromProto(e));
                    return $2fa92ec193801792$export$7fe88b5920ffddd2(n.exists(), n.arrayContainsAny(e));
                }
            case "not-in" /* Operator.NOT_IN */ :
                {
                    const e = r?.arrayValue?.values?.map((e)=>$2fa92ec193801792$var$Constant._fromProto(e));
                    return e ? 1 === e.length ? n.notEqual(e[0]) : n.notEqualAny(e) : n.notEqualAny([]);
                }
            default:
                $2fa92ec193801792$export$1a82df3d29112e01(36935);
        }
    } else if (t instanceof $2fa92ec193801792$export$e7094788287c5e9b) switch(t.op){
        case "and" /* CompositeOperator.AND */ :
            {
                const e = t.getFilters().map((e)=>$2fa92ec193801792$var$__PRIVATE_toPipelineBooleanExpr(e));
                return $2fa92ec193801792$export$7fe88b5920ffddd2(e[0], e[1], ...e.slice(2));
            }
        case "or" /* CompositeOperator.OR */ :
            {
                const e = t.getFilters().map((e)=>$2fa92ec193801792$var$__PRIVATE_toPipelineBooleanExpr(e));
                return $2fa92ec193801792$export$2b548b2e30e1dd12(e[0], e[1], ...e.slice(2));
            }
        default:
            $2fa92ec193801792$export$1a82df3d29112e01(35306);
    }
    throw new Error(`Failed to convert filter to pipeline conditions: ${t}`);
}
function $2fa92ec193801792$export$151db275011178c4(t, n) {
    let r;
    r = $2fa92ec193801792$export$21579262ef46735b(t) ? n.pipeline().collectionGroup(t.collectionGroup) : $2fa92ec193801792$var$__PRIVATE_isDocumentQuery$1(t) ? n.pipeline().documents([
        $2fa92ec193801792$export$ebd11618f299a286(n, t.path.canonicalString())
    ]) : n.pipeline().collection(t.path.canonicalString());
    // filters
    for (const e of t.filters)r = r.where($2fa92ec193801792$var$__PRIVATE_toPipelineBooleanExpr(e));
    // orders
    const i = $2fa92ec193801792$export$ee7c8ad385a60b7b(t), s = i.map((t)=>$2fa92ec193801792$export$b4d5ecaefe2b27f3(t.field.canonicalString()).exists());
    r = s.length > 1 ? r.where($2fa92ec193801792$export$7fe88b5920ffddd2(s[0], s[1], ...s.slice(2))) : r.where(s[0]);
    const _ = i.map((t)=>"asc" /* Direction.ASCENDING */  === t.dir ? $2fa92ec193801792$export$b4d5ecaefe2b27f3(t.field.canonicalString()).ascending() : $2fa92ec193801792$export$b4d5ecaefe2b27f3(t.field.canonicalString()).descending());
    if (_.length > 0) {
        if ("L" /* LimitType.Last */  === t.limitType) {
            const e = function __PRIVATE_reverseOrderings(e) {
                return e.map((e)=>new $2fa92ec193801792$export$101619b11a34a0bd(e.expr, "ascending" === e.direction ? "descending" : "ascending", void 0));
            }(_);
            r = r.sort(e[0], ...e.slice(1)), // cursors
            null !== t.startAt && (r = r.where($2fa92ec193801792$var$__PRIVATE_whereConditionsFromCursor(t.startAt, _, "after"))), null !== t.endAt && (r = r.where($2fa92ec193801792$var$__PRIVATE_whereConditionsFromCursor(t.endAt, _, "before"))), r = r.limit(t.limit), r = r.sort(_[0], ..._.slice(1));
        } else r = r.sort(_[0], ..._.slice(1)), null !== t.startAt && (r = r.where($2fa92ec193801792$var$__PRIVATE_whereConditionsFromCursor(t.startAt, _, "after"))), null !== t.endAt && (r = r.where($2fa92ec193801792$var$__PRIVATE_whereConditionsFromCursor(t.endAt, _, "before"))), null !== t.limit && (r = r.limit(t.limit));
    }
    return r.stages;
}
function $2fa92ec193801792$var$__PRIVATE_whereConditionsFromCursor(e, t, n) {
    // The filterFunc is either greater than or less than
    const r = "before" === n ? $2fa92ec193801792$export$3dfa6803f1a6c839 : $2fa92ec193801792$export$27df29599c06edba, i = e.position.map((e)=>$2fa92ec193801792$var$Constant._fromProto(e)), s = i.length;
    let _ = t[s - 1].expr, o = i[s - 1], a = r(_, o);
    e.inclusive && // When the cursor bound is inclusive, then the last bound
    // can be equal to the value, otherwise it's not equal
    (a = $2fa92ec193801792$export$2b548b2e30e1dd12(a, _.equal(o)));
    // Iterate backwards over the remaining bounds, adding
    // a condition for each one
    for(let e = s - 2; e >= 0; e--)_ = t[e].expr, o = i[e], // For each field in the orderings, the condition is either
    // a) lt|gt the cursor value,
    // b) or equal the cursor value and lt|gt the cursor values for other fields
    a = $2fa92ec193801792$export$2b548b2e30e1dd12(r(_, o), $2fa92ec193801792$export$7fe88b5920ffddd2(_.equal(o), a));
    return a;
}
function $2fa92ec193801792$var$__PRIVATE_canonifyExpr(e) {
    if ((e = $2fa92ec193801792$var$__PRIVATE_unwrapExpression(e)) instanceof $2fa92ec193801792$export$e0c3a065614c6254) return `fld(${e.fieldName})`;
    if (e instanceof $2fa92ec193801792$var$Constant) return `cst(${function __PRIVATE_canonifyConstantValue(e) {
        return null === e ? "null" : "number" == typeof e ? e.toString() : "string" == typeof e ? `"${e}"` : e instanceof $2fa92ec193801792$export$78acf4525d8a74c4 ? `ref(${e.path})` : e instanceof $2fa92ec193801792$export$24baa2b76016ce0e ? `vec(${JSON.stringify(e)})` : JSON.stringify(e);
    }(e.value)})`;
    if (e instanceof $2fa92ec193801792$export$acf3ba20e47771d) return `fn(${e.name},[${e.params.map($2fa92ec193801792$var$__PRIVATE_canonifyExpr).join(",")}])`;
    if ("ListOfExpressions" === e.expressionType) return `list([${e.ur.map($2fa92ec193801792$var$__PRIVATE_canonifyExpr).join(",")}])`;
    throw new Error(`Unrecognized expr ${JSON.stringify(e, null, 2)}`);
}
function $2fa92ec193801792$var$__PRIVATE_canonifyStage(e) {
    if (e instanceof $2fa92ec193801792$export$31e67cf12fc9668) return `${e._name}(${$2fa92ec193801792$var$__PRIVATE_canonifyExprMap(e.fields)})`;
    if (e instanceof $2fa92ec193801792$export$45d219bdcd8ac53c) {
        let t = `${e._name}(${$2fa92ec193801792$var$__PRIVATE_canonifyExprMap(e.accumulators)})`;
        return e.groups.size > 0 && (t += `grouping(${$2fa92ec193801792$var$__PRIVATE_canonifyExprMap(e.groups)})`), t;
    }
    if (e instanceof $2fa92ec193801792$export$f438b12253c2b499) return `${e._name}(${$2fa92ec193801792$var$__PRIVATE_canonifyExprMap(e.groups)})`;
    if (e instanceof $2fa92ec193801792$export$c5d1328b37d47994) return `${e._name}(${e.Er})`;
    if (e instanceof $2fa92ec193801792$export$d22783b3c2400a3a) return `${e._name}(${e.collectionId})`;
    if (e instanceof $2fa92ec193801792$export$7f557e5eb95176c2) return `${e._name}()`;
    if (e instanceof $2fa92ec193801792$export$51b138e5a065c2bb) return `${e._name}(${e.hr.sort()})`;
    if (e instanceof $2fa92ec193801792$export$4b170465d7badfa1) return `${e._name}(${$2fa92ec193801792$var$__PRIVATE_canonifyExpr(e.condition)})`;
    if (e instanceof $2fa92ec193801792$export$56350196709588fc) return `${e._name}(${e.limit})`;
    if (e instanceof $2fa92ec193801792$export$b2bcef12bcefba04) return `${e._name}(${function __PRIVATE_canonifySortOrderings(e) {
        return e.map((e)=>`${$2fa92ec193801792$var$__PRIVATE_canonifyExpr(e.expr)}${e.direction}`).join(",");
    }(e.orderings)})`;
    throw new Error(`Unrecognized stage ${e._name}`);
}
function $2fa92ec193801792$var$__PRIVATE_canonifyExprMap(e) {
    return `${Array.from(e.entries()).sort().map(([e, t])=>`${e}=${$2fa92ec193801792$var$__PRIVATE_canonifyExpr(t)}`).join(",")}`;
}
function $2fa92ec193801792$var$__PRIVATE_canonifyPipeline(e) {
    return e.stages.map((e)=>$2fa92ec193801792$var$__PRIVATE_canonifyStage(e)).join("|");
}
// TODO(pipeline): do a proper implementation for eq.
function $2fa92ec193801792$var$__PRIVATE_pipelineEq(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_canonifyPipeline(e) === $2fa92ec193801792$var$__PRIVATE_canonifyPipeline(t);
}
function $2fa92ec193801792$export$342063e11d6c3cad(e) {
    return e instanceof $2fa92ec193801792$var$CorePipeline;
}
function $2fa92ec193801792$var$__PRIVATE_stringifyQueryOrPipeline(e) {
    return $2fa92ec193801792$export$342063e11d6c3cad(e) ? $2fa92ec193801792$var$__PRIVATE_canonifyPipeline(e) : $2fa92ec193801792$var$__PRIVATE_stringifyQuery(e);
}
function $2fa92ec193801792$var$__PRIVATE_canonifyQueryOrPipeline(e) {
    return $2fa92ec193801792$export$342063e11d6c3cad(e) ? $2fa92ec193801792$var$__PRIVATE_canonifyPipeline(e) : function __PRIVATE_canonifyQuery(e) {
        return `${$2fa92ec193801792$var$__PRIVATE_canonifyTarget($2fa92ec193801792$var$__PRIVATE_queryToTarget(e))}|lt:${e.limitType}`;
    }(e);
}
function $2fa92ec193801792$var$__PRIVATE_queryOrPipelineEqual(e, t) {
    return e instanceof $2fa92ec193801792$var$CorePipeline && t instanceof $2fa92ec193801792$var$CorePipeline ? $2fa92ec193801792$var$__PRIVATE_pipelineEq(e, t) : !(e instanceof $2fa92ec193801792$var$CorePipeline && !(t instanceof $2fa92ec193801792$var$CorePipeline) || !(e instanceof $2fa92ec193801792$var$CorePipeline) && t instanceof $2fa92ec193801792$var$CorePipeline) && $2fa92ec193801792$var$__PRIVATE_queryEquals(e, t);
}
function $2fa92ec193801792$var$__PRIVATE_canonifyTargetOrPipeline(e) {
    return $2fa92ec193801792$var$__PRIVATE_targetIsPipelineTarget(e) ? $2fa92ec193801792$var$__PRIVATE_canonifyPipeline(e) : $2fa92ec193801792$var$__PRIVATE_canonifyTarget(e);
}
function $2fa92ec193801792$var$__PRIVATE_targetOrPipelineEqual(e, t) {
    return e instanceof $2fa92ec193801792$var$CorePipeline && t instanceof $2fa92ec193801792$var$CorePipeline ? $2fa92ec193801792$var$__PRIVATE_pipelineEq(e, t) : !(e instanceof $2fa92ec193801792$var$CorePipeline && !(t instanceof $2fa92ec193801792$var$CorePipeline) || !(e instanceof $2fa92ec193801792$var$CorePipeline) && t instanceof $2fa92ec193801792$var$CorePipeline) && $2fa92ec193801792$var$__PRIVATE_targetEquals(e, t);
}
// function addSystemFields(
//   fields: Map<string, Expression>
// ): Map<string, Expression> {
//   const newFields = new Map<string, Expression>(fields);
//   newFields.set(DOCUMENT_KEY_NAME, field(DOCUMENT_KEY_NAME));
//   newFields.set(CREATE_TIME_NAME, field(CREATE_TIME_NAME));
//   newFields.set(UPDATE_TIME_NAME, field(UPDATE_TIME_NAME));
//   return newFields;
// }
function $2fa92ec193801792$var$__PRIVATE_toCorePipeline(t, n) {
    const r = function __PRIVATE_rewriteStages(t) {
        let n = false;
        const r = [];
        for (const i of t)// For stages that provide ordering semantics
        if (i instanceof $2fa92ec193801792$export$b2bcef12bcefba04) {
            // Ensure we have a stable ordering
            if (n = true, i.orderings.some((e)=>e.expr instanceof $2fa92ec193801792$export$e0c3a065614c6254 && e.expr.fieldName === $2fa92ec193801792$var$Ce)) r.push(i);
            else {
                const t = i.orderings.map((e)=>e);
                t.push($2fa92ec193801792$export$b4d5ecaefe2b27f3($2fa92ec193801792$var$Ce).ascending()), r.push(new $2fa92ec193801792$export$b2bcef12bcefba04(t, {}));
            }
        } else i instanceof $2fa92ec193801792$export$56350196709588fc ? (n || (r.push(new $2fa92ec193801792$export$b2bcef12bcefba04([
            $2fa92ec193801792$export$b4d5ecaefe2b27f3($2fa92ec193801792$var$Ce).ascending()
        ], {})), n = true), r.push(i)) : r.push(i);
        return n || r.push(new $2fa92ec193801792$export$b2bcef12bcefba04([
            $2fa92ec193801792$export$b4d5ecaefe2b27f3($2fa92ec193801792$var$Ce).ascending()
        ], {})), r;
    }(t.stages);
    if (t.userDataReader) {
        const e = t.userDataReader.createContext(3 /* UserDataSource.Argument */ , "toCorePipeline");
        r.forEach((t)=>t._readUserData(e));
    }
    return new $2fa92ec193801792$var$CorePipeline(t.userDataReader.serializer, r, n);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class $2fa92ec193801792$var$MutationBatch {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(e, t, n, r){
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(e, t) {
        const n = t.mutationResults;
        for(let t = 0; t < this.mutations.length; t++){
            const r = this.mutations[t];
            if (r.key.isEqual(e.key)) $2fa92ec193801792$var$__PRIVATE_mutationApplyToRemoteDocument(r, e, n[t]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(e, t) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(e.key) && (t = $2fa92ec193801792$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(e.key) && (t = $2fa92ec193801792$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        return t;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(e, t) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = $2fa92ec193801792$var$__PRIVATE_newMutationMap();
        return this.mutations.forEach((r)=>{
            const i = e.get(r.key), s = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let _ = this.applyToLocalView(s, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            _ = t.has(r.key) ? null : _;
            const o = $2fa92ec193801792$var$__PRIVATE_calculateOverlayMutation(s, _);
            null !== o && n.set(r.key, o), s.isValidDocument() || s.convertToNoDocument($2fa92ec193801792$var$SnapshotVersion.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((e, t)=>e.add(t.key), $2fa92ec193801792$export$a9c996f45e5784d0());
    }
    isEqual(e) {
        return this.batchId === e.batchId && $2fa92ec193801792$var$__PRIVATE_arrayEquals(this.mutations, e.mutations, (e, t)=>$2fa92ec193801792$var$__PRIVATE_mutationEquals(e, t)) && $2fa92ec193801792$var$__PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, (e, t)=>$2fa92ec193801792$var$__PRIVATE_mutationEquals(e, t));
    }
}
/** The result of applying a mutation batch to the backend. */ class $2fa92ec193801792$var$MutationBatchResult {
    constructor(e, t, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r){
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(e, t, n) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(e.mutations.length === n.length, 58842, {
            Br: e.mutations.length,
            Ur: n.length
        });
        let r = function __PRIVATE_documentVersionMap() {
            return $2fa92ec193801792$var$it;
        }();
        const i = e.mutations;
        for(let e = 0; e < i.length; e++)r = r.insert(i[e].key, n[e].version);
        return new $2fa92ec193801792$var$MutationBatchResult(e, t, n, r);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$Kt = "";
/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $2fa92ec193801792$var$__PRIVATE_encodeResourcePath(e) {
    let t = "";
    for(let n = 0; n < e.length; n++)t.length > 0 && (t = $2fa92ec193801792$var$__PRIVATE_encodeSeparator(t)), t = $2fa92ec193801792$var$__PRIVATE_encodeSegment(e.get(n), t);
    return $2fa92ec193801792$var$__PRIVATE_encodeSeparator(t);
}
/** Encodes a single segment of a resource path into the given result */ function $2fa92ec193801792$var$__PRIVATE_encodeSegment(e, t) {
    let n = t;
    const r = e.length;
    for(let t = 0; t < r; t++){
        const r = e.charAt(t);
        switch(r){
            case "\0":
                n += "";
                break;
            case $2fa92ec193801792$var$Kt:
                n += "";
                break;
            default:
                n += r;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $2fa92ec193801792$var$__PRIVATE_encodeSeparator(e) {
    return e + $2fa92ec193801792$var$Kt + "";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $2fa92ec193801792$var$__PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const t = e.length;
    if ($2fa92ec193801792$var$__PRIVATE_hardAssert(t >= 2, 64408, {
        path: e
    }), 2 === t) return $2fa92ec193801792$var$__PRIVATE_hardAssert(e.charAt(0) === $2fa92ec193801792$var$Kt && "" === e.charAt(1), 56145, {
        path: e
    }), $2fa92ec193801792$export$db202ddc8be9136.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    let r = "";
    for(let i = 0; i < t;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const t = e.indexOf($2fa92ec193801792$var$Kt, i);
        (t < 0 || t > __PRIVATE_lastReasonableEscapeIndex) && $2fa92ec193801792$export$1a82df3d29112e01(50515, {
            path: e
        });
        switch(e.charAt(t + 1)){
            case "":
                const s = e.substring(i, t);
                let _;
                0 === r.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                _ = s : (r += s, _ = r, r = ""), n.push(_);
                break;
            case "":
                r += e.substring(i, t), r += "\0";
                break;
            case "":
                // The escape character can be used in the output to encode itself.
                r += e.substring(i, t + 1);
                break;
            default:
                $2fa92ec193801792$export$1a82df3d29112e01(61167, {
                    path: e
                });
        }
        i = t + 2;
    }
    return new $2fa92ec193801792$export$db202ddc8be9136(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$Wt = "remoteDocuments", $2fa92ec193801792$var$Qt = "owner", $2fa92ec193801792$var$Gt = "owner", $2fa92ec193801792$var$zt = "mutationQueues", $2fa92ec193801792$var$jt = "userId", $2fa92ec193801792$var$Ht = "mutations", $2fa92ec193801792$var$Jt = "batchId", $2fa92ec193801792$var$Yt = "userMutationsIndex", $2fa92ec193801792$var$Zt = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $2fa92ec193801792$var$__PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [
        e,
        $2fa92ec193801792$var$__PRIVATE_encodeResourcePath(t)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $2fa92ec193801792$var$__PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [
        e,
        $2fa92ec193801792$var$__PRIVATE_encodeResourcePath(t),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const $2fa92ec193801792$var$Xt = {}, $2fa92ec193801792$var$en = "documentMutations", $2fa92ec193801792$var$tn = "remoteDocumentsV14", $2fa92ec193801792$var$nn = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $2fa92ec193801792$var$rn = "documentKeyIndex", $2fa92ec193801792$var$sn = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $2fa92ec193801792$var$_n = "collectionGroupIndex", $2fa92ec193801792$var$on = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $2fa92ec193801792$var$an = "remoteDocumentGlobal", $2fa92ec193801792$var$un = "remoteDocumentGlobalKey", $2fa92ec193801792$var$cn = "targets", $2fa92ec193801792$var$En = "queryTargetsIndex", $2fa92ec193801792$var$hn = [
    "canonicalId",
    "targetId"
], $2fa92ec193801792$var$Tn = "targetDocuments", $2fa92ec193801792$var$Pn = [
    "targetId",
    "path"
], $2fa92ec193801792$var$Rn = "documentTargetsIndex", $2fa92ec193801792$var$In = [
    "path",
    "targetId"
], $2fa92ec193801792$var$An = "targetGlobalKey", $2fa92ec193801792$var$Vn = "targetGlobal", $2fa92ec193801792$var$dn = "collectionParents", $2fa92ec193801792$var$fn = [
    "collectionId",
    "parent"
], $2fa92ec193801792$var$mn = "clientMetadata", $2fa92ec193801792$var$pn = "clientId", $2fa92ec193801792$var$gn = "bundles", $2fa92ec193801792$var$yn = "bundleId", $2fa92ec193801792$var$wn = "namedQueries", $2fa92ec193801792$var$bn = "name", $2fa92ec193801792$var$vn = "indexConfiguration", $2fa92ec193801792$var$Sn = "indexId", $2fa92ec193801792$var$Dn = "collectionGroupIndex", $2fa92ec193801792$var$xn = "collectionGroup", $2fa92ec193801792$var$Cn = "indexState", $2fa92ec193801792$var$Fn = [
    "indexId",
    "uid"
], $2fa92ec193801792$var$On = "sequenceNumberIndex", $2fa92ec193801792$var$Mn = [
    "uid",
    "sequenceNumber"
], $2fa92ec193801792$var$Nn = "indexEntries", $2fa92ec193801792$var$Ln = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $2fa92ec193801792$var$Bn = "documentKeyIndex", $2fa92ec193801792$var$Un = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $2fa92ec193801792$var$kn = "documentOverlays", $2fa92ec193801792$var$qn = [
    "userId",
    "collectionPath",
    "documentId"
], $2fa92ec193801792$var$$n = "collectionPathOverlayIndex", $2fa92ec193801792$var$Kn = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $2fa92ec193801792$var$Wn = "collectionGroupOverlayIndex", $2fa92ec193801792$var$Qn = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $2fa92ec193801792$var$Gn = "globals", $2fa92ec193801792$var$zn = "name", $2fa92ec193801792$var$jn = [
    $2fa92ec193801792$var$zt,
    $2fa92ec193801792$var$Ht,
    $2fa92ec193801792$var$en,
    $2fa92ec193801792$var$Wt,
    $2fa92ec193801792$var$cn,
    $2fa92ec193801792$var$Qt,
    $2fa92ec193801792$var$Vn,
    $2fa92ec193801792$var$Tn,
    $2fa92ec193801792$var$mn,
    $2fa92ec193801792$var$an,
    $2fa92ec193801792$var$dn,
    $2fa92ec193801792$var$gn,
    $2fa92ec193801792$var$wn
], $2fa92ec193801792$var$Hn = [
    ...$2fa92ec193801792$var$jn,
    $2fa92ec193801792$var$kn
], $2fa92ec193801792$var$Jn = [
    $2fa92ec193801792$var$zt,
    $2fa92ec193801792$var$Ht,
    $2fa92ec193801792$var$en,
    $2fa92ec193801792$var$tn,
    $2fa92ec193801792$var$cn,
    $2fa92ec193801792$var$Qt,
    $2fa92ec193801792$var$Vn,
    $2fa92ec193801792$var$Tn,
    $2fa92ec193801792$var$mn,
    $2fa92ec193801792$var$an,
    $2fa92ec193801792$var$dn,
    $2fa92ec193801792$var$gn,
    $2fa92ec193801792$var$wn,
    $2fa92ec193801792$var$kn
], $2fa92ec193801792$var$Yn = $2fa92ec193801792$var$Jn, $2fa92ec193801792$var$Zn = [
    ...$2fa92ec193801792$var$Yn,
    $2fa92ec193801792$var$vn,
    $2fa92ec193801792$var$Cn,
    $2fa92ec193801792$var$Nn
], $2fa92ec193801792$var$Xn = $2fa92ec193801792$var$Zn, $2fa92ec193801792$var$er = [
    ...$2fa92ec193801792$var$Zn,
    $2fa92ec193801792$var$Gn
], $2fa92ec193801792$var$tr = $2fa92ec193801792$var$er;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $2fa92ec193801792$var$removeMutationBatch(e, t, n) {
    const r = e.store($2fa92ec193801792$var$Ht), i = e.store($2fa92ec193801792$var$en), s = [], _ = IDBKeyRange.only(n.batchId);
    let o = 0;
    const a = r.jn({
        range: _
    }, (e, t, n)=>(o++, n.delete()));
    s.push(a.next(()=>{
        $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === o, 47070, {
            batchId: n.batchId
        });
    }));
    const u = [];
    for (const e of n.mutations){
        const r = $2fa92ec193801792$var$__PRIVATE_newDbDocumentMutationKey(t, e.key.path, n.batchId);
        s.push(i.delete(r)), u.push(e.key);
    }
    return $2fa92ec193801792$var$PersistencePromise.waitFor(s).next(()=>u);
}
/**
 * Returns an approximate size for the given document.
 */ function $2fa92ec193801792$var$__PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    let t;
    if (e.document) t = e.document;
    else if (e.unknownDocument) t = e.unknownDocument;
    else {
        if (!e.noDocument) throw $2fa92ec193801792$export$1a82df3d29112e01(14731);
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$var$__PRIVATE_IndexedDbTransaction extends $2fa92ec193801792$var$PersistenceTransaction {
    constructor(e, t){
        super(), this.kr = e, this.currentSequenceNumber = t;
    }
}
function $2fa92ec193801792$var$__PRIVATE_getStore(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    return $2fa92ec193801792$var$__PRIVATE_SimpleDb.xn(n.kr, t);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class $2fa92ec193801792$var$Overlay {
    constructor(e, t){
        this.largestBatchId = e, this.mutation = t;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(e) {
        return null !== e && this.mutation === e.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class $2fa92ec193801792$var$TargetData {
    constructor(/** The target being listened to. */ e, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ t, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r, /** The latest snapshot version seen for this target. */ i = $2fa92ec193801792$var$SnapshotVersion.min(), s = $2fa92ec193801792$var$SnapshotVersion.min(), _ = $2fa92ec193801792$export$158acd800e1ef08b.EMPTY_BYTE_STRING, o = null){
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = s, this.resumeToken = _, this.expectedCount = o;
    }
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(e) {
        return new $2fa92ec193801792$var$TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(e, t) {
        return new $2fa92ec193801792$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, /* expectedCount= */ null);
    }
    /**
     * Creates a new target data instance with an updated expected count.
     */ withExpectedCount(e) {
        return new $2fa92ec193801792$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(e) {
        return new $2fa92ec193801792$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class $2fa92ec193801792$var$__PRIVATE_LocalSerializer {
    constructor(e){
        this.qr = e;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function $2fa92ec193801792$var$__PRIVATE_fromDbRemoteDocument(e, t) {
    let n;
    if (t.document) n = $2fa92ec193801792$export$3a1a48c8f6ef640e(e.qr, t.document, !!t.hasCommittedMutations);
    else if (t.noDocument) {
        const e = $2fa92ec193801792$export$a07804094c3ecf2d.fromSegments(t.noDocument.path), r = $2fa92ec193801792$var$__PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = $2fa92ec193801792$var$MutableDocument.newNoDocument(e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return $2fa92ec193801792$export$1a82df3d29112e01(56709);
        {
            const e = $2fa92ec193801792$export$a07804094c3ecf2d.fromSegments(t.unknownDocument.path), r = $2fa92ec193801792$var$__PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = $2fa92ec193801792$var$MutableDocument.newUnknownDocument(e, r);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        const t = new $2fa92ec193801792$export$890c4ad488842ce7(e[0], e[1]);
        return $2fa92ec193801792$var$SnapshotVersion.fromTimestamp(t);
    }(t.readTime)), n;
}
/** Encodes a document for storage locally. */ function $2fa92ec193801792$var$__PRIVATE_toDbRemoteDocument(e, t) {
    const n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $2fa92ec193801792$var$__PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: $2fa92ec193801792$var$__PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: $2fa92ec193801792$var$toTimestamp(e, t.version.toTimestamp()),
            createTime: $2fa92ec193801792$var$toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.qr, t);
    else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: $2fa92ec193801792$var$__PRIVATE_toDbTimestamp(t.version)
    };
    else {
        if (!t.isUnknownDocument()) return $2fa92ec193801792$export$1a82df3d29112e01(57904, {
            document: t
        });
        r.unknownDocument = {
            path: n.path.toArray(),
            version: $2fa92ec193801792$var$__PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}
function $2fa92ec193801792$var$__PRIVATE_toDbTimestampKey(e) {
    const t = e.toTimestamp();
    return [
        t.seconds,
        t.nanoseconds
    ];
}
function $2fa92ec193801792$var$__PRIVATE_toDbTimestamp(e) {
    const t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}
function $2fa92ec193801792$var$__PRIVATE_fromDbTimestamp(e) {
    const t = new $2fa92ec193801792$export$890c4ad488842ce7(e.seconds, e.nanoseconds);
    return $2fa92ec193801792$var$SnapshotVersion.fromTimestamp(t);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $2fa92ec193801792$var$__PRIVATE_fromDbMutationBatch(e, t) {
    const n = (t.baseMutations || []).map((t)=>$2fa92ec193801792$var$__PRIVATE_fromMutation(e.qr, t));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let e = 0; e < t.mutations.length - 1; ++e){
        const n = t.mutations[e];
        if (e + 1 < t.mutations.length && void 0 !== t.mutations[e + 1].transform) {
            const r = t.mutations[e + 1];
            n.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e + 1, 1), ++e;
        }
    }
    const r = t.mutations.map((t)=>$2fa92ec193801792$var$__PRIVATE_fromMutation(e.qr, t)), i = $2fa92ec193801792$export$890c4ad488842ce7.fromMillis(t.localWriteTimeMs);
    return new $2fa92ec193801792$var$MutationBatch(t.batchId, i, n, r);
}
/** Decodes a DbTarget into TargetData */ function $2fa92ec193801792$var$__PRIVATE_fromDbTarget(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_fromDbTimestamp(t.readTime), r = void 0 !== t.lastLimboFreeSnapshotVersion ? $2fa92ec193801792$var$__PRIVATE_fromDbTimestamp(t.lastLimboFreeSnapshotVersion) : $2fa92ec193801792$var$SnapshotVersion.min();
    let i;
    return i = function __PRIVATE_isPipelineQueryTarget(e) {
        return void 0 !== e.structuredPipeline;
    }(t.query) ? function __PRIVATE_fromPipelineTarget(e, t) {
        const n = e.structuredPipeline;
        $2fa92ec193801792$var$__PRIVATE_hardAssert((n?.pipeline?.stages ?? []).length > 0, 1845);
        const r = n?.pipeline?.stages.map($2fa92ec193801792$var$__PRIVATE_stageFromProto);
        return new $2fa92ec193801792$var$CorePipeline(t, r);
    }(t.query, e.qr) : function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }(t.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        const t = e.documents.length;
        return $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === t, 1966, {
            count: t
        }), $2fa92ec193801792$var$__PRIVATE_queryToTarget($2fa92ec193801792$export$3c2fa207a37baaea($2fa92ec193801792$var$__PRIVATE_fromQueryPath(e.documents[0])));
    }(t.query) : function __PRIVATE_fromQueryTarget(e) {
        return $2fa92ec193801792$var$__PRIVATE_queryToTarget($2fa92ec193801792$var$__PRIVATE_convertQueryTargetToQuery(e));
    }(t.query), new $2fa92ec193801792$var$TargetData(i, t.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , t.lastListenSequenceNumber, n, r, $2fa92ec193801792$export$158acd800e1ef08b.fromBase64String(t.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $2fa92ec193801792$var$__PRIVATE_toDbTarget(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_toDbTimestamp(t.snapshotVersion), r = $2fa92ec193801792$var$__PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    let i;
    i = $2fa92ec193801792$var$__PRIVATE_targetIsPipelineTarget(t.target) ? $2fa92ec193801792$var$__PRIVATE_toPipelineTarget(e.qr, t.target) : $2fa92ec193801792$var$__PRIVATE_targetIsDocumentTarget(t.target) ? $2fa92ec193801792$var$__PRIVATE_toDocumentsTarget(e.qr, t.target) : $2fa92ec193801792$var$__PRIVATE_toQueryTarget(e.qr, t.target).be;
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: t.targetId,
        canonicalId: $2fa92ec193801792$var$__PRIVATE_canonifyTargetOrPipeline(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}
/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $2fa92ec193801792$export$2e2af4578d910ddf(e) {
    const t = $2fa92ec193801792$var$__PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? $2fa92ec193801792$export$dda1d9f60106f0e9(t, t.limit, "L" /* LimitType.Last */ ) : t;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $2fa92ec193801792$var$__PRIVATE_fromDbDocumentOverlay(e, t) {
    return new $2fa92ec193801792$var$Overlay(t.largestBatchId, $2fa92ec193801792$var$__PRIVATE_fromMutation(e.qr, t.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $2fa92ec193801792$var$__PRIVATE_toDbDocumentOverlayKey(e, t) {
    const n = t.path.lastSegment();
    return [
        e,
        $2fa92ec193801792$var$__PRIVATE_encodeResourcePath(t.path.popLast()),
        n
    ];
}
function $2fa92ec193801792$var$__PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t,
        sequenceNumber: n,
        readTime: $2fa92ec193801792$var$__PRIVATE_toDbTimestamp(r.readTime),
        documentKey: $2fa92ec193801792$var$__PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}
function $2fa92ec193801792$var$__PRIVATE_stageFromProto(e) {
    switch(e.name){
        case "collection":
            return new $2fa92ec193801792$export$c5d1328b37d47994(e.args[0].referenceValue, {});
        case "collection_group":
            return new $2fa92ec193801792$export$d22783b3c2400a3a(e.args[1].stringValue, {});
        case "database":
            return new $2fa92ec193801792$export$7f557e5eb95176c2({});
        case "documents":
            return new $2fa92ec193801792$export$51b138e5a065c2bb(e.args.map((e)=>e.referenceValue), {});
        case "where":
            return new $2fa92ec193801792$export$4b170465d7badfa1($2fa92ec193801792$var$__PRIVATE_exprFromProto(e.args[0]), {});
        case "limit":
            {
                const t = e.args[0].integerValue ?? e.args[0].doubleValue;
                return new $2fa92ec193801792$export$56350196709588fc("number" == typeof t ? t : Number(t), {});
            }
        case "sort":
            return new $2fa92ec193801792$export$b2bcef12bcefba04(e.args.map((e)=>(function __PRIVATE_orderingFromProto(e) {
                    const t = e.mapValue?.fields;
                    return new $2fa92ec193801792$export$101619b11a34a0bd($2fa92ec193801792$var$__PRIVATE_exprFromProto(t.expression), t.direction?.stringValue, "orderingFromProto");
                })(e)), {});
        default:
            throw new Error(`Stage type: ${e.name} not supported.`);
    }
}
function $2fa92ec193801792$var$__PRIVATE_exprFromProto(e) {
    return e.fieldReferenceValue ? new $2fa92ec193801792$export$e0c3a065614c6254($2fa92ec193801792$export$625550452a3fa3ec("_exprFromProto", e.fieldReferenceValue), "_exprFromProto") : e.functionValue ? function __PRIVATE_functionFromProto(e) {
        // TODO(pipeline): When aggregation is supported, we need to return AggregateFunction for the functions
        // with aggregate names (sum, count, etc).
        return new $2fa92ec193801792$export$acf3ba20e47771d(e.functionValue.name, e.functionValue.args?.map($2fa92ec193801792$var$__PRIVATE_exprFromProto) || []);
    }(e) : $2fa92ec193801792$var$Constant._fromProto(e);
}
class $2fa92ec193801792$var$__PRIVATE_IndexedDbMutationQueue {
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ e, t, n, r){
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.$r = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static Kr(e, t, n, r) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        $2fa92ec193801792$var$__PRIVATE_hardAssert("" !== e.uid, 64387);
        const i = e.isAuthenticated() ? e.uid : "";
        return new $2fa92ec193801792$var$__PRIVATE_IndexedDbMutationQueue(i, t, n, r);
    }
    checkEmpty(e) {
        let t = true;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $2fa92ec193801792$var$__PRIVATE_mutationsStore(e).jn({
            index: $2fa92ec193801792$var$Yt,
            range: n
        }, (e, n, r)=>{
            t = false, r.done();
        }).next(()=>t);
    }
    addMutationBatch(e, t, n, r) {
        const i = $2fa92ec193801792$var$__PRIVATE_documentMutationsStore(e), s = $2fa92ec193801792$var$__PRIVATE_mutationsStore(e);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next((_)=>{
            $2fa92ec193801792$var$__PRIVATE_hardAssert("number" == typeof _, 49019);
            const o = new $2fa92ec193801792$var$MutationBatch(_, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                const r = n.baseMutations.map((t)=>$2fa92ec193801792$var$toMutation(e.qr, t)), i = n.mutations.map((t)=>$2fa92ec193801792$var$toMutation(e.qr, t));
                return {
                    userId: t,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: r,
                    mutations: i
                };
            }(this.serializer, this.userId, o), u = [];
            let c = new $2fa92ec193801792$var$SortedSet((e, t)=>$2fa92ec193801792$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
            for (const e of r){
                const t = $2fa92ec193801792$var$__PRIVATE_newDbDocumentMutationKey(this.userId, e.key.path, _);
                c = c.add(e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(t, $2fa92ec193801792$var$Xt));
            }
            return c.forEach((t)=>{
                u.push(this.indexManager.addToCollectionParentIndex(e, t));
            }), e.addOnCommittedListener(()=>{
                this.$r[_] = o.keys();
            }), $2fa92ec193801792$var$PersistencePromise.waitFor(u).next(()=>o);
        });
    }
    lookupMutationBatch(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>e ? ($2fa92ec193801792$var$__PRIVATE_hardAssert(e.userId === this.userId, 48, "Unexpected user for mutation batch", {
                userId: e.userId,
                batchId: t
            }), $2fa92ec193801792$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    Wr(e, t) {
        return this.$r[t] ? $2fa92ec193801792$var$PersistencePromise.resolve(this.$r[t]) : this.lookupMutationBatch(e, t).next((e)=>{
            if (e) {
                const n = e.keys();
                return this.$r[t] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return $2fa92ec193801792$var$__PRIVATE_mutationsStore(e).jn({
            index: $2fa92ec193801792$var$Yt,
            range: r
        }, (e, t, r)=>{
            t.userId === this.userId && ($2fa92ec193801792$var$__PRIVATE_hardAssert(t.batchId >= n, 47524, {
                Qr: n
            }), i = $2fa92ec193801792$var$__PRIVATE_fromDbMutationBatch(this.serializer, t)), r.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(e) {
        const t = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = $2fa92ec193801792$var$Ke;
        return $2fa92ec193801792$var$__PRIVATE_mutationsStore(e).jn({
            index: $2fa92ec193801792$var$Yt,
            range: t,
            reverse: true
        }, (e, t, r)=>{
            n = t.batchId, r.done();
        }).next(()=>n);
    }
    getAllMutationBatches(e) {
        const t = IDBKeyRange.bound([
            this.userId,
            $2fa92ec193801792$var$Ke
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $2fa92ec193801792$var$__PRIVATE_mutationsStore(e).Kn($2fa92ec193801792$var$Yt, t).next((e)=>e.map((e)=>$2fa92ec193801792$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)));
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = $2fa92ec193801792$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
        return $2fa92ec193801792$var$__PRIVATE_documentMutationsStore(e).jn({
            range: r
        }, (n, r, s)=>{
            const [_, o, a] = n, u = $2fa92ec193801792$var$__PRIVATE_decodeResourcePath(o);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (_ === this.userId && t.path.isEqual(u)) // Look up the mutation batch in the store.
            return $2fa92ec193801792$var$__PRIVATE_mutationsStore(e).get(a).next((e)=>{
                if (!e) throw $2fa92ec193801792$export$1a82df3d29112e01(61480, {
                    Gr: n,
                    batchId: a
                });
                $2fa92ec193801792$var$__PRIVATE_hardAssert(e.userId === this.userId, 10503, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: a
                }), i.push($2fa92ec193801792$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            });
            s.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$var$__PRIVATE_primitiveComparator);
        const r = [];
        return t.forEach((t)=>{
            const i = $2fa92ec193801792$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), s = IDBKeyRange.lowerBound(i), _ = $2fa92ec193801792$var$__PRIVATE_documentMutationsStore(e).jn({
                range: s
            }, (e, r, i)=>{
                const [s, _, o] = e, a = $2fa92ec193801792$var$__PRIVATE_decodeResourcePath(_);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                s === this.userId && t.path.isEqual(a) ? n = n.add(o) : i.done();
            });
            r.push(_);
        }), $2fa92ec193801792$var$PersistencePromise.waitFor(r).next(()=>this.zr(e, n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        const n = t.path, r = n.length + 1, i = $2fa92ec193801792$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let _ = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$var$__PRIVATE_primitiveComparator);
        return $2fa92ec193801792$var$__PRIVATE_documentMutationsStore(e).jn({
            range: s
        }, (e, t, i)=>{
            const [s, o, a] = e, u = $2fa92ec193801792$var$__PRIVATE_decodeResourcePath(o);
            s === this.userId && n.isPrefixOf(u) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            u.length === r && (_ = _.add(a)) : i.done();
        }).next(()=>this.zr(e, _));
    }
    zr(e, t) {
        const n = [], r = [];
        // TODO(rockwood): Implement this using iterate.
        return t.forEach((t)=>{
            r.push($2fa92ec193801792$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>{
                if (null === e) throw $2fa92ec193801792$export$1a82df3d29112e01(35274, {
                    batchId: t
                });
                $2fa92ec193801792$var$__PRIVATE_hardAssert(e.userId === this.userId, 9748, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: t
                }), n.push($2fa92ec193801792$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            }));
        }), $2fa92ec193801792$var$PersistencePromise.waitFor(r).next(()=>n);
    }
    removeMutationBatch(e, t) {
        return $2fa92ec193801792$var$removeMutationBatch(e.kr, this.userId, t).next((n)=>(e.addOnCommittedListener(()=>{
                this.jr(t.batchId);
            }), $2fa92ec193801792$var$PersistencePromise.forEach(n, (t)=>this.referenceDelegate.markPotentiallyOrphaned(e, t))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    jr(e) {
        delete this.$r[e];
    }
    performConsistencyCheck(e) {
        return this.checkEmpty(e).next((t)=>{
            if (!t) return $2fa92ec193801792$var$PersistencePromise.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound(/**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */ function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                return [
                    e
                ];
            }(this.userId)), r = [];
            return $2fa92ec193801792$var$__PRIVATE_documentMutationsStore(e).jn({
                range: n
            }, (e, t, n)=>{
                if (e[0] === this.userId) {
                    const t = $2fa92ec193801792$var$__PRIVATE_decodeResourcePath(e[1]);
                    r.push(t);
                } else n.done();
            }).next(()=>{
                $2fa92ec193801792$var$__PRIVATE_hardAssert(0 === r.length, 56720, {
                    Hr: r.map((e)=>e.canonicalString())
                });
            });
        });
    }
    containsKey(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_mutationQueueContainsKey(e, this.userId, t);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ Jr(e) {
        return $2fa92ec193801792$var$__PRIVATE_mutationQueuesStore(e).get(this.userId).next((e)=>e || {
                userId: this.userId,
                lastAcknowledgedBatchId: $2fa92ec193801792$var$Ke,
                lastStreamToken: ""
            });
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $2fa92ec193801792$var$__PRIVATE_mutationQueueContainsKey(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    let _ = false;
    return $2fa92ec193801792$var$__PRIVATE_documentMutationsStore(e).jn({
        range: s,
        zn: true
    }, (e, n, r)=>{
        const [s, o, /*batchID*/ a] = e;
        s === t && o === i && (_ = true), r.done();
    }).next(()=>_);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $2fa92ec193801792$var$__PRIVATE_mutationsStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$Ht);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $2fa92ec193801792$var$__PRIVATE_documentMutationsStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$en);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $2fa92ec193801792$var$__PRIVATE_mutationQueuesStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$zt);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$var$__PRIVATE_IndexedDbBundleCache {
    getBundleMetadata(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_bundlesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbBundle(e) {
                return {
                    id: e.bundleId,
                    createTime: $2fa92ec193801792$var$__PRIVATE_fromDbTimestamp(e.createTime),
                    version: e.version
                };
            }(e);
        });
    }
    saveBundleMetadata(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
            return {
                bundleId: e.id,
                createTime: $2fa92ec193801792$var$__PRIVATE_toDbTimestamp($2fa92ec193801792$var$__PRIVATE_fromVersion(e.createTime)),
                version: e.version
            };
        }(t));
    }
    getNamedQuery(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_namedQueriesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                return {
                    name: e.name,
                    query: $2fa92ec193801792$export$2e2af4578d910ddf(e.bundledQuery),
                    readTime: $2fa92ec193801792$var$__PRIVATE_fromDbTimestamp(e.readTime)
                };
            }(e);
        });
    }
    saveNamedQuery(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
            return {
                name: e.name,
                readTime: $2fa92ec193801792$var$__PRIVATE_toDbTimestamp($2fa92ec193801792$var$__PRIVATE_fromVersion(e.readTime)),
                bundledQuery: e.bundledQuery
            };
        }(t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $2fa92ec193801792$var$__PRIVATE_bundlesStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$gn);
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $2fa92ec193801792$var$__PRIVATE_namedQueriesStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$wn);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class $2fa92ec193801792$var$__PRIVATE_IndexedDbDocumentOverlayCache {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(e, t){
        this.serializer = e, this.userId = t;
    }
    static Kr(e, t) {
        const n = t.uid || "";
        return new $2fa92ec193801792$var$__PRIVATE_IndexedDbDocumentOverlayCache(e, n);
    }
    getOverlay(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_documentOverlayStore(e).get($2fa92ec193801792$var$__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next((e)=>e ? $2fa92ec193801792$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, e) : null);
    }
    getOverlays(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_newOverlayMap();
        return $2fa92ec193801792$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    getAllOverlays(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_newOverlayMap();
        // TODO(pipeline): should we create an index for this? But how often people really expect
        // querying entire database to be fast?
        return $2fa92ec193801792$var$__PRIVATE_documentOverlayStore(e).jn((e, r)=>{
            const i = $2fa92ec193801792$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, r);
            i.largestBatchId > t && n.set(i.getKey(), i);
        }).next(()=>n);
    }
    saveOverlays(e, t, n) {
        const r = [];
        return n.forEach((n, i)=>{
            const s = new $2fa92ec193801792$var$Overlay(t, i);
            r.push(this.Yr(e, s));
        }), $2fa92ec193801792$var$PersistencePromise.waitFor(r);
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = new Set;
        // Get the set of unique collection paths.
        t.forEach((e)=>r.add($2fa92ec193801792$var$__PRIVATE_encodeResourcePath(e.getCollectionPath())));
        const i = [];
        return r.forEach((t)=>{
            const r = IDBKeyRange.bound([
                this.userId,
                t,
                n
            ], [
                this.userId,
                t,
                n + 1
            ], /*lowerOpen=*/ false, /*upperOpen=*/ true);
            i.push($2fa92ec193801792$var$__PRIVATE_documentOverlayStore(e).Gn($2fa92ec193801792$var$$n, r));
        }), $2fa92ec193801792$var$PersistencePromise.waitFor(i);
    }
    getOverlaysForCollection(e, t, n) {
        const r = $2fa92ec193801792$var$__PRIVATE_newOverlayMap(), i = $2fa92ec193801792$var$__PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ true);
        return $2fa92ec193801792$var$__PRIVATE_documentOverlayStore(e).Kn($2fa92ec193801792$var$$n, s).next((e)=>{
            for (const t of e){
                const e = $2fa92ec193801792$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
                r.set(e.getKey(), e);
            }
            return r;
        });
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        const i = $2fa92ec193801792$var$__PRIVATE_newOverlayMap();
        let s;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const _ = IDBKeyRange.bound([
            this.userId,
            t,
            n
        ], [
            this.userId,
            t,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ true);
        return $2fa92ec193801792$var$__PRIVATE_documentOverlayStore(e).jn({
            index: $2fa92ec193801792$var$Wn,
            range: _
        }, (e, t, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const _ = $2fa92ec193801792$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
            i.size() < r || _.largestBatchId === s ? (i.set(_.getKey(), _), s = _.largestBatchId) : n.done();
        }).next(()=>i);
    }
    Yr(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
            const [r, i, s] = $2fa92ec193801792$var$__PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key);
            return {
                userId: t,
                collectionPath: i,
                documentId: s,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: $2fa92ec193801792$var$toMutation(e.qr, n.mutation)
            };
        }(this.serializer, this.userId, t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $2fa92ec193801792$var$__PRIVATE_documentOverlayStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$kn);
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$var$__PRIVATE_IndexedDbGlobalsCache {
    Zr(e) {
        return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$Gn);
    }
    getSessionToken(e) {
        return this.Zr(e).get("sessionToken").next((e)=>{
            const t = e?.value;
            return t ? $2fa92ec193801792$export$158acd800e1ef08b.fromUint8Array(t) : $2fa92ec193801792$export$158acd800e1ef08b.EMPTY_BYTE_STRING;
        });
    }
    setSessionToken(e, t) {
        return this.Zr(e).put({
            name: "sessionToken",
            value: t.toUint8Array()
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class $2fa92ec193801792$var$__PRIVATE_FirestoreIndexValueWriter {
    constructor(){}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ Xr(e, t) {
        this.ei(e, t), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        t.ti();
    }
    ei(e, t) {
        if ("nullValue" in e) this.ni(t, 5);
        else if ("booleanValue" in e) this.ni(t, 10), t.ri(e.booleanValue ? 1 : 0);
        else if ("integerValue" in e) this.ni(t, 15), t.ri($2fa92ec193801792$var$__PRIVATE_normalizeNumber(e.integerValue));
        else if ("doubleValue" in e) {
            const n = $2fa92ec193801792$var$__PRIVATE_normalizeNumber(e.doubleValue);
            isNaN(n) ? this.ni(t, 13) : (this.ni(t, 15), $2fa92ec193801792$var$__PRIVATE_isNegativeZero(n) ? // -0.0, 0 and 0.0 are all considered the same
            t.ri(0) : t.ri(n));
        } else if ("timestampValue" in e) {
            let n = e.timestampValue;
            this.ni(t, 20), "string" == typeof n && (n = $2fa92ec193801792$var$__PRIVATE_normalizeTimestamp(n)), t.ii(`${n.seconds || ""}`), t.ri(n.nanos || 0);
        } else if ("stringValue" in e) this.si(e.stringValue, t), this._i(t);
        else if ("bytesValue" in e) this.ni(t, 30), t.oi($2fa92ec193801792$var$__PRIVATE_normalizeByteString(e.bytesValue)), this._i(t);
        else if ("referenceValue" in e) this.ai(e.referenceValue, t);
        else if ("geoPointValue" in e) {
            const n = e.geoPointValue;
            this.ni(t, 45), t.ri(n.latitude || 0), t.ri(n.longitude || 0);
        } else "mapValue" in e ? $2fa92ec193801792$var$__PRIVATE_isMaxValue(e) ? this.ni(t, Number.MAX_SAFE_INTEGER) : $2fa92ec193801792$var$__PRIVATE_isVectorValue(e) ? this.ui(e.mapValue, t) : (this.ci(e.mapValue, t), this._i(t)) : "arrayValue" in e ? (this.li(e.arrayValue, t), this._i(t)) : $2fa92ec193801792$export$1a82df3d29112e01(19022, {
            Ei: e
        });
    }
    si(e, t) {
        this.ni(t, 25), this.hi(e, t);
    }
    hi(e, t) {
        t.ii(e);
    }
    ci(e, t) {
        const n = e.fields || {};
        this.ni(t, 55);
        for (const e of Object.keys(n))this.si(e, t), this.ei(n[e], t);
    }
    ui(e, t) {
        const n = e.fields || {};
        this.ni(t, 53);
        // Vectors sort first by length
        const r = $2fa92ec193801792$var$je, i = n[r].arrayValue?.values?.length || 0;
        this.ni(t, 15), t.ri($2fa92ec193801792$var$__PRIVATE_normalizeNumber(i)), // Vectors then sort by position value
        this.si(r, t), this.ei(n[r], t);
    }
    li(e, t) {
        const n = e.values || [];
        this.ni(t, 50);
        for (const e of n)this.ei(e, t);
    }
    ai(e, t) {
        this.ni(t, 37);
        $2fa92ec193801792$export$a07804094c3ecf2d.fromName(e).path.forEach((e)=>{
            this.ni(t, 60), this.hi(e, t);
        });
    }
    ni(e, t) {
        e.ri(t);
    }
    _i(e) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        e.ri(2);
    }
}
$2fa92ec193801792$var$__PRIVATE_FirestoreIndexValueWriter.Ti = new $2fa92ec193801792$var$__PRIVATE_FirestoreIndexValueWriter;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law | agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES | CONDITIONS OF ANY KIND, either express | implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** These constants are taken from the backend. */ const $2fa92ec193801792$var$nr = 255;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $2fa92ec193801792$var$__PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    let t = 0;
    return e >> 4 || // Test if the first four bits are zero.
    (t += 4, e <<= 4), e >> 6 || // Test if the first two (or next two) bits are zero.
    (t += 2, e <<= 2), e >> 7 || // Test if the remaining bit is zero.
    (t += 1), t;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $2fa92ec193801792$var$__PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    const t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        let t = 0;
        for(let n = 0; n < 8; ++n){
            const r = $2fa92ec193801792$var$__PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class $2fa92ec193801792$var$__PRIVATE_OrderedCodeWriter {
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    Pi(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Ri(n.value), n = t.next();
        this.Ii();
    }
    Ai(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Vi(n.value), n = t.next();
        this.di();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ fi(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Ri(e);
            else if (e < 2048) this.Ri(960 | e >>> 6), this.Ri(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Ri(480 | e >>> 12), this.Ri(128 | 63 & e >>> 6), this.Ri(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Ri(240 | e >>> 18), this.Ri(128 | 63 & e >>> 12), this.Ri(128 | 63 & e >>> 6), this.Ri(128 | 63 & e);
            }
        }
        this.Ii();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ mi(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Vi(e);
            else if (e < 2048) this.Vi(960 | e >>> 6), this.Vi(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Vi(480 | e >>> 12), this.Vi(128 | 63 & e >>> 6), this.Vi(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Vi(240 | e >>> 18), this.Vi(128 | 63 & e >>> 12), this.Vi(128 | 63 & e >>> 6), this.Vi(128 | 63 & e);
            }
        }
        this.di();
    }
    pi(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const t = this.gi(e), n = $2fa92ec193801792$var$__PRIVATE_unsignedNumLength(t);
        this.yi(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = 255 & t[e];
    }
    wi(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const t = this.gi(e), n = $2fa92ec193801792$var$__PRIVATE_unsignedNumLength(t);
        this.yi(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = ~(255 & t[e]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ bi() {
        this.Si($2fa92ec193801792$var$nr), this.Si(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ Di() {
        this.xi($2fa92ec193801792$var$nr), this.xi(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(e) {
        this.yi(e.length), this.buffer.set(e, this.position), this.position += e.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ Ci() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ gi(e) {
        const t = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function __PRIVATE_doubleToLongBits(e) {
            const t = new DataView(new ArrayBuffer(8));
            return t.setFloat64(0, e, /* littleEndian= */ false), new Uint8Array(t.buffer);
        }(e), n = !!(128 & t[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        t[0] ^= n ? 255 : 128;
        for(let e = 1; e < t.length; ++e)t[e] ^= n ? 255 : 0;
        return t;
    }
    /** Writes a single byte ascending to the buffer. */ Ri(e) {
        const t = 255 & e;
        0 === t ? (this.Si(0), this.Si(255)) : t === $2fa92ec193801792$var$nr ? (this.Si($2fa92ec193801792$var$nr), this.Si(0)) : this.Si(t);
    }
    /** Writes a single byte descending to the buffer.  */ Vi(e) {
        const t = 255 & e;
        0 === t ? (this.xi(0), this.xi(255)) : t === $2fa92ec193801792$var$nr ? (this.xi($2fa92ec193801792$var$nr), this.xi(0)) : this.xi(e);
    }
    Ii() {
        this.Si(0), this.Si(1);
    }
    di() {
        this.xi(0), this.xi(1);
    }
    Si(e) {
        this.yi(1), this.buffer[this.position++] = e;
    }
    xi(e) {
        this.yi(1), this.buffer[this.position++] = ~e;
    }
    yi(e) {
        const t = e + this.position;
        if (t <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < t && (n = t);
        // Create the new buffer.
        const r = new Uint8Array(n);
        r.set(this.buffer), this.buffer = r;
    }
}
class $2fa92ec193801792$var$__PRIVATE_AscendingIndexByteEncoder {
    constructor(e){
        this.Fi = e;
    }
    oi(e) {
        this.Fi.Pi(e);
    }
    ii(e) {
        this.Fi.fi(e);
    }
    ri(e) {
        this.Fi.pi(e);
    }
    ti() {
        this.Fi.bi();
    }
}
class $2fa92ec193801792$var$__PRIVATE_DescendingIndexByteEncoder {
    constructor(e){
        this.Fi = e;
    }
    oi(e) {
        this.Fi.Ai(e);
    }
    ii(e) {
        this.Fi.mi(e);
    }
    ri(e) {
        this.Fi.wi(e);
    }
    ti() {
        this.Fi.Di();
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class $2fa92ec193801792$var$__PRIVATE_IndexByteEncoder {
    constructor(){
        this.Fi = new $2fa92ec193801792$var$__PRIVATE_OrderedCodeWriter, this.ascending = new $2fa92ec193801792$var$__PRIVATE_AscendingIndexByteEncoder(this.Fi), this.descending = new $2fa92ec193801792$var$__PRIVATE_DescendingIndexByteEncoder(this.Fi);
    }
    seed(e) {
        this.Fi.seed(e);
    }
    Oi(e) {
        return 0 /* IndexKind.ASCENDING */  === e ? this.ascending : this.descending;
    }
    Ci() {
        return this.Fi.Ci();
    }
    reset() {
        this.Fi.reset();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class $2fa92ec193801792$var$__PRIVATE_IndexEntry {
    constructor(e, t, n, r){
        this.Mi = e, this.Ni = t, this.Li = n, this.Bi = r;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ Ui() {
        const e = this.Bi.length, t = 0 === e || 255 === this.Bi[e - 1] ? e + 1 : e, n = new Uint8Array(t);
        return n.set(this.Bi, 0), t !== e ? n.set([
            0
        ], this.Bi.length) : ++n[n.length - 1], new $2fa92ec193801792$var$__PRIVATE_IndexEntry(this.Mi, this.Ni, this.Li, n);
    }
    // Create a representation of the Index Entry as a DbIndexEntry
    ki(e, t, n) {
        return {
            indexId: this.Mi,
            uid: e,
            arrayValue: $2fa92ec193801792$var$__PRIVATE_encodeKeySafeBytes(this.Li),
            directionalValue: $2fa92ec193801792$var$__PRIVATE_encodeKeySafeBytes(this.Bi),
            orderedDocumentKey: $2fa92ec193801792$var$__PRIVATE_encodeKeySafeBytes(t),
            documentKey: n.path.toArray()
        };
    }
    // Create a representation of the Index Entry as a DbIndexEntryKey
    qi(e, t, n) {
        const r = this.ki(e, t, n);
        return [
            r.indexId,
            r.uid,
            r.arrayValue,
            r.directionalValue,
            r.orderedDocumentKey,
            r.documentKey
        ];
    }
}
function $2fa92ec193801792$var$__PRIVATE_indexEntryComparator(e, t) {
    let n = e.Mi - t.Mi;
    return 0 !== n ? n : (n = $2fa92ec193801792$var$__PRIVATE_compareByteArrays(e.Li, t.Li), 0 !== n ? n : (n = $2fa92ec193801792$var$__PRIVATE_compareByteArrays(e.Bi, t.Bi), 0 !== n ? n : $2fa92ec193801792$export$a07804094c3ecf2d.comparator(e.Ni, t.Ni)));
}
function $2fa92ec193801792$var$__PRIVATE_compareByteArrays(e, t) {
    for(let n = 0; n < e.length && n < t.length; ++n){
        const r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}
/**
 * Workaround for WebKit bug: https://bugs.webkit.org/show_bug.cgi?id=292721
 * Create a key safe representation of Uint8Array values.
 * If the browser is detected as Safari or WebKit, then
 * the input array will be converted to "sortable byte string".
 * Otherwise, the input array will be returned in its original type.
 */ function $2fa92ec193801792$var$__PRIVATE_encodeKeySafeBytes(e) {
    return (0, $029952e65115eee5$export$ef10bcfb06572016)() ? /**
 * Encodes a Uint8Array into a "sortable byte string".
 * A "sortable byte string" sorts in the same order as the Uint8Array.
 * This works because JS string comparison sorts strings based on code points.
 */ function __PRIVATE_encodeUint8ArrayToSortableString(e) {
        let t = "";
        for(let n = 0; n < e.length; n++)t += String.fromCharCode(e[n]);
        return t;
    }(e) : e;
}
/**
 * Reverts the key safe representation of Uint8Array (created by
 * encodeKeySafeBytes) to a normal Uint8Array.
 */ function $2fa92ec193801792$var$__PRIVATE_decodeKeySafeBytes(e) {
    return "string" != typeof e ? e : function __PRIVATE_decodeSortableStringToUint8Array(e) {
        const t = new Uint8Array(e.length);
        for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
        return t;
    }(e);
}
class $2fa92ec193801792$var$__PRIVATE_TargetIndexMatcher {
    constructor(e){
        // The inequality filters of the target (if it exists).
        // Note: The sort on FieldFilters is not required. Using SortedSet here just to utilize the custom
        // comparator.
        this.$i = new $2fa92ec193801792$var$SortedSet((e, t)=>$2fa92ec193801792$export$b9a6b53f9be3734.comparator(e.field, t.field)), this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), this.Ki = e.orderBy, this.Wi = [];
        for (const t of e.filters){
            const e = t;
            e.isInequality() ? this.$i = this.$i.add(e) : this.Wi.push(e);
        }
    }
    get Qi() {
        return this.$i.size > 1;
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ Gi(e) {
        if ($2fa92ec193801792$var$__PRIVATE_hardAssert(e.collectionGroup === this.collectionId, 49279), this.Qi) // Only single inequality is supported for now.
        // TODO(Add support for multiple inequality query): b/298441043
        return false;
        // If there is an array element, find a matching filter.
        const t = $2fa92ec193801792$var$__PRIVATE_fieldIndexGetArraySegment(e);
        if (void 0 !== t && !this.zi(t)) return false;
        const n = $2fa92ec193801792$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
        let r = new Set, i = 0, s = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; i < n.length && this.zi(n[i]); ++i)r = r.add(n[i].fieldPath.canonicalString());
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (i === n.length) return true;
        if (this.$i.size > 0) {
            // Only a single inequality is currently supported. Get the only entry in the set.
            const e = this.$i.getIterator().getNext();
            // If there is an inequality filter and the field was not in one of the
            // equality filters above, the next segment must match both the filter
            // and the first orderBy clause.
            if (!r.has(e.field.canonicalString())) {
                const t = n[i];
                if (!this.ji(e, t) || !this.Hi(this.Ki[s++], t)) return false;
            }
            ++i;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; i < n.length; ++i){
            const e = n[i];
            if (s >= this.Ki.length || !this.Hi(this.Ki[s++], e)) return false;
        }
        return true;
    }
    /**
     * Returns a full matched field index for this target. Currently multiple
     * inequality query is not supported so function returns null.
     */ Ji() {
        if (this.Qi) return null;
        // We want to make sure only one segment created for one field. For example,
        // in case like a == 3 and a > 2, Index {a ASCENDING} will only be created
        // once.
        let e = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$export$b9a6b53f9be3734.comparator);
        const t = [];
        for (const n of this.Wi){
            if (n.field.isKeyField()) continue;
            if ("array-contains" /* Operator.ARRAY_CONTAINS */  === n.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === n.op) t.push(new $2fa92ec193801792$export$2219238a014317b0(n.field, 2 /* IndexKind.CONTAINS */ ));
            else {
                if (e.has(n.field)) continue;
                e = e.add(n.field), t.push(new $2fa92ec193801792$export$2219238a014317b0(n.field, 0 /* IndexKind.ASCENDING */ ));
            }
        }
        // Note: We do not explicitly check `this.inequalityFilter` but rather rely
        // on the target defining an appropriate "order by" to ensure that the
        // required index segment is added. The query engine would reject a query
        // with an inequality filter that lacks the required order-by clause.
        for (const n of this.Ki)// Stop adding more segments if we see a order-by on key. Typically this
        // is the default implicit order-by which is covered in the index_entry
        // table as a separate column. If it is not the default order-by, the
        // generated index will be missing some segments optimized for order-bys,
        // which is probably fine.
        n.field.isKeyField() || e.has(n.field) || (e = e.add(n.field), t.push(new $2fa92ec193801792$export$2219238a014317b0(n.field, "asc" /* Direction.ASCENDING */  === n.dir ? 0 /* IndexKind.ASCENDING */  : 1 /* IndexKind.DESCENDING */ )));
        return new $2fa92ec193801792$export$4c3d22f3d993c33f($2fa92ec193801792$export$4c3d22f3d993c33f.UNKNOWN_ID, this.collectionId, t, $2fa92ec193801792$export$f787f51d84a910ad.empty());
    }
    zi(e) {
        for (const t of this.Wi)if (this.ji(t, e)) return true;
        return false;
    }
    ji(e, t) {
        if (void 0 === e || !e.field.isEqual(t.fieldPath)) return false;
        const n = "array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op;
        return 2 /* IndexKind.CONTAINS */  === t.kind === n;
    }
    Hi(e, t) {
        return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */  === t.kind && "asc" /* Direction.ASCENDING */  === e.dir || 1 /* IndexKind.DESCENDING */  === t.kind && "desc" /* Direction.DESCENDING */  === e.dir);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function $2fa92ec193801792$var$__PRIVATE_computeInExpansion(e) {
    if ($2fa92ec193801792$var$__PRIVATE_hardAssert(e instanceof $2fa92ec193801792$export$d66501df72047452 || e instanceof $2fa92ec193801792$export$e7094788287c5e9b, 20012), e instanceof $2fa92ec193801792$export$d66501df72047452) {
        if (e instanceof $2fa92ec193801792$var$__PRIVATE_InFilter) {
            const t = e.value.arrayValue?.values?.map((t)=>$2fa92ec193801792$export$d66501df72047452.create(e.field, "==" /* Operator.EQUAL */ , t)) || [];
            return $2fa92ec193801792$export$e7094788287c5e9b.create(t, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
    const t = e.filters.map((e)=>$2fa92ec193801792$var$__PRIVATE_computeInExpansion(e));
    return $2fa92ec193801792$export$e7094788287c5e9b.create(t, e.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter - the composite filter to calculate DNF transform for.
 * @returns the terms in the DNF transform.
 */ function $2fa92ec193801792$var$__PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    const t = $2fa92ec193801792$var$__PRIVATE_computeDistributedNormalForm($2fa92ec193801792$var$__PRIVATE_computeInExpansion(e));
    return $2fa92ec193801792$var$__PRIVATE_hardAssert($2fa92ec193801792$var$__PRIVATE_isDisjunctiveNormalForm(t), 7391), $2fa92ec193801792$var$__PRIVATE_isSingleFieldFilter(t) || $2fa92ec193801792$var$__PRIVATE_isFlatConjunction(t) ? [
        t
    ] : t.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function $2fa92ec193801792$var$__PRIVATE_isSingleFieldFilter(e) {
    return e instanceof $2fa92ec193801792$export$d66501df72047452;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function $2fa92ec193801792$var$__PRIVATE_isFlatConjunction(e) {
    return e instanceof $2fa92ec193801792$export$e7094788287c5e9b && $2fa92ec193801792$var$__PRIVATE_compositeFilterIsFlatConjunction(e);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function $2fa92ec193801792$var$__PRIVATE_isDisjunctiveNormalForm(e) {
    return $2fa92ec193801792$var$__PRIVATE_isSingleFieldFilter(e) || $2fa92ec193801792$var$__PRIVATE_isFlatConjunction(e) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof $2fa92ec193801792$export$e7094788287c5e9b && $2fa92ec193801792$var$__PRIVATE_compositeFilterIsDisjunction(e)) {
            for (const t of e.getFilters())if (!$2fa92ec193801792$var$__PRIVATE_isSingleFieldFilter(t) && !$2fa92ec193801792$var$__PRIVATE_isFlatConjunction(t)) return false;
            return true;
        }
        return false;
    }(e);
}
function $2fa92ec193801792$var$__PRIVATE_computeDistributedNormalForm(e) {
    if ($2fa92ec193801792$var$__PRIVATE_hardAssert(e instanceof $2fa92ec193801792$export$d66501df72047452 || e instanceof $2fa92ec193801792$export$e7094788287c5e9b, 34018), e instanceof $2fa92ec193801792$export$d66501df72047452) return e;
    if (1 === e.filters.length) return $2fa92ec193801792$var$__PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
    const t = e.filters.map((e)=>$2fa92ec193801792$var$__PRIVATE_computeDistributedNormalForm(e));
    let n = $2fa92ec193801792$export$e7094788287c5e9b.create(t, e.op);
    return n = $2fa92ec193801792$var$__PRIVATE_applyAssociation(n), $2fa92ec193801792$var$__PRIVATE_isDisjunctiveNormalForm(n) ? n : ($2fa92ec193801792$var$__PRIVATE_hardAssert(n instanceof $2fa92ec193801792$export$e7094788287c5e9b, 64498), $2fa92ec193801792$var$__PRIVATE_hardAssert($2fa92ec193801792$var$__PRIVATE_compositeFilterIsConjunction(n), 40251), $2fa92ec193801792$var$__PRIVATE_hardAssert(n.filters.length > 1, 57927), n.filters.reduce((e, t)=>$2fa92ec193801792$var$__PRIVATE_applyDistribution(e, t)));
}
function $2fa92ec193801792$var$__PRIVATE_applyDistribution(e, t) {
    let n;
    return $2fa92ec193801792$var$__PRIVATE_hardAssert(e instanceof $2fa92ec193801792$export$d66501df72047452 || e instanceof $2fa92ec193801792$export$e7094788287c5e9b, 38388), $2fa92ec193801792$var$__PRIVATE_hardAssert(t instanceof $2fa92ec193801792$export$d66501df72047452 || t instanceof $2fa92ec193801792$export$e7094788287c5e9b, 25473), // FieldFilter FieldFilter
    n = e instanceof $2fa92ec193801792$export$d66501df72047452 ? t instanceof $2fa92ec193801792$export$d66501df72047452 ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return $2fa92ec193801792$export$e7094788287c5e9b.create([
            e,
            t
        ], "and" /* CompositeOperator.AND */ );
    }(e, t) : $2fa92ec193801792$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof $2fa92ec193801792$export$d66501df72047452 ? $2fa92ec193801792$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if ($2fa92ec193801792$var$__PRIVATE_hardAssert(e.filters.length > 0 && t.filters.length > 0, 48005), $2fa92ec193801792$var$__PRIVATE_compositeFilterIsConjunction(e) && $2fa92ec193801792$var$__PRIVATE_compositeFilterIsConjunction(t)) return $2fa92ec193801792$var$__PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        const n = $2fa92ec193801792$var$__PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = $2fa92ec193801792$var$__PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map((e)=>$2fa92ec193801792$var$__PRIVATE_applyDistribution(e, r));
        return $2fa92ec193801792$export$e7094788287c5e9b.create(i, "or" /* CompositeOperator.OR */ );
    }(e, t), $2fa92ec193801792$var$__PRIVATE_applyAssociation(n);
}
function $2fa92ec193801792$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if ($2fa92ec193801792$var$__PRIVATE_compositeFilterIsConjunction(t)) // Case 1
    return $2fa92ec193801792$var$__PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        const n = t.filters.map((t)=>$2fa92ec193801792$var$__PRIVATE_applyDistribution(e, t));
        return $2fa92ec193801792$export$e7094788287c5e9b.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function $2fa92ec193801792$var$__PRIVATE_applyAssociation(e) {
    if ($2fa92ec193801792$var$__PRIVATE_hardAssert(e instanceof $2fa92ec193801792$export$d66501df72047452 || e instanceof $2fa92ec193801792$export$e7094788287c5e9b, 11850), e instanceof $2fa92ec193801792$export$d66501df72047452) return e;
    const t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === t.length) return $2fa92ec193801792$var$__PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
    if ($2fa92ec193801792$var$__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    const n = t.map((e)=>$2fa92ec193801792$var$__PRIVATE_applyAssociation(e)), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach((t)=>{
        t instanceof $2fa92ec193801792$export$d66501df72047452 ? r.push(t) : t instanceof $2fa92ec193801792$export$e7094788287c5e9b && (t.op === e.op ? // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        r.push(...t.filters) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    }), 1 === r.length ? r[0] : $2fa92ec193801792$export$e7094788287c5e9b.create(r, e.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class $2fa92ec193801792$var$__PRIVATE_MemoryIndexManager {
    constructor(){
        this.Yi = new $2fa92ec193801792$var$__PRIVATE_MemoryCollectionParentIndex;
    }
    addToCollectionParentIndex(e, t) {
        return this.Yi.add(t), $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        return $2fa92ec193801792$var$PersistencePromise.resolve(this.Yi.getEntries(t));
    }
    addFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    deleteFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    deleteAllFieldIndexes(e) {
        // Field indices are not supported with memory persistence.
        return $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    createTargetIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    getDocumentsMatchingTarget(e, t) {
        // Field indices are not supported with memory persistence.
        return $2fa92ec193801792$var$PersistencePromise.resolve(null);
    }
    getIndexType(e, t) {
        // Field indices are not supported with memory persistence.
        return $2fa92ec193801792$var$PersistencePromise.resolve(0 /* IndexType.NONE */ );
    }
    getFieldIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $2fa92ec193801792$var$PersistencePromise.resolve([]);
    }
    getNextCollectionGroupToUpdate(e) {
        // Field indices are not supported with memory persistence.
        return $2fa92ec193801792$var$PersistencePromise.resolve(null);
    }
    getMinOffset(e, t) {
        return $2fa92ec193801792$var$PersistencePromise.resolve($2fa92ec193801792$var$IndexOffset.min());
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return $2fa92ec193801792$var$PersistencePromise.resolve($2fa92ec193801792$var$IndexOffset.min());
    }
    updateCollectionGroup(e, t, n) {
        // Field indices are not supported with memory persistence.
        return $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    updateIndexEntries(e, t) {
        // Field indices are not supported with memory persistence.
        return $2fa92ec193801792$var$PersistencePromise.resolve();
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class $2fa92ec193801792$var$__PRIVATE_MemoryCollectionParentIndex {
    constructor(){
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$export$db202ddc8be9136.comparator), i = !r.has(n);
        return this.index[t] = r.add(n), i;
    }
    has(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t];
        return r && r.has(n);
    }
    getEntries(e) {
        return (this.index[e] || new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$export$db202ddc8be9136.comparator)).toArray();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$rr = "IndexedDbIndexManager", $2fa92ec193801792$var$ir = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class $2fa92ec193801792$var$__PRIVATE_IndexedDbIndexManager {
    constructor(e, t){
        this.databaseId = t, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.Zi = new $2fa92ec193801792$var$__PRIVATE_MemoryCollectionParentIndex, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.Xi = new $2fa92ec193801792$var$ObjectMap((e)=>$2fa92ec193801792$var$__PRIVATE_canonifyTarget(e), (e, t)=>$2fa92ec193801792$var$__PRIVATE_targetEquals(e, t)), this.uid = e.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(e, t) {
        if (!this.Zi.has(t)) {
            const n = t.lastSegment(), r = t.popLast();
            e.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.Zi.add(t);
            });
            const i = {
                collectionId: n,
                parent: $2fa92ec193801792$var$__PRIVATE_encodeResourcePath(r)
            };
            return $2fa92ec193801792$var$__PRIVATE_collectionParentsStore(e).put(i);
        }
        return $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        const n = [], r = IDBKeyRange.bound([
            t,
            ""
        ], [
            $2fa92ec193801792$var$__PRIVATE_immediateSuccessor(t),
            ""
        ], /*lowerOpen=*/ false, /*upperOpen=*/ true);
        return $2fa92ec193801792$var$__PRIVATE_collectionParentsStore(e).Kn(r).next((e)=>{
            for (const r of e){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (r.collectionId !== t) break;
                n.push($2fa92ec193801792$var$__PRIVATE_decodeResourcePath(r.parent));
            }
            return n;
        });
    }
    addFieldIndex(e, t) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = $2fa92ec193801792$var$__PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
            return {
                indexId: e.indexId,
                collectionGroup: e.collectionGroup,
                fields: e.fields.map((e)=>[
                        e.fieldPath.canonicalString(),
                        e.kind
                    ])
            };
        }(t);
        delete r.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(r);
        if (t.indexState) {
            const n = $2fa92ec193801792$var$__PRIVATE_indexStateStore(e);
            return i.next((e)=>{
                n.put($2fa92ec193801792$var$__PRIVATE_toDbIndexState(e, this.uid, t.indexState.sequenceNumber, t.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_indexConfigurationStore(e), r = $2fa92ec193801792$var$__PRIVATE_indexStateStore(e), i = $2fa92ec193801792$var$__PRIVATE_indexEntriesStore(e);
        return n.delete(t.indexId).next(()=>r.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ false, /*upperOpen=*/ true))).next(()=>i.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ false, /*upperOpen=*/ true)));
    }
    deleteAllFieldIndexes(e) {
        const t = $2fa92ec193801792$var$__PRIVATE_indexConfigurationStore(e), n = $2fa92ec193801792$var$__PRIVATE_indexEntriesStore(e), r = $2fa92ec193801792$var$__PRIVATE_indexStateStore(e);
        return t.Gn().next(()=>n.Gn()).next(()=>r.Gn());
    }
    createTargetIndexes(e, t) {
        return $2fa92ec193801792$var$PersistencePromise.forEach(this.es(t), (t)=>this.getIndexType(e, t).next((n)=>{
                if (0 /* IndexType.NONE */  === n || 1 /* IndexType.PARTIAL */  === n) {
                    const n = new $2fa92ec193801792$var$__PRIVATE_TargetIndexMatcher(t).Ji();
                    if (null != n) return this.addFieldIndex(e, n);
                }
            }));
    }
    getDocumentsMatchingTarget(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_indexEntriesStore(e);
        let r = true;
        const i = new Map;
        return $2fa92ec193801792$var$PersistencePromise.forEach(this.es(t), (t)=>this.ts(e, t).next((e)=>{
                r && (r = !!e), i.set(t, e);
            })).next(()=>{
            if (r) {
                let e = $2fa92ec193801792$export$a9c996f45e5784d0();
                const r = [];
                return $2fa92ec193801792$var$PersistencePromise.forEach(i, (i, s)=>{
                    $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$rr, `Using index ${function __PRIVATE_fieldIndexToString(e) {
                        return `id=${e.indexId}|cg=${e.collectionGroup}|f=${e.fields.map((e)=>`${e.fieldPath}:${e.kind}`).join(",")}`;
                    }(i)} to execute ${$2fa92ec193801792$var$__PRIVATE_canonifyTarget(t)}`);
                    const _ = function __PRIVATE_targetGetArrayValues(e, t) {
                        const n = $2fa92ec193801792$var$__PRIVATE_fieldIndexGetArraySegment(t);
                        if (void 0 === n) return null;
                        for (const t of $2fa92ec193801792$var$__PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath))switch(t.op){
                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                return t.value.arrayValue.values || [];
                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                return [
                                    t.value
                                ];
                        }
                        return null;
                    }(s, i), o = function __PRIVATE_targetGetNotInValues(e, t) {
                        const n = new Map;
                        for (const r of $2fa92ec193801792$var$__PRIVATE_fieldIndexGetDirectionalSegments(t))for (const t of $2fa92ec193801792$var$__PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath))switch(t.op){
                            case "==" /* Operator.EQUAL */ :
                            case "in" /* Operator.IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(r.fieldPath.canonicalString(), t.value);
                                break;
                            case "not-in" /* Operator.NOT_IN */ :
                            case "!=" /* Operator.NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(r.fieldPath.canonicalString(), t.value), Array.from(n.values());
                        }
                        return null;
                    }(s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                        const n = [];
                        let r = true;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of $2fa92ec193801792$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $2fa92ec193801792$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.startAt) : $2fa92ec193801792$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.startAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $2fa92ec193801792$export$3b513254972cfc9c(n, r);
                    }(s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                        const n = [];
                        let r = true;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of $2fa92ec193801792$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $2fa92ec193801792$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.endAt) : $2fa92ec193801792$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.endAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $2fa92ec193801792$export$3b513254972cfc9c(n, r);
                    }(s, i), c = this.ns(i, s, a), l = this.ns(i, s, u), E = this.rs(i, s, o), h = this.ss(i.indexId, _, c, a.inclusive, l, u.inclusive, E);
                    return $2fa92ec193801792$var$PersistencePromise.forEach(h, (i)=>n.Qn(i, t.limit).next((t)=>{
                            t.forEach((t)=>{
                                const n = $2fa92ec193801792$export$a07804094c3ecf2d.fromSegments(t.documentKey);
                                e.has(n) || (e = e.add(n), r.push(n));
                            });
                        }));
                }).next(()=>r);
            }
            return $2fa92ec193801792$var$PersistencePromise.resolve(null);
        });
    }
    es(e) {
        let t = this.Xi.get(e);
        if (t) return t;
        if (0 === e.filters.length) t = [
            e
        ];
        else t = $2fa92ec193801792$var$__PRIVATE_getDnfTerms($2fa92ec193801792$export$e7094788287c5e9b.create(e.filters, "and" /* CompositeOperator.AND */ )).map((t)=>$2fa92ec193801792$var$__PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt));
        return this.Xi.set(e, t), t;
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ ss(e, t, n, r, i, s, _) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const o = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = o / (null != t ? t.length : 1), u = [];
        for(let c = 0; c < o; ++c){
            const o = t ? this._s(t[c / a]) : $2fa92ec193801792$var$ir, l = this.us(e, o, n[c % a], r), E = this.cs(e, o, i[c % a], s), h = _.map((t)=>this.us(e, o, t, /* inclusive= */ true));
            u.push(...this.createRange(l, E, h));
        }
        return u;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ us(e, t, n, r) {
        const i = new $2fa92ec193801792$var$__PRIVATE_IndexEntry(e, $2fa92ec193801792$export$a07804094c3ecf2d.empty(), t, n);
        return r ? i : i.Ui();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ cs(e, t, n, r) {
        const i = new $2fa92ec193801792$var$__PRIVATE_IndexEntry(e, $2fa92ec193801792$export$a07804094c3ecf2d.empty(), t, n);
        return r ? i.Ui() : i;
    }
    ts(e, t) {
        const n = new $2fa92ec193801792$var$__PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
        return this.getFieldIndexes(e, r).next((e)=>{
            // Return the index with the most number of segments.
            let t = null;
            for (const r of e)n.Gi(r) && (!t || r.fields.length > t.fields.length) && (t = r);
            return t;
        });
    }
    getIndexType(e, t) {
        let n = 2 /* IndexType.FULL */ ;
        const r = this.es(t);
        return $2fa92ec193801792$var$PersistencePromise.forEach(r, (t)=>this.ts(e, t).next((e)=>{
                e ? 0 /* IndexType.NONE */  !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                    let t = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$export$b9a6b53f9be3734.comparator), n = false;
                    for (const r of e.filters)for (const e of r.getFlattenedFilters())// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    e.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                    // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                    // though these are on the same field, they should be counted as two
                    // separate segments in an index.
                    ("array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op ? n = true : t = t.add(e.field));
                    for (const n of e.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (t = t.add(n.field));
                    return t.size + (n ? 1 : 0);
                }(t) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
            })).next(()=>// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
            // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
            // and apply the limit in memory as a post-processing step.
            (function __PRIVATE_targetHasLimit(e) {
                return null !== e.limit;
            })(t) && r.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ ls(e, t) {
        const n = new $2fa92ec193801792$var$__PRIVATE_IndexByteEncoder;
        for (const r of $2fa92ec193801792$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = t.data.field(r.fieldPath);
            if (null == e) return null;
            const i = n.Oi(r.kind);
            $2fa92ec193801792$var$__PRIVATE_FirestoreIndexValueWriter.Ti.Xr(e, i);
        }
        return n.Ci();
    }
    /** Encodes a single value to the ascending index format. */ _s(e) {
        const t = new $2fa92ec193801792$var$__PRIVATE_IndexByteEncoder;
        return $2fa92ec193801792$var$__PRIVATE_FirestoreIndexValueWriter.Ti.Xr(e, t.Oi(0 /* IndexKind.ASCENDING */ )), t.Ci();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ Es(e, t) {
        const n = new $2fa92ec193801792$var$__PRIVATE_IndexByteEncoder;
        return $2fa92ec193801792$var$__PRIVATE_FirestoreIndexValueWriter.Ti.Xr($2fa92ec193801792$export$995eb9fca571757(this.databaseId, t), n.Oi(function __PRIVATE_fieldIndexGetKeyOrder(e) {
            const t = $2fa92ec193801792$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
            return 0 === t.length ? 0 /* IndexKind.ASCENDING */  : t[t.length - 1].kind;
        }(e))), n.Ci();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ rs(e, t, n) {
        if (null === n) return [];
        let r = [];
        r.push(new $2fa92ec193801792$var$__PRIVATE_IndexByteEncoder);
        let i = 0;
        for (const s of $2fa92ec193801792$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = n[i++];
            for (const n of r)if (this.hs(t, s.fieldPath) && $2fa92ec193801792$var$isArray(e)) r = this.Ts(r, s, e);
            else {
                const t = n.Oi(s.kind);
                $2fa92ec193801792$var$__PRIVATE_FirestoreIndexValueWriter.Ti.Xr(e, t);
            }
        }
        return this.Ps(r);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ ns(e, t, n) {
        return this.rs(e, t, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ Ps(e) {
        const t = [];
        for(let n = 0; n < e.length; ++n)t[n] = e[n].Ci();
        return t;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ Ts(e, t, n) {
        const r = [
            ...e
        ], i = [];
        for (const e of n.arrayValue.values || [])for (const n of r){
            const r = new $2fa92ec193801792$var$__PRIVATE_IndexByteEncoder;
            r.seed(n.Ci()), $2fa92ec193801792$var$__PRIVATE_FirestoreIndexValueWriter.Ti.Xr(e, r.Oi(t.kind)), i.push(r);
        }
        return i;
    }
    hs(e, t) {
        return !!e.filters.find((e)=>e instanceof $2fa92ec193801792$export$d66501df72047452 && e.field.isEqual(t) && ("in" /* Operator.IN */  === e.op || "not-in" /* Operator.NOT_IN */  === e.op));
    }
    getFieldIndexes(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_indexConfigurationStore(e), r = $2fa92ec193801792$var$__PRIVATE_indexStateStore(e);
        return (t ? n.Kn($2fa92ec193801792$var$Dn, IDBKeyRange.bound(t, t)) : n.Kn()).next((e)=>{
            const t = [];
            return $2fa92ec193801792$var$PersistencePromise.forEach(e, (e)=>r.get([
                    e.indexId,
                    this.uid
                ]).next((n)=>{
                    t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                        const n = t ? new $2fa92ec193801792$export$f787f51d84a910ad(t.sequenceNumber, new $2fa92ec193801792$var$IndexOffset($2fa92ec193801792$var$__PRIVATE_fromDbTimestamp(t.readTime), new $2fa92ec193801792$export$a07804094c3ecf2d($2fa92ec193801792$var$__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : $2fa92ec193801792$export$f787f51d84a910ad.empty(), r = e.fields.map(([e, t])=>new $2fa92ec193801792$export$2219238a014317b0($2fa92ec193801792$export$b9a6b53f9be3734.fromServerFormat(e), t));
                        return new $2fa92ec193801792$export$4c3d22f3d993c33f(e.indexId, e.collectionGroup, r, n);
                    }(e, n));
                })).next(()=>t);
        });
    }
    getNextCollectionGroupToUpdate(e) {
        return this.getFieldIndexes(e).next((e)=>0 === e.length ? null : (e.sort((e, t)=>{
                const n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
                return 0 !== n ? n : $2fa92ec193801792$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
            }), e[0].collectionGroup));
    }
    updateCollectionGroup(e, t, n) {
        const r = $2fa92ec193801792$var$__PRIVATE_indexConfigurationStore(e), i = $2fa92ec193801792$var$__PRIVATE_indexStateStore(e);
        return this.Rs(e).next((e)=>r.Kn($2fa92ec193801792$var$Dn, IDBKeyRange.bound(t, t)).next((t)=>$2fa92ec193801792$var$PersistencePromise.forEach(t, (t)=>i.put($2fa92ec193801792$var$__PRIVATE_toDbIndexState(t.indexId, this.uid, e, n)))));
    }
    updateIndexEntries(e, t) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return $2fa92ec193801792$var$PersistencePromise.forEach(t, (t, r)=>{
            const i = n.get(t.collectionGroup);
            return (i ? $2fa92ec193801792$var$PersistencePromise.resolve(i) : this.getFieldIndexes(e, t.collectionGroup)).next((i)=>(n.set(t.collectionGroup, i), $2fa92ec193801792$var$PersistencePromise.forEach(i, (n)=>this.Is(e, t, n).next((t)=>{
                        const i = this.As(r, n);
                        return t.isEqual(i) ? $2fa92ec193801792$var$PersistencePromise.resolve() : this.Vs(e, r, n, t, i);
                    }))));
        });
    }
    ds(e, t, n, r) {
        return $2fa92ec193801792$var$__PRIVATE_indexEntriesStore(e).put(r.ki(this.uid, this.Es(n, t.key), t.key));
    }
    fs(e, t, n, r) {
        return $2fa92ec193801792$var$__PRIVATE_indexEntriesStore(e).delete(r.qi(this.uid, this.Es(n, t.key), t.key));
    }
    Is(e, t, n) {
        const r = $2fa92ec193801792$var$__PRIVATE_indexEntriesStore(e);
        let i = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$var$__PRIVATE_indexEntryComparator);
        return r.jn({
            index: $2fa92ec193801792$var$Bn,
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                $2fa92ec193801792$var$__PRIVATE_encodeKeySafeBytes(this.Es(n, t))
            ])
        }, (e, r)=>{
            i = i.add(new $2fa92ec193801792$var$__PRIVATE_IndexEntry(n.indexId, t, $2fa92ec193801792$var$__PRIVATE_decodeKeySafeBytes(r.arrayValue), $2fa92ec193801792$var$__PRIVATE_decodeKeySafeBytes(r.directionalValue)));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ As(e, t) {
        let n = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$var$__PRIVATE_indexEntryComparator);
        const r = this.ls(t, e);
        if (null == r) return n;
        const i = $2fa92ec193801792$var$__PRIVATE_fieldIndexGetArraySegment(t);
        if (null != i) {
            const s = e.data.field(i.fieldPath);
            if ($2fa92ec193801792$var$isArray(s)) for (const i of s.arrayValue.values || [])n = n.add(new $2fa92ec193801792$var$__PRIVATE_IndexEntry(t.indexId, e.key, this._s(i), r));
        } else n = n.add(new $2fa92ec193801792$var$__PRIVATE_IndexEntry(t.indexId, e.key, $2fa92ec193801792$var$ir, r));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ Vs(e, t, n, r, i) {
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$rr, "Updating index entries for document '%s'", t.key);
        const s = [];
        return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
            const s = e.getIterator(), _ = t.getIterator();
            let o = $2fa92ec193801792$var$__PRIVATE_advanceIterator(s), a = $2fa92ec193801792$var$__PRIVATE_advanceIterator(_);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; o || a;){
                let e = false, t = false;
                if (o && a) {
                    const r = n(o, a);
                    r < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    t = true : r > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (e = true);
                } else null != o ? t = true : e = true;
                e ? (r(a), a = $2fa92ec193801792$var$__PRIVATE_advanceIterator(_)) : t ? (i(o), o = $2fa92ec193801792$var$__PRIVATE_advanceIterator(s)) : (o = $2fa92ec193801792$var$__PRIVATE_advanceIterator(s), a = $2fa92ec193801792$var$__PRIVATE_advanceIterator(_));
            }
        }(r, i, $2fa92ec193801792$var$__PRIVATE_indexEntryComparator, /* onAdd= */ (r)=>{
            s.push(this.ds(e, t, n, r));
        }, /* onRemove= */ (r)=>{
            s.push(this.fs(e, t, n, r));
        }), $2fa92ec193801792$var$PersistencePromise.waitFor(s);
    }
    Rs(e) {
        let t = 1;
        return $2fa92ec193801792$var$__PRIVATE_indexStateStore(e).jn({
            index: $2fa92ec193801792$var$On,
            reverse: true,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (e, n, r)=>{
            r.done(), t = n.sequenceNumber + 1;
        }).next(()=>t);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(e, t, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((e, t)=>$2fa92ec193801792$var$__PRIVATE_indexEntryComparator(e, t)).filter((e, t, n)=>!t || 0 !== $2fa92ec193801792$var$__PRIVATE_indexEntryComparator(e, n[t - 1]));
        const r = [];
        r.push(e);
        for (const i of n){
            const n = $2fa92ec193801792$var$__PRIVATE_indexEntryComparator(i, e), s = $2fa92ec193801792$var$__PRIVATE_indexEntryComparator(i, t);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            r[0] = e.Ui();
            else if (n > 0 && s < 0) // `notInValue` is in the middle of the range
            r.push(i), r.push(i.Ui());
            else if (s > 0) break;
        }
        r.push(t);
        const i = [];
        for(let e = 0; e < r.length; e += 2){
            // If we encounter two bounds that will create an unmatchable key range,
            // then we return an empty set of key ranges.
            if (this.ps(r[e], r[e + 1])) return [];
            const t = r[e].qi(this.uid, $2fa92ec193801792$var$ir, $2fa92ec193801792$export$a07804094c3ecf2d.empty()), n = r[e + 1].qi(this.uid, $2fa92ec193801792$var$ir, $2fa92ec193801792$export$a07804094c3ecf2d.empty());
            i.push(IDBKeyRange.bound(t, n));
        }
        return i;
    }
    ps(e, t) {
        // If lower bound is greater than the upper bound, then the key
        // range can never be matched.
        return $2fa92ec193801792$var$__PRIVATE_indexEntryComparator(e, t) > 0;
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return this.getFieldIndexes(e, t).next($2fa92ec193801792$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
    getMinOffset(e, t) {
        return $2fa92ec193801792$var$PersistencePromise.mapArray(this.es(t), (t)=>this.ts(e, t).next((e)=>e || $2fa92ec193801792$export$1a82df3d29112e01(44426))).next($2fa92ec193801792$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $2fa92ec193801792$var$__PRIVATE_collectionParentsStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$dn);
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $2fa92ec193801792$var$__PRIVATE_indexEntriesStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$Nn);
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $2fa92ec193801792$var$__PRIVATE_indexConfigurationStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$vn);
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $2fa92ec193801792$var$__PRIVATE_indexStateStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$Cn);
}
function $2fa92ec193801792$var$__PRIVATE_getMinOffsetFromFieldIndexes(e) {
    $2fa92ec193801792$var$__PRIVATE_hardAssert(0 !== e.length, 28825);
    let t = e[0].indexState.offset, n = t.largestBatchId;
    for(let r = 1; r < e.length; r++){
        const i = e[r].indexState.offset;
        $2fa92ec193801792$var$__PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $2fa92ec193801792$var$IndexOffset(t.readTime, t.documentKey, n);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class $2fa92ec193801792$var$__PRIVATE_TargetIdGenerator {
    constructor(e){
        this.gs = e;
    }
    next() {
        return this.gs += 2, this.gs;
    }
    static ys() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new $2fa92ec193801792$var$__PRIVATE_TargetIdGenerator(0);
    }
    static ws() {
        // Sync engine assigns target IDs for limbo document detection.
        return new $2fa92ec193801792$var$__PRIVATE_TargetIdGenerator(-1);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$var$__PRIVATE_IndexedDbTargetCache {
    constructor(e, t){
        this.referenceDelegate = e, this.serializer = t;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(e) {
        return this.bs(e).next((t)=>{
            const n = new $2fa92ec193801792$var$__PRIVATE_TargetIdGenerator(t.highestTargetId);
            return t.highestTargetId = n.next(), this.vs(e, t).next(()=>t.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(e) {
        return this.bs(e).next((e)=>$2fa92ec193801792$var$SnapshotVersion.fromTimestamp(new $2fa92ec193801792$export$890c4ad488842ce7(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(e) {
        return this.bs(e).next((e)=>e.highestListenSequenceNumber);
    }
    setTargetsMetadata(e, t, n) {
        return this.bs(e).next((r)=>(r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), this.vs(e, r)));
    }
    addTargetData(e, t) {
        return this.Ss(e, t).next(()=>this.bs(e).next((n)=>(n.targetCount += 1, this.Ds(t, n), this.vs(e, n))));
    }
    updateTargetData(e, t) {
        return this.Ss(e, t);
    }
    removeTargetData(e, t) {
        return this.removeMatchingKeysForTargetId(e, t.targetId).next(()=>$2fa92ec193801792$var$__PRIVATE_targetsStore(e).delete(t.targetId)).next(()=>this.bs(e)).next((t)=>($2fa92ec193801792$var$__PRIVATE_hardAssert(t.targetCount > 0, 8065), t.targetCount -= 1, this.vs(e, t)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return $2fa92ec193801792$var$__PRIVATE_targetsStore(e).jn((s, _)=>{
            const o = $2fa92ec193801792$var$__PRIVATE_fromDbTarget(this.serializer, _);
            o.sequenceNumber <= t && null === n.get(o.targetId) && (r++, i.push(this.removeTargetData(e, o)));
        }).next(()=>$2fa92ec193801792$var$PersistencePromise.waitFor(i)).next(()=>r);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_targetsStore(e).jn((e, n)=>{
            const r = $2fa92ec193801792$var$__PRIVATE_fromDbTarget(this.serializer, n);
            t(r);
        });
    }
    bs(e) {
        return $2fa92ec193801792$var$__PRIVATE_globalTargetStore(e).get($2fa92ec193801792$var$An).next((e)=>($2fa92ec193801792$var$__PRIVATE_hardAssert(null !== e, 2888), e));
    }
    vs(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_globalTargetStore(e).put($2fa92ec193801792$var$An, t);
    }
    Ss(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_targetsStore(e).put($2fa92ec193801792$var$__PRIVATE_toDbTarget(this.serializer, t));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ Ds(e, t) {
        let n = false;
        return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = true), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = true), n;
    }
    getTargetCount(e) {
        return this.bs(e).next((e)=>e.targetCount);
    }
    getTargetData(e, t) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = $2fa92ec193801792$var$__PRIVATE_canonifyTargetOrPipeline(t), r = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return $2fa92ec193801792$var$__PRIVATE_targetsStore(e).jn({
            range: r,
            index: $2fa92ec193801792$var$En
        }, (e, n, r)=>{
            const s = $2fa92ec193801792$var$__PRIVATE_fromDbTarget(this.serializer, n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $2fa92ec193801792$var$__PRIVATE_targetOrPipelineEqual(t, s.target) && (i = s, r.done());
        }).next(()=>i);
    }
    addMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = [], i = $2fa92ec193801792$var$__PRIVATE_documentTargetStore(e);
        return t.forEach((t)=>{
            const s = $2fa92ec193801792$var$__PRIVATE_encodeResourcePath(t.path);
            r.push(i.put({
                targetId: n,
                path: s
            })), r.push(this.referenceDelegate.addReference(e, n, t));
        }), $2fa92ec193801792$var$PersistencePromise.waitFor(r);
    }
    removeMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = $2fa92ec193801792$var$__PRIVATE_documentTargetStore(e);
        return $2fa92ec193801792$var$PersistencePromise.forEach(t, (t)=>{
            const i = $2fa92ec193801792$var$__PRIVATE_encodeResourcePath(t.path);
            return $2fa92ec193801792$var$PersistencePromise.waitFor([
                r.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(e, n, t)
            ]);
        });
    }
    removeMatchingKeysForTargetId(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ false, /*upperOpen=*/ true);
        return n.delete(r);
    }
    getMatchingKeysForTargetId(e, t) {
        const n = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ false, /*upperOpen=*/ true), r = $2fa92ec193801792$var$__PRIVATE_documentTargetStore(e);
        let i = $2fa92ec193801792$export$a9c996f45e5784d0();
        return r.jn({
            range: n,
            zn: true
        }, (e, t, n)=>{
            const r = $2fa92ec193801792$var$__PRIVATE_decodeResourcePath(e[1]), s = new $2fa92ec193801792$export$a07804094c3ecf2d(r);
            i = i.add(s);
        }).next(()=>i);
    }
    containsKey(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([
            n
        ], [
            $2fa92ec193801792$var$__PRIVATE_immediateSuccessor(n)
        ], /*lowerOpen=*/ false, /*upperOpen=*/ true);
        let i = 0;
        return $2fa92ec193801792$var$__PRIVATE_documentTargetStore(e).jn({
            index: $2fa92ec193801792$var$Rn,
            zn: true,
            range: r
        }, ([e, t], n, r)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== e && (i++, r.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    ge(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_targetsStore(e).get(t).next((e)=>e ? $2fa92ec193801792$var$__PRIVATE_fromDbTarget(this.serializer, e) : null);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $2fa92ec193801792$var$__PRIVATE_targetsStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$cn);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $2fa92ec193801792$var$__PRIVATE_globalTargetStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$Vn);
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $2fa92ec193801792$var$__PRIVATE_documentTargetStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$Tn);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class $2fa92ec193801792$var$__PRIVATE_IndexedDbLruDelegateImpl {
    constructor(e, t){
        this.db = e, this.garbageCollector = $2fa92ec193801792$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    rr(e) {
        const t = this.xs(e);
        return this.db.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    xs(e) {
        let t = 0;
        return this.ir(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    forEachTarget(e, t) {
        return this.db.getTargetCache().forEachTarget(e, t);
    }
    ir(e, t) {
        return this.Cs(e, (e, n)=>t(n));
    }
    addReference(e, t, n) {
        return $2fa92ec193801792$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeReference(e, t, n) {
        return $2fa92ec193801792$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeTargets(e, t, n) {
        return this.db.getTargetCache().removeTargets(e, t, n);
    }
    markPotentiallyOrphaned(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ Fs(e, t) {
        return function __PRIVATE_mutationQueuesContainKey(e, t) {
            let n = false;
            return $2fa92ec193801792$var$__PRIVATE_mutationQueuesStore(e).Hn((r)=>$2fa92ec193801792$var$__PRIVATE_mutationQueueContainsKey(e, r, t).next((e)=>(e && (n = true), $2fa92ec193801792$var$PersistencePromise.resolve(!e)))).next(()=>n);
        }(e, t);
    }
    removeOrphanedDocuments(e, t) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
        let i = 0;
        return this.Cs(e, (s, _)=>{
            if (_ <= t) {
                const t = this.Fs(e, s).next((t)=>{
                    if (!t) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(e, s).next(()=>(n.removeEntry(s, $2fa92ec193801792$var$SnapshotVersion.min()), $2fa92ec193801792$var$__PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                            return [
                                0,
                                $2fa92ec193801792$var$__PRIVATE_encodeResourcePath(e.path)
                            ];
                        }(s))));
                });
                r.push(t);
            }
        }).next(()=>$2fa92ec193801792$var$PersistencePromise.waitFor(r)).next(()=>n.apply(e)).next(()=>i);
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(e, n);
    }
    updateLimboDocument(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ Cs(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_documentTargetStore(e);
        let r, i = $2fa92ec193801792$var$__PRIVATE_ListenSequence.yn;
        return n.jn({
            index: $2fa92ec193801792$var$Rn
        }, ([e, n], { path: s, sequenceNumber: _ })=>{
            0 === e ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $2fa92ec193801792$var$__PRIVATE_ListenSequence.yn && t(new $2fa92ec193801792$export$a07804094c3ecf2d($2fa92ec193801792$var$__PRIVATE_decodeResourcePath(r)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = _, r = s) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $2fa92ec193801792$var$__PRIVATE_ListenSequence.yn;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $2fa92ec193801792$var$__PRIVATE_ListenSequence.yn && t(new $2fa92ec193801792$export$a07804094c3ecf2d($2fa92ec193801792$var$__PRIVATE_decodeResourcePath(r)), i);
        });
    }
    getCacheSize(e) {
        return this.db.getRemoteDocumentCache().getSize(e);
    }
}
function $2fa92ec193801792$var$__PRIVATE_writeSentinelKey(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: $2fa92ec193801792$var$__PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}
// Copyright 2024 Google LLC* @license
// Copyright 2024 Google LLC
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//      http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function $2fa92ec193801792$var$__PRIVATE_runPipeline(e, t) {
    let n = t;
    for (const t of e.stages)n = $2fa92ec193801792$var$evaluate({
        serializer: e.serializer,
        serverTimestampBehavior: e.listenOptions?.serverTimestampBehavior
    }, t, n);
    return n;
}
function $2fa92ec193801792$var$__PRIVATE_pipelineMatches(e, t) {
    // TODO(pipeline): this is not true for aggregations, and we need to examine if there are other
    // stages that will not work this way.
    return $2fa92ec193801792$var$__PRIVATE_runPipeline(e, [
        t
    ]).length > 0;
}
function $2fa92ec193801792$var$__PRIVATE_queryOrPipelineMatches(e, t) {
    return $2fa92ec193801792$export$342063e11d6c3cad(e) ? $2fa92ec193801792$var$__PRIVATE_pipelineMatches(e, t) : $2fa92ec193801792$var$__PRIVATE_queryMatches(e, t);
}
function $2fa92ec193801792$var$evaluate(e, t, n) {
    if (t instanceof $2fa92ec193801792$export$c5d1328b37d47994) return function __PRIVATE_evaluateCollection(e, t, n) {
        return n.filter((e)=>e.isFoundDocument() && `/${e.key.getCollectionPath().canonicalString()}` === t.Er);
    }(0, t, n);
    if (t instanceof $2fa92ec193801792$export$4b170465d7badfa1) return function __PRIVATE_evaluateWhere(e, t, n) {
        return n.filter((n)=>{
            const r = $2fa92ec193801792$var$__PRIVATE_valueOrUndefined($2fa92ec193801792$var$__PRIVATE_toEvaluable(t.condition).evaluate(e, n));
            return void 0 !== r && $2fa92ec193801792$var$__PRIVATE_valueEquals$1(r, $2fa92ec193801792$var$Je);
        });
    }(e, t, n);
    if (t instanceof $2fa92ec193801792$export$d22783b3c2400a3a) return function __PRIVATE_evaluateCollectionGroup(e, t, n) {
        // return those records in input whose collection id is stage.collectionId
        return n.filter((e)=>e.isFoundDocument() && e.key.getCollectionPath().lastSegment() === t.collectionId);
    }(0, t, n);
    if (t instanceof $2fa92ec193801792$export$7f557e5eb95176c2) return function __PRIVATE_evaluateDatabase(e, t, n) {
        return n.filter((e)=>e.isFoundDocument());
    }(0, 0, n);
    if (t instanceof $2fa92ec193801792$export$51b138e5a065c2bb) return function __PRIVATE_evaluateDocuments(e, t, n) {
        return n.filter((e)=>e.isFoundDocument() && t.Tr.has(e.key.path.toStringWithLeadingSlash()));
    }(0, t, n);
    if (t instanceof $2fa92ec193801792$export$56350196709588fc) return function __PRIVATE_evaluateLimit(e, t, n) {
        return n.slice(0, t.limit);
    }(0, t, n);
    if (t instanceof $2fa92ec193801792$export$b2bcef12bcefba04) return function __PRIVATE_evaluateSort(e, t, n) {
        const r = t.orderings.map((e)=>({
                Os: $2fa92ec193801792$var$__PRIVATE_toEvaluable(e.expr),
                direction: e.direction
            }));
        return [
            ...n
        ].sort((t, n)=>{
            // Evaluate expressions in stage.orderings against left and right, and use them to compare
            // the documents
            for (const { Os: i, direction: s } of r){
                const r = $2fa92ec193801792$var$__PRIVATE_valueOrUndefined(i.evaluate(e, t)), _ = $2fa92ec193801792$var$__PRIVATE_valueOrUndefined(i.evaluate(e, n)), o = $2fa92ec193801792$var$__PRIVATE_valueCompare(r ?? $2fa92ec193801792$var$He, _ ?? $2fa92ec193801792$var$He);
                if (0 !== o) // Return the comparison result if documents are not equal
                return "ascending" === s ? o : -o;
            }
            return 0;
        });
    }(e, t, n);
    throw new Error(`Unknown stage: ${t._name}`);
}
function $2fa92ec193801792$export$953cecd6e717a553(e) {
    const t = function __PRIVATE_lastEffectiveSort(e) {
        // return the last sort stage, throws exception if it doesn't exist
        // TODO(pipeline): this implementation is wrong, there are stages that can invalidate
        // the orderings later. The proper way to manipulate the pipeline so that last Sort
        // always has effects.
        for(let t = e.stages.length - 1; t >= 0; t--){
            const n = e.stages[t];
            if (n instanceof $2fa92ec193801792$export$b2bcef12bcefba04) return n.orderings;
        }
        throw new Error("Pipeline must contain at least one Sort stage");
    }(e);
    return (n, r)=>{
        for (const i of t){
            // TODO(pipeline): consider the possibility of memoizing the evaluation
            const t = $2fa92ec193801792$var$__PRIVATE_valueOrUndefined($2fa92ec193801792$var$__PRIVATE_toEvaluable(i.expr).evaluate({
                serializer: e.serializer
            }, n)), s = $2fa92ec193801792$var$__PRIVATE_valueOrUndefined($2fa92ec193801792$var$__PRIVATE_toEvaluable(i.expr).evaluate({
                serializer: e.serializer
            }, r)), _ = $2fa92ec193801792$var$__PRIVATE_valueCompare(t || $2fa92ec193801792$var$He, s || $2fa92ec193801792$var$He);
            if (0 !== _) return "ascending" === i.direction ? _ : -_;
        }
        return 0;
    };
}
function $2fa92ec193801792$var$__PRIVATE_getLastEffectiveLimit(e) {
    // TODO(pipeline): Consider other stages that might imply a limit,
    // e.g., FindNearestStage, once they are implemented.
    for(let t = e.stages.length - 1; t >= 0; t--){
        const n = e.stages[t];
        if (n instanceof $2fa92ec193801792$export$56350196709588fc) return {
            limit: n.limit
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class $2fa92ec193801792$var$RemoteDocumentChangeBuffer {
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $2fa92ec193801792$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t)), this.changesApplied = false;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(e) {
        this.assertNotApplied(), this.changes.set(e.key, e);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(e, t) {
        this.assertNotApplied(), this.changes.set(e, $2fa92ec193801792$var$MutableDocument.newInvalidDocument(e).setReadTime(t));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(e, t) {
        this.assertNotApplied();
        const n = this.changes.get(t);
        return void 0 !== n ? $2fa92ec193801792$var$PersistencePromise.resolve(n) : this.getFromCache(e, t);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(e, t) {
        return this.getAllFromCache(e, t);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(e) {
        return this.assertNotApplied(), this.changesApplied = true, this.applyChanges(e);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class $2fa92ec193801792$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl {
    constructor(e){
        this.serializer = e;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(e, t, n) {
        return $2fa92ec193801792$var$__PRIVATE_remoteDocumentsStore(e).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(e, t, n) {
        return $2fa92ec193801792$var$__PRIVATE_remoteDocumentsStore(e).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function __PRIVATE_dbReadTimeKey(e, t) {
            const n = e.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                $2fa92ec193801792$var$__PRIVATE_toDbTimestampKey(t),
                /* document id */ n[n.length - 1]
            ];
        }(t, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(e, t) {
        return this.getMetadata(e).next((n)=>(n.byteSize += t, this.Ms(e, n)));
    }
    getEntry(e, t) {
        let n = $2fa92ec193801792$var$MutableDocument.newInvalidDocument(t);
        return $2fa92ec193801792$var$__PRIVATE_remoteDocumentsStore(e).jn({
            index: $2fa92ec193801792$var$rn,
            range: IDBKeyRange.only($2fa92ec193801792$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = this.Ns(t, r);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ Ls(e, t) {
        let n = {
            size: 0,
            document: $2fa92ec193801792$var$MutableDocument.newInvalidDocument(t)
        };
        return $2fa92ec193801792$var$__PRIVATE_remoteDocumentsStore(e).jn({
            index: $2fa92ec193801792$var$rn,
            range: IDBKeyRange.only($2fa92ec193801792$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = {
                document: this.Ns(t, r),
                size: $2fa92ec193801792$var$__PRIVATE_dbDocumentSize(r)
            };
        }).next(()=>n);
    }
    getEntries(e, t) {
        let n = $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap();
        return this.Bs(e, t, (e, t)=>{
            const r = this.Ns(e, t);
            n = n.insert(e, r);
        }).next(()=>n);
    }
    getAllEntries(e) {
        let t = $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap();
        return $2fa92ec193801792$var$__PRIVATE_remoteDocumentsStore(e).jn((e, n)=>{
            const r = this.Ns($2fa92ec193801792$export$a07804094c3ecf2d.fromSegments(n.prefixPath.concat(n.collectionGroup, n.documentId)), n);
            t = t.insert(r.key, r);
        }).next(()=>t);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ Us(e, t) {
        let n = $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap(), r = new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$export$a07804094c3ecf2d.comparator);
        return this.Bs(e, t, (e, t)=>{
            const i = this.Ns(e, t);
            n = n.insert(e, i), r = r.insert(e, $2fa92ec193801792$var$__PRIVATE_dbDocumentSize(t));
        }).next(()=>({
                documents: n,
                ks: r
            }));
    }
    Bs(e, t, n) {
        if (t.isEmpty()) return $2fa92ec193801792$var$PersistencePromise.resolve();
        let r = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$var$__PRIVATE_dbKeyComparator);
        t.forEach((e)=>r = r.add(e));
        const i = IDBKeyRange.bound($2fa92ec193801792$var$__PRIVATE_dbKey(r.first()), $2fa92ec193801792$var$__PRIVATE_dbKey(r.last())), s = r.getIterator();
        let _ = s.getNext();
        return $2fa92ec193801792$var$__PRIVATE_remoteDocumentsStore(e).jn({
            index: $2fa92ec193801792$var$rn,
            range: i
        }, (e, t, r)=>{
            const i = $2fa92ec193801792$export$a07804094c3ecf2d.fromSegments([
                ...t.prefixPath,
                t.collectionGroup,
                t.documentId
            ]);
            // Go through keys not found in cache.
            for(; _ && $2fa92ec193801792$var$__PRIVATE_dbKeyComparator(_, i) < 0;)n(_, null), _ = s.getNext();
            _ && _.isEqual(i) && // Key found in cache.
            (n(_, t), _ = s.hasNext() ? s.getNext() : null), // Skip to the next key (if there is one).
            _ ? r.$n($2fa92ec193801792$var$__PRIVATE_dbKey(_)) : r.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; _;)n(_, null), _ = s.hasNext() ? s.getNext() : null;
        });
    }
    getDocumentsMatchingQuery(e, t, n, r, i) {
        const s = $2fa92ec193801792$export$342063e11d6c3cad(t) ? $2fa92ec193801792$export$db202ddc8be9136.fromString($2fa92ec193801792$var$getPipelineCollection(t)) : t.path, _ = [
            s.popLast().toArray(),
            s.lastSegment(),
            $2fa92ec193801792$var$__PRIVATE_toDbTimestampKey(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], o = [
            s.popLast().toArray(),
            s.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return $2fa92ec193801792$var$__PRIVATE_remoteDocumentsStore(e).Kn(IDBKeyRange.bound(_, o, true)).next((e)=>{
            i?.incrementDocumentReadCount(e.length);
            let n = $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap();
            for (const i of e){
                const e = this.Ns($2fa92ec193801792$export$a07804094c3ecf2d.fromSegments(i.prefixPath.concat(i.collectionGroup, i.documentId)), i);
                e.isFoundDocument() && ($2fa92ec193801792$var$__PRIVATE_queryOrPipelineMatches(t, e) || r.has(e.key)) && // Either the document matches the given query, or it is mutated.
                (n = n.insert(e.key, e));
            }
            return n;
        });
    }
    getAllFromCollectionGroup(e, t, n, r) {
        let i = $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap();
        const s = $2fa92ec193801792$var$__PRIVATE_dbCollectionGroupKey(t, n), _ = $2fa92ec193801792$var$__PRIVATE_dbCollectionGroupKey(t, $2fa92ec193801792$var$IndexOffset.max());
        return $2fa92ec193801792$var$__PRIVATE_remoteDocumentsStore(e).jn({
            index: $2fa92ec193801792$var$_n,
            range: IDBKeyRange.bound(s, _, true)
        }, (e, t, n)=>{
            const s = this.Ns($2fa92ec193801792$export$a07804094c3ecf2d.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
            i = i.insert(s.key, s), i.size === r && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(e) {
        return new $2fa92ec193801792$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
    }
    getSize(e) {
        return this.getMetadata(e).next((e)=>e.byteSize);
    }
    getMetadata(e) {
        return $2fa92ec193801792$var$__PRIVATE_documentGlobalStore(e).get($2fa92ec193801792$var$un).next((e)=>($2fa92ec193801792$var$__PRIVATE_hardAssert(!!e, 20021), e));
    }
    Ms(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_documentGlobalStore(e).put($2fa92ec193801792$var$un, t);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ Ns(e, t) {
        if (t) {
            const e = $2fa92ec193801792$var$__PRIVATE_fromDbRemoteDocument(this.serializer, t);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(e.isNoDocument() && e.version.isEqual($2fa92ec193801792$var$SnapshotVersion.min()))) return e;
        }
        return $2fa92ec193801792$var$MutableDocument.newInvalidDocument(e);
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function $2fa92ec193801792$var$__PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new $2fa92ec193801792$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class $2fa92ec193801792$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer extends $2fa92ec193801792$var$RemoteDocumentChangeBuffer {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(e, t){
        super(), this.qs = e, this.trackRemovals = t, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.$s = new $2fa92ec193801792$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
    }
    applyChanges(e) {
        const t = [];
        let n = 0, r = new $2fa92ec193801792$var$SortedSet((e, t)=>$2fa92ec193801792$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
        return this.changes.forEach((i, s)=>{
            const _ = this.$s.get(i);
            if (t.push(this.qs.removeEntry(e, i, _.readTime)), s.isValidDocument()) {
                const o = $2fa92ec193801792$var$__PRIVATE_toDbRemoteDocument(this.qs.serializer, s);
                r = r.add(i.path.popLast());
                const a = $2fa92ec193801792$var$__PRIVATE_dbDocumentSize(o);
                n += a - _.size, t.push(this.qs.addEntry(e, i, o));
            } else if (n -= _.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = $2fa92ec193801792$var$__PRIVATE_toDbRemoteDocument(this.qs.serializer, s.convertToNoDocument($2fa92ec193801792$var$SnapshotVersion.min()));
                t.push(this.qs.addEntry(e, i, n));
            }
        }), r.forEach((n)=>{
            t.push(this.qs.indexManager.addToCollectionParentIndex(e, n));
        }), t.push(this.qs.updateMetadata(e, n)), $2fa92ec193801792$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.qs.Ls(e, t).next((e)=>(this.$s.set(t, {
                size: e.size,
                readTime: e.document.readTime
            }), e.document));
    }
    getAllFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.qs.Us(e, t).next(({ documents: e, ks: t })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (t.forEach((t, n)=>{
                this.$s.set(t, {
                    size: n,
                    readTime: e.get(t).readTime
                });
            }), e));
    }
}
function $2fa92ec193801792$var$__PRIVATE_documentGlobalStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$an);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $2fa92ec193801792$var$__PRIVATE_remoteDocumentsStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$tn);
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $2fa92ec193801792$var$__PRIVATE_dbKey(e) {
    const t = e.path.toArray();
    return [
        /* prefix path */ t.slice(0, t.length - 2),
        /* collection id */ t[t.length - 2],
        /* document id */ t[t.length - 1]
    ];
}
function $2fa92ec193801792$var$__PRIVATE_dbCollectionGroupKey(e, t) {
    const n = t.documentKey.path.toArray();
    return [
        /* collection id */ e,
        $2fa92ec193801792$var$__PRIVATE_toDbTimestampKey(t.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $2fa92ec193801792$var$__PRIVATE_dbKeyComparator(e, t) {
    const n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let e = 0; e < n.length - 2 && e < r.length - 2; ++e)if (i = $2fa92ec193801792$var$__PRIVATE_primitiveComparator(n[e], r[e]), i) return i;
    return i = $2fa92ec193801792$var$__PRIVATE_primitiveComparator(n.length, r.length), i || (i = $2fa92ec193801792$var$__PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), i || $2fa92ec193801792$var$__PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 * 16. Parse timestamp strings before creating index entries.
 * 17. TODO(tomandersen)
 * 18. Encode key safe representations of IndexEntry in DbIndexEntryStore.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class $2fa92ec193801792$var$OverlayedDocument {
    constructor(e, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ t){
        this.overlayedDocument = e, this.mutatedFields = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class $2fa92ec193801792$var$LocalDocumentsView {
    constructor(e, t, n, r){
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(e, t) {
        let n = null;
        return this.documentOverlayCache.getOverlay(e, t).next((r)=>(n = r, this.remoteDocumentCache.getEntry(e, t))).next((e)=>(null !== n && $2fa92ec193801792$var$__PRIVATE_mutationApplyToLocalView(n.mutation, e, $2fa92ec193801792$var$FieldMask.empty(), $2fa92ec193801792$export$890c4ad488842ce7.now()), e));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.getLocalViewOfDocuments(e, t, $2fa92ec193801792$export$a9c996f45e5784d0()).next(()=>t));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(e, t, n = $2fa92ec193801792$export$a9c996f45e5784d0()) {
        const r = $2fa92ec193801792$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, r, t).next(()=>this.computeViews(e, t, r, n).next((e)=>{
                let t = $2fa92ec193801792$var$documentMap();
                return e.forEach((e, n)=>{
                    t = t.insert(e, n.overlayedDocument);
                }), t;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, n, t).next(()=>this.computeViews(e, t, n, $2fa92ec193801792$export$a9c996f45e5784d0()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(e, t, n) {
        const r = [];
        return n.forEach((e)=>{
            t.has(e) || r.push(e);
        }), this.documentOverlayCache.getOverlays(e, r).next((e)=>{
            e.forEach((e, n)=>{
                t.set(e, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @returns A map represents the local documents view.
     */ computeViews(e, t, n, r) {
        let i = $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap();
        const s = $2fa92ec193801792$var$__PRIVATE_newDocumentKeyMap(), _ = function __PRIVATE_newOverlayedDocumentMap() {
            return $2fa92ec193801792$var$__PRIVATE_newDocumentKeyMap();
        }();
        return t.forEach((e, t)=>{
            const _ = n.get(t.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            r.has(t.key) && (void 0 === _ || _.mutation instanceof $2fa92ec193801792$var$__PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== _ ? (s.set(t.key, _.mutation.getFieldMask()), $2fa92ec193801792$var$__PRIVATE_mutationApplyToLocalView(_.mutation, t, _.mutation.getFieldMask(), $2fa92ec193801792$export$890c4ad488842ce7.now())) : // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            s.set(t.key, $2fa92ec193801792$var$FieldMask.empty());
        }), this.recalculateAndSaveOverlays(e, i).next((e)=>(e.forEach((e, t)=>s.set(e, t)), t.forEach((e, t)=>_.set(e, new $2fa92ec193801792$var$OverlayedDocument(t, s.get(e) ?? null))), _));
    }
    recalculateAndSaveOverlays(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_newDocumentKeyMap();
        // A reverse lookup map from batch id to the documents within that batch.
        let r = new $2fa92ec193801792$var$SortedMap((e, t)=>e - t), i = $2fa92ec193801792$export$a9c996f45e5784d0();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next((e)=>{
            for (const i of e)i.keys().forEach((e)=>{
                const s = t.get(e);
                if (null === s) return;
                let _ = n.get(e) || $2fa92ec193801792$var$FieldMask.empty();
                _ = i.applyToLocalView(s, _), n.set(e, _);
                const o = (r.get(i.batchId) || $2fa92ec193801792$export$a9c996f45e5784d0()).add(e);
                r = r.insert(i.batchId, o);
            });
        }).next(()=>{
            const s = [], _ = r.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; _.hasNext();){
                const r = _.getNext(), o = r.key, a = r.value, u = $2fa92ec193801792$var$__PRIVATE_newMutationMap();
                a.forEach((e)=>{
                    if (!i.has(e)) {
                        const r = $2fa92ec193801792$var$__PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                        null !== r && u.set(e, r), i = i.add(e);
                    }
                }), s.push(this.documentOverlayCache.saveOverlays(e, o, u));
            }
            return $2fa92ec193801792$var$PersistencePromise.waitFor(s);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.recalculateAndSaveOverlays(e, t));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */ getDocumentsMatchingQuery(e, t, n, r) {
        return $2fa92ec193801792$export$342063e11d6c3cad(t) ? this.getDocumentsMatchingPipeline(e, t, n, r) : $2fa92ec193801792$var$__PRIVATE_isDocumentQuery$1(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : $2fa92ec193801792$export$21579262ef46735b(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup - The collection group for the documents.
     * @param offset - The offset to index into.
     * @param count - The number of documents to return
     * @returns A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(e, t, n, r) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next((i)=>{
            const s = r - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : $2fa92ec193801792$var$PersistencePromise.resolve($2fa92ec193801792$var$__PRIVATE_newOverlayMap());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let _ = $2fa92ec193801792$var$Xe, o = i;
            return s.next((t)=>$2fa92ec193801792$var$PersistencePromise.forEach(t, (t, n)=>(_ < n.largestBatchId && (_ = n.largestBatchId), i.get(t) ? $2fa92ec193801792$var$PersistencePromise.resolve() : this.remoteDocumentCache.getEntry(e, t).next((e)=>{
                        o = o.insert(t, e);
                    }))).next(()=>this.populateOverlays(e, t, i)).next(()=>this.computeViews(e, o, t, $2fa92ec193801792$export$a9c996f45e5784d0())).next((e)=>({
                        batchId: _,
                        changes: $2fa92ec193801792$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(e, t) {
        // Just do a simple document lookup.
        return this.getDocument(e, new $2fa92ec193801792$export$a07804094c3ecf2d(t)).next((e)=>{
            let t = $2fa92ec193801792$var$documentMap();
            return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
        const i = t.collectionGroup;
        let s = $2fa92ec193801792$var$documentMap();
        return this.indexManager.getCollectionParents(e, i).next((_)=>$2fa92ec193801792$var$PersistencePromise.forEach(_, (_)=>{
                const o = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                    return new $2fa92ec193801792$var$__PRIVATE_QueryImpl(t, /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                }(t, _.child(i));
                return this.getDocumentsMatchingCollectionQuery(e, o, n, r).next((e)=>{
                    e.forEach((e, t)=>{
                        s = s.insert(e, t);
                    });
                });
            }).next(()=>s));
    }
    getDocumentsMatchingCollectionQuery(e, t, n, r) {
        // Query the remote documents and overlay mutations.
        let i;
        return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next((s)=>(i = s, this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r))).next((e)=>this.retrieveMatchingLocalDocuments(i, e, (e)=>$2fa92ec193801792$var$__PRIVATE_queryMatches(t, e)));
    }
    getDocumentsMatchingPipeline(e, t, n, r) {
        if ("collection_group" === $2fa92ec193801792$var$getPipelineSourceType(t)) {
            const i = $2fa92ec193801792$var$getPipelineCollectionGroup(t);
            let s = $2fa92ec193801792$var$documentMap();
            return this.indexManager.getCollectionParents(e, i).next((_)=>$2fa92ec193801792$var$PersistencePromise.forEach(_, (_)=>{
                    const o = function __PRIVATE_asCollectionPipelineAtPath(e, t) {
                        const n = e.stages.map((e)=>e instanceof $2fa92ec193801792$export$d22783b3c2400a3a ? new $2fa92ec193801792$export$c5d1328b37d47994(t.canonicalString(), {}) : e);
                        return new $2fa92ec193801792$var$CorePipeline(e.serializer, n);
                    }(t, _.child(i));
                    return this.getDocumentsMatchingPipeline(e, o, n, r).next((e)=>{
                        e.forEach((e, t)=>{
                            s = s.insert(e, t);
                        });
                    });
                }).next(()=>s));
        }
        {
            // Query the remote documents and overlay mutations.
            let i;
            return this.getOverlaysForPipeline(e, t, n.largestBatchId).next((_)=>{
                switch(i = _, $2fa92ec193801792$var$getPipelineSourceType(t)){
                    case "collection":
                        return this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r);
                    case "documents":
                        let _1 = $2fa92ec193801792$export$a9c996f45e5784d0();
                        for (const e of $2fa92ec193801792$var$getPipelineDocuments(t))_1 = _1.add($2fa92ec193801792$export$a07804094c3ecf2d.fromPath(e));
                        return this.remoteDocumentCache.getEntries(e, _1);
                    case "database":
                        return this.remoteDocumentCache.getAllEntries(e);
                    default:
                        throw new $2fa92ec193801792$export$2408f22a0fab9ae5("invalid-argument", `Invalid pipeline source to execute offline: ${$2fa92ec193801792$var$__PRIVATE_canonifyPipeline(t)}`);
                }
            }).next((e)=>this.retrieveMatchingLocalDocuments(i, e, (e)=>$2fa92ec193801792$var$__PRIVATE_pipelineMatches(t, e)));
        }
    }
    retrieveMatchingLocalDocuments(e, t, n) {
        // As documents might match the query because of their overlay we need to
        // include documents for all overlays in the initial document set.
        e.forEach((e, n)=>{
            const r = n.getKey();
            null === t.get(r) && (t = t.insert(r, $2fa92ec193801792$var$MutableDocument.newInvalidDocument(r)));
        });
        // Apply the overlays and match against the query.
        let r = $2fa92ec193801792$var$documentMap();
        return t.forEach((t, i)=>{
            const s = e.get(t);
            void 0 !== s && $2fa92ec193801792$var$__PRIVATE_mutationApplyToLocalView(s.mutation, i, $2fa92ec193801792$var$FieldMask.empty(), $2fa92ec193801792$export$890c4ad488842ce7.now()), // Finally, insert the documents that still match the query
            n(i) && (r = r.insert(t, i));
        }), r;
    }
    getOverlaysForPipeline(e, t, n) {
        switch($2fa92ec193801792$var$getPipelineSourceType(t)){
            case "collection":
                return this.documentOverlayCache.getOverlaysForCollection(e, $2fa92ec193801792$export$db202ddc8be9136.fromString($2fa92ec193801792$var$getPipelineCollection(t)), n);
            case "collection_group":
                throw new $2fa92ec193801792$export$2408f22a0fab9ae5("invalid-argument", `Unexpected collection group pipeline: ${$2fa92ec193801792$var$__PRIVATE_canonifyPipeline(t)}`);
            case "documents":
                return this.documentOverlayCache.getOverlays(e, $2fa92ec193801792$var$getPipelineDocuments(t).map((e)=>$2fa92ec193801792$export$a07804094c3ecf2d.fromPath(e)));
            case "database":
                return this.documentOverlayCache.getAllOverlays(e, n);
            default:
                throw new $2fa92ec193801792$export$2408f22a0fab9ae5("invalid-argument", `Failed to get overlays for pipeline: ${$2fa92ec193801792$var$__PRIVATE_canonifyPipeline(t)}`);
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$var$__PRIVATE_MemoryBundleCache {
    constructor(e){
        this.serializer = e, this.Ks = new Map, this.Ws = new Map;
    }
    getBundleMetadata(e, t) {
        return $2fa92ec193801792$var$PersistencePromise.resolve(this.Ks.get(t));
    }
    saveBundleMetadata(e, t) {
        return this.Ks.set(t.id, /** Decodes a BundleMetadata proto into a BundleMetadata object. */ function __PRIVATE_fromBundleMetadata(e) {
            return {
                id: e.id,
                version: e.version,
                createTime: $2fa92ec193801792$var$__PRIVATE_fromVersion(e.createTime)
            };
        }(t)), $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    getNamedQuery(e, t) {
        return $2fa92ec193801792$var$PersistencePromise.resolve(this.Ws.get(t));
    }
    saveNamedQuery(e, t) {
        return this.Ws.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
            return {
                name: e.name,
                query: $2fa92ec193801792$export$2e2af4578d910ddf(e.bundledQuery),
                readTime: $2fa92ec193801792$var$__PRIVATE_fromVersion(e.readTime)
            };
        }(t)), $2fa92ec193801792$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class $2fa92ec193801792$var$__PRIVATE_MemoryDocumentOverlayCache {
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$export$a07804094c3ecf2d.comparator), this.Qs = new Map;
    }
    getOverlay(e, t) {
        return $2fa92ec193801792$var$PersistencePromise.resolve(this.overlays.get(t));
    }
    getOverlays(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_newOverlayMap();
        return $2fa92ec193801792$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    getAllOverlays(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_newOverlayMap();
        return this.overlays.forEach((e, r)=>{
            r.largestBatchId > t && n.set(e, r);
        }), $2fa92ec193801792$var$PersistencePromise.resolve(n);
    }
    saveOverlays(e, t, n) {
        return n.forEach((n, r)=>{
            this.Yr(e, t, r);
        }), $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = this.Qs.get(n);
        return void 0 !== r && (r.forEach((e)=>this.overlays = this.overlays.remove(e)), this.Qs.delete(n)), $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    getOverlaysForCollection(e, t, n) {
        const r = $2fa92ec193801792$var$__PRIVATE_newOverlayMap(), i = t.length + 1, s = new $2fa92ec193801792$export$a07804094c3ecf2d(t.child("")), _ = this.overlays.getIteratorFrom(s);
        for(; _.hasNext();){
            const e = _.getNext().value, s = e.getKey();
            if (!t.isPrefixOf(s.path)) break;
            // Documents from sub-collections
            s.path.length === i && e.largestBatchId > n && r.set(e.getKey(), e);
        }
        return $2fa92ec193801792$var$PersistencePromise.resolve(r);
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        let i = new $2fa92ec193801792$var$SortedMap((e, t)=>e - t);
        const s = this.overlays.getIterator();
        for(; s.hasNext();){
            const e = s.getNext().value;
            if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
                let t = i.get(e.largestBatchId);
                null === t && (t = $2fa92ec193801792$var$__PRIVATE_newOverlayMap(), i = i.insert(e.largestBatchId, t)), t.set(e.getKey(), e);
            }
        }
        const _ = $2fa92ec193801792$var$__PRIVATE_newOverlayMap(), o = i.getIterator();
        for(; o.hasNext();){
            if (o.getNext().value.forEach((e, t)=>_.set(e, t)), _.size() >= r) break;
        }
        return $2fa92ec193801792$var$PersistencePromise.resolve(_);
    }
    Yr(e, t, n) {
        // Remove the association of the overlay to its batch id.
        const r = this.overlays.get(n.key);
        if (null !== r) {
            const e = this.Qs.get(r.largestBatchId).delete(n.key);
            this.Qs.set(r.largestBatchId, e);
        }
        this.overlays = this.overlays.insert(n.key, new $2fa92ec193801792$var$Overlay(t, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.Qs.get(t);
        void 0 === i && (i = $2fa92ec193801792$export$a9c996f45e5784d0(), this.Qs.set(t, i)), this.Qs.set(t, i.add(n.key));
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$var$__PRIVATE_MemoryGlobalsCache {
    constructor(){
        this.sessionToken = $2fa92ec193801792$export$158acd800e1ef08b.EMPTY_BYTE_STRING;
    }
    getSessionToken(e) {
        return $2fa92ec193801792$var$PersistencePromise.resolve(this.sessionToken);
    }
    setSessionToken(e, t) {
        return this.sessionToken = t, $2fa92ec193801792$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class $2fa92ec193801792$var$__PRIVATE_ReferenceSet {
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.Gs = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$var$__PRIVATE_DocReference.zs), // A set of outstanding references to a document sorted by target id.
        this.js = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$var$__PRIVATE_DocReference.Hs);
    }
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.Gs.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(e, t) {
        const n = new $2fa92ec193801792$var$__PRIVATE_DocReference(e, t);
        this.Gs = this.Gs.add(n), this.js = this.js.add(n);
    }
    /** Add references to the given document keys for the given ID. */ Js(e, t) {
        e.forEach((e)=>this.addReference(e, t));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(e, t) {
        this.Ys(new $2fa92ec193801792$var$__PRIVATE_DocReference(e, t));
    }
    Zs(e, t) {
        e.forEach((e)=>this.removeReference(e, t));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ Xs(e) {
        const t = new $2fa92ec193801792$export$a07804094c3ecf2d(new $2fa92ec193801792$export$db202ddc8be9136([])), n = new $2fa92ec193801792$var$__PRIVATE_DocReference(t, e), r = new $2fa92ec193801792$var$__PRIVATE_DocReference(t, e + 1), i = [];
        return this.js.forEachInRange([
            n,
            r
        ], (e)=>{
            this.Ys(e), i.push(e.key);
        }), i;
    }
    e_() {
        this.Gs.forEach((e)=>this.Ys(e));
    }
    Ys(e) {
        this.Gs = this.Gs.delete(e), this.js = this.js.delete(e);
    }
    t_(e) {
        const t = new $2fa92ec193801792$export$a07804094c3ecf2d(new $2fa92ec193801792$export$db202ddc8be9136([])), n = new $2fa92ec193801792$var$__PRIVATE_DocReference(t, e), r = new $2fa92ec193801792$var$__PRIVATE_DocReference(t, e + 1);
        let i = $2fa92ec193801792$export$a9c996f45e5784d0();
        return this.js.forEachInRange([
            n,
            r
        ], (e)=>{
            i = i.add(e.key);
        }), i;
    }
    containsKey(e) {
        const t = new $2fa92ec193801792$var$__PRIVATE_DocReference(e, 0), n = this.Gs.firstAfterOrEqual(t);
        return null !== n && e.isEqual(n.key);
    }
}
class $2fa92ec193801792$var$__PRIVATE_DocReference {
    constructor(e, t){
        this.key = e, this.n_ = t;
    }
    /** Compare by key then by ID */ static zs(e, t) {
        return $2fa92ec193801792$export$a07804094c3ecf2d.comparator(e.key, t.key) || $2fa92ec193801792$var$__PRIVATE_primitiveComparator(e.n_, t.n_);
    }
    /** Compare by ID then by key */ static Hs(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_primitiveComparator(e.n_, t.n_) || $2fa92ec193801792$export$a07804094c3ecf2d.comparator(e.key, t.key);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$var$__PRIVATE_MemoryMutationQueue {
    constructor(e, t){
        this.indexManager = e, this.referenceDelegate = t, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.Qr = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.r_ = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$var$__PRIVATE_DocReference.zs);
    }
    checkEmpty(e) {
        return $2fa92ec193801792$var$PersistencePromise.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(e, t, n, r) {
        const i = this.Qr;
        this.Qr++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const s = new $2fa92ec193801792$var$MutationBatch(i, t, n, r);
        this.mutationQueue.push(s);
        // Track references by document key and index collection parents.
        for (const t of r)this.r_ = this.r_.add(new $2fa92ec193801792$var$__PRIVATE_DocReference(t.key, i)), this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
        return $2fa92ec193801792$var$PersistencePromise.resolve(s);
    }
    lookupMutationBatch(e, t) {
        return $2fa92ec193801792$var$PersistencePromise.resolve(this.i_(t));
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = this.s_(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $2fa92ec193801792$var$PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return $2fa92ec193801792$var$PersistencePromise.resolve(0 === this.mutationQueue.length ? $2fa92ec193801792$var$Ke : this.Qr - 1);
    }
    getAllMutationBatches(e) {
        return $2fa92ec193801792$var$PersistencePromise.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        const n = new $2fa92ec193801792$var$__PRIVATE_DocReference(t, 0), r = new $2fa92ec193801792$var$__PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
        return this.r_.forEachInRange([
            n,
            r
        ], (e)=>{
            const t = this.i_(e.n_);
            i.push(t);
        }), $2fa92ec193801792$var$PersistencePromise.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$var$__PRIVATE_primitiveComparator);
        return t.forEach((e)=>{
            const t = new $2fa92ec193801792$var$__PRIVATE_DocReference(e, 0), r = new $2fa92ec193801792$var$__PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
            this.r_.forEachInRange([
                t,
                r
            ], (e)=>{
                n = n.add(e.n_);
            });
        }), $2fa92ec193801792$var$PersistencePromise.resolve(this.__(n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = t.path, r = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        $2fa92ec193801792$export$a07804094c3ecf2d.isDocumentKey(i) || (i = i.child(""));
        const s = new $2fa92ec193801792$var$__PRIVATE_DocReference(new $2fa92ec193801792$export$a07804094c3ecf2d(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let _ = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$var$__PRIVATE_primitiveComparator);
        return this.r_.forEachWhile((e)=>{
            const t = e.key.path;
            return !!n.isPrefixOf(t) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (t.length === r && (_ = _.add(e.n_)), true);
        }, s), $2fa92ec193801792$var$PersistencePromise.resolve(this.__(_));
    }
    __(e) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const t = [];
        return e.forEach((e)=>{
            const n = this.i_(e);
            null !== n && t.push(n);
        }), t;
    }
    removeMutationBatch(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(0 === this.o_(t.batchId, "removed"), 55003), this.mutationQueue.shift();
        let n = this.r_;
        return $2fa92ec193801792$var$PersistencePromise.forEach(t.mutations, (r)=>{
            const i = new $2fa92ec193801792$var$__PRIVATE_DocReference(r.key, t.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
        }).next(()=>{
            this.r_ = n;
        });
    }
    jr(e) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(e, t) {
        const n = new $2fa92ec193801792$var$__PRIVATE_DocReference(t, 0), r = this.r_.firstAfterOrEqual(n);
        return $2fa92ec193801792$var$PersistencePromise.resolve(t.isEqual(r && r.key));
    }
    performConsistencyCheck(e) {
        return this.mutationQueue.length, $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ o_(e, t) {
        return this.s_(e);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been removed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ s_(e) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return e - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficient.
     */ i_(e) {
        const t = this.s_(e);
        if (t < 0 || t >= this.mutationQueue.length) return null;
        return this.mutationQueue[t];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The smallest value representable by a 64-bit signed integer (long).
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class $2fa92ec193801792$var$__PRIVATE_MemoryRemoteDocumentCacheImpl {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(e){
        this.a_ = e, /** Underlying cache of documents and their read times. */ this.docs = function __PRIVATE_documentEntryMap() {
            return new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$export$a07804094c3ecf2d.comparator);
        }(), /** Size of all cached documents. */ this.size = 0;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(e, t) {
        const n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.a_(t);
        return this.docs = this.docs.insert(n, {
            document: t.mutableCopy(),
            size: s
        }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(e) {
        const t = this.docs.get(e);
        t && (this.docs = this.docs.remove(e), this.size -= t.size);
    }
    getEntry(e, t) {
        const n = this.docs.get(t);
        return $2fa92ec193801792$var$PersistencePromise.resolve(n ? n.document.mutableCopy() : $2fa92ec193801792$var$MutableDocument.newInvalidDocument(t));
    }
    getEntries(e, t) {
        let n = $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap();
        return t.forEach((e)=>{
            const t = this.docs.get(e);
            n = n.insert(e, t ? t.document.mutableCopy() : $2fa92ec193801792$var$MutableDocument.newInvalidDocument(e));
        }), $2fa92ec193801792$var$PersistencePromise.resolve(n);
    }
    getAllEntries(e) {
        let t = $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap();
        return this.docs.forEach((e, n)=>{
            t = t.insert(e, n.document);
        }), $2fa92ec193801792$var$PersistencePromise.resolve(t);
    }
    getDocumentsMatchingQuery(e, t, n, r) {
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        let i, s;
        $2fa92ec193801792$export$342063e11d6c3cad(t) ? // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        (i = $2fa92ec193801792$export$db202ddc8be9136.fromString($2fa92ec193801792$var$getPipelineCollection(t)), s = (e)=>$2fa92ec193801792$var$__PRIVATE_pipelineMatches(t, e)) : // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        (i = t.path, s = (e)=>$2fa92ec193801792$var$__PRIVATE_queryMatches(t, e));
        let _ = $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap();
        // Document keys are ordered first by numeric value ("__id<Long>__"),
        // then lexicographically by string value. Start the iterator at the minimum
        // possible Document key value.
        const o = new $2fa92ec193801792$export$a07804094c3ecf2d(i.child("__id-9223372036854775808__")), a = this.docs.getIteratorFrom(o);
        for(; a.hasNext();){
            const { key: e, value: { document: t } } = a.getNext();
            if (!i.isPrefixOf(e.path)) break;
            e.path.length > i.length + 1 || $2fa92ec193801792$var$__PRIVATE_indexOffsetComparator($2fa92ec193801792$var$__PRIVATE_newIndexOffsetFromDocument(t), n) <= 0 || (r.has(t.key) || s(t)) && (_ = _.insert(t.key, t.mutableCopy()));
        }
        return $2fa92ec193801792$var$PersistencePromise.resolve(_);
    }
    getAllFromCollectionGroup(e, t, n, r) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        $2fa92ec193801792$export$1a82df3d29112e01(9500);
    }
    u_(e, t) {
        return $2fa92ec193801792$var$PersistencePromise.forEach(this.docs, (e)=>t(e));
    }
    newChangeBuffer(e) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $2fa92ec193801792$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
    }
    getSize(e) {
        return $2fa92ec193801792$var$PersistencePromise.resolve(this.size);
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class $2fa92ec193801792$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer extends $2fa92ec193801792$var$RemoteDocumentChangeBuffer {
    constructor(e){
        super(), this.qs = e;
    }
    applyChanges(e) {
        const t = [];
        return this.changes.forEach((n, r)=>{
            r.isValidDocument() ? t.push(this.qs.addEntry(e, r)) : this.qs.removeEntry(n);
        }), $2fa92ec193801792$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        return this.qs.getEntry(e, t);
    }
    getAllFromCache(e, t) {
        return this.qs.getEntries(e, t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$var$__PRIVATE_MemoryTargetCache {
    constructor(e){
        this.persistence = e, /**
         * Maps a target to the data about that target
         */ this.c_ = new $2fa92ec193801792$var$ObjectMap((e)=>$2fa92ec193801792$var$__PRIVATE_canonifyTargetOrPipeline(e), $2fa92ec193801792$var$__PRIVATE_targetOrPipelineEqual), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $2fa92ec193801792$var$SnapshotVersion.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.l_ = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.E_ = new $2fa92ec193801792$var$__PRIVATE_ReferenceSet, this.targetCount = 0, this.h_ = $2fa92ec193801792$var$__PRIVATE_TargetIdGenerator.ys();
    }
    forEachTarget(e, t) {
        return this.c_.forEach((e, n)=>t(n)), $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    getLastRemoteSnapshotVersion(e) {
        return $2fa92ec193801792$var$PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(e) {
        return $2fa92ec193801792$var$PersistencePromise.resolve(this.l_);
    }
    allocateTargetId(e) {
        return this.highestTargetId = this.h_.next(), $2fa92ec193801792$var$PersistencePromise.resolve(this.highestTargetId);
    }
    setTargetsMetadata(e, t, n) {
        return n && (this.lastRemoteSnapshotVersion = n), t > this.l_ && (this.l_ = t), $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    Ss(e) {
        this.c_.set(e.target, e);
        const t = e.targetId;
        t > this.highestTargetId && (this.h_ = new $2fa92ec193801792$var$__PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), e.sequenceNumber > this.l_ && (this.l_ = e.sequenceNumber);
    }
    addTargetData(e, t) {
        return this.Ss(t), this.targetCount += 1, $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    updateTargetData(e, t) {
        return this.Ss(t), $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    removeTargetData(e, t) {
        return this.c_.delete(t.target), this.E_.Xs(t.targetId), this.targetCount -= 1, $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return this.c_.forEach((s, _)=>{
            _.sequenceNumber <= t && null === n.get(_.targetId) && (this.c_.delete(s), i.push(this.removeMatchingKeysForTargetId(e, _.targetId)), r++);
        }), $2fa92ec193801792$var$PersistencePromise.waitFor(i).next(()=>r);
    }
    getTargetCount(e) {
        return $2fa92ec193801792$var$PersistencePromise.resolve(this.targetCount);
    }
    getTargetData(e, t) {
        const n = this.c_.get(t) || null;
        return $2fa92ec193801792$var$PersistencePromise.resolve(n);
    }
    addMatchingKeys(e, t, n) {
        return this.E_.Js(t, n), $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    removeMatchingKeys(e, t, n) {
        this.E_.Zs(t, n);
        const r = this.persistence.referenceDelegate, i = [];
        return r && t.forEach((t)=>{
            i.push(r.markPotentiallyOrphaned(e, t));
        }), $2fa92ec193801792$var$PersistencePromise.waitFor(i);
    }
    removeMatchingKeysForTargetId(e, t) {
        return this.E_.Xs(t), $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    getMatchingKeysForTargetId(e, t) {
        const n = this.E_.t_(t);
        return $2fa92ec193801792$var$PersistencePromise.resolve(n);
    }
    containsKey(e, t) {
        return $2fa92ec193801792$var$PersistencePromise.resolve(this.E_.containsKey(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class $2fa92ec193801792$var$__PRIVATE_MemoryPersistence {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(e, t){
        this.T_ = {}, this.overlays = {}, this.P_ = new $2fa92ec193801792$var$__PRIVATE_ListenSequence(0), this.R_ = false, this.R_ = true, this.I_ = new $2fa92ec193801792$var$__PRIVATE_MemoryGlobalsCache, this.referenceDelegate = e(this), this.A_ = new $2fa92ec193801792$var$__PRIVATE_MemoryTargetCache(this);
        this.indexManager = new $2fa92ec193801792$var$__PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new $2fa92ec193801792$var$__PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }((e)=>this.referenceDelegate.V_(e)), this.serializer = new $2fa92ec193801792$var$__PRIVATE_LocalSerializer(t), this.d_ = new $2fa92ec193801792$var$__PRIVATE_MemoryBundleCache(this.serializer);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.R_ = false, Promise.resolve();
    }
    get started() {
        return this.R_;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(e) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(e) {
        let t = this.overlays[e.toKey()];
        return t || (t = new $2fa92ec193801792$var$__PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), t;
    }
    getMutationQueue(e, t) {
        let n = this.T_[e.toKey()];
        return n || (n = new $2fa92ec193801792$var$__PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this.T_[e.toKey()] = n), n;
    }
    getGlobalsCache() {
        return this.I_;
    }
    getTargetCache() {
        return this.A_;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.d_;
    }
    runTransaction(e, t, n) {
        $2fa92ec193801792$export$2329c99376c9d0a4("MemoryPersistence", "Starting transaction:", e);
        const r = new $2fa92ec193801792$var$__PRIVATE_MemoryTransaction(this.P_.next());
        return this.referenceDelegate.f_(), n(r).next((e)=>this.referenceDelegate.m_(r).next(()=>e)).toPromise().then((e)=>(r.raiseOnCommittedEvent(), e));
    }
    p_(e, t) {
        return $2fa92ec193801792$var$PersistencePromise.or(Object.values(this.T_).map((n)=>()=>n.containsKey(e, t)));
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class $2fa92ec193801792$var$__PRIVATE_MemoryTransaction extends $2fa92ec193801792$var$PersistenceTransaction {
    constructor(e){
        super(), this.currentSequenceNumber = e;
    }
}
class $2fa92ec193801792$var$__PRIVATE_MemoryEagerDelegate {
    constructor(e){
        this.persistence = e, /** Tracks all documents that are active in Query views. */ this.g_ = new $2fa92ec193801792$var$__PRIVATE_ReferenceSet, /** The list of documents that are potentially GCed after each transaction. */ this.y_ = null;
    }
    static w_(e) {
        return new $2fa92ec193801792$var$__PRIVATE_MemoryEagerDelegate(e);
    }
    get b_() {
        if (this.y_) return this.y_;
        throw $2fa92ec193801792$export$1a82df3d29112e01(60996);
    }
    addReference(e, t, n) {
        return this.g_.addReference(n, t), this.b_.delete(n.toString()), $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.g_.removeReference(n, t), this.b_.add(n.toString()), $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    markPotentiallyOrphaned(e, t) {
        return this.b_.add(t.toString()), $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        this.g_.Xs(t.targetId).forEach((e)=>this.b_.add(e.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
            e.forEach((e)=>this.b_.add(e.toString()));
        }).next(()=>n.removeTargetData(e, t));
    }
    f_() {
        this.y_ = new Set;
    }
    m_(e) {
        // Remove newly orphaned documents.
        const t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return $2fa92ec193801792$var$PersistencePromise.forEach(this.b_, (n)=>{
            const r = $2fa92ec193801792$export$a07804094c3ecf2d.fromPath(n);
            return this.v_(e, r).next((e)=>{
                e || t.removeEntry(r, $2fa92ec193801792$var$SnapshotVersion.min());
            });
        }).next(()=>(this.y_ = null, t.apply(e)));
    }
    updateLimboDocument(e, t) {
        return this.v_(e, t).next((e)=>{
            e ? this.b_.delete(t.toString()) : this.b_.add(t.toString());
        });
    }
    V_(e) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    v_(e, t) {
        return $2fa92ec193801792$var$PersistencePromise.or([
            ()=>$2fa92ec193801792$var$PersistencePromise.resolve(this.g_.containsKey(t)),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>this.persistence.p_(e, t)
        ]);
    }
}
class $2fa92ec193801792$var$__PRIVATE_MemoryLruDelegate {
    constructor(e, t){
        this.persistence = e, this.S_ = new $2fa92ec193801792$var$ObjectMap((e)=>$2fa92ec193801792$var$__PRIVATE_encodeResourcePath(e.path), (e, t)=>e.isEqual(t)), this.garbageCollector = $2fa92ec193801792$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    static w_(e, t) {
        return new $2fa92ec193801792$var$__PRIVATE_MemoryLruDelegate(e, t);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    f_() {}
    m_(e) {
        return $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    forEachTarget(e, t) {
        return this.persistence.getTargetCache().forEachTarget(e, t);
    }
    rr(e) {
        const t = this.xs(e);
        return this.persistence.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    xs(e) {
        let t = 0;
        return this.ir(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    ir(e, t) {
        return $2fa92ec193801792$var$PersistencePromise.forEach(this.S_, (n, r)=>this.Fs(e, n, r).next((e)=>e ? $2fa92ec193801792$var$PersistencePromise.resolve() : t(r)));
    }
    removeTargets(e, t, n) {
        return this.persistence.getTargetCache().removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        let n = 0;
        const r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
        return r.u_(e, (r)=>this.Fs(e, r, t).next((e)=>{
                e || (n++, i.removeEntry(r, $2fa92ec193801792$var$SnapshotVersion.min()));
            })).next(()=>i.apply(e)).next(()=>n);
    }
    markPotentiallyOrphaned(e, t) {
        return this.S_.set(t, e.currentSequenceNumber), $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(e, n);
    }
    addReference(e, t, n) {
        return this.S_.set(n, e.currentSequenceNumber), $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.S_.set(n, e.currentSequenceNumber), $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    updateLimboDocument(e, t) {
        return this.S_.set(t, e.currentSequenceNumber), $2fa92ec193801792$var$PersistencePromise.resolve();
    }
    V_(e) {
        let t = e.key.toString().length;
        return e.isFoundDocument() && (t += $2fa92ec193801792$var$__PRIVATE_estimateByteSize(e.data.value)), t;
    }
    Fs(e, t, n) {
        return $2fa92ec193801792$var$PersistencePromise.or([
            ()=>this.persistence.p_(e, t),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>{
                const e = this.S_.get(t);
                return $2fa92ec193801792$var$PersistencePromise.resolve(void 0 !== e && e > n);
            }
        ]);
    }
    getCacheSize(e) {
        return this.persistence.getRemoteDocumentCache().getSize(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class $2fa92ec193801792$var$__PRIVATE_SchemaConverter {
    constructor(e){
        this.serializer = e;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ Mn(e, t, n, r) {
        const i = new $2fa92ec193801792$var$__PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
        n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
            e.createObjectStore($2fa92ec193801792$var$Qt);
        }(e), function __PRIVATE_createMutationQueue(e) {
            e.createObjectStore($2fa92ec193801792$var$zt, {
                keyPath: $2fa92ec193801792$var$jt
            });
            const t = e.createObjectStore($2fa92ec193801792$var$Ht, {
                keyPath: $2fa92ec193801792$var$Jt,
                autoIncrement: true
            });
            t.createIndex($2fa92ec193801792$var$Yt, $2fa92ec193801792$var$Zt, {
                unique: true
            }), e.createObjectStore($2fa92ec193801792$var$en);
        }(e), $2fa92ec193801792$var$__PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
            e.createObjectStore($2fa92ec193801792$var$Wt);
        }(e));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let s = $2fa92ec193801792$var$PersistencePromise.resolve();
        return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function __PRIVATE_dropQueryCache(e) {
            e.deleteObjectStore($2fa92ec193801792$var$Tn), e.deleteObjectStore($2fa92ec193801792$var$cn), e.deleteObjectStore($2fa92ec193801792$var$Vn);
        }(e), $2fa92ec193801792$var$__PRIVATE_createQueryCache(e)), s = s.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
                const t = e.store($2fa92ec193801792$var$Vn), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: $2fa92ec193801792$var$SnapshotVersion.min().toTimestamp(),
                    targetCount: 0
                };
                return t.put($2fa92ec193801792$var$An, n);
            })(i))), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (s = s.next(()=>(function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
                const n = t.store($2fa92ec193801792$var$Ht);
                return n.Kn().next((n)=>{
                    e.deleteObjectStore($2fa92ec193801792$var$Ht);
                    e.createObjectStore($2fa92ec193801792$var$Ht, {
                        keyPath: $2fa92ec193801792$var$Jt,
                        autoIncrement: true
                    }).createIndex($2fa92ec193801792$var$Yt, $2fa92ec193801792$var$Zt, {
                        unique: true
                    });
                    const r = t.store($2fa92ec193801792$var$Ht), i = n.map((e)=>r.put(e));
                    return $2fa92ec193801792$var$PersistencePromise.waitFor(i);
                });
            })(e, i))), s = s.next(()=>{
            !function __PRIVATE_createClientMetadataStore(e) {
                e.createObjectStore($2fa92ec193801792$var$mn, {
                    keyPath: $2fa92ec193801792$var$pn
                });
            }(e);
        })), n < 5 && r >= 5 && (s = s.next(()=>this.D_(i))), n < 6 && r >= 6 && (s = s.next(()=>((function __PRIVATE_createDocumentGlobalStore(e) {
                e.createObjectStore($2fa92ec193801792$var$an);
            })(e), this.x_(i)))), n < 7 && r >= 7 && (s = s.next(()=>this.C_(i))), n < 8 && r >= 8 && (s = s.next(()=>this.F_(e, i))), n < 9 && r >= 9 && (s = s.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
            }(e);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && r >= 10 && (s = s.next(()=>this.O_(i))), n < 11 && r >= 11 && (s = s.next(()=>{
            !function __PRIVATE_createBundlesStore(e) {
                e.createObjectStore($2fa92ec193801792$var$gn, {
                    keyPath: $2fa92ec193801792$var$yn
                });
            }(e), function __PRIVATE_createNamedQueriesStore(e) {
                e.createObjectStore($2fa92ec193801792$var$wn, {
                    keyPath: $2fa92ec193801792$var$bn
                });
            }(e);
        })), n < 12 && r >= 12 && (s = s.next(()=>{
            !function __PRIVATE_createDocumentOverlayStore(e) {
                const t = e.createObjectStore($2fa92ec193801792$var$kn, {
                    keyPath: $2fa92ec193801792$var$qn
                });
                t.createIndex($2fa92ec193801792$var$$n, $2fa92ec193801792$var$Kn, {
                    unique: false
                }), t.createIndex($2fa92ec193801792$var$Wn, $2fa92ec193801792$var$Qn, {
                    unique: false
                });
            }(e);
        })), n < 13 && r >= 13 && (s = s.next(()=>(function __PRIVATE_createRemoteDocumentCache(e) {
                const t = e.createObjectStore($2fa92ec193801792$var$tn, {
                    keyPath: $2fa92ec193801792$var$nn
                });
                t.createIndex($2fa92ec193801792$var$rn, $2fa92ec193801792$var$sn), t.createIndex($2fa92ec193801792$var$_n, $2fa92ec193801792$var$on);
            })(e)).next(()=>this.M_(e, i)).next(()=>e.deleteObjectStore($2fa92ec193801792$var$Wt))), n < 14 && r >= 14 && (s = s.next(()=>this.N_(e, i))), n < 15 && r >= 15 && (s = s.next(()=>(function __PRIVATE_createFieldIndex(e) {
                const t = e.createObjectStore($2fa92ec193801792$var$vn, {
                    keyPath: $2fa92ec193801792$var$Sn,
                    autoIncrement: true
                });
                t.createIndex($2fa92ec193801792$var$Dn, $2fa92ec193801792$var$xn, {
                    unique: false
                });
                const n = e.createObjectStore($2fa92ec193801792$var$Cn, {
                    keyPath: $2fa92ec193801792$var$Fn
                });
                n.createIndex($2fa92ec193801792$var$On, $2fa92ec193801792$var$Mn, {
                    unique: false
                });
                const r = e.createObjectStore($2fa92ec193801792$var$Nn, {
                    keyPath: $2fa92ec193801792$var$Ln
                });
                r.createIndex($2fa92ec193801792$var$Bn, $2fa92ec193801792$var$Un, {
                    unique: false
                });
            })(e))), n < 16 && r >= 16 && // Clear the object stores to remove possibly corrupted index entries
        (s = s.next(()=>{
            t.objectStore($2fa92ec193801792$var$Cn).clear();
        }).next(()=>{
            t.objectStore($2fa92ec193801792$var$Nn).clear();
        })), n < 17 && r >= 17 && (s = s.next(()=>{
            !function __PRIVATE_createGlobalsStore(e) {
                e.createObjectStore($2fa92ec193801792$var$Gn, {
                    keyPath: $2fa92ec193801792$var$zn
                });
            }(e);
        })), n < 18 && r >= 18 && (0, $029952e65115eee5$export$ef10bcfb06572016)() && (s = s.next(()=>{
            t.objectStore($2fa92ec193801792$var$Cn).clear();
        }).next(()=>{
            t.objectStore($2fa92ec193801792$var$Nn).clear();
        })), s;
    }
    x_(e) {
        let t = 0;
        return e.store($2fa92ec193801792$var$Wt).jn((e, n)=>{
            t += $2fa92ec193801792$var$__PRIVATE_dbDocumentSize(n);
        }).next(()=>{
            const n = {
                byteSize: t
            };
            return e.store($2fa92ec193801792$var$an).put($2fa92ec193801792$var$un, n);
        });
    }
    D_(e) {
        const t = e.store($2fa92ec193801792$var$zt), n = e.store($2fa92ec193801792$var$Ht);
        return t.Kn().next((t)=>$2fa92ec193801792$var$PersistencePromise.forEach(t, (t)=>{
                const r = IDBKeyRange.bound([
                    t.userId,
                    $2fa92ec193801792$var$Ke
                ], [
                    t.userId,
                    t.lastAcknowledgedBatchId
                ]);
                return n.Kn($2fa92ec193801792$var$Yt, r).next((n)=>$2fa92ec193801792$var$PersistencePromise.forEach(n, (n)=>{
                        $2fa92ec193801792$var$__PRIVATE_hardAssert(n.userId === t.userId, 18650, "Cannot process batch from unexpected user", {
                            batchId: n.batchId
                        });
                        const r = $2fa92ec193801792$var$__PRIVATE_fromDbMutationBatch(this.serializer, n);
                        return $2fa92ec193801792$var$removeMutationBatch(e, t.userId, r).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ C_(e) {
        const t = e.store($2fa92ec193801792$var$Tn), n = e.store($2fa92ec193801792$var$Wt);
        return e.store($2fa92ec193801792$var$Vn).get($2fa92ec193801792$var$An).next((e)=>{
            const r = [];
            return n.jn((n, i)=>{
                const s = new $2fa92ec193801792$export$db202ddc8be9136(n), _ = function __PRIVATE_sentinelKey(e) {
                    return [
                        0,
                        $2fa92ec193801792$var$__PRIVATE_encodeResourcePath(e)
                    ];
                }(s);
                r.push(t.get(_).next((n)=>n ? $2fa92ec193801792$var$PersistencePromise.resolve() : ((n)=>t.put({
                            targetId: 0,
                            path: $2fa92ec193801792$var$__PRIVATE_encodeResourcePath(n),
                            sequenceNumber: e.highestListenSequenceNumber
                        }))(s)));
            }).next(()=>$2fa92ec193801792$var$PersistencePromise.waitFor(r));
        });
    }
    F_(e, t) {
        // Create the index.
        e.createObjectStore($2fa92ec193801792$var$dn, {
            keyPath: $2fa92ec193801792$var$fn
        });
        const n = t.store($2fa92ec193801792$var$dn), r = new $2fa92ec193801792$var$__PRIVATE_MemoryCollectionParentIndex, addEntry = (e)=>{
            if (r.add(e)) {
                const t = e.lastSegment(), r = e.popLast();
                return n.put({
                    collectionId: t,
                    parent: $2fa92ec193801792$var$__PRIVATE_encodeResourcePath(r)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return t.store($2fa92ec193801792$var$Wt).jn({
            zn: true
        }, (e, t)=>{
            const n = new $2fa92ec193801792$export$db202ddc8be9136(e);
            return addEntry(n.popLast());
        }).next(()=>t.store($2fa92ec193801792$var$en).jn({
                zn: true
            }, ([e, t, n], r)=>{
                const i = $2fa92ec193801792$var$__PRIVATE_decodeResourcePath(t);
                return addEntry(i.popLast());
            }));
    }
    O_(e) {
        const t = e.store($2fa92ec193801792$var$cn);
        return t.jn((e, n)=>{
            const r = $2fa92ec193801792$var$__PRIVATE_fromDbTarget(this.serializer, n), i = $2fa92ec193801792$var$__PRIVATE_toDbTarget(this.serializer, r);
            return t.put(i);
        });
    }
    M_(e, t) {
        const n = t.store($2fa92ec193801792$var$Wt), r = [];
        return n.jn((e, n)=>{
            const i = t.store($2fa92ec193801792$var$tn), s = (function __PRIVATE_extractKey(e) {
                return e.document ? new $2fa92ec193801792$export$a07804094c3ecf2d($2fa92ec193801792$export$db202ddc8be9136.fromString(e.document.name).popFirst(5)) : e.noDocument ? $2fa92ec193801792$export$a07804094c3ecf2d.fromSegments(e.noDocument.path) : e.unknownDocument ? $2fa92ec193801792$export$a07804094c3ecf2d.fromSegments(e.unknownDocument.path) : $2fa92ec193801792$export$1a82df3d29112e01(36783);
            })(n).path.toArray(), _ = {
                prefixPath: s.slice(0, s.length - 2),
                collectionGroup: s[s.length - 2],
                documentId: s[s.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            r.push(i.put(_));
        }).next(()=>$2fa92ec193801792$var$PersistencePromise.waitFor(r));
    }
    N_(e, t) {
        const n = t.store($2fa92ec193801792$var$Ht), r = $2fa92ec193801792$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new $2fa92ec193801792$var$__PRIVATE_MemoryPersistence($2fa92ec193801792$var$__PRIVATE_MemoryEagerDelegate.w_, this.serializer.qr);
        return n.Kn().next((e)=>{
            const n = new Map;
            return e.forEach((e)=>{
                let t = n.get(e.userId) ?? $2fa92ec193801792$export$a9c996f45e5784d0();
                $2fa92ec193801792$var$__PRIVATE_fromDbMutationBatch(this.serializer, e).keys().forEach((e)=>t = t.add(e)), n.set(e.userId, t);
            }), $2fa92ec193801792$var$PersistencePromise.forEach(n, (e, n)=>{
                const s = new $2fa92ec193801792$var$User(n), _ = $2fa92ec193801792$var$__PRIVATE_IndexedDbDocumentOverlayCache.Kr(this.serializer, s), o = i.getIndexManager(s), a = $2fa92ec193801792$var$__PRIVATE_IndexedDbMutationQueue.Kr(s, this.serializer, o, i.referenceDelegate);
                return new $2fa92ec193801792$var$LocalDocumentsView(r, a, _, o).recalculateAndSaveOverlaysForDocumentKeys(new $2fa92ec193801792$var$__PRIVATE_IndexedDbTransaction(t, $2fa92ec193801792$var$__PRIVATE_ListenSequence.yn), e).next();
            });
        });
    }
}
function $2fa92ec193801792$var$__PRIVATE_createQueryCache(e) {
    e.createObjectStore($2fa92ec193801792$var$Tn, {
        keyPath: $2fa92ec193801792$var$Pn
    }).createIndex($2fa92ec193801792$var$Rn, $2fa92ec193801792$var$In, {
        unique: true
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore($2fa92ec193801792$var$cn, {
        keyPath: "targetId"
    }).createIndex($2fa92ec193801792$var$En, $2fa92ec193801792$var$hn, {
        unique: true
    }), e.createObjectStore($2fa92ec193801792$var$Vn);
}
const $2fa92ec193801792$var$sr = "IndexedDbPersistence", $2fa92ec193801792$var$_r = 18e5, $2fa92ec193801792$var$ar = 5e3, $2fa92ec193801792$var$ur = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.", $2fa92ec193801792$var$cr = "main";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the "primary client". An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s "owner" store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class $2fa92ec193801792$var$__PRIVATE_IndexedDbPersistence {
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ e, t, n, r, i, _, o, a, u, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ c, l = 18){
        if (this.allowTabSynchronization = e, this.persistenceKey = t, this.clientId = n, this.xt = i, this.window = _, this.document = o, this.L_ = u, this.B_ = c, this.U_ = l, this.P_ = null, this.R_ = false, this.isPrimary = false, this.networkEnabled = true, /** Our window.unload handler, if registered. */ this.k_ = null, this.inForeground = false, /** Our 'visibilitychange' listener if registered. */ this.q_ = null, /** The client metadata refresh task. */ this.K_ = null, /** The last time we garbage collected the client metadata object store. */ this.W_ = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.Q_ = (e)=>Promise.resolve(), !$2fa92ec193801792$var$__PRIVATE_IndexedDbPersistence.Je()) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $2fa92ec193801792$var$__PRIVATE_IndexedDbLruDelegateImpl(this, r), this.G_ = t + $2fa92ec193801792$var$cr, this.serializer = new $2fa92ec193801792$var$__PRIVATE_LocalSerializer(a), this.z_ = new $2fa92ec193801792$var$__PRIVATE_SimpleDb(this.G_, this.U_, new $2fa92ec193801792$var$__PRIVATE_SchemaConverter(this.serializer)), this.I_ = new $2fa92ec193801792$var$__PRIVATE_IndexedDbGlobalsCache, this.A_ = new $2fa92ec193801792$var$__PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), this.remoteDocumentCache = $2fa92ec193801792$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), this.d_ = new $2fa92ec193801792$var$__PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.j_ = this.window.localStorage : (this.j_ = null, false === c && $2fa92ec193801792$var$__PRIVATE_logError($2fa92ec193801792$var$sr, "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.H_().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION, $2fa92ec193801792$var$ur);
            return this.J_(), this.Y_(), this.Z_(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (e)=>this.A_.getHighestSequenceNumber(e));
        }).then((e)=>{
            this.P_ = new $2fa92ec193801792$var$__PRIVATE_ListenSequence(e, this.L_);
        }).then(()=>{
            this.R_ = true;
        }).catch((e)=>(this.z_ && this.z_.close(), Promise.reject(e)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ X_(e) {
        return this.Q_ = async (t)=>{
            if (this.started) return e(t);
        }, e(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(e) {
        this.z_.Ln(async (t)=>{
            // Check if an attempt is made to delete IndexedDB.
            null === t.newVersion && await e();
        });
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(e) {
        this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.xt.enqueueAndForget(async ()=>{
            this.started && await this.H_();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ H_() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (e)=>$2fa92ec193801792$var$__PRIVATE_clientMetadataStore(e).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.eo(e).next((e)=>{
                    e || (this.isPrimary = false, this.xt.enqueueRetryable(()=>this.Q_(false)));
                });
            }).next(()=>this.no(e)).next((t)=>this.isPrimary && !t ? this.ro(e).next(()=>false) : !!t && this.io(e).next(()=>true))).catch((e)=>{
            if ($2fa92ec193801792$var$__PRIVATE_isIndexedDbTransactionError(e)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$sr, "Failed to extend owner lease: ", e), this.isPrimary;
            if (!this.allowTabSynchronization) throw e;
            return $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$sr, "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ false;
        }).then((e)=>{
            this.isPrimary !== e && this.xt.enqueueRetryable(()=>this.Q_(e)), this.isPrimary = e;
        });
    }
    eo(e) {
        return $2fa92ec193801792$var$__PRIVATE_primaryClientStore(e).get($2fa92ec193801792$var$Gt).next((e)=>$2fa92ec193801792$var$PersistencePromise.resolve(this.so(e)));
    }
    _o(e) {
        return $2fa92ec193801792$var$__PRIVATE_clientMetadataStore(e).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async oo() {
        if (this.isPrimary && !this.ao(this.W_, $2fa92ec193801792$var$_r)) {
            this.W_ = Date.now();
            const e = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (e)=>{
                const t = $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$mn);
                return t.Kn().next((e)=>{
                    const n = this.uo(e, $2fa92ec193801792$var$_r), r = e.filter((e)=>-1 === n.indexOf(e));
                    // Delete metadata for clients that are no longer considered active.
                    return $2fa92ec193801792$var$PersistencePromise.forEach(r, (e)=>t.delete(e.clientId)).next(()=>r);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this.j_) for (const t of e)this.j_.removeItem(this.co(t.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ Z_() {
        this.K_ = this.xt.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, ()=>this.H_().then(()=>this.oo()).then(()=>this.Z_()));
    }
    /** Checks whether `client` is the local client. */ so(e) {
        return !!e && e.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ no(e) {
        if (this.B_) return $2fa92ec193801792$var$PersistencePromise.resolve(true);
        return $2fa92ec193801792$var$__PRIVATE_primaryClientStore(e).get($2fa92ec193801792$var$Gt).next((t)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== t && this.ao(t.leaseTimestampMs, $2fa92ec193801792$var$ar) && !this.lo(t.ownerId)) {
                if (this.so(t) && this.networkEnabled) return true;
                if (!this.so(t)) {
                    if (!t.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION, $2fa92ec193801792$var$ur);
                    return false;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || $2fa92ec193801792$var$__PRIVATE_clientMetadataStore(e).Kn().next((e)=>void 0 === this.uo(e, $2fa92ec193801792$var$ar).find((e)=>{
                    if (this.clientId !== e.clientId) {
                        const t = !this.networkEnabled && e.networkEnabled, n = !this.inForeground && e.inForeground, r = this.networkEnabled === e.networkEnabled;
                        if (t || n && r) return true;
                    }
                    return false;
                }));
        }).next((e)=>(this.isPrimary !== e && $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$sr, `Client ${e ? "is" : "is not"} eligible for a primary lease.`), e));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.R_ = false, this.Eo(), this.K_ && (this.K_.cancel(), this.K_ = null), this.ho(), this.To(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.z_.runTransaction("shutdown", "readwrite", [
            $2fa92ec193801792$var$Qt,
            $2fa92ec193801792$var$mn
        ], (e)=>{
            const t = new $2fa92ec193801792$var$__PRIVATE_IndexedDbTransaction(e, $2fa92ec193801792$var$__PRIVATE_ListenSequence.yn);
            return this.ro(t).next(()=>this._o(t));
        }), this.z_.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.Po();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ uo(e, t) {
        return e.filter((e)=>this.ao(e.updateTimeMs, t) && !this.lo(e.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ Ro() {
        return this.runTransaction("getActiveClients", "readonly", (e)=>$2fa92ec193801792$var$__PRIVATE_clientMetadataStore(e).Kn().next((e)=>this.uo(e, $2fa92ec193801792$var$_r).map((e)=>e.clientId)));
    }
    get started() {
        return this.R_;
    }
    getGlobalsCache() {
        return this.I_;
    }
    getMutationQueue(e, t) {
        return $2fa92ec193801792$var$__PRIVATE_IndexedDbMutationQueue.Kr(e, this.serializer, t, this.referenceDelegate);
    }
    getTargetCache() {
        return this.A_;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(e) {
        return new $2fa92ec193801792$var$__PRIVATE_IndexedDbIndexManager(e, this.serializer.qr.databaseId);
    }
    getDocumentOverlayCache(e) {
        return $2fa92ec193801792$var$__PRIVATE_IndexedDbDocumentOverlayCache.Kr(this.serializer, e);
    }
    getBundleCache() {
        return this.d_;
    }
    runTransaction(e, t, n) {
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$sr, "Starting transaction:", e);
        const r = "readonly" === t ? "readonly" : "readwrite", i = /** Returns the object stores for the provided schema. */ function __PRIVATE_getObjectStores(e) {
            return 18 === e ? $2fa92ec193801792$var$tr : 17 === e ? $2fa92ec193801792$var$er : 16 === e ? $2fa92ec193801792$var$Xn : 15 === e ? $2fa92ec193801792$var$Zn : 14 === e ? $2fa92ec193801792$var$Yn : 13 === e ? $2fa92ec193801792$var$Jn : 12 === e ? $2fa92ec193801792$var$Hn : 11 === e ? $2fa92ec193801792$var$jn : void $2fa92ec193801792$export$1a82df3d29112e01(60245);
        }(this.U_);
        let _;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.z_.runTransaction(e, r, i, (r)=>(_ = new $2fa92ec193801792$var$__PRIVATE_IndexedDbTransaction(r, this.P_ ? this.P_.next() : $2fa92ec193801792$var$__PRIVATE_ListenSequence.yn), "readwrite-primary" === t ? this.eo(_).next((e)=>!!e || this.no(_)).next((t)=>{
                if (!t) throw $2fa92ec193801792$var$__PRIVATE_logError(`Failed to obtain primary lease for action '${e}'.`), this.isPrimary = false, this.xt.enqueueRetryable(()=>this.Q_(false)), new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION, $2fa92ec193801792$var$pt);
                return n(_);
            }).next((e)=>this.io(_).next(()=>e)) : this.Io(_).next(()=>n(_)))).then((e)=>(_.raiseOnCommittedEvent(), e));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    Io(e) {
        return $2fa92ec193801792$var$__PRIVATE_primaryClientStore(e).get($2fa92ec193801792$var$Gt).next((e)=>{
            if (null !== e && this.ao(e.leaseTimestampMs, $2fa92ec193801792$var$ar) && !this.lo(e.ownerId) && !this.so(e) && !(this.B_ || this.allowTabSynchronization && e.allowTabSynchronization)) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION, $2fa92ec193801792$var$ur);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ io(e) {
        const t = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return $2fa92ec193801792$var$__PRIVATE_primaryClientStore(e).put($2fa92ec193801792$var$Gt, t);
    }
    static Je() {
        return $2fa92ec193801792$var$__PRIVATE_SimpleDb.Je();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ ro(e) {
        const t = $2fa92ec193801792$var$__PRIVATE_primaryClientStore(e);
        return t.get($2fa92ec193801792$var$Gt).next((e)=>this.so(e) ? ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$sr, "Releasing primary lease."), t.delete($2fa92ec193801792$var$Gt)) : $2fa92ec193801792$var$PersistencePromise.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ ao(e, t) {
        const n = Date.now();
        return !(e < n - t) && (!(e > n) || ($2fa92ec193801792$var$__PRIVATE_logError(`Detected an update time that is in the future: ${e} > ${n}`), false));
    }
    J_() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.q_ = ()=>{
            this.xt.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.H_()));
        }, this.document.addEventListener("visibilitychange", this.q_), this.inForeground = "visible" === this.document.visibilityState);
    }
    ho() {
        this.q_ && (this.document.removeEventListener("visibilitychange", this.q_), this.q_ = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ Y_() {
        "function" == typeof this.window?.addEventListener && (this.k_ = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this.Eo();
            const e = /(?:Version|Mobile)\/1[456]/;
            (0, $029952e65115eee5$export$95df08bae54cb4df)() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.xt.enterRestrictedMode(/* purgeExistingTasks= */ true), this.xt.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.k_));
    }
    To() {
        this.k_ && (this.window.removeEventListener("pagehide", this.k_), this.k_ = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ lo(e) {
        try {
            const t = null !== this.j_?.getItem(this.co(e));
            return $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$sr, `Client '${e}' ${t ? "is" : "is not"} zombied in LocalStorage`), t;
        } catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            return $2fa92ec193801792$var$__PRIVATE_logError($2fa92ec193801792$var$sr, "Failed to get zombied client id.", e), false;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ Eo() {
        if (this.j_) try {
            this.j_.setItem(this.co(this.clientId), String(Date.now()));
        } catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            $2fa92ec193801792$var$__PRIVATE_logError("Failed to set zombie client id.", e);
        }
    }
    /** Removes the zombied client entry if it exists. */ Po() {
        if (this.j_) try {
            this.j_.removeItem(this.co(this.clientId));
        } catch (e) {
        // Ignore
        }
    }
    co(e) {
        return `firestore_zombie_${this.persistenceKey}_${e}`;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $2fa92ec193801792$var$__PRIVATE_primaryClientStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$Qt);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $2fa92ec193801792$var$__PRIVATE_clientMetadataStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_getStore(e, $2fa92ec193801792$var$mn);
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $2fa92ec193801792$var$__PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class $2fa92ec193801792$var$__PRIVATE_LocalViewChanges {
    constructor(e, t, n, r){
        this.targetId = e, this.fromCache = t, this.Ao = n, this.Vo = r;
    }
    static fo(e, t) {
        let n = $2fa92ec193801792$export$a9c996f45e5784d0(), r = $2fa92ec193801792$export$a9c996f45e5784d0();
        for (const e of t.docChanges)switch(e.type){
            case 0 /* ChangeType.Added */ :
                n = n.add(e.doc.key);
                break;
            case 1 /* ChangeType.Removed */ :
                r = r.add(e.doc.key);
        }
        return new $2fa92ec193801792$var$__PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2fa92ec193801792$var$__PRIVATE_compareByKey(e, t) {
    return $2fa92ec193801792$export$a07804094c3ecf2d.comparator(e.key, t.key);
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A tracker to keep a record of important details during database local query
 * execution.
 */ class $2fa92ec193801792$var$QueryContext {
    constructor(){
        /**
         * Counts the number of documents passed through during local query execution.
         */ this._documentReadCount = 0;
    }
    get documentReadCount() {
        return this._documentReadCount;
    }
    incrementDocumentReadCount(e) {
        this._documentReadCount += e;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class $2fa92ec193801792$var$__PRIVATE_QueryEngine {
    constructor(){
        this.mo = false, this.po = false, /**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */ this.yo = 100, this.wo = /**
 * This cost represents the evaluation result of
 * (([index, docKey] + [docKey, docContent]) per document in the result set)
 * / ([docKey, docContent] per documents in full collection scan) coming from
 * experiment [enter PR experiment URL here].
 */ function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument() {
            // These values were derived from an experiment where several members of the
            // Firestore SDK team ran a performance test in various environments.
            // Googlers can see b/299284287 for details.
            return (0, $029952e65115eee5$export$95df08bae54cb4df)() ? 8 : $2fa92ec193801792$var$__PRIVATE_getAndroidVersion((0, $029952e65115eee5$export$c36915b22ce77c19)()) > 0 ? 6 : 4;
        }();
    }
    /** Sets the document view to query against. */ initialize(e, t) {
        this.bo = e, this.indexManager = t, this.mo = true;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(e, t, n, r) {
        // Stores the result from executing the query; using this object is more
        // convenient than passing the result between steps of the persistence
        // transaction and improves readability comparatively.
        const i = {
            result: null
        };
        return this.vo(e, t).next((e)=>{
            i.result = e;
        }).next(()=>{
            if (!i.result) return this.So(e, t, r, n).next((e)=>{
                i.result = e;
            });
        }).next(()=>{
            if (i.result) return;
            const n = new $2fa92ec193801792$var$QueryContext;
            return this.Do(e, t, n).next((r)=>{
                if (i.result = r, this.po) return this.xo(e, t, n, r.size);
            });
        }).next(()=>i.result);
    }
    xo(e, t, n, r) {
        return $2fa92ec193801792$export$342063e11d6c3cad(t) ? $2fa92ec193801792$var$PersistencePromise.resolve() : n.documentReadCount < this.yo ? ($2fa92ec193801792$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $2fa92ec193801792$export$2329c99376c9d0a4("QueryEngine", "SDK will not create cache indexes for query:", $2fa92ec193801792$var$__PRIVATE_stringifyQuery(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.yo, "documents"), $2fa92ec193801792$var$PersistencePromise.resolve()) : ($2fa92ec193801792$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $2fa92ec193801792$export$2329c99376c9d0a4("QueryEngine", "Query:", $2fa92ec193801792$var$__PRIVATE_stringifyQuery(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.wo * r ? ($2fa92ec193801792$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $2fa92ec193801792$export$2329c99376c9d0a4("QueryEngine", "The SDK decides to create cache indexes for query:", $2fa92ec193801792$var$__PRIVATE_stringifyQuery(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, $2fa92ec193801792$var$__PRIVATE_queryToTarget(t))) : $2fa92ec193801792$var$PersistencePromise.resolve());
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ vo(e, t) {
        if ($2fa92ec193801792$export$342063e11d6c3cad(t)) return $2fa92ec193801792$var$PersistencePromise.resolve(null);
        let n = t;
        if ($2fa92ec193801792$var$__PRIVATE_queryMatchesAllDocuments(n)) // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return $2fa92ec193801792$var$PersistencePromise.resolve(null);
        let r = $2fa92ec193801792$var$__PRIVATE_queryToTarget(n);
        return this.indexManager.getIndexType(e, r).next((t)=>0 /* IndexType.NONE */  === t ? null : (null !== n.limit && 1 /* IndexType.PARTIAL */  === t && // We cannot apply a limit for targets that are served using a partial
            // index. If a partial index will be used to serve the target, the
            // query may return a superset of documents that match the target
            // (e.g. if the index doesn't include all the target's filters), or
            // may return the correct set of documents in the wrong order (e.g. if
            // the index doesn't include a segment for one of the orderBys).
            // Therefore, a limit should not be applied in such cases.
            (n = $2fa92ec193801792$export$dda1d9f60106f0e9(n, null, "F" /* LimitType.First */ ), r = $2fa92ec193801792$var$__PRIVATE_queryToTarget(n)), this.indexManager.getDocumentsMatchingTarget(e, r).next((t)=>{
                const i = $2fa92ec193801792$export$a9c996f45e5784d0(...t);
                return this.bo.getDocuments(e, i).next((t)=>this.indexManager.getMinOffset(e, r).next((r)=>{
                        const s = this.Co(n, t);
                        return this.Fo(n, s, i, r.readTime) ? this.vo(e, $2fa92ec193801792$export$dda1d9f60106f0e9(n, null, "F" /* LimitType.First */ )) : this.Oo(e, s, n, r);
                    }));
            })));
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ So(e, t, n, r) {
        return ($2fa92ec193801792$export$342063e11d6c3cad(t) ? function __PRIVATE_pipelineMatchesAllDocuments(e) {
            for (const t of e.stages){
                if (t instanceof $2fa92ec193801792$export$56350196709588fc || t instanceof $2fa92ec193801792$export$4e222d082f82ee97) return false;
                // Check if it's the special 'exists(__name__)' case
                if (t instanceof $2fa92ec193801792$export$4b170465d7badfa1) {
                    if (t.condition instanceof $2fa92ec193801792$var$__PRIVATE_BooleanFunctionExpression && "exists" === t.condition._expr.name && t.condition._expr.params[0] instanceof $2fa92ec193801792$export$e0c3a065614c6254 && t.condition._expr.params[0].fieldName === $2fa92ec193801792$var$Ce) continue;
                    return false;
                }
            }
            return true;
        }(t) : $2fa92ec193801792$var$__PRIVATE_queryMatchesAllDocuments(t)) || r.isEqual($2fa92ec193801792$var$SnapshotVersion.min()) ? $2fa92ec193801792$var$PersistencePromise.resolve(null) : this.bo.getDocuments(e, n).next((i)=>{
            const s = this.Co(t, i);
            return this.Fo(t, s, n, r) ? $2fa92ec193801792$var$PersistencePromise.resolve(null) : ($2fa92ec193801792$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $2fa92ec193801792$export$2329c99376c9d0a4("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), $2fa92ec193801792$var$__PRIVATE_stringifyQueryOrPipeline(t)), this.Oo(e, s, t, $2fa92ec193801792$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $2fa92ec193801792$var$Xe)).next((e)=>e));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ Co(e, t) {
        let n, r;
        return $2fa92ec193801792$export$342063e11d6c3cad(e) ? // TODO(pipeline): the order here does not actually matter, not until we implement
        // refill logic for pipelines as well.
        (n = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$var$__PRIVATE_compareByKey), r = (t)=>$2fa92ec193801792$var$__PRIVATE_pipelineMatches(e, t)) : // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        (n = new $2fa92ec193801792$var$SortedSet($2fa92ec193801792$export$7ccc53e8f1e7dfc5(e)), r = (t)=>$2fa92ec193801792$var$__PRIVATE_queryMatches(e, t)), t.forEach((e, t)=>{
            r(t) && (n = n.add(t));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ Fo(e, t, n, r) {
        // TODO(pipeline): For pipelines it is simple for now, we refill for all limit/offset.
        // we should implement a similar approach for query at some point.
        if ($2fa92ec193801792$export$342063e11d6c3cad(e)) return function __PRIVATE_pipelineHasRanges(e) {
            return e.stages.some((e)=>e instanceof $2fa92ec193801792$export$56350196709588fc || e instanceof $2fa92ec193801792$export$4e222d082f82ee97);
        }(e);
        if (null === e.limit) // Queries without limits do not need to be refilled.
        return false;
        if (n.size !== t.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return true;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* LimitType.First */  === e.limitType ? t.last() : t.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
    }
    Do(e, t, n) {
        return $2fa92ec193801792$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $2fa92ec193801792$export$2329c99376c9d0a4("QueryEngine", "Using full collection scan to execute query:", $2fa92ec193801792$var$__PRIVATE_stringifyQueryOrPipeline(t)), this.bo.getDocumentsMatchingQuery(e, t, $2fa92ec193801792$var$IndexOffset.min(), n);
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ Oo(e, t, n, r) {
        // Retrieve all results for documents that were updated since the offset.
        return this.bo.getDocumentsMatchingQuery(e, n, r).next((e)=>// Merge with existing results
            (t.forEach((t)=>{
                e = e.insert(t.key, t);
            }), e));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$lr = "LocalStore", $2fa92ec193801792$var$Er = 3e8;
/**
 * The maximum time to leave a resume token buffered without writing it out.
 * This value is arbitrary: it's long enough to avoid several writes
 * (possibly indefinitely if updates come more frequently than this) but
 * short enough that restarting after crashing will still have a pretty
 * recent resume token.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $2fa92ec193801792$var$__PRIVATE_LocalStoreImpl {
    constructor(/** Manages our in-memory or durable persistence. */ e, t, n, r){
        this.persistence = e, this.Mo = t, this.serializer = r, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.No = new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$var$__PRIVATE_primitiveComparator), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.Lo = new $2fa92ec193801792$var$ObjectMap((e)=>$2fa92ec193801792$var$__PRIVATE_canonifyTargetOrPipeline(e), $2fa92ec193801792$var$__PRIVATE_targetOrPipelineEqual), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.Bo = new Map, this.Uo = e.getRemoteDocumentCache(), this.A_ = e.getTargetCache(), this.d_ = e.getBundleCache(), this.ko(n);
    }
    ko(e) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new $2fa92ec193801792$var$LocalDocumentsView(this.Uo, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.Uo.setIndexManager(this.indexManager), this.Mo.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(e) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (t)=>e.collect(t, this.No));
    }
}
function $2fa92ec193801792$var$__PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
    return new $2fa92ec193801792$var$__PRIVATE_LocalStoreImpl(e, t, n, r);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function $2fa92ec193801792$var$__PRIVATE_localStoreHandleUserChange(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    return await n.persistence.runTransaction("Handle user change", "readonly", (e)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let r;
        return n.mutationQueue.getAllMutationBatches(e).next((i)=>(r = i, n.ko(t), n.mutationQueue.getAllMutationBatches(e))).next((t)=>{
            const i = [], s = [];
            // Union the old/new changed keys.
            let _ = $2fa92ec193801792$export$a9c996f45e5784d0();
            for (const e of r){
                i.push(e.batchId);
                for (const t of e.mutations)_ = _.add(t.key);
            }
            for (const e of t){
                s.push(e.batchId);
                for (const t of e.mutations)_ = _.add(t.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(e, _).next((e)=>({
                    qo: e,
                    removedBatchIds: i,
                    addedBatchIds: s
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $2fa92ec193801792$var$__PRIVATE_localStoreAcknowledgeBatch(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (e)=>{
        const r = t.batch.keys(), i = n.Uo.newChangeBuffer({
            trackRemovals: true
        });
        return (function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            const i = n.batch, s = i.keys();
            let _ = $2fa92ec193801792$var$PersistencePromise.resolve();
            return s.forEach((e)=>{
                _ = _.next(()=>r.getEntry(t, e)).next((t)=>{
                    const s = n.docVersions.get(e);
                    $2fa92ec193801792$var$__PRIVATE_hardAssert(null !== s, 48541), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (t.setReadTime(n.commitVersion), r.addEntry(t)));
                });
            }), _.next(()=>e.mutationQueue.removeMutationBatch(t, i));
        })(n, e, t, i).next(()=>i.apply(e)).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
                let t = $2fa92ec193801792$export$a9c996f45e5784d0();
                for(let n = 0; n < e.mutationResults.length; ++n)e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
                return t;
            }(t))).next(()=>n.localDocuments.getDocuments(e, r));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $2fa92ec193801792$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    const t = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (e)=>t.A_.getLastRemoteSnapshotVersion(e));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $2fa92ec193801792$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = t.snapshotVersion;
    let i = n.No;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (e)=>{
        const s = n.Uo.newChangeBuffer({
            trackRemovals: true
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.No;
        const _ = [];
        t.targetChanges.forEach((s, o)=>{
            const a = i.get(o);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            _.push(n.A_.removeMatchingKeys(e, s.removedDocuments, o).next(()=>n.A_.addMatchingKeys(e, s.addedDocuments, o)));
            let u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(o) ? u = u.withResumeToken($2fa92ec193801792$export$158acd800e1ef08b.EMPTY_BYTE_STRING, $2fa92ec193801792$var$SnapshotVersion.min()).withLastLimboFreeSnapshotVersion($2fa92ec193801792$var$SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), i = i.insert(o, u), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return true;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                const r = t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds();
                if (r >= $2fa92ec193801792$var$Er) return true;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                const i = n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size;
                return i > 0;
            }(a, u, s) && _.push(n.A_.updateTargetData(e, u));
        });
        let o = $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap(), a = $2fa92ec193801792$export$a9c996f45e5784d0();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach((r)=>{
            t.resolvedLimboDocuments.has(r) && _.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        _.push($2fa92ec193801792$var$__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next((e)=>{
            o = e.$o, a = e.Ko;
        })), !r.isEqual($2fa92ec193801792$var$SnapshotVersion.min())) {
            const t = n.A_.getLastRemoteSnapshotVersion(e).next((t)=>n.A_.setTargetsMetadata(e, e.currentSequenceNumber, r));
            _.push(t);
        }
        return $2fa92ec193801792$var$PersistencePromise.waitFor(_).next(()=>s.apply(e)).next(()=>n.localDocuments.getLocalViewOfDocuments(e, o, a)).next(()=>o);
    }).then((e)=>(n.No = i, e));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $2fa92ec193801792$var$__PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    let r = $2fa92ec193801792$export$a9c996f45e5784d0(), i = $2fa92ec193801792$export$a9c996f45e5784d0();
    return n.forEach((e)=>r = r.add(e)), t.getEntries(e, r).next((e)=>{
        let r = $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap();
        return n.forEach((n, s)=>{
            const _ = e.get(n);
            // Check if see if there is a existence state change for this document.
            s.isFoundDocument() !== _.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual($2fa92ec193801792$var$SnapshotVersion.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !_.isValidDocument() || s.version.compareTo(_.version) > 0 || 0 === s.version.compareTo(_.version) && _.hasPendingWrites ? (t.addEntry(s), r = r.insert(n, s)) : $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$lr, "Ignoring outdated watch update for ", n, ". Current version:", _.version, " Watch version:", s.version);
        }), {
            $o: r,
            Ko: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $2fa92ec193801792$var$__PRIVATE_localStoreGetNextMutationBatch(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (e)=>(void 0 === t && (t = $2fa92ec193801792$var$Ke), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $2fa92ec193801792$var$__PRIVATE_localStoreAllocateTarget(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", (e)=>{
        let r;
        return n.A_.getTargetData(e, t).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, $2fa92ec193801792$var$PersistencePromise.resolve(r)) : n.A_.allocateTargetId(e).next((i)=>(r = new $2fa92ec193801792$var$TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), n.A_.addTargetData(e, r).next(()=>r))));
    }).then((e)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const r = n.No.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.No = n.No.insert(e.targetId, e), n.Lo.set(t, e.targetId)), e;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function $2fa92ec193801792$var$__PRIVATE_localStoreReleaseTarget(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_debugCast(e), i = r.No.get(t), s = n ? "readwrite" : "readwrite-primary";
    try {
        n || await r.persistence.runTransaction("Release target", s, (e)=>r.persistence.referenceDelegate.removeTarget(e, i));
    } catch (e) {
        if (!$2fa92ec193801792$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$lr, `Failed to update sequence numbers for target ${t}: ${e}`);
    }
    r.No = r.No.remove(t), // TODO(pipeline): This needs to handle pipeline properly.
    r.Lo.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $2fa92ec193801792$var$__PRIVATE_localStoreExecuteQuery(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    let i = $2fa92ec193801792$var$SnapshotVersion.min(), s = $2fa92ec193801792$export$a9c996f45e5784d0();
    return r.persistence.runTransaction("Execute query", "readwrite", // Use readwrite instead of readonly so indexes can be created
    (e)=>(function __PRIVATE_localStoreGetTargetData(e, t, n) {
            const r = $2fa92ec193801792$var$__PRIVATE_debugCast(e), i = r.Lo.get(n);
            return void 0 !== i ? $2fa92ec193801792$var$PersistencePromise.resolve(r.No.get(i)) : r.A_.getTargetData(t, n);
        })(r, e, $2fa92ec193801792$export$342063e11d6c3cad(t) ? t : $2fa92ec193801792$var$__PRIVATE_queryToTarget(t)).next((t)=>{
            if (t) return i = t.lastLimboFreeSnapshotVersion, r.A_.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
                s = e;
            });
        }).next(()=>r.Mo.getDocumentsMatchingQuery(e, t, n ? i : $2fa92ec193801792$var$SnapshotVersion.min(), n ? s : $2fa92ec193801792$export$a9c996f45e5784d0())).next((e)=>// TODO(pipeline): this needs to be adapted to support other pipeline flavors.
            // For now, only 'exact' flavor is supported and it is enough.
            ($2fa92ec193801792$var$__PRIVATE_setMaxReadTime(r, e), {
                documents: e,
                Wo: s
            })));
}
// PORTING NOTE: Multi-Tab only.
function $2fa92ec193801792$var$__PRIVATE_localStoreGetCachedTarget(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = $2fa92ec193801792$var$__PRIVATE_debugCast(n.A_), i = n.No.get(t);
    return i ? Promise.resolve(i.target ?? null) : n.persistence.runTransaction("Get target data", "readonly", (e)=>r.ge(e, t).next((e)=>e?.target ?? null));
}
// PORTING NOTE: Multi-Tab only.
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $2fa92ec193801792$var$__PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = n.Bo.get(t) || $2fa92ec193801792$var$SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (e)=>n.Uo.getAllFromCollectionGroup(e, t, $2fa92ec193801792$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $2fa92ec193801792$var$Xe), /* limit= */ Number.MAX_SAFE_INTEGER)).then((e)=>($2fa92ec193801792$var$__PRIVATE_setMaxReadTime(n, e), e));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $2fa92ec193801792$var$__PRIVATE_setMaxReadTime(e, t) {
    t.forEach((t, n)=>{
        const r = n.key.getCollectionGroup(), i = e.Bo.get(r) || $2fa92ec193801792$var$SnapshotVersion.min();
        n.readTime.compareTo(i) > 0 && e.Bo.set(r, n.readTime);
    });
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function $2fa92ec193801792$var$__PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    const i = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    let s = $2fa92ec193801792$export$a9c996f45e5784d0(), _ = $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap();
    for (const e of n){
        const n = t.Qo(e.metadata.name);
        e.document && (s = s.add(n));
        const r = t.Go(e);
        r.setReadTime(t.zo(e.metadata.readTime)), _ = _.insert(n, r);
    }
    const o = i.Uo.newChangeBuffer({
        trackRemovals: true
    }), a = await $2fa92ec193801792$var$__PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return $2fa92ec193801792$var$__PRIVATE_queryToTarget($2fa92ec193801792$export$3c2fa207a37baaea($2fa92ec193801792$export$db202ddc8be9136.fromString(`__bundle__/docs/${e}`)));
    }(r));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (e)=>$2fa92ec193801792$var$__PRIVATE_populateDocumentChangeBuffer(e, o, _).next((t)=>(o.apply(e), t)).next((t)=>i.A_.removeMatchingKeysForTargetId(e, a.targetId).next(()=>i.A_.addMatchingKeys(e, s, a.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(e, t.$o, t.Ko)).next(()=>t.$o)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function $2fa92ec193801792$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n = $2fa92ec193801792$export$a9c996f45e5784d0()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const r = await $2fa92ec193801792$var$__PRIVATE_localStoreAllocateTarget(e, $2fa92ec193801792$var$__PRIVATE_queryToTarget($2fa92ec193801792$export$2e2af4578d910ddf(t.bundledQuery))), i = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    return i.persistence.runTransaction("Save named query", "readwrite", (e)=>{
        const s = $2fa92ec193801792$var$__PRIVATE_fromVersion(t.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (r.snapshotVersion.compareTo(s) >= 0) return i.d_.saveNamedQuery(e, t);
        // Update existing target data because the query from the bundle is newer.
        const _ = r.withResumeToken($2fa92ec193801792$export$158acd800e1ef08b.EMPTY_BYTE_STRING, s);
        return i.No = i.No.insert(_.targetId, _), i.A_.updateTargetData(e, _).next(()=>i.A_.removeMatchingKeysForTargetId(e, r.targetId)).next(()=>i.A_.addMatchingKeys(e, n, r.targetId)).next(()=>i.d_.saveNamedQuery(e, t));
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class $2fa92ec193801792$var$__PRIVATE_SizedBundleElement {
    constructor(e, // How many bytes this element takes to store in the bundle.
    t){
        this.jo = e, this.byteLength = t;
    }
    Ho() {
        return "metadata" in this.jo;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * How many bytes to read each time when `ReadableStreamReader.read()` is
 * called. Only applicable for byte streams that we control (e.g. those backed
 * by an UInt8Array).
 */ /**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $2fa92ec193801792$var$__PRIVATE_toByteStreamReaderHelper(e, t = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < e.byteLength) {
                const r = {
                    value: e.slice(n, n + t),
                    done: false
                };
                return n += t, r;
            }
            return {
                done: true
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class $2fa92ec193801792$var$__PRIVATE_OnlineStateTracker {
    constructor(e, t){
        this.asyncQueue = e, this.onlineStateHandler = t, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.Jo = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this.Yo = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.Zo = true;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ Xo() {
        0 === this.Jo && (this.ea("Unknown" /* OnlineState.Unknown */ ), this.Yo = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, ()=>(this.Yo = null, this.ta("Backend didn't respond within 10 seconds."), this.ea("Offline" /* OnlineState.Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ na(e) {
        "Online" /* OnlineState.Online */  === this.state ? this.ea("Unknown" /* OnlineState.Unknown */ ) : (this.Jo++, this.Jo >= 1 && (this.ra(), this.ta(`Connection failed 1 times. Most recent error: ${e.toString()}`), this.ea("Offline" /* OnlineState.Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(e) {
        this.ra(), this.Jo = 0, "Online" /* OnlineState.Online */  === e && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.Zo = false), this.ea(e);
    }
    ea(e) {
        e !== this.state && (this.state = e, this.onlineStateHandler(e));
    }
    ta(e) {
        const t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this.Zo ? ($2fa92ec193801792$var$__PRIVATE_logError(t), this.Zo = false) : $2fa92ec193801792$export$2329c99376c9d0a4("OnlineStateTracker", t);
    }
    ra() {
        null !== this.Yo && (this.Yo.cancel(), this.Yo = null);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$hr = "RemoteStore";
// TODO(b/35853402): Negotiate this with the stream.
class $2fa92ec193801792$var$__PRIVATE_RemoteStoreImpl {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ t, n, r, i){
        this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.ia = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.sa = new Map, this._a = new Map, this.oa = new Map, this.aa = new $2fa92ec193801792$var$__PRIVATE_TargetIdGenerator(1e3), this.ua = new $2fa92ec193801792$var$__PRIVATE_TargetIdGenerator(1001), /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.ca = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.la = [], this.Ea = i, this.Ea.Ke((e)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                $2fa92ec193801792$var$__PRIVATE_canUseNetwork(this) && ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$hr, "Restarting streams for network reachability change."), await async function __PRIVATE_restartNetwork(e) {
                    const t = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
                    t.ca.add(4 /* OfflineCause.ConnectivityChange */ ), await $2fa92ec193801792$var$__PRIVATE_disableNetworkInternal(t), t.ha.set("Unknown" /* OnlineState.Unknown */ ), t.ca.delete(4 /* OfflineCause.ConnectivityChange */ ), await $2fa92ec193801792$var$__PRIVATE_enableNetworkInternal(t);
                }(this));
            });
        }), this.ha = new $2fa92ec193801792$var$__PRIVATE_OnlineStateTracker(n, r);
    }
}
async function $2fa92ec193801792$var$__PRIVATE_enableNetworkInternal(e) {
    if ($2fa92ec193801792$var$__PRIVATE_canUseNetwork(e)) for (const t of e.la)await t(/* enabled= */ true);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function $2fa92ec193801792$var$__PRIVATE_disableNetworkInternal(e) {
    for (const t of e.la)await t(/* enabled= */ false);
}
/**
 * Returns the remote target ID currently mapped to this
 * sdkTargetId. Or returns `0` if the SDK target ID
 * is not currently mapped.
 * @param remoteStoreImpl
 * @param sdkTargetId
 */ function $2fa92ec193801792$var$__PRIVATE_getRemoteTargetId(e, t) {
    return e._a.get(t) || void 0;
}
/**
 * Generates a new remote target ID that is acceptable
 * to map to the given SDK target ID.
 * @param remoteStoreImpl
 * @param sdkTargetId
 */ /**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $2fa92ec193801792$var$__PRIVATE_remoteStoreListen(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = $2fa92ec193801792$var$__PRIVATE_getRemoteTargetId(n, t.targetId);
    // Get any remote target ID currently mapped to the targetData
    // If remote store is still listening for this remote target ID, this is a no-op.
    if (void 0 !== r && n.sa.has(r)) return;
    // Generate and map a new remote ID to the SDK target ID
    const i = /**
 * Generate a new remote target ID for the given SDK target ID.
 * Re-map the given SDK to the new remote ID.
 * Delete any mapping of the old remote ID, if given.
 * @param remoteStoreImpl
 * @param sdkTargetId
 * @return The new remote ID.
 */ function __PRIVATE_allocateRemoteTargetId(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_getRemoteTargetId(e, t);
        void 0 !== n && // If there was an existing remote target ID mapped to that SDK target ID, forget about the old remote ID.
        e.oa.delete(n);
        // Generate a new unique remote target ID
        const r = function __PRIVATE_generateRemoteTargetId(e, t) {
            // If the given sdkTargetId is odd, map it to an odd (sync engine) target ID
            return t % 2 != 0 ? e.ua.next() : e.aa.next();
        }(e, t);
        return e._a.set(t, r), e.oa.set(r, t), r;
    }(n, t.targetId);
    $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$hr, "remoteStoreListen mapping SDK target ID to remote", t.targetId, i);
    // Create a new TargetData for remote use, which uses
    // the remote TargetID.
    const s = new $2fa92ec193801792$var$TargetData(t.target, i, t.purpose, t.sequenceNumber, t.snapshotVersion, t.lastLimboFreeSnapshotVersion, t.resumeToken);
    // Mark this as something the client is currently listening for.
    n.sa.set(i, s), $2fa92ec193801792$var$__PRIVATE_shouldStartWatchStream(n) ? // The listen will be sent in onWatchStreamOpen
    $2fa92ec193801792$var$__PRIVATE_startWatchStream(n) : $2fa92ec193801792$var$__PRIVATE_ensureWatchStream(n).Jt() && $2fa92ec193801792$var$__PRIVATE_sendWatchRequest(n, s);
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $2fa92ec193801792$var$__PRIVATE_remoteStoreUnlisten(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = $2fa92ec193801792$var$__PRIVATE_ensureWatchStream(n), i = $2fa92ec193801792$var$__PRIVATE_getRemoteTargetId(n, t);
    $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$hr, "remoteStoreUnlisten removing mapping of SDK target ID to remote", t, i), n.sa.delete(i), n._a.delete(t), n.oa.delete(i), r.Jt() && $2fa92ec193801792$var$__PRIVATE_sendUnwatchRequest(n, i), 0 === n.sa.size && (r.Jt() ? r.Xt() : $2fa92ec193801792$var$__PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.ha.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $2fa92ec193801792$var$__PRIVATE_sendWatchRequest(e, t) {
    if (e.Ta.H(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo($2fa92ec193801792$var$SnapshotVersion.min()) > 0) {
        const n = e.oa.get(t.targetId);
        if (void 0 === n) // There's already a new remoteStoreListen request for the original
        // target, so ignore this.
        return void $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$hr, "SDK target ID not found for remote ID: " + t.targetId);
        const r = e.remoteSyncer.getRemoteKeysForTarget(n).size;
        t = t.withExpectedCount(r);
    }
    $2fa92ec193801792$var$__PRIVATE_ensureWatchStream(e).Tn(t);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $2fa92ec193801792$var$__PRIVATE_sendUnwatchRequest(e, t) {
    e.Ta.H(t), $2fa92ec193801792$var$__PRIVATE_ensureWatchStream(e).Pn(t);
}
function $2fa92ec193801792$var$__PRIVATE_startWatchStream(e) {
    e.Ta = new $2fa92ec193801792$var$__PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: (t)=>{
            // Remote syncer uses SDK target IDs, so we need to map the remote
            // id to external id
            const n = e.oa.get(t);
            // If no sdkTargetId is mapped, return an empty key set
            return void 0 !== n ? e.remoteSyncer.getRemoteKeysForTarget(n) : $2fa92ec193801792$export$a9c996f45e5784d0();
        },
        ge: (t)=>e.sa.get(t) || null,
        Ae: ()=>e.datastore.serializer.databaseId
    }), $2fa92ec193801792$var$__PRIVATE_ensureWatchStream(e).start(), e.ha.Xo();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $2fa92ec193801792$var$__PRIVATE_shouldStartWatchStream(e) {
    return $2fa92ec193801792$var$__PRIVATE_canUseNetwork(e) && !$2fa92ec193801792$var$__PRIVATE_ensureWatchStream(e).Ht() && e.sa.size > 0;
}
function $2fa92ec193801792$var$__PRIVATE_canUseNetwork(e) {
    return 0 === $2fa92ec193801792$var$__PRIVATE_debugCast(e).ca.size;
}
function $2fa92ec193801792$var$__PRIVATE_cleanUpWatchStreamState(e) {
    e.Ta = void 0;
}
async function $2fa92ec193801792$var$__PRIVATE_onWatchStreamConnected(e) {
    // Mark the client as online since we got a "connected" notification.
    e.ha.set("Online" /* OnlineState.Online */ );
}
async function $2fa92ec193801792$var$__PRIVATE_onWatchStreamOpen(e) {
    e.sa.forEach((t, n)=>{
        $2fa92ec193801792$var$__PRIVATE_sendWatchRequest(e, t);
    });
}
async function $2fa92ec193801792$var$__PRIVATE_onWatchStreamClose(e, t) {
    $2fa92ec193801792$var$__PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
    $2fa92ec193801792$var$__PRIVATE_shouldStartWatchStream(e) ? (e.ha.na(t), $2fa92ec193801792$var$__PRIVATE_startWatchStream(e)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    e.ha.set("Unknown" /* OnlineState.Unknown */ );
}
async function $2fa92ec193801792$var$__PRIVATE_onWatchStreamChange(e, t, n) {
    if (// Mark the client as online since we got a message from the server
    e.ha.set("Online" /* OnlineState.Online */ ), t instanceof $2fa92ec193801792$var$__PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */  === t.state && t.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        /** Handles an error on a target */ await async function __PRIVATE_handleTargetError(e, t) {
            const n = t.cause;
            for (const r of t.targetIds){
                // A watched target might have been removed already.
                if (e.sa.has(r)) {
                    const t = e.oa.get(r);
                    // If we still track the remote target ID, then notify the remoteSyncer
                    // of the error and then free up the remote ID.
                    void 0 !== t && (await e.remoteSyncer.rejectListen(t, n), e._a.delete(t), e.oa.delete(r)), e.sa.delete(r);
                }
                e.Ta.removeTarget(r);
            }
        }(e, t);
    } catch (n) {
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$hr, "Failed to remove targets %s: %s ", t.targetIds.join(","), n), await $2fa92ec193801792$var$__PRIVATE_disableNetworkUntilRecovery(e, n);
    }
    else if (t instanceof $2fa92ec193801792$var$__PRIVATE_DocumentWatchChange ? e.Ta.se(t) : t instanceof $2fa92ec193801792$var$__PRIVATE_ExistenceFilterChange ? e.Ta.Ee(t) : e.Ta.ae(t), !n.isEqual($2fa92ec193801792$var$SnapshotVersion.min())) try {
        const t = await $2fa92ec193801792$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
        n.compareTo(t) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ await function __PRIVATE_raiseWatchSnapshot(e, t) {
            const n = e.Ta.de(t);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            n.targetChanges.forEach((n, r)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = e.sa.get(r);
                    // A watched target might have been removed already.
                    i && e.sa.set(r, i.withResumeToken(n.resumeToken, t));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            // TODO ideally this would use a new remote target ID
            n.targetMismatches.forEach((t, n)=>{
                const r = e.sa.get(t);
                if (!r) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                e.sa.set(t, r.withResumeToken($2fa92ec193801792$export$158acd800e1ef08b.EMPTY_BYTE_STRING, r.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                $2fa92ec193801792$var$__PRIVATE_sendUnwatchRequest(e, t);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const i = new $2fa92ec193801792$var$TargetData(r.target, t, n, r.sequenceNumber);
                $2fa92ec193801792$var$__PRIVATE_sendWatchRequest(e, i);
            });
            const r = /**
 * Convert a RemoteEvent with remote IDs to a RemoteEvent with
 * SDK IDs and dropped updates
 * for any targets we no longer track.
 *
 * @param remoteStoreImpl
 * @param remoteEvent
 * @return a new RemoteEvent with SDK IDs and dropped updates
 * for any targets we no longer track.
 */ function __PRIVATE_toSdkRemoteEvent(e, t) {
                // Map TargetChanges to TargetChanges with SDK ID
                const n = new Map;
                t.targetChanges.forEach((t, r)=>{
                    // If we no longer track the remote ID, then drop the TargetChange
                    // otherwise propagate the TargetChange
                    const i = e.oa.get(r);
                    void 0 !== i && n.set(i, t);
                });
                // Map target mismatches to target mismatches with SDK ID
                let r = new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$var$__PRIVATE_primitiveComparator);
                return t.targetMismatches.forEach((t, n)=>{
                    // If we no longer track the remote ID, then drop the target mismatch
                    // otherwise propagate the target mismatch
                    const i = e.oa.get(t);
                    void 0 !== i && (r = r.insert(i, n));
                }), new $2fa92ec193801792$var$RemoteEvent(t.snapshotVersion, n, r, t.documentUpdates, t.augmentedDocumentUpdates, t.resolvedLimboDocuments);
            }(e, n);
            return e.remoteSyncer.applyRemoteEvent(r);
        }(e, n);
    } catch (t) {
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$hr, "Failed to raise snapshot:", t), await $2fa92ec193801792$var$__PRIVATE_disableNetworkUntilRecovery(e, t);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function $2fa92ec193801792$var$__PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    if (!$2fa92ec193801792$var$__PRIVATE_isIndexedDbTransactionError(t)) throw t;
    e.ca.add(1 /* OfflineCause.IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await $2fa92ec193801792$var$__PRIVATE_disableNetworkInternal(e), e.ha.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>$2fa92ec193801792$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)), // Probe IndexedDB periodically and re-enable network
    e.asyncQueue.enqueueRetryable(async ()=>{
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$hr, "Retrying IndexedDB access"), await n(), e.ca.delete(1 /* OfflineCause.IndexedDbFailed */ ), await $2fa92ec193801792$var$__PRIVATE_enableNetworkInternal(e);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $2fa92ec193801792$var$__PRIVATE_executeWithRecovery(e, t) {
    return t().catch((n)=>$2fa92ec193801792$var$__PRIVATE_disableNetworkUntilRecovery(e, n, t));
}
async function $2fa92ec193801792$var$__PRIVATE_fillWritePipeline(e) {
    const t = $2fa92ec193801792$var$__PRIVATE_debugCast(e), n = $2fa92ec193801792$var$__PRIVATE_ensureWriteStream(t);
    let r = t.ia.length > 0 ? t.ia[t.ia.length - 1].batchId : $2fa92ec193801792$var$Ke;
    for(; $2fa92ec193801792$var$__PRIVATE_canAddToWritePipeline(t);)try {
        const e = await $2fa92ec193801792$var$__PRIVATE_localStoreGetNextMutationBatch(t.localStore, r);
        if (null === e) {
            0 === t.ia.length && n.Xt();
            break;
        }
        r = e.batchId, $2fa92ec193801792$var$__PRIVATE_addToWritePipeline(t, e);
    } catch (e) {
        await $2fa92ec193801792$var$__PRIVATE_disableNetworkUntilRecovery(t, e);
    }
    $2fa92ec193801792$var$__PRIVATE_shouldStartWriteStream(t) && $2fa92ec193801792$var$__PRIVATE_startWriteStream(t);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $2fa92ec193801792$var$__PRIVATE_canAddToWritePipeline(e) {
    return $2fa92ec193801792$var$__PRIVATE_canUseNetwork(e) && e.ia.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $2fa92ec193801792$var$__PRIVATE_addToWritePipeline(e, t) {
    e.ia.push(t);
    const n = $2fa92ec193801792$var$__PRIVATE_ensureWriteStream(e);
    n.Jt() && n.Rn && n.In(t.mutations);
}
function $2fa92ec193801792$var$__PRIVATE_shouldStartWriteStream(e) {
    return $2fa92ec193801792$var$__PRIVATE_canUseNetwork(e) && !$2fa92ec193801792$var$__PRIVATE_ensureWriteStream(e).Ht() && e.ia.length > 0;
}
function $2fa92ec193801792$var$__PRIVATE_startWriteStream(e) {
    $2fa92ec193801792$var$__PRIVATE_ensureWriteStream(e).start();
}
async function $2fa92ec193801792$var$__PRIVATE_onWriteStreamOpen(e) {
    $2fa92ec193801792$var$__PRIVATE_ensureWriteStream(e).dn();
}
async function $2fa92ec193801792$var$__PRIVATE_onWriteHandshakeComplete(e) {
    const t = $2fa92ec193801792$var$__PRIVATE_ensureWriteStream(e);
    // Send the write pipeline now that the stream is established.
    for (const n of e.ia)t.In(n.mutations);
}
async function $2fa92ec193801792$var$__PRIVATE_onMutationResult(e, t, n) {
    const r = e.ia.shift(), i = $2fa92ec193801792$var$MutationBatchResult.from(r, t, n);
    await $2fa92ec193801792$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await $2fa92ec193801792$var$__PRIVATE_fillWritePipeline(e);
}
async function $2fa92ec193801792$var$__PRIVATE_onWriteStreamClose(e, t) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    t && $2fa92ec193801792$var$__PRIVATE_ensureWriteStream(e).Rn && // This error affects the actual write.
    await async function __PRIVATE_handleWriteError(e, t) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (function __PRIVATE_isPermanentWriteError(e) {
            return $2fa92ec193801792$var$__PRIVATE_isPermanentError(e) && e !== $2fa92ec193801792$export$db3b6bfb95261072.ABORTED;
        }(t.code)) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = e.ia.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            $2fa92ec193801792$var$__PRIVATE_ensureWriteStream(e).Zt(), await $2fa92ec193801792$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.rejectFailedWrite(n.batchId, t)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await $2fa92ec193801792$var$__PRIVATE_fillWritePipeline(e);
        }
    }(e, t), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    $2fa92ec193801792$var$__PRIVATE_shouldStartWriteStream(e) && $2fa92ec193801792$var$__PRIVATE_startWriteStream(e);
}
async function $2fa92ec193801792$var$__PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    n.asyncQueue.verifyOperationInProgress(), $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$hr, "RemoteStore received new credentials");
    const r = $2fa92ec193801792$var$__PRIVATE_canUseNetwork(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.ca.add(3 /* OfflineCause.CredentialChange */ ), await $2fa92ec193801792$var$__PRIVATE_disableNetworkInternal(n), r && // Don't set the network status to Unknown if we are offline.
    n.ha.set("Unknown" /* OnlineState.Unknown */ ), await n.remoteSyncer.handleCredentialChange(t), n.ca.delete(3 /* OfflineCause.CredentialChange */ ), await $2fa92ec193801792$var$__PRIVATE_enableNetworkInternal(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function $2fa92ec193801792$var$__PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    t ? (n.ca.delete(2 /* OfflineCause.IsSecondary */ ), await $2fa92ec193801792$var$__PRIVATE_enableNetworkInternal(n)) : t || (n.ca.add(2 /* OfflineCause.IsSecondary */ ), await $2fa92ec193801792$var$__PRIVATE_disableNetworkInternal(n), n.ha.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $2fa92ec193801792$var$__PRIVATE_ensureWatchStream(e) {
    return e.Pa || // Create stream (but note that it is not started yet).
    (e.Pa = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        const r = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
        return r.mn(), new $2fa92ec193801792$var$__PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        ut: $2fa92ec193801792$var$__PRIVATE_onWatchStreamConnected.bind(null, e),
        lt: $2fa92ec193801792$var$__PRIVATE_onWatchStreamOpen.bind(null, e),
        ht: $2fa92ec193801792$var$__PRIVATE_onWatchStreamClose.bind(null, e),
        hn: $2fa92ec193801792$var$__PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.la.push(async (t)=>{
        t ? (e.Pa.Zt(), $2fa92ec193801792$var$__PRIVATE_shouldStartWatchStream(e) ? $2fa92ec193801792$var$__PRIVATE_startWatchStream(e) : e.ha.set("Unknown" /* OnlineState.Unknown */ )) : (await e.Pa.stop(), $2fa92ec193801792$var$__PRIVATE_cleanUpWatchStreamState(e));
    })), e.Pa;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $2fa92ec193801792$var$__PRIVATE_ensureWriteStream(e) {
    return e.Ra || // Create stream (but note that it is not started yet).
    (e.Ra = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        const r = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
        return r.mn(), new $2fa92ec193801792$var$__PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        ut: ()=>Promise.resolve(),
        lt: $2fa92ec193801792$var$__PRIVATE_onWriteStreamOpen.bind(null, e),
        ht: $2fa92ec193801792$var$__PRIVATE_onWriteStreamClose.bind(null, e),
        An: $2fa92ec193801792$var$__PRIVATE_onWriteHandshakeComplete.bind(null, e),
        Vn: $2fa92ec193801792$var$__PRIVATE_onMutationResult.bind(null, e)
    }), e.la.push(async (t)=>{
        t ? (e.Ra.Zt(), // This will start the write stream if necessary.
        await $2fa92ec193801792$var$__PRIVATE_fillWritePipeline(e)) : (await e.Ra.stop(), e.ia.length > 0 && ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$hr, `Stopping write stream with ${e.ia.length} pending writes`), e.ia = []));
    })), e.Ra;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class $2fa92ec193801792$var$__PRIVATE_AsyncObserver {
    constructor(e){
        this.observer = e, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = false;
    }
    next(e) {
        this.muted || this.observer.next && this.Ia(this.observer.next, e);
    }
    error(e) {
        this.muted || (this.observer.error ? this.Ia(this.observer.error, e) : $2fa92ec193801792$var$__PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString()));
    }
    Aa() {
        this.muted = true;
    }
    Ia(e, t) {
        setTimeout(()=>{
            this.muted || e(t);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $2fa92ec193801792$var$DelayedOperation {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new $2fa92ec193801792$var$__PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((e)=>{});
    }
    get promise() {
        return this.deferred.promise;
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(e, t, n, r, i) {
        const s = Date.now() + n, _ = new $2fa92ec193801792$var$DelayedOperation(e, t, s, r, i);
        return _.start(n), _;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(e) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), e);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(e) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((e)=>this.deferred.resolve(e))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $2fa92ec193801792$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
    if ($2fa92ec193801792$var$__PRIVATE_logError("AsyncQueue", `${t}: ${e}`), $2fa92ec193801792$var$__PRIVATE_isIndexedDbTransactionError(e)) return new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.UNAVAILABLE, `${t}: ${e}`);
    throw e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class $2fa92ec193801792$var$__PRIVATE_BundleReaderImpl {
    constructor(/** The reader to read from underlying binary bundle data source. */ e, t){
        this.Va = e, this.serializer = t, /** Cached bundle metadata. */ this.metadata = new $2fa92ec193801792$var$__PRIVATE_Deferred, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.da = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), // Read the metadata (which is the first element).
        this.fa().then((e)=>{
            e && e.Ho() ? this.metadata.resolve(e.jo.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(e?.jo)}`));
        }, (e)=>this.metadata.reject(e));
    }
    close() {
        return this.Va.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async ma() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.fa();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async fa() {
        const e = await this.pa();
        if (null === e) return null;
        const t = this.da.decode(e), n = Number(t);
        isNaN(n) && this.ga(`length string (${t}) is not valid number`);
        const r = await this.ya(n);
        return new $2fa92ec193801792$var$__PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n);
    }
    /** First index of '{' from the underlying buffer. */ wa() {
        return this.buffer.findIndex((e)=>e === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async pa() {
        for(; this.wa() < 0;){
            if (await this.ba()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const e = this.wa();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        e < 0 && this.ga("Reached the end of bundle when a length string is expected.");
        const t = this.buffer.slice(0, e);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(e), t;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async ya(e) {
        for(; this.buffer.length < e;)await this.ba() && this.ga("Reached the end of bundle when more is expected.");
        const t = this.da.decode(this.buffer.slice(0, e));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(e), t;
    }
    ga(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.Va.cancel(), new Error(`Invalid bundle format: ${e}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async ba() {
        const e = await this.Va.read();
        if (!e.done) {
            const t = new Uint8Array(this.buffer.length + e.value.length);
            t.set(this.buffer), t.set(e.value, this.buffer.length), this.buffer = t;
        }
        return e.done;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that can parse a bundle form the string serialization of a bundle.
 */ class $2fa92ec193801792$var$__PRIVATE_BundleReaderSyncImpl {
    constructor(e, t){
        this.bundleData = e, this.serializer = t, this.cursor = 0, this.elements = [];
        let n = this.ma();
        if (!n || !n.Ho()) throw new Error(`The first element of the bundle is not a metadata object, it is\n         ${JSON.stringify(n?.jo)}`);
        this.metadata = n;
        do n = this.ma(), null !== n && this.elements.push(n);
        while (null !== n);
    }
    /* Returns the parsed metadata of the bundle. */ getMetadata() {
        return this.metadata;
    }
    /* Returns the DocumentSnapshot or NamedQuery elements of the bundle. */ va() {
        return this.elements;
    }
    /**
     * Parses the next element of the bundle.
     *
     * @returns a SizedBundleElement representation of the next element in the bundle, or null if
     * no more elements exist.
     */ ma() {
        if (this.cursor === this.bundleData.length) return null;
        const e = this.pa(), t = this.ya(e);
        return new $2fa92ec193801792$var$__PRIVATE_SizedBundleElement(JSON.parse(t), e);
    }
    /**
     * Reads from a specified position from the bundleData string, for a specified
     * number of bytes.
     *
     * @param length - how many characters to read.
     * @returns a string parsed from the bundle.
     */ ya(e) {
        if (this.cursor + e > this.bundleData.length) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INTERNAL, "Reached the end of bundle when more is expected.");
        return this.bundleData.slice(this.cursor, this.cursor += e);
    }
    /**
     * Reads from the current cursor until the first '{'.
     *
     * @returns  A string to integer represention of the parsed value.
     * @throws An {@link Error} if the cursor has reached the end of the stream, since lengths
     * prefix bundle objects.
     */ pa() {
        const e = this.cursor;
        let t = this.cursor;
        for(; t < this.bundleData.length;){
            if ("{" === this.bundleData[t]) {
                if (t === e) throw new Error("First character is a bracket and not a number");
                return this.cursor = t, Number(this.bundleData.slice(e, t));
            }
            t++;
        }
        throw new Error("Reached the end of bundle when more is expected.");
    }
}
/**
 *  Creates an instance of BundleReader without exposing the BundleReaderSyncImpl class type.
 */ const $2fa92ec193801792$var$Tr = "IndexBackfiller";
/** How long we wait to try running index backfill after SDK initialization. */ /** This class is responsible for the scheduling of Index Backfiller. */ class $2fa92ec193801792$var$__PRIVATE_IndexBackfillerScheduler {
    constructor(e, t){
        this.asyncQueue = e, this.Sa = t, this.task = null;
    }
    start() {
        this.Da(15e3);
    }
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    Da(e) {
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$Tr, `Scheduled in ${e}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, async ()=>{
            this.task = null;
            try {
                const e = await this.Sa.xa();
                $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$Tr, `Documents written: ${e}`);
            } catch (e) {
                $2fa92ec193801792$var$__PRIVATE_isIndexedDbTransactionError(e) ? $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$Tr, "Ignoring IndexedDB error during index backfill: ", e) : await $2fa92ec193801792$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.Da(6e4);
        });
    }
}
/** Implements the steps for backfilling indexes. */ class $2fa92ec193801792$var$__PRIVATE_IndexBackfiller {
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ e, t){
        this.localStore = e, this.persistence = t;
    }
    async xa(e = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (t)=>this.Ca(t, e));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ Ca(e, t) {
        const n = new Set;
        let r = t, i = true;
        return $2fa92ec193801792$var$PersistencePromise.doWhile(()=>true === i && r > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next((t)=>{
                if (null !== t && !n.has(t)) return $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$Tr, `Processing collection: ${t}`), this.Fa(e, t, r).next((e)=>{
                    r -= e, n.add(t);
                });
                i = false;
            })).next(()=>t - r);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ Fa(e, t, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next((r)=>this.localStore.localDocuments.getNextDocuments(e, t, r, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(e, i).next(()=>this.Oa(r, n)).next((n)=>($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$Tr, `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(e, t, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ Oa(e, t) {
        let n = e;
        return t.changes.forEach((e, t)=>{
            const r = $2fa92ec193801792$var$__PRIVATE_newIndexOffsetFromDocument(t);
            $2fa92ec193801792$var$__PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
        }), new $2fa92ec193801792$var$IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
const $2fa92ec193801792$var$Pr = "firestore_clients";
/** Assembles the key for a client state in WebStorage */ function $2fa92ec193801792$var$createWebStorageClientStateKey(e, t) {
    return `${$2fa92ec193801792$var$Pr}_${e}_${t}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
const $2fa92ec193801792$var$Rr = "firestore_mutations";
/** Assembles the key for a mutation batch in WebStorage */ function $2fa92ec193801792$var$createWebStorageMutationBatchKey(e, t, n) {
    let r = `${$2fa92ec193801792$var$Rr}_${e}_${n}`;
    return t.isAuthenticated() && (r += `_${t.uid}`), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
const $2fa92ec193801792$var$Ir = "firestore_targets";
/** Assembles the key for a query state in WebStorage */ function $2fa92ec193801792$var$createWebStorageQueryTargetMetadataKey(e, t) {
    return `${$2fa92ec193801792$var$Ir}_${e}_${t}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$Ar = "SharedClientState";
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class $2fa92ec193801792$var$__PRIVATE_MutationMetadata {
    constructor(e, t, n, r){
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ma(e, t, n) {
        const r = JSON.parse(n);
        let i, _ = "object" == typeof r && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error);
        return _ && r.error && (_ = "string" == typeof r.error.message && "string" == typeof r.error.code, _ && (i = new $2fa92ec193801792$export$2408f22a0fab9ae5(r.error.code, r.error.message))), _ ? new $2fa92ec193801792$var$__PRIVATE_MutationMetadata(e, t, r.state, i) : ($2fa92ec193801792$var$__PRIVATE_logError($2fa92ec193801792$var$Ar, `Failed to parse mutation state for ID '${t}': ${n}`), null);
    }
    Na() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class $2fa92ec193801792$var$__PRIVATE_QueryTargetMetadata {
    constructor(e, t, n){
        this.targetId = e, this.state = t, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ma(e, t) {
        const n = JSON.parse(t);
        let r, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (r = new $2fa92ec193801792$export$2408f22a0fab9ae5(n.error.code, n.error.message))), i ? new $2fa92ec193801792$var$__PRIVATE_QueryTargetMetadata(e, n.state, r) : ($2fa92ec193801792$var$__PRIVATE_logError($2fa92ec193801792$var$Ar, `Failed to parse target state for ID '${e}': ${t}`), null);
    }
    Na() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class $2fa92ec193801792$var$__PRIVATE_RemoteClientState {
    constructor(e, t){
        this.clientId = e, this.activeTargetIds = t;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ma(e, t) {
        const n = JSON.parse(t);
        let r = "object" == typeof n && n.activeTargetIds instanceof Array, i = $2fa92ec193801792$var$__PRIVATE_targetIdSet();
        for(let e = 0; r && e < n.activeTargetIds.length; ++e)r = $2fa92ec193801792$var$isSafeInteger(n.activeTargetIds[e]), i = i.add(n.activeTargetIds[e]);
        return r ? new $2fa92ec193801792$var$__PRIVATE_RemoteClientState(e, i) : ($2fa92ec193801792$var$__PRIVATE_logError($2fa92ec193801792$var$Ar, `Failed to parse client data for instance '${e}': ${t}`), null);
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class $2fa92ec193801792$var$__PRIVATE_SharedOnlineState {
    constructor(e, t){
        this.clientId = e, this.onlineState = t;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ma(e) {
        const t = JSON.parse(e);
        return "object" == typeof t && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new $2fa92ec193801792$var$__PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : ($2fa92ec193801792$var$__PRIVATE_logError($2fa92ec193801792$var$Ar, `Failed to parse online state: ${e}`), null);
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class $2fa92ec193801792$var$__PRIVATE_LocalClientState {
    constructor(){
        this.activeTargetIds = $2fa92ec193801792$var$__PRIVATE_targetIdSet();
    }
    La(e) {
        this.activeTargetIds = this.activeTargetIds.add(e);
    }
    Ba(e) {
        this.activeTargetIds = this.activeTargetIds.delete(e);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ Na() {
        const e = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(e);
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class $2fa92ec193801792$var$__PRIVATE_WebStorageSharedClientState {
    constructor(e, t, n, r, i){
        this.window = e, this.xt = t, this.persistenceKey = n, this.Ua = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.ka = this.qa.bind(this), this.$a = new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$var$__PRIVATE_primitiveComparator), this.started = false, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.Ka = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.Wa = $2fa92ec193801792$var$createWebStorageClientStateKey(this.persistenceKey, this.Ua), this.Qa = /** Assembles the key for the current sequence number. */ function createWebStorageSequenceNumberKey(e) {
            return `firestore_sequence_number_${e}`;
        }(this.persistenceKey), this.$a = this.$a.insert(this.Ua, new $2fa92ec193801792$var$__PRIVATE_LocalClientState), this.Ga = new RegExp(`^${$2fa92ec193801792$var$Pr}_${s}_([^_]*)$`), this.za = new RegExp(`^${$2fa92ec193801792$var$Rr}_${s}_(\\d+)(?:_(.*))?$`), this.ja = new RegExp(`^${$2fa92ec193801792$var$Ir}_${s}_(\\d+)$`), this.Ha = /** Assembles the key for the online state of the primary tab. */ function createWebStorageOnlineStateKey(e) {
            return `firestore_online_state_${e}`;
        }(this.persistenceKey), this.Ja = function createBundleLoadedKey(e) {
            return `firestore_bundle_loaded_v2_${e}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.ka);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ static Je(e) {
        return !(!e || !e.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const e = await this.syncEngine.Ro();
        for (const t of e){
            if (t === this.Ua) continue;
            const e = this.getItem($2fa92ec193801792$var$createWebStorageClientStateKey(this.persistenceKey, t));
            if (e) {
                const n = $2fa92ec193801792$var$__PRIVATE_RemoteClientState.Ma(t, e);
                n && (this.$a = this.$a.insert(n.clientId, n));
            }
        }
        this.Ya();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const t = this.storage.getItem(this.Ha);
        if (t) {
            const e = this.Za(t);
            e && this.Xa(e);
        }
        for (const e of this.Ka)this.qa(e);
        this.Ka = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = true;
    }
    writeSequenceNumber(e) {
        this.setItem(this.Qa, JSON.stringify(e));
    }
    getAllActiveQueryTargets() {
        return this.eu(this.$a);
    }
    isActiveQueryTarget(e) {
        let t = false;
        return this.$a.forEach((n, r)=>{
            r.activeTargetIds.has(e) && (t = true);
        }), t;
    }
    addPendingMutation(e) {
        this.tu(e, "pending");
    }
    updateMutationState(e, t, n) {
        this.tu(e, t, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.nu(e);
    }
    addLocalQueryTarget(e, t = true) {
        let n = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(e)) {
            const t = this.storage.getItem($2fa92ec193801792$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            if (t) {
                const r = $2fa92ec193801792$var$__PRIVATE_QueryTargetMetadata.Ma(e, t);
                r && (n = r.state);
            }
        }
        // If the query is listening to cache only, the target ID should not be registered with the
        // local Firestore client as an active watch target.
        return t && this.ru.La(e), this.Ya(), n;
    }
    removeLocalQueryTarget(e) {
        this.ru.Ba(e), this.Ya();
    }
    isLocalQueryTarget(e) {
        return this.ru.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        this.removeItem($2fa92ec193801792$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
    }
    updateQueryState(e, t, n) {
        this.iu(e, t, n);
    }
    handleUserChange(e, t, n) {
        t.forEach((e)=>{
            this.nu(e);
        }), this.currentUser = e, n.forEach((e)=>{
            this.addPendingMutation(e);
        });
    }
    setOnlineState(e) {
        this.su(e);
    }
    notifyBundleLoaded(e) {
        this._u(e);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this.ka), this.removeItem(this.Wa), this.started = false);
    }
    getItem(e) {
        const t = this.storage.getItem(e);
        return $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$Ar, "READ", e, t), t;
    }
    setItem(e, t) {
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$Ar, "SET", e, t), this.storage.setItem(e, t);
    }
    removeItem(e) {
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$Ar, "REMOVE", e), this.storage.removeItem(e);
    }
    qa(e) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const t = e;
        if (t.storageArea === this.storage) {
            if ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$Ar, "EVENT", t.key, t.newValue), t.key === this.Wa) return void $2fa92ec193801792$var$__PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.xt.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== t.key) {
                        if (this.Ga.test(t.key)) {
                            if (null == t.newValue) {
                                const e = this.ou(t.key);
                                return this.au(e, null);
                            }
                            {
                                const e = this.uu(t.key, t.newValue);
                                if (e) return this.au(e.clientId, e);
                            }
                        } else if (this.za.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.cu(t.key, t.newValue);
                                if (e) return this.lu(e);
                            }
                        } else if (this.ja.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.Eu(t.key, t.newValue);
                                if (e) return this.hu(e);
                            }
                        } else if (t.key === this.Ha) {
                            if (null !== t.newValue) {
                                const e = this.Za(t.newValue);
                                if (e) return this.Xa(e);
                            }
                        } else if (t.key === this.Qa) {
                            const e = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                                let t = $2fa92ec193801792$var$__PRIVATE_ListenSequence.yn;
                                if (null != e) try {
                                    const n = JSON.parse(e);
                                    $2fa92ec193801792$var$__PRIVATE_hardAssert("number" == typeof n, 30636, {
                                        Tu: e
                                    }), t = n;
                                } catch (e) {
                                    $2fa92ec193801792$var$__PRIVATE_logError($2fa92ec193801792$var$Ar, "Failed to read sequence number from WebStorage", e);
                                }
                                return t;
                            }(t.newValue);
                            e !== $2fa92ec193801792$var$__PRIVATE_ListenSequence.yn && this.sequenceNumberHandler(e);
                        } else if (t.key === this.Ja) {
                            const e = this.Pu(t.newValue);
                            await Promise.all(e.map((e)=>this.syncEngine.Ru(e)));
                        }
                    }
                } else this.Ka.push(t);
            });
        }
    }
    get ru() {
        return this.$a.get(this.Ua);
    }
    Ya() {
        this.setItem(this.Wa, this.ru.Na());
    }
    tu(e, t, n) {
        const r = new $2fa92ec193801792$var$__PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = $2fa92ec193801792$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.setItem(i, r.Na());
    }
    nu(e) {
        const t = $2fa92ec193801792$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.removeItem(t);
    }
    su(e) {
        const t = {
            clientId: this.Ua,
            onlineState: e
        };
        this.storage.setItem(this.Ha, JSON.stringify(t));
    }
    iu(e, t, n) {
        const r = $2fa92ec193801792$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new $2fa92ec193801792$var$__PRIVATE_QueryTargetMetadata(e, t, n);
        this.setItem(r, i.Na());
    }
    _u(e) {
        const t = JSON.stringify(Array.from(e));
        this.setItem(this.Ja, t);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ ou(e) {
        const t = this.Ga.exec(e);
        return t ? t[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ uu(e, t) {
        const n = this.ou(e);
        return $2fa92ec193801792$var$__PRIVATE_RemoteClientState.Ma(n, t);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ cu(e, t) {
        const n = this.za.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $2fa92ec193801792$var$__PRIVATE_MutationMetadata.Ma(new $2fa92ec193801792$var$User(i), r, t);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Eu(e, t) {
        const n = this.ja.exec(e), r = Number(n[1]);
        return $2fa92ec193801792$var$__PRIVATE_QueryTargetMetadata.Ma(r, t);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Za(e) {
        return $2fa92ec193801792$var$__PRIVATE_SharedOnlineState.Ma(e);
    }
    Pu(e) {
        return JSON.parse(e);
    }
    async lu(e) {
        if (e.user.uid === this.currentUser.uid) return this.syncEngine.Iu(e.batchId, e.state, e.error);
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$Ar, `Ignoring mutation for non-active user ${e.user.uid}`);
    }
    hu(e) {
        return this.syncEngine.Au(e.targetId, e.state, e.error);
    }
    au(e, t) {
        const n = t ? this.$a.insert(e, t) : this.$a.remove(e), r = this.eu(this.$a), i = this.eu(n), s = [], _ = [];
        return i.forEach((e)=>{
            r.has(e) || s.push(e);
        }), r.forEach((e)=>{
            i.has(e) || _.push(e);
        }), this.syncEngine.Vu(s, _).then(()=>{
            this.$a = n;
        });
    }
    Xa(e) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.$a.get(e.clientId) && this.onlineStateHandler(e.onlineState);
    }
    eu(e) {
        let t = $2fa92ec193801792$var$__PRIVATE_targetIdSet();
        return e.forEach((e, n)=>{
            t = t.unionWith(n.activeTargetIds);
        }), t;
    }
}
class $2fa92ec193801792$var$__PRIVATE_MemorySharedClientState {
    constructor(){
        this.du = new $2fa92ec193801792$var$__PRIVATE_LocalClientState, this.fu = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    addPendingMutation(e) {
    // No op.
    }
    updateMutationState(e, t, n) {
    // No op.
    }
    addLocalQueryTarget(e, t = true) {
        return t && this.du.La(e), this.fu[e] || "not-current";
    }
    updateQueryState(e, t, n) {
        this.fu[e] = t;
    }
    removeLocalQueryTarget(e) {
        this.du.Ba(e);
    }
    isLocalQueryTarget(e) {
        return this.du.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        delete this.fu[e];
    }
    getAllActiveQueryTargets() {
        return this.du.activeTargetIds;
    }
    isActiveQueryTarget(e) {
        return this.du.activeTargetIds.has(e);
    }
    start() {
        return this.du = new $2fa92ec193801792$var$__PRIVATE_LocalClientState, Promise.resolve();
    }
    handleUserChange(e, t, n) {
    // No op.
    }
    setOnlineState(e) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(e) {}
    notifyBundleLoaded(e) {
    // No op.
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $2fa92ec193801792$var$__PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $2fa92ec193801792$var$getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class $2fa92ec193801792$export$a93c5207d687da10 {
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(e) {
        return new $2fa92ec193801792$export$a93c5207d687da10(e.comparator);
    }
    /** The default ordering is by key if the comparator is omitted */ constructor(e){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? (t, n)=>e(t, n) || $2fa92ec193801792$export$a07804094c3ecf2d.comparator(t.key, n.key) : (e, t)=>$2fa92ec193801792$export$a07804094c3ecf2d.comparator(e.key, t.key), this.keyedMap = $2fa92ec193801792$var$documentMap(), this.sortedSet = new $2fa92ec193801792$var$SortedMap(this.comparator);
    }
    has(e) {
        return null != this.keyedMap.get(e);
    }
    get(e) {
        return this.keyedMap.get(e);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(e) {
        const t = this.keyedMap.get(e);
        return t ? this.sortedSet.indexOf(t) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(e) {
        this.sortedSet.inorderTraversal((t, n)=>(e(t), false));
    }
    /** Inserts or updates a document with the same key */ add(e) {
        // First remove the element if we have it.
        const t = this.delete(e.key);
        return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
    }
    /** Deletes a document with a given key */ delete(e) {
        const t = this.get(e);
        return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
    }
    isEqual(e) {
        if (!(e instanceof $2fa92ec193801792$export$a93c5207d687da10)) return false;
        if (this.size !== e.size) return false;
        const t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (!e.isEqual(r)) return false;
        }
        return true;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t.toString());
        }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
    }
    copy(e, t) {
        const n = new $2fa92ec193801792$export$a93c5207d687da10;
        return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class $2fa92ec193801792$var$__PRIVATE_DocumentChangeSet {
    constructor(){
        this.mu = new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$export$a07804094c3ecf2d.comparator);
    }
    track(e) {
        const t = e.doc.key, n = this.mu.get(t);
        n ? // Merge the new change with the existing change.
        0 /* ChangeType.Added */  !== e.type && 3 /* ChangeType.Metadata */  === n.type ? this.mu = this.mu.insert(t, e) : 3 /* ChangeType.Metadata */  === e.type && 1 /* ChangeType.Removed */  !== n.type ? this.mu = this.mu.insert(t, {
            type: n.type,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.mu = this.mu.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.mu = this.mu.insert(t, {
            type: 0 /* ChangeType.Added */ ,
            doc: e.doc
        }) : 1 /* ChangeType.Removed */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.mu = this.mu.remove(t) : 1 /* ChangeType.Removed */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.mu = this.mu.insert(t, {
            type: 1 /* ChangeType.Removed */ ,
            doc: n.doc
        }) : 0 /* ChangeType.Added */  === e.type && 1 /* ChangeType.Removed */  === n.type ? this.mu = this.mu.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $2fa92ec193801792$export$1a82df3d29112e01(63341, {
            ye: e,
            pu: n
        }) : this.mu = this.mu.insert(t, e);
    }
    gu() {
        const e = [];
        return this.mu.inorderTraversal((t, n)=>{
            e.push(n);
        }), e;
    }
}
class $2fa92ec193801792$export$c3950d9923825c02 {
    constructor(e, t, n, r, i, s, _, o, a){
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = s, this.syncStateChanged = _, this.excludesMetadataChanges = o, this.hasCachedResults = a;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(e, t, n, r, i) {
        const s = [];
        return t.forEach((e)=>{
            s.push({
                type: 0 /* ChangeType.Added */ ,
                doc: e
            });
        }), new $2fa92ec193801792$export$c3950d9923825c02(e, t, $2fa92ec193801792$export$a93c5207d687da10.emptySet(t), s, n, r, /* syncStateChanged= */ true, /* excludesMetadataChanges= */ false, i);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(e) {
        if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && $2fa92ec193801792$var$__PRIVATE_queryOrPipelineEqual(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return false;
        const t = this.docChanges, n = e.docChanges;
        if (t.length !== n.length) return false;
        for(let e = 0; e < t.length; e++)if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return false;
        return true;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class $2fa92ec193801792$var$__PRIVATE_QueryListenersInfo {
    constructor(){
        this.yu = void 0, this.wu = [];
    }
    // Helper methods that checks if the query has listeners that listening to remote store
    bu() {
        return this.wu.some((e)=>e.vu());
    }
}
class $2fa92ec193801792$var$__PRIVATE_EventManagerImpl {
    constructor(){
        this.queries = $2fa92ec193801792$var$__PRIVATE_newQueriesObjectMap(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.Su = new Set;
    }
    terminate() {
        !function __PRIVATE_errorAllTargets(e, t) {
            const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = n.queries;
            // Prevent further access by clearing ObjectMap.
            n.queries = $2fa92ec193801792$var$__PRIVATE_newQueriesObjectMap(), r.forEach((e, n)=>{
                for (const e of n.wu)e.onError(t);
            });
        }(this, new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.ABORTED, "Firestore shutting down"));
    }
}
function $2fa92ec193801792$var$__PRIVATE_newQueriesObjectMap() {
    return new $2fa92ec193801792$var$ObjectMap((e)=>$2fa92ec193801792$var$__PRIVATE_canonifyQueryOrPipeline(e), $2fa92ec193801792$var$__PRIVATE_queryOrPipelineEqual);
}
async function $2fa92ec193801792$var$__PRIVATE_eventManagerListen(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    let r = 3 /* ListenerSetupAction.NoActionRequired */ ;
    const i = t.query;
    let s = n.queries.get(i);
    s ? !s.bu() && t.vu() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
    (r = 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ ) : (s = new $2fa92ec193801792$var$__PRIVATE_QueryListenersInfo, r = t.vu() ? 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */  : 1 /* ListenerSetupAction.InitializeLocalListenOnly */ );
    try {
        switch(r){
            case 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */ :
                s.yu = await n.onListen(i, /** enableRemoteListen= */ !0);
                break;
            case 1 /* ListenerSetupAction.InitializeLocalListenOnly */ :
                s.yu = await n.onListen(i, /** enableRemoteListen= */ !1);
                break;
            case 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ :
                await n.onFirstRemoteStoreListen(i);
        }
    } catch (e) {
        const n = $2fa92ec193801792$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Initialization of query '${$2fa92ec193801792$export$342063e11d6c3cad(t.query) ? $2fa92ec193801792$var$__PRIVATE_canonifyPipeline(t.query) : $2fa92ec193801792$var$__PRIVATE_stringifyQuery(t.query)}' failed`);
        return void t.onError(n);
    }
    if (n.queries.set(i, s), s.wu.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
    t.Du(n.onlineState), s.yu) t.xu(s.yu) && $2fa92ec193801792$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
async function $2fa92ec193801792$var$__PRIVATE_eventManagerUnlisten(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = t.query;
    let i = 3 /* ListenerRemovalAction.NoActionRequired */ ;
    const s = n.queries.get(r);
    if (s) {
        const e = s.wu.indexOf(t);
        e >= 0 && (s.wu.splice(e, 1), 0 === s.wu.length ? i = t.vu() ? 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */  : 1 /* ListenerRemovalAction.TerminateLocalListenOnly */  : !s.bu() && t.vu() && // The removed listener is the last one that sourced from watch.
        (i = 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ ));
    }
    switch(i){
        case 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ true);
        case 1 /* ListenerRemovalAction.TerminateLocalListenOnly */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ false);
        case 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ :
            return n.onLastRemoteStoreUnlisten(r);
        default:
            return;
    }
}
function $2fa92ec193801792$var$__PRIVATE_eventManagerOnWatchChange(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    let r = false;
    for (const e of t){
        const t = e.query, i = n.queries.get(t);
        if (i) {
            for (const t of i.wu)t.xu(e) && (r = true);
            i.yu = e;
        }
    }
    r && $2fa92ec193801792$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function $2fa92ec193801792$var$__PRIVATE_eventManagerOnWatchError(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_debugCast(e), i = r.queries.get(t);
    if (i) for (const e of i.wu)e.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(t);
}
function $2fa92ec193801792$var$__PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.Su.forEach((e)=>{
        e.next();
    });
}
var $2fa92ec193801792$var$Vr;
!function(e) {
    /** Listen to both cache and server changes */ e.Default = "default", /** Listen to changes in cache only */ e.Cache = "cache";
}($2fa92ec193801792$var$Vr || ($2fa92ec193801792$var$Vr = {}));
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class $2fa92ec193801792$var$__PRIVATE_QueryListener {
    constructor(e, t, n){
        this.query = e, this.Cu = t, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.Fu = false, this.Ou = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ xu(e) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const t = [];
            for (const n of e.docChanges)3 /* ChangeType.Metadata */  !== n.type && t.push(n);
            e = new $2fa92ec193801792$export$c3950d9923825c02(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, /* excludesMetadataChanges= */ true, e.hasCachedResults);
        }
        let t = false;
        return this.Fu ? this.Mu(e) && (this.Cu.next(e), t = true) : this.Nu(e, this.onlineState) && (this.Lu(e), t = true), this.Ou = e, t;
    }
    onError(e) {
        this.Cu.error(e);
    }
    /** Returns whether a snapshot was raised. */ Du(e) {
        this.onlineState = e;
        let t = false;
        return this.Ou && !this.Fu && this.Nu(this.Ou, e) && (this.Lu(this.Ou), t = true), t;
    }
    Nu(e, t) {
        // Always raise the first event when we're synced
        if (!e.fromCache) return true;
        // Always raise event if listening to cache
        if (!this.vu()) return true;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* OnlineState.Offline */  !== t;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options.waitForSyncWhenOnline || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */  === t);
    // Raise data from cache if we have any documents, have cached results before,
    // or we are offline.
    }
    Mu(e) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (e.docChanges.length > 0) return true;
        const t = this.Ou && this.Ou.hasPendingWrites !== e.hasPendingWrites;
        return !(!e.syncStateChanged && !t) && true === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    Lu(e) {
        e = $2fa92ec193801792$export$c3950d9923825c02.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.Fu = true, this.Cu.next(e);
    }
    vu() {
        return this.options.source !== $2fa92ec193801792$var$Vr.Cache;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class $2fa92ec193801792$var$__PRIVATE_BundleConverterImpl {
    constructor(e){
        this.serializer = e;
    }
    Qo(e) {
        return $2fa92ec193801792$var$fromName(this.serializer, e);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ Go(e) {
        return e.metadata.exists ? $2fa92ec193801792$export$3a1a48c8f6ef640e(this.serializer, e.document, false) : $2fa92ec193801792$var$MutableDocument.newNoDocument(this.Qo(e.metadata.name), this.zo(e.metadata.readTime));
    }
    zo(e) {
        return $2fa92ec193801792$var$__PRIVATE_fromVersion(e);
    }
}
/**
 * A class to process the elements from a bundle, and optionally load them into local
 * storage and provide progress update while loading.
 */ class $2fa92ec193801792$export$61196ced6d74a310 {
    constructor(e, t){
        this.Bu = e, this.serializer = t, /** Batched queries to be saved into storage */ this.Uu = [], /** Batched documents to be saved into storage */ this.ku = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $2fa92ec193801792$var$__PRIVATE_bundleInitialProgress(e);
    }
    /**
     * Returns the named queries that have been parsed from the SizeBundleElements added by
     * calling {@link adSizedElement}.
     */ get queries() {
        return this.Uu;
    }
    /**
     * Returns the BundledDocuments that have been parsed from the SizeBundleElements added by
     * calling {@link addSizedElement}.
     */ get documents() {
        return this.ku;
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ qu(e) {
        this.progress.bytesLoaded += e.byteLength;
        let t = this.progress.documentsLoaded;
        if (e.jo.namedQuery) this.Uu.push(e.jo.namedQuery);
        else if (e.jo.documentMetadata) {
            this.ku.push({
                metadata: e.jo.documentMetadata
            }), e.jo.documentMetadata.exists || ++t;
            const n = $2fa92ec193801792$export$db202ddc8be9136.fromString(e.jo.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else e.jo.document && (this.ku[this.ku.length - 1].document = e.jo.document, ++t);
        return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, {
            ...this.progress
        }) : null;
    }
    $u(e) {
        const t = new Map, n = new $2fa92ec193801792$var$__PRIVATE_BundleConverterImpl(this.serializer);
        for (const r of e)if (r.metadata.queries) {
            const e = n.Qo(r.metadata.name);
            for (const n of r.metadata.queries){
                const r = (t.get(n) || $2fa92ec193801792$export$a9c996f45e5784d0()).add(e);
                t.set(n, r);
            }
        }
        return t;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async Ku(e) {
        const t = await $2fa92ec193801792$var$__PRIVATE_localStoreApplyBundledDocuments(e, new $2fa92ec193801792$var$__PRIVATE_BundleConverterImpl(this.serializer), this.ku, this.Bu.id), n = this.$u(this.documents);
        for (const t of this.Uu)await $2fa92ec193801792$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n.get(t.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            Wu: this.collectionGroups,
            Qu: t
        };
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $2fa92ec193801792$var$__PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$var$__PRIVATE_AddedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
class $2fa92ec193801792$var$__PRIVATE_RemovedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class $2fa92ec193801792$var$__PRIVATE_View {
    constructor(e, /** Documents included in the remote target */ t){
        this.query = e, this.Gu = t, this.zu = null, this.hasCachedResults = false, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = false, /** Documents in the view but not in the remote target */ this.ju = $2fa92ec193801792$export$a9c996f45e5784d0(), /** Document Keys that have local changes */ this.mutatedKeys = $2fa92ec193801792$export$a9c996f45e5784d0(), this.Hu = $2fa92ec193801792$export$342063e11d6c3cad(e) ? $2fa92ec193801792$export$953cecd6e717a553(e) : $2fa92ec193801792$export$7ccc53e8f1e7dfc5(e), this.Ju = new $2fa92ec193801792$export$a93c5207d687da10(this.Hu);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get Yu() {
        return this.Gu;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ Zu(e, t) {
        const n = t ? t.Xu : new $2fa92ec193801792$var$__PRIVATE_DocumentChangeSet, r = t ? t.Ju : this.Ju;
        let i = t ? t.mutatedKeys : this.mutatedKeys, s = r, _ = false;
        const [o, a] = this.ec(this.query, r);
        e.inorderTraversal((e, t)=>{
            const u = r.get(e), c = $2fa92ec193801792$var$__PRIVATE_queryOrPipelineMatches(this.query, t) ? t : null, l = !!u && this.mutatedKeys.has(u.key), E = !!c && (c.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
            let h = false;
            // Calculate change
            if (u && c) u.data.isEqual(c.data) ? l !== E && (n.track({
                type: 3 /* ChangeType.Metadata */ ,
                doc: c
            }), h = true) : this.tc(u, c) || (n.track({
                type: 2 /* ChangeType.Modified */ ,
                doc: c
            }), h = true, (o && this.Hu(c, o) > 0 || a && this.Hu(c, a) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (_ = true));
            else !u && c ? (n.track({
                type: 0 /* ChangeType.Added */ ,
                doc: c
            }), h = true) : u && !c && (n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: u
            }), h = true, (o || a) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (_ = true));
            h && (c ? (s = s.add(c), i = E ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
        });
        // Drop documents out to meet limit/limitToLast requirement.
        const u = this.nc(this.query);
        if (u) {
            if ($2fa92ec193801792$export$342063e11d6c3cad(this.query)) {
                // TODO(pipeline): Not very efficient obviously, but should be fine for now.
                // Longer term, limit queries should be evaluated from query engine as well.
                const e = [];
                s.forEach((t)=>e.push(t));
                const t = $2fa92ec193801792$var$__PRIVATE_runPipeline(this.query, e);
                let r = new $2fa92ec193801792$export$a93c5207d687da10($2fa92ec193801792$export$953cecd6e717a553(this.query));
                for (const e of t)r = r.add(e);
                s.forEach((e)=>{
                    r.has(e.key) || (i = i.delete(e.key), n.track({
                        type: 1 /* ChangeType.Removed */ ,
                        doc: e
                    }));
                }), s = r;
            } else {
                const e = this.rc(this.query);
                for(; s.size > u;){
                    const t = "F" /* LimitType.First */  === e ? s.last() : s.first();
                    s = s.delete(t.key), i = i.delete(t.key), n.track({
                        type: 1 /* ChangeType.Removed */ ,
                        doc: t
                    });
                }
            }
        }
        return {
            Ju: s,
            Xu: n,
            Fo: _,
            mutatedKeys: i
        };
    }
    nc(e) {
        return $2fa92ec193801792$export$342063e11d6c3cad(e) ? $2fa92ec193801792$var$__PRIVATE_getLastEffectiveLimit(e)?.limit : e.limit || void 0;
    }
    rc(e) {
        if ($2fa92ec193801792$export$342063e11d6c3cad(e)) {
            const t = $2fa92ec193801792$var$__PRIVATE_getLastEffectiveLimit(e);
            return t && t.limit < 0 ? "L" /* LimitType.Last */  : "F" /* LimitType.First */ ;
        }
        return e.limitType;
    }
    ec(e, t) {
        if ($2fa92ec193801792$export$342063e11d6c3cad(e)) {
            const n = $2fa92ec193801792$var$__PRIVATE_getLastEffectiveLimit(e)?.limit;
            return [
                t.size === n ? t.last() : null,
                null
            ];
        }
        return [
            "F" /* LimitType.First */  === e.limitType && t.size === this.nc(this.query) ? t.last() : null,
            "L" /* LimitType.Last */  === e.limitType && t.size === this.nc(this.query) ? t.first() : null
        ];
    }
    tc(e, t) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param limboResolutionEnabled - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @param targetIsPendingReset - Whether the target is pending to reset due to
     *        existence filter mismatch. If not explicitly specified, it is treated
     *        equivalently to `false`.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(e, t, n, r) {
        const i = this.Ju;
        this.Ju = e.Ju, this.mutatedKeys = e.mutatedKeys;
        // Sort changes based on type and query comparator
        const s = e.Xu.gu();
        s.sort((e, t)=>(function __PRIVATE_compareChangeType(e, t) {
                const order = (e)=>{
                    switch(e){
                        case 0 /* ChangeType.Added */ :
                            return 1;
                        case 2 /* ChangeType.Modified */ :
                        case 3 /* ChangeType.Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* ChangeType.Removed */ :
                            return 0;
                        default:
                            return $2fa92ec193801792$export$1a82df3d29112e01(20277, {
                                ye: e
                            });
                    }
                };
                return order(e) - order(t);
            })(e.type, t.type) || this.Hu(e.doc, t.doc)), this.sc(n), r = r ?? false;
        const _ = t && !r ? this._c() : [], o = 0 === this.ju.size && this.current && !r ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , a = o !== this.zu;
        // We are at synced state if there is no limbo docs are waiting to be resolved, view is current
        // with the backend, and the query is not pending to reset due to existence filter mismatch.
        if (this.zu = o, 0 !== s.length || a) return {
            snapshot: new $2fa92ec193801792$export$c3950d9923825c02(this.query, e.Ju, i, s, e.mutatedKeys, 0 /* SyncState.Local */  === o, a, /* excludesMetadataChanges= */ false, !!n && n.resumeToken.approximateByteSize() > 0),
            oc: _
        };
        // no changes
        return {
            oc: _
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ Du(e) {
        return this.current && "Offline" /* OnlineState.Offline */  === e ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = false, this.applyChanges({
            Ju: this.Ju,
            Xu: new $2fa92ec193801792$var$__PRIVATE_DocumentChangeSet,
            mutatedKeys: this.mutatedKeys,
            Fo: false
        }, /* limboResolutionEnabled= */ false)) : {
            oc: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ ac(e) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.Gu.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.Ju.has(e) && !this.Ju.get(e).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ sc(e) {
        e && (e.addedDocuments.forEach((e)=>this.Gu = this.Gu.add(e)), e.modifiedDocuments.forEach((e)=>{}), e.removedDocuments.forEach((e)=>this.Gu = this.Gu.delete(e)), this.current = e.current);
    }
    _c() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const e = this.ju;
        this.ju = $2fa92ec193801792$export$a9c996f45e5784d0(), this.Ju.forEach((e)=>{
            this.ac(e.key) && (this.ju = this.ju.add(e.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const t = [];
        return e.forEach((e)=>{
            this.ju.has(e) || t.push(new $2fa92ec193801792$var$__PRIVATE_RemovedLimboDocument(e));
        }), this.ju.forEach((n)=>{
            e.has(n) || t.push(new $2fa92ec193801792$var$__PRIVATE_AddedLimboDocument(n));
        }), t;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    uc(e) {
        this.Gu = e.Wo, this.ju = $2fa92ec193801792$export$a9c996f45e5784d0();
        const t = this.Zu(e.documents);
        return this.applyChanges(t, /* limboResolutionEnabled= */ true);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    cc() {
        return $2fa92ec193801792$export$c3950d9923825c02.fromInitialDocuments(this.query, this.Ju, this.mutatedKeys, 0 /* SyncState.Local */  === this.zu, this.hasCachedResults);
    }
}
const $2fa92ec193801792$var$dr = "SyncEngine";
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class $2fa92ec193801792$var$__PRIVATE_QueryView {
    constructor(/**
     * The query itself.
     */ e, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ t, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = e, this.targetId = t, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class $2fa92ec193801792$var$LimboResolution {
    constructor(e){
        this.key = e, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.lc = false;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $2fa92ec193801792$var$__PRIVATE_SyncEngineImpl {
    constructor(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s){
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.Ec = {}, this.hc = new $2fa92ec193801792$var$ObjectMap((e)=>$2fa92ec193801792$var$__PRIVATE_canonifyQueryOrPipeline(e), $2fa92ec193801792$var$__PRIVATE_queryOrPipelineEqual), this.Tc = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.Pc = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.Rc = new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$export$a07804094c3ecf2d.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.Ic = new Map, this.Ac = new $2fa92ec193801792$var$__PRIVATE_ReferenceSet, /** Stores user completion handlers, indexed by User and BatchId. */ this.Vc = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.dc = new Map, this.fc = $2fa92ec193801792$var$__PRIVATE_TargetIdGenerator.ws(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.mc = void 0;
    }
    get isPrimaryClient() {
        return true === this.mc;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function $2fa92ec193801792$var$__PRIVATE_syncEngineListen(e, t, n = true) {
    const r = $2fa92ec193801792$var$__PRIVATE_ensureWatchCallbacks(e);
    let i;
    const s = r.hc.get(t);
    return s ? // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    (r.sharedClientState.addLocalQueryTarget(s.targetId), i = s.view.cc()) : i = await $2fa92ec193801792$var$__PRIVATE_allocateTargetAndMaybeListen(r, t, n, /** shouldInitializeView= */ true), i;
}
/** Query has been listening to the cache, and tries to initiate the remote store listen */ async function $2fa92ec193801792$var$__PRIVATE_triggerRemoteStoreListen(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_ensureWatchCallbacks(e);
    await $2fa92ec193801792$var$__PRIVATE_allocateTargetAndMaybeListen(n, t, /** shouldListenToRemote= */ true, /** shouldInitializeView= */ false);
}
async function $2fa92ec193801792$var$__PRIVATE_allocateTargetAndMaybeListen(e, t, n, r) {
    const i = await $2fa92ec193801792$var$__PRIVATE_localStoreAllocateTarget(e.localStore, $2fa92ec193801792$export$342063e11d6c3cad(t) ? t : $2fa92ec193801792$var$__PRIVATE_queryToTarget(t)), s = i.targetId, _ = e.sharedClientState.addLocalQueryTarget(s, n);
    let o;
    return r && (o = await $2fa92ec193801792$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, s, "current" === _, i.resumeToken)), e.isPrimaryClient && n && $2fa92ec193801792$var$__PRIVATE_remoteStoreListen(e.remoteStore, i), o;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function $2fa92ec193801792$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    e.gc = (t, n, r)=>(async function __PRIVATE_applyDocChanges(e, t, n, r) {
            let i = t.view.Zu(n);
            i.Fo && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await $2fa92ec193801792$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t.query, /* usePreviousResults= */ false).then(({ documents: e })=>t.view.Zu(e, i)));
            const s = r && r.targetChanges.get(t.targetId), _ = r && null != r.targetMismatches.get(t.targetId), o = t.view.applyChanges(i, /* limboResolutionEnabled= */ e.isPrimaryClient, s, _);
            return $2fa92ec193801792$var$__PRIVATE_updateTrackedLimbos(e, t.targetId, o.oc), o.snapshot;
        })(e, t, n, r);
    const s = await $2fa92ec193801792$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t, /* usePreviousResults= */ true), _ = new $2fa92ec193801792$var$__PRIVATE_View(t, s.Wo), o = _.Zu(s.documents), a = $2fa92ec193801792$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */  !== e.onlineState, i), u = _.applyChanges(o, /* limboResolutionEnabled= */ e.isPrimaryClient, a);
    $2fa92ec193801792$var$__PRIVATE_updateTrackedLimbos(e, n, u.oc);
    const c = new $2fa92ec193801792$var$__PRIVATE_QueryView(t, n, _);
    return e.hc.set(t, c), e.Tc.has(n) ? e.Tc.get(n).push(t) : e.Tc.set(n, [
        t
    ]), u.snapshot;
}
/** Stops listening to the query. */ async function $2fa92ec193801792$var$__PRIVATE_syncEngineUnlisten(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_debugCast(e), i = r.hc.get(t), s = r.Tc.get(i.targetId);
    if (s.length > 1) return r.Tc.set(i.targetId, s.filter((e)=>!$2fa92ec193801792$var$__PRIVATE_queryOrPipelineEqual(e, t))), void r.hc.delete(t);
    // No other queries are mapped to the target, clean up the query and the target.
    if (r.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        r.sharedClientState.removeLocalQueryTarget(i.targetId);
        r.sharedClientState.isActiveQueryTarget(i.targetId) || await $2fa92ec193801792$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ false).then(()=>{
            r.sharedClientState.clearQueryState(i.targetId), n && $2fa92ec193801792$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, i.targetId), $2fa92ec193801792$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId);
        }).catch($2fa92ec193801792$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    } else $2fa92ec193801792$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId), await $2fa92ec193801792$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ true);
}
/** Unlistens to the remote store while still listening to the cache. */ async function $2fa92ec193801792$var$__PRIVATE_triggerRemoteStoreUnlisten(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = n.hc.get(t), i = n.Tc.get(r.targetId);
    n.isPrimaryClient && 1 === i.length && // PORTING NOTE: Unregister the target ID with local Firestore client as
    // watch target.
    (n.sharedClientState.removeLocalQueryTarget(r.targetId), $2fa92ec193801792$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId));
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function $2fa92ec193801792$var$__PRIVATE_syncEngineWrite(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e);
    try {
        const e = await function __PRIVATE_localStoreWriteLocally(e, t) {
            const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = $2fa92ec193801792$export$890c4ad488842ce7.now(), i = t.reduce((e, t)=>e.add(t.key), $2fa92ec193801792$export$a9c996f45e5784d0());
            let s, _;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (e)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let o = $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap(), a = $2fa92ec193801792$export$a9c996f45e5784d0();
                return n.Uo.getEntries(e, i).next((e)=>{
                    o = e, o.forEach((e, t)=>{
                        t.isValidDocument() || (a = a.add(e));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(e, o)).next((i)=>{
                    s = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const _ = [];
                    for (const e of t){
                        const t = $2fa92ec193801792$var$__PRIVATE_mutationExtractBaseValue(e, s.get(e.key).overlayedDocument);
                        null != t && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        _.push(new $2fa92ec193801792$var$__PRIVATE_PatchMutation(e.key, t, $2fa92ec193801792$var$__PRIVATE_extractFieldMask(t.value.mapValue), $2fa92ec193801792$export$56c0d5a1e737357d.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(e, r, _, t);
                }).next((t)=>{
                    _ = t;
                    const r = t.applyToLocalDocumentSet(s, a);
                    return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                });
            }).then(()=>({
                    batchId: _.batchId,
                    changes: $2fa92ec193801792$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
                }));
        }(r.localStore, t);
        r.sharedClientState.addPendingMutation(e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
            let r = e.Vc[e.currentUser.toKey()];
            r || (r = new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$var$__PRIVATE_primitiveComparator));
            r = r.insert(t, n), e.Vc[e.currentUser.toKey()] = r;
        }(r, e.batchId, n), await $2fa92ec193801792$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e.changes), await $2fa92ec193801792$var$__PRIVATE_fillWritePipeline(r.remoteStore);
    } catch (e) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const t = $2fa92ec193801792$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Failed to persist write");
        n.reject(t);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function $2fa92ec193801792$var$__PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    try {
        const e = await $2fa92ec193801792$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t);
        // Update `receivedDocument` as appropriate for any limbo targets.
        t.targetChanges.forEach((e, t)=>{
            const r = n.Ic.get(t);
            r && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            ($2fa92ec193801792$var$__PRIVATE_hardAssert(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1, 22616), e.addedDocuments.size > 0 ? r.lc = !0 : e.modifiedDocuments.size > 0 ? $2fa92ec193801792$var$__PRIVATE_hardAssert(r.lc, 14607) : e.removedDocuments.size > 0 && ($2fa92ec193801792$var$__PRIVATE_hardAssert(r.lc, 42227), r.lc = !1));
        }), await $2fa92ec193801792$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e, t);
    } catch (e) {
        await $2fa92ec193801792$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $2fa92ec193801792$var$__PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        const e = [];
        r.hc.forEach((n, r)=>{
            const i = r.view.Du(t);
            i.snapshot && e.push(i.snapshot);
        }), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
            n.onlineState = t;
            let r = false;
            n.queries.forEach((e, n)=>{
                for (const e of n.wu)// Run global snapshot listeners if a consistent snapshot has been emitted.
                e.Du(t) && (r = true);
            }), r && $2fa92ec193801792$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
        }(r.eventManager, t), e.length && r.Ec.hn(e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function $2fa92ec193801792$var$__PRIVATE_syncEngineRejectListen(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    // PORTING NOTE: Multi-tab only.
    r.sharedClientState.updateQueryState(t, "rejected", n);
    const i = r.Ic.get(t), s = i && i.key;
    if (s) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let e = new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$export$a07804094c3ecf2d.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        e = e.insert(s, $2fa92ec193801792$var$MutableDocument.newNoDocument(s, $2fa92ec193801792$var$SnapshotVersion.min()));
        const n = $2fa92ec193801792$export$a9c996f45e5784d0().add(s), i = new $2fa92ec193801792$var$RemoteEvent($2fa92ec193801792$var$SnapshotVersion.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$var$__PRIVATE_primitiveComparator), e, $2fa92ec193801792$var$__PRIVATE_mutableDocumentMap(), n);
        await $2fa92ec193801792$var$__PRIVATE_syncEngineApplyRemoteEvent(r, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        r.Rc = r.Rc.remove(s), r.Ic.delete(t), $2fa92ec193801792$var$__PRIVATE_pumpEnqueuedLimboResolutions(r);
    } else await $2fa92ec193801792$var$__PRIVATE_localStoreReleaseTarget(r.localStore, t, /* keepPersistedTargetData */ false).then(()=>$2fa92ec193801792$var$__PRIVATE_removeAndCleanupTarget(r, t, n)).catch($2fa92ec193801792$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
}
async function $2fa92ec193801792$var$__PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = t.batch.batchId;
    try {
        const e = await $2fa92ec193801792$var$__PRIVATE_localStoreAcknowledgeBatch(n.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        $2fa92ec193801792$var$__PRIVATE_processUserCallback(n, r, /*error=*/ null), $2fa92ec193801792$var$__PRIVATE_triggerPendingWritesCallbacks(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await $2fa92ec193801792$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
    } catch (e) {
        await $2fa92ec193801792$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
async function $2fa92ec193801792$var$__PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    try {
        const e = await function __PRIVATE_localStoreRejectBatch(e, t) {
            const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (e)=>{
                let r;
                return n.mutationQueue.lookupMutationBatch(e, t).next((t)=>($2fa92ec193801792$var$__PRIVATE_hardAssert(null !== t, 37113), r = t.keys(), n.mutationQueue.removeMutationBatch(e, t))).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r)).next(()=>n.localDocuments.getDocuments(e, r));
            });
        }(r.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        $2fa92ec193801792$var$__PRIVATE_processUserCallback(r, t, n), $2fa92ec193801792$var$__PRIVATE_triggerPendingWritesCallbacks(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await $2fa92ec193801792$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e);
    } catch (n) {
        await $2fa92ec193801792$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function $2fa92ec193801792$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    $2fa92ec193801792$var$__PRIVATE_canUseNetwork(n.remoteStore) || $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$dr, "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const e = await function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
            const t = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
            return t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (e)=>t.mutationQueue.getHighestUnacknowledgedBatchId(e));
        }(n.localStore);
        if (e === $2fa92ec193801792$var$Ke) // Trigger the callback right away if there is no pending writes at the moment.
        return void t.resolve();
        const r = n.dc.get(e) || [];
        r.push(t), n.dc.set(e, r);
    } catch (e) {
        const n = $2fa92ec193801792$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Initialization of waitForPendingWrites() operation failed");
        t.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $2fa92ec193801792$var$__PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.dc.get(t) || []).forEach((e)=>{
        e.resolve();
    }), e.dc.delete(t);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $2fa92ec193801792$var$__PRIVATE_processUserCallback(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    let i = r.Vc[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const e = i.get(t);
        e && (n ? e.reject(n) : e.resolve(), i = i.remove(t)), r.Vc[r.currentUser.toKey()] = i;
    }
}
function $2fa92ec193801792$var$__PRIVATE_removeAndCleanupTarget(e, t, n = null) {
    e.sharedClientState.removeLocalQueryTarget(t);
    for (const r of e.Tc.get(t))e.hc.delete(r), n && e.Ec.yc(r, n);
    if (e.Tc.delete(t), e.isPrimaryClient) e.Ac.Xs(t).forEach((t)=>{
        e.Ac.containsKey(t) || // We removed the last reference for this key
        $2fa92ec193801792$var$__PRIVATE_removeLimboTarget(e, t);
    });
}
function $2fa92ec193801792$var$__PRIVATE_removeLimboTarget(e, t) {
    e.Pc.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = e.Rc.get(t);
    null !== n && ($2fa92ec193801792$var$__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.Rc = e.Rc.remove(t), e.Ic.delete(n), $2fa92ec193801792$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function $2fa92ec193801792$var$__PRIVATE_updateTrackedLimbos(e, t, n) {
    for (const r of n)if (r instanceof $2fa92ec193801792$var$__PRIVATE_AddedLimboDocument) e.Ac.addReference(r.key, t), $2fa92ec193801792$var$__PRIVATE_trackLimboChange(e, r);
    else if (r instanceof $2fa92ec193801792$var$__PRIVATE_RemovedLimboDocument) {
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$dr, "Document no longer in limbo: " + r.key), e.Ac.removeReference(r.key, t);
        e.Ac.containsKey(r.key) || // We removed the last reference for this key
        $2fa92ec193801792$var$__PRIVATE_removeLimboTarget(e, r.key);
    } else $2fa92ec193801792$export$1a82df3d29112e01(19791, {
        wc: r
    });
}
function $2fa92ec193801792$var$__PRIVATE_trackLimboChange(e, t) {
    const n = t.key, r = n.path.canonicalString();
    e.Rc.get(n) || e.Pc.has(r) || ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$dr, "New document in limbo: " + n), e.Pc.add(r), $2fa92ec193801792$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $2fa92ec193801792$var$__PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for(; e.Pc.size > 0 && e.Rc.size < e.maxConcurrentLimboResolutions;){
        const t = e.Pc.values().next().value;
        e.Pc.delete(t);
        const n = new $2fa92ec193801792$export$a07804094c3ecf2d($2fa92ec193801792$export$db202ddc8be9136.fromString(t)), r = e.fc.next();
        e.Ic.set(r, new $2fa92ec193801792$var$LimboResolution(n)), e.Rc = e.Rc.insert(n, r), $2fa92ec193801792$var$__PRIVATE_remoteStoreListen(e.remoteStore, new $2fa92ec193801792$var$TargetData($2fa92ec193801792$var$__PRIVATE_queryToTarget($2fa92ec193801792$export$3c2fa207a37baaea(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , $2fa92ec193801792$var$__PRIVATE_ListenSequence.yn));
    }
}
async function $2fa92ec193801792$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_debugCast(e), i = [], s = [], _ = [];
    r.hc.isEmpty() || (r.hc.forEach((e, o)=>{
        _.push(r.gc(o, t, n).then((e)=>{
            // If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
            if ((e || n) && r.isPrimaryClient) {
                // Query state is set to `current` if:
                // - There is a view change and it is up-to-date, or,
                // - There is a global snapshot, the Target is current, and no changes to be resolved
                const t = e ? !e.fromCache : n?.targetChanges.get(o.targetId)?.current;
                r.sharedClientState.updateQueryState(o.targetId, t ? "current" : "not-current");
            }
            // Update views if there are actual changes.
            if (e) {
                i.push(e);
                const t = $2fa92ec193801792$var$__PRIVATE_LocalViewChanges.fo(o.targetId, e);
                s.push(t);
            }
        }));
    }), await Promise.all(_), r.Ec.hn(i), await async function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (e)=>$2fa92ec193801792$var$PersistencePromise.forEach(t, (t)=>$2fa92ec193801792$var$PersistencePromise.forEach(t.Ao, (r)=>n.persistence.referenceDelegate.addReference(e, t.targetId, r)).next(()=>$2fa92ec193801792$var$PersistencePromise.forEach(t.Vo, (r)=>n.persistence.referenceDelegate.removeReference(e, t.targetId, r)))));
        } catch (e) {
            if (!$2fa92ec193801792$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$lr, "Failed to update sequence numbers: " + e);
        }
        for (const e of t){
            const t = e.targetId;
            if (!e.fromCache) {
                const e = n.No.get(t), r = e.snapshotVersion, i = e.withLastLimboFreeSnapshotVersion(r);
                // Advance the last limbo free snapshot version
                n.No = n.No.insert(t, i);
            }
        }
    }(r.localStore, s));
}
async function $2fa92ec193801792$var$__PRIVATE_syncEngineHandleCredentialChange(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    if (!n.currentUser.isEqual(t)) {
        $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$dr, "User change. New user:", t.toKey());
        const e = await $2fa92ec193801792$var$__PRIVATE_localStoreHandleUserChange(n.localStore, t);
        n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
        function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e, t) {
            e.dc.forEach((e)=>{
                e.forEach((e)=>{
                    e.reject(new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.CANCELLED, t));
                });
            }), e.dc.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds), await $2fa92ec193801792$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e.qo);
    }
}
function $2fa92ec193801792$var$__PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = n.Ic.get(t);
    if (r && r.lc) return $2fa92ec193801792$export$a9c996f45e5784d0().add(r.key);
    {
        let e = $2fa92ec193801792$export$a9c996f45e5784d0();
        const r = n.Tc.get(t);
        if (!r) return e;
        for (const t of r ?? []){
            const r = n.hc.get(t);
            e = e.unionWith(r.view.Yu);
        }
        return e;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function $2fa92ec193801792$var$__PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = await $2fa92ec193801792$var$__PRIVATE_localStoreExecuteQuery(n.localStore, t.query, /* usePreviousResults= */ true), i = t.view.uc(r);
    return n.isPrimaryClient && $2fa92ec193801792$var$__PRIVATE_updateTrackedLimbos(n, t.targetId, i.oc), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function $2fa92ec193801792$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    return $2fa92ec193801792$var$__PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then((e)=>$2fa92ec193801792$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function $2fa92ec193801792$var$__PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    const i = $2fa92ec193801792$var$__PRIVATE_debugCast(e), s = await function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
        const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = $2fa92ec193801792$var$__PRIVATE_debugCast(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (e)=>r.Wr(e, t).next((t)=>t ? n.localDocuments.getDocuments(e, t) : $2fa92ec193801792$var$PersistencePromise.resolve(null)));
    }(i.localStore, t);
    null !== s ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await $2fa92ec193801792$var$__PRIVATE_fillWritePipeline(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    ($2fa92ec193801792$var$__PRIVATE_processUserCallback(i, t, r || null), $2fa92ec193801792$var$__PRIVATE_triggerPendingWritesCallbacks(i, t), function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
        $2fa92ec193801792$var$__PRIVATE_debugCast($2fa92ec193801792$var$__PRIVATE_debugCast(e).mutationQueue).jr(t);
    }(i.localStore, t)) : $2fa92ec193801792$export$1a82df3d29112e01(6720, "Unknown batchState", {
        bc: n
    }), await $2fa92ec193801792$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$dr, "Cannot apply mutation batch with id: " + t);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $2fa92ec193801792$var$__PRIVATE_syncEngineApplyPrimaryState(e, t) {
    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    if ($2fa92ec193801792$var$__PRIVATE_ensureWatchCallbacks(n), $2fa92ec193801792$var$__PRIVATE_syncEngineEnsureWriteCallbacks(n), true === t && true !== n.mc) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const e = n.sharedClientState.getAllActiveQueryTargets(), t = await $2fa92ec193801792$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e.toArray());
        n.mc = true, await $2fa92ec193801792$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, true);
        for (const e of t)$2fa92ec193801792$var$__PRIVATE_remoteStoreListen(n.remoteStore, e);
    } else if (false === t && false !== n.mc) {
        const e = [];
        let t = Promise.resolve();
        n.Tc.forEach((r, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? e.push(i) : t = t.then(()=>($2fa92ec193801792$var$__PRIVATE_removeAndCleanupTarget(n, i), $2fa92ec193801792$var$__PRIVATE_localStoreReleaseTarget(n.localStore, i, /*keepPersistedTargetData=*/ true))), $2fa92ec193801792$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
        }), await t, await $2fa92ec193801792$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e), // PORTING NOTE: Multi-Tab only.
        function __PRIVATE_resetLimboDocuments(e) {
            const t = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
            t.Ic.forEach((e, n)=>{
                $2fa92ec193801792$var$__PRIVATE_remoteStoreUnlisten(t.remoteStore, n);
            }), t.Ac.e_(), t.Ic = new Map, t.Rc = new $2fa92ec193801792$var$SortedMap($2fa92ec193801792$export$a07804094c3ecf2d.comparator);
        }(n), n.mc = false, await $2fa92ec193801792$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, false);
    }
}
async function $2fa92ec193801792$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_debugCast(e), i = [], s = [];
    for (const e of t){
        let t;
        const n = r.Tc.get(e);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            t = await $2fa92ec193801792$var$__PRIVATE_localStoreAllocateTarget(r.localStore, $2fa92ec193801792$export$342063e11d6c3cad(n[0]) ? n[0] : $2fa92ec193801792$var$__PRIVATE_queryToTarget(n[0]));
            for (const e of n){
                const t = r.hc.get(e), n = await $2fa92ec193801792$var$__PRIVATE_synchronizeViewAndComputeSnapshot(r, t);
                n.snapshot && s.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await $2fa92ec193801792$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e);
            t = await $2fa92ec193801792$var$__PRIVATE_localStoreAllocateTarget(r.localStore, n), await $2fa92ec193801792$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $2fa92ec193801792$var$__PRIVATE_synthesizeTargetToQuery(n), e, /*current=*/ false, t.resumeToken);
        }
        i.push(t);
    }
    return r.Ec.hn(s), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $2fa92ec193801792$var$__PRIVATE_synthesizeTargetToQuery(e) {
    return $2fa92ec193801792$var$__PRIVATE_targetIsPipelineTarget(e) ? e : $2fa92ec193801792$var$__PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $2fa92ec193801792$var$__PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return $2fa92ec193801792$var$__PRIVATE_debugCast($2fa92ec193801792$var$__PRIVATE_debugCast(e).persistence).Ro();
    }($2fa92ec193801792$var$__PRIVATE_debugCast(e).localStore);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $2fa92ec193801792$var$__PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    const i = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    if (i.mc) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$dr, "Ignoring unexpected query state notification.");
    const s = i.Tc.get(t);
    if (s && s.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                let e;
                if ($2fa92ec193801792$export$342063e11d6c3cad(s[0])) switch($2fa92ec193801792$var$getPipelineSourceType(s[0])){
                    case "collection_group":
                    case "collection":
                        e = await $2fa92ec193801792$var$__PRIVATE_localStoreGetNewDocumentChanges(i.localStore, $2fa92ec193801792$var$getPipelineCollectionId(s[0]));
                        break;
                    case "documents":
                        e = await function __PRIVATE_localStoreGetDocuments(e, t) {
                            const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = $2fa92ec193801792$export$a9c996f45e5784d0(...$2fa92ec193801792$var$getPipelineDocuments(t).map((e)=>$2fa92ec193801792$export$a07804094c3ecf2d.fromPath(e)));
                            return n.persistence.runTransaction("Get documents for pipeline", "readonly", (e)=>n.Uo.getEntries(e, r)).then((e)=>e);
                        }(i.localStore, s[0]);
                        break;
                    default:
                        $2fa92ec193801792$export$7f8ddf7c7c20b3cd(""), e = $2fa92ec193801792$var$documentMap();
                }
                else e = await $2fa92ec193801792$var$__PRIVATE_localStoreGetNewDocumentChanges(i.localStore, function __PRIVATE_queryCollectionGroup(e) {
                    return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
                }(s[0]));
                const r = $2fa92ec193801792$var$RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, $2fa92ec193801792$export$158acd800e1ef08b.EMPTY_BYTE_STRING);
                await $2fa92ec193801792$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, e, r);
                break;
            }
        case "rejected":
            await $2fa92ec193801792$var$__PRIVATE_localStoreReleaseTarget(i.localStore, t, /* keepPersistedTargetData */ true), $2fa92ec193801792$var$__PRIVATE_removeAndCleanupTarget(i, t, r);
            break;
        default:
            $2fa92ec193801792$export$1a82df3d29112e01(64155, n);
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function $2fa92ec193801792$var$__PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_ensureWatchCallbacks(e);
    if (r.mc) {
        for (const e of t){
            if (r.Tc.has(e) && r.sharedClientState.isActiveQueryTarget(e)) {
                $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$dr, "Adding an already active target " + e);
                continue;
            }
            const t = await $2fa92ec193801792$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e), n = await $2fa92ec193801792$var$__PRIVATE_localStoreAllocateTarget(r.localStore, t);
            await $2fa92ec193801792$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $2fa92ec193801792$var$__PRIVATE_synthesizeTargetToQuery(t), n.targetId, /*current=*/ false, n.resumeToken), $2fa92ec193801792$var$__PRIVATE_remoteStoreListen(r.remoteStore, n);
        }
        for (const e of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        r.Tc.has(e) && // Release queries that are still active.
        await $2fa92ec193801792$var$__PRIVATE_localStoreReleaseTarget(r.localStore, e, /* keepPersistedTargetData */ false).then(()=>{
            $2fa92ec193801792$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, e), $2fa92ec193801792$var$__PRIVATE_removeAndCleanupTarget(r, e);
        }).catch($2fa92ec193801792$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    }
}
function $2fa92ec193801792$var$__PRIVATE_ensureWatchCallbacks(e) {
    const t = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = $2fa92ec193801792$var$__PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = $2fa92ec193801792$var$__PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = $2fa92ec193801792$var$__PRIVATE_syncEngineRejectListen.bind(null, t), t.Ec.hn = $2fa92ec193801792$var$__PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.Ec.yc = $2fa92ec193801792$var$__PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), t;
}
function $2fa92ec193801792$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    const t = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = $2fa92ec193801792$var$__PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = $2fa92ec193801792$var$__PRIVATE_syncEngineRejectFailedWrite.bind(null, t), t;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $2fa92ec193801792$var$__PRIVATE_syncEngineLoadBundle(e, t, n) {
    const r = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function __PRIVATE_loadBundleImpl(e, t, n) {
        try {
            const r = await t.getMetadata();
            if (await function __PRIVATE_localStoreHasNewerBundle(e, t) {
                const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = $2fa92ec193801792$var$__PRIVATE_fromVersion(t.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (e)=>n.d_.getBundleMetadata(e, t.id)).then((e)=>!!e && e.createTime.compareTo(r) >= 0);
            }(e.localStore, r)) return await t.close(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                return {
                    taskState: "Success",
                    documentsLoaded: e.totalDocuments,
                    bytesLoaded: e.totalBytes,
                    totalDocuments: e.totalDocuments,
                    totalBytes: e.totalBytes
                };
            }(r)), Promise.resolve(new Set);
            n._updateProgress($2fa92ec193801792$var$__PRIVATE_bundleInitialProgress(r));
            const i = new $2fa92ec193801792$export$61196ced6d74a310(r, t.serializer);
            let s = await t.ma();
            for(; s;){
                const e = await i.qu(s);
                e && n._updateProgress(e), s = await t.ma();
            }
            const _ = await i.Ku(e.localStore);
            return await $2fa92ec193801792$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, _.Qu, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function __PRIVATE_localStoreSaveBundle(e, t) {
                const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
                return n.persistence.runTransaction("Save bundle", "readwrite", (e)=>n.d_.saveBundleMetadata(e, t));
            }(e.localStore, r), n._completeWith(_.progress), Promise.resolve(_.Wu);
        } catch (e) {
            return $2fa92ec193801792$export$7f8ddf7c7c20b3cd($2fa92ec193801792$var$dr, `Loading bundle failed with ${e}`), n._failWith(e), Promise.resolve(new Set);
        }
    })(r, t, n).then((e)=>{
        r.sharedClientState.notifyBundleLoaded(e);
    });
}
class $2fa92ec193801792$export$d24c54395ce0c509 {
    constructor(){
        this.kind = "memory", this.synchronizeTabs = false;
    }
    async initialize(e) {
        this.serializer = $2fa92ec193801792$export$b4171a6734a65d42(e.databaseInfo.databaseId), this.sharedClientState = this.vc(e), this.persistence = this.Sc(e), await this.persistence.start(), this.localStore = this.Dc(e), this.gcScheduler = this.xc(e, this.localStore), this.indexBackfillerScheduler = this.Cc(e, this.localStore);
    }
    xc(e, t) {
        return null;
    }
    Cc(e, t) {
        return null;
    }
    Dc(e) {
        return $2fa92ec193801792$var$__PRIVATE_newLocalStore(this.persistence, new $2fa92ec193801792$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Sc(e) {
        return new $2fa92ec193801792$var$__PRIVATE_MemoryPersistence($2fa92ec193801792$var$__PRIVATE_MemoryEagerDelegate.w_, this.serializer);
    }
    vc(e) {
        return new $2fa92ec193801792$var$__PRIVATE_MemorySharedClientState;
    }
    async terminate() {
        this.gcScheduler?.stop(), this.indexBackfillerScheduler?.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}
$2fa92ec193801792$export$d24c54395ce0c509.provider = {
    build: ()=>new $2fa92ec193801792$export$d24c54395ce0c509
};
class $2fa92ec193801792$export$493d36ec626b6698 extends $2fa92ec193801792$export$d24c54395ce0c509 {
    constructor(e){
        super(), this.cacheSizeBytes = e;
    }
    xc(e, t) {
        $2fa92ec193801792$var$__PRIVATE_hardAssert(this.persistence.referenceDelegate instanceof $2fa92ec193801792$var$__PRIVATE_MemoryLruDelegate, 46915);
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $2fa92ec193801792$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Sc(e) {
        const t = void 0 !== this.cacheSizeBytes ? $2fa92ec193801792$var$LruParams.withCacheSize(this.cacheSizeBytes) : $2fa92ec193801792$var$LruParams.DEFAULT;
        return new $2fa92ec193801792$var$__PRIVATE_MemoryPersistence((e)=>$2fa92ec193801792$var$__PRIVATE_MemoryLruDelegate.w_(e, t), this.serializer);
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class $2fa92ec193801792$export$d66dc83d8cfc8dd extends $2fa92ec193801792$export$d24c54395ce0c509 {
    constructor(e, t, n){
        super(), this.Fc = e, this.cacheSizeBytes = t, this.forceOwnership = n, this.kind = "persistent", this.synchronizeTabs = false;
    }
    async initialize(e) {
        await super.initialize(e), await this.Fc.initialize(this, e), // Enqueue writes from a previous session
        await $2fa92ec193801792$var$__PRIVATE_syncEngineEnsureWriteCallbacks(this.Fc.syncEngine), await $2fa92ec193801792$var$__PRIVATE_fillWritePipeline(this.Fc.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.X_(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    Dc(e) {
        return $2fa92ec193801792$var$__PRIVATE_newLocalStore(this.persistence, new $2fa92ec193801792$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    xc(e, t) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $2fa92ec193801792$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Cc(e, t) {
        const n = new $2fa92ec193801792$var$__PRIVATE_IndexBackfiller(t, this.persistence);
        return new $2fa92ec193801792$var$__PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
    }
    Sc(e) {
        const t = $2fa92ec193801792$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $2fa92ec193801792$var$LruParams.withCacheSize(this.cacheSizeBytes) : $2fa92ec193801792$var$LruParams.DEFAULT;
        return new $2fa92ec193801792$var$__PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, $2fa92ec193801792$var$__PRIVATE_getWindow(), $2fa92ec193801792$var$getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
    }
    vc(e) {
        return new $2fa92ec193801792$var$__PRIVATE_MemorySharedClientState;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class $2fa92ec193801792$export$1fbe638ecf81657e extends $2fa92ec193801792$export$d66dc83d8cfc8dd {
    constructor(e, t){
        super(e, t, /* forceOwnership= */ false), this.Fc = e, this.cacheSizeBytes = t, this.synchronizeTabs = true;
    }
    async initialize(e) {
        await super.initialize(e);
        const t = this.Fc.syncEngine;
        this.sharedClientState instanceof $2fa92ec193801792$var$__PRIVATE_WebStorageSharedClientState && (this.sharedClientState.syncEngine = {
            Iu: $2fa92ec193801792$var$__PRIVATE_syncEngineApplyBatchState.bind(null, t),
            Au: $2fa92ec193801792$var$__PRIVATE_syncEngineApplyTargetState.bind(null, t),
            Vu: $2fa92ec193801792$var$__PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
            Ro: $2fa92ec193801792$var$__PRIVATE_syncEngineGetActiveClients.bind(null, t),
            Ru: $2fa92ec193801792$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.X_(async (e)=>{
            await $2fa92ec193801792$var$__PRIVATE_syncEngineApplyPrimaryState(this.Fc.syncEngine, e), this.gcScheduler && (e && !this.gcScheduler.started ? this.gcScheduler.start() : e || this.gcScheduler.stop()), this.indexBackfillerScheduler && (e && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : e || this.indexBackfillerScheduler.stop());
        });
    }
    vc(e) {
        const t = $2fa92ec193801792$var$__PRIVATE_getWindow();
        if (!$2fa92ec193801792$var$__PRIVATE_WebStorageSharedClientState.Je(t)) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = $2fa92ec193801792$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey);
        return new $2fa92ec193801792$var$__PRIVATE_WebStorageSharedClientState(t, e.asyncQueue, n, e.clientId, e.initialUser);
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class $2fa92ec193801792$export$6554612db691658e {
    async initialize(e, t) {
        this.localStore || (this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, /* startAsPrimary=*/ !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = (e)=>$2fa92ec193801792$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = $2fa92ec193801792$var$__PRIVATE_syncEngineHandleCredentialChange.bind(null, this.syncEngine), await $2fa92ec193801792$var$__PRIVATE_remoteStoreApplyPrimaryState(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(e) {
        return function __PRIVATE_newEventManager() {
            return new $2fa92ec193801792$var$__PRIVATE_EventManagerImpl;
        }();
    }
    createDatastore(e) {
        const t = $2fa92ec193801792$export$b4171a6734a65d42(e.databaseInfo.databaseId), n = $2fa92ec193801792$var$__PRIVATE_newConnection(e.databaseInfo);
        return $2fa92ec193801792$var$__PRIVATE_newDatastore(e.authCredentials, e.appCheckCredentials, n, t);
    }
    createRemoteStore(e) {
        return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
            return new $2fa92ec193801792$var$__PRIVATE_RemoteStoreImpl(e, t, n, r, i);
        }(this.localStore, this.datastore, e.asyncQueue, (e)=>$2fa92ec193801792$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */ ), function __PRIVATE_newConnectivityMonitor() {
            return $2fa92ec193801792$var$__PRIVATE_BrowserConnectivityMonitor.Je() ? new $2fa92ec193801792$var$__PRIVATE_BrowserConnectivityMonitor : new $2fa92ec193801792$var$__PRIVATE_NoopConnectivityMonitor;
        }());
    }
    createSyncEngine(e, t) {
        return function __PRIVATE_newSyncEngine(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        r, i, s, _) {
            const o = new $2fa92ec193801792$var$__PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
            return _ && (o.mc = true), o;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
    }
    async terminate() {
        await async function __PRIVATE_remoteStoreShutdown(e) {
            const t = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
            $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$hr, "RemoteStore shutting down."), t.ca.add(5 /* OfflineCause.Shutdown */ ), await $2fa92ec193801792$var$__PRIVATE_disableNetworkInternal(t), t.Ea.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            t.ha.set("Unknown" /* OnlineState.Unknown */ );
        }(this.remoteStore), this.datastore?.terminate(), this.eventManager?.terminate();
    }
}
$2fa92ec193801792$export$6554612db691658e.provider = {
    build: ()=>new $2fa92ec193801792$export$6554612db691658e
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $2fa92ec193801792$var$Transaction {
    constructor(e){
        this.datastore = e, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = false, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastTransactionError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(e) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw this.lastTransactionError = new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes."), this.lastTransactionError;
        const t = await async function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
            const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = {
                documents: t.map((e)=>$2fa92ec193801792$var$__PRIVATE_toName(n.serializer, e))
            }, i = await n.st("BatchGetDocuments", n.serializer.databaseId, $2fa92ec193801792$export$db202ddc8be9136.emptyPath(), r, t.length), s = new Map;
            i.forEach((e)=>{
                const t = $2fa92ec193801792$var$__PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                s.set(t.key.toString(), t);
            });
            const _ = [];
            return t.forEach((e)=>{
                const t = s.get(e.toString());
                $2fa92ec193801792$var$__PRIVATE_hardAssert(!!t, 55234, {
                    key: e
                }), _.push(t);
            }), _;
        }(this.datastore, e);
        return t.forEach((e)=>this.recordVersion(e)), t;
    }
    set(e, t) {
        this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    update(e, t) {
        try {
            this.write(t.toMutation(e, this.preconditionForUpdate(e)));
        } catch (e) {
            this.lastTransactionError = e;
        }
        this.writtenDocs.add(e.toString());
    }
    delete(e) {
        this.write(new $2fa92ec193801792$export$4a5767248b18ef41(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastTransactionError) throw this.lastTransactionError;
        const e = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((t)=>{
            e.delete(t.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        e.forEach((e, t)=>{
            const n = $2fa92ec193801792$export$a07804094c3ecf2d.fromPath(t);
            this.mutations.push(new $2fa92ec193801792$var$__PRIVATE_VerifyMutation(n, this.precondition(n)));
        }), await async function __PRIVATE_invokeCommitRpc(e, t) {
            const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = {
                writes: t.map((e)=>$2fa92ec193801792$var$toMutation(n.serializer, e))
            };
            await n.tt("Commit", n.serializer.databaseId, $2fa92ec193801792$export$db202ddc8be9136.emptyPath(), r);
        }(this.datastore, this.mutations), this.committed = true;
    }
    recordVersion(e) {
        let t;
        if (e.isFoundDocument()) t = e.version;
        else {
            if (!e.isNoDocument()) throw $2fa92ec193801792$export$1a82df3d29112e01(50498, {
                Oc: e.constructor.name
            });
            // Represent a deleted doc using SnapshotVersion.min().
            t = $2fa92ec193801792$var$SnapshotVersion.min();
        }
        const n = this.readVersions.get(e.key.toString());
        if (n) {
            if (!t.isEqual(n)) // This transaction will fail no matter what.
            throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(e.key.toString(), t);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(e) {
        const t = this.readVersions.get(e.toString());
        return !this.writtenDocs.has(e.toString()) && t ? t.isEqual($2fa92ec193801792$var$SnapshotVersion.min()) ? $2fa92ec193801792$export$56c0d5a1e737357d.exists(false) : $2fa92ec193801792$export$56c0d5a1e737357d.updateTime(t) : $2fa92ec193801792$export$56c0d5a1e737357d.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(e) {
        const t = this.readVersions.get(e.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(e.toString()) && t) {
            if (t.isEqual($2fa92ec193801792$var$SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $2fa92ec193801792$export$56c0d5a1e737357d.updateTime(t);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $2fa92ec193801792$export$56c0d5a1e737357d.exists(true);
    }
    write(e) {
        this.ensureCommitNotCalled(), this.mutations.push(e);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $2fa92ec193801792$var$__PRIVATE_TransactionRunner {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this.Mc = n.maxAttempts, this.jt = new $2fa92ec193801792$var$__PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ Nc() {
        this.Mc -= 1, this.Lc();
    }
    Lc() {
        this.jt.Ut(async ()=>{
            const e = new $2fa92ec193801792$var$Transaction(this.datastore), t = this.Bc(e);
            t && t.then((t)=>{
                this.asyncQueue.enqueueAndForget(()=>e.commit().then(()=>{
                        this.deferred.resolve(t);
                    }).catch((e)=>{
                        this.Uc(e);
                    }));
            }).catch((e)=>{
                this.Uc(e);
            });
        });
    }
    Bc(e) {
        try {
            const t = this.updateFunction(e);
            return !$2fa92ec193801792$var$__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (e) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(e), null;
        }
    }
    Uc(e) {
        this.Mc > 0 && this.kc(e) ? (this.Mc -= 1, this.asyncQueue.enqueueAndForget(()=>(this.Lc(), Promise.resolve()))) : this.deferred.reject(e);
    }
    kc(e) {
        if ("FirebaseError" === e?.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const t = e.code;
            return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !$2fa92ec193801792$var$__PRIVATE_isPermanentError(t);
        }
        return false;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$fr = "FirestoreClient";
/**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ class $2fa92ec193801792$var$FirestoreClient {
    constructor(e, t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, /**
     * Exposed for testing
     */ r, i){
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this._databaseInfo = r, this.user = $2fa92ec193801792$var$User.UNAUTHENTICATED, this.clientId = $2fa92ec193801792$export$ae1af26003f05816.newId(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this._uninitializedComponentsProvider = i, this.authCredentials.start(n, async (e)=>{
            $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$fr, "Received user=", e.uid), await this.authCredentialListener(e), this.user = e;
        }), this.appCheckCredentials.start(n, (e)=>($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$fr, "Received new app check token=", e), this.appCheckCredentialListener(e, this.user)));
    }
    get configuration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this._databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(e) {
        this.authCredentialListener = e;
    }
    setAppCheckTokenChangeListener(e) {
        this.appCheckCredentialListener = e;
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const e = new $2fa92ec193801792$var$__PRIVATE_Deferred;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
            } catch (t) {
                const n = $2fa92ec193801792$var$__PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                e.reject(n);
            }
        }), e.promise;
    }
}
async function $2fa92ec193801792$var$__PRIVATE_setOfflineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress(), $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$fr, "Initializing OfflineComponentProvider");
    const n = e.configuration;
    await t.initialize(n);
    let r = n.initialUser;
    e.setCredentialChangeListener(async (e)=>{
        r.isEqual(e) || (await $2fa92ec193801792$var$__PRIVATE_localStoreHandleUserChange(t.localStore, e), r = e);
    }), // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    t.persistence.setDatabaseDeletedListener(()=>e.terminate()), e._offlineComponents = t;
}
async function $2fa92ec193801792$var$__PRIVATE_setOnlineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress();
    const n = await $2fa92ec193801792$var$__PRIVATE_ensureOfflineComponents(e);
    $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$fr, "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    e.setCredentialChangeListener((e)=>$2fa92ec193801792$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e)), e.setAppCheckTokenChangeListener((e, n)=>$2fa92ec193801792$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n)), e._onlineComponents = t;
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ async function $2fa92ec193801792$var$__PRIVATE_ensureOfflineComponents(e) {
    if (!e._offlineComponents) {
        if (e._uninitializedComponentsProvider) {
            $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$fr, "Using user provided OfflineComponentProvider");
            try {
                await $2fa92ec193801792$var$__PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline);
            } catch (t) {
                const n = t;
                if (!function __PRIVATE_canFallbackFromIndexedDbError(e) {
                    return "FirebaseError" === e.name ? e.code === $2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION || e.code === $2fa92ec193801792$export$db3b6bfb95261072.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
                    // or an aborted error depending on whether the error happened during
                    // schema migration.
                    22 === e.code || 20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
                    // INVALID_STATE for any usage.
                    11 === e.code;
                }(n)) throw n;
                $2fa92ec193801792$export$7f8ddf7c7c20b3cd("Error using user provided cache. Falling back to memory cache: " + n), await $2fa92ec193801792$var$__PRIVATE_setOfflineComponentProvider(e, new $2fa92ec193801792$export$d24c54395ce0c509);
            }
        } else $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$fr, "Using default OfflineComponentProvider"), await $2fa92ec193801792$var$__PRIVATE_setOfflineComponentProvider(e, new $2fa92ec193801792$export$493d36ec626b6698(void 0));
    }
    return e._offlineComponents;
}
async function $2fa92ec193801792$var$__PRIVATE_ensureOnlineComponents(e) {
    return e._onlineComponents || (e._uninitializedComponentsProvider ? ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$fr, "Using user provided OnlineComponentProvider"), await $2fa92ec193801792$var$__PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)) : ($2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$fr, "Using default OnlineComponentProvider"), await $2fa92ec193801792$var$__PRIVATE_setOnlineComponentProvider(e, new $2fa92ec193801792$export$6554612db691658e))), e._onlineComponents;
}
function $2fa92ec193801792$var$__PRIVATE_getPersistence(e) {
    return $2fa92ec193801792$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.persistence);
}
function $2fa92ec193801792$var$__PRIVATE_getLocalStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.localStore);
}
function $2fa92ec193801792$var$__PRIVATE_getRemoteStore(e) {
    return $2fa92ec193801792$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.remoteStore);
}
function $2fa92ec193801792$var$__PRIVATE_getSyncEngine(e) {
    return $2fa92ec193801792$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.syncEngine);
}
function $2fa92ec193801792$var$__PRIVATE_getDatastore(e) {
    return $2fa92ec193801792$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.datastore);
}
async function $2fa92ec193801792$var$__PRIVATE_getEventManager(e) {
    const t = await $2fa92ec193801792$var$__PRIVATE_ensureOnlineComponents(e), n = t.eventManager;
    return n.onListen = $2fa92ec193801792$var$__PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = $2fa92ec193801792$var$__PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = $2fa92ec193801792$var$__PRIVATE_triggerRemoteStoreListen.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = $2fa92ec193801792$var$__PRIVATE_triggerRemoteStoreUnlisten.bind(null, t.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function $2fa92ec193801792$var$__PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $2fa92ec193801792$var$__PRIVATE_getPersistence(e), n = await $2fa92ec193801792$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(true), function __PRIVATE_remoteStoreEnableNetwork(e) {
            const t = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
            return t.ca.delete(0 /* OfflineCause.UserDisabled */ ), $2fa92ec193801792$var$__PRIVATE_enableNetworkInternal(t);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function $2fa92ec193801792$var$__PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $2fa92ec193801792$var$__PRIVATE_getPersistence(e), n = await $2fa92ec193801792$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(false), async function __PRIVATE_remoteStoreDisableNetwork(e) {
            const t = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
            t.ca.add(0 /* OfflineCause.UserDisabled */ ), await $2fa92ec193801792$var$__PRIVATE_disableNetworkInternal(t), // Set the OnlineState to Offline so get()s return from cache, etc.
            t.ha.set("Offline" /* OnlineState.Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $2fa92ec193801792$export$ce26c07117d59d6a(e, t, n, r) {
    const i = new $2fa92ec193801792$var$__PRIVATE_AsyncObserver(r), s = new $2fa92ec193801792$var$__PRIVATE_QueryListener(t, i, n);
    return e.asyncQueue.enqueueAndForget(async ()=>$2fa92ec193801792$var$__PRIVATE_eventManagerListen(await $2fa92ec193801792$var$__PRIVATE_getEventManager(e), s)), ()=>{
        i.Aa(), e.asyncQueue.enqueueAndForget(async ()=>$2fa92ec193801792$var$__PRIVATE_eventManagerUnlisten(await $2fa92ec193801792$var$__PRIVATE_getEventManager(e), s));
    };
}
function $2fa92ec193801792$export$8743009a87fcb00f(e, t) {
    const n = new $2fa92ec193801792$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_readDocumentFromCache(e, t, n) {
            try {
                const r = await function __PRIVATE_localStoreReadDocument(e, t) {
                    const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
                    return n.persistence.runTransaction("read document", "readonly", (e)=>n.localDocuments.getDocument(e, t));
                }(e, t);
                r.isFoundDocument() ? n.resolve(r) : r.isNoDocument() ? n.resolve(null) : n.reject(new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (e) {
                const r = $2fa92ec193801792$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to get document '${t} from cache`);
                n.reject(r);
            }
        })(await $2fa92ec193801792$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $2fa92ec193801792$export$71cec2538cb2c617(e, t, n = {}) {
    const r = new $2fa92ec193801792$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_readDocumentViaSnapshotListener(e, t, n, r, i) {
            const _ = new $2fa92ec193801792$var$__PRIVATE_AsyncObserver({
                next: (a)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    _.Aa(), t.enqueueAndForget(()=>$2fa92ec193801792$var$__PRIVATE_eventManagerUnlisten(e, o));
                    const u = a.docs.has(n);
                    !u && a.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.UNAVAILABLE, "Failed to get document because the client is offline.")) : u && a.fromCache && r && "server" === r.source ? i.reject(new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(a);
                },
                error: (e)=>i.reject(e)
            }), o = new $2fa92ec193801792$var$__PRIVATE_QueryListener($2fa92ec193801792$export$3c2fa207a37baaea(n.path), _, {
                includeMetadataChanges: true,
                waitForSyncWhenOnline: true
            });
            return $2fa92ec193801792$var$__PRIVATE_eventManagerListen(e, o);
        })(await $2fa92ec193801792$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $2fa92ec193801792$export$3d8c2f653ac9d0b9(e, t) {
    const n = new $2fa92ec193801792$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_executeQueryFromCache(e, t, n) {
            try {
                const r = await $2fa92ec193801792$var$__PRIVATE_localStoreExecuteQuery(e, t, /* usePreviousResults= */ !0), i = new $2fa92ec193801792$var$__PRIVATE_View(t, r.Wo), s = i.Zu(r.documents), _ = i.applyChanges(s, /* limboResolutionEnabled= */ !1);
                n.resolve(_.snapshot);
            } catch (e) {
                const r = $2fa92ec193801792$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to execute query '${t} against cache`);
                n.reject(r);
            }
        })(await $2fa92ec193801792$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $2fa92ec193801792$export$dc98b0b04f4c7758(e, t, n = {}) {
    const r = new $2fa92ec193801792$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_executeQueryViaSnapshotListener(e, t, n, r, i) {
            const _ = new $2fa92ec193801792$var$__PRIVATE_AsyncObserver({
                next: (n)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    _.Aa(), t.enqueueAndForget(()=>$2fa92ec193801792$var$__PRIVATE_eventManagerUnlisten(e, o)), n.fromCache && "server" === r.source ? i.reject(new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (e)=>i.reject(e)
            }), o = new $2fa92ec193801792$var$__PRIVATE_QueryListener(n instanceof $2fa92ec193801792$var$__PRIVATE_RealtimePipeline ? $2fa92ec193801792$var$__PRIVATE_toCorePipeline(n) : n, _, {
                includeMetadataChanges: true,
                waitForSyncWhenOnline: true
            });
            return $2fa92ec193801792$var$__PRIVATE_eventManagerListen(e, o);
        })(await $2fa92ec193801792$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $2fa92ec193801792$export$e7c866399fa523f5(e, t, n) {
    const r = new $2fa92ec193801792$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        // Implement and call executeAggregateQueryViaSnapshotListener, similar
        // to the implementation in firestoreClientGetDocumentsViaSnapshotListener
        // above
        try {
            // TODO(b/277628384): check `canUseNetwork()` and handle multi-tab.
            const i = await $2fa92ec193801792$var$__PRIVATE_getDatastore(e);
            r.resolve(async function __PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
                const r = $2fa92ec193801792$var$__PRIVATE_debugCast(e), { request: i, ve: s, parent: _ } = $2fa92ec193801792$var$__PRIVATE_toRunAggregationQueryRequest(r.serializer, $2fa92ec193801792$var$__PRIVATE_queryToAggregateTarget(t), n);
                r.connection.Ye || delete i.parent;
                const o = (await r.st("RunAggregationQuery", r.serializer.databaseId, _, i, /*expectedResponseCount=*/ 1)).filter((e)=>!!e.result);
                // Omit RunAggregationQueryResponse that only contain readTimes.
                $2fa92ec193801792$var$__PRIVATE_hardAssert(1 === o.length, 64727);
                // Remap the short-form aliases that were sent to the server
                // to the client-side aliases. Users will access the results
                // using the client-side alias.
                const a = o[0].result?.aggregateFields;
                return Object.keys(a).reduce((e, t)=>(e[s[t]] = a[t], e), {});
            }(i, t, n));
        } catch (e) {
            r.reject(e);
        }
    }), r.promise;
}
function $2fa92ec193801792$export$6d1e945284085e64(e, t) {
    const n = new $2fa92ec193801792$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        try {
            const r = await $2fa92ec193801792$var$__PRIVATE_getDatastore(e);
            n.resolve(async function __PRIVATE_invokeExecutePipeline(e, t) {
                const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = {
                    database: $2fa92ec193801792$var$__PRIVATE_getEncodedDatabaseId(n.serializer),
                    structuredPipeline: t._toProto(n.serializer)
                }, i = await n.st("ExecutePipeline", n.serializer.databaseId, $2fa92ec193801792$export$db202ddc8be9136.emptyPath(), r), s = [];
                return i.forEach((e)=>{
                    if (e.results && 0 !== e.results.length) return e.results.forEach((t)=>s.push($2fa92ec193801792$var$__PRIVATE_fromPipelineResponse(n.serializer, e, t)));
                    s.push($2fa92ec193801792$var$__PRIVATE_fromPipelineResponse(n.serializer, e));
                }), s;
            }(r, t));
        } catch (e) {
            n.reject(e);
        }
    }), n.promise;
}
function $2fa92ec193801792$export$25ce5a424b770e84(e, t) {
    const n = new $2fa92ec193801792$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>$2fa92ec193801792$var$__PRIVATE_syncEngineWrite(await $2fa92ec193801792$var$__PRIVATE_getSyncEngine(e), t, n)), n.promise;
}
function $2fa92ec193801792$export$a8550f7dbe79f93a(e, t) {
    const n = new $2fa92ec193801792$var$__PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_addSnapshotsInSyncListener(e, t) {
            $2fa92ec193801792$var$__PRIVATE_debugCast(e).Su.add(t), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            t.next();
        })(await $2fa92ec193801792$var$__PRIVATE_getEventManager(e), n)), ()=>{
        n.Aa(), e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
                $2fa92ec193801792$var$__PRIVATE_debugCast(e).Su.delete(t);
            })(await $2fa92ec193801792$var$__PRIVATE_getEventManager(e), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $2fa92ec193801792$export$7910e0436ed8d1de(e, t, n) {
    const r = new $2fa92ec193801792$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        const i = await $2fa92ec193801792$var$__PRIVATE_getDatastore(e);
        new $2fa92ec193801792$var$__PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).Nc();
    }), r.promise;
}
function $2fa92ec193801792$var$__PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    const i = function __PRIVATE_createBundleReader(e, t) {
        let n;
        n = "string" == typeof e ? $2fa92ec193801792$var$__PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new $2fa92ec193801792$var$__PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return $2fa92ec193801792$var$__PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return $2fa92ec193801792$var$__PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), t);
    }(n, $2fa92ec193801792$export$b4171a6734a65d42(t));
    e.asyncQueue.enqueueAndForget(async ()=>{
        $2fa92ec193801792$var$__PRIVATE_syncEngineLoadBundle(await $2fa92ec193801792$var$__PRIVATE_getSyncEngine(e), i, r);
    });
}
function $2fa92ec193801792$var$__PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreGetNamedQuery(e, t) {
            const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Get named query", "readonly", (e)=>n.d_.getNamedQuery(e, t));
        })(await $2fa92ec193801792$var$__PRIVATE_getLocalStore(e), t));
}
function $2fa92ec193801792$export$3466f893ebf79586(e, t) {
    return function __PRIVATE_newBundleReaderSync(e, t) {
        return new $2fa92ec193801792$var$__PRIVATE_BundleReaderSyncImpl(e, t);
    }(e, t);
}
function $2fa92ec193801792$export$c9170ad7d4cd7e57(e, t) {
    return e.asyncQueue.enqueue(async ()=>(async function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
            const n = $2fa92ec193801792$var$__PRIVATE_debugCast(e), r = n.indexManager, i = [];
            return n.persistence.runTransaction("Configure indexes", "readwrite", (e)=>r.getFieldIndexes(e).next((n)=>(function __PRIVATE_diffArrays(e, t, n, r, i) {
                        e = [
                            ...e
                        ], t = [
                            ...t
                        ], e.sort(n), t.sort(n);
                        const s = e.length, _ = t.length;
                        let o = 0, a = 0;
                        for(; o < _ && a < s;){
                            const s = n(e[a], t[o]);
                            s < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            i(e[a++]) : s > 0 ? // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            r(t[o++]) : (o++, a++);
                        }
                        for(; o < _;)r(t[o++]);
                        for(; a < s;)i(e[a++]);
                    })(n, t, $2fa92ec193801792$var$__PRIVATE_fieldIndexSemanticComparator, (t)=>{
                        i.push(r.addFieldIndex(e, t));
                    }, (t)=>{
                        i.push(r.deleteFieldIndex(e, t));
                    })).next(()=>$2fa92ec193801792$var$PersistencePromise.waitFor(i)));
        })(await $2fa92ec193801792$var$__PRIVATE_getLocalStore(e), t));
}
function $2fa92ec193801792$export$7a38258bbe170828(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreSetIndexAutoCreationEnabled(e, t) {
            $2fa92ec193801792$var$__PRIVATE_debugCast(e).Mo.po = t;
        })(await $2fa92ec193801792$var$__PRIVATE_getLocalStore(e), t));
}
function $2fa92ec193801792$export$a9c23c6ac3fc3eca(e) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreDeleteAllFieldIndexes(e) {
            const t = $2fa92ec193801792$var$__PRIVATE_debugCast(e), n = t.indexManager;
            return t.persistence.runTransaction("Delete All Indexes", "readwrite", (e)=>n.deleteAllFieldIndexes(e));
        })(await $2fa92ec193801792$var$__PRIVATE_getLocalStore(e)));
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$export$6b179bb11f7fd3a0 {
    constructor(e = {}, t = {}){
        this.qc = e, this.$c = t, this.Kc = new $2fa92ec193801792$var$OptionsUtil({
            indexMode: {
                serverName: "index_mode"
            }
        });
    }
    _readUserData(e) {
        this.proto = this.Kc.getOptionsProto(e, this.qc, this.$c);
    }
}
class $2fa92ec193801792$export$c69d65aa55814164 {
    constructor(e, t){
        this.pipeline = e, this.options = t;
    }
    _toProto(e) {
        return {
            pipeline: this.pipeline._toProto(e),
            options: this.options.proto
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2fa92ec193801792$var$mr = "AsyncQueue";
class $2fa92ec193801792$var$__PRIVATE_AsyncQueueImpl {
    constructor(e = Promise.resolve()){
        // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.Wc = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.Qc = false, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.Gc = [], // visible for testing
        this.zc = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.jc = false, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.Hc = false, // List of TimerIds to fast-forward delays for.
        this.Jc = [], // Backoff timer used to schedule retries for retryable operations
        this.jt = new $2fa92ec193801792$var$__PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.Yc = ()=>{
            const e = $2fa92ec193801792$var$getDocument();
            e && $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$mr, "Visibility state changed to " + e.visibilityState), this.jt.qt();
        }, this.Zc = e;
        const t = $2fa92ec193801792$var$getDocument();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.Yc);
    }
    get isShuttingDown() {
        return this.Qc;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(e);
    }
    enqueueAndForgetEvenWhileRestricted(e) {
        this.Xc(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.el(e);
    }
    enterRestrictedMode(e) {
        if (!this.Qc) {
            this.Qc = true, this.Hc = e || false;
            const t = $2fa92ec193801792$var$getDocument();
            t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this.Yc);
        }
    }
    enqueue(e) {
        if (this.Xc(), this.Qc) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const t = new $2fa92ec193801792$var$__PRIVATE_Deferred;
        return this.el(()=>this.Qc && this.Hc ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise)).then(()=>t.promise);
    }
    enqueueRetryable(e) {
        this.enqueueAndForget(()=>(this.Wc.push(e), this.tl()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async tl() {
        if (0 !== this.Wc.length) {
            try {
                await this.Wc[0](), this.Wc.shift(), this.jt.reset();
            } catch (e) {
                if (!$2fa92ec193801792$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
                // Failure will be handled by AsyncQueue
                $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$mr, "Operation failed with retryable error: " + e);
            }
            this.Wc.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.jt.Ut(()=>this.tl());
        }
    }
    el(e) {
        const t = this.Zc.then(()=>(this.jc = true, e().catch((e)=>{
                this.zc = e, this.jc = false;
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $2fa92ec193801792$var$__PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", $2fa92ec193801792$var$__PRIVATE_getMessageOrStack(e)), e;
            }).then((e)=>(this.jc = false, e))));
        return this.Zc = t, t;
    }
    enqueueAfterDelay(e, t, n) {
        this.Xc(), // Fast-forward delays for timerIds that have been overridden.
        this.Jc.indexOf(e) > -1 && (t = 0);
        const r = $2fa92ec193801792$var$DelayedOperation.createAndSchedule(this, e, t, n, (e)=>this.nl(e));
        return this.Gc.push(r), r;
    }
    Xc() {
        this.zc && $2fa92ec193801792$export$1a82df3d29112e01(47125, {
            rl: $2fa92ec193801792$var$__PRIVATE_getMessageOrStack(this.zc)
        });
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async il() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let e;
        do e = this.Zc, await e;
        while (e !== this.Zc);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ sl(e) {
        for (const t of this.Gc)if (t.timerId === e) return true;
        return false;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ _l(e) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.il().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.Gc.sort((e, t)=>e.targetTimeMs - t.targetTimeMs);
            for (const t of this.Gc)if (t.skipDelay(), "all" /* TimerId.All */  !== e && t.timerId === e) break;
            return this.il();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ ol(e) {
        this.Jc.push(e);
    }
    /** Called once a DelayedOperation is run or canceled. */ nl(e) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const t = this.Gc.indexOf(e);
        /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.Gc.splice(t, 1);
    }
}
/**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function $2fa92ec193801792$var$__PRIVATE_getMessageOrStack(e) {
    let t = e.message || "";
    return e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the task of loading a Firestore bundle. It provides progress of bundle
 * loading, as well as task completion and error events.
 *
 * The API is compatible with `Promise<LoadBundleTaskProgress>`.
 */ class $2fa92ec193801792$export$9d398bebfec1c039 {
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new $2fa92ec193801792$var$__PRIVATE_Deferred, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(e, t, n) {
        this._progressObserver = {
            next: e,
            error: t,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(e) {
        return this._taskCompletionResolver.promise.catch(e);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(e, t) {
        return this._taskCompletionResolver.promise.then(e, t);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(e) {
        this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(e);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(e) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(e) {
        this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ const $2fa92ec193801792$export$9fa96a7d116ea3ce = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ class $2fa92ec193801792$export$4368d992c4eafac0 extends $2fa92ec193801792$var$Dt {
    /** @hideconstructor */ constructor(e, t, n, r){
        super(e, t, n, r), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = new $2fa92ec193801792$var$__PRIVATE_AsyncQueueImpl, this._persistenceKey = r?.name || "[DEFAULT]";
    }
    async _terminate() {
        if (this._firestoreClient) {
            const e = this._firestoreClient.terminate();
            this._queue = new $2fa92ec193801792$var$__PRIVATE_AsyncQueueImpl(e), this._firestoreClient = void 0, await e;
        }
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $2fa92ec193801792$export$8c78c7c36408ea29(e, t, n) {
    n || (n = $2fa92ec193801792$var$$e);
    const r = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)(e, "firestore");
    if (r.isInitialized(n)) {
        const e = r.getImmediate({
            identifier: n
        }), i = r.getOptions(n);
        if ((0, $029952e65115eee5$export$9cb4719e2e525b7a)(i, t)) return e;
        throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== t.cacheSizeBytes && -1 !== t.cacheSizeBytes && t.cacheSizeBytes < $2fa92ec193801792$var$bt) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    // Workaround to get cookies in Firebase Studio
    return t.host && (0, $029952e65115eee5$export$5b4d24b45140ad90)(t.host) && (0, $029952e65115eee5$export$c0f0d0ce4283a937)(t.host), r.initialize({
        options: t,
        instanceIdentifier: n
    });
}
function $2fa92ec193801792$export$a17c37559e1db147(e, t) {
    const n = "object" == typeof e ? e : (0, $5e587d655f0a08bb$export$f9962582c9e66d99)(), r = "string" == typeof e ? e : t || $2fa92ec193801792$var$$e, i = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)(n, "firestore").getImmediate({
        identifier: r
    });
    if (!i._initialized) {
        const e = (0, $029952e65115eee5$export$a3febcf1f14a3a0c)("firestore");
        e && $2fa92ec193801792$export$667d3bf0c5f83305(i, ...e);
    }
    return i;
}
/**
 * @internal
 */ function $2fa92ec193801792$export$96f57966bedc81b4(e) {
    if (e._terminated) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION, "The client has already been terminated.");
    return e._firestoreClient || $2fa92ec193801792$var$__PRIVATE_configureFirestore(e), e._firestoreClient;
}
function $2fa92ec193801792$var$__PRIVATE_configureFirestore(e) {
    const t = e._freezeSettings(), n = $2fa92ec193801792$var$__PRIVATE_makeDatabaseInfo(e._databaseId, e._app?.options.appId || "", e._persistenceKey, e._app?.options.apiKey, t);
    e._componentsProvider || t.localCache?._offlineComponentProvider && t.localCache?._onlineComponentProvider && (e._componentsProvider = {
        _offline: t.localCache._offlineComponentProvider,
        _online: t.localCache._onlineComponentProvider
    }), e._firestoreClient = new $2fa92ec193801792$var$FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, n, e._componentsProvider && function __PRIVATE_buildComponentProvider(e) {
        const t = e?._online.build();
        return {
            _offline: e?._offline.build(t),
            _online: t
        };
    }(e._componentsProvider));
}
function $2fa92ec193801792$export$1a8f5705751d8277(e, t) {
    $2fa92ec193801792$export$7f8ddf7c7c20b3cd("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const n = e._freezeSettings();
    return $2fa92ec193801792$var$__PRIVATE_setPersistenceProviders(e, $2fa92ec193801792$export$6554612db691658e.provider, {
        build: (e)=>new $2fa92ec193801792$export$d66dc83d8cfc8dd(e, n.cacheSizeBytes, t?.forceOwnership)
    }), Promise.resolve();
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * On failure, `enableMultiTabIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ async function $2fa92ec193801792$export$e171bab687b50e0(e) {
    $2fa92ec193801792$export$7f8ddf7c7c20b3cd("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const t = e._freezeSettings();
    $2fa92ec193801792$var$__PRIVATE_setPersistenceProviders(e, $2fa92ec193801792$export$6554612db691658e.provider, {
        build: (e)=>new $2fa92ec193801792$export$1fbe638ecf81657e(e, t.cacheSizeBytes)
    });
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $2fa92ec193801792$var$__PRIVATE_setPersistenceProviders(e, t, n) {
    if ((e = $2fa92ec193801792$export$df995fae86a55f06(e, $2fa92ec193801792$export$4368d992c4eafac0))._firestoreClient || e._terminated) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
    if (e._componentsProvider || e._getSettings().localCache) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION, "SDK cache is already specified.");
    e._componentsProvider = {
        _online: t,
        _offline: n
    }, $2fa92ec193801792$var$__PRIVATE_configureFirestore(e);
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function $2fa92ec193801792$export$f96d196f7728bb5(e) {
    if (e._initialized && !e._terminated) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const t = new $2fa92ec193801792$var$__PRIVATE_Deferred;
    return e._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function __PRIVATE_indexedDbClearPersistence(e) {
                if (!$2fa92ec193801792$var$__PRIVATE_SimpleDb.Je()) return Promise.resolve();
                const t = e + $2fa92ec193801792$var$cr;
                await $2fa92ec193801792$var$__PRIVATE_SimpleDb.delete(t);
            }($2fa92ec193801792$var$__PRIVATE_indexedDbStoragePrefix(e._databaseId, e._persistenceKey)), t.resolve();
        } catch (e) {
            t.reject(e);
        }
    }), t.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $2fa92ec193801792$export$ad4aebacdcaf47f8(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        const t = new $2fa92ec193801792$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$2fa92ec193801792$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(await $2fa92ec193801792$var$__PRIVATE_getSyncEngine(e), t)), t.promise;
    }($2fa92ec193801792$export$96f57966bedc81b4(e = $2fa92ec193801792$export$df995fae86a55f06(e, $2fa92ec193801792$export$4368d992c4eafac0)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $2fa92ec193801792$export$527e9aa3390079e9(e) {
    return $2fa92ec193801792$var$__PRIVATE_firestoreClientEnableNetwork($2fa92ec193801792$export$96f57966bedc81b4(e = $2fa92ec193801792$export$df995fae86a55f06(e, $2fa92ec193801792$export$4368d992c4eafac0)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $2fa92ec193801792$export$1ee57be6f6687d2c(e) {
    return $2fa92ec193801792$var$__PRIVATE_firestoreClientDisableNetwork($2fa92ec193801792$export$96f57966bedc81b4(e = $2fa92ec193801792$export$df995fae86a55f06(e, $2fa92ec193801792$export$4368d992c4eafac0)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $2fa92ec193801792$export$c18d01048907ea92(e) {
    return (0, $5e587d655f0a08bb$export$48d18de2ff1c45a5)(e.app, "firestore", e._databaseId.database), e._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $2fa92ec193801792$export$6559d589eb85fbb6(e, t) {
    const n = $2fa92ec193801792$export$96f57966bedc81b4(e = $2fa92ec193801792$export$df995fae86a55f06(e, $2fa92ec193801792$export$4368d992c4eafac0)), r = new $2fa92ec193801792$export$9d398bebfec1c039;
    return $2fa92ec193801792$var$__PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $2fa92ec193801792$export$efca4cbe5dd06740(e, t) {
    return $2fa92ec193801792$var$__PRIVATE_firestoreClientGetNamedQuery($2fa92ec193801792$export$96f57966bedc81b4(e = $2fa92ec193801792$export$df995fae86a55f06(e, $2fa92ec193801792$export$4368d992c4eafac0)), t).then((t)=>t ? new $2fa92ec193801792$export$3722cfe417b6ed86(e, null, t.query) : null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts Firestore's internal types to the JavaScript types that we expose
 * to the user.
 *
 * @internal
 */ class $2fa92ec193801792$export$2f6ca3d3b1f80bf5 {
    convertValue(e, t = "none") {
        switch($2fa92ec193801792$var$__PRIVATE_typeOrder(e)){
            case 0 /* TypeOrder.NullValue */ :
                return null;
            case 1 /* TypeOrder.BooleanValue */ :
                return e.booleanValue;
            case 2 /* TypeOrder.NumberValue */ :
                return $2fa92ec193801792$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
            case 3 /* TypeOrder.TimestampValue */ :
                return this.convertTimestamp(e.timestampValue);
            case 4 /* TypeOrder.ServerTimestampValue */ :
                return this.convertServerTimestamp(e, t);
            case 5 /* TypeOrder.StringValue */ :
                return e.stringValue;
            case 6 /* TypeOrder.BlobValue */ :
                return this.convertBytes($2fa92ec193801792$var$__PRIVATE_normalizeByteString(e.bytesValue));
            case 7 /* TypeOrder.RefValue */ :
                return this.convertReference(e.referenceValue);
            case 8 /* TypeOrder.GeoPointValue */ :
                return this.convertGeoPoint(e.geoPointValue);
            case 9 /* TypeOrder.ArrayValue */ :
                return this.convertArray(e.arrayValue, t);
            case 11 /* TypeOrder.ObjectValue */ :
                return this.convertObject(e.mapValue, t);
            case 10 /* TypeOrder.VectorValue */ :
                return this.convertVectorValue(e.mapValue);
            default:
                throw $2fa92ec193801792$export$1a82df3d29112e01(62114, {
                    value: e
                });
        }
    }
    convertObject(e, t) {
        return this.convertObjectMap(e.fields, t);
    }
    /**
     * @internal
     */ convertObjectMap(e, t = "none") {
        const n = {};
        return $2fa92ec193801792$var$forEach(e, (e, r)=>{
            n[e] = this.convertValue(r, t);
        }), n;
    }
    /**
     * @internal
     */ convertVectorValue(e) {
        const t = e.fields?.[$2fa92ec193801792$var$je].arrayValue?.values?.map((e)=>$2fa92ec193801792$var$__PRIVATE_normalizeNumber(e.doubleValue));
        return new $2fa92ec193801792$export$24baa2b76016ce0e(t);
    }
    convertGeoPoint(e) {
        return new $2fa92ec193801792$export$91c6e00c14e7e6fd($2fa92ec193801792$var$__PRIVATE_normalizeNumber(e.latitude), $2fa92ec193801792$var$__PRIVATE_normalizeNumber(e.longitude));
    }
    convertArray(e, t) {
        return (e.values || []).map((e)=>this.convertValue(e, t));
    }
    convertServerTimestamp(e, t) {
        switch(t){
            case "previous":
                const n = $2fa92ec193801792$var$__PRIVATE_getPreviousValue(e);
                return null == n ? null : this.convertValue(n, t);
            case "estimate":
                return this.convertTimestamp($2fa92ec193801792$var$__PRIVATE_getLocalWriteTime(e));
            default:
                return null;
        }
    }
    convertTimestamp(e) {
        const t = $2fa92ec193801792$var$__PRIVATE_normalizeTimestamp(e);
        return new $2fa92ec193801792$export$890c4ad488842ce7(t.seconds, t.nanos);
    }
    convertDocumentKey(e, t) {
        const n = $2fa92ec193801792$export$db202ddc8be9136.fromString(e);
        $2fa92ec193801792$var$__PRIVATE_hardAssert($2fa92ec193801792$var$__PRIVATE_isValidResourceName(n), 9688, {
            name: e
        });
        const r = new $2fa92ec193801792$export$cf2f7c5792f80b46(n.get(1), n.get(3)), i = new $2fa92ec193801792$export$a07804094c3ecf2d(n.popFirst(5));
        return r.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
        $2fa92ec193801792$var$__PRIVATE_logError(`Document ${i} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2fa92ec193801792$export$3b14a55fb2447963 extends $2fa92ec193801792$export$2f6ca3d3b1f80bf5 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $2fa92ec193801792$export$8a5498727ef6be21(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $2fa92ec193801792$export$78acf4525d8a74c4(this.firestore, /* converter= */ null, t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `QueryTarget` representation of the given query. Returns `null`
 * if the Firestore client associated with the given query has not been
 * initialized or has been terminated.
 *
 * @param query - The Query to convert to proto representation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2fa92ec193801792$export$91477dc880baac21(e) {
    const t = $2fa92ec193801792$export$96f57966bedc81b4($2fa92ec193801792$export$df995fae86a55f06(e.firestore, $2fa92ec193801792$export$4368d992c4eafac0)), n = t._onlineComponents?.datastore.serializer;
    return void 0 === n ? null : $2fa92ec193801792$var$__PRIVATE_toQueryTarget(n, $2fa92ec193801792$var$__PRIVATE_queryToTarget(e._query)).be;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns `RunAggregationQueryRequest` which contains the proto representation
 * of the given aggregation query request. Returns null if the Firestore client
 * associated with the given query has not been initialized or has been
 * terminated.
 *
 * @param query - The Query to convert to proto representation.
 * @param aggregateSpec - The set of aggregations and their aliases.
 */ function $2fa92ec193801792$export$23ebac1979863676(e, t) {
    const n = $2fa92ec193801792$export$971d5caa766a69d7(t, (e, t)=>new $2fa92ec193801792$export$3a6d5c9ae78a2c08(t, e.aggregateType, e._internalFieldPath)), r = $2fa92ec193801792$export$96f57966bedc81b4($2fa92ec193801792$export$df995fae86a55f06(e.firestore, $2fa92ec193801792$export$4368d992c4eafac0)), i = r._onlineComponents?.datastore.serializer;
    return void 0 === i ? null : $2fa92ec193801792$var$__PRIVATE_toRunAggregationQueryRequest(i, $2fa92ec193801792$var$__PRIVATE_queryToAggregateTarget(e._query), n, /* skipAliasing= */ true).request;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `ExecutePipelineRequest` representation of the given query.
 * Returns `null` if the Firestore client associated with the given query has
 * not been initialized or has been terminated.
 *
 * @param pipeline - The Pipeline to convert to proto representation.
 */ function $2fa92ec193801792$export$60e660859c376841(e) {
    if (!e._db) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION, "This pipeline was created without a database and cannot be serialized for execution.");
    const t = $2fa92ec193801792$export$df995fae86a55f06(e._db, $2fa92ec193801792$export$4368d992c4eafac0), n = $2fa92ec193801792$export$882b5998b3b9117c(t).createContext(3 /* UserDataSource.Argument */ , "_internalPipelineToExecutePipelineRequestProto");
    e._readUserData(n);
    const r = /**
 * Returns an initialized and started Datastore for the given Firestore
 * instance. Callers must invoke removeComponents() when the Firestore
 * instance is terminated.
 */ function __PRIVATE_getDatastore$1(e) {
        if (e._terminated) throw new $2fa92ec193801792$export$2408f22a0fab9ae5($2fa92ec193801792$export$db3b6bfb95261072.FAILED_PRECONDITION, "The client has already been terminated.");
        if (!$2fa92ec193801792$var$dt.has(e)) {
            $2fa92ec193801792$export$2329c99376c9d0a4($2fa92ec193801792$var$Vt, "Initializing Datastore");
            const t = $2fa92ec193801792$var$__PRIVATE_newConnection($2fa92ec193801792$var$__PRIVATE_makeDatabaseInfo(e._databaseId, e.app.options.appId || "", e._persistenceKey, e.app.options.apiKey, e._freezeSettings())), n = $2fa92ec193801792$export$b4171a6734a65d42(e._databaseId), r = $2fa92ec193801792$var$__PRIVATE_newDatastore(e._authCredentials, e._appCheckCredentials, t, n);
            $2fa92ec193801792$var$dt.set(e, r);
        }
        return $2fa92ec193801792$var$dt.get(e);
    }(t), i = r.serializer;
    if (void 0 === i) return null;
    const _ = new $2fa92ec193801792$export$c69d65aa55814164(e, new $2fa92ec193801792$export$6b179bb11f7fd3a0);
    return {
        database: $2fa92ec193801792$var$__PRIVATE_getEncodedDatabaseId(i),
        structuredPipeline: _._toProto(i)
    };
}







/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(t) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function __PRIVATE_implementsAnyMethods(t, e) {
        if ("object" != typeof t || null === t) return false;
        const n = t;
        for (const t of e)if (t in n && "function" == typeof n[t]) return true;
        return false;
    }(t, [
        "next",
        "error",
        "complete"
    ]);
}
const $a33cbddcd7bfa0a9$var$Wt = "@firebase/firestore", $a33cbddcd7bfa0a9$var$$t = "4.17.0";
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
class $a33cbddcd7bfa0a9$export$fada2345be8928cf {
    /**
     * Create a new AggregateField<T>
     * @param aggregateType - Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath - Optionally specifies the field that is aggregated.
     * @internal
     */ constructor(t = "count", e){
        this._internalFieldPath = e, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField", this.aggregateType = t;
    }
}
/**
 * The results of executing an aggregation query.
 */ class $a33cbddcd7bfa0a9$export$40257fef64be808b {
    /** @hideconstructor */ constructor(t, e, n){
        this._userDataWriter = e, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = t;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
    /**
     * @internal
     * @private
     *
     * Retrieves all fields in the snapshot as a proto value.
     *
     * @returns An `Object` containing all fields in the snapshot.
     */ _fieldsProto() {
        // Return the cloned value to prevent manipulation of the Snapshot's data
        return new (0, $2fa92ec193801792$export$c4ce752e73470fba)({
            mapValue: {
                fields: this._data
            }
        }).clone().value.mapValue.fields;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ let $a33cbddcd7bfa0a9$var$Jt = class DocumentSnapshot {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(t, e, n, r, s){
        this._firestore = t, this._userDataWriter = e, this._key = n, this._document = r, this._converter = s;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new (0, $2fa92ec193801792$export$78acf4525d8a74c4)(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $a33cbddcd7bfa0a9$var$kt(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(t);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * @internal
     * @private
     *
     * Retrieves all fields in the document as a proto Value. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ _fieldsProto() {
        // Return a cloned value to prevent manipulation of the Snapshot's data
        return this._document?.data.clone().value.mapValue.fields ?? void 0;
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t) {
        if (this._document) {
            const e = this._document.data.field((0, $2fa92ec193801792$export$625550452a3fa3ec)("DocumentSnapshot.get", t));
            if (null !== e) return this._userDataWriter.convertValue(e);
        }
    }
}, $a33cbddcd7bfa0a9$var$kt = class QueryDocumentSnapshot extends $a33cbddcd7bfa0a9$var$Jt {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
};
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(t) {
    if ("L" /* LimitType.Last */  === t.limitType && 0 === t.explicitOrderBy.length) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class $a33cbddcd7bfa0a9$var$AppliableConstraint {
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e extends $a33cbddcd7bfa0a9$var$AppliableConstraint {
}
function $a33cbddcd7bfa0a9$export$2fa187e846a241c4(t, e, ...n) {
    let r = [];
    e instanceof $a33cbddcd7bfa0a9$var$AppliableConstraint && r.push(e), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(t) {
        const e = t.filter((t)=>t instanceof $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2).length, n = t.filter((t)=>t instanceof $a33cbddcd7bfa0a9$export$f765fc5789dfd439).length;
        if (e > 1 || e > 0 && n > 0) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(r);
    for (const e of r)t = e._apply(t);
    return t;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class $a33cbddcd7bfa0a9$export$f765fc5789dfd439 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(t, e, n){
        super(), this._field = t, this._op = e, this._value = n, /** The type of this query constraint */ this.type = "where";
    }
    static _create(t, e, n) {
        return new $a33cbddcd7bfa0a9$export$f765fc5789dfd439(t, e, n);
    }
    _apply(t) {
        const e = this._parse(t);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_validateNewFieldFilter(t._query, e), new (0, $2fa92ec193801792$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $2fa92ec193801792$export$f1e1789686576879)(t._query, e));
    }
    _parse(t) {
        const e = (0, $2fa92ec193801792$export$882b5998b3b9117c)(t.firestore), n = function __PRIVATE_newQueryFilter(t, e, n, r, s$1, o, i) {
            let a;
            if (s$1.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */  === o || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === o) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, `Invalid Query. You can't perform '${o}' queries on documentId().`);
                if ("in" /* Operator.IN */  === o || "not-in" /* Operator.NOT_IN */  === o) {
                    $a33cbddcd7bfa0a9$var$__PRIVATE_validateDisjunctiveFilterElements(i, o);
                    const e = [];
                    for (const n of i)e.push($a33cbddcd7bfa0a9$var$__PRIVATE_parseDocumentIdValue(r, t, n));
                    a = {
                        arrayValue: {
                            values: e
                        }
                    };
                } else a = $a33cbddcd7bfa0a9$var$__PRIVATE_parseDocumentIdValue(r, t, i);
            } else "in" /* Operator.IN */  !== o && "not-in" /* Operator.NOT_IN */  !== o && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== o || $a33cbddcd7bfa0a9$var$__PRIVATE_validateDisjunctiveFilterElements(i, o), a = (0, $2fa92ec193801792$export$39b482c5e57630a8)(n, e, i, /* allowArrays= */ "in" /* Operator.IN */  === o || "not-in" /* Operator.NOT_IN */  === o);
            const u = (0, $2fa92ec193801792$export$d66501df72047452).create(s$1, o, a);
            return u;
        }(t._query, "where", e, t.firestore._databaseId, this._field, this._op, this._value);
        return n;
    }
}
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function $a33cbddcd7bfa0a9$export$9c59b80dda569a6e(t, e, n) {
    const r = e, s = (0, $2fa92ec193801792$export$625550452a3fa3ec)("where", t);
    return $a33cbddcd7bfa0a9$export$f765fc5789dfd439._create(s, r, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2 extends $a33cbddcd7bfa0a9$var$AppliableConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e){
        super(), this.type = t, this._queryConstraints = e;
    }
    static _create(t, e) {
        return new $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2(t, e);
    }
    _parse(t) {
        const e = this._queryConstraints.map((e)=>e._parse(t)).filter((t)=>t.getFilters().length > 0);
        return 1 === e.length ? e[0] : (0, $2fa92ec193801792$export$e7094788287c5e9b).create(e, this._getOperator());
    }
    _apply(t) {
        const e = this._parse(t);
        return 0 === e.getFilters().length ? t : (function __PRIVATE_validateNewFilter(t, e) {
            let n = t;
            const r = e.getFlattenedFilters();
            for (const t of r)$a33cbddcd7bfa0a9$var$__PRIVATE_validateNewFieldFilter(n, t), n = (0, $2fa92ec193801792$export$f1e1789686576879)(n, t);
        }(t._query, e), new (0, $2fa92ec193801792$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $2fa92ec193801792$export$f1e1789686576879)(t._query, e)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
    }
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $a33cbddcd7bfa0a9$export$252bb8b3bbdf6749(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_validateQueryFilterConstraint("or", t)), $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2._create("or" /* CompositeOperator.OR */ , t);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $a33cbddcd7bfa0a9$export$21c0ac7fe1cef1b8(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_validateQueryFilterConstraint("and", t)), $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2._create("and" /* CompositeOperator.AND */ , t);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class $a33cbddcd7bfa0a9$export$65a9ba8bbd6ed9e3 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(t, e){
        super(), this._field = t, this._direction = e, /** The type of this query constraint */ this.type = "orderBy";
    }
    static _create(t, e) {
        return new $a33cbddcd7bfa0a9$export$65a9ba8bbd6ed9e3(t, e);
    }
    _apply(t) {
        const e = function __PRIVATE_newQueryOrderBy(t, e, n) {
            if (null !== t.startAt) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== t.endAt) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            const r = new (0, $2fa92ec193801792$export$23f2a1d2818174ef)(e, n);
            return r;
        }(t._query, this._field, this._direction);
        return new (0, $2fa92ec193801792$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $2fa92ec193801792$export$35e795649ee09318)(t._query, e));
    }
}
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function $a33cbddcd7bfa0a9$export$f18af21d6f4dafd8(t, e = "asc") {
    const n = e, r = (0, $2fa92ec193801792$export$625550452a3fa3ec)("orderBy", t);
    return $a33cbddcd7bfa0a9$export$65a9ba8bbd6ed9e3._create(r, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class $a33cbddcd7bfa0a9$export$49bb5356ca788047 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._limit = e, this._limitType = n;
    }
    static _create(t, e, n) {
        return new $a33cbddcd7bfa0a9$export$49bb5356ca788047(t, e, n);
    }
    _apply(t) {
        return new (0, $2fa92ec193801792$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $2fa92ec193801792$export$dda1d9f60106f0e9)(t._query, this._limit, this._limitType));
    }
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $a33cbddcd7bfa0a9$export$ee37e834aaad6f7e(t) {
    return (0, $2fa92ec193801792$export$34aec0b863436764)("limit", t), $a33cbddcd7bfa0a9$export$49bb5356ca788047._create("limit", t, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $a33cbddcd7bfa0a9$export$f823b3589f69d3b8(t) {
    return (0, $2fa92ec193801792$export$34aec0b863436764)("limitToLast", t), $a33cbddcd7bfa0a9$export$49bb5356ca788047._create("limitToLast", t, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class $a33cbddcd7bfa0a9$export$d92e2830aca1d816 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._docOrFields = e, this._inclusive = n;
    }
    static _create(t, e, n) {
        return new $a33cbddcd7bfa0a9$export$d92e2830aca1d816(t, e, n);
    }
    _apply(t) {
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_newQueryBoundFromDocOrFields(t, this.type, this._docOrFields, this._inclusive);
        return new (0, $2fa92ec193801792$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $2fa92ec193801792$export$9e5f44173e64f162)(t._query, e));
    }
}
function $a33cbddcd7bfa0a9$export$859941c5fc8eba6b(...t) {
    return $a33cbddcd7bfa0a9$export$d92e2830aca1d816._create("startAt", t, /*inclusive=*/ true);
}
function $a33cbddcd7bfa0a9$export$dd8dee5f7b804673(...t) {
    return $a33cbddcd7bfa0a9$export$d92e2830aca1d816._create("startAfter", t, /*inclusive=*/ false);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class $a33cbddcd7bfa0a9$export$fd1782fd870d1e06 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._docOrFields = e, this._inclusive = n;
    }
    static _create(t, e, n) {
        return new $a33cbddcd7bfa0a9$export$fd1782fd870d1e06(t, e, n);
    }
    _apply(t) {
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_newQueryBoundFromDocOrFields(t, this.type, this._docOrFields, this._inclusive);
        return new (0, $2fa92ec193801792$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $2fa92ec193801792$export$2d1720544b23b823)(t._query, e));
    }
}
function $a33cbddcd7bfa0a9$export$57203950645b8b11(...t) {
    return $a33cbddcd7bfa0a9$export$fd1782fd870d1e06._create("endBefore", t, /*inclusive=*/ false);
}
function $a33cbddcd7bfa0a9$export$28ec54a8428bdb3f(...t) {
    return $a33cbddcd7bfa0a9$export$fd1782fd870d1e06._create("endAt", t, /*inclusive=*/ true);
}
/** Helper function to create a bound from a document or fields */ function $a33cbddcd7bfa0a9$var$__PRIVATE_newQueryBoundFromDocOrFields(t, e, n, r) {
    if (n[0] = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(n[0]), n[0] instanceof $a33cbddcd7bfa0a9$var$Jt) return function __PRIVATE_newQueryBoundFromDocument(t, e, n, r, s$1) {
        if (!r) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const o = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of (0, $2fa92ec193801792$export$ee7c8ad385a60b7b)(t))if (n.field.isKeyField()) o.push((0, $2fa92ec193801792$export$995eb9fca571757)(e, r.key));
        else {
            const t = r.data.field(n.field);
            if ((0, $2fa92ec193801792$export$f38c853ae54ed474)(t)) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === t) {
                const t = n.field.canonicalString();
                throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${t}' (used as the orderBy) does not exist.`);
            }
            o.push(t);
        }
        return new (0, $2fa92ec193801792$export$3b513254972cfc9c)(o, s$1);
    }(t._query, t.firestore._databaseId, e, n[0]._document, r);
    {
        const s$1 = (0, $2fa92ec193801792$export$882b5998b3b9117c)(t.firestore);
        return function __PRIVATE_newQueryBoundFromFields(t, e, n, r, s$1, o) {
            // Use explicit order by's because it has to match the query the user made
            const i = t.explicitOrderBy;
            if (s$1.length > i.length) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, `Too many arguments provided to ${r}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const a = [];
            for(let o = 0; o < s$1.length; o++){
                const u = s$1[o];
                if (i[o].field.isKeyField()) {
                    if ("string" != typeof u) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${r}(), but got a ${typeof u}`);
                    if (!(0, $2fa92ec193801792$export$21579262ef46735b)(t) && -1 !== u.indexOf("/")) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${r}() must be a plain document ID, but '${u}' contains a slash.`);
                    const n = t.path.child((0, $2fa92ec193801792$export$db202ddc8be9136).fromString(u));
                    if (!(0, $2fa92ec193801792$export$a07804094c3ecf2d).isDocumentKey(n)) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${r}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const s$1 = new (0, $2fa92ec193801792$export$a07804094c3ecf2d)(n);
                    a.push((0, $2fa92ec193801792$export$995eb9fca571757)(e, s$1));
                } else {
                    const t = (0, $2fa92ec193801792$export$39b482c5e57630a8)(n, r, u);
                    a.push(t);
                }
            }
            return new (0, $2fa92ec193801792$export$3b513254972cfc9c)(a, o);
        }(t._query, t.firestore._databaseId, s$1, e, n, r);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_parseDocumentIdValue(t, e, n) {
    if ("string" == typeof (n = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(n))) {
        if ("" === n) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!(0, $2fa92ec193801792$export$21579262ef46735b)(e) && -1 !== n.indexOf("/")) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const r = e.path.child((0, $2fa92ec193801792$export$db202ddc8be9136).fromString(n));
        if (!(0, $2fa92ec193801792$export$a07804094c3ecf2d).isDocumentKey(r)) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
        return (0, $2fa92ec193801792$export$995eb9fca571757)(t, new (0, $2fa92ec193801792$export$a07804094c3ecf2d)(r));
    }
    if (n instanceof (0, $2fa92ec193801792$export$78acf4525d8a74c4)) return (0, $2fa92ec193801792$export$995eb9fca571757)(t, n._key);
    throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${(0, $2fa92ec193801792$export$ab83b03e4111b1d0)(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_validateDisjunctiveFilterElements(t, e) {
    if (!Array.isArray(t) || 0 === t.length) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${e.toString()}' filters.`);
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_validateNewFieldFilter(t, e) {
    const n = function __PRIVATE_findOpInsideFilters(t, e) {
        for (const n of t)for (const t of n.getFlattenedFilters())if (e.indexOf(t.op) >= 0) return t.op;
        return null;
    }(t.filters, function __PRIVATE_conflictingOps(t) {
        switch(t){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(e.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === e.op ? new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${e.op.toString()}' filter.`) : new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, `Invalid query. You cannot use '${e.op.toString()}' filters with '${n.toString()}' filters.`);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_validateQueryFilterConstraint(t, e) {
    if (!(e instanceof $a33cbddcd7bfa0a9$export$f765fc5789dfd439 || e instanceof $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2)) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, `Function ${t}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(t, e, n) {
    let r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = t ? n && (n.merge || n.mergeFields) ? t.toFirestore(e, n) : t.toFirestore(e) : e, r;
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_LiteUserDataWriter extends (0, $2fa92ec193801792$export$2f6ca3d3b1f80bf5) {
    constructor(t){
        super(), this.firestore = t;
    }
    convertBytes(t) {
        return new (0, $2fa92ec193801792$export$8a5498727ef6be21)(t);
    }
    convertReference(t) {
        const e = this.convertDocumentKey(t, this.firestore._databaseId);
        return new (0, $2fa92ec193801792$export$78acf4525d8a74c4)(this.firestore, /* converter= */ null, e);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field - Specifies the field to sum across the result set.
 */ function $a33cbddcd7bfa0a9$export$8a63f25cc62965f1(t) {
    return new $a33cbddcd7bfa0a9$export$fada2345be8928cf("sum", (0, $2fa92ec193801792$export$625550452a3fa3ec)("sum", t));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field - Specifies the field to average across the result set.
 */ function $a33cbddcd7bfa0a9$export$cc6710ee5f037d57(t) {
    return new $a33cbddcd7bfa0a9$export$fada2345be8928cf("avg", (0, $2fa92ec193801792$export$625550452a3fa3ec)("average", t));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 */ function $a33cbddcd7bfa0a9$export$85b9a36db797e02b() {
    return new $a33cbddcd7bfa0a9$export$fada2345be8928cf("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left - Compare this AggregateField to the `right`.
 * @param right - Compare this AggregateField to the `left`.
 */ function $a33cbddcd7bfa0a9$export$31fa8ec66e0239ad(t, e) {
    return t instanceof $a33cbddcd7bfa0a9$export$fada2345be8928cf && e instanceof $a33cbddcd7bfa0a9$export$fada2345be8928cf && t.aggregateType === e.aggregateType && t._internalFieldPath?.canonicalString() === e._internalFieldPath?.canonicalString();
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function $a33cbddcd7bfa0a9$export$104f59389a332076(t, e) {
    return (0, $2fa92ec193801792$export$ef35774e6d314e91)(t.query, e.query) && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(t.data(), e.data());
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the number of documents in the result set of the given query
 * without actually downloading the documents.
 *
 * Using this function to count the documents is efficient because only the
 * final count, not the documents' data, is downloaded. This function can
 * count the documents in cases where the result set is prohibitively large to
 * download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query - The query whose result set size is calculated.
 * @returns A Promise that will be resolved with the count; the count can be
 * retrieved from `snapshot.data().count`, where `snapshot` is the
 * `AggregateQuerySnapshot` to which the returned Promise resolves.
 */ function $a33cbddcd7bfa0a9$export$b1de1b12889d0afb(t) {
    return $a33cbddcd7bfa0a9$export$a51511de2fae49b3(t, {
        count: $a33cbddcd7bfa0a9$export$85b9a36db797e02b()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, are downloaded. This
 * function can perform aggregations of the documents in cases where the result
 * set is prohibitively large to download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query - The query whose result set is aggregated over.
 * @param aggregateSpec - An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 */ function $a33cbddcd7bfa0a9$export$a51511de2fae49b3(t, e) {
    const n = (0, $2fa92ec193801792$export$df995fae86a55f06)(t.firestore, (0, $2fa92ec193801792$export$4368d992c4eafac0)), r = (0, $2fa92ec193801792$export$96f57966bedc81b4)(n), o = (0, $2fa92ec193801792$export$971d5caa766a69d7)(e, (t, e)=>new (0, $2fa92ec193801792$export$3a6d5c9ae78a2c08)(e, t.aggregateType, t._internalFieldPath));
    // Run the aggregation and convert the results
    return (0, $2fa92ec193801792$export$e7c866399fa523f5)(r, t._query, o).then((e)=>/**
 * Converts the core aggregation result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult - Core aggregation result
 * @internal
 */ (function __PRIVATE_convertToAggregateQuerySnapshot(t, e, n) {
            const r = new (0, $2fa92ec193801792$export$3b14a55fb2447963)(t), s = new $a33cbddcd7bfa0a9$export$40257fef64be808b(e, r, n);
            return s;
        })(n, t, e));
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLocalCacheImpl {
    constructor(t){
        this.kind = "memory", this._onlineComponentProvider = (0, $2fa92ec193801792$export$6554612db691658e).provider, this._offlineComponentProvider = t?.garbageCollector ? t.garbageCollector._offlineComponentProvider : {
            build: ()=>new (0, $2fa92ec193801792$export$493d36ec626b6698)(void 0)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_PersistentLocalCacheImpl {
    constructor(t){
        let e;
        this.kind = "persistent", t?.tabManager ? (t.tabManager._initialize(t), e = t.tabManager) : (e = $a33cbddcd7bfa0a9$export$d5f96a3c009e86ac(void 0), e._initialize(t)), this._onlineComponentProvider = e._onlineComponentProvider, this._offlineComponentProvider = e._offlineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryEagerGarbageCollectorImpl {
    constructor(){
        this.kind = "memoryEager", this._offlineComponentProvider = (0, $2fa92ec193801792$export$d24c54395ce0c509).provider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLruGarbageCollectorImpl {
    constructor(t){
        this.kind = "memoryLru", this._offlineComponentProvider = {
            build: ()=>new (0, $2fa92ec193801792$export$493d36ec626b6698)(t)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function $a33cbddcd7bfa0a9$export$574728f3be606189() {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryEagerGarbageCollectorImpl;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function $a33cbddcd7bfa0a9$export$2340f88905cc0c23(t) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLruGarbageCollectorImpl(t?.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function $a33cbddcd7bfa0a9$export$72ef71adb739a32c(t) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLocalCacheImpl(t);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function $a33cbddcd7bfa0a9$export$51b321e43d5331d5(t) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_PersistentLocalCacheImpl(t);
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_SingleTabManagerImpl {
    constructor(t){
        this.forceOwnership = t, this.kind = "persistentSingleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(t) {
        this._onlineComponentProvider = (0, $2fa92ec193801792$export$6554612db691658e).provider, this._offlineComponentProvider = {
            build: (e)=>new (0, $2fa92ec193801792$export$d66dc83d8cfc8dd)(e, t?.cacheSizeBytes, this.forceOwnership)
        };
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MultiTabManagerImpl {
    constructor(){
        this.kind = "PersistentMultipleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(t) {
        this._onlineComponentProvider = (0, $2fa92ec193801792$export$6554612db691658e).provider, this._offlineComponentProvider = {
            build: (e)=>new (0, $2fa92ec193801792$export$1fbe638ecf81657e)(e, t?.cacheSizeBytes)
        };
    }
}
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings - Configures the created tab manager.
 */ function $a33cbddcd7bfa0a9$export$d5f96a3c009e86ac(t) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_SingleTabManagerImpl(t?.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function $a33cbddcd7bfa0a9$export$57e9d290b0b4dc04() {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_MultiTabManagerImpl;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$Gt = "NOT SUPPORTED";
/**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class $a33cbddcd7bfa0a9$export$99d61448206ab5cd {
    /** @hideconstructor */ constructor(t, e){
        this.hasPendingWrites = t, this.fromCache = e;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(t) {
        return this.hasPendingWrites === t.hasPendingWrites && this.fromCache === t.fromCache;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $a33cbddcd7bfa0a9$export$acab0e6ef25eb301 extends $a33cbddcd7bfa0a9$var$Jt {
    /** @hideconstructor protected */ constructor(t, e, n, r, s, o){
        super(t, e, n, r, o), this._firestore = t, this._firestoreImpl = t, this.metadata = s;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(t = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(e, t);
            }
            return this._userDataWriter.convertValue(this._document.data.value, t.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t, e = {}) {
        if (this._document) {
            const n = this._document.data.field((0, $2fa92ec193801792$export$625550452a3fa3ec)("DocumentSnapshot.get", t));
            if (null !== n) return this._userDataWriter.convertValue(n, e.serverTimestamps);
        }
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentSnapshot` instance.
     *
     * @returns a JSON representation of this object.  Throws a {@link FirestoreError} if this
     * `DocumentSnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).FAILED_PRECONDITION, "DocumentSnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        const t = this._document, e = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (e.type = $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchemaVersion, e.bundle = "", e.bundleSource = "DocumentSnapshot", e.bundleName = this._key.toString(), !t || !t.isValidDocument() || !t.isFoundDocument()) return e;
        this._userDataWriter.convertObjectMap(t.data.value.mapValue.fields, "previous");
        return e.bundle = (this._firestore, this.ref.path, "NOT SUPPORTED"), e;
    }
}
function $a33cbddcd7bfa0a9$export$bbac1bdeb8972634(t, e, n) {
    if ((0, $2fa92ec193801792$export$9bb611d729802a56)(e, $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchema)) {
        if (e.bundle === $a33cbddcd7bfa0a9$var$Gt) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = (0, $2fa92ec193801792$export$b4171a6734a65d42)(t._databaseId), s$1 = (0, $2fa92ec193801792$export$3466f893ebf79586)(e.bundle, r), o = s$1.va(), i = new (0, $2fa92ec193801792$export$61196ced6d74a310)(s$1.getMetadata(), r);
        for (const t of o)i.qu(t);
        // Ensure that we have the correct number of documents in the bundle.
        const a = i.documents;
        if (1 !== a.length) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, `Expected bundle data to contain 1 document, but it contains ${a.length} documents.`);
        // Build out the internal document data.
        const u = (0, $2fa92ec193801792$export$3a1a48c8f6ef640e)(r, a[0].document), c = new (0, $2fa92ec193801792$export$a07804094c3ecf2d)((0, $2fa92ec193801792$export$db202ddc8be9136).fromString(e.bundleName));
        // Return the external facing DocumentSnapshot.
        return new $a33cbddcd7bfa0a9$export$acab0e6ef25eb301(t, new $a33cbddcd7bfa0a9$var$__PRIVATE_LiteUserDataWriter(t), c, u, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(/* hasPendingWrites= */ false, /* fromCache= */ false), n || null);
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchemaVersion = "firestore/documentSnapshot/1.0", $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchema = {
    type: (0, $2fa92ec193801792$export$ffb5f4729a158638)("string", $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchemaVersion),
    bundleSource: (0, $2fa92ec193801792$export$ffb5f4729a158638)("string", "DocumentSnapshot"),
    bundleName: (0, $2fa92ec193801792$export$ffb5f4729a158638)("string"),
    bundle: (0, $2fa92ec193801792$export$ffb5f4729a158638)("string")
};
class $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c extends $a33cbddcd7bfa0a9$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(t = {}) {
        return super.data(t);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $a33cbddcd7bfa0a9$export$8f21149d8133945c {
    /** @hideconstructor */ constructor(t, e, n, r){
        this._firestore = t, this._userDataWriter = e, this._snapshot = r, this.metadata = new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const t = [];
        return this.forEach((e)=>t.push(e)), t;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(t, e) {
        this._snapshot.docs.forEach((n)=>{
            t.call(e, new $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, n.key, n, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(t = {}) {
        const e = !!t.includeMetadataChanges;
        if (e && this._snapshot.excludesMetadataChanges) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === e || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function __PRIVATE_changesFromSnapshot(t, e) {
            if (t._snapshot.oldDocs.isEmpty()) {
                let e = 0;
                return t._snapshot.docChanges.map((n)=>{
                    (0, $2fa92ec193801792$export$342063e11d6c3cad)(t._snapshot.query) ? (0, $2fa92ec193801792$export$953cecd6e717a553)(t._snapshot.query) : (0, $2fa92ec193801792$export$7ccc53e8f1e7dfc5)(t.query._query);
                    const r = new $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, n.doc.key, n.doc, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(n.doc.key), t._snapshot.fromCache), t.query.converter);
                    return n.doc, {
                        type: "added",
                        doc: r,
                        oldIndex: -1,
                        newIndex: e++
                    };
                });
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = t._snapshot.oldDocs;
                return t._snapshot.docChanges.filter((t)=>e || 3 /* ChangeType.Metadata */  !== t.type).map((e)=>{
                    const r = new $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, e.doc.key, e.doc, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(e.doc.key), t._snapshot.fromCache), t.query.converter);
                    let s = -1, o = -1;
                    return 0 /* ChangeType.Added */  !== e.type && (s = n.indexOf(e.doc.key), n = n.delete(e.doc.key)), 1 /* ChangeType.Removed */  !== e.type && (n = n.add(e.doc), o = n.indexOf(e.doc.key)), {
                        type: $a33cbddcd7bfa0a9$var$__PRIVATE_resultChangeType(e.type),
                        doc: r,
                        oldIndex: s,
                        newIndex: o
                    };
                });
            }
        }(this, e), this._cachedChangesIncludeMetadataChanges = e), this._cachedChanges;
    }
    /**
     * Returns a JSON-serializable representation of this `QuerySnapshot` instance.
     *
     * @returns a JSON representation of this object. Throws a {@link FirestoreError} if this
     * `QuerySnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).FAILED_PRECONDITION, "QuerySnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const t = {};
        t.type = $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchemaVersion, t.bundleSource = "QuerySnapshot", t.bundleName = (0, $2fa92ec193801792$export$ae1af26003f05816).newId(), this._firestore._databaseId.database, this._firestore._databaseId.projectId;
        const e = [], n = [], r = [];
        return this.docs.forEach((t)=>{
            null !== t._document && (e.push(t._document), n.push(this._userDataWriter.convertObjectMap(t._document.data.value.mapValue.fields, "previous")), r.push(t.ref.path));
        }), t.bundle = (this._firestore, this.query._query, t.bundleName, "NOT SUPPORTED"), t;
    }
}
function $a33cbddcd7bfa0a9$export$5bed7af38da9d026(t, e, n) {
    if ((0, $2fa92ec193801792$export$9bb611d729802a56)(e, $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchema)) {
        if (e.bundle === $a33cbddcd7bfa0a9$var$Gt) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = (0, $2fa92ec193801792$export$b4171a6734a65d42)(t._databaseId), s$1 = (0, $2fa92ec193801792$export$3466f893ebf79586)(e.bundle, r), o = s$1.va(), i = new (0, $2fa92ec193801792$export$61196ced6d74a310)(s$1.getMetadata(), r);
        for (const t of o)i.qu(t);
        if (1 !== i.queries.length) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, `Snapshot data expected 1 query but found ${i.queries.length} queries.`);
        // Create an internal Query object from the named query in the bundle.
        const a = (0, $2fa92ec193801792$export$2e2af4578d910ddf)(i.queries[0].bundledQuery), u = (0, $2fa92ec193801792$export$342063e11d6c3cad)(a) ? (0, $2fa92ec193801792$export$953cecd6e717a553)(a) : (0, $2fa92ec193801792$export$7ccc53e8f1e7dfc5)(a), c = i.documents;
        let l = new (0, $2fa92ec193801792$export$a93c5207d687da10)(u);
        c.map((t)=>{
            const e = (0, $2fa92ec193801792$export$3a1a48c8f6ef640e)(r, t.document);
            l = l.add(e);
        });
        // Create a view snapshot of the query and documents.
        const h = (0, $2fa92ec193801792$export$c3950d9923825c02).fromInitialDocuments(a, l, (0, $2fa92ec193801792$export$a9c996f45e5784d0)(), /* fromCache= */ false, /* hasCachedResults= */ false), d = new (0, $2fa92ec193801792$export$3722cfe417b6ed86)(t, n || null, a);
        // Create an external Query object, required to construct the QuerySnapshot.
        // Return a new QuerySnapshot with all of the collected data.
        return new $a33cbddcd7bfa0a9$export$8f21149d8133945c(t, new $a33cbddcd7bfa0a9$var$__PRIVATE_LiteUserDataWriter(t), d, h);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_resultChangeType(t) {
    switch(t){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return (0, $2fa92ec193801792$export$1a82df3d29112e01)(61501, {
                type: t
            });
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $a33cbddcd7bfa0a9$export$f243a5d948512846(t, e) {
    return t instanceof $a33cbddcd7bfa0a9$export$acab0e6ef25eb301 && e instanceof $a33cbddcd7bfa0a9$export$acab0e6ef25eb301 ? t._firestore === e._firestore && t._key.isEqual(e._key) && (null === t._document ? null === e._document : t._document.isEqual(e._document)) && t._converter === e._converter : t instanceof $a33cbddcd7bfa0a9$export$8f21149d8133945c && e instanceof $a33cbddcd7bfa0a9$export$8f21149d8133945c && t._firestore === e._firestore && (0, $2fa92ec193801792$export$ef35774e6d314e91)(t.query, e.query) && t.metadata.isEqual(e.metadata) && t._snapshot.isEqual(e._snapshot);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchemaVersion = "firestore/querySnapshot/1.0", $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchema = {
    type: (0, $2fa92ec193801792$export$ffb5f4729a158638)("string", $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchemaVersion),
    bundleSource: (0, $2fa92ec193801792$export$ffb5f4729a158638)("string", "QuerySnapshot"),
    bundleName: (0, $2fa92ec193801792$export$ffb5f4729a158638)("string"),
    bundle: (0, $2fa92ec193801792$export$ffb5f4729a158638)("string")
};
const $a33cbddcd7bfa0a9$var$jt = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $a33cbddcd7bfa0a9$export$d94ed661b1cfd435 {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._commitHandler = e, this._mutations = [], this._committed = false, this._dataReader = (0, $2fa92ec193801792$export$882b5998b3b9117c)(t);
    }
    set(t, e, n) {
        this._verifyNotCommitted();
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore), s = $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(r.converter, e, n), o = (0, $2fa92ec193801792$export$43caf9889c228507)(this._dataReader, "WriteBatch.set", r._key, s, null !== r.converter, n);
        return this._mutations.push(o.toMutation(r._key, (0, $2fa92ec193801792$export$56c0d5a1e737357d).none())), this;
    }
    update(t, e, n, ...r) {
        this._verifyNotCommitted();
        const s = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let o;
        return o = "string" == typeof (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e)) || e instanceof (0, $2fa92ec193801792$export$90a7f3efeed30595) ? (0, $2fa92ec193801792$export$efccba1c4a2ef57b)(this._dataReader, "WriteBatch.update", s._key, e, n, r) : (0, $2fa92ec193801792$export$d141bba7fdc215a3)(this._dataReader, "WriteBatch.update", s._key, e), this._mutations.push(o.toMutation(s._key, (0, $2fa92ec193801792$export$56c0d5a1e737357d).exists(true))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(t) {
        this._verifyNotCommitted();
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore);
        return this._mutations = this._mutations.concat(new (0, $2fa92ec193801792$export$4a5767248b18ef41)(e._key, (0, $2fa92ec193801792$export$56c0d5a1e737357d).none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = true, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, e) {
    if ((t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t)).firestore !== e) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ let $a33cbddcd7bfa0a9$var$Ut = class Transaction {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._transaction = e, this._dataReader = (0, $2fa92ec193801792$export$882b5998b3b9117c)(t);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore), n = new $a33cbddcd7bfa0a9$var$__PRIVATE_LiteUserDataWriter(this._firestore);
        return this._transaction.lookup([
            e._key
        ]).then((t)=>{
            if (!t || 1 !== t.length) return (0, $2fa92ec193801792$export$1a82df3d29112e01)(24041);
            const r = t[0];
            if (r.isFoundDocument()) return new $a33cbddcd7bfa0a9$var$Jt(this._firestore, n, r.key, r, e.converter);
            if (r.isNoDocument()) return new $a33cbddcd7bfa0a9$var$Jt(this._firestore, n, e._key, null, e.converter);
            throw (0, $2fa92ec193801792$export$1a82df3d29112e01)(18433, {
                doc: r
            });
        });
    }
    set(t, e, n) {
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore), s = $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(r.converter, e, n), o = (0, $2fa92ec193801792$export$43caf9889c228507)(this._dataReader, "Transaction.set", r._key, s, null !== r.converter, n);
        return this._transaction.set(r._key, o), this;
    }
    update(t, e, n, ...r) {
        const s = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let o;
        return o = "string" == typeof (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e)) || e instanceof (0, $2fa92ec193801792$export$90a7f3efeed30595) ? (0, $2fa92ec193801792$export$efccba1c4a2ef57b)(this._dataReader, "Transaction.update", s._key, e, n, r) : (0, $2fa92ec193801792$export$d141bba7fdc215a3)(this._dataReader, "Transaction.update", s._key, e), this._transaction.update(s._key, o), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(t) {
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore);
        return this._transaction.delete(e._key), this;
    }
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $a33cbddcd7bfa0a9$export$febc5573c75cefb0 extends $a33cbddcd7bfa0a9$var$Ut {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(t, e){
        super(t, e), this._firestore = t;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore), n = new (0, $2fa92ec193801792$export$3b14a55fb2447963)(this._firestore);
        return super.get(t).then((t)=>new $a33cbddcd7bfa0a9$export$acab0e6ef25eb301(this._firestore, n, e._key, t._document, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(/* hasPendingWrites= */ false, /* fromCache= */ false), e.converter));
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $a33cbddcd7bfa0a9$export$3c54e006bf9c93b7(t, e, n) {
    t = (0, $2fa92ec193801792$export$df995fae86a55f06)(t, (0, $2fa92ec193801792$export$4368d992c4eafac0));
    const r = {
        ...$a33cbddcd7bfa0a9$var$jt,
        ...n
    };
    !function __PRIVATE_validateTransactionOptions(t) {
        if (t.maxAttempts < 1) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    const o = (0, $2fa92ec193801792$export$96f57966bedc81b4)(t);
    return (0, $2fa92ec193801792$export$7910e0436ed8d1de)(o, (n)=>e(new $a33cbddcd7bfa0a9$export$febc5573c75cefb0(t, n)), r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A `Promise` that resolves with a `DocumentSnapshot` containing the
 * document contents.
 */ function $a33cbddcd7bfa0a9$export$11eb3b5ef9574821(t) {
    t = (0, $2fa92ec193801792$export$df995fae86a55f06)(t, (0, $2fa92ec193801792$export$78acf4525d8a74c4));
    const e = (0, $2fa92ec193801792$export$df995fae86a55f06)(t.firestore, (0, $2fa92ec193801792$export$4368d992c4eafac0)), n = (0, $2fa92ec193801792$export$96f57966bedc81b4)(e);
    return (0, $2fa92ec193801792$export$71cec2538cb2c617)(n, t._key).then((n)=>$a33cbddcd7bfa0a9$var$__PRIVATE_convertToDocSnapshot(e, t, n));
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` that resolves with a `DocumentSnapshot` containing the
 * document contents.
 */ function $a33cbddcd7bfa0a9$export$a58bd92642f7fb58(t) {
    t = (0, $2fa92ec193801792$export$df995fae86a55f06)(t, (0, $2fa92ec193801792$export$78acf4525d8a74c4));
    const e = (0, $2fa92ec193801792$export$df995fae86a55f06)(t.firestore, (0, $2fa92ec193801792$export$4368d992c4eafac0)), n = (0, $2fa92ec193801792$export$96f57966bedc81b4)(e), r = new (0, $2fa92ec193801792$export$3b14a55fb2447963)(e);
    return (0, $2fa92ec193801792$export$8743009a87fcb00f)(n, t._key).then((n)=>new $a33cbddcd7bfa0a9$export$acab0e6ef25eb301(e, r, t._key, n, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ true), t.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` that resolves with a `DocumentSnapshot` containing the
 * document contents.
 */ function $a33cbddcd7bfa0a9$export$35dd759aed9686b4(t) {
    t = (0, $2fa92ec193801792$export$df995fae86a55f06)(t, (0, $2fa92ec193801792$export$78acf4525d8a74c4));
    const e = (0, $2fa92ec193801792$export$df995fae86a55f06)(t.firestore, (0, $2fa92ec193801792$export$4368d992c4eafac0)), n = (0, $2fa92ec193801792$export$96f57966bedc81b4)(e);
    return (0, $2fa92ec193801792$export$71cec2538cb2c617)(n, t._key, {
        source: "server"
    }).then((n)=>$a33cbddcd7bfa0a9$var$__PRIVATE_convertToDocSnapshot(e, t, n));
}
function $a33cbddcd7bfa0a9$export$81d3477bd73c86ef(t) {
    t = (0, $2fa92ec193801792$export$df995fae86a55f06)(t, (0, $2fa92ec193801792$export$3722cfe417b6ed86));
    const e = (0, $2fa92ec193801792$export$df995fae86a55f06)(t.firestore, (0, $2fa92ec193801792$export$4368d992c4eafac0)), n = (0, $2fa92ec193801792$export$96f57966bedc81b4)(e), r = new (0, $2fa92ec193801792$export$3b14a55fb2447963)(e);
    return $a33cbddcd7bfa0a9$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(t._query), (0, $2fa92ec193801792$export$dc98b0b04f4c7758)(n, t._query).then((n)=>new $a33cbddcd7bfa0a9$export$8f21149d8133945c(e, r, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that resolves with the results of the query.
 */ function $a33cbddcd7bfa0a9$export$3fd010f18eac1dd(t) {
    t = (0, $2fa92ec193801792$export$df995fae86a55f06)(t, (0, $2fa92ec193801792$export$3722cfe417b6ed86));
    const e = (0, $2fa92ec193801792$export$df995fae86a55f06)(t.firestore, (0, $2fa92ec193801792$export$4368d992c4eafac0)), n = (0, $2fa92ec193801792$export$96f57966bedc81b4)(e), r = new (0, $2fa92ec193801792$export$3b14a55fb2447963)(e);
    return (0, $2fa92ec193801792$export$3d8c2f653ac9d0b9)(n, t._query).then((n)=>new $a33cbddcd7bfa0a9$export$8f21149d8133945c(e, r, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that resolves with the results of the query.
 */ function $a33cbddcd7bfa0a9$export$ec7d9e44f349c77b(t) {
    t = (0, $2fa92ec193801792$export$df995fae86a55f06)(t, (0, $2fa92ec193801792$export$3722cfe417b6ed86));
    const e = (0, $2fa92ec193801792$export$df995fae86a55f06)(t.firestore, (0, $2fa92ec193801792$export$4368d992c4eafac0)), n = (0, $2fa92ec193801792$export$96f57966bedc81b4)(e), r = new (0, $2fa92ec193801792$export$3b14a55fb2447963)(e);
    return (0, $2fa92ec193801792$export$dc98b0b04f4c7758)(n, t._query, {
        source: "server"
    }).then((n)=>new $a33cbddcd7bfa0a9$export$8f21149d8133945c(e, r, t, n));
}
function $a33cbddcd7bfa0a9$export$5ff77ddaff3c9e12(t, e, n) {
    t = (0, $2fa92ec193801792$export$df995fae86a55f06)(t, (0, $2fa92ec193801792$export$78acf4525d8a74c4));
    const r = (0, $2fa92ec193801792$export$df995fae86a55f06)(t.firestore, (0, $2fa92ec193801792$export$4368d992c4eafac0)), o = $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(t.converter, e, n), i = (0, $2fa92ec193801792$export$882b5998b3b9117c)(r);
    return $a33cbddcd7bfa0a9$export$1945f8fec9dda613(r, [
        (0, $2fa92ec193801792$export$43caf9889c228507)(i, "setDoc", t._key, o, null !== t.converter, n).toMutation(t._key, (0, $2fa92ec193801792$export$56c0d5a1e737357d).none())
    ]);
}
function $a33cbddcd7bfa0a9$export$22d1fdd1e73faff2(t, e, n, ...r) {
    t = (0, $2fa92ec193801792$export$df995fae86a55f06)(t, (0, $2fa92ec193801792$export$78acf4525d8a74c4));
    const o = (0, $2fa92ec193801792$export$df995fae86a55f06)(t.firestore, (0, $2fa92ec193801792$export$4368d992c4eafac0)), i = (0, $2fa92ec193801792$export$882b5998b3b9117c)(o);
    let a;
    a = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e)) || e instanceof (0, $2fa92ec193801792$export$90a7f3efeed30595) ? (0, $2fa92ec193801792$export$efccba1c4a2ef57b)(i, "updateDoc", t._key, e, n, r) : (0, $2fa92ec193801792$export$d141bba7fdc215a3)(i, "updateDoc", t._key, e);
    return $a33cbddcd7bfa0a9$export$1945f8fec9dda613(o, [
        a.toMutation(t._key, (0, $2fa92ec193801792$export$56c0d5a1e737357d).exists(true))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * Note that the returned `Promise` does _not_ resolve until the document is
 * successfully deleted from the remote Firestore backend and, similarly, is not
 * rejected until the remote Firestore backend reports an error deleting the given
 * document. So if the client cannot reach the backend (for example, due to being
 * offline) then the returned `Promise` will not resolve for a potentially-long
 * time (for example, until the client has gone back online). That being said,
 * the given data _will_ be immediately deleted from the local cache and will be
 * reflected in future "get" operations as if it had been successfully
 * deleted from the remote Firestore server, a feature of Firestore called
 * "latency compensation". The document will _eventually_ be deleted from the remote
 * Firestore backend once a connection can be established. Therefore, it is
 * usually undesirable to `await` the `Promise` returned from this function
 * because the indefinite amount of time before which the promise resolves or
 * rejects can block application logic unnecessarily.
 *
 * @param reference - A reference to the document to delete.
 * @returns A `Promise` that resolves once the document has been successfully
 * deleted from the backend or rejects once the backend reports an error
 * deleting the document.
 */ function $a33cbddcd7bfa0a9$export$a4f20481fae8f78b(t) {
    return $a33cbddcd7bfa0a9$export$1945f8fec9dda613((0, $2fa92ec193801792$export$df995fae86a55f06)(t.firestore, (0, $2fa92ec193801792$export$4368d992c4eafac0)), [
        new (0, $2fa92ec193801792$export$4a5767248b18ef41)(t._key, (0, $2fa92ec193801792$export$56c0d5a1e737357d).none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * Note that the returned `Promise` does _not_ resolve until the document is
 * successfully created to the remote Firestore backend and, similarly, is not
 * rejected until the remote Firestore backend reports an error creating the given
 * document. So if the client cannot reach the backend (for example, due to being
 * offline) then the returned `Promise` will not resolve for a potentially-long
 * time (for example, until the client has gone back online). That being said,
 * the given document _will_ be immediately created in the local cache and will be
 * incorporated into future "get" operations as if it had been successfully
 * created in the remote Firestore server, a feature of Firestore called
 * "latency compensation". The document will _eventually_ be created in the remote
 * Firestore backend once a connection can be established. Therefore, it is
 * usually undesirable to `await` the `Promise` returned from this function
 * because the indefinite amount of time before which the promise resolves or
 * rejects can block application logic unnecessarily.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` that resolves once the docoument has been successfully
 * created in the backend or rejects once the backend reports an error creating
 * the document.
 */ function $a33cbddcd7bfa0a9$export$a13890143fb1c2dd(t, e) {
    const n = (0, $2fa92ec193801792$export$df995fae86a55f06)(t.firestore, (0, $2fa92ec193801792$export$4368d992c4eafac0)), r = (0, $2fa92ec193801792$export$ebd11618f299a286)(t), o = $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(t.converter, e), i = (0, $2fa92ec193801792$export$882b5998b3b9117c)(t.firestore);
    return $a33cbddcd7bfa0a9$export$1945f8fec9dda613(n, [
        (0, $2fa92ec193801792$export$43caf9889c228507)(i, "addDoc", r._key, o, null !== t.converter, {}).toMutation(r._key, (0, $2fa92ec193801792$export$56c0d5a1e737357d).exists(false))
    ]).then(()=>r);
}
function $a33cbddcd7bfa0a9$export$d36370812fb26935(t, ...e) {
    // onSnapshot for Query or Document.
    t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t);
    let n = {
        includeMetadataChanges: false,
        source: "default"
    }, r = 0;
    "object" != typeof e[r] || $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(e[r]) || (n = e[r++]);
    const o = {
        includeMetadataChanges: n.includeMetadataChanges,
        source: n.source
    };
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(e[r])) {
        const t = e[r];
        e[r] = t.next?.bind(t), e[r + 1] = t.error?.bind(t), e[r + 2] = t.complete?.bind(t);
    }
    let i, a, u;
    if (t instanceof (0, $2fa92ec193801792$export$78acf4525d8a74c4)) a = (0, $2fa92ec193801792$export$df995fae86a55f06)(t.firestore, (0, $2fa92ec193801792$export$4368d992c4eafac0)), u = (0, $2fa92ec193801792$export$3c2fa207a37baaea)(t._key.path), i = {
        next: (n)=>{
            e[r] && e[r]($a33cbddcd7bfa0a9$var$__PRIVATE_convertToDocSnapshot(a, t, n));
        },
        error: e[r + 1],
        complete: e[r + 2]
    };
    else {
        const n = (0, $2fa92ec193801792$export$df995fae86a55f06)(t, (0, $2fa92ec193801792$export$3722cfe417b6ed86));
        a = (0, $2fa92ec193801792$export$df995fae86a55f06)(n.firestore, (0, $2fa92ec193801792$export$4368d992c4eafac0)), u = n._query;
        const o = new (0, $2fa92ec193801792$export$3b14a55fb2447963)(a);
        i = {
            next: (t)=>{
                e[r] && e[r](new $a33cbddcd7bfa0a9$export$8f21149d8133945c(a, o, n, t));
            },
            error: e[r + 1],
            complete: e[r + 2]
        }, $a33cbddcd7bfa0a9$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(t._query);
    }
    const c = (0, $2fa92ec193801792$export$96f57966bedc81b4)(a);
    return (0, $2fa92ec193801792$export$ce26c07117d59d6a)(c, u, o, i);
}
function $a33cbddcd7bfa0a9$export$a1ef90ed3b4a87fa(t, e, ...n) {
    const r = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t), s$1 = /**
 * Ensures the data required to construct an {@link onSnapshot} listener exist in a `snapshotJson`
 * object that originates from {@link DocumentSnapshot.toJSON} or {@link Querysnapshot.toJSON}. The
 * data is normalized into a typed object.
 *
 * @param snapshotJson - The JSON object that the app provided to {@link onSnapshot}.
 * @returns A normalized object that contains all of the required bundle JSON fields. If
 * {@link snapshotJson} doesn't contain the required fields, or if the fields exist as empty
 * strings, then the {@link snapshotJson.error} field will be a non empty string.
 *
 * @internal
 */ function __PRIVATE_normalizeSnapshotJsonFields(t) {
        const e = {
            bundle: "",
            bundleName: "",
            bundleSource: ""
        }, n = [
            "bundle",
            "bundleName",
            "bundleSource"
        ];
        for (const r of n){
            if (!(r in t)) {
                e.error = `snapshotJson missing required field: ${r}`;
                break;
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const n = t[r];
            if ("string" != typeof n) {
                e.error = `snapshotJson field '${r}' must be a string.`;
                break;
            }
            if (0 === n.length) {
                e.error = `snapshotJson field '${r}' cannot be an empty string.`;
                break;
            }
            "bundle" === r ? e.bundle = n : "bundleName" === r ? e.bundleName = n : "bundleSource" === r && (e.bundleSource = n);
        }
        return e;
    }(e);
    if (s$1.error) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, s$1.error);
    let o, i = 0;
    if ("object" != typeof n[i] || $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(n[i]) || (o = n[i++]), "QuerySnapshot" === s$1.bundleSource) {
        let t = null;
        if ("object" == typeof n[i] && $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(n[i])) {
            const e = n[i++];
            t = {
                next: e.next,
                error: e.error,
                complete: e.complete
            };
        } else t = {
            next: n[i++],
            error: n[i++],
            complete: n[i++]
        };
        /**
 * Loads the bundle in a separate task and then invokes {@link onSnapshot} with a
 * {@link Query} that represents the Query in the bundle.
 *
 * @param firestore - The {@link Firestore} instance for the {@link onSnapshot} operation request.
 * @param json - The JSON bundle to load, produced by {@link QuerySnapshot.toJSON}.
 * @param options - Options controlling the listen behavior.
 * @param observer - A single object containing `next` and `error` callbacks.
 * @param converter - An optional object that converts objects from Firestore before the onNext
 * listener is invoked.
 * @returns An unsubscribe function that can be called to cancel the snapshot
 * listener.
 *
 * @internal
 */ return function __PRIVATE_onSnapshotQuerySnapshotBundle(t, e, n, r, s) {
            let o, i = false;
            const a = (0, $2fa92ec193801792$export$6559d589eb85fbb6)(t, e.bundle);
            return a.then(()=>(0, $2fa92ec193801792$export$efca4cbe5dd06740)(t, e.bundleName)).then((t)=>{
                if (t && !i) s && t.withConverter(s), o = $a33cbddcd7bfa0a9$export$d36370812fb26935(t, n || {}, r);
            }).catch((t)=>(r.error && r.error(t), ()=>{})), ()=>{
                i || (i = true, o && o());
            };
        }(r, s$1, o, t, n[i]);
    }
    if ("DocumentSnapshot" === s$1.bundleSource) {
        let t = null;
        if ("object" == typeof n[i] && $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(n[i])) {
            const e = n[i++];
            t = {
                next: e.next,
                error: e.error,
                complete: e.complete
            };
        } else t = {
            next: n[i++],
            error: n[i++],
            complete: n[i++]
        };
        return function __PRIVATE_onSnapshotDocumentSnapshotBundle(t, e, n, r, s) {
            let o, i = false;
            const a = (0, $2fa92ec193801792$export$6559d589eb85fbb6)(t, e.bundle);
            return a.then(()=>{
                if (!i) {
                    const i = new (0, $2fa92ec193801792$export$78acf4525d8a74c4)(t, s || null, (0, $2fa92ec193801792$export$a07804094c3ecf2d).fromPath(e.bundleName));
                    o = $a33cbddcd7bfa0a9$export$d36370812fb26935(i, n || {}, r);
                }
            }).catch((t)=>(r.error && r.error(t), ()=>{})), ()=>{
                i || (i = true, o && o());
            };
        }(r, s$1, o, t, n[i]);
    }
    throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, `unsupported bundle source: ${s$1.bundleSource}`);
}
function $a33cbddcd7bfa0a9$export$9dff4f5aba83e348(t, e) {
    t = (0, $2fa92ec193801792$export$df995fae86a55f06)(t, (0, $2fa92ec193801792$export$4368d992c4eafac0));
    const n = (0, $2fa92ec193801792$export$96f57966bedc81b4)(t), r = $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(e) ? e : {
        next: e
    };
    return (0, $2fa92ec193801792$export$a8550f7dbe79f93a)(n, r);
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $a33cbddcd7bfa0a9$export$1945f8fec9dda613(t, e) {
    const n = (0, $2fa92ec193801792$export$96f57966bedc81b4)(t);
    return (0, $2fa92ec193801792$export$25ce5a424b770e84)(n, e);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_convertToDocSnapshot(t, e, n) {
    const r = n.docs.get(e._key), s = new (0, $2fa92ec193801792$export$3b14a55fb2447963)(t);
    return new $a33cbddcd7bfa0a9$export$acab0e6ef25eb301(t, s, e._key, r, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), e.converter);
}
function $a33cbddcd7bfa0a9$export$44cd1c9d57edd9b1(t) {
    return t = (0, $2fa92ec193801792$export$df995fae86a55f06)(t, (0, $2fa92ec193801792$export$4368d992c4eafac0)), (0, $2fa92ec193801792$export$96f57966bedc81b4)(t), new $a33cbddcd7bfa0a9$export$d94ed661b1cfd435(t, (e)=>$a33cbddcd7bfa0a9$export$1945f8fec9dda613(t, e));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a33cbddcd7bfa0a9$export$ff1663c0c1304f1a(t, e) {
    t = (0, $2fa92ec193801792$export$df995fae86a55f06)(t, (0, $2fa92ec193801792$export$4368d992c4eafac0));
    const n = (0, $2fa92ec193801792$export$96f57966bedc81b4)(t);
    if (!n._uninitializedComponentsProvider || "memory" === n._uninitializedComponentsProvider._offline.kind) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return (0, $2fa92ec193801792$export$7f8ddf7c7c20b3cd)("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    const r = function __PRIVATE_parseIndexes(t) {
        const e = "string" == typeof t ? function __PRIVATE_tryParseJson(t) {
            try {
                return JSON.parse(t);
            } catch (t) {
                throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, "Failed to parse JSON: " + t?.message);
            }
        }(t) : t, n = [];
        if (Array.isArray(e.indexes)) for (const t of e.indexes){
            const e = $a33cbddcd7bfa0a9$var$__PRIVATE_tryGetString(t, "collectionGroup"), r = [];
            if (Array.isArray(t.fields)) for (const e of t.fields){
                const t = $a33cbddcd7bfa0a9$var$__PRIVATE_tryGetString(e, "fieldPath"), n = (0, $2fa92ec193801792$export$555508cbc6add439)("setIndexConfiguration", t);
                "CONTAINS" === e.arrayConfig ? r.push(new (0, $2fa92ec193801792$export$2219238a014317b0)(n, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === e.order ? r.push(new (0, $2fa92ec193801792$export$2219238a014317b0)(n, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === e.order && r.push(new (0, $2fa92ec193801792$export$2219238a014317b0)(n, 1 /* IndexKind.DESCENDING */ ));
            }
            n.push(new (0, $2fa92ec193801792$export$4c3d22f3d993c33f)((0, $2fa92ec193801792$export$4c3d22f3d993c33f).UNKNOWN_ID, e, r, (0, $2fa92ec193801792$export$f787f51d84a910ad).empty()));
        }
        return n;
    }(e);
    return (0, $2fa92ec193801792$export$c9170ad7d4cd7e57)(n, r);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_tryGetString(t, e) {
    if ("string" != typeof t[e]) throw new (0, $2fa92ec193801792$export$2408f22a0fab9ae5)((0, $2fa92ec193801792$export$db3b6bfb95261072).INVALID_ARGUMENT, "Missing string value for: " + e);
    return t[e];
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `PersistentCacheIndexManager` for configuring persistent cache indexes used
 * for local query execution.
 *
 * To use, call `getPersistentCacheIndexManager()` to get an instance.
 */ class $a33cbddcd7bfa0a9$export$cf4db3c220e88bd8 {
    /** @hideconstructor */ constructor(t){
        this._firestore = t, /** A type string to uniquely identify instances of this class. */ this.type = "PersistentCacheIndexManager";
    }
}
/**
 * Returns the PersistentCache Index Manager used by the given `Firestore`
 * object.
 *
 * @returns The `PersistentCacheIndexManager` instance, or `null` if local
 * persistent storage is not in use.
 */ function $a33cbddcd7bfa0a9$export$61c6347b57bdfa06(t) {
    t = (0, $2fa92ec193801792$export$df995fae86a55f06)(t, (0, $2fa92ec193801792$export$4368d992c4eafac0));
    const e = $a33cbddcd7bfa0a9$var$Ht.get(t);
    if (e) return e;
    const n = (0, $2fa92ec193801792$export$96f57966bedc81b4)(t);
    if ("persistent" !== n._uninitializedComponentsProvider?._offline.kind) return null;
    const r = new $a33cbddcd7bfa0a9$export$cf4db3c220e88bd8(t);
    return $a33cbddcd7bfa0a9$var$Ht.set(t, r), r;
}
/**
 * Enables the SDK to create persistent cache indexes automatically for local
 * query execution when the SDK believes cache indexes can help improve
 * performance.
 *
 * This feature is disabled by default.
 */ function $a33cbddcd7bfa0a9$export$9b2c0a7aacbcd151(t) {
    $a33cbddcd7bfa0a9$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, true);
}
/**
 * Stops creating persistent cache indexes automatically for local query
 * execution. The indexes which have been created by calling
 * `enablePersistentCacheIndexAutoCreation()` still take effect.
 */ function $a33cbddcd7bfa0a9$export$5b460d5f48076743(t) {
    $a33cbddcd7bfa0a9$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, false);
}
/**
 * Removes all persistent cache indexes.
 *
 * Please note this function will also deletes indexes generated by
 * `setIndexConfiguration()`, which is deprecated.
 */ function $a33cbddcd7bfa0a9$export$72809fc2fc5083d5(t) {
    const e = (0, $2fa92ec193801792$export$96f57966bedc81b4)(t._firestore);
    (0, $2fa92ec193801792$export$a9c23c6ac3fc3eca)(e).then((t)=>(0, $2fa92ec193801792$export$2329c99376c9d0a4)("deleting all persistent cache indexes succeeded")).catch((t)=>(0, $2fa92ec193801792$export$7f8ddf7c7c20b3cd)("deleting all persistent cache indexes failed", t));
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, e) {
    const n = (0, $2fa92ec193801792$export$96f57966bedc81b4)(t._firestore);
    (0, $2fa92ec193801792$export$7a38258bbe170828)(n, e).then((t)=>(0, $2fa92ec193801792$export$2329c99376c9d0a4)(`setting persistent cache index auto creation isEnabled=${e} succeeded`)).catch((t)=>(0, $2fa92ec193801792$export$7f8ddf7c7c20b3cd)(`setting persistent cache index auto creation isEnabled=${e} failed`, t));
}
/**
 * Maps `Firestore` instances to their corresponding
 * `PersistentCacheIndexManager` instances.
 *
 * Use a `WeakMap` so that the mapping will be automatically dropped when the
 * `Firestore` instance is garbage collected. This emulates a private member
 * as described in https://goo.gle/454yvug.
 */ const $a33cbddcd7bfa0a9$var$Ht = new WeakMap;
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Testing hooks for use by Firestore's integration test suite to reach into the
 * SDK internals to validate logic and behavior that is not visible from the
 * public API surface.
 *
 * @internal
 */ class $a33cbddcd7bfa0a9$export$3ab3ff3652492b82 {
    constructor(){
        throw new Error("instances of this class should not be created");
    }
    /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback - the callback to invoke upon existence filter mismatch.
     *
     * @returns a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ static onExistenceFilterMismatch(t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_TestingHooksSpiImpl.instance.onExistenceFilterMismatch(t);
    }
}
/**
 * The implementation of `TestingHooksSpi`.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_TestingHooksSpiImpl {
    constructor(){
        this.i = new Map;
    }
    static get instance() {
        return $a33cbddcd7bfa0a9$var$Yt || ($a33cbddcd7bfa0a9$var$Yt = new $a33cbddcd7bfa0a9$var$__PRIVATE_TestingHooksSpiImpl, (0, $2fa92ec193801792$export$306ddfe3a8403e2)($a33cbddcd7bfa0a9$var$Yt)), $a33cbddcd7bfa0a9$var$Yt;
    }
    Ie(t) {
        this.i.forEach((e)=>e(t));
    }
    onExistenceFilterMismatch(t) {
        const e = Symbol(), n = this.i;
        return n.set(e, t), ()=>n.delete(e);
    }
}
let $a33cbddcd7bfa0a9$var$Yt = null;
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_registerFirestore(c, l = true) {
    (0, $2fa92ec193801792$export$92108d983e8ee699)((0, $5e587d655f0a08bb$export$31499a9cd224b78c)), (0, $5e587d655f0a08bb$export$c930050e7bb63965)(new (0, $5782dd2556309534$export$16fa2f45be04daa8)("firestore", (t, { instanceIdentifier: e, options: n })=>{
        const r = t.getProvider("app").getImmediate(), u = new (0, $2fa92ec193801792$export$4368d992c4eafac0)(new (0, $2fa92ec193801792$export$71511d61b312f219)(t.getProvider("auth-internal")), new (0, $2fa92ec193801792$export$407448d2b89b1813)(r, t.getProvider("app-check-internal")), (0, $2fa92ec193801792$export$8b22cf2602fb60ce)(r, e), r);
        return n = {
            useFetchStreams: l,
            ...n
        }, u._setSettings(n), u;
    }, "PUBLIC").setMultipleInstances(true)), (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($a33cbddcd7bfa0a9$var$Wt, $a33cbddcd7bfa0a9$var$$t, c), // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($a33cbddcd7bfa0a9$var$Wt, $a33cbddcd7bfa0a9$var$$t, "esm2020");
}();





var $b20e7fc8482ee2a9$var$name = "firebase";
var $b20e7fc8482ee2a9$var$version = "12.17.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($b20e7fc8482ee2a9$var$name, $b20e7fc8482ee2a9$var$version, 'app');




const $117415e422c8aaf1$var$firebaseConfig = {
    apiKey: "AIzaSyDrNSoD1LhVGjztjZ0Tysn_nPsGjwrvMqs",
    authDomain: "samplton.eu",
    projectId: "divart-apps",
    storageBucket: "divart-apps.firebasestorage.app",
    messagingSenderId: "742072978260",
    appId: "1:742072978260:web:670c73b68c6a917e9d56c1"
};
const $117415e422c8aaf1$var$app = (0, $5e587d655f0a08bb$export$c55cfd413944906d)($117415e422c8aaf1$var$firebaseConfig);
const $117415e422c8aaf1$export$73693bad9f5880b0 = (0, $b38ec4aa5ef4f8c4$export$96f57966bedc81b4)($117415e422c8aaf1$var$app);
const $117415e422c8aaf1$export$ca328f169d304df4 = new (0, $b38ec4aa5ef4f8c4$export$2d1720544b23b823)();
const $117415e422c8aaf1$export$f932f06c7eb6abeb = (0, $2fa92ec193801792$export$a17c37559e1db147)($117415e422c8aaf1$var$app);


var $99dc7a165646c27f$exports = {};
/*!
* sweetalert2 v11.26.25
* Released under the MIT License.
*/ (function(global, factory) {
    $99dc7a165646c27f$exports = factory();
})($99dc7a165646c27f$exports, function() {
    'use strict';
    function _assertClassBrand(e, t, n) {
        if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
        throw new TypeError("Private element is not present on this object");
    }
    function _checkPrivateRedeclaration(e, t) {
        if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
    function _classPrivateFieldGet2(s, a) {
        return s.get(_assertClassBrand(s, a));
    }
    function _classPrivateFieldInitSpec(e, t, a) {
        _checkPrivateRedeclaration(e, t), t.set(e, a);
    }
    function _classPrivateFieldSet2(s, a, r) {
        return s.set(_assertClassBrand(s, a), r), r;
    }
    const RESTORE_FOCUS_TIMEOUT = 100;
    /** @type {GlobalState} */ const globalState = {};
    const focusPreviousActiveElement = ()=>{
        if (globalState.previousActiveElement instanceof HTMLElement) {
            globalState.previousActiveElement.focus();
            globalState.previousActiveElement = null;
        } else if (document.body) document.body.focus();
    };
    /**
   * Restore previous active (focused) element
   *
   * @param {boolean} returnFocus
   * @returns {Promise<void>}
   */ const restoreActiveElement = (returnFocus)=>{
        return new Promise((resolve)=>{
            if (!returnFocus) return resolve();
            const x = window.scrollX;
            const y = window.scrollY;
            globalState.restoreFocusTimeout = setTimeout(()=>{
                focusPreviousActiveElement();
                resolve();
            }, RESTORE_FOCUS_TIMEOUT); // issues/900
            window.scrollTo(x, y);
        });
    };
    const swalPrefix = 'swal2-';
    /**
   * @typedef {Record<SwalClass, string>} SwalClasses
   */ /**
   * @typedef {'success' | 'warning' | 'info' | 'question' | 'error'} SwalIcon
   * @typedef {Record<SwalIcon, string>} SwalIcons
   */ /** @type {SwalClass[]} */ const classNames = [
        'container',
        'shown',
        'height-auto',
        'iosfix',
        'popup',
        'modal',
        'no-backdrop',
        'no-transition',
        'toast',
        'toast-shown',
        'show',
        'hide',
        'close',
        'title',
        'html-container',
        'actions',
        'confirm',
        'deny',
        'cancel',
        'footer',
        'icon',
        'icon-content',
        'image',
        'input',
        'file',
        'range',
        'select',
        'radio',
        'checkbox',
        'label',
        'textarea',
        'inputerror',
        'input-label',
        'validation-message',
        'progress-steps',
        'active-progress-step',
        'progress-step',
        'progress-step-line',
        'loader',
        'loading',
        'styled',
        'top',
        'top-start',
        'top-end',
        'top-left',
        'top-right',
        'center',
        'center-start',
        'center-end',
        'center-left',
        'center-right',
        'bottom',
        'bottom-start',
        'bottom-end',
        'bottom-left',
        'bottom-right',
        'grow-row',
        'grow-column',
        'grow-fullscreen',
        'rtl',
        'timer-progress-bar',
        'timer-progress-bar-container',
        'scrollbar-measure',
        'icon-success',
        'icon-warning',
        'icon-info',
        'icon-question',
        'icon-error',
        'draggable',
        'dragging'
    ];
    const swalClasses = classNames.reduce((acc, className)=>{
        acc[className] = swalPrefix + className;
        return acc;
    }, /** @type {SwalClasses} */ {});
    /** @type {SwalIcon[]} */ const icons = [
        'success',
        'warning',
        'info',
        'question',
        'error'
    ];
    const iconTypes = icons.reduce((acc, icon)=>{
        acc[icon] = swalPrefix + icon;
        return acc;
    }, /** @type {SwalIcons} */ {});
    const consolePrefix = 'SweetAlert2:';
    /**
   * Capitalize the first letter of a string
   *
   * @param {string} str
   * @returns {string}
   */ const capitalizeFirstLetter = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
    /**
   * Standardize console warnings
   *
   * @param {string | string[]} message
   */ const warn = (message)=>{
        console.warn(`${consolePrefix} ${typeof message === 'object' ? message.join(' ') : message}`);
    };
    /**
   * Standardize console errors
   *
   * @param {string} message
   */ const error = (message)=>{
        console.error(`${consolePrefix} ${message}`);
    };
    /**
   * Private global state for `warnOnce`
   *
   * @type {string[]}
   * @private
   */ const previousWarnOnceMessages = [];
    /**
   * Show a console warning, but only if it hasn't already been shown
   *
   * @param {string} message
   */ const warnOnce = (message)=>{
        if (!previousWarnOnceMessages.includes(message)) {
            previousWarnOnceMessages.push(message);
            warn(message);
        }
    };
    /**
   * Show a one-time console warning about deprecated params/methods
   *
   * @param {string} deprecatedParam
   * @param {string?} useInstead
   */ const warnAboutDeprecation = (deprecatedParam, useInstead = null)=>{
        warnOnce(`"${deprecatedParam}" is deprecated and will be removed in the next major release.${useInstead ? ` Use "${useInstead}" instead.` : ''}`);
    };
    /**
   * If `arg` is a function, call it (with no arguments or context) and return the result.
   * Otherwise, just pass the value through
   *
   * @param {(() => *) | *} arg
   * @returns {*}
   */ const callIfFunction = (arg)=>typeof arg === 'function' ? arg() : arg;
    /**
   * @param {*} arg
   * @returns {boolean}
   */ const hasToPromiseFn = (arg)=>arg && typeof arg.toPromise === 'function';
    /**
   * @param {*} arg
   * @returns {Promise<*>}
   */ const asPromise = (arg)=>hasToPromiseFn(arg) ? arg.toPromise() : Promise.resolve(arg);
    /**
   * @param {*} arg
   * @returns {boolean}
   */ const isPromise = (arg)=>arg && Promise.resolve(arg) === arg;
    /**
   * @returns {boolean}
   */ const isFirefox = ()=>navigator.userAgent.includes('Firefox');
    /**
   * Gets the popup container which contains the backdrop and the popup itself.
   *
   * @returns {HTMLElement | null}
   */ const getContainer = ()=>document.body.querySelector(`.${swalClasses.container}`);
    /**
   * @param {string} selectorString
   * @returns {HTMLElement | null}
   */ const elementBySelector = (selectorString)=>{
        const container = getContainer();
        return container ? container.querySelector(selectorString) : null;
    };
    /**
   * @param {string} className
   * @returns {HTMLElement | null}
   */ const elementByClass = (className)=>{
        return elementBySelector(`.${className}`);
    };
    /**
   * @returns {HTMLElement | null}
   */ const getPopup = ()=>elementByClass(swalClasses.popup);
    /**
   * @returns {HTMLElement | null}
   */ const getIcon = ()=>elementByClass(swalClasses.icon);
    /**
   * @returns {HTMLElement | null}
   */ const getIconContent = ()=>elementByClass(swalClasses['icon-content']);
    /**
   * @returns {HTMLElement | null}
   */ const getTitle = ()=>elementByClass(swalClasses.title);
    /**
   * @returns {HTMLElement | null}
   */ const getHtmlContainer = ()=>elementByClass(swalClasses['html-container']);
    /**
   * @returns {HTMLElement | null}
   */ const getImage = ()=>elementByClass(swalClasses.image);
    /**
   * @returns {HTMLElement | null}
   */ const getProgressSteps = ()=>elementByClass(swalClasses['progress-steps']);
    /**
   * @returns {HTMLElement | null}
   */ const getValidationMessage = ()=>elementByClass(swalClasses['validation-message']);
    /**
   * @returns {HTMLButtonElement | null}
   */ const getConfirmButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(`.${swalClasses.actions} .${swalClasses.confirm}`);
    /**
   * @returns {HTMLButtonElement | null}
   */ const getCancelButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(`.${swalClasses.actions} .${swalClasses.cancel}`);
    /**
   * @returns {HTMLButtonElement | null}
   */ const getDenyButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(`.${swalClasses.actions} .${swalClasses.deny}`);
    /**
   * @returns {HTMLElement | null}
   */ const getInputLabel = ()=>elementByClass(swalClasses['input-label']);
    /**
   * @returns {HTMLElement | null}
   */ const getLoader = ()=>elementBySelector(`.${swalClasses.loader}`);
    /**
   * @returns {HTMLElement | null}
   */ const getActions = ()=>elementByClass(swalClasses.actions);
    /**
   * @returns {HTMLElement | null}
   */ const getFooter = ()=>elementByClass(swalClasses.footer);
    /**
   * @returns {HTMLElement | null}
   */ const getTimerProgressBar = ()=>elementByClass(swalClasses['timer-progress-bar']);
    /**
   * @returns {HTMLElement | null}
   */ const getCloseButton = ()=>elementByClass(swalClasses.close);
    // https://github.com/jkup/focusable/blob/master/index.js
    const focusable = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`;
    /**
   * @returns {HTMLElement[]}
   */ const getFocusableElements = ()=>{
        const popup = getPopup();
        if (!popup) return [];
        /** @type {NodeListOf<HTMLElement>} */ const focusableElementsWithTabindex = popup.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])');
        const focusableElementsWithTabindexSorted = Array.from(focusableElementsWithTabindex)// sort according to tabindex
        .sort((a, b)=>{
            const tabindexA = parseInt(a.getAttribute('tabindex') || '0');
            const tabindexB = parseInt(b.getAttribute('tabindex') || '0');
            if (tabindexA > tabindexB) return 1;
            else if (tabindexA < tabindexB) return -1;
            return 0;
        });
        /** @type {NodeListOf<HTMLElement>} */ const otherFocusableElements = popup.querySelectorAll(focusable);
        const otherFocusableElementsFiltered = Array.from(otherFocusableElements).filter((el)=>el.getAttribute('tabindex') !== '-1');
        return [
            ...new Set(focusableElementsWithTabindexSorted.concat(otherFocusableElementsFiltered))
        ].filter((el)=>isVisible$1(el));
    };
    /**
   * @returns {boolean}
   */ const isModal = ()=>{
        return hasClass(document.body, swalClasses.shown) && !hasClass(document.body, swalClasses['toast-shown']) && !hasClass(document.body, swalClasses['no-backdrop']);
    };
    /**
   * @returns {boolean}
   */ const isToast = ()=>{
        const popup = getPopup();
        if (!popup) return false;
        return hasClass(popup, swalClasses.toast);
    };
    /**
   * @returns {boolean}
   */ const isLoading = ()=>{
        const popup = getPopup();
        if (!popup) return false;
        return popup.hasAttribute('data-loading');
    };
    /**
   * Securely set innerHTML of an element
   * https://github.com/sweetalert2/sweetalert2/issues/1926
   *
   * @param {HTMLElement} elem
   * @param {string} html
   */ const setInnerHtml = (elem, html)=>{
        elem.textContent = '';
        if (html) {
            const parser = new DOMParser();
            const parsed = parser.parseFromString(html, `text/html`);
            const head = parsed.querySelector('head');
            if (head) Array.from(head.childNodes).forEach((child)=>{
                elem.appendChild(child);
            });
            const body = parsed.querySelector('body');
            if (body) Array.from(body.childNodes).forEach((child)=>{
                if (child instanceof HTMLVideoElement || child instanceof HTMLAudioElement) elem.appendChild(child.cloneNode(true)); // https://github.com/sweetalert2/sweetalert2/issues/2507
                else elem.appendChild(child);
            });
        }
    };
    /**
   * @param {HTMLElement} elem
   * @param {string} className
   * @returns {boolean}
   */ const hasClass = (elem, className)=>{
        if (!className) return false;
        return className.split(/\s+/).every((cls)=>elem.classList.contains(cls));
    };
    /**
   * @param {HTMLElement} elem
   * @param {SweetAlertOptions} params
   */ const removeCustomClasses = (elem, params)=>{
        Array.from(elem.classList).forEach((className)=>{
            if (!Object.values(swalClasses).includes(className) && !Object.values(iconTypes).includes(className) && !Object.values(params.showClass || {}).includes(className)) elem.classList.remove(className);
        });
    };
    /**
   * @param {HTMLElement} elem
   * @param {SweetAlertOptions} params
   * @param {string} className
   */ const applyCustomClass = (elem, params, className)=>{
        removeCustomClasses(elem, params);
        if (!params.customClass) return;
        const customClass = params.customClass[/** @type {keyof SweetAlertCustomClass} */ className];
        if (!customClass) return;
        if (typeof customClass !== 'string' && !customClass.forEach) {
            warn(`Invalid type of customClass.${className}! Expected string or iterable object, got "${typeof customClass}"`);
            return;
        }
        addClass(elem, customClass);
    };
    /**
   * @param {HTMLElement} popup
   * @param {import('./renderers/renderInput').InputClass | SweetAlertInput} inputClass
   * @returns {HTMLInputElement | null}
   */ const getInput$1 = (popup, inputClass)=>{
        if (!inputClass) return null;
        switch(inputClass){
            case 'select':
            case 'textarea':
            case 'file':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses[inputClass]}`);
            case 'checkbox':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.checkbox} input`);
            case 'radio':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.radio} input:checked`) || popup.querySelector(`.${swalClasses.popup} > .${swalClasses.radio} input:first-child`);
            case 'range':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.range} input`);
            default:
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.input}`);
        }
    };
    /**
   * @param {HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement} input
   */ const focusInput = (input)=>{
        input.focus();
        // place cursor at end of text in text input
        if (input.type !== 'file') {
            // http://stackoverflow.com/a/2345915
            const val = input.value;
            input.value = '';
            input.value = val;
        }
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   * @param {boolean} condition
   */ const toggleClass = (target, classList, condition)=>{
        if (!target || !classList) return;
        const classes = typeof classList === 'string' ? classList.split(/\s+/).filter(Boolean) : classList;
        const targets = Array.isArray(target) ? target : [
            target
        ];
        targets.forEach((elem)=>{
            classes.forEach((className)=>{
                if (condition) elem.classList.add(className);
                else elem.classList.remove(className);
            });
        });
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   */ const addClass = (target, classList)=>{
        toggleClass(target, classList, true);
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   */ const removeClass = (target, classList)=>{
        toggleClass(target, classList, false);
    };
    /**
   * Get direct child of an element by class name
   *
   * @param {HTMLElement} elem
   * @param {string} className
   * @returns {HTMLElement | undefined}
   */ const getDirectChildByClass = (elem, className)=>/** @type {HTMLElement | undefined} */ Array.from(elem.children).find((child)=>child instanceof HTMLElement && hasClass(child, className));
    /**
   * @param {HTMLElement} elem
   * @param {string} property
   * @param {string | number | null | undefined} value
   */ const applyNumericalStyle = (elem, property, value)=>{
        if (value === `${parseInt(`${value}`)}`) value = parseInt(value);
        if (value || value === 0) elem.style.setProperty(property, typeof value === 'number' ? `${value}px` : /** @type {string} */ value);
        else elem.style.removeProperty(property);
    };
    /**
   * @param {HTMLElement | null} elem
   * @param {string} display
   */ const show = (elem, display = 'flex')=>{
        if (!elem) return;
        elem.style.display = display;
    };
    /**
   * @param {HTMLElement | null} elem
   */ const hide = (elem)=>{
        if (!elem) return;
        elem.style.display = 'none';
    };
    /**
   * @param {HTMLElement | null} elem
   * @param {string} display
   */ const showWhenInnerHtmlPresent = (elem, display = 'block')=>{
        if (!elem) return;
        new MutationObserver(()=>{
            toggle(elem, elem.innerHTML, display);
        }).observe(elem, {
            childList: true,
            subtree: true
        });
    };
    /**
   * @param {HTMLElement} parent
   * @param {string} selector
   * @param {string} property
   * @param {string} value
   */ const setStyle = (parent, selector, property, value)=>{
        /** @type {HTMLElement | null} */ const el = parent.querySelector(selector);
        if (el) el.style.setProperty(property, value);
    };
    /**
   * @param {HTMLElement} elem
   * @param {boolean | string | null | undefined} condition
   * @param {string} display
   */ const toggle = (elem, condition, display = 'flex')=>{
        if (condition) show(elem, display);
        else hide(elem);
    };
    /**
   * borrowed from jquery $(elem).is(':visible') implementation
   *
   * @param {HTMLElement | null} elem
   * @returns {boolean}
   */ const isVisible$1 = (elem)=>Boolean(elem && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length));
    /**
   * @returns {boolean}
   */ const allButtonsAreHidden = ()=>!isVisible$1(getConfirmButton()) && !isVisible$1(getDenyButton()) && !isVisible$1(getCancelButton());
    /**
   * @param {HTMLElement} elem
   * @returns {boolean}
   */ const isScrollable = (elem)=>Boolean(elem.scrollHeight > elem.clientHeight);
    /**
   * @param {HTMLElement} element
   * @param {HTMLElement} stopElement
   * @returns {boolean}
   */ const selfOrParentIsScrollable = (element, stopElement)=>{
        let parent = /** @type {HTMLElement | null} */ element;
        while(parent && parent !== stopElement){
            if (isScrollable(parent)) return true;
            parent = parent.parentElement;
        }
        return false;
    };
    /**
   * borrowed from https://stackoverflow.com/a/46352119
   *
   * @param {HTMLElement} elem
   * @returns {boolean}
   */ const hasCssAnimation = (elem)=>{
        const style = window.getComputedStyle(elem);
        const animDuration = parseFloat(style.getPropertyValue('animation-duration') || '0');
        const transDuration = parseFloat(style.getPropertyValue('transition-duration') || '0');
        return animDuration > 0 || transDuration > 0;
    };
    /**
   * @param {number} timer
   * @param {boolean} reset
   */ const animateTimerProgressBar = (timer, reset = false)=>{
        const timerProgressBar = getTimerProgressBar();
        if (!timerProgressBar) return;
        if (isVisible$1(timerProgressBar)) {
            if (reset) {
                timerProgressBar.style.transition = 'none';
                timerProgressBar.style.width = '100%';
            }
            setTimeout(()=>{
                timerProgressBar.style.transition = `width ${timer / 1000}s linear`;
                timerProgressBar.style.width = '0%';
            }, 10);
        }
    };
    const stopTimerProgressBar = ()=>{
        const timerProgressBar = getTimerProgressBar();
        if (!timerProgressBar) return;
        const timerProgressBarWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
        timerProgressBar.style.removeProperty('transition');
        timerProgressBar.style.width = '100%';
        const timerProgressBarFullWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
        const timerProgressBarPercent = timerProgressBarWidth / timerProgressBarFullWidth * 100;
        timerProgressBar.style.width = `${timerProgressBarPercent}%`;
    };
    /**
   * Detect Node env
   *
   * @returns {boolean}
   */ const isNodeEnv = ()=>typeof window === 'undefined' || typeof document === 'undefined';
    const sweetHTML = `
 <div aria-labelledby="${swalClasses.title}" aria-describedby="${swalClasses['html-container']}" class="${swalClasses.popup}" tabindex="-1">
   <button type="button" class="${swalClasses.close}"></button>
   <ul class="${swalClasses['progress-steps']}"></ul>
   <div class="${swalClasses.icon}"></div>
   <img class="${swalClasses.image}" />
   <h2 class="${swalClasses.title}" id="${swalClasses.title}"></h2>
   <div class="${swalClasses['html-container']}" id="${swalClasses['html-container']}"></div>
   <input class="${swalClasses.input}" id="${swalClasses.input}" />
   <input type="file" class="${swalClasses.file}" />
   <div class="${swalClasses.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${swalClasses.select}" id="${swalClasses.select}"></select>
   <div class="${swalClasses.radio}"></div>
   <label class="${swalClasses.checkbox}">
     <input type="checkbox" id="${swalClasses.checkbox}" />
     <span class="${swalClasses.label}"></span>
   </label>
   <textarea class="${swalClasses.textarea}" id="${swalClasses.textarea}"></textarea>
   <div class="${swalClasses['validation-message']}" id="${swalClasses['validation-message']}"></div>
   <div class="${swalClasses.actions}">
     <div class="${swalClasses.loader}"></div>
     <button type="button" class="${swalClasses.confirm}"></button>
     <button type="button" class="${swalClasses.deny}"></button>
     <button type="button" class="${swalClasses.cancel}"></button>
   </div>
   <div class="${swalClasses.footer}"></div>
   <div class="${swalClasses['timer-progress-bar-container']}">
     <div class="${swalClasses['timer-progress-bar']}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, '');
    /**
   * @returns {boolean}
   */ const resetOldContainer = ()=>{
        const oldContainer = getContainer();
        if (!oldContainer) return false;
        oldContainer.remove();
        removeClass([
            document.documentElement,
            document.body
        ], [
            swalClasses['no-backdrop'],
            swalClasses['toast-shown'],
            // @ts-ignore: 'has-column' is not defined in swalClasses but may be set dynamically
            swalClasses['has-column']
        ]);
        return true;
    };
    const resetValidationMessage$1 = ()=>{
        if (globalState.currentInstance) globalState.currentInstance.resetValidationMessage();
    };
    const addInputChangeListeners = ()=>{
        const popup = getPopup();
        if (!popup) return;
        const input = getDirectChildByClass(popup, swalClasses.input);
        const file = getDirectChildByClass(popup, swalClasses.file);
        /** @type {HTMLInputElement | null} */ const range = popup.querySelector(`.${swalClasses.range} input`);
        /** @type {HTMLOutputElement | null} */ const rangeOutput = popup.querySelector(`.${swalClasses.range} output`);
        const select = getDirectChildByClass(popup, swalClasses.select);
        /** @type {HTMLInputElement | null} */ const checkbox = popup.querySelector(`.${swalClasses.checkbox} input`);
        const textarea = getDirectChildByClass(popup, swalClasses.textarea);
        if (input) input.oninput = resetValidationMessage$1;
        if (file) file.onchange = resetValidationMessage$1;
        if (select) select.onchange = resetValidationMessage$1;
        if (checkbox) checkbox.onchange = resetValidationMessage$1;
        if (textarea) textarea.oninput = resetValidationMessage$1;
        if (range && rangeOutput) {
            range.oninput = ()=>{
                resetValidationMessage$1();
                rangeOutput.value = range.value;
            };
            range.onchange = ()=>{
                resetValidationMessage$1();
                rangeOutput.value = range.value;
            };
        }
    };
    /**
   * @param {string | HTMLElement} target
   * @returns {HTMLElement}
   */ const getTarget = (target)=>{
        if (typeof target === 'string') {
            const element = document.querySelector(target);
            if (!element) throw new Error(`Target element "${target}" not found`);
            return /** @type {HTMLElement} */ element;
        }
        return target;
    };
    /**
   * @param {SweetAlertOptions} params
   */ const setupAccessibility = (params)=>{
        const popup = getPopup();
        if (!popup) return;
        popup.setAttribute('role', params.toast ? 'alert' : 'dialog');
        popup.setAttribute('aria-live', params.toast ? 'polite' : 'assertive');
        if (!params.toast) popup.setAttribute('aria-modal', 'true');
    };
    /**
   * @param {HTMLElement} targetElement
   */ const setupRTL = (targetElement)=>{
        if (window.getComputedStyle(targetElement).direction === 'rtl') {
            addClass(getContainer(), swalClasses.rtl);
            globalState.isRTL = true;
        }
    };
    /**
   * Add modal + backdrop to DOM
   *
   * @param {SweetAlertOptions} params
   */ const init = (params)=>{
        // Clean up the old popup container if it exists
        const oldContainerExisted = resetOldContainer();
        if (isNodeEnv()) {
            error('SweetAlert2 requires document to initialize');
            return;
        }
        const container = document.createElement('div');
        container.className = swalClasses.container;
        if (oldContainerExisted) addClass(container, swalClasses['no-transition']);
        setInnerHtml(container, sweetHTML);
        container.dataset['swal2Theme'] = params.theme;
        const targetElement = getTarget(params.target || 'body');
        targetElement.appendChild(container);
        if (params.topLayer) {
            container.setAttribute('popover', '');
            container.showPopover();
        }
        setupAccessibility(params);
        setupRTL(targetElement);
        addInputChangeListeners();
    };
    /**
   * @param {HTMLElement | object | string} param
   * @param {HTMLElement} target
   */ const parseHtmlToContainer = (param, target)=>{
        // DOM element
        if (param instanceof HTMLElement) target.appendChild(param);
        else if (typeof param === 'object') handleObject(param, target);
        else if (param) setInnerHtml(target, param);
    };
    /**
   * @param {object} param
   * @param {HTMLElement} target
   */ const handleObject = (param, target)=>{
        // JQuery element(s)
        if ('jquery' in param) handleJqueryElem(target, param);
        else setInnerHtml(target, param.toString());
    };
    /**
   * @param {HTMLElement} target
   * @param {any} elem
   */ const handleJqueryElem = (target, elem)=>{
        target.textContent = '';
        if (0 in elem) for(let i = 0; i in elem; i++)target.appendChild(elem[i].cloneNode(true));
        else target.appendChild(elem.cloneNode(true));
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderActions = (instance, params)=>{
        const actions = getActions();
        const loader = getLoader();
        if (!actions || !loader) return;
        // Actions (buttons) wrapper
        if (!params.showConfirmButton && !params.showDenyButton && !params.showCancelButton) hide(actions);
        else show(actions);
        // Custom class
        applyCustomClass(actions, params, 'actions');
        // Render all the buttons
        renderButtons(actions, loader, params);
        // Loader
        setInnerHtml(loader, params.loaderHtml || '');
        applyCustomClass(loader, params, 'loader');
    };
    /**
   * @param {HTMLElement} actions
   * @param {HTMLElement} loader
   * @param {SweetAlertOptions} params
   */ function renderButtons(actions, loader, params) {
        const confirmButton = getConfirmButton();
        const denyButton = getDenyButton();
        const cancelButton = getCancelButton();
        if (!confirmButton || !denyButton || !cancelButton) return;
        // Render buttons
        renderButton(confirmButton, 'confirm', params);
        renderButton(denyButton, 'deny', params);
        renderButton(cancelButton, 'cancel', params);
        handleButtonsStyling(confirmButton, denyButton, cancelButton, params);
        if (params.reverseButtons) {
            if (params.toast) {
                actions.insertBefore(cancelButton, confirmButton);
                actions.insertBefore(denyButton, confirmButton);
            } else {
                actions.insertBefore(cancelButton, loader);
                actions.insertBefore(denyButton, loader);
                actions.insertBefore(confirmButton, loader);
            }
        }
    }
    /**
   * @param {HTMLElement} confirmButton
   * @param {HTMLElement} denyButton
   * @param {HTMLElement} cancelButton
   * @param {SweetAlertOptions} params
   */ function handleButtonsStyling(confirmButton, denyButton, cancelButton, params) {
        if (!params.buttonsStyling) {
            removeClass([
                confirmButton,
                denyButton,
                cancelButton
            ], swalClasses.styled);
            return;
        }
        addClass([
            confirmButton,
            denyButton,
            cancelButton
        ], swalClasses.styled);
        // Apply custom background colors and outline colors to action buttons
        /** @type {[HTMLElement, string, string | undefined][]} */ const buttons = [
            [
                confirmButton,
                'confirm',
                params.confirmButtonColor
            ],
            [
                denyButton,
                'deny',
                params.denyButtonColor
            ],
            [
                cancelButton,
                'cancel',
                params.cancelButtonColor
            ]
        ];
        buttons.forEach(([button, type, color])=>{
            if (color) button.style.setProperty(`--swal2-${type}-button-background-color`, color);
            applyOutlineColor(button);
        });
    }
    /**
   * @param {HTMLElement} button
   */ function applyOutlineColor(button) {
        const buttonStyle = window.getComputedStyle(button);
        if (buttonStyle.getPropertyValue('--swal2-action-button-focus-box-shadow')) // If the button already has a custom outline color, no need to change it
        return;
        const outlineColor = buttonStyle.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, 'rgba($1, $2, $3, 0.5)');
        button.style.setProperty('--swal2-action-button-focus-box-shadow', buttonStyle.getPropertyValue('--swal2-outline').replace(/ rgba\(.*/, ` ${outlineColor}`));
    }
    /**
   * @param {HTMLElement} button
   * @param {'confirm' | 'deny' | 'cancel'} buttonType
   * @param {SweetAlertOptions} params
   */ function renderButton(button, buttonType, params) {
        const buttonName = /** @type {'Confirm' | 'Deny' | 'Cancel'} */ capitalizeFirstLetter(buttonType);
        toggle(button, params[`show${buttonName}Button`], 'inline-block');
        setInnerHtml(button, params[`${buttonType}ButtonText`] || ''); // Set caption text
        button.setAttribute('aria-label', params[`${buttonType}ButtonAriaLabel`] || ''); // ARIA label
        // Add buttons custom classes
        button.className = swalClasses[buttonType];
        applyCustomClass(button, params, `${buttonType}Button`);
    }
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderCloseButton = (instance, params)=>{
        const closeButton = getCloseButton();
        if (!closeButton) return;
        setInnerHtml(closeButton, params.closeButtonHtml || '');
        // Custom class
        applyCustomClass(closeButton, params, 'closeButton');
        toggle(closeButton, params.showCloseButton);
        closeButton.setAttribute('aria-label', params.closeButtonAriaLabel || '');
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderContainer = (instance, params)=>{
        const container = getContainer();
        if (!container) return;
        handleBackdropParam(container, params.backdrop);
        handlePositionParam(container, params.position);
        handleGrowParam(container, params.grow);
        // Custom class
        applyCustomClass(container, params, 'container');
    };
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['backdrop']} backdrop
   */ function handleBackdropParam(container, backdrop) {
        if (typeof backdrop === 'string') container.style.background = backdrop;
        else if (!backdrop) addClass([
            document.documentElement,
            document.body
        ], swalClasses['no-backdrop']);
    }
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['position']} position
   */ function handlePositionParam(container, position) {
        if (!position) return;
        if (position in swalClasses) addClass(container, swalClasses[position]);
        else {
            warn('The "position" parameter is not valid, defaulting to "center"');
            addClass(container, swalClasses.center);
        }
    }
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['grow']} grow
   */ function handleGrowParam(container, grow) {
        if (!grow) return;
        addClass(container, swalClasses[`grow-${grow}`]);
    }
    /**
   * This module contains `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */ var privateProps = {
        innerParams: new WeakMap(),
        domCache: new WeakMap(),
        focusedElement: new WeakMap()
    };
    /// <reference path="../../../../sweetalert2.d.ts"/>
    /** @type {InputClass[]} */ const inputClasses = [
        'input',
        'file',
        'range',
        'select',
        'radio',
        'checkbox',
        'textarea'
    ];
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderInput = (instance, params)=>{
        const popup = getPopup();
        if (!popup) return;
        const innerParams = privateProps.innerParams.get(instance);
        const rerender = !innerParams || params.input !== innerParams.input;
        inputClasses.forEach((inputClass)=>{
            const inputContainer = getDirectChildByClass(popup, swalClasses[inputClass]);
            if (!inputContainer) return;
            // set attributes
            setAttributes(inputClass, params.inputAttributes);
            // set class
            inputContainer.className = swalClasses[inputClass];
            if (rerender) hide(inputContainer);
        });
        if (params.input) {
            if (rerender) showInput(params);
            // set custom class
            setCustomClass(params);
        }
    };
    /**
   * @param {SweetAlertOptions} params
   */ const showInput = (params)=>{
        if (!params.input) return;
        if (!renderInputType[params.input]) {
            error(`Unexpected type of input! Expected ${Object.keys(renderInputType).join(' | ')}, got "${params.input}"`);
            return;
        }
        const inputContainer = getInputContainer(params.input);
        if (!inputContainer) return;
        const input = renderInputType[params.input](inputContainer, params);
        show(inputContainer);
        // input autofocus
        if (params.inputAutoFocus) setTimeout(()=>{
            focusInput(input);
        });
    };
    /**
   * @param {HTMLInputElement} input
   */ const removeAttributes = (input)=>{
        for (const { name: name } of Array.from(input.attributes))if (![
            'id',
            'type',
            'value',
            'style'
        ].includes(name)) input.removeAttribute(name);
    };
    /**
   * @param {InputClass} inputClass
   * @param {SweetAlertOptions['inputAttributes']} inputAttributes
   */ const setAttributes = (inputClass, inputAttributes)=>{
        const popup = getPopup();
        if (!popup) return;
        const input = getInput$1(popup, inputClass);
        if (!input) return;
        removeAttributes(input);
        for(const attr in inputAttributes)input.setAttribute(attr, inputAttributes[attr]);
    };
    /**
   * @param {SweetAlertOptions} params
   */ const setCustomClass = (params)=>{
        if (!params.input) return;
        const inputContainer = getInputContainer(params.input);
        if (inputContainer) applyCustomClass(inputContainer, params, 'input');
    };
    /**
   * @param {HTMLInputElement | HTMLTextAreaElement} input
   * @param {SweetAlertOptions} params
   */ const setInputPlaceholder = (input, params)=>{
        if (!input.placeholder && params.inputPlaceholder) input.placeholder = params.inputPlaceholder;
    };
    /**
   * @param {Input} input
   * @param {Input} prependTo
   * @param {SweetAlertOptions} params
   */ const setInputLabel = (input, prependTo, params)=>{
        if (params.inputLabel) {
            const label = document.createElement('label');
            const labelClass = swalClasses['input-label'];
            label.setAttribute('for', input.id);
            label.className = labelClass;
            if (typeof params.customClass === 'object') addClass(label, params.customClass.inputLabel);
            label.innerText = params.inputLabel;
            prependTo.insertAdjacentElement('beforebegin', label);
        }
    };
    /**
   * @param {SweetAlertInput} inputType
   * @returns {HTMLElement | undefined}
   */ const getInputContainer = (inputType)=>{
        const popup = getPopup();
        if (!popup) return;
        return getDirectChildByClass(popup, swalClasses[/** @type {SwalClass} */ inputType] || swalClasses.input);
    };
    /**
   * @param {HTMLInputElement | HTMLOutputElement | HTMLTextAreaElement} input
   * @param {SweetAlertOptions['inputValue']} inputValue
   */ const checkAndSetInputValue = (input, inputValue)=>{
        if ([
            'string',
            'number'
        ].includes(typeof inputValue)) input.value = `${inputValue}`;
        else if (!isPromise(inputValue)) warn(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof inputValue}"`);
    };
    /** @type {Record<SweetAlertInput, (input: Input | HTMLElement, params: SweetAlertOptions) => Input>} */ const renderInputType = {};
    /**
   * @param {Input | HTMLElement} input
   * @param {SweetAlertOptions} params
   * @returns {Input}
   */ renderInputType.text = renderInputType.email = renderInputType.password = renderInputType.number = renderInputType.tel = renderInputType.url = renderInputType.search = renderInputType.date = renderInputType['datetime-local'] = renderInputType.time = renderInputType.week = renderInputType.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */ (input, params)=>{
        // oxfmt-ignore
        const inputElement = /** @type {HTMLInputElement} */ input;
        checkAndSetInputValue(inputElement, params.inputValue);
        setInputLabel(inputElement, inputElement, params);
        setInputPlaceholder(inputElement, params);
        // oxfmt-ignore
        inputElement.type = /** @type {string} */ params.input;
        return inputElement;
    };
    /**
   * @param {Input | HTMLElement} input
   * @param {SweetAlertOptions} params
   * @returns {Input}
   */ renderInputType.file = (input, params)=>{
        const inputElement = /** @type {HTMLInputElement} */ input;
        setInputLabel(inputElement, inputElement, params);
        setInputPlaceholder(inputElement, params);
        return inputElement;
    };
    /**
   * @param {Input | HTMLElement} range
   * @param {SweetAlertOptions} params
   * @returns {Input}
   */ renderInputType.range = (range, params)=>{
        const rangeContainer = /** @type {HTMLElement} */ range;
        const rangeInput = rangeContainer.querySelector('input');
        const rangeOutput = rangeContainer.querySelector('output');
        if (rangeInput) {
            checkAndSetInputValue(rangeInput, params.inputValue);
            rangeInput.type = /** @type {string} */ params.input;
            setInputLabel(rangeInput, /** @type {Input} */ range, params);
        }
        if (rangeOutput) checkAndSetInputValue(rangeOutput, params.inputValue);
        return /** @type {Input} */ range;
    };
    /**
   * @param {Input | HTMLElement} select
   * @param {SweetAlertOptions} params
   * @returns {Input}
   */ renderInputType.select = (select, params)=>{
        const selectElement = /** @type {HTMLSelectElement} */ select;
        selectElement.textContent = '';
        if (params.inputPlaceholder) {
            const placeholder = document.createElement('option');
            setInnerHtml(placeholder, params.inputPlaceholder);
            placeholder.value = '';
            placeholder.disabled = true;
            placeholder.selected = true;
            selectElement.appendChild(placeholder);
        }
        setInputLabel(selectElement, selectElement, params);
        return selectElement;
    };
    /**
   * @param {Input | HTMLElement} radio
   * @returns {Input}
   */ renderInputType.radio = (radio)=>{
        const radioElement = /** @type {HTMLElement} */ radio;
        radioElement.textContent = '';
        return /** @type {Input} */ radio;
    };
    /**
   * @param {Input | HTMLElement} checkboxContainer
   * @param {SweetAlertOptions} params
   * @returns {Input}
   */ renderInputType.checkbox = (checkboxContainer, params)=>{
        const popup = getPopup();
        if (!popup) throw new Error('Popup not found');
        const checkbox = getInput$1(popup, 'checkbox');
        if (!checkbox) throw new Error('Checkbox input not found');
        checkbox.value = '1';
        checkbox.checked = Boolean(params.inputValue);
        const containerElement = /** @type {HTMLElement} */ checkboxContainer;
        const label = containerElement.querySelector('span');
        if (label) {
            const placeholderOrLabel = params.inputPlaceholder || params.inputLabel;
            if (placeholderOrLabel) setInnerHtml(label, placeholderOrLabel);
        }
        return checkbox;
    };
    /**
   * @param {Input | HTMLElement} textarea
   * @param {SweetAlertOptions} params
   * @returns {Input}
   */ renderInputType.textarea = (textarea, params)=>{
        const textareaElement = /** @type {HTMLTextAreaElement} */ textarea;
        checkAndSetInputValue(textareaElement, params.inputValue);
        setInputPlaceholder(textareaElement, params);
        setInputLabel(textareaElement, textareaElement, params);
        /**
     * @param {HTMLElement} el
     * @returns {number}
     */ const getMargin = (el)=>parseInt(window.getComputedStyle(el).marginLeft) + parseInt(window.getComputedStyle(el).marginRight);
        // https://github.com/sweetalert2/sweetalert2/issues/2291
        setTimeout(()=>{
            // https://github.com/sweetalert2/sweetalert2/issues/1699
            if ('MutationObserver' in window) {
                const popup = getPopup();
                if (!popup) return;
                const initialPopupWidth = parseInt(window.getComputedStyle(popup).width);
                const textareaResizeHandler = ()=>{
                    // check if texarea is still in document (i.e. popup wasn't closed in the meantime)
                    if (!document.body.contains(textareaElement)) return;
                    const textareaWidth = textareaElement.offsetWidth + getMargin(textareaElement);
                    const popupElement = getPopup();
                    if (popupElement) {
                        if (textareaWidth > initialPopupWidth) popupElement.style.width = `${textareaWidth}px`;
                        else applyNumericalStyle(popupElement, 'width', params.width);
                    }
                };
                new MutationObserver(textareaResizeHandler).observe(textareaElement, {
                    attributes: true,
                    attributeFilter: [
                        'style'
                    ]
                });
            }
        });
        return textareaElement;
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderContent = (instance, params)=>{
        const htmlContainer = getHtmlContainer();
        if (!htmlContainer) return;
        showWhenInnerHtmlPresent(htmlContainer);
        applyCustomClass(htmlContainer, params, 'htmlContainer');
        // Content as HTML
        if (params.html) {
            parseHtmlToContainer(params.html, htmlContainer);
            show(htmlContainer, 'block');
        } else if (params.text) {
            htmlContainer.textContent = params.text;
            show(htmlContainer, 'block');
        } else hide(htmlContainer);
        renderInput(instance, params);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderFooter = (instance, params)=>{
        const footer = getFooter();
        if (!footer) return;
        showWhenInnerHtmlPresent(footer);
        toggle(footer, Boolean(params.footer), 'block');
        if (params.footer) parseHtmlToContainer(params.footer, footer);
        // Custom class
        applyCustomClass(footer, params, 'footer');
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderIcon = (instance, params)=>{
        const innerParams = privateProps.innerParams.get(instance);
        const icon = getIcon();
        if (!icon) return;
        // if the given icon already rendered, apply the styling without re-rendering the icon
        if (innerParams && params.icon === innerParams.icon) {
            // Custom or default content
            setContent(icon, params);
            applyStyles(icon, params);
            return;
        }
        if (!params.icon && !params.iconHtml) {
            hide(icon);
            return;
        }
        if (params.icon && Object.keys(iconTypes).indexOf(params.icon) === -1) {
            error(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${params.icon}"`);
            hide(icon);
            return;
        }
        show(icon);
        // Custom or default content
        setContent(icon, params);
        applyStyles(icon, params);
        // Animate icon
        addClass(icon, params.showClass && params.showClass.icon);
        // Re-adjust the success icon on system theme change
        const colorSchemeQueryList = window.matchMedia('(prefers-color-scheme: dark)');
        colorSchemeQueryList.addEventListener('change', adjustSuccessIconBackgroundColor);
    };
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const applyStyles = (icon, params)=>{
        for (const [iconType, iconClassName] of Object.entries(iconTypes))if (params.icon !== iconType) removeClass(icon, iconClassName);
        addClass(icon, params.icon && iconTypes[params.icon]);
        // Icon color
        setColor(icon, params);
        // Success icon background color
        adjustSuccessIconBackgroundColor();
        // Custom class
        applyCustomClass(icon, params, 'icon');
    };
    // Adjust success icon background color to match the popup background color
    const adjustSuccessIconBackgroundColor = ()=>{
        const popup = getPopup();
        if (!popup) return;
        const popupBackgroundColor = window.getComputedStyle(popup).getPropertyValue('background-color');
        /** @type {NodeListOf<HTMLElement>} */ const successIconParts = popup.querySelectorAll('[class^=swal2-success-circular-line], .swal2-success-fix');
        successIconParts.forEach((part)=>{
            part.style.backgroundColor = popupBackgroundColor;
        });
    };
    /**
   *
   * @param {SweetAlertOptions} params
   * @returns {string}
   */ const successIconHtml = (params)=>`
  ${params.animation ? '<div class="swal2-success-circular-line-left"></div>' : ''}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${params.animation ? '<div class="swal2-success-fix"></div>' : ''}
  ${params.animation ? '<div class="swal2-success-circular-line-right"></div>' : ''}
`;
    const errorIconHtml = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`;
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const setContent = (icon, params)=>{
        if (!params.icon && !params.iconHtml) return;
        let oldContent = icon.innerHTML;
        let newContent = '';
        if (params.iconHtml) newContent = iconContent(params.iconHtml);
        else if (params.icon === 'success') {
            newContent = successIconHtml(params);
            oldContent = oldContent.replace(/ style=".*?"/g, ''); // undo adjustSuccessIconBackgroundColor()
        } else if (params.icon === 'error') newContent = errorIconHtml;
        else if (params.icon) {
            const defaultIconHtml = {
                question: '?',
                warning: '!',
                info: 'i'
            };
            newContent = iconContent(defaultIconHtml[params.icon]);
        }
        if (oldContent.trim() !== newContent.trim()) setInnerHtml(icon, newContent);
    };
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const setColor = (icon, params)=>{
        if (!params.iconColor) return;
        icon.style.color = params.iconColor;
        icon.style.borderColor = params.iconColor;
        for (const sel of [
            '.swal2-success-line-tip',
            '.swal2-success-line-long',
            '.swal2-x-mark-line-left',
            '.swal2-x-mark-line-right'
        ])setStyle(icon, sel, 'background-color', params.iconColor);
        setStyle(icon, '.swal2-success-ring', 'border-color', params.iconColor);
    };
    /**
   * @param {string} content
   * @returns {string}
   */ const iconContent = (content)=>`<div class="${swalClasses['icon-content']}">${content}</div>`;
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderImage = (instance, params)=>{
        const image = getImage();
        if (!image) return;
        if (!params.imageUrl) {
            hide(image);
            return;
        }
        show(image, '');
        // Src, alt
        image.setAttribute('src', params.imageUrl);
        image.setAttribute('alt', params.imageAlt || '');
        // Width, height
        applyNumericalStyle(image, 'width', params.imageWidth);
        applyNumericalStyle(image, 'height', params.imageHeight);
        // Class
        image.className = swalClasses.image;
        applyCustomClass(image, params, 'image');
    };
    let dragging = false;
    let mousedownX = 0;
    let mousedownY = 0;
    let initialX = 0;
    let initialY = 0;
    /**
   * @param {HTMLElement} popup
   */ const addDraggableListeners = (popup)=>{
        popup.addEventListener('mousedown', down);
        document.body.addEventListener('mousemove', move);
        popup.addEventListener('mouseup', up);
        popup.addEventListener('touchstart', down);
        document.body.addEventListener('touchmove', move);
        popup.addEventListener('touchend', up);
    };
    /**
   * @param {HTMLElement} popup
   */ const removeDraggableListeners = (popup)=>{
        popup.removeEventListener('mousedown', down);
        document.body.removeEventListener('mousemove', move);
        popup.removeEventListener('mouseup', up);
        popup.removeEventListener('touchstart', down);
        document.body.removeEventListener('touchmove', move);
        popup.removeEventListener('touchend', up);
    };
    /**
   * @param {MouseEvent | TouchEvent} event
   */ const down = (event)=>{
        const popup = getPopup();
        if (!popup) return;
        const icon = getIcon();
        if (event.target === popup || icon && icon.contains(/** @type {HTMLElement} */ event.target)) {
            dragging = true;
            const clientXY = getClientXY(event);
            mousedownX = clientXY.clientX;
            mousedownY = clientXY.clientY;
            initialX = parseInt(popup.style.insetInlineStart) || 0;
            initialY = parseInt(popup.style.insetBlockStart) || 0;
            addClass(popup, 'swal2-dragging');
        }
    };
    /**
   * @param {MouseEvent | TouchEvent} event
   */ const move = (event)=>{
        const popup = getPopup();
        if (!popup) return;
        if (dragging) {
            let { clientX: clientX, clientY: clientY } = getClientXY(event);
            const deltaX = clientX - mousedownX;
            // In RTL mode, negate the horizontal delta since insetInlineStart refers to the right edge
            popup.style.insetInlineStart = `${initialX + (globalState.isRTL ? -deltaX : deltaX)}px`;
            popup.style.insetBlockStart = `${initialY + (clientY - mousedownY)}px`;
        }
    };
    const up = ()=>{
        const popup = getPopup();
        dragging = false;
        removeClass(popup, 'swal2-dragging');
    };
    /**
   * @param {MouseEvent | TouchEvent} event
   * @returns {{ clientX: number, clientY: number }}
   */ const getClientXY = (event)=>{
        const source = event.type.startsWith('touch') ? /** @type {TouchEvent} */ event.touches[0] : /** @type {MouseEvent} */ event;
        return {
            clientX: source.clientX,
            clientY: source.clientY
        };
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderPopup = (instance, params)=>{
        const container = getContainer();
        const popup = getPopup();
        if (!container || !popup) return;
        // Width
        // https://github.com/sweetalert2/sweetalert2/issues/2170
        if (params.toast) {
            applyNumericalStyle(container, 'width', params.width);
            popup.style.width = '100%';
            const loader = getLoader();
            if (loader) popup.insertBefore(loader, getIcon());
        } else applyNumericalStyle(popup, 'width', params.width);
        // Padding
        applyNumericalStyle(popup, 'padding', params.padding);
        // Color
        if (params.color) popup.style.color = params.color;
        // Background
        if (params.background) popup.style.background = params.background;
        hide(getValidationMessage());
        // Classes
        addClasses$1(popup, params);
        if (params.draggable && !params.toast) {
            addClass(popup, swalClasses.draggable);
            addDraggableListeners(popup);
        } else {
            removeClass(popup, swalClasses.draggable);
            removeDraggableListeners(popup);
        }
    };
    /**
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} params
   */ const addClasses$1 = (popup, params)=>{
        const showClass = params.showClass || {};
        // Default Class + showClass when updating Swal.update({})
        popup.className = `${swalClasses.popup} ${isVisible$1(popup) ? showClass.popup : ''}`;
        if (params.toast) {
            addClass([
                document.documentElement,
                document.body
            ], swalClasses['toast-shown']);
            addClass(popup, swalClasses.toast);
        } else addClass(popup, swalClasses.modal);
        // Custom class
        applyCustomClass(popup, params, 'popup');
        // TODO: remove in the next major
        if (typeof params.customClass === 'string') addClass(popup, params.customClass);
        // Icon class (#1842)
        if (params.icon) addClass(popup, swalClasses[`icon-${params.icon}`]);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderProgressSteps = (instance, params)=>{
        const progressStepsContainer = getProgressSteps();
        if (!progressStepsContainer) return;
        const { progressSteps: progressSteps, currentProgressStep: currentProgressStep } = params;
        if (!progressSteps || progressSteps.length === 0 || currentProgressStep === undefined) {
            hide(progressStepsContainer);
            return;
        }
        show(progressStepsContainer);
        progressStepsContainer.textContent = '';
        if (currentProgressStep >= progressSteps.length) warn("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)");
        progressSteps.forEach((step, index)=>{
            const stepEl = createStepElement(step);
            progressStepsContainer.appendChild(stepEl);
            if (index === currentProgressStep) addClass(stepEl, swalClasses['active-progress-step']);
            if (index !== progressSteps.length - 1) {
                const lineEl = createLineElement(params);
                progressStepsContainer.appendChild(lineEl);
            }
        });
    };
    /**
   * @param {string} step
   * @returns {HTMLLIElement}
   */ const createStepElement = (step)=>{
        const stepEl = document.createElement('li');
        addClass(stepEl, swalClasses['progress-step']);
        setInnerHtml(stepEl, step);
        return stepEl;
    };
    /**
   * @param {SweetAlertOptions} params
   * @returns {HTMLLIElement}
   */ const createLineElement = (params)=>{
        const lineEl = document.createElement('li');
        addClass(lineEl, swalClasses['progress-step-line']);
        if (params.progressStepsDistance) applyNumericalStyle(lineEl, 'width', params.progressStepsDistance);
        return lineEl;
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderTitle = (instance, params)=>{
        const title = getTitle();
        if (!title) return;
        showWhenInnerHtmlPresent(title);
        toggle(title, Boolean(params.title || params.titleText), 'block');
        if (params.title) parseHtmlToContainer(params.title, title);
        if (params.titleText) title.innerText = params.titleText;
        // Custom class
        applyCustomClass(title, params, 'title');
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const render = (instance, params)=>{
        var _globalState$eventEmi;
        renderPopup(instance, params);
        renderContainer(instance, params);
        renderProgressSteps(instance, params);
        renderIcon(instance, params);
        renderImage(instance, params);
        renderTitle(instance, params);
        renderCloseButton(instance, params);
        renderContent(instance, params);
        renderActions(instance, params);
        renderFooter(instance, params);
        const popup = getPopup();
        if (typeof params.didRender === 'function' && popup) params.didRender(popup);
        (_globalState$eventEmi = globalState.eventEmitter) === null || _globalState$eventEmi === void 0 || _globalState$eventEmi.emit('didRender', popup);
    };
    /*
   * Global function to determine if SweetAlert2 popup is shown
   */ const isVisible = ()=>{
        return isVisible$1(getPopup());
    };
    /*
   * Global function to click 'Confirm' button
   */ const clickConfirm = ()=>{
        var _dom$getConfirmButton;
        return (_dom$getConfirmButton = getConfirmButton()) === null || _dom$getConfirmButton === void 0 ? void 0 : _dom$getConfirmButton.click();
    };
    /*
   * Global function to click 'Deny' button
   */ const clickDeny = ()=>{
        var _dom$getDenyButton;
        return (_dom$getDenyButton = getDenyButton()) === null || _dom$getDenyButton === void 0 ? void 0 : _dom$getDenyButton.click();
    };
    /*
   * Global function to click 'Cancel' button
   */ const clickCancel = ()=>{
        var _dom$getCancelButton;
        return (_dom$getCancelButton = getCancelButton()) === null || _dom$getCancelButton === void 0 ? void 0 : _dom$getCancelButton.click();
    };
    /** @type {Record<DismissReason, DismissReason>} */ const DismissReason = Object.freeze({
        cancel: 'cancel',
        backdrop: 'backdrop',
        close: 'close',
        esc: 'esc',
        timer: 'timer'
    });
    /**
   * @param {GlobalState} globalState
   */ const removeKeydownHandler = (globalState)=>{
        if (globalState.keydownTarget && globalState.keydownHandlerAdded && globalState.keydownHandler) {
            const handler = /** @type {EventListenerOrEventListenerObject} */ /** @type {unknown} */ globalState.keydownHandler;
            globalState.keydownTarget.removeEventListener('keydown', handler, {
                capture: globalState.keydownListenerCapture
            });
            globalState.keydownHandlerAdded = false;
        }
    };
    /**
   * @param {GlobalState} globalState
   * @param {SweetAlertOptions} innerParams
   * @param {(dismiss: DismissReason) => void} dismissWith
   */ const addKeydownHandler = (globalState, innerParams, dismissWith)=>{
        removeKeydownHandler(globalState);
        if (!innerParams.toast) {
            /** @type {(this: HTMLElement, event: KeyboardEvent) => void} */ const handler = (e)=>keydownHandler(innerParams, e, dismissWith);
            globalState.keydownHandler = handler;
            const target = innerParams.keydownListenerCapture ? window : getPopup();
            if (target) {
                globalState.keydownTarget = target;
                globalState.keydownListenerCapture = innerParams.keydownListenerCapture;
                const eventHandler = /** @type {EventListenerOrEventListenerObject} */ /** @type {unknown} */ handler;
                globalState.keydownTarget.addEventListener('keydown', eventHandler, {
                    capture: globalState.keydownListenerCapture
                });
                globalState.keydownHandlerAdded = true;
            }
        }
    };
    /**
   * @param {number} index
   * @param {number} increment
   * @returns {boolean} shouldPreventDefault
   */ const setFocus = (index, increment)=>{
        var _dom$getPopup;
        const focusableElements = getFocusableElements();
        // search for visible elements and select the next possible match
        if (focusableElements.length) {
            index = index + increment;
            // shift + tab when .swal2-popup is focused
            if (index === -2) index = focusableElements.length - 1;
            // rollover to first item
            if (index === focusableElements.length) index = 0;
            else if (index === -1) index = focusableElements.length - 1;
            focusableElements[index].focus();
            // don't prevent default for iframes (Firefox fix)
            // https://github.com/sweetalert2/sweetalert2/issues/2931
            if (isFirefox() && focusableElements[index] instanceof HTMLIFrameElement) return false;
            return true;
        }
        // no visible focusable elements, focus the popup
        (_dom$getPopup = getPopup()) === null || _dom$getPopup === void 0 || _dom$getPopup.focus();
        return true;
    };
    const arrowKeysNextButton = [
        'ArrowRight',
        'ArrowDown'
    ];
    const arrowKeysPreviousButton = [
        'ArrowLeft',
        'ArrowUp'
    ];
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {KeyboardEvent} event
   * @param {(dismiss: DismissReason) => void} dismissWith
   */ const keydownHandler = (innerParams, event, dismissWith)=>{
        if (!innerParams) return; // This instance has already been destroyed
        // Ignore keydown during IME composition
        // https://developer.mozilla.org/en-US/docs/Web/API/Document/keydown_event#ignoring_keydown_during_ime_composition
        // https://github.com/sweetalert2/sweetalert2/issues/720
        // https://github.com/sweetalert2/sweetalert2/issues/2406
        if (event.isComposing || event.keyCode === 229) return;
        if (innerParams.stopKeydownPropagation) event.stopPropagation();
        // ENTER
        if (event.key === 'Enter') handleEnter(event, innerParams);
        else if (event.key === 'Tab') handleTab(event);
        else if ([
            ...arrowKeysNextButton,
            ...arrowKeysPreviousButton
        ].includes(event.key)) handleArrows(event.key);
        else if (event.key === 'Escape') handleEsc(event, innerParams, dismissWith);
    };
    /**
   * @param {KeyboardEvent} event
   * @param {SweetAlertOptions} innerParams
   */ const handleEnter = (event, innerParams)=>{
        // https://github.com/sweetalert2/sweetalert2/issues/2386
        if (!callIfFunction(innerParams.allowEnterKey)) return;
        const popup = getPopup();
        if (!popup || !innerParams.input) return;
        const input = getInput$1(popup, innerParams.input);
        if (event.target && input && event.target instanceof HTMLElement && event.target.outerHTML === input.outerHTML) {
            if ([
                'textarea',
                'file'
            ].includes(innerParams.input)) return; // do not submit
            clickConfirm();
            event.preventDefault();
        }
    };
    /**
   * @param {KeyboardEvent} event
   */ const handleTab = (event)=>{
        const targetElement = event.target;
        const focusableElements = getFocusableElements();
        const btnIndex = focusableElements.findIndex((el)=>el === targetElement);
        // don't prevent default for iframes (Firefox fix)
        // https://github.com/sweetalert2/sweetalert2/issues/2931
        let shouldPreventDefault = true;
        // Cycle to the next button
        if (!event.shiftKey) shouldPreventDefault = setFocus(btnIndex, 1);
        else shouldPreventDefault = setFocus(btnIndex, -1);
        event.stopPropagation();
        if (shouldPreventDefault) event.preventDefault();
    };
    /**
   * @param {string} key
   */ const handleArrows = (key)=>{
        const actions = getActions();
        const confirmButton = getConfirmButton();
        const denyButton = getDenyButton();
        const cancelButton = getCancelButton();
        if (!actions || !confirmButton || !denyButton || !cancelButton) return;
        /** @type HTMLElement[] */ const buttons = [
            confirmButton,
            denyButton,
            cancelButton
        ];
        if (document.activeElement instanceof HTMLElement && !buttons.includes(document.activeElement)) return;
        const sibling = arrowKeysNextButton.includes(key) ? 'nextElementSibling' : 'previousElementSibling';
        let buttonToFocus = document.activeElement;
        if (!buttonToFocus) return;
        for(let i = 0; i < actions.children.length; i++){
            buttonToFocus = buttonToFocus[sibling];
            if (!buttonToFocus) return;
            if (buttonToFocus instanceof HTMLButtonElement && isVisible$1(buttonToFocus)) break;
        }
        if (buttonToFocus instanceof HTMLButtonElement) buttonToFocus.focus();
    };
    /**
   * @param {KeyboardEvent} event
   * @param {SweetAlertOptions} innerParams
   * @param {(dismiss: DismissReason) => void} dismissWith
   */ const handleEsc = (event, innerParams, dismissWith)=>{
        event.preventDefault();
        if (callIfFunction(innerParams.allowEscapeKey)) dismissWith(DismissReason.esc);
    };
    /**
   * This module contains `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */ var privateMethods = {
        swalPromiseResolve: new WeakMap(),
        swalPromiseReject: new WeakMap()
    };
    // From https://developer.paciellogroup.com/blog/2018/06/the-current-state-of-modal-dialog-accessibility/
    // Adding aria-hidden="true" to elements outside of the active modal dialog ensures that
    // elements not within the active modal dialog will not be surfaced if a user opens a screen
    // reader’s list of elements (headings, form controls, landmarks, etc.) in the document.
    const setAriaHidden = ()=>{
        const container = getContainer();
        const bodyChildren = Array.from(document.body.children);
        bodyChildren.forEach((el)=>{
            if (el.contains(container)) return;
            if (el.hasAttribute('aria-hidden')) el.setAttribute('data-previous-aria-hidden', el.getAttribute('aria-hidden') || '');
            el.setAttribute('aria-hidden', 'true');
        });
    };
    const unsetAriaHidden = ()=>{
        const bodyChildren = Array.from(document.body.children);
        bodyChildren.forEach((el)=>{
            if (el.hasAttribute('data-previous-aria-hidden')) {
                el.setAttribute('aria-hidden', el.getAttribute('data-previous-aria-hidden') || '');
                el.removeAttribute('data-previous-aria-hidden');
            } else el.removeAttribute('aria-hidden');
        });
    };
    // @ts-ignore
    const isSafariOrIOS = typeof window !== 'undefined' && Boolean(window.GestureEvent); // true for Safari desktop + all iOS browsers https://stackoverflow.com/a/70585394
    // @ts-ignore
    const isIOS = isSafariOrIOS && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    /**
   * Fix iOS scrolling
   * http://stackoverflow.com/q/39626302
   */ const iOSfix = ()=>{
        if (isSafariOrIOS && !hasClass(document.body, swalClasses.iosfix)) {
            const offset = document.body.scrollTop;
            document.body.style.top = `${offset * -1}px`;
            addClass(document.body, swalClasses.iosfix);
            lockBodyScroll();
        }
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1246
   */ const lockBodyScroll = ()=>{
        const container = getContainer();
        if (!container) return;
        /** @type {boolean} */ let preventTouchMove;
        /**
     * @param {TouchEvent} event
     */ container.ontouchstart = (event)=>{
            preventTouchMove = shouldPreventTouchMove(event);
        };
        /**
     * @param {TouchEvent} event
     */ container.ontouchmove = (event)=>{
            if (preventTouchMove) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
    };
    /**
   * @param {TouchEvent} event
   * @returns {boolean}
   */ const shouldPreventTouchMove = (event)=>{
        const target = event.target;
        const container = getContainer();
        const htmlContainer = getHtmlContainer();
        if (!container || !htmlContainer) return false;
        if (isStylus(event) || isZoom(event)) return false;
        if (target === container) return true;
        if (!isScrollable(container) && target instanceof HTMLElement && !selfOrParentIsScrollable(target, htmlContainer) && // #2823
        target.tagName !== 'INPUT' && // #1603
        target.tagName !== 'TEXTAREA' && // #2266
        !(isScrollable(htmlContainer) && // #1944
        htmlContainer.contains(target))) return true;
        return false;
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1786
   *
   * @param {TouchEvent} event
   * @returns {boolean}
   */ const isStylus = (event)=>{
        return Boolean(event.touches && event.touches.length && // @ts-ignore - touchType is not a standard property
        event.touches[0].touchType === 'stylus');
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1891
   *
   * @param {TouchEvent} event
   * @returns {boolean}
   */ const isZoom = (event)=>{
        return event.touches && event.touches.length > 1;
    };
    const undoIOSfix = ()=>{
        if (hasClass(document.body, swalClasses.iosfix)) {
            const offset = parseInt(document.body.style.top, 10);
            removeClass(document.body, swalClasses.iosfix);
            document.body.style.top = '';
            document.body.scrollTop = offset * -1;
        }
    };
    /**
   * Measure scrollbar width for padding body during modal show/hide
   * https://github.com/twbs/bootstrap/blob/master/js/src/modal.js
   *
   * @returns {number}
   */ const measureScrollbar = ()=>{
        const scrollDiv = document.createElement('div');
        scrollDiv.className = swalClasses['scrollbar-measure'];
        document.body.appendChild(scrollDiv);
        const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        return scrollbarWidth;
    };
    /**
   * Remember state in cases where opening and handling a modal will fiddle with it.
   * @type {number | null}
   */ let previousBodyPadding = null;
    /**
   * @param {string} initialBodyOverflow
   */ const replaceScrollbarWithPadding = (initialBodyOverflow)=>{
        // for queues, do not do this more than once
        if (previousBodyPadding !== null) return;
        // if the body has overflow
        if (document.body.scrollHeight > window.innerHeight || initialBodyOverflow === 'scroll' // https://github.com/sweetalert2/sweetalert2/issues/2663
        ) {
            // add padding so the content doesn't shift after removal of scrollbar
            previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'));
            document.body.style.paddingRight = `${previousBodyPadding + measureScrollbar()}px`;
        }
    };
    const undoReplaceScrollbarWithPadding = ()=>{
        if (previousBodyPadding !== null) {
            document.body.style.paddingRight = `${previousBodyPadding}px`;
            previousBodyPadding = null;
        }
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} container
   * @param {boolean} returnFocus
   * @param {(() => void) | undefined} didClose
   */ function removePopupAndResetState(instance, container, returnFocus, didClose) {
        if (isToast()) triggerDidCloseAndDispose(instance, didClose);
        else {
            restoreActiveElement(returnFocus).then(()=>triggerDidCloseAndDispose(instance, didClose));
            removeKeydownHandler(globalState);
        }
        // workaround for https://github.com/sweetalert2/sweetalert2/issues/2088
        // for some reason removing the container in Safari will scroll the document to bottom
        if (isSafariOrIOS) {
            container.setAttribute('style', 'display:none !important');
            container.removeAttribute('class');
            container.innerHTML = '';
        } else container.remove();
        if (isModal()) {
            undoReplaceScrollbarWithPadding();
            undoIOSfix();
            unsetAriaHidden();
        }
        removeBodyClasses();
    }
    /**
   * Remove SweetAlert2 classes from body
   */ function removeBodyClasses() {
        removeClass([
            document.documentElement,
            document.body
        ], [
            swalClasses.shown,
            swalClasses['height-auto'],
            swalClasses['no-backdrop'],
            swalClasses['toast-shown']
        ]);
    }
    /**
   * Instance method to close sweetAlert
   *
   * @param {SweetAlertResult | undefined} resolveValue
   * @this {SweetAlert}
   */ function close(resolveValue) {
        resolveValue = prepareResolveValue(resolveValue);
        const swalPromiseResolve = privateMethods.swalPromiseResolve.get(this);
        const didClose = triggerClosePopup(this);
        if (this.isAwaitingPromise) // A swal awaiting for a promise (after a click on Confirm or Deny) cannot be dismissed anymore #2335
        {
            if (!resolveValue.isDismissed) {
                handleAwaitingPromise(this);
                swalPromiseResolve(resolveValue);
            }
        } else if (didClose) // Resolve Swal promise
        swalPromiseResolve(resolveValue);
    }
    /**
   * @param {SweetAlert} instance
   * @returns {boolean}
   */ const triggerClosePopup = (instance)=>{
        const popup = getPopup();
        if (!popup) return false;
        const innerParams = privateProps.innerParams.get(instance);
        if (!innerParams || hasClass(popup, innerParams.hideClass.popup)) return false;
        removeClass(popup, innerParams.showClass.popup);
        addClass(popup, innerParams.hideClass.popup);
        const backdrop = getContainer();
        removeClass(backdrop, innerParams.showClass.backdrop);
        addClass(backdrop, innerParams.hideClass.backdrop);
        handlePopupAnimation(instance, popup, innerParams);
        return true;
    };
    /**
   * @param {Error | string} error
   * @this {SweetAlert}
   */ function rejectPromise(error) {
        const rejectPromise = privateMethods.swalPromiseReject.get(this);
        handleAwaitingPromise(this);
        if (rejectPromise) // Reject Swal promise
        rejectPromise(error);
    }
    /**
   * @param {SweetAlert} instance
   */ const handleAwaitingPromise = (instance)=>{
        if (instance.isAwaitingPromise) {
            // @ts-ignore
            delete instance.isAwaitingPromise;
            // The instance might have been previously partly destroyed, we must resume the destroy process in this case #2335
            if (!privateProps.innerParams.get(instance)) instance._destroy();
        }
    };
    /**
   * @param {SweetAlertResult | undefined} resolveValue
   * @returns {SweetAlertResult}
   */ const prepareResolveValue = (resolveValue)=>{
        // When user calls Swal.close()
        if (typeof resolveValue === 'undefined') return {
            isConfirmed: false,
            isDenied: false,
            isDismissed: true
        };
        return Object.assign({
            isConfirmed: false,
            isDenied: false,
            isDismissed: false
        }, resolveValue);
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} innerParams
   */ const handlePopupAnimation = (instance, popup, innerParams)=>{
        var _globalState$eventEmi;
        const container = getContainer();
        // If animation is supported, animate
        const animationIsSupported = hasCssAnimation(popup);
        if (typeof innerParams.willClose === 'function') innerParams.willClose(popup);
        (_globalState$eventEmi = globalState.eventEmitter) === null || _globalState$eventEmi === void 0 || _globalState$eventEmi.emit('willClose', popup);
        if (animationIsSupported && container) animatePopup(instance, popup, container, Boolean(innerParams.returnFocus), innerParams.didClose);
        else if (container) // Otherwise, remove immediately
        removePopupAndResetState(instance, container, Boolean(innerParams.returnFocus), innerParams.didClose);
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} popup
   * @param {HTMLElement} container
   * @param {boolean} returnFocus
   * @param {(() => void) | undefined} didClose
   */ const animatePopup = (instance, popup, container, returnFocus, didClose)=>{
        globalState.swalCloseEventFinishedCallback = removePopupAndResetState.bind(null, instance, container, returnFocus, didClose);
        /**
     * @param {AnimationEvent | TransitionEvent} e
     */ const swalCloseAnimationFinished = function(e) {
            if (e.target === popup) {
                var _globalState$swalClos;
                (_globalState$swalClos = globalState.swalCloseEventFinishedCallback) === null || _globalState$swalClos === void 0 || _globalState$swalClos.call(globalState);
                delete globalState.swalCloseEventFinishedCallback;
                popup.removeEventListener('animationend', swalCloseAnimationFinished);
                popup.removeEventListener('transitionend', swalCloseAnimationFinished);
            }
        };
        popup.addEventListener('animationend', swalCloseAnimationFinished);
        popup.addEventListener('transitionend', swalCloseAnimationFinished);
    };
    /**
   * @param {SweetAlert} instance
   * @param {(() => void) | undefined} didClose
   */ const triggerDidCloseAndDispose = (instance, didClose)=>{
        setTimeout(()=>{
            var _globalState$eventEmi2;
            if (typeof didClose === 'function') didClose.bind(instance.params)();
            (_globalState$eventEmi2 = globalState.eventEmitter) === null || _globalState$eventEmi2 === void 0 || _globalState$eventEmi2.emit('didClose');
            // instance might have been destroyed already
            if (instance._destroy) instance._destroy();
        });
    };
    /**
   * Shows loader (spinner), this is useful with AJAX requests.
   * By default the loader be shown instead of the "Confirm" button.
   *
   * @param {HTMLButtonElement | null} [buttonToReplace]
   */ const showLoading = (buttonToReplace)=>{
        let popup = getPopup();
        if (!popup) new Swal();
        popup = getPopup();
        if (!popup) return;
        const loader = getLoader();
        if (isToast()) hide(getIcon());
        else replaceButton(popup, buttonToReplace);
        show(loader);
        popup.setAttribute('data-loading', 'true');
        popup.setAttribute('aria-busy', 'true');
        popup.focus();
    };
    /**
   * @param {HTMLElement} popup
   * @param {HTMLButtonElement | null} [buttonToReplace]
   */ const replaceButton = (popup, buttonToReplace)=>{
        const actions = getActions();
        const loader = getLoader();
        if (!actions || !loader) return;
        if (!buttonToReplace && isVisible$1(getConfirmButton())) buttonToReplace = getConfirmButton();
        show(actions);
        if (buttonToReplace) {
            hide(buttonToReplace);
            loader.setAttribute('data-button-to-replace', buttonToReplace.className);
            actions.insertBefore(loader, buttonToReplace);
        }
        addClass([
            popup,
            actions
        ], swalClasses.loading);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputOptionsAndValue = (instance, params)=>{
        if (params.input === 'select' || params.input === 'radio') handleInputOptions(instance, params);
        else if ([
            'text',
            'email',
            'number',
            'tel',
            'textarea'
        ].some((i)=>i === params.input) && (hasToPromiseFn(params.inputValue) || isPromise(params.inputValue))) {
            showLoading(getConfirmButton());
            handleInputValue(instance, params);
        }
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} innerParams
   * @returns {SweetAlertInputValue}
   */ const getInputValue = (instance, innerParams)=>{
        const input = instance.getInput();
        if (!input) return null;
        switch(innerParams.input){
            case 'checkbox':
                return getCheckboxValue(input);
            case 'radio':
                return getRadioValue(input);
            case 'file':
                return getFileValue(input);
            default:
                return innerParams.inputAutoTrim ? input.value.trim() : input.value;
        }
    };
    /**
   * @param {HTMLInputElement} input
   * @returns {number}
   */ const getCheckboxValue = (input)=>input.checked ? 1 : 0;
    /**
   * @param {HTMLInputElement} input
   * @returns {string | null}
   */ const getRadioValue = (input)=>input.checked ? input.value : null;
    /**
   * @param {HTMLInputElement} input
   * @returns {FileList | File | null}
   */ const getFileValue = (input)=>input.files && input.files.length ? input.getAttribute('multiple') !== null ? input.files : input.files[0] : null;
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputOptions = (instance, params)=>{
        const popup = getPopup();
        if (!popup) return;
        /**
     * @param {*} inputOptions
     */ const processInputOptions = (inputOptions)=>{
            if (params.input === 'select') populateSelectOptions(popup, formatInputOptions(inputOptions), params);
            else if (params.input === 'radio') populateRadioOptions(popup, formatInputOptions(inputOptions), params);
        };
        if (hasToPromiseFn(params.inputOptions) || isPromise(params.inputOptions)) {
            showLoading(getConfirmButton());
            asPromise(params.inputOptions).then((inputOptions)=>{
                instance.hideLoading();
                processInputOptions(inputOptions);
            });
        } else if (typeof params.inputOptions === 'object') processInputOptions(params.inputOptions);
        else error(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof params.inputOptions}`);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputValue = (instance, params)=>{
        const input = instance.getInput();
        if (!input) return;
        hide(input);
        asPromise(params.inputValue).then((inputValue)=>{
            input.value = params.input === 'number' ? `${parseFloat(inputValue) || 0}` : `${inputValue}`;
            show(input);
            input.focus();
            instance.hideLoading();
        }).catch((err)=>{
            error(`Error in inputValue promise: ${err}`);
            input.value = '';
            show(input);
            input.focus();
            instance.hideLoading();
        });
    };
    /**
   * @param {HTMLElement} popup
   * @param {InputOptionFlattened[]} inputOptions
   * @param {SweetAlertOptions} params
   */ function populateSelectOptions(popup, inputOptions, params) {
        const select = getDirectChildByClass(popup, swalClasses.select);
        if (!select) return;
        /**
     * @param {HTMLElement} parent
     * @param {string} optionLabel
     * @param {string} optionValue
     */ const renderOption = (parent, optionLabel, optionValue)=>{
            const option = document.createElement('option');
            option.value = optionValue;
            setInnerHtml(option, optionLabel);
            option.selected = isSelected(optionValue, params.inputValue);
            parent.appendChild(option);
        };
        inputOptions.forEach((inputOption)=>{
            const optionValue = inputOption[0];
            const optionLabel = inputOption[1];
            // <optgroup> spec:
            // https://www.w3.org/TR/html401/interact/forms.html#h-17.6
            // "...all OPTGROUP elements must be specified directly within a SELECT element (i.e., groups may not be nested)..."
            // check whether this is a <optgroup>
            if (Array.isArray(optionLabel)) {
                // if it is an array, then it is an <optgroup>
                const optgroup = document.createElement('optgroup');
                optgroup.label = optionValue;
                optgroup.disabled = false; // not configurable for now
                select.appendChild(optgroup);
                optionLabel.forEach((o)=>renderOption(optgroup, o[1], o[0]));
            } else // case of <option>
            renderOption(select, optionLabel, optionValue);
        });
        select.focus();
    }
    /**
   * @param {HTMLElement} popup
   * @param {InputOptionFlattened[]} inputOptions
   * @param {SweetAlertOptions} params
   */ function populateRadioOptions(popup, inputOptions, params) {
        const radio = getDirectChildByClass(popup, swalClasses.radio);
        if (!radio) return;
        inputOptions.forEach((inputOption)=>{
            const radioValue = inputOption[0];
            const radioLabel = inputOption[1];
            const radioInput = document.createElement('input');
            const radioLabelElement = document.createElement('label');
            radioInput.type = 'radio';
            radioInput.name = swalClasses.radio;
            radioInput.value = radioValue;
            if (isSelected(radioValue, params.inputValue)) radioInput.checked = true;
            const label = document.createElement('span');
            setInnerHtml(label, radioLabel);
            label.className = swalClasses.label;
            radioLabelElement.appendChild(radioInput);
            radioLabelElement.appendChild(label);
            radio.appendChild(radioLabelElement);
        });
        const radios = radio.querySelectorAll('input');
        if (radios.length) radios[0].focus();
    }
    /**
   * Converts `inputOptions` into an array of `[value, label]`s
   *
   * @param {*} inputOptions
   * @typedef {string[]} InputOptionFlattened
   * @returns {InputOptionFlattened[]}
   */ const formatInputOptions = (inputOptions)=>{
        const entries = inputOptions instanceof Map ? Array.from(inputOptions) : Object.entries(inputOptions);
        return entries.map(([key, value])=>[
                key,
                typeof value === 'object' ? formatInputOptions(value) : value
            ]); // case of <optgroup>
    };
    /**
   * @param {string} optionValue
   * @param {SweetAlertInputValue} inputValue
   * @returns {boolean}
   */ const isSelected = (optionValue, inputValue)=>Boolean(inputValue) && inputValue != null && inputValue.toString() === optionValue.toString();
    /**
   * @param {SweetAlert} instance
   */ const handleConfirmButtonClick = (instance)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableButtons();
        if (innerParams.input) handleConfirmOrDenyWithInput(instance, 'confirm');
        else confirm(instance, true);
    };
    /**
   * @param {SweetAlert} instance
   */ const handleDenyButtonClick = (instance)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableButtons();
        if (innerParams.returnInputValueOnDeny) handleConfirmOrDenyWithInput(instance, 'deny');
        else deny(instance, false);
    };
    /**
   * @param {SweetAlert} instance
   * @param {(dismiss: DismissReason) => void} dismissWith
   */ const handleCancelButtonClick = (instance, dismissWith)=>{
        instance.disableButtons();
        dismissWith(DismissReason.cancel);
    };
    /**
   * @param {SweetAlert} instance
   * @param {'confirm' | 'deny'} type
   */ const handleConfirmOrDenyWithInput = (instance, type)=>{
        const innerParams = privateProps.innerParams.get(instance);
        if (!innerParams.input) {
            error(`The "input" parameter is needed to be set when using returnInputValueOn${capitalizeFirstLetter(type)}`);
            return;
        }
        const input = instance.getInput();
        const inputValue = getInputValue(instance, innerParams);
        if (innerParams.inputValidator) handleInputValidator(instance, inputValue, type);
        else if (input && !input.checkValidity()) {
            instance.enableButtons();
            instance.showValidationMessage(innerParams.validationMessage || input.validationMessage);
        } else if (type === 'deny') deny(instance, inputValue);
        else confirm(instance, inputValue);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertInputValue} inputValue
   * @param {'confirm' | 'deny'} type
   */ const handleInputValidator = (instance, inputValue, type)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableInput();
        const validationPromise = Promise.resolve().then(()=>asPromise(innerParams.inputValidator(inputValue, innerParams.validationMessage)));
        validationPromise.then((validationMessage)=>{
            instance.enableButtons();
            instance.enableInput();
            if (validationMessage) instance.showValidationMessage(validationMessage);
            else if (type === 'deny') deny(instance, inputValue);
            else confirm(instance, inputValue);
        });
    };
    /**
   * @param {SweetAlert} instance
   * @param {*} value
   */ const deny = (instance, value)=>{
        const innerParams = privateProps.innerParams.get(instance);
        if (innerParams.showLoaderOnDeny) showLoading(getDenyButton());
        if (innerParams.preDeny) {
            instance.isAwaitingPromise = true; // Flagging the instance as awaiting a promise so it's own promise's reject/resolve methods doesn't get destroyed until the result from this preDeny's promise is received
            const preDenyPromise = Promise.resolve().then(()=>asPromise(innerParams.preDeny(value, innerParams.validationMessage)));
            preDenyPromise.then((preDenyValue)=>{
                if (preDenyValue === false) {
                    instance.hideLoading();
                    handleAwaitingPromise(instance);
                } else instance.close(/** @type SweetAlertResult */ {
                    isDenied: true,
                    value: typeof preDenyValue === 'undefined' ? value : preDenyValue
                });
            }).catch((error)=>rejectWith(instance, error));
        } else instance.close(/** @type SweetAlertResult */ {
            isDenied: true,
            value: value
        });
    };
    /**
   * @param {SweetAlert} instance
   * @param {*} value
   */ const succeedWith = (instance, value)=>{
        instance.close(/** @type SweetAlertResult */ {
            isConfirmed: true,
            value: value
        });
    };
    /**
   *
   * @param {SweetAlert} instance
   * @param {string} error
   */ const rejectWith = (instance, error)=>{
        instance.rejectPromise(error);
    };
    /**
   *
   * @param {SweetAlert} instance
   * @param {*} value
   */ const confirm = (instance, value)=>{
        const innerParams = privateProps.innerParams.get(instance);
        if (innerParams.showLoaderOnConfirm) showLoading();
        if (innerParams.preConfirm) {
            instance.resetValidationMessage();
            instance.isAwaitingPromise = true; // Flagging the instance as awaiting a promise so it's own promise's reject/resolve methods doesn't get destroyed until the result from this preConfirm's promise is received
            const preConfirmPromise = Promise.resolve().then(()=>asPromise(innerParams.preConfirm(value, innerParams.validationMessage)));
            preConfirmPromise.then((preConfirmValue)=>{
                if (isVisible$1(getValidationMessage()) || preConfirmValue === false) {
                    instance.hideLoading();
                    handleAwaitingPromise(instance);
                } else succeedWith(instance, typeof preConfirmValue === 'undefined' ? value : preConfirmValue);
            }).catch((error)=>rejectWith(instance, error));
        } else succeedWith(instance, value);
    };
    /**
   * Hides loader and shows back the button which was hidden by .showLoading()
   * @this {SweetAlert}
   */ function hideLoading() {
        // do nothing if popup is closed
        const innerParams = privateProps.innerParams.get(this);
        if (!innerParams) return;
        const domCache = privateProps.domCache.get(this);
        hide(domCache.loader);
        if (isToast()) {
            if (innerParams.icon) show(getIcon());
        } else showRelatedButton(domCache);
        removeClass([
            domCache.popup,
            domCache.actions
        ], swalClasses.loading);
        domCache.popup.removeAttribute('aria-busy');
        domCache.popup.removeAttribute('data-loading');
        this.enableButtons();
    }
    /**
   * @param {DomCache} domCache
   */ const showRelatedButton = (domCache)=>{
        const dataButtonToReplace = domCache.loader.getAttribute('data-button-to-replace');
        const buttonToReplace = dataButtonToReplace ? domCache.popup.getElementsByClassName(dataButtonToReplace) : [];
        if (buttonToReplace.length) show(/** @type {HTMLElement} */ buttonToReplace[0], 'inline-block');
        else if (allButtonsAreHidden()) hide(domCache.actions);
    };
    /**
   * Gets the input DOM node, this method works with input parameter.
   *
   * @returns {HTMLInputElement | null}
   * @this {SweetAlert}
   */ function getInput() {
        const innerParams = privateProps.innerParams.get(this);
        const domCache = privateProps.domCache.get(this);
        if (!domCache) return null;
        return getInput$1(domCache.popup, innerParams.input);
    }
    /**
   * @param {SweetAlert} instance
   * @param {string[]} buttons
   * @param {boolean} disabled
   */ function setButtonsDisabled(instance, buttons, disabled) {
        const domCache = privateProps.domCache.get(instance);
        buttons.forEach((button)=>{
            domCache[button].disabled = disabled;
        });
    }
    /**
   * @param {HTMLInputElement | null} input
   * @param {boolean} disabled
   */ function setInputDisabled(input, disabled) {
        const popup = getPopup();
        if (!popup || !input) return;
        if (input.type === 'radio') {
            /** @type {NodeListOf<HTMLInputElement>} */ const radios = popup.querySelectorAll(`[name="${swalClasses.radio}"]`);
            radios.forEach((radio)=>{
                radio.disabled = disabled;
            });
        } else input.disabled = disabled;
    }
    /**
   * Enable all the buttons
   * @this {SweetAlert}
   */ function enableButtons() {
        setButtonsDisabled(this, [
            'confirmButton',
            'denyButton',
            'cancelButton'
        ], false);
        const focusedElement = privateProps.focusedElement.get(this);
        if (focusedElement instanceof HTMLElement && document.activeElement === document.body) focusedElement.focus();
        privateProps.focusedElement.delete(this);
    }
    /**
   * Disable all the buttons
   * @this {SweetAlert}
   */ function disableButtons() {
        privateProps.focusedElement.set(this, document.activeElement);
        setButtonsDisabled(this, [
            'confirmButton',
            'denyButton',
            'cancelButton'
        ], true);
    }
    /**
   * Enable the input field
   * @this {SweetAlert}
   */ function enableInput() {
        setInputDisabled(this.getInput(), false);
    }
    /**
   * Disable the input field
   * @this {SweetAlert}
   */ function disableInput() {
        setInputDisabled(this.getInput(), true);
    }
    /**
   * Show block with validation message
   *
   * @param {string} error
   * @this {SweetAlert}
   */ function showValidationMessage(error) {
        const domCache = privateProps.domCache.get(this);
        const params = privateProps.innerParams.get(this);
        setInnerHtml(domCache.validationMessage, error);
        domCache.validationMessage.className = swalClasses['validation-message'];
        if (params.customClass && params.customClass.validationMessage) addClass(domCache.validationMessage, params.customClass.validationMessage);
        show(domCache.validationMessage);
        const input = this.getInput();
        if (input) {
            input.setAttribute('aria-invalid', 'true');
            input.setAttribute('aria-describedby', swalClasses['validation-message']);
            focusInput(input);
            addClass(input, swalClasses.inputerror);
        }
    }
    /**
   * Hide block with validation message
   *
   * @this {SweetAlert}
   */ function resetValidationMessage() {
        const domCache = privateProps.domCache.get(this);
        if (domCache.validationMessage) hide(domCache.validationMessage);
        const input = this.getInput();
        if (input) {
            input.removeAttribute('aria-invalid');
            input.removeAttribute('aria-describedby');
            removeClass(input, swalClasses.inputerror);
        }
    }
    const defaultParams = {
        title: '',
        titleText: '',
        text: '',
        html: '',
        footer: '',
        icon: undefined,
        iconColor: undefined,
        iconHtml: undefined,
        template: undefined,
        toast: false,
        draggable: false,
        animation: true,
        theme: 'light',
        showClass: {
            popup: 'swal2-show',
            backdrop: 'swal2-backdrop-show',
            icon: 'swal2-icon-show'
        },
        hideClass: {
            popup: 'swal2-hide',
            backdrop: 'swal2-backdrop-hide',
            icon: 'swal2-icon-hide'
        },
        customClass: {},
        target: 'body',
        color: undefined,
        backdrop: true,
        heightAuto: true,
        allowOutsideClick: true,
        allowEscapeKey: true,
        allowEnterKey: true,
        stopKeydownPropagation: true,
        keydownListenerCapture: false,
        showConfirmButton: true,
        showDenyButton: false,
        showCancelButton: false,
        preConfirm: undefined,
        preDeny: undefined,
        confirmButtonText: 'OK',
        confirmButtonAriaLabel: '',
        confirmButtonColor: undefined,
        denyButtonText: 'No',
        denyButtonAriaLabel: '',
        denyButtonColor: undefined,
        cancelButtonText: 'Cancel',
        cancelButtonAriaLabel: '',
        cancelButtonColor: undefined,
        buttonsStyling: true,
        reverseButtons: false,
        focusConfirm: true,
        focusDeny: false,
        focusCancel: false,
        returnFocus: true,
        showCloseButton: false,
        closeButtonHtml: '&times;',
        closeButtonAriaLabel: 'Close this dialog',
        loaderHtml: '',
        showLoaderOnConfirm: false,
        showLoaderOnDeny: false,
        imageUrl: undefined,
        imageWidth: undefined,
        imageHeight: undefined,
        imageAlt: '',
        timer: undefined,
        timerProgressBar: false,
        width: undefined,
        padding: undefined,
        background: undefined,
        input: undefined,
        inputPlaceholder: '',
        inputLabel: '',
        inputValue: '',
        inputOptions: {},
        inputAutoFocus: true,
        inputAutoTrim: true,
        inputAttributes: {},
        inputValidator: undefined,
        returnInputValueOnDeny: false,
        validationMessage: undefined,
        grow: false,
        position: 'center',
        progressSteps: [],
        currentProgressStep: undefined,
        progressStepsDistance: undefined,
        willOpen: undefined,
        didOpen: undefined,
        didRender: undefined,
        willClose: undefined,
        didClose: undefined,
        didDestroy: undefined,
        scrollbarPadding: true,
        topLayer: false
    };
    const updatableParams = [
        'allowEscapeKey',
        'allowOutsideClick',
        'background',
        'buttonsStyling',
        'cancelButtonAriaLabel',
        'cancelButtonColor',
        'cancelButtonText',
        'closeButtonAriaLabel',
        'closeButtonHtml',
        'color',
        'confirmButtonAriaLabel',
        'confirmButtonColor',
        'confirmButtonText',
        'currentProgressStep',
        'customClass',
        'denyButtonAriaLabel',
        'denyButtonColor',
        'denyButtonText',
        'didClose',
        'didDestroy',
        'draggable',
        'footer',
        'hideClass',
        'html',
        'icon',
        'iconColor',
        'iconHtml',
        'imageAlt',
        'imageHeight',
        'imageUrl',
        'imageWidth',
        'preConfirm',
        'preDeny',
        'progressSteps',
        'returnFocus',
        'reverseButtons',
        'showCancelButton',
        'showCloseButton',
        'showConfirmButton',
        'showDenyButton',
        'text',
        'title',
        'titleText',
        'theme',
        'willClose'
    ];
    /** @type {Record<string, string | undefined>} */ const deprecatedParams = {
        allowEnterKey: undefined
    };
    const toastIncompatibleParams = [
        'allowOutsideClick',
        'allowEnterKey',
        'backdrop',
        'draggable',
        'focusConfirm',
        'focusDeny',
        'focusCancel',
        'returnFocus',
        'heightAuto',
        'keydownListenerCapture'
    ];
    /**
   * Is valid parameter
   *
   * @param {string} paramName
   * @returns {boolean}
   */ const isValidParameter = (paramName)=>{
        return Object.prototype.hasOwnProperty.call(defaultParams, paramName);
    };
    /**
   * Is valid parameter for Swal.update() method
   *
   * @param {string} paramName
   * @returns {boolean}
   */ const isUpdatableParameter = (paramName)=>{
        return updatableParams.indexOf(paramName) !== -1;
    };
    /**
   * Is deprecated parameter
   *
   * @param {string} paramName
   * @returns {string | undefined}
   */ const isDeprecatedParameter = (paramName)=>{
        return deprecatedParams[paramName];
    };
    /**
   * @param {string} param
   */ const checkIfParamIsValid = (param)=>{
        if (!isValidParameter(param)) warn(`Unknown parameter "${param}"`);
    };
    /**
   * @param {string} param
   */ const checkIfToastParamIsValid = (param)=>{
        if (toastIncompatibleParams.includes(param)) warn(`The parameter "${param}" is incompatible with toasts`);
    };
    /**
   * @param {string} param
   */ const checkIfParamIsDeprecated = (param)=>{
        const isDeprecated = isDeprecatedParameter(param);
        if (isDeprecated) warnAboutDeprecation(param, isDeprecated);
    };
    /**
   * Show relevant warnings for given params
   *
   * @param {SweetAlertOptions} params
   */ const showWarningsForParams = (params)=>{
        if (params.backdrop === false && params.allowOutsideClick) warn('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
        if (params.theme && ![
            'light',
            'dark',
            'auto',
            'minimal',
            'borderless',
            'bootstrap-4',
            'bootstrap-4-light',
            'bootstrap-4-dark',
            'bootstrap-5',
            'bootstrap-5-light',
            'bootstrap-5-dark',
            'material-ui',
            'material-ui-light',
            'material-ui-dark',
            'embed-iframe',
            'bulma',
            'bulma-light',
            'bulma-dark'
        ].includes(params.theme)) warn(`Invalid theme "${params.theme}"`);
        for(const param in params){
            checkIfParamIsValid(param);
            if (params.toast) checkIfToastParamIsValid(param);
            checkIfParamIsDeprecated(param);
        }
    };
    /**
   * Updates popup parameters.
   *
   * @this {any}
   * @param {SweetAlertOptions} params
   */ function update(params) {
        const container = getContainer();
        const popup = getPopup();
        const innerParams = privateProps.innerParams.get(this);
        if (!popup || hasClass(popup, innerParams.hideClass.popup)) {
            warn(`You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.`);
            return;
        }
        const validUpdatableParams = filterValidParams(params);
        const updatedParams = Object.assign({}, innerParams, validUpdatableParams);
        showWarningsForParams(updatedParams);
        if (container) container.dataset['swal2Theme'] = updatedParams.theme;
        render(this, updatedParams);
        privateProps.innerParams.set(this, updatedParams);
        Object.defineProperties(this, {
            params: {
                value: Object.assign({}, this.params, params),
                writable: false,
                enumerable: true
            }
        });
    }
    /**
   * @param {SweetAlertOptions} params
   * @returns {SweetAlertOptions}
   */ const filterValidParams = (params)=>{
        /** @type {Record<string, any>} */ const validUpdatableParams = {};
        Object.keys(params).forEach((param)=>{
            if (isUpdatableParameter(param)) {
                const typedParams = /** @type {Record<string, any>} */ params;
                validUpdatableParams[param] = typedParams[param];
            } else warn(`Invalid parameter to update: ${param}`);
        });
        return validUpdatableParams;
    };
    /**
   * Dispose the current SweetAlert2 instance
   * @this {SweetAlert}
   */ function _destroy() {
        var _globalState$eventEmi;
        const domCache = privateProps.domCache.get(this);
        const innerParams = privateProps.innerParams.get(this);
        if (!innerParams) {
            disposeWeakMaps(this); // The WeakMaps might have been partly destroyed, we must recall it to dispose any remaining WeakMaps #2335
            return; // This instance has already been destroyed
        }
        // Check if there is another Swal closing
        if (domCache.popup && globalState.swalCloseEventFinishedCallback) {
            globalState.swalCloseEventFinishedCallback();
            delete globalState.swalCloseEventFinishedCallback;
        }
        if (typeof innerParams.didDestroy === 'function') innerParams.didDestroy();
        (_globalState$eventEmi = globalState.eventEmitter) === null || _globalState$eventEmi === void 0 || _globalState$eventEmi.emit('didDestroy');
        disposeSwal(this);
    }
    /**
   * @param {SweetAlert} instance
   */ const disposeSwal = (instance)=>{
        disposeWeakMaps(instance);
        // Unset this.params so GC will dispose it (#1569)
        // @ts-ignore
        delete instance.params;
        // Unset globalState props so GC will dispose globalState (#1569)
        delete globalState.keydownHandler;
        delete globalState.keydownTarget;
        // Unset currentInstance
        delete globalState.currentInstance;
    };
    /**
   * @param {SweetAlert} instance
   */ const disposeWeakMaps = (instance)=>{
        // If the current instance is awaiting a promise result, we keep the privateMethods to call them once the promise result is retrieved #2335
        if (instance.isAwaitingPromise) {
            unsetWeakMaps(privateProps, instance);
            instance.isAwaitingPromise = true;
        } else {
            unsetWeakMaps(privateMethods, instance);
            unsetWeakMaps(privateProps, instance);
            // @ts-ignore
            delete instance.isAwaitingPromise;
            // Unset instance methods
            // @ts-ignore
            delete instance.disableButtons;
            // @ts-ignore
            delete instance.enableButtons;
            // @ts-ignore
            delete instance.getInput;
            // @ts-ignore
            delete instance.disableInput;
            // @ts-ignore
            delete instance.enableInput;
            // @ts-ignore
            delete instance.hideLoading;
            // @ts-ignore
            delete instance.disableLoading;
            // @ts-ignore
            delete instance.showValidationMessage;
            // @ts-ignore
            delete instance.resetValidationMessage;
            // @ts-ignore
            delete instance.close;
            // @ts-ignore
            delete instance.closePopup;
            // @ts-ignore
            delete instance.closeModal;
            // @ts-ignore
            delete instance.closeToast;
            // @ts-ignore
            delete instance.rejectPromise;
            // @ts-ignore
            delete instance.update;
            // @ts-ignore
            delete instance._destroy;
        }
    };
    /**
   * @param {Record<string, WeakMap<any, any>>} obj
   * @param {SweetAlert} instance
   */ const unsetWeakMaps = (obj, instance)=>{
        for(const i in obj)obj[i].delete(instance);
    };
    var instanceMethods = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        _destroy: _destroy,
        close: close,
        closeModal: close,
        closePopup: close,
        closeToast: close,
        disableButtons: disableButtons,
        disableInput: disableInput,
        disableLoading: hideLoading,
        enableButtons: enableButtons,
        enableInput: enableInput,
        getInput: getInput,
        handleAwaitingPromise: handleAwaitingPromise,
        hideLoading: hideLoading,
        rejectPromise: rejectPromise,
        resetValidationMessage: resetValidationMessage,
        showValidationMessage: showValidationMessage,
        update: update
    });
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {(dismiss: DismissReason) => void} dismissWith
   */ const handlePopupClick = (innerParams, domCache, dismissWith)=>{
        if (innerParams.toast) handleToastClick(innerParams, domCache, dismissWith);
        else {
            // Ignore click events that had mousedown on the popup but mouseup on the container
            // This can happen when the user drags a slider
            handleModalMousedown(domCache);
            // Ignore click events that had mousedown on the container but mouseup on the popup
            handleContainerMousedown(domCache);
            handleModalClick(innerParams, domCache, dismissWith);
        }
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {(dismiss: DismissReason) => void} dismissWith
   */ const handleToastClick = (innerParams, domCache, dismissWith)=>{
        // Closing toast by internal click
        domCache.popup.onclick = ()=>{
            if (innerParams && (isAnyButtonShown(innerParams) || innerParams.timer || innerParams.input)) return;
            dismissWith(DismissReason.close);
        };
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @returns {boolean}
   */ const isAnyButtonShown = (innerParams)=>{
        return Boolean(innerParams.showConfirmButton || innerParams.showDenyButton || innerParams.showCancelButton || innerParams.showCloseButton);
    };
    let ignoreOutsideClick = false;
    /**
   * @param {DomCache} domCache
   */ const handleModalMousedown = (domCache)=>{
        domCache.popup.onmousedown = ()=>{
            domCache.container.onmouseup = function(e) {
                domCache.container.onmouseup = ()=>{};
                // We only check if the mouseup target is the container because usually it doesn't
                // have any other direct children aside of the popup
                if (e.target === domCache.container) ignoreOutsideClick = true;
            };
        };
    };
    /**
   * @param {DomCache} domCache
   */ const handleContainerMousedown = (domCache)=>{
        domCache.container.onmousedown = (e)=>{
            // prevent the modal text from being selected on double click on the container (allowOutsideClick: false)
            if (e.target === domCache.container) e.preventDefault();
            domCache.popup.onmouseup = function(e) {
                domCache.popup.onmouseup = ()=>{};
                // We also need to check if the mouseup target is a child of the popup
                if (e.target === domCache.popup || e.target instanceof HTMLElement && domCache.popup.contains(e.target)) ignoreOutsideClick = true;
            };
        };
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {(dismiss: DismissReason) => void} dismissWith
   */ const handleModalClick = (innerParams, domCache, dismissWith)=>{
        domCache.container.onclick = (e)=>{
            if (ignoreOutsideClick) {
                ignoreOutsideClick = false;
                return;
            }
            if (e.target === domCache.container && callIfFunction(innerParams.allowOutsideClick)) dismissWith(DismissReason.backdrop);
        };
    };
    /**
   * @param {unknown} elem
   * @returns {boolean}
   */ const isJqueryElement = (elem)=>typeof elem === 'object' && elem !== null && 'jquery' in elem;
    /**
   * @param {unknown} elem
   * @returns {boolean}
   */ const isElement = (elem)=>elem instanceof Element || isJqueryElement(elem);
    /**
   * @param {ReadonlyArray<unknown>} args
   * @returns {SweetAlertOptions}
   */ const argsToParams = (args)=>{
        /** @type {Record<string, unknown>} */ const params = {};
        if (typeof args[0] === 'object' && !isElement(args[0])) Object.assign(params, args[0]);
        else [
            'title',
            'html',
            'icon'
        ].forEach((name, index)=>{
            const arg = args[index];
            if (typeof arg === 'string' || isElement(arg)) params[name] = arg;
            else if (arg !== undefined) error(`Unexpected type of ${name}! Expected "string" or "Element", got ${typeof arg}`);
        });
        return /** @type {SweetAlertOptions} */ params;
    };
    /**
   * Main method to create a new SweetAlert2 popup
   *
   * @this {new (...args: any[]) => any}
   * @param  {...SweetAlertOptions} args
   * @returns {Promise<SweetAlertResult>}
   */ function fire(...args) {
        return new this(...args);
    }
    /**
   * Returns an extended version of `Swal` containing `params` as defaults.
   * Useful for reusing Swal configuration.
   *
   * For example:
   *
   * Before:
   * const textPromptOptions = { input: 'text', showCancelButton: true }
   * const {value: firstName} = await Swal.fire({ ...textPromptOptions, title: 'What is your first name?' })
   * const {value: lastName} = await Swal.fire({ ...textPromptOptions, title: 'What is your last name?' })
   *
   * After:
   * const TextPrompt = Swal.mixin({ input: 'text', showCancelButton: true })
   * const {value: firstName} = await TextPrompt('What is your first name?')
   * const {value: lastName} = await TextPrompt('What is your last name?')
   *
   * @param {SweetAlertOptions} mixinParams
   * @returns {SweetAlert}
   * @this {typeof import('../SweetAlert.js').SweetAlert}
   */ function mixin(mixinParams) {
        // @ts-ignore: 'this' refers to the SweetAlert constructor
        class MixinSwal extends this {
            /**
       * @param {any} params
       * @param {any} priorityMixinParams
       */ _main(params, priorityMixinParams) {
                return super._main(params, Object.assign({}, mixinParams, priorityMixinParams));
            }
        }
        // @ts-ignore
        return MixinSwal;
    }
    /**
   * If `timer` parameter is set, returns number of milliseconds of timer remained.
   * Otherwise, returns undefined.
   *
   * @returns {number | undefined}
   */ const getTimerLeft = ()=>{
        return globalState.timeout && globalState.timeout.getTimerLeft();
    };
    /**
   * Stop timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const stopTimer = ()=>{
        if (globalState.timeout) {
            stopTimerProgressBar();
            return globalState.timeout.stop();
        }
    };
    /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const resumeTimer = ()=>{
        if (globalState.timeout) {
            const remaining = globalState.timeout.start();
            animateTimerProgressBar(remaining);
            return remaining;
        }
    };
    /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const toggleTimer = ()=>{
        const timer = globalState.timeout;
        return timer && (timer.running ? stopTimer() : resumeTimer());
    };
    /**
   * Increase timer. Returns number of milliseconds of an updated timer.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @param {number} ms
   * @returns {number | undefined}
   */ const increaseTimer = (ms)=>{
        if (globalState.timeout) {
            const remaining = globalState.timeout.increase(ms);
            animateTimerProgressBar(remaining, true);
            return remaining;
        }
    };
    /**
   * Check if timer is running. Returns true if timer is running
   * or false if timer is paused or stopped.
   * If `timer` parameter isn't set, returns undefined
   *
   * @returns {boolean}
   */ const isTimerRunning = ()=>{
        return Boolean(globalState.timeout && globalState.timeout.isRunning());
    };
    let bodyClickListenerAdded = false;
    /** @type {Record<string, any>} */ const clickHandlers = {};
    /**
   * @this {any}
   * @param {string} attr
   */ function bindClickHandler(attr = 'data-swal-template') {
        clickHandlers[attr] = this;
        if (!bodyClickListenerAdded) {
            document.body.addEventListener('click', bodyClickListener);
            bodyClickListenerAdded = true;
        }
    }
    /**
   * @param {MouseEvent} event
   */ const bodyClickListener = (event)=>{
        for(let el = /** @type {any} */ event.target; el && el !== document; el = el.parentNode)for(const attr in clickHandlers){
            const template = el.getAttribute && el.getAttribute(attr);
            if (template) {
                clickHandlers[attr].fire({
                    template: template
                });
                return;
            }
        }
    };
    // Source: https://gist.github.com/mudge/5830382?permalink_comment_id=2691957#gistcomment-2691957
    class EventEmitter {
        constructor(){
            /** @type {Events} */ this.events = {};
        }
        /**
     * @param {string} eventName
     * @returns {EventHandlers}
     */ _getHandlersByEventName(eventName) {
            if (typeof this.events[eventName] === 'undefined') // not Set because we need to keep the FIFO order
            // https://github.com/sweetalert2/sweetalert2/pull/2763#discussion_r1748990334
            this.events[eventName] = [];
            return this.events[eventName];
        }
        /**
     * @param {string} eventName
     * @param {EventHandler} eventHandler
     */ on(eventName, eventHandler) {
            const currentHandlers = this._getHandlersByEventName(eventName);
            if (!currentHandlers.includes(eventHandler)) currentHandlers.push(eventHandler);
        }
        /**
     * @param {string} eventName
     * @param {EventHandler} eventHandler
     */ once(eventName, eventHandler) {
            /**
       * @param {...any} args
       */ const onceFn = (...args)=>{
                this.removeListener(eventName, onceFn);
                // @ts-ignore
                eventHandler.apply(this, args);
            };
            this.on(eventName, onceFn);
        }
        /**
     * @param {string} eventName
     * @param {...any} args
     */ emit(eventName, ...args) {
            this._getHandlersByEventName(eventName).forEach(/**
       * @param {EventHandler} eventHandler
       */ (eventHandler)=>{
                try {
                    // @ts-ignore
                    eventHandler.apply(this, args);
                } catch (error) {
                    console.error(error);
                }
            });
        }
        /**
     * @param {string} eventName
     * @param {EventHandler} eventHandler
     */ removeListener(eventName, eventHandler) {
            const currentHandlers = this._getHandlersByEventName(eventName);
            const index = currentHandlers.indexOf(eventHandler);
            if (index > -1) currentHandlers.splice(index, 1);
        }
        /**
     * @param {string} eventName
     */ removeAllListeners(eventName) {
            if (this.events[eventName] !== undefined) // https://github.com/sweetalert2/sweetalert2/pull/2763#discussion_r1749239222
            this.events[eventName].length = 0;
        }
        reset() {
            this.events = {};
        }
    }
    globalState.eventEmitter = new EventEmitter();
    /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */ const on = (eventName, eventHandler)=>{
        if (globalState.eventEmitter) globalState.eventEmitter.on(eventName, eventHandler);
    };
    /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */ const once = (eventName, eventHandler)=>{
        if (globalState.eventEmitter) globalState.eventEmitter.once(eventName, eventHandler);
    };
    /**
   * @param {string} [eventName]
   * @param {EventHandler} [eventHandler]
   */ const off = (eventName, eventHandler)=>{
        if (!globalState.eventEmitter) return;
        // Remove all handlers for all events
        if (!eventName) {
            globalState.eventEmitter.reset();
            return;
        }
        if (eventHandler) // Remove a specific handler
        globalState.eventEmitter.removeListener(eventName, eventHandler);
        else // Remove all handlers for a specific event
        globalState.eventEmitter.removeAllListeners(eventName);
    };
    var staticMethods = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        argsToParams: argsToParams,
        bindClickHandler: bindClickHandler,
        clickCancel: clickCancel,
        clickConfirm: clickConfirm,
        clickDeny: clickDeny,
        enableLoading: showLoading,
        fire: fire,
        getActions: getActions,
        getCancelButton: getCancelButton,
        getCloseButton: getCloseButton,
        getConfirmButton: getConfirmButton,
        getContainer: getContainer,
        getDenyButton: getDenyButton,
        getFocusableElements: getFocusableElements,
        getFooter: getFooter,
        getHtmlContainer: getHtmlContainer,
        getIcon: getIcon,
        getIconContent: getIconContent,
        getImage: getImage,
        getInputLabel: getInputLabel,
        getLoader: getLoader,
        getPopup: getPopup,
        getProgressSteps: getProgressSteps,
        getTimerLeft: getTimerLeft,
        getTimerProgressBar: getTimerProgressBar,
        getTitle: getTitle,
        getValidationMessage: getValidationMessage,
        increaseTimer: increaseTimer,
        isDeprecatedParameter: isDeprecatedParameter,
        isLoading: isLoading,
        isTimerRunning: isTimerRunning,
        isUpdatableParameter: isUpdatableParameter,
        isValidParameter: isValidParameter,
        isVisible: isVisible,
        mixin: mixin,
        off: off,
        on: on,
        once: once,
        resumeTimer: resumeTimer,
        showLoading: showLoading,
        stopTimer: stopTimer,
        toggleTimer: toggleTimer
    });
    class Timer {
        /**
     * @param {() => void} callback
     * @param {number} delay
     */ constructor(callback, delay){
            this.callback = callback;
            this.remaining = delay;
            this.running = false;
            this.start();
        }
        /**
     * @returns {number}
     */ start() {
            if (!this.running) {
                this.running = true;
                this.started = new Date();
                this.id = setTimeout(this.callback, this.remaining);
            }
            return this.remaining;
        }
        /**
     * @returns {number}
     */ stop() {
            if (this.started && this.running) {
                this.running = false;
                clearTimeout(this.id);
                this.remaining -= new Date().getTime() - this.started.getTime();
            }
            return this.remaining;
        }
        /**
     * @param {number} n
     * @returns {number}
     */ increase(n) {
            const running = this.running;
            if (running) this.stop();
            this.remaining += n;
            if (running) this.start();
            return this.remaining;
        }
        /**
     * @returns {number}
     */ getTimerLeft() {
            if (this.running) {
                this.stop();
                this.start();
            }
            return this.remaining;
        }
        /**
     * @returns {boolean}
     */ isRunning() {
            return this.running;
        }
    }
    const swalStringParams = [
        'swal-title',
        'swal-html',
        'swal-footer'
    ];
    /**
   * @param {SweetAlertOptions} params
   * @returns {SweetAlertOptions}
   */ const getTemplateParams = (params)=>{
        const template = typeof params.template === 'string' ? /** @type {HTMLTemplateElement} */ document.querySelector(params.template) : params.template;
        if (!template) return {};
        /** @type {DocumentFragment} */ const templateContent = template.content;
        showWarningsForElements(templateContent);
        const result = Object.assign(getSwalParams(templateContent), getSwalFunctionParams(templateContent), getSwalButtons(templateContent), getSwalImage(templateContent), getSwalIcon(templateContent), getSwalInput(templateContent), getSwalStringParams(templateContent, swalStringParams));
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, string | boolean | number>}
   */ const getSwalParams = (templateContent)=>{
        /** @type {Record<string, string | boolean | number>} */ const result = {};
        /** @type {HTMLElement[]} */ const swalParams = Array.from(templateContent.querySelectorAll('swal-param'));
        swalParams.forEach((param)=>{
            showWarningsForAttributes(param, [
                'name',
                'value'
            ]);
            const paramName = /** @type {keyof SweetAlertOptions} */ param.getAttribute('name');
            const value = param.getAttribute('value');
            if (!paramName || !value) return;
            if (paramName in defaultParams && typeof defaultParams[/** @type {keyof typeof defaultParams} */ paramName] === 'boolean') result[paramName] = value !== 'false';
            else if (paramName in defaultParams && typeof defaultParams[/** @type {keyof typeof defaultParams} */ paramName] === 'object') result[paramName] = JSON.parse(value);
            else result[paramName] = value;
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, () => void>}
   */ const getSwalFunctionParams = (templateContent)=>{
        /** @type {Record<string, () => void>} */ const result = {};
        /** @type {HTMLElement[]} */ const swalFunctions = Array.from(templateContent.querySelectorAll('swal-function-param'));
        swalFunctions.forEach((param)=>{
            const paramName = /** @type {keyof SweetAlertOptions} */ param.getAttribute('name');
            const value = param.getAttribute('value');
            if (!paramName || !value) return;
            result[paramName] = new Function(`return ${value}`)();
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, string | boolean>}
   */ const getSwalButtons = (templateContent)=>{
        /** @type {Record<string, string | boolean>} */ const result = {};
        /** @type {HTMLElement[]} */ const swalButtons = Array.from(templateContent.querySelectorAll('swal-button'));
        swalButtons.forEach((button)=>{
            showWarningsForAttributes(button, [
                'type',
                'color',
                'aria-label'
            ]);
            const type = button.getAttribute('type');
            if (!type || ![
                'confirm',
                'cancel',
                'deny'
            ].includes(type)) return;
            result[`${type}ButtonText`] = button.innerHTML;
            result[`show${capitalizeFirstLetter(type)}Button`] = true;
            const color = button.getAttribute('color');
            if (color !== null) result[`${type}ButtonColor`] = color;
            const ariaLabel = button.getAttribute('aria-label');
            if (ariaLabel !== null) result[`${type}ButtonAriaLabel`] = ariaLabel;
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Pick<SweetAlertOptions, 'imageUrl' | 'imageWidth' | 'imageHeight' | 'imageAlt'>}
   */ const getSwalImage = (templateContent)=>{
        const result = {};
        /** @type {HTMLElement | null} */ const image = templateContent.querySelector('swal-image');
        if (image) {
            showWarningsForAttributes(image, [
                'src',
                'width',
                'height',
                'alt'
            ]);
            // getAttribute returns null if attribute is absent; `|| undefined` converts empty string to undefined
            const src = image.getAttribute('src');
            if (src !== null) result.imageUrl = src || undefined;
            const width = image.getAttribute('width');
            if (width !== null) result.imageWidth = width || undefined;
            const height = image.getAttribute('height');
            if (height !== null) result.imageHeight = height || undefined;
            const alt = image.getAttribute('alt');
            if (alt !== null) result.imageAlt = alt || undefined;
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {object}
   */ const getSwalIcon = (templateContent)=>{
        const result = {};
        /** @type {HTMLElement | null} */ const icon = templateContent.querySelector('swal-icon');
        if (icon) {
            showWarningsForAttributes(icon, [
                'type',
                'color'
            ]);
            if (icon.hasAttribute('type')) result.icon = icon.getAttribute('type');
            if (icon.hasAttribute('color')) result.iconColor = icon.getAttribute('color');
            result.iconHtml = icon.innerHTML;
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {object}
   */ const getSwalInput = (templateContent)=>{
        /** @type {Record<string, any>} */ const result = {};
        /** @type {HTMLElement | null} */ const input = templateContent.querySelector('swal-input');
        if (input) {
            showWarningsForAttributes(input, [
                'type',
                'label',
                'placeholder',
                'value'
            ]);
            result.input = input.getAttribute('type') || 'text';
            if (input.hasAttribute('label')) result.inputLabel = input.getAttribute('label');
            if (input.hasAttribute('placeholder')) result.inputPlaceholder = input.getAttribute('placeholder');
            if (input.hasAttribute('value')) result.inputValue = input.getAttribute('value');
        }
        /** @type {HTMLElement[]} */ const inputOptions = Array.from(templateContent.querySelectorAll('swal-input-option'));
        if (inputOptions.length) {
            result.inputOptions = {};
            inputOptions.forEach((option)=>{
                showWarningsForAttributes(option, [
                    'value'
                ]);
                const optionValue = option.getAttribute('value');
                if (!optionValue) return;
                const optionName = option.innerHTML;
                result.inputOptions[optionValue] = optionName;
            });
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @param {string[]} paramNames
   * @returns {Record<string, string>}
   */ const getSwalStringParams = (templateContent, paramNames)=>{
        /** @type {Record<string, string>} */ const result = {};
        for(const i in paramNames){
            const paramName = paramNames[i];
            /** @type {HTMLElement | null} */ const tag = templateContent.querySelector(paramName);
            if (tag) {
                showWarningsForAttributes(tag, []);
                result[paramName.replace(/^swal-/, '')] = tag.innerHTML.trim();
            }
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   */ const showWarningsForElements = (templateContent)=>{
        const allowedElements = swalStringParams.concat([
            'swal-param',
            'swal-function-param',
            'swal-button',
            'swal-image',
            'swal-icon',
            'swal-input',
            'swal-input-option'
        ]);
        Array.from(templateContent.children).forEach((el)=>{
            const tagName = el.tagName.toLowerCase();
            if (!allowedElements.includes(tagName)) warn(`Unrecognized element <${tagName}>`);
        });
    };
    /**
   * @param {HTMLElement} el
   * @param {string[]} allowedAttributes
   */ const showWarningsForAttributes = (el, allowedAttributes)=>{
        Array.from(el.attributes).forEach((attribute)=>{
            if (allowedAttributes.indexOf(attribute.name) === -1) warn([
                `Unrecognized attribute "${attribute.name}" on <${el.tagName.toLowerCase()}>.`,
                `${allowedAttributes.length ? `Allowed attributes are: ${allowedAttributes.join(', ')}` : 'To set the value, use HTML within the element.'}`
            ]);
        });
    };
    const SHOW_CLASS_TIMEOUT = 10;
    /**
   * Open popup, add necessary classes and styles, fix scrollbar
   *
   * @param {SweetAlertOptions} params
   */ const openPopup = (params)=>{
        var _globalState$eventEmi, _globalState$eventEmi2;
        const container = getContainer();
        const popup = getPopup();
        if (!container || !popup) return;
        if (typeof params.willOpen === 'function') params.willOpen(popup);
        (_globalState$eventEmi = globalState.eventEmitter) === null || _globalState$eventEmi === void 0 || _globalState$eventEmi.emit('willOpen', popup);
        const bodyStyles = window.getComputedStyle(document.body);
        const initialBodyOverflow = bodyStyles.overflowY;
        addClasses(container, popup, params);
        // scrolling is 'hidden' until animation is done, after that 'auto'
        setTimeout(()=>{
            setScrollingVisibility(container, popup);
        }, SHOW_CLASS_TIMEOUT);
        if (isModal()) {
            fixScrollContainer(container, params.scrollbarPadding !== undefined ? params.scrollbarPadding : false, initialBodyOverflow);
            setAriaHidden();
        }
        // https://github.com/sweetalert2/sweetalert2/issues/2923
        if (isIOS && params.backdrop === false && popup.scrollHeight > container.clientHeight) // remove pointer-events: none from container, it breaks scrolling tall popups in iOS
        container.style.pointerEvents = 'auto';
        if (!isToast() && !globalState.previousActiveElement) globalState.previousActiveElement = document.activeElement;
        if (typeof params.didOpen === 'function') {
            const didOpen = params.didOpen;
            setTimeout(()=>didOpen(popup));
        }
        (_globalState$eventEmi2 = globalState.eventEmitter) === null || _globalState$eventEmi2 === void 0 || _globalState$eventEmi2.emit('didOpen', popup);
    };
    /**
   * @param {Event} event
   */ const swalOpenAnimationFinished = (event)=>{
        const popup = getPopup();
        if (!popup || event.target !== popup) return;
        const container = getContainer();
        if (!container) return;
        popup.removeEventListener('animationend', swalOpenAnimationFinished);
        popup.removeEventListener('transitionend', swalOpenAnimationFinished);
        container.style.overflowY = 'auto';
        // no-transition is added in init() in case one swal is opened right after another
        removeClass(container, swalClasses['no-transition']);
    };
    /**
   * @param {HTMLElement} container
   * @param {HTMLElement} popup
   */ const setScrollingVisibility = (container, popup)=>{
        if (hasCssAnimation(popup)) {
            container.style.overflowY = 'hidden';
            popup.addEventListener('animationend', swalOpenAnimationFinished);
            popup.addEventListener('transitionend', swalOpenAnimationFinished);
        } else container.style.overflowY = 'auto';
    };
    /**
   * @param {HTMLElement} container
   * @param {boolean} scrollbarPadding
   * @param {string} initialBodyOverflow
   */ const fixScrollContainer = (container, scrollbarPadding, initialBodyOverflow)=>{
        iOSfix();
        if (scrollbarPadding && initialBodyOverflow !== 'hidden') replaceScrollbarWithPadding(initialBodyOverflow);
        // sweetalert2/issues/1247
        setTimeout(()=>{
            container.scrollTop = 0;
        });
    };
    /**
   * @param {HTMLElement} container
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} params
   */ const addClasses = (container, popup, params)=>{
        var _params$showClass;
        if ((_params$showClass = params.showClass) !== null && _params$showClass !== void 0 && _params$showClass.backdrop) addClass(container, params.showClass.backdrop);
        if (params.animation) {
            // this workaround with opacity is needed for https://github.com/sweetalert2/sweetalert2/issues/2059
            popup.style.setProperty('opacity', '0', 'important');
            show(popup, 'grid');
            setTimeout(()=>{
                var _params$showClass2;
                // Animate popup right after showing it
                if ((_params$showClass2 = params.showClass) !== null && _params$showClass2 !== void 0 && _params$showClass2.popup) addClass(popup, params.showClass.popup);
                // and remove the opacity workaround
                popup.style.removeProperty('opacity');
            }, SHOW_CLASS_TIMEOUT); // 10ms in order to fix #2062
        } else show(popup, 'grid');
        addClass([
            document.documentElement,
            document.body
        ], swalClasses.shown);
        if (params.heightAuto && params.backdrop && !params.toast) addClass([
            document.documentElement,
            document.body
        ], swalClasses['height-auto']);
    };
    var defaultInputValidators = {
        /**
     * @param {string} string
     * @param {string} [validationMessage]
     * @returns {Promise<string | void>}
     */ email: (string, validationMessage)=>{
            return /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid email address');
        },
        /**
     * @param {string} string
     * @param {string} [validationMessage]
     * @returns {Promise<string | void>}
     */ url: (string, validationMessage)=>{
            // taken from https://stackoverflow.com/a/3809435 with a small change from #1306 and #2013
            return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid URL');
        }
    };
    /**
   * @param {SweetAlertOptions} params
   */ function setDefaultInputValidators(params) {
        // Use default `inputValidator` for supported input types if not provided
        if (params.inputValidator) return;
        if (params.input === 'email') params.inputValidator = defaultInputValidators['email'];
        if (params.input === 'url') params.inputValidator = defaultInputValidators['url'];
    }
    /**
   * @param {SweetAlertOptions} params
   */ function validateCustomTargetElement(params) {
        // Determine if the custom target element is valid
        if (!params.target || typeof params.target === 'string' && !document.querySelector(params.target) || typeof params.target !== 'string' && !params.target.appendChild) {
            warn('Target parameter is not valid, defaulting to "body"');
            params.target = 'body';
        }
    }
    /**
   * Set type, text and actions on popup
   *
   * @param {SweetAlertOptions} params
   */ function setParameters(params) {
        setDefaultInputValidators(params);
        // showLoaderOnConfirm && preConfirm
        if (params.showLoaderOnConfirm && !params.preConfirm) warn("showLoaderOnConfirm is set to true, but preConfirm is not defined.\nshowLoaderOnConfirm should be used together with preConfirm, see usage example:\nhttps://sweetalert2.github.io/#ajax-request");
        validateCustomTargetElement(params);
        // Replace newlines with <br> in title
        if (typeof params.title === 'string') params.title = params.title.split('\n').join('<br />');
        init(params);
    }
    /** @type {SweetAlert} */ let currentInstance;
    var _promise = /*#__PURE__*/ new WeakMap();
    class SweetAlert {
        /**
     * @param {...(SweetAlertOptions | string)} args
     * @this {SweetAlert}
     */ constructor(...args){
            /**
       * @type {Promise<SweetAlertResult>}
       */ _classPrivateFieldInitSpec(this, _promise, /** @type {Promise<SweetAlertResult>} */ Promise.resolve({
                isConfirmed: false,
                isDenied: false,
                isDismissed: true
            }));
            // Prevent run in Node env
            if (typeof window === 'undefined') return;
            currentInstance = this;
            // @ts-ignore
            const outerParams = Object.freeze(this.constructor.argsToParams(args));
            /** @type {Readonly<SweetAlertOptions>} */ this.params = outerParams;
            /** @type {boolean} */ this.isAwaitingPromise = false;
            _classPrivateFieldSet2(_promise, this, this._main(currentInstance.params));
        }
        /**
     * @param {any} userParams
     * @param {any} mixinParams
     */ _main(userParams, mixinParams = {}) {
            showWarningsForParams(Object.assign({}, mixinParams, userParams));
            if (globalState.currentInstance) {
                const swalPromiseResolve = privateMethods.swalPromiseResolve.get(globalState.currentInstance);
                const { isAwaitingPromise: isAwaitingPromise } = globalState.currentInstance;
                globalState.currentInstance._destroy();
                if (!isAwaitingPromise) swalPromiseResolve({
                    isDismissed: true
                });
                if (isModal()) unsetAriaHidden();
            }
            globalState.currentInstance = currentInstance;
            const innerParams = prepareParams(userParams, mixinParams);
            setParameters(innerParams);
            Object.freeze(innerParams);
            // clear the previous timer
            if (globalState.timeout) {
                globalState.timeout.stop();
                delete globalState.timeout;
            }
            // clear the restore focus timeout
            clearTimeout(globalState.restoreFocusTimeout);
            const domCache = populateDomCache(currentInstance);
            render(currentInstance, innerParams);
            privateProps.innerParams.set(currentInstance, innerParams);
            return swalPromise(currentInstance, domCache, innerParams);
        }
        // `catch` cannot be the name of a module export, so we define our thenable methods here instead
        /**
     * @param {any} onFulfilled
     */ // oxlint-disable-next-line unicorn/no-thenable
        then(onFulfilled) {
            return _classPrivateFieldGet2(_promise, this).then(onFulfilled);
        }
        /**
     * @param {any} onFinally
     */ finally(onFinally) {
            return _classPrivateFieldGet2(_promise, this).finally(onFinally);
        }
    }
    /**
   * @param {SweetAlert} instance
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   * @returns {Promise<SweetAlertResult>}
   */ const swalPromise = (instance, domCache, innerParams)=>{
        return new Promise((resolve, reject)=>{
            // functions to handle all closings/dismissals
            /**
       * @param {DismissReason} dismiss
       */ const dismissWith = (dismiss)=>{
                instance.close({
                    isDismissed: true,
                    dismiss: dismiss,
                    isConfirmed: false,
                    isDenied: false
                });
            };
            privateMethods.swalPromiseResolve.set(instance, resolve);
            privateMethods.swalPromiseReject.set(instance, reject);
            domCache.confirmButton.onclick = ()=>{
                handleConfirmButtonClick(instance);
            };
            domCache.denyButton.onclick = ()=>{
                handleDenyButtonClick(instance);
            };
            domCache.cancelButton.onclick = ()=>{
                handleCancelButtonClick(instance, dismissWith);
            };
            domCache.closeButton.onclick = ()=>{
                dismissWith(DismissReason.close);
            };
            handlePopupClick(innerParams, domCache, dismissWith);
            addKeydownHandler(globalState, innerParams, dismissWith);
            handleInputOptionsAndValue(instance, innerParams);
            openPopup(innerParams);
            setupTimer(globalState, innerParams, dismissWith);
            initFocus(domCache, innerParams);
            // Scroll container to top on open (#1247, #1946)
            setTimeout(()=>{
                domCache.container.scrollTop = 0;
            });
        });
    };
    /**
   * @param {SweetAlertOptions} userParams
   * @param {SweetAlertOptions} mixinParams
   * @returns {SweetAlertOptions}
   */ const prepareParams = (userParams, mixinParams)=>{
        const templateParams = getTemplateParams(userParams);
        const params = Object.assign({}, defaultParams, mixinParams, templateParams, userParams); // precedence is described in #2131
        params.showClass = Object.assign({}, defaultParams.showClass, params.showClass);
        params.hideClass = Object.assign({}, defaultParams.hideClass, params.hideClass);
        if (params.animation === false) {
            params.showClass = {
                backdrop: 'swal2-noanimation'
            };
            params.hideClass = {};
        }
        return params;
    };
    /**
   * @param {SweetAlert} instance
   * @returns {DomCache}
   */ const populateDomCache = (instance)=>{
        const domCache = /** @type {DomCache} */ {
            popup: /** @type {HTMLElement} */ getPopup(),
            container: /** @type {HTMLElement} */ getContainer(),
            actions: /** @type {HTMLElement} */ getActions(),
            confirmButton: /** @type {HTMLElement} */ getConfirmButton(),
            denyButton: /** @type {HTMLElement} */ getDenyButton(),
            cancelButton: /** @type {HTMLElement} */ getCancelButton(),
            loader: /** @type {HTMLElement} */ getLoader(),
            closeButton: /** @type {HTMLElement} */ getCloseButton(),
            validationMessage: /** @type {HTMLElement} */ getValidationMessage(),
            progressSteps: /** @type {HTMLElement} */ getProgressSteps()
        };
        privateProps.domCache.set(instance, domCache);
        return domCache;
    };
    /**
   * @param {GlobalState} globalState
   * @param {SweetAlertOptions} innerParams
   * @param {(dismiss: DismissReason) => void} dismissWith
   */ const setupTimer = (globalState, innerParams, dismissWith)=>{
        const timerProgressBar = getTimerProgressBar();
        hide(timerProgressBar);
        if (innerParams.timer) {
            globalState.timeout = new Timer(()=>{
                dismissWith('timer');
                delete globalState.timeout;
            }, innerParams.timer);
            if (innerParams.timerProgressBar && timerProgressBar) {
                show(timerProgressBar);
                applyCustomClass(timerProgressBar, innerParams, 'timerProgressBar');
                setTimeout(()=>{
                    if (globalState.timeout && globalState.timeout.running) // timer can be already stopped or unset at this point
                    animateTimerProgressBar(/** @type {number} */ innerParams.timer);
                });
            }
        }
    };
    /**
   * Initialize focus in the popup:
   *
   * 1. If `toast` is `true`, don't steal focus from the document.
   * 2. Else if there is an [autofocus] element, focus it.
   * 3. Else if `focusConfirm` is `true` and confirm button is visible, focus it.
   * 4. Else if `focusDeny` is `true` and deny button is visible, focus it.
   * 5. Else if `focusCancel` is `true` and cancel button is visible, focus it.
   * 6. Else focus the first focusable element in a popup (if any).
   *
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   */ const initFocus = (domCache, innerParams)=>{
        if (innerParams.toast) return;
        // TODO: this is dumb, remove `allowEnterKey` param in the next major version
        if (!callIfFunction(innerParams.allowEnterKey)) {
            warnAboutDeprecation('allowEnterKey', 'preConfirm: () => false');
            domCache.popup.focus();
            return;
        }
        if (focusAutofocus(domCache)) return;
        if (focusButton(domCache, innerParams)) return;
        setFocus(-1, 1);
    };
    /**
   * @param {DomCache} domCache
   * @returns {boolean}
   */ const focusAutofocus = (domCache)=>{
        const autofocusElements = Array.from(domCache.popup.querySelectorAll('[autofocus]'));
        for (const autofocusElement of autofocusElements)if (autofocusElement instanceof HTMLElement && isVisible$1(autofocusElement)) {
            autofocusElement.focus();
            return true;
        }
        return false;
    };
    /**
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   * @returns {boolean}
   */ const focusButton = (domCache, innerParams)=>{
        if (innerParams.focusDeny && isVisible$1(domCache.denyButton)) {
            domCache.denyButton.focus();
            return true;
        }
        if (innerParams.focusCancel && isVisible$1(domCache.cancelButton)) {
            domCache.cancelButton.focus();
            return true;
        }
        if (innerParams.focusConfirm && isVisible$1(domCache.confirmButton)) {
            domCache.confirmButton.focus();
            return true;
        }
        return false;
    };
    // Assign instance methods from src/instanceMethods/*.js to prototype
    SweetAlert.prototype.disableButtons = disableButtons;
    SweetAlert.prototype.enableButtons = enableButtons;
    SweetAlert.prototype.getInput = getInput;
    SweetAlert.prototype.disableInput = disableInput;
    SweetAlert.prototype.enableInput = enableInput;
    SweetAlert.prototype.hideLoading = hideLoading;
    SweetAlert.prototype.disableLoading = hideLoading;
    SweetAlert.prototype.showValidationMessage = showValidationMessage;
    SweetAlert.prototype.resetValidationMessage = resetValidationMessage;
    SweetAlert.prototype.close = close;
    SweetAlert.prototype.closePopup = close;
    SweetAlert.prototype.closeModal = close;
    SweetAlert.prototype.closeToast = close;
    SweetAlert.prototype.rejectPromise = rejectPromise;
    SweetAlert.prototype.update = update;
    SweetAlert.prototype._destroy = _destroy;
    // Assign static methods from src/staticMethods/*.js to constructor
    Object.assign(SweetAlert, staticMethods);
    // Proxy to instance methods to constructor, for now, for backwards compatibility
    Object.keys(instanceMethods).forEach((key)=>{
        /**
     * @param {...(SweetAlertOptions | string | undefined)} args
     * @returns {SweetAlertResult | Promise<SweetAlertResult> | undefined}
     */ // @ts-ignore: Dynamic property assignment for backwards compatibility
        SweetAlert[key] = function(...args) {
            // @ts-ignore
            if (currentInstance && currentInstance[key]) // @ts-ignore
            return currentInstance[key](...args);
            return undefined;
        };
    });
    SweetAlert.DismissReason = DismissReason;
    SweetAlert.version = '11.26.25';
    const Swal = SweetAlert;
    // @ts-ignore
    Swal.default = Swal;
    return Swal;
});
if (typeof $99dc7a165646c27f$exports !== 'undefined' && $99dc7a165646c27f$exports.Sweetalert2) $99dc7a165646c27f$exports.swal = $99dc7a165646c27f$exports.sweetAlert = $99dc7a165646c27f$exports.Swal = $99dc7a165646c27f$exports.SweetAlert = $99dc7a165646c27f$exports.Sweetalert2;
"undefined" != typeof document && function(e, t) {
    var n = e.createElement("style");
    if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
    else try {
        n.innerHTML = t;
    } catch (e) {
        n.innerText = t;
    }
}(document, ":root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:auto}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:\"top-start     top            top-end\" \"center-start  center         center-end\" \"bottom-start  bottom-center  bottom-end\";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:\"!\";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:auto}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}");



function $35da740d59af89ba$var$sampltonAlert(options = {}) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).fire({
        background: "#0b1121",
        color: "#fff",
        confirmButtonColor: "#333",
        cancelButtonColor: "#222",
        ...options
    });
}
(0, $b38ec4aa5ef4f8c4$export$71511d61b312f219)((0, $117415e422c8aaf1$export$73693bad9f5880b0), async (user)=>{
    $35da740d59af89ba$var$currentUser = user;
    $35da740d59af89ba$var$isPro = false;
    if (user) try {
        const licenseRef = (0, $2fa92ec193801792$export$ebd11618f299a286)((0, $117415e422c8aaf1$export$f932f06c7eb6abeb), "licenses", user.uid);
        const licenseSnap = await (0, $a33cbddcd7bfa0a9$export$11eb3b5ef9574821)(licenseRef);
        $35da740d59af89ba$var$isPro = licenseSnap.exists() && licenseSnap.data().samplton === true;
    } catch (err) {
        console.error("License check failed:", err);
    }
    $35da740d59af89ba$var$authReady = true;
    await $35da740d59af89ba$var$init();
});
if ('launchQueue' in window) launchQueue.setConsumer(async (launchParams)=>{
    if (!launchParams.files.length) return;
    const fileHandle = launchParams.files[0];
    const file = await fileHandle.getFile();
    const text = await file.text();
    try {
        $35da740d59af89ba$var$pendingFileData = JSON.parse(text);
    } catch (e) {
        await $35da740d59af89ba$var$sampltonAlert({
            title: "Invalid file",
            text: "This is not a valid .samplton file.",
            icon: "error"
        });
    }
});
async function $35da740d59af89ba$var$isTrackCached(url) {
    const data = await $35da740d59af89ba$var$loadFromDB(url);
    return !!data;
}
async function $35da740d59af89ba$var$resetAppKeepAudio() {
    try {
        // 🔴 STOP AUDIO
        if ($35da740d59af89ba$var$source) {
            try {
                $35da740d59af89ba$var$source.stop();
            } catch (e) {}
            $35da740d59af89ba$var$source = null;
        }
        if ($35da740d59af89ba$var$schedulerTimer) {
            clearTimeout($35da740d59af89ba$var$schedulerTimer);
            $35da740d59af89ba$var$schedulerTimer = null;
        }
        // 🔥 1. IndexedDB → len PROJECTS store
        const db = await $35da740d59af89ba$var$openDB();
        const tx = db.transaction("projects", "readwrite");
        await tx.objectStore("projects").clear();
        // 🔥 2. localStorage
        localStorage.clear();
        // 🔥 3. Service Worker cache (PWA)
        if ("caches" in window) {
            const keys = await caches.keys();
            await Promise.all(keys.map((k)=>caches.delete(k)));
        }
        // 🔥 4. RESET RAM (dôležité)
        $35da740d59af89ba$var$bufferCache.clear();
        $35da740d59af89ba$var$songs = [];
        $35da740d59af89ba$var$currentSongIndex = 0;
        $35da740d59af89ba$var$selectedSongIndex = 0;
        $35da740d59af89ba$var$selectedTrackIndex = 0;
        // 🔥 5. UI
        document.body.innerHTML = `
      <div style="color:white;padding:30px;text-align:center;">
        <h2>Done</h2>
        <p></p>
      </div>
    `;
        setTimeout(()=>{
            location.reload();
        }, 800);
    } catch (err) {
        console.error("Reset failed:", err);
        await $35da740d59af89ba$var$sampltonAlert({
            title: "Reset failed",
            icon: "error"
        });
    }
}
// GLOBALS
let $35da740d59af89ba$var$trackSubtitleEl = null;
const $35da740d59af89ba$var$FREE_STORAGE_LIMIT = 104857600; // 100 MB
const $35da740d59af89ba$var$MAX_FREE_FILE_SIZE = 31457280; // 30 MB
let $35da740d59af89ba$var$viewMode = "menu";
let $35da740d59af89ba$var$sampleLibraryMode = false;
let $35da740d59af89ba$var$sampleLibraryTargetTrackIndex = null;
let $35da740d59af89ba$var$samplePreviewSource = null;
let $35da740d59af89ba$var$samplePreviewBuffer = null;
let $35da740d59af89ba$var$samplePreviewStartedAt = 0;
let $35da740d59af89ba$var$samplePreviewOffset = 0;
let $35da740d59af89ba$var$samplePreviewPaused = false;
let $35da740d59af89ba$var$samplePreviewPad = null;
let $35da740d59af89ba$var$songEditMode = false;
let $35da740d59af89ba$var$draggedSongIndex = null;
let $35da740d59af89ba$var$updateQuantPadFn = null;
let $35da740d59af89ba$var$trackEditMode = false;
let $35da740d59af89ba$var$draggedTrackIndex = null;
let $35da740d59af89ba$var$trackSettingsMode = false;
let $35da740d59af89ba$var$trackSettingsIndex = null;
let $35da740d59af89ba$var$saveTimeout;
const $35da740d59af89ba$var$STRIPE_BUY_URL = "https://buy.stripe.com/fZu8wQ8LPewK52K99PdfG01";
let $35da740d59af89ba$var$currentUser = null;
let $35da740d59af89ba$var$isPro = false;
let $35da740d59af89ba$var$authReady = false;
function $35da740d59af89ba$var$getLocalProjectKey() {
    if ($35da740d59af89ba$var$currentUser?.uid) return `main_${$35da740d59af89ba$var$currentUser.uid}`;
    return "main_guest";
}
function $35da740d59af89ba$var$getUsedStorageBytes() {
    return $35da740d59af89ba$var$songs.flatMap((song)=>song.tracks || []).filter((track)=>$35da740d59af89ba$var$isR2Audio(track.mp3)).reduce((sum, track)=>sum + Number(track.fileSize || 0), 0);
}
// =======================
// LOAD TRACKS
// =======================
async function $35da740d59af89ba$var$deleteFromDB(key) {
    const db = await $35da740d59af89ba$var$openDB();
    const tx = db.transaction("files", "readwrite");
    return new Promise((resolve, reject)=>{
        const req = tx.objectStore("files").delete(key);
        req.onsuccess = ()=>resolve();
        req.onerror = ()=>reject(req.error);
    });
}
async function $35da740d59af89ba$var$deleteR2Audio(audioRef) {
    if (!$35da740d59af89ba$var$isR2Audio(audioRef)) return true;
    if (!$35da740d59af89ba$var$currentUser) {
        console.warn("Cannot delete R2 audio: no user");
        return false;
    }
    const fileName = $35da740d59af89ba$var$getR2FileName(audioRef);
    const token = await $35da740d59af89ba$var$currentUser.getIdToken();
    const res = await fetch(`${$35da740d59af89ba$var$R2_API}/audio/${encodeURIComponent(fileName)}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    const data = await res.json();
    if (!res.ok || !data.ok) {
        console.error("R2 delete failed:", data);
        return false;
    }
    console.log("\uD83D\uDDD1\uFE0F R2 deleted:", fileName);
    await $35da740d59af89ba$var$deleteFromDB(audioRef);
    $35da740d59af89ba$var$bufferCache.delete(audioRef);
    return true;
}
async function $35da740d59af89ba$var$detectAudioStart(file) {
    try {
        const arrayBuffer = await file.arrayBuffer();
        const ctx = new (window.AudioContext || window.webkitAudioContext)();
        const buffer = await ctx.decodeAudioData(arrayBuffer.slice(0));
        const sampleRate = buffer.sampleRate;
        // kontrolujeme všetky kanály
        const channels = [];
        for(let c = 0; c < buffer.numberOfChannels; c++)channels.push(buffer.getChannelData(c));
        // -45 dB približne
        const threshold = 0.0056;
        // zvuk musí zostať nad hranicou aspoň cca 10 ms
        const requiredSamples = Math.floor(sampleRate * 0.01);
        let consecutive = 0;
        let startSample = 0;
        for(let i = 0; i < buffer.length; i++){
            let amplitude = 0;
            for (const channel of channels)amplitude = Math.max(amplitude, Math.abs(channel[i]));
            if (amplitude > threshold) {
                consecutive++;
                if (consecutive >= requiredSamples) {
                    startSample = i - requiredSamples + 1;
                    break;
                }
            } else consecutive = 0;
        }
        await ctx.close();
        const startSeconds = startSample / sampleRate;
        return Math.max(0, Number(startSeconds.toFixed(3)));
    } catch (err) {
        console.warn("Audio start detection failed:", err);
        return 0;
    }
}
async function $35da740d59af89ba$var$analyzeAudio(file) {
    const result = {
        bpm: null,
        startAt: 0
    };
    let ctx = null;
    try {
        const arrayBuffer = await file.arrayBuffer();
        ctx = new (window.AudioContext || window.webkitAudioContext)();
        const buffer = await ctx.decodeAudioData(arrayBuffer.slice(0));
        const sampleRate = buffer.sampleRate;
        const length = buffer.length;
        // ==========================================
        // 1. DETEKCIA ZAČIATKU ZVUKU
        // ==========================================
        const channels = [];
        for(let c = 0; c < buffer.numberOfChannels; c++)channels.push(buffer.getChannelData(c));
        // cca -45 dB
        const startThreshold = 0.0056;
        // zvuk musí byť prítomný aspoň 10 ms,
        // aby jeden náhodný peak neurčil začiatok
        const requiredSamples = Math.floor(sampleRate * 0.01);
        let consecutive = 0;
        let startSample = 0;
        let foundStart = false;
        for(let i = 0; i < length; i++){
            let amplitude = 0;
            for (const channel of channels)amplitude = Math.max(amplitude, Math.abs(channel[i]));
            if (amplitude >= startThreshold) {
                consecutive++;
                if (consecutive >= requiredSamples) {
                    startSample = i - requiredSamples + 1;
                    foundStart = true;
                    break;
                }
            } else consecutive = 0;
        }
        if (!foundStart) startSample = 0;
        result.startAt = Number((startSample / sampleRate).toFixed(3));
        // ==========================================
        // 2. BPM DETECTION
        // ==========================================
        // BPM analyzujeme od reálneho začiatku zvuku
        // maximálne 90 sekúnd
        const analysisEnd = Math.min(length, startSample + sampleRate * 90);
        // mix kanálov pre analýzu
        const mono = new Float32Array(analysisEnd - startSample);
        for(let i = startSample; i < analysisEnd; i++){
            let sum = 0;
            for (const channel of channels)sum += channel[i];
            mono[i - startSample] = sum / channels.length;
        }
        // ==========================================
        // ENERGY WINDOWS
        // ==========================================
        // analyzujeme bloky cca 20 ms
        const windowSize = Math.max(1, Math.floor(sampleRate * 0.02));
        const energies = [];
        for(let i = 0; i < mono.length; i += windowSize){
            const end = Math.min(i + windowSize, mono.length);
            let energy = 0;
            for(let j = i; j < end; j++){
                const sample = mono[j];
                energy += sample * sample;
            }
            energies.push(Math.sqrt(energy / Math.max(1, end - i)));
        }
        // ==========================================
        // ONSET / TRANSIENT DETECTION
        // ==========================================
        const changes = [];
        for(let i = 1; i < energies.length; i++)changes.push(Math.max(0, energies[i] - energies[i - 1]));
        if (changes.length < 10) return result;
        // adaptívny threshold
        const sortedChanges = [
            ...changes
        ].sort((a, b)=>a - b);
        const percentileIndex = Math.floor(sortedChanges.length * 0.75);
        const threshold = sortedChanges[Math.min(percentileIndex, sortedChanges.length - 1)] * 1.5;
        const onsetTimes = [];
        // minimálne cca 180 ms medzi onsetmi
        const minOnsetGap = 0.18;
        let lastOnsetTime = -Infinity;
        for(let i = 1; i < changes.length - 1; i++){
            const change = changes[i];
            // lokálne maximum
            if (change >= threshold && change >= changes[i - 1] && change >= changes[i + 1]) {
                const time = i * windowSize / sampleRate;
                if (time - lastOnsetTime >= minOnsetGap) {
                    onsetTimes.push(time);
                    lastOnsetTime = time;
                }
            }
        }
        // ==========================================
        // BPM Z ROZDIELOV MEDZI ONSETMI
        // ==========================================
        if (onsetTimes.length >= 4) {
            const bpmScores = new Map();
            for(let i = 0; i < onsetTimes.length; i++)// porovnaj s niekoľkými ďalšími onsetmi
            for(let j = i + 1; j < Math.min(i + 9, onsetTimes.length); j++){
                const seconds = onsetTimes[j] - onsetTimes[i];
                if (seconds <= 0) continue;
                let bpm = 60 / seconds;
                // normalizácia half/double-time
                while(bpm < 70)bpm *= 2;
                while(bpm > 180)bpm /= 2;
                const rounded = Math.round(bpm);
                // mierne tolerujeme susedné hodnoty
                for(let offset = -1; offset <= 1; offset++){
                    const candidate = rounded + offset;
                    const distance = Math.abs(candidate - bpm);
                    const weight = 1 / (1 + distance);
                    bpmScores.set(candidate, (bpmScores.get(candidate) || 0) + weight);
                }
            }
            let bestBpm = null;
            let bestScore = -Infinity;
            for (const [bpm, score] of bpmScores)if (score > bestScore) {
                bestScore = score;
                bestBpm = bpm;
            }
            if (bestBpm && bestBpm >= 70 && bestBpm <= 180) result.bpm = bestBpm;
        }
        console.log("\uD83C\uDFB5 Audio analysis:", {
            bpm: result.bpm,
            startAt: result.startAt
        });
        return result;
    } catch (err) {
        console.warn("Audio analysis failed:", err);
        return result;
    } finally{
        if (ctx) try {
            await ctx.close();
        } catch (e) {}
    }
}
async function $35da740d59af89ba$var$uploadTrackToR2(track, file) {
    if (!$35da740d59af89ba$var$currentUser) {
        await $35da740d59af89ba$var$sampltonAlert({
            title: "Sign in required",
            text: "To upload audio files, please sign in with Google from the menu.",
            icon: "info"
        });
        return false;
    }
    if (!$35da740d59af89ba$var$isPro && file.size > $35da740d59af89ba$var$MAX_FREE_FILE_SIZE) {
        await $35da740d59af89ba$var$sampltonAlert({
            title: "File too large",
            text: "Free version allows files up to 30 MB.",
            icon: "warning"
        });
        return false;
    }
    if (!$35da740d59af89ba$var$isPro) {
        const used = $35da740d59af89ba$var$getUsedStorageBytes();
        const oldSize = $35da740d59af89ba$var$isR2Audio(track.mp3) ? Number(track.fileSize || 0) : 0;
        const newTotal = used - oldSize + file.size;
        if (newTotal > $35da740d59af89ba$var$FREE_STORAGE_LIMIT) {
            const usedMB = (used / 1024 / 1024).toFixed(1);
            const fileMB = (file.size / 1024 / 1024).toFixed(1);
            await $35da740d59af89ba$var$sampltonAlert({
                title: "Storage limit reached",
                html: `
          Free storage limit is <b>100 MB</b>.<br><br>
          Used: <b>${usedMB} MB</b><br>
          This file: <b>${fileMB} MB</b><br><br>
          Upgrade to PRO for more storage.
        `,
                icon: "warning"
            });
            return false;
        }
    }
    // =========================
    // AUDIO ANALYSIS
    // BPM + START
    // =========================
    try {
        const analysis = await $35da740d59af89ba$var$analyzeAudio(file);
        if (analysis.bpm) track.bpm = analysis.bpm;
        if (Number.isFinite(analysis.startAt) && analysis.startAt >= 0) track.start_at = analysis.startAt;
        console.log("\uD83C\uDFB5 Detected:", "BPM =", analysis.bpm, "START =", analysis.startAt);
    } catch (err) {
        console.warn("Audio analysis skipped:", err);
    }
    const oldAudioRef = track.mp3;
    const token = await $35da740d59af89ba$var$currentUser.getIdToken();
    const formData = new FormData();
    formData.append("file", file);
    if ($35da740d59af89ba$var$isR2Audio(track.mp3)) formData.append("oldFile", $35da740d59af89ba$var$getR2FileName(track.mp3));
    const res = await fetch(`${$35da740d59af89ba$var$R2_API}/upload`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`
        },
        body: formData
    });
    const data = await res.json();
    if (!res.ok || !data.ok) {
        console.error("R2 upload failed:", data);
        await $35da740d59af89ba$var$sampltonAlert({
            title: "Upload failed",
            text: data.error || `Error ${res.status}`,
            icon: "error"
        });
        return false;
    }
    // napr. r2:UUID.mp3
    const audioRef = `r2:${data.file}`;
    // =========================
    // LOCAL AUDIO CACHE
    // =========================
    const buffer = await file.arrayBuffer();
    await $35da740d59af89ba$var$saveToDB(audioRef, buffer.slice(0));
    // track teraz ukazuje na R2
    track.mp3 = audioRef;
    // Ak nemá meno, použi názov súboru
    if (!String(track.name || "").trim() || track.name === "New Loop") {
        const fileNameWithoutExt = file.name.replace(/\.[^/.]+$/, "");
        track.name = fileNameWithoutExt.substring(0, 8);
    }
    // prípadne si necháme info
    track.fileName = file.name;
    track.fileSize = file.size;
    await $35da740d59af89ba$var$saveProject();
    // RAM cache pripravíme tiež
    await $35da740d59af89ba$var$prepareSong([
        track
    ]);
    if ($35da740d59af89ba$var$isR2Audio(oldAudioRef) && oldAudioRef !== track.mp3) await $35da740d59af89ba$var$deleteR2Audio(oldAudioRef);
    console.log("\u2705 Track uploaded:", {
        mp3: track.mp3,
        fileName: file.name
    });
    return true;
}
async function $35da740d59af89ba$var$loadTracks() {
    // 1. uložený projekt
    const project = await $35da740d59af89ba$var$loadProject();
    if (project?.songs) {
        $35da740d59af89ba$var$songs = project.songs;
        return $35da740d59af89ba$var$songs.flatMap((s)=>s.tracks);
    }
    // 2. nič uložené → načítaj Demo Project
    $35da740d59af89ba$var$songs = structuredClone((0, (/*@__PURE__*/$parcel$interopDefault($7efe9ca969eb570d$exports))).songs);
    await $35da740d59af89ba$var$saveProject();
    return $35da740d59af89ba$var$songs.flatMap((s)=>s.tracks);
}
// =======================
// TABLE GOOGLE
// =======================
function $35da740d59af89ba$var$renderSongsTable() {
    if ($35da740d59af89ba$var$sheetEditorEl) {
        $35da740d59af89ba$var$sheetEditorEl.style.display = "block";
        return;
    }
    const wrapper = document.createElement("div");
    wrapper.className = "sheet-editor";
    $35da740d59af89ba$var$sheetEditorEl = wrapper;
    // ❌ CLOSE
    const closeBtn = document.createElement("div");
    closeBtn.textContent = "\u2715";
    closeBtn.className = "pad-mini sheet-close";
    closeBtn.onclick = ()=>{
        wrapper.remove();
        $35da740d59af89ba$var$sheetEditorEl = null;
        $35da740d59af89ba$var$renderSong();
    };
    wrapper.appendChild(closeBtn);
    // ➕ ADD SONG
    const addBtn = document.createElement("div");
    addBtn.textContent = "+";
    addBtn.className = "pad-mini sheet-add";
    addBtn.onclick = async ()=>{
        // FREE používateľ môže mať iba 1 song
        if (!$35da740d59af89ba$var$isPro && $35da740d59af89ba$var$songs.length >= 1) {
            wrapper.remove();
            $35da740d59af89ba$var$sheetEditorEl = null;
            $35da740d59af89ba$var$viewMode = "menu";
            $35da740d59af89ba$var$renderSong();
            return;
        }
        const newSong = {
            title: "New Song",
            tracks: []
        };
        $35da740d59af89ba$var$songs.push(newSong);
        await $35da740d59af89ba$var$saveProject();
        console.log("\u2795 Song added:", newSong.title);
        wrapper.remove();
        $35da740d59af89ba$var$sheetEditorEl = null;
        $35da740d59af89ba$var$renderSongsTable();
    };
    wrapper.appendChild(addBtn);
    const table = document.createElement("table");
    table.className = "sheet-table";
    // 🔷 HEADER
    const thead = document.createElement("thead");
    const headRow = document.createElement("tr");
    const thMove = document.createElement("th");
    thMove.textContent = "\u2195";
    headRow.appendChild(thMove);
    const thDel = document.createElement("th");
    thDel.textContent = "\u2715";
    headRow.appendChild(thDel);
    const thTitle = document.createElement("th");
    thTitle.textContent = "title";
    headRow.appendChild(thTitle);
    thead.appendChild(headRow);
    table.appendChild(thead);
    const tbody = document.createElement("tbody");
    $35da740d59af89ba$var$songs.forEach((song, index)=>{
        const tr = document.createElement("tr");
        tr.style.cursor = "pointer";
        // 🔼🔽 MOVE
        const tdMove = document.createElement("td");
        const up = document.createElement("button");
        up.textContent = "\u2B06";
        const down = document.createElement("button");
        down.textContent = "\u2B07";
        up.onclick = ()=>{
            if (index === 0) return;
            [$35da740d59af89ba$var$songs[index - 1], $35da740d59af89ba$var$songs[index]] = [
                $35da740d59af89ba$var$songs[index],
                $35da740d59af89ba$var$songs[index - 1]
            ];
            $35da740d59af89ba$var$saveProject();
            wrapper.remove();
            $35da740d59af89ba$var$sheetEditorEl = null;
            $35da740d59af89ba$var$renderSongsTable();
        };
        down.onclick = ()=>{
            if (index === $35da740d59af89ba$var$songs.length - 1) return;
            [$35da740d59af89ba$var$songs[index + 1], $35da740d59af89ba$var$songs[index]] = [
                $35da740d59af89ba$var$songs[index],
                $35da740d59af89ba$var$songs[index + 1]
            ];
            $35da740d59af89ba$var$saveProject();
            wrapper.remove();
            $35da740d59af89ba$var$sheetEditorEl = null;
            $35da740d59af89ba$var$renderSongsTable();
        };
        tdMove.appendChild(up);
        tdMove.appendChild(down);
        tr.appendChild(tdMove);
        // ❌ DELETE
        const tdDel = document.createElement("td");
        tdDel.textContent = "\u2715";
        tdDel.onclick = async ()=>{
            const songToDelete = $35da740d59af89ba$var$songs[index];
            if (!songToDelete) return;
            const tracks = songToDelete.tracks || [];
            // 2. Až keď sú R2 súbory preč, odstráň skladbu
            $35da740d59af89ba$var$songs.splice(index, 1);
            // 3. Ulož nový projekt
            await $35da740d59af89ba$var$saveProject();
            console.log("\uD83D\uDDD1\uFE0F Song deleted:", songToDelete.title, `(${tracks.length} tracks)`);
            // 4. Prekresli Songs Table
            wrapper.remove();
            $35da740d59af89ba$var$renderSongsTable();
        };
        tr.appendChild(tdDel);
        // ✏️ TITLE
        const tdTitle = document.createElement("td");
        tdTitle.contentEditable = true;
        tdTitle.textContent = song.title;
        tdTitle.oninput = ()=>{
            let val = tdTitle.textContent.trim();
            if ($35da740d59af89ba$var$isOnlyNumber(val)) {
                val = "New Song";
                tdTitle.textContent = val;
            }
            song.title = val;
            $35da740d59af89ba$var$saveProject();
        };
        tr.appendChild(tdTitle);
        tbody.appendChild(tr);
    });
    table.appendChild(tbody);
    wrapper.appendChild(table);
    document.body.appendChild(wrapper);
}
let $35da740d59af89ba$var$sheetEditorEl = null;
function $35da740d59af89ba$var$renderEditableTable(tracks) {
    if ($35da740d59af89ba$var$sheetEditorEl) {
        $35da740d59af89ba$var$sheetEditorEl.style.display = "block";
        return;
    }
    const wrapper = document.createElement("div");
    wrapper.className = "sheet-editor";
    $35da740d59af89ba$var$sheetEditorEl = wrapper;
    let updatePosition = null;
    // ❌ CLOSE
    const closeBtn = document.createElement("div");
    closeBtn.textContent = "\u2715";
    closeBtn.className = "pad-mini sheet-close";
    if (window.visualViewport) {
        const updatePosition = ()=>{
            const viewportHeight = visualViewport.height;
            const windowHeight = window.innerHeight;
            const keyboardHeight = windowHeight - viewportHeight;
            if (keyboardHeight > 100) closeBtn.style.bottom = keyboardHeight + 15 + "px";
            else closeBtn.style.bottom = "15px";
        };
        visualViewport.addEventListener("resize", updatePosition);
        visualViewport.addEventListener("scroll", updatePosition);
    }
    closeBtn.onclick = ()=>{
        visualViewport.removeEventListener("resize", updatePosition);
        visualViewport.removeEventListener("scroll", updatePosition);
        wrapper.remove();
        $35da740d59af89ba$var$sheetEditorEl = null;
        $35da740d59af89ba$var$renderSong();
    };
    wrapper.appendChild(closeBtn);
    // ➕ ADD ROW
    const addBtn = document.createElement("div");
    addBtn.textContent = "+";
    addBtn.className = "pad-mini sheet-add";
    addBtn.onclick = async ()=>{
        const currentSongTitle = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex]?.title || "New";
        const lastTrack = tracks[tracks.length - 1];
        const newTrack = {
            song: currentSongTitle,
            name: "New Loop",
            notes: "",
            mp3: "",
            bpm: lastTrack ? lastTrack.bpm : 120,
            signature: 4,
            bars: 4,
            start_at: 0.01,
            fadeintime: 0.5,
            repeat: 1
        };
        tracks.push(newTrack);
        await $35da740d59af89ba$var$saveProject();
        const project = await $35da740d59af89ba$var$loadProject();
        if (project?.songs) $35da740d59af89ba$var$songs = project.songs;
        wrapper.remove();
        $35da740d59af89ba$var$sheetEditorEl = null;
        $35da740d59af89ba$var$renderSong();
        const song = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex];
        if (song) $35da740d59af89ba$var$renderEditableTable(song.tracks);
    };
    wrapper.appendChild(addBtn);
    const table = document.createElement("table");
    table.className = "sheet-table";
    // 🧠 fallback headers
    const headers = [
        "start_at",
        "bars",
        "name",
        "mp3",
        "bpm",
        "repeat",
        "signature",
        "autoplay",
        "notes",
        "fadeintime"
    ]; // 🔷 HEADER
    const thead = document.createElement("thead");
    const headRow = document.createElement("tr");
    const thDrag = document.createElement("th");
    thDrag.textContent = "\u22EE"; // alebo nechaj prázdne ""
    headRow.appendChild(thDrag);
    // normal columns
    headers.forEach((h)=>{
        const th = document.createElement("th");
        th.textContent = h;
        headRow.appendChild(th);
    });
    const thMove = document.createElement("th");
    thMove.textContent = "\u2195";
    headRow.appendChild(thMove);
    // delete column
    const thDel = document.createElement("th");
    thDel.textContent = "\u2715";
    headRow.appendChild(thDel);
    thead.appendChild(headRow);
    table.appendChild(thead);
    const tbody = document.createElement("tbody");
    let dragIndex = null;
    tracks.forEach((track, rowIndex)=>{
        const tr = document.createElement("tr");
        const tdDrag = document.createElement("td");
        tdDrag.className = "sheet-drag";
        const dragIcon = document.createElement("div");
        dragIcon.className = "drag-handle";
        dragIcon.innerHTML = "\u283F";
        dragIcon.draggable = true;
        dragIcon.addEventListener("dragstart", ()=>{
            dragIndex = rowIndex;
            tr.classList.add("dragging");
        });
        dragIcon.addEventListener("dragend", ()=>{
            tr.classList.remove("dragging");
        });
        tdDrag.appendChild(dragIcon);
        tr.appendChild(tdDrag);
        // ✏️ DATA CELLS
        headers.forEach((h)=>{
            const td = document.createElement("td");
            if (h === "mp3") {
                const uploadBtn = document.createElement("button");
                uploadBtn.textContent = track.mp3 ? "CHANGE" : "UPLOAD";
                const fileInfo = document.createElement("div");
                fileInfo.style.fontSize = "10px";
                fileInfo.style.marginTop = "4px";
                if ($35da740d59af89ba$var$isR2Audio(track.mp3)) fileInfo.textContent = track.fileName || $35da740d59af89ba$var$getR2FileName(track.mp3);
                else fileInfo.textContent = track.mp3 ? $35da740d59af89ba$var$getFileName(track.mp3) : "";
                uploadBtn.onclick = async ()=>{
                    if (!$35da740d59af89ba$var$currentUser) {
                        await $35da740d59af89ba$var$sampltonAlert({
                            title: "Sign in required",
                            text: "To upload audio files, please sign in with Google from the menu.",
                            icon: "info"
                        });
                        return;
                    }
                    const input = document.createElement("input");
                    input.type = "file";
                    input.accept = "audio/*,.wav,.mp3,.flac,.ogg";
                    input.onchange = async ()=>{
                        const file = input.files?.[0];
                        if (!file) return;
                        uploadBtn.disabled = true;
                        uploadBtn.textContent = "UPLOADING...";
                        try {
                            const ok = await $35da740d59af89ba$var$uploadTrackToR2(track, file);
                            if (ok) {
                                fileInfo.textContent = file.name;
                                uploadBtn.textContent = "CHANGE";
                                $35da740d59af89ba$var$updatePadUI(track);
                                // ak track predtým nemal mp3, pad ešte nemusel existovať
                                const song = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex];
                                if (song) {
                                    wrapper.remove();
                                    $35da740d59af89ba$var$sheetEditorEl = null;
                                    $35da740d59af89ba$var$renderSong();
                                    setTimeout(()=>{
                                        $35da740d59af89ba$var$renderEditableTable($35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex].tracks);
                                    }, 0);
                                }
                            } else uploadBtn.textContent = "UPLOAD";
                        } catch (err) {
                            console.error(err);
                            uploadBtn.textContent = "ERROR";
                        } finally{
                            uploadBtn.disabled = false;
                        }
                    };
                    input.click();
                };
                td.appendChild(uploadBtn);
                td.appendChild(fileInfo);
                tr.appendChild(td);
                return;
            }
            const numericFields = [
                "start_at",
                "bars",
                "bpm",
                "repeat",
                "signature",
                "fadeintime",
                "autoplay"
            ];
            if (numericFields.includes(h)) {
                const input = document.createElement("input");
                input.type = "number";
                input.inputMode = "decimal"; // 🔥 mobile keyboard
                input.step = "any";
                input.value = track[h] ?? "";
                input.addEventListener("input", async ()=>{
                    const val = input.value;
                    const num = $35da740d59af89ba$var$toNumber(val);
                    track[h] = num;
                    if (h === "start_at") track.start_at = num || 0.01;
                    if (h === "bpm") track.bpm = num;
                    if (h === "bars") track.bars = num;
                    if (h === "repeat") track.repeat = num || 1;
                    if (h === "signature") track.signature = num || 4;
                    if (h === "autoplay") track.autoplay = num;
                    $35da740d59af89ba$var$handleLiveUpdate(track);
                    $35da740d59af89ba$var$updatePadUI(track);
                    $35da740d59af89ba$var$scheduleSave(tracks);
                });
                td.appendChild(input);
            } else {
                td.contentEditable = true;
                td.textContent = track[h] ?? "";
                td.addEventListener("input", async ()=>{
                    let val = td.textContent;
                    if (h === "name" || h === "song") {
                        val = String(val);
                        if ($35da740d59af89ba$var$isOnlyNumber(val)) {
                            val = "Loop";
                            td.textContent = val;
                        }
                    }
                    if (h === "notes") val = String(val);
                    else val = val.trim();
                    track[h] = val;
                    if (h === "mp3") {
                        track.mp3 = $35da740d59af89ba$var$fixUrl(val);
                        if (track.mp3) {
                            await $35da740d59af89ba$var$cacheSongTracks([
                                track
                            ]);
                            await $35da740d59af89ba$var$prepareSong([
                                track
                            ]);
                        }
                    }
                    $35da740d59af89ba$var$handleLiveUpdate(track);
                    $35da740d59af89ba$var$updatePadUI(track);
                    $35da740d59af89ba$var$scheduleSave(tracks);
                });
            }
            tr.appendChild(td);
        });
        // 🔼🔽 MOVE CELL
        const tdMove = document.createElement("td");
        tdMove.className = "sheet-move";
        const up = document.createElement("button");
        up.textContent = "\u2B06";
        const down = document.createElement("button");
        down.textContent = "\u2B07";
        up.onclick = ()=>{
            if (rowIndex === 0) return;
            const song = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex];
            [song.tracks[rowIndex - 1], song.tracks[rowIndex]] = [
                song.tracks[rowIndex],
                song.tracks[rowIndex - 1]
            ];
            $35da740d59af89ba$var$saveProject();
            $35da740d59af89ba$var$renderSong(); // 🔥 len toto
            // 🔥 reopen table so správnymi dátami
            setTimeout(()=>{
                $35da740d59af89ba$var$renderEditableTable($35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex].tracks);
            }, 0);
        };
        down.onclick = ()=>{
            const song = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex];
            if (rowIndex === song.tracks.length - 1) return;
            [song.tracks[rowIndex + 1], song.tracks[rowIndex]] = [
                song.tracks[rowIndex],
                song.tracks[rowIndex + 1]
            ];
            $35da740d59af89ba$var$saveProject();
            $35da740d59af89ba$var$renderSong(); // 🔥 redraw UI
            // 🔥 reopen table s fresh dátami
            setTimeout(()=>{
                $35da740d59af89ba$var$renderEditableTable($35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex].tracks);
            }, 0);
        };
        tdMove.appendChild(up);
        tdMove.appendChild(down);
        tr.appendChild(tdMove);
        // ❌ DELETE CELL
        const tdDel = document.createElement("td");
        tdDel.textContent = "\u2715";
        tdDel.className = "sheet-delete";
        tdDel.onclick = async ()=>{
            const trackToDelete = tracks[rowIndex];
            if (!trackToDelete) return;
            const audioRef = trackToDelete.mp3;
            // Najprv zmaž audio z R2
            if ($35da740d59af89ba$var$isR2Audio(audioRef)) {
                const ok = await $35da740d59af89ba$var$deleteR2Audio(audioRef);
                if (!ok) {
                    alert("R2 audio sa nepodarilo vymaza\u0165.");
                    return;
                }
            }
            // Potom odstráň track z projektu
            tracks.splice(rowIndex, 1);
            await $35da740d59af89ba$var$saveProject();
            console.log("\uD83D\uDDD1\uFE0F Track deleted:", audioRef);
            wrapper.remove();
            $35da740d59af89ba$var$sheetEditorEl = null;
            $35da740d59af89ba$var$renderEditableTable(tracks);
        };
        tr.appendChild(tdDel);
        tbody.appendChild(tr);
    });
    tbody.addEventListener("dragover", (e)=>{
        e.preventDefault();
    });
    tbody.addEventListener("drop", (e)=>{
        e.preventDefault();
        const targetRow = e.target.closest("tr");
        if (!targetRow) return;
        const targetIndex = [
            ...tbody.children
        ].indexOf(targetRow);
        if (dragIndex === null || targetIndex === -1 || dragIndex === targetIndex) return;
        const song = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex];
        if (!song) return;
        const moved = song.tracks.splice(dragIndex, 1)[0];
        song.tracks.splice(targetIndex, 0, moved);
        $35da740d59af89ba$var$saveProject();
        wrapper.remove();
        $35da740d59af89ba$var$sheetEditorEl = null;
        $35da740d59af89ba$var$renderEditableTable($35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex].tracks);
        dragIndex = null;
    });
    table.appendChild(tbody);
    wrapper.appendChild(table);
    document.body.appendChild(wrapper);
}
function $35da740d59af89ba$var$handleLiveUpdate(track) {
    if (!$35da740d59af89ba$var$audioCtx) return;
    const song = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex];
    if (!song) return;
    let activeTrack = null;
    let nextTrack = null;
    if ($35da740d59af89ba$var$trackSettingsMode && $35da740d59af89ba$var$trackSettingsIndex !== null) activeTrack = song.tracks[$35da740d59af89ba$var$trackSettingsIndex];
    else {
        const activeIndex = $35da740d59af89ba$var$padsList.indexOf($35da740d59af89ba$var$activePadEl);
        const queuedIndex = $35da740d59af89ba$var$padsList.indexOf($35da740d59af89ba$var$queuedPadEl);
        activeTrack = activeIndex !== -1 ? song.tracks[activeIndex] : null;
        nextTrack = queuedIndex !== -1 ? song.tracks[queuedIndex] : null;
    }
    const bpm = $35da740d59af89ba$var$toNumber(track.bpm) || $35da740d59af89ba$var$tempo;
    const baseBars = $35da740d59af89ba$var$toNumber(track.bars) || 1;
    const repeat = $35da740d59af89ba$var$toNumber(track.repeat) || 1;
    const bars = baseBars;
    const signature = $35da740d59af89ba$var$toNumber(track.signature) || 4;
    const startAtOffset = $35da740d59af89ba$var$toNumber(track.start_at);
    const baseDuration = 60 / bpm * signature * bars;
    // =========================
    // ACTIVE TRACK LIVE UPDATE
    // =========================
    if (track === activeTrack && $35da740d59af89ba$var$source) {
        const restartTime = $35da740d59af89ba$var$getNextBeatTime();
        const newSource = $35da740d59af89ba$var$audioCtx.createBufferSource();
        newSource.buffer = $35da740d59af89ba$var$source.buffer;
        if ($35da740d59af89ba$var$quantizeMode === "NONE") newSource.loop = false;
        else {
            newSource.loop = true;
            newSource.loopStart = startAtOffset;
            newSource.loopEnd = startAtOffset + baseDuration;
        }
        const newGain = $35da740d59af89ba$var$audioCtx.createGain();
        newGain.gain.value = 1;
        newSource.connect(newGain);
        newGain.connect($35da740d59af89ba$var$audioCtx.destination);
        newSource.start(restartTime, startAtOffset);
        try {
            $35da740d59af89ba$var$source.stop(restartTime);
        } catch (e) {}
        $35da740d59af89ba$var$source = newSource;
        $35da740d59af89ba$var$currentGain = newGain;
        $35da740d59af89ba$var$tempo = bpm;
        $35da740d59af89ba$var$currentStartAt = restartTime;
        $35da740d59af89ba$var$currentDuration = baseDuration;
        $35da740d59af89ba$var$currentRepeat = repeat;
        $35da740d59af89ba$var$currentRepeatIndex = 0;
        $35da740d59af89ba$var$nextNoteTime = restartTime;
        $35da740d59af89ba$var$lastSwitchTime = 0;
        $35da740d59af89ba$var$updateActivePadBPM(bpm);
    }
    // =========================
    // QUEUED TRACK LIVE UPDATE
    // =========================
    if (track === nextTrack && $35da740d59af89ba$var$queuedTrack) {
        $35da740d59af89ba$var$queuedTrack.bpm = bpm;
        $35da740d59af89ba$var$queuedTrack.bars = bars;
        $35da740d59af89ba$var$queuedTrack.repeat = repeat;
        $35da740d59af89ba$var$queuedTrack.signature = signature;
        $35da740d59af89ba$var$queuedTrack.startAtOffset = startAtOffset;
        $35da740d59af89ba$var$queuedTrack.fadeTime = $35da740d59af89ba$var$toNumber(track.fadeintime) || 0;
        $35da740d59af89ba$var$queuedTrack.fadeTime = track.fadeintime;
    }
    // =========================
    // AUTOPLAY LIVE UPDATE
    // =========================
    if (track === activeTrack) {
        const val = track.autoplay === "" || track.autoplay == null ? 1 : $35da740d59af89ba$var$toNumber(track.autoplay);
        if (val === 0 && $35da740d59af89ba$var$sequenceMode) {
            $35da740d59af89ba$var$sequenceMode = false;
            if ($35da740d59af89ba$var$queuedPadEl) {
                $35da740d59af89ba$var$queuedPadEl.classList.remove("queued");
                $35da740d59af89ba$var$queuedPadEl = null;
            }
            $35da740d59af89ba$var$queuedTrack = null;
            $35da740d59af89ba$var$updateSeqPad();
        }
    }
}
function $35da740d59af89ba$var$renderSong() {
    $35da740d59af89ba$var$resetApp(false);
    if (!$35da740d59af89ba$var$songs.length) {
        document.body.innerHTML = `<div style="color:white;padding:20px;">No songs found</div>`;
        return;
    }
    $35da740d59af89ba$var$createTopBar();
    $35da740d59af89ba$var$createTopMenu();
    const grid = document.createElement("div");
    grid.className = "pad-grid";
    document.body.appendChild(grid);
    if ($35da740d59af89ba$var$viewMode === "menu") $35da740d59af89ba$var$buildSongPads(grid); // 🔥 SONGS
    else {
        const song = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex];
        if (!song) return;
        if ($35da740d59af89ba$var$sampleLibraryMode) $35da740d59af89ba$var$buildSampleLibraryPads(grid);
        else if ($35da740d59af89ba$var$trackSettingsMode) {
            const track = song.tracks[$35da740d59af89ba$var$trackSettingsIndex];
            $35da740d59af89ba$var$buildTrackSettingsPads(grid, track, $35da740d59af89ba$var$trackSettingsIndex);
        } else if ($35da740d59af89ba$var$trackEditMode) $35da740d59af89ba$var$buildTrackEditPads(grid, song.tracks);
        else $35da740d59af89ba$var$buildPads(grid, song.tracks);
        // table len v song view
        if ($35da740d59af89ba$var$sheetEditorEl && $35da740d59af89ba$var$sheetEditorEl.style.display !== "none") {
            $35da740d59af89ba$var$sheetEditorEl.remove();
            $35da740d59af89ba$var$sheetEditorEl = null;
            $35da740d59af89ba$var$renderEditableTable(song.tracks);
        }
    }
    //  AUTO FIX po render
    if ($35da740d59af89ba$var$sequenceMode && $35da740d59af89ba$var$viewMode === "song" && $35da740d59af89ba$var$padsList.length && !$35da740d59af89ba$var$source) setTimeout(()=>{
        if ($35da740d59af89ba$var$activePadEl) {
            const currentIndex = $35da740d59af89ba$var$padsList.indexOf($35da740d59af89ba$var$activePadEl);
            let nextIndex = currentIndex + 1;
            if (nextIndex >= $35da740d59af89ba$var$padsList.length) nextIndex = 0;
            $35da740d59af89ba$var$queuePadByIndex(nextIndex);
        }
    }, 50);
    if ($35da740d59af89ba$var$viewMode === "menu") $35da740d59af89ba$var$selectedPadIndex = $35da740d59af89ba$var$selectedSongIndex;
    else $35da740d59af89ba$var$selectedPadIndex = $35da740d59af89ba$var$selectedTrackIndex;
    $35da740d59af89ba$var$updatePadSelection();
    $35da740d59af89ba$var$createTableButton();
}
function $35da740d59af89ba$var$updatePadUI(track) {
    const song = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex];
    if (!song) return;
    const index = song.tracks.indexOf(track);
    if (index === -1) return;
    const pad = $35da740d59af89ba$var$padsList[index];
    if (!pad) return;
    const bpm = $35da740d59af89ba$var$toNumber(track.bpm) || $35da740d59af89ba$var$tempo;
    const baseBars = $35da740d59af89ba$var$toNumber(track.bars) || 1;
    const repeat = $35da740d59af89ba$var$toNumber(track.repeat) || 1;
    const signature = $35da740d59af89ba$var$toNumber(track.signature) || 4;
    const name = String(track.name ?? "");
    const safeName = $35da740d59af89ba$var$isOnlyNumber(name) ? "" : name;
    const trackName = safeName.trim() !== "" ? safeName : $35da740d59af89ba$var$getFileName(track.mp3);
    pad.querySelector(".pad-title").textContent = trackName;
    pad.querySelector(".pad-info").textContent = `${bpm} - ${baseBars} (${repeat}x) - ${signature}/4`;
}
// =======================
// GROUP TRACKS BY SONG
// =======================
function $35da740d59af89ba$var$groupTracksBySong(tracks) {
    const map = {};
    const order = [];
    tracks.forEach((track)=>{
        if (!track.mp3) return;
        const key = (track.song || "Default").toString().trim() || "Default";
        if (!map[key]) {
            map[key] = {
                title: key,
                tracks: []
            };
            order.push(key);
        }
        map[key].tracks.push(track);
    });
    return order.map((key)=>map[key]);
}
// =======================
// GLOBALS
// =======================
let $35da740d59af89ba$var$quantizeMode = "BAR"; // BAR | BEAT | NONE
let $35da740d59af89ba$var$selectedPadIndex = 0;
let $35da740d59af89ba$var$selectedSongIndex = 0;
let $35da740d59af89ba$var$selectedTrackIndex = 0;
let $35da740d59af89ba$var$clickOffset = 0.07; // v sekundách
let $35da740d59af89ba$var$updateMetroPadFn = null;
let $35da740d59af89ba$var$padsList = [];
let $35da740d59af89ba$var$songs = [];
let $35da740d59af89ba$var$currentSongIndex = 0;
let $35da740d59af89ba$var$sequenceMode = false;
let $35da740d59af89ba$var$autoplayResumeOnce = false;
let $35da740d59af89ba$var$lastSwitchTime = 0;
let $35da740d59af89ba$var$queuedPadEl = null;
let $35da740d59af89ba$var$activePadEl = null;
let $35da740d59af89ba$var$currentGain = null;
let $35da740d59af89ba$var$metronomeMuted = true;
let $35da740d59af89ba$var$metronomeVolume = parseFloat(localStorage.getItem("metroVol")) || 0.2;
let $35da740d59af89ba$var$audioCtx = null;
let $35da740d59af89ba$var$source = null;
const $35da740d59af89ba$var$bufferCache = new Map();
let $35da740d59af89ba$var$tempo = 120;
let $35da740d59af89ba$var$nextNoteTime = 0;
let $35da740d59af89ba$var$schedulerTimer = null;
let $35da740d59af89ba$var$queuedTrack = null;
let $35da740d59af89ba$var$isMonitoring = false;
let $35da740d59af89ba$var$currentStartAt = 0;
let $35da740d59af89ba$var$currentDuration = 0;
let $35da740d59af89ba$var$currentRepeat = 1;
let $35da740d59af89ba$var$currentRepeatIndex = 0;
let $35da740d59af89ba$var$currentSignature = 4;
let $35da740d59af89ba$var$currentBars = 1;
let $35da740d59af89ba$var$metroCounterEl = null;
function $35da740d59af89ba$var$updatePadSelection() {
    $35da740d59af89ba$var$padsList.forEach((p, i)=>{
        p.classList.toggle("selected", i === $35da740d59af89ba$var$selectedPadIndex);
    });
}
// =======================
// COUNTER
// =======================
function $35da740d59af89ba$var$getCurrentBeatInfo() {
    if (!$35da740d59af89ba$var$audioCtx || !$35da740d59af89ba$var$source) return null;
    const beatDuration = 60 / $35da740d59af89ba$var$tempo;
    const now = $35da740d59af89ba$var$audioCtx.currentTime;
    const elapsed = now - $35da740d59af89ba$var$currentStartAt;
    if (elapsed < 0) return null;
    const totalBeats = Math.floor(elapsed / beatDuration);
    const beatsPerLoop = $35da740d59af89ba$var$currentSignature * $35da740d59af89ba$var$currentBars;
    const totalLoopBeats = beatsPerLoop * $35da740d59af89ba$var$currentRepeat;
    const loopBeat = totalBeats % totalLoopBeats;
    const bar = Math.floor(loopBeat / $35da740d59af89ba$var$currentSignature) + 1;
    const beat = loopBeat % $35da740d59af89ba$var$currentSignature + 1;
    return {
        bar: bar,
        beat: beat
    };
}
function $35da740d59af89ba$var$updatePadCounters() {
    if (!$35da740d59af89ba$var$activePadEl) return;
    const info = $35da740d59af89ba$var$getCurrentBeatInfo();
    if (!info) return;
    const counterEl = $35da740d59af89ba$var$activePadEl.querySelector(".pad-counter");
    if (!counterEl) return;
    counterEl.textContent = `${info.bar}|${info.beat}`;
    requestAnimationFrame($35da740d59af89ba$var$updatePadCounters);
}
let $35da740d59af89ba$var$seqPad = null;
function $35da740d59af89ba$var$updateSeqPad() {
    if (!$35da740d59af89ba$var$seqPad) return;
    $35da740d59af89ba$var$seqPad.classList.toggle("seq-on", $35da740d59af89ba$var$sequenceMode);
    $35da740d59af89ba$var$seqPad.innerHTML = `
  <div class="pad-key playstop">\u{25B6}</div>
    <div class="pad-title">AUTO</div>
    <div class="pad-info">${$35da740d59af89ba$var$sequenceMode ? "ON" : "OFF"}</div>  
  `;
}
function $35da740d59af89ba$var$queuePadByIndex(index) {
    const nextPad = $35da740d59af89ba$var$padsList[index];
    const nextTrackData = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex]?.tracks[index];
    if (!nextPad || !nextTrackData) return;
    if ($35da740d59af89ba$var$queuedPadEl) $35da740d59af89ba$var$queuedPadEl.classList.remove("queued");
    nextPad.classList.add("queued");
    $35da740d59af89ba$var$queuedPadEl = nextPad;
    $35da740d59af89ba$var$loadAudio(nextTrackData.mp3).then((buffer)=>{
        $35da740d59af89ba$var$queuedTrack = {
            buffer: buffer,
            bpm: $35da740d59af89ba$var$toNumber(nextTrackData.bpm) || $35da740d59af89ba$var$tempo,
            bars: $35da740d59af89ba$var$toNumber(nextTrackData.bars) || 1,
            repeat: $35da740d59af89ba$var$toNumber(nextTrackData.repeat) || 1,
            repeatIndex: 0,
            signature: $35da740d59af89ba$var$toNumber(nextTrackData.signature) || 4,
            startAtOffset: $35da740d59af89ba$var$toNumber(nextTrackData.start_at),
            fadeTime: $35da740d59af89ba$var$toNumber(nextTrackData.fadeintime) || 0,
            switchTime: null
        };
    });
}
function $35da740d59af89ba$var$toggleSequence() {
    $35da740d59af89ba$var$sequenceMode = !$35da740d59af89ba$var$sequenceMode;
    $35da740d59af89ba$var$lastSwitchTime = 0;
    // =========================
    // AUTO OFF
    // =========================
    if (!$35da740d59af89ba$var$sequenceMode) {
        $35da740d59af89ba$var$autoplayResumeOnce = false;
        if ($35da740d59af89ba$var$queuedPadEl) {
            $35da740d59af89ba$var$queuedPadEl.classList.remove("queued");
            $35da740d59af89ba$var$queuedPadEl = null;
        }
        $35da740d59af89ba$var$queuedTrack = null;
        $35da740d59af89ba$var$updateSeqPad();
        return;
    }
    // =========================
    // AUTO ON
    // =========================
    const currentIndex = $35da740d59af89ba$var$padsList.indexOf($35da740d59af89ba$var$activePadEl);
    const activeTrack = $35da740d59af89ba$var$getCurrentActiveTrack();
    const autoplayVal = activeTrack?.autoplay === "" || activeTrack?.autoplay == null ? 1 : $35da740d59af89ba$var$toNumber(activeTrack.autoplay);
    // Ručne zapnuté AUTO na AUTOPLAY OFF tracku:
    // dovolíme z neho jeden prechod na ďalší track.
    $35da740d59af89ba$var$autoplayResumeOnce = !!activeTrack && autoplayVal === 0 && currentIndex !== -1;
    $35da740d59af89ba$var$updateSeqPad();
    // Niečo už hrá -> priprav ďalší track
    if ($35da740d59af89ba$var$source && $35da740d59af89ba$var$activePadEl) {
        let nextIndex = currentIndex + 1;
        if (nextIndex >= $35da740d59af89ba$var$padsList.length) nextIndex = 0;
        $35da740d59af89ba$var$queuePadByIndex(nextIndex);
    }
    // Nič nehrá -> spusti prvý pad
    if (!$35da740d59af89ba$var$source && $35da740d59af89ba$var$padsList.length) $35da740d59af89ba$var$padsList[0].click();
}
// =======================
// AUDIO
// =======================
async function $35da740d59af89ba$var$saveProject() {
    const data = {
        version: 1,
        updatedAt: Date.now(),
        songs: $35da740d59af89ba$var$songs
    };
    // LOCAL
    const localDb = await $35da740d59af89ba$var$openDB();
    const tx = localDb.transaction("projects", "readwrite");
    await new Promise((resolve, reject)=>{
        const req = tx.objectStore("projects").put(data, $35da740d59af89ba$var$getLocalProjectKey());
        req.onsuccess = ()=>resolve();
        req.onerror = ()=>reject(req.error);
    });
    // CLOUD
    if ($35da740d59af89ba$var$currentUser && navigator.onLine) try {
        const projectRef = (0, $2fa92ec193801792$export$ebd11618f299a286)((0, $117415e422c8aaf1$export$f932f06c7eb6abeb), "users", $35da740d59af89ba$var$currentUser.uid, "projects", "main");
        await (0, $a33cbddcd7bfa0a9$export$5ff77ddaff3c9e12)(projectRef, data);
    //  console.log("☁️ Project saved");
    } catch (err) {
        console.error("Cloud save failed:", err);
    }
}
async function $35da740d59af89ba$var$loadProject() {
    let localData = null;
    let cloudData = null;
    // =========================
    // LOCAL
    // =========================
    try {
        const localDb = await $35da740d59af89ba$var$openDB();
        const tx = localDb.transaction("projects", "readonly");
        const req = tx.objectStore("projects").get($35da740d59af89ba$var$getLocalProjectKey());
        localData = await new Promise((resolve)=>{
            req.onsuccess = ()=>resolve(req.result || null);
            req.onerror = ()=>resolve(null);
        });
    } catch (err) {
        console.error("Local load failed:", err);
    }
    // =========================
    // CLOUD
    // =========================
    if ($35da740d59af89ba$var$currentUser && navigator.onLine) try {
        const projectRef = (0, $2fa92ec193801792$export$ebd11618f299a286)((0, $117415e422c8aaf1$export$f932f06c7eb6abeb), "users", $35da740d59af89ba$var$currentUser.uid, "projects", "main");
        const snap = await (0, $a33cbddcd7bfa0a9$export$11eb3b5ef9574821)(projectRef);
        if (snap.exists()) cloudData = snap.data();
    } catch (err) {
        console.error("Cloud load failed:", err);
    }
    // =========================
    // POROVNANIE
    // =========================
    // nič v cloude
    if (!cloudData) {
        if (localData && $35da740d59af89ba$var$currentUser && navigator.onLine) try {
            await (0, $a33cbddcd7bfa0a9$export$5ff77ddaff3c9e12)((0, $2fa92ec193801792$export$ebd11618f299a286)((0, $117415e422c8aaf1$export$f932f06c7eb6abeb), "users", $35da740d59af89ba$var$currentUser.uid, "projects", "main"), localData);
        // console.log("☁️ Local project uploaded");
        } catch (err) {
            console.error(err);
        }
        return localData;
    }
    // nič lokálne
    if (!localData) {
        await $35da740d59af89ba$var$saveProjectToLocal(cloudData);
        return cloudData;
    }
    const localTime = Number(localData.updatedAt || 0);
    const cloudTime = Number(cloudData.updatedAt || 0);
    // LOCAL je novší
    if (localTime > cloudTime) {
        try {
            await (0, $a33cbddcd7bfa0a9$export$5ff77ddaff3c9e12)((0, $2fa92ec193801792$export$ebd11618f299a286)((0, $117415e422c8aaf1$export$f932f06c7eb6abeb), "users", $35da740d59af89ba$var$currentUser.uid, "projects", "main"), localData);
        //   console.log("⬆️ Local newer → uploaded");
        } catch (err) {
            console.error(err);
        }
        return localData;
    }
    // CLOUD je novší alebo rovnaký
    await $35da740d59af89ba$var$saveProjectToLocal(cloudData);
    //  console.log("⬇️ Cloud newer → downloaded");
    return cloudData;
}
async function $35da740d59af89ba$var$saveProjectToLocal(data) {
    const localDb = await $35da740d59af89ba$var$openDB();
    const tx = localDb.transaction("projects", "readwrite");
    return new Promise((resolve, reject)=>{
        const req = tx.objectStore("projects").put(data, $35da740d59af89ba$var$getLocalProjectKey());
        req.onsuccess = ()=>resolve();
        req.onerror = ()=>reject(req.error);
    });
}
async function $35da740d59af89ba$var$ensureAudioContext() {
    if (!$35da740d59af89ba$var$audioCtx) $35da740d59af89ba$var$audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    if ($35da740d59af89ba$var$audioCtx.state === "suspended") await $35da740d59af89ba$var$audioCtx.resume();
}
async function $35da740d59af89ba$var$loadAudio(url) {
    if ($35da740d59af89ba$var$bufferCache.has(url)) return $35da740d59af89ba$var$bufferCache.get(url);
    // 🔥 skús DB
    const data = await $35da740d59af89ba$var$loadFromDB(url);
    if (!data) throw new Error("NOT_CACHED");
    const copy = data.slice(0);
    const decoded = await $35da740d59af89ba$var$audioCtx.decodeAudioData(copy);
    $35da740d59af89ba$var$bufferCache.set(url, decoded);
    return decoded;
}
function $35da740d59af89ba$var$openDB() {
    return new Promise((resolve, reject)=>{
        const req = indexedDB.open("samplton-db", 2);
        req.onupgradeneeded = ()=>{
            const db = req.result;
            if (!db.objectStoreNames.contains("files")) db.createObjectStore("files"); // audio
            if (!db.objectStoreNames.contains("projects")) db.createObjectStore("projects"); // 🔥 NOVÉ
        };
        req.onsuccess = ()=>resolve(req.result);
        req.onerror = ()=>reject(req.error);
    });
}
async function $35da740d59af89ba$var$saveToDB(key, buffer) {
    const db = await $35da740d59af89ba$var$openDB();
    const tx = db.transaction("files", "readwrite");
    tx.objectStore("files").put(buffer, key);
}
async function $35da740d59af89ba$var$loadFromDB(key) {
    const db = await $35da740d59af89ba$var$openDB();
    const tx = db.transaction("files", "readonly");
    const req = tx.objectStore("files").get(key);
    return new Promise((resolve, reject)=>{
        req.onsuccess = ()=>resolve(req.result);
        req.onerror = ()=>reject(req.error);
    });
}
// =======================
// METRONOME
// =======================
function $35da740d59af89ba$var$scheduler() {
    while($35da740d59af89ba$var$nextNoteTime < $35da740d59af89ba$var$audioCtx.currentTime + 0.05){
        $35da740d59af89ba$var$scheduleClick($35da740d59af89ba$var$nextNoteTime + $35da740d59af89ba$var$clickOffset);
        $35da740d59af89ba$var$nextNoteTime += 60 / $35da740d59af89ba$var$tempo;
    }
    $35da740d59af89ba$var$schedulerTimer = setTimeout($35da740d59af89ba$var$scheduler, 25);
}
function $35da740d59af89ba$var$scheduleClick(time) {
    if ($35da740d59af89ba$var$metronomeMuted) return;
    const osc = $35da740d59af89ba$var$audioCtx.createOscillator();
    const gain = $35da740d59af89ba$var$audioCtx.createGain();
    osc.frequency.value = 1000;
    gain.gain.setValueAtTime(Math.max(0.001, $35da740d59af89ba$var$metronomeVolume), time);
    gain.gain.exponentialRampToValueAtTime(0.001, time + 0.05);
    osc.connect(gain);
    gain.connect($35da740d59af89ba$var$audioCtx.destination);
    osc.start(time);
    osc.stop(time + 0.05);
}
// =======================
// DOWNLOAD SONG
// =======================
async function $35da740d59af89ba$var$prepareSong(tracks) {
    await $35da740d59af89ba$var$ensureAudioContext();
    for (const t of tracks){
        // 🔥 AK UŽ JE V RAM → SKIP
        if ($35da740d59af89ba$var$bufferCache.has(t.mp3)) continue;
        const data = await $35da740d59af89ba$var$loadFromDB(t.mp3);
        if (!data) continue;
        const copy = data.slice(0);
        const decoded = await $35da740d59af89ba$var$audioCtx.decodeAudioData(copy);
        $35da740d59af89ba$var$bufferCache.set(t.mp3, decoded);
    }
}
async function $35da740d59af89ba$var$cacheSongTracks(tracks) {
    for (const t of tracks){
        if (!t.mp3) continue;
        // už máme LOCAL
        const existing = await $35da740d59af89ba$var$loadFromDB(t.mp3);
        if (existing) continue;
        try {
            let res;
            // =========================
            // R2 AUDIO
            // =========================
            if ($35da740d59af89ba$var$isR2Audio(t.mp3)) {
                if (!$35da740d59af89ba$var$currentUser) throw new Error("NO_USER");
                const token = await $35da740d59af89ba$var$currentUser.getIdToken();
                const fileName = $35da740d59af89ba$var$getR2FileName(t.mp3);
                res = await fetch(`${$35da740d59af89ba$var$R2_API}/audio/${encodeURIComponent(fileName)}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            } else res = await fetch(t.mp3);
            if (!res.ok) throw new Error(`DOWNLOAD_${res.status}`);
            const buffer = await res.arrayBuffer();
            await $35da740d59af89ba$var$saveToDB(t.mp3, buffer.slice(0));
        // console.log("⬇️ Audio cached:", t.mp3);
        } catch (e) {
            console.warn("\u274C Audio cache fail:", t.mp3, e);
        }
    }
}
// =======================
// START FIRST TRACK
// =======================
async function $35da740d59af89ba$var$startFirstTrack(url, bpm, bars, signature = 4, startAtOffset = 0, repeat = 1) {
    const buffer = await $35da740d59af89ba$var$loadAudio(url);
    $35da740d59af89ba$var$currentSignature = signature;
    $35da740d59af89ba$var$currentBars = bars;
    const baseDuration = 60 / bpm * signature * bars;
    const startAt = $35da740d59af89ba$var$quantizeMode === "NONE" ? $35da740d59af89ba$var$audioCtx.currentTime : $35da740d59af89ba$var$getNextBeatTime();
    $35da740d59af89ba$var$source = $35da740d59af89ba$var$audioCtx.createBufferSource();
    $35da740d59af89ba$var$source.buffer = buffer;
    const gainNode = $35da740d59af89ba$var$audioCtx.createGain();
    gainNode.gain.value = 1;
    $35da740d59af89ba$var$source.connect(gainNode);
    gainNode.connect($35da740d59af89ba$var$audioCtx.destination);
    $35da740d59af89ba$var$currentGain = gainNode;
    const loopStart = startAtOffset;
    if ($35da740d59af89ba$var$quantizeMode === "NONE") $35da740d59af89ba$var$source.loop = false;
    else {
        $35da740d59af89ba$var$source.loop = true;
        $35da740d59af89ba$var$source.loopStart = loopStart;
        $35da740d59af89ba$var$source.loopEnd = loopStart + baseDuration;
    }
    $35da740d59af89ba$var$source.start(startAt, loopStart);
    $35da740d59af89ba$var$tempo = bpm;
    $35da740d59af89ba$var$nextNoteTime = startAt;
    if ($35da740d59af89ba$var$schedulerTimer) clearTimeout($35da740d59af89ba$var$schedulerTimer);
    $35da740d59af89ba$var$scheduler();
    $35da740d59af89ba$var$currentStartAt = startAt;
    $35da740d59af89ba$var$currentDuration = baseDuration;
    $35da740d59af89ba$var$currentRepeat = repeat;
    $35da740d59af89ba$var$currentRepeatIndex = 0;
    if (!$35da740d59af89ba$var$isMonitoring) {
        $35da740d59af89ba$var$isMonitoring = true;
        $35da740d59af89ba$var$monitorLoop();
    }
    $35da740d59af89ba$var$updateActivePadBPM(bpm);
    $35da740d59af89ba$var$updatePadCounters();
    //  AUTO FIX
    if ($35da740d59af89ba$var$sequenceMode) {
        const currentIndex = $35da740d59af89ba$var$padsList.indexOf($35da740d59af89ba$var$activePadEl);
        let nextIndex = currentIndex + 1;
        if (nextIndex >= $35da740d59af89ba$var$padsList.length) nextIndex = 0;
        $35da740d59af89ba$var$queuePadByIndex(nextIndex);
    }
}
// =======================
// LOOP MONITOR (QUEUE)
// =======================
function $35da740d59af89ba$var$monitorLoop() {
    function check() {
        if (!$35da740d59af89ba$var$source || !$35da740d59af89ba$var$audioCtx) return;
        const now = $35da740d59af89ba$var$audioCtx.currentTime;
        const elapsed = now - $35da740d59af89ba$var$currentStartAt;
        const loopsPassed = Math.floor(elapsed / $35da740d59af89ba$var$currentDuration);
        // 🔥 iba každý N-ty loop (repeat)
        // 🔥 repeat iba keď je autoplay ON
        if ($35da740d59af89ba$var$sequenceMode && (loopsPassed + 1) % $35da740d59af89ba$var$currentRepeat !== 0) return requestAnimationFrame(check);
        const nextBoundary = $35da740d59af89ba$var$currentStartAt + (loopsPassed + 1) * $35da740d59af89ba$var$currentDuration;
        // ak queuedTrack má vlastný switchTime, použijeme ten
        const targetSwitchTime = $35da740d59af89ba$var$queuedTrack?.switchTime || nextBoundary;
        const timeToBoundary = targetSwitchTime - now;
        const activeTrackData = $35da740d59af89ba$var$getCurrentActiveTrack();
        const autoplayVal = activeTrackData?.autoplay === "" || activeTrackData?.autoplay == null ? 1 : $35da740d59af89ba$var$toNumber(activeTrackData.autoplay);
        if ($35da740d59af89ba$var$sequenceMode && autoplayVal === 0 && !$35da740d59af89ba$var$autoplayResumeOnce) {
            $35da740d59af89ba$var$sequenceMode = false;
            if ($35da740d59af89ba$var$queuedPadEl) {
                $35da740d59af89ba$var$queuedPadEl.classList.remove("queued");
                $35da740d59af89ba$var$queuedPadEl = null;
            }
            $35da740d59af89ba$var$queuedTrack = null;
            $35da740d59af89ba$var$updateSeqPad();
            requestAnimationFrame(check);
            return;
        }
        if (timeToBoundary < 0.1 && $35da740d59af89ba$var$queuedTrack && targetSwitchTime !== $35da740d59af89ba$var$lastSwitchTime) {
            const q = $35da740d59af89ba$var$queuedTrack;
            $35da740d59af89ba$var$queuedTrack = null;
            $35da740d59af89ba$var$currentSignature = q.signature;
            $35da740d59af89ba$var$currentBars = q.bars;
            const newSource = $35da740d59af89ba$var$audioCtx.createBufferSource();
            newSource.buffer = q.buffer;
            const newDuration = 60 / q.bpm * q.signature * q.bars;
            const loopStart = q.startAtOffset;
            if ($35da740d59af89ba$var$quantizeMode === "NONE") newSource.loop = false;
            else {
                newSource.loop = true;
                newSource.loopStart = loopStart;
                newSource.loopEnd = loopStart + newDuration;
            }
            const newGain = $35da740d59af89ba$var$audioCtx.createGain();
            newSource.connect(newGain);
            newGain.connect($35da740d59af89ba$var$audioCtx.destination);
            newSource.start(targetSwitchTime, loopStart);
            const fadeTime = q.fadeTime || 0;
            if (fadeTime > 0) {
                newGain.gain.setValueAtTime(0.001, targetSwitchTime);
                newGain.gain.linearRampToValueAtTime(1, targetSwitchTime + fadeTime);
            } else newGain.gain.value = 1;
            // starý track
            if (fadeTime > 0 && $35da740d59af89ba$var$currentGain) {
                $35da740d59af89ba$var$currentGain.gain.setValueAtTime(1, targetSwitchTime);
                $35da740d59af89ba$var$currentGain.gain.linearRampToValueAtTime(0, targetSwitchTime + fadeTime);
                $35da740d59af89ba$var$source.stop(targetSwitchTime + fadeTime);
            } else $35da740d59af89ba$var$source.stop(targetSwitchTime);
            $35da740d59af89ba$var$source = newSource;
            $35da740d59af89ba$var$currentGain = newGain;
            $35da740d59af89ba$var$currentRepeat = q.repeat || 1;
            $35da740d59af89ba$var$currentRepeatIndex = 0;
            if ($35da740d59af89ba$var$activePadEl) $35da740d59af89ba$var$activePadEl.classList.remove("active");
            if ($35da740d59af89ba$var$queuedPadEl) {
                $35da740d59af89ba$var$queuedPadEl.classList.remove("queued");
                $35da740d59af89ba$var$queuedPadEl.classList.add("active");
                $35da740d59af89ba$var$activePadEl = $35da740d59af89ba$var$queuedPadEl;
                $35da740d59af89ba$var$queuedPadEl = null;
                $35da740d59af89ba$var$updateActivePadBPM(q.bpm);
                const activeIndex = $35da740d59af89ba$var$padsList.indexOf($35da740d59af89ba$var$activePadEl);
                const activeTrack = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex]?.tracks[activeIndex];
                $35da740d59af89ba$var$updateTrackSubtitle(activeTrack);
                // 🔥 AUTO SEQUENCE MODE
                if ($35da740d59af89ba$var$sequenceMode) {
                    const currentIndex = $35da740d59af89ba$var$padsList.indexOf($35da740d59af89ba$var$activePadEl);
                    if (currentIndex !== -1) {
                        let nextIndex = currentIndex + 1;
                        if (nextIndex >= $35da740d59af89ba$var$padsList.length) nextIndex = 0; // loop späť na začiatok
                        const nextPad = $35da740d59af89ba$var$padsList[nextIndex];
                        if (nextPad) {
                            nextPad.classList.add("queued");
                            $35da740d59af89ba$var$queuedPadEl = nextPad;
                            const nextTrackData = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex].tracks[nextIndex];
                            $35da740d59af89ba$var$loadAudio(nextTrackData.mp3).then((buffer)=>{
                                $35da740d59af89ba$var$queuedTrack = {
                                    buffer: buffer,
                                    bpm: $35da740d59af89ba$var$toNumber(nextTrackData.bpm) || $35da740d59af89ba$var$tempo,
                                    bars: $35da740d59af89ba$var$toNumber(nextTrackData.bars) || 1,
                                    repeat: $35da740d59af89ba$var$toNumber(nextTrackData.repeat) || 1,
                                    repeatIndex: 0,
                                    signature: $35da740d59af89ba$var$toNumber(nextTrackData.signature) || 4,
                                    startAtOffset: $35da740d59af89ba$var$toNumber(nextTrackData.start_at),
                                    fadeTime: $35da740d59af89ba$var$toNumber(nextTrackData.fadeintime) || 0,
                                    switchTime: null
                                };
                            });
                        }
                    }
                }
            }
            $35da740d59af89ba$var$tempo = q.bpm;
            $35da740d59af89ba$var$currentStartAt = targetSwitchTime;
            $35da740d59af89ba$var$currentDuration = newDuration;
            $35da740d59af89ba$var$lastSwitchTime = targetSwitchTime;
            $35da740d59af89ba$var$autoplayResumeOnce = false;
        }
        requestAnimationFrame(check);
    }
    check();
}
// =======================
// TOP BAR MENU
// =======================
async function $35da740d59af89ba$var$openLegalSection(key, returnToMenu = true) {
    const section = (0, (/*@__PURE__*/$parcel$interopDefault($5e47a1030dc5501a$exports)))[key];
    if (!section) return;
    await $35da740d59af89ba$var$sampltonAlert({
        title: section.title,
        width: 700,
        html: `
      <div
        style="
          text-align:left;
          line-height:1.65;
          max-height:60vh;
          overflow-y:auto;
          padding-right:10px;
        "
      >
        ${section.content.map((item)=>`<p>${item}</p>`).join("")}
      </div>
    `,
        confirmButtonText: returnToMenu ? "BACK" : "CLOSE"
    });
    if (returnToMenu) await $35da740d59af89ba$var$openLegalMenu();
}
async function $35da740d59af89ba$var$openLegalMenu() {
    const result = await $35da740d59af89ba$var$sampltonAlert({
        title: "Legal & Privacy",
        html: `
      <div style="
        display:flex;
        flex-direction:column;
        gap:10px;
        margin-top:15px;
      ">

        <button
          class="legal-menu-btn"
          data-legal="terms"
        >
          TERMS & CONDITIONS
        </button>

        <button
          class="legal-menu-btn"
          data-legal="privacy"
        >
          PRIVACY POLICY
        </button>

        <button
          class="legal-menu-btn"
          data-legal="cookies"
        >
          COOKIES & LOCAL STORAGE
        </button>

        <button
          class="legal-menu-btn"
          data-legal="contact"
        >
          CONTACT
        </button>

      </div>
    `,
        showConfirmButton: false,
        showCloseButton: true,
        didOpen: ()=>{
            document.querySelectorAll(".legal-menu-btn").forEach((btn)=>{
                btn.onclick = ()=>{
                    const key = btn.dataset.legal;
                    (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).close();
                    setTimeout(()=>{
                        $35da740d59af89ba$var$openLegalSection(key);
                    }, 100);
                };
            });
        }
    });
    return result;
}
function $35da740d59af89ba$var$legalCheckoutText() {
    return `
    <p style="
      font-size:12px;
      opacity:0.85;
      margin-top:18px;
    ">
      By continuing, you confirm that you have read and accepted the
      <a
        href="#"
        class="checkout-terms-link"
        style="
          color:#fff;
          text-decoration:underline;
          font-weight:bold;
        "
      >
        Terms & Conditions
      </a>
      and
      <a
        href="#"
        class="checkout-privacy-link"
        style="
          color:#fff;
          text-decoration:underline;
          font-weight:bold;
        "
      >
        Privacy Policy
      </a>.
    </p>
  `;
}
function $35da740d59af89ba$var$createTopMenu() {
    const wrapper = document.createElement("div");
    wrapper.className = "top-bar-wrapper";
    // 🔹 LEFT TOGGLE BUTTON
    const toggleBtn = document.createElement("div");
    toggleBtn.className = "pad-mini";
    toggleBtn.innerHTML = "\u2630";
    // 🔹 MENU PANEL
    const panel = document.createElement("div");
    panel.className = "top-menu-panel hidden";
    const resetKeepAudioBtn = $35da740d59af89ba$var$createMiniBtn("Reset app", async ()=>{
        const result = await $35da740d59af89ba$var$sampltonAlert({
            title: "Reset app?",
            text: "Your audio files will not be deleted.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "RESET",
            cancelButtonText: "CANCEL"
        });
        if (!result.isConfirmed) return;
        await $35da740d59af89ba$var$resetAppKeepAudio();
    });
    const userBtn = document.createElement("div");
    userBtn.className = "pad-mini user-pad";
    if ($35da740d59af89ba$var$currentUser) {
        userBtn.innerHTML = `
      ${$35da740d59af89ba$var$currentUser.photoURL ? `
            <img
              src="${$35da740d59af89ba$var$currentUser.photoURL}"
              class="user-photo"
              referrerpolicy="no-referrer"
            >
          ` : `<div class="user-photo-fallback"></div>`}
  
      <div class="user-pad-name">
        ${$35da740d59af89ba$var$currentUser.displayName || "User"}
      </div>
  
      <div class="user-pad-status">
        ${$35da740d59af89ba$var$isPro ? "PRO" : "FREE"}
      </div>
  
      <div class="user-pad-storage">
        loading...
      </div>
    `;
        // načítaj reálne využitie R2 z Workera
        $35da740d59af89ba$var$getStorageInfo().then((storage)=>{
            if (!storage) return;
            const storageEl = userBtn.querySelector(".user-pad-storage");
            if (!storageEl) return;
            const usedMB = storage.used / 1024 / 1024;
            const limitMB = storage.limit / 1024 / 1024;
            storageEl.textContent = `${usedMB.toFixed(1)} / ${limitMB.toFixed(0)} MB`;
        });
    } else userBtn.innerHTML = `
      <div class="user-photo-fallback">\u{1F464}</div>
      <div class="user-pad-name">Not signed in</div>
    `;
    const userPhoto = userBtn.querySelector(".user-photo");
    if (userPhoto) userPhoto.onerror = ()=>{
        userPhoto.remove();
        const fallback = document.createElement("div");
        fallback.className = "user-photo-fallback";
        fallback.textContent = "\uD83D\uDC64";
        userBtn.prepend(fallback);
    };
    const authBtn = $35da740d59af89ba$var$createMiniBtn($35da740d59af89ba$var$currentUser ? "Logout" : "Login", async ()=>{
        if ($35da740d59af89ba$var$currentUser) {
            await (0, $b38ec4aa5ef4f8c4$export$21579262ef46735b)((0, $117415e422c8aaf1$export$73693bad9f5880b0));
            return;
        }
        const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        try {
            if (isMobile) await (0, $b38ec4aa5ef4f8c4$export$3b513254972cfc9c)((0, $117415e422c8aaf1$export$73693bad9f5880b0), (0, $117415e422c8aaf1$export$ca328f169d304df4));
            else await (0, $b38ec4aa5ef4f8c4$export$f38c853ae54ed474)((0, $117415e422c8aaf1$export$73693bad9f5880b0), (0, $117415e422c8aaf1$export$ca328f169d304df4));
        } catch (error) {
            console.error("Google login error:", error);
            alert(error.code + "\n" + error.message);
        }
    });
    const buyStorageBtn = $35da740d59af89ba$var$createMiniBtn("+100 MB / 10 \u20AC / YEAR", async ()=>{
        if (!$35da740d59af89ba$var$currentUser) {
            await $35da740d59af89ba$var$sampltonAlert({
                title: "Sign in required",
                text: "Please sign in first.",
                icon: "info"
            });
            return;
        }
        if (!$35da740d59af89ba$var$isPro) {
            await $35da740d59af89ba$var$sampltonAlert({
                title: "PRO required",
                text: "Extra storage is available for PRO users only.",
                icon: "info"
            });
            return;
        }
        const confirm = await $35da740d59af89ba$var$sampltonAlert({
            title: "Extra Cloud Storage",
            icon: "info",
            html: `
          <div style="text-align:left; line-height:1.7;">
      
            <p style="
              font-size:24px;
              font-weight:bold;
              text-align:center;
            ">
              10 \u{20AC} / YEAR
            </p>
      
            <p>
              <b>You will receive:</b>
            </p>
      
            <p>
              \u{2713} +100 MB cloud storage<br>
              \u{2713} Valid for 1 year
            </p>
      
            <hr style="
              border:0;
              border-top:1px solid #333;
              margin:18px 0;
            ">
      
            ${$35da740d59af89ba$var$legalCheckoutText()}
      
          </div>
        `,
            showCancelButton: true,
            confirmButtonText: "CONTINUE TO PAYMENT",
            cancelButtonText: "CANCEL",
            didOpen: ()=>{
                const termsLink = document.querySelector(".checkout-terms-link");
                const privacyLink = document.querySelector(".checkout-privacy-link");
                termsLink?.addEventListener("click", async (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).close();
                    await $35da740d59af89ba$var$openLegalSection("terms", false);
                    buyStorageBtn.click();
                });
                privacyLink?.addEventListener("click", async (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).close();
                    await $35da740d59af89ba$var$openLegalSection("privacy", false);
                    buyStorageBtn.click();
                });
            }
        });
        if (!confirm.isConfirmed) return;
        try {
            const token = await $35da740d59af89ba$var$currentUser.getIdToken();
            const res = await fetch(`${$35da740d59af89ba$var$R2_API}/create-storage-checkout`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });
            const data = await res.json();
            if (!res.ok || !data.ok || !data.url) {
                console.error("Storage checkout failed:", data);
                await $35da740d59af89ba$var$sampltonAlert({
                    title: "Checkout failed",
                    text: "Storage checkout could not be started.",
                    icon: "error"
                });
                return;
            }
            window.location.href = data.url;
        } catch (err) {
            console.error("Storage checkout error:", err);
            await $35da740d59af89ba$var$sampltonAlert({
                title: "Checkout failed",
                text: "Storage checkout could not be started.",
                icon: "error"
            });
        }
    });
    // --- BUTTONY DO PANELU ---
    const prepareAllBtn = $35da740d59af89ba$var$createMiniBtn("Prepare All Songs", async ()=>{
        try {
            prepareAllBtn.innerHTML = "Preparing...";
            await $35da740d59af89ba$var$ensureAudioContext();
            for(let songIndex = 0; songIndex < $35da740d59af89ba$var$songs.length; songIndex++){
                const song = $35da740d59af89ba$var$songs[songIndex];
                // song pad v menu
                const songPad = $35da740d59af89ba$var$padsList[songIndex];
                if (songPad) songPad.classList.add("loading");
                const tracks = (song.tracks || []).filter((track)=>track.mp3);
                for (const track of tracks){
                    // už pripravené v RAM
                    if ($35da740d59af89ba$var$bufferCache.has(track.mp3)) continue;
                    // skús lokálnu IndexedDB
                    let data = await $35da740d59af89ba$var$loadFromDB(track.mp3);
                    // ak lokálne chýba, stiahni z R2
                    if (!data && navigator.onLine) {
                        await $35da740d59af89ba$var$cacheSongTracks([
                            track
                        ]);
                        data = await $35da740d59af89ba$var$loadFromDB(track.mp3);
                    }
                    if (!data) {
                        console.warn("Track not available:", track.mp3);
                        continue;
                    }
                    const copy = data.slice(0);
                    const decoded = await $35da740d59af89ba$var$audioCtx.decodeAudioData(copy);
                    $35da740d59af89ba$var$bufferCache.set(track.mp3, decoded);
                }
                // song hotový
                if (songPad) songPad.classList.remove("loading");
            }
            prepareAllBtn.innerHTML = "Songs Ready";
        } catch (err) {
            console.error("Prepare all failed:", err);
            // odstráň loading zo všetkých song padov
            $35da740d59af89ba$var$padsList.forEach((pad)=>{
                pad.classList.remove("loading");
            });
            prepareAllBtn.innerHTML = "Prepare All Songs";
        }
    });
    const prepareInfoBtn = document.createElement("div");
    prepareInfoBtn.className = "menu-info-btn";
    prepareInfoBtn.textContent = "+";
    prepareInfoBtn.onclick = async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        await $35da740d59af89ba$var$sampltonAlert({
            title: "Prepare All Songs",
            icon: "info",
            html: `
            <div style="text-align:left; line-height:1.6;">
              <p>
                Normally, each song is prepared when you open it.
              </p>
      
              <p>
                <b>Prepare All Songs</b> loads and decodes all tracks
                from all songs in advance.
              </p>
      
              <p>
                This is useful before a live performance,
                because every song will already be ready to play.
              </p>
            </div>
          `,
            confirmButtonText: "OK"
        });
    };
    prepareAllBtn.appendChild(prepareInfoBtn);
    const exportBtn = $35da740d59af89ba$var$createMiniBtn("Export Project", ()=>{
        const name = prompt("Zadaj n\xe1zov s\xfaboru:", "project");
        if (!name) return;
        const safeName = name.trim().replace(/\s+/g, "_").replace(/[^\w-]/g, "");
        const finalName = safeName || "project";
        // 🔥 DATETIME (short)
        const now = new Date();
        const pad = (n)=>String(n).padStart(2, "0");
        const dateTime = now.getFullYear().toString().slice(2) + pad(now.getMonth() + 1) + pad(now.getDate()) + "_" + pad(now.getHours()) + pad(now.getMinutes());
        const data = {
            version: 1,
            songs: $35da740d59af89ba$var$songs
        };
        const blob = new Blob([
            JSON.stringify(data, null, 2)
        ], {
            type: "application/samplton+json"
        });
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = `${finalName}_${dateTime}.samplton`;
        a.click();
        // cleanup
        setTimeout(()=>URL.revokeObjectURL(a.href), 1000);
    });
    const importBtn = $35da740d59af89ba$var$createMiniBtn("Import Project", ()=>{
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".samplton,application/json";
        input.onchange = (e)=>{
            const file = e.target.files[0];
            const reader = new FileReader();
            reader.onload = async ()=>{
                try {
                    const parsed = JSON.parse(reader.result);
                    // 🔥 1. RESET CELÉHO APP STATE
                    $35da740d59af89ba$var$resetApp(true); // ← toto je kľúčové
                    // 🔥 2. RESET CACHE (dôležité!)
                    $35da740d59af89ba$var$bufferCache.clear();
                    // 🔥 3. LOAD DATA
                    if (parsed.songs) $35da740d59af89ba$var$songs = parsed.songs;
                    else $35da740d59af89ba$var$songs = $35da740d59af89ba$var$groupTracksBySong(parsed);
                    $35da740d59af89ba$var$currentSongIndex = 0;
                    $35da740d59af89ba$var$selectedSongIndex = 0;
                    $35da740d59af89ba$var$selectedTrackIndex = 0;
                    // 🔥 4. SAVE
                    await $35da740d59af89ba$var$saveProject();
                    // 🔥 5. DOWNLOAD R2 AUDIO + PREPARE
                    const allTracks = $35da740d59af89ba$var$songs.flatMap((s)=>s.tracks || []);
                    // najprv stiahni chýbajúce audio z R2 do IndexedDB
                    await $35da740d59af89ba$var$cacheSongTracks(allTracks);
                    // až potom ho dekóduj do RAM
                    await $35da740d59af89ba$var$prepareSong(allTracks);
                    // 🔥 6. VIEW RESET
                    $35da740d59af89ba$var$viewMode = "menu";
                    // 🔥 7. RENDER CLEAN
                    $35da740d59af89ba$var$renderSong();
                } catch (err) {
                    console.error(err);
                    await $35da740d59af89ba$var$sampltonAlert({
                        title: "Invalid file",
                        text: "The selected project file could not be loaded.",
                        icon: "error"
                    });
                }
            };
            reader.readAsText(file);
        };
        input.click();
    });
    const importExportBtn = $35da740d59af89ba$var$createMiniBtn("Import / Export", async ()=>{
        const result = await $35da740d59af89ba$var$sampltonAlert({
            title: "Import / Export",
            html: `
          <div style="
            display:flex;
            flex-direction:column;
            gap:10px;
            margin-top:15px;
          ">
            <button
              id="samplton-export-btn"
              class="legal-menu-btn"
            >
              EXPORT PROJECT
            </button>
  
            <button
              id="samplton-import-btn"
              class="legal-menu-btn"
            >
              IMPORT PROJECT
            </button>
          </div>
        `,
            showConfirmButton: false,
            showCloseButton: true,
            didOpen: ()=>{
                document.getElementById("samplton-export-btn")?.addEventListener("click", ()=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).close();
                    exportBtn.click();
                });
                document.getElementById("samplton-import-btn")?.addEventListener("click", ()=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).close();
                    importBtn.click();
                });
            }
        });
        return result;
    });
    const importExportInfoBtn = document.createElement("div");
    importExportInfoBtn.className = "menu-info-btn";
    importExportInfoBtn.textContent = "+";
    importExportInfoBtn.onclick = async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        await $35da740d59af89ba$var$sampltonAlert({
            title: "Import / Export",
            icon: "info",
            html: `
      <div style="text-align:left; line-height:1.6;">

        <p>
          <b>Export Project</b> saves your current Samplton project
          as a <b>.samplton</b> file.
        </p>

        <p>
          The file contains the project structure and settings
          in <b>JSON format</b>, including songs, tracks, BPM,
          bars, start positions, repeats, notes and other settings.
        </p>

        <p>
          <b>Audio files are not stored inside the exported file.</b>
          The project keeps references to your audio stored
          in your Samplton Sample Library.
        </p>

        <p>
          <b>Import Project</b> loads a previously exported
          .samplton project back into Samplton.
        </p>

        <p>
          This can be useful for creating backups or keeping
          different versions of your project.
        </p>

      </div>
    `,
            confirmButtonText: "OK"
        });
    };
    importExportBtn.appendChild(importExportInfoBtn);
    const loadMainBtn = $35da740d59af89ba$var$createMiniBtn("Demo Project", async ()=>{
        const result = await $35da740d59af89ba$var$sampltonAlert({
            title: "Restore Demo Project?",
            text: "This will replace the current local project with the original Samplton demo.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "RESTORE DEMO",
            cancelButtonText: "CANCEL"
        });
        if (!result.isConfirmed) return;
        $35da740d59af89ba$var$songs = structuredClone((0, (/*@__PURE__*/$parcel$interopDefault($7efe9ca969eb570d$exports))).songs);
        $35da740d59af89ba$var$currentSongIndex = 0;
        $35da740d59af89ba$var$selectedSongIndex = 0;
        $35da740d59af89ba$var$selectedTrackIndex = 0;
        await $35da740d59af89ba$var$saveProject();
        $35da740d59af89ba$var$viewMode = "menu";
        $35da740d59af89ba$var$renderSong();
        const allTracks = $35da740d59af89ba$var$songs.flatMap((s)=>s.tracks || []);
        $35da740d59af89ba$var$cacheSongTracks(allTracks);
        $35da740d59af89ba$var$prepareSong(allTracks);
    });
    const newProjectBtn = $35da740d59af89ba$var$createMiniBtn("New Project", async ()=>{
        const emptyProject = {
            version: 1,
            songs: [
                {
                    title: "New Song",
                    tracks: [
                        {
                            song: "New Song",
                            name: "New Loop",
                            notes: "",
                            mp3: "",
                            bpm: 120,
                            signature: 4,
                            bars: 4,
                            start_at: 0.01,
                            fadeintime: 0.5,
                            repeat: 1,
                            autoplay: 1
                        }
                    ]
                }
            ]
        };
        $35da740d59af89ba$var$songs = emptyProject.songs;
        $35da740d59af89ba$var$currentSongIndex = 0;
        $35da740d59af89ba$var$selectedSongIndex = 0;
        $35da740d59af89ba$var$selectedTrackIndex = 0;
        await $35da740d59af89ba$var$saveProject();
        // 🔥 PRIDAŤ SEM
        const allTracks = $35da740d59af89ba$var$songs.flatMap((s)=>s.tracks);
        await $35da740d59af89ba$var$cacheSongTracks(allTracks);
        await $35da740d59af89ba$var$prepareSong(allTracks);
        $35da740d59af89ba$var$viewMode = "song";
        $35da740d59af89ba$var$trackEditMode = true;
        $35da740d59af89ba$var$trackSettingsMode = false;
        $35da740d59af89ba$var$renderSong();
    });
    const installBtn = $35da740d59af89ba$var$createMiniBtn("Install App", async ()=>{
        if (!$35da740d59af89ba$var$deferredPrompt) {
            await $35da740d59af89ba$var$sampltonAlert({
                title: "App unavailable",
                text: "The app is already installed or installation is not available.",
                icon: "info"
            });
            return;
        }
        $35da740d59af89ba$var$deferredPrompt.prompt();
        const { outcome: outcome } = await $35da740d59af89ba$var$deferredPrompt.userChoice;
        $35da740d59af89ba$var$deferredPrompt = null;
    });
    const installInfoBtn = document.createElement("div");
    installInfoBtn.className = "menu-info-btn";
    installInfoBtn.textContent = "+";
    installInfoBtn.onclick = async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        await $35da740d59af89ba$var$sampltonAlert({
            title: "Install Samplton",
            icon: "info",
            html: `
      <div style="text-align:left; line-height:1.6;">
        <p>
          Samplton is a <b>Progressive Web App (PWA)</b>.
        </p>

        <p>
          You can install it on your <b>phone, tablet or computer</b>
          and use it like a standalone application.
        </p>

        <p>
          On desktop, install Samplton directly through
          <b>Google Chrome</b>.
        </p>

        <p>
          Once installed, Samplton can be launched from your
          home screen or applications without opening the website first.
        </p>
      </div>
    `,
            confirmButtonText: "OK"
        });
    };
    installBtn.appendChild(installInfoBtn);
    const keyshots = $35da740d59af89ba$var$createMiniBtn("Keyshots", async ()=>{
        await $35da740d59af89ba$var$sampltonAlert({
            title: "Keyshots",
            icon: "info",
            html: `
        <div style="text-align:left; line-height:1.8;">
          <p><b>1\u{2013}9 / 0</b> \u{2192} play pad</p>
          <p><b>Enter</b> \u{2192} play</p>
          <p><b>R</b> \u{2192} reload</p>
          <p><b>S</b> \u{2192} stop</p>
          <p><b>A</b> \u{2192} auto sequence</p>
          <p><b>Q</b> \u{2192} quantize</p>
          <p><b>C</b> \u{2192} metronome</p>
          <p><b>E</b> \u{2192} edit track or songs</p>
          <p><b>F</b> \u{2192} fullscreen</p>
          <p><b>\u{2190} \u{2192} \u{2191} \u{2193}</b> \u{2192} pads navigate</p>
          <p><b>Backspace</b> \u{2192} menu</p>
        </div>
      `,
            confirmButtonText: "OK"
        });
    });
    const aboutBtn = $35da740d59af89ba$var$createMiniBtn("About Me", async ()=>{
        await $35da740d59af89ba$var$sampltonAlert({
            title: "About Me",
            width: 700,
            html: `
          <div style="
            text-align:left;
            line-height:1.7;
            max-height:65vh;
            overflow-y:auto;
            padding-right:10px;
          ">
  
            <p>
              <b>Martin z Divartu</b> is based in Zvolen, Slovakia.
            </p>
  
            <p>
              It is the solo music project of Martin Rybo\u{161}, combining
              electronic music with live vocals, transverse flute,
              guitar and live looping.
            </p>
  
            <p>
              The music of Martin z Divartu moves between electronic,
              cinematic, alternative and classical influences.
            </p>
  
            <p>
              A characteristic element of the project is the combination
              of organic instruments, rhythms and electronics performed
              entirely live, without the use of a computer during the
              musical performance.
            </p>
  
            <p>
              The focus is on emotional melodies and longer compositions
              that create a story and leave space for emotion,
              atmosphere and imagination.
            </p>
  
            <p>
              Martin is also a hobby coder and developer.
              His live performances are accompanied by original visual
              projections controlled from an MPC via MIDI and routed into
              his own custom web applications.
            </p>
  
            <hr style="
              border:0;
              border-top:1px solid #333;
              margin:20px 0;
            ">
  
            <p style="text-align:center;">
              <a
                href="https://www.divart.sk/martin-z-divartu/"
                target="_blank"
                rel="noopener noreferrer"
                style="color:white;text-decoration:underline;"
              >
                divart
              </a>
            </p>
            <p style="text-align:center;">
              <a
                href="https://www.youtube.com/results?search_query=martin+z+divartu"
                target="_blank"
                rel="noopener noreferrer"
                style="color:white;text-decoration:underline;"
              >
                youtube
              </a>
            </p>
            <p style="text-align:center;">
              <a
                href="https://open.spotify.com/artist/63L3WZLlxIahjeEAZI5WCH"
                target="_blank"
                rel="noopener noreferrer"
                style="color:white;text-decoration:underline;"
              >
                spotify
              </a>
            </p>
  
          </div>
        `,
            confirmButtonText: "CLOSE"
        });
    });
    const legalBtn = $35da740d59af89ba$var$createMiniBtn("Legal & Privacy", async ()=>{
        await $35da740d59af89ba$var$openLegalMenu();
    });
    panel.appendChild(userBtn);
    panel.appendChild(authBtn);
    if (!$35da740d59af89ba$var$currentUser) panel.appendChild(loadMainBtn);
    panel.appendChild(prepareAllBtn);
    // panel.appendChild(newProjectBtn);
    // panel.appendChild(exportBtn);
    // panel.appendChild(importBtn);
    panel.appendChild(importExportBtn);
    panel.appendChild(installBtn);
    // panel.appendChild(resetKeepAudioBtn);
    panel.appendChild(keyshots);
    if (!$35da740d59af89ba$var$currentUser) panel.appendChild(aboutBtn);
    panel.appendChild(legalBtn);
    if ($35da740d59af89ba$var$isPro) panel.appendChild(buyStorageBtn);
    // 🔹 TOGGLE ACTION
    toggleBtn.onclick = ()=>{
        panel.classList.toggle("hidden");
    };
    // 🔹 RIGHT FULLSCREEN
    const fullscreenBtn = document.createElement("div");
    fullscreenBtn.className = "pad-mini";
    fullscreenBtn.innerHTML = "\u26F6";
    fullscreenBtn.onclick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        $35da740d59af89ba$var$toggleFullscreen(fullscreenBtn);
    };
    // 🔹 APPEND
    wrapper.appendChild(toggleBtn);
    wrapper.appendChild(panel);
    wrapper.appendChild(fullscreenBtn);
    document.body.appendChild(wrapper);
}
function $35da740d59af89ba$var$createTableButton() {
    const btn = document.createElement("div");
    btn.className = "floating-table-btn";
    if ($35da740d59af89ba$var$viewMode === "menu") {
        btn.innerHTML = $35da740d59af89ba$var$songEditMode ? "\u2713" : "\u270E";
        btn.onclick = ()=>{
            $35da740d59af89ba$var$songEditMode = !$35da740d59af89ba$var$songEditMode;
            $35da740d59af89ba$var$renderSong();
        };
    } else {
        // SAMPLE LIBRARY
        if ($35da740d59af89ba$var$sampleLibraryMode) {
            btn.innerHTML = "\u270E";
            btn.onclick = ()=>{
                $35da740d59af89ba$var$stopSampleLibraryPreview();
                $35da740d59af89ba$var$sampleLibraryMode = false;
                $35da740d59af89ba$var$sampleLibraryTargetTrackIndex = null;
                $35da740d59af89ba$var$trackEditMode = true;
                $35da740d59af89ba$var$trackSettingsMode = false;
                $35da740d59af89ba$var$renderSong();
            };
            document.body.appendChild(btn);
            return;
        }
        // NORMAL SONG / TRACK EDIT
        btn.innerHTML = $35da740d59af89ba$var$trackEditMode ? "\u2713" : "\u270E";
        btn.onclick = ()=>{
            $35da740d59af89ba$var$trackEditMode = !$35da740d59af89ba$var$trackEditMode;
            $35da740d59af89ba$var$renderSong();
        };
    }
    document.body.appendChild(btn);
}
// helper
function $35da740d59af89ba$var$updateTrackSubtitle(track = null) {
    if (!$35da740d59af89ba$var$trackSubtitleEl || !document.body.contains($35da740d59af89ba$var$trackSubtitleEl)) {
        $35da740d59af89ba$var$trackSubtitleEl = document.createElement("div");
        $35da740d59af89ba$var$trackSubtitleEl.className = "track-subtitle";
        document.body.appendChild($35da740d59af89ba$var$trackSubtitleEl);
    }
    const text = String(track?.notes || "").trim();
    const visible = track?.notesVisible === true;
    if (!visible || !text) {
        $35da740d59af89ba$var$trackSubtitleEl.textContent = "";
        $35da740d59af89ba$var$trackSubtitleEl.classList.remove("visible");
        return;
    }
    $35da740d59af89ba$var$trackSubtitleEl.textContent = text;
    $35da740d59af89ba$var$trackSubtitleEl.classList.add("visible");
}
async function $35da740d59af89ba$var$getStorageInfo() {
    if (!$35da740d59af89ba$var$currentUser) return null;
    try {
        const token = await $35da740d59af89ba$var$currentUser.getIdToken();
        const res = await fetch(`${$35da740d59af89ba$var$R2_API}/storage`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        const data = await res.json();
        if (!res.ok || !data.ok) {
            console.error("Storage info failed:", data);
            return null;
        }
        //  console.log("STORAGE:", data);
        return data;
    } catch (err) {
        console.error("Storage info error:", err);
        return null;
    }
}
function $35da740d59af89ba$var$createMiniBtn(label, fn) {
    const btn = document.createElement("div");
    btn.className = "pad-mini";
    btn.innerHTML = label;
    btn.onclick = fn;
    return btn;
}
function $35da740d59af89ba$var$toggleFullscreen(btn) {
    if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen().catch((err)=>{
            console.error(err);
        });
        if (btn) btn.innerHTML = "\u2921";
    } else {
        document.exitFullscreen();
        if (btn) btn.innerHTML = "\u26F6";
    }
}
// =======================
// UTILS
// =======================
function $35da740d59af89ba$var$getCurrentActiveTrack() {
    const song = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex];
    if (!song) return null;
    const index = $35da740d59af89ba$var$padsList.indexOf($35da740d59af89ba$var$activePadEl);
    return index !== -1 ? song.tracks[index] : null;
}
function $35da740d59af89ba$var$getGridColumns() {
    if (!$35da740d59af89ba$var$padsList.length) return 1;
    const firstTop = $35da740d59af89ba$var$padsList[0].offsetTop;
    let cols = 0;
    for (let pad of $35da740d59af89ba$var$padsList){
        if (pad.offsetTop !== firstTop) break;
        cols++;
    }
    return cols || 1;
}
function $35da740d59af89ba$var$showLoader() {
    if (document.querySelector(".loader")) return;
    const loader = document.createElement("div");
    loader.className = "loader";
    document.body.appendChild(loader);
}
function $35da740d59af89ba$var$hideLoader() {
    document.querySelector(".loader")?.remove();
}
function $35da740d59af89ba$var$isOnlyNumber(val) {
    return /^\d+$/.test(String(val).trim());
}
function $35da740d59af89ba$var$buildSongPads(grid) {
    $35da740d59af89ba$var$padsList = [];
    let index = 1;
    $35da740d59af89ba$var$songs.forEach((song, i)=>{
        const pad = document.createElement("div");
        pad.className = "pad";
        if ($35da740d59af89ba$var$songEditMode) pad.classList.add("song-edit-pad");
        pad.innerHTML = `
      <div class="pad-key">${index}</div>
      <div class="pad-title"></div>
      <div class="pad-info">${song.tracks.length} tracks</div>
    `;
        const titleEl = pad.querySelector(".pad-title");
        titleEl.textContent = song.title;
        // =========================
        // EDIT MODE
        // =========================
        if ($35da740d59af89ba$var$songEditMode) {
            titleEl.classList.add("song-edit-title");
            titleEl.onclick = (e)=>{
                e.stopPropagation();
                titleEl.contentEditable = "true";
                titleEl.focus();
                const range = document.createRange();
                range.selectNodeContents(titleEl);
                const selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
            };
            const finishTitleEdit = async ()=>{
                let val = titleEl.textContent.trim();
                if (!val || $35da740d59af89ba$var$isOnlyNumber(val)) val = "New Song";
                song.title = val;
                titleEl.textContent = val;
                titleEl.contentEditable = "false";
                song.tracks.forEach((track)=>{
                    track.song = val;
                });
                await $35da740d59af89ba$var$saveProject();
            };
            titleEl.onblur = finishTitleEdit;
            titleEl.onkeydown = (e)=>{
                if (e.key === "Enter") {
                    e.preventDefault();
                    titleEl.blur();
                }
            };
            // DRAG HANDLE
            const dragHandle = document.createElement("div");
            dragHandle.className = "song-drag-handle";
            dragHandle.textContent = "\u283F";
            dragHandle.draggable = true;
            dragHandle.addEventListener("dragstart", (e)=>{
                e.stopPropagation();
                $35da740d59af89ba$var$draggedSongIndex = i;
                pad.classList.add("dragging");
                if (e.dataTransfer) e.dataTransfer.effectAllowed = "move";
            });
            dragHandle.addEventListener("dragend", ()=>{
                pad.classList.remove("dragging");
            });
            pad.appendChild(dragHandle);
            // DELETE
            const deleteBtn = document.createElement("div");
            deleteBtn.className = "song-delete-btn";
            deleteBtn.textContent = "\u2715";
            deleteBtn.onclick = async (e)=>{
                e.stopPropagation();
                const songToDelete = $35da740d59af89ba$var$songs[i];
                if (!songToDelete) return;
                const tracks = songToDelete.tracks || [];
                for (const track of tracks){
                    const audioRef = track.mp3;
                    if ($35da740d59af89ba$var$isR2Audio(audioRef)) {
                        const ok = await $35da740d59af89ba$var$deleteR2Audio(audioRef);
                        if (!ok) {
                            await $35da740d59af89ba$var$sampltonAlert({
                                title: "Delete failed",
                                text: "Song could not be deleted.",
                                icon: "error"
                            });
                            return;
                        }
                    }
                }
                $35da740d59af89ba$var$songs.splice(i, 1);
                await $35da740d59af89ba$var$saveProject();
                $35da740d59af89ba$var$renderSong();
            };
            pad.appendChild(deleteBtn);
            // DROP TARGET
            pad.addEventListener("dragover", (e)=>{
                e.preventDefault();
                if ($35da740d59af89ba$var$draggedSongIndex === null || $35da740d59af89ba$var$draggedSongIndex === i) return;
                pad.classList.add("drag-over");
            });
            pad.addEventListener("dragleave", ()=>{
                pad.classList.remove("drag-over");
            });
            pad.addEventListener("drop", async (e)=>{
                e.preventDefault();
                e.stopPropagation();
                pad.classList.remove("drag-over");
                if ($35da740d59af89ba$var$draggedSongIndex === null || $35da740d59af89ba$var$draggedSongIndex === i) return;
                const fromIndex = $35da740d59af89ba$var$draggedSongIndex;
                const movedSong = $35da740d59af89ba$var$songs.splice(fromIndex, 1)[0];
                let targetIndex = i;
                if (fromIndex < i) targetIndex--;
                $35da740d59af89ba$var$songs.splice(targetIndex, 0, movedSong);
                $35da740d59af89ba$var$draggedSongIndex = null;
                await $35da740d59af89ba$var$saveProject();
                $35da740d59af89ba$var$renderSong();
            });
        }
        // =========================
        // NORMAL MODE
        // =========================
        pad.onclick = async ()=>{
            if ($35da740d59af89ba$var$songEditMode) return;
            pad.classList.add("loading");
            try {
                $35da740d59af89ba$var$currentSongIndex = i;
                $35da740d59af89ba$var$selectedSongIndex = i;
                $35da740d59af89ba$var$viewMode = "song";
                const currentSong = $35da740d59af89ba$var$songs[i];
                // Ak skladba ešte nemá žiadne audio,
                // otvor ju rovno v edit režime s + upload tlačidlom
                const hasAudio = currentSong.tracks.some((track)=>String(track.mp3 || "").trim() !== "");
                if (!hasAudio) {
                    // ak by nemala ani jeden track, vytvor základný
                    if (!currentSong.tracks.length) {
                        currentSong.tracks.push({
                            song: currentSong.title,
                            name: "New Loop",
                            notes: "",
                            mp3: "",
                            bpm: 120,
                            signature: 4,
                            bars: 4,
                            start_at: 0.01,
                            fadeintime: 0.5,
                            repeat: 1,
                            autoplay: 1
                        });
                        await $35da740d59af89ba$var$saveProject();
                    }
                    $35da740d59af89ba$var$trackEditMode = true;
                    $35da740d59af89ba$var$trackSettingsMode = false;
                } else $35da740d59af89ba$var$trackEditMode = false;
                await $35da740d59af89ba$var$ensureAudioContext();
                if (!navigator.onLine) {
                    pad.classList.remove("loading");
                    $35da740d59af89ba$var$renderSong();
                    return;
                }
                const showFirstLoadHint = !$35da740d59af89ba$var$currentUser && localStorage.getItem("guestFirstLoadHintSeen") !== "1";
                if (showFirstLoadHint) $35da740d59af89ba$var$updateTrackSubtitle({
                    notes: "First load saves audio in your browser. Next time it loads much faster and works offline. You can also preload all songs from Menu.",
                    notesVisible: true
                });
                await $35da740d59af89ba$var$cacheSongTracks(currentSong.tracks);
                await $35da740d59af89ba$var$prepareSong(currentSong.tracks);
                if (showFirstLoadHint) {
                    localStorage.setItem("guestFirstLoadHintSeen", "1");
                    $35da740d59af89ba$var$updateTrackSubtitle({
                        notes: "Ready for fast & offline playback \u2713",
                        notesVisible: true
                    });
                }
            } catch (err) {
                if (err.message === "NOT_CACHED" || err.message === "OFFLINE") {
                    pad.classList.remove("loading");
                    return;
                }
                console.error("Audio load failed:", err);
                pad.classList.remove("loading");
            }
            pad.classList.remove("loading");
            $35da740d59af89ba$var$renderSong();
        };
        grid.appendChild(pad);
        $35da740d59af89ba$var$padsList.push(pad);
        index++;
    });
    // =========================
    // ADD SONG PAD
    // =========================
    if ($35da740d59af89ba$var$songEditMode) {
        const addPad = document.createElement("div");
        addPad.className = "pad add-song-pad";
        addPad.innerHTML = `
    <div class="pad-key">+</div>
    <div class="pad-title">ADD SONG</div>
    <div class="pad-info">new song</div>
  `;
        addPad.onclick = async (e)=>{
            e.preventDefault();
            e.stopPropagation();
            if (!$35da740d59af89ba$var$isPro && $35da740d59af89ba$var$songs.length >= 1) {
                await $35da740d59af89ba$var$sampltonAlert({
                    title: "FREE limit",
                    text: "FREE version allows only 1 song.",
                    icon: "info"
                });
                return;
            }
            const newSong = {
                title: "New Song",
                tracks: []
            };
            // pridaj okamžite do RAM
            $35da740d59af89ba$var$songs.push(newSong);
            $35da740d59af89ba$var$selectedSongIndex = $35da740d59af89ba$var$songs.length - 1;
            $35da740d59af89ba$var$currentSongIndex = $35da740d59af89ba$var$selectedSongIndex;
            // najprv prekresli, aby bolo hneď vidieť výsledok
            $35da740d59af89ba$var$renderSong();
            try {
                await $35da740d59af89ba$var$saveProject();
            //  console.log("✅ Song added:", newSong);
            } catch (err) {
                console.error("\u274C Add song save failed:", err);
            }
        };
        grid.appendChild(addPad);
    }
    // FREE → BUY PRO
    if ($35da740d59af89ba$var$authReady && !$35da740d59af89ba$var$isPro && !$35da740d59af89ba$var$songEditMode) {
        const proPad = document.createElement("div");
        proPad.className = "pad buy-pro-pad";
        proPad.innerHTML = `
      <div class="pad-key">P</div>
      <div class="pad-title">BUY PRO for 10\u{20AC}</div>
      <div class="pad-info">Unlimited songs / 100 mb</div>
    `;
        proPad.onclick = async ()=>{
            if (!$35da740d59af89ba$var$currentUser) {
                await $35da740d59af89ba$var$sampltonAlert({
                    title: "Sign in required",
                    text: "Please sign in before buying PRO.",
                    icon: "info"
                });
                return;
            }
            const confirm = await $35da740d59af89ba$var$sampltonAlert({
                title: "Samplton PRO",
                icon: "info",
                html: `
          <div style="text-align:left; line-height:1.7;">
      
            <p style="
              font-size:24px;
              font-weight:bold;
              text-align:center;
            ">
              10 \u{20AC}
            </p>
      
            <p><b>Samplton PRO includes:</b></p>
      
            <p>
              \u{2713} Unlimited songs<br>
              \u{2713} 100 MB cloud storage<br>
              \u{2713} PRO features
            </p>
      
            <hr style="
              border:0;
              border-top:1px solid #333;
              margin:18px 0;
            ">
      
            ${$35da740d59af89ba$var$legalCheckoutText()}
      
          </div>
        `,
                showCancelButton: true,
                confirmButtonText: "CONTINUE TO PAYMENT",
                cancelButtonText: "CANCEL",
                didOpen: ()=>{
                    const termsLink = document.querySelector(".checkout-terms-link");
                    const privacyLink = document.querySelector(".checkout-privacy-link");
                    termsLink?.addEventListener("click", async (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).close();
                        await $35da740d59af89ba$var$openLegalSection("terms", false);
                        proPad.click();
                    });
                    privacyLink?.addEventListener("click", async (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        (0, (/*@__PURE__*/$parcel$interopDefault($99dc7a165646c27f$exports))).close();
                        await $35da740d59af89ba$var$openLegalSection("privacy", false);
                        proPad.click();
                    });
                }
            });
            if (!confirm.isConfirmed) return;
            try {
                proPad.classList.add("loading");
                const token = await $35da740d59af89ba$var$currentUser.getIdToken();
                const res = await fetch(`${$35da740d59af89ba$var$R2_API}/create-checkout`, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                });
                const data = await res.json();
                if (!res.ok || !data.ok || !data.url) {
                    console.error("Checkout failed:", data);
                    await $35da740d59af89ba$var$sampltonAlert({
                        title: "Checkout failed",
                        text: "PRO checkout could not be started.",
                        icon: "error"
                    });
                    return;
                }
                window.location.href = data.url;
            } catch (err) {
                console.error("Checkout error:", err);
                await $35da740d59af89ba$var$sampltonAlert({
                    title: "Checkout failed",
                    text: "PRO checkout could not be started.",
                    icon: "error"
                });
            } finally{
                proPad.classList.remove("loading");
            }
        };
        grid.appendChild(proPad);
    }
}
function $35da740d59af89ba$var$openNotesModal(text) {
    const modal = document.createElement("div");
    modal.className = "notes-modal";
    const box = document.createElement("div");
    box.className = "notes-box";
    box.innerHTML = `
    <div>${text}</div>
  `;
    modal.appendChild(box);
    document.body.appendChild(modal);
    modal.onclick = ()=>modal.remove();
    box.onclick = (e)=>{
        e.stopPropagation();
    };
}
function $35da740d59af89ba$var$getUrlParam(name) {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
}
function $35da740d59af89ba$var$updateMetroCounter() {
    if (!$35da740d59af89ba$var$metroCounterEl || !$35da740d59af89ba$var$audioCtx || !$35da740d59af89ba$var$source) {
        requestAnimationFrame($35da740d59af89ba$var$updateMetroCounter);
        return;
    }
    const beatDuration = 60 / $35da740d59af89ba$var$tempo;
    const now = $35da740d59af89ba$var$audioCtx.currentTime;
    const elapsed = now - $35da740d59af89ba$var$currentStartAt;
    if (elapsed >= 0) {
        const totalBeats = Math.floor(elapsed / beatDuration);
        const beatsPerLoop = $35da740d59af89ba$var$currentSignature * $35da740d59af89ba$var$currentBars;
        const totalLoopBeats = beatsPerLoop * $35da740d59af89ba$var$currentRepeat;
        const loopBeat = totalBeats % totalLoopBeats;
        const bar = Math.floor(loopBeat / $35da740d59af89ba$var$currentSignature) + 1;
        const beat = loopBeat % $35da740d59af89ba$var$currentSignature + 1;
        $35da740d59af89ba$var$metroCounterEl.textContent = `${bar}l${beat}`;
    }
    requestAnimationFrame($35da740d59af89ba$var$updateMetroCounter);
}
function $35da740d59af89ba$var$getNextBeatTime() {
    if (!$35da740d59af89ba$var$audioCtx) return 0;
    const now = $35da740d59af89ba$var$audioCtx.currentTime;
    const beatDuration = 60 / $35da740d59af89ba$var$tempo;
    // 🔥 ak ešte nič nehrá → zarovnaj na najbližší beat OD TERAZ
    if (!$35da740d59af89ba$var$source) return Math.ceil(now / beatDuration) * beatDuration;
    const elapsed = Math.max(0, now - $35da740d59af89ba$var$currentStartAt);
    const beatsPassed = Math.floor(elapsed / beatDuration);
    return $35da740d59af89ba$var$currentStartAt + (beatsPassed + 1) * beatDuration;
}
function $35da740d59af89ba$var$updateActivePadBPM(bpm) {
    if (!$35da740d59af89ba$var$activePadEl) return;
    const duration = 60 / bpm;
    $35da740d59af89ba$var$activePadEl.style.animationDuration = duration + "s";
}
let $35da740d59af89ba$var$loaderEl = null;
function $35da740d59af89ba$var$getFileName(url) {
    if (!url) return "";
    let n = url.split("/").pop();
    n = n.replace(/\.[^/.]+$/, "");
    n = n.replace(/[-_]/g, " ");
    return n;
}
const $35da740d59af89ba$var$R2_API = "https://samplton-api.matorybos.workers.dev";
function $35da740d59af89ba$var$isR2Audio(value) {
    return String(value || "").startsWith("r2:");
}
function $35da740d59af89ba$var$getR2FileName(value) {
    return String(value || "").slice(3);
}
function $35da740d59af89ba$var$fixUrl(url) {
    if (!url) return "";
    const s = String(url).trim();
    if (!s) return "";
    // R2 reference nechaj tak
    if (s.startsWith("r2:")) return s;
    if (s.startsWith("http")) return s;
    return "https://www.divartwp.sk" + s;
}
function $35da740d59af89ba$var$toNumber(val) {
    if (val == null) return 0;
    return parseFloat(String(val).replace(/\s+/g, "") // 🔥 odstráni všetky medzery
    .replace(",", ".") // čiarka → bodka
    ) || 0;
}
// =======================
// TOP BAR
// =======================
function $35da740d59af89ba$var$createTopBar() {
    const bar = document.createElement("div");
    bar.className = "top-bar";
    // 🔥 zobraz len v SONG view
    if ($35da740d59af89ba$var$viewMode === "song") {
        const songNumber = document.createElement("div");
        songNumber.className = "song-number";
        songNumber.textContent = $35da740d59af89ba$var$currentSongIndex + 1;
        const title = document.createElement("div");
        title.className = "song-title";
        title.textContent = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex]?.title || "";
        // klik = späť do menu (super UX)
        title.onclick = ()=>{
            $35da740d59af89ba$var$viewMode = "menu";
            $35da740d59af89ba$var$renderSong();
        };
        bar.appendChild(songNumber);
        bar.appendChild(title);
    }
    document.body.appendChild(bar);
}
// =======================
// BUILD PADS
// =======================
async function $35da740d59af89ba$var$previewTrack(track, pad) {
    if (!track?.mp3) return;
    await $35da740d59af89ba$var$ensureAudioContext();
    // offline → musí byť v cache
    if (!navigator.onLine) {
        const cached = await $35da740d59af89ba$var$isTrackCached(track.mp3);
        if (!cached) return;
    }
    pad.classList.add("loading");
    try {
        const buffer = await $35da740d59af89ba$var$loadAudio(track.mp3);
        const bpm = $35da740d59af89ba$var$toNumber(track.bpm) || 120;
        const bars = $35da740d59af89ba$var$toNumber(track.bars) || 1;
        const signature = $35da740d59af89ba$var$toNumber(track.signature) || 4;
        const repeat = $35da740d59af89ba$var$toNumber(track.repeat) || 1;
        const startAtOffset = $35da740d59af89ba$var$toNumber(track.start_at);
        const duration = 60 / bpm * signature * bars;
        // ak už niečo hrá → stop
        if ($35da740d59af89ba$var$source) {
            try {
                $35da740d59af89ba$var$source.stop();
            } catch (e) {}
            $35da740d59af89ba$var$source = null;
        }
        if ($35da740d59af89ba$var$schedulerTimer) {
            clearTimeout($35da740d59af89ba$var$schedulerTimer);
            $35da740d59af89ba$var$schedulerTimer = null;
        }
        if ($35da740d59af89ba$var$activePadEl) $35da740d59af89ba$var$activePadEl.classList.remove("active");
        const startTime = $35da740d59af89ba$var$audioCtx.currentTime + 0.03;
        const newSource = $35da740d59af89ba$var$audioCtx.createBufferSource();
        newSource.buffer = buffer;
        const newGain = $35da740d59af89ba$var$audioCtx.createGain();
        newGain.gain.value = 1;
        newSource.connect(newGain);
        newGain.connect($35da740d59af89ba$var$audioCtx.destination);
        newSource.loop = true;
        newSource.loopStart = startAtOffset;
        newSource.loopEnd = startAtOffset + duration;
        newSource.start(startTime, startAtOffset);
        $35da740d59af89ba$var$source = newSource;
        $35da740d59af89ba$var$currentGain = newGain;
        $35da740d59af89ba$var$tempo = bpm;
        $35da740d59af89ba$var$currentSignature = signature;
        $35da740d59af89ba$var$currentBars = bars;
        $35da740d59af89ba$var$currentStartAt = startTime;
        $35da740d59af89ba$var$currentDuration = duration;
        $35da740d59af89ba$var$currentRepeat = repeat;
        $35da740d59af89ba$var$currentRepeatIndex = 0;
        $35da740d59af89ba$var$nextNoteTime = startTime;
        $35da740d59af89ba$var$lastSwitchTime = 0;
        $35da740d59af89ba$var$activePadEl = pad;
        pad.classList.add("active");
        $35da740d59af89ba$var$updateTrackSubtitle(track);
        if ($35da740d59af89ba$var$schedulerTimer) clearTimeout($35da740d59af89ba$var$schedulerTimer);
        $35da740d59af89ba$var$scheduler();
        if (!$35da740d59af89ba$var$isMonitoring) {
            $35da740d59af89ba$var$isMonitoring = true;
            $35da740d59af89ba$var$monitorLoop();
        }
        $35da740d59af89ba$var$updateActivePadBPM(bpm);
        $35da740d59af89ba$var$updatePadCounters();
    } catch (err) {
        console.error("Preview failed:", err);
    }
    pad.classList.remove("loading");
}
function $35da740d59af89ba$var$buildTrackSettingsPads(grid, track, trackIndex) {
    $35da740d59af89ba$var$padsList = [];
    if (!track) return;
    // =========================
    // TRACK PAD
    // =========================
    const trackName = String(track.name || "").trim() || $35da740d59af89ba$var$getFileName(track.mp3) || "New Loop";
    const trackPad = document.createElement("div");
    trackPad.className = "pad track-settings-main";
    trackPad.innerHTML = `
  <div class="pad-key">${trackIndex + 1}</div>
  <div class="pad-title">${trackName}</div>
  <div class="pad-info">PLAY PREVIEW</div>
`;
    trackPad.onclick = async ()=>{
        await $35da740d59af89ba$var$previewTrack(track, trackPad);
    };
    trackPad.innerHTML = `
    <div class="pad-key">${trackIndex + 1}</div>
    <div class="pad-title">${trackName}</div>
    <div class="pad-info">TRACK SETTINGS</div>
  `;
    grid.appendChild(trackPad);
    // =========================
    // STOP PAD
    // =========================
    const stopPad = document.createElement("div");
    stopPad.className = "pad track-settings-stop";
    stopPad.innerHTML = `
  <div class="pad-key playstop">\u{25A0}</div>
  <div class="pad-title">STOP</div>
  <div class="pad-info">stop preview</div>
`;
    stopPad.onclick = (e)=>{
        e.stopPropagation();
        if ($35da740d59af89ba$var$source) {
            try {
                $35da740d59af89ba$var$source.stop();
            } catch (err) {}
            $35da740d59af89ba$var$source = null;
        }
        if ($35da740d59af89ba$var$schedulerTimer) {
            clearTimeout($35da740d59af89ba$var$schedulerTimer);
            $35da740d59af89ba$var$schedulerTimer = null;
        }
        $35da740d59af89ba$var$currentStartAt = 0;
        $35da740d59af89ba$var$currentDuration = 0;
        $35da740d59af89ba$var$nextNoteTime = 0;
        $35da740d59af89ba$var$queuedTrack = null;
        if ($35da740d59af89ba$var$activePadEl) $35da740d59af89ba$var$activePadEl.classList.remove("active");
        if ($35da740d59af89ba$var$queuedPadEl) $35da740d59af89ba$var$queuedPadEl.classList.remove("queued");
        $35da740d59af89ba$var$activePadEl = null;
        $35da740d59af89ba$var$queuedPadEl = null;
        $35da740d59af89ba$var$isMonitoring = false;
        trackPad.classList.remove("active");
    };
    grid.appendChild(stopPad);
    // =========================
    // HELPER - NUMBER PAD
    // =========================
    function createNumberSetting(label, field, fallback = 0) {
        const pad = document.createElement("div");
        pad.className = "pad setting-pad";
        const value = track[field] === "" || track[field] == null ? fallback : track[field];
        pad.innerHTML = `
      <div class="setting-label">${label}</div>
  
      <input
      class="setting-number-input"
      type="number"
      inputmode="decimal"
      step="0.01"
      value="${value}"  
    >
    `;
        const input = pad.querySelector(".setting-number-input");
        const saveValue = ()=>{
            const num = $35da740d59af89ba$var$toNumber(input.value);
            track[field] = num;
            if (field === "start_at" && num < 0) track[field] = 0;
            $35da740d59af89ba$var$handleLiveUpdate(track);
            $35da740d59af89ba$var$scheduleSave();
        };
        input.addEventListener("input", saveValue);
        input.addEventListener("click", (e)=>{
            e.stopPropagation();
            input.select();
        });
        grid.appendChild(pad);
    }
    // =========================
    // SETTINGS
    // =========================
    createNumberSetting("BPM", "bpm", 120);
    createNumberSetting("BARS", "bars", 4);
    createNumberSetting("REPEAT", "repeat", 1);
    createNumberSetting("SIGNATURE", "signature", 4);
    createNumberSetting("START", "start_at", 0.01);
    createNumberSetting("FADE", "fadeintime", 0);
    // =========================
    // AUTOPLAY
    // =========================
    const autoplayPad = document.createElement("div");
    autoplayPad.className = "pad setting-pad autoplay-setting-pad";
    const autoplayOn = track.autoplay === "" || track.autoplay == null ? true : $35da740d59af89ba$var$toNumber(track.autoplay) !== 0;
    function updateAutoplayPad() {
        const on = track.autoplay === "" || track.autoplay == null ? true : $35da740d59af89ba$var$toNumber(track.autoplay) !== 0;
        autoplayPad.innerHTML = `
      <div class="setting-label">AUTOPLAY</div>
      <div class="setting-value">${on ? "ON" : "OFF"}</div>
      <div class="pad-info">tap to switch</div>
    `;
    }
    autoplayPad.onclick = async ()=>{
        const current = track.autoplay === "" || track.autoplay == null ? 1 : $35da740d59af89ba$var$toNumber(track.autoplay);
        track.autoplay = current === 0 ? 1 : 0;
        updateAutoplayPad();
        $35da740d59af89ba$var$handleLiveUpdate(track);
        await $35da740d59af89ba$var$saveProject();
    };
    updateAutoplayPad();
    grid.appendChild(autoplayPad);
    // =========================
    // NOTES
    // =========================
    const notesPad = document.createElement("div");
    notesPad.className = "pad setting-pad notes-setting-pad";
    notesPad.innerHTML = `
  <div class="setting-label">NOTES</div>

  <div
    class="setting-notes"
    contenteditable="true"
  ></div>

  <label class="notes-visible-option">
    <input
      type="checkbox"
      class="notes-visible-checkbox"
      ${track.notesVisible === true ? "checked" : ""}
    >
    subtitle
  </label>
`;
    const notesEl = notesPad.querySelector(".setting-notes");
    const notesCheckbox = notesPad.querySelector(".notes-visible-checkbox");
    notesCheckbox.onclick = (e)=>{
        e.stopPropagation();
    };
    notesCheckbox.onchange = async ()=>{
        track.notesVisible = notesCheckbox.checked;
        $35da740d59af89ba$var$updateTrackSubtitle(track === $35da740d59af89ba$var$getCurrentActiveTrack() ? track : null);
        await $35da740d59af89ba$var$saveProject();
    };
    notesEl.textContent = track.notes || "";
    notesEl.onclick = (e)=>{
        e.stopPropagation();
        notesEl.focus();
    };
    notesEl.oninput = ()=>{
        track.notes = notesEl.textContent;
        $35da740d59af89ba$var$scheduleSave();
    };
    grid.appendChild(notesPad);
    // =========================
    // BACK
    // =========================
    const backPad = document.createElement("div");
    backPad.className = "pad back-pad";
    backPad.innerHTML = `
  <div class="pad-key playstop">\u{25C0}\u{25C0}</div>
    <div class="pad-title">BACK</div>
    <div class="pad-info">track editor</div>
  `;
    backPad.onclick = ()=>{
        $35da740d59af89ba$var$trackSettingsMode = false;
        $35da740d59af89ba$var$trackSettingsIndex = null;
        $35da740d59af89ba$var$trackEditMode = true;
        $35da740d59af89ba$var$renderSong();
    };
    grid.appendChild(backPad);
}
async function $35da740d59af89ba$var$buildSampleLibraryPads(grid) {
    $35da740d59af89ba$var$padsList = [];
    if (!$35da740d59af89ba$var$currentUser) {
        const infoPad = document.createElement("div");
        infoPad.className = "pad";
        infoPad.innerHTML = `
      <div>\u{1F464}</div>
      <div class="pad-title">NO LIBRARY</div>
      <div class="pad-info">click to sign in</div>
    `;
        infoPad.onclick = async ()=>{
            const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
            try {
                if (isMobile) await (0, $b38ec4aa5ef4f8c4$export$3b513254972cfc9c)((0, $117415e422c8aaf1$export$73693bad9f5880b0), (0, $117415e422c8aaf1$export$ca328f169d304df4));
                else await (0, $b38ec4aa5ef4f8c4$export$f38c853ae54ed474)((0, $117415e422c8aaf1$export$73693bad9f5880b0), (0, $117415e422c8aaf1$export$ca328f169d304df4));
            } catch (error) {
                console.error("Google login error:", error);
                await $35da740d59af89ba$var$sampltonAlert({
                    title: "Sign in failed",
                    text: error.message,
                    icon: "error"
                });
            }
        };
        grid.appendChild(infoPad);
        // BACK
        const backPad = document.createElement("div");
        backPad.className = "pad back-pad";
        backPad.innerHTML = `
      <div class="pad-key playstop">\u{25C0}\u{25C0}</div>
      <div class="pad-title">BACK</div>
      <div class="pad-info">track editor</div>
    `;
        backPad.onclick = ()=>{
            $35da740d59af89ba$var$sampleLibraryMode = false;
            $35da740d59af89ba$var$sampleLibraryTargetTrackIndex = null;
            $35da740d59af89ba$var$trackEditMode = true;
            $35da740d59af89ba$var$trackSettingsMode = false;
            $35da740d59af89ba$var$renderSong();
        };
        grid.appendChild(backPad);
        return;
    }
    const loadingPad = document.createElement("div");
    loadingPad.className = "pad";
    loadingPad.innerHTML = `
    <div class="pad-title">LOADING...</div>
    <div class="pad-info">Sample Library</div>
  `;
    grid.appendChild(loadingPad);
    try {
        const token = await $35da740d59af89ba$var$currentUser.getIdToken();
        const res = await fetch(`${$35da740d59af89ba$var$R2_API}/files`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        const data = await res.json();
        loadingPad.remove();
        if (!res.ok || !data.ok) throw new Error(data.error || "FILES_LOAD_FAILED");
        const files = data.files || [];
        if (!files.length) {
            const emptyPad = document.createElement("div");
            emptyPad.className = "pad";
            emptyPad.innerHTML = `
        <div class="pad-title">EMPTY LIBRARY</div>
        <div class="pad-info">No audio files</div>
      `;
            grid.appendChild(emptyPad);
        }
        files.forEach((file, index)=>{
            const pad = document.createElement("div");
            pad.className = "pad sample-file-pad";
            const sizeMB = Number(file.size || 0) / 1024 / 1024;
            const displayName = String(file.name || file.file || "Audio").replace(/\.[^/.]+$/, "");
            pad.innerHTML = `
          ${$35da740d59af89ba$var$sampleLibraryTargetTrackIndex !== null ? `<div class="sample-load-btn">LOAD</div>` : `<div class="sample-delete-btn">\u{2715}</div>`}
        
         
          <div class="pad-title"></div>
          <div class="pad-info">${sizeMB.toFixed(1)} MB</div>
        
          <div class="sample-pause-btn">\u{23F8}</div>
        `;
            pad.querySelector(".pad-title").textContent = displayName;
            const audioRef = file.ref || `r2:${file.file}`;
            // =========================
            // LOAD INTO TRACK
            // =========================
            const loadBtn = pad.querySelector(".sample-load-btn");
            if (loadBtn) loadBtn.onclick = async (e)=>{
                e.stopPropagation();
                const song = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex];
                if (!song) return;
                const track = song.tracks[$35da740d59af89ba$var$sampleLibraryTargetTrackIndex];
                if (!track) return;
                track.mp3 = audioRef;
                track.fileName = file.name || file.file || "";
                track.fileSize = Number(file.size || 0);
                if (!String(track.name || "").trim() || track.name === "New Loop") track.name = displayName;
                await $35da740d59af89ba$var$saveProject();
                // priprav sample aj lokálne
                await $35da740d59af89ba$var$cacheSongTracks([
                    {
                        mp3: audioRef
                    }
                ]);
                await $35da740d59af89ba$var$prepareSong([
                    {
                        mp3: audioRef
                    }
                ]);
                $35da740d59af89ba$var$stopSampleLibraryPreview();
                $35da740d59af89ba$var$sampleLibraryMode = false;
                $35da740d59af89ba$var$sampleLibraryTargetTrackIndex = null;
                $35da740d59af89ba$var$trackEditMode = true;
                $35da740d59af89ba$var$renderSong();
            };
            const deleteBtn = pad.querySelector(".sample-delete-btn");
            if (deleteBtn) deleteBtn.onclick = async (e)=>{
                e.stopPropagation();
                const usedBy = [];
                $35da740d59af89ba$var$songs.forEach((song, songIndex)=>{
                    (song.tracks || []).forEach((track, trackIndex)=>{
                        if (track.mp3 === audioRef) usedBy.push({
                            songIndex: songIndex,
                            trackIndex: trackIndex,
                            songTitle: song.title,
                            trackName: track.name
                        });
                    });
                });
                let message = `Delete "${displayName}" from Sample Library?`;
                if (usedBy.length > 0) message = `"${displayName}" is used by ${usedBy.length} track(s).\n\n` + `Deleting it will make those tracks lose their audio.\n\n` + `Delete anyway?`;
                const result = await $35da740d59af89ba$var$sampltonAlert({
                    title: "Delete sample?",
                    text: message,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "DELETE",
                    cancelButtonText: "CANCEL"
                });
                if (!result.isConfirmed) return;
                $35da740d59af89ba$var$stopSampleLibraryPreview();
                const ok = await $35da740d59af89ba$var$deleteR2Audio(audioRef);
                if (!ok) {
                    await $35da740d59af89ba$var$sampltonAlert({
                        title: "Delete failed",
                        text: "Sample could not be deleted.",
                        icon: "error"
                    });
                    return;
                }
                $35da740d59af89ba$var$renderSong();
            };
            // =========================
            // PAD CLICK = PLAY / RESTART
            // =========================
            pad.onclick = async ()=>{
                try {
                    await $35da740d59af89ba$var$ensureAudioContext();
                    pad.classList.add("loading");
                    const existing = await $35da740d59af89ba$var$loadFromDB(audioRef);
                    if (!existing) await $35da740d59af89ba$var$cacheSongTracks([
                        {
                            mp3: audioRef
                        }
                    ]);
                    const buffer = await $35da740d59af89ba$var$loadAudio(audioRef);
                    $35da740d59af89ba$var$stopSampleLibraryPreview();
                    $35da740d59af89ba$var$samplePreviewBuffer = buffer;
                    $35da740d59af89ba$var$samplePreviewPad = pad;
                    $35da740d59af89ba$var$samplePreviewOffset = 0;
                    $35da740d59af89ba$var$samplePreviewPaused = false;
                    const previewSource = $35da740d59af89ba$var$audioCtx.createBufferSource();
                    previewSource.buffer = buffer;
                    previewSource.loop = false;
                    const gain = $35da740d59af89ba$var$audioCtx.createGain();
                    gain.gain.value = 1;
                    previewSource.connect(gain);
                    gain.connect($35da740d59af89ba$var$audioCtx.destination);
                    $35da740d59af89ba$var$samplePreviewStartedAt = $35da740d59af89ba$var$audioCtx.currentTime;
                    previewSource.start(0, $35da740d59af89ba$var$samplePreviewOffset);
                    $35da740d59af89ba$var$samplePreviewSource = previewSource;
                    pad.classList.add("active");
                    previewSource.onended = ()=>{
                        if ($35da740d59af89ba$var$samplePreviewSource === previewSource && !$35da740d59af89ba$var$samplePreviewPaused) {
                            $35da740d59af89ba$var$samplePreviewSource = null;
                            $35da740d59af89ba$var$samplePreviewBuffer = null;
                            $35da740d59af89ba$var$samplePreviewOffset = 0;
                            pad.classList.remove("active");
                            if ($35da740d59af89ba$var$samplePreviewPad === pad) $35da740d59af89ba$var$samplePreviewPad = null;
                        }
                    };
                } catch (err) {
                    console.error("Sample preview failed:", err);
                    $35da740d59af89ba$var$sampltonAlert({
                        title: "Audio preview failed",
                        icon: "error"
                    });
                } finally{
                    pad.classList.remove("loading");
                }
            };
            // =========================
            // PAUSE / RESUME
            // =========================
            const pauseBtn = pad.querySelector(".sample-pause-btn");
            pauseBtn.onclick = async (e)=>{
                e.stopPropagation();
                await $35da740d59af89ba$var$ensureAudioContext();
                // iný sample ešte nehrá
                if ($35da740d59af89ba$var$samplePreviewPad !== pad || !$35da740d59af89ba$var$samplePreviewBuffer) {
                    pad.click();
                    return;
                }
                // PAUSE
                if ($35da740d59af89ba$var$samplePreviewSource && !$35da740d59af89ba$var$samplePreviewPaused) {
                    const elapsed = $35da740d59af89ba$var$audioCtx.currentTime - $35da740d59af89ba$var$samplePreviewStartedAt;
                    $35da740d59af89ba$var$samplePreviewOffset += elapsed;
                    if ($35da740d59af89ba$var$samplePreviewOffset >= $35da740d59af89ba$var$samplePreviewBuffer.duration) $35da740d59af89ba$var$samplePreviewOffset = 0;
                    $35da740d59af89ba$var$samplePreviewPaused = true;
                    try {
                        $35da740d59af89ba$var$samplePreviewSource.stop();
                    } catch (err) {}
                    $35da740d59af89ba$var$samplePreviewSource = null;
                    pauseBtn.textContent = "\u25B6";
                    pad.classList.remove("active");
                    return;
                }
                // RESUME
                if ($35da740d59af89ba$var$samplePreviewPaused && $35da740d59af89ba$var$samplePreviewBuffer) {
                    const previewSource = $35da740d59af89ba$var$audioCtx.createBufferSource();
                    previewSource.buffer = $35da740d59af89ba$var$samplePreviewBuffer;
                    previewSource.loop = false;
                    const gain = $35da740d59af89ba$var$audioCtx.createGain();
                    gain.gain.value = 1;
                    previewSource.connect(gain);
                    gain.connect($35da740d59af89ba$var$audioCtx.destination);
                    $35da740d59af89ba$var$samplePreviewStartedAt = $35da740d59af89ba$var$audioCtx.currentTime;
                    previewSource.start(0, $35da740d59af89ba$var$samplePreviewOffset);
                    $35da740d59af89ba$var$samplePreviewSource = previewSource;
                    $35da740d59af89ba$var$samplePreviewPaused = false;
                    pauseBtn.textContent = "\u23F8";
                    pad.classList.add("active");
                    previewSource.onended = ()=>{
                        if ($35da740d59af89ba$var$samplePreviewSource === previewSource && !$35da740d59af89ba$var$samplePreviewPaused) {
                            $35da740d59af89ba$var$samplePreviewSource = null;
                            $35da740d59af89ba$var$samplePreviewBuffer = null;
                            $35da740d59af89ba$var$samplePreviewOffset = 0;
                            $35da740d59af89ba$var$samplePreviewPad = null;
                            pad.classList.remove("active");
                            pauseBtn.textContent = "\u23F8";
                        }
                    };
                }
            };
            grid.appendChild(pad);
            $35da740d59af89ba$var$padsList.push(pad);
        });
    } catch (err) {
        loadingPad.remove();
        console.error("Sample Library load failed:", err);
        const errorPad = document.createElement("div");
        errorPad.className = "pad";
        errorPad.innerHTML = `
      <div class="pad-title">LOAD ERROR</div>
      <div class="pad-info">Sample Library</div>
    `;
        grid.appendChild(errorPad);
    }
    // =========================
    // BACK
    // =========================
    const backPad = document.createElement("div");
    backPad.className = "pad back-pad";
    backPad.innerHTML = `
  <div class="pad-key playstop">\u{25C0}\u{25C0}</div>
    <div class="pad-title">BACK</div>
    <div class="pad-info">track editor</div>
  `;
    backPad.onclick = ()=>{
        $35da740d59af89ba$var$stopSampleLibraryPreview();
        $35da740d59af89ba$var$sampleLibraryMode = false;
        $35da740d59af89ba$var$sampleLibraryTargetTrackIndex = null;
        $35da740d59af89ba$var$renderSong();
    };
    grid.appendChild(backPad);
}
function $35da740d59af89ba$var$stopSampleLibraryPreview() {
    if ($35da740d59af89ba$var$samplePreviewSource) try {
        $35da740d59af89ba$var$samplePreviewSource.stop();
    } catch (e) {}
    if ($35da740d59af89ba$var$samplePreviewPad) {
        $35da740d59af89ba$var$samplePreviewPad.classList.remove("active");
        const pauseBtn = $35da740d59af89ba$var$samplePreviewPad.querySelector(".sample-pause-btn");
        if (pauseBtn) pauseBtn.textContent = "\u23F8";
    }
    $35da740d59af89ba$var$samplePreviewSource = null;
    $35da740d59af89ba$var$samplePreviewBuffer = null;
    $35da740d59af89ba$var$samplePreviewStartedAt = 0;
    $35da740d59af89ba$var$samplePreviewOffset = 0;
    $35da740d59af89ba$var$samplePreviewPaused = false;
    $35da740d59af89ba$var$samplePreviewPad = null;
}
function $35da740d59af89ba$var$buildTrackEditPads(grid, tracks) {
    $35da740d59af89ba$var$padsList = [];
    tracks.forEach((track, i)=>{
        const pad = document.createElement("div");
        pad.className = "pad track-edit-pad";
        pad.innerHTML = `
  <div class="pad-key">${i + 1}</div>

  <div class="pad-title track-edit-title"></div>

  <div
    class="track-upload-btn"
    title="${track.mp3 ? "Change audio" : "Upload audio"}"
  >
    ${track.mp3 ? "\u21BB" : "+"}
  </div>
`;
        const titleEl = pad.querySelector(".track-edit-title");
        titleEl.textContent = String(track.name || "").trim() || $35da740d59af89ba$var$getFileName(track.mp3) || "New Loop";
        // =========================
        // EDIT NAME
        // =========================
        titleEl.onclick = (e)=>{
            e.stopPropagation();
            titleEl.contentEditable = "true";
            titleEl.focus();
            const range = document.createRange();
            range.selectNodeContents(titleEl);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
        };
        const finishNameEdit = async ()=>{
            let val = titleEl.textContent.trim();
            if (!val || $35da740d59af89ba$var$isOnlyNumber(val)) val = "New Loop";
            track.name = val;
            titleEl.textContent = val;
            titleEl.contentEditable = "false";
            await $35da740d59af89ba$var$saveProject();
        };
        titleEl.onblur = finishNameEdit;
        titleEl.onkeydown = (e)=>{
            if (e.key === "Enter") {
                e.preventDefault();
                titleEl.blur();
            }
        };
        // =========================
        // DRAG
        // =========================
        const dragHandle = document.createElement("div");
        dragHandle.className = "track-drag-handle";
        dragHandle.textContent = "\u283F";
        dragHandle.draggable = true;
        dragHandle.addEventListener("dragstart", (e)=>{
            e.stopPropagation();
            $35da740d59af89ba$var$draggedTrackIndex = i;
            pad.classList.add("dragging");
            if (e.dataTransfer) e.dataTransfer.effectAllowed = "move";
        });
        dragHandle.addEventListener("dragend", ()=>{
            pad.classList.remove("dragging");
            $35da740d59af89ba$var$draggedTrackIndex = null;
        });
        pad.appendChild(dragHandle);
        // =========================
        // DELETE
        // =========================
        const deleteBtn = document.createElement("div");
        deleteBtn.className = "track-delete-btn";
        deleteBtn.textContent = "\u2715";
        deleteBtn.onclick = async (e)=>{
            e.stopPropagation();
            const result = await $35da740d59af89ba$var$sampltonAlert({
                title: "Delete track?",
                text: `Delete "${track.name || "Track"}"?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "DELETE",
                cancelButtonText: "CANCEL"
            });
            if (!result.isConfirmed) return;
            const song = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex];
            if (!song) return;
            song.tracks.splice(i, 1);
            await $35da740d59af89ba$var$saveProject();
            $35da740d59af89ba$var$renderSong();
        };
        pad.appendChild(deleteBtn);
        // =========================
        // UPLOAD / CHANGE
        // =========================
        const uploadBtn = pad.querySelector(".track-upload-btn");
        uploadBtn.onclick = async (e)=>{
            e.stopPropagation();
            if (!$35da740d59af89ba$var$currentUser) {
                await $35da740d59af89ba$var$sampltonAlert({
                    title: "Sign in required",
                    text: "To upload audio files, please sign in with Google from the menu.",
                    icon: "info"
                });
                return;
            }
            const input = document.createElement("input");
            input.type = "file";
            input.accept = "audio/*,.wav,.mp3,.flac,.ogg";
            input.onchange = async ()=>{
                const file = input.files?.[0];
                if (!file) return;
                const uploading = document.createElement("div");
                uploading.className = "uploading";
                uploading.textContent = "UPLOADING...";
                document.body.appendChild(uploading);
                try {
                    const ok = await $35da740d59af89ba$var$uploadTrackToR2(track, file);
                    if (ok) {
                        uploadBtn.textContent = "\u21BB";
                        titleEl.textContent = String(track.name || "").trim() || $35da740d59af89ba$var$getFileName(track.mp3) || "New Loop";
                        await $35da740d59af89ba$var$saveProject();
                    } else uploadBtn.textContent = track.mp3 ? "\u21BB" : "+";
                } catch (err) {
                    console.error("Track upload failed:", err);
                    uploadBtn.textContent = track.mp3 ? "\u21BB" : "+";
                } finally{
                    uploading.remove();
                }
            };
            input.click();
        };
        // =========================
        // LOAD FROM SAMPLE LIBRARY
        // =========================
        const libraryBtn = document.createElement("div");
        libraryBtn.className = "track-library-btn";
        libraryBtn.textContent = "\u25A3";
        libraryBtn.title = "Load from Sample Library";
        libraryBtn.onclick = (e)=>{
            e.stopPropagation();
            $35da740d59af89ba$var$sampleLibraryTargetTrackIndex = i;
            $35da740d59af89ba$var$sampleLibraryMode = true;
            $35da740d59af89ba$var$renderSong();
        };
        pad.appendChild(libraryBtn);
        // =========================
        // PENCIL
        // =========================
        const editBtn = document.createElement("div");
        editBtn.className = "track-settings-btn";
        editBtn.textContent = "\u270E";
        editBtn.onclick = (e)=>{
            e.stopPropagation();
            $35da740d59af89ba$var$trackSettingsIndex = i;
            $35da740d59af89ba$var$trackSettingsMode = true;
            $35da740d59af89ba$var$renderSong();
        };
        pad.appendChild(editBtn);
        // =========================
        // DRAG TARGET
        // =========================
        pad.addEventListener("dragover", (e)=>{
            e.preventDefault();
            if ($35da740d59af89ba$var$draggedTrackIndex === null || $35da740d59af89ba$var$draggedTrackIndex === i) return;
            pad.classList.add("drag-over");
        });
        pad.addEventListener("dragleave", ()=>{
            pad.classList.remove("drag-over");
        });
        pad.addEventListener("drop", async (e)=>{
            e.preventDefault();
            e.stopPropagation();
            pad.classList.remove("drag-over");
            if ($35da740d59af89ba$var$draggedTrackIndex === null || $35da740d59af89ba$var$draggedTrackIndex === i) return;
            const fromIndex = $35da740d59af89ba$var$draggedTrackIndex;
            const movedTrack = tracks.splice(fromIndex, 1)[0];
            let targetIndex = i;
            if (fromIndex < i) targetIndex--;
            tracks.splice(targetIndex, 0, movedTrack);
            $35da740d59af89ba$var$draggedTrackIndex = null;
            await $35da740d59af89ba$var$saveProject();
            $35da740d59af89ba$var$renderSong();
        });
        grid.appendChild(pad);
        $35da740d59af89ba$var$padsList.push(pad);
    });
    // =========================
    // ADD TRACK
    // =========================
    const addPad = document.createElement("div");
    addPad.className = "pad add-track-pad";
    addPad.innerHTML = `
    <div class="pad-key">+</div>
    <div class="pad-title">ADD TRACK</div>
    <div class="pad-info">new sample</div>
  `;
    addPad.onclick = async ()=>{
        const song = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex];
        if (!song) return;
        const lastTrack = song.tracks[song.tracks.length - 1];
        const newTrack = {
            song: song.title,
            name: "New Loop",
            notes: "",
            mp3: "",
            bpm: lastTrack ? $35da740d59af89ba$var$toNumber(lastTrack.bpm) || 120 : 120,
            signature: 4,
            bars: 4,
            start_at: 0.01,
            fadeintime: 0.5,
            repeat: 1,
            autoplay: 1
        };
        song.tracks.push(newTrack);
        await $35da740d59af89ba$var$saveProject();
        $35da740d59af89ba$var$renderSong();
    };
    grid.appendChild(addPad);
    // =========================
    // SAMPLE LIBRARY
    // =========================
    const libraryPad = document.createElement("div");
    libraryPad.className = "pad sample-library-pad";
    libraryPad.innerHTML = `
  <div class="pad-key">+</div>
  <div class="pad-title">SAMPLE LIBRARY</div>
  <div class="pad-info">R2 audio files</div>
`;
    libraryPad.onclick = ()=>{
        $35da740d59af89ba$var$sampleLibraryTargetTrackIndex = null;
        $35da740d59af89ba$var$sampleLibraryMode = true;
        $35da740d59af89ba$var$renderSong();
    };
    grid.appendChild(libraryPad);
    // =========================
    // DUPLICATE LAST
    // =========================
    const duplicatePad = document.createElement("div");
    duplicatePad.className = "pad duplicate-track-pad";
    duplicatePad.innerHTML = `
  <div class="pad-key">\u{29C9}</div>
  <div class="pad-title">DUPLICATE LAST</div>
  <div class="pad-info">copy last track</div>
`;
    duplicatePad.onclick = async ()=>{
        const song = $35da740d59af89ba$var$songs[$35da740d59af89ba$var$currentSongIndex];
        if (!song) return;
        if (!song.tracks.length) return;
        const lastTrack = song.tracks[song.tracks.length - 1];
        const duplicatedTrack = {
            ...lastTrack,
            // nech má nový názov
            name: `${lastTrack.name || "New Loop"} COPY`
        };
        song.tracks.push(duplicatedTrack);
        await $35da740d59af89ba$var$saveProject();
        $35da740d59af89ba$var$renderSong();
    };
    grid.appendChild(duplicatePad);
}
function $35da740d59af89ba$var$buildPads(grid, tracks) {
    const defaultBpm = $35da740d59af89ba$var$toNumber(tracks.find((t)=>t.bpm)?.bpm) || 120;
    $35da740d59af89ba$var$padsList = [];
    // METRONOME PAD
    const metroPad = document.createElement("div");
    metroPad.className = "pad metronome-pad";
    function updateMetroPad() {
        $35da740d59af89ba$var$updateMetroPadFn = updateMetroPad;
        metroPad.innerHTML = `
      <div class="pad-title"></div>
      <div class="pad-info">${$35da740d59af89ba$var$metronomeMuted ? "OFF" : "ON"}</div>
      <div class="pad-counter"></div>
      <input type="range" min="0" max="1" step="0.01" value="${$35da740d59af89ba$var$metronomeVolume}" class="metro-volume">
    `;
        $35da740d59af89ba$var$metroCounterEl = metroPad.querySelector(".pad-counter");
    }
    metroPad.addEventListener("input", (e)=>{
        if (e.target.classList.contains("metro-volume")) {
            $35da740d59af89ba$var$metronomeVolume = parseFloat(e.target.value);
            localStorage.setItem("metroVol", String($35da740d59af89ba$var$metronomeVolume));
        }
    });
    metroPad.onclick = (e)=>{
        if (e.target.classList.contains("metro-volume")) return;
        $35da740d59af89ba$var$metronomeMuted = !$35da740d59af89ba$var$metronomeMuted;
        localStorage.setItem("metroMuted", $35da740d59af89ba$var$metronomeMuted ? "1" : "0");
        updateMetroPad();
    };
    updateMetroPad();
    $35da740d59af89ba$var$seqPad = document.createElement("div");
    $35da740d59af89ba$var$seqPad.className = "pad seq-pad";
    $35da740d59af89ba$var$seqPad.onclick = $35da740d59af89ba$var$toggleSequence;
    function getManualQuantizedTime() {
        if (!$35da740d59af89ba$var$audioCtx) return 0;
        const now = $35da740d59af89ba$var$audioCtx.currentTime;
        // 🔥 NONE = okamžite
        if ($35da740d59af89ba$var$quantizeMode === "NONE") return now;
        if (!$35da740d59af89ba$var$source) return now;
        const beatDuration = 60 / $35da740d59af89ba$var$tempo;
        const elapsed = now - $35da740d59af89ba$var$currentStartAt;
        const beatsPassed = Math.floor(elapsed / beatDuration);
        if ($35da740d59af89ba$var$quantizeMode === "BEAT") return $35da740d59af89ba$var$currentStartAt + (beatsPassed + 1) * beatDuration;
        if ($35da740d59af89ba$var$quantizeMode === "FOUR_BEATS") {
            const step = 4;
            const stepsPassed = Math.floor(beatsPassed / step);
            return $35da740d59af89ba$var$currentStartAt + (stepsPassed + 1) * step * beatDuration;
        }
        if ($35da740d59af89ba$var$quantizeMode === "BAR") {
            const loopsPassed = Math.floor(elapsed / $35da740d59af89ba$var$currentDuration);
            return $35da740d59af89ba$var$currentStartAt + (loopsPassed + 1) * $35da740d59af89ba$var$currentDuration;
        }
        return now;
    }
    let quantPad = document.createElement("div");
    quantPad.className = "pad";
    function updateQuantPad() {
        let label = $35da740d59af89ba$var$quantizeMode;
        if ($35da740d59af89ba$var$quantizeMode === "FOUR_BEATS") label = "4 BEAT";
        if ($35da740d59af89ba$var$quantizeMode === "BEAT") label = "1 BEAT";
        if ($35da740d59af89ba$var$quantizeMode === "BAR") label = "BAR";
        quantPad.innerHTML = `
    <div class="pad-key">Q</div>
    <div class="pad-title">QUANT</div>
    <div class="pad-info">${label}</div>
  `;
    }
    $35da740d59af89ba$var$updateQuantPadFn = updateQuantPad;
    quantPad.onclick = ()=>{
        if ($35da740d59af89ba$var$quantizeMode === "BAR") $35da740d59af89ba$var$quantizeMode = "FOUR_BEATS";
        else if ($35da740d59af89ba$var$quantizeMode === "FOUR_BEATS") $35da740d59af89ba$var$quantizeMode = "BEAT";
        else if ($35da740d59af89ba$var$quantizeMode === "BEAT") $35da740d59af89ba$var$quantizeMode = "NONE";
        else $35da740d59af89ba$var$quantizeMode = "BAR";
        updateQuantPad();
    };
    updateQuantPad();
    // 🔴 STOP PAD
    const stopPad = document.createElement("div");
    stopPad.className = "pad stop-pad";
    stopPad.innerHTML = `
  <div class="pad-key playstop" style="font-size:30px!important;top:5px!important">\u{25A0}</div>
    <div class="pad-title">STOP</div>
    <div class="pad-info">panic</div>
  `;
    stopPad.onclick = ()=>{
        if ($35da740d59af89ba$var$source) {
            try {
                $35da740d59af89ba$var$source.stop();
            } catch (e) {}
            $35da740d59af89ba$var$source = null;
        }
        if ($35da740d59af89ba$var$schedulerTimer) {
            clearTimeout($35da740d59af89ba$var$schedulerTimer);
            $35da740d59af89ba$var$schedulerTimer = null;
        }
        $35da740d59af89ba$var$currentStartAt = 0;
        $35da740d59af89ba$var$currentDuration = 0;
        $35da740d59af89ba$var$nextNoteTime = 0;
        $35da740d59af89ba$var$queuedTrack = null;
        if ($35da740d59af89ba$var$activePadEl) $35da740d59af89ba$var$activePadEl.classList.remove("active");
        if ($35da740d59af89ba$var$queuedPadEl) $35da740d59af89ba$var$queuedPadEl.classList.remove("queued");
        $35da740d59af89ba$var$activePadEl = null;
        $35da740d59af89ba$var$queuedPadEl = null;
        $35da740d59af89ba$var$isMonitoring = false;
    };
    const backPad = document.createElement("div");
    backPad.className = "pad back-pad";
    backPad.innerHTML = `
  <div class="pad-key playstop">\u{25C0}\u{25C0}</div>
  <div class="pad-title">Back</div>
  <div class="pad-info">menu</div>
`;
    backPad.onclick = ()=>{
        $35da740d59af89ba$var$selectedTrackIndex = $35da740d59af89ba$var$selectedPadIndex;
        $35da740d59af89ba$var$selectedSongIndex = $35da740d59af89ba$var$currentSongIndex;
        $35da740d59af89ba$var$viewMode = "menu";
        $35da740d59af89ba$var$renderSong();
    };
    let trackIndex = 1;
    // TRACKS
    tracks.forEach((track)=>{
        if (!track.mp3) return;
        const bpm = $35da740d59af89ba$var$toNumber(track.bpm) || defaultBpm;
        const baseBars = $35da740d59af89ba$var$toNumber(track.bars) || 8;
        const repeat = $35da740d59af89ba$var$toNumber(track.repeat) || 1;
        const bars = baseBars;
        const totalBars = baseBars * repeat;
        const signature = $35da740d59af89ba$var$toNumber(track.signature) || 4;
        const startAtOffset = $35da740d59af89ba$var$toNumber(track.start_at);
        const trackName = track.name && track.name.trim() !== "" ? track.name : $35da740d59af89ba$var$getFileName(track.mp3);
        const pad = document.createElement("div");
        pad.className = "pad";
        pad.innerHTML = `
    <div class="pad-key">${trackIndex}</div>
      <div class="pad-title">${trackName}</div>
      <div class="pad-info">${bpm} | ${baseBars} | ${repeat}x | ${signature}/4</div>
     
          `;
        // 🔥 NOTES (SEM!)
        if (String(track.notes || "").trim() !== "") {
            const note = document.createElement("div");
            note.className = "pad-note";
            note.innerHTML = "\u270E";
            note.onclick = (e)=>{
                e.stopPropagation();
                $35da740d59af89ba$var$openNotesModal(track.notes);
            };
            pad.appendChild(note);
        }
        trackIndex++;
        pad.onclick = async ()=>{
            if (!track.mp3) return;
            // 🔥 OFFLINE CHECK
            if (!navigator.onLine) {
                const cached = await $35da740d59af89ba$var$isTrackCached(track.mp3);
                if (!cached) return; // nič nerob → žiadny error
            }
            //  console.log("START OFFSET:", startAtOffset);
            pad.classList.add("loading");
            try {
                const buffer = await $35da740d59af89ba$var$loadAudio(track.mp3);
                // restart active pad na najbližší beat
                if (pad === $35da740d59af89ba$var$activePadEl && $35da740d59af89ba$var$source && $35da740d59af89ba$var$audioCtx) {
                    const restartTime = $35da740d59af89ba$var$quantizeMode === "NONE" ? $35da740d59af89ba$var$audioCtx.currentTime : $35da740d59af89ba$var$getNextBeatTime();
                    const newSource = $35da740d59af89ba$var$audioCtx.createBufferSource();
                    newSource.buffer = buffer;
                    const baseDuration = 60 / bpm * signature * bars;
                    const loopStart = startAtOffset;
                    if ($35da740d59af89ba$var$quantizeMode === "NONE") newSource.loop = false;
                    else {
                        newSource.loop = true;
                        newSource.loopStart = loopStart;
                        newSource.loopEnd = loopStart + baseDuration;
                    }
                    const newGain = $35da740d59af89ba$var$audioCtx.createGain();
                    newGain.gain.value = 1;
                    newSource.connect(newGain);
                    newGain.connect($35da740d59af89ba$var$audioCtx.destination);
                    newSource.start(restartTime, loopStart);
                    $35da740d59af89ba$var$source.stop(restartTime);
                    $35da740d59af89ba$var$source = newSource;
                    $35da740d59af89ba$var$currentGain = newGain;
                    $35da740d59af89ba$var$currentStartAt = restartTime;
                    $35da740d59af89ba$var$currentDuration = baseDuration;
                    $35da740d59af89ba$var$currentRepeat = repeat;
                    $35da740d59af89ba$var$currentRepeatIndex = 0;
                    pad.classList.remove("loading");
                    return;
                }
                if (pad === $35da740d59af89ba$var$queuedPadEl) {
                    if ($35da740d59af89ba$var$queuedTrack) $35da740d59af89ba$var$queuedTrack.switchTime = getManualQuantizedTime();
                    else {
                        // 🔥 už sa preplo → znovu queue
                        const index = $35da740d59af89ba$var$padsList.indexOf(pad);
                        $35da740d59af89ba$var$queuePadByIndex(index);
                    }
                    pad.classList.remove("loading");
                    return;
                }
                if (!$35da740d59af89ba$var$source) {
                    await $35da740d59af89ba$var$startFirstTrack(track.mp3, bpm, bars, signature, startAtOffset, repeat);
                    pad.classList.remove("loading");
                    if ($35da740d59af89ba$var$activePadEl) $35da740d59af89ba$var$activePadEl.classList.remove("active");
                    $35da740d59af89ba$var$activePadEl = pad;
                    pad.classList.add("active");
                    $35da740d59af89ba$var$updateTrackSubtitle(track);
                    return;
                }
                if ($35da740d59af89ba$var$queuedPadEl) $35da740d59af89ba$var$queuedPadEl.classList.remove("queued");
                $35da740d59af89ba$var$queuedPadEl = pad;
                pad.classList.add("queued");
                $35da740d59af89ba$var$queuedTrack = {
                    buffer: buffer,
                    bpm: bpm,
                    bars: bars,
                    signature: signature,
                    startAtOffset: startAtOffset,
                    fadeTime: $35da740d59af89ba$var$toNumber(track.fadeintime) || 0,
                    fadeTime: track.fadeintime,
                    switchTime: getManualQuantizedTime(),
                    repeat: repeat,
                    repeatIndex: 0
                };
                setTimeout(()=>{
                    pad.classList.remove("loading");
                }, 200);
            } catch (err) {
                console.error("Audio load failed:", err);
                pad.classList.remove("loading");
            }
        };
        // 🔥 CHECK CACHE (tu to patrí)
        $35da740d59af89ba$var$isTrackCached(track.mp3).then((cached)=>{
            if (!navigator.onLine) // 🔥 offline → nič nezobrazuj
            return;
            if (!cached) {
                pad.classList.add("not-loaded");
                const badge = document.createElement("div");
                badge.className = "pad-missing";
                badge.textContent = "!";
                pad.appendChild(badge);
            }
        });
        grid.appendChild(pad);
        $35da740d59af89ba$var$padsList.push(pad);
    });
    grid.appendChild(metroPad);
    grid.appendChild(quantPad);
    grid.appendChild($35da740d59af89ba$var$seqPad);
    grid.appendChild(stopPad);
    grid.appendChild(backPad);
    $35da740d59af89ba$var$updateSeqPad();
    $35da740d59af89ba$var$selectedPadIndex = $35da740d59af89ba$var$selectedTrackIndex;
    $35da740d59af89ba$var$updatePadSelection();
}
// =======================
// INIT / RENDER
// =======================
let $35da740d59af89ba$var$pendingFileData = null;
function $35da740d59af89ba$var$scheduleSave() {
    clearTimeout($35da740d59af89ba$var$saveTimeout);
    $35da740d59af89ba$var$saveTimeout = setTimeout(()=>{
        $35da740d59af89ba$var$saveProject();
    }, 300); // delay
}
async function $35da740d59af89ba$var$init() {
    try {
        await $35da740d59af89ba$var$loadTracks();
        const songParam = $35da740d59af89ba$var$getUrlParam("song");
        if (songParam) {
            $35da740d59af89ba$var$viewMode = "song"; // 🔥 len ak je param
            if (!isNaN(songParam)) {
                const index = parseInt(songParam);
                if ($35da740d59af89ba$var$songs[index]) $35da740d59af89ba$var$currentSongIndex = index;
            } else {
                const index = $35da740d59af89ba$var$songs.findIndex((s)=>s.title.toLowerCase() === songParam.toLowerCase());
                if (index !== -1) $35da740d59af89ba$var$currentSongIndex = index;
            }
        } else $35da740d59af89ba$var$viewMode = "menu"; // 🔥 default
        $35da740d59af89ba$var$renderSong();
        $35da740d59af89ba$var$updateMetroCounter();
    } catch (err) {
        console.error("Init failed:", err);
        document.body.innerHTML = `<div style="color:white;padding:20px;">Load error</div>`;
    }
}
function $35da740d59af89ba$var$resetApp(clearUi = true) {
    if ($35da740d59af89ba$var$source) {
        try {
            $35da740d59af89ba$var$source.stop();
        } catch (e) {}
        $35da740d59af89ba$var$source = null;
    }
    if ($35da740d59af89ba$var$schedulerTimer) {
        clearTimeout($35da740d59af89ba$var$schedulerTimer);
        $35da740d59af89ba$var$schedulerTimer = null;
    }
    $35da740d59af89ba$var$queuedTrack = null;
    $35da740d59af89ba$var$isMonitoring = false;
    $35da740d59af89ba$var$activePadEl = null;
    $35da740d59af89ba$var$queuedPadEl = null;
    $35da740d59af89ba$var$currentGain = null;
    $35da740d59af89ba$var$currentStartAt = 0;
    $35da740d59af89ba$var$currentDuration = 0;
    if (clearUi) document.body.innerHTML = "";
    else {
        const oldLoader = $35da740d59af89ba$var$loaderEl;
        document.body.innerHTML = "";
        if (oldLoader) {
            $35da740d59af89ba$var$loaderEl = oldLoader;
            document.body.appendChild($35da740d59af89ba$var$loaderEl);
        }
    }
}
// =======================
// START
// =======================
document.addEventListener("click", (e)=>{
    // klik v SweetAlert → menu nechaj otvorené
    if (e.target.closest(".swal2-container")) return;
    // klik mimo menu → zavri menu
    if (!e.target.closest(".top-bar-wrapper")) document.querySelector(".top-menu-panel")?.classList.add("hidden");
});
document.addEventListener("keydown", (e)=>{
    if (e.key === "Backspace") {
        // 🔥 ak píšeš do inputu → nechaj browser
        if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA" || e.target.isContentEditable) return;
        // 🔥 ak si v song view → späť do menu
        if (e.key === "Backspace" && $35da740d59af89ba$var$viewMode === "song") {
            e.preventDefault();
            $35da740d59af89ba$var$selectedTrackIndex = $35da740d59af89ba$var$selectedPadIndex;
            $35da740d59af89ba$var$selectedSongIndex = $35da740d59af89ba$var$currentSongIndex;
            $35da740d59af89ba$var$viewMode = "menu";
            $35da740d59af89ba$var$renderSong();
        }
    }
    if (e.key === "Escape" && $35da740d59af89ba$var$sheetEditorEl) $35da740d59af89ba$var$sheetEditorEl.style.display = "none";
    if (e.target.tagName === "INPUT" || e.target.isContentEditable) return;
    if (e.key.toLowerCase() === "q") {
        if ($35da740d59af89ba$var$quantizeMode === "BAR") $35da740d59af89ba$var$quantizeMode = "FOUR_BEATS";
        else if ($35da740d59af89ba$var$quantizeMode === "FOUR_BEATS") $35da740d59af89ba$var$quantizeMode = "BEAT";
        else if ($35da740d59af89ba$var$quantizeMode === "BEAT") $35da740d59af89ba$var$quantizeMode = "NONE";
        else $35da740d59af89ba$var$quantizeMode = "BAR";
        $35da740d59af89ba$var$updateQuantPadFn?.();
    }
    if (e.key.toLowerCase() === "r") {
        const prevSongIndex = $35da740d59af89ba$var$currentSongIndex; // 🔥 zapamätaj
        $35da740d59af89ba$var$resetApp(false);
        $35da740d59af89ba$var$loadTracks().then((tracks)=>{
            $35da740d59af89ba$var$songs = $35da740d59af89ba$var$groupTracksBySong(tracks);
            // 🔥 vráť sa na rovnakú skladbu
            if ($35da740d59af89ba$var$songs[prevSongIndex]) $35da740d59af89ba$var$currentSongIndex = prevSongIndex;
            else $35da740d59af89ba$var$currentSongIndex = 0;
            $35da740d59af89ba$var$viewMode = "song"; // 🔥 nikdy menu
            $35da740d59af89ba$var$renderSong();
        });
    }
    const key = e.key;
    // čísla 1–9
    if (/^[1-9]$/.test(key)) {
        const index = parseInt(key) - 1;
        const pad = $35da740d59af89ba$var$padsList[index];
        if (pad) pad.click();
    }
    // nula = 10. pad
    if (key === "0") {
        const pad = $35da740d59af89ba$var$padsList[9];
        if (pad) pad.click();
    }
    if (e.key.toLowerCase() === "s") {
        if ($35da740d59af89ba$var$source) {
            try {
                $35da740d59af89ba$var$source.stop();
            } catch (e) {}
            $35da740d59af89ba$var$source = null;
        }
        if ($35da740d59af89ba$var$schedulerTimer) {
            clearTimeout($35da740d59af89ba$var$schedulerTimer);
            $35da740d59af89ba$var$schedulerTimer = null;
        }
        $35da740d59af89ba$var$currentStartAt = 0;
        $35da740d59af89ba$var$currentDuration = 0;
        $35da740d59af89ba$var$nextNoteTime = 0;
        $35da740d59af89ba$var$queuedTrack = null;
        if ($35da740d59af89ba$var$activePadEl) $35da740d59af89ba$var$activePadEl.classList.remove("active");
        if ($35da740d59af89ba$var$queuedPadEl) $35da740d59af89ba$var$queuedPadEl.classList.remove("queued");
        $35da740d59af89ba$var$activePadEl = null;
        $35da740d59af89ba$var$queuedPadEl = null;
        $35da740d59af89ba$var$isMonitoring = false;
        $35da740d59af89ba$var$updateTrackSubtitle(null);
    }
    // 🔥 ignoruj keď píšeš do table
    if (e.target.tagName === "INPUT" || e.target.isContentEditable) return;
    // =======================
    // MENU MODE
    // =======================
    if ($35da740d59af89ba$var$viewMode === "menu") {
        if (e.key === "ArrowRight") {
            $35da740d59af89ba$var$selectedPadIndex++;
            if ($35da740d59af89ba$var$selectedPadIndex >= $35da740d59af89ba$var$padsList.length) $35da740d59af89ba$var$selectedPadIndex = 0;
            $35da740d59af89ba$var$updatePadSelection();
        }
        if (e.key === "ArrowLeft") {
            $35da740d59af89ba$var$selectedPadIndex--;
            if ($35da740d59af89ba$var$selectedPadIndex < 0) $35da740d59af89ba$var$selectedPadIndex = $35da740d59af89ba$var$padsList.length - 1;
            $35da740d59af89ba$var$updatePadSelection();
        }
        if (e.key === "ArrowUp") {
            const cols = $35da740d59af89ba$var$getGridColumns();
            $35da740d59af89ba$var$selectedPadIndex -= cols;
            if ($35da740d59af89ba$var$selectedPadIndex < 0) $35da740d59af89ba$var$selectedPadIndex = 0;
            $35da740d59af89ba$var$updatePadSelection();
        }
        if (e.key === "ArrowDown") {
            const cols = $35da740d59af89ba$var$getGridColumns();
            $35da740d59af89ba$var$selectedPadIndex += cols;
            if ($35da740d59af89ba$var$selectedPadIndex >= $35da740d59af89ba$var$padsList.length) $35da740d59af89ba$var$selectedPadIndex = $35da740d59af89ba$var$padsList.length - 1;
            $35da740d59af89ba$var$updatePadSelection();
        }
        // 🔥 ENTER = otvor song
        if (e.key === "Enter") {
            const pad = $35da740d59af89ba$var$padsList[$35da740d59af89ba$var$selectedPadIndex];
            if (pad) pad.click();
        }
    }
    // =======================
    // SONG MODE (PAD NAV)
    // =======================
    if ($35da740d59af89ba$var$viewMode === "song") {
        if (e.key === "ArrowRight") {
            $35da740d59af89ba$var$selectedPadIndex++;
            if ($35da740d59af89ba$var$selectedPadIndex >= $35da740d59af89ba$var$padsList.length) $35da740d59af89ba$var$selectedPadIndex = 0;
            $35da740d59af89ba$var$updatePadSelection();
        }
        if (e.key === "ArrowLeft") {
            $35da740d59af89ba$var$selectedPadIndex--;
            if ($35da740d59af89ba$var$selectedPadIndex < 0) $35da740d59af89ba$var$selectedPadIndex = $35da740d59af89ba$var$padsList.length - 1;
            $35da740d59af89ba$var$updatePadSelection();
        }
        if (e.key === "ArrowUp") {
            const cols = $35da740d59af89ba$var$getGridColumns();
            $35da740d59af89ba$var$selectedPadIndex -= cols;
            if ($35da740d59af89ba$var$selectedPadIndex < 0) $35da740d59af89ba$var$selectedPadIndex = 0;
            $35da740d59af89ba$var$updatePadSelection();
        }
        if (e.key === "ArrowDown") {
            const cols = $35da740d59af89ba$var$getGridColumns();
            $35da740d59af89ba$var$selectedPadIndex += cols;
            if ($35da740d59af89ba$var$selectedPadIndex >= $35da740d59af89ba$var$padsList.length) $35da740d59af89ba$var$selectedPadIndex = $35da740d59af89ba$var$padsList.length - 1;
            $35da740d59af89ba$var$updatePadSelection();
        }
        // ENTER = play
        if (e.key === "Enter") {
            const pad = $35da740d59af89ba$var$padsList[$35da740d59af89ba$var$selectedPadIndex];
            if (pad) pad.click();
        }
    }
    if (e.key.toLowerCase() === "e") {
        // MENU → nový edit režim song padov
        if ($35da740d59af89ba$var$viewMode === "menu") {
            $35da740d59af89ba$var$songEditMode = !$35da740d59af89ba$var$songEditMode;
            $35da740d59af89ba$var$renderSong();
            return;
        }
        // SONG → zatiaľ stále track table
        if ($35da740d59af89ba$var$viewMode === "song") {
            $35da740d59af89ba$var$trackEditMode = !$35da740d59af89ba$var$trackEditMode;
            $35da740d59af89ba$var$renderSong();
            return;
        }
    }
    // 🔥 FULLSCREEN
    if (e.key.toLowerCase() === "f") $35da740d59af89ba$var$toggleFullscreen();
    if (e.key.toLowerCase() === "a") $35da740d59af89ba$var$toggleSequence();
    if (e.key.toLowerCase() === "c") {
        $35da740d59af89ba$var$metronomeMuted = !$35da740d59af89ba$var$metronomeMuted;
        localStorage.setItem("metroMuted", $35da740d59af89ba$var$metronomeMuted ? "1" : "0");
        if ($35da740d59af89ba$var$updateMetroPadFn) $35da740d59af89ba$var$updateMetroPadFn();
    }
});
window.shiftClick = (ms)=>{
    $35da740d59af89ba$var$clickOffset = ms / 1000;
};
let $35da740d59af89ba$var$deferredPrompt = null;
window.addEventListener("beforeinstallprompt", (e)=>{
    e.preventDefault(); // ❗ vypne default browser prompt
    $35da740d59af89ba$var$deferredPrompt = e;
});
var $a99b1c90995f445f$exports = {};
$a99b1c90995f445f$exports = import.meta.resolve("czWhb");


if ("serviceWorker" in navigator && location.hostname !== "localhost") navigator.serviceWorker.register($a99b1c90995f445f$exports).then(()=>console.log("\u2705 SW ready")).catch((err)=>console.error("SW fail", err));
window.testR2Download = async (fileName)=>{
    if (!$35da740d59af89ba$var$currentUser) {
        console.log("No user");
        return;
    }
    const token = await $35da740d59af89ba$var$currentUser.getIdToken();
    const res = await fetch(`https://samplton-api.matorybos.workers.dev/audio/${encodeURIComponent(fileName)}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    if (!res.ok) {
        console.error("R2 download failed:", res.status, await res.text());
        return;
    }
    const buffer = await res.arrayBuffer();
    return buffer;
};


//# sourceMappingURL=samplton-auth.ef83d2ca.js.map
